webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1053)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(550),
  /* template */
  __webpack_require__(1690),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__globals__ = __webpack_require__(85);




var API_BASE = "api/Wizard";

var WizardService = function () {
  function WizardService() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, WizardService);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(WizardService, [{
    key: "readMasterSurveysAndProjects",
    value: function readMasterSurveysAndProjects() {
      return $.ajax({
        method: "GET",
        url: API_BASE + "/MasterSurveysAndProjects",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          return data;
        },
        error: function error(_error) {
          console.error("Error on GET in readMasterSurveysAndProjects()", _error);
          __WEBPACK_IMPORTED_MODULE_3__globals__["a" /* default */].showErrorSnackbar("readMasterSurveysAndProjects() failed");
        }
      });
    }
  }, {
    key: "readAgencies",
    value: function readAgencies() {
      return $.ajax({
        method: "GET",
        url: API_BASE + "/Agencies",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          return data;
        },
        error: function error(_error2) {
          console.error("Error on GET in readAgencies()", _error2);
          __WEBPACK_IMPORTED_MODULE_3__globals__["a" /* default */].showErrorSnackbar("readAgencies() failed");
        }
      });
    }
  }, {
    key: "exportConfiguration",
    value: function exportConfiguration(ConfigurationGuid) {
      return $.ajax({
        method: "GET",
        url: API_BASE + "/" + ConfigurationGuid + "/Export",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            __WEBPACK_IMPORTED_MODULE_3__globals__["a" /* default */].showErrorSnackbar(data.Error);
            console.error(data.Error);
            return;
          }
          __WEBPACK_IMPORTED_MODULE_3__globals__["a" /* default */].downloadFile(data[0].DownloadId);
        },
        error: function error(_error3) {
          console.error("Error on GET in exportConfiguration()", _error3);
          __WEBPACK_IMPORTED_MODULE_3__globals__["a" /* default */].showErrorSnackbar("exportConfiguration() failed");
        }
      });
    }
  }, {
    key: "readImporters",
    value: function readImporters() {
      return $.ajax({
        method: "GET",
        url: API_BASE + "/Importers",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          return data;
        },
        error: function error(_error4) {
          console.error("Error on GET in readImporters()", _error4);
          __WEBPACK_IMPORTED_MODULE_3__globals__["a" /* default */].showErrorSnackbar("readImporters() failed");
        }
      });
    }
  }, {
    key: "readScenarios",
    value: function readScenarios(configurationGuid) {
      return $.ajax({
        method: "GET",
        url: API_BASE + "/Scenarios/" + configurationGuid,
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          return data;
        },
        error: function error(_error5) {
          console.error("Error on GET in readScenarios()", _error5);
          __WEBPACK_IMPORTED_MODULE_3__globals__["a" /* default */].showErrorSnackbar("readScenarios() failed");
        }
      });
    }
  }, {
    key: "readCarModel",
    value: function readCarModel() {
      return $.ajax({
        method: "GET",
        url: "api/CarModel",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          return data;
        },
        error: function error(_error6) {
          console.error("Error on GET in readCarModel()", _error6);
          __WEBPACK_IMPORTED_MODULE_3__globals__["a" /* default */].showErrorSnackbar("readCarModel() failed");
        }
      });
    }
  }, {
    key: "readCarSegment",
    value: function readCarSegment() {
      return $.ajax({
        method: "GET",
        url: "api/CarModel/CarSegment",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          return data;
        },
        error: function error(_error7) {
          console.error("Error on GET in readCarSegment()", _error7);
          __WEBPACK_IMPORTED_MODULE_3__globals__["a" /* default */].showErrorSnackbar("readCarSegment() failed");
        }
      });
    }
  }, {
    key: "readConfigurations",
    value: function readConfigurations() {
      return $.ajax({
        method: "GET",
        url: API_BASE + "/Configurations",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          return data;
        },
        error: function error(_error8) {
          console.error("Error on GET in readConfigurations()", _error8);
          __WEBPACK_IMPORTED_MODULE_3__globals__["a" /* default */].showErrorSnackbar("readConfigurations() failed");
        }
      });
    }
  }, {
    key: "readConfiguration",
    value: function readConfiguration(configurationGuid) {
      return $.ajax({
        method: "GET",
        url: API_BASE + "/Configuration/" + configurationGuid,
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          return data;
        },
        error: function error(_error9) {
          console.error("Error on GET in readConfiguration()", _error9);
          __WEBPACK_IMPORTED_MODULE_3__globals__["a" /* default */].showErrorSnackbar("readConfiguration() failed");
        }
      });
    }
  }, {
    key: "saveConfiguration",
    value: function saveConfiguration(config) {
      return $.ajax({
        method: "POST",
        url: API_BASE + "/Configuration",
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(config),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          return data;
        },
        error: function error(_error10) {
          console.error("Error on POST in saveConfiguration()", _error10);
          __WEBPACK_IMPORTED_MODULE_3__globals__["a" /* default */].showErrorSnackbar("saveConfiguration() failed");
        }
      });
    }
  }, {
    key: "readBrandsOfConfiguration",
    value: function readBrandsOfConfiguration(configurationGuid) {
      return $.ajax({
        method: "GET",
        url: "/api/Wizard/Brands/" + configurationGuid,
        success: function success(data) {
          return data;
        },
        error: function error() {
          console.error("Error on GET in readBrandsOfConfiguration()");
          __WEBPACK_IMPORTED_MODULE_3__globals__["a" /* default */].showErrorSnackbar("read Brands failed");
        }
      });
    }
  }, {
    key: "readConfigurationLocations",
    value: function readConfigurationLocations(configurationGuid) {
      return $.ajax({
        method: "GET",
        url: API_BASE + "/ConfigurationLocations/" + configurationGuid,
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          return data;
        },
        error: function error(_error11) {
          console.error("Error on GET in readConfigurationLocations()", _error11);
          __WEBPACK_IMPORTED_MODULE_3__globals__["a" /* default */].showErrorSnackbar("readConfigurationLocations() failed");
        }
      });
    }
  }, {
    key: "deleteConfiguration",
    value: function deleteConfiguration(configurationGuid) {
      return $.ajax({
        method: "DELETE",
        url: API_BASE + "/" + configurationGuid,
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          return data;
        },
        error: function error(_error12) {
          console.error("Error on DELETE in deleteConfiguration()", _error12);
          __WEBPACK_IMPORTED_MODULE_3__globals__["a" /* default */].showErrorSnackbar("deleteConfiguration() failed");
        }
      });
    }
  }, {
    key: "getProjectAttachments",
    value: function getProjectAttachments(configurationGuid) {
      var _this = this;

      return $.ajax({
        method: "GET",
        url: "/api/data/ProjectAttachments/" + configurationGuid,
        success: function success(data) {
          return data;
        },
        error: function error() {
          console.error("Attachments data access failed in getProjectAttachments()");
          __WEBPACK_IMPORTED_MODULE_3__globals__["a" /* default */].showErrorSnackbar(_this.lang.CM2043);
        }
      });
    }
  }, {
    key: "createElementsFromConfiguration",
    value: function createElementsFromConfiguration(configurationGuid) {
      return $.ajax({
        method: "POST",
        url: API_BASE + "/CreateElementsFromConfiguration",
        data: configurationGuid,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          return data;
        },
        error: function error() {
          console.error("Create elements from configuration failed.");
          __WEBPACK_IMPORTED_MODULE_3__globals__["a" /* default */].showErrorSnackbar("createElementsFromConfiguration() failed");
        }
      });
    }
  }, {
    key: "updateConfigurationStatus",
    value: function updateConfigurationStatus(configurationGuid, targetStatus) {
      return $.ajax({
        method: "POST",
        url: API_BASE + "/" + configurationGuid + "/" + targetStatus,
        success: function success(data) {
          return data;
        },
        error: function error() {
          console.error("Update configuration status failed in updateConfigurationStatus()");
          __WEBPACK_IMPORTED_MODULE_3__globals__["a" /* default */].showErrorSnackbar("updateConfigurationStatus() failed");
        }
      });
    }
  }, {
    key: "addProjectAttachment",
    value: function addProjectAttachment(projectGuid, downloadId, attachmentType) {
      return $.ajax({
        method: "POST",
        url: API_BASE + "/ProjectAttachment/" + projectGuid + "/" + downloadId + "/" + attachmentType,
        success: function success(data) {
          return data;
        },
        error: function error() {
          console.error("Add ProjectAttachment failed");
          __WEBPACK_IMPORTED_MODULE_3__globals__["a" /* default */].showErrorSnackbar("addProjectAttachment() failed");
        }
      });
    }
  }, {
    key: "getMasterSurvey",
    value: function getMasterSurvey(configurationGuid) {
      return $.ajax({
        method: "GET",
        url: "/api/Wizard/MasterSurvey/" + configurationGuid,
        success: function success(data) {
          return data;
        },
        error: function error() {
          console.error("Get master survey failed in getMasterSurvey()");
          __WEBPACK_IMPORTED_MODULE_3__globals__["a" /* default */].showErrorSnackbar("Get master survey failed");
        }
      });
    }
  }]);

  return WizardService;
}();

/* harmony default export */ __webpack_exports__["a"] = (new WizardService());
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1017)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(543),
  /* template */
  __webpack_require__(1655),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-16e8f212",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1044)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(566),
  /* template */
  __webpack_require__(1681),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-58307ed4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__package_json__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__package_json__);








var uuidv4 = __webpack_require__(60);

var globals = new __WEBPACK_IMPORTED_MODULE_4_vue__["default"]({
  name: "globals",
  computed: {
    currentUserRole: function currentUserRole() {
      if (this.currentUserInfo && this.currentUserInfo.UserTypeId) return this.currentUserInfo.UserTypeId;
      return -1;
    },
    currentUserName: function currentUserName() {
      if (!this.currentUserInfo) return "";
      return this.currentUserInfo.IsLoggedInAsUser || this.currentUserInfo.LoginName || "";
    },
    isPaymentsReadingAllowed: function isPaymentsReadingAllowed() {
      if (!this.currentUserInfo) return false;
      return this.currentUserInfo.UserTypeId === 1 && [4, 5, 8].indexOf(this.currentUserInfo.RoleId) > -1;
    },
    isPaymentsEditingAllowed: function isPaymentsEditingAllowed() {
      return this.isPaymentsReadingAllowed && this.currentUserInfo.RoleId === 8;
    },
    isSkillLevelEditingAllowed: function isSkillLevelEditingAllowed() {
      if (!this.currentUserInfo) return false;
      return this.currentUserInfo.UserTypeId === 1 && [4, 8].indexOf(this.currentUserInfo.RoleId) > -1;
    },
    currentDateFormatForInputMask: function currentDateFormatForInputMask() {
      var dateFormat = "yyyy-mm-dd";
      switch (this.currentLocale) {
        case "de":
          dateFormat = "dd.mm.yyyy";
          break;
        case "fr":
        case "es":
          dateFormat = "dd/mm/yyyy";
          break;
        default:
          dateFormat = "yyyy-mm-dd";
      }
      return dateFormat;
    },
    currentDateFormatForMoment: function currentDateFormatForMoment() {
      var dateFormat = "YYYY-MM-DD";
      switch (this.currentLocale) {
        case "de":
          dateFormat = "DD.MM.YYYY";
          break;
        case "fr":
        case "es":
          dateFormat = "DD/MM/YYYY";
          break;
        default:
          dateFormat = "YYYY-MM-DD";
      }
      return dateFormat;
    },
    currentDateTimeFormatForMoment: function currentDateTimeFormatForMoment() {
      return this.currentDateFormatForMoment + " - HH:mm:ss";
    },
    currentLocale: function currentLocale() {
      return this.selectedLanguage.substring(0, 2);
    },
    isAgencyUser: function isAgencyUser() {
      return !!this.currentUserInfo && !!this.currentUserInfo.AgencyGuid;
    },
    isLeadAgencyUser: function isLeadAgencyUser() {
      return !!this.currentUserInfo && this.currentUserInfo.AgencyTypeName === "Lead";
    },
    isLocalAgencyUser: function isLocalAgencyUser() {
      return !!this.currentUserInfo && this.currentUserInfo.AgencyTypeName === "Local";
    },
    isAudiUser: function isAudiUser() {
      return !!this.currentUserInfo && !!this.currentUserInfo.IsAudiUser;
    },
    isAdminUser: function isAdminUser() {
      return !!this.currentUserInfo && this.currentUserInfo.UserTypeId === 1 && !this.currentUserInfo.IsAudiUser;
    },
    isLoggedInAsOtherUser: function isLoggedInAsOtherUser() {
      return !!this.currentUserInfo && !!this.currentUserInfo.IsLoggedInAsUser;
    },
    googleApiKey: function googleApiKey() {
      if (_.includes("https://dev.projects.audi-mysteryshopping.com/#/", "msmloop.com")) return __WEBPACK_IMPORTED_MODULE_6__package_json__["googleApiKeys"].msm;
      if (_.includes("https://dev.projects.audi-mysteryshopping.com/#/", "audi-mysteryshopping")) return __WEBPACK_IMPORTED_MODULE_6__package_json__["googleApiKeys"].audi;
      return __WEBPACK_IMPORTED_MODULE_6__package_json__["googleApiKeys"].dev;
    },
    userAgencyGuid: function userAgencyGuid() {
      return this.currentUserInfo.AgencyGuid;
    }
  },
  methods: {
    /**
     * Check if the current user is a LeadAgency Plus for this wave
     * @param {String} waveGuid
     */
    isWaveLeadAgencyPlus: function isWaveLeadAgencyPlus(waveGuid) {
      var _this = this;

      // Client users get only ClientId and Agency users only AgencyId so it is a way to check if an user is an Agency
      if (this.currentUserInfo.AgencyId) {
        var query = "api/ProjectWaves/" + waveGuid + "/AgencyStatus";
        query += "?ApprovalStatus=All";
        return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          $.ajax({
            method: "GET",
            url: query,
            success: function success(data) {
              if (data.Error) {
                console.error(data.Error);
                reject(data.Error);
              }
              if (data && data.Wave && data.Wave.LeadAgencyId) resolve(data.Wave.LeadAgencyId == _this.currentUserInfo.AgencyId);else resolve(false);
            },
            error: function error(_error) {
              console.error("Error on GET in getWaveStatus()");
              _this.globals.showErrorSnackbar("Error on GET in getWaveStatus");
              reject(data.Error);
            }
          });
        });
      } else {
        return false;
      }
    },
    localizeFlatpickrConfig: function localizeFlatpickrConfig() {
      this.flatpickrDateConfig.locale = this.currentLocale;
      this.flatpickrIsoDateConfig.locale = this.currentLocale;
      this.flatpickrDatetimeConfig.locale = this.currentLocale;

      var dateFormat = void 0;
      switch (this.currentLocale) {
        case "de":
          dateFormat = "d.m.Y";
          break;
        case "fr":
        case "es":
          dateFormat = "d/m/Y";
          break;
        default:
          dateFormat = "Y-m-d";
      }
      this.flatpickrDateConfig.altFormat = dateFormat;
      this.flatpickrIsoDateConfig.altFormat = dateFormat;
      this.flatpickrDatetimeConfig.altFormat = dateFormat + " H:i";
    },
    toggleFlatpickr: function toggleFlatpickr(inputId) {
      var el = document.getElementById(inputId);
      if (!el) return;
      var fp = el._flatpickr;
      if (!fp) return;
      fp.toggle();
    },
    showSpinner: function showSpinner(immediate) {
      var _this2 = this;

      if (!this.$debouncedShowSpinnerFunc) this.$debouncedShowSpinnerFunc = _.debounce(function () {
        return _this2.spinnerVisible = true;
      }, 500);

      if (!this.$stackedSpinnerRequests) this.$stackedSpinnerRequests = 0;
      this.$stackedSpinnerRequests++;

      this.$debouncedShowSpinnerFunc();
      if (immediate) this.$debouncedShowSpinnerFunc.flush();
    },
    hideSpinner: function hideSpinner() {
      if (--this.$stackedSpinnerRequests > 0) return;

      this.$stackedSpinnerRequests = 0; // Avoid negative values
      this.$debouncedShowSpinnerFunc.cancel();
      this.spinnerVisible = false;
    },
    getCurrencyString: function getCurrencyString(value, currencyCode) {
      if (typeof value === "undefined" || isNaN(value) || value === null) return "";
      var result = value.toFixed(2);
      var currency = void 0;
      switch (currencyCode) {
        case "EUR":
          currency = {
            symbol: "€",
            prefix: false
          };
          break;
        case "USD":
          currency = {
            symbol: "$",
            prefix: true
          };
          break;
        case "CNY":
          currency = {
            symbol: "¥",
            prefix: false
          };
          break;
        default:
          currency = {
            symbol: "",
            prefix: false
          };
      }

      switch (this.currentLocale) {
        case "de":
          result = result.replace(".", ",").replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
          break;
        default:
          result = result.replace(",", ".").replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      }
      result = currency.prefix ? currency.symbol + " " + result : result + " " + currency.symbol;
      return result;
    },
    showSuccessSnackbar: function showSuccessSnackbar(text, timeout) {
      var options = _.cloneDeep(this.snackbarConfig);
      if (typeof timeout === "number" && timeout > 0) options.timeout = timeout;
      options.content = text || this.lang.G00023;
      options.style = "snackbar-success";
      options.id = "successSnackbar";
      options.onClose = function () {
        $("#successSnackbar > span").hide();
      };
      $.snackbar(options);
      $("#successSnackbar > span").show();
    },
    showErrorSnackbar: function showErrorSnackbar(text, timeout) {
      var options = _.cloneDeep(this.snackbarConfig);
      if (typeof timeout === "number" && timeout > 0) options.timeout = timeout;
      options.content = text || this.lang.G00024;
      options.style = "snackbar-error";
      options.id = "errorSnackbar";
      options.onClose = function () {
        $("#errorSnackbar > span").hide();
      };
      $.snackbar(options);
      $("#errorSnackbar > span").show();
    },
    downloadFile: function downloadFile(guid) {
      var link = document.createElement("a");
      link.download = "";
      link.href = "api/Download/" + guid;
      link.click();
      link.remove();
    },
    uploadFile: function uploadFile(file, _success, _error2, done) {
      var _this3 = this;

      var uploadData = new FormData();
      uploadData.append("file", file, file.name);
      var uploadGuid = uuidv4();
      this.pendingUploads[uploadGuid] = {};

      this.pendingUploads[uploadGuid].request = $.ajax({
        method: "POST",
        url: "api/Upload",
        data: uploadData,
        dataType: "json",
        contentType: false,
        processData: false,
        global: false,
        xhr: function xhr() {
          var xhr = $.ajaxSettings.xhr();
          if (xhr.upload) {
            _this3.pendingUploads[uploadGuid].sizes = [0, file.size, 0];

            xhr.upload.addEventListener("progress", function (e) {
              if (e.lengthComputable) {
                _this3.pendingUploads[uploadGuid].sizes = [e.loaded, e.total, e.loaded / e.total];
                _this3.calculateUploadProgress();
              }
            }, false);
          }
          return xhr;
        },
        success: function success(data) {
          if (_success) _success(data);
        },
        error: function error(err) {
          if (err.statusText === "abort") {
            console.error("Upload canceled by user");
            _this3.globals.showErrorSnackbar(_this3.lang.G00001);
          } else {
            console.error("Error on POST in uploadFile()");
            _this3.globals.showErrorSnackbar(_this3.lang.G00002);
            delete _this3.pendingUploads[uploadGuid];
          }
          if (_error2) _error2();
        },
        complete: function complete() {
          _this3.calculateUploadProgress();
          if (done) done();
        }
      });
    },
    calculateUploadProgress: function calculateUploadProgress() {
      var sumLoaded = 0,
          sumTotal = 0,
          countDone = 0;
      var count = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.pendingUploads).length;

      for (var upload in this.pendingUploads) {
        sumLoaded += this.pendingUploads[upload].sizes[0];
        sumTotal += this.pendingUploads[upload].sizes[1];
        countDone += this.pendingUploads[upload].sizes[2];
      }

      if (count < 1 || countDone == count) {
        this.currentUploadProgress = 100;
        this.pendingUploads = {};
        return;
      }
      this.currentUploadProgress = Number((sumLoaded * 100 / sumTotal).toFixed(0));
    },
    cancelPendingUploads: function cancelPendingUploads() {
      for (var guid in this.pendingUploads) {
        this.pendingUploads[guid].request.abort();
      }
      this.pendingUploads = {};
      this.currentUploadProgress = 100;
    },
    isValidFileType: function isValidFileType(file, acceptedTypes) {
      if (!acceptedTypes) return true;
      var types = _.split(_.replace(acceptedTypes, " ", ""), ",");

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(types), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var type = _step.value;

          if (type === "image/*" && _.startsWith(file.type, "image/") || type === "video/*" && _.startsWith(file.type, "video/") || type === "audio/*" && _.startsWith(file.type, "audio/")) return true;

          if (file.type === type) return true;

          if (_.startsWith(type, ".") && _.endsWith(file.name, type)) return true;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return false;
    },

    // Requests the language strings for the selected language from server
    getLanguageStrings: function getLanguageStrings(that, _success2, _error3) {
      var _this4 = this;

      if (that.$options.name && this.langCache[that.$options.name]) {
        that.lang = this.langCache[that.$options.name];
        if (_success2) _success2();
        return;
      }

      var langKeys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(that.lang);

      $.ajax({
        method: "POST",
        url: "api/Language/Translations",
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(langKeys),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          var dataKeys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data);
          if (dataKeys.length == langKeys.length) that.lang = data;else {
            for (var i = 0; i < dataKeys.length; i++) {
              that.lang[dataKeys[i]] = data[dataKeys[i]];
            }
          }
          if (that.$options.name) _this4.langCache[that.$options.name] = that.lang;
          if (_success2) _success2();
        },
        error: function error(err) {
          if (err.status === 0 || err.status === 401) return; // Request canceled or unauthorized
          console.error("Language data access failed in getLanguageStrings()");
          _this4.showErrorSnackbar(_this4.lang.G00003);
          if (_error3) _error3();
        }
      });
    },

    // Requests information about the current user from backend
    getCurrentUserInfo: function getCurrentUserInfo(callback, errorCallback) {
      var _this5 = this;

      $.ajax({
        method: "GET",
        url: "api/SecurityUsers/Current",
        success: function success(data) {
          _this5.currentUserInfo = data;
          _this5.selectedLanguage = data.FrontendLanguageCode;
          _this5.$emit("currentUserInfoReceived");
          if (callback) callback();
        },
        error: function error() {
          console.error("Userdata access failed in getCurrentUserInfo()");
          _this5.currentUserInfo = null;
          if (errorCallback) errorCallback();
        }
      }).fail(function (err) {
        console.log(err);
      });
    },
    isAccessAllowed: function isAccessAllowed(policy) {
      if (!policy || !this.currentUserInfo || !this.currentUserInfo.Policies) return false;

      var idx = this.currentUserInfo.Policies.indexOf(policy);
      if (idx < 0) return false;
      return true;
    },

    // Extracts the date in a localized format from an iso timestamp
    getLocalizedDateFromIsoTimestamp: function getLocalizedDateFromIsoTimestamp(isoTimestamp) {
      return __WEBPACK_IMPORTED_MODULE_5_moment___default()(isoTimestamp).format(this.currentDateFormatForMoment);
    },

    // Extracts the date and time in a localized format from an iso timestamp
    getLocalizedDateTimeFromIsoTimestamp: function getLocalizedDateTimeFromIsoTimestamp(isoTimestamp) {
      return __WEBPACK_IMPORTED_MODULE_5_moment___default()(isoTimestamp).format(this.currentDateTimeFormatForMoment);
    },

    // Extracts the date and time in a localized format from an iso timestamp in UTC
    getLocalizedDateTimeFromUtcIsoTimestamp: function getLocalizedDateTimeFromUtcIsoTimestamp(isoTimestamp) {
      return __WEBPACK_IMPORTED_MODULE_5_moment___default.a.utc(isoTimestamp).local().format(this.currentDateTimeFormatForMoment);
    },
    getIsoDateFromIsoTimestamp: function getIsoDateFromIsoTimestamp(isoTimestamp) {
      return __WEBPACK_IMPORTED_MODULE_5_moment___default()(isoTimestamp).format("YYYY-MM-DD");
    },

    // Requests a list of all countries and returns it by calling the callback function
    getCountryList: function getCountryList(callback) {
      var _this6 = this;

      if (!_.isEmpty(this.countryList)) {
        if (callback) callback(this.countryList);
        return;
      }

      if (!this.$pendingCountryListCallbacks) {
        this.$pendingCountryListCallbacks = [callback];
      } else {
        this.$pendingCountryListCallbacks.push(callback);
        return;
      }

      var executeCallbacks = function executeCallbacks(data) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this6.$pendingCountryListCallbacks), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var cb = _step2.value;
            if (cb) cb(data);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        delete _this6.$pendingCountryListCallbacks;
      };

      var queryString = "api/Data/Countries";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this6.countryList = data;
          executeCallbacks(_this6.countryList);
        },
        error: function error() {
          console.error("Error on GET in getCountryList()");
          _this6.globals.showErrorSnackbar(_this6.lang.G00004);
          executeCallbacks({});
        }
      });
    },
    getOccupationalGroupList: function getOccupationalGroupList(callback) {
      var _this7 = this;

      if (!_.isEmpty(this.occupationalGroupList)) {
        callback(this.occupationalGroupList);
        return;
      }

      var queryString = "api/Data/OccupationalGroup";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this7.occupationalGroupList = data;
          callback(_this7.occupationalGroupList);
        },
        error: function error() {
          console.error("Error on GET in getOccupationalGroupList()");
          _this7.globals.showErrorSnackbar(_this7.lang.G00005);
        }
      });
    },
    getTimezonesList: function getTimezonesList(callback) {
      var _this8 = this;

      if (!_.isEmpty(this.timezonesList)) {
        callback(this.timezonesList);
        return;
      }

      var queryString = "api/Data/Timezones";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this8.timezonesList = data;
          callback(_this8.timezonesList);
        },
        error: function error() {
          console.error("Error on GET in getTimezonesList()");
          _this8.globals.showErrorSnackbar(_this8.lang.G00008);
        }
      });
    },
    getRegionsList: function getRegionsList(callback) {
      var _this9 = this;

      if (!_.isEmpty(this.regionsList)) {
        callback(this.regionsList);
        return;
      }

      var queryString = "api/Data/Regions";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this9.regionsList = data;
          callback(_this9.regionsList);
        },
        error: function error() {
          console.error("Error on GET in getRegionsList()");
          _this9.globals.showErrorSnackbar(_this9.lang.G00009);
        }
      });
    },
    getLanguageList: function getLanguageList(callback) {
      var _this10 = this;

      if (!_.isEmpty(this.languageList)) {
        callback(this.languageList);
        return;
      }

      var queryString = "api/Data/Languages";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this10.languageList = data;
          callback(_this10.languageList);
        },
        error: function error() {
          console.error("Error on GET in getLanguageList()");
          _this10.globals.showErrorSnackbar(_this10.lang.G00010);
        }
      });
    },
    getClientList: function getClientList(callback) {
      var _this11 = this;

      if (!_.isEmpty(this.clientList)) {
        callback(this.clientList);
        return;
      }

      if (!this.$pendingClientListCallbacks) {
        this.$pendingClientListCallbacks = [callback];
      } else {
        this.$pendingClientListCallbacks.push(callback);
        return;
      }

      var executeCallbacks = function executeCallbacks(data) {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this11.$pendingClientListCallbacks), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var cb = _step3.value;
            cb(data);
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        delete _this11.$pendingClientListCallbacks;
      };

      var queryString = "api/Data/ClientsWithGuid";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this11.clientList = [];
          for (var guid in data) {
            _this11.clientList.push({
              ClientGuid: guid,
              ClientName: data[guid]
            });
          }
          _this11.clientList.sort(function (a, b) {
            if (a.ClientName.toLowerCase() < b.ClientName.toLowerCase()) return -1;
            if (a.ClientName.toLowerCase() > b.ClientName.toLowerCase()) return 1;
            return 0;
          });

          executeCallbacks(_this11.clientList);
        },
        error: function error() {
          console.error("Error on GET in getClientList()");
          _this11.globals.showErrorSnackbar(_this11.lang.G00011);
          executeCallbacks([]);
        }
      });
    },
    getImporterList: function getImporterList(callback) {
      var _this12 = this;

      if (!_.isEmpty(this.importerList)) {
        callback(this.importerList);
        return;
      }

      if (!this.$pendingImporterListCallbacks) {
        this.$pendingImporterListCallbacks = [callback];
      } else {
        this.$pendingImporterListCallbacks.push(callback);
        return;
      }

      var executeCallbacks = function executeCallbacks(data) {
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this12.$pendingImporterListCallbacks), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var cb = _step4.value;
            cb(data);
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }

        delete _this12.$pendingImporterListCallbacks;
      };

      var queryString = "api/Importer";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this12.importerList = [];
          if (!_.isEmpty(data)) {
            _this12.importerList = data;
            var internationalImporter = _.remove(_this12.importerList, function (importer) {
              return importer.ImporterGuid === "1D86A788-07D6-4681-BD8C-9C15800DF8BA";
            });
            if (internationalImporter[0]) _this12.importerList.unshift(internationalImporter[0]);
          }
          executeCallbacks(_this12.importerList);
        },
        error: function error() {
          console.error("Error on GET in getImporterList()");
          _this12.globals.showErrorSnackbar(_this12.lang.G00026);
          executeCallbacks([]);
        }
      });
    },
    getCarModelList: function getCarModelList(callback) {
      var _this13 = this;

      if (!_.isEmpty(this.carModelList)) {
        callback(this.carModelList);
        return;
      }

      $.ajax({
        method: "GET",
        url: "api/CarModel",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this13.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this13.carModelList = [];
          if (!_.isEmpty(data)) _this13.carModelList = data;
          callback(_this13.carModelList);
        },
        error: function error() {
          console.error("Car model list access failed in getCarModelList()");
          _this13.globals.showErrorSnackbar(_this13.lang.G00028);
          callback([]);
        }
      });
    },
    getCarSegmentList: function getCarSegmentList(callback) {
      var _this14 = this;

      if (!_.isEmpty(this.carSegmentList)) {
        callback(this.carSegmentList);
        return;
      }

      $.ajax({
        method: "GET",
        url: "api/CarModel/CarSegment",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this14.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this14.carSegmentList = [];
          if (!_.isEmpty(data)) _this14.carSegmentList = data;
          callback(_this14.carSegmentList);
        },
        error: function error() {
          console.error("Segment list access failed in getCarSegmentList()");
          _this14.globals.showErrorSnackbar(_this14.lang.G00029);
          callback([]);
        }
      });
    },
    getProjectList: function getProjectList(callback) {
      var _this15 = this;

      var queryString = "api/Data/Projects";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          if (_.isEmpty(data)) data = [];
          callback(data);
        },
        error: function error() {
          console.error("Error on GET in getProjectList()");
          _this15.globals.showErrorSnackbar(_this15.lang.G00012);
          callback([]);
        }
      });
    },
    getWaveList: function getWaveList(callback) {
      var _this16 = this;

      var queryString = "api/Data/Waves";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          if (data && data[0]) callback(data);else callback([]);
        },
        error: function error() {
          console.error("Error on GET in getWaveList()");
          _this16.globals.showErrorSnackbar(_this16.lang.G00013);
          callback([]);
        }
      });
    },
    getScenarioList: function getScenarioList(callback) {
      var _this17 = this;

      var queryString = "api/Data/Scenarios";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          if (data && data[0]) callback(data);else callback([]);
        },
        error: function error() {
          console.error("Error on GET in getScenarioList()");
          _this17.globals.showErrorSnackbar(_this17.lang.G00014);
          callback([]);
        }
      });
    },
    getAgencyList: function getAgencyList(callback) {
      var _this18 = this;

      var queryString = "api/Data/agencies";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          if (data && data[0]) callback(data);else callback([]);
        },
        error: function error() {
          console.error("Agency data access failed in getAgencyList()");
          _this18.globals.showErrorSnackbar(_this18.lang.G00015);
          callback({});
        }
      });
    },
    getShopperList: function getShopperList(callback) {
      var _this19 = this;

      var queryString = "api/Data/MysteryShopper";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          callback(data);
        },
        error: function error() {
          console.error("Shopper data access failed in getShopperList()");
          _this19.globals.showErrorSnackbar(_this19.lang.G00016);
          callback({});
        }
      });
    },
    getUserList: function getUserList(callback) {
      var _this20 = this;

      if (!_.isEmpty(this.userList)) {
        callback(this.userList);
        return;
      }

      var queryString = "api/Data/OpUser";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this20.userList = data;
          callback(data);
        },
        error: function error() {
          console.error("User data access failed in getUserList()");
          _this20.globals.showErrorSnackbar(_this20.lang.G00030);
          callback({});
        }
      });
    },
    getSettlementStatusses: function getSettlementStatusses(callback) {
      var _this21 = this;

      if (!_.isEmpty(this.settlementStatusses)) {
        callback(this.settlementStatusses);
        return;
      }

      var queryString = "api/Data/SettlementStatusses";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this21.settlementStatusses = data;
          callback(_this21.settlementStatusses);
        },
        error: function error() {
          console.error("Error on GET in getSettlementStatusses()");
          _this21.globals.showErrorSnackbar(_this21.lang.G00007);
        }
      });
    },
    getUserTypeList: function getUserTypeList(callback) {
      var _this22 = this;

      if (!_.isEmpty(this.userTypeList)) {
        callback(this.userTypeList);
        return;
      }

      var queryString = "api/Data/Usertypes";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this22.userTypeList = data;
          callback(_this22.userTypeList);
        },
        error: function error() {
          console.error("Error on GET in getUserTypeList()");
          _this22.globals.showErrorSnackbar(_this22.lang.G00017);
        }
      });
    },
    getAgencyTypeList: function getAgencyTypeList(callback) {
      var _this23 = this;

      if (!_.isEmpty(this.agencyTypeList)) {
        callback(this.agencyTypeList);
        return;
      }

      if (!this.$pendingAgencyTypeListCallbacks) {
        this.$pendingAgencyTypeListCallbacks = [callback];
      } else {
        this.$pendingAgencyTypeListCallbacks.push(callback);
        return;
      }

      var executeCallbacks = function executeCallbacks(data) {
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this23.$pendingAgencyTypeListCallbacks), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var cb = _step5.value;
            cb(data);
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }

        delete _this23.$pendingAgencyTypeListCallbacks;
      };

      var queryString = "api/Data/AgencyTypes";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this23.agencyTypeList = data;
          executeCallbacks(_this23.agencyTypeList);
        },
        error: function error() {
          console.error("Error on GET in getAgencyTypeList()");
          _this23.globals.showErrorSnackbar(_this23.lang.G00027);
          executeCallbacks([]);
        }
      });
    },
    getSecurityRoleList: function getSecurityRoleList(callback) {
      var _this24 = this;

      if (!_.isEmpty(this.securityRoleList)) {
        callback(this.securityRoleList);
        return;
      }

      var queryString = "api/Data/SecurityRoles";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this24.securityRoleList = data;
          callback(_this24.securityRoleList);
        },
        error: function error() {
          console.error("Error on GET in getSecurityRoleList()");
          _this24.globals.showErrorSnackbar(_this24.lang.G00018);
        }
      });
    },
    getDistanceUnitList: function getDistanceUnitList(callback) {
      var _this25 = this;

      if (!_.isEmpty(this.distanceUnitList)) {
        callback(this.distanceUnitList);
        return;
      }

      var queryString = "api/Data/DistanceUnits";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this25.distanceUnitList = data;
          callback(_this25.distanceUnitList);
        },
        error: function error() {
          console.error("Error on GET in getDistanceUnitList()");
          _this25.globals.showErrorSnackbar(_this25.lang.G00019);
        }
      });
    },
    getCountryLanguageList: function getCountryLanguageList(callback) {
      var _this26 = this;

      if (!_.isEmpty(this.countryLanguageList)) {
        callback(this.countryLanguageList);
        return;
      }

      var queryString = "api/Data/CountryLanguages";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this26.countryLanguageList = data;
          callback(_this26.countryLanguageList);
        },
        error: function error() {
          console.error("Error on GET in getCountryLanguageList()");
          _this26.globals.showErrorSnackbar(_this26.lang.G00020);
        }
      });
    },
    getLocaleList: function getLocaleList(callback) {
      var _this27 = this;

      if (!_.isEmpty(this.localeList)) {
        callback(this.localeList);
        return;
      }

      var queryString = "api/Data/Locales";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this27.localeList = data;
          callback(_this27.localeList);
        },
        error: function error() {
          console.error("Error on GET in getLocaleList()");
          _this27.globals.showErrorSnackbar(_this27.lang.G00021);
        }
      });
    },
    getPasswordPolicyList: function getPasswordPolicyList(callback) {
      var _this28 = this;

      if (!_.isEmpty(this.passwordPolicyList)) {
        callback(this.passwordPolicyList);
        return;
      }

      var queryString = "api/Data/PasswordPolicy";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this28.passwordPolicyList = data;
          callback(_this28.passwordPolicyList);
        },
        error: function error() {
          console.error("Error on GET in getPasswordPolicyList()");
          _this28.globals.showErrorSnackbar(_this28.lang.G00006);
        }
      });
    },
    getSurveyInstancesStatusList: function getSurveyInstancesStatusList(callback) {
      var _this29 = this;

      if (!_.isEmpty(this.surveyInstancesStatusList)) {
        callback(this.surveyInstancesStatusList);
        return;
      }

      var queryString = "api/Data/SurveyInstancesStatusses";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this29.surveyInstancesStatusList = data;
          callback(_this29.surveyInstancesStatusList);
        },
        error: function error() {
          console.error("Error on GET in getSurveyInstancesStatusList()");
          _this29.globals.showErrorSnackbar(_this29.lang.G00022);
        }
      });
    },

    // source: https://stackoverflow.com/questions/20600800/js-client-side-exif-orientation-rotate-and-mirror-jpeg-images
    getImageOrientation: function getImageOrientation(image, callback) {
      if (!image) return;

      var reader = new FileReader();

      reader.onload = function (event) {
        var view = new DataView(event.target.result);

        if (view.getUint16(0, false) != 0xffd8) return callback(-2);

        var length = view.byteLength,
            offset = 2;

        while (offset < length) {
          var marker = view.getUint16(offset, false);
          offset += 2;

          if (marker == 0xffe1) {
            if (view.getUint32(offset += 2, false) != 0x45786966) {
              return callback(-1);
            }
            var little = view.getUint16(offset += 6, false) == 0x4949;
            offset += view.getUint32(offset + 4, little);
            var tags = view.getUint16(offset, little);
            offset += 2;

            for (var i = 0; i < tags; i++) {
              if (view.getUint16(offset + i * 12, little) == 0x0112) return callback(view.getUint16(offset + i * 12 + 8, little));
            }
          } else if ((marker & 0xff00) != 0xff00) break;else offset += view.getUint16(offset, false);
        }
        return callback(-1);
      };

      reader.readAsArrayBuffer(image.slice(0, 64 * 1024));
    },
    resetImageOrientation: function resetImageOrientation(srcImage, srcOrientation, callback) {
      var _this30 = this;

      if (srcOrientation === 1) {
        callback(srcImage);
        return;
      }

      var img = new Image();

      img.onload = function () {
        var width = img.width,
            height = img.height,
            canvas = document.createElement("canvas"),
            ctx = canvas.getContext("2d");

        // set proper canvas dimensions before transform & export
        if (4 < srcOrientation && srcOrientation < 9) {
          canvas.width = height;
          canvas.height = width;
        } else {
          canvas.width = width;
          canvas.height = height;
        }

        // transform context before drawing image
        switch (srcOrientation) {
          case 2:
            ctx.transform(-1, 0, 0, 1, width, 0);
            break;
          case 3:
            ctx.transform(-1, 0, 0, -1, width, height);
            break;
          case 4:
            ctx.transform(1, 0, 0, -1, 0, height);
            break;
          case 5:
            ctx.transform(0, 1, 1, 0, 0, 0);
            break;
          case 6:
            ctx.transform(0, 1, -1, 0, height, 0);
            break;
          case 7:
            ctx.transform(0, -1, -1, 0, height, width);
            break;
          case 8:
            ctx.transform(0, -1, 1, 0, 0, width);
            break;
          default:
            break;
        }

        // draw image
        ctx.drawImage(img, 0, 0);

        var file = _this30.dataURItoBlob(canvas.toDataURL(srcImage.type));
        file.name = srcImage.name;
        file.lastModifiedDate = new Date();

        // export base64
        callback(file);
      };

      img.src = srcImage.imageUrl;
    },

    //source: https://web.archive.org/web/20160425180542/http://blog.devteaminc.co/posting-a-canvas-image-to-twitter-using-oauth/
    dataURItoBlob: function dataURItoBlob(dataURI) {
      // convert base64/URLEncoded data component to raw binary data held in a string
      var byteString;
      if (dataURI.split(",")[0].indexOf("base64") >= 0) byteString = atob(dataURI.split(",")[1]);else byteString = unescape(dataURI.split(",")[1]);
      // separate out the mime component
      var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
      // write the bytes of the string to a typed array
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ia], { type: mimeString });
    },
    doAfterNTicks: function doAfterNTicks(that, n, f) {
      var _this31 = this;

      that.$nextTick(function () {
        if (n < 2) f();else _this31.doAfterNTicks(that, n - 1, f);
      });
    },

    //source: https://stackoverflow.com/questions/16308037/detect-when-elements-within-a-scrollable-div-are-out-of-view
    isNodeVisibleInDOM: function isNodeVisibleInDOM(elem, container, partial) {
      var contHeight = $(container).height();
      var elemTop = $(elem).offset().top - $(container).offset().top;
      var elemBottom = elemTop + $(elem).height();

      var isTotal = elemTop >= 0 && elemBottom <= contHeight;
      var isPart = (elemTop < 0 && elemBottom > 0 || elemTop > 0 && elemTop <= contHeight) && partial;

      return isTotal || isPart;
    },
    truncateString: function truncateString(str, maxLength) {
      if (!str || typeof str !== "string") return "";
      return _.truncate(str, {
        length: maxLength,
        separator: " "
      });
    },
    getMarkupText: function getMarkupText(html) {
      if (!html || typeof html !== "string") return "";
      var container = document.createElement("DIV");
      container.innerHTML = html;
      return container.textContent || container.innerText || "";
    },
    isLocalizedDateTodayOrBefore: function isLocalizedDateTodayOrBefore(date) {
      var momentDate = __WEBPACK_IMPORTED_MODULE_5_moment___default()(date, this.currentDateFormatForMoment);
      return momentDate.isValid() && this.isISODateTodayOrBefore(momentDate);
    },
    isISODateTodayOrBefore: function isISODateTodayOrBefore(date) {
      if (!date) return false;
      var momentDate = __WEBPACK_IMPORTED_MODULE_5_moment___default()(date);
      if (!momentDate.isValid()) return false;
      var today = __WEBPACK_IMPORTED_MODULE_5_moment___default()(new Date());
      return momentDate.isSameOrBefore(today, "day");
    },
    stringEqualsWithoutWildcard: function stringEqualsWithoutWildcard(str1, str2) {
      if (typeof str1 !== "string" || typeof str2 !== "string") return false;
      str1 = str1.replace(/%/g, "");
      str2 = str2.replace(/%/g, "");
      if (str1 === str2) return true;
      return false;
    },
    removeWildcardsFromString: function removeWildcardsFromString(str) {
      if (typeof str !== "string") return "";
      return str.replace(/%/g, "");
    },
    addWildcardsToString: function addWildcardsToString(str) {
      if (!str || typeof str !== "string") return "";
      return "%" + str + "%";
    },
    doAfterEvents: function doAfterEvents(eventList, task) {
      var target = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this;

      var count = eventList.length;
      var execute = function execute() {
        if (--count > 0) return;
        task();
      };
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(eventList), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var event = _step6.value;

          target.$once(event, execute);
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }
    },
    toLocaleDateTimeString: function toLocaleDateTimeString(string) {
      if (!string) return;
      var date = new Date(string);
      return date.toLocaleString();
    },
    toLocaleDateString: function toLocaleDateString(string) {
      if (!string) return;
      var date = new Date(string);
      return date.toLocaleDateString();
    },
    insertAtCaret: function insertAtCaret(areaId, text) {
      var area = document.getElementById(areaId);
      var start = area.selectionStart;
      var end = area.selectionEnd;

      $(area).val($(area).val().substring(0, start) + text + $(area).val().substring(end));
      area.selectionStart = area.selectionEnd = start + 1;
    }
  },
  watch: {
    selectedLanguage: function selectedLanguage(newLanguage) {
      if (newLanguage) {
        this.langCache = {};
        this.getLanguageStrings(this);
        this.localizeFlatpickrConfig();
        this.settlementStatusses = {};
        this.countryList = {};
        this.occupationalGroupList = {};
        this.$emit("languageUpdated");
      }
    }
  },
  data: function data() {
    return {
      currentUserInfo: null,
      selectedLanguage: "",
      spinnerVisible: false,
      tooltipDelay: {
        show: 500,
        hide: 100
      },
      flatpickrDateConfig: {
        altInput: true,
        altFormat: "Y-m-d",
        dateFormat: "Y-m-d",
        defaultDate: [""],
        locale: "en",
        clickOpens: false,
        disableMobile: true
      },
      flatpickrIsoDateConfig: {
        altInput: true,
        altFormat: "Y-m-d",
        dateFormat: "Z",
        defaultDate: [""],
        locale: "en",
        clickOpens: false,
        disableMobile: true
      },
      flatpickrTimeConfig: {
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        time_24hr: true,
        locale: "en",
        clickOpens: false,
        // disableMobile: true,
        onOpen: function onOpen(selectedDates, dateStr, instance) {
          if (selectedDates.length === 0) instance.setDate("12:00", true, "H:i");
        }
      },
      flatpickrDatetimeConfig: {
        altInput: true,
        altFormat: "Y-m-d H:i",
        enableTime: true,
        dateFormat: "Y-m-d H:i",
        time_24hr: true,
        locale: "en",
        clickOpens: false,
        disableMobile: true
      },
      snackbarConfig: {
        content: "", // text of the snackbar
        style: "",
        timeout: 3000,
        htmlAllowed: false
      },
      countryList: {},
      occupationalGroupList: {},
      timezonesList: [],
      regionsList: [],
      languageList: {},
      userTypeList: {},
      agencyTypeList: [],
      securityRoleList: [],
      userList: [],
      distanceUnitList: {},
      countryLanguageList: [],
      localeList: [],
      passwordPolicyList: [],
      surveyInstancesStatusList: [],
      settlementStatusses: {},
      clientList: [],
      importerList: [],
      carModelList: [],
      carSegmentList: [],
      pendingUploads: {},
      currentUploadProgress: 100,
      langCache: {},
      lang: {
        G00000: "No results found",
        G00001: "Upload canceled",
        G00002: "Upload failed",
        G00003: "Language data access failed",
        G00004: "Country data request failed",
        G00005: "Occupational group data request failed",
        G00006: "Password policy data request failed",
        G00007: "Invoice status list data request failed",
        G00008: "Timezone data request failed",
        G00009: "Region data request failed",
        G00010: "Language data request failed",
        G00011: "Client data request failed",
        G00012: "Project data request failed",
        G00013: "Wave data request failed",
        G00014: "Scenario data request failed",
        G00015: "Agency data request failed",
        G00016: "Shopper data request failed",
        G00017: "User type data request failed",
        G00018: "Security role data request failed",
        G00019: "Distance unit data request failed",
        G00020: "Country language data request failed",
        G00021: "Locale data request failed",
        G00022: "Check status data request failed",
        G00023: "Success",
        G00024: "Error",
        G00025: "File download failed",
        G00026: "Importer data request failed",
        G00027: "Agency type data request failed",
        G00028: "Car model data request failed",
        G00029: "Car segment data request failed",
        G00030: "User data request failed"
      }
    };
  }
});

/* harmony default export */ __webpack_exports__["a"] = (globals);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__features_json__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__features_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__features_json__);



var CURRENT_TARGET = "audi";

var feature = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  computed: {
    currentTarget: function currentTarget() {
      return CURRENT_TARGET;
    },
    isAudiTarget: function isAudiTarget() {
      return CURRENT_TARGET.indexOf("audi") > -1;
    }
  },
  methods: {
    isEnabled: function isEnabled(name) {
      if (!__WEBPACK_IMPORTED_MODULE_1__features_json___default.a[name] || !__WEBPACK_IMPORTED_MODULE_1__features_json___default.a[name].target) {
        console.error("Unknown feature: " + name);
        return false;
      }

      var targets = __WEBPACK_IMPORTED_MODULE_1__features_json___default.a[name].target.split(" ");
      if (targets.indexOf(CURRENT_TARGET) > -1) return true;
      return false;
    },
    isDisabled: function isDisabled(name) {
      return !this.isEnabled(name);
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (feature);

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    togglePermission: function togglePermission(_items) {
      var selected = _.takeWhile(_items, ["permitted", true]);
      if (selected.length !== _items.length) _.forEach(_items, function (itm) {
        itm.permitted = true;
      });else _.forEach(_items, function (itm) {
        itm.permitted = false;
      });
    },
    getSelectedItems: function getSelectedItems(_items) {
      var results = [];
      _.forEach(_items, function (l) {
        if (l.permitted) results.push(l.id);
      });
      return results;
    },
    putItems: function putItems(_this, _url, _items, _source, _successCallback, _errorCallback) {
      $.ajax({
        method: "PUT",
        url: _url,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_items),
        dataType: "json",
        contentType: "application/json; charset=utf-8",

        success: function success() {
          _successCallback();
        },
        error: function error(data) {
          if (data.statusText == "OK") return;
          console.error("Error on PUT in " + _source + ".saveChanges()");
          _errorCallback();
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 210 */,
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1063)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(541),
  /* template */
  __webpack_require__(1700),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-79e3792d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 212 */
/***/ (function(module, exports) {

module.exports = {"name":"msm_loop_v2","version":"2.2.10","description":"MSM Loop v2","author":"Marc Stöckel","private":true,"scripts":{"dev":"node build/dev-server.js","start":"node build/dev-server.js config=localhost","start-audi":"node build/dev-server.js config=localhost-audi","build":"node build/build.js","test":"jest","pree2e":"webdriver-manager update --standalone","e2e":"protractor"},"googleApiKeys":{"dev":"AIzaSyAYTZ_Xy5ho5kkg8hr91JiSYdoXY16JgqI","msm":"AIzaSyANcvr9_qvJu0_Qj4DqcWPygtQALed9pRQ","audi":"AIzaSyANXa3eXWwvDKV4fU94IJAsYDdhQTqe3lo"},"jest":{"setupFiles":["./src/setup-jest.js"],"moduleFileExtensions":["js","json","vue"],"moduleNameMapper":{"^@[/](.+)":"<rootDir>/src/$1","^components[/](.+)":"<rootDir>/src/components/$1","src/components/([^\\.]*)$":"<rootDir>/src/components/$1.vue","^vue$":"vue/dist/vue.common.js","src/([^\\.]*)$":"<rootDir>/src/$1.vue","ace-builds":"<rootDir>/node_modules/ace-builds"},"transform":{".*\\.(vue)$":"vue-jest",".+\\.(css|styl|less|sass|scss|png|jpg|ttf|woff|woff2)$":"jest-transform-stub","^.+\\.js$":"<rootDir>/node_modules/babel-jest"},"transformIgnorePatterns":["<rootDir>/node_modules/(?!(cropperjs)/)"],"collectCoverage":false,"collectCoverageFrom":["src/components/**/*.{js,vue}","!**/node_modules/**"],"coverageReporters":["html","text-summary"]},"dependencies":{"@riophae/vue-treeselect":"0.0.38","ace-builds":"1.4.7","animate.css":"3.7.0","base64url":"3.0.1","bootstrap":"3.3.7","bootstrap-material-design":"0.5.10","bootstrap-vue":"2.0.0-rc.11","css-vars-ponyfill":"2.2.1","dhtmlx-gantt":"5.2.0","flatpickr":"4.6.3","inputmask":"4.0.8","jquery":"3.3.1","keycloak-js":"^6.0.1","liquor-tree":"0.2.61","lodash":"4.17.11","material-design-icons":"3.0.1","material-symbols":"^0.34.1","moment":"2.24.0","protractor":"^7.0.0","select2":"4.0.10","snackbarjs":"1.1.0","survey-knockout":"1.0.72","survey-vue":"1.0.87","surveyjs-editor":"1.0.72","text-encoding-shim":"1.0.5","typeface-roboto":"0.0.54","uuid":"3.3.2","vue":"2.6.12","vue-click-outside":"1.0.7","vue-cropperjs":"2.2.2","vue-currency-input":"1.6.0","vue-router":"3.0.1","vuejs-logger":"^1.5.5","vuex":"3.1.3"},"devDependencies":{"@vue/test-utils":"1.0.0-beta.27","autoprefixer":"^6.7.2","babel-core":"^6.22.1","babel-jest":"23.6.0","babel-loader":"^6.2.10","babel-plugin-transform-es2015-for-of":"^6.23.0","babel-plugin-transform-runtime":"^6.22.0","babel-polyfill":"^6.26.0","babel-preset-env":"^1.3.2","babel-preset-stage-2":"^6.22.0","babel-register":"^6.22.0","chalk":"^1.1.3","connect-history-api-fallback":"^1.3.0","copy-webpack-plugin":"^4.0.1","css-loader":"^0.28.0","eventsource-polyfill":"^0.9.6","execa":"^1.0.0","express":"^4.14.1","extract-text-webpack-plugin":"^2.0.0","file-loader":"^0.11.1","flush-promises":"^1.0.2","friendly-errors-webpack-plugin":"^1.1.3","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.19.1","jasmine-reporters":"^2.3.2","jest":"23.6.0","jest-transform-stub":"^2.0.0","npm":"^6.4.1","opn":"^4.0.2","optimize-css-assets-webpack-plugin":"^1.3.0","ora":"^1.2.0","phantomjs-prebuilt":"^2.1.16","protractor-jasmine2-screenshot-reporter":"^0.5.0","rimraf":"^2.6.0","semver":"^5.3.0","shelljs":"^0.8.5","url-loader":"^1.0.1","vue-jest":"3.0.0","vue-loader":"^12.1.0","vue-style-loader":"^3.0.1","vue-template-compiler":"2.6.12","webpack":"^2.6.1","webpack-bundle-analyzer":"^2.2.1","webpack-dev-middleware":"^1.10.0","webpack-hot-middleware":"^2.18.0","webpack-merge":"^4.1.0","webpack-version-file-plugin":"^0.3.3","ws":"3.3.2"},"engines":{"node":">= 4.0.0","npm":">= 3.0.0"},"browserslist":["> 1%","last 2 versions","not ie <= 8"]}

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "keycloak", function() { return keycloak; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_flatpickr_dist_themes_material_blue_css__ = __webpack_require__(1001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_flatpickr_dist_themes_material_blue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_flatpickr_dist_themes_material_blue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_design_icons_iconfont_material_icons_css__ = __webpack_require__(1002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_design_icons_iconfont_material_icons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_design_icons_iconfont_material_icons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_typeface_roboto_index_css__ = __webpack_require__(1005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_typeface_roboto_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_typeface_roboto_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_animate_css_animate_min_css__ = __webpack_require__(991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_animate_css_animate_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_animate_css_animate_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_snackbarjs__ = __webpack_require__(1544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_snackbarjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_snackbarjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__App__ = __webpack_require__(1553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__router__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__globals__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__feature__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_material_symbols_outlined_css__ = __webpack_require__(1003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_material_symbols_outlined_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_material_symbols_outlined_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__services_app_service__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_keycloak_js__ = __webpack_require__(1520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_keycloak_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_keycloak_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuejs_logger__ = __webpack_require__(1748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuejs_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vuejs_logger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_currency_input__ = __webpack_require__(1552);

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




















// Import JS services

Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype, "$appService", {
  value: __WEBPACK_IMPORTED_MODULE_16__services_app_service__["a" /* default */]
});

// Import Keycloak JS Adapter


var options = {
  isEnabled: true,
  logLevel: __WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip ? "error" : "debug",
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: "|",
  showConsoleColors: true
};
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_18_vuejs_logger___default.a, options);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_19_vue_currency_input__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component("treeselect", __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.globals = __WEBPACK_IMPORTED_MODULE_12__globals__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.feature = __WEBPACK_IMPORTED_MODULE_13__feature__["a" /* default */];

var initOptions = {
  url: "https://dev.authentication.audi-mysteryshopping.com/auth",
  realm: "AudiLoopDev",
  clientId: "loopOpFrontend",
  onLoad: "login-required",
  enableLogging: false
};

if ("audi".includes("dev-audi")) {
  if (initOptions.url == undefined) {
    initOptions.url = "https://dev.authentication.audi-mysteryshopping.com/auth";
  }
  if (initOptions.realm == undefined) {
    initOptions.realm = "AudiLoopDev";
  }
  if (initOptions.clientId == undefined) {
    initOptions.clientId = "loopOpFrontend";
  }
  if (initOptions.onLoad == undefined) {
    initOptions.onLoad = "login-required";
  }
}

if (__WEBPACK_IMPORTED_MODULE_16__services_app_service__["a" /* default */].getAccessToken()) initOptions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, initOptions, {
  token: __WEBPACK_IMPORTED_MODULE_16__services_app_service__["a" /* default */].getAccessToken(),
  refreshToken: __WEBPACK_IMPORTED_MODULE_16__services_app_service__["a" /* default */].getRefreshToken(),
  idToken: __WEBPACK_IMPORTED_MODULE_16__services_app_service__["a" /* default */].getIdToken()
});

var keycloak = __WEBPACK_IMPORTED_MODULE_17_keycloak_js__(initOptions);
try {
  keycloak.init(initOptions).success(function (auth) {
    if (!auth) {
      __WEBPACK_IMPORTED_MODULE_16__services_app_service__["a" /* default */].removeTokensFromStorage();
      window.location.reload();
    } else {
      __WEBPACK_IMPORTED_MODULE_16__services_app_service__["a" /* default */].storeTokensInStorage(keycloak.token, keycloak.idToken, keycloak.refreshToken);
      __WEBPACK_IMPORTED_MODULE_16__services_app_service__["a" /* default */].configureAjaxSetup();

      new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
        el: "#app",
        router: __WEBPACK_IMPORTED_MODULE_11__router__["a" /* default */],
        store: __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */],
        template: "<App/>",
        components: {
          App: __WEBPACK_IMPORTED_MODULE_10__App___default.a
        },
        render: function render(h) {
          return h(__WEBPACK_IMPORTED_MODULE_10__App___default.a);
        }
      }).$mount("#app");
    }

    //Token Refresh
    setInterval(function () {
      keycloak.updateToken(70).success(function (refreshed) {
        if (refreshed) {
          __WEBPACK_IMPORTED_MODULE_16__services_app_service__["a" /* default */].storeTokensInStorage(keycloak.token, keycloak.idToken, keycloak.refreshToken);
          __WEBPACK_IMPORTED_MODULE_16__services_app_service__["a" /* default */].configureAjaxSetup();
        } else {
          console.warn("Token not refreshed, valid for " + Math.round(keycloak.tokenParsed.exp + keycloak.timeSkew - new Date().getTime() / 1000) + " seconds");
        }
      }).error(function () {
        console.error("Failed to refresh token!");
        __WEBPACK_IMPORTED_MODULE_16__services_app_service__["a" /* default */].removeTokensFromStorage();
        window.location.reload();
      });
    }, 20000);
  }).error(function () {
    console.error("Authentification failed!");
    __WEBPACK_IMPORTED_MODULE_16__services_app_service__["a" /* default */].removeTokensFromStorage();
    window.location.reload();
  });
} catch (error) {
  console.warn("Something went wrong. Redirecting to login.");
  __WEBPACK_IMPORTED_MODULE_16__services_app_service__["a" /* default */].removeTokensFromStorage();
  window.location.reload();
}



/***/ }),
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ClientManagement_ClientManagement__ = __webpack_require__(1568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ClientManagement_ClientManagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ClientManagement_ClientManagement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_LocationManagement_LocationManagement__ = __webpack_require__(1583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_LocationManagement_LocationManagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_LocationManagement_LocationManagement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_LocationManagement_LocationImport__ = __webpack_require__(1581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_LocationManagement_LocationImport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_LocationManagement_LocationImport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_UserManagement__ = __webpack_require__(1630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_UserManagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_UserManagement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_SurveyEditor_SurveyEditor__ = __webpack_require__(1617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_SurveyEditor_SurveyEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_SurveyEditor_SurveyEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ProjectManagement_ProjectManagement__ = __webpack_require__(1586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ProjectManagement_ProjectManagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_ProjectManagement_ProjectManagement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_AgencyManagement_AgencyManagement__ = __webpack_require__(1554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_AgencyManagement_AgencyManagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_AgencyManagement_AgencyManagement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_SurveyManagement_SurveyManagement__ = __webpack_require__(1619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_SurveyManagement_SurveyManagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_SurveyManagement_SurveyManagement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_CheckManagement_CheckManagement__ = __webpack_require__(1562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_CheckManagement_CheckManagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_CheckManagement_CheckManagement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_SurveyView_SurveyView__ = __webpack_require__(1622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_SurveyView_SurveyView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_SurveyView_SurveyView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_KPIManagement_KPIManagement__ = __webpack_require__(1576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_KPIManagement_KPIManagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_KPIManagement_KPIManagement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_DataProtection__ = __webpack_require__(1570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_DataProtection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_DataProtection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Imprint__ = __webpack_require__(1572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Imprint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Imprint__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_PageNotFound__ = __webpack_require__(1585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_PageNotFound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_PageNotFound__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_StatusManagement_StatusManagement__ = __webpack_require__(1614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_StatusManagement_StatusManagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_StatusManagement_StatusManagement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_ShopperManagement_ShopperManagement__ = __webpack_require__(1613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_ShopperManagement_ShopperManagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_ShopperManagement_ShopperManagement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_ShopperManagement_ShopperCheckManagement__ = __webpack_require__(1611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_ShopperManagement_ShopperCheckManagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_ShopperManagement_ShopperCheckManagement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Recruiting_Recruiting__ = __webpack_require__(1594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Recruiting_Recruiting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_Recruiting_Recruiting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_ShopperApproval_ShopperApproval__ = __webpack_require__(1598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_ShopperApproval_ShopperApproval___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_ShopperApproval_ShopperApproval__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_UserSettings__ = __webpack_require__(1634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_UserSettings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_UserSettings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Wizards_AppWizard_vue__ = __webpack_require__(1635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Wizards_AppWizard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_Wizards_AppWizard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Wizards_ConfigOverview_vue__ = __webpack_require__(1644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Wizards_ConfigOverview_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_Wizards_ConfigOverview_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__feature__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__globals__ = __webpack_require__(85);




























__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var routes = [
// Routes to the different components are registered here
{
  path: "/config/:configurationGuid",
  name: "Wizard",
  component: __WEBPACK_IMPORTED_MODULE_22__components_Wizards_AppWizard_vue___default.a
}, {
  path: "/config/:configurationGuid/:step",
  name: "Wizard",
  component: __WEBPACK_IMPORTED_MODULE_22__components_Wizards_AppWizard_vue___default.a
}, {
  path: "/configoverview",
  name: "ConfigOverview",
  component: __WEBPACK_IMPORTED_MODULE_23__components_Wizards_ConfigOverview_vue___default.a
}, {
  path: "/clientmanagement",
  name: "ClientManagement",
  component: __WEBPACK_IMPORTED_MODULE_2__components_ClientManagement_ClientManagement___default.a
}, {
  path: "/locationmanagement",
  name: "LocationManagement",
  component: __WEBPACK_IMPORTED_MODULE_3__components_LocationManagement_LocationManagement___default.a
}, {
  path: "/locationimport/:clientGuid",
  name: "LocationImport",
  component: __WEBPACK_IMPORTED_MODULE_4__components_LocationManagement_LocationImport___default.a
}, {
  path: "/usermanagement",
  name: "UserManagement",
  component: __WEBPACK_IMPORTED_MODULE_5__components_UserManagement___default.a
}, {
  path: "/surveyeditor",
  name: "SurveyEditor",
  component: __WEBPACK_IMPORTED_MODULE_6__components_SurveyEditor_SurveyEditor___default.a
}, {
  path: "/projectmanagement",
  name: "ProjectManagement",
  component: __WEBPACK_IMPORTED_MODULE_7__components_ProjectManagement_ProjectManagement___default.a
}, {
  path: "/agencymanagement",
  name: "AgencyManagement",
  component: __WEBPACK_IMPORTED_MODULE_8__components_AgencyManagement_AgencyManagement___default.a
}, {
  path: "/surveymanagement",
  name: "SurveyManagement",
  component: __WEBPACK_IMPORTED_MODULE_9__components_SurveyManagement_SurveyManagement___default.a
}, {
  path: "/checkmanagement",
  name: "CheckManagement",
  component: __WEBPACK_IMPORTED_MODULE_10__components_CheckManagement_CheckManagement___default.a
}, {
  path: "/surveyview/:surveyInstanceId",
  name: "SurveyView",
  component: __WEBPACK_IMPORTED_MODULE_11__components_SurveyView_SurveyView___default.a
}, {
  path: "/kpimanagement",
  name: "KPIManagement",
  component: __WEBPACK_IMPORTED_MODULE_12__components_KPIManagement_KPIManagement___default.a
}, {
  path: "/dataprotection",
  name: "DataProtection",
  component: __WEBPACK_IMPORTED_MODULE_13__components_DataProtection___default.a
}, {
  path: "/imprint",
  name: "Imprint",
  component: __WEBPACK_IMPORTED_MODULE_14__components_Imprint___default.a
}, {
  path: "/surveycode",
  name: "SurveyCodeLogin"
}, {
  path: "/surveycode/:sc",
  name: "SurveyCodeDirectLogin"
}, {
  path: "/callback",
  name: "DirectToLoginCallback"
}, {
  path: "/logout_callback",
  name: "DirectToLogoutCallback"
}, {
  path: "/statusmanagement",
  name: "StatusManagement",
  component: __WEBPACK_IMPORTED_MODULE_16__components_StatusManagement_StatusManagement___default.a
}];

if (__WEBPACK_IMPORTED_MODULE_24__feature__["a" /* default */].isEnabled("shoppermanagement")) {
  routes.push({
    path: "/shoppermanagement",
    name: "ShopperManagement",
    component: __WEBPACK_IMPORTED_MODULE_17__components_ShopperManagement_ShopperManagement___default.a
  });
  routes.push({
    path: "/shoppermanagement/checks",
    name: "ShopperCheckManagement",
    props: function props(route) {
      return {
        selectedShopperGuid: route.query.selectedShopperGuid
      };
    },
    component: __WEBPACK_IMPORTED_MODULE_18__components_ShopperManagement_ShopperCheckManagement___default.a
  });
}
if (__WEBPACK_IMPORTED_MODULE_24__feature__["a" /* default */].isEnabled("recruiting")) routes.push({
  path: "/recruiting",
  name: "Recruiting",
  component: __WEBPACK_IMPORTED_MODULE_19__components_Recruiting_Recruiting___default.a
});
if (__WEBPACK_IMPORTED_MODULE_24__feature__["a" /* default */].isEnabled("userSettings")) routes.push({
  path: "/settings",
  name: "UserSettings",
  component: __WEBPACK_IMPORTED_MODULE_21__components_UserSettings___default.a
});
if (__WEBPACK_IMPORTED_MODULE_24__feature__["a" /* default */].isEnabled("shopperApproval")) routes.push({
  path: "/shopperapproval",
  name: "ShopperApproval",
  component: __WEBPACK_IMPORTED_MODULE_20__components_ShopperApproval_ShopperApproval___default.a
});

routes.push({
  path: "*",
  name: "PageNotFound",
  component: __WEBPACK_IMPORTED_MODULE_15__components_PageNotFound___default.a
});

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  //mode: 'history',
  routes: routes
}));

/***/ }),
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1064)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(483),
  /* template */
  __webpack_require__(1702),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7cf5834e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1065)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(511),
  /* template */
  __webpack_require__(1703),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7d9f93f6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1066)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(537),
  /* template */
  __webpack_require__(1704),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7dcc8756",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1013)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(551),
  /* template */
  __webpack_require__(1650),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-09b90016",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 453 */,
/* 454 */,
/* 455 */
/***/ (function(module, exports) {

module.exports = {"dev":{"changes":[]},"2.2.8":{"date":"2026-07-24","changes":["Style update","General bugfixes and improvements"]},"2.2.7":{"date":"2026-03-31","changes":["Add geocode to shopper edit dialog"]},"2.2.6":{"date":"2026-03-17","changes":["Changed Above 65 to Above 70 in shopper age status indicator"]},"2.2.5":{"date":"2026-02-26","changes":["General bugfixes and improvements"]},"2.2.4":{"date":"2026-02-02","changes":["Configuration wizard","Wave status page","General bugfixes and improvements"]},"2.2.3":{"date":"2024-11-27","changes":["Adjustment of user permissions","Automated validation of checks","New survey export","Column changes for the approval and shopper tab","Shopper proposal by lead agency","Comment icon in the approval tab"]},"2.2.2":{"date":"2024-09-04","changes":["Added anonymization of shopper data older than 2 years","Changed the warning feature for the proposed shoppers from location to dealer group"]},"2.2.1":{"date":"2020-07-22","changes":["Added project filter for KPI translations","Enabled table setting storage for checks and KPIs","Enabled reporting group and security setting access for audi users","Disabled check opening for audi users","Improved check export content for audi system","Improved check status workflow","Some general bugfixes and improvements"]},"2.2.0":{"date":"2020-07-15","changes":["Added new importer management (Audi)","Added new agency types local and lead (Audi)","Added new user settings component","Added storage for table settings and filters (activate in user settings)","Added synchrionization of filters for clients, projects and importers (activate in user settings)","Added new approval component (Audi)","Added new car model management (Audi)","Added car model distribution for waves (Audi)","Added new wave info","Added new longtext for scenarios","Added some new properties to recruiting map pin info (Audi)","Added check deletion and copy of deleted checks for lead agencies (Audi)","Added new local agency check assignment dialog for lead agencies (Audi)","Added new check history","Added new location history","Added new wave status","Added Audi as new user type (Audi)","Added translation tool for location data","Added shopper name to checks table (Audi)","Added approved shopper informations to check view","Added KPI copy between projects of a client","Enabled editing of location properties on location creation","Enabled user management and recruiting access for agencies (Audi)","Enabled shopper management access for local agencies (Audi)","Disabled shopper list access (Audi)","Disabled clientmanagement access for agencies (Audi)","Disabled cost center for waves (Audi)","Disabled invoice features for Audi system","Limited user export and import to client users (Audi)","Changed visibility of some buttons depending on user policies","Moved location import and export to locationmanagement","Removed project accountables (Audi)","Updated Audi CI","Some general bugfixes and improvements"]},"2.1.2":{"date":"2020-07-01","changes":["Added total elements count for datatables","Added third state (not answered) for shopper properties checkbox type","Added distance filtering of shoppers in recruiting map","Added user account unlock by password reset","Some general bugfixes and improvements"]},"2.1.1":{"date":"2020-05-04","changes":["Added option to change own password for shoppers","Added german shopper manual download link","Added fixed position for table filters","Added free offers distance sort for shoppers","Added free offers distance and location free info for shopper","Changed translation for shopper custom properties","Improved free offers filter for shoppers","Improved email workflow for shopper registration","Fixed IBAN and BIC validation error because of included blanks","Some general bugfixes and performance improvements"]},"2.1.0":{"date":"2020-03-10","changes":["Added shopper filter for free offers","Added validation for IBAN and BIC","Added flag to list types of shopper properties to decide if the shopper should be able to add custom values","Added account status for shoppers","Added tooltip for invoice state values in checkmanagement","Added online state filter for free offers in checkmanagement","Added storage of table settings in shoppermanagement","Added new columns for postal code, country, city and location informations to free offers table for shoppers","Added new 404 page for undefined routes","Added some new translations","Added SurveyId information for KPIs","Added new check info (max. 50 characters)","Added date order check for start and end date of free offers","Added reset of check answer and status if a status 110 free offer is separated from its shopper","Added old shopper ID to administration tab of shopper profile","Improved tab rendering in some dialogs","Improved rendering performance for some data tables","Improved spinner behavior","Improved datepicker performance and month selection","Improved language request frequency on application start","Improved login workflow","Disabled filtering free offers by date and payment for shoppers","Disabled clients tab for Audi users","Removed check report template setting for surveys","Removed old surveycode from check export","Removed ability to delete or change the shopper of checks with invoice state \"o\"","Removed ability to delete checks from database that do not have status 100 or 300","Changed translation of survey title to \"project\" for shoppers","Fixed changing internal note for checks changed check status","Fixed upload dialog scaling down images after drawing mode usage","Fixed upload dialog showing up on pressing enter with focus inside survey form","Fixed shopper not able to copy information from invoice table","Fixed currency value of 0 in checks not passing validation","Fixed location property filter in recruiting component showing redundant values","Fixed shopper or agency not showing up in select on check editing","Fixed german translation for text length validation in survey","Fixed changing survey code after update of some reporting settings of the check","Fixed select2 rendering issue in firefox","Fixed an issue that prevented from changing check types in some cases","Fixed an issue with the user import receiving names with more than 19 characters","Some general bugfixes and styling improvements"]},"2.0.13":{"date":"2020-01-20","changes":["Added shopper management","Added shopper profile","Added shopper property management","Added shopper property form in shopper profile","Added recruiting component","Added payment module","Added free offers module","Added check type filter in check management","Added expiry date in check management","Added red text color for expired checks","Added cost center information for waves","Added internal note for checks","Added new question type \"expression\"","Added location information column instead of check description to shopper checks","Added new reporting permissions","Added preselection of new created checks in check management","Added new check states for deleted checks (301 - 304)","Limited reporting permissions for survey elements to groups that are assigned to the survey","Removed security group filter for survey elements","Fixed ability to save locations with high precision GPS coordinates","Improved behavior of check creation modal","Some general bugfixes"]},"2.0.10":{"date":"2019-10-30","changes":["Added target groups for reporting","Added briefing and survey documents","Added possibility for partner to export the survey translations","Added automatic retrieval of geocoding information for shopper and locations","Added export of last modified date of checks","Fixed order of location properties in check view not consistent","Fixed searching with chinese characters did not work","Fixed survey translations being truncated after 250 characters","Fixed wave based filtering of questions did not work as expected","Fixed shopper in rare cases overwriting translation answers given by MSM","Fixed multiple uploads in rare cases not being saved correctly","Fixed error when copying a user","Changed layout of \"survey already submitted\" notice when logging in with survey code"]},"2.0.6":{"date":"2019-08-15","changes":["Added delay to upload progress indicator","Added counter for selected locations and reset button in check creator","Added ability to change the location of existing checks","Added ability to open check properties readonly if their status is higher than 200","Added error message for user creation if the chosen username already exists","Added error message if no client is selected in user export with active client filter","Allowed cluster weight values up to 999.999","Changed translation of upload dialog button","Fixed some bugs in SurveyUploadDialog","Fixed user export error if custom property of the client is called \"Region\"","Fixed check deletion error","Some general bugfixes"]},"2.0.5":{"date":"2019-07-26","changes":["Added version number and changelog","Added progress indicator for file uploads","Bugfixes"]},"2.0.4":{"date":"2019-07-24","changes":["Improved survey translations","Added KPI translation dialog","Added ability to open checks in new browsertabs","Added check language selection","Added question numbers to survey editor filter selections","Added weight property to survey clusters","Fixed wrong orientation of some images after upload","Some more bugfixes and performance improvements"]}}

/***/ }),
/* 456 */
/***/ (function(module, exports) {

module.exports = {"briefingAndSurveyDocs":{"target":"prod training demo china dev audi training-audi dev-audi"},"changePasswordSelf":{"target":"training dev audi training-audi dev-audi"},"recruiting":{"target":"prod training demo china dev audi training-audi dev-audi"},"shoppermanagement":{"target":"prod training demo china dev audi training-audi dev-audi"},"surveyEditorJSONEditor":{"target":"prod demo training dev audi training-audi dev-audi"},"surveyQuizTimers":{"target":"demo dev"},"settlement":{"target":"prod training demo china dev audi training-audi dev-audi"},"freeOffers":{"target":"prod training demo china dev audi training-audi dev-audi"},"userSettings":{"target":"dev audi training-audi dev-audi"},"leadAgencies":{"target":"audi training-audi dev-audi"},"shopperApproval":{"target":"audi training-audi dev-audi"},"loginAs":{"target":"dev dev-audi"},"audi_importers":{"target":"audi training-audi dev-audi"}}

/***/ }),
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect_dist_vue_treeselect_min_css__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect_dist_vue_treeselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect_dist_vue_treeselect_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_material_design_dist_css_bootstrap_material_design_min_css__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_material_design_dist_css_bootstrap_material_design_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_material_design_dist_css_bootstrap_material_design_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_material_design_dist_css_ripples_min_css__ = __webpack_require__(993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_material_design_dist_css_ripples_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_bootstrap_material_design_dist_css_ripples_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bootstrap_material_design_dist_js_material_min_js__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bootstrap_material_design_dist_js_material_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_bootstrap_material_design_dist_js_material_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bootstrap_material_design_dist_js_ripples_min_js__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bootstrap_material_design_dist_js_ripples_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_bootstrap_material_design_dist_js_ripples_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(1534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_flatpickr__ = __webpack_require__(1512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_flatpickr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_flatpickr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_flatpickr_dist_l10n__ = __webpack_require__(1513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_flatpickr_dist_l10n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_flatpickr_dist_l10n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Tools_gmaps__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_css_vars_ponyfill__ = __webpack_require__(985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__package_json__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Tools_Dialogs_ConfirmationDialog__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Tools_Dialogs_ConfirmationDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_Tools_Dialogs_ConfirmationDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Tools_Dialogs_NotificationDialog__ = __webpack_require__(1628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Tools_Dialogs_NotificationDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_Tools_Dialogs_NotificationDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Tools_Dialogs_ChangelogModal__ = __webpack_require__(1623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Tools_Dialogs_ChangelogModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Tools_Dialogs_ChangelogModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Tools_Dialogs_UploadProgressModal__ = __webpack_require__(1629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Tools_Dialogs_UploadProgressModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_Tools_Dialogs_UploadProgressModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Tools_Dialogs_EditVatRatesModal__ = __webpack_require__(1624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Tools_Dialogs_EditVatRatesModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_Tools_Dialogs_EditVatRatesModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Tools_Dialogs_HtmlEditorModal__ = __webpack_require__(1627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Tools_Dialogs_HtmlEditorModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_Tools_Dialogs_HtmlEditorModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Tools_Dialogs_FeedModal__ = __webpack_require__(1626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Tools_Dialogs_FeedModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_Tools_Dialogs_FeedModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Tools_Dialogs_ElementHistoryModal__ = __webpack_require__(1625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Tools_Dialogs_ElementHistoryModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_Tools_Dialogs_ElementHistoryModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_AppSidebar_vue__ = __webpack_require__(1559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_AppSidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_AppSidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_AppHeaderAlternative_vue__ = __webpack_require__(1558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_AppHeaderAlternative_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_AppHeaderAlternative_vue__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Import CSS






// Import JavaScript




// Import flatpickr



// Google Maps






// import dialogs












/* harmony default export */ __webpack_exports__["default"] = ({
  name: "app",
  props: ["keycloak"],
  components: {
    ConfirmationDialog: __WEBPACK_IMPORTED_MODULE_15__components_Tools_Dialogs_ConfirmationDialog___default.a,
    NotificationDialog: __WEBPACK_IMPORTED_MODULE_16__components_Tools_Dialogs_NotificationDialog___default.a,
    ChangelogModal: __WEBPACK_IMPORTED_MODULE_17__components_Tools_Dialogs_ChangelogModal___default.a,
    UploadProgressModal: __WEBPACK_IMPORTED_MODULE_18__components_Tools_Dialogs_UploadProgressModal___default.a,
    EditVatRatesModal: __WEBPACK_IMPORTED_MODULE_19__components_Tools_Dialogs_EditVatRatesModal___default.a,
    HtmlEditorModal: __WEBPACK_IMPORTED_MODULE_20__components_Tools_Dialogs_HtmlEditorModal___default.a,
    FeedModal: __WEBPACK_IMPORTED_MODULE_21__components_Tools_Dialogs_FeedModal___default.a,
    ElementHistoryModal: __WEBPACK_IMPORTED_MODULE_22__components_Tools_Dialogs_ElementHistoryModal___default.a,
    AppSidebar: __WEBPACK_IMPORTED_MODULE_23__components_AppSidebar_vue___default.a,
    AppHeaderAlternative: __WEBPACK_IMPORTED_MODULE_24__components_AppHeaderAlternative_vue___default.a
  },
  beforeCreate: function beforeCreate() {
    var _this = this;

    $.material.init();
    this.$store.commit("initStore");
    window.addEventListener("click", function (e) {
      _this.$linkClicked = e.target.tagName.toLowerCase() === "a";
      setTimeout(function () {
        delete _this.$linkClicked;
      }, 100);
    });
    window.addEventListener("beforeunload", function () {
      if (!_this.$linkClicked) {
        _this.globals.$appUnloading = true;
        _this.$destroy();
      }
    });

    if (this.feature.isAudiTarget) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_css_vars_ponyfill__["a" /* default */])({
        variables: {
          "color-primary": "rgb(51, 51, 51)",
          "color-primary-rgb": "51, 51, 51",
          "color-primary-input": "rgb(51, 51, 51)",
          "color-primary-input-rgb": "51, 51, 51",
          "color-primary-input-hover": "rgb(76, 76, 76)",
          "color-primary-input-hover-rgb": "76, 76, 76",
          "active-alpha": "0.2"
        }
      });
      $("head > title").text("Audi Loop");
      $("head > link[type='image/x-icon']").attr("href", "/static/favicon-audi.webp");

      this.mainOpHost = "projects.audi-mysteryshopping.com";
    } else __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_css_vars_ponyfill__["a" /* default */])();

    // Makes tooltips available for all rendered components
    $(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });

    // Allows textarea to expand automatically
    // Applied globally on all textareas with the "autoExpand" class
    $(document).on("input.autoExpand", "textarea.autoExpand", function () {
      if (!this.scrollHeight) return;
      var minRows = 1,
          rows = void 0;
      this.rows = minRows;

      var style = window.getComputedStyle(this, null).getPropertyValue("font-size"); // Get font size from textarea
      var fontSize = parseFloat(style);

      if (!this.baseScrollHeight) {
        var valueBackup = this.value;
        this.value = "";
        this.baseScrollHeight = this.scrollHeight;
        this.value = valueBackup;
      }

      rows = Math.ceil((this.scrollHeight - this.baseScrollHeight) / (fontSize + 6)); // 6px for line spacing
      if (rows < 0) rows = 0;
      this.rows = minRows + rows;
    });

    $(document).on("show.bs.modal", ".modal", function () {
      var zIndex = 1040 + 10 * $(".modal:visible").length;
      $(this).css("z-index", zIndex);
      setTimeout(function () {
        $(".modal-backdrop").not(".modal-stack").css("z-index", zIndex - 1).addClass("modal-stack");
      }, 0);
    });

    // Ensures that select2 and flatpickr can get input focus inside modal
    $.fn.modal.Constructor.prototype.enforceFocus = function () {};
  },
  created: function created() {
    var _this2 = this;

    if (location.hash.indexOf("#/surveycode") > -1) return;

    var checkAccessToken = function checkAccessToken() {
      _this2.isAccessTokenAvailable = !!_this2.$appService.getAccessToken();
      if (!_this2.isAccessTokenAvailable) {
        console.warn("No access token available");
      }
    };

    this.globals.$off("accessTokenChanged");
    this.globals.$on("accessTokenChanged", checkAccessToken);
    checkAccessToken();

    $(document).ajaxStart(function () {
      _this2.globals.showSpinner();
    }).ajaxStop(function () {
      _this2.globals.hideSpinner();
    });

    this.$appService.initializeGlobalAjaxEvents();

    this.globals.$off("openGlobalConfirmationDialog");
    this.globals.$on("openGlobalConfirmationDialog", function (confirmationDialogData) {
      _this2.confirmationDialogData = confirmationDialogData;
      _this2.openConfirmationDialog();
    });

    this.globals.$off("openGlobalNotificationDialog");
    this.globals.$on("openGlobalNotificationDialog", function (notificationDialogData) {
      _this2.notificationDialogData = notificationDialogData;
      _this2.openNotificationDialog();
    });

    this.globals.$off("openEditVatRatesModal");
    this.globals.$on("openEditVatRatesModal", function () {
      _this2.showEditVatRatesModal = true;
    });

    this.globals.$off("openHtmlEditorModal");
    this.globals.$on("openHtmlEditorModal", function () {
      _this2.showHtmlEditorModal = true;
    });

    this.globals.$off("openGlobalUnsavedChangesDialog");
    this.globals.$on("openGlobalUnsavedChangesDialog", function (yesCallback, cancelCallback) {
      _this2.globals.$off("GlobalUnsavedChangesYesConfirmation");
      if (yesCallback) _this2.globals.$once("GlobalUnsavedChangesYesConfirmation", function () {
        yesCallback();
      });
      _this2.globals.$off("GlobalUnsavedChangesNoConfirmation");
      if (cancelCallback) _this2.globals.$once("GlobalUnsavedChangesNoConfirmation", function () {
        cancelCallback();
      });

      _this2.globals.$emit("openGlobalConfirmationDialog", {
        initiator: "GlobalUnsavedChanges",
        confirmationTitle: _this2.lang.A0025,
        colorRed: true,
        yesButtonText: _this2.lang.A0026,
        noButtonText: _this2.lang.A0027,
        htmlText: "<p><b>" + _this2.lang.A0028 + "</b></p>"
      });
    });

    this.initGoogleApi();
  },
  mounted: function mounted() {
    var _this3 = this;

    if (location.hash.indexOf("#/surveycode") > -1) return;

    // Gets executed right after rendering the component
    var userInfoCallback = function userInfoCallback() {
      if (_this3.globals.currentUserInfo.IsAudiUser) {
        _this3.$router.beforeResolve(function (to, from, next) {
          if (to.name === "ClientManagement") {
            next("/");
            return;
          }
          next();
        });
        if (_this3.$route.name === "ClientManagement") _this3.$router.push("/");
      }
      _this3.setInitialRoute();
      _this3.nextLanguage = _this3.globals.selectedLanguage;
    };
    this.globals.getCurrentUserInfo(userInfoCallback);

    this.getLanguageList();
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    if (this.feature.isAudiTarget) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_css_vars_ponyfill__["a" /* default */])({
        variables: {
          "color-primary": "rgb(51, 51, 51)",
          "color-primary-rgb": "51, 51, 51",
          "color-primary-input": "rgb(51, 51, 51)",
          "color-primary-input-rgb": "51, 51, 51",
          "color-primary-input-hover": "rgb(76, 76, 76)",
          "color-primary-input-hover-rgb": "76, 76, 76",
          "active-alpha": "0.2"
        }
      });
      $("head > title").text("Audi Loop");
      $("head > link[type='image/x-icon']").attr("href", "/static/favicon-audi.webp");

      this.mainOpHost = "projects.audi-mysteryshopping.com";
    } else __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_css_vars_ponyfill__["a" /* default */])();
  },

  computed: {
    userLoginState: function userLoginState() {
      return this.globals.currentUserInfo ? true : false;
    },
    showSidebar: function showSidebar() {
      return false;
    },
    sidebarClass: function sidebarClass() {
      // Standard: bei <1024px schmal, bei Override breit
      if (window.innerWidth <= 1024) {
        return this.isSidebarExpanded ? "app-body-sidebar-expanded" : "app-body-sidebar";
      }
      return "app-body-sidebar";
    }
  },
  methods: {
    redirectToSupport: function redirectToSupport() {
      if (this.feature.currentTarget === "china") {
        if (this.globals.currentUserRole < 2) window.open("https://help.msmloop.asia/redmine");else alert("Please contact your MSM Asia project manager!");
      } else {
        if (this.globals.currentUserRole == 2) window.open("https://projects.msmloop.com/api/Download/055f8eec-c35a-4bf3-ad9c-3190839d62bc");else window.open("http://help.msmloop.com/redmine/login");
      }
    },
    setInitialRoute: function setInitialRoute() {
      if (this.$route.name && this.$route.name !== "PageNotFound") return; // Route is already selected

      if (this.globals.currentUserRole === 1) {
        this.globals.currentUserInfo.IsAudiUser ? this.$router.push("/locationmanagement") : this.$router.push("/clientmanagement");
      } else if (this.globals.currentUserRole === 2) {
        this.$router.push("/checkmanagement");
      }
    },

    // Opens the dialog to select a language
    openSelectLanguageDialog: function openSelectLanguageDialog() {
      if (!this.globals.isAccessAllowed("LoopOp_SecurityUsersLocalization_Update") || !this.globals.isAccessAllowed("LoopOp_Language_Read")) {
        this.globals.showErrorSnackbar("Access denied");
        return;
      }
      $("#selectLanguageDialog").modal("show");
    },
    userLogout: function userLogout() {
      this.$appService.logout();
    },
    initGoogleApi: function initGoogleApi() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__components_Tools_gmaps__["a" /* default */])(_this4.globals.googleApiKey);

              case 3:
                _this4.globals.$emit("googleInitDone");
                _context.next = 9;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);

                console.error(_context.t0);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this4, [[0, 6]]);
      }))();
    },


    // Closes the language selection dialog
    closeSelectLanguageDialog: function closeSelectLanguageDialog() {
      $("#selectLanguageDialog").modal("hide");
    },


    // Requests a list of available languages from the server
    getLanguageList: function getLanguageList() {
      var _this5 = this;

      $.ajax({
        method: "GET",
        url: "api/Language",
        success: function success(data) {
          // this.languageList = data;
          //TODO: Only show german and english in production
          _this5.languageList = {
            de: data.de,
            en: data.en
          };
          if (["china", "dev"].indexOf(_this5.feature.currentTarget) > -1) _this5.languageList.zh = data.zh;
        },
        error: function error() {
          console.error("Language data access failed in getLanguageList()");
        }
      });
    },
    selectedLanguageDialogClosed: function selectedLanguageDialogClosed() {
      var _this6 = this;

      if (this.nextLanguage === this.globals.selectedLanguage) return;
      var param = "?LanguageCode=" + this.nextLanguage.substring(0, 2);

      $.ajax({
        method: "PUT",
        url: "api/SecurityUsers/Localization" + param,
        dataType: "text",
        success: function success(data) {
          _this6.globals.selectedLanguage = _this6.nextLanguage;
          _this6.globals.showSuccessSnackbar("Language switched to: " + _this6.globals.selectedLanguage);
        },
        error: function error() {
          console.error("Error on PUT in selectedLanguageDialogClosed()");
          _this6.globals.showErrorSnackbar("Language update failed");
        }
      });
    },
    openConfirmationDialog: function openConfirmationDialog() {
      this.confirmationDialogId = this.confirmationDialogData.initiator + "Confirmation";
      this.showConfirmationDialog = true;
    },
    onYesConfirmation: function onYesConfirmation() {
      this.globals.$emit(this.confirmationDialogData.initiator + "YesConfirmation");
      this.showConfirmationDialog = false;
    },
    onNoConfirmation: function onNoConfirmation() {
      this.globals.$emit(this.confirmationDialogData.initiator + "NoConfirmation");
      this.showConfirmationDialog = false;
    },
    onCloseConfirmationDialog: function onCloseConfirmationDialog() {
      this.globals.$emit(this.confirmationDialogData.initiator + "CloseDialog");
    },
    onConfirmationDialogClosed: function onConfirmationDialogClosed() {
      this.globals.$emit(this.confirmationDialogData.initiator + "DialogClosed");
      this.showConfirmationDialog = false;
    },
    openNotificationDialog: function openNotificationDialog() {
      this.notificationDialogId = this.notificationDialogData.initiator + "Notification";
      this.showNotificationDialog = true;
    },
    onCloseNotificationDialog: function onCloseNotificationDialog() {
      this.globals.$emit(this.notificationDialogData.initiator + "CloseDialog");
    },
    onNotificationDialogClosed: function onNotificationDialogClosed() {
      this.globals.$emit(this.notificationDialogData.initiator + "DialogClosed");
      this.showNotificationDialog = false;
    },
    toggleMobileMenu: function toggleMobileMenu() {
      console.warn("Toggling mobile menu");
      this.isSidebarExpanded = !this.isSidebarExpanded;
    }
  },
  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    },
    "globals.currentUploadProgress": function globalsCurrentUploadProgress(newValue) {
      var _this7 = this;

      if (newValue === 100) this.showUploadProgress = false;else {
        setTimeout(function () {
          if (_this7.globals.currentUploadProgress < 50) _this7.showUploadProgress = true;
        }, 1000);
      }
    }
  },
  data: function data() {
    // Global data inside the component is stored here
    return {
      currentPageTitle: "Dashboard",
      appVersion: __WEBPACK_IMPORTED_MODULE_14__package_json__["version"],
      mainOpHost: "projects.msmloop.com",
      isAccessTokenAvailable: false,
      isSidebarExpanded: false,
      nextLanguage: "en",
      languageList: {}, // Stores a list of all available languages
      lang: {
        A0000: "Clients",
        A0001: "Locations",
        A0002: "User",
        A0003: "Log Out",
        A0004: "Edit profile",
        A0006: "Language",
        A0007: "Select a language",
        A0009: "Accept",
        A0010: "Users",
        A0011: "Projects",
        A0012: "Partners",
        A0013: "Surveys",
        A0014: "Checks",
        A0015: "Survey View",
        A0016: "KPIs",
        A0017: "Data Protection",
        A0018: "Imprint",
        A0019: "Free Offers",
        A0020: "Survey Payment",
        A0021: "Support",
        A0023: "Shopper",
        A0024: "Settings",
        A0025: "Unsaved changes",
        A0026: "Yes",
        A0027: "Cancel",
        A0028: "There are unsaved changes that will be lost after this action. Do you want to proceed anyway?",
        A0029: "Recruiting",
        A0032: "Approval",
        A0033: "Logged in as",
        A0034: "Status",

        W00066: "Configurations"
      },
      confirmationDialogData: {},
      showConfirmationDialog: false,
      notificationDialogData: {},
      showNotificationDialog: false,
      confirmationDialogId: "confirmationDialog",
      notificationDialogId: "notificationDialog",
      showChangelogModal: false,
      showUploadProgress: false,
      showEditVatRatesModal: false,
      showHtmlEditorModal: false
    };
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AgencyManagementToolbar__ = __webpack_require__(1557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AgencyManagementToolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__AgencyManagementToolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AgencyManagementTable__ = __webpack_require__(1556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AgencyManagementTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__AgencyManagementTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AgencyManagementEditModal__ = __webpack_require__(1555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AgencyManagementEditModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__AgencyManagementEditModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Tools_Dialogs_ConfirmationDialog__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Tools_Dialogs_ConfirmationDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Tools_Dialogs_ConfirmationDialog__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "AgencyManagement",
  created: function created() {
    var _this = this;

    this.globals.getRegionsList(function (callbackData) {
      _this.allRegions = callbackData;
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    this.globals.getAgencyTypeList(function (data) {
      _this2.agencyTypeList = data;
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.writeComponentSettingsToStore();
  },
  data: function data() {
    return {
      showEditModal: false,
      showDeleteModal: false,
      tableFilter: "",
      tableElementCount: 0,
      pageSize: 20,
      pageNumer: 0,
      selectedAgency: {},
      agencySelected: false,
      modeAdd: null,
      allRegions: [],
      agencyTypeList: [],
      agencyList: [],
      refreshEnabled: false,
      lang: {
        AM0000: "Agentur löschen",
        AM0001: "Soll folgende Agentur wirklich gelöscht werden?",
        AM0002: "Ja",
        AM0003: "Nein",
        AM0004: "ID",
        AM0005: "Name",
        AM0006: "Agentur seit"
      }
    };
  },

  methods: {
    readComponentSettingsFromStore: function readComponentSettingsFromStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      var storedData = this.$store.getters["localFilters/agencyManagement"];
      if (storedData) {
        if (storedData.searchString) this.$refs["agencyManagementToolbar"].searchString = _.cloneDeep(storedData.searchString);
        if (storedData.pageSize) this.$refs["agencyManagementToolbar"].pageSize = _.cloneDeep(storedData.pageSize);
        if (storedData.currentSort) this.$refs["agencyManagementTable"].currentSort = _.cloneDeep(storedData.currentSort);
        this.$refs["agencyManagementToolbar"].emitUserSearch();
        this.$refs["agencyManagementToolbar"].emitChangePageSize();
      }
    },
    writeComponentSettingsToStore: function writeComponentSettingsToStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      if (this.$refs["agencyManagementToolbar"] && this.$refs["agencyManagementTable"]) {
        this.$store.commit("localFilters/agencyManagement", {
          searchString: this.$refs["agencyManagementToolbar"].searchString,
          currentSort: this.$refs["agencyManagementTable"].currentSort,
          pageSize: this.$refs["agencyManagementToolbar"].pageSize
        });
      }
    },
    toggleModal: function toggleModal(modeAdd) {
      this.modeAdd = modeAdd;
      if (modeAdd) {
        this.selectedAgency = {};
        this.agencySelected = false;
      }
      this.showEditModal = !this.showEditModal;
    },

    // Emits from toolbar
    onSearchTextChanged: function onSearchTextChanged(value) {
      this.tableFilter = value;
    },
    onPageSizeChanged: function onPageSizeChanged(value) {
      this.pageSize = value;
    },
    onPageNumberChanged: function onPageNumberChanged(value) {
      this.pageNumer = value - 1;
    },
    triggerReload: function triggerReload() {
      if (this.$refs.agencyManagementTable) this.$refs.agencyManagementTable.getAllAgencies();
    },

    // Emits from table
    onTableElementsCountChange: function onTableElementsCountChange(value) {
      this.tableElementCount = value;
    },
    onAgencySelected: function onAgencySelected(agency) {
      this.selectedAgency = agency;
      this.agencySelected = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(agency).length === 0 ? false : true;
    },
    onAgencyOpenEdit: function onAgencyOpenEdit(agency) {
      this.selectedAgency = agency;
      this.toggleModal(false);
    },

    // Emits from edit modal
    onModalClosed: function onModalClosed() {
      this.showEditModal = false;
    },
    onAgencyDeleted: function onAgencyDeleted() {
      var _this3 = this;

      $.ajax({
        method: "DELETE",
        url: "api/agencies/" + this.selectedAgency.AgencyGuid,
        success: function success() {
          _this3.showDeleteModal = false;
          _this3.onAgencySelected({});
          _this3.$refs.agencyManagementTable.getAllAgencies();
          _this3.globals.showSuccessSnackbar("Agency deletion successful");
        },
        error: function error(_error) {
          console.error("Error deleting agency", _error);
          _this3.globals.showErrorSnackbar("Agency deletion failed");
        }
      });
    },
    onAgencySaved: function onAgencySaved(newAgency) {
      var _this4 = this;

      var request = {
        method: "POST",
        url: "api/agencies",
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(newAgency),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          _this4.selectedAgency = newAgency;
          if (data[0]) _this4.selectedAgency.AgencyGuid = data[0].AgencyGuid;
          _this4.$refs.agencyManagementTable.getAllAgencies();
          _this4.globals.showSuccessSnackbar("Agency data update successful");
        },
        error: function error() {
          _this4.globals.showErrorSnackbar("Agency data update failed");
        }
      };

      if (!this.modeAdd) {
        request.method = "PUT";
        request.url += "/" + newAgency.AgencyGuid;
      }

      $.ajax(request);
    },
    onRefreshEnabled: function onRefreshEnabled(value) {
      this.refreshEnabled = value;
    }
  },
  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
      this.triggerReload();
    }
  },
  components: {
    AgencyManagementToolbar: __WEBPACK_IMPORTED_MODULE_2__AgencyManagementToolbar___default.a,
    AgencyManagementTable: __WEBPACK_IMPORTED_MODULE_3__AgencyManagementTable___default.a,
    AgencyManagementEditModal: __WEBPACK_IMPORTED_MODULE_4__AgencyManagementEditModal___default.a,
    ConfirmationDialog: __WEBPACK_IMPORTED_MODULE_5__Tools_Dialogs_ConfirmationDialog___default.a
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tools_Select2__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Tools_Select2__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "AgencyManagementEditModal",
  components: { Select2: __WEBPACK_IMPORTED_MODULE_0__Tools_Select2___default.a },
  props: ["showEditModal", "modeAdd", "editAgencyModel", "allRegions", "agencyList"],
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this);
      this.globals.getCountryList();
    }

    this.fpAgencySince = flatpickr("#inputAgencySince", this.globals.flatpickrDateConfig);

    this.globals.getAgencyTypeList(function (data) {
      _this.agencyTypeList = data;
      var localAgency = _.find(_this.agencyTypeList, function (at) {
        return at.AgencyTypeName === "Local";
      });
      _this.localAgencyTypeGuid = localAgency ? localAgency.AgencyTypeGuid : "";
    });
  },
  destroyed: function destroyed() {
    if (this.fpAgencySince) this.fpAgencySince.destroy();
  },
  data: function data() {
    return {
      lang: {
        AM3000: "Neue Agentur anlegen",
        AM3001: "Agentur bearbeiten",
        AM3002: "Stammdaten",
        AM3003: "Name",
        AM3004: "Straße",
        AM3005: "Stadt",
        AM3006: "PLZ",
        AM3007: "Land",
        AM3008: "Agentur seit",
        AM3009: "Abbrechen",
        AM3010: "Speichern",
        AM3011: "Region",
        AM3012: "Adresszusatz",
        AM3013: "Bitte auswählen...",
        AM3014: "Diese Angabe ist erforderlich!",
        AM3015: "Agency type",
        AM3016: "Lead agency"
      },
      agencyEditModel: {
        AgencyId: "",
        AgencyGuid: "",
        AgencyName: "",
        AgencyTypeGuid: "",
        AgencyAddress: "",
        AgencyAddress2: "",
        AgencyCity: "",
        AgencyPostalCode: "",
        AgencyCountry: "",
        AgencyState_Region: "",
        AgencySince: ""
      },
      showMe: false,
      regionsOfCountry: [],
      invalidInputIds: [],
      fpAgencySince: null,
      agencyTypeList: [],
      localAgencyTypeGuid: ""
    };
  },

  computed: {
    leadAgencyList: function leadAgencyList() {
      var _this2 = this;

      return this.agencyList.filter(function (ag) {
        return ag.AgencyTypeGuid !== _this2.localAgencyTypeGuid && ag.AgencyGuid !== _this2.agencyEditModel.AgencyGuid;
      });
    }
  },
  methods: {
    // Validates an input with the given id, changes the input color depending on the validation result and returns the result
    validateInput: function validateInput(id) {
      var result = $("#" + id)[0].checkValidity(); // Checks validation depending on the input type or a given pattern in the template
      if (result) {
        $("#" + id).parent().parent().removeClass("has-error"); // has-error has to be added to the form-group element
        var idx = this.invalidInputIds.indexOf(id);
        if (idx > -1) {
          this.invalidInputIds.splice(idx, 1); // Remove from list, if valid
        }
      } else {
        $("#" + id).parent().parent().addClass("has-error");
        if (this.invalidInputIds.indexOf(id) < 0) this.invalidInputIds.push(id); // Add to list, if invalid
      }
      return result;
    },


    // Returns true if an input has a validation error, otherwise false
    inputHasError: function inputHasError(id) {
      if (this.invalidInputIds.indexOf(id) > -1) return true;
      return false;
    },


    // Triggers input validation and ensures further progress if validation was successful
    validateBeforeSubmit: function validateBeforeSubmit(dialogId) {
      var result = true;

      var elements = $("#" + dialogId).find(":input"); // Returns a list of all inputs on the dialog
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0) result = this.validateInput(elements[i].id) && result; // If only one input is invalid, the whole form is invalid
      }

      if (dialogId == "editAgency") {
        if (!result) {
          this.globals.showErrorSnackbar("Form validation failed");
          return;
        }
        this.emitNewAgency();
      }
    },


    // Resets all validation errors for the given dialog
    resetValidationErrors: function resetValidationErrors(dialogId) {
      var elements = $("#" + dialogId).find(":input"); // Returns a list of all inputs on the dialog
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0) $("#" + elements[i].id).parent().parent().removeClass("has-error");
      }
      this.invalidInputIds = [];
    },
    toggleDialog: function toggleDialog(show) {
      var _this3 = this;

      if (show === false) {
        this.showMe = show;
      }

      if (this.showMe) {
        $("#editAgency").modal("show");
        if (this.modeAdd) {
          this.agencyEditModel = {};
          if (this.localAgencyTypeGuid) this.$set(this.agencyEditModel, "AgencyTypeGuid", this.localAgencyTypeGuid);

          if (this.globals.currentUserInfo.AgencyGuid) {
            var myAgency = _.find(this.leadAgencyList, function (a) {
              return a.AgencyGuid === _this3.globals.currentUserInfo.AgencyGuid.toUpperCase();
            });
            if (myAgency) this.agencyEditModel.ParentAgency = myAgency.AgencyGuid;
          }
          this.fpAgencySince.clear();
          this.$nextTick(function () {
            _this3.resetValidationErrors("editAgency");
          });
        } else this.getAgencyEditModel();
        if (!this.agencyEditModel.AgencyCountry) this.countryChanged(true);
      } else {
        $("#editAgency").modal("hide");
        this.$emit("modalClosed", true);
      }
    },
    getAgencyEditModel: function getAgencyEditModel() {
      var _this4 = this;

      $.ajax({
        method: "GET",
        url: "api/agencies/" + this.editAgencyModel.AgencyGuid,
        success: function success(data) {
          if (data.Error) {
            _this4.globals.showErrorSnackbar(data.Error);
            return;
          }

          if (data.ParentAgencies) {
            data.ParentAgency = data.ParentAgencies[0].AgencyGuid;
            delete data.ParentAgencies;
          }
          _this4.agencyEditModel = data;
          _this4.countryChanged();
          _this4.fpAgencySince.setDate(_this4.agencyEditModel.AgencySince, true, "Y-m-d");
          _this4.$nextTick(function () {
            _this4.resetValidationErrors("editAgency");
          });
        },
        error: function error() {
          console.error("Agency data access failed in getAgencyEditModel()");
          _this4.globals.showErrorSnackbar("Agency data access failed");
        }
      });
    },


    // Emit methods
    emitNewAgency: function emitNewAgency() {
      var saveData = _.cloneDeep(this.agencyEditModel);

      if (saveData.AgencyTypeGuid !== this.localAgencyTypeGuid) delete saveData.ParentAgency;

      if (saveData.ParentAgency) {
        saveData.ParentAgencies = [{ AgencyGuid: saveData.ParentAgency }];
        delete saveData.ParentAgency;
      }

      this.$emit("onAgencySaved", saveData);
      this.toggleDialog(false);
    },
    countryChanged: function countryChanged(resetRegionModel) {
      this.regionsOfCountry = [];
      var country = this.agencyEditModel.AgencyCountry;
      if (!this.allRegions) return;

      if (country) {
        var filteredRegions = this.allRegions.filter(function (r) {
          return r.Country.toLowerCase().indexOf(country.toLowerCase()) >= 0;
        });

        if (filteredRegions.length > 0) {
          this.regionsOfCountry = filteredRegions[0].Regions;
          this.$refs.editAgencyRegionSelect.reinit();
        }
      }

      if (!country || resetRegionModel) delete this.agencyEditModel.AgencyState_Region;
    }
  },
  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
      this.globals.getCountryList();
    },
    showEditModal: function showEditModal(newVal) {
      this.showMe = newVal;
      if (newVal) this.toggleDialog();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["tableFilter", "pageSize", "pageNumber", "selectedAgency"],
  name: "AgencyManagementTable",
  data: function data() {
    return {
      lang: {
        AM2000: "ID",
        AM2001: "Name",
        AM2002: "Straße",
        AM2003: "Stadt",
        AM2004: "Region",
        AM2005: "PLZ",
        AM2006: "Land",
        AM2007: "Adresszusatz",
        AM2008: "Agentur seit"
      },
      allAgencies: [],
      filteredAgencies: [],
      pagedAgencies: [],
      currentSort: { key: "AgencyId", asc: true }
    };
  },

  // Manage Lifecycle Hooks
  created: function created() {
    this.getAllAgencies();
  },
  mounted: function mounted() {
    var _this = this;

    this.setClientTableHeight();
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    // Sets the new table height after the window got resized
    $(window).on("resize", function () {
      _this.setClientTableHeight();
    }).resize();
  },

  // Methods
  methods: {
    // Common methods
    handleHttpError: function handleHttpError(err, text) {
      console.error("An error occured while fetching data from Back end\n        " + (text ? text : ""), err);
    },
    extractHttpData: function extractHttpData(response) {
      if (response.status === 200) {
        // When server respondet with OK - 200
        return response.body;
      } else {
        this.handleHttpError(null, response.statusText);
      }
    },
    setRefreshEnabled: function setRefreshEnabled(value) {
      this.$emit("onRefreshEnabled", value);
    },

    // Special methods
    getAllAgencies: function getAllAgencies() {
      var _this2 = this;

      this.setRefreshEnabled(false);

      $.ajax({
        method: "GET",
        url: "api/agencies",
        success: function success(res) {
          if (_.isEmpty(res)) res = [];
          _this2.allAgencies = res;
          _this2.$emit("agenciesReceived", _this2.allAgencies);
          _this2.filteredAgencies = res;
          _this2.emitTableElementCount();
          _this2.doPaging();
          _this2.orderTableCell("");
          _this2.doFiltering();
        },
        error: function error(_error) {
          _this2.handleHttpError(_error);
        },
        complete: function complete() {
          _this2.setRefreshEnabled(true);
        }
      });
    },
    selectAgency: function selectAgency(agency) {
      this.$emit("onAgencySelected", agency);
    },
    openEditAgency: function openEditAgency(agency) {
      if (!this.globals.isAccessAllowed("LoopOp_Agencies_Read")) return;
      this.$emit("onAgencyOpenEdit", agency);
    },
    showSortArrow: function showSortArrow(key, asc) {
      return this.currentSort.key === key && this.currentSort.asc === asc;
    },
    orderTableCell: function orderTableCell(orderProp) {
      var _this3 = this;

      // Nothing to sort by => return
      if (orderProp === "" && this.currentSort.key === "") return;

      if (orderProp !== "") {
        this.currentSort.key === orderProp ? this.currentSort.asc = !this.currentSort.asc : this.currentSort = { asc: true, key: orderProp };
      }

      var sortFunction = function sortFunction(agency) {
        if (typeof agency[_this3.currentSort.key] === "string") {
          return agency[_this3.currentSort.key].toLowerCase();
        }
        return agency[_this3.currentSort.key];
      };

      this.filteredAgencies = _.orderBy(this.filteredAgencies, [sortFunction], [this.currentSort.asc ? "asc" : "desc", "asc"]);
      this.doPaging();
    },
    doPaging: function doPaging() {
      var startIndex = this.pageNumber * this.pageSize;
      var endIndex = startIndex + this.pageSize;
      this.pagedAgencies = this.filteredAgencies.slice(startIndex, endIndex);
    },
    doFiltering: function doFiltering() {
      // Reset filtering when search string is empty
      this.tableFilter === "" || this.tableFilter === undefined ? (this.filteredAgencies = this.allAgencies, this.doPaging()) : null;

      var words = this.tableFilter.split(" ");
      // Get all keys from agency object
      var keys = ["AgencyId", "AgencyName", "AgencyTypeName", "AgencyAddress", "AgencyAddress2", "AgencyCity", "AgencyState_Region", "AgencyCountry", "AgencyPostalCode", "AgencySince"];

      var agencyFilter = function agencyFilter(agency) {
        var containsSearch = false;
        words.forEach(function (word) {
          keys.forEach(function (key) {
            if (agency[key] && agency[key].toString().toLowerCase().indexOf(word.toLowerCase()) > -1) {
              containsSearch = true;
              return;
            }
          });
        });
        return containsSearch;
      };

      this.filteredAgencies = this.allAgencies.filter(agencyFilter);
      this.currentSort.asc = !this.currentSort.asc;
      this.orderTableCell(this.currentSort.key);
      this.emitTableElementCount();
    },

    // Emits to parent component
    emitTableElementCount: function emitTableElementCount() {
      this.$emit("onTableElementsCountChange", this.filteredAgencies.length);
    },
    setClientTableHeight: function setClientTableHeight() {
      var height = $(window).height();
      height -= $(".agency--panel").height() + $("#app-navbar").height() + 47 + 36; // 47 pixel for the free space around the cards, 36px for fixed headers
      $(".main-table-scrollbar").css("max-height", height);
    }
  },
  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    },
    pageSize: function pageSize() {
      this.doPaging();
    },
    pageNumber: function pageNumber() {
      this.doPaging();
    },
    tableFilter: function tableFilter() {
      this.doFiltering();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "AgencyManagementToolbar",
  props: ["tableElementCount", "agencySelected", "refreshEnabled"],
  data: function data() {
    return {
      lang: {
        AM1000: "Aktualisieren",
        AM1001: "Suche ...",
        AM1002: "Neue Agentur",
        AM1003: "Bearbeiten",
        AM1004: "Elemente pro Seite",
        AM1005: "Alle",
        AM1006: "Erste Seite",
        AM1007: "Letzte Seite",
        AM1008: "Löschen",
        AM1009: "Total agencies count"
      },
      searchString: "",
      pageSize: 20,
      currentPage: 1,
      pageNumbers: [],
      showPages: []
    };
  },
  mounted: function mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
  },

  methods: {
    // Emit functions
    emitUserSearch: function emitUserSearch() {
      this.$emit("searchTextChanged", this.searchString);
    },
    emitChangePageNumber: function emitChangePageNumber() {
      this.$emit("pageNumberChanged", this.currentPage);
    },
    emitChangePageSize: function emitChangePageSize() {
      this.$emit("pageSizeChanged", this.pageSize);
    },
    emitEditAgency: function emitEditAgency(addMode) {
      this.$emit("openEditAgency", addMode);
    },
    emitDeleteAgency: function emitDeleteAgency() {
      this.$emit("openDeleteAgency");
    },
    emitTriggerReload: function emitTriggerReload() {
      this.$emit("onTriggerReload");
    },

    // Markup functions
    changePageSize: function changePageSize(pageNumber, pageSize) {
      this.selectPage(pageNumber);
      this.pageSize = pageSize === -1 ? this.tableElementCount : pageSize;
      this.emitChangePageSize();
      this.pageCount();
      this.getPageingObject();
    },
    selectPage: function selectPage(pageNumber) {
      this.currentPage = pageNumber || 1;
      this.emitChangePageNumber();
      this.getPageingObject();
    },
    pageCount: function pageCount() {
      this.pageNumbers = [];
      var pages = this.tableElementCount ? Math.ceil(this.tableElementCount / this.pageSize) : 0;
      for (var i = 1; i <= pages; i++) {
        this.pageNumbers.push(i);
      }
    },
    getPageingObject: function getPageingObject() {
      if (this.currentPage < 4) {
        this.showPages = this.pageNumbers.slice(0, 5);
        return;
      }

      var outOfIndex = this.currentPage + 2 > this.pageNumbers.length;

      var startIndex = outOfIndex ? this.pageNumbers.length - 5 : this.currentPage - 3;

      var endIndex = outOfIndex ? this.pageNumbers.length : this.currentPage + 2;

      this.showPages = this.pageNumbers.slice(startIndex, endIndex);
    }
  },
  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    },
    tableElementCount: function tableElementCount() {
      this.pageCount();
      this.getPageingObject();
    }
  }
});

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import AuthenticationService from "@/services/AuthenticationService";

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AppHeaderAlternative',
  props: {
    title: { type: String, default: 'Dashboard' },
    lang: { type: Object, required: true },
    languageList: { type: Object, required: true }
  },
  data: function data() {
    return {
      searchQuery: '',
      showUserDropdown: false
    };
  },

  methods: {
    navigate: function navigate(route, title) {
      this.$router.push(route);
      this.$emit('set-title', title);
    },
    showNotifications: function showNotifications() {
      // Handle notifications click
    },
    toggleUserMenu: function toggleUserMenu() {
      this.showUserDropdown = !this.showUserDropdown;
    },
    closeUserMenu: function closeUserMenu() {
      this.showUserDropdown = false;
    },
    logout: function logout() {
      // Handle logout logic
      this.showUserDropdown = false;
      // Add your logout logic here
      console.log('Logging out...');
    }
  },
  directives: {
    'click-outside': {
      bind: function bind(el, binding) {
        el.clickOutsideEvent = function (event) {
          if (!(el === event.target || el.contains(event.target))) {
            binding.value();
          }
        };
        document.addEventListener('click', el.clickOutsideEvent);
      },
      unbind: function unbind(el) {
        document.removeEventListener('click', el.clickOutsideEvent);
      }
    }
  },
  computed: {
    localUserProfile: function localUserProfile() {
      return this.globals.currentUserInfo;
    },


    userDisplayName: function userDisplayName() {
      if (!this.localUserProfile) return;

      if (this.localUserProfile && this.localUserProfile.FirstName && this.localUserProfile.LastName) return this.localUserProfile.FirstName + ' ' + this.localUserProfile.LastName;else return this.localUserProfile.LoginName;
    },

    userDisplayType: function userDisplayType() {
      if (!this.localUserProfile) return;

      if (this.localUserProfile.UserType) return this.localUserProfile.UserType === 'M' ? 'Admin' : 'User';
      return 'User';
    },

    userInitials: function userInitials() {
      if (!this.localUserProfile) return;

      if (this.localUserProfile.FirstName && this.localUserProfile.LastName) return this.localUserProfile.FirstName.charAt(0).toUpperCase() + this.localUserProfile.LastName.charAt(0).toUpperCase();else return this.localUserProfile.LoginName.charAt(0).toUpperCase() + this.localUserProfile.LoginName.charAt(1).toUpperCase();
    }

  }
});

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      showGuide: false
    };
  },


  props: {
    lang: { type: Object, required: true }
  },

  methods: {
    navigate: function navigate(route, title) {
      this.$router.push(route);
      this.$emit('set-title', title);
    },
    hasClass: function hasClass(element) {
      return element.classList;
    },
    logout: function logout() {
      // AuthenticationService.logout();
      if (this.isExternalUser) this.$router.push({ name: 'signedout' });
    },
    isActiveRoute: function isActiveRoute(route) {
      return this.$route.path === route || this.$route.path.startsWith(route + '/');
    }
  },

  computed: {
    localUserProfile: function localUserProfile() {
      return this.globals.currentUserInfo;
    },


    userDisplayName: function userDisplayName() {
      return this.localUserProfile.FirstName + ' ' + this.localUserProfile.LastName;
    },

    userInitials: function userInitials() {
      if (this.localUserProfile.FirstName && this.localUserProfile.LastName) return this.localUserProfile.FirstName.charAt(0).toUpperCase() + this.localUserProfile.LastName.charAt(0).toUpperCase();else return '';
    }
  }
});

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "AddChecksFurtherSettingsModal",
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    survey: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      settings: {
        SurveyInstanceSince: "",
        SurveyInstanceUntil: "",
        SurveyInstanceBasePayment: 0,
        SurveyInstancePlusPayment: 0,
        SurveyInstanceSkillLevel: 0,
        SurveyInstanceDescription: "",
        OnlineState: false,
        LocationFree: false,
        ShopperFilter: {}
      },
      fpBegin: null,
      fpEnd: null,
      lang: {
        CFM000: "Offer details",
        CFM001: "Online",
        CFM002: "Location free",
        CFM003: "Begin",
        CFM004: "End",
        CFM005: "Payment",
        CFM006: "Addition",
        CFM007: "Total",
        CFM008: "Edit offer description",
        CFM009: "Reset",
        CFM010: "Close",
        CFM011: "Offer description",
        CFM012: "Shopper Filter",
        CFM013: "Difficulty",
        CFM014: "inherit from survey",
        CFM015: "simple",
        CFM016: "difficult",
        CFM017: "End date before start date",
        CFM018: "Inherit from survey"
      }
    };
  },

  computed: {
    totalPayment: function totalPayment() {
      return this.settings.SurveyInstanceBasePayment + this.settings.SurveyInstancePlusPayment;
    }
  },
  watch: {
    showModal: function showModal(newValue) {
      if (newValue) this.openModal();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#addChecksFurtherSettingsModal").on("hide.bs.modal", function (e) {
      return _this.$emit("closeModal");
    });
    $("#addChecksFurtherSettingsModal").on("hidden.bs.modal", function (e) {
      _this.$emit("modalClosed", _this.settings);
    });

    this.fpBegin = flatpickr("#inputFurtherSettingsStartDate", this.globals.flatpickrDateConfig);
    this.fpEnd = flatpickr("#inputFurtherSettingsEndDate", this.globals.flatpickrDateConfig);
  },
  destroyed: function destroyed() {
    if (this.fpBegin) this.fpBegin.destroy();
    if (this.fpEnd) this.fpEnd.destroy();
  },

  methods: {
    openModal: function openModal() {
      var _this2 = this;

      this.globals.$on("getDataFromHtmlEditorModal", function (data) {
        _this2.settings.SurveyInstanceDescription = data;
      });
      this.globals.$on("getDataFromShopperFilterModal", function (data) {
        _this2.settings.ShopperFilter = data;
      });
      $("#addChecksFurtherSettingsModal").modal("show");
    },
    closeModal: function closeModal() {
      if (this.settings.SurveyInstanceSince && this.settings.SurveyInstanceUntil && this.settings.SurveyInstanceSince > this.settings.SurveyInstanceUntil) {
        this.globals.showErrorSnackbar(this.lang.CFM017);
        return;
      }

      this.globals.$off("getDataFromHtmlEditorModal");
      this.globals.$off("getDataFromShopperFilterModal");
      $("#addChecksFurtherSettingsModal").modal("hide");
    },
    openHtmlEditor: function openHtmlEditor() {
      this.globals.$emit("openHtmlEditorModal");
      this.globals.$emit("sendDataToHtmlEditorModal", {
        title: this.lang.CFM011,
        content: this.settings.SurveyInstanceDescription
      });
    },
    openShopperFilterModal: function openShopperFilterModal() {
      this.globals.$emit("openShopperFilterModal");
      this.globals.$emit("sendDataToShopperFilterModal", this.settings.ShopperFilter);
    },
    clearSettings: function clearSettings() {
      this.fpBegin.clear();
      this.fpEnd.clear();
      this.settings = {
        SurveyInstanceSince: "",
        SurveyInstanceUntil: "",
        SurveyInstanceBasePayment: 0,
        SurveyInstancePlusPayment: 0,
        SurveyInstanceSkillLevel: 0,
        SurveyInstanceDescription: "",
        OnlineState: false,
        LocationFree: false,
        ShopperFilter: {}
      };
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tools_Select2__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Tools_Select2__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "CheckLocalAgencyAssignmentModal",
  components: {
    Select2: __WEBPACK_IMPORTED_MODULE_2__Tools_Select2___default.a
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    selectedChecks: {
      Type: Array,
      default: function _default() {
        return [];
      }
    },
    agencies: {
      Type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      selectedLocalAgency: "",
      lang: {
        CLAA00: "Agency assignment",
        CLAA01: "Local agency",
        CLAA02: "Please choose a local agency...",
        CLAA03: "Close",
        CLAA04: "Save",
        CLAA05: "Agency assignment request failed",
        CLAA06: "Agency assignment updated",
        CLAA07: "Assignment update failed"
      }
    };
  },

  computed: {
    localAgencies: function localAgencies() {
      var _this = this;

      if (!this.globals.currentUserInfo.AgencyGuid || this.agencies.length < 1) return [];
      var lead = this.agencies.find(function (a) {
        return a.AgencyGuid === _this.globals.currentUserInfo.AgencyGuid.toUpperCase();
      });
      return lead && lead.ChildAgencies ? lead.ChildAgencies : [];
    }
  },
  watch: {
    showModal: function showModal(newVal) {
      if (newVal) this.openModal();else this.closeModal();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
    $("#checkLocalAgencyAssignmentModal").on("hide.bs.modal", function (e) {
      _this2.$emit("closeModal");
    });
    $("#checkLocalAgencyAssignmentModal").on("hidden.bs.modal", function (e) {
      _this2.$emit("modalClosed");
    });
  },

  methods: {
    openModal: function openModal() {
      this.getAgencyAssignment();
      $("#checkLocalAgencyAssignmentModal").modal("show");
    },
    closeModal: function closeModal() {
      $("#checkLocalAgencyAssignmentModal").modal("hide");
    },
    getAgencyAssignment: function getAgencyAssignment() {
      var _this3 = this;

      this.selectedLocalAgency = "";
      var sendData = { SurveyInstances: [] };
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.selectedChecks), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var guid = _step.value;

          sendData.SurveyInstances.push({ SurveyInstanceGuid: guid });
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      $.ajax({
        method: "POST",
        url: "api/SurveyInstances/AgencyAssignment/Get",
        data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(sendData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this3.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this3.selectedLocalAgency = "";
          if (data.Properties && data.Properties.AssignedLocalAgencyGuid) _this3.selectedLocalAgency = data.Properties.AssignedLocalAgencyGuid;
        },
        error: function error() {
          console.error("Error on POST in getAgencyAssignment()");
          _this3.globals.showErrorSnackbar(_this3.lang.CLAA05);
        }
      });
    },
    saveAgencyAssignment: function saveAgencyAssignment() {
      var _this4 = this;

      var sendData = {
        Properties: {
          AssignedLocalAgencyGuid: this.selectedLocalAgency
        },
        SurveyInstances: []
      };
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.selectedChecks), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var guid = _step2.value;

          sendData.SurveyInstances.push({ SurveyInstanceGuid: guid });
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      $.ajax({
        method: "PATCH",
        url: "api/SurveyInstances/AgencyAssignment",
        data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(sendData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this4.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this4.$emit("modalDataSaved");
          _this4.globals.showSuccessSnackbar(_this4.lang.CLAA06);
          _this4.closeModal();
        },
        error: function error() {
          console.error("Error on PATCH in saveAgencyAssignment()");
          _this4.globals.showErrorSnackbar(_this4.lang.CLAA07);
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_click_outside__ = __webpack_require__(1550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_click_outside__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CheckManagementEditModal__ = __webpack_require__(1564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CheckManagementEditModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__CheckManagementEditModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CheckManagementAddModal__ = __webpack_require__(1563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CheckManagementAddModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__CheckManagementAddModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CheckManagementFilterModal__ = __webpack_require__(1565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CheckManagementFilterModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__CheckManagementFilterModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Tools_Dialogs_ConfirmationDialog__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Tools_Dialogs_ConfirmationDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__Tools_Dialogs_ConfirmationDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SettlementDownloadModal__ = __webpack_require__(1566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SettlementDownloadModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__SettlementDownloadModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CheckPaymentModal__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CheckPaymentModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__CheckPaymentModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ShopperFilterModal__ = __webpack_require__(1567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ShopperFilterModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__ShopperFilterModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__CheckLocalAgencyAssignmentModal__ = __webpack_require__(1561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__CheckLocalAgencyAssignmentModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__CheckLocalAgencyAssignmentModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Tools_Select2__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__Tools_Select2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_survey_vue__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_survey_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_survey_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_jquery__);







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















/* harmony default export */ __webpack_exports__["default"] = ({
  name: "CheckManagement",
  components: {
    CheckManagementEditModal: __WEBPACK_IMPORTED_MODULE_8__CheckManagementEditModal___default.a,
    CheckManagementAddModal: __WEBPACK_IMPORTED_MODULE_9__CheckManagementAddModal___default.a,
    CheckManagementFilterModal: __WEBPACK_IMPORTED_MODULE_10__CheckManagementFilterModal___default.a,
    ConfirmationDialog: __WEBPACK_IMPORTED_MODULE_11__Tools_Dialogs_ConfirmationDialog___default.a,
    SettlementDownloadModal: __WEBPACK_IMPORTED_MODULE_12__SettlementDownloadModal___default.a,
    CheckPaymentModal: __WEBPACK_IMPORTED_MODULE_13__CheckPaymentModal___default.a,
    ShopperFilterModal: __WEBPACK_IMPORTED_MODULE_14__ShopperFilterModal___default.a,
    CheckLocalAgencyAssignmentModal: __WEBPACK_IMPORTED_MODULE_15__CheckLocalAgencyAssignmentModal___default.a,
    Select2: __WEBPACK_IMPORTED_MODULE_16__Tools_Select2___default.a
  },
  created: function created() {
    var _this = this;

    this.globals.$off("openShopperFilterModal");
    this.globals.$on("openShopperFilterModal", function () {
      _this.showShopperFilterModal = true;
    });
  },
  mounted: function mounted() {
    this.readComponentSettingsFromStore();

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this, this.setElementHeights);
    this.getCheckData();
    this.getDataLists();
    this.getCustomSettingsList();
    $(window).on("resize", this.setElementHeights).resize();

    if (!this.globals.currentUserInfo) this.globals.$once("currentUserInfoReceived", this.setElementHeights);
  },
  destroyed: function destroyed() {
    $(window).off("resize", this.setElementHeights);
    this.writeComponentSettingsToStore();
  },

  methods: {
    setElementHeights: function setElementHeights() {
      this.$nextTick(function () {
        var height = $(window).height();
        height -= $("#checks-top-panel").height() + $("#app-navbar").height() + $(".main-table > thead").height() + 47; // 47 pixel for the free space around the cards
        $(".main-table-scrollbar").css("max-height", height);

        height = $(window).height();
        height -= $(".main-table > thead").height() + 390;
        $("#create-checks-table").css("max-height", height);
        height += 85;
        $("#check-list-table").css("max-height", height);
      });
    },
    readComponentSettingsFromStore: function readComponentSettingsFromStore() {
      var _this2 = this;

      if (!this.$store.getters["userSettings/rememberFilters"]) return;

      this.$filterRestorePending = true;
      var restoreDone = function restoreDone() {
        if (_this2.$refs.clientSelect) _this2.$refs.clientSelect.updateValue();
        if (_this2.$refs.importerSelect) _this2.$refs.importerSelect.updateValue();
        if (_this2.$refs.projectSelect) _this2.$refs.projectSelect.updateValue();

        delete _this2.$filterRestorePending;
        _this2.getCheckData();
      };

      var restoreFilters = function restoreFilters() {
        _this2.$nextTick(function () {
          var storedData = _this2.$store.getters["localFilters/checkManagement"];
          if (storedData) {
            for (var key in storedData) {
              if (key === "selectedClient") _this2.onClientSelection(storedData[key]);else if (_.has(_this2, key)) _this2[key] = _.cloneDeep(storedData[key]);
            }
          }

          if (!_this2.$store.getters["userSettings/syncFilters"]) {
            restoreDone();
            return;
          }
          if (!_this2.feature.isAudiTarget) {
            var storedClient = _this2.$store.getters["sharedFilters/client"];
            _this2.onClientSelection(storedClient.ClientGuid || "");
          } else {
            _this2.onClientSelection();

            var storedImporter = _this2.$store.getters["sharedFilters/importer"];
            _this2.selectedImporter = storedImporter.ImporterGuid || "";
          }

          var storedProject = _this2.$store.getters["sharedFilters/project"];
          _this2.selectedProject = storedProject.ProjectGuid || "";

          restoreDone();
        });
      };

      var eventsToWaitFor = ["ClientListReceived", "ProjectListReceived", "StatusListReceived"];
      if (this.feature.isAudiTarget) eventsToWaitFor.push("ImporterListReceived");
      this.globals.doAfterEvents(eventsToWaitFor, restoreFilters, this);
    },
    writeComponentSettingsToStore: function writeComponentSettingsToStore() {
      var _this3 = this;

      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      this.$store.commit("localFilters/checkManagement", {
        selectedClient: this.selectedClient,
        selectedImporter: this.selectedImporter,
        selectedProject: this.selectedProject,
        selectedCheckType: this.selectedCheckType,
        selectedOnlineState: this.selectedOnlineState,
        filterStrings: this.filterStrings,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        pageSize: this.pageSize
      });

      if (!this.$store.getters["userSettings/syncFilters"]) return;
      if (!this.feature.isAudiTarget || !this.feature.isEnabled("audi_importers")) {
        if (this.selectedClient) {
          var client = _.find(this.dataLists.clientList, function (c) {
            return c.ClientGuid === _this3.selectedClient;
          });
          if (client) this.$store.commit("sharedFilters/client", client);
        } else {
          var storedClient = this.$store.getters["sharedFilters/client"];
          if (storedClient.ClientGuid) this.$store.commit("sharedFilters/client");
        }
      } else {
        if (this.selectedImporter) {
          var importer = _.find(this.dataLists.importerList, function (i) {
            return i.ImporterGuid === _this3.selectedImporter;
          });
          if (importer) this.$store.commit("sharedFilters/importer", importer);
        } else {
          var storedImporter = this.$store.getters["sharedFilters/importer"];
          if (storedImporter.ImporterGuid) this.$store.commit("sharedFilters/importer");
        }
      }

      if (this.selectedProject) {
        var project = _.find(this.dataLists.projectsOfClient, function (p) {
          return p.ProjectGuid === _this3.selectedProject;
        });
        if (project) this.$store.commit("sharedFilters/project", project);
      } else {
        var storedProject = this.$store.getters["sharedFilters/project"];
        if (storedProject.ProjectGuid) this.$store.commit("sharedFilters/project");
      }
    },
    getCustomSettingsList: function getCustomSettingsList() {
      var _this4 = this;

      $.ajax({
        method: "GET",
        url: "api/Data/CustomSettings",
        success: function success(data) {
          _this4.CheckManagementFilter = data;
          _this4.getCountOfCheckManagementFilter();
        },
        error: function error() {
          console.error("Custom settings data access failed in getCustomSettingsList()");
          _this4.globals.showErrorSnackbar("Custom settings data access failed");
        }
      });
    },
    getCountOfCheckManagementFilter: function getCountOfCheckManagementFilter() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries___default()(this.CheckManagementFilter)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _step$value = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_step.value, 2),
              key = _step$value[0],
              value = _step$value[1];

          if (value == true) this.CheckManagementFilterCounter++;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    getNameOfSelectedClient: function getNameOfSelectedClient() {
      var _this5 = this;

      if (this.dataLists.clientList.length < 1) return "";
      var currentClient = this.dataLists.clientList.filter(function (c) {
        return c.ClientGuid == _this5.selectedClient;
      });
      if (currentClient.length < 1) return "";
      return currentClient[0].ClientName;
    },
    downloadCheckData: function downloadCheckData() {
      var _this6 = this;

      var param = this.selectedClient + "?file_type=" + this.checkExportFileType;

      $.ajax({
        method: "POST",
        url: "api/SurveyInstances/Export/" + param,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.length > 0 && data[0].DownloadId) _this6.globals.downloadFile(data[0].DownloadId);

          _this6.showExportModal = false;
        },
        error: function error(_error) {
          console.error("Error on POST in downloadCheckData()");
          _this6.globals.showErrorSnackbar("Check export failed");
        }
      });
    },
    onAddChecksDialogDataSaved: function onAddChecksDialogDataSaved() {
      // this.getCheckData(); // Refresh datatable
    },
    onAddChecksDialogClosed: function onAddChecksDialogClosed() {
      this.showAddChecksDialog = false;
      this.getCheckData();
    },
    onEditChecksDialogClosed: function onEditChecksDialogClosed() {
      var _this7 = this;

      this.showEditChecksDialog = false;
      this.$nextTick(function () {
        _this7.getCheckData();
      });
    },
    onFilterChecksDialogClosed: function onFilterChecksDialogClosed() {
      this.showCheckManagementFilterModal = false;
    },
    onClientSelection: function onClientSelection(client) {
      var _this8 = this;

      if (client) this.selectedClient = client;
      this.selectedChecks = [];
      this.selectedCheckIds = [];
      this.selectedPage = 1;
      this.getProjectsOfSelectedClient();
      if (_.findIndex(this.dataLists.projectsOfClient, function (p) {
        return p.ProjectGuid === _this8.selectedProject;
      }) < 0) this.selectedProject = "";
    },
    onProjectSelection: function onProjectSelection(project) {
      if (project) this.selectedProject = project;
      this.selectedChecks = [];
      this.selectedCheckIds = [];
      this.selectedPage = 1;
      this.getCheckData();
    },
    toggleOnlineStateFilter: function toggleOnlineStateFilter() {
      if (typeof this.selectedOnlineState !== "boolean") this.selectedOnlineState = true;else if (this.selectedOnlineState) this.selectedOnlineState = false;else this.selectedOnlineState = null;

      this.getCheckData();
    },
    getProjectsOfSelectedClient: function getProjectsOfSelectedClient() {
      var _this9 = this;

      this.dataLists.projectsOfClient = [];
      if (!this.selectedClient) return;

      var pl = this.dataLists.projectList.find(function (p) {
        return p.ClientGuid === _this9.selectedClient;
      });
      if (pl && pl.Projects) this.dataLists.projectsOfClient = pl.Projects;
    },
    cloneSelectedChecks: function cloneSelectedChecks() {
      var _this10 = this;

      if (this.selectedChecks.length < 1) return;
      var sendData = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(this.selectedChecks), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var guid = _step2.value;

          sendData.push({ SurveyInstanceGuid: guid });
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      $.ajax({
        method: "POST",
        url: "/api/SurveyInstances/AgencyClone",
        data: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(sendData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this10.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this10.selectedChecks = [];
          _this10.selectedCheckIds = [];
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(data), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var check = _step3.value;

              _this10.selectedChecks.push(check.SurveyInstanceGuid);
              _this10.selectedCheckIds.push(check.SurveyInstanceId);
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }

          _this10.getCheckData();
          _this10.globals.showSuccessSnackbar(_this10.lang.CM0077);
        },
        error: function error(_error2) {
          console.error("Error on POST in cloneSelectedChecks()");
          _this10.globals.showErrorSnackbar(_this10.lang.CM0078);
        }
      });
    },
    showCheckHistory: function showCheckHistory() {
      if (!this.selectedChecks[0] || !this.selectedCheckIds[0]) return;
      var config = {
        type: "SurveyInstance",
        guid: this.selectedChecks[0],
        id: this.selectedCheckIds[0]
      };
      this.globals.$emit("showElementHistory", config);
    },
    openCheck: function openCheck(id) {
      var _this11 = this;

      var newWindow = window.open("/#/surveyview/" + id);
      newWindow.onbeforeunload = function () {
        _this11.getCheckData();
      };
      newWindow.openerVueInstance = this;
    },
    openChecks: function openChecks(force) {
      var _this12 = this;

      if (!force && this.selectedChecks.length > 3) {
        this.globals.$off("OpenMultipleChecksModalYesConfirmation");
        this.globals.$on("OpenMultipleChecksModalYesConfirmation", function () {
          _this12.openChecks(true);
        });

        this.globals.$emit("openGlobalConfirmationDialog", {
          initiator: "OpenMultipleChecksModal",
          confirmationTitle: this.lang.CM0053,
          colorRed: true,
          yesButtonText: this.lang.CM0054,
          noButtonText: this.lang.CM0055,
          htmlText: "<p><b>" + this.lang.CM0056 + ":\n            " + this.selectedChecks.length + "<br>\n            <br>" + this.lang.CM0057 + "<br>\n            <br>" + this.lang.CM0058 + "</b></p>"
        });
        return;
      }

      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(this.selectedCheckIds), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var id = _step4.value;

          this.openCheck(id);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }
    },
    calcAllowedStatusCodes: function calcAllowedStatusCodes() {
      var _this13 = this;

      if (this.filterStrings.SurveyInstanceStatusId.toString().length < 2) this.allowedStatusCodes = [];else {
        this.allowedStatusCodes = _.find(this.dataLists.statusCodes, function (s) {
          return s.SurveyInstanceStatusId == _this13.filterStrings.SurveyInstanceStatusId;
        }).SurveyInstanceFollowUpStatusses;
        if (!this.allowedStatusCodes) this.allowedStatusCodes = [];
      }

      this.selectedStatusCode = null;
    },
    getStatusCodeDescription: function getStatusCodeDescription(code) {
      var statusCodeObject = _.find(this.dataLists.statusCodes, function (c) {
        return c.SurveyInstanceStatusId === code;
      });
      if (statusCodeObject) return statusCodeObject.SurveyInstanceStatusDescription;else return code.toString();
    },
    getSurveyList: function getSurveyList() {
      var _this14 = this;

      $.ajax({
        method: "GET",
        url: "api/Data/projectssurveys",
        success: function success(data) {
          _this14.dataLists.surveyList = data;
        },
        error: function error() {
          console.error("Survey data access failed in getSurveyList()");
          _this14.globals.showErrorSnackbar("Survey data access failed");
        }
      });
    },
    getDataLists: function getDataLists() {
      var _this15 = this;

      this.globals.getProjectList(function (data) {
        _this15.dataLists.projectList = data;
        _this15.$emit("ProjectListReceived");
        _this15.getProjectsOfSelectedClient();
      });
      this.globals.getWaveList(function (data) {
        _this15.dataLists.waveList = data;
      });
      this.globals.getScenarioList(function (data) {
        _this15.dataLists.scenarioList = data;
      });
      this.getSurveyList();
      this.globals.getAgencyList(function (data) {
        _this15.dataLists.agencyList = [];
        if (data && data[0]) _this15.dataLists.agencyList = data;
      });
      this.globals.getShopperList(function (data) {
        _this15.dataLists.shopperList = data;
      });
      this.globals.getSurveyInstancesStatusList(function (callbackData) {
        _this15.dataLists.statusCodes = callbackData;
        _this15.$emit("StatusListReceived");
      });
      this.globals.getClientList(function (data) {
        _this15.dataLists.clientList = data;
        if (_this15.feature.isAudiTarget && _this15.feature.isEnabled("audi_importers") && data && data[0]) _this15.onClientSelection(data[0].ClientGuid);
        _this15.$emit("ClientListReceived");
      });

      if (this.feature.isAudiTarget && this.feature.isEnabled("audi_importers")) {
        this.globals.getImporterList(function (data) {
          _this15.dataLists.importerList = data;
          _this15.$emit("ImporterListReceived");
        });
      }
    },

    // Calculates the sort order for the given column and refreshes the displayed data
    sortCheckData: function sortCheckData(field) {
      if (field == this.sortField) {
        this.sortOrder == "asc" ? this.sortOrder = "desc" : this.sortOrder = "asc";
      } else {
        this.sortField = field;
        this.sortOrder = "asc";
      }
      this.selectedChecks = [];
      this.selectedCheckIds = [];
      this.selectedPage = 1;
      this.getCheckData();
    },

    // Catches check data for the table from the server, including current filter, pagination and sort settings
    getCheckData: function getCheckData() {
      var _this16 = this;

      if (this.$filterRestorePending) return;
      this.refreshEnabled = false;

      var query = "api/SurveyInstances/Get?page_size=" + this.pageSize + "&page=" + this.selectedPage + "&sort_column=" + this.sortField + "&sort_order=" + this.sortOrder;

      var body = { Filter: {} };
      for (var key in this.filterStrings) {
        if (this.filterStrings[key].length > 0) body.Filter[key] = this.filterStrings[key];
      }
      if (this.selectedClient) body.Filter.ClientGuid = this.selectedClient;
      if (this.selectedProject) body.Filter.ProjectGuid = this.selectedProject;
      if (this.selectedImporter) body.Filter.ImporterGuid = this.selectedImporter;
      if (this.selectedCheckType) body.Filter.SurveyInstanceType = this.selectedCheckType;
      if (this.selectedCheckType === "FO" && typeof this.selectedOnlineState === "boolean") body.Filter.OnlineState = this.selectedOnlineState;

      $.ajax({
        method: "POST",
        url: query,
        data: _.isEmpty(body.Filter) ? "" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(body),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data[0]) {
            if (data[0].SurveyInstances) _this16.checkData = data[0].SurveyInstances;else _this16.checkData = [];
            _this16.pageCount = data[0].Page_Count;
            _this16.checkCount = data[0].Count;
          }
        },
        error: function error(_error3) {
          console.error("Error on POST in getCheckData()");
          _this16.globals.showErrorSnackbar(_this16.lang.CM0062);
        },
        complete: function complete() {
          _this16.refreshEnabled = true;
        }
      });
    },

    // Toggles the selected-state of a given check.
    // If the check is not yet selected, it will be added to the array of selected checks.
    // If the check is already selected, it will be removed from that array.
    selectCheck: function selectCheck(checkGuid, checkId, e) {
      var _this17 = this;

      if (!e) return;

      if (e.ctrlKey && !e.shiftKey) {
        var idx = _.indexOf(this.selectedChecks, checkGuid);
        if (idx > -1) {
          _.pullAt(this.selectedChecks, idx);
          _.remove(this.selectedCheckIds, function (id) {
            return id === checkId;
          });
          this.lastSelectedCheck = "";
        } else {
          this.selectedChecks.push(checkGuid);
          this.selectedCheckIds.push(checkId);
          this.lastSelectedCheck = checkGuid;
        }
      } else if (!e.ctrlKey && e.shiftKey) {
        document.getSelection().removeAllRanges();
        if (!this.lastSelectedCheck) return;

        var idx1 = _.findIndex(this.checkData, function (c) {
          return c.SurveyInstanceGuid === _this17.lastSelectedCheck;
        });
        var idx2 = _.findIndex(this.checkData, function (c) {
          return c.SurveyInstanceGuid === checkGuid;
        });

        if (idx1 > idx2) {
          var tmp = idx1;
          idx1 = idx2;
          idx2 = tmp;
        }

        for (var i = idx1; i <= idx2; i++) {
          if (!this.isCheckSelected(this.checkData[i].SurveyInstanceGuid)) {
            this.selectedChecks.push(this.checkData[i].SurveyInstanceGuid);
            this.selectedCheckIds.push(this.checkData[i].SurveyInstanceId);
          }
        }
      } else {
        this.selectedChecks = [checkGuid];
        this.selectedCheckIds = [checkId];
        this.lastSelectedCheck = checkGuid;
      }
      this.selectedStatusCode = null;
      this.$forceUpdate();
    },
    clearLastSelection: function clearLastSelection() {
      this.lastSelectedCheck = "";
    },

    // Returns true if the given check is selected, otherwise false is returned.
    isCheckSelected: function isCheckSelected(checkGuid) {
      return _.indexOf(this.selectedChecks, checkGuid) > -1;
    },
    isPageSelected: function isPageSelected() {
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(this.checkData), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var check = _step5.value;

          if (!this.isCheckSelected(check.SurveyInstanceGuid)) return false;
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      return true;
    },
    togglePageSelected: function togglePageSelected() {
      var _this18 = this;

      if (this.checkData.length < 1) return;
      var selState = this.isPageSelected();
      if (!selState) {
        var _iteratorNormalCompletion6 = true;
        var _didIteratorError6 = false;
        var _iteratorError6 = undefined;

        try {
          for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(this.checkData), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
            var check = _step6.value;

            if (!this.isCheckSelected(check.SurveyInstanceGuid)) {
              this.selectedChecks.push(check.SurveyInstanceGuid);
              this.selectedCheckIds.push(check.SurveyInstanceId);
            }
          }
        } catch (err) {
          _didIteratorError6 = true;
          _iteratorError6 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion6 && _iterator6.return) {
              _iterator6.return();
            }
          } finally {
            if (_didIteratorError6) {
              throw _iteratorError6;
            }
          }
        }
      } else {
        var _iteratorNormalCompletion7 = true;
        var _didIteratorError7 = false;
        var _iteratorError7 = undefined;

        try {
          var _loop = function _loop() {
            var check = _step7.value;

            _.remove(_this18.selectedChecks, function (guid) {
              return guid === check.SurveyInstanceGuid;
            });
            _.remove(_this18.selectedCheckIds, function (id) {
              return id === check.SurveyInstanceId;
            });
          };

          for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(this.checkData), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
            _loop();
          }
        } catch (err) {
          _didIteratorError7 = true;
          _iteratorError7 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion7 && _iterator7.return) {
              _iterator7.return();
            }
          } finally {
            if (_didIteratorError7) {
              throw _iteratorError7;
            }
          }
        }

        this.$forceUpdate();
      }
    },
    changeSelectedChecksStatus: function changeSelectedChecksStatus() {
      var _this19 = this;

      if (!this.selectedStatusCode || this.selectedCheckIds.length === 0) return;

      var sendData = {};
      sendData.SurveyInstanceIds = this.selectedCheckIds;
      sendData.SurveyInstanceStatusId = this.selectedStatusCode;

      $.ajax({
        method: "PUT",
        url: "api/SurveyInstances",
        data: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(sendData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) _this19.globals.showErrorSnackbar(data.Error);else {
            _this19.globals.showSuccessSnackbar("Status update successful");
            _this19.getCheckData();
            _this19.selectedStatusCode = null;
          }
        },
        error: function error() {
          console.error("Error on PUT in changeSelectedChecksStatus()");
          _this19.globals.showErrorSnackbar("Status update failed");
        }
      });
    },

    // Updates the current pagesize and the selected pagenumber and triggers the refresh of the table
    updatePaging: function updatePaging(pageNumber, pageSize) {
      this.selectedPage = pageNumber || 1;
      if (pageSize != 0) this.pageSize = pageSize;
      this.getCheckData();
    },

    // Returns a range of numbers with min-value, max-value and stepsize
    getRange: function getRange(min, max, step) {
      var range = [],
          j = 0;
      for (var i = min; i <= max; i += step) {
        range[j++] = i;
      }
      return range;
    },

    // Returns a list of all pagenumbers that should be visible depending on the current page and the count of pages
    getVisiblePages: function getVisiblePages() {
      if (this.pageCount <= 7) {
        return this.getRange(1, this.pageCount, 1);
      } else if (this.pageCount > 7 && this.selectedPage <= 4) {
        return this.getRange(1, 6, 1);
      } else if (this.pageCount > 7 && this.selectedPage >= this.pageCount - 3) {
        return this.getRange(this.pageCount - 5, this.pageCount, 1);
      } else {
        return this.getRange(this.selectedPage - 2, this.selectedPage + 2, 1);
      }
    },
    showAutovalidationDialog: function showAutovalidationDialog() {
      var _this20 = this;

      $("#autovalidationDialog").modal("show");

      $("#autovalidationDialog").on("hidden.bs.modal", function (e) {
        _this20.autovalidation.invalidChecks = [];
        _this20.autovalidation.validatedChecks = [];
      });
    },
    startAutovalidation: function startAutovalidation() {
      var _this21 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var checksToValidate, res, _key, r, key;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:

                _this21.configureSurveyJs();

                _this21.autovalidation.invalidChecks = [];
                _this21.autovalidation.validatedChecks = [];

                checksToValidate = [];

                if (!(_this21.selectedChecks.length > 0)) {
                  _context.next = 42;
                  break;
                }

                _context.prev = 5;
                res = [];
                _context.t0 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.keys(_this21.selectedChecks);

              case 8:
                if ((_context.t1 = _context.t0()).done) {
                  _context.next = 23;
                  break;
                }

                _key = _context.t1.value;
                _context.prev = 10;
                _context.next = 13;
                return _this21.getOneSurveyAndSurveyInstanceJson(_this21.selectedChecks[_key]);

              case 13:
                r = _context.sent;

                res = res.concat(r);
                _context.next = 21;
                break;

              case 17:
                _context.prev = 17;
                _context.t2 = _context["catch"](10);

                console.error("Check data access failed in getSurveyAndSurveyInstanceJson()", _context.t2);
                _this21.globals.showErrorSnackbar("Check data access failed");

              case 21:
                _context.next = 8;
                break;

              case 23:

                res.forEach(function (e) {
                  if (e.SurveyInstanceStatusId <= 200 && e.SurveyInstanceStatusId > 100) {
                    e.Survey = JSON.parse(e.Survey);
                    e.SurveyInstanceAnswer = JSON.parse(e.SurveyInstanceAnswer);
                    e.SurveyInstanceAnswerPosition = JSON.parse(e.SurveyInstanceAnswerPosition);
                    checksToValidate.push(e);
                  } else {
                    _this21.autovalidation.invalidChecks.push({
                      SID: e.SurveyId,
                      CheckID: e.SurveyInstanceId,
                      Status: e.SurveyInstanceStatusId
                    });
                  }
                });
                _context.t3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.keys(checksToValidate);

              case 25:
                if ((_context.t4 = _context.t3()).done) {
                  _context.next = 32;
                  break;
                }

                key = _context.t4.value;
                _context.next = 29;
                return _this21.validateCheck(checksToValidate[key]);

              case 29:
                _this21.globals.showSuccessSnackbar(parseInt(key) + 1 + "/" + _this21.selectedChecks.length + " checks finished!");
                _context.next = 25;
                break;

              case 32:
                _context.next = 38;
                break;

              case 34:
                _context.prev = 34;
                _context.t5 = _context["catch"](5);

                console.error("Error in autovalidation");
                console.error(_context.t5);

              case 38:
                _this21.getCheckData();
                $("#autovalidationDialog").modal("show");
                _context.next = 43;
                break;

              case 42:
                _this21.globals.showErrorSnackbar("No checks selected");

              case 43:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this21, [[5, 34], [10, 17]]);
      }))();
    },
    getOneSurveyAndSurveyInstanceJson: function getOneSurveyAndSurveyInstanceJson(id) {
      var _this22 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", $.ajax({
                  method: "POST",
                  url: "api/SurveyInstances/SurveyAndSurveyInstanceJsons/",
                  dataType: "json",
                  data: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()([id]),
                  contentType: "application/json; charset=utf-8",
                  success: function success(data) {
                    return data;
                  },
                  error: function error(_error4) {
                    console.error("Error on POST in getOneSurveyAndSurveyInstanceJson()", _error4);
                    _this22.globals.showErrorSnackbar("Check validation failed");
                  }
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this22);
      }))();
    },
    getSurveyAndSurveyInstanceJson: function getSurveyAndSurveyInstanceJson() {
      var _this23 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var query = "api/SurveyInstances/SurveyAndSurveyInstanceJsons/";
        $.ajax({
          method: "POST",
          url: query,
          data: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(_this23.selectedChecks),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            resolve(data);
          },
          error: function error() {
            console.error("Check data access failed in getSurveyAndSurveyInstanceJson()");
            _this23.globals.showErrorSnackbar("Check data access failed");
            reject();
          }
        });
      });
    },
    validateCheck: function validateCheck(check) {
      var _this24 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var pageIndex, hasErrors, newStatus;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this24.autovalidation.survey = new __WEBPACK_IMPORTED_MODULE_17_survey_vue__["Model"](check.Survey);

                _this24.autovalidation.survey.data = check.SurveyInstanceAnswer;
                // this.autovalidation.survey.runTriggers(); // does not exist in currently used old version of survey.js

                pageIndex = 0; // Start from the first page

                _this24.autovalidation.survey.currentPageNo = pageIndex; // Set the current page to the first page

                // Iterate through all pages
                while (pageIndex < _this24.autovalidation.survey.pages.length - 1) {
                  _this24.autovalidation.survey.nextPage();
                  pageIndex++;
                }

                // After reaching the last page, you can optionally call completeLastPage if needed
                hasErrors = !_this24.autovalidation.survey.completeLastPage();

                if (!(
                // this.autovalidation.survey.hasErrors() ||
                hasErrors || check.SurveyInstanceAnswerDateOfVisit == null || check.SurveyInstanceAnswerTimeIn == null || check.SurveyInstanceAnswerTimeOut == null)) {
                  _context3.next = 10;
                  break;
                }

                _this24.autovalidation.invalidChecks.push({
                  SID: check.SurveyId,
                  CheckID: check.SurveyInstanceId,
                  Status: check.SurveyInstanceStatusId
                });
                _context3.next = 44;
                break;

              case 10:
                // clean surveyanswers
                _this24.cleanupSurveyAnswer();
                // calc new progress
                check.SurveyInstanceProgress = _this24.calcSurveyProgress(_this24.autovalidation.survey, check);
                // calc Points
                _this24.calcPointsOfContainer(_this24.autovalidation.survey);

                _context3.t0 = true;
                _context3.next = _context3.t0 === (check.SurveyInstanceStatusId === 110) ? 16 : _context3.t0 === (check.SurveyInstanceStatusId === 130) ? 18 : _context3.t0 === ((check.SurveyInstanceStatusId === 120 || check.SurveyInstanceStatusId === 140) && _this24.globals.currentUserRole > 1) ? 20 : _context3.t0 === (check.SurveyInstanceStatusId === 150) ? 22 : _context3.t0 === _.includes([120, 140, 160, 165, 170, 190], check.SurveyInstanceStatusId) ? 24 : _context3.t0 === (check.SurveyInstanceStatusId === 200) ? 26 : 28;
                break;

              case 16:
                newStatus = 120;
                return _context3.abrupt("break", 29);

              case 18:
                newStatus = 140;
                return _context3.abrupt("break", 29);

              case 20:
                newStatus = 160;
                return _context3.abrupt("break", 29);

              case 22:
                newStatus = 165;
                return _context3.abrupt("break", 29);

              case 24:
                newStatus = 200;
                return _context3.abrupt("break", 29);

              case 26:
                newStatus = 200;
                return _context3.abrupt("break", 29);

              case 28:
                return _context3.abrupt("break", 29);

              case 29:
                if (!newStatus) {
                  _context3.next = 44;
                  break;
                }

                _context3.prev = 30;
                _context3.next = 33;
                return _this24.saveSurveyInstanceAnswers(check);

              case 33:
                if (newStatus === 200 && check.SurveyInstanceStatusId === 200) {
                  _context3.next = 36;
                  break;
                }

                _context3.next = 36;
                return _this24.updateCheckStatus(newStatus, check.SurveyInstanceId);

              case 36:
                _this24.autovalidation.validatedChecks.push({
                  SID: check.SurveyId,
                  CheckID: check.SurveyInstanceId,
                  "Status old": check.SurveyInstanceStatusId,
                  "Status New": newStatus
                });
                _context3.next = 44;
                break;

              case 39:
                _context3.prev = 39;
                _context3.t1 = _context3["catch"](30);

                console.error("Error in saveSurveys");
                console.error(_context3.t1);
                _this24.globals.showErrorSnackbar("saving survey instance " + check.SurveyInstanceId + " failed");

              case 44:
                _this24.autovalidation.survey = null;
                return _context3.abrupt("return");

              case 46:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this24, [[30, 39]]);
      }))();
    },
    saveSurveyInstanceAnswers: function saveSurveyInstanceAnswers(check) {
      var queryString = "api/SurveyInstancesAnswers/ViaAutovalidation/" + check.SurveyInstanceId;

      var surveyObject = _.clone(check);
      delete surveyObject.Survey;
      delete surveyObject.SurveyId;
      delete surveyObject.SurveyInstanceGuid;
      delete surveyObject.SurveyInstanceId;
      delete surveyObject.SurveyInstanceStatusId;
      surveyObject.SurveyInstanceAnswer = _.cloneDeep(this.autovalidation.survey.data);
      surveyObject.SurveyInstanceAnswerMaxPoints = this.autovalidation.survey.pointsMax;
      surveyObject.SurveyInstanceAnswerPoints = this.autovalidation.survey.pointsReached;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        $.ajax({
          method: "PUT",
          url: queryString,
          data: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(surveyObject),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            if (data.Error) {
              reject("Server Error:" + data.Error);
            }
            resolve(data);
          },
          error: function error(_error5) {
            reject(_error5);
          }
        });
      });
    },
    updateCheckStatus: function updateCheckStatus(status, id) {
      if (!status) return;
      var sendData = {};
      sendData.SurveyInstanceIds = [id];
      sendData.SurveyInstanceStatusId = status;
      var queryString = "api/SurveyInstances";

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        $.ajax({
          url: queryString,
          type: "PUT",
          data: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(sendData),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            if (data.Error) {
              reject("Server Error:" + data.Error);
            }
            resolve(data);
          },
          error: function error(_error6) {
            reject(_error6);
          }
        });
      });
    },
    calcSurveyProgress: function calcSurveyProgress(survey, check) {
      var requiredFields = ["SurveyInstanceAnswerDateOfVisit", "SurveyInstanceAnswerTimeIn", "SurveyInstanceAnswerTimeOut"];
      var visibleQuestions = survey.getAllQuestions(true);
      var requiredCount = 0;
      var answeredCount = 0;
      for (var i = 0; i < visibleQuestions.length; i++) {
        if (visibleQuestions[i].isRequired) {
          requiredCount++;
          if (!visibleQuestions[i].isEmpty()) answeredCount++;
        }
      }
      requiredCount += requiredFields.length;
      requiredFields.forEach(function (field) {
        if (check[field] !== "") {
          answeredCount++;
        }
      });
      var result = Math.round(answeredCount / requiredCount * 100);
      return result;
    },
    configureSurveyJs: function configureSurveyJs() {
      var _this25 = this;

      // Register functions for expression trigger and add maxPointsReached for selectbase questions
      __WEBPACK_IMPORTED_MODULE_17_survey_vue__["FunctionFactory"].Instance.register("setMaxPoints", function (params) {
        if (params.length < 1 || !_this25.autovalidation.survey) return;
        for (var i = 0; i < params.length; i++) {
          var q = _this25.autovalidation.survey.getQuestionByName(params[i]);
          if (q) q.maxPointsReached = true;
        }
      });
      __WEBPACK_IMPORTED_MODULE_17_survey_vue__["FunctionFactory"].Instance.register("unsetMaxPoints", function (params) {
        if (params.length < 1 || !_this25.autovalidation.survey) return;
        for (var i = 0; i < params.length; i++) {
          var q = _this25.autovalidation.survey.getQuestionByName(params[i]);
          if (q && q.maxPointsReached) q.maxPointsReached = false;
        }
      });
      __WEBPACK_IMPORTED_MODULE_17_survey_vue__["JsonObject"].metaData.addProperty("selectbase", {
        name: "maxPointsReached:boolean"
      });
      __WEBPACK_IMPORTED_MODULE_17_survey_vue__["JsonObject"].metaData.addProperty("panel", {
        name: "isCluster:boolean"
      });
      __WEBPACK_IMPORTED_MODULE_17_survey_vue__["JsonObject"].metaData.addProperty("panel", {
        name: "backgroundColor:text"
      });
      __WEBPACK_IMPORTED_MODULE_17_survey_vue__["JsonObject"].metaData.addProperty("question", "commentForShopper:text");

      __WEBPACK_IMPORTED_MODULE_17_survey_vue__["JsonObject"].metaData.addProperty("checkbox", "exclusiveValue:checkboxValue");

      // Add points to answers
      __WEBPACK_IMPORTED_MODULE_17_survey_vue__["JsonObject"].metaData.addClass("itemvaluesWithPoints", ["points:number"], null, "itemvalue");
      __WEBPACK_IMPORTED_MODULE_17_survey_vue__["JsonObject"].metaData.addProperty("selectbase", "choices:itemvalues");
      var property1 = __WEBPACK_IMPORTED_MODULE_17_survey_vue__["JsonObject"].metaData.findProperty("selectbase", "choices");
      property1.typeValue = "itemvaluesWithPoints";
      property1.className = "itemvaluesWithPoints";

      __WEBPACK_IMPORTED_MODULE_17_survey_vue__["JsonObject"].metaData.addProperty("rating", "rateValues:itemvalues");
      property1 = __WEBPACK_IMPORTED_MODULE_17_survey_vue__["JsonObject"].metaData.findProperty("rating", "rateValues");
      property1.typeValue = "itemvaluesWithPoints";
      property1.className = "itemvaluesWithPoints";

      // Add maxPoints to answers of radiogroups
      __WEBPACK_IMPORTED_MODULE_17_survey_vue__["JsonObject"].metaData.addClass("itemvaluesWithPointsAndMaxPoints", ["points:number", "maxPoints:number"], null, "itemvalue");
      __WEBPACK_IMPORTED_MODULE_17_survey_vue__["JsonObject"].metaData.addProperty("radiogroup", "choices:itemvalues");
      var property2 = __WEBPACK_IMPORTED_MODULE_17_survey_vue__["JsonObject"].metaData.findProperty("radiogroup", "choices");
      property2.typeValue = "itemvaluesWithPointsAndMaxPoints";
      property2.className = "itemvaluesWithPointsAndMaxPoints";

      __WEBPACK_IMPORTED_MODULE_17_survey_vue__["JsonObject"].metaData.addProperty("question", {
        name: "pointsMax:number"
      });

      __WEBPACK_IMPORTED_MODULE_17_survey_vue__["JsonObject"].metaData.addProperty("question", "guid");
      __WEBPACK_IMPORTED_MODULE_17_survey_vue__["JsonObject"].metaData.addProperty("panelbase", "guid");
      __WEBPACK_IMPORTED_MODULE_17_survey_vue__["JsonObject"].metaData.addProperty("itemvalue", "guid");

      // Add custom question numbers
      __WEBPACK_IMPORTED_MODULE_17_survey_vue__["JsonObject"].metaData.addProperty("question", {
        name: "customQuestionNumber",
        default: 0
      });

      // Add properties for currency inputs
      __WEBPACK_IMPORTED_MODULE_17_survey_vue__["JsonObject"].metaData.addProperty("survey", {
        name: "currencySymbol",
        default: "€"
      });
      __WEBPACK_IMPORTED_MODULE_17_survey_vue__["JsonObject"].metaData.addProperty("survey", {
        name: "currencyDecimalPoint",
        default: "comma"
      });
    },
    calcPointsOfContainer: function calcPointsOfContainer(container) {
      var type = container.getType();
      var containerTypes = ["panel", "page", "survey"];

      if (_.indexOf(containerTypes, type) < 0) return; // No container type
      container.pointsMax = 0;
      container.pointsReached = 0;
      var elements = type === "survey" ? container.pages : container.elements;

      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(elements), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var el = _step8.value;

          if (_.indexOf(containerTypes, el.getType()) > -1) {
            this.calcPointsOfContainer(el);
            container.pointsMax += el.pointsMax || 0;
            container.pointsReached += el.pointsReached || 0;
          } else {
            var qpoints = this.getPointsOfQuestion(el);
            container.pointsMax += qpoints.pointsMax;
            container.pointsReached += qpoints.pointsReached;
          }
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }
    },

    // Returns the points of a given question
    getPointsOfQuestion: function getPointsOfQuestion(question) {
      var points = { pointsMax: 0, pointsReached: 0 };
      var qtype = question.getType();
      if (!qtype || typeof question.value === "undefined") return points;

      if (_.indexOf(["text", "comment", "file"], qtype) > -1) {
        if (question.pointsMax) {
          points.pointsMax = question.pointsMax;
          points.pointsReached = question.pointsMax;
        }
      } else if (qtype === "checkbox") {
        if (question.value.length > 0) {
          if (question.pointsMax) points.pointsMax = question.pointsMax;
          var _iteratorNormalCompletion9 = true;
          var _didIteratorError9 = false;
          var _iteratorError9 = undefined;

          try {
            for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(question.value), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
              var item = _step9.value;

              var answer = _.find(question.choices, {
                value: item
              });
              if (answer && answer.points) points.pointsReached += answer.points;
            }
          } catch (err) {
            _didIteratorError9 = true;
            _iteratorError9 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion9 && _iterator9.return) {
                _iterator9.return();
              }
            } finally {
              if (_didIteratorError9) {
                throw _iteratorError9;
              }
            }
          }
        }
      } else if (qtype === "radiogroup") {
        var _answer = _.find(question.choices, { value: question.value });
        if (_answer) {
          if (_answer.maxPoints) points.pointsMax = _answer.maxPoints;else if (question.pointsMax) points.pointsMax = question.pointsMax;

          if (_answer.points) points.pointsReached = _answer.points;
        }
      } else if (qtype === "dropdown") {
        var _answer2 = _.find(question.choices, { value: question.value });
        if (_answer2) {
          if (question.pointsMax) points.pointsMax = question.pointsMax;
          if (_answer2.points) points.pointsReached = _answer2.points;
        }
      } else if (qtype === "rating") {
        if (!question.rateValues || question.rateValues.length < 1) {
          if (question.pointsMax) {
            points.pointsMax = question.pointsMax;
            points.pointsReached = question.pointsMax;
          }
        } else {
          var _answer3 = _.find(question.rateValues, { value: question.value });
          if (_answer3) {
            if (question.pointsMax) points.pointsMax = question.pointsMax;
            if (_answer3.points) points.pointsReached = _answer3.points;
          }
        }
      }
      return points;
    },
    showAutovalidationButton: function showAutovalidationButton() {
      var role = this.globals.getUserRole();
      if (!role) {
        return false;
      }
      switch (role.RoleName) {
        case "MSM_Administrator_Sysadmin":
          return true;
        case "MSM_MSM_Administrator":
          return true;
        case "MSM_MSM_ProjectLeader_Senior":
          return true;
        default:
          return false;
      }
    },
    cleanupSurveyAnswer: function cleanupSurveyAnswer() {
      if (this.autovalidation.survey.clearInvisibleValues === "none") return;
      var visibleQuestions = this.autovalidation.survey.getAllQuestions(true);

      this.autovalidation.survey.data = _.pickBy(this.autovalidation.survey.data, function (value, key) {
        return _.findIndex(visibleQuestions, function (q) {
          return q.name === key;
        }) > -1;
      });
    }
  },
  watch: {
    selectedClient: function selectedClient() {
      if (!this.showAddChecksDialog) this.getCheckData();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this, this.setElementHeights);
    },
    "filterStrings.SurveyInstanceStatusId": function filterStringsSurveyInstanceStatusId() {
      this.selectedChecks = [];
      this.selectedCheckIds = [];
      this.selectedPage = 1;
      this.includeChecks = true;
      this.calcAllowedStatusCodes();
      this.getCheckData();
    }
  },
  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_7_vue_click_outside___default.a
  },
  data: function data() {
    // Global data inside the component is stored here
    return {
      selectedChecks: [], // GUIDs
      selectedCheckIds: [], // IDs TODO: Should be removed
      CheckManagementFilter: [],
      CheckManagementFilterCounter: 0,
      CheckManagementFilterWidthSID: 3,
      lastSelectedCheck: -1,
      includeChecks: true,
      selectedClient: "",
      selectedImporter: "",
      selectedProject: "",
      selectedCheckType: "",
      selectedOnlineState: null,
      pageSize: 20, // Number of checks on one page of the table
      selectedPage: 1, // Number of the page, that is visible
      pageCount: 0, // Count of available pages depending on the pagesize and the data
      checkCount: 0,
      showEditChecksDialog: false,
      showCheckManagementFilterModal: false,
      showAddChecksDialog: false,
      showSettlementDownloadModal: false,
      showCheckPaymentModal: false,
      showShopperFilterModal: false,
      showCheckLocalAgencyAssignmentModal: false,
      checkExportFileType: "xlsx",
      showExportModal: false,
      filterStrings: {
        // Strings that are manipulated by the user for filtering the table
        ClientGuid: "",
        SurveyId: "",
        SurveyInstanceId: "",
        SurveyInstanceGuid: "",
        ShortSurveyCode: "",
        WaveName: "",
        SurveyInstanceStatusId: "",
        ProjectGuid: "",
        LocationStoreId: "",
        LocationName: "",
        LocationAddress: "",
        LocationCountry: "",
        SurveyInstanceAnswerDateOfVisit: "",
        SurveyInstanceShopperSubmittedAt: "",
        SurveyInstancePartnerSubmittedAt: "",
        SurveyInstanceNote: "",
        SurveyInstanceUntil: "",
        ScenarioName: "",
        SurveyInstanceInfo: "",
        SurveyInstanceResponsable: "",
        ApprovedShopperName: "",
        SurveyInstanceScore: "",
        SurveyInstanceProgress: "",
        SettlementNumber: "",
        SurveyInstanceModifiedAt: ""
      },
      sortField: "SurveyInstanceId", // Selected column for sorting
      sortOrder: "desc", // Should be "asc" or "desc"
      refreshEnabled: false, // false, if check data is requested and server did not respond yet to avoid multiple requests at the same time
      checkData: [], // Stores the check data on the current page
      dataLists: {
        clientList: [], // List of all clients
        importerList: [],
        surveyList: [], // List of all surveys
        statusCodes: [],
        projectList: [],
        projectsOfClient: [],
        waveList: [],
        scenarioList: [],
        agencyList: [],
        shopperList: {}
      },
      allowedStatusCodes: [],
      selectedStatusCode: null,
      invalidInputIds: [], // IDs of inputs with validation error
      metaInformationOfCurrentCheck: {},
      lang: {
        // Contains localization strings for the selected language
        CM0000: "Update",
        CM0001: "New",
        CM0002: "Edit",
        CM0003: "Delete",
        CM0004: "Export",
        CM0005: "Open",
        CM0006: "Move to Status",
        CM0007: "Select Page",
        CM0008: "Deselect Page",
        CM0009: "Invert Selection",
        CM0010: "Reset Selection",
        CM0011: "Please select a client...",
        CM0012: "Elements per page",
        CM0013: "First page",
        CM0014: "Last page",
        CM0015: "SID",
        CM0016: "Check ID",
        CM0017: "Survey Code",
        CM0018: "Status",
        CM0019: "Project",
        CM0020: "Wave",
        CM0021: "Scenario",
        CM0022: "Address",
        CM0023: "Country",
        CM0024: "Visit",
        CM0025: "Submit Shopper",
        CM0026: "Submit Partner",
        CM0027: "Internal note",
        CM0028: "Expiry Date",
        CM0029: "User",
        CM0030: "Score",
        CM0031: "Progress",
        CM0032: "Filter",
        CM0033: "Survey View",
        CM0034: "Delete Checks",
        CM0035: "Do you really want to delete the selected checks?",
        CM0036: "No",
        CM0037: "Yes",
        CM0038: "Check Export",
        CM0039: "Download",
        CM0040: "Cancel",
        CM0041: "Export Checks for Client",
        CM0042: "Please select a file type",
        CM0043: "Text CSV (.csv)",
        CM0044: "Microsoft Excel 97-2003 (.xls)",
        CM0045: "Microsoft Excel 2007-2013 XML (.xlsx)",
        CM0046: "Please filter for status first",
        CM0047: "Modified At",
        CM0048: "Please select a project...",
        CM0049: "Total checks count",
        CM0050: "StoreID",
        CM0051: "Location Name",
        CM0052: "Estimated - Relevant are the reporting results",
        CM0053: "Open multiple checks",
        CM0054: "Yes",
        CM0055: "No",
        CM0056: "You are trying to open the following amount of checks",
        CM0057: "Opening many checks at once can lead to performance issues until your browser will load multiple new tabs at once.",
        CM0058: "Do you really want to proceed?",
        CM0059: "Invoice lists",
        CM0060: "Invoice",
        CM0061: "Payments",
        CM0062: "Check request failed",
        CM0063: "Free offer",
        CM0064: "Manual assignment",
        CM0065: "Agency",
        CM0066: "Check type",
        CM0067: "Online",
        CM0068: "Meaning of the filterable values",
        CM0069: "Invoice approved",
        CM0070: "Submitted by shopper",
        CM0071: "Check is assigned",
        CM0072: "Partner check or no payout",
        CM0073: "Check Info",
        CM0074: "Importer",
        CM0075: "Assign",
        CM0076: "Clone",
        CM0077: "Checks cloned",
        CM0078: "Check cloning failed",
        CM0079: "Shopper",
        CM0080: "History",
        CM1074: "Custom settings"
      },
      autovalidation: {
        invalidChecks: [],
        validatedChecks: [],
        survey: null
      }

    };
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Tools_Select2__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Tools_Select2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AddChecksFurtherSettingsModal__ = __webpack_require__(1560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AddChecksFurtherSettingsModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__AddChecksFurtherSettingsModal__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "CheckManagementAddModal",
  components: {
    Select2: __WEBPACK_IMPORTED_MODULE_3__Tools_Select2___default.a,
    AddChecksFurtherSettingsModal: __WEBPACK_IMPORTED_MODULE_4__AddChecksFurtherSettingsModal___default.a
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#addChecksDialog").on("hidden.bs.modal", function (e) {
      _this.$emit("dialogClosed");
    });

    if (this.feature.isAudiTarget && this.feature.isEnabled("leadAgencies")) {
      this.globals.getAgencyTypeList(function (data) {
        _this.agencyTypeList = data;
      });
    }
  },

  computed: {
    leadAgencyGuid: function leadAgencyGuid() {
      if (this.agencyTypeList.length < 1) return "";
      var leadAgency = _.find(this.agencyTypeList, function (at) {
        return at.AgencyTypeName === "Lead";
      });
      return leadAgency ? leadAgency.AgencyTypeGuid : "";
    },
    leadAgencies: function leadAgencies() {
      var _this2 = this;

      if (!this.leadAgencyGuid) return [];
      return this.dataLists.agencyList.filter(function (a) {
        return a.AgencyTypeGuid === _this2.leadAgencyGuid;
      });
    }
  },
  methods: {
    // Initializes the dialog on opening
    openAddChecksDialog: function openAddChecksDialog() {
      var _this3 = this;

      this.selectedClientLocal = this.selectedClient;
      this.selectedProjectLocal = "";
      if (this.selectedProject) this.$nextTick(function () {
        _this3.selectedProjectLocal = _this3.selectedProject;
      });
      this.selectedCheckType = "";
      if (this.feature.isAudiTarget) this.selectedCheckType = "AG";
      this.selectedAgency = "";
      this.selectedUser = "";
      this.globalAmount = 0;
      this.checkInfo = "";
      this.selectedBriefingGuid = "";
      this.selectedSurveyGuid = "";
      this.selectedLocations = [];
      this.amountList = [];
      this.createdChecks = [];
      this.createdCheckIds = [];
      this.$refs["addChecksFurtherSettingsModal"].clearSettings();
      this.clearFilterStrings();
      this.getLocationData(true);
      $("#addChecksDialog").modal("show");
    },


    // Closes the addChecksDialog
    closeAddChecksDialog: function closeAddChecksDialog() {
      $("#addChecksDialog").modal("hide");
      this.$emit("checksCreated", {
        guids: this.createdChecks,
        ids: this.createdCheckIds
      });
    },
    clearFilter: function clearFilter() {
      if (!this.feature.isAudiTarget) this.selectedClientLocal = "";
      this.selectedProjectLocal = "";
      this.selectedSurvey = "";
      this.selectedWave = "";
      this.selectedScenario = "";
      this.selectedUser = "";
      this.selectedAgency = "";
      this.globalAmount = 0;
      this.selectedLocations = [];
      this.amountList = [];
      this.clearFilterStrings();
      this.$forceUpdate();
    },
    clearFilterStrings: function clearFilterStrings() {
      var _this4 = this;

      var filterKeys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.filterStrings);
      filterKeys.forEach(function (filterKey) {
        return _this4.filterStrings[filterKey] = "";
      });
    },
    sortLocationData: function sortLocationData(field) {
      if (field == this.sortField) {
        this.sortOrder == "asc" ? this.sortOrder = "desc" : this.sortOrder = "asc";
      } else {
        this.sortField = field;
        this.sortOrder = "asc";
      }
      this.selectedPage = 1;
      this.getLocationData();
    },
    toggleLocationSelected: function toggleLocationSelected(locationId) {
      var idx = _.indexOf(this.selectedLocations, locationId);
      if (idx > -1) _.pullAt(this.selectedLocations, idx);else this.selectedLocations.push(locationId);
      this.$forceUpdate();
    },
    isLocationSelected: function isLocationSelected(locationId) {
      return _.indexOf(this.selectedLocations, locationId) > -1;
    },
    isPageSelected: function isPageSelected() {
      for (var i = 0; i < this.locationData.length; i++) {
        if (!this.isLocationSelected(this.locationData[i].LocationId)) return false;
      }
      return true;
    },
    togglePageSelected: function togglePageSelected() {
      if (this.locationData.length < 1) return;
      var selState = this.isPageSelected();
      if (!selState) {
        for (var i = 0; i < this.locationData.length; i++) {
          if (!this.isLocationSelected(this.locationData[i].LocationId)) this.selectedLocations.push(this.locationData[i].LocationId);
        }
      } else {
        for (var _i = 0; _i < this.locationData.length; _i++) {
          this.toggleLocationSelected(this.locationData[_i].LocationId);
        }
      }
    },
    getLocationData: function getLocationData(discardAmounts) {
      var _this5 = this;

      if (!this.selectedClientLocal || !this.selectedProjectLocal && this.feature.isAudiTarget && this.feature.isEnabled("audi_importers")) {
        this.locationData = [];
        this.pageCount = 0;
        this.pageSize = 20;
        this.selectedPage = 1;
        return;
      }

      if (!discardAmounts) this.storeAmountsForPage();
      var getString = "api/SurveyInstances/Locations/" + this.selectedClientLocal + "?page_size=" + this.pageSize + "&page=" + this.selectedPage + "&sort_column=" + this.sortField + "&sort_order=" + this.sortOrder;
      getString = encodeURI(getString);

      var filter = _.pickBy(this.filterStrings, function (value, key) {
        return value.length > 0;
      });

      var sendData = {};
      if (!_.isEmpty(filter)) sendData.Filter = filter;
      if (this.selectedProjectLocal) sendData.ProjectGuidForImporterFilter = this.selectedProjectLocal;

      $.ajax({
        method: "POST",
        url: getString,
        data: _.isEmpty(sendData) ? "" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(sendData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data[0]) {
            if (data[0].Locations) _this5.locationData = data[0].Locations;
            // If GET was successful, store location data and page count from server
            else _this5.locationData = [];
            _this5.pageCount = data[0].Page_Count;
            _this5.totalElementsCount = data[0].Count;
            _this5.readAmountsForPage();
          }
        },
        error: function error() {
          console.error("Error on POST in getLocationData()");
          _this5.globals.showErrorSnackbar("Location data access failed");
        }
      });
    },
    createChecks: function createChecks() {
      var _this6 = this;

      this.storeAmountsForPage();
      this.removeUnselectedLocationsFromAmountList();
      this.setGlobalAmount();
      _.remove(this.amountList, function (entry) {
        return entry.Amount < 1;
      });

      if (this.amountList.length < 1) {
        this.globals.showErrorSnackbar(this.lang.CM2042);
        console.error("Error creating checks: No amounts selected");
        return;
      }

      var sendData = {};
      if (this.selectedSurvey) sendData.Surveys = [this.selectedSurvey];
      if (this.selectedScenario && this.selectedWave) sendData.WavesScenarios = [{ WaveGuid: this.selectedWave, ScenarioGuid: this.selectedScenario }];
      if (this.selectedAgency) {
        if (this.feature.isAudiTarget) sendData.LeadAgencyGuid = this.selectedAgency;else sendData.LocalAgencyGuid = this.selectedAgency;
      }
      if (this.selectedUser) sendData.ShopperGuid = this.selectedUser;
      sendData.Locations = this.amountList;
      if (this.selectedCheckType) sendData.SurveyInstanceType = this.selectedCheckType;
      if (this.selectedBriefingGuid) sendData.BriefingDownloadGuid = this.selectedBriefingGuid;
      if (this.selectedSurveyGuid) sendData.SurveyDownloadGuid = this.selectedSurveyGuid;
      if (this.checkInfo) sendData.SurveyInstanceInfo = this.checkInfo;

      if (this.selectedCheckType === "FO") {
        for (var key in this.furtherCheckSettings) {
          if (this.furtherCheckSettings[key] || typeof this.furtherCheckSettings[key] === "boolean") sendData[key] = this.furtherCheckSettings[key];
        }
      }

      $.ajax({
        method: "POST",
        url: "api/SurveyInstances",
        data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(sendData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          _this6.globals.showSuccessSnackbar(_this6.lang.CM2041);
          _this6.$emit("dialogDataSaved");
          _this6.amountList = [];
          _this6.selectedSurvey = "";
          _this6.selectedWave = "";

          if (_.isEmpty(data)) {
            console.error("Missing check IDs");
            return;
          }
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var check = _step.value;

              _this6.createdChecks.push(check.SurveyInstanceGuid);
              _this6.createdCheckIds.push(check.SurveyInstanceId);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        },
        error: function error() {
          console.error("Error on POST in createChecks()");
          _this6.globals.showErrorSnackbar(_this6.lang.CM2040);
        }
      });
    },
    setAmount: function setAmount(amount, locationIds) {
      var am = _.find(this.amountList, function (a) {
        return a.Amount == amount;
      });
      if (am) {
        am.LocationIds = _.union(am.LocationIds, locationIds);
      } else {
        var amountObj = { Amount: amount, LocationIds: locationIds };
        this.amountList.push(amountObj);
      }
    },
    setGlobalAmount: function setGlobalAmount() {
      if (!this.globalAmount) return;
      for (var i = 0; i < this.selectedLocations.length; i++) {
        if (!this.hasAmount(this.selectedLocations[i])) {
          this.setAmount(this.globalAmount, [this.selectedLocations[i]]);
        }
      }
    },
    hasAmount: function hasAmount(locationId) {
      for (var i = 0; i < this.amountList.length; i++) {
        var locs = this.amountList[i].LocationIds;
        for (var j = 0; j < locs.length; j++) {
          if (locs[j] == locationId) return true;
        }
      }
      return false;
    },
    removeUnselectedLocationsFromAmountList: function removeUnselectedLocationsFromAmountList() {
      for (var i = 0; i < this.amountList.length; i++) {
        var locs = this.amountList[i].LocationIds;
        for (var j = 0; j < locs.length; j++) {
          if (!this.isLocationSelected(locs[j])) _.pullAt(locs, j);
        }
        if (locs.length < 1) _.pullAt(this.amountList, i);
      }
    },
    storeAmountsForPage: function storeAmountsForPage() {
      for (var i = 0; i < this.locationData.length; i++) {
        if (this.locationData[i].Amount) {
          this.setAmount(this.locationData[i].Amount, [this.locationData[i].LocationId]);
        }
      }
    },
    readAmountsForPage: function readAmountsForPage() {
      var _this7 = this;

      if (this.amountList.length < 1) return;
      for (var i = 0; i < this.amountList.length; i++) {
        var locs = this.amountList[i].LocationIds;

        var _loop = function _loop(j) {
          ld = _.find(_this7.locationData, function (l) {
            return l.LocationId == locs[j];
          });

          if (ld) {
            ld.Amount = _this7.amountList[i].Amount;
          }
        };

        for (var j = 0; j < locs.length; j++) {
          var ld;

          _loop(j);
        }
      }
    },
    updatePaging: function updatePaging(pageNumber, pageSize) {
      this.selectedPage = pageNumber || 1;
      if (pageSize != 0) this.pageSize = pageSize;
      this.getLocationData();
    },


    // Returns a range of numbers with min-value, max-value and stepsize
    getRange: function getRange(min, max, step) {
      var range = [],
          j = 0;
      for (var i = min; i <= max; i += step) {
        range[j++] = i;
      }
      return range;
    },


    // Returns a list of all pagenumbers that should be visible depending on the current page and the count of pages
    getVisiblePages: function getVisiblePages() {
      if (this.pageCount <= 7) {
        return this.getRange(1, this.pageCount, 1);
      } else if (this.pageCount > 7 && this.selectedPage <= 4) {
        return this.getRange(1, 6, 1);
      } else if (this.pageCount > 7 && this.selectedPage >= this.pageCount - 3) {
        return this.getRange(this.pageCount - 5, this.pageCount, 1);
      } else {
        return this.getRange(this.selectedPage - 2, this.selectedPage + 2, 1);
      }
    },
    getProjectAttachments: function getProjectAttachments() {
      var _this8 = this;

      var queryString = "/api/data/ProjectAttachments/" + this.selectedProjectLocal;
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          if (data.length > 0) {
            _this8.briefingAttachments = data.filter(function (d) {
              return d.AttachmentType === "Briefing";
            });
            _this8.surveyAttachments = data.filter(function (d) {
              return d.AttachmentType === "Survey";
            });
          }
        },
        error: function error() {
          console.error("Attachments data access failed in getProjectAttachments()");
          _this8.globals.showErrorSnackbar(_this8.lang.CM2043);
        }
      });
    },
    furtherSettingsModalClosed: function furtherSettingsModalClosed(data) {
      this.showFurtherSettingsModal = false;
      this.furtherCheckSettings = data;
    }
  },
  watch: {
    showDialog: function showDialog(newValue) {
      if (newValue) this.openAddChecksDialog();else this.closeAddChecksDialog();
    },
    selectedClientLocal: function selectedClientLocal(newValue) {
      if (newValue) {
        var pl = this.dataLists.projectList.find(function (p) {
          return p.ClientGuid === newValue;
        });
        if (pl && pl.Projects) this.projectsOfClient = pl.Projects;else this.projectsOfClient = [];
      }
      this.selectedProjectLocal = "";
      this.selectedLocations = [];
      this.amountList = [];
      this.getLocationData(true);
    },
    selectedProjectLocal: function selectedProjectLocal(newValue) {
      if (newValue) {
        var sl = this.dataLists.surveyList.find(function (s) {
          return s.ProjectGuid === newValue;
        });
        if (sl && sl.Surveys) this.surveysOfProject = sl.Surveys;else this.surveysOfProject = [];

        var wl = this.dataLists.waveList.find(function (w) {
          return w.ProjectGuid === newValue;
        });
        if (wl && wl.Waves) this.wavesOfProject = wl.Waves;else this.wavesOfProject = [];

        this.getProjectAttachments();
      }
      this.selectedSurvey = "";
      this.selectedWave = "";

      if (this.feature.isAudiTarget && this.feature.isEnabled("audi_importers")) {
        this.selectedLocations = [];
        this.amountList = [];
        this.getLocationData(true);
      }
    },
    selectedWave: function selectedWave(newValue) {
      if (newValue) {
        var scl = this.dataLists.scenarioList.find(function (s) {
          return s.WaveGuid === newValue;
        });
        if (scl && scl.Scenarios) this.scenariosOfWave = scl.Scenarios;else this.scenariosOfWave = [];
      }
      this.selectedScenario = "";
    },
    selectedUser: function selectedUser(newValue) {
      if (!newValue) return;
      this.selectedAgency = "";
    },
    selectedAgency: function selectedAgency(newValue) {
      if (!newValue) return;
      this.selectedUser = "";
    },
    selectedSurvey: function selectedSurvey(id) {
      if (!id) this.selectedSurveyData = {};else this.selectedSurveyData = _.find(this.surveysOfProject, function (s) {
        return s.SurveyId == id;
      }) || {};
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  props: ["dataLists", "selectedClient", "selectedProject", "showDialog"],
  data: function data() {
    // Global data inside the component is stored here
    return {
      selectedPage: 1,
      pageSize: 20,
      pageCount: 0,
      totalElementsCount: 0,
      sortOrder: "asc",
      sortField: "LocationId",
      filterStrings: {
        Search: "",
        LocationId: "",
        LocationStoreId: "",
        LocationCountry: "",
        LocationAddress: "",
        LocationProperties: "",
        LocationStatusId: "",
        SurveyInstancesCount: ""
      },
      locationData: [],
      selectedLocations: [],
      projectsOfClient: [],
      surveysOfProject: [],
      wavesOfProject: [],
      scenariosOfWave: [],
      agencyTypeList: [],
      selectedClientLocal: -1,
      selectedProjectLocal: "",
      selectedSurvey: "",
      selectedSurveyData: {},
      selectedWave: "",
      selectedScenario: "",
      selectedUser: "",
      selectedAgency: "",
      selectedBriefingGuid: "",
      selectedSurveyGuid: "",
      selectedCheckType: "",
      globalAmount: 0,
      checkInfo: "",
      amountList: [],
      briefingAttachments: [],
      surveyAttachments: [],
      createdChecks: [],
      createdCheckIds: [], //TODO: should be removed
      furtherCheckSettings: {
        OnlineState: false,
        LocationFree: false
      },
      showFurtherSettingsModal: false,
      lang: {
        CM2000: "Create Checks",
        CM2001: "Select Client...",
        CM2002: "Select Project...",
        CM2003: "Select Survey...",
        CM2004: "Select Wave...",
        CM2005: "Select Scenario...",
        CM2006: "Select Shopper...",
        CM2007: "Begin",
        CM2008: "End",
        CM2009: "Amount",
        CM2010: "Clear Filter",
        CM2011: "Select Page",
        CM2012: "Deselect Page",
        CM2013: "Select Agency...",
        CM2014: "Search...",
        CM2015: "Elements per page",
        CM2016: "First page",
        CM2017: "Last page",
        CM2018: "Location ID",
        CM2019: "Location Store ID",
        CM2020: "Country",
        CM2021: "Location Address",
        CM2022: "Location Properties",
        CM2023: "Status Location",
        CM2024: "Existing Checks",
        CM2025: "Filter",
        CM2026: "Create",
        CM2027: "Check Description",
        CM2028: "It is not allowed to create checks with an amount of 0 surveys",
        CM2029: "Choose briefing document...",
        CM2030: "Choose survey document...",
        CM2031: "Select check type",
        CM2032: "Free offer",
        CM2033: "Manual assignment",
        CM2034: "Agency",
        CM2035: "Check refund",
        CM2036: "Reset",
        CM2037: "Selected locations",
        CM2038: "Offer details",
        CM2039: "Close",
        CM2040: "Check creation failed",
        CM2041: "Check creation successful",
        CM2042: "No amounts selected",
        CM2043: "Attachment data access failed",
        CM2044: "Check Info",
        CM2045: "Total locations count"
      }
    };
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tools_Select2__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Tools_Select2__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "CheckManagementEditModal",
  components: {
    Select2: __WEBPACK_IMPORTED_MODULE_2__Tools_Select2___default.a
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) {
      this.languageStringsReceived = false;
      this.globals.getLanguageStrings(this, function () {
        _this.languageStringsReceived = true;
      });
    }

    $("#editChecksDialog").on("hidden.bs.modal", function (e) {
      _this.$emit("dialogClosed");
    });

    if (this.feature.isAudiTarget && this.feature.isEnabled("leadAgencies")) {
      this.globals.getAgencyTypeList(function (data) {
        _this.agencyTypeList = data;
      });
    }
  },

  computed: {
    leadAgencyGuid: function leadAgencyGuid() {
      if (this.agencyTypeList.length < 1) return "";
      var leadAgency = _.find(this.agencyTypeList, function (at) {
        return at.AgencyTypeName === "Lead";
      });
      return leadAgency ? leadAgency.AgencyTypeGuid : "";
    },
    leadAgencies: function leadAgencies() {
      var _this2 = this;

      if (!this.leadAgencyGuid) return [];
      return this.dataLists.agencyList.filter(function (a) {
        return a.AgencyTypeGuid === _this2.leadAgencyGuid;
      });
    },
    localAgencies: function localAgencies() {
      var _this3 = this;

      if (!this.generalSettingsData.SurveyInstanceAssignedLeadAgencyGuid || this.leadAgencies.length < 1) return [];

      var lead = this.leadAgencies.find(function (a) {
        return a.AgencyGuid === _this3.generalSettingsData.SurveyInstanceAssignedLeadAgencyGuid;
      });
      if (this.$refs.checkEditSelectLocalAgency) this.$refs.checkEditSelectLocalAgency.updateValue();
      return lead && lead.ChildAgencies ? lead.ChildAgencies : [];
    }
  },
  methods: {
    convertScenarioList: function convertScenarioList() {
      this.scenarioList = [];
      for (var i = 0; i < this.dataLists.scenarioList.length; i++) {
        this.scenarioList = _.union(this.scenarioList, this.dataLists.scenarioList[i].Scenarios);
      }
    },
    openShopperFilterModal: function openShopperFilterModal() {
      var _this4 = this;

      this.globals.$emit("openShopperFilterModal");
      this.globals.$emit("sendDataToShopperFilterModal", this.shopperFilter);
      if (!this.$multipleCheckFilterMessageShown && this.selectedChecks.length > 1) {
        this.$multipleCheckFilterMessageShown = true;
        setTimeout(function () {
          _this4.globals.$emit("openGlobalNotificationDialog", {
            initiator: "CheckManagementEditModalOpenShopperFilter",
            notificationTitle: _this4.lang.CM1062,
            closeButtonText: _this4.lang.CM1063,
            htmlText: "<p>" + _this4.lang.CM1064 + "<br><br>" + _this4.lang.CM1065 + "</p>"
          });
        }, 200);
      }
    },
    toggleSetting: function toggleSetting(setting) {
      if (this.generalSettingsData[setting] > 0) this.generalSettingsData[setting] = 0;else this.generalSettingsData[setting] = 1;
      this.$forceUpdate();
    },
    surveyInstanceTypeChanged: function surveyInstanceTypeChanged(value) {
      delete this.generalSettingsData.SurveyInstanceAssignedLocalAgencyGuid;
      delete this.generalSettingsData.SurveyInstanceAssignedShopperGuid;

      if (value === "FO") {
        if (typeof this.generalSettingsData.LocationFree !== "number") this.generalSettingsData.LocationFree = 0;
        if (typeof this.generalSettingsData.OnlineState !== "number") this.generalSettingsData.OnlineState = 0;
      }
    },

    // Fills the editCheck dialog with data, depending on the dialog mode.
    openEditChecksDialog: function openEditChecksDialog() {
      var _this5 = this;

      this.globals.$on("getDataFromShopperFilterModal", function (data) {
        if (_.isEqual(_this5.shopperFilter, data)) return;
        _this5.shopperFilter = data;
        _this5.shopperFilterDataDirty = true;
      });
      if (this.$clientChanged) {
        this.getLocationsOfSelectedClient();
        delete this.$clientChanged;
      }
      this.convertScenarioList();
      this.getWavesOfProject();
      this.getProjectAttachments();

      this.getCheckSpecificData();

      this.checkData = { Surveys: [] };
      $.ajax({
        method: "POST",
        url: "api/SurveyInstances/Properties?include=" + this.includeChecks,
        data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.selectedCheckIds),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            _this5.globals.showErrorSnackbar(data.Error);
            _this5.$emit("dialogClosed");
          } else {
            _this5.generalSettingsData = data;
            _this5.previousLocationGuid = data.SurveyInstanceLocationGuid;
            _this5.getShopperFilterObject();

            if (data.SurveyInstanceDescription === "-1") {
              _this5.generalSettingsData.SurveyInstanceDescription = "";
              _this5.surveyInstanceDescriptionMixed = true;
            }
            if (data.SurveyInstanceInfo === "-1") {
              _this5.generalSettingsData.SurveyInstanceInfo = "";
              _this5.surveyInstanceInfoMixed = true;
            }

            _this5.$nextTick(function () {
              $("#checkManagementEditModalSelectAgency").val(_this5.generalSettingsData.SurveyInstanceAssignedLocalAgencyGuid);
              $("#checkManagementEditModalSelectUser").val(_this5.generalSettingsData.SurveyInstanceAssignedShopperGuid);

              var waveBackup = _this5.generalSettingsData.SurveyInstanceWaveGuid;
              var scenarioBackup = _this5.generalSettingsData.SurveyInstanceScenarioGuid;
              $("#checkManagementEditModalSelectWave").val(_this5.generalSettingsData.SurveyInstanceWaveGuid);
              $("#checkManagementEditModalSelectWave").trigger("change");
              _this5.$nextTick(function () {
                $("#checkManagementEditModalSelectScenario").val(scenarioBackup);
                $("#checkManagementEditModalSelectScenario").trigger("change");
                _this5.generalSettingsData.SurveyInstanceWaveGuid = waveBackup;
                _this5.generalSettingsData.SurveyInstanceScenarioGuid = scenarioBackup;
              });

              $("#checkManagementEditModalSelectLocation").val(_this5.generalSettingsData.SurveyInstanceLocationGuid);

              if (_this5.$refs.checkEditSelectLeadAgency) _this5.$refs.checkEditSelectLeadAgency.updateValue();

              _this5.fpCustomReportingDate = flatpickr("#inputCustomReportingDateCheckMgmtEdit", _this5.globals.flatpickrDateConfig);
              _this5.fpBegin = flatpickr("#inputCheckEditStartDate", _this5.globals.flatpickrDateConfig);
              _this5.fpEnd = flatpickr("#inputCheckEditEndDate", _this5.globals.flatpickrDateConfig);

              if (data.SurveyInstanceCustomReportingDate != "-1") _this5.fpCustomReportingDate.setDate(_this5.generalSettingsData.SurveyInstanceCustomReportingDate, true);
              if (data.SurveyInstanceSince != "-1") _this5.fpBegin.setDate(_this5.generalSettingsData.SurveyInstanceSince, true);
              if (data.SurveyInstanceUntil != "-1") _this5.fpEnd.setDate(_this5.generalSettingsData.SurveyInstanceUntil, true);

              if (!_this5.generalSettingsData.BriefingDownloadGuid) _this5.generalSettingsData.BriefingDownloadGuid = "";
              if (!_this5.generalSettingsData.SurveyDownloadGuid) _this5.generalSettingsData.SurveyDownloadGuid = "";
            });

            $("#editChecksDialog").modal("show");
            _this5.globals.$off("getDataFromHtmlEditorModal");
            _this5.globals.$on("getDataFromHtmlEditorModal", function (data) {
              _this5.generalSettingsData.SurveyInstanceDescription = data;
            });
          }
        },
        error: function error() {
          console.error("Check data access failed in openEditChecksDialog()");
          _this5.globals.showErrorSnackbar(_this5.lang.CM1045);
          _this5.$emit("dialogClosed");
        }
      });
    },

    // Closes the editChecksDialog
    closeEditChecksDialog: function closeEditChecksDialog() {
      this.globals.$off("getDataFromShopperFilterModal");
      if (this.fpCustomReportingDate) this.fpCustomReportingDate.destroy();
      if (this.fpDateOfVisit) this.fpDateOfVisit.destroy();
      if (this.fpTimeIn) this.fpTimeIn.destroy();
      if (this.fpTimeOut) this.fpTimeOut.destroy();
      if (this.fpBegin) this.fpBegin.destroy();
      if (this.fpEnd) this.fpEnd.destroy();
      $("#editChecksDialog").modal("hide");
    },
    getShopperFilterObject: function getShopperFilterObject() {
      var _this6 = this;

      if (this.generalSettingsData.SurveyInstanceType !== "FO" || this.selectedChecks.length > 1) {
        this.shopperFilter = {};
        this.shopperFilterDataDirty = false;
        return;
      }

      var url = "api/SurveyInstances/ShopperFilter/" + this.selectedChecks[0];
      $.ajax({
        method: "GET",
        url: url,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          _this6.shopperFilter = data && data.ShopperFilter ? data.ShopperFilter : {};
          _this6.shopperFilterDataDirty = false;
        },
        error: function error() {
          console.error("Error on GET in getShopperFilterObject()");
          _this6.globals.showErrorSnackbar(_this6.lang.CM1054);
          _this6.$emit("dialogClosed");
        }
      });
    },
    saveShopperFilterObject: function saveShopperFilterObject() {
      var _this7 = this;

      if (!this.shopperFilterDataDirty) return;
      var url = "api/SurveyInstances/ShopperFilter";
      var sendData = {
        SurveyInstanceGuids: this.selectedChecks,
        ShopperFilter: this.shopperFilter
      };

      $.ajax({
        method: "PUT",
        url: url,
        data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(sendData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          _this7.shopperFilterDataDirty = false;
        },
        error: function error() {
          console.error("Error on PUT in saveShopperFilterObject()");
          _this7.globals.showErrorSnackbar(_this7.lang.CM1055);
        }
      });
    },

    // Sends the data from editCheck dialog to the server to store it in the database
    saveEditCheckDialogData: function saveEditCheckDialogData() {
      var _this8 = this;

      this.saveShopperFilterObject();
      this.saveCheckSpecificData();

      if (this.generalSettingsData.SurveyInstanceType === "AG" && !this.generalSettingsData.SurveyInstanceAssignedLocalAgencyGuid && !this.feature.isAudiTarget) {
        this.globals.showErrorSnackbar(this.lang.CM1046);
        return;
      }
      if (this.generalSettingsData.SurveyInstanceType === "MA" && !this.generalSettingsData.SurveyInstanceAssignedShopperGuid) {
        this.globals.showErrorSnackbar(this.lang.CM1047);
        return;
      }
      if (this.generalSettingsData.SurveyInstanceSince && this.generalSettingsData.SurveyInstanceSince !== "-1" && this.generalSettingsData.SurveyInstanceUntil && this.generalSettingsData.SurveyInstanceUntil !== "-1" && this.generalSettingsData.SurveyInstanceSince > this.generalSettingsData.SurveyInstanceUntil) {
        this.globals.showErrorSnackbar(this.lang.CM1060);
        return;
      }

      var sendData = _.cloneDeep(this.generalSettingsData);

      sendData.SurveyInstanceIds = this.selectedCheckIds;
      if (this.surveyInstanceDescriptionMixed && !sendData.SurveyInstanceDescription) {
        sendData.SurveyInstanceDescription = "-1";
      }
      this.surveyInstanceDescriptionMixed = false;
      if (this.surveyInstanceInfoMixed && !sendData.SurveyInstanceInfo) {
        sendData.SurveyInstanceInfo = "-1";
      }
      this.surveyInstanceInfoMixed = false;

      if (!sendData.SurveyInstanceCustomReportingDate) delete sendData.SurveyInstanceCustomReportingDate;

      $.ajax({
        method: "PUT",
        url: "api/SurveyInstances/Properties?include=" + this.includeChecks,
        data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(sendData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            _this8.globals.showErrorSnackbar(data.Error);
            console.error(data.Error);
            return;
          }
          _this8.globals.showSuccessSnackbar(_this8.lang.CM1048);
          _this8.$emit("dialogDataSaved");
          _this8.closeEditChecksDialog();
        },
        error: function error() {
          console.error("Error on PUT in saveEditCheckDialogData()");
          _this8.globals.showErrorSnackbar(_this8.lang.CM1049);
        }
      });
    },
    getCheckSpecificData: function getCheckSpecificData() {
      var _this9 = this;

      $.ajax({
        method: "POST",
        url: "api/SurveyInstances/Properties/DetailsList",
        data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.selectedChecks),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (!data || !data.length) {
            _this9.specificSettingsData.dataList = [];
            _this9.specificSettingsData.selectedCheck = {};
            return;
          }
          _this9.specificSettingsData.dataList = data;
          _this9.specificSettingsData.selectedCheck = data[0];

          _this9.fpDateOfVisit = flatpickr("#inputDateOfVisitCheckMgmtEdit", _this9.globals.flatpickrDateConfig);
          _this9.fpTimeIn = flatpickr("#inputTimeInCheckMgmtEdit", _this9.globals.flatpickrTimeConfig);
          _this9.fpTimeOut = flatpickr("#inputTimeOutCheckMgmtEdit", _this9.globals.flatpickrTimeConfig);
        },
        error: function error() {
          console.error("Error on POST in getCheckSpecificData()");
          _this9.globals.showErrorSnackbar(_this9.lang.CM1045);
        }
      });
    },
    saveCheckSpecificData: function saveCheckSpecificData() {
      var _this10 = this;

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.specificSettingsData.dataList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var check = _step.value;

          for (var property in check) {
            if (!check[property]) delete check[property];
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      $.ajax({
        method: "PUT",
        url: "api/SurveyInstances/Properties/DetailsList",
        data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.specificSettingsData.dataList),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        error: function error() {
          console.error("Error on PUT in saveCheckSpecificData()");
          _this10.globals.showErrorSnackbar(_this10.lang.CM1049);
        }
      });
    },
    getWavesOfProject: function getWavesOfProject() {
      var _this11 = this;

      if (!this.selectedProject) {
        this.wavesOfProject = [];
        return;
      }

      var wl = this.dataLists.waveList.find(function (w) {
        return w.ProjectGuid === _this11.selectedProject;
      });
      if (wl && wl.Waves) this.wavesOfProject = wl.Waves;else this.wavesOfProject = [];
    },
    getScenariosOfWave: function getScenariosOfWave() {
      var _this12 = this;

      if (!this.generalSettingsData.SurveyInstanceWaveGuid) {
        this.scenariosOfWave = [];
        return;
      }

      var sl = this.dataLists.scenarioList.find(function (s) {
        return s.WaveGuid === _this12.generalSettingsData.SurveyInstanceWaveGuid;
      });
      if (sl && sl.Scenarios) this.scenariosOfWave = sl.Scenarios;else this.scenariosOfWave = [];
    },
    selectedLocationChanged: function selectedLocationChanged() {
      var _this13 = this;

      if (!this.previousLocationGuid || this.generalSettingsData.SurveyInstanceLocationGuid === this.previousLocationGuid) return;

      this.globals.$off("CheckManagementEditModalSelectedLocationChangedCloseDialog");
      this.globals.$once("CheckManagementEditModalSelectedLocationChangedCloseDialog", function () {
        if (_this13.previousLocationGuid) _this13.generalSettingsData.SurveyInstanceLocationGuid = _this13.previousLocationGuid;
      });
      this.globals.$off("CheckManagementEditModalSelectedLocationChangedYesConfirmation");
      this.globals.$once("CheckManagementEditModalSelectedLocationChangedYesConfirmation", function () {
        _this13.previousLocationGuid = "";
      });

      this.globals.$emit("openGlobalConfirmationDialog", {
        initiator: "CheckManagementEditModalSelectedLocationChanged",
        confirmationTitle: this.lang.CM1030,
        colorRed: true,
        yesButtonText: this.lang.CM1031,
        noButtonText: this.lang.CM1032,
        htmlText: "<p><b>" + this.lang.CM1033 + "</b></p>"
      });
    },
    getLocationsOfSelectedClient: function getLocationsOfSelectedClient() {
      var _this14 = this;

      $.ajax({
        method: "POST",
        url: "api/SurveyInstances/Locations/" + this.selectedClient,
        success: function success(data) {
          if (data[0]) {
            if (data[0].Locations) _this14.locationsOfSelectedClient = data[0].Locations;else _this14.locationsOfSelectedClient = [];
          }
        },
        error: function error() {
          console.error("Error on POST in getLocationsOfSelectedClient()");
          _this14.globals.showErrorSnackbar("Location data access failed");
        }
      });
    },
    getProjectAttachments: function getProjectAttachments() {
      var _this15 = this;

      if (!this.selectedProject) {
        this.briefingAttachments = [];
        this.surveyAttachments = [];
        return;
      }
      var queryString = "/api/data/ProjectAttachments/" + this.selectedProject;
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          if (data.length > 0) {
            _this15.briefingAttachments = data.filter(function (d) {
              return d.AttachmentType === "Briefing";
            });
            _this15.surveyAttachments = data.filter(function (d) {
              return d.AttachmentType === "Survey";
            });
          }
        },
        error: function error() {
          console.error("Project attachments data access failed in getProjectAttachments()");
          _this15.globals.showErrorSnackbar(_this15.lang.CM1050);
        }
      });
    },
    openHtmlEditor: function openHtmlEditor() {
      this.globals.$emit("openHtmlEditorModal");
      this.globals.$emit("sendDataToHtmlEditorModal", {
        title: this.lang.CM1051,
        content: this.generalSettingsData.SurveyInstanceDescription
      });
    }
  },
  watch: {
    showDialog: function showDialog(value) {
      if (value) this.openEditChecksDialog();else this.closeEditChecksDialog();
    },
    selectedClient: function selectedClient(newValue) {
      if (newValue) this.$clientChanged = true;
    },
    "specificSettingsData.selectedCheck": function specificSettingsDataSelectedCheck(check) {
      if (this.fpDateOfVisit && !_.isEmpty(this.fpDateOfVisit)) this.fpDateOfVisit.setDate(check.SurveyInstanceAnswerDateOfVisit, true, "Y-m-d");
      if (this.fpTimeIn && !_.isEmpty(this.fpTimeIn)) this.fpTimeIn.setDate(check.SurveyInstanceAnswerTimeIn, true, "H:i");
      if (this.fpTimeOut && !_.isEmpty(this.fpTimeOut)) this.fpTimeOut.setDate(check.SurveyInstanceAnswerTimeOut, true, "H:i");
    },
    "generalSettingsData.SurveyInstanceWaveGuid": function generalSettingsDataSurveyInstanceWaveGuid() {
      this.getScenariosOfWave();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      var _this16 = this;

      this.languageStringsReceived = false;
      this.globals.getLanguageStrings(this, function () {
        _this16.languageStringsReceived = true;
      });
    }
  },
  props: ["dataLists", "selectedChecks", "selectedCheckIds", "selectedClient", "selectedProject", "includeChecks", "showDialog", "projectSelected"],
  data: function data() {
    // Global data inside the component is stored here
    return {
      checkData: {}, // The check data of the selected check is stored here
      generalSettingsData: {
        SurveyInstanceCustomReportingDate: "",
        SurveyInstanceExternalInterface: 0,
        SurveyInstanceExternalCustom: 0,
        SurveyInstanceQueryTool: 0,
        SurveyInstanceDashboard: 0,
        SurveyInstanceCheckExplorer: 0,
        SurveyInstanceAggregatedReport: 0,
        SurveyInstanceRawDataExports: 0,
        SurveyInstanceFrequencies: 0,
        SurveyInstanceMediaExplorer: 0,
        SurveyInstanceLocationGuid: "",
        SurveyInstanceScenarioGuid: "",
        SurveyInstanceWaveGuid: "",
        SurveyInstanceAssignedShopperGuid: "",
        SurveyInstanceAssignedLocalAgencyGuid: "",
        SurveyInstanceInfo: ""
      },
      surveyInstanceDescriptionMixed: false,
      surveyInstanceInfoMixed: false,
      specificSettingsData: {
        selectedCheck: {},
        dataList: []
      },
      shopperFilter: {},
      shopperFilterDataDirty: false,
      scenarioList: [],
      wavesOfProject: [],
      scenariosOfWave: [],
      locationsOfSelectedClient: [],
      briefingAttachments: [],
      surveyAttachments: [],
      previousLocationGuid: "",
      fpCustomReportingDate: null,
      fpDateOfVisit: null,
      fpTimeIn: null,
      fpTimeOut: null,
      fpBegin: null,
      fpEnd: null,
      languageStringsReceived: false,
      lang: {
        CM1000: "Edit Checks",
        CM1001: "General Settings",
        CM1002: "PDF sent by Mail",
        CM1003: "External Interface",
        CM1004: "External Custom",
        CM1005: "Query Tool",
        CM1006: "Dashboard",
        CM1007: "Check Explorer",
        CM1008: "Aggregated Report",
        CM1009: "Raw Data Exports",
        CM1010: "Frequencies",
        CM1011: "Media Explorer",
        CM1012: "Type of Mail",
        CM1013: "Custom Reporting Date",
        CM1014: "Scenario",
        CM1015: "User",
        CM1016: "Agency",
        CM1017: "Check Specific Settings",
        CM1018: "Selected Checks",
        CM1019: "Date of Visit",
        CM1020: "Time In",
        CM1021: "Time Out",
        CM1022: "Memo Shopper",
        CM1023: "Memo Agency",
        CM1024: "Memo MSM",
        CM1025: "Cancel",
        CM1026: "Save",
        CM1027: "Check Description",
        CM1028: "Wave",
        CM1029: "Location",
        CM1030: "Location changed",
        CM1031: "Yes",
        CM1032: "No",
        CM1033: "ATTENTION: Changing the location may impact filters inside the check. Do you really want to change the location?",
        CM1034: "Briefing",
        CM1035: "Survey",
        CM1036: "Check type",
        CM1037: "Free offer",
        CM1038: "Manual assignment",
        CM1039: "Agency",
        CM1040: "Begin",
        CM1041: "End",
        CM1042: "Online",
        CM1043: "Location free",
        CM1044: "Edit offer description",
        CM1045: "Check property access failed",
        CM1046: "No agency selected",
        CM1047: "No user selected",
        CM1048: "Check property update successful",
        CM1049: "Check property update failed",
        CM1050: "Attachment data access failed",
        CM1051: "Offer description",
        CM1052: "Internal note",
        CM1053: "Shopper filter",
        CM1054: "Shopper filter request failed",
        CM1055: "Shopper filter update failed",
        CM1056: "Check Info",
        CM1057: "Difficulty",
        CM1058: "simple",
        CM1059: "difficult",
        CM1060: "End date before start date",
        CM1061: "Inherit from survey",
        CM1062: "Combined filters",
        CM1063: "OK",
        CM1064: "Due to the selection of multiple checks there are lots of possible filter combinations that could not be represented in this view. In this case an empty filter appears.",
        CM1065: "Nevertheless it‘s possible to define a new filter for all selected checks. Already existing filters will be overwritten.",
        CM1066: "Lead agency",
        CM1067: "Local agency",
        CM1068: "Shopper",
        CM1069: "Age",
        CM1070: "Gender",
        CM1071: "Car",
        CM1072: "Target segment",
        CM1073: "Target model"
      }
    };
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "CheckManagementFilterModal",
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    check: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      headers: ["SID", "CheckID", "CheckCode", "Status", "Project", "Wave", "Scenario", "CheckInfo", "StoreID", "LocationName", "Address", "Country", "Visit", "Internalnote", "ExpiryDate", "Agency", "Shopper", "Score", "Progress", "Modifiedat"],
      items: [],
      languageStringsReceived: false,
      langShort: {},
      lang: {
        // Contains localization strings for the selected language
        CM0015: "SID",
        CM0016: "Check ID",
        CM0017: "Survey Code",
        CM0018: "Status",
        CM0019: "Project",
        CM0020: "Wave",
        CM0021: "Scenario",
        CM0073: "Check Info",
        CM0050: "StoreID",
        CM0051: "Location Name",
        CM0022: "Address",
        CM0023: "Country",
        CM0024: "Visit",
        CM0027: "Internal note",
        CM0028: "Expiry Date",
        CM0065: "Agency",
        CM0079: "Shopper",
        CM0030: "Score",
        CM0031: "Progress",
        CM0047: "Modified At",
        CM1026: "Save",
        CM1074: "Custom settings"
      }
    };
  },

  watch: {
    showModal: function showModal() {
      if (this.showModal) {
        this.getCustomSettingsList();
        this.getLanguageShort();
        this.openModal();
      } else {
        this.closeModal();
      }
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      var _this = this;

      this.languageStringsReceived = false;
      this.globals.getLanguageStrings(this, function () {
        _this.languageStringsReceived = true;
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.globals.selectedLanguage) {
      this.languageStringsReceived = false;
      this.globals.getLanguageStrings(this, function () {
        _this2.languageStringsReceived = true;
      });
    }
    this.getLanguageShort();
    $("#checkManagementFilterModal").on("hide.bs.modal", function (e) {
      return _this2.$emit("closeModal");
    });
  },

  methods: {
    openModal: function openModal() {
      this.$nextTick(function () {
        $("#checkManagementFilterModal").modal("show");
      });
    },
    closeModal: function closeModal() {
      $("#checkManagementFilterModal").modal("hide");
    },
    getLanguageShort: function getLanguageShort() {
      this.langShort = Object.fromEntries(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(this.lang).filter(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 1),
            key = _ref2[0];

        return key.includes("CM0");
      }));
    },
    getCustomSettingsList: function getCustomSettingsList() {
      var _this3 = this;

      $.ajax({
        method: "GET",
        url: "api/Data/CustomSettings",
        success: function success(data) {
          _this3.items = data;
        },
        error: function error() {
          console.error("Custom settings data access failed in getCustomSettingsList()");
          _this3.globals.showErrorSnackbar("Custom settings data access failed");
        }
      });
    },
    saveCustomSettingsList: function saveCustomSettingsList() {
      var _this4 = this;

      console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.items));
      $.ajax({
        method: "PUT",
        url: "api/SurveyInstances/Properties/CustomSettings",
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.items),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this4.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this4.globals.showSuccessSnackbar("Custom Settings saved!");
          _this4.closeModal();
        },
        error: function error() {
          console.error("Error on POST in saveCustomSettingsList()");
          _this4.globals.showErrorSnackbar("Custom Settings not saved!");
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "CheckPaymentModal",
  components: {},
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#checkPaymentModal").on("hidden.bs.modal", function (e) {
      _this.$emit("modalClosed");
    });

    $("#collapseCheckPaymentSpecific").on("show.bs.collapse", function () {
      $("#checkPaymentModal .modal-dialog").css("width", "1200px");
    });
    $("#collapseCheckPaymentSpecific").on("hide.bs.collapse", function () {
      $("#checkPaymentModal .modal-dialog").css("width", "");
    });
    $("#collapseCheckPaymentGeneral").on("show.bs.collapse", function () {
      _this.calcGeneralPaymentData();
    });
  },

  methods: {
    openModal: function openModal() {
      var _this2 = this;

      this.selectedCheck = {};
      this.checkDataList = [];
      this.generalSettlementData = {
        BasePaymentSum: 0,
        PlusPaymentSum: 0,
        MinusPaymentSum: 0,
        PurchaseMoneySum: 0,
        TotalPaymentSum: 0
      };
      var success = function success() {
        $("#checkPaymentModal").modal("show");
      };
      var error = function error() {
        _this2.$emit("modalClosed");
      };
      this.getPaymentData(success, error);
    },
    closeModal: function closeModal() {
      $("#checkPaymentModal").modal("hide");
    },
    openEditVATModal: function openEditVATModal() {
      this.globals.$emit("openEditVatRatesModal");
    },
    getPaymentData: function getPaymentData(_success, _error) {
      var _this3 = this;

      var query = "api/SurveyInstances/Properties/Settlement";

      $.ajax({
        method: "POST",
        url: query,
        data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.surveyInstanceGuids),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (!data || _.isEmpty(data)) {
            console.error("Unexpected server response in getPaymentData()");
            if (_error) _error();
            return;
          }
          if (data.Error) {
            console.error(data.Error);
            _this3.globals.showErrorSnackbar(data.Error);
            if (_error) _error();
            return;
          }
          _this3.checkDataList = data;
          _this3.paymentFormDirty = false;

          if (!_this3.globals.isPaymentsEditingAllowed) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this3.checkDataList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var _check = _step.value;

                _check.EnableEditPayments = false;
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          }if (!_this3.selectedCheck.SurveyInstanceGuid) _this3.selectedCheck = _this3.checkDataList[0];else {
            _this3.selectedCheck = _.find(_this3.checkDataList, function (c) {
              return c.SurveyInstanceGuid === _this3.selectedCheck.SurveyInstanceGuid;
            });
          }
          _this3.calcGeneralPaymentData();
          if (_success) _success();
        },
        error: function error(err) {
          console.error("Error on POST in getPaymentData()");
          _this3.globals.showErrorSnackbar(_this3.lang.CPM026);
          if (_error) _error();
        }
      });
    },
    savePaymentData: function savePaymentData() {
      var _this4 = this;

      if (this.hasNegativePayout()) {
        this.globals.showErrorSnackbar(this.lang.CPM030);
        console.error("At least one check has a negative payout value");
        return;
      }

      var query = "api/SurveyInstances/Properties/Settlement";

      $.ajax({
        method: "PUT",
        url: query,
        data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.checkDataList),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (!data) return;
          if (data.Error) {
            console.error(data.Error);
            _this4.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this4.globals.showSuccessSnackbar(_this4.lang.CPM027);
          _this4.getPaymentData();
        },
        error: function error(_error2) {
          console.error("Error on PUT in savePaymentData()");
          _this4.globals.showErrorSnackbar(_this4.lang.CPM028);
        }
      });
    },
    hasNegativePayout: function hasNegativePayout() {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.checkDataList), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var check = _step2.value;

          if (check.Payout < 0) return true;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return false;
    },
    calcGeneralTotalPayment: function calcGeneralTotalPayment() {
      this.generalSettlementData.TotalPayment = 0;
      if (this.generalSettlementData.BasePayment) this.generalSettlementData.TotalPayment += this.generalSettlementData.BasePayment;
      if (this.generalSettlementData.PlusPayment) this.generalSettlementData.TotalPayment += this.generalSettlementData.PlusPayment;
      if (this.generalSettlementData.MinusPayment) this.generalSettlementData.TotalPayment -= this.generalSettlementData.MinusPayment;
    },
    calcSpecificTotalPayment: function calcSpecificTotalPayment() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.selectedCheck;

      check.TotalPayment = 0;
      if (check.BasePayment) check.TotalPayment += check.BasePayment;
      if (check.PlusPayment) check.TotalPayment += check.PlusPayment;
      if (check.MinusPayment) check.TotalPayment -= check.MinusPayment;
      check.Payout = check.TotalPayment;
      if (check.PurchaseMoney) check.Payout += check.PurchaseMoney;
      this.$forceUpdate();
    },
    calcGeneralPaymentData: function calcGeneralPaymentData() {
      this.generalSettlementData.BasePaymentSum = 0;
      this.generalSettlementData.PlusPaymentSum = 0;
      this.generalSettlementData.MinusPaymentSum = 0;
      this.generalSettlementData.PurchaseMoneySum = 0;
      this.generalSettlementData.TotalPaymentSum = 0;
      this.generalSettlementData.PayoutApproved = !!this.checkDataList[0].PayoutApproved;
      this.generalSettlementData.EnableEditPayments = true;

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.checkDataList), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var check = _step3.value;

          this.calcSpecificTotalPayment(check);
          if (check.BasePayment) this.generalSettlementData.BasePaymentSum += check.BasePayment;
          if (check.PlusPayment) this.generalSettlementData.PlusPaymentSum += check.PlusPayment;
          if (check.MinusPayment) this.generalSettlementData.MinusPaymentSum += check.MinusPayment;
          if (check.PurchaseMoney) this.generalSettlementData.PurchaseMoneySum += check.PurchaseMoney;
          if (check.TotalPayment) this.generalSettlementData.TotalPaymentSum += check.TotalPayment;

          if (check.PayoutApproved !== this.generalSettlementData.PayoutApproved) this.generalSettlementData.PayoutApproved = "mixed";

          this.generalSettlementData.EnableEditPayments = this.generalSettlementData.EnableEditPayments && !!check.EnableEditPayments;
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    },
    writeToAllChecks: function writeToAllChecks(prop) {
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.checkDataList), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var check = _step4.value;

          check[prop] = this.generalSettlementData[prop];
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      this.calcGeneralPaymentData();
    },
    togglePayoutApprovedForAll: function togglePayoutApprovedForAll() {
      var idx = _.findIndex(this.checkDataList, function (c) {
        return !c.EnablePayoutApprovedChange;
      });
      if (idx > -1) {
        this.globals.showErrorSnackbar(this.lang.CPM029);
        console.error("At least one check is not allowed to change payout approval state");
        return;
      }
      this.generalSettlementData.PayoutApproved = !this.generalSettlementData.PayoutApproved;
      this.writeToAllChecks("PayoutApproved");
      this.$forceUpdate();
    },
    showDialogData: function showDialogData() {
      this.generalSettlementData.BasePayment = this.showNumberData(this.generalSettlementData.BasePayment);
      this.generalSettlementData.PlusPayment = this.showNumberData(this.generalSettlementData.PlusPayment);
      this.generalSettlementData.MinusPayment = this.showNumberData(this.generalSettlementData.MinusPayment);
      this.generalSettlementData.TotalPayment = this.showNumberData(this.generalSettlementData.TotalPayment);
    },
    showNumberData: function showNumberData(field) {
      return field ? field !== -1 ? field : null : 0;
    }
  },
  watch: {
    showModal: function showModal(newVal) {
      if (newVal) this.openModal();else this.closeModal();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  props: ["surveyInstanceGuids", "showModal"],
  data: function data() {
    return {
      checkDataList: [],
      selectedCheck: {},
      paymentFormDirty: false,
      generalSettlementData: {
        BasePaymentSum: 0,
        PlusPaymentSum: 0,
        MinusPaymentSum: 0,
        PurchaseMoneySum: 0,
        TotalPaymentSum: 0
      },
      lang: {
        CPM000: "Payments",
        CPM001: "All Checks",
        CPM002: "ATTENTION: Changing these values will update all selected checks!",
        CPM003: "Invoice release",
        CPM004: "Payment",
        CPM005: "Addition",
        CPM006: "Deduction",
        CPM007: "Total",
        CPM008: "Others",
        CPM009: "Comment",
        CPM010: "Individual Processing",
        CPM011: "Checks",
        CPM012: "Project",
        CPM013: "Wave",
        CPM014: "Scenario",
        CPM015: "Shopper",
        CPM016: "VAT Mandatory",
        CPM017: "Payout",
        CPM018: "Invoice",
        CPM019: "Remove release",
        CPM020: "Release invoice",
        CPM021: "Release submitted at",
        CPM022: "Release will be submitted after saving.",
        CPM023: "Close",
        CPM024: "Save",
        CPM025: "Tax rates",
        CPM026: "Payment data access failed",
        CPM027: "Payment data updated",
        CPM028: "Payment data update failed",
        CPM029: "At least one check is not allowed to change payout approval state",
        CPM030: "Negative payout"
      }
    };
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "SettlementDownloadModal",
  props: {
    showModal: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      settlementNumber: "",
      lang: {
        SDM000: "Download Invoice List",
        SDM001: "Invoice Number",
        SDM002: "Create new invoice list",
        SDM003: "Cancel",
        SDM004: "Download",
        SDM005: "Invoice list export failed",
        SDM006: "Invoice list created",
        SDM007: "Invoice list creation failed",
        SDM008: "Invalid invoice number"
      }
    };
  },

  watch: {
    showModal: function showModal() {
      if (this.showModal) {
        this.openModal();
      } else {
        this.closeModal();
      }
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
    $("#settlementDownloadModal").on("hide.bs.modal", function (e) {
      return _this.$emit("closeModal");
    });
    $("#settlementDownloadModal").on("hidden.bs.modal", function (e) {
      _this.$emit("modalClosed");
    });
  },

  methods: {
    openModal: function openModal() {
      this.settlementNumber = "";
      this.$nextTick(function () {
        $("#settlementDownloadModal").modal("show");
      });
    },
    closeModal: function closeModal() {
      $("#settlementDownloadModal").modal("hide");
    },
    downloadSettlementList: function downloadSettlementList() {
      var _this2 = this;

      this.settlementNumber = this.settlementNumber.replace(" ", "").replace("\n", "");
      if (this.settlementNumber.length !== 8 || !this.settlementNumber.match(/^[0-9]+$/)) {
        console.error("Invalid SettlementNumber:", this.settlementNumber);
        this.globals.showErrorSnackbar(this.lang.SDM008);
        return;
      }

      var queryString = "api/Settlement/SettlementNumber/" + this.settlementNumber + "/Export";
      $.ajax({
        method: "GET",
        url: queryString,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (!data || !data[0] || !data[0].DownloadId) {
            console.error("Missing DownloadId");
            _this2.globals.showErrorSnackbar(_this2.lang.SDM005);
            return;
          }
          _this2.globals.downloadFile(data[0].DownloadId);
          _this2.$emit("closeModal");
        },
        error: function error() {
          console.error("Error on POST in downloadSettlementList()");
          _this2.globals.showErrorSnackbar(_this2.lang.SDM005);
        }
      });
    },
    createNewSettlementList: function createNewSettlementList() {
      var _this3 = this;

      var queryString = "api/Settlement";

      $.ajax({
        method: "POST",
        url: queryString,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this3.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this3.settlementNumber = data.SettlementNumber;
          _this3.globals.showSuccessSnackbar(_this3.lang.SDM006);
        },
        error: function error() {
          console.error("Error on POST in createNewSettlementList()");
          _this3.globals.showErrorSnackbar(_this3.lang.SDM007);
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Recruiting_ShopperFilter__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Recruiting_ShopperFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Recruiting_ShopperFilter__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ShopperFilterModal",
  components: {
    ShopperFilter: __WEBPACK_IMPORTED_MODULE_0__Recruiting_ShopperFilter___default.a
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    selectedClient: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      filterObject: {},
      countryList: [],
      locationPropertiesList: [],
      copyData: {},
      lang: {
        CSM000: "Shopper Filter",
        CSM001: "Close",
        CSM002: "Location property data request failed",
        CSM003: "Please set client filter first",
        CSM004: "Copy filter",
        CSM005: "Paste filter"
      }
    };
  },

  watch: {
    showModal: function showModal(newValue) {
      newValue ? this.openModal() : this.closeModal();
    },
    selectedClient: function selectedClient() {
      this.locationPropertiesList = [];
      if (this.filterObject.NotWithLocationPropertyGuids) delete this.filterObject.NotWithLocationPropertyGuids;
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
      this.globals.getCountryList(this.convertCountryList);
    }
  },
  created: function created() {
    this.globals.getCountryList(this.convertCountryList);
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
    $("#shopperFilterModal").on("hidden.bs.modal", function (e) {
      _this.$refs.shopperFilterComponent.collectFilterData();
      _this.globals.$emit("getDataFromShopperFilterModal", _this.filterObject);
      _this.$emit("modalClosed");
    });

    this.globals.$off("sendDataToShopperFilterModal");
    this.globals.$on("sendDataToShopperFilterModal", function (data) {
      _this.filterObject = data ? _.cloneDeep(data) : {};
      _this.$nextTick(function () {
        _this.$refs.shopperFilterComponent.restoreFilterSettings();
      });
    });
  },

  methods: {
    openModal: function openModal() {
      if (!this.selectedClient) {
        console.error("No client selected");
        this.globals.showErrorSnackbar(this.lang.CSM003);
        this.$emit("modalClosed");
        return;
      }
      this.getLocationProperties();
      $("#shopperFilterModal").modal("show");
    },
    closeModal: function closeModal() {
      $("#shopperFilterModal").modal("hide");
    },
    copyFilter: function copyFilter() {
      this.$refs.shopperFilterComponent.collectFilterData();
      this.copyData = {
        filterObject: _.cloneDeep(this.filterObject),
        client: this.selectedClient
      };
    },
    restoreFilter: function restoreFilter() {
      var _this2 = this;

      if (!this.copyData.client || this.copyData.client !== this.selectedClient || !this.copyData.filterObject) return;
      this.filterObject = this.copyData.filterObject;
      this.$nextTick(function () {
        _this2.$refs.shopperFilterComponent.restoreFilterSettings();
      });
    },
    convertCountryList: function convertCountryList(data) {
      this.countryList = [];
      for (var country in data) {
        this.countryList.push({
          CountryCode: country,
          CountryName: data[country]
        });
      }
    },
    getLocationProperties: function getLocationProperties() {
      var _this3 = this;

      if (this.locationPropertiesList.length > 0) return;

      var query = "api/Recruiting/Data/LocationProperties/" + this.selectedClient;
      $.ajax({
        method: "GET",
        url: query,
        success: function success(data) {
          _this3.locationPropertiesList = data;
        },
        error: function error() {
          console.error("Error on GET in getLocationProperties()");
          _this3.globals.showErrorSnackbar(_this3.lang.CSM002);
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SurveyManagement_SurveyManagementEditModal__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SurveyManagement_SurveyManagementEditModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SurveyManagement_SurveyManagementEditModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Tools_Dialogs_ConfirmationDialog__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Tools_Dialogs_ConfirmationDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Tools_Dialogs_ConfirmationDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ImporterManagement__ = __webpack_require__(1569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ImporterManagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ImporterManagement__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ClientManagement",
  mounted: function mounted() {
    this.readComponentSettingsFromStore();
    // Gets executed right after rendering the component
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this, this.setClientTableHeight);
    this.getClientData();
    this.getEditClientDialogSelectData();

    // Sets the new table height after the window got resized
    $(window).on("resize", this.setClientTableHeight).resize();

    if (!this.globals.currentUserInfo) this.globals.$once("currentUserInfoReceived", this.setClientTableHeight);
  },
  destroyed: function destroyed() {
    if (this.fpInputSince) this.fpInputSince.destroy();
    $(window).off("resize", this.setClientTableHeight);
    this.writeComponentSettingsToStore();
  },

  computed: {
    nameOfSelectedClient: function nameOfSelectedClient() {
      var _this = this;

      if (this.clientList.length < 1) return "";
      var currentClient = _.find(this.clientList, function (c) {
        return c.ClientId == _this.selectedClient;
      });
      if (currentClient && currentClient.ClientName) return currentClient.ClientName;
      return "";
    }
  },
  methods: {
    setClientTableHeight: function setClientTableHeight() {
      this.$nextTick(function () {
        var height = $(window).height();
        height -= $("#clients-top-panel").height() + $("#app-navbar").height() + $(".main-table > thead").height() + 47; // 47 pixel for the free space around the cards
        $(".main-table-scrollbar").css("max-height", height);
      });
    },
    readComponentSettingsFromStore: function readComponentSettingsFromStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      var storedData = this.$store.getters["localFilters/clientManagement"];
      if (storedData) {
        for (var key in storedData) {
          if (_.has(this, key)) this[key] = _.cloneDeep(storedData[key]);
        }
      }

      if (!this.$store.getters["userSettings/syncFilters"]) return;
      if (!this.feature.isAudiTarget || !this.feature.isEnabled("audi_importers")) {
        var storedClient = this.$store.getters["sharedFilters/client"];
        if (storedClient.ClientName) {
          this.searchString = this.globals.removeWildcardsFromString(storedClient.ClientName);
        } else this.searchString = "";
      }
    },
    writeComponentSettingsToStore: function writeComponentSettingsToStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      this.$store.commit("localFilters/clientManagement", {
        searchString: this.searchString,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        pageSize: this.pageSize
      });

      if (!this.$store.getters["userSettings/syncFilters"]) return;
      if (!this.feature.isAudiTarget || !this.feature.isEnabled("audi_importers")) {
        var storedClient = this.$store.getters["sharedFilters/client"];
        if (this.globals.removeWildcardsFromString(storedClient.ClientName) !== this.searchString) {
          this.$store.commit("sharedFilters/client", {
            ClientName: this.globals.addWildcardsToString(this.searchString)
          });
        }
      }
    },
    correctTextareaHeight: function correctTextareaHeight() {
      this.$nextTick(function () {
        var textareas = document.getElementsByClassName("autoExpand");
        for (var i = 0; i < textareas.length; i++) {
          $(textareas[i]).trigger("input");
        }
      });
    },

    // Validates an input with the given id, changes the input color depending on the validation result and returns the result
    validateInput: function validateInput(id) {
      var result = $("#" + id)[0].checkValidity(); // Checks validation depending on the input type or a given pattern in the template
      if (result) {
        $("#" + id).parent().parent().removeClass("has-error"); // has-error has to be added to the form-group element
        var idx = this.invalidInputIds.indexOf(id);
        if (idx > -1) {
          this.invalidInputIds.splice(idx, 1); // Remove from list, if valid
        }
      } else {
        $("#" + id).parent().parent().addClass("has-error");
        if (this.invalidInputIds.indexOf(id) < 0) this.invalidInputIds.push(id); // Add to list, if invalid
      }
      return result;
    },


    // Returns true if an input has a validation error, otherwise false
    inputHasError: function inputHasError(id) {
      if (this.invalidInputIds.indexOf(id) > -1) return true;
      return false;
    },


    // Triggers input validation and ensures further progress if validation was successful
    validateBeforeSubmit: function validateBeforeSubmit(dialogId) {
      var result = true;

      var elements = $("#" + dialogId).find(":input"); // Returns a list of all inputs on the dialog
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0) result = this.validateInput(elements[i].id) && result; // If only one input is invalid, the whole form is invalid
      }

      if (dialogId == "editClient") {
        this.editClientDialogData.showAlert = !result;
        if (!result) return;
        this.saveEditClientDialogData();
      }
    },


    // Resets all validation errors for the given dialog
    resetValidationErrors: function resetValidationErrors(dialogId) {
      var elements = $("#" + dialogId).find(":input"); // Returns a list of all inputs on the dialog
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0) $("#" + elements[i].id).parent().parent().removeClass("has-error");
      }
      this.invalidInputIds = [];
    },


    // Gets executed after the editSurveyDialog got closed
    onEditSurveyDialogClosed: function onEditSurveyDialogClosed() {
      this.showEditSurveyDialog = false;
    },


    // Gets executed after the editSurveyDialog successfully saved some data
    onEditSurveyDialogDataSaved: function onEditSurveyDialogDataSaved(savedSurvey) {
      var _this2 = this;

      if (!this.editSurveyDialogModeAdd) {
        var changedSurvey = this.editClientDialogData.clientData.Surveys.filter(function (e) {
          return e.SurveyId == _this2.editClientDialogData.selectedSurvey;
        });
        changedSurvey[0].SurveyTitle = savedSurvey.SurveyTitle;
      }
    },


    // Returns the title of the selected survey
    getSelectedSurveyTitle: function getSelectedSurveyTitle() {
      var _this3 = this;

      if (!this.editClientDialogData.clientData.Surveys) return "";
      var currentSurvey = this.editClientDialogData.clientData.Surveys.filter(function (s) {
        return s.SurveyId == _this3.editClientDialogData.selectedSurvey;
      });
      if (currentSurvey.length < 1) return "";
      return currentSurvey[0].SurveyTitle;
    },


    // Sends a delete request for the selected survey to the server
    deleteSurvey: function deleteSurvey() {
      var _this4 = this;

      $.ajax({
        method: "DELETE",
        url: "api/Surveys/" + this.editClientDialogData.selectedSurvey,
        success: function success(data) {
          if (data.Error) {
            _this4.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this4.globals.showSuccessSnackbar("Survey deletion successful");
          // If DELETE was successful, remove survey from survey list
          _this4.editClientDialogData.clientData.Surveys = _this4.editClientDialogData.clientData.Surveys.filter(function (e) {
            return e.SurveyId != _this4.editClientDialogData.selectedSurvey;
          });
          _this4.editClientDialogData.selectedSurvey = -1;
          _this4.showDeleteSurveyModal = false;
        },
        error: function error() {
          console.error("Error on DELETE in deleteSurvey()");
          _this4.globals.showErrorSnackbar("Survey deletion failed");
        }
      });
    },


    // Redirects to the survey editor component in a new tab to edit the survey with the given ID
    redirectToSurveyEditor: function redirectToSurveyEditor(surveyId) {
      var _this5 = this;

      $.ajax({
        method: "PATCH",
        url: "api/Surveys/" + surveyId + "/Lock",
        data: '{ "Lock": true }',
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) _this5.globals.showErrorSnackbar(data.Error);else {
            $("#editClient").modal("hide");
            _this5.$router.push({
              path: "surveyeditor",
              query: { id: surveyId }
            });
          }
        },
        error: function error() {
          console.error("Error on PUT in redirectToSurveyEditor()");
          _this5.globals.showErrorSnackbar("Survey lock failed");
        }
      });
    },


    // Adds a new custom property to client data
    addNewCustomProperty: function addNewCustomProperty() {
      if (this.editClientDialogData.newCustomProperty != "") {
        if (!("CustomProperties" in this.editClientDialogData.clientData)) this.editClientDialogData.clientData.CustomProperties = [];

        var newProp = {
          ID: "",
          Name: this.editClientDialogData.newCustomProperty,
          Visibility: 0,
          Position: this.editClientDialogData.clientData.CustomProperties.length + 1
        };
        this.editClientDialogData.clientData.CustomProperties.push(newProp);
        this.editClientDialogData.newCustomProperty = "";
        this.correctTextareaHeight();
      }
    },


    // Shows a security dialog to ask the user if a custom property should really be deleted
    openRemoveCustomPropertyDialog: function openRemoveCustomPropertyDialog(propId) {
      this.removeCustomPropertySecurityDialogData.propId = propId;
      this.removeCustomPropertySecurityDialogData.propName = this.editClientDialogData.clientData.CustomProperties.filter(function (prop) {
        return prop.Id == propId;
      })[0].Name;
      $("#removeCustomPropertySecurityDialog").modal("show");
    },


    // Removes the custom property with the given ID from the client data
    removeCustomProperty: function removeCustomProperty(propId) {
      var position = this.editClientDialogData.clientData.CustomProperties.filter(function (prop) {
        return prop.Id == propId;
      })[0].Position;

      this.editClientDialogData.clientData.CustomProperties = this.editClientDialogData.clientData.CustomProperties.filter(function (prop) {
        return prop.Id != propId;
      });

      var prop;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.editClientDialogData.clientData.CustomProperties), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          prop = _step.value;

          if (prop.Position > position) prop.Position--;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      $("#removeCustomPropertySecurityDialog").modal("hide");
      this.$forceUpdate();
      this.correctTextareaHeight();
    },


    // Reorders custom properties after the position of a property changed
    reorderCustomProperties: function reorderCustomProperties() {
      var allPositions = this.getRange(1, this.editClientDialogData.clientData.CustomProperties.length, 1);
      var missingPos = 0;
      var newPos = 0;
      var propName = "";

      // Find missing position number and the position and name of the changed property
      for (var i = 0; i < allPositions.length; i++) {
        if (this.editClientDialogData.clientData.CustomProperties[i].Position != allPositions[i]) {
          missingPos = allPositions[i];
          newPos = this.editClientDialogData.clientData.CustomProperties[i].Position;
          propName = this.editClientDialogData.clientData.CustomProperties[i].Name;
        }
      }
      if (missingPos == 0) return; // No position missing -> no value changed

      // Move position numbers between new position number and missing position number
      for (var i = 0; i < allPositions.length; i++) {
        if (this.editClientDialogData.clientData.CustomProperties[i].Name != propName) {
          // Do NOT move the changed property
          if (this.editClientDialogData.clientData.CustomProperties[i].Position < missingPos && this.editClientDialogData.clientData.CustomProperties[i].Position >= newPos) {
            this.editClientDialogData.clientData.CustomProperties[i].Position++;
          }
          if (this.editClientDialogData.clientData.CustomProperties[i].Position > missingPos && this.editClientDialogData.clientData.CustomProperties[i].Position <= newPos) {
            this.editClientDialogData.clientData.CustomProperties[i].Position--;
          }
        }
      }
      this.sortCustomPropertiesByPosition();
      this.$forceUpdate(); // Forces the table to update
    },


    // Sorts the available custom properties by their position number
    sortCustomPropertiesByPosition: function sortCustomPropertiesByPosition() {
      if (typeof this.editClientDialogData.clientData.CustomProperties == "undefined") return;
      this.editClientDialogData.clientData.CustomProperties.sort(function (a, b) {
        return a.Position - b.Position;
      });
      this.correctTextareaHeight();
    },
    isCustomPropertyRemovable: function isCustomPropertyRemovable(prop) {
      if (prop.LocationPropertyGuid === "F65898B5-4D53-4E4E-959A-06D128D9F7FE" || prop.LocationPropertyGuid === "B820479A-0F40-4584-9C76-8553AD91276D") return false;
      return true;
    },


    // Refreshes the region list in the dropdown of the editClient dialog depending on the selected country
    changedCountry: function changedCountry(country, section) {
      var regionObj = [{ Regions: [] }];
      var tzObj = [{ TimeZones: [] }];

      if (typeof this.regionList != "undefined") {
        if (typeof country != "undefined" && country != "" && country != "  ") {
          regionObj = this.regionList.filter(function (region) {
            // Filter regions for the given country
            return region.Country.toLowerCase().indexOf(country.toLowerCase()) >= 0;
          });
        }
      }

      if (typeof this.timeZones != "undefined") {
        if (typeof country != "undefined" && country != "" && country != "  ") {
          tzObj = this.timeZones.filter(function (tz) {
            // Filter timezones for the given country
            return tz.Country.toLowerCase().indexOf(country.toLowerCase()) >= 0;
          });
        }
      }

      if (section == "general") {
        if (regionObj.length == 0) this.editClientDialogData.currentRegionsGeneral = [];else this.editClientDialogData.currentRegionsGeneral = regionObj[0].Regions;

        if (tzObj.length == 0) this.editClientDialogData.currentTimeZonesGeneral = [];else this.editClientDialogData.currentTimeZonesGeneral = tzObj[0].TimeZones;

        var idx = this.editClientDialogData.currentRegionsGeneral.map(function (e) {
          return e.Region;
        }).indexOf(this.editClientDialogData.clientData.ClientState_Region);

        if (idx < 0) delete this.editClientDialogData.clientData.ClientState_Region;

        idx = this.editClientDialogData.currentTimeZonesGeneral.map(function (e) {
          return e.TimeZoneId;
        }).indexOf(this.editClientDialogData.clientData.ClientTimeZoneId);

        if (idx < 0) delete this.editClientDialogData.clientData.ClientTimeZoneId;
      } else if (section == "billing") {
        if (regionObj.length == 0) this.editClientDialogData.currentRegionsBilling = [];else this.editClientDialogData.currentRegionsBilling = regionObj[0].Regions;

        var idx = this.editClientDialogData.currentRegionsBilling.map(function (e) {
          return e.Region;
        }).indexOf(this.editClientDialogData.clientData.ClientBillingState_Region);

        if (idx < 0) delete this.editClientDialogData.clientData.ClientBillingState_Region;
      }
    },


    // Opens the editClient dialog after dialog data received
    editClientDialogDataReceived: function editClientDialogDataReceived() {
      $("#editClient").modal("show");

      if ($("#collapseCustProp").attr("aria-expanded")) {
        $("#editClient").off("shown.bs.modal", this.correctTextareaHeight);
        $("#editClient").on("shown.bs.modal", this.correctTextareaHeight);
      }
      $("#collapseCustProp").off("shown.bs.collapse", this.correctTextareaHeight);
      $("#collapseCustProp").on("shown.bs.collapse", this.correctTextareaHeight);
    },


    // Fills the editClient dialog with data, depending on the dialog mode.
    // Available modes: "create" --> New client is created, default values are set
    //                  "edit" --> Edit existing client, catch values from server
    openEditClientDialog: function openEditClientDialog(mode) {
      var _this6 = this;

      this.fpInputSince = flatpickr("#inputSinceClientMgmtEdit", this.globals.flatpickrDateConfig);

      if (mode == "create") {
        this.editClientDialogData.dialogTitle = this.lang.C0088;
        this.editClientDialogData.dialogType = "create";
        delete this.editClientDialogData.clientData.ClientId;
        delete this.editClientDialogData.clientData.ClientName;
        delete this.editClientDialogData.clientData.ClientAddress;
        delete this.editClientDialogData.clientData.ClientAddress2;
        delete this.editClientDialogData.clientData.ClientCity;
        delete this.editClientDialogData.clientData.ClientState_Region;
        delete this.editClientDialogData.clientData.ClientPostalCode;
        delete this.editClientDialogData.clientData.ClientCountry;
        delete this.editClientDialogData.clientData.ClientSince;
        delete this.editClientDialogData.clientData.ClientContactFirstName;
        delete this.editClientDialogData.clientData.ClientContactLastName;
        delete this.editClientDialogData.clientData.ClientContactPhone;
        delete this.editClientDialogData.clientData.ClientContactFax;
        delete this.editClientDialogData.clientData.ClientContactEmail;
        delete this.editClientDialogData.clientData.ClientBillTo;
        delete this.editClientDialogData.clientData.ClientBillingAddress;
        delete this.editClientDialogData.clientData.ClientBillingAddress2;
        delete this.editClientDialogData.clientData.ClientBillingCity;
        delete this.editClientDialogData.clientData.ClientBillingState_Region;
        delete this.editClientDialogData.clientData.ClientBillingCountry;
        delete this.editClientDialogData.clientData.ClientBillingPostalCode;
        delete this.editClientDialogData.clientData.ClientBillToEmail;
        delete this.editClientDialogData.clientData.ClientBillingTerms;
        delete this.editClientDialogData.clientData.ClientTimeZoneId;
        delete this.editClientDialogData.clientData.ClientAdditionalInfo;
        delete this.editClientDialogData.clientData.ClientPageLogoURL;
        this.editClientDialogData.clientData.ClientStatusId = "A";
        this.editClientDialogData.clientData.Surveys = [];
        this.editClientDialogData.clientData.CustomProperties = [];

        this.changedCountry("", "general");
        this.changedCountry("", "billing");
        $("#editClient").modal("show");
        this.fpInputSince.clear();
      } else if (mode == "edit") {
        this.editClientDialogData.dialogTitle = this.lang.C0089;
        this.editClientDialogData.dialogType = "edit";
        this.editClientDialogData.clientData = {};

        $.ajax({
          method: "GET",
          url: "api/Clients/" + this.selectedClient,
          success: function success(data) {
            _this6.editClientDialogDataReceived();
            _this6.editClientDialogData.clientData = data; // Store response data from server
            _this6.changedCountry(_this6.editClientDialogData.clientData.ClientCountry, "general"); // Load region dropdown depending on the selected country
            _this6.changedCountry(_this6.editClientDialogData.clientData.ClientBillingCountry, "billing");
            _this6.sortCustomPropertiesByPosition();

            _this6.fpInputSince.setDate(_this6.editClientDialogData.clientData.ClientSince);
          },
          error: function error() {
            console.error("Client data access failed in openEditClientDialog()");
            _this6.globals.showErrorSnackbar("Client data access failed");
          }
        });
      } else {
        // Wrong mode
        console.error("Wrong client dialog mode in openEditClientDialog()");
        $("#editClient").modal("hide");
        return false;
      }
      this.editClientDialogData.selectedSurvey = -1;
      this.editClientDialogData.showAlert = false;
      this.resetValidationErrors("editClient");
      return true; // Mode was ok
    },


    // Catch client list
    getClientList: function getClientList() {
      var _this7 = this;

      $.ajax({
        method: "GET",
        url: "api/Data/Clients",
        success: function success(data) {
          _this7.clientList = [];
          for (var x in data) {
            _this7.clientList.push({
              ClientId: x,
              ClientName: data[x]
            });
          }

          _this7.clientList.sort(function (a, b) {
            // Sort clients by name
            if (a.ClientName.toLowerCase() < b.ClientName.toLowerCase()) return -1;
            if (a.ClientName.toLowerCase() > b.ClientName.toLowerCase()) return 1;
            return 0;
          });
        },
        error: function error() {
          console.error("Client data access failed in getClientList()");
          _this7.globals.showErrorSnackbar("Client data access failed");
        }
      });
    },


    // Catches data for dropdown lists from server
    getEditClientDialogSelectData: function getEditClientDialogSelectData() {
      var _this8 = this;

      if (this.globals.selectedLanguage) this.globals.getCountryList();
      this.globals.getRegionsList(function (callbackData) {
        _this8.regionList = callbackData;
      });
      this.getClientList();
      this.globals.getTimezonesList(function (callbackData) {
        _this8.timeZones = callbackData;
      });
      this.globals.getLanguageList(function (callbackData) {
        _this8.languageList = callbackData;
      });
      this.globals.getLocaleList(function (callbackData) {
        _this8.localesList = callbackData;
      });
    },


    // Sends the data from editClient dialog to the server to store it in the database
    saveEditClientDialogData: function saveEditClientDialogData() {
      var _this9 = this;

      if (this.editClientDialogData.dialogType == "create") {
        // Create new client
        $.ajax({
          method: "POST",
          url: "api/Clients",
          data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.editClientDialogData.clientData),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            // If POST was successful, hide dialog and add client to local clientlist
            $("#editClient").modal("hide");
            _this9.globals.showSuccessSnackbar("Client creation successful");
            var newClient = {
              ClientId: data[0].ClientId,
              ClientName: _this9.editClientDialogData.clientData.ClientName
            };
            // Insert into dropdown client data
            _this9.clientList.push(newClient);
            _this9.clientList.sort(function (a, b) {
              if (a.ClientName.toLowerCase() < b.ClientName.toLowerCase()) return -1;
              if (a.ClientName.toLowerCase() > b.ClientName.toLowerCase()) return 1;
              return 0;
            });

            newClient.ClientAddress = _this9.editClientDialogData.clientData.ClientAddress;
            newClient.ClientCity = _this9.editClientDialogData.clientData.ClientCity;
            newClient.ClientState_Region = _this9.editClientDialogData.clientData.ClientState_Region;
            newClient.ClientPostalCode = _this9.editClientDialogData.clientData.ClientPostalCode;
            newClient.ClientCountry = _this9.editClientDialogData.clientData.ClientCountry;

            // Insert into table data
            _this9.clientData.push(newClient);
            _this9.selectedClient = newClient.ClientId;
            _this9.filterClientData(); // Filter data to display new client at the right position of the table
          },
          error: function error() {
            console.error("Error on POST in saveEditClientDialogData()");
            _this9.globals.showErrorSnackbar("Client creation failed");
          }
        });
      } else if (this.editClientDialogData.dialogType == "edit") {
        // Update existing client
        $.ajax({
          method: "PUT",
          url: "api/Clients/" + this.editClientDialogData.clientData.ClientId,
          data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.editClientDialogData.clientData),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            // If PUT was successful, hide dialog and update client in the local clientlist
            $("#editClient").modal("hide");
            _this9.globals.showSuccessSnackbar("Client update successful");

            // Update table data
            var objIndex = _.findIndex(_this9.clientData, function (o) {
              return o.ClientId == _this9.editClientDialogData.clientData.ClientId;
            });
            _this9.clientData[objIndex].ClientName = _this9.editClientDialogData.clientData.ClientName;
            _this9.clientData[objIndex].ClientAddress = _this9.editClientDialogData.clientData.ClientAddress;
            _this9.clientData[objIndex].ClientCity = _this9.editClientDialogData.clientData.ClientCity;
            _this9.clientData[objIndex].ClientState_Region = _this9.editClientDialogData.clientData.ClientState_Region;
            _this9.clientData[objIndex].ClientPostalCode = _this9.editClientDialogData.clientData.ClientPostalCode;
            _this9.clientData[objIndex].ClientCountry = _this9.editClientDialogData.clientData.ClientCountry;

            // Update dropdown client data
            objIndex = _.findIndex(_this9.clientList, function (o) {
              return o.ClientId == _this9.editClientDialogData.clientData.ClientId;
            });
            _this9.clientList[objIndex].ClientName = _this9.editClientDialogData.clientData.ClientName;

            _this9.filterClientData(); // Filter data to display new client at the right position of the table
          },
          error: function error() {
            console.error("Error on PUT in saveEditClientDialogData()");
            _this9.globals.showErrorSnackbar("Client update failed");
          }
        });
      } else console.error("Wrong client dialog mode in saveEditClientDialogData()");
    },


    // Calculates the sort order for the given column and triggers the filter where the clientdata will be sorted
    sortClientData: function sortClientData(field) {
      if (field == this.sortField) {
        this.sortOrder == "asc" ? this.sortOrder = "desc" : this.sortOrder = "asc";
      } else {
        this.sortField = field;
        this.sortOrder = "asc";
      }
      this.selectedPage = 1;
      this.filterClientData();
    },


    // Catches client data for the table from the server
    getClientData: function getClientData() {
      var _this10 = this;

      this.refreshEnabled = false; // Disable refresh, so it can not be triggered again until the server responded

      $.ajax({
        url: "api/Clients",
        type: "GET",
        success: function success(data) {
          _this10.clientData = [];
          if (!_.isEmpty(data)) _this10.clientData = data;
          _this10.filterClientData();
        },
        error: function error() {
          console.error("Error on GET in getClientData()");
        },
        complete: function complete() {
          _this10.refreshEnabled = true; // Enable refresh of the client data after server response
        }
      });
    },


    // Updates the current pagesize and the selected pagenumber and triggers the reload of the page
    updatePaging: function updatePaging(pageNumber, pageSize) {
      this.selectedPage = pageNumber;
      if (pageSize != 0) this.pageSize = pageSize;
      this.loadCurrentPageOfClientData();
    },


    // Returns a range of numbers with min-value, max-value and stepsize
    getRange: function getRange(min, max, step) {
      var range = [],
          j = 0;
      for (var i = min; i <= max; i += step) {
        range[j++] = i;
      }
      return range;
    },


    // Returns a list of all pagenumbers that should be visible depending on the current page and the count of pages
    getVisiblePages: function getVisiblePages() {
      if (this.numberOfPages() <= 7) {
        return this.getRange(1, this.numberOfPages(), 1);
      } else if (this.numberOfPages() > 7 && this.selectedPage <= 4) {
        return this.getRange(1, 6, 1);
      } else if (this.numberOfPages() > 7 && this.selectedPage >= this.numberOfPages() - 3) {
        return this.getRange(this.numberOfPages() - 5, this.numberOfPages(), 1);
      } else {
        return this.getRange(this.selectedPage - 2, this.selectedPage + 2, 1);
      }
    },


    // Returns the count of pages depending on the selected pagesize and the length of the client data list
    numberOfPages: function numberOfPages() {
      if (this.pageSize == -1) return 1;
      if (this.filteredClientData.length % this.pageSize == 0) return this.filteredClientData.length / this.pageSize;else return parseInt(this.filteredClientData.length / this.pageSize) + 1;
    },


    // Selects the client data that has to be displayed on the selected page
    loadCurrentPageOfClientData: function loadCurrentPageOfClientData() {
      if (this.pageSize == -1) this.clientDataOnCurrentPage = this.filteredClientData;else {
        // Display all data, no pages
        this.clientDataOnCurrentPage = [];
        var startIndex = (this.selectedPage - 1) * this.pageSize;
        for (var i = startIndex; i < startIndex + this.pageSize; i++) {
          if (this.filteredClientData[i] != null) this.clientDataOnCurrentPage[i - startIndex] = this.filteredClientData[i];
        }
      }
    },


    // Filters the client data by every single word in the searchString, separated by a blank
    // and triggers the sorting and the reload of the selected page, so that the expected data is displayed on the table
    filterClientData: function filterClientData() {
      if (!this.searchString) this.filteredClientData = this.clientData;
      var words = [this.searchString]; //this.searchString.split(" ");

      var keys = ["ClientId", "ClientName", "ClientAddress", "ClientPostalCode", "ClientCity", "ClientState_Region", "ClientCountry"];

      var clientFilter = function clientFilter(client) {
        var containsSearch = false;
        words.forEach(function (word) {
          keys.forEach(function (key) {
            if (client[key] && client[key].toString().toLowerCase().indexOf(word.toLowerCase()) > -1) {
              containsSearch = true;
              return;
            }
          });
        });
        return containsSearch;
      };
      this.filteredClientData = !_.isEmpty(this.clientData) ? this.clientData.filter(clientFilter) : [];

      this.startSorting(this.filteredClientData); // Sort the filtered data
      this.loadCurrentPageOfClientData(); // Display selected page of filtered and sorted data
    },


    // Sorts the clientData depending on the selected column and sort order
    startSorting: function startSorting(clientData) {
      // Sort by ID
      if (this.sortField == "id") {
        if (this.sortOrder == "asc") clientData.sort(function (a, b) {
          return a.ClientId - b.ClientId;
        });else if (this.sortOrder == "desc") clientData.sort(function (b, a) {
          return a.ClientId - b.ClientId;
        });
      } else if (this.sortField == "name") {
        // Sort by name
        if (this.sortOrder == "asc") clientData.sort(function (a, b) {
          if (a.ClientName.toLowerCase() < b.ClientName.toLowerCase()) return -1;
          if (a.ClientName.toLowerCase() > b.ClientName.toLowerCase()) return 1;
          return 0;
        });else if (this.sortOrder == "desc") clientData.sort(function (b, a) {
          if (a.ClientName.toLowerCase() < b.ClientName.toLowerCase()) return -1;
          if (a.ClientName.toLowerCase() > b.ClientName.toLowerCase()) return 1;
          return 0;
        });
      } else if (this.sortField == "address") {
        // Sort by address
        if (this.sortOrder == "asc") clientData.sort(function (a, b) {
          if (a.ClientAddress.toLowerCase() < b.ClientAddress.toLowerCase()) return -1;
          if (a.ClientAddress.toLowerCase() > b.ClientAddress.toLowerCase()) return 1;
          return 0;
        });else if (this.sortOrder == "desc") clientData.sort(function (b, a) {
          if (a.ClientAddress.toLowerCase() < b.ClientAddress.toLowerCase()) return -1;
          if (a.ClientAddress.toLowerCase() > b.ClientAddress.toLowerCase()) return 1;
          return 0;
        });
      } else if (this.sortField == "city") {
        // Sort by city
        if (this.sortOrder == "asc") clientData.sort(function (a, b) {
          if (a.ClientCity.toLowerCase() < b.ClientCity.toLowerCase()) return -1;
          if (a.ClientCity.toLowerCase() > b.ClientCity.toLowerCase()) return 1;
          return 0;
        });else if (this.sortOrder == "desc") clientData.sort(function (b, a) {
          if (a.ClientCity.toLowerCase() < b.ClientCity.toLowerCase()) return -1;
          if (a.ClientCity.toLowerCase() > b.ClientCity.toLowerCase()) return 1;
          return 0;
        });
      } else if (this.sortField == "region") {
        // Sort by region
        if (this.sortOrder == "asc") clientData.sort(function (a, b) {
          if (a.ClientState_Region.toLowerCase() < b.ClientState_Region.toLowerCase()) return -1;
          if (a.ClientState_Region.toLowerCase() > b.ClientState_Region.toLowerCase()) return 1;
          return 0;
        });else if (this.sortOrder == "desc") clientData.sort(function (b, a) {
          if (a.ClientState_Region.toLowerCase() < b.ClientState_Region.toLowerCase()) return -1;
          if (a.ClientState_Region.toLowerCase() > b.ClientState_Region.toLowerCase()) return 1;
          return 0;
        });
      } else if (this.sortField == "postalcode") {
        // Sort by postalcode
        if (this.sortOrder == "asc") clientData.sort(function (a, b) {
          return a.ClientPostalCode - b.ClientPostalCode;
        });else if (this.sortOrder == "desc") clientData.sort(function (b, a) {
          return a.ClientPostalCode - b.ClientPostalCode;
        });
      } else if (this.sortField == "country") {
        // Sort by country
        if (this.sortOrder == "asc") clientData.sort(function (a, b) {
          if (a.ClientCountry.toLowerCase() < b.ClientCountry.toLowerCase()) return -1;
          if (a.ClientCountry.toLowerCase() > b.ClientCountry.toLowerCase()) return 1;
          return 0;
        });else if (this.sortOrder == "desc") clientData.sort(function (b, a) {
          if (a.ClientCountry.toLowerCase() < b.ClientCountry.toLowerCase()) return -1;
          if (a.ClientCountry.toLowerCase() > b.ClientCountry.toLowerCase()) return 1;
          return 0;
        });
      } else console.error("Error: invalid sortField in startSorting()");
    }
  },
  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this, this.setClientTableHeight);
      this.globals.getCountryList();
    },
    selectedClient: function selectedClient(newId) {
      if (newId > -1) this.selectedClientData = _.find(this.clientData, ["ClientId", newId]);else this.selectedClientData = null;
    }
  },
  data: function data() {
    // Global data inside the component is stored here
    return {
      selectedClient: -1, // ID of the selected client, -1 if none is selected
      selectedClientData: null,
      pageSize: 20, // Number of clients on one page of the table
      selectedPage: 1, // Number of the page, that is visible
      searchString: "",
      sortField: "name", // Selected column for sorting
      sortOrder: "asc", // Should be "asc" or "desc"
      refreshEnabled: false, // false, if client data is requested and server did not respond yet to avoid multiple requests at the same time
      filteredClientData: [], // Stores the client data that passed the filter
      clientDataOnCurrentPage: [], // Stores the client data on the current page
      clientData: [], // Stores the whole client data from server
      timeZones: [], // List of available timezones
      clientList: [], // List of available clients
      regionList: [], // List of all available regions
      languageList: {},
      localesList: [],
      fpInputSince: null,
      editClientDialogData: {
        // Data for the editClient dialog
        dialogType: "", // Should be "create" or "edit"
        dialogTitle: "", // Title of the dialog
        clientData: {}, // The client data of the selected client is stored here
        currentRegionsGeneral: [], // List of regions in the selected country in the general section
        currentRegionsBilling: [], // List of regions in the selected country in the billing section
        currentTimeZonesGeneral: [],
        newCustomProperty: "", // Stores the name of a new custom property
        showAlert: false, // true --> Alert for validation errors is visible
        selectedSurvey: -1 // Stores the selected survey on the survey page
      },
      removeCustomPropertySecurityDialogData: {
        propId: -1,
        propName: ""
      },
      showEditSurveyDialog: false,
      showDeleteSurveyModal: false,
      showImportersModal: false,
      editSurveyDialogModeAdd: true,
      invalidInputIds: [], // IDs of inputs with validation error
      lang: {
        // Contains localization strings for the selected language
        C0000: "Aktualisieren",
        C0001: "Neuer Kunde",
        C0002: "Bearbeiten",
        C0005: "Geokodierung",
        C0006: "Neuer Fragebogen",
        C0007: "Suche...",
        C0008: "Elemente pro Seite",
        C0009: "Alle",
        C0010: "Erste Seite",
        C0011: "Letzte Seite",
        C0012: "Kunden-ID",
        C0013: "Kundenname",
        C0014: "Straße",
        C0015: "Stadt",
        C0016: "Region",
        C0017: "PLZ",
        C0018: "Land",
        C0019: "ID",
        C0020: "Allgemein",
        C0021: "Kundenname",
        C0022: "Straße",
        C0023: "Adresszusatz",
        C0024: "Stadt",
        C0025: "Region",
        C0026: "Bitte auswählen...",
        C0027: "Land",
        C0028: "PLZ",
        C0029: "Kunde seit dem",
        C0030: "Zeitzone",
        C0031: "Zusätzliche Anmerkungen",
        C0032: "Kontakt",
        C0033: "Vorname",
        C0034: "Nachname",
        C0035: "Telefon",
        C0036: "Fax",
        C0037: "E-Mail",
        C0038: "Rechnungsinformationen",
        C0039: "Rechnungsempfänger",
        C0040: "Adresse",
        C0041: "Adresszusatz",
        C0042: "Stadt",
        C0043: "Region",
        C0044: "Land",
        C0045: "PLZ",
        C0046: "E-Mail",
        C0047: "Bezeichnungen",
        C0048: "Personalisierung",
        C0049: "Kundenlogo URL",
        C0050: "Jedes Bild-Format ist erlaubt, jedoch für beste Bildqualität, benutzen Sie PNG-Format mit transparentem Hintergrund und einer Höhe unter 100 Pixel.",
        C0051: "Begrüßungstext für Kunden",
        C0052: "Beispiel",
        C0053: "Willkommen",
        C0054: "Erlaubt Platzhalter",
        C0055: "Startseite Layout",
        C0056: "Farbkodierung",
        C0057: "MSM Navigator Standarddefinition",
        C0058: "Nachkommastellen",
        C0059: "Fragebögen",
        C0060: "ID",
        C0061: "Fragebogen",
        C0062: "Custom Properties",
        C0063: "Neue Auswertungsebene",
        C0064: "Hinzufügen",
        C0065: "Eigenschaftsbezeichnung",
        C0066: "ID",
        C0067: "Position",
        C0068: "Ihre Eingaben sind fehlerhaft. Bitte prüfen Sie alle rot markierten Felder!",
        C0069: "Abbrechen",
        C0070: "Speichern",
        C0088: "Neuer Kunde",
        C0089: "Kunden bearbeiten",
        C0090: "Diese Angabe ist erforderlich!",
        C0091: "Dies ist keine gültige Telefonnummer!",
        C0092: "Dies ist keine gültige Faxnummer!",
        C0093: "Dies ist keine gültige URL!",
        C0094: "Dies ist keine gültige E-Mail Adresse!",
        C0095: "Neuer Fragebogen",
        C0096: "Allgemein",
        C0097: "Kunde",
        C0098: "Titel",
        C0099: "Ihre Eingaben sind fehlerhaft. Bitte prüfen Sie alle rot markierten Felder!",
        C0100: "Abbrechen",
        C0101: "Speichern",
        C0102: "Fragebogen bearbeiten",
        C0103: "Sichtbarkeit",
        C0104: "Operativ",
        C0105: "Reporting",
        C0107: "Bearbeiten",
        C0108: "Fragebogen Editor",
        C0109: "Löschen",
        C0110: "Benutzerdefinierte Eigenschaft löschen",
        C0111: "ACHTUNG: Beim Entfernen einer Benutzerdefinierten Eigenschaft, werden auch alle zugehörigen Definitionen bei den Standorten entfernt!",
        C0112: "Soll die Benutzerdefinierte Eigenschaft",
        C0113: "wirklich gelöscht werden?",
        C0114: "Nein",
        C0115: "Ja",
        C0116: "Delete Survey",
        C0117: "Do you really want to delete the following survey?",
        C0118: "Importers",
        C0119: "Total clients count"
      }
    };
  },

  components: {
    SurveyManagementEditModal: __WEBPACK_IMPORTED_MODULE_2__SurveyManagement_SurveyManagementEditModal___default.a,
    ConfirmationDialog: __WEBPACK_IMPORTED_MODULE_3__Tools_Dialogs_ConfirmationDialog___default.a,
    ImporterManagement: __WEBPACK_IMPORTED_MODULE_4__ImporterManagement___default.a
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ImporterManagement",
  props: {
    showModal: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      newImporter: "",
      importerList: [],
      isImporterEditing: false,
      lang: {
        IMP000: "Importers",
        IMP001: "New importer",
        IMP002: "Add",
        IMP003: "Importer",
        IMP004: "Actions",
        IMP005: "Close",
        IMP006: "Importer list access failed",
        IMP007: "Importer name already exists",
        IMP008: "Importer creation successful",
        IMP009: "Importer creation failed",
        IMP010: "Importer update successful",
        IMP011: "Importer update failed",
        IMP012: "Importer deletion successful",
        IMP013: "Importer deletion failed",
        IMP014: "Delete Importer",
        IMP015: "Yes",
        IMP016: "No",
        IMP017: "Do you really want to delete the following importer?",
        IMP018: "Empty importer name not allowed"
      }
    };
  },

  watch: {
    showModal: function showModal(newValue) {
      newValue ? this.openModal() : this.closeModal();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
    $("#importerManagementModal").on("hidden.bs.modal", function (e) {
      _this.$emit("modalClosed");
    });
  },

  methods: {
    openModal: function openModal() {
      this.newImporter = "";
      this.isImporterEditing = false;
      this.getImporterList();
      $("#importerManagementModal").modal("show");
    },
    closeModal: function closeModal() {
      this.globals.importerList = [];
      $("#importerManagementModal").modal("hide");
    },
    getImporterList: function getImporterList() {
      var _this2 = this;

      $.ajax({
        method: "GET",
        url: "api/Importer",
        success: function success(data) {
          _this2.importerList = [];
          if (!_.isEmpty(data)) {
            _this2.importerList = data;
            var internationalImporter = _.remove(_this2.importerList, function (importer) {
              return importer.ImporterGuid === "1D86A788-07D6-4681-BD8C-9C15800DF8BA";
            });
            if (internationalImporter[0]) _this2.importerList.unshift(internationalImporter[0]);
          }
        },
        error: function error() {
          console.error("Importer list access failed in getImporterList()");
          _this2.globals.showErrorSnackbar(_this2.lang.IMP006);
        }
      });
    },
    addNewImporter: function addNewImporter() {
      var _this3 = this;

      $("#inputNewImporter").focus();
      if (!this.newImporter || this.isImporterEditing) return;
      if (_.findIndex(this.importerList, function (i) {
        return i.ImporterName === _this3.newImporter;
      }) > -1) {
        this.globals.showErrorSnackbar(this.lang.IMP007);
        return;
      }
      var postData = {
        ImporterName: this.newImporter
      };
      $.ajax({
        method: "POST",
        url: "api/Importer",
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(postData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          _this3.importerList.unshift(data);
          _this3.globals.showSuccessSnackbar(_this3.lang.IMP008);
          _this3.newImporter = "";
        },
        error: function error() {
          console.error("Error on POST in addNewImporter()");
          _this3.globals.showErrorSnackbar(_this3.lang.IMP009);
        }
      });
    },
    updateImporter: function updateImporter(importer) {
      var _this4 = this;

      $.ajax({
        method: "PUT",
        url: "api/Importer/" + importer.ImporterGuid,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(importer),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          _this4.globals.showSuccessSnackbar(_this4.lang.IMP010);
        },
        error: function error() {
          console.error("Error on PUT in updateImporter()");
          _this4.globals.showErrorSnackbar(_this4.lang.IMP011);
        }
      });
    },
    deleteImporter: function deleteImporter(importer) {
      var _this5 = this;

      if (this.isImporterEditing) return;

      this.globals.$off("DeleteImporterYesConfirmation");
      this.globals.$on("DeleteImporterYesConfirmation", function () {
        $.ajax({
          method: "DELETE",
          url: "api/Importer/" + importer.ImporterGuid,
          success: function success(data) {
            _.remove(_this5.importerList, function (i) {
              return i.ImporterGuid === importer.ImporterGuid;
            });
            _this5.$forceUpdate();
            _this5.globals.showSuccessSnackbar(_this5.lang.IMP012);
          },
          error: function error() {
            console.error("Error on DELETE in deleteImporter()");
            _this5.globals.showErrorSnackbar(_this5.lang.IMP013);
          }
        });
      });

      this.globals.$emit("openGlobalConfirmationDialog", {
        initiator: "DeleteImporter",
        confirmationTitle: this.lang.IMP014,
        colorRed: true,
        yesButtonText: this.lang.IMP015,
        noButtonText: this.lang.IMP016,
        htmlText: "<p>" + this.lang.IMP017 + "</p>\n                  <p><b>" + importer.ImporterName + "</b></p>"
      });
    },
    editImporter: function editImporter(e, importer) {
      if (this.isImporterEditing) return;
      importer.editing = true;
      this.isImporterEditing = true;
      importer.prevImporterName = importer.ImporterName;
      var input = $(e.target).closest("tr").find("input");
      input.prop("readonly", "");
      input.focus();
    },
    saveImporter: function saveImporter(e, importer) {
      var input = $(e.target).closest("tr").find("input");

      if (!importer.ImporterName) {
        this.globals.showErrorSnackbar(this.lang.IMP018);
        input.focus();
        return;
      }

      var count = _.filter(this.importerList, function (i) {
        return i.ImporterName === importer.ImporterName;
      }).length;
      if (count > 1) {
        this.globals.showErrorSnackbar(this.lang.IMP007);
        input.focus();
        return;
      }

      this.isImporterEditing = false;
      delete importer.editing;
      delete importer.prevImporterName;
      input.prop("readonly", "true");
      this.updateImporter(importer);
    },
    undoImporterChanges: function undoImporterChanges(e, importer) {
      var input = $(e.target).closest("tr").find("input");
      input.prop("readonly", "true");
      this.isImporterEditing = false;
      delete importer.editing;
      importer.ImporterName = importer.prevImporterName;
      delete importer.prevImporterName;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tools_Select2__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Tools_Select2__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ImportUsersModal",
  components: { Select2: __WEBPACK_IMPORTED_MODULE_0__Tools_Select2___default.a },
  mounted: function mounted() {
    var _this = this;

    $("#importUsersDialog").on("hidden.bs.modal", function () {
      _this.$emit("dialogClosed");
    });

    $("#importUsersImportFileInput").click(function (e) {
      $(e.target).val("");
      _this.importUsersDialogData.selectedFile = {};
      _this.$forceUpdate();
    });
  },

  methods: {
    openImportUsersDialog: function openImportUsersDialog() {
      var selOption = this.importUsersDialogData.selectedOption;
      this.importUsersDialogData = {
        selectedOption: selOption,
        selectedText: "",
        selectedFile: {},
        serverResponse: {},
        trimImportData: false
      };

      if (this.feature.isAudiTarget && this.clientList[0]) {
        this.importUsersDialogData.UserTypeId = 4;
        this.importUsersDialogData.ClientId = this.clientList[0].ClientId;
      }

      $("#importUsersImportFileInput").val("");
      this.importStep = 1; //TODO:
      $("#importUsersDialog").modal("show");
    },
    closeImportUsersDialog: function closeImportUsersDialog() {
      $("#importUsersDialog").modal("hide");
    },
    downloadUserList: function downloadUserList() {
      // TODO:
      if (this.importUsersDialogData.serverResponse && this.importUsersDialogData.serverResponse[0] && this.importUsersDialogData.serverResponse[0].DownloadId) {
        this.globals.downloadFile(this.importUsersDialogData.serverResponse[0].DownloadId);
        this.closeImportUsersDialog();
      } else console.error("Missing downloadId in downloadUserList()");
    },
    uploadImportData: function uploadImportData() {
      var _this2 = this;

      if (this.importUsersDialogData.UserTypeId == 4 && !this.importUsersDialogData.ClientId) {
        this.globals.showErrorSnackbar("Please select a client");
        console.error("Missing client selection for user export");
        return;
      }

      if (this.importUsersDialogData.selectedOption === "text") {
        if (this.importUsersDialogData.selectedText === "") {
          this.globals.showErrorSnackbar("Please insert import data");
          console.error("Error: No import text available in uploadImportData()");
          return;
        }

        // Escape all " characters
        var importText = this.importUsersDialogData.selectedText.replace(/"/g, '\\"');

        // Build import JSON
        var importString = '{"data":"';
        importString += importText + '"';
        importString += ',"trim":' + this.importUsersDialogData.trimImportData;
        importString += "}";

        var url = "api/SecurityUsers/Import";
        if (this.importUsersDialogData.UserTypeId) {
          url += "?userTypeId=" + this.importUsersDialogData.UserTypeId;
          if (this.importUsersDialogData.UserTypeId == 4 && this.importUsersDialogData.ClientId) url += "&clientId=" + this.importUsersDialogData.ClientId;
          if (this.importUsersDialogData.UserTypeId == 2 && this.importUsersDialogData.AgencyId) url += "&agencyId=" + this.importUsersDialogData.AgencyId;
        }

        $.ajax({
          method: "POST",
          url: url,
          data: importString,
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          timeout: 600000,
          success: function success(data) {
            // this.importUsersDialogData.serverResponse = data;
            // this.importStep = 2;
            _this2.getCurrentImportData();
          },
          error: function error() {
            console.error("Error on POST in uploadImportData()");
            _this2.globals.showErrorSnackbar("User import failed");
          },
          complete: function complete() {
            _this2.importUsersDialogData.selectedText = "";
            _this2.importUsersDialogData.selectedFile = {};
            $("#importUsersImportFileInput").val("");
          }
        });
      } else if (this.importUsersDialogData.selectedOption === "file") {
        if (_.isEmpty(this.importUsersDialogData.selectedFile)) {
          console.error("Error: No import file available in uploadImportData()");
          this.globals.showErrorSnackbar("Please select an import file");
          return;
        }

        var _importString = '{"file":"' + this.importUsersDialogData.selectedFile.file + '"';
        _importString += ',"trim":' + this.importUsersDialogData.trimImportData + "}";

        var _url = "api/SecurityUsers/Import";
        if (this.importUsersDialogData.UserTypeId) {
          _url += "?userTypeId=" + this.importUsersDialogData.UserTypeId;
          if (this.importUsersDialogData.UserTypeId == 4 && this.importUsersDialogData.ClientId) _url += "&clientId=" + this.importUsersDialogData.ClientId;
          if (this.importUsersDialogData.UserTypeId == 2 && this.importUsersDialogData.AgencyId) _url += "&agencyId=" + this.importUsersDialogData.AgencyId;
        }

        $.ajax({
          method: "POST",
          url: _url,
          data: _importString,
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          timeout: 600000,
          success: function success(data) {
            // this.importUsersDialogData.serverResponse = data;
            // this.importStep = 2;
            _this2.getCurrentImportData();
          },
          error: function error(data) {
            console.error("Error on POST in uploadImportData()");
            _this2.globals.showErrorSnackbar("User import failed");
          },
          complete: function complete() {
            _this2.importUsersDialogData.selectedText = "";
            _this2.importUsersDialogData.selectedFile = {};
            $("#importUsersImportFileInput").val("");
          }
        });
      }
    },
    getCurrentImportData: function getCurrentImportData() {
      var _this3 = this;

      var url = "api/SecurityUsers/Import?page_size=0&filter={\"Errors\":false}";

      $.ajax({
        method: "GET",
        url: url,
        success: function success(data) {
          if (data && data[0]) {
            if (data[0].Error_Counter) _this3.importStep = 2;else _this3.saveImportData();
          }
        },
        error: function error() {
          console.error("Error on GET in getCurrentImportData()");
          _this3.globals.showErrorSnackbar("Import data access failed");
        }
      });
    },
    saveImportData: function saveImportData() {
      var _this4 = this;

      var dataString = '{"save":true}';

      // the save action also needs to know which usertype and id to use
      // because we again check for errors
      var url = "api/SecurityUsers/Import";
      if (this.importUsersDialogData.UserTypeId) {
        url += "?userTypeId=" + this.importUsersDialogData.UserTypeId;
        if (this.importUsersDialogData.UserTypeId == 4 && this.importUsersDialogData.ClientId) url += "&clientId=" + this.importUsersDialogData.ClientId;
        if (this.importUsersDialogData.UserTypeId == 2 && this.importUsersDialogData.AgencyId) url += "&agencyId=" + this.importUsersDialogData.AgencyId;
      }

      $.ajax({
        method: "POST",
        url: url,
        data: dataString,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          _this4.globals.showSuccessSnackbar("User import successful");

          if (data && data[0] && data[0].DownloadId) {
            _this4.importUsersDialogData.serverResponse = data;
            _this4.importStep = 3;
          } else {
            _this4.closeImportUsersDialog();
          }
          //TODO: Download password list
        },
        error: function error() {
          console.error("Error on POST in saveImportData()");
          _this4.globals.showErrorSnackbar("User import failed");
        }
      });
    },
    onImportFileChange: function onImportFileChange(e) {
      var _this5 = this;

      var files = e.target.files || e.dataTransfer.files;
      if (!files.length || !files[0].name) {
        this.importUsersDialogData.selectedFile = {};
        return;
      }
      var fileObject = files[0];

      var uploadSuccess = function uploadSuccess(data) {
        if (!data || !data[0]) return;

        if (_this5.importUsersDialogData.selectedFile) {
          _this5.importUsersDialogData.selectedFile.file = data[0].DownloadId;
          _this5.importUsersDialogData.selectedFile.name = fileObject.name;
        } else _this5.importUsersDialogData.selectedFile = data;

        _this5.$forceUpdate();
      };
      this.globals.uploadFile(fileObject, uploadSuccess);
      e.target.value = null;
    }
  },
  watch: {
    showDialog: function showDialog(newValue) {
      if (newValue === true) this.openImportUsersDialog();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  props: ["showDialog", "userTypeList", "clientList", "agencyList"],
  data: function data() {
    // Global data inside the component is stored here
    return {
      importUsersDialogData: {
        selectedOption: "text",
        selectedText: "",
        selectedFile: {},
        serverResponse: {},
        trimImportData: false
      },
      importStep: 1,
      lang: {}
    };
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_liquor_tree__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tools_Select2__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Tools_Select2__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "KpiQuestionAssignmentModal",
  components: { liquortree: __WEBPACK_IMPORTED_MODULE_1_liquor_tree__["a" /* default */], Select2: __WEBPACK_IMPORTED_MODULE_2__Tools_Select2___default.a },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
    $("#kpiAssignmentDialog").on("hide.bs.modal", function (e) {
      _this.$emit("dialogClosed");
    });
  },

  props: ["showDialog", "clientList", "selectedClientFromParent", "selectedKpiData", "kpiEvaluationRulesList", "kpiGroupEvaluationRulesList", "projectList"],
  watch: {
    showDialog: function showDialog() {
      this.showDialog ? this.openKpiAssignmentDialog() : this.closeKpiAssignmentDialog();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  data: function data() {
    return {
      selectedClientGuid: "",
      kpiGroupsOfSelectedClient: [],
      selectedKpiGroupGuid: "",
      kpisOfSelectedKpiGroup: [],
      selectedKpiGuid: "",
      selectedKpi: {},
      surveysFromSelectedKpiGroup: [],
      selectedSurveyGuid: "",
      treeData: [],
      showTree: false,
      treeViewChanged: false,
      treeOptions: {
        parentSelect: true,
        deletion: function deletion(node) {
          return node.checked();
        }
      },
      lang: {
        KM1000: "KPI – Question Assignment",
        KM1001: "Client",
        KM1002: "KPI Group",
        KM1003: "Evaluation rule",
        KM1004: "Client",
        KM1005: "KPI Group",
        KM1006: "Please select a KPI Group...",
        KM1007: "KPI",
        KM1008: "Please select a KPI...",
        KM1009: "Close",
        KM1010: "Survey",
        KM1011: "Please select a survey...",
        KM1012: "Save",
        KM1013: "Project"
      }
    };
  },

  computed: {
    nameOfSelectedClient: function nameOfSelectedClient() {
      var _this2 = this;

      if (!this.selectedClientGuid) return " - ";
      var client = this.clientList.find(function (c) {
        return c.ClientGuid === _this2.selectedClientGuid;
      });
      return client ? client.ClientName : " - ";
    },
    nameOfSelectedKpiGroup: function nameOfSelectedKpiGroup() {
      var _this3 = this;

      if (!this.selectedKpiGroupGuid) return " - ";
      var kpiGroup = this.kpiGroupsOfSelectedClient.find(function (element) {
        return element.KPIGroupGuid === _this3.selectedKpiGroupGuid;
      });
      return kpiGroup ? kpiGroup.KPIGroupShortText : " - ";
    },
    nameOfselectedEvaluationRuleGuid: function nameOfselectedEvaluationRuleGuid() {
      var _this4 = this;

      if (!this.selectedKpiGroupGuid) return " - ";
      var evaluationRule = void 0;
      var kpi = this.kpisOfSelectedKpiGroup.find(function (el) {
        return el.KPIGuid === _this4.selectedKpiGuid;
      });
      if (kpi && kpi.KPIEvaluationRuleGuid) {
        evaluationRule = this.kpiEvaluationRulesList.find(function (el) {
          return el.EvaluationRuleGuid === kpi.KPIEvaluationRuleGuid;
        });
        return evaluationRule.EvaluationRule;
      }

      var kpiGroup = this.kpiGroupsOfSelectedClient.find(function (element) {
        return element.KPIGroupGuid === _this4.selectedKpiGroupGuid;
      });
      if (kpiGroup) evaluationRule = this.kpiGroupEvaluationRulesList.find(function (element) {
        return element.EvaluationRuleGuid === kpiGroup.KPIEvaluationRuleGuid;
      });
      return evaluationRule ? evaluationRule.EvaluationRule : " - ";
    },
    nameOfSelectedProject: function nameOfSelectedProject() {
      if (!this.selectedKpiGroupGuid || !this.selectedClientGuid) return " - ";
      var kpiGroup = _.find(this.kpiGroupsOfSelectedClient, ["KPIGroupGuid", this.selectedKpiGroupGuid]);
      var projectGuid = void 0,
          projectName = void 0;
      if (kpiGroup && kpiGroup.Projects && kpiGroup.Projects[0] && kpiGroup.Projects[0].ProjectGuid) projectGuid = kpiGroup.Projects[0].ProjectGuid;

      if (projectGuid) {
        var clientProjects = _.find(this.projectList, ["ClientGuid", this.selectedClientGuid]);
        if (clientProjects && clientProjects.Projects && clientProjects.Projects.length > 0) {
          var projectData = _.find(clientProjects.Projects, ["ProjectGuid", projectGuid]);
          if (projectData && projectData.ProjectName) projectName = projectData.ProjectName;
        }
      }
      if (projectName) return projectName;
      return " - ";
    },
    selectedSurvey: function selectedSurvey() {
      var _this5 = this;

      return this.surveysFromSelectedKpiGroup.find(function (survey) {
        return survey.SurveyGuid === _this5.selectedSurveyGuid;
      });
    }
  },
  methods: {
    openKpiAssignmentDialog: function openKpiAssignmentDialog() {
      $("#kpiAssignmentDialog").modal("show");
      this.initKpiAssignmentDialog();
      this.getKpiGroupsOfSelectedClient();
    },
    closeKpiAssignmentDialog: function closeKpiAssignmentDialog() {
      $("#kpiAssignmentDialog").modal("hide");
    },
    initKpiAssignmentDialog: function initKpiAssignmentDialog() {
      this.selectedClientGuid = "";
      if (this.selectedClientFromParent) this.selectedClientGuid = this.selectedClientFromParent;

      this.selectedKpiGroupGuid = "";
      this.selectedKpiGuid = "";
      this.selectedSurveyGuid = "";
      this.kpisOfSelectedKpiGroup = [];
      this.surveysFromSelectedKpiGroup = [];
      this.treeData = [];
      this.showTree = false;
      this.treeViewChanged = false;
    },
    getKpiGroupsOfSelectedClient: function getKpiGroupsOfSelectedClient(changed) {
      var _this6 = this;

      this.selectedKpiGroupGuid = "";
      if (changed) {
        this.selectedKpiGuid = "";
        this.selectedSurveyGuid = "";
      }
      this.surveysFromSelectedKpiGroup = [];
      this.kpisOfSelectedKpiGroup = [];
      this.treeData = [];
      this.reloadTreeView();

      var queryString = "api/KPIGroups/Client/" + this.selectedClientGuid;

      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this6.kpiGroupsOfSelectedClient = !_.isEmpty(data) ? data : [];
          _this6.sortKpiGroupsByKpiCode();
          if (!changed && !_.isEmpty(_this6.selectedKpiData)) {
            _this6.$nextTick(function () {
              _this6.selectedKpiGroupGuid = _this6.selectedKpiData.KPIGroups[0].KPIGroupGuid;
              _this6.getKpiInformation();
            });
          }
        },
        error: function error() {
          console.error("Error on GET in getKpiGroupsOfSelectedClient()");
          _this6.globals.showErrorSnackbar("KPI Group request failed");
        }
      });
    },
    sortKpiGroupsByKpiCode: function sortKpiGroupsByKpiCode() {
      this.kpiGroupsOfSelectedClient.sort(function (a, b) {
        if (a.KPIGroupCode.toLowerCase() < b.KPIGroupCode.toLowerCase()) return -1;
        if (a.KPIGroupCode.toLowerCase() > b.KPIGroupCode.toLowerCase()) return 1;
        return 0;
      });
    },
    getKpiInformation: function getKpiInformation(changed) {
      this.treeData = [];
      this.reloadTreeView();
      if (this.selectedKpiGroupGuid) {
        this.getKpisOfSelectedKpiGroup(changed);
        this.getSurveysFromSelectedKpiGroup();
      }
    },
    getKpisOfSelectedKpiGroup: function getKpisOfSelectedKpiGroup(changed) {
      var _this7 = this;

      if (!this.selectedKpiGroupGuid) return;
      this.selectedKpiGuid = "";
      var queryString = "api/KPIGroups/" + this.selectedKpiGroupGuid;

      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this7.kpisOfSelectedKpiGroup = data[0].KPIs || [];
          _this7.sortKpisByKpiCode();

          if (!changed && !_.isEmpty(_this7.selectedKpiData)) _this7.$nextTick(function () {
            _this7.selectedKpiGuid = _this7.selectedKpiData.KPIGuid;
            _this7.getKpiSurveyAssignment();
          });
        },
        error: function error() {
          console.error("Error on GET in getKpisOfSelectedKpiGroup()");
          _this7.globals.showErrorSnackbar("KPI data request failed");
        }
      });
    },
    sortKpisByKpiCode: function sortKpisByKpiCode() {
      this.kpisOfSelectedKpiGroup.sort(function (a, b) {
        if (a.KPICode.toLowerCase() < b.KPICode.toLowerCase()) return -1;
        if (a.KPICode.toLowerCase() > b.KPICode.toLowerCase()) return 1;
        return 0;
      });
    },
    getSurveysFromSelectedKpiGroup: function getSurveysFromSelectedKpiGroup() {
      var _this8 = this;

      if (!this.selectedKpiGroupGuid) return;
      var getString = "api/KPIGroups/" + this.selectedKpiGroupGuid + "/Data/SurveyQuestions";

      $.ajax({
        method: "GET",
        url: getString,
        success: function success(data) {
          _this8.surveysFromSelectedKpiGroup = !_.isEmpty(data) ? data : [];
          _this8.sortSurveysBySurveyTitle();
        },
        error: function error() {
          console.error("Survey data request failed in getSurveysFromSelectedKpiGroup()");
          _this8.globals.showErrorSnackbar("Survey data request failed");
        }
      });
    },
    sortSurveysBySurveyTitle: function sortSurveysBySurveyTitle() {
      this.surveysFromSelectedKpiGroup.sort(function (a, b) {
        if (a.SurveyTitle.toLowerCase() < b.SurveyTitle.toLowerCase()) return -1;
        if (a.SurveyTitle.toLowerCase() > b.SurveyTitle.toLowerCase()) return 1;
        return 0;
      });
    },
    getKpiSurveyAssignment: function getKpiSurveyAssignment() {
      var _this9 = this;

      if (!this.selectedKpiGuid) {
        this.selectedKpi.SurveyQuestions = [];
        return;
      }
      var getString = "api/KPIs/" + this.selectedKpiGuid;

      $.ajax({
        method: "GET",
        url: getString,
        success: function success(data) {
          if (!_.isEmpty(data)) {
            _this9.selectedKpi = data[0];
            if (!_this9.selectedKpi.SurveyQuestions) _this9.selectedKpi.SurveyQuestions = [];
          } else _this9.selectedKpi = {};
          _this9.getSelectedSurvey();
        },
        error: function error() {
          console.error("Assignment data request failed in getKpiSurveyAssignment()");
          _this9.globals.showErrorSnackbar("Assignment data request failed");
        }
      });
    },
    getSelectedSurvey: function getSelectedSurvey() {
      this.treeData = [];
      this.reloadTreeView();
      this.treeViewChanged = false;
      if (this.selectedSurveyGuid && this.selectedKpiGuid) {
        this.generateTreeDataFromSurvey(this.selectedSurvey);
      }
    },

    // generate the json string for liquor tree from received survey of a selected kpi group
    generateTreeDataFromSurvey: function generateTreeDataFromSurvey(selectedSurvey) {
      if (!selectedSurvey || !selectedSurvey.Panel) return;
      var surveyCluster = selectedSurvey.Panel;
      this.treeData = surveyCluster.map(function (surveyElement) {
        var node = {};
        node.data = surveyElement;
        node.text = surveyElement.Title;
        if (surveyElement.Questions) node.children = surveyElement.Questions.map(function (question) {
          var child = {};
          child.data = question;
          child.text = question.Title;
          return child;
        });
        return node;
      });
      if (this.selectedKpi.SurveyQuestions) this.setCheckedSurveyQuestions(this.selectedKpi.SurveyQuestions);
      this.reloadTreeView();
    },
    setCheckedSurveyQuestions: function setCheckedSurveyQuestions(surveyQuestions) {
      var _this10 = this;

      var checkedQuestions = surveyQuestions.filter(function (survey) {
        return survey.SurveyGuid === _this10.selectedSurveyGuid;
      });
      if (checkedQuestions.length === 0) return;
      var questions = checkedQuestions[0].Questions;
      if (!questions) return;
      this.treeData.forEach(function (treeElement) {
        if (treeElement.children) {
          questions.forEach(function (question) {
            var node = treeElement.children.find(function (child) {
              return child.data.QuestionGuid === question.QuestionGuid;
            });
            if (node) node.state = {
              checked: true
            };
          });
        }
      });
    },
    reloadTreeView: function reloadTreeView() {
      var _this11 = this;

      this.showTree = false;
      this.$nextTick(function () {
        _this11.showTree = true;
      });
    },
    toggleQuestionCheckbox: function toggleQuestionCheckbox(node) {
      this.treeViewChanged = true;
      node.checked() ? node.uncheck() : node.check();
    },
    getCheckedSurveyQuestions: function getCheckedSurveyQuestions() {
      var _this12 = this;

      var tree = this.$refs.kpiQuestionAssignmentTree;
      if (!tree) return;
      var idx = this.selectedKpi.SurveyQuestions.findIndex(function (element) {
        return element.SurveyGuid === _this12.selectedSurveyGuid;
      });
      var selection = tree.findAll({ state: { checked: true } });
      var questions = [];
      if (selection) {
        selection.forEach(function (element) {
          if (!element.data.IsCluster) {
            questions.push({
              QuestionGuid: element.data.QuestionGuid,
              QuestionTitle: element.text
            });
          }
        });
        if (idx === -1) {
          var newSurveyQuestion = {
            SurveyGuid: this.selectedSurveyGuid,
            SurveyTitle: this.selectedSurvey.SurveyTitle,
            Questions: questions
          };
          this.selectedKpi.SurveyQuestions.push(newSurveyQuestion);
        } else this.selectedKpi.SurveyQuestions[idx].Questions = questions;
      } else this.selectedKpi.SurveyQuestions.splice(idx, 1);
    },
    saveKpiQuestionAssignmentData: function saveKpiQuestionAssignmentData() {
      var _this13 = this;

      var queryString = "api/KPIs/" + this.selectedKpiGuid;
      this.getCheckedSurveyQuestions();

      $.ajax({
        method: "PUT",
        url: queryString,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedKpi),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data[0] && data[0].error) {
            console.error(data[0].error);
            _this13.globals.showErrorSnackbar(data[0].error);
            return;
          }
          _this13.globals.showSuccessSnackbar("Assignment data update successful");
          _this13.treeViewChanged = false;
        },
        error: function error() {
          console.error("Assignment data update failed in saveKpiQuestionAssignmentData()");
          _this13.globals.showErrorSnackbar("Assignment data update failed");
        }
      });
    },
    convertQuestionTypeToLetter: function convertQuestionTypeToLetter(type) {
      if (!type) return "";
      switch (type) {
        case "checkbox":
          return "M";
        case "radiogroup":
          return "S";
        case "dropdown":
          return "D";
        case "rating":
          return "R";
        default:
          return "";
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tools_Select2__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Tools_Select2__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "KPICopyModal",
  components: {
    Select2: __WEBPACK_IMPORTED_MODULE_0__Tools_Select2___default.a
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    projects: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    selectedProject: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      selectedSourceProject: "",
      selectedTargetProject: "",
      lang: {
        KCM000: "Copy KPI Data",
        KCM001: "Source project",
        KCM002: "Please select a source project...",
        KCM003: "Target project",
        KCM004: "Please select a target project...",
        KCM005: "Close",
        KCM006: "Copy",
        KCM007: "Copying to the same project is not possible",
        KCM008: "KPI data copied",
        KCM009: "KPI data copy failed"
      }
    };
  },

  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    },
    showModal: function showModal(newVal) {
      newVal ? this.openModal() : this.closeModal();
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#kpiCopyModal").on("hidden.bs.modal", function (e) {
      return _this.$emit("modalClosed");
    });
  },

  methods: {
    openModal: function openModal() {
      this.selectedSourceProject = "";
      this.selectedTargetProject = "";
      if (this.selectedProject) this.selectedSourceProject = this.selectedProject;
      $("#kpiCopyModal").modal("show");
    },
    closeModal: function closeModal() {
      $("#kpiCopyModal").modal("hide");
    },
    copyKpis: function copyKpis() {
      var _this2 = this;

      if (this.selectedSourceProject === this.selectedTargetProject) {
        console.error("kpi copy not possible due to identical source and target project");
        this.globals.showErrorSnackbar(this.lang.KCM007);
        return;
      }

      var query = "api/KPIs/CopyKPIs/FromProject/" + this.selectedSourceProject + "/ToProject/" + this.selectedTargetProject;
      $.ajax({
        method: "POST",
        url: query,
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this2.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this2.globals.showSuccessSnackbar(_this2.lang.KCM008);
          _this2.$emit("copyDone");
          _this2.closeModal();
        },
        error: function error(_error) {
          console.error("Error on POST in copyKpis()");
          _this2.globals.showErrorSnackbar(_this2.lang.KCM009);
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tools_Select2__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Tools_Select2__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "KPIGroupEditModal",
  components: {
    Select2: __WEBPACK_IMPORTED_MODULE_1__Tools_Select2___default.a
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#editKPIGroupDialog").on("hide.bs.modal", function (e) {
      _this.$emit("dialogClosed");
    });

    // Register global events
    this.globals.$off("KPIGroupDeleteModalYesConfirmation");
    this.globals.$on("KPIGroupDeleteModalYesConfirmation", function () {
      _this.deleteSelectedKpiGroup();
    });
  },

  props: ["showDialog", "clientList", "projectList", "kpiGroupEvaluationRulesList", "selectedClientForKpiGroups"],
  watch: {
    showDialog: function showDialog() {
      this.showDialog ? this.openEditKPIGroupDialog() : this.closeEditKPIGroupDialog();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  data: function data() {
    return {
      selectedKpiGroupInformation: {
        KPIGroupGuid: "",
        KPIGroupCode: "",
        KPIGroupShortText: "",
        KPIGroupLongText: "",
        KPIGroupDescription: "",
        KPIEvaluationRuleGuid: "",
        Projects: []
      },
      selectedTab: "editKpiGroupTab",
      selectedKpiGroupGuid: "",
      filterKpiGroupString: "",
      filteredKpiGroups: [],
      selectedKpiGroupDirty: false,
      changeKpiOrderDirty: false,
      changeKpiGroupOrderDirty: false,
      kpiGroupsOfSelectedClient: [],
      kpisOfSelectedKpiGroup: [],
      selectedClientGuid: "",
      selectedProjectGuid: "",
      clientProjectList: [],
      showAlert: false,
      invalidInputIds: [],
      selectedEvaluationRule: "",
      lang: {
        KM4000: "KPI Group Code",
        KM4001: "KPI Group Shorttext",
        KM4002: "Close",
        KM4003: "Save",
        KM4004: "KPI Group Longtext",
        KM4005: "Description",
        KM4006: "KPI Group Management",
        KM4007: "Client",
        KM4008: "Project",
        KM4009: "Please select a project...",
        KM4010: "Evaluation rule",
        KM4011: "Please select an evaluation rule...",
        KM4012: "ID",
        KM4013: "Filter",
        KM4014: "Edit KPI Group",
        KM4015: "New",
        KM4016: "Delete",
        KM4017: "KPI Order",
        KM4018: "KPI Shorttext",
        KM4019: "Position",
        KM4020: "Delete KPI Group",
        KM4021: "Do you really want to delete the following KPI group?",
        KM4022: "Yes",
        KM4023: "No",
        KM4024: "ID",
        KM4025: "KPI Group Code",
        KM4026: "KPI Group Shorttext",
        KM4027: "KPI Group",
        KM4028: "Your inputs are incorrect. Please check the fields marked in red!",
        KM4029: "This is a required entry!",
        KM4030: "Save positions",
        KM4031: "Weight",
        KM4032: "KPI Group Code – max. 200 characters",
        KM4033: "KPI Group Shorttext – max. 50 characters, will be visible in Cockpit",
        KM4034: "KPI Group Longtext – max. 200 characters",
        KM4035: "Weight of the KPI Group related to other KPI Groups",
        KM4036: "Position",
        KM4037: "KPI Group Order",
        KM4038: "KPI Group Shorttext",
        KM4039: "Position"
      }
    };
  },

  computed: {
    nameOfSelectedClient: function nameOfSelectedClient() {
      var _this2 = this;

      if (this.selectedClientGuid === "") return " - ";
      var client = this.clientList.find(function (c) {
        return c.ClientGuid === _this2.selectedClientGuid;
      });
      return client ? client.ClientName : " - ";
    },
    nameOfSelectedKpiGroup: function nameOfSelectedKpiGroup() {
      var _this3 = this;

      if (this.selectedKpiGroupGuid === "") return " - ";
      var kpiGroup = this.kpiGroupsOfSelectedClient.find(function (element) {
        return element.KPIGroupGuid === _this3.selectedKpiGroupGuid;
      });
      return kpiGroup ? kpiGroup.KPIGroupShortText : " - ";
    },
    nameOfSelectedEvaluationRuleGuid: function nameOfSelectedEvaluationRuleGuid() {
      var selectedEvaluationRuleGuid = this.selectedKpiGroupInformation.KPIEvaluationRuleGuid;
      if (!selectedEvaluationRuleGuid) return " - ";
      var evaluationRule = this.kpiGroupEvaluationRulesList.find(function (element) {
        return element.EvaluationRuleGuid === selectedEvaluationRuleGuid;
      });
      this.selectedEvaluationRule = evaluationRule.EvaluationRule || " - ";
      return this.selectedEvaluationRule;
    }
  },
  methods: {
    initEditKPIGroupDialog: function initEditKPIGroupDialog() {
      this.createNewKpiGroup();
      this.selectedClientGuid = this.selectedClientForKpiGroups;
      this.changeKpiGroupOrderDirty = false;
    },

    // reset form states and empty input fields
    createNewKpiGroup: function createNewKpiGroup() {
      this.selectedKpiGroupInformation = {
        KPIGroupGuid: "",
        KPIGroupCode: "",
        KPIGroupShortText: "",
        KPIGroupLongText: "",
        KPIGroupDescription: "",
        KPIEvaluationRuleGuid: "",
        Projects: []
      };
      this.selectedKpiGroupGuid = "";
      this.selectedEvaluationRule = "";
      this.selectedProjectGuid = "";
      this.kpisOfSelectedKpiGroup = [];
      this.selectedKpiGroupDirty = false;
      this.showAlert = false;
      this.changeKpiOrderDirty = false;
      this.changeKpiGroupOrderDirty = false;
      this.resetValidationErrors("editKPIGroupDialog");
    },
    openEditKPIGroupDialog: function openEditKPIGroupDialog() {
      $("#editKPIGroupDialog").modal("show");
      this.initEditKPIGroupDialog();
      this.getKpiGroupsOfSelectedClient();
    },
    closeEditKPIGroupDialog: function closeEditKPIGroupDialog() {
      $("#editKPIGroupDialog").modal("hide");
    },
    getKpiGroupsOfSelectedClient: function getKpiGroupsOfSelectedClient() {
      var _this4 = this;

      var queryString = "api/KPIGroups/Client/" + this.selectedClientGuid;

      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          if (!_.isEmpty(data)) {
            _this4.kpiGroupsOfSelectedClient = data;
            _this4.kpiGroupsOfSelectedClient.forEach(function (kpiGroup) {
              if (!kpiGroup.Projects) kpiGroup.Projects = [];
            });
          } else _this4.kpiGroupsOfSelectedClient = [];
          _this4.sortKpiGroupsByPosition();
          _this4.doFilterKpiGroups();
          _this4.filterClientProjectList();
        },
        error: function error() {
          console.error("Error on GET in getKpiGroupsOfSelectedClient()");
          _this4.globals.showErrorSnackbar("KPI Group data request failed");
        }
      });
    },
    doFilterKpiGroups: function doFilterKpiGroups() {
      var _this5 = this;

      // Reset filtering when search string is empty
      if (!this.kpiGroupsOfSelectedClient || this.kpiGroupsOfSelectedClient.length < 1) {
        this.filteredKpiGroups = this.kpiGroupsOfSelectedClient;
        return;
      }

      var words = this.filterKpiGroupString.split(" ");
      var keys = ["KPIGroupId", "KPIGroupCode", "KPIGroupShortText"];

      var kpiGroupFilter = function kpiGroupFilter(kpiGroup) {
        var isKpiGroupInList = _this5.kpiGroupsOfSelectedClient.find(function (element) {
          return element.KPIGroupGuid === kpiGroup.KPIGroupGuid;
        });
        if (!isKpiGroupInList) return false;

        var containsSearch = false;
        words.forEach(function (word) {
          keys.forEach(function (key) {
            if (kpiGroup[key] && kpiGroup[key].toString().toLowerCase().indexOf(word.toLowerCase()) > -1) {
              containsSearch = true;
              return;
            }
          });
        });
        return containsSearch;
      };
      this.filteredKpiGroups = this.kpiGroupsOfSelectedClient.filter(kpiGroupFilter);
    },
    filterClientProjectList: function filterClientProjectList() {
      var _this6 = this;

      this.clientProjectList = [];
      if (this.selectedClientGuid) {
        var listOfClientProjects = this.projectList.filter(function (project) {
          return project.ClientGuid === _this6.selectedClientGuid;
        });
        if (listOfClientProjects.length > 0) {
          this.clientProjectList = listOfClientProjects[0].Projects;
          this.sortClientProjectList();
        }
      }
    },
    sortClientProjectList: function sortClientProjectList() {
      this.clientProjectList.sort(function (a, b) {
        // Sort projects by name
        if (a.ProjectName.toLowerCase() < b.ProjectName.toLowerCase()) return -1;
        if (a.ProjectName.toLowerCase() > b.ProjectName.toLowerCase()) return 1;
        return 0;
      });
    },
    getKpisOfSelectedKpiGroup: function getKpisOfSelectedKpiGroup() {
      var _this7 = this;

      var queryString = "api/KPIGroups/" + this.selectedKpiGroupGuid;

      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this7.selectedKpiGroupInformation = data[0] || {};
          _this7.selectedProjectGuid = _this7.selectedKpiGroupInformation.Projects.length > 0 ? _this7.selectedKpiGroupInformation.Projects[0].ProjectGuid : "";

          _this7.kpisOfSelectedKpiGroup = data[0].KPIs || [];
          _this7.sortKpisByGroupPosition();
        },
        error: function error() {
          console.error("KPI data request failed in getKpisOfSelectedKpiGroup()");
          _this7.globals.showErrorSnackbar("KPI data request failed");
        }
      });
    },
    getSelectedKpiGroupInformation: function getSelectedKpiGroupInformation() {
      if (!this.globals.isAccessAllowed("LoopOp_KPIGroups_Read")) {
        this.globals.showErrorSnackbar("Access forbidden");
        console.error("Access forbidden: LoopOp_KPIGroups_Read");
        this.selectedKpiGroupGuid = "";
        return;
      }

      if (!this.selectedKpiGroupGuid) return;
      this.getKpisOfSelectedKpiGroup();
      this.selectedKpiGroupDirty = false;
      this.changeKpiOrderDirty = false;
      this.showAlert = false;
      this.resetValidationErrors("editKPIGroupDialog");
    },
    getKpiGroupData: function getKpiGroupData() {
      if (this.selectedTab === "editKpiGroupTab" || this.selectedTab === "kpiOrderTab") this.getSelectedKpiGroupInformation();
      if (this.selectedTab === "kpiGroupOrderTab") {
        this.changeKpiGroupOrderDirty = false;
        this.getKpiGroupsOfSelectedClient();
      }
    },
    getClientProject: function getClientProject(projectGuid) {
      var result = this.clientProjectList.find(function (element) {
        return element.ProjectGuid === projectGuid;
      });
      return { ProjectGuid: result.ProjectGuid };
    },
    saveEditKPIGroupDialogData: function saveEditKPIGroupDialogData() {
      var _this8 = this;

      if (!this.globals.isAccessAllowed("LoopOp_KPIGroups_Create") && !this.selectedKpiGroupGuid) {
        this.globals.showErrorSnackbar("Access forbidden");
        console.error("Access forbidden: LoopOp_KPIGroups_Create");
        return;
      } else if (!this.globals.isAccessAllowed("LoopOp_KPIGroups_Update") && this.selectedKpiGroupGuid) {
        this.globals.showErrorSnackbar("Access forbidden");
        console.error("Access forbidden: LoopOp_KPIGroups_Update");
        return;
      }

      var queryString = !this.selectedKpiGroupGuid ? "api/KPIGroups/Client/" + this.selectedClientGuid // new kpi group
      : "api/KPIGroups/" + this.selectedKpiGroupGuid; // update exisiting kpi group

      this.selectedKpiGroupInformation.Projects = [];
      if (this.selectedProjectGuid) {
        var clientProject = this.getClientProject(this.selectedProjectGuid);
        this.selectedKpiGroupInformation.Projects.push(clientProject);
      }

      if (this.selectedKpiGroupInformation.KPIGroupWeight === "") delete this.selectedKpiGroupInformation.KPIGroupWeight;

      if (!this.selectedKpiGroupGuid) {
        // create new kpi group
        $.ajax({
          method: "POST",
          url: queryString,
          data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedKpiGroupInformation),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            _this8.globals.showSuccessSnackbar("KPI Group creation successful");
            _this8.selectedKpiGroupGuid = data[0].KPIGroupGuid;
            _this8.selectedKpiGroupInformation = _.cloneDeep(data[0]);
            _this8.selectedKpiGroupDirty = false;
            _this8.getKpiGroupsOfSelectedClient();
          },
          error: function error() {
            console.error("Error on POST in saveEditKPIGroupDialogData()");
            _this8.globals.showErrorSnackbar("KPI Group creation failed");
          }
        });
      } else {
        // update exisiting kpi group
        $.ajax({
          method: "PUT",
          url: queryString,
          data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedKpiGroupInformation),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            _this8.globals.showSuccessSnackbar("KPI Group update successful");
            _this8.selectedKpiGroupDirty = false;
            _this8.getKpiGroupsOfSelectedClient();
          },
          error: function error() {
            console.error("Error on PUT in saveEditKPIGroupDialogData()");
            _this8.globals.showErrorSnackbar("KPI Group update failed");
          }
        });
      }
    },
    openDeleteKpiGroupConfirmationDialog: function openDeleteKpiGroupConfirmationDialog() {
      if (!this.globals.isAccessAllowed("LoopOp_KPIGroups_Delete")) {
        this.globals.showErrorSnackbar("Access forbidden");
        console.error("Access forbidden: LoopOp_KPIGroups_Delete");
        return;
      }

      this.globals.$emit("openGlobalConfirmationDialog", this.getDeleteDialogData());
    },
    getDeleteDialogData: function getDeleteDialogData() {
      return {
        initiator: "KPIGroupDeleteModal",
        confirmationTitle: this.lang.KM4020,
        colorRed: true,
        yesButtonText: this.lang.KM4022,
        noButtonText: this.lang.KM4023,
        htmlText: "<p><b>" + this.lang.KM4021 + "</b></p>\n        <div class=\"form-group\">\n          <label class=\"col-md-4 text-black\">" + this.lang.KM4024 + "</label>\n          <label class=\"col-md-8 text-black\">" + this.selectedKpiGroupInformation.KPIGroupId + "</label>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-md-4 text-black\">" + this.lang.KM4025 + "</label>\n          <label class=\"col-md-8 text-black\">" + this.selectedKpiGroupInformation.KPIGroupCode + "</label>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-md-4 text-black\">" + this.lang.KM4026 + "</label>\n          <label class=\"col-md-8 text-black\">" + this.selectedKpiGroupInformation.KPIGroupShortText + "</label>\n        </div>"
      };
    },
    deleteSelectedKpiGroup: function deleteSelectedKpiGroup() {
      var _this9 = this;

      var queryString = "api/KPIGroups/" + this.selectedKpiGroupGuid;

      $.ajax({
        method: "DELETE",
        url: queryString,
        success: function success(data) {
          // If delete was successful, refresh displayed data and hide dialog
          _this9.globals.showSuccessSnackbar("KPI group deletion successful");
          _this9.createNewKpiGroup();
          _this9.getKpiGroupsOfSelectedClient();
          _this9.$forceUpdate();
        },
        error: function error() {
          console.error("KPI group deletion failed in deleteSelectedKpiGroup()");
          _this9.globals.showErrorSnackbar("KPI group deletion failed");
        }
      });
    },

    // Reorders kpis of a kpi group after the position of a kpi changed
    reorderKpisInKpiGroup: function reorderKpisInKpiGroup() {
      var _this10 = this;

      var numberOfKpis = this.kpisOfSelectedKpiGroup.length,
          allPositions = _.range(1, numberOfKpis + 1),
          missingPos = 0,
          newPos = 0,
          kpiGuid = "";

      // Find missing position number and the position and code of the changed kpi
      allPositions.forEach(function (position, index) {
        if (position !== _this10.kpisOfSelectedKpiGroup[index].KPIGroupPosition) {
          missingPos = position;
          newPos = _this10.kpisOfSelectedKpiGroup[index].KPIGroupPosition;
          kpiGuid = _this10.kpisOfSelectedKpiGroup[index].KPIGuid;
        }
      });

      if (missingPos === 0) return; // No position missing -> no value changed

      // Move position numbers between new position number and missing position number
      for (var i = 0; i < allPositions.length; i++) {
        if (this.kpisOfSelectedKpiGroup[i].KPIGuid !== kpiGuid) {
          // Do NOT move the changed kpi
          if (this.kpisOfSelectedKpiGroup[i].KPIGroupPosition < missingPos && this.kpisOfSelectedKpiGroup[i].KPIGroupPosition >= newPos) this.kpisOfSelectedKpiGroup[i].KPIGroupPosition++;
          if (this.kpisOfSelectedKpiGroup[i].KPIGroupPosition > missingPos && this.kpisOfSelectedKpiGroup[i].KPIGroupPosition <= newPos) this.kpisOfSelectedKpiGroup[i].KPIGroupPosition--;
        }
      }
      this.sortKpisByGroupPosition();
    },

    // Sorts the available kpis by their position number
    sortKpisByGroupPosition: function sortKpisByGroupPosition() {
      if (this.kpisOfSelectedKpiGroup.length < 0) return;
      this.kpisOfSelectedKpiGroup.sort(function (a, b) {
        return a.KPIGroupPosition - b.KPIGroupPosition;
      });
    },
    saveKpisNewOrder: function saveKpisNewOrder() {
      var _this11 = this;

      // save new kpi order in selected kpi group
      var queryString = "api/KPIGroups/" + this.selectedKpiGroupGuid;
      this.selectedKpiGroupInformation.KPIs = this.kpisOfSelectedKpiGroup;

      $.ajax({
        method: "PUT",
        url: queryString,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedKpiGroupInformation),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          _this11.globals.showSuccessSnackbar("Save KPI Position successful");
          _this11.changeKpiOrderDirty = false;
          _this11.getKpiGroupsOfSelectedClient();
        },
        error: function error() {
          console.error("Error on PUT in saveKpisNewOrder()");
          _this11.globals.showErrorSnackbar("Save KPI Position failed");
        }
      });
    },

    // Reorders kpiGroups from a client after the position of a kpiGroup changed
    reorderKpiGroups: function reorderKpiGroups() {
      var _this12 = this;

      var numberOfKpiGroups = this.kpiGroupsOfSelectedClient.length,
          allPositions = _.range(1, numberOfKpiGroups + 1),
          missingPos = 0,
          newPos = 0,
          kpiGroupGuid = "";

      // Find missing position number and the position and code of the changed kpiGroup
      allPositions.forEach(function (position, index) {
        if (position !== _this12.kpiGroupsOfSelectedClient[index].KPIGroupPosition) {
          missingPos = position;
          newPos = _this12.kpiGroupsOfSelectedClient[index].KPIGroupPosition;
          kpiGroupGuid = _this12.kpiGroupsOfSelectedClient[index].KPIGroupGuid;
        }
      });

      if (missingPos === 0) return; // No position missing -> no value changed

      // Move position numbers between new position number and missing position number
      for (var i = 0; i < allPositions.length; i++) {
        if (this.kpiGroupsOfSelectedClient[i].KPIGroupGuid !== kpiGroupGuid) {
          // Do NOT move the changed kpiGroup
          if (this.kpiGroupsOfSelectedClient[i].KPIGroupPosition < missingPos && this.kpiGroupsOfSelectedClient[i].KPIGroupPosition >= newPos) this.kpiGroupsOfSelectedClient[i].KPIGroupPosition++;
          if (this.kpiGroupsOfSelectedClient[i].KPIGroupPosition > missingPos && this.kpiGroupsOfSelectedClient[i].KPIGroupPosition <= newPos) this.kpiGroupsOfSelectedClient[i].KPIGroupPosition--;
        }
      }
      this.sortKpiGroupsByPosition();
    },

    // Sorts the available kpi groups by their position number
    sortKpiGroupsByPosition: function sortKpiGroupsByPosition() {
      if (this.kpiGroupsOfSelectedClient.length < 0) return;
      this.kpiGroupsOfSelectedClient.sort(function (a, b) {
        return a.KPIGroupPosition - b.KPIGroupPosition;
      });
    },
    generateKpiGroupNewOrderPayload: function generateKpiGroupNewOrderPayload() {
      return this.kpiGroupsOfSelectedClient.map(function (kpiGroup) {
        return {
          KPIGroupGuid: kpiGroup.KPIGroupGuid,
          KPIGroupPosition: kpiGroup.KPIGroupPosition
        };
      });
    },
    saveKpiGroupsNewOrder: function saveKpiGroupsNewOrder() {
      var _this13 = this;

      var queryString = "api/KPIGroups/Positions/Client/" + this.selectedClientGuid;
      var payload = this.generateKpiGroupNewOrderPayload();
      $.ajax({
        method: "PUT",
        url: queryString,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          _this13.globals.showSuccessSnackbar("Save KPI Group Postion successful");
          _this13.changeKpiGroupOrderDirty = false;
          _this13.getKpiGroupsOfSelectedClient();
        },
        error: function error() {
          console.error("Error on PUT in saveKpiGroupsNewOrder()");
          _this13.globals.showErrorSnackbar("Save KPI Group Position failed");
        }
      });
    },

    // Triggers input validation and ensures further progress if validation was successful
    validateBeforeSubmit: function validateBeforeSubmit(dialog) {
      var result = true;
      var elements = $("#" + dialog).find(":input"); // Returns a list of all inputs on the dialog
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0) result = this.validateInput(elements[i].id) && result; // If only one input is invalid, the whole form is invalid
      }
      if (dialog === "editKPIGroupDialog") {
        this.showAlert = !result;
        if (!result) return;
        this.saveEditKPIGroupDialogData();
      }
    },

    // Validates an input with the given id, changes the input color depending on the validation result and returns the result
    validateInput: function validateInput(id) {
      var result = $("#" + id)[0].checkValidity(); // Checks validation depending on the input type or a given pattern in the template
      if (result) {
        $("#" + id).parent().parent().removeClass("has-error"); // has-error has to be added to the form-group element
        var idx = this.invalidInputIds.indexOf(id);
        if (idx > -1) {
          this.invalidInputIds.splice(idx, 1); // Remove from list, if valid
        }
      } else {
        $("#" + id).parent().parent().addClass("has-error");
        if (this.invalidInputIds.indexOf(id) < 0) this.invalidInputIds.push(id); // Add to list, if invalid
      }
      return result;
    },

    // Returns true if an input has a validation error, otherwise false
    inputHasError: function inputHasError(id) {
      return this.invalidInputIds.indexOf(id) > -1 ? true : false;
    },

    // Resets all validation errors for the given dialog
    resetValidationErrors: function resetValidationErrors(dialog) {
      var elements = $("#" + dialog).find(":input"); // Returns a list of all inputs on the dialog
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0) $("#" + elements[i].id).parent().parent().removeClass("has-error");
      }
      this.invalidInputIds = [];
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__KPIManagementEditModal__ = __webpack_require__(1577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__KPIManagementEditModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__KPIManagementEditModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__KPIManagementTranslateModal__ = __webpack_require__(1578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__KPIManagementTranslateModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__KPIManagementTranslateModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__KPIGroupEditModal_vue__ = __webpack_require__(1575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__KPIGroupEditModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__KPIGroupEditModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__KPIAssignmentModal_vue__ = __webpack_require__(1573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__KPIAssignmentModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__KPIAssignmentModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__KPICopyModal__ = __webpack_require__(1574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__KPICopyModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__KPICopyModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Tools_Select2__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Tools_Select2__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: "KPIManagement",
  components: {
    "kpi-group-edit-modal": __WEBPACK_IMPORTED_MODULE_5__KPIGroupEditModal_vue___default.a,
    "kpi-management-edit-modal": __WEBPACK_IMPORTED_MODULE_3__KPIManagementEditModal___default.a,
    "kpi-assignment-modal": __WEBPACK_IMPORTED_MODULE_6__KPIAssignmentModal_vue___default.a,
    "kpi-management-translate-modal": __WEBPACK_IMPORTED_MODULE_4__KPIManagementTranslateModal___default.a,
    KPICopyModal: __WEBPACK_IMPORTED_MODULE_7__KPICopyModal___default.a,
    Select2: __WEBPACK_IMPORTED_MODULE_8__Tools_Select2___default.a
  },
  data: function data() {
    return {
      showEditKpiDialog: false,
      showTranslateKpiDialog: false,
      showKpiGroupEditDialog: false,
      showKpiAssignmentDialog: false,
      showKPICopyModal: false,
      clientList: [],
      importerList: [],
      projectList: [],
      clientProjectList: [],
      filteredKpiData: [],
      kpiDataOnCurrentPage: [],
      refreshEnabled: false, // false, if kpi data is requested and server did not respond yet to avoid multiple requests at the same time
      kpiData: [], // List of all kpis
      selectedKpiGuid: "", // GUID of the selected kpi
      selectedKpiData: {},
      searchString: "",
      pageSize: 20, // Number of kpis on one page of the table
      selectedPage: 1, // Number of the page, that is visible
      selectedClient: "",
      selectedImporter: "",
      selectedProject: "",
      clientInformation: {},
      kpiGroupEvaluationRulesList: [],
      kpiEvaluationRulesList: [],
      columnFilterObject: {
        KPICode: "",
        KPIShortText: "",
        KPILongText: "",
        KPIGroups: "",
        ClientName: "",
        Importers: "",
        Projects: "",
        SurveyIdString: "",
        KPIEvaluationRuleName: ""
      },
      currentSort: { key: "KPICode", asc: true },
      selectedClientForKpiTranslation: {},
      lang: {
        // Contains localization strings for the selected language
        KM0000: "Refresh",
        KM0001: "KPI Management",
        KM0002: "Search...",
        KM0003: "Items per page",
        KM0004: "First page",
        KM0005: "Last page",
        KM0006: "KPI Code",
        KM0007: "KPI Shorttext",
        KM0008: "KPI Longtext",
        KM0009: "Translation",
        KM0010: "KPI Groups",
        KM0011: "Please select a client...",
        KM0012: "Please select a project...",
        KM0013: "Client",
        KM0014: "Filter",
        KM0015: "Project",
        KM0016: "Calculation rule",
        KM0017: "Assignment",
        KM0018: "Please select an importer...",
        KM0019: "Importer",
        KM0020: "Total KPIs count",
        KM0021: "Copy KPI data"
      }
    };
  },

  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.readComponentSettingsFromStore();
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
    this.getKpiGroupEvaluationRulesList();
    this.getKpiEvaluationRulesList();
    this.globals.getClientList(function (data) {
      _this.clientList = data;
      if (_this.feature.isAudiTarget && _this.feature.isEnabled("audi_importers") && _this.clientList[0]) {
        _this.selectedClient = _this.clientList[0].ClientGuid;
        _this.onClientSelection();
      }
      _this.$emit("ClientListReceived");
    });
    this.globals.getProjectList(function (data) {
      _this.projectList = data;
      if (_this.selectedClient) _this.getClientProjectList();
      _this.$emit("ProjectListReceived");
    });

    if (this.feature.isAudiTarget && this.feature.isEnabled("audi_importers")) {
      this.globals.getImporterList(function (data) {
        _this.importerList = data;
      });
    }

    $(window).on("resize", this.setTableHeight).resize();

    if (!this.globals.currentUserInfo) this.globals.$once("currentUserInfoReceived", this.setTableHeight);
  },
  destroyed: function destroyed() {
    $(window).off("resize", this.setTableHeight);
    this.writeComponentSettingsToStore();
  },

  methods: {
    setTableHeight: function setTableHeight() {
      this.$nextTick(function () {
        var height = $(window).height();
        height -= $("#kpi-top-panel").height() + $("#app-navbar").height() + $(".main-table > thead").height() + 47;
        $(".main-table-scrollbar").css("max-height", height);
      });
    },
    readComponentSettingsFromStore: function readComponentSettingsFromStore() {
      var _this2 = this;

      if (!this.$store.getters["userSettings/rememberFilters"]) return;

      this.$filterRestorePending = true;
      var restoreDone = function restoreDone() {
        if (_this2.$refs.clientSelect) _this2.$refs.clientSelect.updateValue();
        if (_this2.$refs.importerSelect) _this2.$refs.importerSelect.updateValue();
        if (_this2.$refs.projectSelect) _this2.$refs.projectSelect.updateValue();

        delete _this2.$filterRestorePending;
        _this2.getKpiData();
      };
      var restoreFilters = function restoreFilters() {
        _this2.$nextTick(function () {
          var storedData = _this2.$store.getters["localFilters/kpiManagement"];
          if (storedData) {
            for (var key in storedData) {
              if (_.has(_this2, key)) _this2[key] = _.cloneDeep(storedData[key]);
              if (key === "selectedClient") _this2.onClientSelection();
            }
          }

          if (!_this2.$store.getters["userSettings/syncFilters"]) {
            restoreDone();
            return;
          }
          if (!_this2.feature.isAudiTarget || !_this2.feature.isEnabled("audi_importers")) {
            var storedClient = _this2.$store.getters["sharedFilters/client"];
            _this2.selectedClient = storedClient.ClientGuid || "";
            _this2.onClientSelection();
          } else {
            var storedImporter = _this2.$store.getters["sharedFilters/importer"];
            _this2.selectedImporter = storedImporter.ImporterGuid || "";
          }

          var storedProject = _this2.$store.getters["sharedFilters/project"];
          _this2.selectedProject = storedProject.ProjectGuid || "";

          restoreDone();
        });
      };
      this.globals.doAfterEvents(["ClientListReceived", "ProjectListReceived"], restoreFilters, this);
    },
    writeComponentSettingsToStore: function writeComponentSettingsToStore() {
      var _this3 = this;

      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      this.$store.commit("localFilters/kpiManagement", {
        selectedClient: this.selectedClient,
        selectedImporter: this.selectedImporter,
        selectedProject: this.selectedProject,
        columnFilterObject: this.columnFilterObject,
        searchString: this.searchString,
        currentSort: this.currentSort,
        pageSize: this.pageSize
      });

      if (!this.$store.getters["userSettings/syncFilters"]) return;
      if (!this.feature.isAudiTarget || !this.feature.isEnabled("audi_importers")) {
        if (this.selectedClient) {
          var client = _.find(this.clientList, function (c) {
            return c.ClientGuid === _this3.selectedClient;
          });
          if (client) this.$store.commit("sharedFilters/client", client);
        } else {
          var storedClient = this.$store.getters["sharedFilters/client"];
          if (storedClient.ClientGuid) this.$store.commit("sharedFilters/client");
        }
      } else {
        if (this.selectedImporter) {
          var importer = _.find(this.importerList, function (i) {
            return i.ImporterGuid === _this3.selectedImporter;
          });
          if (importer) this.$store.commit("sharedFilters/importer", importer);
        } else {
          var storedImporter = this.$store.getters["sharedFilters/importer"];
          if (storedImporter.ImporterGuid) this.$store.commit("sharedFilters/importer");
        }
      }

      if (this.selectedProject) {
        var project = _.find(this.clientProjectList, function (p) {
          return p.ProjectGuid === _this3.selectedProject;
        });
        if (project) this.$store.commit("sharedFilters/project", project);
      } else {
        var storedProject = this.$store.getters["sharedFilters/project"];
        if (storedProject.ProjectGuid) this.$store.commit("sharedFilters/project");
      }
    },
    onClientSelection: function onClientSelection() {
      this.selectedKpiGuid = "";
      this.selectedKpiData = {};
      this.getKpiData();
      this.getClientProjectList();
      this.getClientInformation();
    },
    disableButtonNoClientSelected: function disableButtonNoClientSelected() {
      return !this.selectedClient;
    },
    getClientInformation: function getClientInformation() {
      var _this4 = this;

      if (this.selectedClient) this.clientInformation = this.clientList.find(function (client) {
        return client.ClientGuid === _this4.selectedClient;
      });
    },

    // Select Customer Project
    getClientProjectList: function getClientProjectList() {
      var _this5 = this;

      this.selectedProject = "";
      this.clientProjectList = [];
      if (this.selectedClient) {
        var listOfClientProjects = this.projectList.filter(function (project) {
          return project.ClientGuid === _this5.selectedClient;
        });
        if (listOfClientProjects.length > 0) {
          this.clientProjectList = listOfClientProjects[0].Projects;
          this.sortClientProjectList();
        }
      }
    },
    sortClientProjectList: function sortClientProjectList() {
      this.clientProjectList.sort(function (a, b) {
        // Sort projects by name
        if (a.ProjectName.toLowerCase() < b.ProjectName.toLowerCase()) return -1;
        if (a.ProjectName.toLowerCase() > b.ProjectName.toLowerCase()) return 1;
        return 0;
      });
    },
    getKpiData: function getKpiData() {
      var _this6 = this;

      if (this.$filterRestorePending) return;
      if (!this.selectedClient) {
        this.kpiData = [];
        this.doFiltering();
        return;
      }
      this.refreshEnabled = false;
      var queryString = "api/KPIs/Client/" + this.selectedClient;

      if (this.selectedImporter) queryString += "?ImporterGuid=" + this.selectedImporter;

      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this6.kpiData = !_.isEmpty(data) ? data : [];
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_this6.kpiData), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var kpi = _step.value;

              kpi.SurveyIdString = _this6.getSurveyIdListString(kpi.Surveys);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          _this6.doFiltering();
        },
        error: function error() {
          console.error("KPI data request failed in getKpiData()");
          _this6.globals.showErrorSnackbar("KPI data access failed");
        },
        complete: function complete() {
          _this6.refreshEnabled = true;
        }
      });
    },
    getKpiGroupEvaluationRulesList: function getKpiGroupEvaluationRulesList() {
      var _this7 = this;

      var queryString = "api/KPIGroups/Data/EvaluationRules";

      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this7.kpiGroupEvaluationRulesList = [];
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(data).forEach(function (_ref) {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
                key = _ref2[0],
                value = _ref2[1];

            return _this7.kpiGroupEvaluationRulesList.push({
              EvaluationRuleGuid: key,
              EvaluationRule: value
            });
          });
        },
        error: function error() {
          console.error("KPI group evaluation rules access failed in getKpiGroupEvaluationRulesList()");
          _this7.globals.showErrorSnackbar("Evaluation rules access failed");
        }
      });
    },
    getKpiEvaluationRulesList: function getKpiEvaluationRulesList() {
      var _this8 = this;

      var queryString = "api/KPIs/Data/EvaluationRules";

      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this8.kpiEvaluationRulesList = [];
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(data).forEach(function (_ref3) {
            var _ref4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
                key = _ref4[0],
                value = _ref4[1];

            return _this8.kpiEvaluationRulesList.push({
              EvaluationRuleGuid: key,
              EvaluationRule: value
            });
          });
        },
        error: function error() {
          console.error("KPI evaluation rules access failed in getKpiEvaluationRulesList()");
          _this8.globals.showErrorSnackbar("Evaluation rules access failed");
        }
      });
    },
    getSurveyIdListString: function getSurveyIdListString(surveys) {
      if (!surveys || !surveys.length) return "";
      var result = "";
      for (var i = 0; i < surveys.length; i++) {
        result += surveys[i].SurveyId;
        if (i < surveys.length - 1) result += ", ";
      }
      return result;
    },
    showSortArrow: function showSortArrow(key, asc) {
      return this.currentSort.key === key && this.currentSort.asc === asc;
    },
    orderTableByColumn: function orderTableByColumn(orderProp) {
      var _this9 = this;

      // Nothing to sort by => return
      if (!orderProp && !this.currentSort.key) return;

      if (orderProp) {
        this.currentSort.key === orderProp ? this.currentSort.asc = !this.currentSort.asc : this.currentSort = { asc: true, key: orderProp };
      }

      var sortFunction = function sortFunction(kpi) {
        if (typeof kpi[_this9.currentSort.key] === "string") {
          return kpi[_this9.currentSort.key].toLowerCase();
        } else if (Array.isArray(kpi[_this9.currentSort.key])) {
          if (kpi[_this9.currentSort.key][0].KPIGroupCode) return kpi[_this9.currentSort.key][0].KPIGroupCode.toLowerCase();
          if (kpi[_this9.currentSort.key][0].ProjectName) return kpi[_this9.currentSort.key][0].ProjectName.toLowerCase();
          if (kpi[_this9.currentSort.key][0].ImporterName) return kpi[_this9.currentSort.key][0].ImporterName.toLowerCase();
        }
        return kpi[_this9.currentSort.key];
      };
      this.filteredKpiData = _.orderBy(this.filteredKpiData, [sortFunction], [this.currentSort.asc ? "asc" : "desc", "asc"]);
      this.loadCurrentPageOfKpiData();
    },
    doFiltering: function doFiltering() {
      var _this10 = this;

      // Reset filtering when search string is empty
      if (!this.searchString) this.filteredKpiData = this.kpiData;

      var words = this.searchString.split(" ");
      var keys = ["KPICode", "KPIShortText", "KPILongText", "KPIGroups", "ClientName", "Importers", "Projects", "SurveyIdString", "KPIEvaluationRuleName"];

      var filterStrings = this.columnFilterObject;

      var kpiFilter = function kpiFilter(kpi) {
        var containsSearch = false;
        words.forEach(function (word) {
          keys.forEach(function (key) {
            if (key === "KPIGroups") {
              if (kpi[key][0] && kpi[key][0].KPIGroupCode && kpi[key][0].KPIGroupCode.toString().toLowerCase().indexOf(word.toLowerCase()) > -1) {
                containsSearch = true;
                return;
              }
            } else if (key === "Projects") {
              if (kpi[key][0] && kpi[key][0].ProjectName && kpi[key][0].ProjectName.toString().toLowerCase().indexOf(word.toLowerCase()) > -1) {
                containsSearch = true;
                return;
              }
            } else if (key === "Importers") {
              if (kpi[key] && kpi[key][0].ImporterName.toString().toLowerCase().indexOf(word.toLowerCase()) > -1) {
                containsSearch = true;
                return;
              }
            } else if (kpi[key] && kpi[key].toString().toLowerCase().indexOf(word.toLowerCase()) > -1) {
              containsSearch = true;
              return;
            }
          });
        });
        if (!containsSearch) return false; // KPI does not match search string

        keys.forEach(function (key) {
          if (!containsSearch) return;

          if (key === "KPIGroups") {
            if (kpi[key][0] && kpi[key][0].KPIGroupCode && kpi[key][0].KPIGroupCode.toString().toLowerCase().indexOf(filterStrings[key].toLowerCase()) < 0) {
              containsSearch = false;
              return;
            }
          } else if (key === "Projects") {
            if (kpi[key][0] && kpi[key][0].ProjectName && kpi[key][0].ProjectName.toString().toLowerCase().indexOf(filterStrings[key].toLowerCase()) < 0) {
              containsSearch = false;
              return;
            }
          } else if (key === "Importers") {
            if (!kpi[key] && filterStrings[key] || kpi[key] && kpi[key][0].ImporterName.toString().toLowerCase().indexOf(filterStrings[key].toLowerCase()) < 0) {
              containsSearch = false;
              return;
            }
          } else if (!kpi[key] && filterStrings[key] || kpi[key] && kpi[key].toString().toLowerCase().indexOf(filterStrings[key].toLowerCase()) < 0) {
            containsSearch = false; // KPI does not match filterstring
            return;
          }
        });
        return containsSearch;
      };

      this.filteredKpiData = !_.isEmpty(this.kpiData) ? this.kpiData.filter(kpiFilter) : [];

      // Filter kpi data for selected project
      if (this.selectedProject) {
        this.filteredKpiData = this.filteredKpiData.filter(function (kpi) {
          return kpi.Projects[0].ProjectGuid === _this10.selectedProject;
        });
      }

      this.currentSort.asc = !this.currentSort.asc;
      this.orderTableByColumn(this.currentSort.key);
    },

    // Returns a list of all pagenumbers that should be visible depending on the current page and the count of pages
    getVisiblePages: function getVisiblePages() {
      if (this.numberOfPages() <= 7) {
        return _.range(1, this.numberOfPages() + 1);
      } else if (this.numberOfPages() > 7 && this.selectedPage <= 4) {
        return _.range(1, 7);
      } else if (this.numberOfPages() > 7 && this.selectedPage >= this.numberOfPages() - 3) {
        return _.range(this.numberOfPages() - 5, this.numberOfPages() + 1);
      } else {
        return _.range(this.selectedPage - 2, this.selectedPage + 3);
      }
    },
    updatePaging: function updatePaging(pageNumber, pageSize) {
      this.selectedPage = pageNumber;
      if (pageSize != 0) this.pageSize = pageSize;
      this.loadCurrentPageOfKpiData();
    },

    // Returns the count of pages depending on the selected pagesize and the length of the client data list
    numberOfPages: function numberOfPages() {
      if (this.pageSize == -1) return 1;
      if (this.filteredKpiData.length % this.pageSize == 0) return this.filteredKpiData.length / this.pageSize;else return parseInt(this.filteredKpiData.length / this.pageSize) + 1;
    },
    loadCurrentPageOfKpiData: function loadCurrentPageOfKpiData() {
      if (this.pageSize == -1) this.kpiDataOnCurrentPage = this.filteredKpiData;else {
        // Display all data, no pages
        this.kpiDataOnCurrentPage = [];
        var startIndex = (this.selectedPage - 1) * this.pageSize;
        for (var i = startIndex; i < startIndex + this.pageSize; i++) {
          if (this.filteredKpiData[i] != null) this.kpiDataOnCurrentPage[i - startIndex] = this.filteredKpiData[i];
        }
      }
    },
    openEditKpiDialog: function openEditKpiDialog() {
      if (!this.globals.isAccessAllowed("LoopOp_KPIGroups_ReadAll")) {
        this.globals.showErrorSnackbar("Access forbidden");
        console.error("Access forbidden: LoopOp_KPIGroups_ReadAll");
        return;
      }
      this.showEditKpiDialog = true;
    },
    onEditKpiDialogClosed: function onEditKpiDialogClosed() {
      this.showEditKpiDialog = false;
      this.getKpiData();
    },
    getSelectedClient: function getSelectedClient(clientGuid) {
      var client = this.clientList.find(function (client) {
        return client.ClientGuid === clientGuid;
      });
      return { clientGuid: client.ClientGuid, clientName: client.ClientName };
    },

    // Opens the dialog to translate kpis
    openKpiLanguageDialog: function openKpiLanguageDialog() {
      this.selectedClientForKpiTranslation = this.getSelectedClient(this.selectedClient);
      this.showTranslateKpiDialog = true;
    },

    // Gets executed after the translateKpiDialog got closed
    onTranslateKpiDialogClosed: function onTranslateKpiDialogClosed() {
      this.showTranslateKpiDialog = false;
    },
    openEditKpiDataDialog: function openEditKpiDataDialog() {
      this.showEditKpiDialog = true;
    },
    openKpiGroupEditModal: function openKpiGroupEditModal() {
      if (!this.globals.isAccessAllowed("LoopOp_KPIGroups_ReadAll")) {
        this.globals.showErrorSnackbar("Access forbidden");
        console.error("Access forbidden: LoopOp_KPIGroups_ReadAll");
        return;
      }
      this.showKpiGroupEditDialog = true;
    },
    onKpiGroupEditDialogClosed: function onKpiGroupEditDialogClosed() {
      this.showKpiGroupEditDialog = false;
      this.getKpiData();
    },
    openKpiAssignmentDialog: function openKpiAssignmentDialog() {
      if (!this.globals.isAccessAllowed("LoopOp_KPIsAssignment_Read")) {
        this.globals.showErrorSnackbar("Access forbidden");
        console.error("Access forbidden: LoopOp_KPIsAssignment_Read");
        return;
      }
      if (!this.globals.isAccessAllowed("LoopOp_KPIGroups_ReadAll")) {
        this.globals.showErrorSnackbar("Access forbidden");
        console.error("Access forbidden: LoopOp_KPIGroups_ReadAll");
        return;
      }
      this.showKpiAssignmentDialog = true;
    },
    onKpiAssignmentDialogDialogClosed: function onKpiAssignmentDialogDialogClosed() {
      this.showKpiAssignmentDialog = false;
      this.getKpiData();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tools_Select2__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Tools_Select2__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "KPIManagementEditModal",
  components: {
    Select2: __WEBPACK_IMPORTED_MODULE_1__Tools_Select2___default.a
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#editKpiDialog").on("hide.bs.modal", function (e) {
      _this.$emit("dialogClosed");
    });

    this.globals.$off("KPIDeleteModalYesConfirmation");
    this.globals.$on("KPIDeleteModalYesConfirmation", function () {
      _this.deleteSelectedKpi();
    });
  },

  props: ["showDialog", "clientList", "selectedClientForKpi", "projectList", "kpiEvaluationRulesList"],
  watch: {
    showDialog: function showDialog() {
      this.showDialog ? this.openEditKpiDialog() : this.closeEditKpiDialog();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  data: function data() {
    return {
      selectedClient: "",
      kpiGroupsOfSelectedClient: [],
      selectedTab: "editKpiTab",
      selectedKpiGroupGuid: "",
      kpisOfSelectedKpiGroup: [],
      selectedKpiDirty: false,
      selectedKpiGuid: "",
      invalidInputIds: [],
      showAlert: false,
      changeKpiOrderDirty: false,
      selectedKpiGroupInformation: {},
      clientProjectList: [],
      selectedProjectGuid: "",
      projectKpiGroupList: [],
      selectedKpiInformation: {
        KPICode: "",
        KPIShortText: "",
        KPILongText: "",
        KPIDescription: "",
        KPIGroups: []
      },
      lang: {
        KM2000: "KPI Management",
        KM2001: "Select a KPI Group…",
        KM2002: "Position",
        KM2003: "KPI Code",
        KM2004: "KPI Shorttext",
        KM2005: "Edit KPI",
        KM2006: "KPI Order",
        KM2007: "KPI Code",
        KM2008: "KPI Shorttext",
        KM2009: "KPI Longtext",
        KM2010: "Description",
        KM2011: "This is a required entry!",
        KM2012: "Your inputs are incorrect. Please check the fields marked in red!",
        KM2013: "New",
        KM2014: "Save",
        KM2015: "Delete",
        KM2016: "KPI Shorttext",
        KM2017: "Position",
        KM2018: "Close",
        KM2019: "Delete KPI",
        KM2020: "Yes",
        KM2021: "No",
        KM2022: "Do you really want to delete the following KPI?",
        KM2023: "ID",
        KM2024: "KPI Code",
        KM2025: "KPI Shorttext",
        KM2026: "Client",
        KM2027: "KPI Group",
        KM2028: "Evaluation rule",
        KM2029: "Project",
        KM2030: "Please select a project...",
        KM2031: "Inherited",
        KM2032: "Weight",
        KM2033: "Save positions",
        KM2034: "KPI Shorttext – max. 50 characters, will be visible in Cockpit",
        KM2035: "KPI Longtext – max. 200 characters",
        KM2036: "Weight of the KPI within the KPI Group",
        KM2037: "KPI Code – max. 200 characters"
      }
    };
  },

  computed: {
    nameOfSelectedClient: function nameOfSelectedClient() {
      var _this2 = this;

      if (this.selectedClient === "") return " - ";
      var client = this.clientList.find(function (c) {
        return c.ClientGuid === _this2.selectedClient;
      });
      return client ? client.ClientName : " - ";
    },
    nameOfSelectedKpiGroup: function nameOfSelectedKpiGroup() {
      var _this3 = this;

      if (this.selectedKpiGroupGuid === "") return " - ";
      var kpiGroup = this.kpiGroupsOfSelectedClient.find(function (element) {
        return element.KPIGroupGuid === _this3.selectedKpiGroupGuid;
      });
      return kpiGroup ? kpiGroup.KPIGroupShortText : " - ";
    },
    nameOfSelectedEvaluationRuleGuid: function nameOfSelectedEvaluationRuleGuid() {
      var _this4 = this;

      if (this.selectedKpiGroupGuid === "") return " - ";
      var kpiGroup = this.kpiGroupsOfSelectedClient.find(function (element) {
        return element.KPIGroupGuid === _this4.selectedKpiGroupGuid;
      });
      var evaluationRule = this.kpiEvaluationRulesList.find(function (element) {
        return element.EvaluationRuleGuid === kpiGroup.KPIEvaluationRuleGuid;
      });
      return evaluationRule ? evaluationRule.EvaluationRule : " - ";
    },
    nameOfSelectedProject: function nameOfSelectedProject() {
      var _this5 = this;

      if (this.selectedProjectGuid === "") return " - ";
      var projectName = this.clientProjectList.filter(function (project) {
        return project.ProjectGuid === _this5.selectedProjectGuid;
      });
      return projectName ? projectName[0].ProjectName : " - ";
    }
  },
  methods: {
    initEditKpiDialog: function initEditKpiDialog() {
      this.createNewKpi();
      this.selectedClient = this.selectedClientForKpi;
      this.getKpiGroupsOfSelectedClient();
      this.selectedKpiGuid = "";
      this.selectedKpiGroupGuid = "";
      this.changeKpiOrderDirty = false;
      this.kpiGroupsOfSelectedClient = [];
      this.kpisOfSelectedKpiGroup = [];
      this.selectedKpiGroupInformation = {};
    },
    createNewKpi: function createNewKpi() {
      this.selectedKpiInformation = {
        KPICode: "",
        KPIShortText: "",
        KPILongText: "",
        KPIDescription: "",
        KPIGroups: []
      };
      this.selectedKpiGuid = "";
      this.showAlert = false;
      this.selectedKpiDirty = false;
      this.resetValidationErrors("editKpiDialog");
    },
    openEditKpiDialog: function openEditKpiDialog() {
      $("#editKpiDialog").modal("show");
      this.initEditKpiDialog();
      this.getClientProjectList();
    },
    closeEditKpiDialog: function closeEditKpiDialog() {
      $("#editKpiDialog").modal("hide");
    },
    getClientProjectList: function getClientProjectList() {
      var _this6 = this;

      this.selectedProjectGuid = "";
      this.selectedKpiGroupGuid = "";
      this.clientProjectList = [];
      this.kpisOfSelectedKpiGroup = [];

      if (this.selectedClient) {
        var listOfClientProjects = this.projectList.filter(function (project) {
          return project.ClientGuid === _this6.selectedClient;
        });
        if (listOfClientProjects.length > 0) {
          this.clientProjectList = listOfClientProjects[0].Projects;
          this.sortClientProjectList();
        }
      }
    },
    sortClientProjectList: function sortClientProjectList() {
      this.clientProjectList.sort(function (a, b) {
        if (a.ProjectName.toLowerCase() < b.ProjectName.toLowerCase()) return -1;
        if (a.ProjectName.toLowerCase() > b.ProjectName.toLowerCase()) return 1;
        return 0;
      });
    },
    getKpiGroupsOfSelectedClient: function getKpiGroupsOfSelectedClient() {
      var _this7 = this;

      if (!this.selectedClient) return;
      this.selectedKpiGroupGuid = "";
      this.kpisOfSelectedKpiGroup = [];
      this.createNewKpi();

      var queryString = "api/KPIGroups/Client/" + this.selectedClient;
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this7.kpiGroupsOfSelectedClient = !_.isEmpty(data) ? data : [];
          _this7.sortKpiGroups();
          _this7.filterKpiGroupsByProject();
        },
        error: function error() {
          console.error("Error on GET in getKpiGroupsOfSelectedClient()");
          _this7.globals.showErrorSnackbar("KPI Group request failed");
        }
      });
    },
    filterKpiGroupsByProject: function filterKpiGroupsByProject() {
      var _this8 = this;

      this.selectedKpiGroupGuid = "";
      this.projectKpiGroupList = [];

      if (this.selectedProjectGuid) {
        var listOfProjectKpiGroup = this.kpiGroupsOfSelectedClient.filter(function (kpiGroup) {
          if (!kpiGroup.Projects) return false;
          return kpiGroup.Projects[0].ProjectGuid === _this8.selectedProjectGuid;
        });
        if (listOfProjectKpiGroup.length > 0) this.projectKpiGroupList = listOfProjectKpiGroup;
      }
    },
    sortKpiGroups: function sortKpiGroups() {
      this.kpiGroupsOfSelectedClient.sort(function (a, b) {
        if (a.KPIGroupCode.toLowerCase() < b.KPIGroupCode.toLowerCase()) return -1;
        if (a.KPIGroupCode.toLowerCase() > b.KPIGroupCode.toLowerCase()) return 1;
        return 0;
      });
    },
    getKpisOfSelectedKpiGroup: function getKpisOfSelectedKpiGroup() {
      var _this9 = this;

      if (!this.selectedKpiGroupGuid) {
        this.kpisOfSelectedKpiGroup = [];
        return;
      }
      var queryString = "api/KPIGroups/" + this.selectedKpiGroupGuid;

      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          if (!data || !data[0] || _.isEmpty(data[0]) || !data[0].KPIs) {
            _this9.selectedKpiGroupInformation = {};
            _this9.kpisOfSelectedKpiGroup = [];
            return;
          }
          _this9.selectedKpiGroupInformation = data[0];
          _this9.kpisOfSelectedKpiGroup = data[0].KPIs;
          _this9.sortKpisByGroupPosition();
        },
        error: function error() {
          console.error("Error on GET in getKpisOfSelectedKpiGroup()");
          _this9.globals.showErrorSnackbar("KPIs request failed");
        }
      });
    },
    getKpiData: function getKpiData() {
      var _this10 = this;

      if (!this.globals.isAccessAllowed("LoopOp_KPIs_Read")) {
        this.globals.showErrorSnackbar("Access forbidden");
        console.error("Access forbidden: LoopOp_KPIs_Read");
        this.selectedKpiGuid = "";
        return;
      }
      this.refreshEnabled = false;
      var queryString = "api/KPIs/" + this.selectedKpiGuid;

      this.showAlert = false;
      this.selectedKpiDirty = false;
      this.resetValidationErrors("editKpiDialog");

      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          if (!data || !data[0] || _.isEmpty(data[0])) {
            _this10.selectedKpiInformation = {};
            return;
          }
          _this10.selectedKpiInformation = data[0];
        },
        error: function error() {
          console.error("KPI data request failed in getKpiData()");
          _this10.globals.showErrorSnackbar("KPI data request failed");
        },
        complete: function complete() {
          _this10.refreshEnabled = true;
        }
      });
    },
    validateBeforeSubmit: function validateBeforeSubmit(dialog) {
      var result = true;
      var elements = $("#" + dialog).find(":input");
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0) result = this.validateInput(elements[i].id) && result;
      }
      if (dialog === "editKpiDialog") {
        this.showAlert = !result;
        if (!result) return;
        this.saveEditKpiDialogData();
      }
    },
    validateInput: function validateInput(id) {
      var result = $("#" + id)[0].checkValidity();
      if (result) {
        $("#" + id).parent().parent().removeClass("has-error");
        var idx = this.invalidInputIds.indexOf(id);
        if (idx > -1) {
          this.invalidInputIds.splice(idx, 1);
        }
      } else {
        $("#" + id).parent().parent().addClass("has-error");
        if (this.invalidInputIds.indexOf(id) < 0) this.invalidInputIds.push(id);
      }
      return result;
    },
    inputHasError: function inputHasError(id) {
      return this.invalidInputIds.indexOf(id) > -1 ? true : false;
    },
    resetValidationErrors: function resetValidationErrors(dialog) {
      var elements = $("#" + dialog).find(":input");
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0) $("#" + elements[i].id).parent().parent().removeClass("has-error");
      }
      this.invalidInputIds = [];
    },
    openDeleteKpiConfirmationDialog: function openDeleteKpiConfirmationDialog() {
      if (!this.globals.isAccessAllowed("LoopOp_KPIs_Delete")) {
        this.globals.showErrorSnackbar("Access forbidden");
        console.error("Access forbidden: LoopOp_KPIs_Delete");
        return;
      }
      this.globals.$emit("openGlobalConfirmationDialog", this.getDeleteDialogData());
    },
    getDeleteDialogData: function getDeleteDialogData() {
      return {
        initiator: "KPIDeleteModal",
        confirmationTitle: this.lang.KM2019,
        colorRed: true,
        yesButtonText: this.lang.KM2020,
        noButtonText: this.lang.KM2021,
        htmlText: "<p><b>" + this.lang.KM2022 + "</b></p>\n        <div class=\"form-group\">\n          <label class=\"col-md-4 text-black\">" + this.lang.KM2023 + "</label>\n          <label class=\"col-md-8 text-black\">" + this.selectedKpiInformation.KPIId + "</label>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-md-4 text-black\">" + this.lang.KM2024 + "</label>\n          <label class=\"col-md-8 text-black\">" + this.selectedKpiInformation.KPICode + "</label>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-md-4 text-black\">" + this.lang.KM2025 + "</label>\n          <label class=\"col-md-8 text-black\">" + this.selectedKpiInformation.KPIShortText + "</label>\n        </div>"
      };
    },
    deleteSelectedKpi: function deleteSelectedKpi() {
      var _this11 = this;

      var queryString = "api/KPIs/" + this.selectedKpiGuid;
      $.ajax({
        method: "DELETE",
        url: queryString,
        success: function success(data) {
          _this11.globals.showSuccessSnackbar("KPI deletion successful");
          _this11.createNewKpi();
          _this11.getKpisOfSelectedKpiGroup();
          _this11.$forceUpdate();
        },
        error: function error() {
          console.error("KPI deletion failed in deleteSelectedKpi()");
          _this11.globals.showErrorSnackbar("KPI deletion failed");
        }
      });
    },

    // Reorders kpis of a kpi group after the position of a kpi changed
    reorderKpisInKpiGroup: function reorderKpisInKpiGroup() {
      var _this12 = this;

      var numberOfKpis = this.kpisOfSelectedKpiGroup.length,
          allPositions = _.range(1, numberOfKpis + 1),
          missingPos = 0,
          newPos = 0,
          kpiGuid = "";

      // Find missing position number and the position and code of the changed kpi
      allPositions.forEach(function (position, index) {
        if (position !== _this12.kpisOfSelectedKpiGroup[index].KPIGroupPosition) {
          missingPos = position;
          newPos = _this12.kpisOfSelectedKpiGroup[index].KPIGroupPosition;
          kpiGuid = _this12.kpisOfSelectedKpiGroup[index].KPIGuid;
        }
      });

      if (missingPos === 0) return; // No position missing -> no value changed

      // Move position numbers between new position number and missing position number
      for (var i = 0; i < allPositions.length; i++) {
        if (this.kpisOfSelectedKpiGroup[i].KPIGuid !== kpiGuid) {
          // Do NOT move the changed kpi
          if (this.kpisOfSelectedKpiGroup[i].KPIGroupPosition < missingPos && this.kpisOfSelectedKpiGroup[i].KPIGroupPosition >= newPos) this.kpisOfSelectedKpiGroup[i].KPIGroupPosition++;
          if (this.kpisOfSelectedKpiGroup[i].KPIGroupPosition > missingPos && this.kpisOfSelectedKpiGroup[i].KPIGroupPosition <= newPos) this.kpisOfSelectedKpiGroup[i].KPIGroupPosition--;
        }
      }
      this.sortKpisByGroupPosition();
    },
    sortKpisByGroupPosition: function sortKpisByGroupPosition() {
      if (!this.kpisOfSelectedKpiGroup == "undefined") return;
      this.kpisOfSelectedKpiGroup.sort(function (a, b) {
        return a.KPIGroupPosition - b.KPIGroupPosition;
      });
    },
    saveKpisNewOrder: function saveKpisNewOrder() {
      var _this13 = this;

      if (!this.globals.isAccessAllowed("LoopOp_KPIGroups_Update")) {
        this.globals.showErrorSnackbar("Access forbidden");
        console.error("Access forbidden: LoopOp_KPIGroups_Update");
        return;
      }

      var queryString = "api/KPIGroups/" + this.selectedKpiGroupGuid;
      this.selectedKpiGroupInformation.KPIs = this.kpisOfSelectedKpiGroup;
      $.ajax({
        method: "PUT",
        url: queryString,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedKpiGroupInformation),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          _this13.globals.showSuccessSnackbar("KPI Group update successful");
          _this13.changeKpiOrderDirty = false;
          _this13.getKpisOfSelectedKpiGroup();
        },
        error: function error() {
          console.error("Error on POST in saveEditKPIGroupDialogData()");
          _this13.globals.showErrorSnackbar("KPI Group update failed");
        }
      });
    },
    getKPIGroup: function getKPIGroup(kpiGroupGuid) {
      var result = this.kpiGroupsOfSelectedClient.find(function (element) {
        return element.KPIGroupGuid === kpiGroupGuid;
      });
      return {
        KPIGroupGuid: result.KPIGroupGuid,
        KPIGroupCode: result.KPIGroupCode
      };
    },
    saveEditKpiDialogData: function saveEditKpiDialogData() {
      var _this14 = this;

      if (!this.globals.isAccessAllowed("LoopOp_KPIs_Create") && !this.selectedKpiGuid) {
        this.globals.showErrorSnackbar("Access forbidden");
        console.error("Access forbidden: LoopOp_KPIs_Create");
        return;
      } else if (!this.globals.isAccessAllowed("LoopOp_KPIs_Update") && this.selectedKpiGuid) {
        this.globals.showErrorSnackbar("Access forbidden");
        console.error("Access forbidden: LoopOp_KPIs_Update");
        return;
      }

      var queryString = !this.selectedKpiGuid ? "api/KPIs" // new kpi group
      : "api/KPIs/" + this.selectedKpiGuid; // update exisiting kpi group
      var kpiGroup = this.getKPIGroup(this.selectedKpiGroupGuid);
      if (this.selectedKpiInformation.KPIGroups) this.selectedKpiInformation.KPIGroups = [];
      this.selectedKpiInformation.KPIGroups.push(kpiGroup);

      if (!this.selectedKpiInformation.KPIEvaluationRuleGuid) delete this.selectedKpiInformation.KPIEvaluationRuleGuid;

      if (this.selectedKpiInformation.KPIWeight === "") delete this.selectedKpiInformation.KPIWeight;

      if (!this.selectedKpiGuid) {
        $.ajax({
          method: "POST",
          url: queryString,
          data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedKpiInformation),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            _this14.globals.showSuccessSnackbar("KPI creation successful");
            _this14.selectedKpiGuid = data[0].KPIGuid;
            _this14.selectedKpiInformation = _.cloneDeep(data[0]);
            _this14.selectedKpiDirty = false;
            _this14.getKpisOfSelectedKpiGroup();
          },
          error: function error() {
            console.error("Error on POST in saveEditKpiDialogData()");
            _this14.globals.showErrorSnackbar("KPI creation failed");
          }
        });
      } else {
        $.ajax({
          method: "PUT",
          url: queryString,
          data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedKpiInformation),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            _this14.globals.showSuccessSnackbar("KPI update successful");
            _this14.selectedKpiDirty = false;
            _this14.getKpisOfSelectedKpiGroup();
          },
          error: function error() {
            console.error("Error on POST in saveEditKpiDialogData()");
            _this14.globals.showErrorSnackbar("KPI update failed");
          }
        });
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tools_Select2__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Tools_Select2__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "KPIManagementTranslateModal",
  components: { Select2: __WEBPACK_IMPORTED_MODULE_1__Tools_Select2___default.a },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#translateKpiDialog").on("hidden.bs.modal", function (e) {
      _this.$emit("dialogClosed");
    });
  },

  watch: {
    showDialog: function showDialog() {
      if (this.showDialog) this.openTranslateKpiDialog();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  props: ["showDialog", "client", "projects", "initialProject"],
  data: function data() {
    return {
      selectedLocaleCode: "",
      selectedProject: "",
      searchKpiString: "",
      kpiTranslations: [],
      filteredKpiTranslations: [],
      avaibleLocaleList: [],
      isTranslationDirty: false,
      isInitialSort: false,
      currentSort: { key: "Type", asc: true },
      lang: {
        KM3000: "Save",
        KM3001: "KPI Translation",
        KM3002: "Language selection",
        KM3003: "Please choose a language...",
        KM3004: "Search...",
        KM3005: "Type",
        KM3006: "Text",
        KM3007: "Translation",
        KM3008: "Client",
        KM3009: "Close",
        KM3010: "Discard changes",
        KM3011: "Yes",
        KM3012: "No",
        KM3013: "There are unsaved changes. Do you want to proceed?",
        KM3014: "Reset sort",
        KM3015: "Project",
        KM3016: "Please select a project..."
      }
    };
  },

  methods: {
    correctTextareaHeight: function correctTextareaHeight() {
      this.$nextTick(function () {
        var textareas = document.getElementsByClassName("autoExpand");
        for (var i = 0; i < textareas.length; i++) {
          $(textareas[i]).trigger("input");
        }
      });
    },
    openTranslateKpiDialog: function openTranslateKpiDialog() {
      $("#translateKpiDialog").modal("show");
      this.initTranslateKpiDialog();
      this.getAvailableLocaleList();
    },
    initTranslateKpiDialog: function initTranslateKpiDialog() {
      this.selectedLocaleCode = "";
      this.selectedProject = this.initialProject ? this.initialProject : "";
      this.searchKpiString = "";
      this.isTranslationDirty = false;
      this.isInitialSort = false;
      this.kpiTranslations = [];
      this.filteredKpiTranslations = [];
    },
    closeKpiTranslationModal: function closeKpiTranslationModal() {
      if (this.isTranslationDirty) {
        this.globals.$emit("openGlobalUnsavedChangesDialog", function () {
          $("#translateKpiDialog").modal("hide");
        });
        return;
      }
      $("#translateKpiDialog").modal("hide");
    },
    getAvailableLocaleList: function getAvailableLocaleList() {
      var _this2 = this;

      var queryString = "api/KPITranslation/" + this.client.clientGuid + "/AvailableLocales";

      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this2.avaibleLocaleList = !_.isEmpty(data) ? data : [];
          _this2.$nextTick(function () {
            $("#selectLocale").val("").trigger("change");
          });
        },
        error: function error() {
          console.error("Available locale list access failed in getAvailableLocaleList()");
          _this2.globals.showErrorSnackbar("Available locale list access failed");
        }
      });
    },
    selectedLocaleChanged: function selectedLocaleChanged(value, event) {
      var _this3 = this;

      if (!value) return;
      if (this.isTranslationDirty) {
        this.globals.$emit("openGlobalUnsavedChangesDialog", function () {
          _this3.selectedLocaleCode = value;
          _this3.getKpiTranslations();
        }, function () {
          $(event.target).val(_this3.selectedLocaleCode).trigger("change");
        });
        return;
      }
      this.selectedLocaleCode = value;
      this.getKpiTranslations();
    },
    orderTableByColumn: function orderTableByColumn(orderProp) {
      var _this4 = this;

      if (!orderProp && !this.currentSort.key) return;

      if (orderProp) {
        this.currentSort.key === orderProp ? this.currentSort.asc = !this.currentSort.asc : this.currentSort = { asc: true, key: orderProp };
      }

      this.isInitialSort = true;

      var sortFunction = function sortFunction(kpi) {
        if (typeof kpi[_this4.currentSort.key] === "string") {
          return kpi[_this4.currentSort.key].toLowerCase();
        }
        return kpi[_this4.currentSort.key];
      };
      this.filteredKpiTranslations = _.orderBy(this.filteredKpiTranslations, [sortFunction], [this.currentSort.asc ? "asc" : "desc", "asc"]);
    },
    showSortArrow: function showSortArrow(key, asc) {
      return this.currentSort.key === key && this.currentSort.asc === asc;
    },
    doFiltering: function doFiltering() {
      if (!this.searchKpiString) this.filteredKpiTranslations = this.kpiTranslations;

      var words = this.searchKpiString.split(" ");
      var keys = ["Type", "Text", "Translation", "InheritedTranslation"];

      var kpiFilter = function kpiFilter(kpi) {
        var containsSearch = false;
        words.forEach(function (word) {
          keys.forEach(function (key) {
            if (kpi[key] && kpi[key].toString().toLowerCase().indexOf(word.toLowerCase()) > -1) {
              containsSearch = true;
              return;
            }
          });
        });
        return containsSearch;
      };

      this.filteredKpiTranslations = !_.isEmpty(this.kpiTranslations) ? this.kpiTranslations.filter(kpiFilter) : [];
      this.currentSort.asc = !this.currentSort.asc;
      this.getInitialSort();
    },
    getKpiTranslations: function getKpiTranslations() {
      var _this5 = this;

      if (!this.client.clientGuid || !this.selectedLocaleCode) {
        this.kpiTranslations = [];
        this.doFiltering();
        return;
      }
      var queryString = "api/KPITranslation/" + this.client.clientGuid + "?LocaleCode=" + this.selectedLocaleCode;

      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this5.kpiTranslations = !_.isEmpty(data) ? data : [];
          _this5.isTranslationDirty = false;
          _this5.doFiltering();
          _this5.correctTextareaHeight();
        },
        error: function error() {
          console.error("KPI Translations access failed in getKpiTranslations()");
          _this5.globals.showErrorSnackbar("KPI Translations access failed");
        }
      });
    },
    saveKpiTranslations: function saveKpiTranslations() {
      var _this6 = this;

      var queryString = "api/KPITranslation/" + this.client.clientGuid + "?LocaleCode=" + this.selectedLocaleCode;

      $.ajax({
        method: "PUT",
        url: queryString,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.kpiTranslations),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          _this6.globals.showSuccessSnackbar("KPI Translation update successful");
          _this6.isTranslationDirty = false;
        },
        error: function error() {
          console.error("Error on PUT in saveKpiTranslations()");
          _this6.globals.showErrorSnackbar("KPI Translation update failed");
        }
      });
    },
    getInitialSort: function getInitialSort() {
      this.isInitialSort = false;
      // kpi groups
      var orderByKpiGroupType = ["KPIGroupCode", "KPIGroupShortText", "KPIGroupLongText"];
      var kpiGroups = this.filteredKpiTranslations.filter(function (kpi) {
        return !kpi.KPIGroupGuid;
      });
      this.sortElementsBy(kpiGroups, orderByKpiGroupType);
      // kpi
      var orderByKpiType = ["KPICode", "KPIShortText", "KPILongText"];
      var kpis = this.filteredKpiTranslations.filter(function (kpi) {
        return kpi.KPIGroupGuid;
      });
      this.sortElementsBy(kpis, orderByKpiType);

      kpis.forEach(function (kpi, index) {
        var idx = _.findLastIndex(kpiGroups, function (kpiGroup) {
          return kpiGroup.Guid === kpi.KPIGroupGuid;
        });
        kpiGroups.splice(idx + index % 3 + 1, 0, kpi);
      });

      this.filteredKpiTranslations = kpiGroups;
    },
    sortElementsBy: function sortElementsBy(elementsToSort, sortBy) {
      elementsToSort.sort(function (a, b) {
        if (a.Guid > b.Guid) return 1;
        if (a.Guid < b.Guid) return -1;

        if (a.Guid === b.Guid) {
          if (sortBy.indexOf(a.Type) > sortBy.indexOf(b.Type)) return 1;
          if (sortBy.indexOf(a.Type) < sortBy.indexOf(b.Type)) return -1;
          if (sortBy.indexOf(a.Type) === sortBy.indexOf(b.Type)) return 0;
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tools_Select2__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Tools_Select2__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "LocationDataTranslateModal",
  components: {
    Select2: __WEBPACK_IMPORTED_MODULE_1__Tools_Select2___default.a
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    selectedLocation: {
      type: String,
      default: ""
    },
    selectedLocationId: {
      type: Number,
      default: -1
    }
  },
  data: function data() {
    return {
      selectedCountry: "",
      selectedLanguage: "",
      countryList: [],
      countryLanguages: [],
      translationDataList: [],
      baseLocationData: {},
      currentTranslationDataDirty: false,
      lang: {
        LTM000: "Translate location data",
        LTM001: "Country",
        LTM002: "Language",
        LTM003: "Please select a country...",
        LTM004: "Please select a language...",
        LTM005: "No translation data for this language stored yet.",
        LTM006: "Name of the location",
        LTM007: "Street",
        LTM008: "Addition to address",
        LTM009: "Region",
        LTM010: "City",
        LTM011: "Postal code",
        LTM012: "Close",
        LTM013: "Save",
        LTM014: "Unsaved Changes",
        LTM015: "Save",
        LTM016: "Discard changes",
        LTM017: "There are unsaved changes for the current translation entry. Do you want to save them?",
        LTM018: "Location data access failed",
        LTM019: "Localized location data access failed",
        LTM020: "Translation data update successful",
        LTM021: "Translation data update failed"
      }
    };
  },

  computed: {
    currentCountryLanguages: function currentCountryLanguages() {
      var _this = this;

      if (!this.selectedCountry) return [];
      var countryObj = _.find(this.countryLanguages, function (country) {
        return country.CountryCode === _this.selectedCountry;
      });
      if (countryObj) return countryObj.Languages || [];
      return [];
    },
    currentTranslationData: function currentTranslationData() {
      var _this2 = this;

      if (!this.selectedLanguage) return {};
      var data = _.find(this.translationDataList, function (trData) {
        return trData.CountryCode === _this2.selectedCountry && trData.LanguageCode === _this2.selectedLanguage;
      });
      return data || {};
    }
  },
  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      var _this3 = this;

      this.globals.getLanguageStrings(this);
      this.globals.getCountryList(function (data) {
        return _this3.countryList = data;
      });
    },
    showModal: function showModal(newVal) {
      if (newVal) this.openModal();
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
    this.getSelectData();

    $("#locationDataTranslateModal").on("hidden.bs.modal", function (e) {
      return _this4.$emit("modalClosed");
    });

    this.globals.$off("IgnoreUnsavedLocationTranslationYesConfirmation");
    this.globals.$on("IgnoreUnsavedLocationTranslationYesConfirmation", this.saveLocalizedLocationData);
    this.globals.$off("IgnoreUnsavedLocationTranslationNoConfirmation");
    this.globals.$on("IgnoreUnsavedLocationTranslationNoConfirmation", this.getLocalizedLocationData);
  },

  methods: {
    openModal: function openModal() {
      this.getLocalizedLocationData();
      this.getBaseLocationData();
    },
    closeModal: function closeModal() {
      $("#locationDataTranslateModal").modal("hide");
    },
    showDirtyDataWarning: function showDirtyDataWarning() {
      this.$refs.selectLocalizedLocationDataCountryCode.close();
      this.$refs.selectLocalizedLocationDataLanguageCode.close();

      this.globals.$emit("openGlobalConfirmationDialog", {
        initiator: "IgnoreUnsavedLocationTranslation",
        confirmationTitle: this.lang.LTM014,
        colorRed: true,
        yesButtonText: this.lang.LTM015,
        noButtonText: this.lang.LTM016,
        htmlText: "<p>" + this.lang.LTM017 + "</p>"
      });
    },
    addNewTranslationData: function addNewTranslationData() {
      this.translationDataList.push({
        LocationGuid: this.selectedLocation,
        CountryCode: this.selectedCountry,
        LanguageCode: this.selectedLanguage
      });
    },
    getBaseLocationData: function getBaseLocationData() {
      var _this5 = this;

      if (this.selectedLocationId < 0) return;

      $.ajax({
        method: "GET",
        url: "api/Locations/" + this.selectedLocationId,
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this5.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this5.baseLocationData = data;
        },
        error: function error() {
          console.error("Error on GET in getBaseLocationData()");
          _this5.globals.showErrorSnackbar(_this5.lang.LTM018);
        }
      });
    },
    getLocalizedLocationData: function getLocalizedLocationData() {
      var _this6 = this;

      if (!this.selectedLocation) return;

      $.ajax({
        method: "GET",
        url: "api/Locations/" + this.selectedLocation + "/Translations",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this6.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this6.translationDataList = data;
          _this6.currentTranslationDataDirty = false;
          if (!$("#locationDataTranslateModal").hasClass("in")) $("#locationDataTranslateModal").modal("show");
        },
        error: function error() {
          console.error("Error on GET in getLocalizedLocationData()");
          _this6.globals.showErrorSnackbar(_this6.lang.LTM019);
          _this6.$emit("modalClosed");
        }
      });
    },
    saveLocalizedLocationData: function saveLocalizedLocationData() {
      var _this7 = this;

      var queryString = "api/Locations/" + this.selectedLocation + "/Translations";
      var reqMethod = "POST";
      if (this.currentTranslationData.LocationTranslationGuid) {
        queryString = "api/Locations/Translations/" + this.currentTranslationData.LocationTranslationGuid;
        reqMethod = "PUT";
      }

      $.ajax({
        method: reqMethod,
        url: queryString,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.currentTranslationData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this7.globals.showErrorSnackbar(data.Error);
            return;
          }
          if (data && data[0]) _this7.translationDataList = data;
          _this7.currentTranslationDataDirty = false;
          _this7.globals.showSuccessSnackbar(_this7.lang.LTM020);
        },
        error: function error() {
          console.error("Error on POST in saveLocalizedLocationData()");
          _this7.globals.showErrorSnackbar(_this7.lang.LTM021);
        }
      });
    },
    deleteTranslationData: function deleteTranslationData() {
      var _this8 = this;

      if (!this.currentTranslationData.LocationTranslationGuid) {
        this.removeCurrentTranslationFromList();
        return;
      }
      var queryString = "api/Locations/Translations/" + this.currentTranslationData.LocationTranslationGuid;

      $.ajax({
        method: "DELETE",
        url: queryString,
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this8.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this8.removeCurrentTranslationFromList();
          _this8.globals.showSuccessSnackbar(_this8.lang.LTM020);
        },
        error: function error() {
          console.error("Error on DELETE in deleteTranslationData()");
          _this8.globals.showErrorSnackbar(_this8.lang.LTM021);
        }
      });
    },
    removeCurrentTranslationFromList: function removeCurrentTranslationFromList() {
      var _this9 = this;

      _.remove(this.translationDataList, function (td) {
        return td.CountryCode === _this9.selectedCountry && td.LanguageCode === _this9.selectedLanguage;
      });
      var tmpLang = this.selectedLanguage;
      this.selectedLanguage = "";
      this.currentTranslationDataDirty = false;
      this.$nextTick(function () {
        _this9.selectedLanguage = tmpLang;
      });
    },
    getSelectData: function getSelectData() {
      var _this10 = this;

      if (this.globals.selectedLanguage) {
        this.globals.getCountryList(function (data) {
          return _this10.countryList = data;
        });
      }
      this.globals.getCountryLanguageList(function (callbackData) {
        _this10.countryLanguages = callbackData;
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tools_Select2__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Tools_Select2__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "LocationExportModal",
  components: { Select2: __WEBPACK_IMPORTED_MODULE_0__Tools_Select2___default.a },
  props: {
    showModal: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      selectedClient: "",
      clientList: [],
      exportLocationsFileType: "xlsx",
      lang: {
        LEX000: "Location Export",
        LEX001: "Cancel",
        LEX002: "Download",
        LEX003: "No client selected",
        LEX004: "Location export failed",
        LEX005: "Client"
      }
    };
  },

  watch: {
    showModal: function showModal(newValue) {
      newValue ? this.openModal() : this.closeModal();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
    this.globals.getClientList(function (data) {
      _this.clientList = data;
      if (_this.clientList.length === 1) {
        _this.$nextTick(function () {
          _this.selectedClient = _this.clientList[0].ClientGuid;
        });
      }
    });

    $("#exportLocationsModal").on("hidden.bs.modal", function (e) {
      _this.$emit("modalClosed");
    });
  },

  methods: {
    openModal: function openModal() {
      $("#exportLocationsModal").modal("show");
    },
    closeModal: function closeModal() {
      $("#exportLocationsModal").modal("hide");
    },
    downloadExportData: function downloadExportData() {
      var _this2 = this;

      if (!this.selectedClient) {
        this.globals.showErrorSnackbar(this.lang.LEX003);
        return;
      }

      var url = "api/Locations/Export/" + this.selectedClient + "?file_type=" + this.exportLocationsFileType;
      $.ajax({
        method: "GET",
        url: url,
        success: function success(data) {
          var guid = JSON.parse(data)[0].DownloadId;
          _this2.globals.downloadFile(guid);
          _this2.closeModal();
        },
        error: function error() {
          console.error("Export data access failed in downloadExportData()");
          _this2.globals.showErrorSnackbar(_this2.lang.LEX004);
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "LocationImport",
  created: function created() {
    var guidRegex = RegExp(/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i);

    if (guidRegex.test(this.$route.params.clientGuid)) this.selectedClient = this.$route.params.clientGuid;else {
      this.globals.showErrorSnackbar(this.lang.I0039);
      this.$router.push({
        path: "/locationmanagement"
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    // Gets executed right after rendering the component
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
    var error = function error() {
      _this.$router.push({
        path: "/locationmanagement"
      });
    };
    this.getCurrentImportData(error);

    $(window).on("resize", this.setTableHeight).resize();

    $("#feedbackModal").on("hide.bs.modal", function () {
      _this.checkForErrors = false;
      _this.initialRender = false;
    });
  },
  destroyed: function destroyed() {
    $(window).off("resize", this.setTableHeight);
  },

  methods: {
    setTableHeight: function setTableHeight() {
      var height = $(window).height();
      height -= $("#import-top-panel").height() + $("#app-navbar").height() + 47; // 47 pixel for the free space around the cards
      $(".import-table-panel").css("max-height", height);
    },

    // Display some information dialog to let the user know what to do, depending on whether there are errors or not
    showInitialMessages: function showInitialMessages() {
      if (this.noErrors) {
        this.feedbackModalData.type = "okNoAction";
        this.feedbackModalData.title = this.lang.I0009;
        this.feedbackModalData.text = this.lang.I0010;
        this.feedbackModalData.text += this.lang.I0011;
        this.feedbackModalData.text += this.lang.I0012;
      } else {
        this.feedbackModalData.type = "okNoAction";
        this.feedbackModalData.title = this.lang.I0013;
        this.feedbackModalData.text = this.lang.I0014;
        this.feedbackModalData.text += this.lang.I0015;
        this.feedbackModalData.text += this.lang.I0016;
        this.feedbackModalData.text += this.lang.I0017;
        this.feedbackModalData.text += this.lang.I0018;
      }
      $("#feedbackModal").modal("show");
    },

    // Display information about errors that are still available
    showErrorCheckMessages: function showErrorCheckMessages() {
      if (this.serverResponse.Error_Counter < 1) {
        // No more errors left
        this.feedbackModalData.type = "okNoAction";
        this.feedbackModalData.title = this.lang.I0023;
        this.feedbackModalData.text = this.lang.I0024;
        this.feedbackModalData.text += this.lang.I0025;
        $("#feedbackModal").modal("show");
      } else {
        // Still errors left
        this.feedbackModalData.type = "okNoAction";
        this.feedbackModalData.title = this.lang.I0026;
        this.feedbackModalData.text = this.lang.I0027;
        $("#feedbackModal").modal("show");
      }
    },

    // Toggles the selected-state of a given row, if it does not contain errors.
    // If the row is not yet selected, it will be added to the array of selected rows.
    // If the row is already selected, it will be removed from that array.
    toggleRowSelected: function toggleRowSelected(index) {
      if (this.rowContainsError(index)) return;
      var idx = this.selectedRowNumbers.indexOf(this.serverResponse.Locations[index].RN);
      if (idx > -1) this.selectedRowNumbers.splice(idx, 1);else this.selectedRowNumbers.push(this.serverResponse.Locations[index].RN);
    },

    // Selects all available rows
    // selectAllRows() {
    //   let rowNumbers = this.getRange(1, this.serverResponse.Count, 1);
    //   this.selectedRowNumbers = rowNumbers;
    // },
    // Returns true if row is selected, otherwise false.
    isRowSelected: function isRowSelected(index) {
      return this.selectedRowNumbers.indexOf(this.serverResponse.Locations[index].RN) > -1;
    },

    // Returns true if given datarow is updated, otherwise false.
    isRowUpdated: function isRowUpdated(index) {
      return this.serverResponse.Locations[index].state === "U";
    },

    // Returns true if given datarow is new, otherwise false.
    isRowNew: function isRowNew(index) {
      return this.serverResponse.Locations[index].state === "I";
    },

    // Closes the import and returns to the client management
    exitImport: function exitImport() {
      $("#feedbackModal").modal("hide");
      this.$router.push({
        path: "/locationmanagement"
      });
    },

    // Sends a message to the server to store the import data in the database
    saveImportData: function saveImportData() {
      var _this2 = this;

      if (this.noErrors || this.selectedRowNumbers.length > 0) {
        var dataString = '{"save":true';

        if (this.selectedRowNumbers.length > 0) dataString += ',"selected":' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.selectedRowNumbers);
        dataString += "}";

        // Send data to the server
        $.ajax({
          method: "POST",
          url: "api/Locations/Import/" + this.selectedClient,
          data: dataString,
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            _this2.globals.showSuccessSnackbar(_this2.lang.I0020);
            _this2.$router.push({
              path: "/locationmanagement"
            });
          },
          error: function error() {
            console.error("Error on POST in saveImportData()");
            _this2.globals.showErrorSnackbar(_this2.lang.I0022);
          }
        });
      } else console.error("Error on saveImportData(): There are still errors left");
    },

    // Sends corrected import data to the server to check, if the new data is valid
    validateImportData: function validateImportData() {
      var _this3 = this;

      var dataString = '{"corrections":';

      var correctionData = [];
      for (var locIdx = 0; locIdx < this.serverResponse.Locations.length; locIdx++) {
        if (this.serverResponse.Locations[locIdx].ErrorColumnNames)
          // Build data structure
          for (var errIdx = 0; errIdx < this.serverResponse.Locations[locIdx].ErrorColumnNames.length; errIdx++) {
            var obj = {};
            obj.RN = this.serverResponse.Locations[locIdx].RN;
            obj.ColumnName = this.serverResponse.Locations[locIdx].ErrorColumnNames[errIdx];
            obj.Value = this.serverResponse.Locations[locIdx][obj.ColumnName];

            correctionData.push(obj);
          }
      }

      dataString += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(correctionData) + "}";
      $.ajax({
        method: "POST",
        url: "api/Locations/Import/" + this.selectedClient,
        data: dataString,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          _this3.checkForErrors = true;
          _this3.getCurrentImportData();
          _this3.globals.showSuccessSnackbar(_this3.lang.I0040);
        },
        error: function error() {
          console.error("Error on POST in validateImportData()");
          _this3.globals.showErrorSnackbar(_this3.lang.I0041);
        }
      });
    },

    // Returns a string that contains all parameters for the request containing paging and filter states
    getRequestParamString: function getRequestParamString() {
      var getString = "?page_size=" + this.pageSize;
      getString += "&page=" + this.selectedPage;
      getString += "&sort_order=" + (this.sortOrderAsc ? "asc" : "desc");
      if (this.sortColumn) getString += "&sort_column=" + this.sortColumn;

      if (this.errorFilterState || this.newFilterState || this.updatedFilterState) {
        getString += "&filter={";
        if (this.errorFilterState) getString += '"Errors":' + this.errorFilterState;

        if (this.errorFilterState && (this.newFilterState || this.updatedFilterState)) getString += ",";

        if (this.newFilterState || this.updatedFilterState) {
          getString += '"States":[';

          if (this.newFilterState) {
            getString += '"I"';
            if (this.updatedFilterState) getString += ',"U"';
          } else {
            if (this.updatedFilterState) getString += '"U"';
          }
          getString += "]";
        }
        getString += "}";
      }
      return getString;
    },

    // Requests importdata for the current page with the current settings from the server
    getCurrentImportData: function getCurrentImportData(_error) {
      var _this4 = this;

      var getString = "api/Locations/Import/" + this.getRequestParamString();
      getString = encodeURI(getString);

      $.ajax({
        method: "GET",
        url: getString,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          _this4.pageSize = data[0].Page_Size;
          _this4.selectedPage = data[0].Page;
          _this4.pageCount = data[0].Page_Count;
          _this4.serverResponse = data[0];
          _this4.noErrors = !_this4.errorsExist();
          _this4.tableHeaders = _this4.getTableHeaders();

          if (_this4.initialRender) {
            // Only executes the first time after component rendering
            _this4.showInitialMessages();
            if (_this4.serverResponse.Error_Counter + _this4.serverResponse.Updated_Counter + _this4.serverResponse.Inserted_Counter == 0) {
              _this4.errorFilterState = false;
              _this4.updatedFilterState = false;
              _this4.newFilterState = false;
            }
          }

          if (_this4.checkForErrors) {
            // Only executes after data validation
            _this4.showErrorCheckMessages();
            if (_this4.serverResponse.Error_Counter + _this4.serverResponse.Updated_Counter + _this4.serverResponse.Inserted_Counter == 0) {
              _this4.errorFilterState = false;
              _this4.updatedFilterState = false;
              _this4.newFilterState = false;
            }
          }
        },
        error: function error() {
          console.error("Error on GET in getCurrentImportData()");
          _this4.globals.showErrorSnackbar(_this4.lang.I0042);
          if (_error) _error();
        }
      });
    },

    // Tells the server to discard the import data
    discardImportData: function discardImportData() {
      var _this5 = this;

      var dataString = '{"save":false}';

      $.ajax({
        method: "POST",
        url: "api/Locations/Import/" + this.selectedClient,
        data: dataString,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          _this5.exitImport();
        },
        error: function error() {
          console.error("Error on POST in discardImportData()");
          _this5.globals.showErrorSnackbar();
        }
      });
    },

    // Displays a security check dialog if the user tries to cancel the import
    cancelLocationImport: function cancelLocationImport() {
      this.feedbackModalData.type = "YesNoCancelImport";
      this.feedbackModalData.title = this.lang.I0028;
      this.feedbackModalData.text = this.lang.I0029;
      $("#feedbackModal").modal("show");
    },

    // Returns true, if the row with the given index contains an error value, otherwise false
    rowContainsError: function rowContainsError(index) {
      if (this.noErrors) return false;

      if (this.serverResponse.Locations[index].ErrorColumnNames) return true;
      return false;
    },

    // Returns true, if the field with the given rowindex and columnname contains an error, otherwise false
    isErrorValue: function isErrorValue(rowindex, column) {
      if (!this.rowContainsError(rowindex)) return false;

      if (this.serverResponse.Locations[rowindex].ErrorColumnNames.indexOf(column) > -1) return true;
    },

    // Returns true if there are errors in the server response, otherwise false
    errorsExist: function errorsExist() {
      if (!this.serverResponse.Error_Counter) return false;
      return this.serverResponse.Error_Counter > 0;
    },

    // Returns a list of header names for the table
    getTableHeaders: function getTableHeaders() {
      if (!this.serverResponse || !this.serverResponse.Locations) return [""];
      var headers = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.serverResponse.Locations[0]);

      // Remove columns that do not have to be shown
      var idx = void 0;
      var removeCols = ["RN", "state", "ErrorColumnNames"];
      for (var i = 0; i < removeCols.length; i++) {
        idx = headers.indexOf(removeCols[i]);
        if (idx !== -1) headers.splice(idx, 1);
      }
      return headers;
    },
    getVisibleLocationData: function getVisibleLocationData(location) {
      return _.pick(location, this.tableHeaders);
    },

    // Updates the current pagesize and the selected pagenumber and triggers the refresh of the table
    updatePaging: function updatePaging(pageNumber, pageSize) {
      this.selectedPage = pageNumber;
      if (pageSize != 0) this.pageSize = pageSize;
      this.getCurrentImportData();
    },

    // Returns a range of numbers with min-value, max-value and stepsize
    getRange: function getRange(min, max, step) {
      var range = [],
          j = 0;
      for (var i = min; i <= max; i += step) {
        range[j++] = i;
      }
      return range;
    },

    // Returns a list of all pagenumbers that should be visible depending on the current page and the count of pages
    getVisiblePages: function getVisiblePages() {
      if (this.pageCount <= 7) {
        return this.getRange(1, this.pageCount, 1);
      } else if (this.pageCount > 7 && this.selectedPage <= 4) {
        return this.getRange(1, 6, 1);
      } else if (this.pageCount > 7 && this.selectedPage >= this.pageCount - 3) {
        return this.getRange(this.pageCount - 5, this.pageCount, 1);
      } else {
        return this.getRange(this.selectedPage - 2, this.selectedPage + 2, 1);
      }
    }
  },
  watch: {
    errorFilterState: function errorFilterState() {
      this.getCurrentImportData();
    },
    newFilterState: function newFilterState() {
      if (!(this.initialRender || this.checkForErrors)) this.getCurrentImportData();
    },
    updatedFilterState: function updatedFilterState() {
      if (!(this.initialRender || this.checkForErrors)) this.getCurrentImportData();
    },
    sortColumn: function sortColumn() {
      this.getCurrentImportData();
    },
    sortOrderAsc: function sortOrderAsc() {
      this.getCurrentImportData();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  data: function data() {
    // Global data inside the component is stored here
    return {
      selectedClient: "",
      serverResponse: [], // Stores the server response data
      pageSize: 20, // Number of locations on one page of the table
      selectedPage: 1, // Number of the page, that is visible
      pageCount: 0, // Count of available pages depending on the pagesize and the data
      sortOrderAsc: true,
      sortColumn: "",
      noErrors: false, // true --> there are currently no errors in the import data
      tableHeaders: [],
      errorFilterState: true, // Stores the current state of the error-filter
      newFilterState: true, // Stores the current state of the new-filter
      updatedFilterState: true, // Stores the current state of the updated-filter
      checkForErrors: false,
      initialRender: true,
      selectedRowNumbers: [], // Stores the index of the selected table-row
      feedbackModalData: {
        type: "info", // Should be "okNoAction", "okImportSuccessful" or "YesNoCancelImport" -> different dialog types
        title: "", // Set the dialog title here
        text: "" // Set the dialog text here
      },
      lang: {
        I0000: "Save",
        I0001: "Send correction",
        I0002: "Cancel import",
        I0003: "Error",
        I0004: "Add",
        I0005: "Updated",
        I0006: "No",
        I0007: "Yes",
        I0008: "OK",
        I0009: "Import data were successfully verified.",
        I0010: "The data were successfully verified and free of error!<br><br>",
        I0011: "The imported data can be seen in the following table.<br>",
        I0012: 'For writing the data to the database click <b>"Save"</b>.<br>',
        I0013: "Check import data",
        I0014: "Please check the data to be imported.<br><br>",
        I0015: "In all lines marked in yellow errors are highlighted in red.<br>",
        I0016: "The incorrect inputs can only be edit by double clicking.<br>",
        I0017: 'For resending the revised data click <b>"Send correction"</b>.<br>',
        I0018: 'By clicking <b>"Activate filter"</b> only faulty records will be shown.<br>',
        I0019: "Import was successful",
        I0020: "Data were successfully imported.",
        I0021: "Import failed",
        I0022: "An error occurred while importing!",
        I0023: "Correction was successful",
        I0024: "The data were successfully verified and free of further errors!<br><br>",
        I0025: 'For writing the data to the database click <b>"Save"</b>.<br>',
        I0026: "Incorrect correction",
        I0027: "Sorry, but there are still errors in the import data. Please correct them!",
        I0028: "Cancel import",
        I0029: "Do you really want to cancel the import?",
        I0030: "Items per page",
        I0031: "First page",
        I0032: "Last page",
        I0033: "Selected",
        I0034: "Incorrect",
        I0035: "Updated",
        I0036: "Add",
        I0037: "Clear selection",
        I0038: "No data",
        I0039: "Invalid client",
        I0040: "Import data update successful",
        I0041: "Import data update failed",
        I0042: "Import data access failed"
      }
    };
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tools_Select2__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Tools_Select2__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "LocationImportDataModal",
  components: { Select2: __WEBPACK_IMPORTED_MODULE_0__Tools_Select2___default.a },
  props: {
    showModal: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      importOption: "text",
      trimImportData: false,
      importText: "",
      selectedFile: {},
      selectedClient: "",
      clientList: [],
      lang: {
        LIM000: "Location import",
        LIM001: "Text import",
        LIM002: "File import",
        LIM003: "Text",
        LIM004: "Please insert the table data to be imported here.",
        LIM005: "File",
        LIM006: "Please select a file...",
        LIM007: "Cancel",
        LIM008: "OK",
        LIM009: "Clean data",
        LIM010: "Client",
        LIM011: "No client selected",
        LIM012: "Please insert import data",
        LIM013: "Please select an import file",
        LIM014: "Location import failed"
      }
    };
  },

  watch: {
    showModal: function showModal(newValue) {
      newValue ? this.openModal() : this.closeModal();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
    this.globals.getClientList(function (data) {
      _this.clientList = data;
      if (_this.clientList.length === 1) _this.selectedClient = _this.clientList[0].ClientGuid;
    });

    $("#importLocationsModal").on("hidden.bs.modal", function (e) {
      _this.$emit("modalClosed");
      if (_this.$locationImportSuccess) {
        delete _this.$locationImportSuccess;
        _this.$router.push({
          path: "locationimport/" + _this.selectedClient
        });
      }
    });
  },

  methods: {
    openModal: function openModal() {
      this.importText = "";
      this.selectedFile = {};
      $("#importLocationsModal").modal("show");
    },
    closeModal: function closeModal() {
      $("#importLocationsModal").modal("hide");
    },
    uploadImportData: function uploadImportData() {
      var _this2 = this;

      if (!this.selectedClient) {
        this.globals.showErrorSnackbar(this.lang.LIM011);
        return;
      }
      var requestData = void 0;
      if (this.importOption === "text") {
        if (!this.importText) {
          this.globals.showErrorSnackbar(this.lang.LIM012);
          return;
        }
        // Escape all " characters
        var importText = this.importText.replace(/"/g, '\\"');
        requestData = "{\"data\":\"" + importText + "\",\"trim\":" + this.trimImportData + "}";
      } else {
        if (_.isEmpty(this.selectedFile)) {
          this.globals.showErrorSnackbar(this.lang.LIM013);
          return;
        }
        requestData = "{\"file\":\"" + this.selectedFile.file + "\",\"trim\":" + this.trimImportData + "}";
      }

      $.ajax({
        method: "POST",
        url: "api/Locations/Import/" + this.selectedClient,
        data: requestData,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        timeout: 600000,
        success: function success(data) {
          _this2.$locationImportSuccess = true;
          $("#importLocationsModal").modal("hide");
        },
        error: function error(data) {
          console.error("Error on POST in uploadImportData()");
          _this2.globals.showErrorSnackbar(_this2.lang.LIM014);
        },
        complete: function complete() {
          _this2.importText = "";
          $("#locationImportFileInput")[0].value = null;
        }
      });
    },


    // Writes the filename to the input of the file import, after a file was selected
    onImportFileChange: function onImportFileChange(e) {
      var _this3 = this;

      var files = e.target.files || e.dataTransfer.files;
      if (!files.length || !files[0].name) {
        this.selectedFile = {};
        return;
      }
      var fileObject = files[0];

      var uploadSuccess = function uploadSuccess(data) {
        if (_this3.selectedFile) {
          _this3.selectedFile.file = data[0].DownloadId;
          _this3.selectedFile.name = fileObject.name;
        } else _this3.selectedFile = data;

        _this3.$forceUpdate();
      };
      this.globals.uploadFile(fileObject, uploadSuccess);
      e.target.value = null;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LocationImportDataModal__ = __webpack_require__(1582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LocationImportDataModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__LocationImportDataModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationExportModal__ = __webpack_require__(1580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationExportModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__LocationExportModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationManagementEditModal__ = __webpack_require__(1584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationManagementEditModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__LocationManagementEditModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LocationDataTranslateModal__ = __webpack_require__(1579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LocationDataTranslateModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__LocationDataTranslateModal__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "LocationManagement",
  components: {
    LocationImportDataModal: __WEBPACK_IMPORTED_MODULE_1__LocationImportDataModal___default.a,
    LocationExportModal: __WEBPACK_IMPORTED_MODULE_2__LocationExportModal___default.a,
    LocationManagementEditModal: __WEBPACK_IMPORTED_MODULE_3__LocationManagementEditModal___default.a,
    LocationDataTranslateModal: __WEBPACK_IMPORTED_MODULE_4__LocationDataTranslateModal___default.a
  },
  mounted: function mounted() {
    this.readComponentSettingsFromStore();

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this, this.setLocationTableHeight);
    this.getLocationData();

    $(window).on("resize", this.setLocationTableHeight).resize();

    if (!this.globals.currentUserInfo) this.globals.$once("currentUserInfoReceived", this.setLocationTableHeight);
  },
  destroyed: function destroyed() {
    $(window).off("resize", this.setLocationTableHeight);
    this.writeComponentSettingsToStore();
  },

  methods: {
    setLocationTableHeight: function setLocationTableHeight() {
      this.$nextTick(function () {
        var height = $(window).height();
        height -= $("#locations-top-panel").height() + $("#app-navbar").height() + $(".main-table > thead").height() + 47; // 47 pixel for the free space around the cards
        $(".main-table-scrollbar").css("max-height", height);
      });
    },
    readComponentSettingsFromStore: function readComponentSettingsFromStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      var storedData = this.$store.getters["localFilters/locationManagement"];
      if (storedData) {
        for (var key in storedData) {
          if (_.has(this, key)) this[key] = _.cloneDeep(storedData[key]);
        }
      }

      if (!this.$store.getters["userSettings/syncFilters"]) return;
      if (!this.feature.isAudiTarget || !this.feature.isEnabled("audi_importers")) {
        var storedClient = this.$store.getters["sharedFilters/client"];
        this.filterStrings.ClientName = storedClient.ClientName || "";
      } else {
        var storedImporter = this.$store.getters["sharedFilters/importer"];
        this.filterStrings.ImporterName = storedImporter.ImporterName || "";
      }
    },
    writeComponentSettingsToStore: function writeComponentSettingsToStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      this.$store.commit("localFilters/locationManagement", {
        filterStrings: this.filterStrings,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        pageSize: this.pageSize
      });

      if (!this.$store.getters["userSettings/syncFilters"]) return;
      if (!this.feature.isAudiTarget || !this.feature.isEnabled("audi_importers")) {
        var storedClient = this.$store.getters["sharedFilters/client"];
        if (storedClient.ClientName !== this.filterStrings.ClientName) {
          this.$store.commit("sharedFilters/client", {
            ClientName: this.filterStrings.ClientName
          });
        }
      } else {
        var storedImporter = this.$store.getters["sharedFilters/importer"];
        if (storedImporter.ImporterName !== this.filterStrings.ImporterName) {
          this.$store.commit("sharedFilters/importer", {
            ImporterName: this.filterStrings.ImporterName
          });
        }
      }
    },
    onLocationDataUpdated: function onLocationDataUpdated($event) {
      if ($event) {
        this.selectedLocation = $event.LocationId;
        this.selectedLocationGuid = $event.LocationGuid;
      }
      this.getLocationData();
    },
    openDeleteLocationDialog: function openDeleteLocationDialog() {
      var _this = this;

      var objIndex = _.findIndex(this.locationData, function (o) {
        return o.LocationId == _this.selectedLocation;
      });
      this.deleteLocationDialogData = this.locationData[objIndex];
      $("#deleteLocation").modal("show");
    },
    deleteLocationData: function deleteLocationData() {
      var _this2 = this;

      $.ajax({
        method: "DELETE",
        url: "api/Locations/" + this.selectedLocation,
        success: function success(data) {
          $("#deleteLocation").modal("hide");
          _this2.globals.showSuccessSnackbar("Location deletion successful");
          _this2.selectedLocation = -1;
          _this2.selectedLocationGuid = "";
          _this2.getLocationData();
        },
        error: function error() {
          console.error("Location data deletion failed in deleteLocationData()");
          _this2.globals.showErrorSnackbar("Location deletion failed");
        }
      });
    },
    sortLocationData: function sortLocationData(field) {
      if (field == this.sortField) {
        this.sortOrder == "asc" ? this.sortOrder = "desc" : this.sortOrder = "asc";
      } else {
        this.sortField = field;
        this.sortOrder = "asc";
      }
      this.selectedPage = 1;
      this.getLocationData();
    },
    getLocationData: function getLocationData() {
      var _this3 = this;

      this.refreshEnabled = false;

      var getString = "api/Locations/Get?page_size=" + this.pageSize + "&page=" + this.selectedPage + "&sort_column=" + this.sortField + "&sort_order=" + this.sortOrder;
      getString = encodeURI(getString);

      var filter = _.pickBy(this.filterStrings, function (value, key) {
        return value.length > 0;
      });

      $.ajax({
        method: "POST",
        url: getString,
        data: _.isEmpty(filter) ? "" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ Filter: filter }),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (typeof data[0] == "undefined") {
            _this3.locationData = [];
            _this3.pageCount = 1;
          } else {
            _this3.locationData = data[0].Locations;
            _this3.pageCount = data[0].Page_Count;
            _this3.totalElementsCount = data[0].Count;
          }
        },
        error: function error() {
          console.error("Error on POST in getLocationData()");
          _this3.globals.showErrorSnackbar("Location data access failed");
        },
        complete: function complete() {
          _this3.refreshEnabled = true;
        }
      });
    },
    updatePaging: function updatePaging(pageNumber, pageSize) {
      this.selectedPage = pageNumber || 1;
      if (pageSize != 0) this.pageSize = pageSize;
      this.getLocationData();
    },
    getRange: function getRange(min, max, step) {
      var range = [],
          j = 0;
      for (var i = min; i <= max; i += step) {
        range[j++] = i;
      }
      return range;
    },
    getVisiblePages: function getVisiblePages() {
      if (this.pageCount <= 7) {
        return this.getRange(1, this.pageCount, 1);
      } else if (this.pageCount > 7 && this.selectedPage <= 4) {
        return this.getRange(1, 6, 1);
      } else if (this.pageCount > 7 && this.selectedPage >= this.pageCount - 3) {
        return this.getRange(this.pageCount - 5, this.pageCount, 1);
      } else {
        return this.getRange(this.selectedPage - 2, this.selectedPage + 2, 1);
      }
    }
  },
  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this, this.setLocationTableHeight);
    }
  },
  data: function data() {
    // Global data inside the component is stored here
    return {
      selectedLocation: -1, // ID of the selected location, -1 if none is selected
      selectedLocationGuid: "",
      pageSize: 20, // Number of locations on one page of the table
      selectedPage: 1, // Number of the page, that is visible
      pageCount: 0, // Count of available pages depending on the pagesize and the data
      totalElementsCount: 0,
      filterStrings: {
        // Strings that are manipulated by the user for filtering the table
        Search: "",
        ClientId: "",
        ClientName: "",
        ImporterName: "",
        LocationStoreId: "",
        LocationName: "",
        LocationAddress: "",
        LocationCity: "",
        LocationPostalCode: "",
        LocationCountry: "",
        LocationStatusId: ""
      },
      sortField: "LocationName", // Selected column for sorting
      sortOrder: "asc", // Should be "asc" or "desc"
      refreshEnabled: false, // false, if location data is requested and server did not respond yet to avoid multiple requests at the same time
      locationData: [], // Stores the location data on the current page
      deleteLocationDialogData: {}, // Stores data for the deleteLocation dialog
      showLocationImportDataModal: false,
      showLocationExportModal: false,
      showEditLocationModal: false,
      showLocationDataTranslateModal: false,
      lang: {
        // Contains localization strings for the selected language
        L0000: "Aktualisieren",
        L0001: "Neuer Standort",
        L0002: "Bearbeiten",
        L0003: "Löschen",
        L0004: "Geokodierung",
        L0005: "Suche...",
        L0006: "Elemente pro Seite",
        L0007: "Erste Seite",
        L0008: "Letzte Seite",
        L0009: "Kunde",
        L0010: "LOC#",
        L0011: "Name",
        L0012: "Straße",
        L0013: "Stadt",
        L0014: "Region",
        L0015: "PLZ",
        L0016: "Land",
        L0017: "Telefon",
        L0018: "Stunden",
        L0019: "Status",
        L0020: "Filter",
        L0021: "Allgemein",
        L0022: "Kunde",
        L0023: "Bitte auswählen...",
        L0024: "Store-ID",
        L0025: "Name des Standortes",
        L0026: "Straße",
        L0027: "Adresszusatz",
        L0028: "Landkreis",
        L0029: "Stadt",
        L0030: "Land",
        L0031: "Region",
        L0032: "Zeitzone",
        L0033: "PLZ",
        L0034: "Telefon",
        L0035: "Telefax",
        L0036: "Öffnungszeiten",
        L0037: "Standort Foto URL",
        L0038: "Export E-Mail",
        L0039: "Export E-Mail Name",
        L0040: "Standort Status",
        L0041: "Aktiv",
        L0042: "Vorübergehend Deaktiviert",
        L0043: "Dauerhaft Deaktiviert",
        L0044: "Breitengrad",
        L0045: "Längengrad",
        L0046: "Geocode Quelle",
        L0052: "Zusätzliche Anmerkungen",
        L0053: "Zusätzliche Anmerkungen",
        L0054: "Benutzerdefinierte Eigenschaften",
        L0055: "Beschreibung",
        L0056: "Wert",
        L0057: "Ihre Eingaben sind fehlerhaft. Bitte prüfen Sie alle rot markierten Felder!",
        L0058: "Abbrechen",
        L0059: "Speichern",
        L0060: "Standort löschen",
        L0061: "Soll folgender Standort wirklich gelöscht werden?",
        L0062: "Kunde",
        L0063: "LOC#",
        L0064: "Name",
        L0065: "Straße",
        L0066: "Stadt",
        L0067: "Region",
        L0068: "PLZ",
        L0069: "Land",
        L0070: "Telefon",
        L0071: "Stunden",
        L0072: "Status",
        L0073: "Nein",
        L0074: "Ja",
        L0075: "Neuer Standort",
        L0076: "Standort bearbeiten",
        L0077: "Kunden-ID",
        L0078: "Diese Angabe ist erforderlich!",
        L0079: "Dies ist keine gültige Telefonnummer!",
        L0080: "Dies ist keine gültige Faxnummer!",
        L0081: "Dies ist keine gültige URL!",
        L0082: "Dies ist keine gültige E-Mail Adresse!",
        L0083: "Ungültiger Wert",
        L0084: "Default Export Country",
        L0085: "Default Export Language",
        L0086: "Location Import",
        L0087: "Download locations",
        L0088: "Importer",
        L0089: "Total locations count",
        L0090: "Show location history",
        L0091: "Translate"
      }
    };
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tools_Select2__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Tools_Select2__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "LocationManagementEditModal",
  components: {
    Select2: __WEBPACK_IMPORTED_MODULE_1__Tools_Select2___default.a
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    selectedLocation: {
      type: Number,
      default: -1
    },
    lang: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      dialogTitle: "",
      locationData: {},
      currentRegions: [],
      currentTimeZones: [],
      currentExportLanguages: [],
      showAlert: false,
      timeZones: [],
      locationStatusList: [],
      regionList: [],
      clientList: [],
      importerList: [],
      countryLanguages: [],
      invalidInputIds: []
    };
  },

  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.getLocationStatusList();
      this.globals.getCountryList();
    },
    showModal: function showModal(newVal) {
      if (newVal) this.initLocationData();
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.getSelectData();

    $("#locationManagementEditModal").on("hidden.bs.modal", function (e) {
      return _this.$emit("modalClosed");
    });
  },

  methods: {
    openModal: function openModal() {
      $("#locationManagementEditModal").modal("show");
    },
    closeModal: function closeModal() {
      $("#locationManagementEditModal").modal("hide");
    },
    correctTextareaHeight: function correctTextareaHeight() {
      this.$nextTick(function () {
        var textareas = document.getElementsByClassName("autoExpand");
        for (var i = 0; i < textareas.length; i++) {
          $(textareas[i]).trigger("input");
        }
      });
    },
    validateInput: function validateInput(id) {
      var result = $("#" + id)[0].checkValidity();
      if (result) {
        $("#" + id).parent().parent().removeClass("has-error");
        var idx = this.invalidInputIds.indexOf(id);
        if (idx > -1) {
          this.invalidInputIds.splice(idx, 1);
        }
      } else {
        $("#" + id).parent().parent().addClass("has-error");
        if (this.invalidInputIds.indexOf(id) < 0) this.invalidInputIds.push(id);
      }
      return result;
    },
    inputHasError: function inputHasError(id) {
      if (this.invalidInputIds.indexOf(id) > -1) return true;
      return false;
    },
    validateBeforeSubmit: function validateBeforeSubmit(dialogId) {
      var result = true;

      var elements = $("#" + dialogId).find(":input");
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0) result = this.validateInput(elements[i].id) && result;
      }

      if (dialogId === "locationManagementEditModal") {
        this.showAlert = !result;
        if (!result) return;
        this.saveLocationData();
      }
    },
    resetValidationErrors: function resetValidationErrors(dialogId) {
      var elements = $("#" + dialogId).find(":input");
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0) $("#" + elements[i].id).parent().parent().removeClass("has-error");
      }
      this.invalidInputIds = [];
    },
    showLocationHistory: function showLocationHistory() {
      var config = {
        type: "Location",
        guid: this.locationData.LocationGuid,
        id: this.locationData.LocationId
      };
      this.globals.$emit("showElementHistory", config);
    },
    changedCountry: function changedCountry(country) {
      var regionObj = [{ Regions: [] }];
      var tzObj = [{ TimeZones: [] }];

      if (this.regionList) {
        if (country) {
          regionObj = this.regionList.filter(function (region) {
            return region.Country.toLowerCase().indexOf(country.toLowerCase()) >= 0;
          });
        }
      }

      if (this.timeZones) {
        if (country) {
          tzObj = this.timeZones.filter(function (tz) {
            return tz.Country.toLowerCase().indexOf(country.toLowerCase()) >= 0;
          });
        }
      }

      if (regionObj.length === 0) this.currentRegions = [];else this.currentRegions = regionObj[0].Regions;

      if (tzObj.length === 0) this.currentTimeZones = [];else this.currentTimeZones = tzObj[0].TimeZones;

      var idx = this.currentRegions.map(function (e) {
        return e.Region;
      }).indexOf(this.locationData.LocationState_Region);
      if (idx < 0) delete this.locationData.LocationState_Region;

      idx = this.currentTimeZones.map(function (e) {
        return e.TimeZoneId;
      }).indexOf(this.locationData.LocationTimeZoneId);
      if (idx < 0) delete this.locationData.LocationTimeZoneId;

      this.$refs.regionSelect.updateValue();
      this.$refs.timeZoneSelect.updateValue();
    },
    changedExportCountryCode: function changedExportCountryCode(keepLanguageCode) {
      var languageList = [];
      if (this.countryLanguages[0]) {
        var cc = this.locationData.LocationExportDefaultCountryCode;
        if (cc) {
          var cl = this.countryLanguages.filter(function (country) {
            return country.CountryCode === cc;
          });
          if (cl[0] && cl[0].Languages) languageList = cl[0].Languages;
        }
      }
      this.currentExportLanguages = languageList;
      if (!keepLanguageCode) delete this.locationData.LocationExportDefaultLanguageCode;

      this.$refs.exportLanguageSelect.updateValue();
    },
    sortCustomPropertiesByPosition: function sortCustomPropertiesByPosition() {
      if (!this.locationData.CustomProperties) return;

      this.locationData.CustomProperties.sort(function (a, b) {
        return a.Position - b.Position;
      });
    },
    locationDataReceived: function locationDataReceived() {
      this.openModal();

      if ($("#collapseCustProp").attr("aria-expanded")) {
        $("#locationManagementEditModal").off("shown.bs.modal", this.correctTextareaHeight);
        $("#locationManagementEditModal").on("shown.bs.modal", this.correctTextareaHeight);
      }
      $("#collapseCustProp").off("shown.bs.collapse", this.correctTextareaHeight);
      $("#collapseCustProp").on("shown.bs.collapse", this.correctTextareaHeight);
    },
    initLocationData: function initLocationData() {
      var _this2 = this;

      if (this.selectedLocation < 1) {
        this.dialogTitle = this.lang.L0075;
        this.locationData = {
          LocationStatusId: "A"
        };
        if (this.audiClientId) {
          this.locationData.ClientId = this.audiClientId;
          this.getLocationProperties(this.audiClientId);
        }

        this.changedCountry("");
        this.currentExportLanguages = [];
        this.openModal();
      } else {
        this.dialogTitle = this.lang.L0076;
        this.locationData = {};
        this.currentExportLanguages = [];

        $.ajax({
          method: "GET",
          url: "api/Locations/" + this.selectedLocation,
          success: function success(data) {
            if (data.Error) {
              console.error(data.Error);
              _this2.globals.showErrorSnackbar(data.Error);
              return;
            }
            _this2.locationDataReceived();
            if (data.Importers) {
              data.ImporterGuid = data.Importers[0].ImporterGuid;
              delete data.Importers;
            }
            _this2.locationData = data;
            _this2.changedCountry(_this2.locationData.LocationCountry);
            _this2.changedExportCountryCode(true);
            _this2.sortCustomPropertiesByPosition();
          },
          error: function error() {
            console.error("Location data access failed in initLocationData()");
            _this2.globals.showErrorSnackbar("Location data access failed");
          }
        });
      }
      this.showAlert = false;
      this.resetValidationErrors("locationManagementEditModal");
    },
    saveLocationData: function saveLocationData() {
      var _this3 = this;

      if (this.clientList.length < 1) {
        this.globals.showErrorSnackbar("No client available");
        return;
      }
      var sendData = _.cloneDeep(this.locationData);
      if (sendData.ImporterGuid) {
        sendData.Importers = [{ ImporterGuid: sendData.ImporterGuid }];
        delete sendData.ImporterGuid;

        if (!sendData.ClientId) sendData.ClientId = this.clientList[0].ClientId;
      }

      for (var prop in sendData) {
        if (typeof sendData[prop] === "string" && !sendData[prop]) delete sendData[prop];
      }

      if (this.selectedLocation < 1) {
        $.ajax({
          method: "POST",
          url: "api/Locations",
          data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(sendData),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            if (data.Error) {
              console.error(data.Error);
              _this3.globals.showErrorSnackbar(data.Error);
              return;
            }
            _this3.globals.showSuccessSnackbar("Location creation successful");
            _this3.closeModal();
            _this3.$emit("locationDataUpdated", data[0].LocationId);
          },
          error: function error() {
            console.error("Error on POST in saveLocationData()");
            _this3.globals.showErrorSnackbar("Location creation failed");
          }
        });
      } else {
        $.ajax({
          method: "PUT",
          url: "api/Locations/" + this.locationData.LocationId,
          data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(sendData),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            if (data.Error) {
              console.error(data.Error);
              _this3.globals.showErrorSnackbar(data.Error);
              return;
            }
            _this3.globals.showSuccessSnackbar("Location update successful");
            _this3.closeModal();
            _this3.$emit("locationDataUpdated");
          },
          error: function error() {
            console.error("Error on PUT in saveLocationData()");
            _this3.globals.showErrorSnackbar("Location update failed");
          }
        });
      }
    },
    getSelectData: function getSelectData() {
      var _this4 = this;

      if (this.globals.selectedLanguage) {
        this.globals.getCountryList();
        this.getLocationStatusList();
      }
      this.globals.getCountryLanguageList(function (callbackData) {
        _this4.countryLanguages = callbackData;
      });
      this.getClientList(function () {
        if (_this4.feature.isAudiTarget && _this4.clientList[0]) {
          _this4.audiClientId = _this4.clientList[0].ClientId;
        }
      });
      if (this.feature.isAudiTarget && this.feature.isEnabled("audi_importers")) {
        this.globals.getImporterList(function (callbackData) {
          _this4.importerList = _.cloneDeep(callbackData);
          _.remove(_this4.importerList, function (importer) {
            return importer.ImporterGuid === "1D86A788-07D6-4681-BD8C-9C15800DF8BA";
          });
        });
      }
      this.globals.getRegionsList(function (callbackData) {
        _this4.regionList = callbackData;
      });
      this.globals.getTimezonesList(function (callbackData) {
        _this4.timeZones = callbackData;
      });
    },
    getClientList: function getClientList(callback) {
      var _this5 = this;

      $.ajax({
        method: "GET",
        url: "api/Data/Clients",
        success: function success(data) {
          _this5.clientList = [];
          for (var x in data) {
            _this5.clientList.push({ ClientId: x, ClientName: data[x] });
          }

          _this5.clientList.sort(function (a, b) {
            if (a.ClientName.toLowerCase() < b.ClientName.toLowerCase()) return -1;
            if (a.ClientName.toLowerCase() > b.ClientName.toLowerCase()) return 1;
            return 0;
          });

          if (callback) callback();
        },
        error: function error() {
          console.error("Client data access failed in getClientList()");
          _this5.globals.showErrorSnackbar("Client data access failed");
        }
      });
    },
    getLocationStatusList: function getLocationStatusList() {
      var _this6 = this;

      $.ajax({
        method: "GET",
        url: "api/data/locationstatusses",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this6.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this6.locationStatusList = data;
        },
        error: function error() {
          console.error("Location status data access failed in getLocationStatusList()");
          _this6.globals.showErrorSnackbar("Location status data access failed");
        }
      });
    },
    getLocationProperties: function getLocationProperties(clientId) {
      var _this7 = this;

      if (!clientId) return;

      $.ajax({
        method: "GET",
        url: "/api/Clients/" + clientId + "/LocationProperties",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this7.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this7.locationData.CustomProperties = data;
          _this7.sortCustomPropertiesByPosition();
          _this7.$forceUpdate();
        },
        error: function error() {
          console.error("Location properties data access failed in getLocationProperties()");
          _this7.globals.showErrorSnackbar("Location properties data access failed");
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    setInitialRoute: function setInitialRoute() {
      if (this.globals.currentUserRole === 1) {
        this.globals.currentUserInfo.IsAudiUser ? this.$router.push("/locationmanagement") : this.$router.push("/clientmanagement");
      } else {
        this.$router.push("/checkmanagement");
      }
    }
  }
});

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProjectManagementEditModal__ = __webpack_require__(1587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProjectManagementEditModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ProjectManagementEditModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ScenarioEditModal__ = __webpack_require__(1589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ScenarioEditModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ScenarioEditModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WaveEditModal__ = __webpack_require__(1590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WaveEditModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__WaveEditModal__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ProjectManagement",
  components: {
    ProjectManagementEditModal: __WEBPACK_IMPORTED_MODULE_1__ProjectManagementEditModal___default.a,
    ScenarioEditModal: __WEBPACK_IMPORTED_MODULE_2__ScenarioEditModal___default.a,
    WaveEditModal: __WEBPACK_IMPORTED_MODULE_3__WaveEditModal___default.a
  },
  mounted: function mounted() {
    this.readComponentSettingsFromStore();
    // Gets executed right after rendering the component
    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this);
      this.getProjectData();
    }
    this.getEditProjectDialogSelectData();

    // Sets the new table height after the window got resized
    $(window).on("resize", this.setTableHeight).resize();

    if (!this.globals.currentUserInfo) this.globals.$once("currentUserInfoReceived", this.setTableHeight);
  },
  destroyed: function destroyed() {
    $(window).off("resize", this.setTableHeight);
    this.writeComponentSettingsToStore();
  },

  methods: {
    setTableHeight: function setTableHeight() {
      this.$nextTick(function () {
        var height = $(window).height();
        height -= $("#projects-top-panel").height() + $("#app-navbar").height() + $(".main-table > thead").height() + 47; // 47 pixel for the free space around the cards
        $(".main-table-scrollbar").css("max-height", height);
      });
    },
    readComponentSettingsFromStore: function readComponentSettingsFromStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      var storedData = this.$store.getters["localFilters/projectManagement"];
      if (storedData) {
        for (var key in storedData) {
          if (_.has(this, key)) this[key] = _.cloneDeep(storedData[key]);
        }
      }

      if (!this.$store.getters["userSettings/syncFilters"]) return;
      var storedProject = this.$store.getters["sharedFilters/project"];
      this.filterStrings.ProjectName = storedProject.ProjectName || "";

      if (!this.feature.isAudiTarget || !this.feature.isEnabled("audi_importers")) {
        var storedClient = this.$store.getters["sharedFilters/client"];
        this.filterStrings.ClientName = storedClient.ClientName || "";
      } else {
        var storedImporter = this.$store.getters["sharedFilters/importer"];
        this.filterStrings.ImporterName = storedImporter.ImporterName || "";
      }
    },
    writeComponentSettingsToStore: function writeComponentSettingsToStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      this.$store.commit("localFilters/projectManagement", {
        filterStrings: this.filterStrings,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        pageSize: this.pageSize
      });

      if (!this.$store.getters["userSettings/syncFilters"]) return;
      var storedProject = this.$store.getters["sharedFilters/project"];
      if (storedProject.ProjectName !== this.filterStrings.ProjectName) {
        this.$store.commit("sharedFilters/project", {
          ProjectName: this.filterStrings.ProjectName
        });
      }
      if (!this.feature.isAudiTarget || !this.feature.isEnabled("audi_importers")) {
        var storedClient = this.$store.getters["sharedFilters/client"];
        if (storedClient.ClientName !== this.filterStrings.ClientName) {
          this.$store.commit("sharedFilters/client", {
            ClientName: this.filterStrings.ClientName
          });
        }
      } else {
        var storedImporter = this.$store.getters["sharedFilters/importer"];
        if (storedImporter.ImporterName !== this.filterStrings.ImporterName) {
          this.$store.commit("sharedFilters/importer", {
            ImporterName: this.filterStrings.ImporterName
          });
        }
      }
    },

    // Gets executed after the editProjectDialog successfully saved some data
    onEditProjectDialogDataSaved: function onEditProjectDialogDataSaved(newProjectData) {
      this.getProjectData(); // Refresh datatable
      if (newProjectData.ProjectId) {
        this.selectedProjectData = newProjectData;
        this.selectedProject = newProjectData.ProjectId;
        this.clientOfSelectedProject = newProjectData.ClientId;
      }
    },


    // Gets executed after the editProjectDialog got closed
    onEditProjectDialogClosed: function onEditProjectDialogClosed() {
      this.showEditProjectDialog = false;
    },
    onEditScenarioDialogClosed: function onEditScenarioDialogClosed() {
      this.showEditScenarioDialog = false;
    },
    onEditWaveDialogClosed: function onEditWaveDialogClosed() {
      this.showEditWaveDialog = false;
    },


    // Opens the security check dialog for deleting the selected project
    openDeleteProjectDialog: function openDeleteProjectDialog() {
      var _this = this;

      var objIndex = _.findIndex(this.projectData, function (o) {
        return o.ProjectId == _this.selectedProject;
      });
      this.deleteProjectDialogData = this.projectData[objIndex];
      $("#deleteProjectDialog").modal("show");
    },


    // Sends a delete request for the selected project to the server
    deleteProjectData: function deleteProjectData() {
      var _this2 = this;

      $.ajax({
        method: "DELETE",
        url: "api/Projects/" + this.selectedProject,
        success: function success(data) {
          // If delete was successful, refresh displayed data and hide dialog
          _this2.globals.showSuccessSnackbar("Project deletion successful");
          _this2.selectedProject = -1;
          _this2.getProjectData();
          $("#deleteProjectDialog").modal("hide");
        },
        error: function error() {
          console.error("Project data deletion failed in deleteProjectData()");
          _this2.globals.showErrorSnackbar("Project deletion failed");
        }
      });
    },


    // Catch client list
    getClientList: function getClientList() {
      var _this3 = this;

      $.ajax({
        method: "GET",
        url: "api/Data/Clients",
        success: function success(data) {
          _this3.clientList = [];
          for (var x in data) {
            _this3.clientList.push({ ClientId: x, ClientName: data[x] });
          }

          _this3.clientList.sort(function (a, b) {
            // Sort clients by name
            if (a.ClientName.toLowerCase() < b.ClientName.toLowerCase()) return -1;
            if (a.ClientName.toLowerCase() > b.ClientName.toLowerCase()) return 1;
            return 0;
          });
        },
        error: function error() {
          console.error("Client data access failed in getClientList()");
          _this3.globals.showErrorSnackbar("Client data access failed");
        }
      });
    },


    // Catch survey list
    getSurveyList: function getSurveyList() {
      var _this4 = this;

      $.ajax({
        method: "GET",
        url: "api/Data/surveys",
        success: function success(data) {
          _this4.surveyList = [];
          if (!_.isEmpty(data)) _this4.surveyList = data;
        },
        error: function error() {
          console.error("Survey data access failed in getSurveyList()");
          _this4.globals.showErrorSnackbar("Survey data access failed");
        }
      });
    },


    // Catches data for dropdown lists from server
    getEditProjectDialogSelectData: function getEditProjectDialogSelectData() {
      this.getClientList();
      this.getSurveyList();
    },


    // Calculates the sort order for the given column and refreshes the displayed data
    sortProjectData: function sortProjectData(field) {
      if (field == this.sortField) {
        this.sortOrder == "asc" ? this.sortOrder = "desc" : this.sortOrder = "asc";
      } else {
        this.sortField = field;
        this.sortOrder = "asc";
      }
      this.selectedPage = 1;
      this.getProjectData();
    },


    // Catches project data for the table from the server, including current filter, pagination and sort settings
    getProjectData: function getProjectData() {
      var _this5 = this;

      this.refreshEnabled = false;

      var getString = "api/Projects/Get?page_size=" + this.pageSize + "&page=" + this.selectedPage + "&sort_column=" + this.sortField + "&sort_order=" + this.sortOrder;
      getString = encodeURI(getString);

      var filter = _.pickBy(this.filterStrings, function (value, key) {
        return value.length > 0;
      });

      $.ajax({
        method: "POST",
        url: getString,
        data: _.isEmpty(filter) ? "" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ Filter: filter }),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          _this5.projectData = data[0].Projects; // If GET was successful, store project data and page count from server
          _this5.pageCount = data[0].Page_Count;
          _this5.totalElementsCount = data[0].Count;
        },
        error: function error() {
          console.error("Error on POST in getProjectData()");
          _this5.globals.showErrorSnackbar("Project data access failed");
        },
        complete: function complete() {
          _this5.refreshEnabled = true;
        }
      });
    },


    // Updates the current pagesize and the selected pagenumber and triggers the refresh of the table
    updatePaging: function updatePaging(pageNumber, pageSize) {
      this.selectedPage = pageNumber || 1;
      if (pageSize != 0) this.pageSize = pageSize;
      this.getProjectData();
    },


    // Returns a range of numbers with min-value, max-value and stepsize
    getRange: function getRange(min, max, step) {
      var range = [],
          j = 0;
      for (var i = min; i <= max; i += step) {
        range[j++] = i;
      }
      return range;
    },


    // Returns a list of all pagenumbers that should be visible depending on the current page and the count of pages
    getVisiblePages: function getVisiblePages() {
      if (this.pageCount <= 7) {
        return this.getRange(1, this.pageCount, 1);
      } else if (this.pageCount > 7 && this.selectedPage <= 4) {
        return this.getRange(1, 6, 1);
      } else if (this.pageCount > 7 && this.selectedPage >= this.pageCount - 3) {
        return this.getRange(this.pageCount - 5, this.pageCount, 1);
      } else {
        return this.getRange(this.selectedPage - 2, this.selectedPage + 2, 1);
      }
    }
  },
  watch: {
    selectedProject: function selectedProject(newValue) {
      if (newValue < 0) {
        this.selectedProjectData = {};
        return;
      }
      if (this.selectedProjectData.ProjectId === newValue) return;
      var project = _.find(this.projectData, function (p) {
        return p.ProjectId == newValue;
      });
      if (project) this.selectedProjectData = project;
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
      this.getProjectData();
    }
  },
  data: function data() {
    // Global data inside the component is stored here
    return {
      selectedProject: -1, // ID of the selected project, -1 if none is selected
      selectedProjectData: {},
      clientOfSelectedProject: -1,
      pageSize: 20, // Number of projects on one page of the table
      selectedPage: 1, // Number of the page, that is visible
      pageCount: 0, // Count of available pages depending on the pagesize and the data
      totalElementsCount: 0,
      showEditProjectDialog: false,
      showEditScenarioDialog: false,
      showEditWaveDialog: false,
      editProjectDialogModeAdd: true,
      filterStrings: {
        // Strings that are manipulated by the user for filtering the table
        Search: "",
        ProjectId: "",
        ProjectName: "",
        ClientName: "",
        ImporterName: "",
        ProjectActiveLocationsCount: "",
        ProjectTotalLocationsCount: "",
        ProjectSurveysCount: "",
        ProjectSince: "",
        ProjectCreatedBy: ""
      },
      sortField: "projectName", // Selected column for sorting
      sortOrder: "asc", // Should be "asc" or "desc"
      refreshEnabled: false, // false, if project data is requested and server did not respond yet to avoid multiple requests at the same time
      projectData: [], // Stores the project data on the current page
      clientList: [], // List of all clients
      surveyList: [], // List of all surveys
      deleteProjectDialogData: {}, // Stores data for the deleteProject dialog
      invalidInputIds: [], // IDs of inputs with validation error
      lang: {
        // Contains localization strings for the selected language
        P0000: "Refresh",
        P0001: "Add project",
        P0002: "Edit",
        P0003: "Delete",
        P0004: "Search...",
        P0005: "Items per page",
        P0006: "First page",
        P0007: "Last page",
        P0008: "ProjectID",
        P0009: "Name",
        P0010: "Active locations",
        P0011: "All locations",
        P0012: "Active surveys",
        P0014: "Creation date",
        P0015: "Created by",
        P0016: "Filter",
        P0017: "Add project",
        P0018: "Edit project",
        P0019: "Delete project",
        P0020: "Do you really want to delete the following project?",
        P0021: "ProjectID",
        P0022: "Name",
        P0023: "Created at",
        P0024: "No",
        P0025: "Yes",
        P0026: "Cancel",
        P0027: "Save",
        P0028: "Scenarios",
        P0029: "Waves",
        P0030: "Client",
        P0031: "Importer",
        P0032: "Total projects count"
      }
    };
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProjectManagementGantt__ = __webpack_require__(1588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProjectManagementGantt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ProjectManagementGantt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tools_Select2__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Tools_Select2__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var uuidv4 = __webpack_require__(60);

// Returns the current date with an offset of days
var getCurrentDate = function getCurrentDate(days) {
  var cdate = new Date();
  cdate.setDate(cdate.getDate() + days);
  cdate.setHours(0, 0, 0, 0);
  return cdate;
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ProjectManagementEditModal",
  components: { gantt: __WEBPACK_IMPORTED_MODULE_1__ProjectManagementGantt___default.a, Select2: __WEBPACK_IMPORTED_MODULE_2__Tools_Select2___default.a },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    this.getProjectAccountables();
    if (this.feature.isAudiTarget && this.feature.isEnabled("audi_importers")) {
      this.globals.getImporterList(function (data) {
        _this.importerList = data;
      });
    }

    $("#editProjectDialog").on("hidden.bs.modal", function (e) {
      _this.$emit("dialogClosed");
    });

    $("#editProjectDialog").on("shown.bs.modal", function () {
      gantt.render();
    });

    $("#collapseEditProjectPlanning").on("show.bs.collapse", function () {
      $("#editProjectDialog .modal-dialog").css("width", "95vw");
      _this.isGanttVisible = true;
    });
    $("#collapseEditProjectPlanning").on("hide.bs.collapse", function () {
      $("#editProjectDialog .modal-dialog").css("width", "1200px");
      _this.isGanttVisible = false;
    });

    $("#collapseEditProjectPlanning").on("shown.bs.collapse", function () {
      gantt.render();
    });

    // Initialize flatpickr instances
    this.fpProjectSince = flatpickr("#inputProjectSince", this.globals.flatpickrDateConfig);
    this.fpProjectUntil = flatpickr("#inputProjectUntil", this.globals.flatpickrDateConfig);
  },
  destroyed: function destroyed() {
    if (this.fpProjectSince) this.fpProjectSince.destroy();
    if (this.fpProjectUntil) this.fpProjectUntil.destroy();
  },

  methods: {
    // Validates an input with the given id, changes the input color depending on the validation result and returns the result
    validateInput: function validateInput(id) {
      var result = $("#" + id)[0].checkValidity(); // Checks validation depending on the input type or a given pattern in the template
      if (result) {
        $("#" + id).parent().parent().removeClass("has-error"); // has-error has to be added to the form-group element
        var idx = this.invalidInputIds.indexOf(id);
        if (idx > -1) {
          this.invalidInputIds.splice(idx, 1); // Remove from list, if valid
        }
      } else {
        $("#" + id).parent().parent().addClass("has-error");
        if (this.invalidInputIds.indexOf(id) < 0) this.invalidInputIds.push(id); // Add to list, if invalid
      }
      return result;
    },


    // Returns true if an input has a validation error, otherwise false
    inputHasError: function inputHasError(id) {
      if (this.invalidInputIds.indexOf(id) > -1) return true;
      return false;
    },


    // Triggers input validation and ensures further progress if validation was successful
    validateBeforeSubmit: function validateBeforeSubmit(dialogId) {
      var result = true;

      var elements = $("#" + dialogId).find(":input"); // Returns a list of all inputs on the dialog
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0) result = this.validateInput(elements[i].id) && result; // If only one input is invalid, the whole form is invalid
      }

      if (dialogId == "editProjectDialog") {
        this.showAlert = !result;
        if (!result) return;
        this.saveEditProjectDialogData();
      }
    },


    // Resets all validation errors for the given dialog
    resetValidationErrors: function resetValidationErrors(dialogId) {
      var elements = $("#" + dialogId).find(":input"); // Returns a list of all inputs on the dialog
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0) $("#" + elements[i].id).parent().parent().removeClass("has-error");
      }
      this.invalidInputIds = [];
    },
    zoomGanttChart: function zoomGanttChart(zoomIn) {
      var currentUnit = gantt.config.scale_unit;
      var newUnit = "";

      switch (currentUnit) {
        case "week":
          newUnit = zoomIn ? "week" : "month";
          break;
        case "month":
          newUnit = zoomIn ? "week" : "year";
          break;
        case "year":
          newUnit = zoomIn ? "month" : "year";
          break;
        default:
          newUnit = "week";
      }

      switch (newUnit) {
        case "week":
          gantt.config.date_scale = "%F, %Y, W%W";
          gantt.config.subscales = [{ unit: "day", step: 1, date: "%j, %D" }];
          break;
        case "month":
          gantt.config.date_scale = "%M %Y";
          gantt.config.subscales = [{ unit: "week", step: 1, date: "W%W" }];
          break;
        case "year":
          gantt.config.date_scale = "%Y";
          gantt.config.subscales = [{ unit: "month", step: 1, date: "%M" }];
          break;
        default:
          gantt.config.date_scale = "%F, %Y, W%W";
          gantt.config.subscales = [{ unit: "day", step: 1, date: "%j, %D" }];
      }

      gantt.config.scale_unit = newUnit;
      this.currentScaleUnit = newUnit;
      gantt.render();
    },


    // Stores all surveys that are available for the selected client to a list and removes all selected surveys, if necessary
    filterSurveysForClient: function filterSurveysForClient(cid, removeSelectedSurveys) {
      if (cid > -1) {
        var listObj = this.surveyList.filter(function (s) {
          return s.ClientId == cid;
        });
        this.availableSurveys = listObj.length == 0 ? [] : listObj[0].Surveys;
      } else this.availableSurveys = [];

      this.selectedAssignedSurveyIds = [];
      this.selectedUnassignedSurveyIds = [];

      if (removeSelectedSurveys) this.projectData.Surveys = [];
    },
    getAvailableSurveysForClient: function getAvailableSurveysForClient() {
      var _this2 = this;

      var request = "api/Clients/" + this.projectData.ClientId + "/AvailableSurveys";
      this.projectData.AvailableSurveys = [];

      $.ajax({
        method: "GET",
        url: request,
        success: function success(data) {
          if (data && data.AvailableSurveys) {
            _this2.projectData.AvailableSurveys = data.AvailableSurveys;
          }
          _this2.filterSurveysForClient(_this2.projectData.ClientId, true);
        },
        error: function error() {
          console.error("Survey data access failed in getAvailableSurveysForClient()");
          _this2.globals.showErrorSnackbar("Survey data access failed");
        }
      });
    },


    // Shows a security modal for changing reporting visibility to avoid data loss
    surveyReportingVisibilityChanged: function surveyReportingVisibilityChanged(survey) {
      if (survey.ReportingVisibility === false) return;
      var forceReportingVisibilityChange = false;

      this.globals.$off("SurveyReportingVisibilityChangedModalYesConfirmation");
      this.globals.$on("SurveyReportingVisibilityChangedModalYesConfirmation", function () {
        survey.ReportingVisibility = true;
        forceReportingVisibilityChange = true;
      });
      this.globals.$off("SurveyReportingVisibilityChangedModalDialogClosed");
      this.globals.$on("SurveyReportingVisibilityChangedModalDialogClosed", function () {
        if (!forceReportingVisibilityChange) survey.ReportingVisibility = false;
        forceReportingVisibilityChange = false;
      });

      this.globals.$emit("openGlobalConfirmationDialog", {
        initiator: "SurveyReportingVisibilityChangedModal",
        confirmationTitle: this.lang.P1019,
        colorRed: true,
        yesButtonText: this.lang.P1017,
        noButtonText: this.lang.P1018,
        htmlText: "<p><b>" + this.lang.P1020 + "</b></p>\n          <p>" + this.lang.P1021 + "</p>"
      });
    },


    // Assigns selected surveys to the project
    assignSurveys: function assignSurveys() {
      if (this.selectedUnassignedSurveyIds.length === 0) return;
      for (var i = 0; i < this.selectedUnassignedSurveyIds.length; i++) {
        this.projectData.Surveys.push({
          SurveyId: this.selectedUnassignedSurveyIds[i],
          ReportingVisibility: true
        });
      }
      this.selectedUnassignedSurveyIds = [];
    },


    // Unassigns selected surveys from the project
    unassignSurveys: function unassignSurveys() {
      if (this.selectedAssignedSurveyIds.length === 0) return;
      for (var i = 0; i < this.selectedAssignedSurveyIds.length; i++) {
        var index = this.getIndexOfSurveyInProjectDataSurveys(this.selectedAssignedSurveyIds[i]);
        this.projectData.Surveys.splice(index, 1);
      }
      this.selectedAssignedSurveyIds = [];
    },


    // Returns a list of currently assigned surveys
    getAssignedSurveys: function getAssignedSurveys() {
      var _this3 = this;

      return this.availableSurveys.filter(function (s) {
        return _.findIndex(_this3.projectData.Surveys, function (ps) {
          return s.SurveyId === ps.SurveyId;
        }) > -1;
      });
    },


    // Returns a list of currently unassigned surveys
    getUnassignedSurveys: function getUnassignedSurveys() {
      var _this4 = this;

      return this.availableSurveys.filter(function (s) {
        return _.findIndex(_this4.projectData.Surveys, function (ps) {
          return s.SurveyId === ps.SurveyId;
        }) < 0 && _.findIndex(_this4.projectData.AvailableSurveys, function (pas) {
          return s.SurveyId === pas;
        }) > -1;
      });
    },


    // Adds a new item to the survey list if it's not already in the list. Otherwise the item will me removed from the list.
    toggleListItem: function toggleListItem(list, id) {
      var index = list.indexOf(id);
      if (index > -1) {
        list.splice(index, 1);
      } else list.push(id);
    },


    // Adds a new item to the survey list if it's not already in the list. Otherwise the item will me removed from the list.
    toggleSurveyListItem: function toggleSurveyListItem(list, id) {
      var index = _.findIndex(list, function (s) {
        return s.SurveyId === id;
      });

      if (index > -1) {
        list.splice(index, 1);
      } else list.push({ SurveyId: id, ReportingVisibility: true });
    },


    // Returns the index of a survey in the list of surveys that are attached to the project
    getIndexOfSurveyInProjectDataSurveys: function getIndexOfSurveyInProjectDataSurveys(id) {
      return _.findIndex(this.projectData.Surveys, function (s) {
        return s.SurveyId === id;
      });
    },


    // Fills the editProject dialog with data, depending on the dialog mode.
    openEditProjectDialog: function openEditProjectDialog() {
      var _this5 = this;

      if (this.dialogModeAdd) {
        this.dialogTitle = this.lang.P1012;
        delete this.projectData.ProjectId;
        delete this.projectData.ProjectGuid;
        delete this.projectData.ProjectCreatedBy;
        delete this.projectData.ProjectName;
        delete this.projectData.ClientId;
        delete this.projectData.ImporterGuid;
        delete this.projectData.ProjectSince;
        delete this.projectData.ProjectUntil;
        delete this.projectData.ProjectActiveLocationsCount;
        delete this.projectData.ProjectTotalLocationsCount;
        delete this.projectData.ProjectSurveysCount;
        delete this.projectData.ProjectAccountableGuid;

        if (this.feature.isAudiTarget && this.feature.isEnabled("audi_importers") && this.clientList[0]) {
          this.projectData.ClientId = this.clientList[0].ClientId;
          this.getAvailableSurveysForClient();
        }

        this.fpProjectUntil.clear();
        this.fpProjectSince.clear();

        this.briefings = [];
        this.surveys = [];

        this.filterSurveysForClient(-1, true);
        this.initGanttProject();
        $("#editProjectDialog").modal("show");
      } else {
        this.dialogTitle = this.lang.P1013;

        $.ajax({
          method: "GET",
          url: "api/Projects/" + this.selectedProject,
          success: function success(data) {
            if (data.Importers) {
              data.ImporterGuid = data.Importers[0].ImporterGuid;
              delete data.Importers;
            }
            _this5.projectData = data; // Store response data from server
            if (_this5.projectData.ClientId) _this5.filterSurveysForClient(data.ClientId, false);
            if (!_this5.projectData.Surveys) _this5.projectData.Surveys = [];

            if (_this5.projectData.ProjectSince) _this5.fpProjectSince.setDate(_this5.projectData.ProjectSince);else _this5.fpProjectSince.clear();
            if (_this5.projectData.ProjectUntil) _this5.fpProjectUntil.setDate(_this5.projectData.ProjectUntil);else _this5.fpProjectUntil.clear();

            if (_this5.projectData.Attachments) {
              _this5.briefings = _this5.projectData.Attachments.filter(function (attachment) {
                return attachment.AttachmentType === "Briefing";
              });
              _this5.surveys = _this5.projectData.Attachments.filter(function (attachment) {
                return attachment.AttachmentType === "Survey";
              });
            }

            gantt.clearAll();
            if (_this5.projectData.ProjectSince && _this5.projectData.ProjectUntil) {
              gantt.parse(_this5.projectData.Gantt);
              _this5.prepareGanttChart();
            } else _this5.initGanttProject();
            $("#editProjectDialog").modal("show");
          },
          error: function error() {
            console.error("Project data access failed in openEditProjectDialog()");
            _this5.globals.showErrorSnackbar("Project data access failed");
            _this5.$emit("dialogClosed");
          }
        });
      }
      this.showAlert = false;
      this.resetValidationErrors("editProjectDialog");
    },


    // Closes the editProjectDialog
    closeEditProjectDialog: function closeEditProjectDialog() {
      $("#editProjectDialog").modal("hide");
    },


    // Opens all tasks in the current gantt dataset and sets the initial zoom depending on the project duration
    prepareGanttChart: function prepareGanttChart() {
      var gData = this.projectData.Gantt.data;
      for (var i = 0; i < gData.length; i++) {
        if (gData[i].type != gantt.config.types.scenario && gantt.hasChild(gData[i].id)) {
          gantt.open(gData[i].id);
        }
      }

      var duration = (gData[0].end_date - gData[0].start_date) / (1000 * 60 * 60 * 24); // duration in days

      if (duration > 120) {
        gantt.config.scale_unit = "year";
        gantt.config.date_scale = "%Y";
        gantt.config.subscales = [{ unit: "month", step: 1, date: "%M" }];
      } else if (duration > 30) {
        gantt.config.scale_unit = "month";
        gantt.config.date_scale = "%M %Y";
        gantt.config.subscales = [{ unit: "week", step: 1, date: "W%W" }];
      } else {
        gantt.config.scale_unit = "week";
        gantt.config.date_scale = "%F, %Y, W%W";
        gantt.config.subscales = [{ unit: "day", step: 1, date: "%j, %D" }];
      }
    },


    // Sends the data from editProject dialog to the server to store it in the database
    saveEditProjectDialogData: function saveEditProjectDialogData() {
      var _this6 = this;

      if (this.briefings.length > 0 || this.surveys.length > 0) this.projectData.Attachments = this.briefings.concat(this.surveys);else delete this.projectData.Attachments;
      var sendData = _.cloneDeep(this.projectData);
      delete sendData.Gantt;

      if (sendData.ImporterGuid) {
        sendData.Importers = [{ ImporterGuid: sendData.ImporterGuid }];
        delete sendData.ImporterGuid;
      }

      if (this.dialogModeAdd) {
        // Create new project
        $.ajax({
          method: "POST",
          url: "api/Projects",
          data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(sendData),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            // If POST was successful, refresh displayed data and hide dialog
            _this6.globals.showSuccessSnackbar("Project creation successful");
            _this6.closeEditProjectDialog();
            // this.$emit("dialogDataSaved", data.ProjectId, sendData.ClientId);
            _this6.$emit("dialogDataSaved", data);
          },
          error: function error() {
            console.error("Error on POST in saveEditProjectDialogData()");
            _this6.globals.showErrorSnackbar("Project creation failed");
          }
        });
      } else {
        // Update existing project
        $.ajax({
          method: "PUT",
          url: "api/Projects/" + this.projectData.ProjectId,
          data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(sendData),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            if (data && data.length > 0 && data[0].error) {
              console.error("Error on PUT in saveEditProjectDialogData()");
              _this6.globals.showErrorSnackbar(data[0].error);
              return;
            }
            // If PUT was successful, refresh displayed data and hide dialog
            _this6.globals.showSuccessSnackbar("Project update successful");
            _this6.closeEditProjectDialog();
            _this6.$emit("dialogDataSaved", sendData.ProjectId, sendData.ClientId);
          },
          error: function error() {
            console.error("Error on PUT in saveEditProjectDialogData()");
            _this6.globals.showErrorSnackbar("Project update failed");
          }
        });
      }
    },


    // Updates the task data after a task was updated
    updateGanttTask: function updateGanttTask(id, action, task) {
      if (action == "inserted") {
        this.projectData.Gantt.data.push(task);
      } else if (action == "updated") {
        var idx = this.projectData.Gantt.data.map(function (t) {
          return t.id;
        }).indexOf(id);
        this.projectData.Gantt.data[idx] = task;
      } else if (action == "deleted") {
        this.projectData.Gantt.data = this.projectData.Gantt.data.filter(function (t) {
          return t.id != id;
        });
      } else console.error("Error on task update in updateGanttTask()");
    },


    // Initializes the gantt project data
    initGanttProject: function initGanttProject() {
      var projectTemplate = {
        id: uuidv4(),
        text: "",
        type: gantt.config.types.project,
        start_date: getCurrentDate(0),
        end_date: getCurrentDate(1)
      };

      projectTemplate.start_date.setHours(0, 0, 0, 0);
      projectTemplate.end_date.setHours(0, 0, 0, 0);

      this.projectData.Gantt.data = [projectTemplate];

      gantt.clearAll();
      gantt.parse(this.projectData.Gantt);
      this.prepareGanttChart();
    },
    getProjectAccountables: function getProjectAccountables() {
      var _this7 = this;

      var queryString = "/api/data/ProjectAccountable";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          if (!_.isEmpty(data)) _this7.listOfProjectAccountables = data;
        },
        error: function error() {
          console.error("Project accountables data access failed in getProjectAccountables()");
          _this7.globals.showErrorSnackbar("Project accountables data access failed");
        }
      });
    },
    onBriefingAttachmentFileChange: function onBriefingAttachmentFileChange(e) {
      var _this8 = this;

      var files = e.target.files || e.dataTransfer.files;
      if (!files.length || !files[0].name) return;

      var attachmentFileObject = files[0];

      var uploadSuccess = function uploadSuccess(data) {
        _this8.briefings.push({
          DownloadId: data[0].DownloadId,
          FileName: attachmentFileObject.name,
          AttachmentType: "Briefing"
        });

        _this8.globals.showSuccessSnackbar("Attachment upload successful");
        _this8.$forceUpdate();
      };
      this.globals.uploadFile(attachmentFileObject, uploadSuccess);
      e.target.value = null;
    },
    onSurveyAttachmentFileChange: function onSurveyAttachmentFileChange(e) {
      var _this9 = this;

      var files = e.target.files || e.dataTransfer.files;
      if (!files.length || !files[0].name) return;

      var attachmentFileObject = files[0];

      var uploadSuccess = function uploadSuccess(data) {
        _this9.surveys.push({
          DownloadId: data[0].DownloadId,
          FileName: attachmentFileObject.name,
          AttachmentType: "Survey"
        });

        _this9.globals.showSuccessSnackbar("Attachment upload successful");
        _this9.$forceUpdate();
      };
      this.globals.uploadFile(attachmentFileObject, uploadSuccess);
      e.target.value = null;
    },
    removeAttachmentFile: function removeAttachmentFile(list, fileIndex) {
      list.splice(fileIndex, 1);
      this.$forceUpdate();
    }
  },
  watch: {
    showDialog: function showDialog() {
      if (this.showDialog && (this.dialogModeAdd || this.globals.isAccessAllowed("LoopOp_Projects_Read"))) {
        this.openEditProjectDialog();
      } else {
        this.closeEditProjectDialog();
        this.$emit("dialogClosed");
      }
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  props: ["selectedProject", "clientList", "surveyList", "showDialog", "dialogModeAdd"],
  data: function data() {
    // Global data inside the component is stored here
    return {
      dialogTitle: "", // Title of the dialog
      projectData: {
        Gantt: {
          data: [{
            id: uuidv4(),
            text: "",
            type: gantt.config.types.project,
            start_date: getCurrentDate(0),
            end_date: getCurrentDate(0)
          }]
        }
      }, // The project data of the selected project is stored here
      showAlert: false, // true --> Alert for validation errors is visible
      invalidInputIds: [], // IDs of inputs with validation error
      isGanttVisible: false,
      currentScaleUnit: "week",
      selectedAssignedSurveyIds: [],
      selectedUnassignedSurveyIds: [],
      availableSurveys: [],
      fpProjectSince: null,
      fpProjectUntil: null,
      listOfProjectAccountables: {},
      briefings: [],
      surveys: [],
      importerList: [],
      lang: {
        P1000: "General",
        P1001: "Name",
        P1002: "This is a required entry!",
        P1003: "Client",
        P1004: "Please select...",
        P1005: "Surveys",
        P1006: "Available surveys",
        P1007: "Allocated surveys",
        P1008: "Project planning",
        P1009: "Your inputs are incorrect. Please check all fields marked in red!",
        P1010: "Cancel",
        P1011: "Save",
        P1012: "Create project",
        P1013: "Edit project",
        P1014: "Reporting visibility",
        P1015: "Start date",
        P1016: "End date",
        P1017: "Yes",
        P1018: "No",
        P1019: "Change Reporting Visibility",
        P1020: "Do you really want to make the whole survey visible in reporting?",
        P1021: "All defined security settings on user level for this survey will be lost.",
        P1022: "Project accountable",
        P1023: "File Upload",
        P1024: "Briefing",
        P1025: "Choose briefing",
        P1026: "Please choose a briefing...",
        P1027: "Download briefing",
        P1028: "Delete briefing",
        P1029: "File name",
        P1030: "Actions",
        P1031: "Survey",
        P1032: "Choose survey",
        P1033: "Please choose a survey...",
        P1034: "Download survey",
        P1035: "Delete survey",
        P1036: "Importer"
      }
    };
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dhtmlx_gantt_codebase_ext_dhtmlxgantt_tooltip_js__ = __webpack_require__(989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dhtmlx_gantt_codebase_ext_dhtmlxgantt_tooltip_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_dhtmlx_gantt_codebase_ext_dhtmlxgantt_tooltip_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dhtmlx_gantt_codebase_ext_dhtmlxgantt_csp_js__ = __webpack_require__(987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dhtmlx_gantt_codebase_ext_dhtmlxgantt_csp_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_dhtmlx_gantt_codebase_ext_dhtmlxgantt_csp_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dhtmlx_gantt_codebase_ext_dhtmlxgantt_smart_rendering_js__ = __webpack_require__(988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dhtmlx_gantt_codebase_ext_dhtmlxgantt_smart_rendering_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_dhtmlx_gantt_codebase_ext_dhtmlxgantt_smart_rendering_js__);
//
//
//
//



// import "dhtmlx-gantt/codebase/ext/dhtmlxgantt_quick_info.js";


// import "dhtmlx-gantt/codebase/locale/locale_de.js";
var uuidv4 = __webpack_require__(60);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ProjectManagementGantt",
  props: {
    tasks: {
      type: Object,
      default: function _default() {
        return { data: [], links: [] };
      }
    }
  },
  methods: {
    // Updates start date and end date of parent tasks if a child was updated
    // updateParentTaskDates(changedTask) {
    //   var parentTaskId = gantt.getParent(changedTask);
    //   if (!parentTaskId) return;

    //   // Update the parent of the changed task to fit the duration
    //   var parentTask = gantt.getTask(parentTaskId);
    //   var siblings = gantt.getChildren(parentTask.id);
    //   if (siblings.length > 0) {
    //     var minStartDate = gantt.getTask(siblings[0]).start_date;
    //     var maxEndDate = gantt.getTask(siblings[0]).end_date;

    //     for (var i = 1; i < siblings.length; i++) {
    //       if (minStartDate > gantt.getTask(siblings[i]).start_date)
    //         minStartDate = gantt.getTask(siblings[i]).start_date;
    //       if (maxEndDate < gantt.getTask(siblings[i]).end_date)
    //         maxEndDate = gantt.getTask(siblings[i]).end_date;
    //     }

    //     if (maxEndDate <= minStartDate)
    //       maxEndDate.setDate(minStartDate.getDate() + 1);

    //     parentTask.start_date = minStartDate;
    //     parentTask.end_date = maxEndDate;
    //   }
    //   gantt.updateTask(parentTask.id);
    // },

    // Updates start date and end date of children tasks if a parent was updated
    // updateChildrenTaskDates(changedTask) {
    //   var children = gantt.getChildren(changedTask.id);
    //   if (children.length < 1) return;

    //   // Update the children of the changed task to fit the duration
    //   var child;
    //   for (var i = 0; i < children.length; i++) {
    //     child = gantt.getTask(children[i]);
    //     if (child.start_date < changedTask.start_date)
    //       child.start_date = changedTask.start_date;
    //     if (child.end_date > changedTask.end_date)
    //       child.end_date = changedTask.end_date;

    //     if (child.end_date <= child.start_date)
    //       if (child.start_date == changedTask.start_date)
    //         child.end_date = gantt.date.add(child.start_date, 1, "day");
    //       else child.start_date = gantt.date.add(child.end_date, -1, "day");

    //     this.updateChildrenTaskDates(child);
    //   }
    // },

    // Deletes all children from the changed task
    deleteChildren: function deleteChildren(changedTask) {
      var children = gantt.getChildren(changedTask.id);
      if (children) {
        for (var i = 0; i < children.length; i++) {
          gantt.deleteTask(children[i]);
          this.$emit("task-updated", children[i], "deleted");
        }
      }
    },


    // Initializes events
    $_initGanttEvents: function $_initGanttEvents() {
      var _this = this;

      if (gantt.$_eventsInitialized) return;

      gantt.attachEvent("onTemplatesReady", function () {
        // parse
        gantt.templates.xml_date = function (dateString) {
          return new Date(dateString);
        };
        // stringify
        gantt.templates.xml_format = function (date) {
          var isoDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString();
          return isoDate;
        };
      });

      gantt.attachEvent("onTaskCreated", function (task) {
        var parentTask = gantt.getTask(gantt.getParent(task));
        task.id = uuidv4();
        if (parentTask.type == gantt.config.types.project) {
          task.type = gantt.config.types.wave; // Projects can only contain waves
          task.text = "New wave";
        } else if (parentTask.type == gantt.config.types.wave) {
          task.type = gantt.config.types.scenario; // Waves can only contain scenarios
          task.text = "New scenario";
        } else return false; // No subtasks for scenarios
        return true;
      });

      // gantt.attachEvent("onTaskDblClick", id => {
      //   if (!id) return false;
      //   // There is only one project that can not be deleted
      //   if (gantt.getTask(id).type == gantt.config.types.project) return false;
      //   return true;
      // });

      gantt.attachEvent("onAfterTaskAdd", function (id, task) {
        // this.updateParentTaskDates(task);

        _this.$emit("task-updated", id, "inserted", task);
        gantt.render();
      });
      gantt.attachEvent("onAfterTaskUpdate", function (id, task) {
        if (task.type == gantt.config.types.project && task.end_date <= task.start_date) task.end_date.setDate(task.start_date.getDate() + 1);

        // this.updateParentTaskDates(task);
        // this.updateChildrenTaskDates(task);

        _this.$emit("task-updated", id, "updated", task);
        gantt.render();
      });
      gantt.attachEvent("onAfterTaskDelete", function (id, task) {
        // this.updateParentTaskDates(task);

        _this.$emit("task-updated", id, "deleted");
        gantt.render();
      });

      gantt.attachEvent("onBeforeTaskDelete", function (id, task) {
        _this.deleteChildren(task);
      });

      // Hide delete button for project
      gantt.attachEvent("onBeforeLightbox", function (id) {
        var task = gantt.getTask(id);

        if (task.type === "project") $(".gantt_delete_btn_set").css("display", "none");else setTimeout(function () {
          // The timeout is a workaround for no visible delete button at first opening
          $(".gantt_delete_btn_set").css("display", "block");
        }, 1);

        return true;
      });

      // Store current task to remove reportingVisibility settings later for non wave tasks
      gantt.attachEvent("onBeforeLightbox", function (id) {
        _this.currentLightboxTask = gantt.getTask(id);
        return true;
      });
      gantt.attachEvent("onAfterLightbox", function () {
        if (_this.currentLightboxTask.type !== "wave") delete _this.currentLightboxTask.reportingVisibility;
      });

      // gantt.attachEvent("onTaskDrag", (id, mode, task, original) => {
      //   var formatFunc = gantt.date.date_to_str("%d/%m/%Y");
      //   if (
      //     formatFunc(task.start_date) == formatFunc(gantt.getState().min_date)
      //   ) {
      //     gantt.getState().min_date = gantt.date.add(
      //       gantt.getState().min_date,
      //       -1,
      //       "day"
      //     );
      //     gantt.render();
      //     gantt.showDate(gantt.getState().min_date);
      //   } else if (
      //     formatFunc(task.end_date) == formatFunc(gantt.getState().max_date)
      //   ) {
      //     gantt.getState().max_date = gantt.date.add(
      //       gantt.getState().max_date,
      //       2,
      //       "day"
      //     );
      //     gantt.render();
      //     gantt.showDate(gantt.getState().max_date);
      //   }
      // });

      gantt.$_eventsInitialized = true;
    }
  },
  mounted: function mounted() {
    this.$_initGanttEvents();
    gantt.init(this.$refs.gantt);
    gantt.parse(this.$props.tasks);
    gantt.config.autosize = true;

    gantt.config.lightbox.sections = [{
      name: "description",
      height: 70,
      map_to: "text",
      type: "textarea",
      focus: true
    }, {
      name: "time",
      height: 35,
      map_to: "auto",
      type: "time"
    }, {
      name: "rep",
      type: "checkbox",
      map_to: "reportingVisibility",
      options: [{
        key: "true",
        label: "Visible in reporting?"
      }],
      default_value: true
    }];

    gantt.config.scale_unit = "week";
    gantt.config.scale_height = 50;
    gantt.config.date_scale = "%F, %Y, W%W";
    gantt.config.subscales = [{ unit: "day", step: 1, date: "%j, %D" }];

    gantt.config.show_progress = false;
    gantt.config.show_links = false;
    gantt.config.drag_move = false;
    gantt.config.drag_resize = false;

    gantt.config.columns = [{ name: "text", width: "*", tree: true, resize: true }, {
      name: "start_date",
      label: "Start date",
      template: function template(task) {
        return gantt.templates.task_date(task.start_date);
      },
      align: "center"
    }, {
      name: "end_date",
      label: "End date",
      template: function template(task) {
        return gantt.templates.task_date(gantt.date.add(task.end_date, 0, "day"));
      },
      align: "center"
    }, { name: "add", label: "", width: 44 }];

    gantt.config.types.wave = "wave";
    gantt.config.types.scenario = "scenario";
    gantt.locale.labels.type_wave = "New Wave";
    gantt.locale.labels.type_scenario = "New Scenario";

    gantt.locale.labels.section_rep = "Reporting";

    // Set checkbox state and hide checkbox for non wave tasks
    gantt.form_blocks.checkbox.set_value = function (node, value, task) {
      node.firstChild.firstChild.checked = !!value;
      var style = task.type === "wave" ? "" : "none";
      node.style.display = style; // editor area
      node.previousSibling.style.display = style; //section header
      gantt.resizeLightbox(); //correct size of lightbox
    };
    // Store checkbox state as boolean instead of string array
    gantt.form_blocks.checkbox.get_value = function (node, task) {
      var checked = node.firstChild.firstChild.checked;
      return checked;
    };

    // gantt.locale = this.lang;
    // console.log(gantt.locale);
    // if (globals.selectedLanguage == "de")
    //   require("dhtmlx-gantt/codebase/locale/locale_de.js");

    gantt.templates.task_class = function (start, end, task) {
      if (task.type == gantt.config.types.wave) {
        return "wave_task";
      }
      if (task.type == gantt.config.types.scenario) {
        return "scenario_task";
      }
      return "";
    };

    gantt.templates.grid_row_class = function (start, end, task) {
      if (task.$level > 1) {
        return "no_subtasks";
      }
      return "";
    };

    gantt.config.readonly = true;
  },
  data: function data() {
    return {
      currentLightboxTask: null,
      lang: {
        date: {
          month_full: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
          month_short: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
          day_full: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
          day_short: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
        },
        labels: {
          new_task: "New task",
          icon_save: "Save",
          icon_cancel: "Cancel",
          icon_details: "Details",
          icon_edit: "Edit",
          icon_delete: "Delete",
          confirm_closing: "Your changes will be lost, are you sure?",
          confirm_deleting: "Task will be deleted permanently, are you sure?",

          section_description: "Description",
          section_time: "Time period",
          section_type: "Type",
          section_rep: "Reporting",

          column_text: "Task Name",
          column_start_date: "Start datee",
          column_end_date: "End datee",
          column_duration: "Duration",
          column_add: "",

          confirm_link_deleting: "Dependency will be deleted permanently, are you sure?",
          link_from: "From",
          link_to: "To",
          link_start: "Start",
          link_end: "End",

          type_task: "Task",
          type_project: "Project",
          type_milestone: "Milestone",
          type_wave: "Wave",
          type_scenario: "Scenario",

          minutes: "Minutes",
          hours: "Hours",
          days: "Days",
          weeks: "Week",
          months: "Months",
          years: "Years"
        }
      }
    };
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tools_Select2__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Tools_Select2__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var uuidv4 = __webpack_require__(60);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ScenarioEditDialog",
  components: {
    Select2: __WEBPACK_IMPORTED_MODULE_1__Tools_Select2___default.a
  },
  props: ["showDialog", "selectedProjectData", "clientList", "selectedClientFromProject"],
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#editScenarioDialog").on("hidden.bs.modal", function (e) {
      _this.$emit("dialogClosed");
    });

    // Register global events
    this.globals.$off("ScenarioDeleteModalYesConfirmation");
    this.globals.$on("ScenarioDeleteModalYesConfirmation", function () {
      _this.deleteSelectedScenario();
    });
  },

  watch: {
    selectedTab: function selectedTab(newValue) {
      this.tabVisibilityChanged();
      if (newValue === "assignClientTab") this.getScenariosOfSelectedClient();
    },
    showDialog: function showDialog() {
      if (this.showDialog) this.openScenarioEditDialog();else this.closeScenarioEditDialog();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  data: function data() {
    return {
      scenarios: [],
      filteredScenarios: [],
      filteredClients: [],
      filterScenarioString: "",
      filterClientString: "",
      selectedClient: -1,
      selectedTab: "editScenarioTab",
      copyScenarios: false,
      unsavedAssignments: false,
      selectedScenarioDirty: false,
      selectedScenario: {
        ScenarioGuid: "",
        ScenarioName: "",
        ScenarioDescription: "",
        ScenarioLongtext: ""
      },
      selectedScenarios: [],
      scenariosOfSelectedClient: [],
      lang: {
        SC0000: "Scenario Administration",
        SC0001: "Copy",
        SC0002: "Save",
        SC0003: "Delete",
        SC0004: "Name",
        SC0005: "Description",
        SC0006: "Close",
        SC0007: "Edit scenario",
        SC0008: "Assign scenarios",
        SC0009: "Client name",
        SC0010: "New",
        SC0011: "Filter",
        SC0012: "ID",
        SC0013: "Name",
        SC0014: "Description",
        SC0015: "Delete Scenario",
        SC0016: "Do you really want to delete the following scenario?",
        SC0017: "Yes",
        SC0018: "No",
        SC0019: "Project",
        SC0020: "Client",
        SC0021: "Longtext"
      }
    };
  },

  computed: {
    nameOfSelectedClient: function nameOfSelectedClient() {
      var _this2 = this;

      if (this.selectedClient < 0) return "";
      var client = _.find(this.clientList, function (c) {
        return c.ClientId == _this2.selectedClient;
      });
      if (client) return client.ClientName;
      return "";
    }
  },
  methods: {
    saveSelectedScenario: function saveSelectedScenario() {
      var _this3 = this;

      var data = void 0,
          queryString = void 0;
      var currentScenarioIndex = _.findIndex(this.scenarios, function (s) {
        return s.ScenarioGuid === _this3.selectedScenario.ScenarioGuid;
      });
      if (currentScenarioIndex > -1) {
        // Scenario does already exist
        queryString = "api/Scenarios/" + this.selectedScenario.ScenarioGuid;
        data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedScenario);

        $.ajax({
          method: "PUT",
          url: queryString,
          data: data,
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            if (data.Error) {
              console.error(data.Error);
              _this3.globals.showErrorSnackbar(data.Error);
              return;
            }
            _this3.scenarios[currentScenarioIndex] = _.cloneDeep(_this3.selectedScenario);
            _this3.doFilteringScenarios();
            _this3.$forceUpdate();
            _this3.globals.showSuccessSnackbar("Scenario update successful");
            _this3.selectedScenarioDirty = false;
          },
          error: function error() {
            console.error("Error on PUT in saveSelectedScenario()");
            _this3.globals.showErrorSnackbar("Scenario update failed");
          }
        });
      } else {
        // Scenario does not yet exist
        delete this.selectedScenario.ScenarioId;

        queryString = "api/Scenarios";
        data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedScenario);

        $.ajax({
          method: "POST",
          url: queryString,
          data: data,
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            if (data.Error) {
              console.error(data.Error);
              _this3.globals.showErrorSnackbar(data.Error);
              return;
            }
            if (data[0]) {
              if (data[0].ScenarioId) _this3.selectedScenario.ScenarioId = data[0].ScenarioId;
              if (data[0].ScenarioGuid) _this3.selectedScenario.ScenarioGuid = data[0].ScenarioGuid;
            }
            var scenario = _.cloneDeep(_this3.selectedScenario);
            _this3.scenarios.push(scenario);
            _this3.scenariosOfSelectedClient.push(scenario.ScenarioGuid);
            _this3.selectScenario(scenario.ScenarioGuid);
            _this3.doFilteringScenarios();
            _this3.$forceUpdate();
            _this3.globals.showSuccessSnackbar("Scenario update successful");
            _this3.selectedScenarioDirty = false;
          },
          error: function error() {
            console.error("Error on POST in saveSelectedScenario()");
            _this3.globals.showErrorSnackbar("Scenario update failed");
          }
        });
      }
    },
    deleteSelectedScenario: function deleteSelectedScenario() {
      var _this4 = this;

      $.ajax({
        method: "DELETE",
        url: "api/Scenarios/" + this.selectedScenario.ScenarioGuid,
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this4.globals.showErrorSnackbar(data.Error);
            return;
          }
          // If delete was successful, refresh displayed data and hide dialog
          _this4.globals.showSuccessSnackbar("Scenario deletion successful");
          _.remove(_this4.scenarios, function (s) {
            return s.ScenarioGuid === _this4.selectedScenario.ScenarioGuid;
          });
          _this4.createNewScenario();
          _this4.doFilteringScenarios();
        },
        error: function error() {
          console.error("Scenario deletion failed in deleteSelectedScenario()");
          _this4.globals.showErrorSnackbar("Scenario deletion failed");
        }
      });
    },
    createNewScenario: function createNewScenario() {
      this.selectedScenario = {
        ScenarioGuid: uuidv4(),
        ScenarioName: "",
        ClientIds: [this.selectedClient]
      };
      this.selectedScenarios = [];
      this.selectedScenarioDirty = false;
    },
    copyScenariosClicked: function copyScenariosClicked() {
      this.copyScenarios = !this.copyScenarios;
      this.selectedClient = -1;
      if (!this.copyScenarios) this.selectedScenarios = [];
    },
    getAllScenarios: function getAllScenarios() {
      var _this5 = this;

      var queryString = "api/Scenarios";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this5.scenarios = [];
          if (data && data[0]) _this5.scenarios = data;
          _this5.doFilteringScenarios();
        },
        error: function error() {
          console.error("Error on GET in getAllScenarios()");
          _this5.globals.showErrorSnackbar("Scenario request failed");
        }
      });
    },
    getScenariosOfSelectedClient: function getScenariosOfSelectedClient() {
      var _this6 = this;

      var queryString = "api/Clients/" + this.selectedClient + "/Scenarios";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          if (data) {
            if (_this6.selectedTab === "assignClientTab") {
              if (_this6.copyScenarios) {
                _this6.selectedScenarios = _.union(_this6.selectedScenarios, data.Scenarios);
                _this6.unsavedAssignments = true;
              } else {
                _this6.selectedScenarios = data.Scenarios || [];
                _this6.unsavedAssignments = false;
              }
            }
            if (data.Scenarios) _this6.scenariosOfSelectedClient = data.Scenarios;else _this6.scenariosOfSelectedClient = [];
          } else {
            _this6.selectedScenarios = [];
            _this6.scenariosOfSelectedClient = [];
          }
          _this6.copyScenarios = false;
          if (_this6.selectedTab === "editScenarioTab") _this6.doFilteringScenarios();
        },
        error: function error() {
          console.error("Error on GET in getScenariosOfSelectedClient()");
          _this6.globals.showErrorSnackbar("Scenario request failed");
        }
      });
    },
    saveScenariosOfSelectedClient: function saveScenariosOfSelectedClient() {
      var _this7 = this;

      var queryString = "api/Clients/" + this.selectedClient + "/Scenarios";
      var sendData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        Scenarios: this.selectedScenarios
      });

      $.ajax({
        method: "PUT",
        url: queryString,
        data: sendData,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this7.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this7.globals.showSuccessSnackbar("Scenario assignment update successful");
          _this7.unsavedAssignments = false;
        },
        error: function error() {
          console.error("Error on PUT in saveScenariosOfSelectedClient()");
          _this7.globals.showErrorSnackbar("Scenario assignment update failed");
        }
      });
    },
    doFilteringScenarios: function doFilteringScenarios() {
      var _this8 = this;

      // Reset filtering when search string is empty
      if (!this.scenarios || !this.scenarios[0]) return;

      var words = this.filterScenarioString.split(" ");
      var keys = ["ScenarioId", "ScenarioName", "ScenarioDescription"];

      var scenarioFilter = function scenarioFilter(scenario) {
        if (_this8.selectedTab === "editScenarioTab" && _.indexOf(_this8.scenariosOfSelectedClient, scenario.ScenarioGuid) < 0) return false;

        var containsSearch = false;
        words.forEach(function (word) {
          keys.forEach(function (key) {
            if (scenario[key] && scenario[key].toString().toLowerCase().indexOf(word.toLowerCase()) > -1) {
              containsSearch = true;
              return;
            }
          });
        });
        return containsSearch;
      };
      this.filteredScenarios = this.scenarios.filter(scenarioFilter);
    },
    doFilteringClients: function doFilteringClients() {
      // Reset filtering when search string is empty
      if (!this.clientList || this.clientList.length < 1) return;
      if (!this.filterClientString) {
        this.filteredClients = this.clientList;
        return;
      }

      var words = this.filterClientString.split(" ");
      var keys = ["ClientId", "ClientName"];

      var clientFilter = function clientFilter(client) {
        var containsSearch = false;
        words.forEach(function (word) {
          keys.forEach(function (key) {
            if (client[key] && client[key].toString().toLowerCase().indexOf(word.toLowerCase()) > -1) {
              containsSearch = true;
              return;
            }
          });
        });
        return containsSearch;
      };
      this.filteredClients = this.clientList.filter(clientFilter);
    },
    getScenarioData: function getScenarioData(guid) {
      var sc = _.find(this.scenarios, function (s) {
        return s.ScenarioGuid === guid;
      });
      if (sc) sc = _.cloneDeep(sc);else sc = this.selectedScenario;
      return sc;
    },
    selectScenario: function selectScenario(scenarioGuid) {
      if (this.selectedTab === "editScenarioTab") {
        this.selectedScenarios = [scenarioGuid];
        this.selectedScenarioDirty = false;
      } else {
        if (this.selectedClient < 0) return;
        var idx = _.indexOf(this.selectedScenarios, scenarioGuid);
        if (idx > -1) {
          _.pullAt(this.selectedScenarios, idx);
        } else {
          this.selectedScenarios.push(scenarioGuid);
        }
        this.unsavedAssignments = true;
      }

      if (this.selectedScenarios.length === 1) this.selectedScenario = this.getScenarioData(this.selectedScenarios[0]);else if (this.selectedScenarios.length < 1) this.createNewScenario();
      this.$forceUpdate();
    },
    isScenarioSelected: function isScenarioSelected(scenarioGuid) {
      return _.indexOf(this.selectedScenarios, scenarioGuid) > -1;
    },
    selectClient: function selectClient(id) {
      this.selectedClient = id;
      this.getScenariosOfSelectedClient();
    },
    isClientSelected: function isClientSelected(id) {
      return this.selectedClient == id;
    },
    openDeleteScenarioConfirmationDialog: function openDeleteScenarioConfirmationDialog() {
      this.globals.$emit("openGlobalConfirmationDialog", this.getDeleteDialogData());
    },
    getDeleteDialogData: function getDeleteDialogData() {
      return {
        initiator: "ScenarioDeleteModal",
        confirmationTitle: this.lang.SC0015,
        colorRed: true,
        yesButtonText: this.lang.SC0017,
        noButtonText: this.lang.SC0018,
        htmlText: "<p><b>" + this.lang.SC0016 + "</b></p>\n        <div class=\"form-group\">\n          <label class=\"col-md-3 text-black\">" + this.lang.SC0012 + "</label>\n          <label class=\"col-md-9 text-black\">" + this.selectedScenario.ScenarioId + "</label>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-md-3 text-black\">" + this.lang.SC0013 + "</label>\n          <label class=\"col-md-9 text-black\">" + this.selectedScenario.ScenarioName + "</label>\n        </div>"
      };
    },
    tabVisibilityChanged: function tabVisibilityChanged() {
      this.selectedScenarios = [];
      this.createNewScenario();
      this.copyScenarios = false;
      this.unsavedAssignments = false;
      this.selectedScenarioDirty = false;
      this.doFilteringScenarios();
    },
    openScenarioEditDialog: function openScenarioEditDialog() {
      this.selectedClient = this.selectedClientFromProject;
      this.getScenariosOfSelectedClient();
      this.tabVisibilityChanged();
      this.getAllScenarios();
      this.doFilteringClients();
      $("#editScenarioDialog").modal("show");
    },
    closeScenarioEditDialog: function closeScenarioEditDialog() {
      $("#editScenarioDialog").modal("hide");
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_int__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_map__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_set__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__WaveStatusModal__ = __webpack_require__(1591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__WaveStatusModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__WaveStatusModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Tools_Select2_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Tools_Select2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__Tools_Select2_vue__);









//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var uuidv4 = __webpack_require__(60);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "WaveEditDialog",
  components: { Select2: __WEBPACK_IMPORTED_MODULE_10__Tools_Select2_vue___default.a, WaveStatusModal: __WEBPACK_IMPORTED_MODULE_9__WaveStatusModal___default.a },
  props: ["showDialog", "selectedClient", "selectedProjectData"],
  data: function data() {
    return {
      waves: [],
      wavePositions: [],
      scenarios: [],
      leadAgencies: [],
      filteredWaves: [],
      filteredScenarios: [],
      carModelList: [],
      importerList: null,
      segmentList: null,
      filterWaveString: "",
      filterScenarioString: "",
      selectedTab: "editWaveTab",
      selectedWave: {},
      selectedWaveDirty: false,
      wavePositionsDirty: false,
      scenariosOfClient: [],
      fpInputWaveUntil: null,
      fpInputWaveSince: null,
      fpInputWavePlannedUntil: null,
      fpInputWavePlannedSince: null,
      forceReportingVisibilityChange: false,
      brands: [],
      lang: {
        WV0000: "Wave Administration",
        WV0001: "Filter",
        WV0002: "ID",
        WV0003: "Name",
        WV0004: "Start date",
        WV0005: "End date",
        WV0006: "Edit wave",
        WV0007: "Assign scenarios",
        WV0008: "Reporting Visibility",
        WV0009: "New",
        WV0010: "Save",
        WV0011: "Delete",
        WV0012: "ID",
        WV0013: "Name",
        WV0014: "Description",
        WV0015: "Close",
        WV0016: "Yes",
        WV0017: "No",
        WV0018: "Delete Wave",
        WV0019: "Do you really want to delete the following wave?",
        WV0020: "Period of time",
        WV0021: "Change Reporting Visibility",
        WV0022: "Do you really want to make the whole wave visible in reporting?",
        WV0023: "All defined security settings on user level for this wave will be lost.",
        WV0024: "Project",
        WV0025: "Client",
        WV0026: "Save positions",
        WV0027: "Position",
        WV0028: "Cost center",
        WV0029: "Audi cars",
        WV0030: "Model",
        WV0031: "Share",
        WV0032: "Overall share values exceed 100%",
        WV0033: "Info",
        WV0034: "Status",
        WV0035: "Competitor Cars",
        WV0036: "Actions",
        WV0037: "Add model",
        WV0038: "Empty model already exists",
        WV0039: "Lead agency PLUS",
        WV0040: "Wave without approval",
        WV0041: "Local Wave",
        WV0042: "Planned start date",
        WV0043: "Planned end date",
        WV0044: "Brand",
        WV0045: "Visits",
        WV0046: "Frequency / Store",
        WV0047: "Add Visit",
        WV0048: "-- Choose --",
        WV0049: "Following competitors do not reach 100% Share: {{brands}}",
        WV0050: "Total",
        WV0051: "#Visits",
        WV0052: "Duplicated Frequency / Store for {{brand}} found.",
        WV0053: "Empty brand selection in 'Visits'.",
        WV0054: "Empty brand selection in 'Competitor Cars'.",
        WV0055: "All Visits for {{brand}} must be > 0.",
        WV0056: "Distribution value for a model set more than once!",
        WV0057: "Overall share values are below 99%",
        SA0012: "Importer",
        CMM002: "Segments"
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this);
      this.initFlatpickr();
    }

    this.loadLeadAgencies();

    $("#editWaveDialog").on("hidden.bs.modal", function (e) {
      _this.$emit("dialogClosed");
    });

    // Register global events
    this.globals.$off("WaveDeleteModalYesConfirmation");
    this.globals.$on("WaveDeleteModalYesConfirmation", function () {
      _this.deleteSelectedWave();
    });

    if (this.feature.isAudiTarget && this.feature.isEnabled("shopperApproval")) {
      this.globals.getCarModelList(function (data) {
        _this.carModelList = _.cloneDeep(data);
      });
      this.globals.getImporterList(function (data) {
        _this.importerList = data;
      });
      this.globals.getCarSegmentList(function (data) {
        _this.segmentList = data;
      });
    }
  },
  destroyed: function destroyed() {
    if (this.fpInputWaveUntil) this.fpInputWaveUntil.destroy();
    if (this.fpInputWaveSince) this.fpInputWaveSince.destroy();
    if (this.fpInputWavePlannedSince) this.fpInputWavePlannedSince.destroy();
    if (this.fpInputWavePlannedUntil) this.fpInputWavePlannedUntil.destroy();
  },

  watch: {
    showDialog: function showDialog() {
      if (this.showDialog) this.openWaveEditDialog();else this.closeWaveEditDialog();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
      this.initFlatpickr();
    }
  },
  methods: {
    // Initialize flatpickr instances
    initFlatpickr: function initFlatpickr() {
      this.fpInputWaveSince = flatpickr("#inputWaveStartDate", this.globals.flatpickrDateConfig);
      this.fpInputWaveUntil = flatpickr("#inputWaveEndDate", this.globals.flatpickrDateConfig);
      this.fpInputWavePlannedSince = flatpickr("#inputWavePlannedStartDate", this.globals.flatpickrDateConfig);
      this.fpInputWavePlannedUntil = flatpickr("#inputWavePlannedEndDate", this.globals.flatpickrDateConfig);
    },
    loadLeadAgencies: function loadLeadAgencies() {
      var _this2 = this;

      $.ajax({
        method: "GET",
        url: "api/agencies/lead",
        success: function success(res) {
          if (_.isEmpty(res)) res = [];
          _this2.leadAgencies = res;
        },
        error: function error() {
          console.error("Error on GET in loadLeadAgencies()");
          _this2.globals.showErrorSnackbar("Lead agencies load failed");
        }
      });
    },
    loadBrands: function loadBrands() {
      var _this3 = this;

      var queryString = "/api/data/Brands/" + this.selectedProjectData.ProjectId;
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          if (!_.isEmpty(data)) _this3.brands = data.map(function (p) {
            return p.LocationPropertyValue;
          });
        },
        error: function error() {
          console.error("Error on GET in getBrands()");
          _this3.globals.showErrorSnackbar("Brands get failed");
        }
      });
    },
    readCarModelDistributionFromSelectedWave: function readCarModelDistributionFromSelectedWave() {
      var _this4 = this;

      this.clearCarModelDistribution();

      if (!this.selectedWave.CarModelDistribution) return;

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        var _loop = function _loop() {
          var waveEntry = _step.value;

          var modelListEntry = _.find(_this4.carModelList, function (model) {
            return model.CarModelGuid === waveEntry.CarModelGuid;
          });
          if (modelListEntry) modelListEntry.Distribution = parseFloat((waveEntry.Distribution * 100).toFixed(4));
        };

        for (var _iterator = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(this.selectedWave.CarModelDistribution), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          _loop();
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    storeCarModelDistributionToSelectedWave: function storeCarModelDistributionToSelectedWave() {
      var sum = 0;
      var modelsSet = new __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_set___default.a();
      this.selectedWave.CarModelDistribution = [];

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(this.carModelList), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var entry = _step2.value;

          if (entry.Distribution === undefined) {
            continue;
          }

          if (modelsSet.has(entry.CarModelName)) {
            this.globals.showErrorSnackbar(this.lang.WV0056);
            console.error("Distribution value for a model set more than once!");
            return false;
          }

          sum += entry.Distribution;
          this.selectedWave.CarModelDistribution.push({
            CarModelGuid: entry.CarModelGuid,
            Distribution: parseFloat((entry.Distribution / 100).toFixed(4))
          });

          modelsSet.add(entry.CarModelName);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      if (this.selectedWave.CarModelDistribution.length < 1) delete this.selectedWave.CarModelDistribution;

      if (sum > 100) {
        this.globals.showErrorSnackbar(this.lang.WV0032);
        console.error("Overall car model distribution values for this wave exceeds 100%");
        return false;
      }

      if (sum < 99) {
        this.globals.showErrorSnackbar(this.lang.WV0057);
        console.error("Overall car model distribution values for this wave is below 99%");
        return false;
      }
      return true;
    },
    clearCarModelDistribution: function clearCarModelDistribution() {
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(this.carModelList), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var entry = _step3.value;
          delete entry.Distribution;
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    },
    addCompetitorCarModel: function addCompetitorCarModel() {
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(this.selectedWave.CompetitorCarModelDistribution), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var entry = _step4.value;

          if (!entry.CompetitorCarModel) {
            this.globals.showErrorSnackbar(this.lang.WV0038);
            console.error("Empty competitor model already existis");
            return;
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      this.selectedWave.CompetitorCarModelDistribution.push({
        CompetitorCarBrand: "",
        Distribution: 0
      });
      this.$forceUpdate();
    },
    deleteCompetitorCarModel: function deleteCompetitorCarModel(index) {
      _.pullAt(this.selectedWave.CompetitorCarModelDistribution, index);
      this.$forceUpdate();
    },
    validateDistributionValue: function validateDistributionValue(model, type) {
      var lowerLimit = 0,
          upperLimit = 100;
      if (type === "competitor") upperLimit = 1;

      if (model.Distribution === '') {
        model.Distribution = undefined;
      } else if (typeof model.Distribution !== "number" || model.Distribution < lowerLimit) {
        model.Distribution = lowerLimit;
      } else if (model.Distribution > upperLimit) {
        model.Distribution = upperLimit;
      }
      this.$forceUpdate();
    },
    validateCompetitorCarModelDistribution: function validateCompetitorCarModelDistribution() {
      if (this.selectedWave.CompetitorCarModelDistribution.length < 1) {
        delete this.selectedWave.CompetitorCarModelDistribution;
        return;
      }

      var map = this.getCompetitorCarBrandDistributionMap(this.selectedWave);
      var validationErrorMap = new __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_map___default.a([].concat(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default()(map)).filter(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        return value < 0.99 || value > 1;
      }));
      if (validationErrorMap.size > 0) {
        var brands = [].concat(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default()(validationErrorMap.keys())).join(', ');
        this.globals.showErrorSnackbar(this.lang.WV0049.replace('{{brands}}', brands));
        console.error("Following competitors do not have a share of 100% per brand: " + brands);
        return false;
      }
    },
    validateVisitValue: function validateVisitValue(val) {
      var lowerLimit = 1;
      var number = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_int___default()(val);
      if (number < lowerLimit) return lowerLimit;
      if (!__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer___default()(number)) return Math.floor(number);
      return number;
    },
    showWaveStatus: function showWaveStatus() {
      var config = {
        guid: this.selectedWave.WaveGuid,
        id: this.selectedWave.WaveId
      };
      this.globals.$emit("showWaveStatus", config);
    },
    saveSelectedWave: function saveSelectedWave() {
      var _this5 = this;

      if (this.carModelList.length > 0 && !this.storeCarModelDistributionToSelectedWave()) return;

      if (!this.validiateBrandSelections()) return;

      if (this.selectedWave.CompetitorCarModelDistribution && this.validateCompetitorCarModelDistribution() === false) return;

      if (!this.validateVisits()) return;

      if (this.selectedWave.LeadAgencyId == "") this.selectedWave.LeadAgencyId = null;

      var data = void 0,
          queryString = void 0;
      var currentWaveIndex = _.findIndex(this.waves, function (w) {
        return w.WaveGuid === _this5.selectedWave.WaveGuid;
      });
      if (currentWaveIndex > -1) {
        // Wave does already exist
        queryString = "api/ProjectWaves/" + this.selectedWave.WaveGuid;
        data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.selectedWave);
        $.ajax({
          method: "PUT",
          url: queryString,
          data: data,
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            if (data.Error) {
              console.error(data.Error);
              _this5.globals.showErrorSnackbar(data.Error);
              return;
            }
            if (!_this5.selectedWave.CompetitorCarModelDistribution) _this5.selectedWave.CompetitorCarModelDistribution = [];
            _this5.waves[currentWaveIndex] = _.cloneDeep(_this5.selectedWave);
            _this5.doFilteringWaves();
            _this5.$forceUpdate();
            _this5.globals.showSuccessSnackbar("Wave update successful");
            _this5.selectedWaveDirty = false;
          },
          error: function error(e) {
            console.error("Error on PUT in saveSelectedWave()");
            _this5.globals.showErrorSnackbar("Wave update failed");
          }
        });
      } else {
        // Wave does not yet exist
        delete this.selectedWave.WaveId;
        this.selectedWave.WaveGuid = uuidv4();

        queryString = "api/Projects/" + this.selectedProjectData.ProjectGuid + "/Waves";
        data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()([this.selectedWave]);

        $.ajax({
          method: "POST",
          url: queryString,
          data: data,
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            if (data.Error) {
              console.error(data.Error);
              _this5.globals.showErrorSnackbar(data.Error);
              return;
            }
            if (data[0]) {
              if (data[0].WaveId) _this5.selectedWave.WaveId = data[0].WaveId;
              if (data[0].WaveGuid) _this5.selectedWave.WaveGuid = data[0].WaveGuid;
              if (data[0].WavePosition) _this5.selectedWave.WavePosition = data[0].WavePosition;
            }
            if (!_this5.selectedWave.CompetitorCarModelDistribution) _this5.selectedWave.CompetitorCarModelDistribution = [];
            var wave = _.cloneDeep(_this5.selectedWave);
            _this5.waves.push(wave);
            _this5.doFilteringWaves();
            _this5.$forceUpdate();
            _this5.globals.showSuccessSnackbar("Wave update successful");
            _this5.selectedWaveDirty = false;
          },
          error: function error() {
            console.error("Error on POST in saveSelectedWave()");
            _this5.globals.showErrorSnackbar("Wave update failed");
          }
        });
      }
    },
    saveWavePositions: function saveWavePositions() {
      var _this6 = this;

      var queryString = "api/Projects/" + this.selectedProjectData.ProjectGuid + "/Waves";

      this.readWavePositions();
      var data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.wavePositions);

      $.ajax({
        method: "PUT",
        url: queryString,
        data: data,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this6.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this6.globals.showSuccessSnackbar("Wave position update successful");
          _this6.wavePositionsDirty = false;
        },
        error: function error() {
          console.error("Error on PUT in saveWavePositions()");
          _this6.globals.showErrorSnackbar("Wave position update failed");
        }
      });
    },
    deleteSelectedWave: function deleteSelectedWave() {
      var _this7 = this;

      $.ajax({
        method: "DELETE",
        url: "api/ProjectWaves/" + this.selectedWave.WaveGuid,
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this7.globals.showErrorSnackbar(data.Error);
            return;
          }
          // If delete was successful, refresh displayed data and hide dialog
          _this7.globals.showSuccessSnackbar("Wave deletion successful");
          _.remove(_this7.waves, function (w) {
            return w.WaveGuid === _this7.selectedWave.WaveGuid;
          });
          _this7.createNewWave();
          _this7.closeWavePositionGap();
          _this7.doFilteringWaves();
        },
        error: function error() {
          console.error("Wave deletion failed in deleteSelectedWave()");
          _this7.globals.showErrorSnackbar("Wave deletion failed");
        }
      });
    },
    createNewWave: function createNewWave() {
      this.selectedWave = {
        WaveGuid: uuidv4(),
        ReportingVisibility: true,
        WaveWithoutApprovel: false,
        IsLocalWave: false,
        Scenarios: [],
        BrandVisits: []
      };
      this.fpInputWaveUntil.clear();
      this.fpInputWaveSince.clear();
      this.fpInputWavePlannedSince.clear();
      this.fpInputWavePlannedUntil.clear();
      this.clearCarModelDistribution();
      if (this.feature.isAudiTarget && this.feature.isEnabled("shopperApproval")) this.selectedWave.CompetitorCarModelDistribution = [];
      this.selectedWaveDirty = false;
    },
    getAllWaves: function getAllWaves() {
      var _this8 = this;

      var queryString = "api/Projects/" + this.selectedProjectData.ProjectGuid + "/Waves";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          if (!data || _.isEmpty(data)) {
            _this8.waves = [];
            return;
          }
          _this8.waves = data;
          _this8.sortWavesByPosition();
          _this8.doFilteringWaves();
        },
        error: function error() {
          console.error("Error on GET in getAllWaves()");
          _this8.globals.showErrorSnackbar("Wave request failed");
        }
      });
    },
    getAllScenarios: function getAllScenarios() {
      var _this9 = this;

      var queryString = "api/Scenarios";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this9.scenarios = data;
          _this9.getScenariosOfClient();
        },
        error: function error() {
          console.error("Error on GET in getAllScenarios()");
          _this9.globals.showErrorSnackbar("Scenario request failed");
        }
      });
    },
    getScenariosOfClient: function getScenariosOfClient() {
      var _this10 = this;

      var queryString = "/api/Clients/" + this.selectedClient + "/Scenarios";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this10.scenarios = _this10.scenarios.filter(function (sc) {
            return _.indexOf(data.Scenarios, sc.ScenarioGuid) < 0 ? false : true;
          });
          _this10.doFilteringScenarios();
        },
        error: function error() {
          console.error("Error on GET in getScenariosOfClient()");
          _this10.globals.showErrorSnackbar("Scenario request failed");
        }
      });
    },
    doFilteringWaves: function doFilteringWaves() {
      // Reset filtering when search string is empty
      if (!this.waves || this.waves.length < 1) return;
      if (!this.filterWaveString) {
        this.filteredWaves = this.waves;
        return;
      }

      var words = this.filterWaveString.split(" ");
      var keys = ["WaveId", "WaveName", "WaveStart", "WaveEnd"];

      var waveFilter = function waveFilter(wave) {
        var containsSearch = false;
        words.forEach(function (word) {
          keys.forEach(function (key) {
            if (wave[key] && wave[key].toString().toLowerCase().indexOf(word.toLowerCase()) > -1) {
              containsSearch = true;
              return;
            }
          });
        });
        return containsSearch;
      };
      this.filteredWaves = this.waves.filter(waveFilter);
    },
    reorderWaves: function reorderWaves() {
      var allPositions = _.range(1, this.waves.length + 1);
      var missingPos = 0;
      var newPos = 0;
      var waveGuid = "";

      // Find missing position number and the position and name of the changed wave
      for (var i = 0; i < allPositions.length; i++) {
        if (this.waves[i].WavePosition != allPositions[i]) {
          missingPos = allPositions[i];
          newPos = this.waves[i].WavePosition;
          waveGuid = this.waves[i].WaveGuid;
        }
      }
      if (missingPos == 0) return; // No position missing -> no value changed

      // Move position numbers between new position number and missing position number
      for (var i = 0; i < allPositions.length; i++) {
        if (this.waves[i].WaveGuid != waveGuid) {
          // Do NOT move the changed wave
          if (this.waves[i].WavePosition < missingPos && this.waves[i].WavePosition >= newPos) {
            this.waves[i].WavePosition++;
          }
          if (this.waves[i].WavePosition > missingPos && this.waves[i].WavePosition <= newPos) {
            this.waves[i].WavePosition--;
          }
        }
      }
      this.sortWavesByPosition();
      this.$forceUpdate(); // Forces the table to update
    },
    closeWavePositionGap: function closeWavePositionGap() {
      if (this.waves.length < 1) return;
      this.waves[0].WavePosition = 1;
      for (var i = 1; i < this.waves.length; i++) {
        // Closes gap
        if (this.waves[i].WavePosition > this.waves[i - 1].WavePosition + 1) this.waves[i].WavePosition--;
        // Fixes double wave positions
        if (this.waves[i].WavePosition == this.waves[i - 1].WavePosition) this.waves[i].WavePosition++;
      }
    },
    sortWavesByPosition: function sortWavesByPosition() {
      if (!this.waves) return;
      this.waves.sort(function (a, b) {
        return a.WavePosition - b.WavePosition;
      });
    },
    readWavePositions: function readWavePositions() {
      this.wavePositions = [];
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(this.waves), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var wave = _step5.value;

          this.wavePositions.push({
            WaveGuid: wave.WaveGuid,
            WavePosition: wave.WavePosition
          });
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }
    },
    doFilteringScenarios: function doFilteringScenarios() {
      // Reset filtering when search string is empty
      if (!this.scenarios || this.scenarios.length < 1) return;
      if (!this.filterScenarioString) {
        this.filteredScenarios = this.scenarios;
        return;
      }

      var words = this.filterScenarioString.split(" ");
      var keys = ["ScenarioId", "ScenarioName", "ScenarioDescription"];

      var scenarioFilter = function scenarioFilter(scenario) {
        var containsSearch = false;
        words.forEach(function (word) {
          keys.forEach(function (key) {
            if (scenario[key] && scenario[key].toString().toLowerCase().indexOf(word.toLowerCase()) > -1) {
              containsSearch = true;
              return;
            }
          });
        });
        return containsSearch;
      };
      this.filteredScenarios = this.scenarios.filter(scenarioFilter);
    },
    selectWave: function selectWave(WaveGuid) {
      var wave = this.waves.find(function (w) {
        return w.WaveGuid === WaveGuid;
      });
      if (wave) {
        this.selectedWave = _.cloneDeep(wave);
        if (this.carModelList.length > 0) this.readCarModelDistributionFromSelectedWave();
        if (this.feature.isAudiTarget && this.feature.isEnabled("shopperApproval") && !this.selectedWave.CompetitorCarModelDistribution) this.selectedWave.CompetitorCarModelDistribution = [];
        this.fpInputWaveSince.setDate(this.selectedWave.WaveSince);
        this.fpInputWaveUntil.setDate(this.selectedWave.WaveUntil);
        this.fpInputWavePlannedSince.setDate(this.selectedWave.WavePlannedSince);
        this.fpInputWavePlannedUntil.setDate(this.selectedWave.WavePlannedUntil);
        this.selectedWaveDirty = false;
      } else {
        this.createNewWave();
      }
    },
    isWaveSelected: function isWaveSelected(WaveGuid) {
      return this.selectedWave.WaveGuid === WaveGuid;
    },
    selectScenario: function selectScenario(scenarioGuid) {
      if (!this.selectedWave.WaveId) return;
      if (!this.selectedWave.Scenarios) this.selectedWave.Scenarios = [scenarioGuid];else {
        var idx = _.indexOf(this.selectedWave.Scenarios, scenarioGuid);
        if (idx > -1) {
          _.pullAt(this.selectedWave.Scenarios, idx);
        } else {
          this.selectedWave.Scenarios.push(scenarioGuid);
        }
      }
      this.selectedWaveDirty = true;
      this.$forceUpdate();
    },
    isScenarioSelected: function isScenarioSelected(scenarioGuid) {
      return _.indexOf(this.selectedWave.Scenarios, scenarioGuid) > -1;
    },
    openDeleteWaveConfirmationDialog: function openDeleteWaveConfirmationDialog() {
      this.globals.$emit("openGlobalConfirmationDialog", this.getDeleteDialogData());
    },
    getDeleteDialogData: function getDeleteDialogData() {
      return {
        initiator: "WaveDeleteModal",
        confirmationTitle: this.lang.WV0018,
        colorRed: true,
        yesButtonText: this.lang.WV0016,
        noButtonText: this.lang.WV0017,
        htmlText: "<p><b>" + this.lang.WV0019 + "</b></p>\n        <div class=\"form-group\">\n          <label class=\"col-md-3 text-black\">" + this.lang.WV0002 + "</label>\n          <label class=\"col-md-9 text-black\">" + this.selectedWave.WaveId + "</label>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-md-3 text-black\">" + this.lang.WV0003 + "</label>\n          <label class=\"col-md-9 text-black\">" + this.selectedWave.WaveName + "</label>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-md-3 text-black\">" + this.lang.WV0020 + "</label>\n          <label class=\"col-md-9 text-black\">" + this.globals.getLocalizedDateFromIsoTimestamp(this.selectedWave.WaveSince) + " - " + this.globals.getLocalizedDateFromIsoTimestamp(this.selectedWave.WaveUntil) + "</label>\n        </div>"
      };
    },
    openWaveEditDialog: function openWaveEditDialog() {
      this.wavePositionsDirty = false;
      this.filteredWaves = [];
      this.createNewWave();
      this.getAllWaves();
      this.getAllScenarios();
      this.loadBrands();
      $("#editWaveDialog").modal("show");
    },
    closeWaveEditDialog: function closeWaveEditDialog() {
      $("#editWaveDialog").modal("hide");
    },
    waveReportingVisibilityChanged: function waveReportingVisibilityChanged(wave) {
      if (wave.ReportingVisibility === false) return;
      var forceReportingVisibilityChange = false;

      this.globals.$off("WaveReportingVisibilityChangedModalYesConfirmation");
      this.globals.$on("WaveReportingVisibilityChangedModalYesConfirmation", function () {
        wave.ReportingVisibility = true;
        forceReportingVisibilityChange = true;
      });
      this.globals.$off("WaveReportingVisibilityChangedModalDialogClosed");
      this.globals.$on("WaveReportingVisibilityChangedModalDialogClosed", function () {
        if (!forceReportingVisibilityChange) wave.ReportingVisibility = false;
        forceReportingVisibilityChange = false;
      });
      this.openReportingVisibilityChangedDialog();
    },
    openReportingVisibilityChangedDialog: function openReportingVisibilityChangedDialog() {
      this.globals.$emit("openGlobalConfirmationDialog", this.getReportingVisibilityChangedDialogData());
    },
    getReportingVisibilityChangedDialogData: function getReportingVisibilityChangedDialogData() {
      return {
        initiator: "WaveReportingVisibilityChangedModal",
        confirmationTitle: this.lang.WV0021,
        colorRed: true,
        yesButtonText: this.lang.WV0016,
        noButtonText: this.lang.WV0017,
        htmlText: "<p><b>" + this.lang.WV0022 + "</b></p>\n        <p>" + this.lang.WV0023 + "</p>"
      };
    },
    addNewBrandVisit: function addNewBrandVisit(wave) {
      if (!wave.BrandVisits) wave.BrandVisits = [];
      wave.BrandVisits.push({ BrandName: "", Visits: [this.getEmptyVisit()] });
    },
    addVisitToBrandVisit: function addVisitToBrandVisit(brandVisit) {
      brandVisit.Visits.push(this.getEmptyVisit());
    },
    getEmptyVisit: function getEmptyVisit() {
      return { Frequency: 0, NoOfVisits: 0 };
    },
    canSelectBrand: function canSelectBrand(wave, brandName) {
      return wave.BrandVisits.find(function (p) {
        return p.BrandName === brandName;
      });
    },
    removeBrandVisit: function removeBrandVisit(wave, index) {
      wave.BrandVisits.splice(index, 1);
    },
    removeVisit: function removeVisit(wave, brandIndex, index) {
      wave.BrandVisits[brandIndex].Visits.splice(index, 1);
    },
    getTotalNumberOfVisits: function getTotalNumberOfVisits(wave) {
      if (!wave || !wave.BrandVisits) return 0;
      var result = 0;
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(wave.BrandVisits), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var brandVisit = _step6.value;

          if (!brandVisit.Visits) continue;
          brandVisit.Visits.forEach(function (v) {
            return result += v.Frequency * v.NoOfVisits;
          });
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      return result;
    },
    getCompetitorCarBrandDistributionMap: function getCompetitorCarBrandDistributionMap() {
      var result = new __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_map___default.a();

      if (!this.selectedWave || !this.selectedWave.CompetitorCarModelDistribution) return result;

      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(this.selectedWave.CompetitorCarModelDistribution), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var competitorCar = _step7.value;

          result.set(competitorCar.CompetitorCarBrand, (result.get(competitorCar.CompetitorCarBrand) || 0) + (competitorCar.Distribution || 0));
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }

      return result;
    },
    getCompetitorDistributionsInfoToolTip: function getCompetitorDistributionsInfoToolTip() {
      var map = this.getCompetitorCarBrandDistributionMap();
      return [].concat(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default()(map.entries())).map(function (p) {
        return p[0] + ": " + (p[1] * 100).toFixed(1) + "%";
      });
    },
    validateVisits: function validateVisits() {
      if (!this.selectedWave || !this.selectedWave.BrandVisits) return true;

      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(this.selectedWave.BrandVisits), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var brandVisit = _step8.value;

          if (brandVisit.Visits.findIndex(function (p) {
            return p.NoOfVisits <= 0 || p.Frequency <= 0 || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default()(p.NoOfVisits) || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default()(p.Frequency);
          }) >= 0) {
            console.error("0 Value in Visit for Brand " + brandVisit.BrandName);
            this.globals.showErrorSnackbar(this.lang.WV0055.replace('{{brand}}', brandVisit.BrandName));
            return false;
          }

          var visitSet = new __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_set___default.a(brandVisit.Visits.map(function (p) {
            return p.Frequency.toString();
          }));
          if (visitSet.size != brandVisit.Visits.length) {
            console.error("Duplicated Frequency for Brand " + brandVisit.BrandName);
            this.globals.showErrorSnackbar(this.lang.WV0052.replace('{{brand}}', brandVisit.BrandName));
            return false;
          }
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      return true;
    },
    canSaveWave: function canSaveWave() {
      return this.selectedWave.WaveName && this.selectedWave.WaveSince && this.selectedWave.WaveUntil && this.selectedWave.WavePlannedSince && this.selectedWave.WavePlannedUntil && (this.globals.isAccessAllowed('LoopOp_ProjectWaves_Create') && !this.selectedWave.WaveId || this.globals.isAccessAllowed('LoopOp_ProjectWaves_Update') && this.selectedWave.WaveId);
    },
    canRemoveVisit: function canRemoveVisit(wave, brandIndex) {
      if (!wave || brandIndex == undefined || brandIndex < 0 || !wave.BrandVisits[brandIndex]) return false;
      return wave.BrandVisits[brandIndex].Visits.length > 1;
    },
    validiateBrandSelections: function validiateBrandSelections() {
      var messages = [];
      if (this.selectedWave.BrandVisits.findIndex(function (p) {
        return p.BrandName == "";
      }) >= 0) {
        console.error(this.lang.WV0053);
        messages.push(this.lang.WV0053);
      }
      if (this.selectedWave.CompetitorCarModelDistribution.findIndex(function (p) {
        return p.CompetitorCarBrand == "";
      }) >= 0) {
        console.error(this.lang.WV0054);
        messages.push(this.lang.WV0054);
      }

      if (messages.length > 0) {
        this.globals.showErrorSnackbar(messages.join(' '));
        return false;
      }
      return true;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "WaveStatusModal",
  data: function data() {
    return {
      elementId: 0,
      statusData: {},
      lang: {
        WVS000: "Wave Status",
        WVS001: "Check Status",
        WVS002: "Total check count",
        WVS003: "In approval",
        WVS004: "In progress",
        WVS005: "In reporting",
        WVS006: "In time",
        WVS007: "Approvals",
        WVS008: "Without proposals",
        WVS009: "With proposals",
        WVS010: "Approved",
        WVS011: "Rejected",
        WVS012: "Audi Cars",
        WVS013: "Model",
        WVS014: "Target value",
        WVS015: "Current value",
        WVS016: "Close",
        WVS017: "Wave status request failed",
        WVS018: "Competitor cars"
      }
    };
  },

  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    this.globals.$off("showWaveStatus");
    this.globals.$on("showWaveStatus", function (config) {
      _this.getWaveStatus(config);
    });
  },

  methods: {
    openModal: function openModal() {
      $("#waveStatusModal").modal("show");
    },
    closeModal: function closeModal() {
      $("#waveStatusModal").modal("hide");
    },
    getWaveStatus: function getWaveStatus(config) {
      var _this2 = this;

      if (!config) return;
      var query = "api/ProjectWaves/" + config.guid + "/Status";
      this.elementId = config.id;

      $.ajax({
        method: "GET",
        url: query,
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this2.globals.showErrorSnackbar(data.Error);
            return;
          }
          if (data) _this2.statusData = data;
          _this2.openModal();
        },
        error: function error(_error) {
          console.error("Error on GET in getWaveStatus()");
          _this2.globals.showErrorSnackbar(_this2.lang.WVS017);
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tools_Select2__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Tools_Select2__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var uuidv4 = __webpack_require__(60);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "CheckFilter",
  components: {
    Select2: __WEBPACK_IMPORTED_MODULE_2__Tools_Select2___default.a
  },
  props: {
    currentFilterObject: {
      Type: Object,
      default: function _default() {
        return {};
      }
    },
    locationPropertiesList: {
      Type: Array,
      default: function _default() {
        return [];
      }
    },
    countryList: {
      Type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      selectedClient: "",
      selectedProject: "",
      selectedWave: "",
      selectedImporter: "",
      clientList: [],
      importerList: [],
      projectList: [],
      waveList: [],
      scenarioList: [],
      // cityLists: [],
      dynamicFilters: [],
      filterTypes: ["Country", "City", "PostalCode", "LocationProperty", "Scenario", "Status"],
      recruitingStatusList: ["NOT_ASSIGNED", "ASSIGNED_WITH_ANSWER", "ASSIGNED_NO_ANSWER"],
      resultCheckData: {},
      lang: {
        RCC000: "Check filter",
        RCC001: "Available Checks",
        RCC002: "Client",
        RCC003: "Project",
        RCC004: "Wave",
        RCC005: "Choose",
        RCC006: "Type of filter",
        RCC007: "Select values",
        RCC008: "Add filter",
        RCC009: "Check data request failed",
        RCC010: "City data request failed",
        RCC011: "City",
        RCC012: "Country",
        RCC013: "Location property",
        RCC014: "Scenario",
        RCC015: "Status",
        RCC016: "Not assigned",
        RCC017: "Edited",
        RCC018: "Assigned but not edited",
        RCC019: "Please type in a value",
        RCC020: "Postal code",
        RCC021: "The maximum count of checks that can be shown on the map is exceeded. If you want to see all results on the map, please define some more filters.",
        RCC022: "Importer"
      }
    };
  },

  computed: {
    projectsOfSelectedClient: function projectsOfSelectedClient() {
      var _this = this;

      var entry = _.find(this.projectList, function (el) {
        return el.ClientGuid === _this.selectedClient;
      });
      if (entry && entry.Projects) return entry.Projects;
      return [];
    },
    wavesOfSelectedProject: function wavesOfSelectedProject() {
      var _this2 = this;

      var entry = _.find(this.waveList, function (el) {
        return el.ProjectGuid === _this2.selectedProject;
      });
      if (entry && entry.Waves) return entry.Waves;
      return [];
    },
    scenariosOfSelectedWave: function scenariosOfSelectedWave() {
      var _this3 = this;

      var entry = _.find(this.scenarioList, function (el) {
        return el.WaveGuid === _this3.selectedWave;
      });
      if (entry && entry.Scenarios) return entry.Scenarios;
      return [];
    },
    checkCountExceeded: function checkCountExceeded() {
      if (!this.resultCheckData || _.isEmpty(this.resultCheckData) || !this.resultCheckData.SurveyInstances) return false;
      return this.resultCheckData.SurveyInstanceCount > this.resultCheckData.SurveyInstances.length;
    }
  },
  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this, this.debouncedUpdateSelect2Data);
    },
    selectedClient: function selectedClient(newClient) {
      if (!this.$filterRestorePending) this.selectedProject = "";
      this.getLocationProperties();
    },
    selectedProject: function selectedProject() {
      if (!this.$filterRestorePending) this.selectedWave = "";
    },
    selectedWave: function selectedWave(newGuid) {
      var _this4 = this;

      if (!this.$filterRestorePending) _.forEach(this.dynamicFilters, function (f) {
        if (f.Type === "Scenario") {
          delete f.Value;
          f.currentDynamicFilterValues = _this4.scenariosOfSelectedWave;
        }
      });

      if (newGuid) this.getCheckFilterResult();else this.resultCheckData = {};
    },
    resultCheckData: function resultCheckData(newData) {
      this.$emit("checkDataChanged", newData);
    }
  },
  created: function created() {
    this.debouncedUpdateSelect2Data = _.debounce(this.updateSelect2Data, 500);
  },
  mounted: function mounted() {
    var _this5 = this;

    this.readComponentSettingsFromStore();
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this, this.debouncedUpdateSelect2Data);
    this.globals.getClientList(function (data) {
      _this5.clientList = data;
      if (_this5.feature.isAudiTarget && _this5.feature.isEnabled("audi_importers") && _this5.clientList[0]) _this5.selectedClient = _this5.clientList[0].ClientGuid;
      _this5.$emit("ClientListReceived");
    });
    this.globals.getProjectList(function (data) {
      _this5.projectList = data;
      _this5.$emit("ProjectListReceived");
    });
    this.globals.getWaveList(function (data) {
      _this5.waveList = data;
      _this5.$emit("WaveListReceived");
    });
    this.globals.getScenarioList(function (data) {
      _this5.scenarioList = data;
      _this5.$emit("ScenarioListReceived");
    });

    if (this.feature.isAudiTarget && this.feature.isEnabled("audi_importers")) {
      this.globals.getImporterList(function (data) {
        _this5.importerList = data;
        _this5.$emit("ImporterListReceived");
      });
    }
  },
  destroyed: function destroyed() {
    this.writeComponentSettingsToStore();
  },

  methods: {
    readComponentSettingsFromStore: function readComponentSettingsFromStore() {
      var _this6 = this;

      if (!this.$store.getters["userSettings/rememberFilters"]) return;

      this.$filterRestorePending = true;
      var restoreDone = function restoreDone() {
        _this6.$nextTick(function () {
          delete _this6.$filterRestorePending;
          _this6.debouncedUpdateSelect2Data();
        });
      };

      var restoreFilters = function restoreFilters() {
        _this6.$nextTick(function () {
          var storedData = _this6.$store.getters["localFilters/recruiting_checkFilter"];
          if (storedData) {
            for (var key in storedData) {
              if (_.has(_this6, key)) _this6[key] = _.cloneDeep(storedData[key]);
            }
          }

          if (!_this6.$store.getters["userSettings/syncFilters"]) {
            restoreDone();
            return;
          }
          if (!_this6.feature.isAudiTarget || !_this6.feature.isEnabled("audi_importers")) {
            var storedClient = _this6.$store.getters["sharedFilters/client"];
            if (_this6.selectedClient !== storedClient.ClientGuid) {
              _this6.selectedWave = "";
              _this6.dynamicFilters = [];
            }
            _this6.selectedClient = storedClient.ClientGuid || "";
          } else {
            var storedImporter = _this6.$store.getters["sharedFilters/importer"];
            _this6.selectedImporter = storedImporter.ImporterGuid || "";
          }

          var storedProject = _this6.$store.getters["sharedFilters/project"];
          if (_this6.selectedProject !== storedProject.ProjectGuid) {
            _this6.selectedWave = "";
            _this6.dynamicFilters = [];
          }
          _this6.selectedProject = storedProject.ProjectGuid || "";

          restoreDone();
        });
      };

      var eventsToWaitFor = ["ClientListReceived", "ProjectListReceived", "WaveListReceived", "ScenarioListReceived"];

      if (this.feature.isAudiTarget) eventsToWaitFor.push("ImporterListReceived");

      if (this.countryList.length < 1) {
        eventsToWaitFor.push("CountryListReceived");
        this.$parent.$once("CountryListReceived", function () {
          return _this6.$emit("CountryListReceived");
        });
      }

      if (this.selectedClient && this.locationPropertiesList.length < 1) {
        eventsToWaitFor.push("LocationPropertiesReceived");
        this.$parent.$once("LocationPropertiesReceived", function () {
          return _this6.$emit("LocationPropertiesReceived");
        });
      }

      this.globals.doAfterEvents(eventsToWaitFor, restoreFilters, this);
    },
    writeComponentSettingsToStore: function writeComponentSettingsToStore() {
      var _this7 = this;

      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      this.$store.commit("localFilters/recruiting_checkFilter", {
        selectedClient: this.selectedClient,
        selectedImporter: this.selectedImporter,
        selectedProject: this.selectedProject,
        selectedWave: this.selectedWave,
        dynamicFilters: this.dynamicFilters
      });

      if (!this.$store.getters["userSettings/syncFilters"]) return;
      if (!this.feature.isAudiTarget || !this.feature.isEnabled("audi_importers")) {
        if (this.selectedClient) {
          var client = _.find(this.clientList, function (c) {
            return c.ClientGuid === _this7.selectedClient;
          });
          if (client) this.$store.commit("sharedFilters/client", client);
        } else {
          var storedClient = this.$store.getters["sharedFilters/client"];
          if (storedClient.ClientGuid) this.$store.commit("sharedFilters/client");
        }
      } else {
        if (this.selectedImporter) {
          var importer = _.find(this.importerList, function (i) {
            return i.ImporterGuid === _this7.selectedImporter;
          });
          if (importer) this.$store.commit("sharedFilters/importer", importer);
        } else {
          var storedImporter = this.$store.getters["sharedFilters/importer"];
          if (storedImporter.ImporterGuid) this.$store.commit("sharedFilters/importer");
        }
      }

      if (this.selectedProject) {
        var project = _.find(this.projectsOfSelectedClient, function (p) {
          return p.ProjectGuid === _this7.selectedProject;
        });
        if (project) this.$store.commit("sharedFilters/project", project);
      } else {
        var storedProject = this.$store.getters["sharedFilters/project"];
        if (storedProject.ProjectGuid) this.$store.commit("sharedFilters/project");
      }
    },
    updateSelect2Data: function updateSelect2Data() {
      var _this8 = this;

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        var _loop = function _loop() {
          var filter = _step.value;

          if (filter.Type === "Country") filter.currentDynamicFilterValues = _this8.countryList;else if (filter.Type === "Status") filter.currentDynamicFilterValues = _this8.recruitingStatusList;else if (filter.Type === "LocationProperty") filter.currentDynamicFilterValues = _this8.locationPropertiesList;else if (filter.Type === "Scenario") {
            filter.currentDynamicFilterValues = _this8.scenariosOfSelectedWave;
            if (filter.Value) _.remove(filter.Value, function (selectedValue) {
              return _.findIndex(filter.currentDynamicFilterValues, function (val) {
                return val.ScenarioGuid === selectedValue;
              }) < 0;
            });
          }
        };

        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.dynamicFilters), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          _loop();
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.$forceUpdate();

      this.$nextTick(function () {
        for (var refName in _this8.$refs) {
          if (_this8.$refs[refName][0]) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this8.$refs[refName]), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var _component = _step2.value;

                if (_component.reinit) _component.reinit();
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          } else if (_this8.$refs[refName].reinit) _this8.$refs[refName].reinit();
        }
      });

      this.getCheckFilterResult();
    },
    updateSelect2Values: function updateSelect2Values() {
      for (var refName in this.$refs) {
        if (this.$refs[refName][0]) {
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.$refs[refName]), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var _component2 = _step3.value;

              if (_component2.updateValue) _component2.updateValue();
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }
        } else if (this.$refs[refName].updateValue) this.$refs[refName].updateValue();
      }
    },
    getTranslationFor: function getTranslationFor(text) {
      switch (text) {
        case "City":
          return this.lang.RCC011;
        case "Country":
          return this.lang.RCC012;
        case "PostalCode":
          return this.lang.RCC020;
        case "LocationProperty":
          return this.lang.RCC013;
        case "Scenario":
          return this.lang.RCC014;
        case "Status":
          return this.lang.RCC015;
        case "NOT_ASSIGNED":
          return this.lang.RCC016;
        case "ASSIGNED_WITH_ANSWER":
          return this.lang.RCC017;
        case "ASSIGNED_NO_ANSWER":
          return this.lang.RCC018;
      }
      return text;
    },
    clearCheckFilter: function clearCheckFilter() {
      if (!this.feature.isAudiTarget) this.selectedClient = "";else {
        this.selectedImporter = "";
        this.selectedProject = "";
      }
      this.dynamicFilters = [];
      this.resultCheckData = {};
    },
    addDynamicFilter: function addDynamicFilter() {
      this.dynamicFilters.push({
        Guid: uuidv4(),
        Type: ""
      });
    },
    removeDynamicFilter: function removeDynamicFilter(filter) {
      if (filter.Type === "Country") _.remove(this.dynamicFilters, function (f) {
        return f.Type === "City";
      });
      _.remove(this.dynamicFilters, function (f) {
        return f.Guid === filter.Guid;
      });
      this.getCheckFilterResult();
      this.$forceUpdate();
      this.updateSelect2Values();
    },
    isLastDynamicFilterEmpty: function isLastDynamicFilterEmpty() {
      if (this.dynamicFilters.length < 1) return false;
      return !this.dynamicFilters[this.dynamicFilters.length - 1].Type;
    },
    propertyAlreadyUsed: function propertyAlreadyUsed(guid) {
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.dynamicFilters), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var _filter = _step4.value;

          if (_filter.Value === guid) return true;
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return false;
    },
    isTypeEnabled: function isTypeEnabled(type, filter) {
      if (type === "LocationProperty") return true;
      // else if (
      //   type === "City" &&
      //   (!this.isCountryFilterDefined || filter.Type === "Country")
      // )
      //   return false;

      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.dynamicFilters), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var _filter2 = _step5.value;

          if (_filter2.Type === type) return false;
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      return true;
    },

    // setCitiesOfSelectedCountriesForCityFilter() {
    //   let cityFilter = _.find(this.dynamicFilters, f => f.Type === "City");
    //   if (!cityFilter) return;

    //   let cities = [];
    //   let countryFilter = _.find(
    //     this.dynamicFilters,
    //     f => f.Type === "Country"
    //   );
    //   if (countryFilter && countryFilter.Value) {
    //     countryFilter.Value.forEach(entry => {
    //       let cityList = _.find(this.cityLists, c => c.CountryCode === entry);
    //       if (cityList && cityList.Cities)
    //         cities = _.union(cities, cityList.Cities);
    //     });
    //     cities = _.sortBy(cities, [c => c.City.toLowerCase()]);
    //   }
    //   cityFilter.currentDynamicFilterValues = cities;
    //   cityFilter.secondLevelSelectVisible = false;

    //   this.$nextTick(() => {
    //     cityFilter.secondLevelSelectVisible = true;
    //     this.$forceUpdate();
    //   });
    // },
    dynamicFilterTypeChanged: function dynamicFilterTypeChanged(filter) {
      var _this9 = this;

      delete filter.Value;
      delete filter.ValuesValue;
      delete filter.currentDynamicFilterValues;
      delete filter.currentDynamicFilterValueValues;
      delete filter.secondLevelSelectVisible;
      delete filter.thirdLevelSelectVisible;

      // if (!this.isCountryFilterDefined)
      //   _.remove(this.dynamicFilters, f => f.Type === "City");

      if (filter.Type === "Country") {
        filter.currentDynamicFilterValues = this.countryList;
      } else if (filter.Type === "City" || filter.Type === "PostalCode") {
        // this.setCitiesOfSelectedCountriesForCityFilter();
        filter.currentDynamicFilterValues = [];
      } else if (filter.Type === "LocationProperty") {
        filter.currentDynamicFilterValues = this.locationPropertiesList;
      } else if (filter.Type === "Scenario") {
        filter.currentDynamicFilterValues = this.scenariosOfSelectedWave;
      } else if (filter.Type === "Status") {
        filter.currentDynamicFilterValues = this.recruitingStatusList;
      } else return;

      this.$nextTick(function () {
        filter.secondLevelSelectVisible = true;
        _this9.$forceUpdate();
      });
    },
    dynamicFilterValueChanged: function dynamicFilterValueChanged(filter) {
      var _this10 = this;

      // Forces select2 to rerender with new options
      delete filter.Subvalue;
      delete filter.thirdLevelSelectVisible;

      // if (filter.Type === "Country") {
      //   this.getCheckFilterResult();
      // let waitForRequest = false;
      // for (let cc of filter.Value) {
      //   if (_.findIndex(this.cityLists, ["CountryCode", cc]) < 0) {
      //     this.getCityList(cc);
      //     waitForRequest = true;
      //   }
      // }
      // if (!waitForRequest)
      // this.setCitiesOfSelectedCountriesForCityFilter();
      // } else
      if (_.indexOf(["Status", "City", "PostalCode", "Country"], filter.Type) > -1) {
        this.getCheckFilterResult();
      } else {
        this.$nextTick(function () {
          if (!filter.Value) return;
          var currVal = _.find(filter.currentDynamicFilterValues, function (val) {
            return val[filter.Type + "Guid"] === filter.Value;
          });
          if (currVal && currVal[filter.Type + "Values"] && currVal[filter.Type + "Values"].length > 0) {
            filter.currentDynamicFilterValueValues = currVal[filter.Type + "Values"];
            filter.thirdLevelSelectVisible = true;
            _this10.$forceUpdate();
          } else _this10.getCheckFilterResult();
        });
      }
    },
    collectFilterData: function collectFilterData() {
      var result = {
        ClientGuid: this.selectedClient,
        ProjectGuid: this.selectedProject,
        WaveGuid: this.selectedWave
      };
      if (this.selectedImporter) result.ImporterGuid = this.selectedImporter;

      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.dynamicFilters), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var _filter3 = _step6.value;

          if (!_filter3.Type || !_filter3.Value) continue;

          if (_filter3.Type === "Country") {
            if (!_filter3.Value || _filter3.Value.length < 1) continue;
            result.CountryCodes = _filter3.Value;
          } else if (_filter3.Type === "City") {
            if (!_filter3.Value || _filter3.Value.length < 1) continue;
            result.Cities = _filter3.Value;
          } else if (_filter3.Type === "PostalCode") {
            if (!_filter3.Value || _filter3.Value.length < 1) continue;
            result.PostalCodes = _filter3.Value;
          } else if (_filter3.Type === "LocationProperty") {
            if (!_filter3.Value || !_filter3.Subvalue || _filter3.Subvalue.length < 1) continue;
            if (!result.LocationProperties) result.LocationProperties = [];
            result.LocationProperties.push({
              LocationPropertyGuid: _filter3.Value,
              LocationPropertyValues: _filter3.Subvalue
            });
          } else if (_filter3.Type === "Scenario") {
            if (!_filter3.Value || _filter3.Value.length < 1) continue;
            result.ScenarioGuids = _filter3.Value;
          } else if (_filter3.Type === "Status") {
            if (!_filter3.Value || _filter3.Value.length < 1) continue;
            result.SurveyInstanceRecruitingStatus = _filter3.Value;
          }
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      this.$emit("filterUpdate", result);
    },
    getLocationProperties: function getLocationProperties() {
      this.$emit("requestLocationProperties", this.selectedClient);
    },
    getCheckFilterResult: function getCheckFilterResult() {
      var _this11 = this;

      if (this.$filterRestorePending || !this.selectedWave) return;
      this.collectFilterData();
      var query = "api/Recruiting/SurveyInstances";
      var postData = this.currentFilterObject;

      $.ajax({
        method: "POST",
        url: query,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(postData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          _this11.resultCheckData = data;
        },
        error: function error() {
          console.error("Error on POST in getCheckFilterResult()");
          _this11.globals.showErrorSnackbar(_this11.lang.RC0009);
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__globals__ = __webpack_require__(85);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



window.gmapsInfoWindowMarkerButtonClicked = function (type, guid) {
  var data = { type: type, guid: guid };
  __WEBPACK_IMPORTED_MODULE_0__globals__["a" /* default */].$emit("gmapsInfoWindowMarkerButtonClicked", data);
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "GoogleMaps",
  props: {
    currentFilterObject: {
      Type: Object,
      default: function _default() {
        return {};
      }
    },
    checkList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    shopperList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      geocoder: null,
      map: null,
      mapInitDone: false,
      searchString: "",
      currentMapRadius: 50,
      isMapRadiusVisible: false,
      location: "Deutschland",
      currentPosition: null,
      icons: {
        ASSIGNED_NO_ANSWER: { icon: "ylw-circle.png" },
        ASSIGNED_WITH_ANSWER: { icon: "orange-circle.png" },
        NOT_ASSIGNED: { icon: "grn-circle.png" },
        shopper: { icon: "blu-stars.png" }
      },
      mapOptions: {
        streetViewControl: false,
        fullscreenControl: false,
        mapTypeControl: false,
        zoomControl: true,
        scaleControl: true,
        rotateControl: false,
        disableDefaultUi: false,
        mapTypeId: "roadmap"
      },
      checkMarkers: [],
      shopperMarkers: [],
      currentMapCircle: null,
      selectedMarker: null,
      searchBox: null,
      lang: {
        RCM000: "Search",
        RCM001: "Radius in km",
        RCM002: "Switch radius visibility",
        RCM003: "Filter for this check",
        RCM004: "Filter for this shopper",
        RCM005: "Wave",
        RCM006: "Gender",
        RCM007: "Age",
        RCM008: "male",
        RCM009: "female",
        RCM010: "Shopper",
        RCM011: "Check assigned but not yet edited",
        RCM012: "Check assigned and edited",
        RCM013: "Check not assigned",
        RCM014: "Remove filter",
        RCM015: "Scenario",
        RCM016: "Vehicle",
        RCM017: "Target model",
        RCM018: "Approved shopper"
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    if (!window.google) {
      this.globals.$once("googleInitDone", function () {
        _this.initGoogleMap();
      });
    } else {
      this.initGoogleMap();
    }
  },

  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    },
    isMapRadiusVisible: function isMapRadiusVisible(newVal) {
      if (newVal) $(".btn-marker-info").removeClass("hidden");else {
        var button = $(".btn-marker-info");
        button.addClass("hidden");
        button.removeClass("btn-warning");
        button.html(this.lang.RCM003);
      }
    }
  },
  methods: {
    initGoogleMap: function initGoogleMap() {
      var _this2 = this;

      var currentPosition = { lat: 51, lng: 10.5 };

      var init = function init() {
        _this2.mapOptions.center = new google.maps.LatLng(currentPosition.lat, currentPosition.lng);
        _this2.mapOptions.zoom = 6;

        _this2.map = new google.maps.Map(document.getElementById("gmaps-container"), _this2.mapOptions);
        _this2.map.infowindow = new google.maps.InfoWindow();

        var input = document.getElementById("gmapsSearchInput");
        _this2.map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);
        var radiusInput = document.getElementById("gmapsRadiusInput");
        _this2.map.controls[google.maps.ControlPosition.TOP_RIGHT].push(radiusInput);

        _this2.searchBox = new google.maps.places.SearchBox(input);
        _this2.searchBox.addListener("places_changed", _this2.searchLocation);

        _this2.geocoder = new google.maps.Geocoder();

        google.maps.event.addListenerOnce(_this2.map, "tilesloaded", function () {
          _this2.mapInitDone = true;
        });
      };

      navigator.geolocation.getCurrentPosition(function (pos) {
        currentPosition = {
          lat: pos.coords.latitude,
          lng: pos.coords.longitude
        };
        init();
      }, function (error) {
        console.error(error);
        init();
      });

      this.globals.$off("gmapsInfoWindowMarkerButtonClicked");
      this.globals.$on("gmapsInfoWindowMarkerButtonClicked", function (data) {
        var button = $("#gmapsInfoWindowMarkerButton-" + data.guid);
        if (button) {
          if (_this2.currentFilterObject.RadiusSurveyInstanceGuid === data.guid) {
            button.removeClass("btn-warning");
            button.html(_this2.lang.RCM003);
            data.state = false;
          } else {
            button.addClass("btn-warning");
            button.html(_this2.lang.RCM014);
            data.state = true;
          }
        }
        _this2.$emit("markerInfoSelectButtonClicked", data);
      });
    },
    iconMarkerFactory: function iconMarkerFactory() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "NOT_ASSIGNED";
      var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { width: 50, height: 50 };

      var iconBaseUrl = "https://maps.google.com/mapfiles/kml/paddle/";
      var url = "" + iconBaseUrl + this.icons[type].icon;
      var scaledSize = size;
      return { url: url, scaledSize: scaledSize };
    },
    zoomToLocation: function zoomToLocation(formatted_address) {
      var _this3 = this;

      this.geocoder.geocode({ address: formatted_address }, function (results, status) {
        if (status !== "OK" || !results[0]) {
          throw new Error(status);
        }
        _this3.map.setCenter(results[0].geometry.location);
        _this3.map.fitBounds(results[0].geometry.viewport);
      });
    },
    searchLocation: function searchLocation() {
      var _this4 = this;

      var location = this.searchBox.getPlaces(); //TODO: does not work if location in searchbox was selected before
      if (location) this.zoomToLocation(location[0].formatted_address);else {
        if (!this.searchString) return;
        this.geocoder.geocode({ address: this.searchString }, function (results, status) {
          if (status !== "OK" || !results[0]) {
            throw new Error(status);
          }
          _this4.zoomToLocation(results[0].formatted_address);
        });
      }
    },
    currentMapRadiusChanged: function currentMapRadiusChanged() {
      if (this.currentMapRadius < 0) this.currentMapRadius = 0;else if (this.currentMapRadius > 9999) this.currentMapRadius = 9999;
      this.drawMarkerCircle(this.selectedMarker);
      this.emitRadiusData();
    },
    changeMapRadiusVisibility: function changeMapRadiusVisibility() {
      this.isMapRadiusVisible = !this.isMapRadiusVisible;
      this.drawMarkerCircle(this.selectedMarker);
      this.emitRadiusData();
    },
    emitRadiusData: function emitRadiusData() {
      var radiusData = {
        visible: this.isMapRadiusVisible,
        radius: this.currentMapRadius
      };
      this.$emit("mapRadiusChanged", radiusData);
    },
    showChecksOnMap: function showChecksOnMap() {
      var _this5 = this;

      this.clearCheckMarkers();

      this.checkList.forEach(function (check) {
        if (!check.Location) return;
        var location = {
          lng: check.Location.Longitude,
          lat: check.Location.Latitude
        };

        var infotext = "<div style=\"text-align: left;\">\n          <b>Check ID: " + check.SurveyInstanceId + "</b>\n          <br>\n          <br>" + check.LocationName + "\n          <br>\n          <br>" + check.LocationAddress + "\n          <br>" + check.LocationPostalCode + " " + check.LocationCity + "\n          <br>\n          <br>" + _this5.lang.RCM005 + ": " + check.WaveName + "\n          <br>" + _this5.lang.RCM015 + ": " + check.ScenarioName;

        if (check.ApprovedShopperName) infotext += "<br>\n          <br>" + _this5.lang.RCM018 + ":\n          <br>" + check.ApprovedShopperName;

        infotext += "<br><button class=\"btn btn-raised btn-success btn-marker-info hidden\" \n            id=\"gmapsInfoWindowMarkerButton-" + check.SurveyInstanceGuid + "\" \n            onclick=\"gmapsInfoWindowMarkerButtonClicked('check','" + check.SurveyInstanceGuid + "')\">" + _this5.lang.RCM003 + "</button>\n          </div>";

        var marker = new google.maps.Marker({
          position: location,
          map: _this5.map,
          icon: _this5.iconMarkerFactory(check.SurveyInstanceRecruitingStatus),
          infotext: infotext
        });
        marker.addListener("click", function () {
          _this5.showMarkerInfo(marker);
          _this5.drawMarkerCircle(marker);
          _this5.selectedMarker = marker;
          _this5.$nextTick(function () {
            var button = $("#gmapsInfoWindowMarkerButton-" + check.SurveyInstanceGuid);
            if (_this5.isMapRadiusVisible) button.removeClass("hidden");
            if (check.SurveyInstanceGuid === _this5.currentFilterObject.RadiusSurveyInstanceGuid) {
              button.addClass("btn-warning");
              button.html(_this5.lang.RCM014);
            }
          });
        });
        _this5.checkMarkers.push(marker);
      });
    },
    showShoppersOnMap: function showShoppersOnMap() {
      var _this6 = this;

      this.clearShopperMarkers();

      this.shopperList.forEach(function (shopper) {
        if (!shopper.Location) return;
        var location = {
          lng: shopper.Location.Longitude,
          lat: shopper.Location.Latitude
        };
        var infotext = "<div style=\"text-align: left;\">\n          <b>" + shopper.FirstName + " " + shopper.LastName + " (" + shopper.Username + ")</b>\n          <br>\n          <br>" + _this6.lang.RCM006 + ": " + (shopper.Gender === "F" ? _this6.lang.RCM009 : _this6.lang.RCM008) + "\n          <br>" + _this6.lang.RCM007 + ": " + shopper.Age + "\n          <br>Ort: " + shopper.City;

        if (shopper.AudiShopperInfos) for (var i = 0; i < shopper.AudiShopperInfos.length; i++) {
          infotext += "\n          <br>\n          <br><b>" + _this6.lang.RCM016 + " " + (i + 1) + "</b>: " + shopper.AudiShopperInfos[i].ShopperCar + "\n          <br>" + _this6.lang.RCM017 + ": " + shopper.AudiShopperInfos[i].CarModelName + " (" + shopper.AudiShopperInfos[i].CarMatch + ")\n          ";
        }

        infotext += "<br><button class=\"btn btn-raised btn-success btn-marker-info hidden\"\n            id=\"gmapsInfoWindowMarkerButton-" + shopper.ShopperGuid + "\"\n            onclick=\"gmapsInfoWindowMarkerButtonClicked('shopper','" + shopper.ShopperGuid + "')\">" + _this6.lang.RCM004 + "</button>\n        </div>";
        var marker = new google.maps.Marker({
          position: location,
          map: _this6.map,
          icon: _this6.iconMarkerFactory("shopper"),
          infotext: infotext
        });
        marker.addListener("click", function () {
          _this6.showMarkerInfo(marker);
          _this6.drawMarkerCircle(marker);
          _this6.selectedMarker = marker;
        });
        _this6.shopperMarkers.push(marker);
      });
    },
    showMarkerInfo: function showMarkerInfo(marker) {
      this.map.infowindow.setContent(marker.infotext);
      this.map.infowindow.open(this.map, marker);
    },
    drawMarkerCircle: function drawMarkerCircle(marker) {
      if (this.currentMapCircle) this.currentMapCircle.setMap(null); // Remove old circle
      if (!marker || !this.isMapRadiusVisible) return;

      this.currentMapCircle = new google.maps.Circle({
        map: this.map,
        radius: this.currentMapRadius * 1000,
        fillColor: "#990000"
      });
      this.currentMapCircle.bindTo("center", marker, "position");
    },
    clearCheckMarkers: function clearCheckMarkers() {
      this.checkMarkers.forEach(function (marker) {
        marker.setMap(null);
      });
      this.checkMarkers = [];
    },
    clearShopperMarkers: function clearShopperMarkers() {
      this.shopperMarkers.forEach(function (marker) {
        marker.setMap(null);
      });
      this.shopperMarkers = [];
      this.selectedMarker = null;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CheckFilter__ = __webpack_require__(1592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CheckFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CheckFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ShopperFilter__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ShopperFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ShopperFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GoogleMaps__ = __webpack_require__(1593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GoogleMaps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__GoogleMaps__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Recruiting",
  components: {
    CheckFilter: __WEBPACK_IMPORTED_MODULE_1__CheckFilter___default.a,
    ShopperFilter: __WEBPACK_IMPORTED_MODULE_2__ShopperFilter___default.a,
    GoogleMaps: __WEBPACK_IMPORTED_MODULE_3__GoogleMaps___default.a
  },
  data: function data() {
    return {
      currentFilterObject: {},
      checkFilterResults: {},
      shopperFilterResults: {},
      locationPropertiesList: [],
      countryList: [],
      lang: {
        RC000: "Show results on map",
        RC001: "Export",
        RC002: "Export failed",
        RC003: "Location property data request failed",
        RC004: "Clear filters"
      }
    };
  },

  computed: {
    isExportDisabled: function isExportDisabled() {
      if (!this.checkFilterResults.SurveyInstanceCount || !this.shopperFilterResults.ShopperCount || this.checkFilterResults.SurveyInstanceCount * this.shopperFilterResults.ShopperCount > 10000) return true;

      return false;
    }
  },
  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
      this.globals.getCountryList(this.convertCountryList);
    }
  },
  mounted: function mounted() {
    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this);
      this.globals.getCountryList(this.convertCountryList);
    }

    this.debouncedGetShopperFilterResults = _.debounce(this.$refs.shopperFilterRef.getShopperFilterResult, 600);
  },

  methods: {
    convertCountryList: function convertCountryList(data) {
      this.countryList = [];
      for (var country in data) {
        this.countryList.push({
          CountryCode: country,
          CountryName: data[country]
        });
      }
      this.$emit("CountryListReceived");
    },
    clearFilters: function clearFilters() {
      this.$refs.checkFilterRef.clearCheckFilter();
      this.$refs.shopperFilterRef.clearShopperFilter();
    },
    updateCheckFilter: function updateCheckFilter(data) {
      this.currentFilterObject.SurveyInstance = data;
    },
    updateShopperFilter: function updateShopperFilter(data) {
      this.currentFilterObject.Shopper = data;
    },
    updateMapRadius: function updateMapRadius(data) {
      if (!data.visible) {
        delete this.currentFilterObject.Radius;
        delete this.currentFilterObject.RadiusSurveyInstanceGuid;
        this.$refs.checkFilterRef.getCheckFilterResult();
      } else {
        this.currentFilterObject.Radius = data.radius * 1000;
      }

      if (this.debouncedGetShopperFilterResults) this.debouncedGetShopperFilterResults();
    },
    onCheckDataChanged: function onCheckDataChanged($event) {
      this.checkFilterResults = $event;

      if (typeof this.currentFilterObject.Radius === "number") this.$refs.shopperFilterRef.getShopperFilterResult();
    },
    onShopperDataChanged: function onShopperDataChanged($event) {
      this.shopperFilterResults = $event;
    },
    onCheckSelectionChanged: function onCheckSelectionChanged($event) {
      if (!$event) return;
      if (!$event.state || !$event.guid) delete this.currentFilterObject.RadiusSurveyInstanceGuid;else this.currentFilterObject.RadiusSurveyInstanceGuid = $event.guid;

      this.$refs.checkFilterRef.getCheckFilterResult();
    },
    exportResults: function exportResults() {
      var _this = this;

      var query = "api/Recruiting/Export";
      var postData = this.currentFilterObject;

      $.ajax({
        method: "POST",
        url: query,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(postData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          _this.globals.downloadFile(data[0].DownloadId);
        },
        error: function error() {
          console.error("Error on POST in exportResults()");
          _this.globals.showErrorSnackbar(_this.lang.RC002);
        }
      });
    },
    getLocationProperties: function getLocationProperties(client) {
      var _this2 = this;

      if (!client) {
        this.locationPropertiesList = [];
        return;
      }

      var query = "api/Recruiting/Data/LocationProperties/" + client;
      $.ajax({
        method: "GET",
        url: query,
        success: function success(data) {
          _this2.locationPropertiesList = data;
          _this2.$emit("LocationPropertiesReceived");
        },
        error: function error() {
          console.error("Error on GET in getLocationProperties()");
          _this2.globals.showErrorSnackbar(_this2.lang.RC003);
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tools_Select2__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Tools_Select2__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var uuidv4 = __webpack_require__(60);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ShopperFilter",
  components: {
    Select2: __WEBPACK_IMPORTED_MODULE_2__Tools_Select2___default.a
  },
  props: {
    currentFilterObject: {
      Type: Object,
      default: function _default() {
        return {};
      }
    },
    locationPropertiesList: {
      Type: Array,
      default: function _default() {
        return [];
      }
    },
    countryList: {
      Type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      notSameLocation: false,
      notWithLocationPropertyGuids: [],
      notWithinTimespanValue: 0,
      notWithinTimespan: "days",
      timespans: ["days", "weeks", "months", "years"],
      dynamicFilters: [],
      shopperPropertiesList: [],
      occupationalGroupList: [],
      isRecruitingFilter: false,
      filterTypes: ["Country", "City", "PostalCode", "Gender", "Age", "OccupationalGroup", "ShopperProperty"],
      resultShopperData: {},
      lang: {
        RCS000: "Shopper filter",
        RCS001: "Available Shoppers",
        RCS002: "Not same location for",
        RCS003: "Select only shoppers that did not visit the location of the check within a given time period",
        RCS004: "Not within location properties... (optional)",
        RCS005: "Select only shoppers that did not visit any location where the selected location properties have the same value as for the locations that the shopper already visited",
        RCS006: "Choose",
        RCS007: "Type of filter",
        RCS008: "Value",
        RCS009: "Select Value(s)",
        RCS010: "Add filter",
        RCS011: "Shopper property data request failed",
        RCS012: "Shopper data request failed",
        RCS013: "Shopper property",
        RCS014: "days",
        RCS015: "weeks",
        RCS016: "months",
        RCS017: "years",
        RCS018: "Please type in a value",
        RCS019: "male",
        RCS020: "female",
        RCS021: "divers",
        RCS022: "from",
        RCS023: "to",
        RCS024: "Country",
        RCS025: "City",
        RCS026: "Postal code",
        RCS027: "Gender",
        RCS028: "Age",
        RCS029: "Occupational group",
        RCS030: "The maximum count of shoppers that can be shown on the map is exceeded. If you want to see all results on the map, please define some more filters.",
        RCS031: "No answer"
      }
    };
  },

  computed: {
    shopperCountExceeded: function shopperCountExceeded() {
      if (!this.resultShopperData || _.isEmpty(this.resultShopperData) || !this.resultShopperData.Shoppers) return false;
      return this.resultShopperData.ShopperCount > this.resultShopperData.Shoppers.length;
    }
  },
  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      var _this = this;

      this.globals.getLanguageStrings(this, this.debouncedUpdateSelect2Data);
      this.globals.getOccupationalGroupList(function (data) {
        _this.occupationalGroupList = [];
        for (var guid in data) {
          _this.occupationalGroupList.push({
            OccupationalGroupGuid: guid,
            OccupationalGroupName: data[guid]
          });
        }
        _this.$emit("OccupationalGroupsReceived");
        _this.debouncedUpdateSelect2Data();
      });
    },
    resultShopperData: function resultShopperData(newData) {
      this.$emit("shopperDataChanged", newData);
    }
  },
  created: function created() {
    this.isRecruitingFilter = this.$route.name === "Recruiting";
    this.debouncedUpdateSelect2Data = _.debounce(this.updateSelect2Data, 500);
  },
  mounted: function mounted() {
    var _this2 = this;

    this.readComponentSettingsFromStore();

    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this, this.debouncedUpdateSelect2Data);
      this.globals.getOccupationalGroupList(function (data) {
        _this2.occupationalGroupList = [];
        for (var guid in data) {
          _this2.occupationalGroupList.push({
            OccupationalGroupGuid: guid,
            OccupationalGroupName: data[guid]
          });
        }
        _this2.$emit("OccupationalGroupsReceived");
      });
    }
    this.getShopperProperties();
    this.getShopperFilterResult();
  },
  destroyed: function destroyed() {
    this.writeComponentSettingsToStore();
  },

  methods: {
    readComponentSettingsFromStore: function readComponentSettingsFromStore() {
      var _this3 = this;

      if (!this.$store.getters["userSettings/rememberFilters"] || !this.isRecruitingFilter) return;

      this.$filterRestorePending = true;
      var restoreDone = function restoreDone() {
        _this3.$nextTick(function () {
          delete _this3.$filterRestorePending;
          _this3.debouncedUpdateSelect2Data();
        });
      };

      var restoreFilters = function restoreFilters() {
        _this3.$nextTick(function () {
          var storedData = _this3.$store.getters["localFilters/recruiting_shopperFilter"];
          if (storedData) {
            for (var key in storedData) {
              if (_.has(_this3, key)) _this3[key] = _.cloneDeep(storedData[key]);
            }
          }
          restoreDone();
        });
      };

      var eventsToWaitFor = ["ShopperPropertiesReceived"];

      if (this.countryList.length < 1) {
        eventsToWaitFor.push("CountryListReceived");
        this.$parent.$once("CountryListReceived", function () {
          return _this3.$emit("CountryListReceived");
        });
      }

      if (this.locationPropertiesList.length < 1) {
        eventsToWaitFor.push("LocationPropertiesReceived");
        this.$parent.$once("LocationPropertiesReceived", function () {
          return _this3.$emit("LocationPropertiesReceived");
        });
      }

      if (this.occupationalGroupList.length < 1) eventsToWaitFor.push("OccupationalGroupsReceived");

      this.globals.doAfterEvents(eventsToWaitFor, restoreFilters, this);
    },
    writeComponentSettingsToStore: function writeComponentSettingsToStore() {
      if (!this.$store.getters["userSettings/rememberFilters"] || !this.isRecruitingFilter) return;
      this.$store.commit("localFilters/recruiting_shopperFilter", {
        notSameLocation: this.notSameLocation,
        notWithLocationPropertyGuids: this.notWithLocationPropertyGuids,
        notWithinTimespanValue: this.notWithinTimespanValue,
        notWithinTimespan: this.notWithinTimespan,
        dynamicFilters: this.dynamicFilters
      });
    },
    updateSelect2Data: function updateSelect2Data() {
      var _this4 = this;

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.dynamicFilters), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var filter = _step.value;

          if (filter.Type === "Gender") filter.currentDynamicFilterValues = [{ GenderName: this.lang.RCS019, GenderCode: "M" }, { GenderName: this.lang.RCS020, GenderCode: "F" }, { GenderName: this.lang.RCS021, GenderCode: "D" }];else if (filter.Type === "Country") filter.currentDynamicFilterValues = this.countryList;else if (filter.Type === "OccupationalGroup") filter.currentDynamicFilterValues = this.occupationalGroupList;else if (filter.Type === "ShopperProperty") filter.currentDynamicFilterValues = this.shopperPropertiesList;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      _.remove(this.notWithLocationPropertyGuids, function (selectedValue) {
        return _.findIndex(_this4.locationPropertiesList, function (val) {
          return val.LocationPropertyGuid === selectedValue;
        }) < 0;
      });
      this.$forceUpdate();

      this.$nextTick(function () {
        for (var refName in _this4.$refs) {
          if (_this4.$refs[refName][0]) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this4.$refs[refName]), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var _component = _step2.value;

                if (_component.reinit) _component.reinit();
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          } else if (_this4.$refs[refName].reinit) _this4.$refs[refName].reinit();
        }
      });

      this.getShopperFilterResult();
    },
    updateSelect2Values: function updateSelect2Values() {
      for (var refName in this.$refs) {
        if (this.$refs[refName][0]) {
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.$refs[refName]), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var _component2 = _step3.value;

              if (_component2.updateValue) _component2.updateValue();
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }
        } else if (this.$refs[refName].updateValue) this.$refs[refName].updateValue();
      }
    },
    getTranslationFor: function getTranslationFor(text) {
      switch (text) {
        case "ShopperProperty":
          return this.lang.RCS013;
        case "Country":
          return this.lang.RCS024;
        case "City":
          return this.lang.RCS025;
        case "PostalCode":
          return this.lang.RCS026;
        case "Gender":
          return this.lang.RCS027;
        case "Age":
          return this.lang.RCS028;
        case "OccupationalGroup":
          return this.lang.RCS029;
        case "days":
          return this.lang.RCS014;
        case "weeks":
          return this.lang.RCS015;
        case "months":
          return this.lang.RCS016;
        case "years":
          return this.lang.RCS017;
      }
      return text;
    },
    clearShopperFilter: function clearShopperFilter() {
      this.notSameLocation = false;
      this.notWithLocationPropertyGuids = [];
      this.notWithinTimespanValue = 0;
      this.notWithinTimespan = "days";
      this.dynamicFilters = [];
      this.getShopperFilterResult();
    },
    validateTimespanValue: function validateTimespanValue() {
      if (this.notWithinTimespanValue < 0) this.notWithinTimespanValue = 0;else if (this.notWithinTimespanValue > 100000) this.notWithinTimespanValue = 100000;
      this.notWithinTimespanValue = Math.floor(this.notWithinTimespanValue);
    },
    addDynamicFilter: function addDynamicFilter() {
      this.dynamicFilters.push({
        Guid: uuidv4(),
        Type: ""
      });
    },
    removeDynamicFilter: function removeDynamicFilter(filter) {
      _.remove(this.dynamicFilters, function (f) {
        return f.Guid === filter.Guid;
      });
      this.getShopperFilterResult();
      this.$forceUpdate();
      this.updateSelect2Values();
    },
    isLastDynamicFilterEmpty: function isLastDynamicFilterEmpty() {
      if (this.dynamicFilters.length < 1) return false;
      return !this.dynamicFilters[this.dynamicFilters.length - 1].Type;
    },
    isTypeEnabled: function isTypeEnabled(type, filter) {
      if (type === "ShopperProperty") return true;

      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.dynamicFilters), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var _filter = _step4.value;

          if (_filter.Type === type) return false;
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return true;
    },
    propertyAlreadyUsed: function propertyAlreadyUsed(guid) {
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.dynamicFilters), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var filter = _step5.value;

          if (filter.Value === guid) return true;
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      return false;
    },
    dynamicFilterTypeChanged: function dynamicFilterTypeChanged(filter) {
      var _this5 = this;

      delete filter.Value;
      delete filter.ValuesValue;
      delete filter.currentDynamicFilterValues;
      delete filter.currentDynamicFilterValueValues;
      delete filter.secondLevelSelectVisible;
      delete filter.secondLevelRangeVisible;

      if (filter.Type === "Country") {
        filter.currentDynamicFilterValues = this.countryList;
        filter.secondLevelSelectVisible = true;
      } else if (filter.Type === "City" || filter.Type === "PostalCode") {
        filter.currentDynamicFilterValues = [];
      } else if (filter.Type === "Gender") {
        filter.currentDynamicFilterValues = [{ GenderName: this.lang.RCS019, GenderCode: "M" }, { GenderName: this.lang.RCS020, GenderCode: "F" }, { GenderName: this.lang.RCS021, GenderCode: "D" }];
      } else if (filter.Type === "OccupationalGroup") {
        filter.currentDynamicFilterValues = this.occupationalGroupList;
      } else if (filter.Type === "Age") {
        filter.secondLevelRangeVisible = true;
        filter.Value = {};
        return;
      } else if (filter.Type === "ShopperProperty") {
        filter.currentDynamicFilterValues = this.shopperPropertiesList;
      } else return;

      this.$nextTick(function () {
        filter.secondLevelSelectVisible = true;
        _this5.$forceUpdate();
      });
    },
    dynamicFilterValueChanged: function dynamicFilterValueChanged(filter) {
      var _this6 = this;

      // Forces select2 to rerender with new options
      delete filter.Subvalue;
      delete filter.thirdLevelInputVisible;

      if (filter.Type !== "ShopperProperty") {
        this.getShopperFilterResult();
        return;
      }

      this.$nextTick(function () {
        if (!filter.Value) return;
        var currVal = "";

        if (filter.Type === "ShopperProperty") {
          var _iteratorNormalCompletion6 = true;
          var _didIteratorError6 = false;
          var _iteratorError6 = undefined;

          try {
            for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(filter.currentDynamicFilterValues), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
              var topic = _step6.value;

              currVal = _.find(topic.ChildProperties, function (val) {
                return val[filter.Type + "Guid"] === filter.Value;
              });
              if (currVal) break;
            }
          } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion6 && _iterator6.return) {
                _iterator6.return();
              }
            } finally {
              if (_didIteratorError6) {
                throw _iteratorError6;
              }
            }
          }
        } else currVal = _.find(filter.currentDynamicFilterValues, function (val) {
          return val[filter.Type + "Guid"] === filter.Value;
        });

        if (currVal) {
          filter.thirdLevelInputType = currVal.PropertyType;
          if (currVal.PropertyType === "SingleSelect") filter.thirdLevelInputType = "MultiSelect";
          filter.thirdLevelInputVisible = true;

          if (filter.thirdLevelInputType === "Checkbox") {
            filter.Subvalue = true;
          }
          if ((filter.thirdLevelInputType === "MultiSelect" || filter.thirdLevelInputType === "SingleSelect") && currVal[filter.Type + "Values"] && currVal[filter.Type + "Values"].length > 0) {
            filter.currentDynamicFilterValueValues = currVal[filter.Type + "Values"];

            var _iteratorNormalCompletion7 = true;
            var _didIteratorError7 = false;
            var _iteratorError7 = undefined;

            try {
              for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(filter.currentDynamicFilterValueValues), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                var value = _step7.value;

                if (value.ListCustomValue) {
                  value.ListValueGuid = value.ListCustomValue;
                  value.ListValue = value.ListCustomValue;
                  delete value.ListCustomValue;
                }
              }
            } catch (err) {
              _didIteratorError7 = true;
              _iteratorError7 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion7 && _iterator7.return) {
                  _iterator7.return();
                }
              } finally {
                if (_didIteratorError7) {
                  throw _iteratorError7;
                }
              }
            }
          } else _this6.getShopperFilterResult();
          _this6.$forceUpdate();
        }
      });
    },
    collectFilterData: function collectFilterData() {
      var result = {};

      if (this.notSameLocation) {
        result.NotSameLocation = this.notSameLocation;
        result.NotWithinDays = this.notWithinTimespanValue;
        if (this.notWithinTimespan === "days") result.NotWithinDays *= 1;else if (this.notWithinTimespan === "weeks") result.NotWithinDays *= 7;else if (this.notWithinTimespan === "months") result.NotWithinDays *= 30;else if (this.notWithinTimespan === "years") result.NotWithinDays *= 365;

        if (this.notWithLocationPropertyGuids.length > 0) result.NotWithLocationPropertyGuids = this.notWithLocationPropertyGuids;
      }

      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.dynamicFilters), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var filter = _step8.value;

          if (!filter.Type || !filter.Value) continue;

          if (filter.Type === "Country") {
            if (!filter.Value || filter.Value.length < 1) continue;
            result.CountryCodes = filter.Value;
          } else if (filter.Type === "City") {
            if (!filter.Value || filter.Value.length < 1) continue;
            result.Cities = filter.Value;
          } else if (filter.Type === "PostalCode") {
            if (!filter.Value || filter.Value.length < 1) continue;
            result.PostalCodes = filter.Value;
          } else if (filter.Type === "Gender") {
            if (!filter.Value || filter.Value.length < 1) continue;
            result.Genders = filter.Value;
          } else if (filter.Type === "OccupationalGroup") {
            if (!filter.Value || filter.Value.length < 1) continue;
            result.OccupationalGroups = filter.Value;
          } else if (filter.Type === "Age") {
            if (!filter.Value || _.isEmpty(filter.Value)) continue;
            if (!filter.Value.From) delete filter.Value.From;
            if (!filter.Value.To) delete filter.Value.To;

            if (filter.Value.From < 0) filter.Value.From = 0;
            if (filter.Value.From > 100) filter.Value.From = 100;
            if (filter.Value.To < 0) filter.Value.To = 0;
            if (filter.Value.To > 100) filter.Value.To = 100;

            if (filter.Value.From && filter.Value.To && filter.Value.From > filter.Value.To) {
              ;

              var _ref = [filter.Value.To, filter.Value.From];
              filter.Value.From = _ref[0];
              filter.Value.To = _ref[1];
            }if (!_.isEmpty(filter.Value)) result.Age = filter.Value;
          } else if (filter.Type === "ShopperProperty") {
            if (!filter.Value || typeof filter.Subvalue === "undefined") continue;

            var filterObject = {
              ShopperPropertyGuid: filter.Value
            };

            if (filter.thirdLevelInputType === "MultiSelect") {
              if (filter.Subvalue.length < 1) continue;
              var guids = _.groupBy(filter.Subvalue, function (val) {
                return !!val.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i);
              });
              if (guids.true) filterObject.ListValueGuids = guids.true;
              if (guids.false) filterObject.ListCustomValues = guids.false;
            } else if (filter.thirdLevelInputType === "SingleSelect") {
              if (!!filter.Subvalue.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i)) filterObject.ListValueGuids = [filter.Subvalue];else filterObject.ListCustomValues = [filter.Subvalue];
            } else if (filter.thirdLevelInputType === "Checkbox") {
              filterObject.BitValue = filter.Subvalue;
            } else {
              // Text and Integer
              filterObject.TextValues = _.words(filter.Subvalue);
            }

            if (!result.ShopperProperties) result.ShopperProperties = [];
            result.ShopperProperties.push(filterObject);
          }
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      this.$emit("filterUpdate", result);
    },
    restoreFilterSettings: function restoreFilterSettings() {
      this.clearShopperFilter();
      var filterObject = this.currentFilterObject;
      if (_.isEmpty(filterObject)) return;

      this.notSameLocation = typeof filterObject.NotSameLocation === "boolean" ? filterObject.NotSameLocation : false;
      this.notWithLocationPropertyGuids = filterObject.NotWithLocationPropertyGuids || [];
      this.notWithinTimespanValue = filterObject.NotWithinDays || 0;
      if (this.notWithinTimespanValue && this.notWithinTimespanValue % 365 === 0) {
        this.notWithinTimespanValue /= 365;
        this.notWithinTimespan = "years";
      } else if (this.notWithinTimespanValue && this.notWithinTimespanValue % 30 === 0) {
        this.notWithinTimespanValue /= 30;
        this.notWithinTimespan = "months";
      } else if (this.notWithinTimespanValue && this.notWithinTimespanValue % 7 === 0) {
        this.notWithinTimespanValue /= 7;
        this.notWithinTimespan = "weeks";
      } else this.notWithinTimespan = "days";

      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.filterTypes), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          var type = _step9.value;

          var apiType = this.getApiPropertyNameForFilterType(type);
          if (filterObject[apiType]) {
            if (type === "ShopperProperty") {
              var _iteratorNormalCompletion10 = true;
              var _didIteratorError10 = false;
              var _iteratorError10 = undefined;

              try {
                for (var _iterator10 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(filterObject.ShopperProperties), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                  var prop = _step10.value;

                  var subvalue = prop.ListValueGuids || prop.ListCustomValues || prop.TextValues || prop.BitValue;

                  if (prop.ListValueGuids && prop.ListCustomValues) subvalue = _.concat(prop.ListValueGuids, prop.ListCustomValues);

                  this.createDynamicFilter(type, prop.ShopperPropertyGuid, subvalue);
                }
              } catch (err) {
                _didIteratorError10 = true;
                _iteratorError10 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion10 && _iterator10.return) {
                    _iterator10.return();
                  }
                } finally {
                  if (_didIteratorError10) {
                    throw _iteratorError10;
                  }
                }
              }
            } else {
              this.createDynamicFilter(type, filterObject[apiType]);
            }
          }
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9.return) {
            _iterator9.return();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }

      this.updateSelect2Values();
    },
    createDynamicFilter: function createDynamicFilter(type, value, subvalue) {
      var filter = {
        Guid: uuidv4(),
        Type: type
      };
      this.dynamicFilterTypeChanged(filter);
      filter.Value = value;
      this.dynamicFilterValueChanged(filter);
      this.$nextTick(function () {
        if (typeof subvalue !== "undefined") filter.Subvalue = subvalue;
      });
      this.dynamicFilters.push(filter);
    },
    getApiPropertyNameForFilterType: function getApiPropertyNameForFilterType(filterType) {
      switch (filterType) {
        case "Country":
          return "CountryCodes";
        case "City":
          return "Cities";
        case "PostalCode":
          return "PostalCodes";
        case "Gender":
          return "Genders";
        case "Age":
          return "Age";
        case "OccupationalGroup":
          return "OccupationalGroups";
        case "ShopperProperty":
          return "ShopperProperties";
        default:
          return "";
      }
    },
    getShopperProperties: function getShopperProperties() {
      var _this7 = this;

      var query = "api/Recruiting/Data/ShopperProperties";
      $.ajax({
        method: "GET",
        url: query,
        success: function success(data) {
          _this7.shopperPropertiesList = data;
          if (!data || _.isEmpty(data)) _this7.shopperPropertiesList = [];

          var _iteratorNormalCompletion11 = true;
          var _didIteratorError11 = false;
          var _iteratorError11 = undefined;

          try {
            for (var _iterator11 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this7.shopperPropertiesList), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
              var topic = _step11.value;

              topic.ShopperPropertyName = topic.Title;
              topic.ShopperPropertyType = topic.Type;
              delete topic.Title;
              delete topic.Type;

              if (topic.ChildProperties) {
                var _iteratorNormalCompletion12 = true;
                var _didIteratorError12 = false;
                var _iteratorError12 = undefined;

                try {
                  for (var _iterator12 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(topic.ChildProperties), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
                    var _property = _step12.value;

                    _property.ShopperPropertyName = _property.Title;
                    _property.ShopperPropertyType = _property.Type;
                    _property.ShopperPropertyValues = _property.AvailableValues;
                    delete _property.Title;
                    delete _property.Type;
                    delete _property.AvailableValues;
                  }
                } catch (err) {
                  _didIteratorError12 = true;
                  _iteratorError12 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion12 && _iterator12.return) {
                      _iterator12.return();
                    }
                  } finally {
                    if (_didIteratorError12) {
                      throw _iteratorError12;
                    }
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError11 = true;
            _iteratorError11 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion11 && _iterator11.return) {
                _iterator11.return();
              }
            } finally {
              if (_didIteratorError11) {
                throw _iteratorError11;
              }
            }
          }

          _this7.$emit("ShopperPropertiesReceived");
        },
        error: function error() {
          console.error("Error on GET in getShopperProperties()");
          _this7.globals.showErrorSnackbar(_this7.lang.RCS011);
        }
      });
    },
    getShopperFilterResult: function getShopperFilterResult() {
      var _this8 = this;

      if (!this.isRecruitingFilter || this.$filterRestorePending) return;
      this.collectFilterData();
      var query = "api/Recruiting/Shoppers";
      var postData = this.currentFilterObject;

      $.ajax({
        method: "POST",
        url: query,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(postData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          _this8.resultShopperData = data;
        },
        error: function error() {
          console.error("Error on POST in getShopperFilterResult()");
          _this8.globals.showErrorSnackbar(_this8.lang.RCS012);
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Tools_Select2__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Tools_Select2__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ApprovalWaveStatusModal",
  components: {
    Select2: __WEBPACK_IMPORTED_MODULE_3__Tools_Select2___default.a
  },
  data: function data() {
    return {
      selectedProject: "",
      selectedWave: "",
      statusData: {},
      projectsWaves: [],
      selectedApprovalStatus: null,
      lang: {
        AWS000: "Wave Status",
        AWS001: "Project",
        AWS002: "Wave",
        AWS003: "Please select a project...",
        AWS004: "Please select a wave...",
        AWS005: "Check Status",
        AWS006: "Total check count",
        AWS007: "In approval",
        AWS008: "In progress",
        AWS009: "In reporting",
        AWS010: "In time",
        AWS011: "Approvals",
        AWS012: "None",
        AWS013: "Open",
        AWS014: "Approved",
        AWS015: "Wave charactertistics",
        AWS016: "Gender",
        AWS017: "Male",
        AWS018: "Female",
        AWS019: "Age",
        AWS020: "Min",
        AWS021: "Max",
        AWS022: "Above 65",
        AWS023: "Distance",
        AWS024: "Reg. year shopper car",
        AWS025: "Model match",
        AWS026: "Downgrade",
        AWS027: "Match",
        AWS028: "Upgrade",
        AWS029: "Audi cars",
        AWS030: "Model",
        AWS031: "Target value",
        AWS032: "Current value",
        AWS033: "Competitor cars",
        AWS034: "Close",
        AWS035: "Wave status access failed",
        AWS036: "Please select a approval status..."
      }
    };
  },

  computed: {
    availableWaves: function availableWaves() {
      var _this = this;

      if (!this.projectsWaves[0]) return [];
      var project = _.find(this.projectsWaves, function (p) {
        return p.ProjectGuid === _this.selectedProject;
      });
      return project && project.Waves ? project.Waves : [];
    }
  },
  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    this.globals.getWaveList(function (data) {
      _this2.projectsWaves = data;
    });

    this.globals.$off("showApprovalWaveStatus");
    this.globals.$on("showApprovalWaveStatus", function (check) {
      if (check.ProjectGuid && check.WaveGuid) {
        _this2.selectedProject = check.ProjectGuid;
        _this2.selectedWave = check.WaveGuid;
        _this2.$refs.waveSelect.updateValue();
      }
      _this2.getWaveStatus();
      _this2.openModal();
    });
  },

  methods: {
    openModal: function openModal() {
      $("#approvalWaveStatusModal").modal("show");
    },
    closeModal: function closeModal() {
      $("#approvalWaveStatusModal").modal("hide");
    },
    getWaveStatus: function getWaveStatus() {
      var _this3 = this;

      if (!this.selectedWave) return;
      var query = "api/ProjectWaves/" + this.selectedWave + "/AgencyStatus";
      if (this.selectedApprovalStatus) query += "?ApprovalStatus=" + this.selectedApprovalStatus;else query += "?ApprovalStatus=all";

      $.ajax({
        method: "GET",
        url: query,
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this3.globals.showErrorSnackbar(data.Error);
            return;
          }
          if (data) _this3.statusData = data;
        },
        error: function error(_error) {
          console.error("Error on GET in getWaveStatus()");
          _this3.globals.showErrorSnackbar(_this3.lang.AWS035);
        }
      });
    },
    getGroupedCompetitorCars: function getGroupedCompetitorCars() {
      if (!this.statusData.CompetitorCarDistribution) {
        return [];
      }

      var carBrandMap = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a();
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.statusData.CompetitorCarDistribution), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var ccd = _step.value;

          if (!carBrandMap.has(ccd.CompetitorCarBrand)) {
            carBrandMap.set(ccd.CompetitorCarBrand, []);
          }
          carBrandMap.get(ccd.CompetitorCarBrand).push(ccd);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(carBrandMap);
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Tools_Select2__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Tools_Select2__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "CarModelManagement",
  components: { select2: __WEBPACK_IMPORTED_MODULE_2__components_Tools_Select2___default.a },
  props: {
    showModal: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      importerList: null,
      selectedImporter: null,
      newModel: "",
      newSegment: "",
      selectedSegments: [],
      segmentList: [],
      modelList: [],
      isModelEditing: false,
      isSegmentEditing: false,
      lang: {
        CMM000: "Car Models",
        CMM001: "Models",
        CMM002: "Segments",
        CMM003: "New model name",
        CMM004: "Segments",
        CMM005: "Add",
        CMM006: "Name",
        CMM007: "Segments",
        CMM008: "Actions",
        CMM009: "New segment name",
        CMM010: "Close",
        CMM011: "Car model already exists",
        CMM012: "Car model created",
        CMM013: "Car model creation failed",
        CMM014: "Car model updated",
        CMM015: "Car model update failed",
        CMM016: "Car model deleted",
        CMM017: "Car model deletion failed",
        CMM018: "Delete Car Model",
        CMM019: "Yes",
        CMM020: "No",
        CMM021: "Do you really want to delete the following car model?",
        CMM022: "Incomplete data",
        CMM023: "Segment already exists",
        CMM024: "Segment created",
        CMM025: "Segment creation failed",
        CMM026: "Segment updated",
        CMM027: "Segment update failed",
        CMM028: "Segment deleted",
        CMM029: "Segment deletion failed",
        CMM030: "Delete Segment",
        CMM031: "Do you really want to delete the following segment?",
        CMM032: "ATTENTION: Car models will also be deleted if they are not assigned to any other segment!",
        CMM033: "Please select a segment name",
        CMM034: "Importer"
      }
    };
  },

  watch: {
    showModal: function showModal(newValue) {
      newValue ? this.openModal() : this.closeModal();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    this.globals.getImporterList(function (data) {
      _this.importerList = data;
    });

    $("#carModelManagement").on("hidden.bs.modal", function (e) {
      _this.$emit("modalClosed");
    });
  },

  methods: {
    openModal: function openModal() {
      var _this2 = this;

      this.newModel = "";
      this.newSegment = "";
      this.isModelEditing = false;
      this.isSegmentEditing = false;
      this.globals.getCarSegmentList(function (data) {
        _this2.segmentList = data;
        if (data[0] && data[0].CarSegmentGuid) _this2.$nextTick(function () {
          _this2.selectedSegments = [data[0].CarSegmentGuid];
        });
      });
      this.globals.getCarModelList(function (data) {
        return _this2.modelList = data;
      });
      $("#carModelManagement").modal("show");
    },
    closeModal: function closeModal() {
      this.globals.carModelList = [];
      this.globals.carSegmentList = [];
      $("#carModelManagement").modal("hide");
    },
    getCarSegmentNameList: function getCarSegmentNameList(segments) {
      var _this3 = this;

      if (!segments || !segments[0] || !this.segmentList[0]) return "";
      var result = "";
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        var _loop = function _loop() {
          var seg = _step.value;

          var segmentObject = _.find(_this3.segmentList, function (s) {
            return s.CarSegmentGuid === seg.CarSegmentGuid;
          });
          if (segmentObject && segmentObject.CarSegmentName) {
            if (result.length > 0) result += ", ";
            result += segmentObject.CarSegmentName;
          }
        };

        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(segments), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          _loop();
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return result;
    },
    getCarSegmentsGuidList: function getCarSegmentsGuidList(model) {
      var result = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(model.CarSegments), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var segment = _step2.value;

          result.push(segment.CarSegmentGuid);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return result;
    },
    carSegmentsOfModelChanged: function carSegmentsOfModelChanged(model, e) {
      model.CarSegments = [];
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(e), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var guid = _step3.value;

          model.CarSegments.push({ CarSegmentGuid: guid });
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    },
    addNewModel: function addNewModel() {
      var _this4 = this;

      $("#inputNewCarModel").focus();
      if (!this.newModel || !this.selectedSegments[0] || this.isModelEditing) return;
      // if (
      //   _.findIndex(this.modelList, (i) => i.CarModelName === this.newModel) >
      //   -1
      // ) {
      //   this.globals.showErrorSnackbar(this.lang.CMM011);
      //   return;
      // }
      var postData = {
        CarModelName: this.newModel,
        CarSegments: [],
        ImporterGuid: this.selectedImporter
      };
      this.carSegmentsOfModelChanged(postData, this.selectedSegments);

      $.ajax({
        method: "POST",
        url: "api/CarModel",
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(postData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this4.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this4.modelList = data[0] ? data : [];
          _this4.globals.showSuccessSnackbar(_this4.lang.CMM012);
          _this4.newModel = "";
        },
        error: function error() {
          console.error("Error on POST in addNewModel()");
          _this4.globals.showErrorSnackbar(_this4.lang.CMM013);
        }
      });
    },
    updateModel: function updateModel(model) {
      var _this5 = this;

      $.ajax({
        method: "PUT",
        url: "api/CarModel/" + model.CarModelGuid,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(model),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this5.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this5.globals.showSuccessSnackbar(_this5.lang.CMM014);
        },
        error: function error() {
          console.error("Error on PUT in updateModel()");
          _this5.globals.showErrorSnackbar(_this5.lang.CMM015);
        }
      });
    },
    deleteModel: function deleteModel(model) {
      var _this6 = this;

      if (this.isModelEditing) return;

      this.globals.$off("DeleteCarModelYesConfirmation");
      this.globals.$on("DeleteCarModelYesConfirmation", function () {
        $.ajax({
          method: "DELETE",
          url: "api/CarModel/" + model.CarModelGuid,
          success: function success(data) {
            if (data.Error) {
              console.error(data.Error);
              _this6.globals.showErrorSnackbar(data.Error);
              return;
            }
            _.remove(_this6.modelList, function (i) {
              return i.CarModelGuid === model.CarModelGuid;
            });
            _this6.$forceUpdate();
            _this6.globals.showSuccessSnackbar(_this6.lang.CMM016);
          },
          error: function error() {
            console.error("Error on DELETE in deleteModel()");
            _this6.globals.showErrorSnackbar(_this6.lang.CMM017);
          }
        });
      });

      this.globals.$emit("openGlobalConfirmationDialog", {
        initiator: "DeleteCarModel",
        confirmationTitle: this.lang.CMM018,
        colorRed: true,
        yesButtonText: this.lang.CMM019,
        noButtonText: this.lang.CMM020,
        htmlText: "<p>" + this.lang.CMM021 + "</p>\n                  <p><b>" + model.CarModelName + "</b></p>"
      });
    },
    editModel: function editModel(e, model) {
      if (this.isModelEditing) return;
      model.editing = true;
      this.isModelEditing = true;
      model.prevCarModelName = model.CarModelName;
      model.prevCarSegments = model.CarSegments;
      var input = $(e.target).closest("tr").find("input");
      input.prop("readonly", "");
      input.focus();
    },
    saveModel: function saveModel(e, model) {
      var input = $(e.target).closest("tr").find("input");

      if (!model.CarModelName || !model.CarSegments || !model.CarSegments[0]) {
        this.globals.showErrorSnackbar(this.lang.CMM022);
        input.focus();
        return;
      }

      // let count = _.filter(
      //   this.modelList,
      //   (i) => i.CarModelName === model.CarModelName
      // ).length;
      // if (count > 1) {
      //   this.globals.showErrorSnackbar(this.lang.CMM011);
      //   input.focus();
      //   return;
      // }

      this.isModelEditing = false;
      delete model.editing;
      delete model.prevCarModelName;
      delete model.prevCarSegments;
      input.prop("readonly", "true");
      this.updateModel(model);
    },
    undoModelChanges: function undoModelChanges(e, model) {
      var input = $(e.target).closest("tr").find("input");
      input.prop("readonly", "true");
      this.isModelEditing = false;
      delete model.editing;
      model.CarModelName = model.prevCarModelName;
      delete model.prevCarModelName;
      model.CarSegments = model.prevCarSegments;
      delete model.prevCarSegments;
    },
    addNewSegment: function addNewSegment() {
      var _this7 = this;

      $("#inputNewSegment").focus();
      if (!this.newSegment || this.isSegmentEditing) return;
      if (_.findIndex(this.segmentList, function (i) {
        return i.CarSegmentName === _this7.newSegment;
      }) > -1) {
        this.globals.showErrorSnackbar(this.lang.CMM023);
        return;
      }
      var postData = {
        CarSegmentName: this.newSegment
      };
      $.ajax({
        method: "POST",
        url: "api/CarModel/CarSegment",
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(postData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this7.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this7.segmentList = data[0] ? data : [];
          _this7.globals.showSuccessSnackbar(_this7.lang.CMM024);
          _this7.newSegment = "";
        },
        error: function error() {
          console.error("Error on POST in addNewSegment()");
          _this7.globals.showErrorSnackbar(_this7.lang.CMM025);
        }
      });
    },
    updateSegment: function updateSegment(segment) {
      var _this8 = this;

      $.ajax({
        method: "PUT",
        url: "api/CarModel/CarSegment/" + segment.CarSegmentGuid,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(segment),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this8.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this8.globals.showSuccessSnackbar(_this8.lang.CMM026);
        },
        error: function error() {
          console.error("Error on PUT in updateSegment()");
          _this8.globals.showErrorSnackbar(_this8.lang.CMM027);
        }
      });
    },
    deleteSegment: function deleteSegment(segment) {
      var _this9 = this;

      if (this.isSegmentEditing) return;

      this.globals.$off("DeleteSegmentYesConfirmation");
      this.globals.$on("DeleteSegmentYesConfirmation", function () {
        $.ajax({
          method: "DELETE",
          url: "api/CarModel/CarSegment/" + segment.CarSegmentGuid,
          success: function success(data) {
            if (data.Error) {
              console.error(data.Error);
              _this9.globals.showErrorSnackbar(data.Error);
              return;
            }
            _.remove(_this9.segmentList, function (i) {
              return i.CarSegmentGuid === segment.CarSegmentGuid;
            });
            _.remove(_this9.modelList, function (i) {
              return i.CarSegments.length === 1 && i.CarSegments[0].CarSegmentGuid === segment.CarSegmentGuid;
            });
            _this9.$forceUpdate();
            _this9.globals.showSuccessSnackbar(_this9.lang.CMM028);
          },
          error: function error() {
            console.error("Error on DELETE in deleteSegment()");
            _this9.globals.showErrorSnackbar(_this9.lang.CMM029);
          }
        });
      });

      this.globals.$emit("openGlobalConfirmationDialog", {
        initiator: "DeleteSegment",
        confirmationTitle: this.lang.CMM030,
        colorRed: true,
        yesButtonText: this.lang.CMM019,
        noButtonText: this.lang.CMM020,
        htmlText: "<p>" + this.lang.CMM031 + "</p>\n                  <p><b>" + segment.CarSegmentName + "</b></p>\n                  <p>" + this.lang.CMM032 + "</p>"
      });
    },
    editSegment: function editSegment(e, segment) {
      if (this.isSegmentEditing) return;
      segment.editing = true;
      this.isSegmentEditing = true;
      segment.prevCarSegmentName = segment.CarSegmentName;
      var input = $(e.target).closest("tr").find("input");
      input.prop("readonly", "");
      input.focus();
    },
    saveSegment: function saveSegment(e, segment) {
      var input = $(e.target).closest("tr").find("input");

      if (!segment.CarSegmentName) {
        this.globals.showErrorSnackbar(this.lang.CMM033);
        input.focus();
        return;
      }

      var count = _.filter(this.segmentList, function (i) {
        return i.CarSegmentName === segment.CarSegmentName;
      }).length;
      if (count > 1) {
        this.globals.showErrorSnackbar(this.lang.CMM023);
        input.focus();
        return;
      }

      this.isSegmentEditing = false;
      delete segment.editing;
      delete segment.prevCarSegmentName;
      input.prop("readonly", "true");
      this.updateSegment(segment);
    },
    undoSegmentChanges: function undoSegmentChanges(e, segment) {
      var input = $(e.target).closest("tr").find("input");
      input.prop("readonly", "true");
      this.isSegmentEditing = false;
      delete segment.editing;
      segment.CarSegmentName = segment.prevCarSegmentName;
      delete segment.prevCarSegmentName;
    },
    updateModelImporterName: function updateModelImporterName(model) {
      var updated = false;
      this.importerList.forEach(function (e) {
        if (e.ImporterGuid == model.ImporterGuid) {
          model.ImporterName = e.ImporterName;
          updated = true;
        }
      });
      if (!updated) model.ImporterName = null;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "GoogleMaps",
  props: {
    currentFilterObject: {
      Type: Object,
      default: function _default() {
        return {};
      }
    },
    checkList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    proposalList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      geocoder: null,
      map: null,
      mapInitDone: false,
      location: "Deutschland",
      currentPosition: null,
      icons: {
        check: { icon: "blue_pin.png" },
        Open: { icon: "yellow_pin.png" },
        Approved: { icon: "green_pin.png" },
        Rejected: { icon: "red_pin.png" },
        Multiple: { icon: "rainbow_pin.png" }
      },
      mapOptions: {
        streetViewControl: false,
        fullscreenControl: false,
        mapTypeControl: false,
        zoomControl: true,
        maxZoom: 15,
        minZoom: 3,
        scaleControl: true,
        rotateControl: false,
        disableDefaultUi: false,
        mapTypeId: "roadmap",
        restriction: {
          latLngBounds: {
            north: 80,
            south: -80,
            east: 200,
            west: -200
          }
        }
      },
      checkMarkers: [],
      shopperMarkers: [],
      currentMapCircle: null,
      selectedMarker: null,
      searchBox: null,
      lang: {
        RCM000: "Search",
        RCM001: "Radius in km",
        RCM002: "Switch radius visibility",
        RCM003: "Filter for this check",
        RCM004: "Filter for this shopper",
        RCM005: "Wave",
        RCM006: "Gender",
        RCM007: "Age",
        RCM008: "male",
        RCM009: "female",
        RCM010: "Shopper",
        RCM011: "Check assigned but not yet edited",
        RCM012: "Check assigned and edited",
        RCM013: "Check not assigned",
        RCM014: "Remove filter",
        RCM015: "Scenario",
        RCM016: "Vehicle",
        RCM017: "Target model",
        RCM018: "Approved shopper",

        SAM005: "ShopperID",
        SAM009: "Distance",
        SAM012: "Segment",
        SAM022: "approved",
        SAM023: "open",
        SAM024: "rejected",

        A0032: "Approval",

        SAGM01: "Check",
        SAGM02: "Open approval",
        SAGM03: "Completed approval",
        SAGM04: "Rejected approval",
        SAGM05: "Multiple shoppers with <br>same Location",
        SAGM06: "completed"
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    if (!window.google) {
      this.globals.$once("googleInitDone", function () {
        _this.initGoogleMap();
      });
    } else {
      this.initGoogleMap();
    }
    setTimeout(function () {
      _this.showChecksOnMap();
      _this.showShoppersOnMap();
    }, 500);
  },

  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    },
    isMapRadiusVisible: function isMapRadiusVisible(newVal) {
      if (newVal) $(".btn-marker-info").removeClass("hidden");else {
        var button = $(".btn-marker-info");
        button.addClass("hidden");
        button.removeClass("btn-warning");
        button.html(this.lang.RCM003);
      }
    }
  },
  methods: {
    setMarkerOpacity: function setMarkerOpacity(surveyInstanceId) {
      this.checkMarkers.forEach(function (e) {
        if (surveyInstanceId == null) {
          e.setOpacity(1);
          return;
        } else if (e.SurveyInstanceId != surveyInstanceId) {
          e.setOpacity(0.5);
        } else {
          e.setOpacity(1);
        }
      });
      this.shopperMarkers.forEach(function (e) {
        if (surveyInstanceId == null) {
          e.setOpacity(1);
          return;
        } else if (e.SurveyInstanceId != surveyInstanceId) {
          e.setOpacity(0.5);
        } else {
          e.setOpacity(1);
        }

        if (e.SurveyInstanceIds) {
          var opacity = 0.5;
          if (e.SurveyInstanceIds.includes(surveyInstanceId)) {
            opacity = 1;
          }
          e.setOpacity(opacity);
        }
      });
    },
    setMarkerOpacityViaArray: function setMarkerOpacityViaArray(surveyInstanceIds) {
      this.checkMarkers.forEach(function (e) {
        if (surveyInstanceIds.includes(e.SurveyInstanceId)) {
          e.setOpacity(1);
        } else {
          e.setOpacity(0.5);
        }
      });
      this.shopperMarkers.forEach(function (e) {
        if (surveyInstanceIds.includes(e.SurveyInstanceId)) {
          e.setOpacity(1);
        } else {
          e.setOpacity(0.5);
        }
        if (e.SurveyInstanceIds) {
          var opacity = 0.5;
          e.SurveyInstanceIds.forEach(function (sid) {
            if (surveyInstanceIds.includes(sid)) {
              opacity = 1;
            }
          });
          e.setOpacity(opacity);
        }
      });
    },
    initGoogleMap: function initGoogleMap() {
      var _this2 = this;

      var currentPosition = { lat: 51, lng: 10.5 };

      var init = function init() {
        _this2.mapOptions.center = new google.maps.LatLng(currentPosition.lat, currentPosition.lng);
        _this2.mapOptions.zoom = 6;

        _this2.map = new google.maps.Map(document.getElementById("gmaps-container"), _this2.mapOptions);
        _this2.map.infowindow = new google.maps.InfoWindow();

        _this2.geocoder = new google.maps.Geocoder();

        google.maps.event.addListenerOnce(_this2.map, "tilesloaded", function () {
          _this2.mapInitDone = true;
        });
        _this2.map.addListener("click", function () {
          _this2.setMarkerOpacity(null);
        });
      };

      navigator.geolocation.getCurrentPosition(function (pos) {
        currentPosition = {
          lat: pos.coords.latitude,
          lng: pos.coords.longitude
        };
        init();
      }, function (error) {
        console.error(error);
        init();
      });
    },
    iconMarkerFactory: function iconMarkerFactory() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Open";
      var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { width: 24, height: 42 };

      var iconBaseUrl = "/static/pins/";
      var url = "" + iconBaseUrl + this.icons[type].icon;
      var scaledSize = size;
      return { url: url, scaledSize: scaledSize };
    },
    zoomToLocation: function zoomToLocation(formatted_address) {
      var _this3 = this;

      this.geocoder.geocode({ address: formatted_address }, function (results, status) {
        if (status !== "OK" || !results[0]) {
          throw new Error(status);
        }
        _this3.map.setCenter(results[0].geometry.location);
        _this3.map.fitBounds(results[0].geometry.viewport);
      });
    },
    showChecksOnMap: function showChecksOnMap() {
      var _this4 = this;

      this.clearCheckMarkers();

      this.checkList.forEach(function (check) {
        if (!check.Location) return;
        var location = {
          lng: check.Location.Longitude,
          lat: check.Location.Latitude
        };

        var infotext = "<div style=\"text-align: left;\">\n          <b>Check ID: " + check.SurveyInstanceId + "</b>\n          <br>\n          <br>" + check.LocationName + "\n          <br>\n          <br>" + check.LocationAddress + "\n          <br>\n          <br>" + _this4.lang.RCM005 + ": " + check.WaveName + "\n          <br>" + _this4.lang.RCM015 + ": " + check.ScenarioName;

        if (check.ApprovedShopperName) infotext += "<br>\n          <br>" + _this4.lang.RCM018 + ":\n          <br>" + check.ApprovedShopperName;

        infotext += "</div>";

        var customIcon = _this4.iconMarkerFactory("check");

        var marker = new google.maps.Marker({
          position: location,
          map: _this4.map,
          icon: customIcon,
          infotext: infotext
        });
        marker.addListener("click", function () {
          _this4.showMarkerInfo(marker);
          _this4.selectedMarker = marker;
          _this4.setMarkerOpacity(marker.SurveyInstanceId);
        });
        marker.SurveyInstanceId = check.SurveyInstanceId;
        _this4.checkMarkers.push(marker);
      });
    },
    showShoppersOnMap: function showShoppersOnMap() {
      var _this5 = this;

      this.clearShopperMarkers();

      this.proposalList.forEach(function (shopper) {
        if (!shopper.Location) return;
        var location = {
          lng: shopper.Location.Longitude,
          lat: shopper.Location.Latitude
        };
        var infotext = "<div style=\"text-align: left;\">\n          <b>" + shopper.DisplayName + "</b>\n          <br><b>Check ID: " + shopper.SurveyInstanceId + "</b>\n          <br>" + _this5.lang.SAM005 + ": " + shopper.ShopperId + "\n          <br>" + _this5.lang.RCM006 + ": " + shopper.Gender + "\n          <br>" + _this5.lang.SAM009 + ": " + shopper.Distance + " km\n          <br>\n          <br>" + _this5.lang.SAM012 + ": " + shopper.CarSegmentName + "\n          <br>" + _this5.lang.RCM016 + ": " + shopper.ShopperCar + "\n          <br>" + _this5.lang.RCM017 + ": " + shopper.CarModelName + " (" + shopper.CarMatch + ")\n          <br>" + _this5.lang.A0032 + " " + (shopper.MainEntityApprovalStatus ? shopper.MainEntityApprovalStatus == 'Rejected' ? _this5.lang.SAM024 : _this5.lang.SAGM06 : _this5.lang.SAM023) + "\n        ";

        infotext += "</div>";

        var marker = new google.maps.Marker({
          position: location,
          map: _this5.map,
          icon: _this5.iconMarkerFactory(shopper.MainEntityApprovalStatus),
          infotext: infotext
        });
        marker.addListener("click", function () {
          _this5.showMarkerInfo(marker);
          _this5.selectedMarker = marker;
          _this5.setMarkerOpacity(marker.SurveyInstanceId);
        });
        marker.SurveyInstanceId = shopper.SurveyInstanceId;
        _this5.shopperMarkers.push(marker);
      });

      this.combineMarkersWithSameLocation(this.shopperMarkers);
    },
    showMarkerInfo: function showMarkerInfo(marker) {
      this.map.infowindow.setContent(marker.infotext);
      this.map.infowindow.open(this.map, marker);
    },
    clearCheckMarkers: function clearCheckMarkers() {
      this.checkMarkers.forEach(function (marker) {
        marker.setMap(null);
      });
      this.checkMarkers = [];
    },
    clearShopperMarkers: function clearShopperMarkers() {
      this.shopperMarkers.forEach(function (marker) {
        marker.setMap(null);
      });
      this.shopperMarkers = [];
      this.selectedMarker = null;
    },
    combineMarkersWithSameLocation: function combineMarkersWithSameLocation(markerList) {
      var _this6 = this;

      var allDuplicates = [];
      var currentDuplicates = [];
      markerList.forEach(function (currentMarker) {
        if (allDuplicates.filter(function (d) {
          return d == currentMarker;
        }).length > 0) return;

        // find markers with same position
        currentDuplicates = [];
        markerList.forEach(function (shopperMarker) {
          if (currentMarker === shopperMarker) return;
          if (currentMarker.position.lat() == shopperMarker.position.lat() && currentMarker.position.lng() == shopperMarker.position.lng()) {
            currentDuplicates.push(shopperMarker);
            allDuplicates.push(shopperMarker);
            markerList.filter(function (sm) {
              sm != shopperMarker;
            });
          }
        });
        if (currentDuplicates.length > 0) {
          currentDuplicates.push(currentMarker);
          allDuplicates.push(currentMarker);

          var infotext = "";
          var surveyInstanceIds = [];
          currentDuplicates.forEach(function (element) {
            surveyInstanceIds.push(element.SurveyInstanceId);
            infotext += element.infotext;
            if (element == currentDuplicates[currentDuplicates.length - 1]) return;
            infotext += "<hr>";
          });
          var location = {
            lng: currentDuplicates[0].position.lng(),
            lat: currentDuplicates[0].position.lat()
          };
          // make new marker
          var marker = new google.maps.Marker({
            position: location,
            map: _this6.map,
            icon: _this6.iconMarkerFactory("Multiple"),
            infotext: infotext
          });
          marker.addListener("click", function () {
            _this6.showMarkerInfo(marker);
            _this6.selectedMarker = marker;
            _this6.setMarkerOpacityViaArray(marker.SurveyInstanceIds);
          });
          marker.SurveyInstanceIds = surveyInstanceIds;
          markerList.push(marker);

          // delete old markers
          currentDuplicates.forEach(function (element) {
            element.setMap(null);
          });
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ShopperProposalModal__ = __webpack_require__(1602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ShopperProposalModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ShopperProposalModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ShopperApprovalModal__ = __webpack_require__(1600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ShopperApprovalModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ShopperApprovalModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ShopperMultiApprovalModal__ = __webpack_require__(1601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ShopperMultiApprovalModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ShopperMultiApprovalModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ShopperApprovalMap__ = __webpack_require__(1599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ShopperApprovalMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ShopperApprovalMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CarModelManagement__ = __webpack_require__(1596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CarModelManagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__CarModelManagement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Tools_Dialogs_ConfirmationDialog__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Tools_Dialogs_ConfirmationDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Tools_Dialogs_ConfirmationDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ApprovalWaveStatusModal__ = __webpack_require__(1595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ApprovalWaveStatusModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ApprovalWaveStatusModal__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ShopperApproval",
  components: {
    ShopperProposalModal: __WEBPACK_IMPORTED_MODULE_1__ShopperProposalModal___default.a,
    ShopperApprovalModal: __WEBPACK_IMPORTED_MODULE_2__ShopperApprovalModal___default.a,
    ShopperMultiApprovalModal: __WEBPACK_IMPORTED_MODULE_3__ShopperMultiApprovalModal___default.a,
    ShopperApprovalMap: __WEBPACK_IMPORTED_MODULE_4__ShopperApprovalMap___default.a,
    CarModelManagement: __WEBPACK_IMPORTED_MODULE_5__CarModelManagement___default.a,
    ApprovalWaveStatusModal: __WEBPACK_IMPORTED_MODULE_7__ApprovalWaveStatusModal___default.a,
    ConfirmationDialog: __WEBPACK_IMPORTED_MODULE_6__Tools_Dialogs_ConfirmationDialog___default.a
  },
  data: function data() {
    return {
      pageSize: 20,
      selectedPage: 1,
      pageCount: 1,
      checkCount: 0,
      sortField: "UTCLastUpdatedAt",
      sortOrder: "desc", // Should be "asc" or "desc"
      selectedCheck: {},
      selectedCheckIds: [],
      lastSelectedCheck: null,
      showShopperProposalModal: false,
      showShopperApprovalModal: false,
      showShopperMultiApprovalModal: false,
      showCarModelManagement: false,
      showExportDialog: false,
      showMap: false,
      filterStrings: {
        Search: "",
        SurveyId: "",
        SurveyInstanceId: "",
        ImporterName: "",
        ProjectName: "",
        WaveName: "",
        ScenarioName: "",
        LocationStoreId: "",
        LocationName: "",
        LocationAddress: "",
        LocationCity: "",
        LocationCountry: "",
        DealerGroup: "",
        Brand: "",
        LastUpdatedAt: [],
        UTCLastUpdatedAt: [],
        ShopperId: "",
        DisplayName: "",
        Occupation: "",
        Gender: "",
        Distance: "",
        CarSegmentName: "",
        CarModelName: "",
        ShopperCar: "",
        CarMatch: "",
        ApprovedByLeadAgency: "",
        ApprovedByMainEntity: "",
        SurveyInstanceInfo: "",
        FeedPostCount: ""
      },
      lastUpdateAtFilterContent: "",
      fpFilterLastUpdateAt: null,
      approvalData: [],
      approvalDataForExport: [],
      lang: {
        SA0000: "Refresh",
        SA0001: "Proposals",
        SA0002: "Approvals",
        SA0003: "Car Models",
        SA0004: "Wave Status",
        SA0005: "Search...",
        SA0006: "Elements per page",
        SA0007: "First page",
        SA0008: "Last page",
        SA0009: "Total checks count",
        SA0010: "SID",
        SA0011: "CheckID",
        SA0012: "Importer",
        SA0013: "Wave",
        SA0014: "StoreID",
        SA0015: "Location",
        SA0016: "City",
        SA0017: "Country",
        SA0018: "Group",
        SA0019: "Brand",
        SA0020: "Updated",
        SA0021: "ShopperID",
        SA0022: "Name",
        SA0023: "Age",
        SA0024: "Gender",
        SA0025: "Distance",
        SA0026: "Profession",
        SA0027: "Model",
        SA0028: "Segment",
        SA0029: "Car",
        SA0030: "Match",
        SA0031: "Lead",
        SA0032: "Audi / Lead PLUS",
        SA0033: "Filter",
        SA0034: "any",
        SA0035: "Upgrade",
        SA0036: "Match",
        SA0037: "Downgrade",
        SA0038: "none",
        SA0039: "approved",
        SA0040: "open",
        SA0041: "rejected",
        SA0042: "Survey title",
        SA0043: "Project",
        SA0044: "Scenario",
        SA0045: "Audi car model distribution",
        SA0046: "Competitor car distribution",
        SA0047: "Approval data request failed",
        SA0048: "Export",
        SA0049: "Export Approval",
        SA0050: "Download",
        SA0051: "Cancel",
        SA0052: "Updated:",
        SA0053: "Status:",
        CM0073: "Check Info",
        SAM002: "Messages",
        SA0054: "with messages"
      }
    };
  },

  computed: {
    isSelectedCheckOnCurrentPage: function isSelectedCheckOnCurrentPage() {
      var _this = this;

      if (!this.selectedCheck.SurveyInstanceGuid) return false;
      return _.findIndex(this.approvalData, function (check) {
        return check.SurveyInstanceGuid === _this.selectedCheck.SurveyInstanceGuid;
      }) > -1;
    },
    selectedChecks: function selectedChecks() {
      var _this2 = this;

      return this.approvalData.filter(function (check) {
        var keep = false;
        _this2.selectedCheckIds.forEach(function (checkId) {
          if (checkId == check.SurveyInstanceId) keep = true;
        });
        return keep;
      });
    }
  },
  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this, this.setElementHeights);
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.readComponentSettingsFromStore();
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    var initUpdatedAtFilter = function initUpdatedAtFilter() {
      if (_this3.fpFilterLastUpdateAt) _this3.fpFilterLastUpdateAt.destroy();
      var fpConfig = _.cloneDeep(_this3.globals.flatpickrDateConfig);
      fpConfig.mode = "range";
      fpConfig.onChange = function (selectedDates, dateStr, instance) {
        if (selectedDates.length === 1) return;
        _this3.filterStrings.UTCLastUpdatedAt = [];
        if (selectedDates.length === 2) _this3.filterStrings.UTCLastUpdatedAt = [_this3.globals.getIsoDateFromIsoTimestamp(selectedDates[0]), _this3.globals.getIsoDateFromIsoTimestamp(selectedDates[1])];

        _this3.lastUpdateAtFilterContent = instance.altInput.value;
        _this3.getApprovalData();
      };
      _this3.fpFilterLastUpdateAt = flatpickr("#inputFilterLastUpdateAt", fpConfig);
      if (_this3.filterStrings.UTCLastUpdatedAt && _this3.filterStrings.UTCLastUpdatedAt.length === 2) {
        _this3.fpFilterLastUpdateAt.setDate(_this3.filterStrings.UTCLastUpdatedAt);
        _this3.lastUpdateAtFilterContent = _this3.fpFilterLastUpdateAt.altInput.value;
      }

      _this3.getApprovalData();
    };

    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this, this.setElementHeights);
      initUpdatedAtFilter();
    }
    this.globals.$off("languageUpdated");
    this.globals.$on("languageUpdated", initUpdatedAtFilter);

    $(window).on("resize", this.setElementHeights).resize();
  },
  destroyed: function destroyed() {
    $(window).off("resize", this.setElementHeights);
    this.writeComponentSettingsToStore();
    if (this.fpFilterLastUpdateAt) this.fpFilterLastUpdateAt.destroy();
  },

  methods: {
    exportApproval: function exportApproval() {
      var _this4 = this;

      // This is a workaround. A better solution would be to send the filters directly to the export function.
      this.getApprovalData(true, function () {
        var getString = "api/Approval/ShopperProposal/Export";

        getString = encodeURI(getString);

        var filterApproval = { Filter: _this4.filterStrings };

        $.ajax({
          method: "POST",
          url: getString,
          data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filterApproval),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            if (data.length > 0 && data[0].DownloadId) _this4.globals.downloadFile(data[0].DownloadId);
          },
          error: function error(data) {
            console.error("Error on POST in exportApprovals()");
            _this4.globals.showErrorSnackbar("Users export failed");
          }
        });
      });
    },
    setElementHeights: function setElementHeights() {
      var height = $(window).height();
      height -= $("#approval-top-panel").height() + $("#app-navbar").height() + $(".main-table > thead").height() + 47; // 47 pixel for the free space around the cards
      $(".main-table-scrollbar").css("max-height", height);
    },
    readComponentSettingsFromStore: function readComponentSettingsFromStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      var storedData = this.$store.getters["localFilters/shopperApproval"];
      if (storedData) {
        for (var key in storedData) {
          if (_.has(this, key)) this[key] = _.cloneDeep(storedData[key]);
        }
      }

      if (!this.$store.getters["userSettings/syncFilters"]) return;
      var storedImporter = this.$store.getters["sharedFilters/importer"];
      this.filterStrings.ImporterName = storedImporter.ImporterName || "";

      // let storedProject = this.$store.getters["sharedFilters/project"];
      // this.filterStrings.ProjectName = storedProject.ProjectName || "";
    },
    writeComponentSettingsToStore: function writeComponentSettingsToStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      this.$store.commit("localFilters/shopperApproval", {
        filterStrings: this.filterStrings,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        pageSize: this.pageSize
      });

      if (!this.$store.getters["userSettings/syncFilters"]) return;
      var storedImporter = this.$store.getters["sharedFilters/importer"];
      if (storedImporter.ImporterName !== this.filterStrings.ImporterName) {
        this.$store.commit("sharedFilters/importer", {
          ImporterName: this.filterStrings.ImporterName
        });
      }
      // let storedProject = this.$store.getters["sharedFilters/project"];
      // if (storedProject.ProjectName !== this.filterStrings.ProjectName) {
      //   this.$store.commit("sharedFilters/project", {
      //     ProjectName: this.filterStrings.ProjectName
      //   });
      // }
    },
    getApprovalData: function getApprovalData() {
      var _this5 = this;

      var all = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var callback = arguments[1];

      var query = "";
      if (all) query = "api/Approval/Get?page=" + this.selectedPage + "&sort_column=" + this.sortField + "&sort_order=" + this.sortOrder;else query = "api/Approval/Get?page_size=" + this.pageSize + "&page=" + this.selectedPage + "&sort_column=" + this.sortField + "&sort_order=" + this.sortOrder;

      var body = { Filter: {} };
      for (var key in this.filterStrings) {
        if (this.filterStrings[key].length > 0) body.Filter[key] = this.filterStrings[key];
      }

      $.ajax({
        method: "POST",
        url: query,
        data: _.isEmpty(body.Filter) ? "" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(body),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error || !data[0]) {
            _this5.globals.showErrorSnackbar(data.Error || "");
            data.Error && console.error(data.Error);
            return;
          }

          if (all) {
            _this5.approvalDataForExport = data[0].Approvals;
          } else {
            _this5.approvalData = data[0].Approvals;
            _this5.pageCount = data[0].Page_Count;
            _this5.checkCount = data[0].Count;

            var selected = _.find(_this5.approvalData, function (check) {
              return check.SurveyInstanceGuid === _this5.selectedCheck.SurveyInstanceGuid;
            });
            if (selected) _this5.selectedCheck = selected;
          }

          if (callback) callback();
        },
        error: function error(_error) {
          console.error("Error on POST in getApprovalData()");
          _this5.globals.showErrorSnackbar(_this5.lang.SA0047);
        }
      });
    },
    sortCheckData: function sortCheckData(field) {
      var _this6 = this;

      if (field === this.sortField) {
        this.sortOrder === "asc" ? this.sortOrder = "desc" : this.sortOrder = "asc";
      } else {
        this.sortField = field;
        this.sortOrder = "asc";
      }
      this.selectedPage = 1;
      this.getApprovalData(false);
      this.$nextTick(function () {
        _this6.setElementHeights();
      });
    },
    updatePaging: function updatePaging(pageNumber, pageSize) {
      this.selectedPage = pageNumber || 1;
      if (pageSize) this.pageSize = pageSize;
      this.getApprovalData(false);
    },
    getVisiblePages: function getVisiblePages() {
      if (this.pageCount <= 7) {
        return _.range(1, this.pageCount + 1, 1);
      } else if (this.pageCount > 7 && this.selectedPage <= 4) {
        return _.range(1, 7, 1);
      } else if (this.pageCount > 7 && this.selectedPage >= this.pageCount - 3) {
        return _.range(this.pageCount - 5, this.pageCount + 1, 1);
      } else {
        return _.range(this.selectedPage - 2, this.selectedPage + 3, 1);
      }
    },
    selectCheck: function selectCheck(checkId, e) {
      var _this7 = this;

      if (e.ctrlKey && !e.shiftKey && !this.globals.isLocalAgencyUser) {
        var idx = _.indexOf(this.selectedCheckIds, checkId);
        if (idx > -1) {
          _.remove(this.selectedCheckIds, function (id) {
            return id === checkId;
          });
        } else {
          this.selectedCheckIds.push(checkId);
        }
        this.lastSelectedCheck = checkId;
      } else if (!e.ctrlKey && e.shiftKey && !this.globals.isLocalAgencyUser) {
        document.getSelection().removeAllRanges();
        if (!this.lastSelectedCheck) return;

        var idx1 = _.findIndex(this.approvalData, function (c) {
          return c.SurveyInstanceId === _this7.lastSelectedCheck;
        });
        var idx2 = _.findIndex(this.approvalData, function (c) {
          return c.SurveyInstanceId === checkId;
        });

        if (idx1 > idx2) {
          var tmp = idx1;
          idx1 = idx2;
          idx2 = tmp;
        }

        for (var i = idx1; i <= idx2; i++) {
          if (!this.isCheckSelected(this.approvalData[i].SurveyInstanceId)) {
            this.selectedCheckIds.push(this.approvalData[i].SurveyInstanceId);
          }
        }
      } else {
        this.selectedCheckIds = [checkId];
        this.lastSelectedCheck = checkId;
      }
    },
    isCheckSelected: function isCheckSelected(checkId) {
      return _.indexOf(this.selectedCheckIds, checkId) > -1;
    },
    getNumberOfProposals: function getNumberOfProposals(surveyInstanceId) {
      var surveyInstance = this.approvalData.find(function (surveyInstance) {
        return surveyInstance.SurveyInstanceId === surveyInstanceId;
      });
      return surveyInstance.ShopperProposals.length;
    },
    toggleShopperApprovalModal: function toggleShopperApprovalModal() {
      var _this8 = this;

      if (this.selectedCheckIds.length == 1) this.showShopperApprovalModal = !this.showShopperApprovalModal;else if (this.selectedCheckIds.length > 1) {
        var checksWithMultipleProposalsCount = 0;

        var _loop = function _loop(index) {
          var checkId = _this8.selectedCheckIds[index];
          check = _this8.approvalData.find(function (e) {
            return e.SurveyInstanceId == checkId;
          });

          if (check.ShopperProposals.length != 1) {
            checksWithMultipleProposalsCount++;
            _this8.selectedCheckIds[index] = null;
          };
        };

        for (var index = 0; index < this.selectedCheckIds.length; index++) {
          var check;

          _loop(index);
        };
        if (this.selectedCheckIds.length == checksWithMultipleProposalsCount) return;
        this.showShopperMultiApprovalModal = !this.showShopperMultiApprovalModal;
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GoogleMaps__ = __webpack_require__(1597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GoogleMaps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__GoogleMaps__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ShopperApprovalMap",
  components: {
    GoogleMaps: __WEBPACK_IMPORTED_MODULE_0__GoogleMaps___default.a
  },
  props: {
    checkList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      lang: {}
    };
  },

  computed: {
    proposalList: function proposalList() {
      var res = [];
      this.checkList.forEach(function (check) {
        if (check.ShopperProposals) {
          check.ShopperProposals.forEach(function (proposal) {
            proposal.SurveyInstanceId = check.SurveyInstanceId;
            res.push(proposal);
          });
        }
      });
      return res;
    }
  },
  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  mounted: function mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    this.openModal();
  },

  methods: {
    openModal: function openModal() {
      $("#shopperApprovalMap").modal("show");
    },
    closeModal: function closeModal() {
      $("#shopperApprovalMap").modal("hide");
      this.$emit("close");
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray__);








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ShopperApprovalModal",
  props: {
    check: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      statusData: {},
      shopperPreviousVisits: [],
      shopperPreviousVisited: false,
      carSegmentList: [],
      carModelList: [],
      lang: {
        SAM000: "Shopper Approval",
        SAM001: "Shopper",
        SAM002: "Messages",
        SAM003: "Lead Approval",
        SAM004: "Audi / Lead PLUS Approval",
        SAM005: "ShopperID",
        SAM006: "Name",
        SAM007: "Age",
        SAM008: "Gender",
        SAM009: "Distance",
        SAM010: "Profession",
        SAM011: "Model",
        SAM012: "Segment",
        SAM013: "Car",
        SAM014: "Match",
        SAM015: "Downgrade",
        SAM016: "Match",
        SAM017: "Upgrade",
        SAM018: "Last update",
        SAM019: "Agency Channel",
        SAM020: "Audi / Lead agency PLUS Channel",
        SAM021: "Conversation",
        SAM022: "approved",
        SAM023: "open",
        SAM024: "rejected",
        SAM025: "Close",
        SAM026: "Approval updated",
        SAM027: "Approval update failed",
        SAM028: "Shopper already checked the same location in the past!",
        SAM029: "Error while getting shopper who previous visited",
        SAM030: "Competitor Model:",
        AWS026: "Downgrade",
        AWS027: "Match",
        AWS028: "Upgrade",
        AWS029: "Audi cars",
        AWS030: "Model",
        AWS031: "Target value",
        AWS032: "Current value",
        AWS033: "Competitor cars",

        SPM020: "Update shopper profile data"
      }
    };
  },

  computed: {
    anyShopperAlreadyApproved: function anyShopperAlreadyApproved() {
      if (!this.check.ShopperProposals) return false;
      return _.findIndex(this.check.ShopperProposals, function (proposal) {
        return proposal.MainEntityApprovalStatus === "Approved";
      }) > -1;
    },


    // #2135
    filteredCarModelList: function filteredCarModelList() {
      var _this = this;

      // filter importer specific car models
      var importerSpecificCarModelList = this.carModelList.filter(function (carModel) {
        return carModel.ImporterGuid === _this.check.ImporterGuid;
      });
      var filteredList = this.carModelList.filter(function (carModel) {
        var keepIt = true;
        importerSpecificCarModelList.forEach(function (element) {
          if (carModel.CarModelName === element.CarModelName) keepIt = false;
        });
        if (keepIt) return carModel;
      });

      // merge
      filteredList = [].concat(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(filteredList), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(importerSpecificCarModelList));

      // sort filteredList by CarModelName, ImporterName
      filteredList = filteredList.sort(function (a, b) {
        var nameA = a.CarModelName.toUpperCase();
        var nameB = b.CarModelName.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        var nameC = a.ImporterName ? a.ImporterName.toUpperCase() : "";
        var nameD = b.ImporterName ? b.ImporterName.toUpperCase() : "";
        if (nameC < nameD) {
          return -1;
        }
        if (nameC > nameD) {
          return 1;
        }

        // name and importer name must be equal
        return 0;
      });

      // remove duplicates
      // keep first of duplicates which has no importer
      var uniqueList = [];
      var isIncluded = false;
      filteredList.forEach(function (element) {
        isIncluded = false;
        uniqueList.forEach(function (uniqueElement) {
          if (uniqueElement.CarModelName === element.CarModelName) isIncluded = true;
        });
        if (!isIncluded) uniqueList.push(element);
      });
      return uniqueList;
    },
    userAgencyEqualsCheckAgency: function userAgencyEqualsCheckAgency() {
      if (this.check.LeadAgencyGuid) {
        if (this.globals.userAgencyGuid.toLowerCase() == this.check.LeadAgencyGuid.toLowerCase()) return true;
      }
      return false;
    }
  },
  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  created: function created() {
    var _this2 = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    this.globals.getCarSegmentList(function (data) {
      _this2.carSegmentList = data;
    });
    this.globals.getCarModelList(function (data) {
      _this2.carModelList = data;
    });
  },
  mounted: function mounted() {
    var _this3 = this;

    this.getWaveStatus();
    this.openModal();

    $("#shopperApprovalModal").on("hidden.bs.modal", function (e) {
      return _this3.$emit("modalClosed");
    });
  },

  methods: {
    updateShopperData: function updateShopperData(proposal) {
      var _this4 = this;

      var query = "/api/Approval/ShopperProposal/" + proposal.ShopperProposalGuid;

      $.ajax({
        method: "PATCH",
        url: query,
        dataType: "json",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this4.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this4.globals.showSuccessSnackbar(_this4.lang.SPM023);
          _this4.$emit("resetData");
        },
        error: function error(_error) {
          console.error("Error on PATCH in updateShopperData()", _error);
          _this4.globals.showErrorSnackbar(_this4.lang.SPM024);
        }
      });
    },
    carModelsOfSelectedSegment: function carModelsOfSelectedSegment(guid) {
      var _this5 = this;

      return _.filter(this.filteredCarModelList, function (model) {
        return _.findIndex(model.CarSegments, function (segment) {
          return segment.CarSegmentGuid === guid;
        }) > -1 && _.findIndex(_this5.check.CarModelDistribution, function (audiCars) {
          return audiCars.CarModelGuid === model.CarModelGuid;
        }) > -1;
      });
    },
    openModal: function openModal() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this6.init();

              case 2:
                $("#shopperApprovalModal").modal("show");

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this6);
      }))();
    },
    init: function init() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var i;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this7.getPreviousVisits();

              case 2:
                _this7.getLastFeedComments();
                _context2.next = 5;
                return _this7.globals.isWaveLeadAgencyPlus(_this7.check.WaveGuid);

              case 5:
                _this7.check.isWaveLeadAgencyPlus = _context2.sent;

                for (i = 0; i < _this7.check.ShopperProposals.length; i++) {
                  _this7.check.ShopperProposals[i].ShopperPreviousVisited = _this7.shopperAlreadyChecked(_this7.check.ShopperProposals[i].ShopperGuid);
                }
                _this7.$forceUpdate();

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this7);
      }))();
    },
    closeModal: function closeModal() {
      $("#shopperApprovalModal").modal("hide");
    },
    showFeed: function showFeed(proposal, type) {
      var _this8 = this;

      this.globals.$off("feedModalClosed");
      this.globals.$once("feedModalClosed", function (itemGuid, posts) {
        if (posts[0] && posts[0].Content) {
          if (type === "Audi") {
            proposal.LastCommentLeadAudi = posts[0].Content;
            proposal.LastCommentLeadAudiCreatedBy = posts[0].FeedPostCreatedBy.Username;
          } else {
            proposal.LastCommentLeadLocal = posts[0].Content;
            proposal.LastCommentLeadLocalCreatedBy = posts[0].FeedPostCreatedBy.Username;
          }
          _this8.$forceUpdate();
        }
      });

      var feedName = type === "Audi" ? "LeadAgencyAudi" : "LeadAgencyLocalAgency";
      this.globals.$emit("openFeedModal", {
        ItemGuid: proposal.ShopperProposalGuid,
        FeedType: "ShopperProposal",
        FeedName: feedName
      });
    },
    shopperAlreadyChecked: function shopperAlreadyChecked(shopperGuid) {
      if (shopperGuid && this.shopperPreviousVisits.length > 0) {
        for (var i = 0; i < this.shopperPreviousVisits.length; i++) {
          if (shopperGuid === this.shopperPreviousVisits[i].ShopperGuid) return true;
        }
        return false;
      } else {
        return false;
      }
    },
    getPreviousVisits: function getPreviousVisits() {
      var _this9 = this;

      var query = "/api/Shopper/PreviousVisits/" + this.check.SurveyInstanceId;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        $.ajax({
          methode: "GET",
          url: query,
          dataType: "json",
          success: function success(data) {
            _this9.shopperPreviousVisits = data;
            resolve(data);
          },
          error: function error(_error2) {
            console.error("Error on GET in getPreviousVisits()");
            _this9.globals.showErrorSnackbar(_this9.lang.SAM029);
            reject(_error2);
          }
        });
      });
    },
    getLastFeedComments: function getLastFeedComments() {
      var _this10 = this;

      var requestCount = this.check.ShopperProposals.length;
      if (this.globals.isLeadAgencyUser) requestCount *= 2;

      this.globals.$off("feedPostsReceived");
      this.globals.$on("feedPostsReceived", function (itemGuid, feedName, posts) {
        if (posts[0] && posts[0].Content) {
          var proposal = _.find(_this10.check.ShopperProposals, function (p) {
            return p.ShopperProposalGuid === itemGuid;
          });
          if (feedName === "LeadAgencyAudi") {
            proposal.LastCommentLeadAudi = posts[0].Content;
            proposal.LastCommentLeadAudiCreatedBy = posts[0].FeedPostCreatedBy.Username;
          } else if (feedName === "LeadAgencyLocalAgency") {
            proposal.LastCommentLeadLocal = posts[0].Content;
            proposal.LastCommentLeadLocalCreatedBy = posts[0].FeedPostCreatedBy.Username;
          }
        }

        if (--requestCount <= 0) {
          _this10.globals.$off("feedPostsReceived");
          _this10.$forceUpdate();
        }
      });

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.check.ShopperProposals), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var proposal = _step.value;

          if (this.globals.isLeadAgencyUser || this.globals.isAdminUser) this.globals.$emit("requestFeedPosts", {
            ItemGuid: proposal.ShopperProposalGuid,
            FeedType: "ShopperProposal",
            FeedName: "LeadAgencyLocalAgency"
          });
          this.globals.$emit("requestFeedPosts", {
            ItemGuid: proposal.ShopperProposalGuid,
            FeedType: "ShopperProposal",
            FeedName: "LeadAgencyAudi"
          });
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    updateApprovalState: function updateApprovalState(proposal, approvalSource) {
      var _this11 = this;

      //#1925 Fix for lead agency PLUS approvals
      //if (this.globals.isWaveLeadAgencyPlus(this.check.WaveGuid)) {
      // proposal.AgencyApprovalStatus = proposal.MainEntityApprovalStatus;
      //}
      var query = "api/Approval/ShopperApproval/" + proposal.ShopperProposalGuid;
      var body = {
        ShopperApprovalType: "Reset",
        ShopperApprovalSource: approvalSource
      };
      var approvalState = void 0;
      if (approvalSource === "leadAgency") {
        approvalState = proposal.AgencyApprovalStatus;
        //proposal.MainEntityApprovalStatus = proposal.AgencyApprovalStatus;
      } else {
        approvalState = proposal.MainEntityApprovalStatus;
        //Fix for lead agency plus wave
        if (!this.globals.isAudiUser && approvalState != "Rejected" && this.globals.isLeadAgencyUser && this.userAgencyEqualsCheckAgency) proposal.AgencyApprovalStatus = proposal.MainEntityApprovalStatus;
        ////Fix for Audi user maybe we need on else if for lead agency PLUS
        ////proposal.AgencyApprovalStatus = proposal.MainEntityApprovalStatus;
      }

      if (approvalState === "Approved") body.ShopperApprovalType = "Approve";else if (approvalState === "Rejected") body.ShopperApprovalType = "Reject";
      $.ajax({
        method: "POST",
        url: query,
        data: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(body),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            _this11.globals.showErrorSnackbar(data.Error);
            console.error(data.Error);
            _this11.$emit("resetData");
            return;
          }
          // if (
          //   this.globals.isAudiUser &&
          //   proposal.AgencyApprovalStatus != "Approved"
          // ) {
          //   proposal.AgencyApprovalStatus = proposal.MainEntityApprovalStatus;
          //   this.$emit("resetData");
          // }
          _this11.$emit("resetData");
          _this11.globals.showSuccessSnackbar(_this11.lang.SAM026);
          _this11.$forceUpdate();
        },
        error: function error(_error3) {
          console.error("Error on POST in updateApprovalState()");
          _this11.globals.showErrorSnackbar(_this11.lang.SAM027);
          _this11.$emit("resetData");
        }
      });
    },
    updateShopperProposalCarModelAndMatch: function updateShopperProposalCarModelAndMatch(proposal) {
      var _this12 = this;

      $.ajax({
        method: "GET",
        url: "api/Approval/UpdateShopperProposalCarModelAndMatch",
        data: {
          "shopper-proposal-guid": proposal.ShopperProposalGuid,
          "car-model-guid": proposal.CarModelGuid,
          "car-match": proposal.CarMatch,
          "competitor-car-model-guid": proposal.CompetitorCarModelGuid
        },
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            _this12.globals.showErrorSnackbar(data.Error);
            console.error(data.Error);
            return;
          }
          _this12.globals.showSuccessSnackbar("Approval updated.");
        },
        error: function error(_error4) {
          console.error("Error on POST in updateShopperProposalCarModelAndMatch()");
          _this12.globals.showErrorSnackbar(_error4);
        }
      });
    },
    getWaveStatus: function getWaveStatus() {
      var _this13 = this;

      if (!this.check.WaveGuid) return;
      var query = "api/ProjectWaves/" + this.check.WaveGuid + "/AgencyStatus?ApprovalStatus=all";

      $.ajax({
        method: "GET",
        url: query,
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this13.globals.showErrorSnackbar(data.Error);
            return;
          }
          if (data) _this13.statusData = data;
        },
        error: function error(_error5) {
          console.error("Error on GET in getWaveStatus()");
          _this13.globals.showErrorSnackbar(_this13.lang.AWS035);
        }
      });
    },
    getGroupedCompetitorCars: function getGroupedCompetitorCars() {
      if (!this.statusData.CompetitorCarDistribution) {
        return [];
      }

      var carBrandMap = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a();
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.statusData.CompetitorCarDistribution), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var ccd = _step2.value;

          if (ccd.CompetitorCarBrand !== this.check.Brand) continue;
          if (!carBrandMap.has(ccd.CompetitorCarBrand)) {
            carBrandMap.set(ccd.CompetitorCarBrand, []);
          }
          carBrandMap.get(ccd.CompetitorCarBrand).push(ccd);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(carBrandMap);
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ShopperMultiApprovalModal",
  props: {
    checks: {
      type: Array,
      default: []
    }
  },
  data: function data() {
    return {
      leadAgencyApproval: null,
      mainEntityApproval: null,
      lang: {
        SAM000: "Shopper Approval",
        SAM001: "Shopper",
        SAM002: "Messages",
        SAM003: "Lead Approval",
        SAM004: "Audi / Lead PLUS Approval",
        SAM005: "ShopperID",
        SAM006: "Name",
        SAM007: "Age",
        SAM008: "Gender",
        SAM009: "Distance",
        SAM010: "Profession",
        SAM011: "Model",
        SAM012: "Segment",
        SAM013: "Car",
        SAM014: "Match",
        SAM015: "Downgrade",
        SAM016: "Match",
        SAM017: "Upgrade",
        SAM018: "Last update",
        SAM019: "Agency Channel",
        SAM020: "Audi / Lead agency PLUS Channel",
        SAM021: "Conversation",
        SAM022: "approved",
        SAM023: "open",
        SAM024: "rejected",
        SAM025: "Close",
        SAM026: "Approval updated",
        SAM027: "Approval update failed",
        SAM028: "Shopper already checked the same location in the past!",
        SAM029: "Error while getting shopper who previous visited",
        SAM030: "Competitor Model:"
      }
    };
  },

  computed: {
    allChecksAreLeadAgencyPlus: function allChecksAreLeadAgencyPlus() {
      var res = true;
      this.checks.forEach(function (check) {
        if (!check.IsLeadAgencyPlus) {
          res = false;
          return;
        }
      });
      return res;
    },
    allChecksAreOfSameLeadAgency: function allChecksAreOfSameLeadAgency() {
      var res = true;
      var firstAgencyGuid = this.checks[0].LeadAgencyGuid;
      this.checks.forEach(function (check) {
        if (check.LeadAgencyGuid != firstAgencyGuid) {
          res = false;
          return;
        }
      });
      return res;
    },
    userAgencyEqualsCheckAgency: function userAgencyEqualsCheckAgency() {
      if (this.allChecksAreOfSameLeadAgency && this.checks[0].LeadAgencyGuid) {
        if (this.globals.userAgencyGuid.toLowerCase() == this.checks[0].LeadAgencyGuid.toLowerCase()) return true;
      }
      return false;
    },
    highestSurveyInstanceStatusId: function highestSurveyInstanceStatusId() {
      var res = this.checks[0].SurveyInstanceStatusId;
      this.checks.forEach(function (check) {
        if (check.SurveyInstanceStatusId > res) {
          res = check.SurveyInstanceStatusId;
        }
      });
      return res;
    },
    anyMainEntityApprovalStatusSet: function anyMainEntityApprovalStatusSet() {
      var res = this.checks[0].SurveyInstanceStatusId;
      this.checks.forEach(function (check) {
        if (check.SurveyInstanceStatusId > res) {
          res = check.SurveyInstanceStatusId;
        }
      });
      return res;
    }
  },
  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  created: function created() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
  },
  mounted: function mounted() {
    var _this = this;

    this.openModal();

    $("#shopperApprovalModal").on("hidden.bs.modal", function (e) {
      return _this.$emit("modalClosed");
    });
  },

  methods: {
    openModal: function openModal() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // await this.getPreviousVisits();
                // this.getLastFeedComments();
                // this.check.isWaveLeadAgencyPlus = await this.globals.isWaveLeadAgencyPlus(
                //   this.check.WaveGuid
                // );
                // for (var i = 0; i < this.check.ShopperProposals.length; i++) {
                //   this.check.ShopperProposals[i].ShopperPreviousVisited =
                //     this.shopperAlreadyChecked(
                //       this.check.ShopperProposals[i].ShopperGuid
                //     );
                // }
                // this.$forceUpdate();
                $("#shopperApprovalModal").modal("show");

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    closeModal: function closeModal() {
      $("#shopperApprovalModal").modal("hide");
    },
    updateApprovalState: function updateApprovalState(approvalSource) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, check, query, body, approvalState;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 3;
                _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this3.checks);

              case 5:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context2.next = 17;
                  break;
                }

                check = _step.value;
                query = "api/Approval/ShopperApproval/" + check.ShopperProposals[0].ShopperProposalGuid;
                body = {
                  ShopperApprovalType: "Reset",
                  ShopperApprovalSource: approvalSource
                };
                approvalState = void 0;

                if (approvalSource === "leadAgency") {
                  approvalState = _this3.leadAgencyApproval;
                  //proposal.MainEntityApprovalStatus = proposal.AgencyApprovalStatus;
                } else {
                  approvalState = _this3.mainEntityApproval;
                  //Fix for lead agency plus wave
                  if (!_this3.globals.isAudiUser && check.isWaveLeadAgencyPlus && approvalState != "Rejected") {
                    check.ShopperProposals[0].AgencyApprovalStatus = check.ShopperProposals[0].MainEntityApprovalStatus;
                  }
                  ////Fix for Audi user maybe we need on else if for lead agency PLUS
                  ////proposal.AgencyApprovalStatus = proposal.MainEntityApprovalStatus;
                }

                if (approvalState === "Approved") body.ShopperApprovalType = "Approve";else if (approvalState === "Rejected") body.ShopperApprovalType = "Reject";
                _context2.next = 14;
                return $.ajax({
                  method: "POST",
                  url: query,
                  data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(body),
                  dataType: "json",
                  contentType: "application/json; charset=utf-8",
                  success: function success(data) {
                    if (data.Error) {
                      _this3.globals.showErrorSnackbar(data.Error);
                      console.error(data.Error);
                      _this3.$emit("resetData");
                      return;
                    }
                    // if (
                    //   this.globals.isAudiUser &&
                    //   proposal.AgencyApprovalStatus != "Approved"
                    // ) {
                    //   proposal.AgencyApprovalStatus = proposal.MainEntityApprovalStatus;
                    //   this.$emit("resetData");
                    // }
                    _this3.$emit("resetData");
                    _this3.globals.showSuccessSnackbar(_this3.lang.SAM026);
                    _this3.$forceUpdate();
                  },
                  error: function error(_error) {
                    console.error("Error on POST in updateApprovalState()");
                    _this3.globals.showErrorSnackbar(_this3.lang.SAM027);
                    _this3.$emit("resetData");
                  }
                });

              case 14:
                _iteratorNormalCompletion = true;
                _context2.next = 5;
                break;

              case 17:
                _context2.next = 23;
                break;

              case 19:
                _context2.prev = 19;
                _context2.t0 = _context2["catch"](3);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 23:
                _context2.prev = 23;
                _context2.prev = 24;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 26:
                _context2.prev = 26;

                if (!_didIteratorError) {
                  _context2.next = 29;
                  break;
                }

                throw _iteratorError;

              case 29:
                return _context2.finish(26);

              case 30:
                return _context2.finish(23);

              case 31:
                ;

              case 32:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[3, 19, 23, 31], [24,, 26, 30]]);
      }))();
    },
    updateShopperProposalCarModelAndMatch: function updateShopperProposalCarModelAndMatch(proposal) {
      var _this4 = this;

      $.ajax({
        method: "GET",
        url: "api/Approval/UpdateShopperProposalCarModelAndMatch",
        data: {
          "shopper-proposal-guid": proposal.ShopperProposalGuid,
          "car-model-guid": proposal.CarModelGuid,
          "car-match": proposal.CarMatch,
          "competitor-car-model-guid": proposal.CompetitorCarModelGuid
        },
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            _this4.globals.showErrorSnackbar(data.Error);
            console.error(data.Error);
            return;
          }
          _this4.globals.showSuccessSnackbar("Approval updated.");
        },
        error: function error(_error2) {
          console.error("Error on POST in updateShopperProposalCarModelAndMatch()");
          _this4.globals.showErrorSnackbar(_error2);
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Tools_Select2__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Tools_Select2__);








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ShopperProposalModal",
  components: {
    Select2: __WEBPACK_IMPORTED_MODULE_8__Tools_Select2___default.a
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    check: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      shoppers: [],
      statusData: {},
      selectedShopper: "",
      selectedCarSegment: "",
      selectedCarModel: "",
      selectedCompetitorCar: "",
      selectedCarMatch: "=",
      selectedShopperCar: "",
      shopperPreviousVisits: [],
      shopperPreviousVisited: false,
      carSegmentList: [],
      carModelList: [],
      shopperCars: [],
      lang: {
        SPM000: "Shopper Proposal",
        SPM001: "Car segment / model",
        SPM002: "Please select a segment...",
        SPM003: "Please select an audi car model...",
        SPM004: "Competitor car model",
        SPM005: "...or a competitor car...",
        SPM006: "Shopper",
        SPM007: "Please select a shopper...",
        SPM008: "Shopper car / Match",
        SPM009: "Please select a shopper car...",
        SPM010: "Upgrade",
        SPM011: "Match",
        SPM012: "Downgrade",
        SPM013: "Name",
        SPM014: "Model",
        SPM015: "Segment",
        SPM016: "Car",
        SPM017: "Match",
        SPM018: "Actions",
        SPM019: "Open conversation",
        SPM020: "Update shopper profile data",
        SPM021: "Delete proposal",
        SPM022: "Close",
        SPM023: "Shopper profile data updated",
        SPM024: "Shopper profile data update failed",
        SPM025: "Shopper proposal added",
        SPM026: "Shopper proposal failed",
        SPM027: "Shopper proposal deleted",
        SPM028: "Shopper proposal deletion failed",
        SPM029: "Delete Shopper Proposal",
        SPM030: "Yes",
        SPM031: "No",
        SPM032: "Do you really want to delete the following shopper proposal?",
        SPM033: "Shopper car access failed",
        SPM034: "Shopper already checked the same location in the past!",
        SPM035: "Error while getting shopper who previous visited",
        AWS026: "Downgrade",
        AWS027: "Match",
        AWS028: "Upgrade",
        AWS029: "Audi cars",
        AWS030: "Model",
        AWS031: "Target value",
        AWS032: "Current value",
        AWS033: "Competitor cars"
      }
    };
  },

  computed: {
    unproposedShoppers: function unproposedShoppers() {
      var _this = this;

      if (!this.check.ShopperProposals) return this.shoppers;
      return _.filter(this.shoppers, function (shopper) {
        return _.findIndex(_this.check.ShopperProposals, function (proposal) {
          return proposal.ShopperGuid === shopper.ShopperGuid;
        }) < 0;
      });
    },
    anyShopperAlreadyApproved: function anyShopperAlreadyApproved() {
      if (!this.check.ShopperProposals) return false;
      return _.findIndex(this.check.ShopperProposals, function (proposal) {
        return proposal.MainEntityApprovalStatus === "Approved";
      }) > -1;
    },
    carModelsOfSelectedSegment: function carModelsOfSelectedSegment() {
      var _this2 = this;

      return _.filter(this.filteredCarModelList, function (model) {
        return _.findIndex(model.CarSegments, function (segment) {
          return segment.CarSegmentGuid === _this2.selectedCarSegment;
        }) > -1 && _.findIndex(_this2.check.CarModelDistribution, function (audiCars) {
          return audiCars.CarModelGuid === model.CarModelGuid;
        }) > -1;
      });
    },


    // #2135
    filteredCarModelList: function filteredCarModelList() {
      var _this3 = this;

      // filter importer specific car models
      var importerSpecificCarModelList = this.carModelList.filter(function (carModel) {
        return carModel.ImporterGuid === _this3.check.ImporterGuid;
      });
      var filteredList = this.carModelList.filter(function (carModel) {
        var keepIt = true;
        importerSpecificCarModelList.forEach(function (element) {
          if (carModel.CarModelName === element.CarModelName) keepIt = false;
        });
        if (keepIt) return carModel;
      });

      // merge
      filteredList = [].concat(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(filteredList), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(importerSpecificCarModelList));

      // sort filteredList by CarModelName, ImporterName
      filteredList = filteredList.sort(function (a, b) {
        var nameA = a.CarModelName.toUpperCase();
        var nameB = b.CarModelName.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        var nameC = a.ImporterName ? a.ImporterName.toUpperCase() : "";
        var nameD = b.ImporterName ? b.ImporterName.toUpperCase() : "";
        if (nameC < nameD) {
          return -1;
        }
        if (nameC > nameD) {
          return 1;
        }

        // name and importer name must be equal
        return 0;
      });

      // remove duplicates
      // keep first of duplicates which has no importer
      var uniqueList = [];
      var isIncluded = false;
      filteredList.forEach(function (element) {
        isIncluded = false;
        uniqueList.forEach(function (uniqueElement) {
          if (uniqueElement.CarModelName === element.CarModelName) isIncluded = true;
        });
        if (!isIncluded) uniqueList.push(element);
      });

      return uniqueList;
    }
  },
  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    },
    showModal: function showModal(newVal) {
      newVal ? this.openModal() : this.closeModal();
    }
  },
  created: function created() {
    var _this4 = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    this.globals.getShopperList(function (data) {
      _this4.shoppers = [];
      for (var guid in data) {
        _this4.shoppers.push({
          ShopperGuid: guid,
          ShopperName: data[guid]
        });
      }
    });

    this.globals.getCarSegmentList(function (data) {
      _this4.carSegmentList = data;
    });
    this.globals.getCarModelList(function (data) {
      _this4.carModelList = data;
    });
  },
  mounted: function mounted() {
    var _this5 = this;

    this.getWaveStatus();
    this.openModal();

    $("#shopperProposalModal").on("hidden.bs.modal", function (e) {
      return _this5.$emit("modalClosed");
    });
  },

  methods: {
    openModal: function openModal() {
      this.selectedShopper = "";
      this.selectedShopperCar = "";
      this.selectedCarMatch = "=";
      this.shopperPreviousVisited = false;
      $("#shopperProposalModal").modal("show");
    },
    closeModal: function closeModal() {
      $("#shopperProposalModal").modal("hide");
    },
    showFeed: function showFeed(proposal) {
      this.globals.$emit("openFeedModal", {
        ItemGuid: proposal.ShopperProposalGuid,
        FeedType: "ShopperProposal",
        FeedName: "LeadAgencyLocalAgency"
      });
    },
    shopperAlreadyChecked: function shopperAlreadyChecked() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee() {
        var shopperPreviousVisits, i;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this6.getPreviousVisits();

              case 2:
                shopperPreviousVisits = _context.sent;

                if (!(_this6.selectedShopper && shopperPreviousVisits.length > 0)) {
                  _context.next = 16;
                  break;
                }

                i = 0;

              case 5:
                if (!(i < shopperPreviousVisits.length)) {
                  _context.next = 12;
                  break;
                }

                if (!(shopperPreviousVisits[i].ShopperGuid == _this6.selectedShopper)) {
                  _context.next = 9;
                  break;
                }

                _this6.shopperPreviousVisited = true;
                return _context.abrupt("return", true);

              case 9:
                i++;
                _context.next = 5;
                break;

              case 12:
                _this6.shopperPreviousVisited = false;
                return _context.abrupt("return", false);

              case 16:
                _this6.shopperPreviousVisited = false;
                return _context.abrupt("return", false);

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this6);
      }))();
    },
    getPreviousVisits: function getPreviousVisits() {
      var _this7 = this;

      var query = "/api/Shopper/PreviousVisits/" + this.check.SurveyInstanceId;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        $.ajax({
          methode: "GET",
          url: query,
          dataType: "json",
          success: function success(data) {
            _this7.shopperPreviousVisits = data;
            resolve(data);
          },
          error: function error(_error) {
            console.error("Error on GET in getPreviousVisits()");
            _this7.globals.showErrorSnackbar(_this7.lang.SPM035);
            reject(_error);
          }
        });
      });
    },
    updateShopperData: function updateShopperData(proposal) {
      var _this8 = this;

      var query = "/api/Approval/ShopperProposal/" + proposal.ShopperProposalGuid;

      $.ajax({
        method: "PATCH",
        url: query,
        dataType: "json",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this8.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this8.globals.showSuccessSnackbar(_this8.lang.SPM023);
          _this8.$emit("dataUpdated");
        },
        error: function error(_error2) {
          console.error("Error on PATCH in updateShopperData()");
          _this8.globals.showErrorSnackbar(_this8.lang.SPM024);
        }
      });
    },
    addShopper: function addShopper() {
      var _this9 = this;

      var sendData = {
        SurveyInstanceGuid: this.check.SurveyInstanceGuid,
        ShopperGuid: this.selectedShopper,
        CarSegmentGuid: this.selectedCarSegment,
        CarModelGuid: this.selectedCarModel,
        CarMatch: this.selectedCarMatch
      };

      if (this.selectedCompetitorCar) {
        sendData.CompetitorCarModelGuid = this.selectedCompetitorCar;
        delete sendData.CarModelGuid;
      }

      var shopperCar = _.find(this.shopperCars, function (car) {
        return car.ValueGroupGuid === _this9.selectedShopperCar;
      });
      if (shopperCar) sendData.SelectedShopperGroupProperties = [{
        ValueGroupGuid: shopperCar.ValueGroupGuid,
        ShopperPropertyGroupGuid: shopperCar.ShopperPropertyGroupGuid
      }];

      var query = "api/Approval/ShopperProposal";
      $.ajax({
        method: "POST",
        url: query,
        data: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(sendData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this9.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this9.globals.showSuccessSnackbar(_this9.lang.SPM025);
          _this9.selectedShopper = "";
          _this9.selectedShopperCar = "";
          _this9.$emit("dataUpdated");
        },
        error: function error(_error3) {
          console.error("Error on POST in addShopper()");
          _this9.globals.showErrorSnackbar(_this9.lang.SPM026);
        }
      });
    },
    deleteShopper: function deleteShopper(shopper) {
      var _this10 = this;

      this.globals.$off("DeleteShopperProposalYesConfirmation");
      this.globals.$on("DeleteShopperProposalYesConfirmation", function () {
        $.ajax({
          method: "DELETE",
          url: "api/Approval/ShopperProposal/" + shopper.ShopperProposalGuid,
          success: function success(data) {
            if (data.Error) {
              console.error(data.Error);
              _this10.globals.showErrorSnackbar(data.Error);
              return;
            }
            _this10.globals.showSuccessSnackbar(_this10.lang.SPM027);
            _this10.$emit("dataUpdated");
          },
          error: function error() {
            console.error("Error on DELETE in deleteShopper()");
            _this10.globals.showErrorSnackbar(_this10.lang.SPM028);
          }
        });
      });

      this.globals.$emit("openGlobalConfirmationDialog", {
        initiator: "DeleteShopperProposal",
        confirmationTitle: this.lang.SPM029,
        colorRed: true,
        yesButtonText: this.lang.SPM030,
        noButtonText: this.lang.SPM031,
        htmlText: "<p>" + this.lang.SPM032 + "</p>\n                  <p><b>" + shopper.DisplayName + "</b></p>"
      });
    },
    getShopperCars: function getShopperCars() {
      var _this11 = this;

      this.shopperCars = [];
      if (!this.selectedShopper) return;
      $.ajax({
        method: "GET",
        url: "api/ShopperProperty/AUDI/CarsOfShopper/" + this.selectedShopper,
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this11.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this11.shopperCars = data;
        },
        error: function error() {
          console.error("Shopper car access failed in getShopperCars()");
          _this11.globals.showErrorSnackbar(_this11.lang.SPM033);
        }
      });
    },
    getWaveStatus: function getWaveStatus() {
      var _this12 = this;

      if (!this.check.WaveGuid) return;
      var query = "api/ProjectWaves/" + this.check.WaveGuid + "/AgencyStatus?ApprovalStatus=all";

      $.ajax({
        method: "GET",
        url: query,
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this12.globals.showErrorSnackbar(data.Error);
            return;
          }
          if (data) _this12.statusData = data;
        },
        error: function error(_error4) {
          console.error("Error on GET in getWaveStatus()");
          _this12.globals.showErrorSnackbar(_this12.lang.AWS035);
        }
      });
    },
    getGroupedCompetitorCars: function getGroupedCompetitorCars() {
      if (!this.statusData.CompetitorCarDistribution) {
        return [];
      }

      var carBrandMap = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a();
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.statusData.CompetitorCarDistribution), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var ccd = _step.value;

          if (ccd.CompetitorCarBrand !== this.check.Brand) continue;
          if (!carBrandMap.has(ccd.CompetitorCarBrand)) {
            carBrandMap.set(ccd.CompetitorCarBrand, []);
          }
          carBrandMap.get(ccd.CompetitorCarBrand).push(ccd);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(carBrandMap);
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FormComponents_IntegerInput__ = __webpack_require__(1607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FormComponents_IntegerInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__FormComponents_IntegerInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FormComponents_TextInput__ = __webpack_require__(1610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FormComponents_TextInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__FormComponents_TextInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FormComponents_SingleSelectInput__ = __webpack_require__(1609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FormComponents_SingleSelectInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__FormComponents_SingleSelectInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FormComponents_MultiSelectInput__ = __webpack_require__(1608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FormComponents_MultiSelectInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__FormComponents_MultiSelectInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormComponents_CheckboxInput__ = __webpack_require__(1606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormComponents_CheckboxInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__FormComponents_CheckboxInput__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var uuidv4 = __webpack_require__(60);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "CustomePropertiesForm",
  components: {
    IntegerInput: __WEBPACK_IMPORTED_MODULE_2__FormComponents_IntegerInput___default.a,
    TextInput: __WEBPACK_IMPORTED_MODULE_3__FormComponents_TextInput___default.a,
    SingleSelectInput: __WEBPACK_IMPORTED_MODULE_4__FormComponents_SingleSelectInput___default.a,
    MultiSelectInput: __WEBPACK_IMPORTED_MODULE_5__FormComponents_MultiSelectInput___default.a,
    CheckboxInput: __WEBPACK_IMPORTED_MODULE_6__FormComponents_CheckboxInput___default.a
  },
  props: {
    shopperGuid: {
      Type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      propertiesFormSchema: [],
      guidRegex: RegExp(/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i)
    };
  },

  methods: {
    updateShopperValues: function updateShopperValues(property, valueGroup, value) {
      var valueObject = void 0;
      if (!valueGroup) valueObject = property.Values && property.Values[0];else {
        valueObject = _.find(valueGroup.Values, function (v) {
          return v.ShopperPropertyGuid === property.Guid;
        });
      }
      if (!valueObject) {
        valueObject = {
          ShopperPropertyGuid: property.Guid,
          ShopperValues: []
        };
        if (valueGroup) {
          if (!valueGroup.Values) valueGroup.Values = [];
          valueGroup.Values.push(valueObject);
        } else {
          if (!property.Values) property.Values = [];
          property.Values.push(valueObject);
        }
      }
      var newShopperValues = [{}];

      // Write current value to ShopperValues
      switch (property.PropertyType) {
        case "Text":
        case "Integer":
          newShopperValues[0].TextValue = value;
          break;
        case "Checkbox":
          if (typeof value === "boolean") newShopperValues[0].BitValue = value;
          break;
        case "SingleSelect":
          if (this.guidRegex.test(value)) newShopperValues[0].ListValueGuid = value;else newShopperValues[0].ListCustomValue = value;
          break;
        case "MultiSelect":
          for (var i = 0; i < value.length; i++) {
            if (!newShopperValues[i]) newShopperValues[i] = {};
            if (this.guidRegex.test(value[i])) newShopperValues[i].ListValueGuid = value[i];else newShopperValues[i].ListCustomValue = value[i];
          }
          break;
      }

      // Restore old ValueGuids
      for (var _i = 0; _i < valueObject.ShopperValues.length; _i++) {
        if (valueObject.ShopperValues[_i].ValueGuid && newShopperValues[_i]) newShopperValues[_i].ValueGuid = valueObject.ShopperValues[_i].ValueGuid;
      }

      valueObject.ShopperValues = newShopperValues;
      this.$forceUpdate();
    },
    getShopperValues: function getShopperValues(property, valueGroup) {
      var valueObject = void 0;
      if (!valueGroup) valueObject = property.Values && property.Values[0];else {
        valueObject = _.find(valueGroup.Values, function (v) {
          return v.ShopperPropertyGuid === property.Guid;
        });
      }
      var sv = valueObject && valueObject.ShopperValues;

      switch (property.PropertyType) {
        case "Text":
        case "Integer":
          if (!sv || !sv[0] || !sv[0].TextValue) return "";
          return sv[0].TextValue;
        case "Checkbox":
          return sv && sv[0] && sv[0].BitValue;
        case "SingleSelect":
          if (!sv || !sv[0]) return "";
          return sv[0].ListValueGuid || sv[0].ListCustomValue || "";
        case "MultiSelect":
          if (!sv || !sv[0]) return [];
          var result = [];
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(sv), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var el = _step.value;

              if (el.ListValueGuid) result.push(el.ListValueGuid);
              if (el.ListCustomValue) result.push(el.ListCustomValue);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          return result;
      }
    },
    addDynamicGroup: function addDynamicGroup(dynamicGroup) {
      if (!dynamicGroup.ValueGroups) dynamicGroup.ValueGroups = [];
      var newValueGroupsEntry = {
        ValueGroupGuid: uuidv4(),
        Values: []
      };

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(dynamicGroup.ChildProperties), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var prop = _step2.value;

          newValueGroupsEntry.Values.push({
            ShopperPropertyGuid: prop.Guid,
            ShopperValues: []
          });
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      dynamicGroup.ValueGroups.push(newValueGroupsEntry);
      this.$forceUpdate();
    },
    removeDynamicGroup: function removeDynamicGroup(groupObj, guid) {
      _.remove(groupObj.ValueGroups, function (vg) {
        return vg.ValueGroupGuid === guid;
      });
      this.$forceUpdate();
    },
    getPropertyStoreObject: function getPropertyStoreObject() {
      var result = {
        Properties: []
      };
      this.propertiesFormSchema.forEach(function (topic) {
        if (topic.ChildProperties) topic.ChildProperties.forEach(function (secondLevelProp) {
          if (secondLevelProp.ValueGroups) result.Properties.push({
            ValueGroups: secondLevelProp.ValueGroups
          });else if (secondLevelProp.Values) result.Properties.push({ Values: secondLevelProp.Values });
        });
      });
      return result;
    },
    getShopperProperties: function getShopperProperties(_success, _error) {
      var _this = this;

      this.propertiesFormSchema = [];
      var queryString = "api/ShopperProperty/Shopper/" + (this.shopperGuid || "Sturcture");

      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this.propertiesFormSchema = !_.isEmpty(data) ? data.Properties : [];
          _success();
        },
        error: function error() {
          console.error("Error on GET in getShopperProperties()");
          _error();
        }
      });
    },
    saveShopperProperties: function saveShopperProperties(successCallback, errorCallback) {
      var payload = this.getPropertyStoreObject();
      if (!this.shopperGuid) return payload;
      var queryString = "api/ShopperProperty/Shopper/" + this.shopperGuid;

      $.ajax({
        method: "PUT",
        url: queryString,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          successCallback();
        },
        error: function error() {
          console.error("Error on PUT in saveShopperProperties()");
          errorCallback();
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_liquor_tree__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Tools_Select2__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Tools_Select2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CustomPropertyListEditModal__ = __webpack_require__(1605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CustomPropertyListEditModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__CustomPropertyListEditModal__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component("liquor-tree", __WEBPACK_IMPORTED_MODULE_2_liquor_tree__["a" /* default */]);
var baseLiquorTree = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].options.components["liquor-tree"];
var customLiquorTree = baseLiquorTree.extend({
  methods: {
    onDragStart: function onDragStart(e) {
      return true;
    }
  }
});

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "CustomPropertyEditModal",
  components: {
    liquortree: customLiquorTree,
    Select2: __WEBPACK_IMPORTED_MODULE_3__Tools_Select2___default.a,
    CustomPropertyListEditModal: __WEBPACK_IMPORTED_MODULE_4__CustomPropertyListEditModal___default.a
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#customPropertyEditModal").on("hide.bs.modal", function (e) {
      _this.$emit("dialogClosed");
    });

    $("#customPropertyEditModal").on("shown.bs.modal", function (e) {
      if (!_this.attentionMessageShown) _this.globals.$emit("openGlobalNotificationDialog", {
        initiator: "CustomPropertyEditModalAttentionMessage",
        notificationTitle: _this.lang.SM2015,
        colorRed: true,
        closeButtonText: _this.lang.SM2016,
        htmlText: "<p><b>" + _this.lang.SM2017 + "</b></p>"
      });
      _this.attentionMessageShown = true;
    });
  },

  props: ["showDialog"],
  watch: {
    showDialog: function showDialog(newValue) {
      if (newValue) this.openCustomPropertyEditDialog();else this.closeCustomPropertyEditDialog();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  data: function data() {
    return {
      propertyTreeData: {},
      propertyTreeFilter: "",
      selectedPropertyNode: {},
      selectedPropertyNodeData: {},
      propertyTreeOptions: {
        parentSelect: true,
        multiple: false,
        propertyNames: {
          text: "Title",
          children: "ChildNodes"
        },
        filter: {
          matcher: function matcher(query, node) {
            return node.data.text.toLowerCase().indexOf(query.toLowerCase()) > -1;
          }
        }
      },
      draggingTreeNode: null,
      currentDropTargetId: null,
      currentTreeNodes: null,
      isTreeDirty: false,
      isCurrentNodeDirty: false,
      showPropertyListEditModal: false,
      attentionMessageShown: false,
      inputPropertyTypesList: ["Checkbox", "SingleSelect", "MultiSelect", "Text", "Integer"],
      lang: {
        SM2000: "Property Management",
        SM2001: "Search...",
        SM2002: "Add new topic",
        SM2003: "Save order",
        SM2004: "Type",
        SM2005: "Title",
        SM2006: "Input type",
        SM2007: "List",
        SM2008: "Edit selectable elements",
        SM2009: "Visible",
        SM2010: "Dynamic",
        SM2011: "Active",
        SM2012: "Insert new property",
        SM2013: "Insert new property group",
        SM2014: "Save unit",
        SM2015: "ATTENTION",
        SM2016: "OK",
        SM2017: "Changes in this view will have immediate impact on the user profile of all shoppers. So please be careful if you plan to save any changes.",
        SM2018: "Unsaved changes",
        SM2019: "Save",
        SM2020: "Discard",
        SM2021: "There are unsaved changes for the previous selected element. Do you want to save them?",
        SM2022: "Missing title",
        SM2023: "Element update successful",
        SM2024: "Element update failed",
        SM2025: "Order update successful",
        SM2026: "Order update failed",
        SM2027: "If an element is not visible, only MSM users can see it. It does not appear in the profile of shoppers.",
        SM2028: "Dynamic elements can have multiple entries in the shopper profile. Shoppers can add as many entries as they need.",
        SM2029: "If an element is inactive, it does never appear in the shopper profile. Even MSM users can not see it.",
        SM2030: "Topic",
        SM2031: "Group",
        SM2032: "Property",
        SM2033: "Discard changes",
        SM2034: "Recommended",
        SM2035: "A recommended property will be highlighted in the shopper profile",
        SM2036: "Allow custom values",
        SM2037: "In addition to the predefined values in the list the shopper is allowed to add custom values that are not part of the list.",
        SM2038: "Property tree data access failed",
        SM2039: "Property data access failed",
        SM2040: "Access denied"
      }
    };
  },

  methods: {
    ltDragStart: function ltDragStart(node, e) {
      e.dataTransfer.dropEffect = "move";
      this.draggingTreeNode = node;
      this.currentTreeNodes = $("#customPropertiesTreeContainer").find(".tree-node");
    },
    ltDragEnter: function ltDragEnter(node, e) {
      var dNode = this.draggingTreeNode;
      var borderStyle = "solid 2px red";
      var borderPosition = "border-bottom";
      var targetNodeId = null;

      if (node.id === dNode.id) return false;

      if (dNode.data.Type === "Topic") {
        var targetTopic = node;
        while (targetTopic.data.Type !== "Topic") {
          targetTopic = targetTopic.parent;
        }targetNodeId = targetTopic.id;
      } else if (dNode.data.Type === "Group") {
        if (node.parent && node.parent.data.Type === "Group") targetNodeId = node.parent.id;else if (node.data.Type === "Topic" && node.children.length > 0) {
          targetNodeId = node.children[0].id;
          borderPosition = "border-top";
        } else targetNodeId = node.id;
      } else {
        if (node.data.Type !== "Property" && node.children.length > 0) {
          targetNodeId = node.children[0].id;
          borderPosition = "border-top";
        } else targetNodeId = node.id;
      }

      if (targetNodeId === dNode.id) return false; // Do not drop node on itself

      $("#customPropertiesTreeContainer").find(".tree-node[data-id=\"" + targetNodeId + "\"]").css(borderPosition, borderStyle);
      this.currentDropTargetId = targetNodeId;
      return true;
    },
    ltDragLeave: function ltDragLeave(node, e) {
      this.currentTreeNodes.css("border", "");
      this.currentDropTargetId = null;
    },
    ltDragEnd: function ltDragEnd(node, e) {
      this.draggingTreeNode = null;
    },
    ltDrop: function ltDrop(node, e) {
      this.currentTreeNodes.css("border", "");
      this.currentDropTargetId = null;
      this.currentTreeNodes = null;

      var dNode = this.draggingTreeNode;

      if (dNode.id === node.id) {
        return;
      }

      // Avoid moving topic or group inside itself
      if (dNode.data.Type === "Topic" && node.parent && (node.parent.id === dNode.id || node.parent.parent && node.parent.parent.id === dNode.id)) return;
      if (dNode.data.Type === "Group" && node.parent && node.parent.id === dNode.id) return;

      dNode.remove(); // Remove on old position

      // Find new position and insert dragged node
      if (node.data.Type === "Topic") {
        if (dNode.data.Type === "Topic") node.after(dNode);else node.prepend(dNode);
      }

      if (node.data.Type === "Group") {
        if (dNode.data.Type === "Topic") node.parent.after(dNode);else if (dNode.data.Type === "Group") node.after(dNode);else node.prepend(dNode);
      }

      if (node.data.Type === "Property") {
        if (dNode.data.Type === "Topic") {
          if (node.parent.data.Type === "Topic") node.parent.after(dNode);else node.parent.parent.after(dNode);
        } else if (dNode.data.Type === "Group") {
          if (node.parent.data.Type === "Group") node.parent.after(dNode);else node.after(dNode);
        } else node.after(dNode);
      }
      dNode.select();
      if (dNode.parent) dNode.parent.expand();

      this.isTreeDirty = true;
    },
    initCustomPropertyEditModal: function initCustomPropertyEditModal() {
      this.propertyTreeFilter = "";
      this.selectedPropertyNode = {};
      this.selectedPropertyNodeData = {};
    },
    openCustomPropertyEditDialog: function openCustomPropertyEditDialog() {
      this.initCustomPropertyEditModal();
      this.getProperties();
      $("#customPropertyEditModal").modal("show");
    },
    closeCustomPropertyEditDialog: function closeCustomPropertyEditDialog() {
      var _this2 = this;

      if (this.isTreeDirty || this.isCurrentNodeDirty) {
        this.globals.$emit("openGlobalUnsavedChangesDialog", function () {
          _this2.isTreeDirty = false;
          _this2.isCurrentNodeDirty = false;
          $("#customPropertyEditModal").modal("hide");
        });
        return;
      }
      $("#customPropertyEditModal").modal("hide");
    },
    getProperties: function getProperties() {
      var _this3 = this;

      var queryString = "api/ShopperProperty/Tree";

      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          if (!data) {
            console.error("No property data available");
            return;
          }
          _this3.propertyTreeData = {};
          _this3.$nextTick(function () {
            _this3.propertyTreeData = data;
            _this3.isTreeDirty = false;
            _this3.globals.doAfterNTicks(_this3, 2, function () {
              var treeRef = _this3.$refs.customPropertiesTree;
              if (!treeRef) return;
              treeRef.expandAll();
              var selectedProp = treeRef.find({
                data: { Guid: _this3.selectedPropertyNodeData.Guid }
              });
              if (selectedProp) {
                selectedProp.select();
                _this3.$nextTick(function () {
                  var el = document.querySelector("li[data-id=\"" + selectedProp[0].id + "\"]");
                  var container = document.getElementById("customPropertiesTreeContainer");
                  if (!el || !container) return;
                  var nodeVisible = _this3.globals.isNodeVisibleInDOM(el, container, false);
                  if (!nodeVisible) el.scrollIntoView({ behavior: "smooth" });
                });
              }
            });
          });
        },
        error: function error() {
          console.error("Property data access failed in getProperties()");
          _this3.globals.showErrorSnackbar(_this3.lang.SM2038);
        }
      });
    },
    getPropertyData: function getPropertyData() {
      var _this4 = this;

      var queryString = "api/ShopperProperty/Property/" + this.selectedPropertyNode.data.Guid;

      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          if (!data) {
            console.error("No property data available");
          }
          _this4.selectedPropertyNodeData = data;
          _this4.isCurrentNodeDirty = false;
        },
        error: function error() {
          console.error("Property data access failed in getPropertyData()");
          _this4.globals.showErrorSnackbar(_this4.lang.SM2039);
        }
      });
    },
    onPropertySelected: function onPropertySelected(node) {
      var _this5 = this;

      if (!this.globals.isAccessAllowed("LoopOp_ShopperProperties_Read")) {
        this.globals.showErrorSnackbar(this.lang.SM2040);
        console.error("Access denied: LoopOp_ShopperProperties_Read");
        return;
      }

      if (this.isCurrentNodeDirty) {
        this.globals.$off("CustomPropertyUnsavedChangesYesConfirmation");
        this.globals.$once("CustomPropertyUnsavedChangesYesConfirmation", function () {
          _this5.saveCurrentNode();
          _this5.isCurrentNodeDirty = false;
        });
        this.globals.$off("CustomPropertyUnsavedChangesCloseDialog");
        this.globals.$once("CustomPropertyUnsavedChangesCloseDialog", function () {
          _this5.selectedPropertyNode = node;
          _this5.getPropertyData();
        });
        this.globals.$emit("openGlobalConfirmationDialog", {
          initiator: "CustomPropertyUnsavedChanges",
          confirmationTitle: this.lang.SM2018,
          colorRed: true,
          yesButtonText: this.lang.SM2019,
          noButtonText: this.lang.SM2020,
          htmlText: "<p><b>" + this.lang.SM2021 + "</b></p>"
        });
        return;
      }
      this.selectedPropertyNode = node;
      this.getPropertyData();
    },
    discardCurrentNodeChanges: function discardCurrentNodeChanges() {
      if (this.selectedPropertyNode.id) {
        var node = this.$refs.customPropertiesTree.find({
          id: this.selectedPropertyNode.id
        });
        node.unselect();
      }
      this.selectedPropertyNode = {};
      this.selectedPropertyNodeData = {};
      this.isCurrentNodeDirty = false;
    },
    nodeDataChanged: function nodeDataChanged() {
      this.isCurrentNodeDirty = true;
    },
    insertNewNode: function insertNewNode(type) {
      if (!this.globals.isAccessAllowed("LoopOp_ShopperProperties_Create")) {
        this.globals.showErrorSnackbar(this.lang.SM2040);
        console.error("Access denied: LoopOp_ShopperProperties_Create");
        return;
      }

      if (!type) return;

      var newNode = {};
      newNode.Type = type;
      newNode.Visible = false;
      newNode.Active = false;

      if (type !== "Topic") {
        newNode.ParentGuid = this.selectedPropertyNodeData.Guid;
        newNode.Dynamic = false;
      }
      if (type === "Property") {
        newNode.PropertyType = "Text";
        newNode.AllowCustomValues = false;
      }
      if (type === "Group") {
        newNode.Dynamic = true;
      }

      this.selectedPropertyNodeData = newNode;
    },
    cleanUpSelectedNode: function cleanUpSelectedNode() {
      if (this.selectedPropertyNodeData.PropertyType !== "SingleSelect" && this.selectedPropertyNodeData.PropertyType !== "MultiSelect") {
        delete this.selectedPropertyNodeData.AllowCustomValues;
        delete this.selectedPropertyNodeData.ListGuid;
      }
    },
    saveCurrentNode: function saveCurrentNode() {
      var _this6 = this;

      if (!this.globals.isAccessAllowed("LoopOp_ShopperProperties_Update")) {
        this.globals.showErrorSnackbar(this.lang.SM2040);
        console.error("Access denied: LoopOp_ShopperProperties_Update");
        return;
      }

      if (!this.selectedPropertyNodeData.Title) {
        this.globals.showErrorSnackbar(this.lang.SM2022);
        return;
      }

      this.cleanUpSelectedNode();

      var method = this.selectedPropertyNodeData.Guid ? "PUT" : "POST";
      var url = "api/ShopperProperty/Property/" + (this.selectedPropertyNodeData.Guid || "");
      var dataString = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedPropertyNodeData);

      $.ajax({
        method: method,
        url: url,
        data: dataString,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this6.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this6.globals.showSuccessSnackbar(_this6.lang.SM2023);
          if (method === "POST") _this6.selectedPropertyNodeData = data;
          _this6.isCurrentNodeDirty = false;
          _this6.getProperties();
        },
        error: function error() {
          console.error("Error on POST in saveCurrentNode()");
          _this6.globals.showErrorSnackbar(_this6.lang.SM2024);
        }
      });
    },
    saveTree: function saveTree() {
      var _this7 = this;

      if (!this.globals.isAccessAllowed("LoopOp_ShopperProperties_Update")) {
        this.globals.showErrorSnackbar(this.lang.SM2040);
        console.error("Access denied: LoopOp_ShopperProperties_Update");
        return;
      }

      var url = "api/ShopperProperty/Tree";
      var treeData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ Nodes: this.createTreeJSON() });

      $.ajax({
        method: "PUT",
        url: url,
        data: treeData,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this7.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this7.isTreeDirty = false;
          _this7.globals.showSuccessSnackbar(_this7.lang.SM2025);
        },
        error: function error() {
          console.error("Error on POST in saveTree()");
          _this7.globals.showErrorSnackbar(_this7.lang.SM2026);
        }
      });
    },
    createTreeJSON: function createTreeJSON() {
      var treeJSON = this.$refs.customPropertiesTree.toJSON();

      var transformNode = function transformNode(node) {
        var newNode = {
          Title: node.text,
          data: node.data
        };
        if (newNode.data.text) delete newNode.data.text;
        if (node.children.length > 0) newNode.ChildNodes = _.map(node.children, transformNode);

        return newNode;
      };

      for (var i = 0; i < treeJSON.length; i++) {
        treeJSON[i] = transformNode(treeJSON[i]);
      }

      return treeJSON;
    },
    getTypeTranslation: function getTypeTranslation(type) {
      switch (type) {
        case "Topic":
          return this.lang.SM2030;
        case "Group":
          return this.lang.SM2031;
        case "Property":
          return this.lang.SM2032;
        default:
          return type;
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "CustomPropertyListEditModal",
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#customPropertyListEditModal").on("hide.bs.modal", function (e) {
      _this.$emit("modalClosing");
    });
  },

  props: ["showModal", "listGuid"],
  watch: {
    showModal: function showModal(newValue) {
      if (newValue) this.openListEditModal();else this.closeListEditModal();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  data: function data() {
    return {
      propertyListAddData: "",
      propertyListAddEnabled: false,
      propertyListData: {},
      isPropertyListDataDirty: false,
      hasPropertyListError: false,
      selectedListItems: [],
      lang: {
        SM2500: "Edit selection list",
        SM2501: "Add new entries",
        SM2502: "Select all",
        SM2503: "Unselect all",
        SM2504: "Remove selected",
        SM2505: "Hide selected",
        SM2506: "Show selected",
        SM2507: "Item",
        SM2508: "Actions",
        SM2509: "Close",
        SM2510: "Save",
        SM2511: "List update successful",
        SM2512: "List update failed",
        SM2513: "Empty values are not allowed",
        SM2514: "Value already exists"
      }
    };
  },

  methods: {
    openListEditModal: function openListEditModal() {
      this.propertyListAddData = "";
      this.propertyListAddEnabled = false;
      this.propertyListData = {};
      this.isPropertyListDataDirty = false;
      this.hasPropertyListError = false;
      this.selectedListItems = [];
      this.getPropertyListItems();
      $("#customPropertyListEditModal").modal("show");
    },
    closeListEditModal: function closeListEditModal() {
      var _this2 = this;

      if (this.isPropertyListDataDirty) {
        this.globals.$emit("openGlobalUnsavedChangesDialog", function () {
          _this2.isPropertyListDataDirty = false;
          $("#customPropertyListEditModal").modal("hide");
        });
        return;
      }
      $("#customPropertyListEditModal").modal("hide");
    },
    showAddPropertyListInput: function showAddPropertyListInput() {
      this.propertyListAddEnabled = true;
      this.toggleSelectAllEntries(true);
      this.$nextTick(function () {
        $("#textareaPropertyList").focus();
      });
    },
    getPropertyListItems: function getPropertyListItems() {
      var _this3 = this;

      if (!this.listGuid) {
        //No list created yet
        return;
      }

      var queryString = "api/ShopperProperty/List/" + this.listGuid;

      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          if (!data) {
            console.error("No property list data available");
          }
          _this3.propertyListData = data;
          _this3.sortPropertyValues();
        },
        error: function error() {
          console.error("Property list access failed in getPropertyListItems()");
          _this3.globals.showErrorSnackbar("Property list access failed");
        }
      });
    },
    storePropertyListItems: function storePropertyListItems() {
      var _this4 = this;

      var method = this.listGuid ? "PUT" : "POST";
      var url = "api/ShopperProperty/List/" + (this.listGuid || "");
      this.sortPropertyValues();
      var dataString = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.propertyListData);

      $.ajax({
        method: method,
        url: url,
        data: dataString,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this4.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this4.globals.showSuccessSnackbar(_this4.lang.SM2511);
          _this4.isPropertyListDataDirty = false;
          if (method === "POST") _this4.$emit("propertyListCreated", data.ListGuid);
          _this4.closeListEditModal();
        },
        error: function error() {
          console.error("Error on " + method + " in storePropertyListItems()");
          _this4.globals.showErrorSnackbar(_this4.lang.SM2512);
        }
      });
    },
    addNewPropertyListEntries: function addNewPropertyListEntries() {
      this.propertyListAddEnabled = false;
      if (!this.propertyListAddData) return;

      var entries = _.split(this.propertyListAddData, "\n");
      this.propertyListAddData = "";
      if (!this.propertyListData.Values) this.propertyListData.Values = [];

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(entries), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var entry = _step.value;

          if (entry && !this.isEntryInList(entry)) this.propertyListData.Values.push({ Value: entry, selected: true });
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.isPropertyListDataDirty = true;
      this.selectedListItems = [];
      this.sortPropertyValues();
    },
    isEntryInList: function isEntryInList(entry) {
      if (!this.propertyListData.Values) return false;
      return _.findIndex(this.propertyListData.Values, ["Value", entry]) > -1;
    },
    sortPropertyValues: function sortPropertyValues() {
      this.propertyListData.Values = _.sortBy(this.propertyListData.Values, [function (val) {
        return val.Value.toLowerCase();
      }]);
    },
    toggleSelectAllEntries: function toggleSelectAllEntries(clear) {
      var value = clear ? false : !this.allEntriesSelected();
      _.forEach(this.propertyListData.Values, function (val) {
        val.selected = value;
      });
      this.$forceUpdate();
    },
    isAnyEntrySelected: function isAnyEntrySelected() {
      if (!this.propertyListData.Values) return false;
      return _.findIndex(this.propertyListData.Values, ["selected", true]) > -1;
    },
    allEntriesSelected: function allEntriesSelected() {
      if (this.propertyListData.Values) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.propertyListData.Values), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var _val = _step2.value;

            if (!_val.selected) return false;
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      } else return false;
      return true;
    },
    removeSelectedEntries: function removeSelectedEntries() {
      if (this.propertyListData.Values) {
        _.remove(this.propertyListData.Values, function (val) {
          return !!val.selected;
        });
        this.isPropertyListDataDirty = true;
        this.$forceUpdate();
      }
    },
    removeEntry: function removeEntry(index) {
      _.pullAt(this.propertyListData.Values, index);
      this.$forceUpdate();
    },
    editEntry: function editEntry(e) {
      var input = $(e.target).closest("tr").find("input");
      if (!this.hasPropertyListError) input.prop("readonly", "");
      input.focus();
    },
    allSelectedEntriesVisible: function allSelectedEntriesVisible() {
      if (this.propertyListData.Values) {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.propertyListData.Values), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var _val2 = _step3.value;

            if (_val2.selected && !_val2.Visible) return false;
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      } else return false;
      return true;
    },
    toggleVisibilityOfSelectedEntries: function toggleVisibilityOfSelectedEntries() {
      var visible = !this.allSelectedEntriesVisible();
      this.propertyListData.Values.forEach(function (val) {
        if (val.selected) val.Visible = visible;
      });
      this.isPropertyListDataDirty = true;
      this.$forceUpdate();
    },
    propertyListEntryChanged: function propertyListEntryChanged(e, index) {
      var _this5 = this;

      if (e.target.readOnly) return;

      var newValue = e.target.value;
      var values = this.propertyListData.Values;

      var onError = function onError() {
        values[index].error = true;
        _this5.hasPropertyListError = true;
        _this5.editEntry(e);
        _this5.$forceUpdate();
      };

      if (!newValue) {
        onError();
        this.globals.showErrorSnackbar(this.lang.SM2513);
        return;
      }

      for (var i = 0; i < values.length; i++) {
        if (i !== index && values[i].Value === newValue) {
          onError();
          this.globals.showErrorSnackbar(this.lang.SM2514);
          return;
        }
      }

      delete values[index].error;
      this.hasPropertyListError = false;
      this.$forceUpdate();
      e.target.readOnly = "true";
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "CheckboxInput",
  props: {
    Title: String,
    Guid: String,
    Recommended: { type: Boolean, default: false },
    value: { type: Boolean, default: undefined },
    readOnly: { type: Boolean, default: false }
  },
  methods: {
    updateValue: function updateValue() {
      if (this.readOnly) return;
      var result = void 0;
      if (this.value === true) result = false;else if (this.value === false) result = undefined;else result = true;
      this.$emit("input", result);
    }
  }
});

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "IntegerInput",
  props: {
    Title: String,
    Guid: String,
    Recommended: { type: Boolean, default: false },
    value: { type: String, default: "" },
    readOnly: { type: Boolean, default: false }
  },
  methods: {
    updateValue: function updateValue(event) {
      this.$emit("input", event.target.value);
    }
  }
});

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tools_Select2__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Tools_Select2__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "MultiSelectInput",
  components: { Select2: __WEBPACK_IMPORTED_MODULE_0__Tools_Select2___default.a },
  props: {
    Title: String,
    Guid: String,
    ListValues: { type: Array, default: function _default() {
        return [];
      } },
    Recommended: { type: Boolean, default: false },
    AllowCustomValues: { type: Boolean, default: false },
    value: { type: Array, default: function _default() {
        return [];
      } },
    readOnly: { type: Boolean, default: false }
  },
  methods: {
    updateValue: function updateValue(newValue) {
      this.$emit("input", newValue);
    }
  }
});

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tools_Select2__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Tools_Select2__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "SingleSelectInput",
  components: { Select2: __WEBPACK_IMPORTED_MODULE_0__Tools_Select2___default.a },
  props: {
    Title: String,
    Guid: String,
    ListValues: { type: Array, default: function _default() {
        return [];
      } },
    Recommended: { type: Boolean, default: false },
    AllowCustomValues: { type: Boolean, default: false },
    value: { type: String, default: "" },
    readOnly: { type: Boolean, default: false }
  },
  methods: {
    updateValue: function updateValue(newValue) {
      this.$emit("input", newValue);
    }
  }
});

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "TextInput",
  props: {
    Title: String,
    Guid: String,
    Recommended: { type: Boolean, default: false },
    value: { type: String, default: "" },
    index: { type: Number, default: -1 },
    readOnly: { type: Boolean, default: false }
  },
  methods: {
    updateValue: function updateValue(event) {
      this.$emit("input", event.target.value);
    }
  }
});

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CheckManagement_CheckPaymentModal__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CheckManagement_CheckPaymentModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CheckManagement_CheckPaymentModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Tools_Select2__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Tools_Select2__);



var _name$components$prop;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = (_name$components$prop = {
  name: "ShopperCheckManagement",
  components: {
    CheckPaymentModal: __WEBPACK_IMPORTED_MODULE_2__CheckManagement_CheckPaymentModal___default.a,
    Select2: __WEBPACK_IMPORTED_MODULE_3__Tools_Select2___default.a
  },
  props: ["selectedShopperGuid"],
  data: function data() {
    return {
      searchString: "",
      refreshEnabled: false,
      showCheckPaymentModal: false,
      shopperCheckList: [],
      filteredShopperChecklist: [],
      shopperChecksOnCurrentPage: [],
      selectedPage: 1,
      pageSize: 20,
      selectedCheckGuid: "",
      settlementStatusses: {},
      shopperData: {},
      selectedShopper: {},
      selectedChecks: [],
      checkStates: [100, 110, 120],
      lastSelectedCheck: -1,
      currentSort: { key: "SurveyInstanceStatusId", asc: true },
      filterStrings: {
        SurveyInstanceId: "",
        ProjectName: "",
        WaveName: "",
        ScenarioName: "",
        ClientName: "",
        ImporterName: "",
        LocationName: "",
        LocationAddress: "",
        LocationCountry: "",
        SurveyInstanceStatusId: "",
        SettlementState: "",
        SettlementNumber: "",
        SettlementDate: ""
      },
      lang: {
        SM4000: "Refresh",
        SM4001: "Close",
        SM4002: "Search...",
        SM4003: "Check ID",
        SM4004: "Export",
        SM4005: "Project",
        SM4006: "Wave",
        SM4007: "Scenario",
        SM4008: "Client",
        SM4009: "Location Name",
        SM4010: "Check State",
        SM4011: "Location Address",
        SM4012: "Location Country",
        SM4013: "Payoff State",
        SM4014: "Payoff Number",
        SM4015: "Payoff Date",
        SM4016: "Filter",
        SM4017: "Shopper Checks Export",
        SM4018: "Download",
        SM4019: "Cancel",
        SM4020: "Export selected checks from shopper",
        SM4021: "Payments",
        SM4022: "Importer",
        SM4023: "Items per page",
        SM4024: "First page",
        SM4025: "Last page",
        SM4026: "Total checks count"
      }
    };
  },

  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      var _this = this;

      this.globals.getLanguageStrings(this, this.setTableHeight);
      this.settlementStatusses = {};
      this.filterStrings.SettlementState = "";
      this.globals.getSettlementStatusses(function (data) {
        _this.settlementStatusses = data;
        _this.getShopperCheckList();
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.readComponentSettingsFromStore();
    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this, this.setTableHeight);
      this.globals.getSettlementStatusses(function (data) {
        _this2.settlementStatusses = data;
      });
    }
    this.getShopperInformation();
    this.getShopperCheckList();

    // Sets the new table height after the window got resized
    $(window).on("resize", this.setTableHeight).resize();

    if (!this.globals.currentUserInfo) this.globals.$once("currentUserInfoReceived", this.setTableHeight);

    // Register global events
    this.globals.$off("ShopperCheckManagementYesConfirmation");
    this.globals.$on("ShopperCheckManagementYesConfirmation", function () {
      _this2.exportSelectedShopperChecks();
    });
  },
  destroyed: function destroyed() {
    $(window).off("resize", this.setTableHeight);
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$components$prop, "destroyed", function destroyed() {
  this.writeComponentSettingsToStore();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$components$prop, "methods", {
  readComponentSettingsFromStore: function readComponentSettingsFromStore() {
    if (!this.$store.getters["userSettings/rememberFilters"]) return;

    if (!this.$store.getters["userSettings/syncFilters"]) return;
    if (!this.feature.isAudiTarget || !this.feature.isEnabled("audi_importers")) {
      var storedClient = this.$store.getters["sharedFilters/client"];
      if (storedClient.ClientName) {
        this.filterStrings.ClientName = this.globals.removeWildcardsFromString(storedClient.ClientName);
      } else this.filterStrings.ClientName = "";
    } else {
      var storedImporter = this.$store.getters["sharedFilters/importer"];
      if (storedImporter.ImporterName) {
        this.filterStrings.ImporterName = this.globals.removeWildcardsFromString(storedImporter.ImporterName);
      } else this.filterStrings.ImporterName = "";
    }

    var storedProject = this.$store.getters["sharedFilters/project"];
    if (storedProject.ProjectName) {
      this.filterStrings.ProjectName = this.globals.removeWildcardsFromString(storedProject.ProjectName);
    } else this.filterStrings.ProjectName = "";
  },
  writeComponentSettingsToStore: function writeComponentSettingsToStore() {
    if (!this.$store.getters["userSettings/rememberFilters"]) return;

    if (!this.$store.getters["userSettings/syncFilters"]) return;
    if (!this.feature.isAudiTarget || !this.feature.isEnabled("audi_importers")) {
      var storedClient = this.$store.getters["sharedFilters/client"];
      if (this.globals.removeWildcardsFromString(storedClient.ClientName) !== this.filterStrings.ClientName) {
        this.$store.commit("sharedFilters/client", {
          ClientName: this.globals.addWildcardsToString(this.filterStrings.ClientName)
        });
      }
    } else {
      var storedImporter = this.$store.getters["sharedFilters/importer"];
      if (this.globals.removeWildcardsFromString(storedImporter.ImporterName) !== this.filterStrings.ImporterName) {
        this.$store.commit("sharedFilters/importer", {
          ImporterName: this.globals.addWildcardsToString(this.filterStrings.ImporterName)
        });
      }
    }

    var storedProject = this.$store.getters["sharedFilters/project"];
    if (this.globals.removeWildcardsFromString(storedProject.ProjectName) !== this.filterStrings.ProjectName) {
      this.$store.commit("sharedFilters/project", {
        ProjectName: this.globals.addWildcardsToString(this.filterStrings.ProjectName)
      });
    }
  },
  getShopperCheckList: function getShopperCheckList() {
    var _this3 = this;

    var queryString = "api/Shopper/" + this.selectedShopperGuid + "/SurveyInstances";
    this.refreshEnabled = false;

    $.ajax({
      method: "GET",
      url: queryString,
      success: function success(data) {
        _this3.shopperCheckList = [];
        if (!_.isEmpty(data)) _this3.shopperCheckList = data;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this3.shopperCheckList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var check = _step.value;

            if (check.SettlementDate) check.SettlementDate = _this3.globals.getLocalizedDateFromIsoTimestamp(check.SettlementDate);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        _this3.setSettlementsStates();
        _this3.doFiltering();
      },
      error: function error() {
        console.error("Error on GET in getShopperCheckList()");
        _this3.globals.showErrorSnackbar("Check data request failed");
      },
      complete: function complete() {
        _this3.refreshEnabled = true;
      }
    });
  },
  getShopperInformation: function getShopperInformation() {
    var _this4 = this;

    var queryString = "api/Shopper/" + this.selectedShopperGuid;

    $.ajax({
      method: "GET",
      url: queryString,
      success: function success(data) {
        _this4.shopperData = data;
      },
      error: function error() {
        console.error("Error on GET in getShopperInformation()");
        _this4.globals.showErrorSnackbar("Shopper data request failed");
      }
    });
  },
  setSettlementsStates: function setSettlementsStates() {
    var _this5 = this;

    if (_.isEmpty(this.settlementStatusses)) {
      // Wait for request
      setTimeout(function () {
        _this5.setSettlementsStates();
      }, 500);
      return;
    }

    this.shopperCheckList.forEach(function (check) {
      if (check.SurveyInstanceStatusId < 120) check.SettlementState = "-";else check.SettlementState = _this5.settlementStatusses[check.SettlementStatusGuid];
    });
    this.$forceUpdate();
  },
  setTableHeight: function setTableHeight() {
    this.$nextTick(function () {
      var height = $(window).height();
      height -= $("#shoppercheckmanagement-top-panel").height() + $("#app-navbar").height() + $("#shoppercheckmanagement .main-table > thead").height() + 47;
      $("#shoppercheckmanagement .main-table-scrollbar").css("max-height", height);
    });
  },
  doFiltering: function doFiltering() {
    var _this6 = this;

    // Reset filtering when search string is empty
    if (this.searchString) this.filteredShopperChecklist = this.shopperCheckList;

    var words = this.searchString.split(" ");
    var keys = ["SurveyInstanceId", "ProjectName", "WaveName", "ScenarioName", "ClientName", "ImporterName", "LocationName", "LocationAddress", "LocationCountry", "SurveyInstanceStatusId", "SettlementState", "SettlementNumber", "SettlementDate"];

    var surveyFilter = function surveyFilter(survey) {
      var containsSearch = false;
      words.forEach(function (word) {
        keys.forEach(function (key) {
          if (survey[key] && survey[key].toString().toLowerCase().indexOf(word.toLowerCase()) > -1) {
            containsSearch = true;
            return;
          }
        });
      });
      if (!containsSearch) return false;
      keys.forEach(function (key) {
        if (!containsSearch) return;
        if (!survey[key] && _this6.filterStrings[key] || survey[key] && survey[key].toString().toLowerCase().indexOf(_this6.filterStrings[key].toLowerCase()) < 0) {
          containsSearch = false;
          return;
        }
      });
      return containsSearch;
    };
    this.filteredShopperChecklist = !_.isEmpty(this.shopperCheckList) ? this.shopperCheckList.filter(surveyFilter) : [];
    this.currentSort.asc = !this.currentSort.asc;
    this.orderTableByColumn(this.currentSort.key);
  },
  showSortArrow: function showSortArrow(key, asc) {
    return this.currentSort.key === key && this.currentSort.asc === asc;
  },
  orderTableByColumn: function orderTableByColumn(orderProp) {
    var _this7 = this;

    if (!orderProp && !this.currentSort.key) return;
    if (orderProp) {
      this.currentSort.key === orderProp ? this.currentSort.asc = !this.currentSort.asc : this.currentSort = { asc: true, key: orderProp };
    }
    if (orderProp === "SurveyInstanceStatusId") {
      this.orderCheckStateColumn();
    } else {
      var sortFunction = function sortFunction(check) {
        if (typeof check[_this7.currentSort.key] === "string") {
          return check[_this7.currentSort.key].toLowerCase();
        }
        return check[_this7.currentSort.key];
      };
      this.filteredShopperChecklist = _.orderBy(this.filteredShopperChecklist, [sortFunction], [this.currentSort.asc ? "asc" : "desc", "asc"]);
    }
    this.loadCurrentPageOfShopperChecks();
    this.$nextTick(function () {
      _this7.setTableHeight();
    });
  },
  orderCheckStateColumn: function orderCheckStateColumn() {
    var checkStateSortOrder = [110, 100, 120];
    var ordering = {};
    checkStateSortOrder.forEach(function (element, index) {
      return ordering[element] = index;
    });
    this.currentSort.asc ? this.filteredShopperChecklist.sort(function (a, b) {
      return ordering[a.SurveyInstanceStatusId] - ordering[b.SurveyInstanceStatusId];
    }) : this.filteredShopperChecklist.sort(function (a, b) {
      return ordering[b.SurveyInstanceStatusId] - ordering[a.SurveyInstanceStatusId];
    });
    this.loadCurrentPageOfShopperChecks();
  },

  // Returns a list of all pagenumbers that should be visible depending on the current page and the count of pages
  getVisiblePages: function getVisiblePages() {
    if (this.numberOfPages() <= 7) {
      return _.range(1, this.numberOfPages() + 1);
    } else if (this.numberOfPages() > 7 && this.selectedPage <= 4) {
      return _.range(1, 7);
    } else if (this.numberOfPages() > 7 && this.selectedPage >= this.numberOfPages() - 3) {
      return _.range(this.numberOfPages() - 5, this.numberOfPages() + 1);
    } else {
      return _.range(this.selectedPage - 2, this.selectedPage + 3);
    }
  },
  updatePaging: function updatePaging(pageNumber, pageSize) {
    this.selectedPage = pageNumber;
    if (pageSize != 0) this.pageSize = pageSize;
    this.loadCurrentPageOfShopperChecks();
  },

  // Returns the count of pages depending on the selected pagesize and the length of the client data list
  numberOfPages: function numberOfPages() {
    if (this.pageSize == -1) return 1;
    if (this.filteredShopperChecklist.length % this.pageSize == 0) return this.filteredShopperChecklist.length / this.pageSize;else return parseInt(this.filteredShopperChecklist.length / this.pageSize) + 1;
  },
  loadCurrentPageOfShopperChecks: function loadCurrentPageOfShopperChecks() {
    if (this.pageSize == -1) this.shopperChecksOnCurrentPage = this.filteredShopperChecklist;else {
      // Display all data, no pages
      this.shopperChecksOnCurrentPage = [];
      var startIndex = (this.selectedPage - 1) * this.pageSize;
      for (var i = startIndex; i < startIndex + this.pageSize; i++) {
        if (this.filteredShopperChecklist[i] != null) this.shopperChecksOnCurrentPage[i - startIndex] = this.filteredShopperChecklist[i];
      }
    }
  },
  openShopperCheckExportConfirmationDialog: function openShopperCheckExportConfirmationDialog() {
    this.globals.$emit("openGlobalConfirmationDialog", this.getExportShopperData());
  },
  getExportShopperData: function getExportShopperData() {
    return {
      initiator: "ShopperCheckManagement",
      confirmationTitle: this.lang.SM4017,
      yesButtonText: this.lang.SM4018,
      noButtonText: this.lang.SM4019,
      htmlText: "<p>" + this.lang.SM4020 + "</p>"
    };
  },

  // TODO: implement export api
  exportSelectedShopperChecks: function exportSelectedShopperChecks() {
    console.log("export");
  },
  selectChecks: function selectChecks(checkGuid, e) {
    var _this8 = this;

    if (!e) return;

    if (e.ctrlKey && !e.shiftKey) {
      var idx = _.indexOf(this.selectedChecks, checkGuid);
      if (idx > -1) {
        _.pullAt(this.selectedChecks, idx);
        this.lastSelectedCheck = -1;
      } else {
        this.selectedChecks.push(checkGuid);
        this.lastSelectedCheck = checkGuid;
      }
    } else if (!e.ctrlKey && e.shiftKey) {
      document.getSelection().removeAllRanges();
      if (this.lastSelectedCheck < 0) return;

      var idx1 = _.findIndex(this.shopperChecksOnCurrentPage, function (c) {
        return c.SurveyInstanceGuid == _this8.lastSelectedCheck;
      });
      var idx2 = _.findIndex(this.shopperChecksOnCurrentPage, function (c) {
        return c.SurveyInstanceGuid == checkGuid;
      });

      if (idx1 > idx2) {
        ;

        var _ref = [idx1, idx2];
        idx2 = _ref[0];
        idx1 = _ref[1];
      }for (var i = idx1; i <= idx2; i++) {
        if (!this.isCheckSelected(this.shopperChecksOnCurrentPage[i].SurveyInstanceGuid)) this.selectedChecks.push(this.shopperChecksOnCurrentPage[i].SurveyInstanceGuid);
      }
    } else {
      this.selectedChecks = [checkGuid];
      this.lastSelectedCheck = checkGuid;
    }
    this.$forceUpdate();
  },
  isCheckSelected: function isCheckSelected(checkGuid) {
    return _.indexOf(this.selectedChecks, checkGuid) > -1;
  }
}), _name$components$prop);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tools_Select2__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Tools_Select2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CustomPropertiesForm__ = __webpack_require__(1603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CustomPropertiesForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CustomPropertiesForm__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ShopperDataEditModal",
  components: {
    Select2: __WEBPACK_IMPORTED_MODULE_2__Tools_Select2___default.a,
    CustomPropertiesForm: __WEBPACK_IMPORTED_MODULE_3__CustomPropertiesForm___default.a
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this);
      this.globals.getCountryList();
    }

    $("#editShopperDialog").on("hide.bs.modal", function (e) {
      _this.$emit("dialogClosed");
    });

    this.fpBirthdate = flatpickr("#inputShopperBirthdate", this.globals.flatpickrDateConfig);
  },
  destroyed: function destroyed() {
    if (this.fpBirthdate) this.fpBirthdate.destroy();
  },

  props: ["showDialog", "occupationalGroupList", "dialogModeAdd", "selectedShopperGuid"],
  watch: {
    showDialog: function showDialog() {
      this.showDialog ? this.openEditShopperDialog() : this.closeEditShopperDialog();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
      this.globals.getCountryList();
    }
  },
  data: function data() {
    return {
      dialogTitle: "",
      invalidInputIds: [],
      fpBirthdate: null,
      profilePictureFileObject: {},
      shopperPicture: {
        fileGuid: "",
        fileName: ""
      },
      editShopperData: {
        Active: true,
        ShopperSkillLevel: 3,
        Salutation: "",
        FirstName: "",
        LastName: "",
        Address1: "",
        PostalCode: "",
        City: "",
        CountryCode: "",
        Birthdate: "",
        Email: "",
        Phone1: "",
        Phone2: "",
        OccupationalGroupGuid: "", // Berufsgruppe
        Occupation: "", // Tätig als
        Employer: "", // Tätig bei
        Gender: "",
        // VatNo: "",
        ProfilePictureGuid: ""
      },
      bankDetailsData: {},
      lang: {
        SM1000: "New Shopper",
        SM1001: "Edit Shopper",
        SM1002: "Shopper Information",
        SM1003: "Salutation", // form of adress
        SM1004: "Please select...",
        SM1005: "Madam",
        SM1006: "Monsieur",
        SM1007: "Close",
        SM1008: "Save",
        SM1009: "This is a required entry!",
        SM1010: "First name",
        SM1011: "Last name",
        SM1012: "Street",
        SM1013: "Postal Code",
        SM1014: "City",
        SM1015: "Country",
        SM1016: "Birthday",
        SM1017: "Email",
        SM1018: "Phone",
        SM1019: "Alternative Phone",
        SM1020: "Career",
        SM1021: "Profession",
        SM1022: "Active by",
        SM1023: "Got attention by",
        SM1024: "Picture",
        SM1025: "Please choose a picture...",
        SM1026: "Choose picture",
        SM1027: "Download picture",
        SM1028: "Delete picture",
        SM1029: "Gender",
        SM1030: "Male",
        SM1031: "Female",
        SM1032: "VAT No.",
        SM1033: "Divers",
        SM1034: "Form validation failed",
        SM1035: "Bank Details",
        SM1036: "Bank Name",
        SM1037: "BIC",
        SM1038: "IBAN",
        SM1039: "Account owner",
        SM1040: "Custom Properties",
        SM1041: "VAT No.",
        SM1042: "VAT not mandatory",
        SM1043: "Social security number",
        SM1044: "Administration",
        SM1045: "Account status",
        SM1046: "Activated",
        SM1047: "Deactivated",
        SM1048: "Username",
        SM1049: "Experience level",
        SM1050: "simple projects",
        SM1051: "difficult projects",
        SM1052: "Previous Shopper ID",

        L0044: "Breitengrad",
        L0045: "Längengrad",
        L0046: "Geocode Quelle",
        L0083: "Ungültiger Wert"
      }
    };
  },

  methods: {
    openEditShopperDialog: function openEditShopperDialog() {
      var _this2 = this;

      this.bankDetailsData = {};
      if (this.dialogModeAdd) {
        this.dialogTitle = this.lang.SM1000;
        this.initEditShopperDialog();
        if (this.$refs.customPropertiesForm) this.$nextTick(function () {
          _this2.$refs.customPropertiesForm.getShopperProperties(function () {
            $("#editShopperDialog").modal("show");
          }, function () {
            _this2.globals.showErrorSnackbar("Shopper property data request failed");
            _this2.$emit("dialogClosed");
          });
        });
      } else {
        this.dialogTitle = this.lang.SM1001;
        var requestCount = 3;
        var successCallback = function successCallback() {
          if (--requestCount < 1) {
            $("#editShopperDialog").modal("show");
            _this2.resetValidationErrors("editShopperDialog");
          }
        };
        var errorCallback = function errorCallback() {
          _this2.globals.showErrorSnackbar("Shopper data request failed");
          _this2.$emit("dialogClosed");
        };
        this.getSelectedShopper(successCallback, errorCallback);
        this.getBankDetails(successCallback, errorCallback);

        if (this.$refs.customPropertiesForm) this.$refs.customPropertiesForm.getShopperProperties(successCallback, errorCallback);else successCallback();
      }
      this.resetValidationErrors("editShopperDialog");
    },
    getSelectedShopper: function getSelectedShopper(_success, _error) {
      var _this3 = this;

      var queryString = "api/Shopper/" + this.selectedShopperGuid;

      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this3.editShopperData = data;
          if (!_this3.editShopperData.Salutation) _this3.editShopperData.Salutation = "";
          if (_this3.editShopperData.Birthdate) _this3.fpBirthdate.setDate(_this3.editShopperData.Birthdate);
          _success();
        },
        error: function error() {
          console.error("Error on GET in getSelectedShopper()");
          _error();
        }
      });
    },
    closeEditShopperDialog: function closeEditShopperDialog() {
      $("#editShopperDialog").modal("hide");
    },
    initEditShopperDialog: function initEditShopperDialog() {
      var _this4 = this;

      var fieldsToRemove = ["Username", "ShopperGuid", "ShopperId", "VatNo", "VatNotMandatory", "Active", "MigratedShopperId"];
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.editShopperData).forEach(function (key) {
        fieldsToRemove.indexOf(key) < 0 ? _this4.editShopperData[key] = "" : delete _this4.editShopperData[key];
      });
      this.editShopperData.Active = true;
      this.editShopperData.ShopperSkillLevel = 3;
      this.fpBirthdate.clear();
    },

    // Triggers input validation and ensures further progress if validation was successful
    validateBeforeSubmit: function validateBeforeSubmit(dialog) {
      var result = true;
      var elements = $("#" + dialog).find(":input"); // Returns a list of all inputs on the dialog
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0) result = this.validateInput(elements[i].id) && result; // If only one input is invalid, the whole form is invalid
      }
      if (dialog === "editShopperDialog") {
        if (!result) {
          this.globals.showErrorSnackbar(this.lang.SM1034);
          return;
        }
        this.saveEditShopperData();
      }
    },

    // Validates an input with the given id, changes the input color depending on the validation result and returns the result
    validateInput: function validateInput(id) {
      // Checks validation depending on the input type or a given pattern in the template
      var result = id === "inputShopperBirthdate" ? $("#" + id)[0].value !== "" : $("#" + id)[0].checkValidity();
      if (result) {
        $("#" + id).parent().parent().removeClass("has-error"); // has-error has to be added to the form-group element
        var idx = this.invalidInputIds.indexOf(id);
        if (idx > -1) {
          this.invalidInputIds.splice(idx, 1); // Remove from list, if valid
        }
      } else {
        $("#" + id).parent().parent().addClass("has-error");
        if (this.invalidInputIds.indexOf(id) < 0) this.invalidInputIds.push(id); // Add to list, if invalid
      }
      return result;
    },

    // Returns true if an input has a validation error, otherwise false
    inputHasError: function inputHasError(id) {
      return this.invalidInputIds.indexOf(id) > -1 ? true : false;
    },

    // Resets all validation errors for the given dialog
    resetValidationErrors: function resetValidationErrors(dialog) {
      var elements = $("#" + dialog).find(":input"); // Returns a list of all inputs on the dialog
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0) $("#" + elements[i].id).parent().parent().removeClass("has-error");
      }
      this.invalidInputIds = [];
    },
    cleanUpEmptyData: function cleanUpEmptyData() {
      for (var prop in this.editShopperData) {
        if (typeof this.editShopperData[prop] === "string" && !this.editShopperData[prop]) delete this.editShopperData[prop];
      }
    },
    saveEditShopperData: function saveEditShopperData() {
      var _this5 = this;

      this.cleanUpEmptyData();
      var queryString = "api/Shopper";
      var reqMethod = "POST";

      if (!this.dialogModeAdd) {
        queryString += "/" + this.selectedShopperGuid;
        reqMethod = "PUT";
      } else this.editShopperData.Active = true;

      if (!this.editShopperData.ProfilePictureGuid) delete this.editShopperData.ProfilePictureGuid;

      var requestCount = 2;
      var successCallback = function successCallback() {
        if (--requestCount < 1) {
          var successMsg = _this5.dialogModeAdd ? "Shopper creation successful" : "Shopper update successful";
          _this5.globals.showSuccessSnackbar(successMsg);
          _this5.closeEditShopperDialog();
          _this5.$emit("dialogDataSaved");
        }
      };
      var errorCallback = function errorCallback() {
        var errorMsg = _this5.dialogModeAdd ? "Shopper creation failed" : "Shopper update failed";
        _this5.globals.showErrorSnackbar(errorMsg);
      };

      if (this.$refs.customPropertiesForm) {
        var custPropData = this.$refs.customPropertiesForm.saveShopperProperties(successCallback, errorCallback);
        if (custPropData && custPropData.Properties) {
          requestCount--;
          if (custPropData.Properties[0]) this.editShopperData.Properties = custPropData.Properties;
        }
      }

      $.ajax({
        method: reqMethod,
        url: queryString,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.editShopperData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          successCallback();
        },
        error: function error() {
          console.error("Error on " + reqMethod + " in saveEditShopperData()");
          errorCallback();
        }
      });
    },
    onShopperProfilePictureFileChange: function onShopperProfilePictureFileChange(e) {
      var _this6 = this;

      var files = e.target.files || e.dataTransfer.files;
      if (!files.length || !files[0].name) {
        this.editShopperData.ProfilePictureGuid = "";
        this.profilePictureFileObject = {};
        return;
      }
      this.profilePictureFileObject = files[0];
      if (this.profilePictureFileObject.type.indexOf("image/") < 0) {
        this.globals.showErrorSnackbar("Invalid file type");
        e.target.value = null;
        return;
      }

      var callback = function callback() {
        var uploadSuccess = function uploadSuccess(data) {
          _this6.editShopperData.ProfilePictureGuid = data[0].DownloadId;
          _this6.editShopperData.ProfilePictureFileName = _this6.profilePictureFileObject.name;
          _this6.globals.showSuccessSnackbar("Profile picture upload successful");
          _this6.$forceUpdate();
        };

        _this6.globals.uploadFile(_this6.profilePictureFileObject, uploadSuccess);
        e.target.value = null;
      };

      this.profilePictureFileObject.imageUrl = URL.createObjectURL(this.profilePictureFileObject);
      this.globals.getImageOrientation(this.profilePictureFileObject, function (orientation) {
        _this6.globals.resetImageOrientation(_this6.profilePictureFileObject, orientation, function (data) {
          _this6.profilePictureFileObject = data;
          callback();
        });
      });
    },
    removeShopperProfilePictureFile: function removeShopperProfilePictureFile() {
      $("#inputShopperProfilePictureFile")[0].value = null;
      this.editShopperData.ProfilePictureGuid = "";
      this.editShopperData.ProfilePictureFileName = "";
      this.profilePictureFileObject = {};
      this.$forceUpdate();
    },
    getBankDetails: function getBankDetails(_success2, _error2) {
      var _this7 = this;

      if (!this.globals.isAccessAllowed("LoopOp_ShopperBankDetails_ReadAll")) {
        _success2();
        return;
      }

      var queryString = "api/Shopper/" + this.selectedShopperGuid + "/BankDetails";

      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          if (data) {
            if (!_.isEmpty(data)) {
              _this7.bankDetailsData = data[0];
            } else {
              _this7.bankDetailsData = {};
            }
            _success2();
          } else _error2();
        },
        error: function error() {
          console.error("Error on GET in getBankDetails()");
          _this7.bankDetailsData = {};
          _error2();
        }
      });
    },

    //TODO: bank details are readonly for now but later it might be necessary to change values for MSM users
    // saveBankDetails(success, error) {
    //   let queryString = `api/Shopper/${this.selectedShopperGuid}/BankDetails`;
    //   let reqMethod = "POST";
    //   if (this.bankDetailsData.BankDetailsGuid) {
    //     queryString += "/" + this.bankDetailsData.BankDetailsGuid;
    //     reqMethod = "PUT";
    //   }

    //   $.ajax({
    //     method: reqMethod,
    //     url: queryString,
    //     data: JSON.stringify(this.bankDetailsData),
    //     dataType: "json",
    //     contentType: "application/json; charset=utf-8",
    //     success: data => {
    //       if (data && !_.isEmpty(data)) {
    //         this.bankDetailsData = data;
    //       }
    //       success();
    //     },
    //     error: () => {
    //       console.error("Error on PUT in saveProfileData()");
    //       error();
    //     }
    //   });
    // },
    openFileSelector: function openFileSelector() {
      $("#inputShopperProfilePictureFile").click();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ShopperEditModal__ = __webpack_require__(1612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ShopperEditModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ShopperEditModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CustomPropertyEditModal__ = __webpack_require__(1604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CustomPropertyEditModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CustomPropertyEditModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Tools_Dialogs_ChangePasswordDialog__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Tools_Dialogs_ChangePasswordDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Tools_Dialogs_ChangePasswordDialog__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ShopperManagement",
  components: {
    "shopper-edit-modal": __WEBPACK_IMPORTED_MODULE_1__ShopperEditModal___default.a,
    "custom-property-edit-modal": __WEBPACK_IMPORTED_MODULE_2__CustomPropertyEditModal___default.a,
    "change-password-dialog": __WEBPACK_IMPORTED_MODULE_3__Tools_Dialogs_ChangePasswordDialog___default.a
  },
  data: function data() {
    return {
      searchString: "",
      pageSize: 20,
      selectedPage: 1,
      pageCount: 0,
      totalElementsCount: 0,
      refreshEnabled: false,
      shoppersList: [],
      currentSort: { key: "FirstName", asc: true },
      showEditShopperDataDialog: false,
      showCustomPropertyEditDialog: false,
      occupationalGroupList: {},
      selectedShopper: {},
      editShopperDialogModeAdd: true,
      showChangePasswordDialog: false,
      filterStrings: {
        Search: "",
        ShopperId: "",
        Username: "",
        FirstName: "",
        LastName: "",
        Gender: "",
        PostalCode: "",
        City: "",
        CountryCode: "",
        Email: "",
        Age: "",
        NumberOfChecks: "",
        Active: ""
      },
      lang: {
        SM0000: "Refresh",
        SM0001: "New Shopper",
        SM0002: "Edit",
        SM0003: "Properties",
        SM0004: "Search...",
        SM0005: "Items per page",
        SM0006: "First page",
        SM0007: "Last page",
        SM0008: "First Name",
        SM0009: "Last Name",
        SM0010: "Username",
        SM0011: "Gender",
        SM0012: "Postal Code",
        SM0013: "City",
        SM0014: "Email",
        SM0015: "Age",
        SM0016: "Number of checks",
        SM0017: "Delete",
        SM0018: "Password",
        SM0019: "Search",
        SM0020: "Export",
        SM0021: "Shopper Export",
        SM0022: "Download",
        SM0023: "Cancel",
        SM0024: "Export Selected Shopper",
        SM0025: "View Shopper Checks",
        SM0026: "Assignment",
        SM0027: "Delete Shoppper",
        SM0028: "Yes",
        SM0029: "No",
        SM0030: "Do you really want to delete this shopper?",
        SM0031: "ID",
        SM0032: "First name",
        SM0033: "Last name",
        SM0034: "Active",
        SM0035: "Total shoppers count",
        SA0021: "ShopperID"
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.readComponentSettingsFromStore();
    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this, this.setTableHeight);
      this.globals.getOccupationalGroupList(function (callbackData) {
        _this.occupationalGroupList = callbackData;
      });
    }
    this.getShoppersList();
    // Sets the new table height after the window got resized
    $(window).on("resize", this.setTableHeight).resize();

    if (!this.globals.currentUserInfo) this.globals.$once("currentUserInfoReceived", this.setTableHeight);

    // Register global events
    // Export
    this.globals.$off("ExportShopperYesConfirmation");
    this.globals.$on("ExportShopperYesConfirmation", function () {
      _this.exportSelectedShopper();
    });

    // Delete shopper
    this.globals.$off("DeleteShopperYesConfirmation");
    this.globals.$on("DeleteShopperYesConfirmation", function () {
      _this.deleteSelectedShopper();
    });
  },
  destroyed: function destroyed() {
    this.writeComponentSettingsToStore();
    $(window).off("resize", this.setTableHeight);
  },

  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      var _this2 = this;

      this.globals.getLanguageStrings(this, this.setTableHeight);
      this.globals.getOccupationalGroupList(function (callbackData) {
        _this2.occupationalGroupList = callbackData;
      });
    }
  },
  methods: {
    setTableHeight: function setTableHeight() {
      this.$nextTick(function () {
        var height = $(window).height();
        height -= $("#shoppermanagement-top-panel").height() + $("#app-navbar").height() + $("#shoppermanagement .main-table > thead").height() + 47;
        $("#shoppermanagement .main-table-scrollbar").css("max-height", height);
      });
    },
    readComponentSettingsFromStore: function readComponentSettingsFromStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      var storedData = this.$store.getters["localFilters/shopperManagement"];
      if (storedData) {
        for (var key in storedData) {
          if (_.has(this, key)) this[key] = _.cloneDeep(storedData[key]);
        }
      }
    },
    writeComponentSettingsToStore: function writeComponentSettingsToStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      this.$store.commit("localFilters/shopperManagement", {
        selectedShopper: this.selectedShopper,
        pageSize: this.pageSize,
        selectedPage: this.selectedPage,
        currentSort: this.currentSort,
        filterStrings: this.filterStrings
      });
    },
    getShoppersList: function getShoppersList() {
      var _this3 = this;

      var queryString = "api/Shopper/Get?page_size=" + this.pageSize + "&page=" + this.selectedPage + "&sort_column=" + this.currentSort.key + "&sort_order=" + (this.currentSort.asc ? "asc" : "desc");
      queryString = encodeURI(queryString);

      var filter = _.pickBy(this.filterStrings, function (value, key) {
        if (key === "Active" && value.length > 0) return true;
        return value.length > 0;
      });
      if (typeof filter.Active === "string") filter.Active = filter.Active === "true" ? true : false;

      this.refreshEnabled = false;

      $.ajax({
        method: "POST",
        url: queryString,
        data: _.isEmpty(filter) ? "" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ Filter: filter }),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          _this3.shoppersList = data[0].Shoppers;
          _this3.pageCount = data[0].Page_Count;
          _this3.totalElementsCount = data[0].Count;
        },
        error: function error() {
          console.error("Shopper data request failed in getShoppersList()");
          _this3.globals.showErrorSnackbar("Shopper data access failed");
        },
        complete: function complete() {
          _this3.refreshEnabled = true;
        }
      });
    },
    updateActiveFilter: function updateActiveFilter() {
      if (!this.filterStrings.Active) this.filterStrings.Active = "true";else if (this.filterStrings.Active === "true") this.filterStrings.Active = "false";else this.filterStrings.Active = "";
    },
    updatePaging: function updatePaging(pageNumber, pageSize) {
      this.selectedPage = pageNumber || 1;
      if (pageSize != 0) this.pageSize = pageSize;
      this.getShoppersList();
    },
    getRange: function getRange(min, max, step) {
      var range = [],
          j = 0;
      for (var i = min; i <= max; i += step) {
        range[j++] = i;
      }
      return range;
    },
    getVisiblePages: function getVisiblePages() {
      if (this.pageCount <= 7) {
        return this.getRange(1, this.pageCount, 1);
      } else if (this.pageCount > 7 && this.selectedPage <= 4) {
        return this.getRange(1, 6, 1);
      } else if (this.pageCount > 7 && this.selectedPage >= this.pageCount - 3) {
        return this.getRange(this.pageCount - 5, this.pageCount, 1);
      } else {
        return this.getRange(this.selectedPage - 2, this.selectedPage + 2, 1);
      }
    },
    showSortArrow: function showSortArrow(key, asc) {
      return this.currentSort.key === key && this.currentSort.asc === asc;
    },
    orderTableByColumn: function orderTableByColumn(orderProp) {
      if (!orderProp && !this.currentSort.key) return;

      if (orderProp) {
        this.currentSort.key === orderProp ? this.currentSort.asc = !this.currentSort.asc : this.currentSort = { asc: true, key: orderProp };
      }
      this.getShoppersList();
    },
    isShopperSelected: function isShopperSelected() {
      return !!this.selectedShopper.ShopperGuid;
    },
    openEditShopperDialog: function openEditShopperDialog() {
      this.showEditShopperDataDialog = true;
    },
    onEditShopperDataClosed: function onEditShopperDataClosed() {
      this.showEditShopperDataDialog = false;
      // this.getShoppersList();
    },
    openCustomPropertyDialog: function openCustomPropertyDialog() {
      this.showCustomPropertyEditDialog = true;
    },
    onCustomPropertyDialogClosed: function onCustomPropertyDialogClosed() {
      this.showCustomPropertyEditDialog = false;
    },
    openShopperExportConfirmationDialog: function openShopperExportConfirmationDialog() {
      this.globals.$emit("openGlobalConfirmationDialog", this.getExportShopperData());
    },

    // TODO:
    getExportShopperData: function getExportShopperData() {
      return {
        initiator: "ExportShopper",
        confirmationTitle: this.lang.SM0021,
        yesButtonText: this.lang.SM0022,
        noButtonText: this.lang.SM0023,
        htmlText: "<p><b>" + this.lang.SM0024 + "</b></p>\n        <div class=\"form-group\">\n          <label class=\"col-md-4 text-black\">" + this.lang.SM0031 + "</label>\n          <label class=\"col-md-8 text-black\">" + this.selectedShopper.ShopperId + "</label>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-md-4 text-black\">" + this.lang.SM0032 + "</label>\n          <label class=\"col-md-8 text-black\">" + this.selectedShopper.FirstName + "</label>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-md-4 text-black\">" + this.lang.SM0033 + "</label>\n          <label class=\"col-md-8 text-black\">" + this.selectedShopper.LastName + "</label>\n        </div>"
      };
    },

    // TODO: implement export api
    exportSelectedShopper: function exportSelectedShopper() {
      console.log("export");
    },
    onEditShopperDialogDataSaved: function onEditShopperDialogDataSaved() {
      this.getShoppersList();
    },
    openDeleteShopperConfirmationDialog: function openDeleteShopperConfirmationDialog() {
      this.globals.$emit("openGlobalConfirmationDialog", this.getDeleteDialogData());
    },
    getDeleteDialogData: function getDeleteDialogData() {
      var shopper = this.selectedShopper;
      return {
        initiator: "DeleteShopper",
        confirmationTitle: this.lang.SM0027,
        colorRed: true,
        yesButtonText: this.lang.SM0028,
        noButtonText: this.lang.SM0029,
        htmlText: "<p><b>" + this.lang.SM0030 + "</b></p>\n        <div class=\"form-group\">\n          <label class=\"col-md-4 text-black\">" + this.lang.SM0031 + "</label>\n          <label class=\"col-md-8 text-black\">" + shopper.ShopperId + "</label>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-md-4 text-black\">" + this.lang.SM0032 + "</label>\n          <label class=\"col-md-8 text-black\">" + shopper.FirstName + "</label>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-md-4 text-black\">" + this.lang.SM0033 + "</label>\n          <label class=\"col-md-8 text-black\">" + shopper.LastName + "</label>\n        </div>"
      };
    },
    deleteSelectedShopper: function deleteSelectedShopper() {
      var _this4 = this;

      var queryString = "api/Shopper/" + this.selectedShopper.ShopperGuid;

      $.ajax({
        method: "DELETE",
        url: queryString,
        success: function success(data) {
          _this4.globals.showSuccessSnackbar("Shopper deletion successful");
          _this4.getShoppersList();
        },
        error: function error() {
          console.error("Shopper deletion failed in deleteSelectedShopper()");
          _this4.globals.showErrorSnackbar("Shopper deletion failed");
        }
      });
    },
    openChangePasswordDialog: function openChangePasswordDialog() {
      this.showChangePasswordDialog = true;
    },
    onChangePasswordDialogClosed: function onChangePasswordDialogClosed() {
      this.showChangePasswordDialog = false;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StatusWave_vue__ = __webpack_require__(1615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StatusWave_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__StatusWave_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StatusWaveDetail_vue__ = __webpack_require__(1616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StatusWaveDetail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__StatusWaveDetail_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StatusManagement',
  components: { StatusWave: __WEBPACK_IMPORTED_MODULE_1__StatusWave_vue___default.a, StatusWaveDetail: __WEBPACK_IMPORTED_MODULE_2__StatusWaveDetail_vue___default.a },
  mounted: function mounted() {
    this.getWaveData();
  },
  data: function data() {
    return {
      waveData: [],
      waveGuid: null,
      approvalStatus: null,
      search: null
    };
  },

  methods: {
    openDetails: function openDetails(e) {
      this.waveGuid = e;
    },
    getWaveData: function getWaveData() {
      var _this = this;

      $.ajax({
        url: "api/Status",
        method: "POST",
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ ApprovalStatus: this.approvalStatus, Search: this.search }),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          _this.waveData = [];
          if (!_.isEmpty(data)) _this.waveData = data;
        },
        error: function error() {
          console.error("Error on GET in getWaveData()");
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tools_StatIndicator_vue__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tools_StatIndicator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Tools_StatIndicator_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StatusWave',
  components: { StatIndicator: __WEBPACK_IMPORTED_MODULE_0__Tools_StatIndicator_vue___default.a },
  props: {
    wave: null
  }
});

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Tools_StatIndicator_vue__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Tools_StatIndicator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Tools_StatIndicator_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Tools_Select2__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Tools_Select2__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StatusWaveDetail',
  components: { StatIndicator: __WEBPACK_IMPORTED_MODULE_3__Tools_StatIndicator_vue___default.a, Select2: __WEBPACK_IMPORTED_MODULE_4__Tools_Select2___default.a },
  props: {
    waveGuid: null
  },
  data: function data() {
    return {
      statusData: null,
      selectedApprovalStatus: null,
      lang: {
        AWS000: "Wave Status",
        AWS001: "Project",
        AWS002: "Wave",
        AWS003: "Please select a project...",
        AWS004: "Please select a wave...",
        AWS005: "Check Status",
        AWS006: "Total check count",
        AWS007: "In approval",
        AWS008: "In progress",
        AWS009: "In reporting",
        AWS010: "In time",
        AWS011: "Approvals",
        AWS012: "None",
        AWS013: "Open",
        AWS014: "Approved",
        AWS015: "Wave charactertistics",
        AWS016: "Gender",
        AWS017: "Male",
        AWS018: "Female",
        AWS019: "Age",
        AWS020: "Min",
        AWS021: "Max",
        AWS022: "Above 70",
        AWS023: "Distance",
        AWS024: "Reg. year shopper car",
        AWS025: "Model match",
        AWS026: "Downgrade",
        AWS027: "Match",
        AWS028: "Upgrade",
        AWS029: "Audi cars",
        AWS030: "Model",
        AWS031: "Target value",
        AWS032: "Current value",
        AWS033: "Competitor cars",
        AWS034: "Close",
        AWS035: "Wave status access failed",
        AWS036: "Please select a approval status...",
        AWS037: "Cars",

        WV0044: "Brand"
      }
    };
  },

  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  mounted: function mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    this.getWaveStatus();
  },

  methods: {
    getWaveStatus: function getWaveStatus() {
      var _this = this;

      var query = 'api/ProjectWaves/' + this.waveGuid + '/AgencyStatus';
      if (this.selectedApprovalStatus) query += '?ApprovalStatus=' + this.selectedApprovalStatus;else query += "?ApprovalStatus=all";

      $.ajax({
        method: "GET",
        url: query,
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this.globals.showErrorSnackbar(data.Error);
            return;
          }
          if (data) _this.statusData = data;
        },
        error: function error(_error) {
          console.error("Error on GET in getWaveStatus()", _error);
          _this.globals.showErrorSnackbar(_this.lang.AWS035);
        }
      });
    },
    getGroupedCompetitorCars: function getGroupedCompetitorCars() {
      if (!this.statusData.CompetitorCarDistribution) {
        return [];
      }

      var carBrandMap = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a();
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.statusData.CompetitorCarDistribution), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var ccd = _step.value;

          if (!carBrandMap.has(ccd.CompetitorCarBrand)) {
            carBrandMap.set(ccd.CompetitorCarBrand, []);
          }
          carBrandMap.get(ccd.CompetitorCarBrand).push(ccd);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(carBrandMap);
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__packages_surveyjs_editor_surveyeditor_js__ = __webpack_require__(1752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__packages_surveyjs_editor_surveyeditor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__packages_surveyjs_editor_surveyeditor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__packages_surveyjs_editor_surveyeditor_css__ = __webpack_require__(1006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__packages_surveyjs_editor_surveyeditor_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__packages_surveyjs_editor_surveyeditor_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_survey_knockout__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_survey_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_survey_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_inputmask__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_inputmask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_inputmask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_select2__ = __webpack_require__(1542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_select2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_select2_dist_css_select2_css__ = __webpack_require__(1004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_select2_dist_css_select2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_select2_dist_css_select2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_ace_builds__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_ace_builds___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_ace_builds__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__SurveyElementSecurityModal__ = __webpack_require__(1618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__SurveyElementSecurityModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__SurveyElementSecurityModal__);









//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











var uuidv4 = __webpack_require__(60);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "SurveyEditor",
  components: { SurveyElementSecurityModal: __WEBPACK_IMPORTED_MODULE_16__SurveyElementSecurityModal___default.a },
  created: function created() {
    this.configureSurveyEditor();
    this.initializeEditorDesign();

    if (this.globals.selectedLanguage) {
      this.getEditorLocalization();
      this.globals.getLanguageStrings(this);
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.surveyId = parseInt(this.$route.query.id);

    this.lockSurvey(true);
    var heartBeatFunc = function heartBeatFunc() {
      _this.lockSurvey(true);
    };
    this.timer = setInterval(heartBeatFunc, this.heartBeat);

    // if (!this.globals.isProduction this.getKpiList();
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
    this.lockSurvey(false);
  },
  destroyed: function destroyed() {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(this.fpInstancesFromSurvey), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var instance = _step.value;

        if (instance) instance.destroy();
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  },

  methods: {
    calcDesignerHeight: function calcDesignerHeight() {
      this.designerHeight = $(window).height();
      this.designerHeight -= $("#app-navbar").height() + 240;
    },
    initializeEditor: function initializeEditor() {
      var _this2 = this;

      this.calcDesignerHeight();

      var editorOptions = {
        questionTypes: ["text", "checkbox", "radiogroup", "dropdown", "comment", "rating", "html", "file", "expression"],
        showEmbededSurveyTab: false,
        generateValidJSON: true,
        showTestSurveyTab: true,
        showJSONEditorTab: this.globals.isAccessAllowed("LoopOp_SurveyEditor_Read") && this.feature.isEnabled("surveyEditorJSONEditor"),
        showObjectTitles: true,
        showTitlesInExpressions: true,
        isAutoSave: false,
        designerHeight: this.designerHeight + "px"
      };

      // Store previous state and survey if editor instance already exists
      var saveState = void 0,
          currentSurvey = void 0;
      if (this.editor) {
        saveState = this.editor.stateValue;
        currentSurvey = this.editor.text;
      }

      this.editor = new __WEBPACK_IMPORTED_MODULE_9__packages_surveyjs_editor_surveyeditor_js__["SurveyEditor"]("surveyEditorContainer", editorOptions);
      this.editor.haveCommercialLicense = true;

      if (this.surveyData && this.surveyData.Survey) this.editor.text = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_json_stringify___default()(this.surveyData.Survey);

      this.configureToolbox();

      this.editor.saveSurveyFunc = function (saveNo, callback) {
        var survey = _this2.addUnsetMaxPointsTriggers(_.cloneDeep(_this2.editor.text));
        _this2.saveSurveyData(survey, saveNo, callback);
      };

      // Use tabs instead of accordion on modal
      this.editor.useTabsInElementEditor = true;

      this.initializeEditorEvents();

      // Restore previous editor state and survey
      if (currentSurvey) {
        this.editor.stateValue = saveState;
        this.updateSaveButtonColor(saveState);
        this.editor.text = currentSurvey;
      }

      // Add reset toolbox button to the toolbar
      this.editor.toolbarItems.splice(3, 0, {
        id: "clearCustomToolbox",
        visible: true,
        title: __WEBPACK_IMPORTED_MODULE_9__packages_surveyjs_editor_surveyeditor_js__["editorLocalization"].getLocale().ed.clearCustomToolbox || "Reset Toolbox",
        enabled: true,
        action: function action() {
          _this2.editor.toolbox.clearCopiedItems();
          _this2.editor.toolbox.expandAllCategories();
          localStorage.removeItem("surveyEditorToolboxConfig");
        }
      });

      // Add update button to rerender the whole editor
      this.editor.toolbarItems.splice(3, 0, {
        id: "updateEditorView",
        visible: true,
        title: __WEBPACK_IMPORTED_MODULE_9__packages_surveyjs_editor_surveyeditor_js__["editorLocalization"].getLocale().ed.updateEditorView || "Update View",
        enabled: true,
        action: function action() {
          var text = _this2.editor.text;
          var saveState = _this2.editor.stateValue;
          _this2.editor.render();
          _this2.editor.text = text;
          _this2.updateSaveButtonColor(saveState);
        }
      });

      if (!this.globals.isAccessAllowed("LoopOp_SurveyEditor_Update")) $(".svd_json_editor_area").prop("disabled", true);

      // Sets the new editor height after the window got resized
      $(window).on("resize", function () {
        _this2.calcDesignerHeight();
        _this2.editor.koDesignerHeight(_this2.designerHeight + "px");
      }).resize();
    },
    addUnsetMaxPointsTriggers: function addUnsetMaxPointsTriggers(surveyString) {
      var surveyJSON = JSON.parse(surveyString);
      var triggers = surveyJSON.triggers;
      var newTriggers = [];

      if (triggers) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(triggers), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var t = _step2.value;

            if (t.type === "runexpression" && t.runExpression && _.includes(t.runExpression, "setMaxPoints")) {
              var newTrigger = _.cloneDeep(t);
              newTrigger.expression = "!(" + newTrigger.expression + ")";
              newTrigger.runExpression = _.replace(newTrigger.runExpression, "setMaxPoints", "unsetMaxPoints");
              newTriggers.push(newTrigger);
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        surveyJSON.triggers = _.union(triggers, newTriggers);
        surveyString = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_json_stringify___default()(surveyJSON);
      }
      return surveyString;
    },
    removeUnsetMaxPointsTriggers: function removeUnsetMaxPointsTriggers(surveyString) {
      var surveyJSON = JSON.parse(surveyString);
      var triggers = surveyJSON.triggers;

      if (triggers) {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(triggers), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var t = _step3.value;

            if (t.type === "runexpression" && t.runExpression && _.includes(t.runExpression, "unsetMaxPoints")) {
              _.pull(triggers, t);
            }
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        surveyJSON.triggers = triggers;
        surveyString = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_json_stringify___default()(surveyJSON);
      }
      return surveyString;
    },
    lockSurvey: function lockSurvey(state) {
      var _this3 = this;

      var sendData = { Lock: state };
      var url = "api/Surveys/" + this.surveyId + "/Lock";
      $.ajax({
        method: "PATCH",
        url: url,
        data: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_json_stringify___default()(sendData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        global: false,
        success: function success(data) {
          if (data.Error) _this3.globals.showErrorSnackbar(data.Error);
        },
        error: function error() {
          console.error("Error on PUT in lockSurvey()");
          if (state) _this3.globals.showErrorSnackbar("Survey lock failed");else _this3.globals.showErrorSnackbar("Survey unlock failed");
        }
      });
    },
    initializeEditorEvents: function initializeEditorEvents() {
      var _this4 = this;

      var generateElementGUIDs = function generateElementGUIDs(element) {
        var elementType = element.getType();
        if (!elementType) return;

        element.guid = uuidv4();

        if (elementType === "panel" || elementType === "paneldynamic" || elementType === "page") {
          var elements = elementType === "paneldynamic" ? element.templateElements : element.elements;

          var _iteratorNormalCompletion4 = true;
          var _didIteratorError4 = false;
          var _iteratorError4 = undefined;

          try {
            for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(elements), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
              var el = _step4.value;

              generateElementGUIDs(el);
            }
          } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
              }
            } finally {
              if (_didIteratorError4) {
                throw _iteratorError4;
              }
            }
          }

          return;
        }

        if (element.choices) {
          var _iteratorNormalCompletion5 = true;
          var _didIteratorError5 = false;
          var _iteratorError5 = undefined;

          try {
            for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(element.choices), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
              var choice = _step5.value;

              choice.guid = uuidv4();
            }
          } catch (err) {
            _didIteratorError5 = true;
            _iteratorError5 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion5 && _iterator5.return) {
                _iterator5.return();
              }
            } finally {
              if (_didIteratorError5) {
                throw _iteratorError5;
              }
            }
          }
        }
        if (element.rateValues) {
          var _iteratorNormalCompletion6 = true;
          var _didIteratorError6 = false;
          var _iteratorError6 = undefined;

          try {
            for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(element.rateValues), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
              var value = _step6.value;

              value.guid = uuidv4();
            }
          } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion6 && _iterator6.return) {
                _iterator6.return();
              }
            } finally {
              if (_didIteratorError6) {
                throw _iteratorError6;
              }
            }
          }
        }
        if (element.columns) {
          var _iteratorNormalCompletion7 = true;
          var _didIteratorError7 = false;
          var _iteratorError7 = undefined;

          try {
            for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(element.columns), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
              var col = _step7.value;

              col.guid = uuidv4();
            }
          } catch (err) {
            _didIteratorError7 = true;
            _iteratorError7 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion7 && _iterator7.return) {
                _iterator7.return();
              }
            } finally {
              if (_didIteratorError7) {
                throw _iteratorError7;
              }
            }
          }
        }
        if (element.rows && Array.isArray(element.rows)) {
          var _iteratorNormalCompletion8 = true;
          var _didIteratorError8 = false;
          var _iteratorError8 = undefined;

          try {
            for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(element.rows), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
              var row = _step8.value;

              row.guid = uuidv4();
            }
          } catch (err) {
            _didIteratorError8 = true;
            _iteratorError8 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion8 && _iterator8.return) {
                _iterator8.return();
              }
            } finally {
              if (_didIteratorError8) {
                throw _iteratorError8;
              }
            }
          }
        }
      };

      var generateElementNames = function generateElementNames(element) {
        var elementType = element.getType();
        if (!elementType) return;

        if (elementType === "panel") {
          element.name = "g" + _.padStart(_this4.nextQuestionGroupId.toString(), 5, "0");
          _this4.nextQuestionGroupId++;
          element.title = element.isCluster ? __WEBPACK_IMPORTED_MODULE_9__packages_surveyjs_editor_surveyeditor_js__["editorLocalization"].getLocale().qt.cluster || "Cluster" : __WEBPACK_IMPORTED_MODULE_9__packages_surveyjs_editor_surveyeditor_js__["editorLocalization"].getLocale().qt.questiongroup || "Question Group";
        }

        if (elementType === "panel" || elementType === "paneldynamic" || elementType === "page") {
          var elements = elementType === "paneldynamic" ? element.templateElements : element.elements;

          var _iteratorNormalCompletion9 = true;
          var _didIteratorError9 = false;
          var _iteratorError9 = undefined;

          try {
            for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(elements), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
              var el = _step9.value;

              generateElementNames(el);
            }
          } catch (err) {
            _didIteratorError9 = true;
            _iteratorError9 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion9 && _iterator9.return) {
                _iterator9.return();
              }
            } finally {
              if (_didIteratorError9) {
                throw _iteratorError9;
              }
            }
          }

          return;
        }

        if (element.isCommentOf && element.isCommentOf.length > 0 || _.startsWith(element.name, "c")) {
          var idx = element.parent.elements.indexOf(element);

          // No main question available
          if (idx < 1) {
            element.parent.removeQuestion(element);
            return;
          }
          var main = element.parent.elements[idx - 1];
          // Upper question is not main question
          if (!main.hasCommentText) {
            element.parent.removeQuestion(element);
            return;
          }

          element.name = "c" + main.name.substring(1);
          element.isCommentOf = main.name;
        } else {
          // else, generate new question name
          element.name = "q" + _.padStart(_this4.nextQuestionId.toString(), 5, "0");
          _this4.nextQuestionId++;
        }
      };

      // Add maxPointsReached to result
      this.editor.onTestSurveyCreated.add(function (sender, options) {
        options.survey.onComplete.add(function (result) {
          var resultData = result.data;
          var questions = result.getAllQuestions();
          var maxPointsQuestions = [];

          var _iteratorNormalCompletion10 = true;
          var _didIteratorError10 = false;
          var _iteratorError10 = undefined;

          try {
            for (var _iterator10 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(questions), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
              var q = _step10.value;

              if (q.maxPointsReached) {
                maxPointsQuestions.push(q.name);
              }
            }
          } catch (err) {
            _didIteratorError10 = true;
            _iteratorError10 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion10 && _iterator10.return) {
                _iterator10.return();
              }
            } finally {
              if (_didIteratorError10) {
                throw _iteratorError10;
              }
            }
          }

          if (maxPointsQuestions.length > 0) resultData.maxPointsReached = maxPointsQuestions;else delete resultData.maxPointsReached;

          result.data = resultData;
        });
      });

      // Adds guids to all new elements in the survey
      this.editor.onQuestionAdded.add(function (sender, options) {
        var parent = options.question.parent;
        if (parent.getType() === "page" && parent.elements.length == 2) {
          var _iteratorNormalCompletion11 = true;
          var _didIteratorError11 = false;
          var _iteratorError11 = undefined;

          try {
            for (var _iterator11 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(parent.elements), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
              var el = _step11.value;

              if (el.isCluster) {
                parent.removeElement(options.question);
                el.addQuestion(options.question);
              }
            }
          } catch (err) {
            _didIteratorError11 = true;
            _iteratorError11 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion11 && _iterator11.return) {
                _iterator11.return();
              }
            } finally {
              if (_didIteratorError11) {
                throw _iteratorError11;
              }
            }
          }
        }

        generateElementGUIDs(options.question);
        generateElementNames(options.question);
        if (_.startsWith(options.question.name, "q") && options.question.getType() !== "html") options.question.isRequired = true;

        if (!options.question.hasTitle || options.question.title === options.question.name) options.question.title = options.question.name;

        var questionType = options.question.getType();

        if (options.question.choices) {
          var _iteratorNormalCompletion12 = true;
          var _didIteratorError12 = false;
          var _iteratorError12 = undefined;

          try {
            for (var _iterator12 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(options.question.choices), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
              var item = _step12.value;

              if (!item.hasText) item.text = item.value;
            }
          } catch (err) {
            _didIteratorError12 = true;
            _iteratorError12 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion12 && _iterator12.return) {
                _iterator12.return();
              }
            } finally {
              if (_didIteratorError12) {
                throw _iteratorError12;
              }
            }
          }
        }
        if (options.question.columns) {
          for (var i = 0; i < options.question.columns.length; i++) {
            if (options.question.columns[i].name) options.question.columns[i].name = "column" + (i + 1);else options.question.columns[i].value = "item" + (i + 1);
          }
        }
        if (options.question.rows) {
          for (var i = 0; i < options.question.rows.length; i++) {
            options.question.rows[i].value = "item" + (i + 1);
            options.question.rows[i].text = options.question.rows[i].value;
          }
        }

        // Do not store files in JSON result as base64 as default
        if (questionType === "file") {
          options.question.storeDataAsText = false;
          options.question.showPreview = true;
          options.question.imageHeight = 150;
        }

        if (questionType === "text" || questionType === "comment" || questionType === "matrixdropdown" || questionType === "matrixdynamic") {
          options.question.translationRequired = true;
        }
      });
      this.editor.onPanelAdded.add(function (sender, options) {
        var parent = options.panel.parent;
        if (parent.elements.length > 1 && options.panel.isCluster) {
          parent.removeElement(options.panel);
          _this4.globals.showErrorSnackbar("No cluster allowed here");
          return;
        }
        if (parent.elements.length == 2) {
          var _iteratorNormalCompletion13 = true;
          var _didIteratorError13 = false;
          var _iteratorError13 = undefined;

          try {
            for (var _iterator13 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(parent.elements), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
              var el = _step13.value;

              if (el.isCluster) {
                parent.removeElement(options.panel);
                el.addQuestion(options.panel);
              }
            }
          } catch (err) {
            _didIteratorError13 = true;
            _iteratorError13 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion13 && _iterator13.return) {
                _iterator13.return();
              }
            } finally {
              if (_didIteratorError13) {
                throw _iteratorError13;
              }
            }
          }
        }
        var parentType = parent.getType();
        if (!(parentType === "page" || parentType === "panel" && parent.isCluster === true && options.panel.isCluster === false)) {
          parent.removeQuestion(options.panel);
          parent.parent.addQuestion(options.panel);
        }
        generateElementGUIDs(options.panel);
        generateElementNames(options.panel);

        var isCluster = !!options.panel.isCluster;
        if (isCluster) {
          options.panel.backgroundColor = "#FFFFFF";
        }
        __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("panel", "backgroundColor").visible = isCluster;
        __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("panel", "weight").visible = isCluster;
      });
      this.editor.onPageAdded.add(function (sender, options) {
        generateElementGUIDs(options.page);
        generateElementNames(options.page);
      });
      this.editor.onItemValueAdded.add(function (sender, options) {
        if (options.newItem) {
          options.newItem.guid = uuidv4();
          options.newItem.text = options.newItem.value;
        }
      });
      this.editor.onMatrixColumnAdded.add(function (sender, options) {
        options.newColumn.guid = uuidv4();
      });

      this.editor.onElementDoubleClick.add(function (sender, options) {
        var elementType = options.element.getType();
        if (elementType === "panel" || elementType === "paneldynamic") return;
        _this4.editor.showElementEditor(options.element);
      });

      // Set exclusive value for checkboxes on survey test
      this.editor.onTestSurveyCreated.add(function (sender, options) {
        options.survey.onValueChanged.add(function (sender, options) {
          var q = options.question;
          //If question is not defined or question is not checkbox or exclusiveValue does not exist do nothing
          if (!q || q.getType() != "checkbox" || !q.exclusiveValue) return;
          //returns if the value set for the first time or there is nothing to do
          if (!q.prevValue || !options.value) {
            q.prevValue = options.value;
            return;
          }
          var index = options.value.indexOf(q.exclusiveValue);
          //has "None of the above selected"
          if (index > -1) {
            //"None of the above selected" was selected before
            if (q.prevValue.indexOf(q.exclusiveValue) > -1) {
              var value = options.value;
              value.splice(index, 1);
              q.value = value;
            } else {
              //none select just now
              q.value = [q.exclusiveValue];
            }
          }
          q.prevValue = _.clone(q.value);
        });
      });

      // Fill noneGuid property if hasNone is selected
      this.editor.onPropertyValueChanging.add(function (sender, options) {
        if (options.propertyName !== "hasNone") return;
        if (options.value) options.obj.noneGuid = uuidv4();else options.obj.noneGuid = "";
      });

      // Disable dropping questions or panels in some cases
      this.editor.onDragDropAllow.add(function (sender, options) {
        var target = options.target;
        var parent = options.parent;

        // If there is a cluster, no questions outside the cluster allowed
        if (parent.getType() === "page" && parent.elements.length === 1 && parent.elements[0].isCluster === true) options.allow = false;
        // New clusters can only be added to an empty page
        else if (parent.getType() === "page" && parent.elements.length > 0 && target.isCluster === true) options.allow = false;
          // No cluster in cluster and no questiongroup in questiongroup allowed
          else if (target.getType() === "panel" && parent.getType() === "panel") {
              if (parent.isCluster === false) options.allow = false;else if (parent.isCluster && target.isCluster) options.allow = false;
            }
      });

      // Predefine filetypes for video upload questions
      this.editor.onPropertyValueChanging.add(function (sender, options) {
        if (options.propertyName !== "isVideoUpload") return;

        if (options.value) {
          options.obj.acceptedTypes = "video/*";
          options.obj.isPictureUpload = false;
        }

        // if (options.value) {
        //   let acceptedTypes = options.obj.acceptedTypes || "";
        //   for (let type of this.videoFileTypes) {
        //     if (acceptedTypes.indexOf(type) < 0) {
        //       if (acceptedTypes) acceptedTypes += ", " + type;
        //       else acceptedTypes += type;
        //     }
        //   }
        //   options.obj.acceptedTypes = acceptedTypes;
        // } else {
        //   let acceptedTypes = options.obj.acceptedTypes;
        //   for (let type of this.videoFileTypes) {
        //     let idx = acceptedTypes.indexOf(type);
        //     if (idx < 0) continue;

        //     if (idx == 0) {
        //       acceptedTypes = _.replace(acceptedTypes, type, "");
        //       acceptedTypes = _.trimStart(acceptedTypes, ", ");
        //     } else acceptedTypes = _.replace(acceptedTypes, ", " + type, "");
        //   }
        //   options.obj.acceptedTypes = acceptedTypes;
        // }
      });

      // Predefine filetypes for video upload questions
      this.editor.onPropertyValueChanging.add(function (sender, options) {
        if (options.propertyName !== "isPictureUpload") return;
        if (options.value) {
          options.obj.acceptedTypes = "image/*";
          options.obj.isVideoUpload = false;
        }
      });

      // Automatically add and remove comment questions depending on hasCommentText state
      this.editor.onModified.add(function (sender, options) {
        // Add or remove comment depending on hasCommentText state
        if (options.type === "PROPERTY_CHANGED" && options.name === "hasCommentText") {
          if (options.newValue === true) {
            var comment = __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["QuestionFactory"].Instance.createQuestion("text", "c" + options.target.name.substring(1));
            var idx = options.target.parent.elements.indexOf(options.target);
            options.target.parent.addQuestion(comment, idx + 1);
            comment.isCommentOf = options.target.name;
            comment.visibleIf = options.target.visibleIf;
            comment.isRequired = false;
          } else {
            //Remove comment question
            var _comment = options.target.survey.getQuestionByName("c" + options.target.name.substring(1));
            if (!_comment) return;
            _comment.parent.removeQuestion(_comment);
          }
          _this4.editor.surveyObjects.selectObject(options.target);
        }

        // If question is deleted, also delete comment
        if (options.type === "OBJECT_DELETED" && options.target.hasCommentText) {
          var _comment2 = options.target.survey.getQuestionByName("c" + options.target.name.substring(1));
          if (!_comment2) return;
          _comment2.parent.removeQuestion(_comment2);
        } else if (options.type === "OBJECT_DELETED" && options.target.isCommentOf) {
          // If comment is deleted, disable hasCommentText on question
          var question = options.target.survey.getQuestionByName(options.target.isCommentOf);
          if (!question) return;
          question.hasCommentText = false;
          _this4.editor.surveyObjects.selectObject(question);
        }
      });

      // Adding questions from toolbox
      this.editor.onModified.add(function (sender, options) {
        if (options.type !== "ADDED_FROM_TOOLBOX") return;

        // If question is added from toolbox between question with comment, move comment back behind question
        var parent = options.question.parent;
        if (!parent) return;

        var idx = -1;
        for (var i = 0; i < parent.elements.length; i++) {
          if (parent.elements[i].name === options.question.name) {
            if (parent.elements[i + 1] && parent.elements[i + 1].isCommentOf) idx = i;
            break;
          }
        }
        if (idx >= 0) {
          var comment = options.question.survey.getQuestionByName(parent.elements[idx + 1].name);
          if (comment) {
            comment.parent.removeQuestion(comment);
            parent.addQuestion(comment, idx);
          }
        }

        // If question with comment is added from custom toolbox, create comment question
        if (options.question.hasCommentText) {
          var _comment3 = __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["QuestionFactory"].Instance.createQuestion("text", "c" + options.question.name.substring(1));
          var _idx = parent.elements.indexOf(options.question);
          options.question.parent.addQuestion(_comment3, _idx + 1);
          _comment3.isCommentOf = options.question.name;
          _comment3.visibleIf = options.question.visibleIf;
          _comment3.isRequired = false;
        }
        _this4.editor.surveyObjects.selectObject(options.question);
      });

      // Dropping question in editor
      this.editor.onModified.add(function (sender, options) {
        if (options.type !== "DO_DROP") return;

        if (!options.moveToParent) return;
        // If question is moved, also move comment
        if (options.target.hasCommentText === true && options.source) {
          var comment = options.target.survey.getQuestionByName("c" + options.target.name.substring(1));
          if (!comment) return;
          comment.parent.removeQuestion(comment);
          var newIdx = options.moveToIndex;
          for (var i = 0; i < options.moveToParent.elements.length; i++) {
            if (options.moveToParent.elements[i].name === options.target.name) {
              newIdx = i + 1;
              break;
            }
          }
          options.moveToParent.addQuestion(comment, newIdx);
        } else if (options.target.isCommentOf) {
          // If comment is moved, also move question
          var question = options.target.survey.getQuestionByName(options.target.isCommentOf);
          if (!question) return;
          question.parent.removeQuestion(question);
          var _newIdx = options.moveToIndex;
          for (var _i = 0; _i < options.moveToParent.elements.length; _i++) {
            if (options.moveToParent.elements[_i].name === options.target.name) {
              _newIdx = _i;
              break;
            }
          }
          options.moveToParent.addQuestion(question, _newIdx);
        } else if (options.moveToParent.elements[options.moveToIndex + 1] && options.moveToParent.elements[options.moveToIndex + 1].isCommentOf) {
          // If other question is moved between question and comment from below, move comment back behind question
          var _comment4 = options.moveToParent.elements[options.moveToIndex + 1];
          if (!_comment4) return;
          _comment4.parent.removeQuestion(_comment4);
          options.moveToParent.addQuestion(_comment4, options.moveToIndex);
        } else if (options.moveToParent.elements[options.moveToIndex] && options.moveToParent.elements[options.moveToIndex].isCommentOf) {
          // If other question is moved between question and comment from above, move comment back behind question
          var _comment5 = options.moveToParent.elements[options.moveToIndex];
          if (!_comment5) return;
          _comment5.parent.removeQuestion(_comment5);
          options.moveToParent.addQuestion(_comment5, options.moveToIndex - 1);
        }

        // If new question with comment is added from custom toolbox, create comment question
        if (options.target.hasCommentText === true && !options.source) {
          var _comment6 = __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["QuestionFactory"].Instance.createQuestion("text", "c" + options.target.name.substring(1));
          var idx = options.moveToIndex + 1;
          if (options.moveToParent.elements[options.moveToIndex].isCommentOf) idx++;
          options.moveToParent.addQuestion(_comment6, idx);
          _comment6.isCommentOf = options.target.name;
          _comment6.visibleIf = options.target.visibleIf;
          _comment6.isRequired = false;
        }

        // Select the question that was moved
        var touchedElement = options.newElement;
        if (!touchedElement) touchedElement = options.target;
        _this4.editor.surveyObjects.selectObject(touchedElement.survey.getQuestionByName(touchedElement.name));
      });

      // Disable fast entry for choices
      this.editor.onSetPropertyEditorOptions.add(function (sender, options) {
        options.editorOptions.showTextView = false;
      });

      // Add upload functionality for survey test
      this.editor.onTestSurveyCreated.add(function (sender, options) {
        options.survey.onUploadFiles.add(function (sender, options) {
          if (!_this4.globals.isAccessAllowed("LoopOp_Upload_Create")) {
            _this4.globals.showErrorSnackbar("Permission denied");
            options.callback("error");
            return;
          }

          var files = options.files;
          if (!files || !files[0]) {
            _this4.globals.showErrorSnackbar("Error on file upload");
            console.error("No upload file available");
            options.callback("error");
            return;
          }

          var uploadCount = files.length;
          var question = sender.getQuestionByName(options.name);
          var callbackData = [];

          files.forEach(function (file) {
            var containsImage = _.startsWith(file.type, "image");

            if (question.acceptedTypes) {
              if (!_this4.globals.isValidFileType(file, question.acceptedTypes)) {
                _this4.globals.showErrorSnackbar("Wrong file type: " + file.name);
                console.error("file type mismatch: " + file.name + " - accepted types: " + question.acceptedTypes);
                options.callback("error");
                return;
              }
            }

            var callback = function callback() {
              var uploadSuccess = function uploadSuccess(data) {
                callbackData.push({
                  file: file,
                  content: data[0].DownloadId
                });
                if (--uploadCount < 1) {
                  options.callback("success", callbackData);
                  _this4.globals.showSuccessSnackbar("Attachment upload successful");
                }
              };
              var uploadError = function uploadError() {
                options.callback("error");
              };

              _this4.globals.uploadFile(file, uploadSuccess, uploadError);
            };
            file.imageUrl = URL.createObjectURL(file);
            if (containsImage) _this4.globals.getImageOrientation(file, function (orientation) {
              _this4.globals.resetImageOrientation(file, orientation, function (data) {
                file = data;
                callback();
              });
            });else callback();
          });
        });

        options.survey.onDownloadFile.add(function (sender, options) {
          options.callback("success", "/api/download/" + options.content);
        });
      });

      this.editor.onDesignerSurveyCreated.add(function (editor, opt) {
        // Select cluster background color in designer survey
        opt.survey.onUpdatePanelCssClasses.add(function (sender, options) {
          if (!options.panel.isCluster) return;
          var pName = options.panel.name;
          var panelContainer = options.cssClasses.panel.container;

          if (panelContainer.indexOf(pName) < 0) {
            panelContainer += " background-" + pName;
            options.cssClasses.panel.container = panelContainer;
            $(".background-" + pName).css("background", options.panel.backgroundColor);
          }
        });

        // Toggle visibility of panel background property depending on panel type
        opt.survey.onSelectedElementChanged.add(function (sender, options) {
          if (!options.newElement || options.newElement.getType() !== "panel") return;

          var isCluster = !!options.newElement.isCluster;
          __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("panel", "backgroundColor").visible = isCluster;
          __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("panel", "weight").visible = isCluster;
        });

        // Store reference of selected survey element
        opt.survey.onSelectedElementChanged.add(function (sender, options) {
          if (!options.newElement) return;
          if (!options.newElement.guid) {
            console.error("missing element guid: ", options.newElement);
            _this4.globals.showErrorSnackbar("Missing element guid");
            return;
          }
          _this4.selectedSurveyElement = options.newElement;
        });
      });

      this.editor.onTestSurveyCreated.add(function (editor, opt) {
        // Select cluster background color in test survey
        opt.survey.onUpdatePanelCssClasses.add(function (sender, options) {
          if (!options.panel.isCluster) return;
          var pName = options.panel.name;
          var panelContainer = options.cssClasses.panel.container;

          if (panelContainer.indexOf(pName) < 0) {
            panelContainer += " background-" + pName;
            options.cssClasses.panel.container = panelContainer;
            $(".background-" + pName).css("background", options.panel.backgroundColor);
          }
        });
      });

      // Mark upper right corner of questions with visibleIf
      this.editor.onDesignerSurveyCreated.add(function (editor, options) {
        options.survey.onAfterRenderQuestion.add(function (survey, options) {
          if (options.question.visibleIf) $(options.htmlElement).addClass("sv_element_with_visibleif");
        });
      });

      // Make visibleIf reactive
      this.editor.onPropertyValueChanging.add(function (sender, options) {
        if (options.propertyName !== "visibleIf") return;

        if (options.value) $(options.obj.renderedElement).addClass("sv_element_with_visibleif");else $(options.obj.renderedElement).removeClass("sv_element_with_visibleif");
      });

      // Display point values on element templates
      this.editor.onDesignerSurveyCreated.add(function (editor, options) {
        // Points for questions
        options.survey.onAfterRenderQuestion.add(function (survey, options) {
          var pointsMax = options.question.pointsMax || 0;

          var pointsHtml = "\n            <div class=\"points-max-on-element\">\n              <span>" + __WEBPACK_IMPORTED_MODULE_9__packages_surveyjs_editor_surveyeditor_js__["editorLocalization"].getLocale().pe.pointsMax + ": </span>\n              <span class=\"points-max-value\">\n                " + pointsMax + "\n              </span>\n            </div>";

          $(options.htmlElement).append(pointsHtml);
        });

        // Points for panels
        options.survey.onAfterRenderPanel.add(function (survey, options) {
          if (!options.panel.pointsMax) _this4.calcPointsMaxOfContainer(options.panel);
          var pointsMax = options.panel.pointsMax || 0;

          var pointsHtml = "\n            <div class=\"points-max-on-element\">\n              <span>" + __WEBPACK_IMPORTED_MODULE_9__packages_surveyjs_editor_surveyeditor_js__["editorLocalization"].getLocale().pe.pointsMax + ": </span>\n              <span class=\"points-max-value\">\n                " + (pointsMax ? pointsMax : 0) + "\n              </span>\n            </div>";

          $(options.htmlElement).append(pointsHtml);
        });

        // Points calculation for container elements and survey header
        options.survey.onAfterRenderSurvey.add(function (survey, options) {
          _this4.calcPointsMaxOfContainer(options.survey);

          var pointsMaxSpan = "<span class=\"points-max-on-survey\">(" + __WEBPACK_IMPORTED_MODULE_9__packages_surveyjs_editor_surveyeditor_js__["editorLocalization"].getLocale().pe.pointsMax + ": \n            " + options.survey.pointsMax + ")</span>";

          $(options.htmlElement).find(".sv_container > .panel-heading > h3").append(pointsMaxSpan);
        });
      });
      this.editor.onAdornerRendered.add(function (editor, options) {
        if (options.adorner === "choices-label") {
          // Add points to choices
          var answerDivs = $(options.element).find("item-editor");
          var choices = options.question.choices;
          var pointsLabel = void 0,
              points = 0,
              maxPoints = 0;

          if (options.context) {
            points = options.context.points || 0;
            if (typeof options.context.maxPoints === "number") maxPoints = options.context.maxPoints;else maxPoints = options.question.pointsMax || 0;
          }

          pointsLabel = "\n              <label style=\"padding: 0;\">(" + points + "/" + maxPoints + ")</label>\n            ";
          $(answerDivs[0].parentElement).append(pointsLabel);
        } else if (options.adorner === "select-choices") {
          // Add points to select choices
          var _answerDivs = $(options.element).find("item-editor");
          var _choices = options.question.choices;
          var pointsHtml = void 0,
              _points = void 0,
              _maxPoints = void 0;

          for (var i = 0; i < _answerDivs.length; i++) {
            _points = _choices[i].points || 0;
            _maxPoints = _choices[i].maxPoints || options.question.pointsMax || 0;

            pointsHtml = "\n                <label style=\"padding: 0;\">(" + _points + "/" + _maxPoints + ")</label>\n              ";
            $(_answerDivs[i].parentElement).append(pointsHtml);
          }
        }
        // else if (options.adorner === "title") {
        //   // Add points to question title
        //   let maxPoints = options.question.pointsMax || 0;
        //   let pointsLabel = `
        //     <label class="points-max-on-survey" style="padding: 0;">(${maxPoints})</label>
        //   `;
        //   $(options.element).append(pointsLabel);
        // }
      });

      // Add pointsMax value to elements in content list
      this.editor.onGetObjectTextInPropertyGrid.add(function (editor, options) {
        var pointsMax = options.obj.pointsMax || 0;
        options.text += " (" + pointsMax + ")";
      });

      // Show question number, text and name on condition select
      this.editor.onConditionQuestionsGetList.add(function (editor, options) {
        var surveyQuestionNumbersOff = true;
        if (options.obj.survey) surveyQuestionNumbersOff = options.obj.survey.showQuestionNumbers === "off";

        options.list.forEach(function (item) {
          var questionNumber = "";
          if (item.question) {
            if (surveyQuestionNumbersOff && item.question.customQuestionNumber) questionNumber = item.question.customQuestionNumber;else if (!surveyQuestionNumbersOff && item.question.no) questionNumber = item.question.no;
          }
          item.text = questionNumber + " " + item.text + " (" + item.name + ")";
        });
      });

      // Toggle question number visibility
      this.editor.onPropertyValueChanging.add(function (sender, options) {
        if (options.propertyName !== "showQuestionNumbers") return;

        if (options.value === "off") options.obj.questionTitleTemplate = "{customQuestionNumber} {title} {require}";else options.obj.questionTitleTemplate = "{no} {title} {require}";
      });

      // TODO: Workaround: Disable svd-splitter until it does not work properly
      this.editor.onDesignerSurveyCreated.add(function (editor, options) {
        $(document).find("svd-splitter").css("display", "none");
      });

      // Add commentForShopper and shortName to question preview
      this.editor.onDesignerSurveyCreated.add(function (editor, options) {
        var survey = options.survey;
        survey.onAfterRenderQuestion.add(function (survey, options) {
          if (__WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty(options.question.getType(), "commentForShopper")) {
            var comment = options.question.commentForShopper;
            var headerLoc = __WEBPACK_IMPORTED_MODULE_9__packages_surveyjs_editor_surveyeditor_js__["editorLocalization"].getPropertyName("commentForShopper");
            var commentHtml = "\n              <div class=\"shopper-comment-container big\"" + (comment ? "" : ' style="display: none;"') + ">\n                <div class=\"shopper-comment-header\">\n                  " + (comment ? headerLoc + ":" : "") + "\n                </div>\n                <div class=\"shopper-comment-content\">\n                  " + (comment ? comment : "") + "\n                </div>\n              </div>";

            $(options.htmlElement).append(commentHtml);
          }

          if (__WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty(options.question.getType(), "shortName")) {
            var shortName = options.question.shortName;
            var shortNameHtml = "\n              <div class=\"short-name-on-question\">\n                <span>\n                  " + (shortName ? shortName : "") + "\n                </span>\n              </div>";

            $(options.htmlElement).append(shortNameHtml);
          }
        });
      });

      // Make shortName and commentForShopper reactive
      this.editor.onPropertyValueChanging.add(function (sender, options) {
        if (options.propertyName === "shortName") {
          $("#" + options.obj.id + " > .short-name-on-question > span").text(options.value);
        } else if (options.propertyName === "commentForShopper") {
          var commentContainer = $("#" + options.obj.id + " .shopper-comment-container");
          var headerLoc = __WEBPACK_IMPORTED_MODULE_9__packages_surveyjs_editor_surveyeditor_js__["editorLocalization"].getPropertyName("commentForShopper");
          commentContainer.css("display", options.value ? "" : "none");
          commentContainer.find(".shopper-comment-header").text(headerLoc);
          commentContainer.find(".shopper-comment-content").html(options.value);
        }
      });

      // Updates pointsMax values for container elements after modifications
      this.editor.onModified.add(function (sender, options) {
        var pointsManipulationTypes = ["DO_DROP", "ADDED_FROM_TOOLBOX", "OBJECT_DELETED", "PROPERTY_CHANGED"];
        if (_.indexOf(pointsManipulationTypes, options.type) < 0) return;
        if (options.type === "PROPERTY_CHANGED" && options.name !== "pointsMax") return;

        var element = options.target || options.question;
        if (element) _this4.calcPointsMaxOfContainer(element.survey.currentPage);
      });

      // Add commentForShopper to questions in test survey
      this.editor.onTestSurveyCreated.add(function (editor, options) {
        options.survey.onAfterRenderQuestion.add(function (survey, options) {
          if (!options.question.commentForShopper) return;

          var comment = "\n          <div class=\"shopper-comment-container small\" \n            style=\"cursor: pointer;\"\n            aria-expanded=\"false\"\n            data-toggle=\"collapse\" \n            data-target=\"#instructions-" + options.question.name + "\">\n            <div class=\"shopper-comment-header\">\n              <span><i class=\"material-icons md-add\">add_circle_outline</i></span>\n              <span><i class=\"material-icons md-remove\">remove_circle_outline</i></span>\n              <span class=\"shopper-comment-header-text\">\n                " + __WEBPACK_IMPORTED_MODULE_9__packages_surveyjs_editor_surveyeditor_js__["editorLocalization"].getPropertyName("commentForShopper") + "\n              </span>\n            </div>\n            <div id=\"instructions-" + options.question.name + "\"\n              class=\"collapse shopper-comment-content\">\n              " + options.question.commentForShopper + "\n            </div>\n          </div>";

          $(options.htmlElement).append(comment);
        });
      });

      // Store test survey instance and disable language switch for survey test
      this.editor.onTestSurveyCreated.add(function (editor, options) {
        _this4.testSurvey = options.survey;

        $("#testSurveyLocale").parent().css("display", "none");
      });

      // Configure inputmask depending on inputType property
      this.editor.onTestSurveyCreated.add(function (editor, options) {
        options.survey.onAfterRenderQuestion.add(function (survey, options) {
          var inputMaskConfig = void 0,
              el = void 0,
              fp = void 0;

          var _iteratorNormalCompletion14 = true;
          var _didIteratorError14 = false;
          var _iteratorError14 = undefined;

          try {
            for (var _iterator14 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(_this4.singleInputTypes), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
              var type = _step14.value;

              el = $(options.htmlElement).find('input[type="' + type + '"]');
              if (el.length < 1) continue;
              if (type !== "number") $(el).prop("type", "text");

              inputMaskConfig = {
                clearIncomplete: true
              };

              switch (type) {
                case "date":
                  fp = flatpickr("#" + el[0].id, _this4.globals.flatpickrDateConfig);
                  fp.setDate(options.question.value, true, "Y-m-d");
                  break;
                case "datetime":
                  fp = flatpickr("#" + el[0].id, _this4.globals.flatpickrDatetimeConfig);
                  fp.setDate(options.question.value, true, "Y-m-d H:i");
                  break;
                case "email":
                  inputMaskConfig.alias = "email";
                  break;
                case "number":
                  inputMaskConfig.alias = "numeric";
                  inputMaskConfig.rightAlign = false;
                  inputMaskConfig.inputType = "number";
                  break;
                case "tel":
                  inputMaskConfig.mask = "+(99[9]) 9{2,14}";
                  break;
                case "time":
                  fp = flatpickr("#" + el[0].id, _this4.globals.flatpickrTimeConfig);
                  fp.setDate(options.question.value, true, "H:i");
                  break;
                case "url":
                  inputMaskConfig.regex = "(https?|ftp)://.*";
                  break;
                case "currency":
                  inputMaskConfig.alias = "currency";
                  inputMaskConfig.placeholder = "_";
                  inputMaskConfig.clearIncomplete = false;
                  inputMaskConfig.rightAlign = false;
                  inputMaskConfig.tabThrough = true;
                  inputMaskConfig.positionCaretOnClick = "select";

                  inputMaskConfig.autoUnmask = true;
                  inputMaskConfig.onBeforeMask = function (value, opts) {
                    var newValue = value.toString();
                    var radixPointIndex = newValue.indexOf(".");
                    if (radixPointIndex > -1) {
                      if (!newValue[radixPointIndex + 2]) newValue = newValue + "0";
                    } else newValue = newValue + ".00";

                    newValue = newValue.replace(".", opts.radixPoint);
                    return newValue;
                  };
                  inputMaskConfig.onUnMask = function (maskedValue, unmaskedValue, opts) {
                    if (unmaskedValue === "" && opts.nullable === true) {
                      return unmaskedValue;
                    }
                    var stringValue = maskedValue.replace(opts.prefix, "");
                    stringValue = stringValue.replace(new RegExp(__WEBPACK_IMPORTED_MODULE_12_inputmask___default.a.escapeRegex(opts.groupSeparator), "g"), "");
                    if (opts.placeholder.charAt(0) !== "") {
                      stringValue = stringValue.replace(new RegExp(opts.placeholder.charAt(0), "g"), "0");
                    }

                    if (inputMaskConfig.radixPoint === ",") stringValue = stringValue.replace(",", ".");

                    unmaskedValue = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(stringValue);
                    return unmaskedValue;
                  };

                  inputMaskConfig.prefix = survey.currencySymbol + " ";
                  inputMaskConfig.groupSeparator = survey.currencyDecimalPoint === "comma" ? "." : ",";
                  inputMaskConfig.radixPoint = survey.currencyDecimalPoint === "comma" ? "," : ".";

                  if (!survey.getValue(options.question.name)) survey.setValue(options.question.name, 0);
              }

              if (fp) {
                $(el[0].parentElement).on("click", function (e) {
                  fp.toggle();
                });
                _this4.fpInstancesFromSurvey.push(fp);
              } else __WEBPACK_IMPORTED_MODULE_12_inputmask___default()(inputMaskConfig).mask(el);
            }
          } catch (err) {
            _didIteratorError14 = true;
            _iteratorError14 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion14 && _iterator14.return) {
                _iterator14.return();
              }
            } finally {
              if (_didIteratorError14) {
                throw _iteratorError14;
              }
            }
          }
        });
      });

      // Remove email validator if inputType changes to other value
      this.editor.onPropertyValueChanging.add(function (sender, options) {
        if (options.propertyName !== "inputType") return;
        if (options.value !== "email") options.obj.validators = [];
      });

      // Make sure that question title and item text are always available in survey JSON
      this.editor.onPropertyValueChanging.add(function (sender, options) {
        if (options.propertyName === "title") {
          if (!options.value) options.newValue = options.obj.name;
        }

        if (options.propertyName === "choices") {
          options.newValue = options.value;
          var _iteratorNormalCompletion15 = true;
          var _didIteratorError15 = false;
          var _iteratorError15 = undefined;

          try {
            for (var _iterator15 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(options.newValue), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
              var item = _step15.value;

              if (!item.hasText) item.text = item.value;
            }
          } catch (err) {
            _didIteratorError15 = true;
            _iteratorError15 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion15 && _iterator15.return) {
                _iterator15.return();
              }
            } finally {
              if (_didIteratorError15) {
                throw _iteratorError15;
              }
            }
          }
        }
      });

      // Change the visible message on empty pages. Needs several updates until surveyjs tries to overwrite the text.
      var changeEmptyPageMessage = function changeEmptyPageMessage() {
        $("#surveyjs + div.empty-message").html(__WEBPACK_IMPORTED_MODULE_9__packages_surveyjs_editor_surveyeditor_js__["editorLocalization"].getLocale().survey.dropQuestionOnPage || "Step 1: Add cluster<br>Step 2: Add question");
      };
      this.editor.onModified.add(function (sender, options) {
        if (options.type === "OBJECT_DELETED" && options.target.survey.currentPage.elements.length < 1) {
          changeEmptyPageMessage();
        }
      });
      this.editor.onDesignerSurveyCreated.add(function (editor, options) {
        options.survey.onAfterRenderPage.add(function (survey, options) {
          if (options.page.elements.length < 1) {
            changeEmptyPageMessage();
          }
        });
      });

      // Hide type change adorner for panels
      this.editor.onElementAllowOperations.add(function (editor, options) {
        var obj = options.obj;
        if (!obj || !obj.page) return;

        if (obj.getType() === "panel") {
          options.allowChangeType = false;
        }
      });

      // Add security button to survey elements
      this.editor.onDefineElementMenuItems.add(function (sender, options) {
        var securityButton = {
          name: "security",
          text: __WEBPACK_IMPORTED_MODULE_9__packages_surveyjs_editor_surveyeditor_js__["editorLocalization"].getLocale().survey.security || "Security",
          hasTitle: true,
          onClick: function onClick(element) {
            _this4.surveyElementSecurityModalVisible = true;
          }
        };
        options.items.unshift(securityButton);
      });

      // Limit description to 1000 chars and show counter below textarea
      this.editor.onPropertyAfterRender.add(function (sender, options) {
        if (options.property.name === "description") {
          var input = $(options.htmlElement).find(".input-group > input.form-control").attr("maxlength", 1000);

          _this4.$nextTick(function () {
            $(options.htmlElement).find(".modal .modal-body span.description-length-counter").text(input.val().length + "/" + 1000);
          });
        }
      });
      var debouncedDescriptionCounterUpdateFunc = null;
      this.editor.onPropertyEditorKeyDown.add(function (sender, options) {
        if (options.propertyName === "description" && options.event.target.tagName === "TEXTAREA") {
          var target = options.event.target;
          if (debouncedDescriptionCounterUpdateFunc) debouncedDescriptionCounterUpdateFunc();else {
            debouncedDescriptionCounterUpdateFunc = _.debounce(function () {
              target.nextSibling.innerText = target.value.length + "/" + target.maxLength;
              debouncedDescriptionCounterUpdateFunc = null;
            }, 500);
            debouncedDescriptionCounterUpdateFunc();
          }
        }
      });

      // Set dirty flag if survey is edited in JSON editor
      this.editor.jsonEditor.koText.subscribe(function (newText) {
        if (_this4.surveyDirty) return;

        if (!_this4.surveyDirtyTextStorage) {
          _this4.surveyDirtyTextStorage = newText;
          return;
        }

        if (_this4.surveyDirtyTextStorage !== newText && _this4.editor.koViewType() === "editor") _this4.surveyDirty = true;

        _this4.surveyDirtyTextStorage = newText;
      });
    },
    initializeEditorDesign: function initializeEditorDesign() {
      var mainColor = $(":root").css("--color-primary-input");
      var mainHoverColor = $(":root").css("--color-primary-input-hover");
      var textColor = "#4a4a4a";
      var headerColor = "#160ce8";
      var headerBackgroundColor = "#4a4a4a";
      var bodyContainerBackgroundColor = "#f8f8f8";

      var defaultThemeColorsSurvey = __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["StylesManager"].ThemeColors["default"];
      defaultThemeColorsSurvey["$main-color"] = mainColor;
      defaultThemeColorsSurvey["$main-hover-color"] = mainHoverColor;
      defaultThemeColorsSurvey["$text-color"] = textColor;
      defaultThemeColorsSurvey["$header-color"] = headerColor;
      defaultThemeColorsSurvey["$header-background-color"] = headerBackgroundColor;
      defaultThemeColorsSurvey["$body-container-background-color"] = bodyContainerBackgroundColor;

      var defaultThemeColorsEditor = __WEBPACK_IMPORTED_MODULE_9__packages_surveyjs_editor_surveyeditor_js__["StylesManager"].ThemeColors["default"];
      defaultThemeColorsEditor["$primary-color"] = mainColor;
      defaultThemeColorsEditor["$secondary-color"] = mainColor;
      defaultThemeColorsEditor["$primary-hover-color"] = mainHoverColor;
      defaultThemeColorsEditor["$primary-text-color"] = textColor;
      defaultThemeColorsEditor["$selection-border-color"] = mainColor;

      __WEBPACK_IMPORTED_MODULE_9__packages_surveyjs_editor_surveyeditor_js__["StylesManager"].applyTheme("bootstrapmaterial");
    },
    configureToolbox: function configureToolbox() {
      var _this5 = this;

      this.editor.toolbox.copiedItemMaxCount = 10;
      this.editor.toolbox.allowExpandMultipleCategories = true;

      var containerName = __WEBPACK_IMPORTED_MODULE_9__packages_surveyjs_editor_surveyeditor_js__["editorLocalization"].getLocale().ed.toolboxContainerCategory || "Container";

      var clusterTemplate = {
        name: "cluster",
        isCopied: false,
        iconName: "icon-panel",
        title: __WEBPACK_IMPORTED_MODULE_9__packages_surveyjs_editor_surveyeditor_js__["editorLocalization"].getLocale().qt.cluster || "Cluster",
        json: {
          type: "panel",
          isCluster: true
        }
      };
      var questionGroupTemplate = {
        name: "questiongroup",
        isCopied: false,
        iconName: "icon-panel",
        title: __WEBPACK_IMPORTED_MODULE_9__packages_surveyjs_editor_surveyeditor_js__["editorLocalization"].getLocale().qt.questiongroup || "Question Group",
        json: {
          type: "panel",
          isCluster: false
        }
      };
      this.editor.toolbox.addItems([clusterTemplate, questionGroupTemplate]);

      var categories = [{
        name: "cluster",
        category: containerName
      }, {
        name: "questiongroup",
        category: containerName
      }];
      this.editor.toolbox.changeCategories(categories);

      // Read custom toolbox items from localStorage
      var customToolboxConfig = localStorage.getItem("surveyEditorCustomToolbox");
      if (customToolboxConfig) {
        var customToolboxConfigObject = JSON.parse(customToolboxConfig);
        var _iteratorNormalCompletion16 = true;
        var _didIteratorError16 = false;
        var _iteratorError16 = undefined;

        try {
          for (var _iterator16 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(customToolboxConfigObject), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
            var item = _step16.value;

            item.category = __WEBPACK_IMPORTED_MODULE_9__packages_surveyjs_editor_surveyeditor_js__["editorLocalization"].getLocale().ed.toolboxCustomCategory || "Custom";
          }
        } catch (err) {
          _didIteratorError16 = true;
          _iteratorError16 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion16 && _iterator16.return) {
              _iterator16.return();
            }
          } finally {
            if (_didIteratorError16) {
              throw _iteratorError16;
            }
          }
        }

        customToolboxConfig = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_json_stringify___default()(customToolboxConfigObject);
        this.editor.toolbox.copiedJsonText = customToolboxConfig;
      }

      this.editor.toolbox.expandAllCategories();

      this.editor.onCustomElementAddedIntoToolbox.add(function (sender, options) {
        // Change name and title of toolbox item
        _this5.editor.toolbox.changeCategory(options.element.name, __WEBPACK_IMPORTED_MODULE_9__packages_surveyjs_editor_surveyeditor_js__["editorLocalization"].getLocale().ed.toolboxCustomCategory || "Custom");
        var element = _this5.editor.toolbox.koCategories()[2].items.filter(function (item) {
          return item.name === options.element.name;
        })[0];
        element.name = options.element.title;
        element.title = options.element.title;
        _this5.editor.toolbox.copiedJsonText = _this5.editor.toolbox.copiedJsonText; // Force toolbox refresh
        _this5.editor.toolbox.expandAllCategories();

        // Store custom toolbox items to localStorage
        var customToolboxConfig = JSON.parse(_this5.editor.toolbox.copiedJsonText);
        var _iteratorNormalCompletion17 = true;
        var _didIteratorError17 = false;
        var _iteratorError17 = undefined;

        try {
          for (var _iterator17 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(customToolboxConfig), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
            var _item = _step17.value;
            _item.category = "Custom";
          }
        } catch (err) {
          _didIteratorError17 = true;
          _iteratorError17 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion17 && _iterator17.return) {
              _iterator17.return();
            }
          } finally {
            if (_didIteratorError17) {
              throw _iteratorError17;
            }
          }
        }

        customToolboxConfig = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_json_stringify___default()(customToolboxConfig);
        localStorage.setItem("surveyEditorCustomToolbox", customToolboxConfig);
      });
    },


    // Calculates the next available question id
    findNextQuestionId: function findNextQuestionId() {
      var questions = this.editor.survey.getAllQuestions();
      var currentId = 0,
          maxId = 0;
      var idString = "";
      for (var i = 0; i < questions.length; i++) {
        idString = questions[i].name.substring(1);
        currentId = _.parseInt(idString);
        if (currentId > maxId) maxId = currentId;
      }
      this.nextQuestionId = maxId + 1;
    },


    // Calculates the next available question id
    findNextQuestionGroupId: function findNextQuestionGroupId() {
      var panels = this.editor.survey.getAllPanels();
      var currentId = 0,
          maxId = 0;
      var idString = "";
      for (var i = 0; i < panels.length; i++) {
        idString = panels[i].name.substring(1);
        currentId = _.parseInt(idString);
        if (currentId > maxId) maxId = currentId;
      }
      this.nextQuestionGroupId = maxId + 1;
    },


    // Calculates the pointsMax value of the given container element
    calcPointsMaxOfContainer: function calcPointsMaxOfContainer(container) {
      var type = container.getType();
      var containerTypes = ["panel", "page", "survey"];

      if (_.indexOf(containerTypes, type) < 0) return; // No container type
      container.pointsMax = 0;
      var elements = type === "survey" ? container.pages : container.elements;

      var _iteratorNormalCompletion18 = true;
      var _didIteratorError18 = false;
      var _iteratorError18 = undefined;

      try {
        for (var _iterator18 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(elements), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
          var el = _step18.value;

          if (_.indexOf(containerTypes, el.getType()) > -1) {
            this.calcPointsMaxOfContainer(el);
          }
          container.pointsMax += el.pointsMax || 0;
        }
      } catch (err) {
        _didIteratorError18 = true;
        _iteratorError18 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion18 && _iterator18.return) {
            _iterator18.return();
          }
        } finally {
          if (_didIteratorError18) {
            throw _iteratorError18;
          }
        }
      }
    },


    // Requests the current survey data from the server
    getSurveyData: function getSurveyData() {
      var _this6 = this;

      $.ajax({
        method: "GET",
        url: "api/Surveys/" + this.surveyId,
        success: function success(data) {
          if (data.SurveyData) {
            _this6.surveyData = data.SurveyData; // Store response data from server
            if (_this6.surveyData.Survey) {
              var survey = _this6.removeUnsetMaxPointsTriggers(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_json_stringify___default()(_this6.surveyData.Survey));
              _this6.editor.text = survey;
              _this6.findNextQuestionId();
              _this6.findNextQuestionGroupId();
            } else {
              // Adds a guid to the first page of a new survey
              _this6.editor.survey.visiblePages[0].guid = uuidv4();
              _this6.editor.survey.focusFirstQuestionAutomatic = false;

              // Fix for showing title in new surveys
              _this6.editor.survey.title = data.SurveyData.SurveyTitle;
              _this6.editor.text = _.cloneDeep(_this6.editor.text);
            }

            _this6.editor.survey.title = data.SurveyData.SurveyTitle;

            if (_this6.editor.survey.showQuestionNumbers === "off") _this6.editor.survey.questionTitleTemplate = "{customQuestionNumber} {title} {require}";else _this6.editor.survey.questionTitleTemplate = "{title} {require}";

            _this6.editor.stateValue = "saved";
            _this6.surveyDirty = false;
            _this6.surveyDirtyTextStorage = null;

            if (!_this6.surveyData.ReportingSettings) _this6.surveyData.ReportingSettings = [];
            // if (!this.surveyData.VisibilitySettings)
            //   this.surveyData.VisibilitySettings = [];
          }
        },
        error: function error() {
          console.error("Survey data access failed in getSurveyData()");
          _this6.globals.showErrorSnackbar("Survey data access failed");
        }
      });
    },


    // Requests localization data for the survey editor
    getEditorLocalization: function getEditorLocalization() {
      var _this7 = this;

      this.getSurveyViewLocalization();

      $.ajax({
        method: "GET",
        url: "api/Language/ComponentTranslation/SurveyEditor",
        success: function success(data) {
          if (data && data.length > 0) {
            __WEBPACK_IMPORTED_MODULE_9__packages_surveyjs_editor_surveyeditor_js__["editorLocalization"].locales[data[0].LanguageCode] = data[0].Translation;
          }
          var newLocale = _this7.globals.selectedLanguage.substring(0, 2).toLowerCase();
          __WEBPACK_IMPORTED_MODULE_9__packages_surveyjs_editor_surveyeditor_js__["editorLocalization"].currentLocale = newLocale;

          delete __WEBPACK_IMPORTED_MODULE_9__packages_surveyjs_editor_surveyeditor_js__["editorLocalization"].getLocale().pe.conditionShowMoreUrl;

          _this7.initializeEditor();
          if (_this7.surveyData === null) _this7.getSurveyData();
        },
        error: function error() {
          console.error("Localization data access failed in getEditorLocalization()");
          _this7.globals.showErrorSnackbar("Localization data access failed");
        }
      });
    },


    // Requests localization data for the survey view
    getSurveyViewLocalization: function getSurveyViewLocalization() {
      var _this8 = this;

      $.ajax({
        method: "GET",
        url: "api/Language/ComponentTranslation/SurveyView",
        success: function success(data) {
          if (data && data.length > 0) {
            __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["surveyLocalization"].locales[data[0].LanguageCode] = data[0].Translation;
          }
          var newLocale = _this8.globals.selectedLanguage.substring(0, 2).toLowerCase();
          __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["surveyLocalization"].defaultLocale = newLocale;
        },
        error: function error() {
          console.error("Localization data access failed in getSurveyViewLocalization()");
          _this8.globals.showErrorSnackbar("Localization data access failed");
        }
      });
    },


    // Sends the current survey data to the server
    saveSurveyData: function saveSurveyData(sdata, saveNo, callback) {
      var _this9 = this;

      if (!this.globals.isAccessAllowed("LoopOp_Surveys_Update")) {
        this.globals.showErrorSnackbar("Permission denied");
        callback(saveNo, false);
        return;
      }

      this.surveyData.Survey = JSON.parse(sdata);
      if (this.cleanupSecuritySettings() === false) return;

      if (this.surveyDirty) this.surveyData.SurveyDirty = true;
      var data = { SurveyData: this.surveyData };
      if (this.forceSave) data.ForceSave = true;

      $.ajax({
        type: "PUT",
        url: "api/Surveys/" + this.surveyId,
        data: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_json_stringify___default()(data),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(res) {
          if (res && res.Confirmation && res.Confirmation === "EXISTING_CHECKS") {
            _this9.globals.$off("SaveSurveyDataYesConfirmation");
            _this9.globals.$on("SaveSurveyDataYesConfirmation", function () {
              _this9.forceSave = true;
              _this9.saveSurveyData(sdata, saveNo, callback);
            });
            _this9.globals.$off("SaveSurveyDataDialogClosed");
            _this9.globals.$on("SaveSurveyDataDialogClosed", function () {
              if (!_this9.forceSave) _this9.editor.stateValue = "modified";
            });

            _this9.globals.$emit("openGlobalConfirmationDialog", {
              initiator: "SaveSurveyData",
              confirmationTitle: _this9.lang.SE0000,
              colorRed: true,
              yesButtonText: _this9.lang.SE0001,
              noButtonText: _this9.lang.SE0002,
              htmlText: "<b>\n                <p>" + _this9.lang.SE0003 + "</p>\n                <p class=\"text-uppercase\">" + _this9.lang.SE0004 + "</p>\n              </b>"
            });
          } else callback(saveNo, true);
        },
        error: function error() {
          console.error("Error on PUT in saveSurveyData()");
          _this9.globals.showErrorSnackbar("Survey update failed");
          callback(saveNo, false);
        }
      });
    },
    cleanupSecuritySettings: function cleanupSecuritySettings() {
      var elements = _.concat(this.editor.survey.getAllQuestions(), this.editor.survey.getAllPanels());
      var _iteratorNormalCompletion19 = true;
      var _didIteratorError19 = false;
      var _iteratorError19 = undefined;

      try {
        for (var _iterator19 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(elements), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
          var el = _step19.value;

          if (!el.guid) {
            console.error("missing element guid: ", el);
            this.globals.showErrorSnackbar("Missing element guid");
            return false;
          }
        }
      } catch (err) {
        _didIteratorError19 = true;
        _iteratorError19 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion19 && _iterator19.return) {
            _iterator19.return();
          }
        } finally {
          if (_didIteratorError19) {
            throw _iteratorError19;
          }
        }
      }

      var cleanupFunc = function cleanupFunc(setting) {
        return _.findIndex(elements, function (el) {
          return el.guid.toUpperCase() === setting.ElementGuid;
        }) < 0;
      };

      _.remove(this.surveyData.ReportingSettings, cleanupFunc);
      _.remove(this.surveyData.SecuritySettings, cleanupFunc);
    },


    // Save security settings of the current survey element
    saveSurveyElementSecuritySettings: function saveSurveyElementSecuritySettings(settings) {
      if (!this.surveyData.SecuritySettings) this.$set(this.surveyData, 'SecuritySettings', []);
      if (!this.surveyData.ReportingSettings) this.$set(this.surveyData, 'ReportingSettings', []);

      var repIndex = _.findIndex(this.surveyData.ReportingSettings, ["ElementGuid", this.selectedSurveyElement.guid.toUpperCase()]);
      if (repIndex > -1) this.surveyData.ReportingSettings[repIndex] = settings.reporting;else this.surveyData.ReportingSettings.push(settings.reporting);

      var secIndex = _.findIndex(this.surveyData.SecuritySettings, ["ElementGuid", this.selectedSurveyElement.guid.toUpperCase()]);
      if (settings.general) {
        if (secIndex > -1) this.surveyData.SecuritySettings[secIndex] = settings.general;else this.surveyData.SecuritySettings.push(settings.general);
      } else _.pullAt(this.surveyData.SecuritySettings, secIndex);

      this.editor.stateValue = "modified";
    },


    // Requests all KPIs from the server
    getKpiList: function getKpiList() {
      var _this10 = this;

      $.ajax({
        method: "GET",
        url: "api/Data/kpis",
        success: function success(data) {
          var kpiList = [];
          for (var kpi in data) {
            kpiList.push({ value: kpi, text: data[kpi] });
          }

          // Add KPI property to questions
          __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.addProperty("question", {
            name: "kpis:multiplevalues",
            choices: kpiList
          });
          // Add KPI tab to question editor modal
          __WEBPACK_IMPORTED_MODULE_9__packages_surveyjs_editor_surveyeditor_js__["SurveyQuestionEditorDefinition"].definition["question"].tabs.push({ name: "kpis" });
        },
        error: function error() {
          console.error("KPI data access failed in getKpiList()");
          _this10.globals.showErrorSnackbar("KPI data access failed");
        }
      });
    },
    updateSaveButtonColor: function updateSaveButtonColor(state) {
      if (state === "saved") $("#svd-save > button").css("background-color", "green");
      if (state === "modified") $("#svd-save > button").css("background-color", "red");
      if (state === "saving") $("#svd-save > button").css("background-color", "yellow");
    },
    configureSurveyEditor: function configureSurveyEditor() {
      var _this12 = this;

      if (__WEBPACK_IMPORTED_MODULE_9__packages_surveyjs_editor_surveyeditor_js__["editorConfigDone"]) return;

      // Add points to answers
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.addClass("itemvaluesWithPoints", ["points:number", "isPositive:boolean"], null, "itemvalue");
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.addProperty("selectbase", "choices:itemvalues");
      var property1 = __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("selectbase", "choices");
      property1.typeValue = "itemvaluesWithPoints";
      property1.className = "itemvaluesWithPoints";

      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.addProperty("rating", "rateValues:itemvalues");
      property1 = __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("rating", "rateValues");
      property1.typeValue = "itemvaluesWithPoints";
      property1.className = "itemvaluesWithPoints";

      // Add maxPoints to answers of radiogroups
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.addClass("itemvaluesWithPointsAndMaxPoints", ["points:number", "maxPoints:number", "isPositive:boolean"], null, "itemvalue");
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.addProperty("radiogroup", "choices:itemvalues");
      var property2 = __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("radiogroup", "choices");
      property2.typeValue = "itemvaluesWithPointsAndMaxPoints";
      property2.className = "itemvaluesWithPointsAndMaxPoints";

      // Add data protection property to questions
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.addProperty("question", {
        name: "observeDataProtection:boolean"
      });
      __WEBPACK_IMPORTED_MODULE_9__packages_surveyjs_editor_surveyeditor_js__["SurveyQuestionEditorDefinition"].definition["question"].properties.push({ name: "observeDataProtection" });

      // Add points properties to questions
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.addProperty("question", {
        name: "pointsMin:number"
      });
      __WEBPACK_IMPORTED_MODULE_9__packages_surveyjs_editor_surveyeditor_js__["SurveyQuestionEditorDefinition"].definition["question"].properties.push({ name: "pointsMin" });
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.addProperty("question", {
        name: "pointsMax:number"
      });
      __WEBPACK_IMPORTED_MODULE_9__packages_surveyjs_editor_surveyeditor_js__["SurveyQuestionEditorDefinition"].definition["question"].properties.push({ name: "pointsMax" });

      // Add video upload property to file questions
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.addProperty("file", {
        name: "isVideoUpload:boolean"
      });

      // Add picture upload property to file questions
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.addProperty("file", {
        name: "isPictureUpload:boolean"
      });

      // Add short text property for reporting
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.addProperty("question", {
        name: "shortName",
        type: "shortname",
        isRequired: true
      });
      var ShortTextEditor = {
        render: function render(editor, htmlElement) {
          var input = document.createElement("input");
          input.className = "form-control svd_editor_control";
          input.type = "text";
          input.maxLength = 5;
          input.style.width = "100%";
          htmlElement.appendChild(input);
          input.onchange = function () {
            editor.koValue(input.value);
          };
          editor.onValueUpdated = function (newValue) {
            input.value = editor.koValue() || "";
          };
          input.value = editor.koValue() || "";
        }
      };
      __WEBPACK_IMPORTED_MODULE_9__packages_surveyjs_editor_surveyeditor_js__["SurveyPropertyEditorFactory"].registerCustomEditor("shortname", ShortTextEditor);
      __WEBPACK_IMPORTED_MODULE_9__packages_surveyjs_editor_surveyeditor_js__["SurveyQuestionEditorDefinition"].definition.question.properties.splice(1, 0, "shortName");

      // Add short question text property for filenames
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.addProperty("question", {
        name: "questionTextShort",
        type: "questionTextShort",
        isRequired: true
      });
      var questionTextShortEditor = {
        render: function render(editor, htmlElement) {
          var input = document.createElement("input");
          input.className = "form-control svd_editor_control";
          input.type = "text";
          input.maxLength = 50;
          input.style.width = "100%";
          htmlElement.appendChild(input);
          input.onchange = function () {
            input.value = input.value.replace(/ /g, "_");
            editor.koValue(input.value);
          };
          input.onkeypress = function (e) {
            if (e.which == 32) return false;
          };
          editor.onValueUpdated = function (newValue) {
            input.value = editor.koValue() || "";
          };
          input.value = editor.koValue() || "";
        }
      };
      __WEBPACK_IMPORTED_MODULE_9__packages_surveyjs_editor_surveyeditor_js__["SurveyPropertyEditorFactory"].registerCustomEditor("questionTextShort", questionTextShortEditor);
      __WEBPACK_IMPORTED_MODULE_9__packages_surveyjs_editor_surveyeditor_js__["SurveyQuestionEditorDefinition"].definition.file.properties.splice(0, 0, "questionTextShort");

      // Add color selection property for clusters
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.addProperty("panel", {
        name: "backgroundColor",
        type: "backgroundColor"
      });
      var colorEditor = {
        render: function render(editor, htmlElement) {
          var input = document.createElement("input");
          input.className = "form-control svd_editor_control";
          input.type = "color";
          input.style.width = "100%";
          htmlElement.appendChild(input);
          input.onchange = function () {
            editor.koValue(input.value);
          };
          editor.onValueUpdated = function (newValue) {
            input.value = editor.koValue() || "";
          };
          input.value = editor.koValue() || "";
        }
      };
      __WEBPACK_IMPORTED_MODULE_9__packages_surveyjs_editor_surveyeditor_js__["SurveyPropertyEditorFactory"].registerCustomEditor("backgroundColor", colorEditor);

      // Add isCluster flag to panels
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.addProperty("panel", {
        name: "isCluster:boolean",
        default: false
      });
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("panel", "isCluster").readOnly = true;

      // Add translationRequired flag to questions that can contain text input
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.addProperty("text", {
        name: "translationRequired:boolean"
      });
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.addProperty("comment", {
        name: "translationRequired:boolean"
      });
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.addProperty("matrixdropdownbase", {
        name: "translationRequired:boolean"
      });

      // Add isShowOnlySelectedAnswer flag to selectbase questions
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.addProperty("selectbase", {
        name: "isShowOnlySelectedAnswer:boolean",
        default: false
      });

      // Add comment properties for creating comment questions
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.addProperty("text", "isCommentOf");
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("text", "isCommentOf").readOnly = true;
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.addProperty("comment", "isCommentOf");
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("comment", "isCommentOf").readOnly = true;
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.addProperty("selectbase", {
        name: "hasCommentText:boolean"
      });

      // Add commentForShopper property for all questions
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.addProperty("question", "commentForShopper:html");

      // Limit description to 1000 chars
      var descriptionModalEditor = {
        afterRender: function afterRender(modalEditor, htmlElement) {
          if (modalEditor.property.name === "description") {
            htmlElement.maxLength = 1000;
            var counter = document.createElement("span");
            counter.innerText = htmlElement.value.length + "/" + htmlElement.maxLength;
            counter.className = "help-block description-length-counter";
            htmlElement.parentNode.insertBefore(counter, htmlElement.nextSibling);
          }
        }
      };
      __WEBPACK_IMPORTED_MODULE_9__packages_surveyjs_editor_surveyeditor_js__["SurveyPropertyModalEditor"].registerCustomWidget("text", descriptionModalEditor);

      // Add exclusive value selection for checkbox questions

      var SurveyPropertyDefaultCheckboxValueEditor = function (_SurveyEditor$SurveyP) {
        __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(SurveyPropertyDefaultCheckboxValueEditor, _SurveyEditor$SurveyP);

        function SurveyPropertyDefaultCheckboxValueEditor(property) {
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SurveyPropertyDefaultCheckboxValueEditor);

          return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SurveyPropertyDefaultCheckboxValueEditor.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(SurveyPropertyDefaultCheckboxValueEditor)).call(this, property));
        }

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(SurveyPropertyDefaultCheckboxValueEditor, [{
          key: "buildQuestionJson",
          value: function buildQuestionJson() {
            var qjson = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(SurveyPropertyDefaultCheckboxValueEditor.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(SurveyPropertyDefaultCheckboxValueEditor.prototype), "buildQuestionJson", this).call(this);
            qjson.type = "radiogroup";
            return qjson;
          }
        }]);

        return SurveyPropertyDefaultCheckboxValueEditor;
      }(__WEBPACK_IMPORTED_MODULE_9__packages_surveyjs_editor_surveyeditor_js__["SurveyPropertyDefaultValueEditor"]);

      __WEBPACK_IMPORTED_MODULE_9__packages_surveyjs_editor_surveyeditor_js__["SurveyPropertyEditorFactory"].registerEditor("checkboxValue", function (property) {
        return new SurveyPropertyDefaultCheckboxValueEditor(property);
      });
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.addProperty("checkbox", "exclusiveValue:checkboxValue");

      __WEBPACK_IMPORTED_MODULE_9__packages_surveyjs_editor_surveyeditor_js__["removeAdorners"](["rating-item"]);

      // Add custom question numbers
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.addProperty("question", {
        name: "customQuestionNumber",
        default: 0
      });

      // Add guid property to questions, pages and panels and set to readonly
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.addProperty("question", "guid");
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.addProperty("panelbase", "guid");
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.addProperty("matrixdropdowncolumn", "guid");
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.addProperty("itemvalue", "guid");
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.addProperty("checkbox", "noneGuid");
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("question", "guid").visible = false;
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("panelbase", "guid").visible = false;
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("checkbox", "noneGuid").visible = false;
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("itemvalue", "guid").visible = false;

      // Make question names readonly
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("question", "name").readOnly = true;
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("itemvalue", "value").readOnly = true;
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("itemvaluesWithPoints", "value").readOnly = true;
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("panelbase", "name").readOnly = true;
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("file", "storeDataAsText").readOnly = true;
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("matrixdropdowncolumn", "name").readOnly = true;

      // Add weight per cluster
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.addProperty("panel", {
        name: "weight",
        type: "percentage"
      });
      var percentageEditor = {
        render: function render(editor, htmlElement) {
          var input = document.createElement("input");
          input.className = "form-control svd_editor_control";
          input.type = "number";
          input.step = 0.001;
          input.max = 99.99999;
          input.min = 0;
          input.style.width = "100%";
          htmlElement.appendChild(input);
          input.onchange = function () {
            if (input.valueAsNumber > input.max) input.value = input.max;else if (input.valueAsNumber < input.min) input.value = input.min;
            editor.koValue(parseFloat(input.value));
          };
          editor.onValueUpdated = function (newValue) {
            input.value = editor.koValue() || "";
          };
          input.value = editor.koValue() || "";
        }
      };
      __WEBPACK_IMPORTED_MODULE_9__packages_surveyjs_editor_surveyeditor_js__["SurveyPropertyEditorFactory"].registerCustomEditor("percentage", percentageEditor);

      // Add securitySettings object to questions and panels
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.addProperty("question", "securitySettings");
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("question", "securitySettings").visible = false;
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.addProperty("panel", "securitySettings");
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("panel", "securitySettings").visible = false;

      // Limit choices of inputType property
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("text", "inputType").choicesValue = ["date", "datetime", "email", "number", "password", "range", "tel", "text", "time", "url", "currency"];

      // Add properties for currency inputs
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.addProperty("survey", {
        name: "currencySymbol",
        default: "€"
      });
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.addProperty("survey", {
        name: "currencyDecimalPoint",
        default: "comma"
      });
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("survey", "currencyDecimalPoint").choicesValue = ["comma", "point"];

      // Register functions for expression trigger and add maxPointsReached for selectbase questions
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["FunctionFactory"].Instance.register("setMaxPoints", function (params) {
        if (params.length < 1 || !_this12.testSurvey) return;
        for (var i = 0; i < params.length; i++) {
          var q = _this12.testSurvey.getQuestionByName(params[i]);
          if (q) q.maxPointsReached = true;
        }
      });
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["FunctionFactory"].Instance.register("unsetMaxPoints", function (params) {
        if (params.length < 1 || !_this12.testSurvey) return;
        for (var i = 0; i < params.length; i++) {
          var q = _this12.testSurvey.getQuestionByName(params[i]);
          if (q && q.maxPointsReached) q.maxPointsReached = false;
        }
      });
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.addProperty("selectbase", {
        name: "maxPointsReached:boolean",
        default: false
      });
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("selectbase", "maxPointsReached").visible = false;

      // Remove unnecessary features
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("survey", "title").visible = false;
      if (this.feature.isDisabled("surveyQuizTimers")) {
        __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("survey", "showTimerPanel").visible = false;
        __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("survey", "showTimerPanelMode").visible = false;
        __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("survey", "maxTimeToFinish").visible = false;
        __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("survey", "maxTimeToFinishPage").visible = false;
        __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("page", "maxTimeToFinish").visible = false;
      }
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("survey", "completedBeforeHtml").visible = false;
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("survey", "locale").visible = false;
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("survey", "pageNextText").visible = false;
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("survey", "pagePrevText").visible = false;
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("survey", "startSurveyText").visible = false;
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("survey", "completeText").visible = false;
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("survey", "showNavigationButtons").visible = false;
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("survey", "showPrevButton").visible = false;
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("survey", "storeOthersAsComment").visible = false;
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("survey", "sendResultOnPageNext").visible = false;
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("survey", "cookieName").visible = false;
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("survey", "maxOthersLength").visible = false;
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("survey", "checkErrorsMode").visible = false;

      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("selectbase", "choicesByUrl").visible = false;
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("selectbase", "hasComment").visible = false;
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("question", "commentText").visible = false;
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("question", "useDisplayValuesInTitle").visible = false;
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("rating", "hasComment").visible = false;
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("selectbase", "hasOther").visible = false;
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("selectbase", "otherText").visible = false;
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("selectbase", "otherErrorText").visible = false;
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("selectbase", "storeOthersAsComment").visible = false;
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("checkbox", "hasNone").visible = false;
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("checkbox", "noneText").visible = false;
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("checkbox", "hasSelectAll").visible = false;
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("checkbox", "selectAllText").visible = false;
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("rating", "correctAnswer").visible = false;
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("survey", "questionStartIndex").visible = false;
      __WEBPACK_IMPORTED_MODULE_11_survey_knockout__["JsonObject"].metaData.findProperty("survey", "questionTitleTemplate").visible = false;

      _.remove(__WEBPACK_IMPORTED_MODULE_9__packages_surveyjs_editor_surveyeditor_js__["SurveyQuestionEditorDefinition"].definition["file"].properties, function (p) {
        return p.name === "storeDataAsText";
      });

      // Remove imagepicker from questionconverter
      var convertInfo = __WEBPACK_IMPORTED_MODULE_9__packages_surveyjs_editor_surveyeditor_js__["QuestionConverter"].convertInfo;
      for (var type in convertInfo) {
        _.pull(convertInfo[type], "imagepicker");
      }

      __WEBPACK_IMPORTED_MODULE_9__packages_surveyjs_editor_surveyeditor_js__["editorConfigDone"] = true;
    }
  },
  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage(newLanguage) {
      if (!newLanguage) return;
      this.getEditorLocalization();
      this.globals.getLanguageStrings(this);
    },
    "globals.currentUserInfo": function globalsCurrentUserInfo(newValue) {
      if (!newValue.Policies) return;
      this.initializeEditor(); // Avoids race condition for JSON Editor access
    },
    "editor.state": function editorState(newState) {
      if (!newState) return;
      this.updateSaveButtonColor(newState);
    }
  },
  data: function data() {
    return {
      editorUrl: "",
      surveyId: -1,
      surveyData: null,
      testSurvey: null,
      designerSurvey: null,
      editor: null,
      heartBeat: 30000,
      timer: null,
      designerHeight: 600,
      nextQuestionId: 0,
      nextQuestionGroupId: 0,
      surveyDirty: false,
      surveyDirtyTextStorage: null,
      forceSave: false,
      selectedSurveyElement: null,
      surveyElementSecurityModalVisible: false,
      fpInstancesFromSurvey: [],
      // videoFileTypes: [".avi", ".mov", ".mp4", ".mpg", ".wmv", ".3gp"],
      singleInputTypes: ["date", "datetime", "email", "number", "tel", "time", "url", "currency"],
      lang: {
        SE0000: "Save survey",
        SE0001: "Yes",
        SE0002: "No",
        SE0003: "ATTENTION: There are already existing checks based on this survey. Do you really want to save?",
        SE0004: "All affected checks will be changed by this action"
      }
    };
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Tools_Select2__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Tools_Select2__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "SurveyElementSecurityModal",
  components: { select2: __WEBPACK_IMPORTED_MODULE_4__components_Tools_Select2___default.a },
  props: {
    modalVisible: {
      type: Boolean,
      default: false
    },
    surveyElement: {
      type: Object,
      required: true
    },
    surveyData: {
      type: Object,
      required: true
    },
    surveyId: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      securitySettings: {},
      reportingSettings: {},
      securityElements: {},
      securityGroups: {},
      selectedSecurityGroup: "",
      currentReportingGroupSettings: {},
      reportingSettingsStrings: {},
      securitySettingsStrings: {},
      defaultReportingSettings: {
        notVisibleInCheckReport: false,
        notVisibleInRawData: false,
        uploadVisibleInMediaExplorer: false
      },
      validationMessage: {
        Msg: "",
        MsgNr: 0,
        Error: false
      },
      lang: {
        SE1000: "Security Settings",
        SE1001: "Not visible in Check Report",
        SE1002: "PDF sent by Mail",
        SE1003: "External Interface",
        SE1004: "External Custom",
        SE1005: "Query Tool",
        SE1006: "Dashboard",
        SE1007: "Check Explorer",
        SE1008: "Aggregated Report",
        SE1009: "Raw Data Exports",
        SE1010: "Frequencies",
        SE1011: "Media Explorer",
        SE1012: "Upload visible in Media Explorer",
        SE1013: "Role",
        SE1014: "Security Group",
        SE1015: "Wave",
        SE1016: "Scenario",
        SE1017: "Custom Property",
        SE1018: "Location",
        SE1019: "Operative",
        SE1020: "Reporting",
        SE1021: "Security Level",
        SE1022: "Elements",
        SE1023: "Visible",
        SE1024: "FF",
        SE1025: "Add new",
        SE1026: "Remove all",
        SE1027: "Cancel",
        SE1028: "Save",
        SE1029: "Not visible in Raw Data",
        SE1030: "Group",
        SE1031: "There is no group approved for this survey.",

        SE1036: "Condition",
        SE1037: "Please select...",
        SE1038: "Expression",
        SE1039: "e.g."
      }
    };
  },

  watch: {
    modalVisible: function modalVisible() {
      if (this.modalVisible) this.showModal();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this, this.setListTranslations);
    },

    // surveyElement: {
    //   handler(newElement, oldElement) {
    //     if (!newElement) return;

    //     this.initializeGeneralVisibilitySettings();
    //     if (oldElement) this.initializeReportingVisibilitySettings();
    //   },
    //   immediate: true,
    // },
    selectedSecurityGroup: function selectedSecurityGroup(newValue, oldValue) {
      if (!newValue) return;

      if (oldValue) {
        this.storeReportingSettingsForGroup(oldValue);
      }
      this.readReportingSettingsForGroup(newValue);
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.modalVisible) this.showModal();

    $("#surveyElementSecurityModal").on("hide.bs.modal", function (e) {
      _this.$emit("closeModal");
      _this.clearErrorMsg();
    });

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this, this.setListTranslations);
    this.setListTranslations();
    this.getSecurityElements();
    this.getSecurityGroupsOfSurvey();
  },

  methods: {
    showModal: function showModal() {
      this.initializeSecuritySettings();
      this.initializeReportingSettings();
      this.selectedSecurityGroup = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.securityGroups)[0];
      if (this.securitySettings && this.securitySettings.Rules && this.securitySettings.Rules.length < 1) this.clearGeneralSettings();
      $("#surveyElementSecurityModal").modal("show");
    },
    hideModal: function hideModal() {
      $("#surveyElementSecurityModal").modal("hide");
      this.validationMessage.Msg = "";
    },
    clearErrorMsg: function clearErrorMsg() {
      this.validationMessage.Msg = "";
      this.validationMessage.Error = false;
    },

    /**
     * remove invalid rules
     */
    cleanRules: function cleanRules() {
      if (this.securitySettings.Rules.length > 0) {
        _.remove(this.securitySettings.Rules, function (r) {
          return _.isEmpty(r) || !r.RuleType || !r[r.RuleType] || r[r.RuleType].length < 1 || r.RuleType == "LocationProperty" && !r.LocationPropertyValue[0];
        });
      }
    },

    /**
     * Request to validate the rules and expression obj
     * @param {string} expression the logic expression
     * @param {array} rules all the RulesNumbers
     * @returns { Promise } returns data.valid = true if is valid and
     * contains an error msg in data.validationMessage.Msg on error
     */
    requestValidation: function requestValidation(expression, rules) {
      var queryString = "/api/Surveys/ValidateSecurityCondition"; // ToDo : add endpoint
      var data = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({
        Expression: expression,
        RuleNumbers: rules
      });

      return $.ajax({
        url: queryString,
        type: "POST",
        data: data,
        success: function success(data) {
          return data;
        },
        error: function error(jqXHR, textStatus, errorThrown) {
          var err = [jqXHR, textStatus, errorThrown];
          return err;
        }
      });
    },
    saveSecuritySettings: function saveSecuritySettings() {
      var _this2 = this;

      this.cleanRules();

      // REMOVE UNNECESSARY ELEMENTS OF RULES DEPENDING ON RULETYPE
      // REPLACES PART OF RuleTypeChanged() METHOD
      // #1781 RELATED
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.securitySettings.Rules), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var rule = _step.value;

          if (rule.RuleType == "Wave") {
            rule.LocationPropertyValue = [];
            delete rule.LocationProperty;
            delete rule.Location;
            delete rule.Scenario;
          } else if (rule.RuleType == "Scenario") {
            rule.LocationPropertyValue = [];
            delete rule.LocationProperty;
            delete rule.Location;
            delete rule.WaveFF;
            delete rule.Wave;
          } else if (rule.RuleType == "Location") {
            rule.LocationPropertyValue = [];
            delete rule.LocationProperty;
            delete rule.WaveFF;
            delete rule.Wave;
            delete rule.Scenario;
          } else if (rule.RuleType == "LocationProperty") {
            delete rule.Location;
            delete rule.WaveFF;
            delete rule.Wave;
            delete rule.Scenario;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (this.securitySettings.Rules.length == 0 && this.securitySettings.Expression != "") {
        this.validationMessage.Msg = "No usable Rules";
        this.validationMessage.Error = true;
        return;
      }

      var rules = this.securitySettings.Rules.map(function (el) {
        return el.RuleNumber;
      });

      this.requestValidation(this.securitySettings.Expression, rules).then(function (data) {
        if (data.Valid) {
          _this2.validationMessage.Error = false;
          _this2.validationMessage.Msg = "";
          _this2.saveAndClose();
        } else {
          _this2.validationMessage.Error = true;
          _this2.validationMessage.Msg = data.ErrorMessage;
        }
      }).catch(function (err) {
        console.error(err);
        _this2.globals.showErrorSnackbar("Failed to Validate Expression");
      });
    },
    saveAndClose: function saveAndClose() {
      this.storeReportingSettingsForGroup(this.selectedSecurityGroup);
      var settings = {
        general: this.generateSecuritySettingsStoreObject(),
        reporting: this.reportingSettings
      };
      this.$emit("saveSecuritySettings", settings);
      this.$forceUpdate();
      this.hideModal();
    },
    generateSecuritySettingsStoreObject: function generateSecuritySettingsStoreObject() {
      var _this3 = this;

      var result = _.cloneDeep(this.securitySettings);
      if (result.Rules.length > 0) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          var _loop = function _loop() {
            var rule = _step2.value;

            var newRuleEntry = {};

            if (rule.RuleType == "LocationProperty") {
              if (Array.isArray(rule.LocationProperty)) {
                newRuleEntry.LocationPropertyGuid = rule.LocationProperty[0];
              } else {
                newRuleEntry.LocationPropertyGuid = rule.LocationProperty;
              }
              newRuleEntry.LocationPropertyValues = _.map(rule.LocationPropertyValue, function (val) {
                return { LocationPropertyValue: val };
              });
              delete rule.LocationPropertyValue;
            } else {
              newRuleEntry[rule.RuleType + "s"] = _.map(rule[rule.RuleType], function (guid) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, _this3.getIdKeyOfRuleType(rule.RuleType), guid);
              });
            }

            if (rule.RuleType == "Wave") {
              // undefined, false, NULL etc.
              if (!rule.WaveFF) {
                newRuleEntry.WaveFF = false;
              } else {
                newRuleEntry.WaveFF = rule.WaveFF;
              }
              // cleanup for save request (otherwise it is inside Rules and inside Wave Array (has to be in Wave Array))
              delete rule.WaveFF;
            }

            rule[rule.RuleType] = newRuleEntry;
          };

          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(result.Rules), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            _loop();
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      } else {
        delete result.Rules;
        delete result.Expression;
      }
      return result;
    },
    setListTranslations: function setListTranslations() {
      this.reportingSettingsStrings = {
        notVisibleInCheckReport: this.lang.SE1001,
        notVisibleInRawData: this.lang.SE1029,
        pdfSentByMail: this.lang.SE1002,
        externalInterface: this.lang.SE1003,
        externalCustom: this.lang.SE1004,
        queryTool: this.lang.SE1005,
        dashboard: this.lang.SE1006,
        checkExplorer: this.lang.SE1007,
        aggregatedReport: this.lang.SE1008,
        rawDataExports: this.lang.SE1009,
        frequencies: this.lang.SE1010,
        mediaExplorer: this.lang.SE1011,
        uploadVisibleInMediaExplorer: this.lang.SE1012
      };
      this.securitySettingsStrings = {
        Role: this.lang.SE1013,
        // securityGroup: this.lang.SE1014,
        Wave: this.lang.SE1015,
        Scenario: this.lang.SE1016,
        LocationProperty: this.lang.SE1017,
        Location: this.lang.SE1018
      };
    },
    clearGeneralSettings: function clearGeneralSettings() {
      this.securitySettings.ElementGuid = this.surveyElement.guid.toUpperCase();
      this.securitySettings.Expression = "";
      this.securitySettings.Rules = [];
      this.$forceUpdate();
    },
    addNewGeneralSetting: function addNewGeneralSetting() {
      var newSetting = {
        RuleNumber: this.generateNewRuleNumber()
      };
      this.securitySettings.Rules.push(newSetting);

      this.$forceUpdate();
    },
    removeGeneralSetting: function removeGeneralSetting(ruleNumber) {
      _.remove(this.securitySettings.Rules, function (r) {
        return r.RuleNumber == ruleNumber;
      });
      //TODO: Remove rule from expression
      this.$forceUpdate();
    },
    generateNewRuleNumber: function generateNewRuleNumber() {
      if (!this.securitySettings.Rules || !this.securitySettings.Rules[0]) return 1;
      var maxNumber = 1;
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.securitySettings.Rules), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _rule = _step3.value;

          if (_rule.RuleNumber > maxNumber) maxNumber = _rule.RuleNumber;
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return maxNumber + 1;
    },
    ruleTypeChanged: function ruleTypeChanged(obj) {
      if (!obj) return;

      // LETTING THIS RUN ALWAYS SHOWS WAVEFF AS FALSE - FIX IT IF YOU WANT TO USE THIS
      for (var prop in obj) {
        if (prop !== "RuleType" && prop !== "RuleNumber" && !(obj.RuleType === "Wave" && prop === "WaveFF")) delete obj[prop];
      }

      if (obj.RuleType) {
        if (obj.RuleType == "LocationProperty") obj.LocationPropertyValue = [];
      }

      this.$forceUpdate();
    },
    ruleValueChanged: function ruleValueChanged(rule, d) {
      if (rule.RuleType == "LocationProperty") {
        // rule.LocationPropertyValue = [];
        // this.$refs[`locationPropertySelect${rule.RuleNumber}`][0].reinit();
      }
      this.$forceUpdate();
    },
    getListNameOfRuleType: function getListNameOfRuleType(ruleType) {
      var listName = "";
      if (!ruleType) return listName;

      switch (ruleType) {
        case "Role":
          listName = "SecurityRoles";
          break;
        // case "securityGroup":
        //   listName = "SecurityGroups";
        //   break;
        case "Wave":
          listName = "Waves";
          break;
        case "Scenario":
          listName = "Scenarios";
          break;
        case "LocationProperty":
          listName = "LocationProperties";
          break;
        case "Location":
          listName = "Locations";
          break;
      }
      return listName;
    },
    getIdKeyOfRuleType: function getIdKeyOfRuleType(ruleType) {
      var idKey = "";
      if (!ruleType) return idKey;

      switch (ruleType) {
        case "Role":
          idKey = "RoleId";
          break;
        // case "securityGroup":
        //   idKey = "GroupGuid";
        //   break;
        case "Wave":
          idKey = "WaveGuid";
          break;
        case "Scenario":
          idKey = "ScenarioGuid";
          break;
        case "LocationProperty":
          idKey = "LocationPropertyGuid";
          break;
        case "Location":
          idKey = "LocationGuid";
          break;
      }
      return idKey;
    },
    getElementsForCurrentRuleType: function getElementsForCurrentRuleType(ruleType) {
      var elements = [];
      if (!ruleType) return elements;

      var listName = this.getListNameOfRuleType(ruleType);
      if (listName) elements = this.securityElements[listName];
      return elements;
    },
    getLocationPropertyValues: function getLocationPropertyValues(prop) {
      if (!this.securityElements || _.isEmpty(this.securityElements) || !this.securityElements.LocationProperties) {
        return [];
      }
      var locationProp = this.securityElements.LocationProperties.find(function (p) {
        if (Array.isArray(prop)) {
          return p.LocationPropertyGuid === prop[0];
        } else {
          return p.LocationPropertyGuid === prop;
        }
      });
      if (locationProp && locationProp.LocationPropertyValues) return locationProp.LocationPropertyValues;
    },
    getElementName: function getElementName(element) {
      var keys = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(element);
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(keys), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var k = _step4.value;

          if (k.indexOf("Name") > -1) return element[k];
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return "";
    },
    getSecurityElements: function getSecurityElements() {
      var _this4 = this;

      var getString = "/api/data/SecurityElements?SurveyId=" + this.surveyId;

      $.ajax({
        method: "GET",
        url: getString,
        success: function success(data) {
          _this4.securityElements = data;
        },
        error: function error() {
          console.error("SecurityElements data access failed in getSecurityElements()");
          _this4.globals.showErrorSnackbar("Security data access failed");
        }
      });
    },
    getSecurityGroupsOfSurvey: function getSecurityGroupsOfSurvey() {
      var _this5 = this;

      var getString = "api/SecurityGroups/Data/Survey/" + this.surveyData.SurveyGuid;

      $.ajax({
        method: "GET",
        url: getString,
        success: function success(data) {
          _this5.securityGroups = data;
          _this5.selectedSecurityGroup = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(_this5.securityGroups)[0];
          _this5.initializeReportingSettings();
        },
        error: function error() {
          console.error("Security group data access failed in getSecurityGroupsOfSurvey()");
          _this5.globals.showErrorSnackbar("Security group data access failed");
        }
      });
    },
    initializeSecuritySettings: function initializeSecuritySettings() {
      var _this6 = this;

      /**
       * @type {Array}
       */
      var SecuritySettings = this.surveyData.SecuritySettings;
      var ElsecSettings = void 0;
      if (SecuritySettings) {
        ElsecSettings = SecuritySettings.find(function (el) {
          return el.ElementGuid === _this6.surveyElement.guid.toUpperCase();
        });
      }

      if (ElsecSettings) {
        ElsecSettings = _.cloneDeep(ElsecSettings);

        if (!ElsecSettings.Rules) {
          ElsecSettings.Rules = [];
          ElsecSettings.Expression = "";
        }
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          var _loop2 = function _loop2() {
            var rule = _step5.value;

            if (rule.RuleType == "Wave") {
              rule.WaveFF = rule.Wave.WaveFF;
            }

            if (rule.RuleType == "LocationProperty") {
              if (rule.LocationProperty && rule.LocationProperty.LocationPropertyValues) {
                rule.LocationPropertyValue = rule.LocationProperty.LocationPropertyValues.map(function (el) {
                  return el.LocationPropertyValue;
                });
                rule.LocationProperty = rule.LocationProperty.LocationPropertyGuid;
              }
            }
            // else if (rule.RuleType == "Role") {

            // } 
            else {
                rule[rule.RuleType] = _.map(rule[rule.RuleType][rule.RuleType + "s"], function (obj) {
                  return obj[_this6.getIdKeyOfRuleType(rule.RuleType)];
                });
              }
          };

          for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(ElsecSettings.Rules), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            _loop2();
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }

        this.securitySettings = ElsecSettings;

        for (var refName in this.$refs) {
          if (this.$refs[refName][0] && this.$refs[refName][0].updateValue) this.$refs[refName][0].updateValue();
        }
      } else {
        this.securitySettings = {
          ElementGuid: this.surveyElement.guid.toUpperCase(),
          Expression: "",
          Rules: []
        };
      }
      this.$forceUpdate();
    },
    initializeReportingSettings: function initializeReportingSettings() {
      var _this7 = this;

      if (!this.surveyData || !this.surveyData.ReportingSettings) return -1;

      var repSettings = this.surveyData.ReportingSettings.find(function (el) {
        return el.ElementGuid === _this7.surveyElement.guid.toUpperCase();
      });

      if (repSettings) {
        this.reportingSettings = _.cloneDeep(repSettings);
      } else {
        this.reportingSettings = {
          ElementGuid: this.surveyElement.guid.toUpperCase(),
          Groups: []
        };

        this.reportingSettings.Groups.push({
          GroupGuid: this.selectedSecurityGroup,
          Settings: _.cloneDeep(this.defaultReportingSettings)
        });
      }
      this.readReportingSettingsForGroup(this.selectedSecurityGroup);
    },
    readReportingSettingsForGroup: function readReportingSettingsForGroup(groupGuid) {
      if (!this.reportingSettings) return -1;
      var newGroup = this.reportingSettings.Groups.find(function (el) {
        return el.GroupGuid === groupGuid;
      });

      this.currentReportingGroupSettings = newGroup && newGroup.Settings ? newGroup.Settings : _.cloneDeep(this.defaultReportingSettings);
    },
    storeReportingSettingsForGroup: function storeReportingSettingsForGroup(groupGuid) {
      var oldGroup = _.find(this.reportingSettings.Groups, ["GroupGuid", groupGuid]);
      if (!oldGroup) this.reportingSettings.Groups.push({
        GroupGuid: groupGuid,
        Settings: this.currentReportingGroupSettings
      });else oldGroup.Settings = this.currentReportingGroupSettings;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SurveyManagementEditModal__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SurveyManagementEditModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SurveyManagementEditModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SurveyManagementTranslateModal__ = __webpack_require__(1620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SurveyManagementTranslateModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SurveyManagementTranslateModal__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "SurveyManagement",
  components: {
    SurveyManagementEditModal: __WEBPACK_IMPORTED_MODULE_1__SurveyManagementEditModal___default.a,
    SurveyManagementTranslateModal: __WEBPACK_IMPORTED_MODULE_2__SurveyManagementTranslateModal___default.a
  },
  mounted: function mounted() {
    var _this = this;

    this.readComponentSettingsFromStore();
    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this);
      this.getSurveyData();
    }
    this.globals.getLanguageList(function (callbackData) {
      _this.languageList = callbackData;
    });
    this.globals.getLocaleList(function (callbackData) {
      _this.localesList = callbackData;
    });

    $(window).on("resize", this.setTableHeight).resize();

    if (!this.globals.currentUserInfo) this.globals.$once("currentUserInfoReceived", this.setTableHeight);
  },
  destroyed: function destroyed() {
    $(window).off("resize", this.setTableHeight);
    this.writeComponentSettingsToStore();
  },

  methods: {
    setTableHeight: function setTableHeight() {
      this.$nextTick(function () {
        var height = $(window).height();
        height -= $("#surveys-top-panel").height() + $("#app-navbar").height() + $(".main-table > thead").height() + 47; // 47 pixel for the free space around the cards
        $(".main-table-scrollbar").css("max-height", height);
      });
    },
    readComponentSettingsFromStore: function readComponentSettingsFromStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      var storedData = this.$store.getters["localFilters/surveyManagement"];
      if (storedData) {
        for (var key in storedData) {
          if (_.has(this, key)) this[key] = _.cloneDeep(storedData[key]);
        }
      }

      if (!this.$store.getters["userSettings/syncFilters"]) return;
      if (!this.feature.isAudiTarget || !this.feature.isEnabled("audi_importers")) {
        var storedClient = this.$store.getters["sharedFilters/client"];
        this.filterStrings.ClientName = storedClient.ClientName || "";
      } else {
        var storedImporter = this.$store.getters["sharedFilters/importer"];
        this.filterStrings.ImporterName = storedImporter.ImporterName || "";
      }
    },
    writeComponentSettingsToStore: function writeComponentSettingsToStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      this.$store.commit("localFilters/surveyManagement", {
        filterStrings: this.filterStrings,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        pageSize: this.pageSize
      });

      if (!this.$store.getters["userSettings/syncFilters"]) return;
      if (!this.feature.isAudiTarget || !this.feature.isEnabled("audi_importers")) {
        var storedClient = this.$store.getters["sharedFilters/client"];
        if (storedClient.ClientName !== this.filterStrings.ClientName) {
          this.$store.commit("sharedFilters/client", {
            ClientName: this.filterStrings.ClientName
          });
        }
      } else {
        var storedImporter = this.$store.getters["sharedFilters/importer"];
        if (storedImporter.ImporterName !== this.filterStrings.ImporterName) {
          this.$store.commit("sharedFilters/importer", {
            ImporterName: this.filterStrings.ImporterName
          });
        }
      }
    },

    // Gets executed after the editSurveyDialog successfully saved some data
    onEditSurveyDialogDataSaved: function onEditSurveyDialogDataSaved(survey) {
      this.getSurveyData(); // Refresh datatable
      if (survey) this.selectedSurvey = survey;
    },

    // Gets executed after the editSurveyDialog got closed
    onEditSurveyDialogClosed: function onEditSurveyDialogClosed() {
      this.showEditSurveyDialog = false;
      this.copySurvey = false;
    },

    // Redirects to the survey editor component in a new tab to edit the survey with the given ID
    redirectToSurveyEditor: function redirectToSurveyEditor(surveyId) {
      var _this2 = this;

      $.ajax({
        method: "PATCH",
        url: "api/Surveys/" + surveyId + "/Lock",
        data: '{ "Lock": true }',
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) _this2.globals.showErrorSnackbar(data.Error);else {
            _this2.$router.push({
              path: "surveyeditor",
              query: { id: surveyId }
            });
          }
        },
        error: function error() {
          console.error("Error on PUT in redirectToSurveyEditor()");
          _this2.globals.showErrorSnackbar("Survey lock failed");
        }
      });
    },

    // Opens the security check dialog for deleting the selected survey
    openDeleteSurveyDialog: function openDeleteSurveyDialog() {
      $("#deleteSurvey").modal("show");
    },

    // Opens the dialog to select Survey language and then translate
    openSelectSurveyLanguageDialog: function openSelectSurveyLanguageDialog() {
      this.showTranslateSurveyDialog = true;
    },

    // Gets executed after the translateSurveyDialog got closed
    onTranslateSurveyDialogClosed: function onTranslateSurveyDialogClosed() {
      this.showTranslateSurveyDialog = false;
    },

    // Sends a delete request for the selected survey to the server
    deleteSurveyData: function deleteSurveyData() {
      var _this3 = this;

      $.ajax({
        method: "DELETE",
        url: "api/Surveys/" + this.selectedSurvey.SurveyId,
        success: function success(data) {
          // If delete was successful, refresh displayed data and hide dialog
          $("#deleteSurvey").modal("hide");
          if (data.Error) _this3.globals.showErrorSnackbar(data.Error);else _this3.globals.showSuccessSnackbar("Survey deletion successful");
          _this3.selectedSurvey = null;
          _this3.getSurveyData();
        },
        error: function error() {
          console.error("Survey data deletion failed in deleteSurveyData()");
          _this3.globals.showErrorSnackbar("Survey deletion failed");
        }
      });
    },

    // Calculates the sort order for the given column and refreshes the displayed data
    sortSurveyData: function sortSurveyData(field) {
      if (field == this.sortField) {
        this.sortOrder == "asc" ? this.sortOrder = "desc" : this.sortOrder = "asc";
      } else {
        this.sortField = field;
        this.sortOrder = "asc";
      }
      this.selectedPage = 1;
      this.getSurveyData();
    },

    // Catches survey data for the table from the server, including current filter, pagination and sort settings
    getSurveyData: function getSurveyData() {
      var _this4 = this;

      this.refreshEnabled = false; // Disable refresh, so it can not be triggered again until the server responded

      var getString = "api/Surveys/Get?page_size=" + this.pageSize + "&page=" + this.selectedPage + "&sort_column=" + this.sortField + "&sort_order=" + this.sortOrder;
      getString = encodeURI(getString);

      var filter = _.pickBy(this.filterStrings, function (value, key) {
        if (key === "SurveyActive" && value < 2) return true;
        return value.length > 0;
      });
      if (typeof filter.SurveyActive === "number") filter.SurveyActive = !!filter.SurveyActive;

      $.ajax({
        method: "POST",
        url: getString,
        data: _.isEmpty(filter) ? "" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ Filter: filter }),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (typeof data[0] == "undefined") {
            _this4.surveyData = [];
            _this4.pageCount = 1;
          } else {
            _this4.surveyData = data[0].Surveys; // If GET was successful, store survey data and page count from server
            _this4.pageCount = data[0].Page_Count;
            _this4.totalElementsCount = data[0].Count;
          }
        },
        error: function error() {
          console.error("Error on POST in getSurveyData()");
          _this4.globals.showErrorSnackbar("Survey data access failed");
        },
        complete: function complete() {
          _this4.refreshEnabled = true;
        }
      });
    },

    // Updates the current pagesize and the selected pagenumber and triggers the refresh of the table
    updatePaging: function updatePaging(pageNumber, pageSize) {
      this.selectedPage = pageNumber || 1;
      if (pageSize != 0) this.pageSize = pageSize;
      this.getSurveyData();
    },

    // Returns a range of numbers with min-value, max-value and stepsize
    getRange: function getRange(min, max, step) {
      var range = [],
          j = 0;
      for (var i = min; i <= max; i += step) {
        range[j++] = i;
      }
      return range;
    },

    // Returns a list of all pagenumbers that should be visible depending on the current page and the count of pages
    getVisiblePages: function getVisiblePages() {
      if (this.pageCount <= 7) {
        return this.getRange(1, this.pageCount, 1);
      } else if (this.pageCount > 7 && this.selectedPage <= 4) {
        return this.getRange(1, 6, 1);
      } else if (this.pageCount > 7 && this.selectedPage >= this.pageCount - 3) {
        return this.getRange(this.pageCount - 5, this.pageCount, 1);
      } else {
        return this.getRange(this.selectedPage - 2, this.selectedPage + 2, 1);
      }
    },

    // Export and download of survey
    downloadSurvey: function downloadSurvey(selectedSurvey) {
      var _this5 = this;

      if (!selectedSurvey) return;
      var query = "api/Surveys/" + selectedSurvey.SurveyGuid + "/Export";

      $.ajax({
        method: "GET",
        url: query,
        success: function success(data) {
          if (data.Error) {
            _this5.globals.showErrorSnackbar(data.Error);
            console.error(data.Error);
            return;
          }
          _this5.globals.downloadFile(data[0].DownloadId);
        },
        error: function error(XMLHttpRequest, textStatus, errorThrown) {
          console.error("Survey Export failed");
          console.error(XMLHttpRequest + " " + textStatus + " : " + errorThrown);
          _this5.globals.showErrorSnackbar(_this5.lang.U0046);
        }
      });
    }
  },
  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
      this.getSurveyData();
    }
  },
  data: function data() {
    // Global data inside the component is stored here
    return {
      selectedSurvey: null, // ID of the selected survey
      pageSize: 20, // Number of locations on one page of the table
      selectedPage: 1, // Number of the page, that is visible
      pageCount: 0, // Count of available pages depending on the pagesize and the data
      totalElementsCount: 0,
      filterStrings: {
        // Strings that are manipulated by the user for filtering the table
        Search: "",
        SurveyId: "",
        SurveyTitle: "",
        ClientName: "",
        ImporterName: "",
        SurveyCreatedAt: "",
        CurrentUser: "",
        SurveyActive: 2
      },
      showActiveSurveys: 2, // 0 = inactive, 1 = active, 2 = all
      sortField: "SurveyTitle", // Selected column for sorting
      sortOrder: "asc", // Should be "asc" or "desc"
      refreshEnabled: false, // false, if location data is requested and server did not respond yet to avoid multiple requests at the same time
      surveyData: [], // Stores the survey data on the current page
      showEditSurveyDialog: false,
      editSurveyDialogModeAdd: true,
      copySurvey: false,
      languageList: {},
      localesList: [],
      showTranslateSurveyDialog: false,
      lang: {
        // Contains localization strings for the selected language
        U0000: "Refresh",
        U0001: "Add",
        U0002: "Edit",
        U0003: "Delete",
        U0004: "Survey Editor",
        U0005: "Search...",
        U0006: "Items per page",
        U0007: "First page",
        U0008: "Last page",
        U0009: "SID",
        U0010: "Title",
        U0011: "Client",
        U0012: "Created",
        U0013: "In use",
        U0014: "Filter",
        U0022: "Cancel",
        U0023: "Save",
        U0024: "Delete Survey",
        U0025: "Do you really want to delete the following survey?",
        U0026: "SID",
        U0027: "Title",
        U0028: "Client",
        U0029: "Created",
        U0030: "No",
        U0031: "Yes",
        U0034: "Copy",
        U0035: "Used by",
        U0036: "Active",
        U0037: "Translation",
        U0038: "Language selection",
        U0039: "Continue",
        U0043: "Importer",
        U0044: "Total surveys count",
        U0045: "Export",
        U0046: "Survey export failed"
      }
    };
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tools_Select2__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Tools_Select2__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "SurveyManagementEditModal",
  components: { Select2: __WEBPACK_IMPORTED_MODULE_2__Tools_Select2___default.a },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
    this.globals.getClientList(function (data) {
      _this.clientList = data;
    });
    if (this.feature.isAudiTarget && this.feature.isEnabled("audi_importers")) {
      this.globals.getImporterList(function (data) {
        _this.importerList = data;
      });
    }

    $("#editSurveyDialog").on("hidden.bs.modal", function (e) {
      _this.$emit("dialogClosed");
    });
  },

  methods: {
    // Validates an input with the given id, changes the input color depending on the validation result and returns the result
    validateInput: function validateInput(id) {
      var result = $("#" + id)[0].checkValidity(); // Checks validation depending on the input type or a given pattern in the template
      if (result) {
        $("#" + id).parent().parent().removeClass("has-error"); // has-error has to be added to the form-group element
        var idx = this.invalidInputIds.indexOf(id);
        if (idx > -1) {
          this.invalidInputIds.splice(idx, 1); // Remove from list, if valid
        }
      } else {
        $("#" + id).parent().parent().addClass("has-error");
        if (this.invalidInputIds.indexOf(id) < 0) this.invalidInputIds.push(id); // Add to list, if invalid
      }
      return result;
    },


    // Returns true if an input has a validation error, otherwise false
    inputHasError: function inputHasError(id) {
      if (this.invalidInputIds.indexOf(id) > -1) return true;
      return false;
    },


    // Triggers input validation and ensures further progress if validation was successful
    validateBeforeSubmit: function validateBeforeSubmit(dialogId) {
      var result = true;

      var elements = $("#" + dialogId).find(":input"); // Returns a list of all inputs on the dialog
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0) result = this.validateInput(elements[i].id) && result; // If only one input is invalid, the whole form is invalid
      }

      if (dialogId == "editSurveyDialog") {
        this.showAlert = !result;
        if (!result) return;
        this.saveEditSurveyDialogData();
      }
    },


    // Resets all validation errors for the given dialog
    resetValidationErrors: function resetValidationErrors(dialogId) {
      var elements = $("#" + dialogId).find(":input"); // Returns a list of all inputs on the dialog
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0) $("#" + elements[i].id).parent().parent().removeClass("has-error");
      }
      this.invalidInputIds = [];
    },


    // Redirects to the survey translation tool
    redirectToSurveyTranslation: function redirectToSurveyTranslation(key) {
      // TODO:
      console.log("open survey translation for: " + key);
    },


    // Returns true, if the given language is already selected, otherwise false
    isLanguageSelected: function isLanguageSelected(languageCode, countryCode) {
      var langList = this.surveyData.SurveySelectedLanguages;
      if (!langList || !languageCode) return false;

      for (var i = 0; i < langList.length; i++) {
        if (langList[i].LanguageCode == languageCode) {
          if ((!langList[i].CountryCode || langList[i].CountryCode.length < 1) && !countryCode.length) return true;else if (langList[i].CountryCode == countryCode) return true;
        }
      }
      return false;
    },
    getLocaleString: function getLocaleString(languageCode, countryCode) {
      if (!this.languageList || !this.localesList) return "";

      var result = this.languageList[languageCode];

      var ll = this.localesList.filter(function (l) {
        return l.LanguageCode == languageCode;
      });

      if (ll && ll.length > 0 && ll[0].Locales) {
        var loc = ll[0].Locales.filter(function (c) {
          return c.CountryCode == countryCode;
        });
        if (loc && loc.length > 0) result += " - " + loc[0].CountryName;
      }
      return result;
    },
    getLocales: function getLocales() {
      var _this2 = this;

      var loc = this.localesList.filter(function (l) {
        return l.LanguageCode == _this2.newSurveyLanguage;
      });
      if (loc && loc.length > 0 && loc[0].Locales) this.languageLocaleList = loc[0].Locales;else this.languageLocaleList = [];
    },
    getSurveyGroupList: function getSurveyGroupList() {
      var _this3 = this;

      if (!this.surveyData.ClientGuid) return;
      var query = "api/SecurityGroups/Data/Client/" + this.surveyData.ClientGuid;

      $.ajax({
        method: "GET",
        url: query,
        success: function success(data) {
          if (data.Error) {
            _this3.globals.showErrorSnackbar(data.Error);
            console.error(data.Error);
            return;
          }
          _this3.surveyGroupList = data;
        },
        error: function error() {
          console.error("Survey group data access failed in getSurveyGroupList()");
          _this3.globals.showErrorSnackbar(_this3.lang.U1085);
        }
      });
    },


    // Adds a new survey language to the surveydata
    addNewSurveyLanguage: function addNewSurveyLanguage() {
      if (!this.newSurveyLanguage) return;
      if (this.isLanguageSelected(this.newSurveyLanguage, this.newSurveyLanguageLocale)) {
        this.globals.showErrorSnackbar(this.lang.U1040);
        this.newSurveyLanguageLocale = null;
        return;
      }

      if (!this.surveyData.SurveySelectedLanguages) this.surveyData.SurveySelectedLanguages = [];

      var newLanguage = {};
      newLanguage.LanguageCode = this.newSurveyLanguage;
      if (this.newSurveyLanguageLocale) newLanguage.CountryCode = this.newSurveyLanguageLocale;
      newLanguage.IsDefault = this.surveyData.SurveySelectedLanguages.length > 0 ? false : true;

      this.surveyData.SurveySelectedLanguages.push(newLanguage);
      this.newSurveyLanguageLocale = null;
      this.$forceUpdate();
    },


    // Removes the language with the given key from the list of selected languages
    removeSelectedLanguage: function removeSelectedLanguage(languageCode, countryCode) {
      if (!this.surveyData.SurveySelectedLanguages) return;

      var idx = _.findIndex(this.surveyData.SurveySelectedLanguages, function (l) {
        return l.LanguageCode == languageCode && l.CountryCode == countryCode;
      });
      if (idx < 0) return;

      var isDefaultLanguage = this.surveyData.SurveySelectedLanguages[idx].IsDefault;

      this.surveyData.SurveySelectedLanguages.splice(idx, 1);
      if (this.surveyData.SurveySelectedLanguages.length === 0) delete this.surveyData.SurveySelectedLanguages;else if (isDefaultLanguage) this.surveyData.SurveySelectedLanguages[0].IsDefault = true;
      this.$forceUpdate();
    },
    setDefaultSurveyLanguage: function setDefaultSurveyLanguage(index) {
      for (var i = 0; i < this.surveyData.SurveySelectedLanguages.length; i++) {
        this.surveyData.SurveySelectedLanguages[i].IsDefault = false;
      }
      this.surveyData.SurveySelectedLanguages[index].IsDefault = true;
    },


    // Writes the filename to the input of the survey attachment, after a file was selected
    onSurveyAttachmentFileChange: function onSurveyAttachmentFileChange(e) {
      var _this4 = this;

      if (!this.globals.isAccessAllowed("LoopOp_Upload_Create")) {
        this.globals.showErrorSnackbar(this.lang.U1076);
        return;
      }

      var files = e.target.files || e.dataTransfer.files;
      if (!files.length || !files[0].name) return;

      this.attachmentFileObject = files[0];

      var uploadSuccess = function uploadSuccess(data) {
        if (_this4.surveyData.SurveyAttachments) {
          _this4.surveyData.SurveyAttachments[0].DownloadId = data[0].DownloadId;
          _this4.surveyData.SurveyAttachments[0].DownloadFileName = _this4.attachmentFileObject.name;
        } else _this4.surveyData.SurveyAttachments = data;

        _this4.globals.showSuccessSnackbar(_this4.lang.U1077);
        _this4.$forceUpdate();
      };
      this.globals.uploadFile(this.attachmentFileObject, uploadSuccess);
      e.target.value = null;
    },


    // Removes the survey attachment file from the survey data and resets the input field
    removeSurveyAttachmentFile: function removeSurveyAttachmentFile() {
      this.surveyData.SurveyAttachments = [{}];
      this.attachmentFileObject = {};
      this.$forceUpdate();
    },


    // Writes the filename to the input of the survey logo, after a file was selected
    onSurveyLogoFileChange: function onSurveyLogoFileChange(e) {
      var _this5 = this;

      if (!this.globals.isAccessAllowed("LoopOp_Upload_Create")) {
        this.globals.showErrorSnackbar(this.lang.U1076);
        return;
      }

      var files = e.target.files || e.dataTransfer.files;
      if (!files.length || !files[0].name) return;

      this.logoFileObject = files[0];

      var uploadSuccess = function uploadSuccess(data) {
        _this5.surveyData.SurveyLogoId = data[0].DownloadId;
        _this5.surveyData.SurveyLogoFileName = _this5.logoFileObject.name;
        _this5.globals.showSuccessSnackbar(_this5.lang.U1078);
        _this5.$forceUpdate();
      };
      this.globals.uploadFile(this.logoFileObject, uploadSuccess);
      e.target.value = null;
    },


    // Removes the survey logo file from the survey data and resets the input field
    removeSurveyLogoFile: function removeSurveyLogoFile() {
      delete this.surveyData.SurveyLogoId;
      delete this.surveyData.SurveyLogoFileName;
      this.logoFileObject = {};
      this.$forceUpdate();
    },


    // Stores the current visibility settings to the data object
    storeCurrentVisibilitySettings: function storeCurrentVisibilitySettings() {
      var currentData = this.currentVisibilitySettings;

      if (!this.visibilitySettings) this.visibilitySettings = {};

      this.visibilitySettings[currentData.selected] = currentData.selectedGroups;
    },


    // Reads the current visibility settings for the given element from the data object
    readCurrentVisibilitySettings: function readCurrentVisibilitySettings(element) {
      var currentData = this.currentVisibilitySettings;
      var dataStorage = [];
      if (this.visibilitySettings && this.visibilitySettings[element]) dataStorage = this.visibilitySettings[element];

      currentData.selected = element;
      currentData.selectedGroups = dataStorage;
    },


    // Resets the all visibility settings to the default values
    resetVisibilitySettings: function resetVisibilitySettings() {
      this.currentVisibilitySettings.selected = "survey";
      this.currentVisibilitySettings.selectedGroups = [];
      this.visibilitySettings = {};
    },


    // Takes all available groups into current visibility settings and removes all groups if they are already selected
    toggleAllVisibilityGroups: function toggleAllVisibilityGroups() {
      var ids = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.surveyGroupList);

      if (ids.length <= this.currentVisibilitySettings.selectedGroups.length) {
        this.currentVisibilitySettings.selectedGroups = [];
        return;
      }

      var num = void 0;
      for (var i = 0; i < ids.length; i++) {
        num = ids[i];
        if (this.currentVisibilitySettings.selectedGroups.indexOf(num) < 0) this.currentVisibilitySettings.selectedGroups.push(num);
      }
    },


    // Refreshes displayed visibility settings after changing the submenu
    visibilitySubmenuChanged: function visibilitySubmenuChanged(element) {
      this.storeCurrentVisibilitySettings();
      this.readCurrentVisibilitySettings(element);
      var currentData = this.currentVisibilitySettings;

      // Update header text
      switch (element) {
        case "survey":
          currentData.headerText = this.lang.U1011;
          break;
        case "date":
          currentData.headerText = this.lang.U1012;
          break;
        case "time":
          currentData.headerText = this.lang.U1013;
          break;
        case "points":
          currentData.headerText = this.lang.U1014;
          break;
        case "remarks":
          currentData.headerText = this.lang.U1015;
          break;
        case "attachment":
          currentData.headerText = this.lang.U1016;
          break;
        default:
          currentData.headerText = "";
      }
    },


    // Fills the editSurvey dialog with data, depending on the dialog mode.
    openEditSurveyDialog: function openEditSurveyDialog() {
      var _this6 = this;

      // document.getElementById("visibilitySurveyLink").click();
      this.visibilitySubmenuChanged("survey");

      this.removeSurveyAttachmentFile();
      this.removeSurveyLogoFile();
      this.newSurveyLanguage = null;
      this.newSurveyLanguageLocale = null;

      if (this.dialogModeAdd) {
        this.dialogTitle = this.lang.U0032;
        this.surveyData = {};
        if (this.selectedClient) this.surveyData.ClientGuid = this.selectedClient.ClientGuid;
        this.surveyData.SurveyAttachments = [{}];
        this.surveyData.SurveyActive = true;
        this.surveyData.SurveyShowAttachmentsPage = true;
        this.surveyData.SurveySkillLevel = 3;

        if (this.feature.isAudiTarget && this.feature.isEnabled("audi_importers") && this.clientList[0]) {
          this.surveyData.ClientGuid = this.clientList[0].ClientGuid;
          this.getSurveyGroupList();
        }

        this.resetVisibilitySettings();
        $("#editSurveyDialog").modal("show");
      } else {
        this.dialogTitle = this.copySurvey ? this.lang.U1061 : this.lang.U0033;
        this.surveyData = { SurveyAttachments: [{}] };

        $.ajax({
          method: "GET",
          url: "api/Surveys/" + this.selectedSurvey.SurveyId,
          success: function success(data) {
            if (!data.Error) {
              $("#editSurveyDialog").modal("show");
              _this6.surveyData = data.SurveyData;
              _this6.visibilitySettings = data.VisibilitySettings;
              if (_this6.surveyData.Importers) {
                _this6.surveyData.ImporterGuid = _this6.surveyData.Importers[0].ImporterGuid;
                delete _this6.surveyData.Importers;
              }
              _this6.readCurrentVisibilitySettings(_this6.currentVisibilitySettings.selected);
              _this6.logoFileObject.name = _this6.surveyData.SurveyLogoFileName;
              if (!_this6.surveyData.SurveyAttachments) _this6.surveyData.SurveyAttachments = [{}];else _this6.attachmentFileObject.name = _this6.surveyData.SurveyAttachments[0].DownloadFileName;

              _this6.getSurveyGroupList();
            } else {
              _this6.globals.showErrorSnackbar(data.Error);
              _this6.$emit("dialogClosed");
            }
          },
          error: function error() {
            console.error("Survey data access failed in openEditSurveyDialog()");
            _this6.globals.showErrorSnackbar(_this6.lang.U1086);
            _this6.$emit("dialogClosed");
          }
        });
      }
      this.showAlert = false;
      this.resetValidationErrors("editSurveyDialog");
    },


    // Closes the editSurveyDialog
    closeEditSurveyDialog: function closeEditSurveyDialog() {
      $("#editSurveyDialog").modal("hide");
    },


    // Sends the data from editSurvey dialog to the server to store it in the database
    saveEditSurveyDialogData: function saveEditSurveyDialogData(forceSave) {
      var _this7 = this;

      if (!this.surveyData.SurveySelectedLanguages) {
        this.globals.showErrorSnackbar(this.lang.U1079);
        return;
      }
      if (!this.surveyData.ClientGuid) {
        this.globals.showErrorSnackbar(this.lang.U1080);
        return;
      }

      this.storeCurrentVisibilitySettings();

      var sendData = {
        SurveyData: _.cloneDeep(this.surveyData),
        VisibilitySettings: _.cloneDeep(this.visibilitySettings)
      };

      if (!this.surveyData.SurveyAttachments[0].DownloadId) {
        sendData.SurveyData.SurveyAttachments = [];
      }

      if (sendData.SurveyData.ImporterGuid) {
        sendData.SurveyData.Importers = [{ ImporterGuid: sendData.SurveyData.ImporterGuid }];
        delete sendData.SurveyData.ImporterGuid;
      }

      if (this.dialogModeAdd || this.copySurvey) {
        if (this.copySurvey) {
          sendData.IsCopyOf = this.surveyData.SurveyGuid;
          delete sendData.SurveyData.SurveyGuid;
          delete sendData.SurveyData.SurveyId;
        }
        // Create new survey
        $.ajax({
          method: "POST",
          url: "api/Surveys",
          data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(sendData),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            if (data.Error) {
              _this7.globals.showErrorSnackbar(data.Error);
              console.error(data.Error);
              return;
            }
            // If POST was successful, refresh displayed data and hide dialog
            _this7.globals.showSuccessSnackbar(_this7.lang.U1081);
            _this7.closeEditSurveyDialog();
            _this7.$emit("dialogDataSaved", data[0]);
            _this7.$emit("surveyEditorRedirect", data[0].SurveyId);
          },
          error: function error() {
            console.error("Error on POST in saveEditSurveyDialogData()");
            _this7.globals.showErrorSnackbar(_this7.lang.U1082);
          }
        });
      } else {
        // Update existing survey
        if (forceSave) sendData.ForceSave = true;
        $.ajax({
          method: "PUT",
          url: "api/Surveys/" + this.surveyData.SurveyId,
          data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(sendData),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            if (data.Error) {
              _this7.globals.showErrorSnackbar(data.Error);
              console.error(data.Error);
              return;
            }

            if (data && data.Confirmation && data.Confirmation === "EXISTING_CHECKS") {
              _this7.globals.$off("SaveSurveyDataYesConfirmation");
              _this7.globals.$on("SaveSurveyDataYesConfirmation", function () {
                _this7.saveEditSurveyDialogData(true);
              });

              _this7.globals.$emit("openGlobalConfirmationDialog", {
                initiator: "SaveSurveyData",
                confirmationTitle: _this7.lang.U1062,
                colorRed: true,
                yesButtonText: _this7.lang.U1063,
                noButtonText: _this7.lang.U1064,
                htmlText: "<b>\n                  <p>" + _this7.lang.U1065 + "</p>\n                  <p class=\"text-uppercase\">" + _this7.lang.U1066 + "</p>\n                </b>"
              });
            } else {
              // If PUT was successful, refresh displayed data and hide dialog
              _this7.globals.showSuccessSnackbar(_this7.lang.U1083);
              _this7.closeEditSurveyDialog();
              _this7.$emit("dialogDataSaved", sendData.SurveyData);
            }
          },
          error: function error() {
            console.error("Error on PUT in saveEditSurveyDialogData()");
            _this7.globals.showErrorSnackbar(_this7.lang.U1084);
          }
        });
      }
    }
  },
  watch: {
    showDialog: function showDialog() {
      if (this.showDialog && (this.dialogModeAdd || this.globals.isAccessAllowed("LoopOp_Surveys_Read"))) this.openEditSurveyDialog();else {
        this.closeEditSurveyDialog();
        this.$emit("dialogClosed");
      }
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  props: ["selectedSurvey", "selectedClient", "showDialog", "dialogModeAdd", "copySurvey", "languageList", "localesList"],
  data: function data() {
    // Global data inside the component is stored here
    return {
      dialogTitle: "", // Title of the dialog
      newSurveyLanguage: null,
      newSurveyLanguageLocale: null,
      languageLocaleList: {},
      surveyData: {
        SurveyAttachments: [{}]
      }, // The survey data of the selected survey is stored here
      visibilitySettings: {},
      showAlert: false, // true --> Alert for validation errors is visible
      invalidInputIds: [], // IDs of inputs with validation error
      logoFileObject: {},
      attachmentFileObject: {},
      surveyGroupList: {},
      clientList: [],
      importerList: [],
      currentVisibilitySettings: {
        selected: "survey",
        headerText: "",
        selectedGroups: []
      },
      initialVisibilitySettings: {
        survey: [],
        date: [],
        time: [],
        points: [],
        remarks: [],
        attachment: []
      },
      lang: {
        U0015: "General",
        U0016: "Client",
        U0017: "Title",
        U0018: "Title 2 (subtitle)",
        U0019: "Title 3 (subtitle)",
        U0020: "This is a required entry!",
        U0021: "The inputs are incorrect. Please check the fields marked in red!",
        U0022: "Cancel",
        U0023: "Save",
        U0032: "Add survey",
        U0033: "Edit survey",
        U0040: "Difficulty",
        U0041: "simple",
        U0042: "difficult",
        U1000: "Please select...",
        U1001: "Security group for survey",
        U1002: "Survey",
        U1003: "Date",
        U1004: "Time",
        U1005: "Points",
        U1006: "Mystery Shopper information",
        U1007: "Annex",
        U1011: "The survey is visible for the following groups",
        U1012: "Date (Client view / Export) is visible for the following groups",
        U1013: "Time (Client view / Export) is visible for the following groups",
        U1014: "Points (Client view / Export)  are visible for the following groups",
        U1015: "Mystery Shopper information are visible for the following groups",
        U1016: "Annexes (Client view / Export) are visible for the following groups",
        U1017: "Language versions",
        U1018: "Language selection",
        U1019: "Add",
        U1020: "Language",
        U1021: "Actions",
        U1022: "Annex",
        U1023: "Name of the annex",
        U1024: "File",
        U1025: "Please select a file...",
        U1026: "Other",
        U1027: "Logo",
        U1028: "Please select a logo...",
        U1029: "Minimal annexes",
        U1031: "Activated",
        U1032: "Select all",
        U1033: "Clean selection",
        U1034: "Select file",
        U1035: "Download file",
        U1036: "Delete file",
        U1037: "Survey active",
        U1040: "This language was already selected",
        U1059: "Country",
        U1060: "The following content will NOT be copied and has to be set manually",
        U1061: "Copy survey",
        U1062: "Save survey",
        U1063: "Yes",
        U1064: "No",
        U1065: "ATTENTION: There are already existing checks based on this survey. Do you really want to save?",
        U1066: "All affected checks will be changed by this action",
        U1067: "Please select a language...",
        U1068: "Please select a country...",
        U1069: "Reporting default",
        U1074: "Attachments allowed",
        U1075: "Importer",
        U1076: "Permission denied",
        U1077: "Attachment upload successful",
        U1078: "Logo upload successful",
        U1079: "No survey language selected",
        U1080: "No client selected",
        U1081: "Survey creation successful",
        U1082: "Survey creation failed",
        U1083: "Survey update successful",
        U1084: "Survey update failed",
        U1085: "Survey group data access failed",
        U1086: "Survey data access failed"
      }
    };
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tools_Select2__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Tools_Select2__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "SurveyManagementTranslateModal",
  components: {
    Select2: __WEBPACK_IMPORTED_MODULE_1__Tools_Select2___default.a
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#translateSurveyDialog").on("hidden.bs.modal", function (e) {
      _this.$emit("dialogClosed");
    });
  },

  methods: {
    // Adjusts the height of textareas with the "autoExpand" class
    correctTextareaHeight: function correctTextareaHeight() {
      this.$nextTick(function () {
        var textareas = document.getElementsByClassName("autoExpand");
        for (var i = 0; i < textareas.length; i++) {
          $(textareas[i]).trigger("input");
        }
      });
    },
    openTranslateSurveyDialog: function openTranslateSurveyDialog() {
      this.dialogTitle = this.lang.U1039;
      this.selectedLanguage = "";
      this.translationList = [];
      this.translationListDirty = false;
      this.loadSurveyLocales();
      $("#translateSurveyDialog").modal("show");
    },
    closeTranslateSurveyDialog: function closeTranslateSurveyDialog() {
      if (this.translationListDirty) {
        this.globals.$emit("openGlobalUnsavedChangesDialog", function () {
          $("#translateSurveyDialog").modal("hide");
        });
        return;
      }
      $("#translateSurveyDialog").modal("hide");
    },
    loadSurveyLocales: function loadSurveyLocales() {
      var _this2 = this;

      var queryString = "api/SurveyTranslation/" + this.selectedSurvey.SurveyId + "/Locales";

      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this2.surveyLocales = data;
          _this2.$nextTick(function () {
            $("#inputSurveyLanguage").val("").trigger("change");
          });
        },
        error: function error() {
          console.error("Survey locale data access failed in loadSurveyLocales()");
          _this2.globals.showErrorSnackbar("Survey locale data access failed");
        }
      });
    },
    selectedLanguageChanged: function selectedLanguageChanged(value, event) {
      var _this3 = this;

      if (!value) return;
      if (this.translationListDirty) {
        this.globals.$emit("openGlobalUnsavedChangesDialog", function () {
          _this3.selectedLanguage = value;
          _this3.loadSurveyTranslation();
        }, function () {
          $(event.target).val(_this3.selectedLanguage).trigger("change");
        });
        return;
      }
      this.selectedLanguage = value;
      this.loadSurveyTranslation();
    },
    loadSurveyTranslation: function loadSurveyTranslation() {
      var _this4 = this;

      var queryString = "api/SurveyTranslation/" + this.selectedSurvey.SurveyId + "?localeCode=" + this.selectedLanguage;

      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this4.translationData = data;
          _this4.translationList = _this4.translationData.Translations;
          _this4.translationListDirty = false;
          _this4.correctTextareaHeight();
        },
        error: function error() {
          console.error("Survey translation data access failed in loadSurveyTranslation()");
          _this4.globals.showErrorSnackbar("Translation data access failed");
        }
      });
    },
    toggleAgencyTranslatePermission: function toggleAgencyTranslatePermission() {
      this.translationData.AllowAgencyEdit = !this.translationData.AllowAgencyEdit;
      this.updateAgencyTranslatePermission();
    },
    submitTranslationsFromAgency: function submitTranslationsFromAgency() {
      var _this5 = this;

      this.translationData.AllowAgencyEdit = false;
      if (this.translationListDirty) this.saveTranslateSurveyDialogData(function () {
        _this5.updateAgencyTranslatePermission();
      });else this.updateAgencyTranslatePermission();
    },
    updateAgencyTranslatePermission: function updateAgencyTranslatePermission() {
      var _this6 = this;

      var sendData = { AllowAgencyEdit: this.translationData.AllowAgencyEdit };
      var queryString = "api/SurveyTranslation/" + this.selectedSurvey.SurveyId + "?localeCode=" + this.selectedLanguage;

      $.ajax({
        method: "PATCH",
        url: queryString,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(sendData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (_this6.globals.currentUserRole == 1) _this6.globals.showSuccessSnackbar("Permission update successful");else if (_this6.globals.currentUserRole == 2) _this6.globals.showSuccessSnackbar("Translations submitted");
        },
        error: function error() {
          console.error("Error on PATCH in toggleAgencyTranslatePermission()");
          if (_this6.globals.currentUserRole == 1) _this6.globals.showSuccessSnackbar("Permission update failed");else if (_this6.globals.currentUserRole == 2) _this6.globals.showSuccessSnackbar("Translations submit failed");
        }
      });
    },
    isNewGroup: function isNewGroup(currGroupId) {
      return currGroupId !== this.groupId;
    },
    setNewGroup: function setNewGroup(currGroupId) {
      this.groupId = currGroupId;
    },
    saveTranslateSurveyDialogData: function saveTranslateSurveyDialogData(callback) {
      var _this7 = this;

      var queryString = "api/SurveyTranslation/" + this.selectedSurvey.SurveyId + "?localeCode=" + this.selectedLanguage;

      $.ajax({
        method: "PUT",
        url: queryString,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.translationData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this7.globals.showErrorSnackbar(data.Error);
            _this7.loadSurveyTranslation();
            return;
          }
          _this7.translationListDirty = false;
          _this7.globals.showSuccessSnackbar("Translation data update successful");
          if (callback) callback();
        },
        error: function error() {
          console.error("Error on POST in saveTranslateSurveyDialogData()");
          _this7.globals.showErrorSnackbar("Translation data update failed");
        }
      });
    },
    downloadTranslationExportData: function downloadTranslationExportData() {
      var _this8 = this;

      var queryString = "api/SurveyTranslation/Export?file_type=" + this.exportTranslationFileType;

      $.ajax({
        method: "POST",
        url: queryString,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.translationList),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          var guid = data[0].DownloadId;
          $(window).prop("location", "api/Download/" + guid);
          $("#exportTranslation").modal("hide");
        },
        error: function error() {
          console.error("Error on POST in downloadExportTranslationData()");
          _this8.globals.showErrorSnackbar("Translation export failed");
        }
      });
    },

    // Uploads import data to the server and manipulates the UI depending on the progress and response from the server
    uploadImportData: function uploadImportData() {
      if (this.importTranslationDialogData.selectedOption == "text") {
        if (this.importTranslationDialogData.selectedText == "") {
          console.error("Error: No import text available in uploadImportData()");
          return;
        }

        this.translationList = JSON.parse(this.importTranslationDialogData.selectedText);
      } else if (this.importTranslationDialogData.selectedOption == "file") {
        if (typeof this.importTranslationDialogData.selectedFile == "undefined") {
          console.error("Error: No import file available in uploadImportData()");
          return;
        }
        console.log("Uploading file: " + this.importTranslationDialogData.selectedFile.name);

        var reader = new FileReader();
        reader.readAsDataURL(this.importTranslationDialogData.selectedFile);
        reader.onload = function () {};
        reader.onerror = function (error) {};
      } else console.error("Error on file upload in uploadImportData()");
      $("#importTranslation").modal("hide");
    },


    // Writes the filename to the input of the file import, after a file was selected
    onImportFileChange: function onImportFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;

      var uploadFile = files[0];
      if (typeof uploadFile.name == "undefined" || uploadFile.name == "") return;
      this.importTranslationDialogData.selectedFile = uploadFile;
    },


    // Cleans up the import data after the import got closed
    importClosed: function importClosed() {
      this.displayTranslationImport = false;
      this.importTranslationDialogData.selectedText = "";
      this.importTranslationDialogData.selectedFile = {};
    }
  },
  watch: {
    showDialog: function showDialog() {
      if (this.showDialog) this.openTranslateSurveyDialog();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  props: ["selectedSurvey", "showDialog"],
  data: function data() {
    // Global data inside the component is stored here
    return {
      dialogTitle: "",
      translationList: [],
      translationData: {},
      translationListDirty: false,
      surveyLocales: {},
      selectedLanguage: "",
      exportTranslationFileType: "xlsx",
      importTranslationDialogData: {
        selectedOption: "text", // Should be "text" or "file"
        selectedText: "", // String that is pasted to the textarea on text import
        selectedFile: {}, // File informations of the selected file on file import
        serverResponse: {}, // Response data from the server has to be stored here
        trimImportData: false
      },
      lang: {
        U0023: "Save",
        U1039: "Survey Translation",
        U1018: "Language selection",
        U0056: "Export",
        U0057: "Import",
        U1041: "Survey Import",
        U1042: "Please select an import option",
        U1043: "Text-Import",
        U1044: "File-Import",
        U1045: "Text",
        U1046: "Please insert the table data to be imported here.",
        U1047: "File",
        U1048: "Please select a file...",
        U1049: "Cancel",
        U1050: "OK",
        U1051: "Export translations",
        U1052: "The translation data is ready to download.",
        U1053: "Text CSV (.csv)",
        U1054: "Microsoft Excel 97-2003 (.xls)",
        U1055: "Microsoft Excel 2007-2013 XML (.xlsx)",
        U1056: "Download",
        U1057: "Close",
        U1058: "Load translations",
        U1070: "Enable for agency",
        U1071: "Disable for agency",
        U1072: "Please select...",
        U1073: "Submit"
      }
    };
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cropperjs__ = __webpack_require__(1551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cropperjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_cropperjs__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "SurveyUploadDialog",
  props: ["showDialog", "questionData"],
  components: {
    "vue-cropper": __WEBPACK_IMPORTED_MODULE_2_vue_cropperjs___default.a
  },
  created: function created() {
    var _this = this;

    this.globals.$off("SurveyUploadDialogYesConfirmation");
    this.globals.$on("SurveyUploadDialogYesConfirmation", function () {
      _this.setImageEdited(false);
      _this.filesAdded = false;
      if (_this.fileChanged) {
        _this.setIndex(_this.index);
        _this.fileChanged = false;
      }

      if (_this.currentModeChanged) {
        _this.currentModeChanged = false;
        _this.currentMode = _this.currentMode === "crop" ? "colorize" : "crop";
      }

      _this.closeDialog ? _this.closeSurveyUploadDialog() : _this.restoreImage();
    });
  },

  watch: {
    showDialog: function showDialog() {
      if (this.showDialog) this.openSurveyUploadDialog();else this.closeSurveyUploadDialog();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    },
    edit: function edit() {
      if (this.edit > -1) this.getImage();
    },
    currentMode: function currentMode() {
      if (this.currentMode === "colorize") this.setCanvasSize();
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
    $("#surveyUploadDialog").on("hidden.bs.modal", function () {
      return _this2.$emit("dialogClosed");
    });
    this.getImage();
    this.initCanvas();
    $(window).on("resize", function () {
      _this2.canvas.showCanvas = false;
      var timeoutFunc = function timeoutFunc() {
        _this2.canvas.showCanvas = true;
        _this2.setCanvasSize();
      };
      if (_this2.windowResizeTimer) clearTimeout(_this2.windowResizeTimer);
      _this2.windowResizeTimer = setTimeout(timeoutFunc, 300);
    }).resize();
  },
  data: function data() {
    return {
      selectedFiles: [],
      edit: -1,
      cropedImage: null,
      showFiles: false,
      currentMode: "crop",
      dragMode: "drag",
      windowResizeTimer: null,
      imageSize: {
        height: 0,
        width: 0
      },
      canvas: {
        editCanvas: null,
        editCanvasContext: null,
        editImage: null,
        prevX: 0,
        prevY: 0,
        currX: 0,
        currY: 0,
        lineWidth: 2,
        fillStyle: "#000000",
        globalCompositeOperation: "source-over",
        mouseClicked: false,
        scaleOnNextDraw: 1,
        height: 0,
        width: 0,
        currentShape: "line",
        showCanvas: true
      },
      lang: {
        SU0000: "Edit Uploads",
        SU0001: "Upload",
        SU0002: "Close",
        SU0003: "Color",
        SU0004: "Line width",
        SU0005: "Name",
        SU0006: "Size",
        SU0007: "Last modified",
        SU0008: "File type",
        SU0009: "Add files",
        SU0010: "Delete selected files",
        SU0011: "Save changes",
        SU0012: "Scaling mode",
        SU0013: "Zoom in",
        SU0014: "Zoom out",
        SU0015: "Zoom to original size",
        SU0016: "Drag mode",
        SU0017: "Rotate left",
        SU0018: "Rotate right",
        SU0019: "Cropping mode",
        SU0020: "Crop image",
        SU0021: "Drawing mode",
        SU0022: "Pen",
        SU0023: "Frame",
        SU0024: "Rectangle",
        SU0025: "Undo",
        SU0026: "Redo",
        SU0027: "Discard changes",
        SU0028: "Yes",
        SU0029: "No",
        SU0030: "There are unsaved changes. Do you want to proceed?"
      },
      shapes: [],
      shape: {},
      editedImages: [],
      editedImage: {},
      indexToDelete: [],
      countFilesToDelete: 0,
      filesToDeleteInSurvey: [],
      editimg: null,
      fileTypesMimeIcons: {
        ods: "/static/mime/ods.png", // open/libre office calc
        odt: "/static/mime/odt.png", // open/libre office writer
        doc: "/static/mime/doc.png", // ms office word
        docx: "/static/mime/doc.png", // ms office word
        xls: "/static/mime/xls.png", // ms office excel
        xlsx: "/static/mime/xlsx.png", // ms office excel
        pdf: "/static/mime/pdf.png", // pdf
        txt: "/static/mime/txt.png", // text file
        zip: "/static/mime/zip.png", // zip file
        default: "/static/mime/blank.png" // all other files
      },
      imageTypes: ["jpg", "jpeg", "gif", "png", "tif"],
      imageEdited: false,
      imageSaved: false,
      disableUploadButton: false,
      currentShapesLength: -1,
      lastActionRedo: true,
      lastActionUndo: true,
      disableAddFileButton: false,
      filesAdded: false,
      closeDialog: false,
      currentModeChanged: false,
      currentShapesLengthSaved: 0,
      fileChanged: false,
      index: -1
    };
  },

  methods: {
    getConfirmationDialogData: function getConfirmationDialogData() {
      return {
        initiator: "SurveyUploadDialog",
        confirmationTitle: this.lang.SU0027,
        yesButtonText: this.lang.SU0028,
        noButtonText: this.lang.SU0029,
        colorRed: true,
        htmlText: "<b>" + this.lang.SU0030 + "</b>"
      };
    },
    restoreImage: function restoreImage() {
      // if (this.fileChanged) {
      //   this.cropedImage = null;
      //   this.shape = {};
      //   this.shapes = [];
      //   this.fileChanged = false;
      // } else {
      this.cropedImage = null;
      if (this.currentMode === "crop") {
        this.getImage();
      } else {
        this.shape = {};
        this.shapes.splice(this.currentShapesLengthSaved, this.shapes.length);
        this.currentShapesLength = this.currentShapesLengthSaved;
        this.draw(this.currentShapesLengthSaved);
      }
      // }
    },
    saveFilesToBackend: function saveFilesToBackend() {
      var _this3 = this;

      var filesToUpload = {};
      this.filesAdded = false;
      if (!this.imageEdited) {
        filesToUpload = {
          questionName: this.questionData.questionName,
          files: this.selectedFiles.filter(function (file) {
            return !file.content;
          }),
          filesToDeleteInSurvey: this.filesToDeleteInSurvey
        };
        this.$emit("dialogDataSaved", filesToUpload);
        this.globals.$on("surveyAttachmentUploadComplete", function () {
          _this3.filesAdded = false;
          _this3.fileChanged = false;
          _this3.closeSurveyUploadDialog();
        });
        if (filesToUpload.files.length < 1) this.closeSurveyUploadDialog();
      } else {
        this.closeDialog = true;
        this.globals.$emit("openGlobalConfirmationDialog", this.getConfirmationDialogData());
      }
    },
    openSurveyUploadDialog: function openSurveyUploadDialog() {
      $("#surveyUploadDialog").modal("show");
      this.initQuestionContent();
    },
    closeSurveyUploadDialog: function closeSurveyUploadDialog() {
      if (!this.imageEdited && !this.filesAdded && !this.fileChanged) {
        this.edit = -1;
        this.editimg = null;
        this.selectedFiles = [];
        this.cropedImage = null;
        this.showFiles = false;
        this.currentMode = "crop";
        this.shapes = [];
        this.shape = {};
        this.editedImages = [];
        this.editedImage = {};
        this.countFilesToDelete = 0;
        this.canvas.lineWidth = 2;
        this.canvas.fillStyle = "#000000";
        this.canvas.currentShape = "line";
        this.filesToDeleteInSurvey = [];
        this.disableUploadButton = false;
        this.lastActionRedo = true;
        this.lastActionUndo = true;
        $("#fileChooser").val("");
        $("#surveyUploadDialog").modal("hide");
      } else {
        this.closeDialog = true;
        this.globals.$emit("openGlobalConfirmationDialog", this.getConfirmationDialogData());
      }
    },
    initCanvas: function initCanvas() {
      this.imageSize.height = $(".show-image").height();
      this.imageSize.width = $(".show-image").width();
      // initialize canvas
      this.canvas.editCanvas = document.getElementById("editCanvas");
      this.canvas.editCanvasContext = this.canvas.editCanvas.getContext("2d");
      // mouse listener
      this.canvas.editCanvas.addEventListener("mousemove", this.handleMouseEvent);
      this.canvas.editCanvas.addEventListener("mousedown", this.handleMouseEvent);
      this.canvas.editCanvas.addEventListener("mouseup", this.handleMouseEvent);
      this.canvas.editCanvas.addEventListener("mouseout", this.handleMouseEvent);
    },
    initQuestionContent: function initQuestionContent() {
      var _this4 = this;

      if (this.questionData.questionContent && this.questionData.questionContent.length > 0) {
        this.selectedFiles = this.questionData.questionContent;
        _.forEach(this.selectedFiles, function (file) {
          _this4.setMimeTypeIcon(file);
          file.delete = false;
        });
        this.showFiles = true;
      }
      this.disableAddFileButton = !this.questionData.allowMultipleFiles && this.selectedFiles.length === 1;
    },
    handleFiles: function handleFiles(event) {
      var _this5 = this;

      var oldSelectedFiles = [];
      if (event.target.files.length < 1) return; // File selection aborted
      if (this.selectedFiles) {
        // no duplicate files
        oldSelectedFiles = this.selectedFiles;
        this.selectedFiles = _.unionBy(oldSelectedFiles, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(event.target.files), "name");
        this.disableUploadButton = oldSelectedFiles.length !== this.selectedFiles.length;
      } else {
        this.selectedFiles = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(event.target.files);
        this.disableUploadButton = true;
      }
      event.target.value = null;

      var callback = function callback() {
        _this5.showFiles = true;
        _this5.updateFileList();
        _this5.$forceUpdate();
        _this5.filesAdded = !_this5.filesAdded ? oldSelectedFiles.length !== _this5.selectedFiles.length : _this5.filesAdded;
        _this5.disableAddFileButton = !_this5.questionData.allowMultipleFiles && _this5.selectedFiles.length === 1;
      };

      var _loop = function _loop(i) {
        if (!_this5.selectedFiles[i].content) {
          if (_.startsWith(_this5.selectedFiles[i].type, "image")) {
            _this5.selectedFiles[i].imageUrl = URL.createObjectURL(_this5.selectedFiles[i]);
            _this5.globals.getImageOrientation(_this5.selectedFiles[i], function (orientation) {
              _this5.globals.resetImageOrientation(_this5.selectedFiles[i], orientation, function (data) {
                _this5.selectedFiles[i] = data;
                _this5.selectedFiles[i].delete = false;
                _this5.setMimeTypeIcon(_this5.selectedFiles[i]);
                if (i === _this5.selectedFiles.length - 1) callback();
                _this5.$forceUpdate();
              });
            });
          } else {
            _this5.selectedFiles[i].delete = false;
            _this5.setMimeTypeIcon(_this5.selectedFiles[i]);
            callback();
          }
        }
      };

      for (var i = 0; i < this.selectedFiles.length; i++) {
        _loop(i);
      }
    },
    setMimeTypeIcon: function setMimeTypeIcon(file) {
      var words = file.name.split(".");
      var extension = words[words.length - 1];
      if (this.imageTypes.indexOf(extension.toLowerCase()) > -1) {
        file.imageUrl = file.content ? "/api/Download/" + file.content : URL.createObjectURL(file);
      } else file.imageUrl = this.fileTypesMimeIcons[extension] || this.fileTypesMimeIcons["default"];
    },
    onToggleDelete: function onToggleDelete(index) {
      var _this6 = this;

      this.selectedFiles[index].delete = !this.selectedFiles[index].delete;
      this.countFilesToDelete = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.selectedFiles).reduce(function (count, key) {
        if (_this6.selectedFiles[key].delete) count++;
        return count;
      }, 0);
      if (this.editedImages.length > 0) {
        _.forEach(this.editedImages, function (image) {
          if (image.index === index) {
            image.delete = !image.delete;
          }
        });
      }
      this.$forceUpdate();
    },
    onDeleteFiles: function onDeleteFiles() {
      var _this7 = this;

      this.selectedFiles = this.selectedFiles.filter(function (file) {
        if (file.delete) _this7.filesToDeleteInSurvey.push({ name: file.name });
        return !file.delete;
      });

      if (this.editedImages.length > 0) {
        var filesToDelete = _.filter(this.editedImages, function (image) {
          return image.delete;
        });
        var nrFilesToDelete = _.size(filesToDelete);
        var maxIndex = filesToDelete.reduce(function (max, item) {
          return item.index > max ? item.index : max;
        }, 0);
        this.editedImages.map(function (file) {
          file.index = file.index > maxIndex ? file.index - nrFilesToDelete : file.index;
        });
        this.editedImages = _.remove(this.editedImages, function (image) {
          return !image.delete;
        });
      }
      this.showFiles = this.selectedFiles.length > 0 ? true : false;
      this.edit = -1;
      this.editimg = null;
      this.cropedImage = null;
      this.currentMode = "colorize";
      this.countFilesToDelete = 0;
      this.disableUploadButton = true;
      this.filesAdded = true;
      this.disableAddFileButton = !this.questionData.allowMultipleFiles && this.selectedFiles.length === 1;
    },
    setImageEdited: function setImageEdited(edit) {
      this.imageEdited = edit;
      if (!edit) {
        this.lastActionRedo = true;
        this.lastActionUndo = true;
      }
      this.imageEdited ? ($(".btn-save-mini").css("background-color", "red"), this.disableUploadButton = false) : ($(".btn-save-mini").css("background-color", "green"), this.disableUploadButton = true);
    },
    onCropImage: function onCropImage() {
      var imageType = this.selectedFiles[this.index].type;
      this.cropedImage = this.$refs.cropper.getCroppedCanvas().toDataURL(imageType);
      this.$refs.cropper.replace(this.cropedImage);
      this.setImageEdited(true);
    },
    onZoomIn: function onZoomIn() {
      this.$refs.cropper.relativeZoom(0.1);
    },
    onZoomOut: function onZoomOut() {
      this.$refs.cropper.relativeZoom(-0.1);
    },
    onRotateLeft: function onRotateLeft() {
      this.$refs.cropper.rotate(-90);
      this.getRotatedImage();
      this.setImageEdited(true);
    },
    onRotateRight: function onRotateRight() {
      this.$refs.cropper.rotate(90);
      this.getRotatedImage();
      this.setImageEdited(true);
    },
    onZoomToOriginalSize: function onZoomToOriginalSize() {
      this.$refs.cropper.zoomTo(1);
    },
    onSetDragMode: function onSetDragMode(dragMode) {
      this.$refs.cropper.setDragMode(dragMode);
      this.dragMode = dragMode;
    },
    getRotatedImage: function getRotatedImage() {
      // change to old way if browser doesn't support object destructuring
      var _$refs$cropper$getCan = this.$refs.cropper.getCanvasData(),
          canvasWidth = _$refs$cropper$getCan.width,
          canvasHeight = _$refs$cropper$getCan.height;

      var _$refs$cropper$getCro = this.$refs.cropper.getCropBoxData(),
          cropBoxLeft = _$refs$cropper$getCro.left,
          cropBoxTop = _$refs$cropper$getCro.top,
          cropBoxWidth = _$refs$cropper$getCro.width,
          cropBoxHeight = _$refs$cropper$getCro.height;

      this.$refs.cropper.setCropBoxData({
        left: 0,
        top: 0,
        width: canvasWidth,
        height: canvasHeight
      });

      var imageType = this.selectedFiles[this.index].type;
      this.cropedImage = this.$refs.cropper.getCroppedCanvas().toDataURL(imageType);
      this.$refs.cropper.setCropBoxData({
        left: cropBoxLeft,
        top: cropBoxTop,
        width: cropBoxWidth,
        height: cropBoxHeight
      });
    },
    updateFileList: function updateFileList() {
      var _this8 = this;

      if (this.editedImages.length > 0) {
        this.editedImages.forEach(function (image) {
          _this8.selectedFiles[image.index] = image.image;
          _this8.selectedFiles[image.index].imageUrl = URL.createObjectURL(image.image);
          _this8.selectedFiles[image.index].delete = false;
          _this8.selectedFiles[image.index].index = image.index;
        });
      }
    },
    saveImage: function saveImage() {
      var _this9 = this;

      // check if a selected image was already edited
      var idx = _.findIndex(this.editedImages, function (image) {
        return image.index === _this9.edit;
      });
      var imageType = this.selectedFiles[this.index].type;

      // Convert Blob to File
      // source: https://stackoverflow.com/questions/27159179/how-to-convert-blob-to-file-in-javascript
      var file = null;
      if (this.currentMode === "crop" && this.cropedImage) {
        file = this.globals.dataURItoBlob(this.cropedImage);
      } else if (this.currentMode === "colorize") {
        file = this.globals.dataURItoBlob(this.canvas.editCanvas.toDataURL(imageType));
      }

      file.name = this.editimg.name;
      file.lastModifiedDate = new Date();
      if (idx > -1) {
        this.editedImages[idx].image = file;
      } else {
        this.editedImage = {
          index: this.edit,
          image: file
        };
      }
      this.currentShapesLengthSaved = this.shapes.length;
      this.cropedImage = null;

      if (!_.isEmpty(this.editedImage)) this.editedImages.push(this.editedImage);
      var newEditimg = idx > -1 ? this.editedImages[idx].image : this.editedImage.image;
      if (newEditimg) this.editimg = newEditimg;
      this.updateFileList();
      this.$forceUpdate();
      this.editedImage = {};
      this.setImageEdited(false);
      this.imageSaved = true;
      this.fileChanged = true;
    },
    drawImageOnCanvas: function drawImageOnCanvas(image) {
      this.canvas.editCanvasContext.setTransform(1, 0, 0, 1, 0, 0);
      if (!this.canvas.editImage) {
        this.canvas.editImage = new Image();
        this.canvas.editImage.src = image.imageUrl;
      }
      if (this.cropedImage) this.canvas.editImage.src = this.cropedImage;
      this.canvas.editCanvas.height = this.canvas.editImage.height;
      this.canvas.editCanvas.width = this.canvas.editImage.width;
      this.canvas.scaleOnNextDraw = this.canvas.editImage.height / this.canvas.height;
      this.canvas.editCanvasContext.drawImage(this.canvas.editImage, 0, 0);
    },
    clearCanvas: function clearCanvas() {
      // clear canvas
      // Use the identity matrix while clearing the canvas
      this.canvas.editCanvasContext.setTransform(1, 0, 0, 1, 0, 0);
      this.canvas.editCanvasContext.clearRect(0, 0, this.canvas.editCanvas.width, this.canvas.editCanvas.height);
    },
    formatDate: function formatDate(dateInMs) {
      return this.globals.getLocalizedDateTimeFromIsoTimestamp(dateInMs);
    },
    formatBytes: function formatBytes(a, b) {
      // source: https://stackoverflow.com/questions/15900485/correct-way-to-convert-size-in-bytes-to-kb-mb-gb-in-javascript
      if (0 == a) return "0 Bytes";
      var c = 1024,
          d = b || 2,
          e = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
          f = Math.floor(Math.log(a) / Math.log(c));
      return parseFloat((a / Math.pow(c, f)).toFixed(d)) + " " + e[f];
    },
    undoLastAction: function undoLastAction() {
      this.currentShapesLength -= 1;
      this.lastActionUndo = this.currentShapesLength > 0 ? false : true;
      this.setImageEdited(!this.lastActionUndo);
      this.lastActionRedo = false;
      this.draw(this.currentShapesLength);
    },
    redoLastAction: function redoLastAction() {
      if (this.currentShapesLength < this.shapes.length) {
        this.currentShapesLength += 1;
        this.lastActionUndo = false;
      }
      this.lastActionRedo = this.currentShapesLength < this.shapes.length ? false : true;
      this.setImageEdited(true);
      this.draw(this.currentShapesLength);
    },
    handleMouseEvent: function handleMouseEvent(e) {
      if (e.type === "mousedown") {
        this.canvas.prevX = this.canvas.currX;
        this.canvas.prevY = this.canvas.currY;
        this.canvas.currX = e.offsetX;
        this.canvas.currY = e.offsetY;
        this.canvas.mouseClicked = true;
        this.shape.name = this.canvas.currentShape;
        this.shape.color = this.canvas.fillStyle;
        this.shape.lineWidth = this.canvas.lineWidth;
        if (this.canvas.currentShape !== "line") {
          this.shape.startX = this.canvas.currX;
          this.shape.startY = this.canvas.currY;
        }
        if (this.canvas.currentShape === "line") {
          this.shape.linePoints = [];
          var linePoint = {
            previousPoint: {
              x: this.canvas.currX,
              y: this.canvas.currY
            },
            currentPoint: {
              x: this.canvas.currX,
              y: this.canvas.currY
            }
          };
          this.shape.linePoints.push(linePoint);
        }
        this.draw(this.currentShapesLength);
      }
      if (e.type === "mouseup") {
        this.canvas.mouseClicked = false;
        if (this.currentShapesLength < this.shapes.length) this.shapes.splice(this.currentShapesLength, this.shapes.length);
        this.shapes.push(this.shape);
        this.shape = {};
        this.setImageEdited(true);
        this.currentShapesLength = this.shapes.length;
        this.lastActionUndo = false;
        this.lastActionRedo = true;
      }
      if (e.type === "mouseout") {
        this.canvas.mouseClicked = false;
      }
      if (e.type === "mousemove") {
        if (this.canvas.mouseClicked) {
          this.canvas.prevX = this.canvas.currX;
          this.canvas.prevY = this.canvas.currY;
          this.canvas.currX = e.offsetX;
          this.canvas.currY = e.offsetY;
          if (this.canvas.currentShape === "line") {
            var _linePoint = {
              previousPoint: {
                x: this.canvas.prevX,
                y: this.canvas.prevY
              },
              currentPoint: {
                x: this.canvas.currX,
                y: this.canvas.currY
              }
            };
            this.shape.linePoints.push(_linePoint);
          }
          if (this.canvas.currentShape !== "line") {
            this.shape.width = this.canvas.currX - this.shape.startX;
            this.shape.height = this.canvas.currY - this.shape.startY;
          }
          this.draw(this.currentShapesLength);
        }
      }
    },
    drawShape: function drawShape(shape) {
      var _this10 = this;

      this.canvas.editCanvasContext.beginPath();
      switch (shape.name) {
        case "line":
          this.canvas.editCanvasContext.lineWidth = shape.lineWidth;
          this.canvas.editCanvasContext.strokeStyle = shape.color;
          this.canvas.editCanvasContext.lineCap = "round";
          shape.linePoints.forEach(function (linePoint) {
            _this10.drawLine(linePoint.previousPoint.x, linePoint.previousPoint.y, linePoint.currentPoint.x, linePoint.currentPoint.y);
          });
          break;
        case "rectangle":
          this.drawRectangle(shape.startX, shape.startY, shape.width, shape.height, shape.color, shape.lineWidth);
          break;
        case "fillrectangle":
          this.drawFillRectangle(shape.startX, shape.startY, shape.width, shape.height, shape.color, shape.lineWidth);
          break;
      }
      this.canvas.editCanvasContext.stroke();
      this.canvas.editCanvasContext.closePath();
    },
    draw: function draw(numberOfShapes) {
      this.clearCanvas();
      if (!this.canvas.editImage) return;
      this.drawImageOnCanvas(this.canvas.editImage);
      if (this.canvas.scaleOnNextDraw !== 1) {
        this.canvas.editCanvasContext.scale(this.canvas.scaleOnNextDraw, this.canvas.scaleOnNextDraw);
        this.canvas.scaleOnNextDraw = 1;
      }
      // draw all saved shapes
      if (this.shapes.length > 0) {
        for (var i = 0; i < numberOfShapes; i++) {
          this.drawShape(this.shapes[i]);
        }
      }
      // draw current shape
      if (this.shape) this.drawShape(this.shape);
    },
    drawLine: function drawLine(startX, startY, endX, endY) {
      this.canvas.editCanvasContext.moveTo(startX, startY);
      this.canvas.editCanvasContext.lineTo(endX, endY);
    },
    drawRectangle: function drawRectangle(startX, startY, width, height, color, lineWidth) {
      this.canvas.editCanvasContext.lineWidth = lineWidth;
      this.canvas.editCanvasContext.strokeStyle = color;
      this.canvas.editCanvasContext.rect(startX, startY, width, height);
    },
    drawFillRectangle: function drawFillRectangle(startX, startY, width, height, color, lineWidth) {
      this.canvas.editCanvasContext.lineWidth = lineWidth;
      this.canvas.editCanvasContext.fillStyle = color;
      this.canvas.editCanvasContext.fillRect(startX, startY, width, height);
    },
    setCurrentShape: function setCurrentShape(shape) {
      this.canvas.currentShape = shape;
    },
    setCurrentMode: function setCurrentMode(mode) {
      if (!this.imageEdited) {
        if (this.canvas.editImage) {
          this.canvas.editImage = null;
          this.shape = {};
          this.shapes = [];
        }
        this.currentMode = mode;
        if (!this.editimg) return;
        if (this.currentMode === "colorize") {
          this.drawImageOnCanvas(this.editimg);
          this.setImageEdited(false);
        } else this.$refs.cropper.replace(this.editimg.imageUrl);
      } else {
        this.closeDialog = false;
        this.currentModeChanged = true;
        this.globals.$emit("openGlobalConfirmationDialog", this.getConfirmationDialogData());
      }
    },
    setIndex: function setIndex(index) {
      this.index = index;
      if (!this.imageEdited) {
        this.currentMode = "crop";
        this.onSetDragMode("move");
        if (this.canvas.editImage) {
          this.canvas.editImage = null;
          this.shape = {};
          this.shapes = [];
          this.cropedImage = null;
        }
        this.edit = index;
        this.setImageEdited(false);
      } else {
        this.closeDialog = false;
        this.fileChanged = true;
        this.globals.$emit("openGlobalConfirmationDialog", this.getConfirmationDialogData());
      }
    },
    getImage: function getImage() {
      this.editimg = this.edit in this.selectedFiles ? this.selectedFiles[this.edit] : null;
      this.setCanvasSize();
    },
    calculateImageRatio: function calculateImageRatio(image, callback) {
      var imageObj = new Image();
      imageObj.onload = function () {
        callback(this.width / this.height);
      };
      imageObj.src = image.imageUrl;
    },
    setCanvasSize: function setCanvasSize() {
      var _this11 = this;

      if (!this.editimg) return;

      // if selected element is an image -> show on canvas
      if (_.startsWith(this.editimg.type, "image")) {
        this.calculateImageRatio(this.editimg, function (ratio) {
          _this11.imageSize.height = $(".show-image").height();
          _this11.imageSize.width = $(".show-image").width();
          var displayRatio = _this11.imageSize.width / _this11.imageSize.height;
          var canvasHeight = void 0,
              canvasWidth = void 0,
              canvasTopSpace = 0,
              canvasLeftSpace = 0;
          if (displayRatio < ratio) {
            canvasWidth = _this11.imageSize.width;
            canvasHeight = _this11.imageSize.width / ratio;
            canvasTopSpace = (_this11.imageSize.height - canvasHeight) / 2;
          } else {
            canvasWidth = _this11.imageSize.height * ratio;
            canvasHeight = _this11.imageSize.height;
            canvasLeftSpace = (_this11.imageSize.width - canvasWidth) / 2;
          }
          _this11.canvas.editCanvas.style.height = canvasHeight.toString() + "px";
          _this11.canvas.editCanvas.style.width = canvasWidth.toString() + "px";
          _this11.canvas.editCanvas.style.marginTop = canvasTopSpace.toString() + "px";
          _this11.canvas.editCanvas.style.marginLeft = canvasLeftSpace.toString() + "px";
          _this11.canvas.height = canvasHeight;
          _this11.canvas.width = canvasWidth;
          _this11.currentMode === "crop" ? _this11.$refs.cropper.replace(_this11.editimg.imageUrl) : _this11.drawImageOnCanvas(_this11.editimg);
        });
        this.canvas.showCanvas = true;
      } else this.canvas.showCanvas = false;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_survey_vue__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_survey_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_survey_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_inputmask__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_inputmask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_inputmask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Tools_Select2__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Tools_Select2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SurveyUploadDialog__ = __webpack_require__(1621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SurveyUploadDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__SurveyUploadDialog__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var Survey = __WEBPACK_IMPORTED_MODULE_4_survey_vue__["Survey"];

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "SurveyView",
  components: { "survey-upload-dialog": __WEBPACK_IMPORTED_MODULE_7__SurveyUploadDialog___default.a, Select2: __WEBPACK_IMPORTED_MODULE_6__Tools_Select2___default.a },
  props: {
    selectedSurveyInstanceFromParent: Number,
    displayOnlyMode: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showUploadDialog: false,
      surveyInstanceId: "",
      surveyLocaleCode: "",
      survey: new __WEBPACK_IMPORTED_MODULE_4_survey_vue__["Model"](),
      surveyData: null,
      saveRequestPending: false,
      surveyInstanceStatusId: -1,
      fpDate: null,
      fpTimeIn: null,
      fpTimeOut: null,
      fpInstancesFromSurvey: [],
      invalidInputIds: [],
      inputMetaInformationDisabled: false,
      saveButtonDisabled: true,
      prevButtonDisabled: true,
      nextButtonDisabled: true,
      completeButtonDisabled: true,
      moveToShopperButtonDisabled: true,
      moveToAgencyButtonDisabled: true,
      moveToMSMButtonDisabled: true,
      moveToMSMInternalButtonDisabled: true,
      metaInformation: {},
      dynamicPanels: null,
      currentRouterPath: "",
      isClosableWindow: false,
      questionData: {
        acceptedTypes: null,
        questionContent: null,
        questionName: "",
        questionId: "",
        allowMultipleFiles: false
      },
      singleInputTypes: ["date", "datetime", "email", "number", "tel", "time", "url", "currency"],
      lang: {
        SV0000: "Meta information",
        SV0001: "Date",
        SV0002: "Time in",
        SV0003: "Time out",
        SV0004: "Memo Shopper",
        SV0005: "Memo Agency",
        SV0006: "Memo MSM",
        SV0007: "Prev",
        SV0008: "Next",
        SV0009: "Complete",
        SV0010: "Close",
        SV0011: "Save",
        SV0012: "This information is required!",
        SV0013: "Survey Instance Id",
        SV0014: "Survey Id",
        SV0015: "Survey Instance Guid",
        SV0016: "Location Store Id",
        SV0017: "Location Name",
        SV0018: "Location Address",
        SV0019: "Location Country",
        SV0020: "Scenario Name",
        SV0021: "Wave Name",
        SV0022: "Instructions",
        SV0023: "Edit Uploads",
        SV0024: "Move to shopper",
        SV0025: "Move to agency",
        SV0026: "Move to MSM",
        SV0027: "Validate",
        SV0028: "Internal Review",
        SV0029: "Score",
        SV0030: "Estimated - Relevant are the reporting results",
        SV0031: "Validation error - please check your inputs!",
        SV0038: "Close Survey",
        SV0039: "Yes",
        SV0040: "No",
        SV0041: "There are unsaved changes for this survey.",
        SV0042: "Do you really want to quit without saving?",
        SV0045: "Position latitude",
        SV0046: "Position longitude",
        SV0051: "Language",
        SV0052: "Change language",
        SV0053: "Save",
        SV0054: "Discard",
        SV0055: "There are unsaved changes that will be lost after switching the survey language.",
        SV0056: "Do you want to save the current changes?",
        SV0057: "Check Info",
        SV0058: "Invalid value",
        SV0059: "Wave Info",
        SV0060: "Audi car model distribution",
        SV0061: "Show check history",
        SV0062: "Competitor car distribution",
        SV0063: "Shopper",
        SV0064: "Age",
        SV0065: "Gender",
        SV0066: "Car",
        SV0067: "Target segment",
        SV0068: "Target model",
        SV0069: "Move to local agency",
        SV0070: "Move to lead agency"
      },
      requiredFields: ["inputDateSurveyView", "inputTimeInSurveyView", "inputTimeOutSurveyView"]
    };
  },
  created: function created() {
    this.configureSurveyJs();
    this.initializeSurveyDesign();
  },
  mounted: function mounted() {
    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this);
      this.getSurveyViewLocalization();

      this.initializeDataFromParent();
      this.getSurveyDataByInstanceId();
    }
    this.currentRouterPath = this.$route.path;
    this.isClosableWindow = !!window.opener;
  },
  destroyed: function destroyed() {
    if (this.fpDate) this.fpDate.destroy();
    if (this.fpTimeIn) this.fpTimeIn.destroy();
    if (this.fpTimeOut) this.fpTimeOut.destroy();
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.fpInstancesFromSurvey), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var instance = _step.value;

        if (instance) instance.destroy();
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  },

  methods: {
    openSurveyUploadDialog: function openSurveyUploadDialog() {
      var _this = this;

      if (this.survey && this.survey.data) {
        if (this.dynamicPanels && this.dynamicPanels.length > 0) {
          var questionPanel = this.dynamicPanels.filter(function (panel) {
            return panel.elements[0].id === _this.questionData.questionId;
          });
          if (questionPanel.length > 0) this.questionData.questionContent = _.cloneDeep(questionPanel[0].elements[0].value);else if (this.survey.data[this.questionData.questionName]) this.questionData.questionContent = _.cloneDeep(this.survey.data[this.questionData.questionName]);
        } else if (this.survey.data[this.questionData.questionName]) this.questionData.questionContent = _.cloneDeep(this.survey.data[this.questionData.questionName]);
      }
      this.showUploadDialog = true;
    },
    onSurveyUploadDialogClosed: function onSurveyUploadDialogClosed() {
      this.questionData.questionContent = null;
      this.showUploadDialog = false;
    },
    onUploadDialogDataSaved: function onUploadDialogDataSaved(filesToSave) {
      var _this2 = this;

      var questionName = filesToSave.questionName;
      var filesToDelete = filesToSave.filesToDeleteInSurvey;

      if (filesToSave.files.length > 0 || filesToDelete.length > 0) this.saveButtonDisabled = false;

      if (filesToSave.files.length > 0) {
        _.forEach(filesToSave.files, function (file) {
          // delete old files before adding the edited ones
          var idx = void 0;
          if (_this2.dynamicPanels && _this2.dynamicPanels.length > 0) {
            var dynPanelAnswers = _this2.survey.data.e99999;
            for (var i = 0; i < dynPanelAnswers.length; i++) {
              idx = _.findIndex(_this2.survey.data.e99999[i][questionName], function (f) {
                return f.name === file.name;
              });
              if (idx > -1) _this2.survey.data.e99999[i][questionName].splice(idx, 1);
            }
          }
          var currentQuestion = _this2.survey.getQuestionByName(questionName);
          if (currentQuestion && currentQuestion.getType() === "file") {
            idx = _.findIndex(_this2.survey.data[questionName], function (f) {
              return f.name === file.name;
            });
            currentQuestion.removeFile(file);
          }
        });
        if (this.dynamicPanels && this.dynamicPanels.length > 0) {
          var questionPanel = this.dynamicPanels.filter(function (panel) {
            return panel.elements[0].id === _this2.questionData.questionId;
          });
          if (questionPanel.length > 0) questionPanel[0].elements[0].loadFiles(filesToSave.files);else this.survey.getQuestionByName(questionName).loadFiles(filesToSave.files);
        } else {
          this.survey.getQuestionByName(questionName).loadFiles(filesToSave.files);
        }
      }
      // remove deleted files in dialog in survey
      if (filesToDelete.length > 0) {
        if (this.dynamicPanels && this.dynamicPanels.length > 0) {
          var _questionPanel = this.dynamicPanels.filter(function (panel) {
            return panel.elements[0].id === _this2.questionData.questionId;
          });
          if (_questionPanel.length > 0) {
            _.forEach(filesToDelete, function (file) {
              var idx = _.findIndex(_questionPanel[0].elements[0].value, function (f) {
                return f.name === file.name;
              });
              if (idx > -1) _questionPanel[0].elements[0].value.splice(idx, 1);
              _questionPanel[0].elements[0].removeFile(file);
            });
          } else {
            _.forEach(filesToDelete, function (file) {
              var idx = _.findIndex(_this2.survey.data[questionName], function (f) {
                return f.name === file.name;
              });
              if (idx > -1) _this2.survey.data[questionName].splice(idx, 1);
              _this2.survey.getQuestionByName(questionName).removeFile(file);
            });
          }
        } else {
          _.forEach(filesToDelete, function (file) {
            var idx = _.findIndex(_this2.survey.data[questionName], function (f) {
              return f.name === file.name;
            });
            if (idx > -1) _this2.survey.data[questionName].splice(idx, 1);
            _this2.survey.getQuestionByName(questionName).removeFile(file);
          });
        }
      }
    },
    showCheckHistory: function showCheckHistory() {
      var config = {
        type: "SurveyInstance",
        guid: this.metaInformation.SurveyInstanceGuid,
        id: this.metaInformation.SurveyInstanceId
      };
      this.globals.$emit("showElementHistory", config);
    },
    configureSurveyJs: function configureSurveyJs() {
      var _this3 = this;

      // Register functions for expression trigger and add maxPointsReached for selectbase questions
      __WEBPACK_IMPORTED_MODULE_4_survey_vue__["FunctionFactory"].Instance.register("setMaxPoints", function (params) {
        if (params.length < 1 || !_this3.survey) return;
        for (var i = 0; i < params.length; i++) {
          var q = _this3.survey.getQuestionByName(params[i]);
          if (q) q.maxPointsReached = true;
        }
      });
      __WEBPACK_IMPORTED_MODULE_4_survey_vue__["FunctionFactory"].Instance.register("unsetMaxPoints", function (params) {
        if (params.length < 1 || !_this3.survey) return;
        for (var i = 0; i < params.length; i++) {
          var q = _this3.survey.getQuestionByName(params[i]);
          if (q && q.maxPointsReached) q.maxPointsReached = false;
        }
      });
      __WEBPACK_IMPORTED_MODULE_4_survey_vue__["JsonObject"].metaData.addProperty("selectbase", {
        name: "maxPointsReached:boolean"
      });
      __WEBPACK_IMPORTED_MODULE_4_survey_vue__["JsonObject"].metaData.addProperty("panel", {
        name: "isCluster:boolean"
      });
      __WEBPACK_IMPORTED_MODULE_4_survey_vue__["JsonObject"].metaData.addProperty("panel", {
        name: "backgroundColor:text"
      });
      __WEBPACK_IMPORTED_MODULE_4_survey_vue__["JsonObject"].metaData.addProperty("question", "commentForShopper:text");

      __WEBPACK_IMPORTED_MODULE_4_survey_vue__["JsonObject"].metaData.addProperty("checkbox", "exclusiveValue:checkboxValue");

      // Add points to answers
      __WEBPACK_IMPORTED_MODULE_4_survey_vue__["JsonObject"].metaData.addClass("itemvaluesWithPoints", ["points:number"], null, "itemvalue");
      __WEBPACK_IMPORTED_MODULE_4_survey_vue__["JsonObject"].metaData.addProperty("selectbase", "choices:itemvalues");
      var property1 = __WEBPACK_IMPORTED_MODULE_4_survey_vue__["JsonObject"].metaData.findProperty("selectbase", "choices");
      property1.typeValue = "itemvaluesWithPoints";
      property1.className = "itemvaluesWithPoints";

      __WEBPACK_IMPORTED_MODULE_4_survey_vue__["JsonObject"].metaData.addProperty("rating", "rateValues:itemvalues");
      property1 = __WEBPACK_IMPORTED_MODULE_4_survey_vue__["JsonObject"].metaData.findProperty("rating", "rateValues");
      property1.typeValue = "itemvaluesWithPoints";
      property1.className = "itemvaluesWithPoints";

      // Add maxPoints to answers of radiogroups
      __WEBPACK_IMPORTED_MODULE_4_survey_vue__["JsonObject"].metaData.addClass("itemvaluesWithPointsAndMaxPoints", ["points:number", "maxPoints:number"], null, "itemvalue");
      __WEBPACK_IMPORTED_MODULE_4_survey_vue__["JsonObject"].metaData.addProperty("radiogroup", "choices:itemvalues");
      var property2 = __WEBPACK_IMPORTED_MODULE_4_survey_vue__["JsonObject"].metaData.findProperty("radiogroup", "choices");
      property2.typeValue = "itemvaluesWithPointsAndMaxPoints";
      property2.className = "itemvaluesWithPointsAndMaxPoints";

      __WEBPACK_IMPORTED_MODULE_4_survey_vue__["JsonObject"].metaData.addProperty("question", {
        name: "pointsMax:number"
      });

      __WEBPACK_IMPORTED_MODULE_4_survey_vue__["JsonObject"].metaData.addProperty("question", "guid");
      __WEBPACK_IMPORTED_MODULE_4_survey_vue__["JsonObject"].metaData.addProperty("panelbase", "guid");
      __WEBPACK_IMPORTED_MODULE_4_survey_vue__["JsonObject"].metaData.addProperty("itemvalue", "guid");

      // Add custom question numbers
      __WEBPACK_IMPORTED_MODULE_4_survey_vue__["JsonObject"].metaData.addProperty("question", {
        name: "customQuestionNumber",
        default: 0
      });

      // Add properties for currency inputs
      __WEBPACK_IMPORTED_MODULE_4_survey_vue__["JsonObject"].metaData.addProperty("survey", {
        name: "currencySymbol",
        default: "€"
      });
      __WEBPACK_IMPORTED_MODULE_4_survey_vue__["JsonObject"].metaData.addProperty("survey", {
        name: "currencyDecimalPoint",
        default: "comma"
      });
    },
    initializeSurveyDesign: function initializeSurveyDesign() {
      var mainColor = $(":root").css("--color-primary-input");
      var mainHoverColor = $(":root").css("--color-primary-input-hover");
      var textColor = "#4a4a4a";
      var headerColor = "#160ce8";
      var headerBackgroundColor = "#4a4a4a";
      var bodyContainerBackgroundColor = "#f8f8f8";
      var defaultThemeColorsSurvey = __WEBPACK_IMPORTED_MODULE_4_survey_vue__["StylesManager"].ThemeColors["default"];
      defaultThemeColorsSurvey["$main-color"] = mainColor;
      defaultThemeColorsSurvey["$main-hover-color"] = mainHoverColor;
      defaultThemeColorsSurvey["$text-color"] = textColor;
      defaultThemeColorsSurvey["$header-color"] = headerColor;
      defaultThemeColorsSurvey["$header-background-color"] = headerBackgroundColor;
      defaultThemeColorsSurvey["$body-container-background-color"] = bodyContainerBackgroundColor;
      __WEBPACK_IMPORTED_MODULE_4_survey_vue__["StylesManager"].applyTheme("bootstrapmaterial");
    },
    validateSurvey: function validateSurvey() {
      this.survey.completeLastPage();
    },
    validateInput: function validateInput(id) {
      var result = document.getElementById(id).value !== "";
      if (result) {
        $("#" + id).parent().parent().removeClass("has-error"); // has-error has to be added to the form-group element
        var idx = this.invalidInputIds.indexOf(id);
        if (idx > -1) {
          this.invalidInputIds.splice(idx, 1); // Remove from list, if valid
        }
      } else {
        $("#" + id).parent().parent().addClass("has-error");
        if (this.invalidInputIds.indexOf(id) < 0) this.invalidInputIds.push(id); // Add to list, if invalid
      }
      return result;
    },

    // Returns true if an input has a validation error, otherwise false
    inputHasError: function inputHasError(id) {
      return this.invalidInputIds.indexOf(id) > -1 ? true : false;
    },
    resetValidationErrors: function resetValidationErrors(id) {
      var elements = $("#" + id).find(":input"); // Returns a list of all inputs on the dialog
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0) $("#" + elements[i].id).parent().parent().removeClass("has-error");
      }
      this.invalidInputIds = [];
    },
    initializeDataFromParent: function initializeDataFromParent() {
      this.surveyInstanceId = this.selectedSurveyInstanceFromParent;

      if (this.$route.params.surveyInstanceId) this.surveyInstanceId = this.$route.params.surveyInstanceId;
    },
    changeSurveyLanguage: function changeSurveyLanguage() {
      var _this4 = this;

      if (!this.saveButtonDisabled) {
        this.globals.$off("ChangeCheckLanguageWithUnsavedChangesYesConfirmation");
        this.globals.$once("ChangeCheckLanguageWithUnsavedChangesYesConfirmation", function () {
          _this4.saveSurvey(false);
        });
        this.globals.$off("ChangeCheckLanguageWithUnsavedChangesDialogClosed");
        this.globals.$once("ChangeCheckLanguageWithUnsavedChangesDialogClosed", function () {
          _this4.getSurveyDataByInstanceId();
        });

        this.globals.$emit("openGlobalConfirmationDialog", {
          initiator: "ChangeCheckLanguageWithUnsavedChanges",
          confirmationTitle: this.lang.SV0052,
          yesButtonText: this.lang.SV0053,
          noButtonText: this.lang.SV0054,
          htmlText: "<p><b>" + this.lang.SV0055 + "<br><br>" + this.lang.SV0056 + "</b></p>"
        });
      } else this.getSurveyDataByInstanceId();
    },
    initializeFlatpickr: function initializeFlatpickr() {
      this.fpDate = flatpickr("#inputDateSurveyView", this.globals.flatpickrDateConfig);
      if (Array.isArray(this.fpDate)) location.reload(); // Workaround for initialization error after opening surveyview in multiple tabs at the same time
      if (this.inputMetaInformationDisabled) {
        this.fpDate._input.setAttribute("disabled", true);
      }
      this.fpTimeIn = flatpickr("#inputTimeInSurveyView", this.globals.flatpickrTimeConfig);
      this.fpTimeOut = flatpickr("#inputTimeOutSurveyView", this.globals.flatpickrTimeConfig);
    },
    getSurveyDataByInstanceId: function getSurveyDataByInstanceId() {
      var _this5 = this;

      this.resetValidationErrors("meta-information-container");
      var queryString = "api/SurveyInstancesAnswers/" + this.surveyInstanceId;
      if (this.surveyLocaleCode) queryString += "?localeCode=" + this.surveyLocaleCode;

      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this5.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this5.surveyData = data;
          _this5.surveyInstanceStatusId = data.SurveyInstanceStatusId;
          _this5.survey = new __WEBPACK_IMPORTED_MODULE_4_survey_vue__["Model"](_this5.surveyData.Survey);
          _this5.surveyLocaleCode = data.LocaleCode;
          var languageCode = data.LocaleCode.substring(0, 2).toLowerCase();
          var frontendLanguage = _this5.globals.selectedLanguage.substring(0, 2).toLowerCase();
          if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_4_survey_vue__["surveyLocalization"].locales).indexOf(languageCode) > -1) __WEBPACK_IMPORTED_MODULE_4_survey_vue__["surveyLocalization"].currentLocale = languageCode;else if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_4_survey_vue__["surveyLocalization"].locales).indexOf(frontendLanguage) > -1) __WEBPACK_IMPORTED_MODULE_4_survey_vue__["surveyLocalization"].currentLocale = frontendLanguage;else __WEBPACK_IMPORTED_MODULE_4_survey_vue__["surveyLocalization"].currentLocale = "en";

          _this5.inputMetaInformationDisabled = data.SurveyInstanceAnswerReadOnly;
          if (_this5.displayOnlyMode || data.SurveyInstanceAnswerReadOnly) {
            _this5.survey.mode = "display";
          }

          // Fix for dynamic panels showing up with too low panel count
          var dynPanelUploads = _this5.survey.getQuestionByName("e99999");
          if (dynPanelUploads) {
            var dynPanelMinCount = dynPanelUploads.minPanelCount || 0;
            if (_this5.surveyData.SurveyInstanceAnswer && _this5.surveyData.SurveyInstanceAnswer.e99999) {
              var missingUploadsCount = dynPanelMinCount - _this5.surveyData.SurveyInstanceAnswer.e99999.length;
              if (missingUploadsCount > 0) for (var i = 0; i < missingUploadsCount; i++) {
                _this5.surveyData.SurveyInstanceAnswer.e99999.push({});
              }
            }
          }

          _this5.configureStatusButtonAccess();
          _this5.initializeSurvey();
          _this5.initializeFlatpickr();
          _this5.loadDataIntoForm();
          _this5.readMaxPointsReachedFromResult();
          _this5.saveButtonDisabled = true;
          _this5.$nextTick(function () {
            _this5.getMetaInformation();
          });
          _this5.$emit("surveyDataReceived");
        },
        error: function error() {
          console.error("Error in getSurveyDataByInstanceId");
          _this5.globals.showErrorSnackbar("Survey request failed");
        }
      });
    },


    // Requests localization data for the survey view
    getSurveyViewLocalization: function getSurveyViewLocalization() {
      var _this6 = this;

      $.ajax({
        method: "GET",
        url: "api/Language/ComponentTranslation/SurveyView",
        success: function success(data) {
          if (data && data.length > 0) {
            __WEBPACK_IMPORTED_MODULE_4_survey_vue__["surveyLocalization"].locales[data[0].LanguageCode] = data[0].Translation;
          }
          var newLocale = _this6.globals.selectedLanguage.substring(0, 2).toLowerCase();
          __WEBPACK_IMPORTED_MODULE_4_survey_vue__["surveyLocalization"].defaultLocale = newLocale;
        },
        error: function error() {
          console.error("Localization data access failed in getSurveyViewLocalization()");
          _this6.globals.showErrorSnackbar("Localization data access failed");
        }
      });
    },
    configureStatusButtonAccess: function configureStatusButtonAccess() {
      var currentStatus = this.surveyInstanceStatusId;
      if (!currentStatus) return;

      this.moveToShopperButtonDisabled = true;
      this.moveToAgencyButtonDisabled = true;
      this.moveToMSMButtonDisabled = true;
      this.moveToMSMInternalButtonDisabled = true;

      this.moveToShopperButtonDisabled = _.indexOf([120, 140, 170, 190, 200], currentStatus) < 0 ? true : false;
      if (this.globals.isLocalAgencyUser && currentStatus > 160) this.moveToShopperButtonDisabled = true;

      if (this.globals.isLocalAgencyUser && currentStatus >= 150) {
        this.moveToShopperButtonDisabled = false;
      }

      this.moveToAgencyButtonDisabled = _.indexOf([160, 170, 190, 200], currentStatus) < 0 ? true : false;

      this.moveToMSMButtonDisabled = _.indexOf([150], currentStatus) < 0 ? true : false;

      this.moveToMSMInternalButtonDisabled = _.indexOf([120, 160, 165, 190, 200], currentStatus) < 0 ? true : false;
    },
    getMetaInformation: function getMetaInformation() {
      this.calcPointsOfContainer(this.survey);

      this.metaInformation = {
        SurveyId: this.surveyData.SurveyId,
        SurveyInstanceId: this.surveyData.SurveyInstanceId,
        SurveyInstanceGuid: this.surveyData.SurveyInstanceGuid,
        ShortSurveyCode: this.surveyData.ShortSurveyCode,
        LocationStoreId: this.surveyData.LocationStoreId,
        LocationName: this.surveyData.LocationName,
        LocationAddress: this.surveyData.LocationAddress,
        LocationCountry: this.surveyData.LocationCountry,
        ScenarioName: this.surveyData.ScenarioName,
        WaveName: this.surveyData.WaveName,
        CarModelDistribution: this.surveyData.CarModelDistribution,
        CompetitorCarModelDistribution: this.surveyData.CompetitorCarModelDistribution,
        WaveInfo: this.surveyData.WaveInfo,
        SurveyInstanceInfo: this.surveyData.SurveyInstanceInfo,
        Score: "(" + this.survey.pointsReached + "/" + this.survey.pointsMax + ")"
      };
      if (this.surveyData.ApprovedShopper) this.metaInformation.ApprovedShopper = this.surveyData.ApprovedShopper;
    },
    loadDataIntoForm: function loadDataIntoForm() {
      // load result set of an existing survey
      if (this.surveyData.SurveyInstanceAnswer) {
        this.survey.data = this.surveyData.SurveyInstanceAnswer;
      }
      // load time and memo information
      if (this.surveyData.SurveyInstanceAnswerDateOfVisit) {
        this.fpDate.setDate(this.surveyData.SurveyInstanceAnswerDateOfVisit, true, "Y-m-d");
      }
      if (this.surveyData.SurveyInstanceAnswerTimeIn) {
        this.fpTimeIn.setDate(this.surveyData.SurveyInstanceAnswerTimeIn, true, "H:i");
      }
      if (this.surveyData.SurveyInstanceAnswerTimeOut) {
        this.fpTimeOut.setDate(this.surveyData.SurveyInstanceAnswerTimeOut, true, "H:i");
      }
      if (this.surveyData.SurveyInstanceAnswerPosition && this.surveyData.SurveyInstanceAnswerPosition.Latitude && this.surveyData.SurveyInstanceAnswerPosition.Longitude) {
        var latInput = document.getElementById("inputGPSSurveyViewLat");
        var longInput = document.getElementById("inputGPSSurveyViewLong");
        if (latInput) latInput.value = this.surveyData.SurveyInstanceAnswerPosition.Latitude;
        if (longInput) longInput.value = this.surveyData.SurveyInstanceAnswerPosition.Longitude;
      }
      if (this.surveyData.SurveyInstanceAnswerMemoShopper) {
        document.getElementById("txtMemoShopper").value = this.surveyData.SurveyInstanceAnswerMemoShopper;
      }
      if (this.surveyData.SurveyInstanceAnswerMemoAgency) {
        document.getElementById("txtMemoAgency").value = this.surveyData.SurveyInstanceAnswerMemoAgency;
      }
      if (this.surveyData.SurveyInstanceAnswerMemoMSM) {
        var msmMemoInput = document.getElementById("txtMemoMSM");
        if (msmMemoInput) msmMemoInput.value = this.surveyData.SurveyInstanceAnswerMemoMSM;
      }
    },
    initializeSurvey: function initializeSurvey() {
      var _this7 = this;

      // disable survey buttons
      this.survey.showNavigationButtons = false;
      // initialize survey events
      this.survey.onComplete.add(function (survey) {
        // disable buttons
        _this7.prevButtonDisabled = true;
        _this7.nextButtonDisabled = true;
        _this7.completeButtonDisabled = true;
        _this7.saveButtonDisabled = true;
        // save to backend
        _this7.saveSurvey(true);
      });
      this.survey.onCompleting.add(function (survey, options) {
        var validationResult = true;
        _this7.requiredFields.forEach(function (field) {
          validationResult = _this7.validateInput(field) && validationResult;
        });
        _this7.survey.isCurrentPageHasErrors;
        if (!validationResult) {
          _this7.globals.showErrorSnackbar(_this7.lang.SV0031);
          options.allowComplete = false;
          survey.clear(false, false);
          var currPage = survey.currentPage;
          _this7.$nextTick(function () {
            survey.currentPage = currPage;
          });
          return;
        }
      });
      this.survey.onCurrentPageChanged.add(function (survey) {
        _this7.doOnCurrentPageChanged();
      });
      this.survey.onValueChanged.add(function (sender, options) {
        // enable save button only when survey changed
        _this7.saveButtonDisabled = false;
      });
      this.survey.onAfterRenderPage.add(function (sender, options) {
        // activate save button on input event for input type text and number and textarea
        var inputs = document.querySelectorAll("#surveyViewForm input, #surveyViewForm textarea");
        for (var i = 0; i < inputs.length; i++) {
          inputs[i].oninput = function (input) {
            _this7.saveButtonDisabled = false;
          };
        }
      });
      this.doOnCurrentPageChanged();

      // Some visual fixes for read only surveys
      this.survey.onAfterRenderPage.add(function (sender, options) {
        if (sender.mode === "display") {
          $(".sv_qstn .radio input:disabled, .sv_qstn .checkbox input:disabled").parent().css("cursor", "not-allowed").css("color", "grey");
          $(".sv_qstn textarea:read-only").prop("disabled", true);
        }
      });

      // Set prevValue for exclusive property on survey load
      this.survey.onAfterRenderSurvey.add(function (survey, options) {
        var questions = survey.getAllQuestions(false);
        for (var i = 0; i < questions.length; i++) {
          if (questions[i].getType() === "checkbox") {
            questions[i].prevValue = _.clone(questions[i].value);
          }
        }
      });

      // Avoid opening upload modal on enter inside survey form
      this.survey.onAfterRenderSurvey.add(function (sender, options) {
        $(options.htmlElement).find("form").on("keypress", function (e) {
          if (e.target.tagName === "TEXTAREA") return true;
          var keyCode = e.keyCode || e.which;
          if (keyCode === 13) {
            return false;
          }
        });
      });

      // Add functionality for exclusiveValue property
      this.survey.onValueChanged.add(function (sender, options) {
        var q = options.question;
        //If question is not defined or question is not checkbox or exclusiveValue does not exist do nothing
        if (!q || q.getType() != "checkbox" || !q.exclusiveValue) return;
        //returns if the value set for the first time or there is nothing to do
        if (!q.prevValue || !options.value) {
          q.prevValue = options.value;
          return;
        }
        var index = options.value.indexOf(q.exclusiveValue);
        //has "None of the above selected"
        if (index > -1) {
          //"None of the above selected" was selected before
          if (q.prevValue.indexOf(q.exclusiveValue) > -1) {
            var value = options.value;
            value.splice(index, 1);
            q.value = value;
          } else {
            //none select just now
            q.value = [q.exclusiveValue];
          }
        }
        q.prevValue = _.clone(q.value);
      });

      // Trigger validation after changing question value
      this.survey.onValueChanged.add(function (sender, options) {
        if (!options.question) return;
        options.question.hasErrors(true);
      });
      // Select cluster background color in test survey
      this.survey.onUpdatePanelCssClasses.add(function (sender, options) {
        if (!options.panel.isCluster) return;
        var pName = options.panel.name;
        var panelContainer = options.cssClasses.panel.container;
        if (panelContainer.indexOf(pName) < 0) {
          panelContainer += " background-" + pName;
          options.cssClasses.panel.container = panelContainer;
        }
      });
      // Add background color to clusters
      this.survey.onAfterRenderPage.add(function (sender, options) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(options.page.elements), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var el = _step2.value;

            if (el.isCluster) {
              $(".background-" + el.name).css("background", el.backgroundColor);
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      });
      // Set inputmask or datepicker for available input types in survey
      this.survey.onAfterRenderQuestion.add(function (survey, options) {
        var inputMaskConfig = void 0,
            el = void 0,
            fp = void 0;

        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(_this7.singleInputTypes), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var type = _step3.value;

            el = $(options.htmlElement).find('input[type="' + type + '"]');
            if (el.length < 1) continue;
            if (type !== "number") $(el).prop("type", "text");

            inputMaskConfig = {
              clearIncomplete: true
            };

            switch (type) {
              case "date":
                fp = flatpickr("#" + el[0].id, _this7.globals.flatpickrDateConfig);
                fp.setDate(options.question.value, true, "Y-m-d");
                break;
              case "datetime":
                fp = flatpickr("#" + el[0].id, _this7.globals.flatpickrDatetimeConfig);
                fp.setDate(options.question.value, true, "Y-m-d H:i");
                break;
              case "email":
                inputMaskConfig.alias = "email";
                break;
              case "number":
                inputMaskConfig.alias = "numeric";
                inputMaskConfig.rightAlign = false;
                inputMaskConfig.inputType = "number";
                break;
              case "tel":
                inputMaskConfig.mask = "+(99[9]) 9{2,14}";
                break;
              case "time":
                fp = flatpickr("#" + el[0].id, _this7.globals.flatpickrTimeConfig);
                fp.setDate(options.question.value, true, "H:i");
                break;
              case "url":
                inputMaskConfig.regex = "(https?|ftp)://.*";
                break;
              case "currency":
                inputMaskConfig.alias = "currency";
                inputMaskConfig.placeholder = "_";
                inputMaskConfig.clearIncomplete = false;
                inputMaskConfig.rightAlign = false;
                inputMaskConfig.tabThrough = true;
                inputMaskConfig.positionCaretOnClick = "select";

                inputMaskConfig.autoUnmask = true;
                inputMaskConfig.onBeforeMask = function (value, opts) {
                  var newValue = value.toString();
                  var radixPointIndex = newValue.indexOf(".");
                  if (radixPointIndex > -1) {
                    if (!newValue[radixPointIndex + 2]) newValue = newValue + "0";
                  } else newValue = newValue + ".00";

                  newValue = newValue.replace(".", opts.radixPoint);
                  return newValue;
                };
                inputMaskConfig.onUnMask = function (maskedValue, unmaskedValue, opts) {
                  if (unmaskedValue === "" && opts.nullable === true) {
                    return unmaskedValue;
                  }
                  var stringValue = maskedValue.replace(opts.prefix, "");
                  stringValue = stringValue.replace(new RegExp(__WEBPACK_IMPORTED_MODULE_5_inputmask___default.a.escapeRegex(opts.groupSeparator), "g"), "");
                  if (opts.placeholder.charAt(0) !== "") {
                    stringValue = stringValue.replace(new RegExp(opts.placeholder.charAt(0), "g"), "0");
                  }

                  if (inputMaskConfig.radixPoint === ",") stringValue = stringValue.replace(",", ".");

                  unmaskedValue = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(stringValue);
                  return unmaskedValue;
                };

                inputMaskConfig.prefix = survey.currencySymbol + " ";
                inputMaskConfig.groupSeparator = survey.currencyDecimalPoint === "comma" ? "." : ",";
                inputMaskConfig.radixPoint = survey.currencyDecimalPoint === "comma" ? "," : ".";

                if (!survey.getValue(options.question.name)) survey.setValue(options.question.name, 0);
            }

            if (fp) {
              $(el[0].parentElement).on("click", function (e) {
                fp.toggle();
              });
              _this7.fpInstancesFromSurvey.push(fp);
            } else __WEBPACK_IMPORTED_MODULE_5_inputmask___default()(inputMaskConfig).mask(el);
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      });
      this.survey.onAfterRenderQuestion.add(function (survey, options) {
        // add upload edit dialog to a file input question
        if (options.question.getType() === "file" && _this7.survey.mode === "edit" && $(window).width() >= 1200) {
          var uploadDialog = "\n            <div class=\"form-group\">\n              <button id=\"upload-" + options.question.id + "\" class=\"btn btn-raised btn-upload\">" + _this7.lang.SV0023 + "</button> \n            </div>";
          var btn_id = "upload-" + options.question.id;
          $(document).on("click", "#" + btn_id, function (e) {
            e.preventDefault();
            _this7.questionData.questionName = options.question.name;
            _this7.questionData.questionId = options.question.id;
            _this7.questionData.acceptedTypes = options.question.acceptedTypes;
            _this7.questionData.allowMultipleFiles = options.question.allowMultiple;
            _this7.openSurveyUploadDialog();
          });
          $(options.htmlElement).append(uploadDialog);
        }
        // TODO: Will not work if there is more than one dynamic panel
        if (options.question.getType() === "paneldynamic") _this7.dynamicPanels = options.question.panels;

        // Add commentForShopper text to question template
        if (options.question.commentForShopper) {
          var comment = "\n          <div class=\"shopper-comment-container small\" \n            style=\"cursor: pointer;\"\n            aria-expanded=\"false\"\n            data-toggle=\"collapse\" \n            data-target=\"#instructions-" + options.question.name + "\">\n            <div class=\"shopper-comment-header\">\n              <span><i class=\"material-icons md-add\">add_circle_outline</i></span>\n              <span><i class=\"material-icons md-remove\">remove_circle_outline</i></span>\n              <span class=\"shopper-comment-header-text\">" + _this7.lang.SV0022 + "</span>\n            </div>\n            <div id=\"instructions-" + options.question.name + "\"\n              class=\"collapse shopper-comment-content\">\n              " + options.question.commentForShopper + "\n            </div>\n          </div>";
          $(options.htmlElement).append(comment);
        }
      });
      this.survey.onDynamicPanelAdded.add(function (sender, options) {
        _this7.dynamicPanels = options.question.panels;
      });
      this.survey.onDynamicPanelRemoved.add(function (sender, options) {
        _this7.dynamicPanels = options.question.panels;
      });

      this.survey.onUploadFiles.add(function (sender, options) {
        if (!_this7.globals.isAccessAllowed("LoopOp_Upload_Create")) {
          _this7.globals.showErrorSnackbar("Permission denied");
          options.callback("error");
          return;
        }
        var files = options.files;
        if (!files || !files[0]) {
          _this7.globals.showErrorSnackbar("Error on file upload");
          console.error("No upload file available");
          options.callback("error");
          return;
        }

        var uploadCount = files.length;
        var question = sender.getQuestionByName(options.name);
        var callbackData = [];

        files.forEach(function (file) {
          var containsImage = _.startsWith(file.type, "image");

          if (question && question.acceptedTypes) {
            if (!_this7.globals.isValidFileType(file, question.acceptedTypes)) {
              _this7.globals.showErrorSnackbar("Wrong file type: " + file.name);
              console.error("file type mismatch: " + file.name + " - accepted types: " + question.acceptedTypes);
              options.callback("error");
              return;
            }
          }

          var callback = function callback() {
            var uploadSuccess = function uploadSuccess(data) {
              callbackData.push({
                file: file,
                content: data[0].DownloadId
              });

              if (--uploadCount < 1) {
                options.callback("success", callbackData);
                _this7.globals.showSuccessSnackbar("Attachment upload successful");
                _this7.globals.$emit("surveyAttachmentUploadComplete");
              }
            };
            var uploadError = function uploadError() {
              options.callback("error");
            };

            _this7.globals.uploadFile(file, uploadSuccess, uploadError);
          };
          file.imageUrl = URL.createObjectURL(file);
          if (containsImage) _this7.globals.getImageOrientation(file, function (orientation) {
            _this7.globals.resetImageOrientation(file, orientation, function (data) {
              file = data;
              callback();
            });
          });else callback();
        });
      });
      this.survey.onDownloadFile.add(function (sender, options) {
        options.callback("success", "/api/download/" + options.content);
      });
      this.$surveyInitDone = true;
    },

    // collect data
    collectSurveyData: function collectSurveyData(complete) {
      var surveydata = {
        SurveyInstanceAnswerDateOfVisit: document.getElementById("inputDateSurveyView").value,
        LocaleCode: this.surveyLocaleCode,
        SurveyInstanceAnswerTimeIn: document.getElementById("inputTimeInSurveyView").value,
        SurveyInstanceAnswerTimeOut: document.getElementById("inputTimeOutSurveyView").value,
        SurveyInstanceAnswerMemoShopper: document.getElementById("txtMemoShopper").value,
        SurveyInstanceAnswerMemoAgency: document.getElementById("txtMemoAgency").value,
        SurveyInstanceAnswer: this.survey.data,
        SurveyInstanceProgress: complete ? 100 : this.calcSurveyProgress()
      };
      var msmMemoInput = document.getElementById("txtMemoMSM");
      if (msmMemoInput) surveydata.SurveyInstanceAnswerMemoMSM = msmMemoInput.value;

      var latInput = document.getElementById("inputGPSSurveyViewLat");
      var lat = latInput && latInput.value;
      var longInput = document.getElementById("inputGPSSurveyViewLong");
      var long = longInput && longInput.value;
      if (lat && long) surveydata.SurveyInstanceAnswerPosition = {
        Latitude: parseFloat(lat),
        Longitude: parseFloat(long)
      };

      return surveydata;
    },
    saveSurveyToBackend: function saveSurveyToBackend(complete) {
      var _this8 = this;

      if (this.saveRequestPending) return;
      var surveyObject = this.collectSurveyData(complete);
      var queryString = "api/SurveyInstancesAnswers/" + this.surveyInstanceId;

      this.getMetaInformation(); // Calculates score of survey and updates meta information
      surveyObject.SurveyInstanceAnswerPoints = this.survey.pointsReached;
      surveyObject.SurveyInstanceAnswerMaxPoints = this.survey.pointsMax;
      surveyObject.VisibleElements = this.getVisibleSurveyElements();
      surveyObject.SurveyInstanceNote = this.surveyData.SurveyInstanceNote;

      this.saveButtonDisabled = true;
      this.saveRequestPending = true;

      $.ajax({
        method: "PUT",
        url: queryString,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(surveyObject),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success() {
          if (complete) _this8.moveCheckTo("validation");else {
            if (_this8.globals.currentUserRole == 1 && _this8.surveyInstanceStatusId === 200) _this8.moveCheckTo("msminternal", true);
          }
        },
        error: function error() {
          console.error("Error on PUT in saveSurveyToBackend");
          _this8.globals.showErrorSnackbar("Survey update failed");
        },
        complete: function complete() {
          _this8.saveRequestPending = false;
        }
      });
    },
    moveCheckTo: function moveCheckTo(type, keepSurveyOpen) {
      var newStatus = void 0;
      var currentStatus = this.surveyInstanceStatusId;

      if (type === "shopper") {
        if (_.indexOf([120, 140, 170, 190, 200], currentStatus) > -1) newStatus = 130;else if (_.indexOf([150, 170], currentStatus) > -1 && this.globals.isLocalAgencyUser) newStatus = 130;
      } else if (type === "agency") {
        if (_.indexOf([160, 170, 190, 200], currentStatus) > -1) newStatus = 150;
      } else if (type === "msm") {
        if (_.indexOf([150], currentStatus) > -1) newStatus = 165;
      } else if (type === "msminternal") {
        if (_.indexOf([120, 160, 165, 190, 200], currentStatus) > -1) newStatus = 170;
      } else if (type === "validation") {
        if (_.indexOf([100, 110], currentStatus) > -1) newStatus = 120;else if (currentStatus === 130) newStatus = 140;else if ((currentStatus === 120 || currentStatus === 140) && this.globals.currentUserRole > 1) newStatus = 160;else if (currentStatus === 150) newStatus = 165;else if (_.indexOf([120, 140, 160, 165, 170, 190], currentStatus) > -1)
          // 120 & 140 for MSM Users
          newStatus = 200;
      }

      if (newStatus) this.updateCheckStatus(newStatus, keepSurveyOpen);
    },
    updateCheckStatus: function updateCheckStatus(status, keepSurveyOpen) {
      var _this9 = this;

      if (!status) return;
      var sendData = {};
      sendData.SurveyInstanceIds = [this.surveyInstanceId];
      sendData.SurveyInstanceStatusId = status;
      $.ajax({
        method: "PUT",
        url: "api/SurveyInstances",
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(sendData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) _this9.globals.showErrorSnackbar(data.Error);else {
            _this9.surveyInstanceStatusId = status;
            _this9.globals.showSuccessSnackbar("Status update successful");
            if (_this9.globals.currentUserRole < 3 && !keepSurveyOpen) {
              _this9.globals.showSuccessSnackbar("Status update successful");
              setTimeout(function () {
                window.close();
              }, 1500);
            }
          }
        },
        error: function error() {
          console.error("Error on PUT in updateCheckStatus()");
          _this9.globals.showErrorSnackbar("Status update failed");
        }
      });
    },
    addMaxPointsReachedToResult: function addMaxPointsReachedToResult() {
      var resultData = this.survey.data;
      var questions = this.survey.getAllQuestions();
      var maxPointsQuestions = [];
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(questions), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var q = _step4.value;

          if (q.maxPointsReached) {
            maxPointsQuestions.push(q.name);
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      if (maxPointsQuestions.length > 0) resultData.maxPointsReached = maxPointsQuestions;else delete resultData.maxPointsReached;
      this.survey.data = resultData;
    },
    readMaxPointsReachedFromResult: function readMaxPointsReachedFromResult() {
      var resultData = this.survey.data;
      var maxPointsQuestions = resultData.maxPointsReached;
      if (maxPointsQuestions) {
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(maxPointsQuestions), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var qName = _step5.value;

            var q = this.survey.getQuestionByName(qName);
            q.maxPointsReached = true;
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }
      }
    },
    exitSurvey: function exitSurvey(force) {
      var _this10 = this;

      if (!this.saveButtonDisabled && !force) {
        this.globals.$off("CloseSurveyWithUnsavedChangesModalYesConfirmation");
        this.globals.$once("CloseSurveyWithUnsavedChangesModalYesConfirmation", function () {
          _this10.exitSurvey(true);
        });

        this.globals.$emit("openGlobalConfirmationDialog", {
          initiator: "CloseSurveyWithUnsavedChangesModal",
          confirmationTitle: this.lang.SV0038,
          colorRed: true,
          yesButtonText: this.lang.SV0039,
          noButtonText: this.lang.SV0040,
          htmlText: "<p><b>" + this.lang.SV0041 + "<br><br>" + this.lang.SV0042 + "</b></p>"
        });
        return;
      }
      window.close();
    },
    saveSurvey: function saveSurvey(complete) {
      this.addMaxPointsReachedToResult();
      this.saveSurveyToBackend(complete);
    },
    doOnCurrentPageChanged: function doOnCurrentPageChanged() {
      // only one page
      if (this.survey.visiblePageCount == 1) {
        this.prevButtonDisabled = true;
        this.nextButtonDisabled = true;
        this.completeButtonDisabled = false;
      } else if (this.survey.isFirstPage) {
        // first page of many
        this.prevButtonDisabled = true;
        this.nextButtonDisabled = false;
        this.completeButtonDisabled = true;
      } else if (this.survey.isLastPage) {
        // last page
        this.prevButtonDisabled = false;
        this.nextButtonDisabled = true;
        this.completeButtonDisabled = false;
      } else {
        // between first and last page
        this.prevButtonDisabled = false;
        this.nextButtonDisabled = false;
        this.completeButtonDisabled = true;
      }
      if (this.surveyData.SurveyInstanceAnswerReadOnly || this.surveyInstanceStatusId > 200 || this.displayOnlyMode && (!this.surveyData.SurveyInstanceProgress || this.surveyData.SurveyInstanceProgress < 100)) this.completeButtonDisabled = true;
    },
    calcSurveyProgress: function calcSurveyProgress() {
      var visibleQuestions = this.survey.getAllQuestions(true);
      var requiredCount = 0;
      var answeredCount = 0;
      for (var i = 0; i < visibleQuestions.length; i++) {
        if (visibleQuestions[i].isRequired) {
          requiredCount++;
          if (!visibleQuestions[i].isEmpty()) answeredCount++;
        }
      }
      requiredCount += this.requiredFields.length;
      this.requiredFields.forEach(function (field) {
        if (document.getElementById(field).value !== "") {
          answeredCount++;
        }
      });
      var result = Math.round(answeredCount / requiredCount * 100);
      return result;
    },
    getVisibleSurveyElements: function getVisibleSurveyElements() {
      var visibleElements = [];

      var visibleQuestions = this.survey.getAllQuestions(true);
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(visibleQuestions), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var q = _step6.value;

          if (q.guid) visibleElements.push(q.guid);
          if (q.choices) {
            var _iteratorNormalCompletion8 = true;
            var _didIteratorError8 = false;
            var _iteratorError8 = undefined;

            try {
              for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(q.choices), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                var choice = _step8.value;

                if (choice.isVisible && choice.guid) visibleElements.push(choice.guid);
              }
            } catch (err) {
              _didIteratorError8 = true;
              _iteratorError8 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion8 && _iterator8.return) {
                  _iterator8.return();
                }
              } finally {
                if (_didIteratorError8) {
                  throw _iteratorError8;
                }
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      var visiblePanels = this.survey.getAllPanels(true);
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(visiblePanels), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var p = _step7.value;

          if (p.guid) visibleElements.push(p.guid);
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }

      return visibleElements;
    },

    // Calculates the points value of the given container element
    calcPointsOfContainer: function calcPointsOfContainer(container) {
      var type = container.getType();
      var containerTypes = ["panel", "page", "survey"];

      if (_.indexOf(containerTypes, type) < 0) return; // No container type
      container.pointsMax = 0;
      container.pointsReached = 0;
      var elements = type === "survey" ? container.pages : container.elements;

      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(elements), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          var el = _step9.value;

          if (_.indexOf(containerTypes, el.getType()) > -1) {
            this.calcPointsOfContainer(el);
            container.pointsMax += el.pointsMax || 0;
            container.pointsReached += el.pointsReached || 0;
          } else {
            var qpoints = this.getPointsOfQuestion(el);
            container.pointsMax += qpoints.pointsMax;
            container.pointsReached += qpoints.pointsReached;
          }
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9.return) {
            _iterator9.return();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }
    },

    // Returns the points of a given question
    getPointsOfQuestion: function getPointsOfQuestion(question) {
      var points = { pointsMax: 0, pointsReached: 0 };
      var qtype = question.getType();
      if (!qtype || typeof question.value === "undefined") return points;

      if (_.indexOf(["text", "comment", "file"], qtype) > -1) {
        if (question.pointsMax) {
          points.pointsMax = question.pointsMax;
          points.pointsReached = question.pointsMax;
        }
      } else if (qtype === "checkbox") {
        if (question.value.length > 0) {
          if (question.pointsMax) points.pointsMax = question.pointsMax;
          var _iteratorNormalCompletion10 = true;
          var _didIteratorError10 = false;
          var _iteratorError10 = undefined;

          try {
            for (var _iterator10 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(question.value), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
              var item = _step10.value;

              var answer = _.find(question.choices, {
                value: item
              });
              if (answer && answer.points) points.pointsReached += answer.points;
            }
          } catch (err) {
            _didIteratorError10 = true;
            _iteratorError10 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion10 && _iterator10.return) {
                _iterator10.return();
              }
            } finally {
              if (_didIteratorError10) {
                throw _iteratorError10;
              }
            }
          }
        }
      } else if (qtype === "radiogroup") {
        var _answer = _.find(question.choices, { value: question.value });
        if (_answer) {
          if (_answer.maxPoints) points.pointsMax = _answer.maxPoints;else if (question.pointsMax) points.pointsMax = question.pointsMax;

          if (_answer.points) points.pointsReached = _answer.points;
        }
      } else if (qtype === "dropdown") {
        var _answer2 = _.find(question.choices, { value: question.value });
        if (_answer2) {
          if (question.pointsMax) points.pointsMax = question.pointsMax;
          if (_answer2.points) points.pointsReached = _answer2.points;
        }
      } else if (qtype === "rating") {
        if (!question.rateValues || question.rateValues.length < 1) {
          if (question.pointsMax) {
            points.pointsMax = question.pointsMax;
            points.pointsReached = question.pointsMax;
          }
        } else {
          var _answer3 = _.find(question.rateValues, { value: question.value });
          if (_answer3) {
            if (question.pointsMax) points.pointsMax = question.pointsMax;
            if (_answer3.points) points.pointsReached = _answer3.points;
          }
        }
      }
      return points;
    }
  },
  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
      this.getSurveyViewLocalization();

      if (this.$surveyInitDone) return;
      this.initializeDataFromParent();
      this.getSurveyDataByInstanceId();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ChangePasswordDialog",
  props: {
    showDialog: {
      default: false,
      type: Boolean
    },
    userGuid: {
      default: "",
      type: String
    },
    userName: {
      default: "",
      type: String
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#changePasswordDialog" + this._uid).on("hide.bs.modal", function (e) {
      _this.$emit("dialogClosed");
    });
    this.globals.getPasswordPolicyList(function (callbackData) {
      _this.passwordPolicy = callbackData;
    });
    this.debouncedCheckPasswordValidity = _.debounce(this.validatePassword, 500);
  },

  watch: {
    showDialog: function showDialog() {
      this.showDialog ? this.openChangePasswordDialog() : this.closeChangePasswordDialog();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  data: function data() {
    return {
      passwordsMatch: false,
      isPasswordValid: false,
      passwordPolicy: [],
      passwordValidity: {},
      passwords: {
        oldPassword: "",
        newPassword: "",
        newPasswordRepeat: ""
      },
      lang: {
        PW0000: "Reset password",
        PW0001: "New password",
        PW0002: "Change new password",
        PW0003: "Password policies",
        PW0004: "at least",
        PW0005: "letters",
        PW0006: "capital letter(s)",
        PW0007: "small letter(s)",
        PW0008: "numeral(s)",
        PW0009: "special character(s)",
        PW0010: "Cancel",
        PW0011: "Save",
        PW0012: "Passwords match",
        PW0013: "Old password",
        PW0014: "Change password",
        PW0015: "Old password missing",
        PW0016: "Password changed",
        PW0017: "User"
      }
    };
  },

  methods: {
    openChangePasswordDialog: function openChangePasswordDialog() {
      $("#changePasswordDialog" + this._uid).modal("show");
      this.initChangePasswordDialog();
    },
    closeChangePasswordDialog: function closeChangePasswordDialog() {
      $("#changePasswordDialog" + this._uid).modal("hide");
    },
    initChangePasswordDialog: function initChangePasswordDialog() {
      this.passwordsMatch = false;
      this.isPasswordValid = false;
      this.passwordValidity = {};
      this.passwords = {
        oldPassword: "",
        newPassword: "",
        newPasswordRepeat: ""
      };
    },
    doCheckIfPasswordIsValid: function doCheckIfPasswordIsValid() {
      if (this.debouncedCheckPasswordValidity) this.debouncedCheckPasswordValidity();
    },
    validatePassword: function validatePassword() {
      var _this2 = this;

      var passwordToCheck = {
        Password: this.passwords.newPassword
      };
      $.ajax({
        method: "POST",
        url: "api/Password/ValidatePassword",
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(passwordToCheck),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          _this2.passwordValidity = data;
          _this2.checkPasswordValidity();
        },
        error: function error() {
          console.error("Error on POST in validatePassword()");
          _this2.globals.showErrorSnackbar("Password check failed");
        }
      });
    },
    checkIfPasswordsMatch: function checkIfPasswordsMatch() {
      this.passwordsMatch = !!this.passwords.newPassword && !!this.passwords.newPasswordRepeat ? this.passwords.newPassword === this.passwords.newPasswordRepeat : false;
    },
    checkPasswordValidity: function checkPasswordValidity() {
      this.isPasswordValid = _.filter(this.passwordValidity, function (value) {
        return !value;
      }).length === 0;
    },
    checkIfNewPasswordPassed: function checkIfNewPasswordPassed() {
      if (this.isPasswordValid && this.passwordsMatch) this.saveNewPassword();
    },
    saveNewPassword: function saveNewPassword() {
      var _this3 = this;

      var request = this.userGuid ? "api/Password/ChangePassword/" + this.userGuid : "api/Password/ChangePassword";

      var passwordData = { Password: this.passwords.newPassword };
      if (!this.userGuid) {
        if (!this.passwords.oldPassword) {
          this.globals.showErrorSnackbar(this.lang.PW0015);
          return;
        }
        passwordData.OldPassword = this.passwords.oldPassword;
      }

      $.ajax({
        method: "PATCH",
        url: request,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(passwordData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            _this3.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this3.globals.showSuccessSnackbar(_this3.lang.PW0016);
          _this3.closeChangePasswordDialog();
        },
        error: function error() {
          console.error("Error on PUT in saveNewPassword()");
          _this3.globals.showErrorSnackbar("Password update failed");
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__changelog_json__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__changelog_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__changelog_json__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ChangelogModal",
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    openChangelogModal: function openChangelogModal() {
      $("#changelogModal").modal("show");
    },
    closeChangelogModal: function closeChangelogModal() {
      $("#changelogModal").modal("hide");
    }
  },
  mounted: function mounted() {
    var _this = this;

    $("#changelogModal").on("hide.bs.modal", function (e) {
      return _this.$emit("closeDialog");
    });
  },

  watch: {
    showDialog: function showDialog(newValue) {
      if (newValue) {
        this.openChangelogModal();
      } else {
        this.closeChangelogModal();
      }
    }
  },
  data: function data() {
    return {
      changelog: __WEBPACK_IMPORTED_MODULE_0__changelog_json__
    };
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ConfirmationDialog",
  props: {
    dialogId: {
      type: String,
      default: "confirmationDialog"
    },
    confirmationTitle: {
      type: String,
      default: ""
    },
    yesButtonText: {
      type: String,
      default: "Yes"
    },
    yesButtonDisable: {
      type: Boolean,
      default: false
    },
    noButtonText: {
      type: String,
      default: "No"
    },
    noButtonDisable: {
      type: Boolean,
      default: false
    },
    showDialog: {
      type: Boolean,
      default: false
    },
    colorRed: {
      type: Boolean,
      default: false
    },
    htmlText: {
      type: String,
      default: ""
    }
  },
  mounted: function mounted() {
    var _this = this;

    $("#" + this.dialogId).on("hide.bs.modal", function (e) {
      return _this.$emit("closeDialog");
    });
    $("#" + this.dialogId).on("hidden.bs.modal", function (e) {
      return _this.$emit("dialogClosed");
    });
  },

  watch: {
    showDialog: function showDialog() {
      this.showDialog ? this.openConfirmationDialog() : this.closeConfirmationDialog();
    }
  },
  methods: {
    openConfirmationDialog: function openConfirmationDialog() {
      var _this2 = this;

      this.$nextTick(function () {
        $("#" + _this2.dialogId).modal("show");
      });
    },
    closeConfirmationDialog: function closeConfirmationDialog() {
      $("#" + this.dialogId).modal("hide");
    },
    onYesConfirmation: function onYesConfirmation() {
      this.$emit("onYesConfirmation");
    },
    onNoConfirmation: function onNoConfirmation() {
      this.$emit("onNoConfirmation");
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Select2__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Select2__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EditVatRatesModal",
  components: {
    Select2: __WEBPACK_IMPORTED_MODULE_2__Select2___default.a
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      vatDataDirty: false,
      selectedCountry: "",
      currentEntry: {
        CountryCode: "",
        VatRate: undefined
      },
      vatDataList: [],
      lang: {
        EVR000: "VAT",
        EVR001: "Tax Rates",
        EVR002: "Country",
        EVR003: "VAT Rate",
        EVR004: "Close",
        EVR005: "Save"
      }
    };
  },

  computed: {
    vatRatePercentage: {
      get: function get() {
        if (!this.currentEntry.VatRate) return undefined;
        return (this.currentEntry.VatRate * 100).toFixed(2);
      },
      set: function set(value) {
        if (!value || value < 0) value = 0;
        if (value > 100) value = 100;
        this.currentEntry.VatRate = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()((value / 100).toFixed(4));
      }
    }
  },
  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
      this.globals.getCountryList();
    },
    showModal: function showModal(newVal) {
      newVal ? this.openModal() : this.closeModal();
    },
    selectedCountry: function selectedCountry(newCountryCode) {
      var entry = _.find(this.vatDataList, function (v) {
        return v.CountryCode === newCountryCode;
      });
      if (!entry) {
        entry = {
          CountryCode: newCountryCode,
          VatRate: undefined
        };
        this.vatDataList.push(entry);
      }
      this.currentEntry = entry;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this);
      this.globals.getCountryList();
    }

    $("#editVatRatesModal").on("hidden.bs.modal", function (e) {
      return _this.$emit("modalClosed");
    });
  },

  methods: {
    openModal: function openModal() {
      var _this2 = this;

      this.vatDataDirty = false;
      var success = function success() {
        _this2.$nextTick(function () {
          _this2.selectedCountry = "DE";
          $("#editVatRatesModal").modal("show");
        });
      };
      this.getVatRates(success);
    },
    closeModal: function closeModal() {
      $("#editVatRatesModal").modal("hide");
    },
    getVatRates: function getVatRates(_success) {
      var _this3 = this;

      this.selectedCountry = "";
      var query = "api/Administration/VatRates#test";
      $.ajax({
        method: "GET",
        url: query,
        success: function success(data) {
          _this3.vatDataList = data;
          if (_success) _success();
        },
        error: function error() {
          console.error("Error on GET in getVatRates()");
          _this3.globals.showErrorSnackbar("Tax rates data access failed");
        }
      });
    },
    saveVatRates: function saveVatRates() {
      var _this4 = this;

      var sendData = _.cloneDeep(this.vatDataList);
      _.remove(sendData, function (entry) {
        return !entry.VatRate;
      });

      var query = "api/Administration/VatRates";
      $.ajax({
        method: "PUT",
        url: query,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(sendData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this4.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this4.globals.showSuccessSnackbar("Tax rates updated");
          _this4.vatDataDirty = false;
        },
        error: function error(_error) {
          console.error("Error on PUT in saveVatRates()");
          _this4.globals.showErrorSnackbar("Tax rates update failed");
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ElementHistoryModal",
  data: function data() {
    return {
      title: "",
      elementId: 0,
      history: [],
      lang: {
        HIS000: "Info",
        HIS001: "Action",
        HIS002: "No history entries available.",
        HIS003: "Close",
        HIS004: "Check History",
        HIS005: "Location History",
        HIS006: "History data request failed"
      }
    };
  },

  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    this.globals.$off("showElementHistory");
    this.globals.$on("showElementHistory", function (config) {
      _this.getElementHistory(config);
    });
  },

  methods: {
    openModal: function openModal() {
      $("#elementHistoryModal").modal("show");
    },
    closeModal: function closeModal() {
      $("#elementHistoryModal").modal("hide");
    },
    getElementHistory: function getElementHistory(config) {
      var _this2 = this;

      if (!config) return;
      var query = "";

      if (config.type === "SurveyInstance") {
        query = "api/SurveyInstanceHistory/" + config.guid;
        this.title = this.lang.HIS004;
      } else if (config.type === "Location") {
        query = "api/LocationHistory/" + config.guid;
        this.title = this.lang.HIS005;
      }

      if (!query) {
        console.error("History config error");
        return;
      }

      this.elementId = config.id;
      this.history = [];

      $.ajax({
        method: "GET",
        url: query,
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this2.globals.showErrorSnackbar(data.Error);
            return;
          }
          if (data[0]) _this2.history = data;
          _this2.openModal();
        },
        error: function error(_error) {
          console.error("Error on GET in getElementHistory()");
          _this2.globals.showErrorSnackbar(_this2.lang.HIS006);
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "FeedModal",
  data: function data() {
    return {
      title: "",
      newFeedPostContent: "",
      availableFeeds: [],
      currentFeedConfig: {},
      currentFeedPosts: [],
      lang: {
        FEE000: "Feed",
        FEE001: "New message...",
        FEE002: "Send",
        FEE003: "No messages available yet.",
        FEE004: "Info",
        FEE005: "Message",
        FEE006: "Close",
        FEE007: "Available feeds request failed",
        FEE008: "Feed data request failed",
        FEE009: "Message sent",
        FEE010: "Sending failed"
      }
    };
  },

  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
    this.getAvailableFeeds();

    $("#feedModal").on("hidden.bs.modal", function (e) {
      _this.globals.$emit("feedModalClosed", _this.currentFeedConfig.ItemGuid, _this.currentFeedPosts);
    });

    this.globals.$off("openFeedModal");
    this.globals.$on("openFeedModal", function (config) {
      _this.currentFeedConfig = config;
      _this.getFeedPosts();
      $("#feedModal").modal("show");
    });
    this.globals.$off("closeFeedModal");
    this.globals.$on("closeFeedModal", function () {
      $("#feedModal").modal("hide");
    });

    this.globals.$off("requestFeedPosts");
    this.globals.$on("requestFeedPosts", function (config) {
      _this.getFeedPosts(config);
    });
  },

  methods: {
    addContentHighlighting: function addContentHighlighting(content) {
      var userHighlightString = "@" + this.globals.currentUserName;

      var result = content.replace(userHighlightString, "<span class=\"text-red text-bold\">" + userHighlightString + "</span>");
      return result;
    },
    getCurrentFeedGuid: function getCurrentFeedGuid(config) {
      var currentFeed = _.find(this.availableFeeds, function (f) {
        return f.FeedType === config.FeedType && f.FeedName === config.FeedName;
      });
      return currentFeed && currentFeed.FeedGuid;
    },
    getAvailableFeeds: function getAvailableFeeds() {
      var _this2 = this;

      $.ajax({
        method: "GET",
        url: "api/Feed/Available",
        success: function success(data) {
          if (data.Error) {
            _this2.globals.showErrorSnackbar(data.Error);
            console.error(data.Error);
            return;
          }
          _this2.availableFeeds = [];
          if (data[0]) _this2.availableFeeds = data;
        },
        error: function error(_error) {
          console.error("Error on GET in getAvailableFeeds()");
          _this2.globals.showErrorSnackbar(_this2.lang.FEE007);
        }
      });
    },
    getFeedPosts: function getFeedPosts(config) {
      var _this3 = this;

      var cfg = config || this.currentFeedConfig;
      if (!cfg.ItemGuid) return;

      var currentFeedGuid = this.getCurrentFeedGuid(cfg);
      if (!currentFeedGuid) return;

      var query = "api/Feed/" + currentFeedGuid + "/Posts/" + cfg.ItemGuid;
      $.ajax({
        method: "GET",
        url: query,
        success: function success(data) {
          if (data.Error) {
            _this3.globals.showErrorSnackbar(data.Error);
            console.error(data.Error);
            return;
          }

          _this3.currentFeedPosts = data[0] ? _.orderBy(data, ["FeedPostCreatedAt"], ["desc"]) : [];

          _this3.globals.$emit("feedPostsReceived", cfg.ItemGuid, cfg.FeedName, _this3.currentFeedPosts);
        },
        error: function error(_error2) {
          console.error("Error on GET in getFeedPosts()");
          _this3.globals.showErrorSnackbar(_this3.lang.FEE008);
          _this3.currentFeedPosts = [];
          _this3.globals.$emit("feedPostsReceived", cfg.ItemGuid, cfg.FeedName, []);
        }
      });
    },
    addFeedPost: function addFeedPost() {
      var _this4 = this;

      var cfg = this.currentFeedConfig;
      if (!cfg.ItemGuid || !this.newFeedPostContent) return;

      var currentFeedGuid = this.getCurrentFeedGuid(cfg);
      if (!currentFeedGuid) return;

      var sendData = {
        Content: this.newFeedPostContent
      };
      var query = "api/Feed/" + currentFeedGuid + "/Posts/" + cfg.ItemGuid;

      $.ajax({
        method: "POST",
        url: query,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(sendData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this4.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this4.getFeedPosts();
          _this4.newFeedPostContent = "";
          _this4.globals.showSuccessSnackbar(_this4.lang.FEE009);
        },
        error: function error(_error3) {
          console.error("Error on POST in addFeedPost()");
          _this4.globals.showErrorSnackbar(_this4.lang.FEE010);
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ace_builds__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ace_builds___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ace_builds__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "HtmlEditorModal",
  props: {
    showModal: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    openModal: function openModal() {
      $("#htmlEditorModal").modal("show");
    },
    closeModal: function closeModal() {
      $("#htmlEditorModal").modal("hide");
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
    $("#htmlEditorModal").on("hidden.bs.modal", function (e) {
      _this.$emit("modalClosed");
      _this.globals.$emit("getDataFromHtmlEditorModal", _this.content);
    });

    this.globals.$off("sendDataToHtmlEditorModal");
    this.globals.$on("sendDataToHtmlEditorModal", function (data) {
      _this.title = data.title;
      _this.content = data.content || "";
      _this.aceEditor.setValue(_this.content);
    });

    __webpack_require__(468);
    __WEBPACK_IMPORTED_MODULE_0_ace_builds___default.a.require("ace/ext/language_tools");
    this.aceEditor = __WEBPACK_IMPORTED_MODULE_0_ace_builds___default.a.edit("aceEditor");
    this.aceEditor.session.setMode("ace/mode/html");
    this.aceEditor.setTheme("ace/theme/tomorrow");
    this.aceEditor.on("blur", function () {
      _this.content = _this.aceEditor.getValue();
    });
  },

  watch: {
    showModal: function showModal(newValue) {
      newValue ? this.openModal() : this.closeModal();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  data: function data() {
    return {
      title: "",
      content: "",
      aceEditor: null,
      lang: {
        HEM000: "HTML Editor",
        HEM001: "Preview",
        HEM002: "Close"
      }
    };
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "NotificationDialog",
  props: {
    dialogId: {
      type: String,
      default: "notificationDialog"
    },
    notificationTitle: {
      type: String,
      default: ""
    },
    closeButtonText: {
      type: String,
      default: "Close"
    },
    showDialog: {
      type: Boolean,
      default: false
    },
    colorRed: {
      type: Boolean,
      default: false
    },
    htmlText: {
      type: String,
      default: ""
    }
  },
  methods: {
    openNotificationDialog: function openNotificationDialog() {
      var _this = this;

      this.$nextTick(function () {
        $("#" + _this.dialogId).modal("show");
      });
    },
    closeNotificationDialog: function closeNotificationDialog() {
      $("#" + this.dialogId).modal("hide");
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    $("#" + this.dialogId).on("hide.bs.modal", function (e) {
      return _this2.$emit("closeDialog");
    });
    $("#" + this.dialogId).on("hidden.bs.modal", function (e) {
      _this2.$emit("dialogClosed");
    });
  },

  watch: {
    showDialog: function showDialog() {
      if (this.showDialog) {
        this.openNotificationDialog();
      } else {
        this.closeNotificationDialog();
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "UploadProgressModal",
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    progress: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      lang: {
        UPM000: "Uploading",
        UPM001: "Cancel"
      }
    };
  },

  watch: {
    showDialog: function showDialog(newValue) {
      if (newValue) {
        this.openUploadProgressModal();
      } else {
        this.closeUploadProgressModal();
      }
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  mounted: function mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
  },

  methods: {
    openUploadProgressModal: function openUploadProgressModal() {
      $("#uploadProgressModal").modal("show");
    },
    closeUploadProgressModal: function closeUploadProgressModal() {
      $("#uploadProgressModal").modal("hide");
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);

//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Select2",
  props: {
    value: {
      default: null
    },
    width: {
      type: String,
      default: "100%"
    },
    placeholder: {
      // Example object: { id: '', text: 'Please select an entry...' }
      // id is the value of the option
      // an empty option needs to be added to the list
      // If only a string is provided, the placeholder will appear for any value that no option exists for
      type: [Object, String],
      default: null
    },
    allowClear: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    tags: {
      type: Boolean,
      default: false
    },
    noResultsString: {
      type: String,
      default: ""
    }
  },
  mounted: function mounted() {
    this.initSelect2();
  },

  watch: {
    value: function value(_value) {
      if (this.tags) this.addTaggedValues();
      $(this.$el).val(_value).trigger("change.select2");
    },
    placeholder: function placeholder(value) {
      this.initSelect2();
    },
    allowClear: function allowClear() {
      this.initSelect2();
    },
    multiple: function multiple() {
      this.initSelect2();
    },
    tags: function tags() {
      this.initSelect2();
    }
  },
  destroyed: function destroyed() {
    this.destroySelect2();
  },

  methods: {
    addTaggedValues: function addTaggedValues() {
      if (this.multiple) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.value), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _val = _step.value;

            if (!this.isValueInOptions(_val)) this.addCustomValueToOptions(_val);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      } else if (!this.isValueInOptions(this.value)) this.addCustomValueToOptions(this.value);
    },
    isValueInOptions: function isValueInOptions(value) {
      var options = $(this.$el).find("option");
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(options), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var option = _step2.value;

          if (value === option.value) return true;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return false;
    },
    addCustomValueToOptions: function addCustomValueToOptions(value) {
      $(this.$el).append(new Option(value, value));
    },
    updateValue: function updateValue() {
      var _this = this;

      this.$nextTick(function () {
        $(_this.$el).val(_this.value).trigger("change.select2");
      });
    },
    reinit: function reinit() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.destroySelect2();
        _this2.initSelect2();
      });
    },
    destroySelect2: function destroySelect2() {
      $(this.$el).off().select2("destroy");
    },
    open: function open() {
      $(this.$el).select2("open");
    },
    close: function close() {
      $(this.$el).select2("close");
    },
    initSelect2: function initSelect2() {
      var _this3 = this;

      var vm = this;
      var options = {
        width: this.width,
        allowClear: this.allowClear,
        tags: this.tags,
        multiple: this.multiple,
        language: {
          noResults: function noResults() {
            return _this3.noResultsString || _this3.globals.lang.G00000;
          }
        }
      };
      if (this.placeholder) options.placeholder = this.placeholder;
      if (this.tags) options.tokenSeparators = [",", " "];

      // If this select was already initialized before, events are already registered
      var alreadyInitialized = $(this.$el).hasClass("select2-hidden-accessible");

      $(this.$el)
      // init select2
      .select2(options).val(this.value).trigger("change.select2");

      if (this.tags && this.value) {
        this.addTaggedValues();
        this.updateValue();
      }

      if (!alreadyInitialized) {
        // emit event on change.
        $(this.$el).on("change", function (event) {
          var result = void 0;
          if (!vm.multiple) result = this.value;else {
            var selected = $(this).select2("data");
            result = [];
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
              for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(selected), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var option = _step3.value;

                result.push(option.id);
              }
            } catch (err) {
              _didIteratorError3 = true;
              _iteratorError3 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }
              } finally {
                if (_didIteratorError3) {
                  throw _iteratorError3;
                }
              }
            }
          }
          vm.$emit("input", result, event);
          vm.$emit("change", result, event);
        }).focus(function () {
          $(this).select2("open");
        });

        $(this.$el).on("select2:open", function (e) {
          vm.$emit("open", e);
        });

        $(this.$el).on("select2:opening", function (e) {
          vm.$emit("beforeOpen", e);
        });

        $(this.$el).on("select2:close", function (e) {
          vm.$emit("close", e);
        });
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StatIndicator',
  props: {
    value: { type: Number, default: 0 },
    centerText: { type: Number, default: 0 },
    label: { type: String, default: '' },
    size: { type: Number, default: 50 },
    stroke: { type: Number, default: 2.5 },
    trackColor: { type: String, default: '#f5f5f5' },
    ringColor: { type: String, default: '#f50537' },
    showRing: { type: Boolean, default: true },
    showSquare: { type: Boolean, default: false },
    decimalPlaces: { type: Number, default: 1 },
    isPercentage: { type: Boolean, default: false },
    suffix: { type: String, default: '' }
  },
  computed: {
    value_computed: function value_computed() {
      // if(!this.value) return null;
      if (this.isPercentage) return this.value * 100;
      return this.value;
    },
    centerText_computed: function centerText_computed() {
      // if(!this.centerText) return null;
      if (this.isPercentage) return Number((this.centerText * 100).toFixed(this.decimalPlaces));
      return Number(this.centerText.toFixed(this.decimalPlaces));
    },
    r: function r() {
      return this.size / 2 - this.stroke;
    },
    c: function c() {
      return 2 * Math.PI * this.r;
    },
    dashArray: function dashArray() {
      return this.c;
    },
    dashOffset: function dashOffset() {
      var v = Math.max(0, Math.min(100, this.value_computed));
      return this.c * (100 - v) / 100;
    },
    box: function box() {
      return { width: this.size + 'px', height: this.size + 'px' };
    }
  }
});

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ImportUsersModal__ = __webpack_require__(1571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ImportUsersModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_ImportUsersModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UserMgmt_SettingsPoliciesControl__ = __webpack_require__(1632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UserMgmt_SettingsPoliciesControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__UserMgmt_SettingsPoliciesControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UserMgmt_CustomPropertiesPoliciesControl__ = __webpack_require__(1631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UserMgmt_CustomPropertiesPoliciesControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__UserMgmt_CustomPropertiesPoliciesControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UserMgmt_SurveysQuestionsPoliciesControl__ = __webpack_require__(1633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UserMgmt_SurveysQuestionsPoliciesControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__UserMgmt_SurveysQuestionsPoliciesControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Tools_Select2__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Tools_Select2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__globals__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Tools_Dialogs_ConfirmationDialog__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Tools_Dialogs_ConfirmationDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Tools_Dialogs_ConfirmationDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Tools_Dialogs_ChangePasswordDialog__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Tools_Dialogs_ChangePasswordDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__Tools_Dialogs_ChangePasswordDialog__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  name: "UserManagement",
  components: {
    SettingsPoliciesControl: __WEBPACK_IMPORTED_MODULE_4__UserMgmt_SettingsPoliciesControl___default.a,
    CustomPropertiesPoliciesControl: __WEBPACK_IMPORTED_MODULE_5__UserMgmt_CustomPropertiesPoliciesControl___default.a,
    SurveysQuestionsPoliciesControl: __WEBPACK_IMPORTED_MODULE_6__UserMgmt_SurveysQuestionsPoliciesControl___default.a,
    ImportUsersModal: __WEBPACK_IMPORTED_MODULE_3__components_ImportUsersModal___default.a,
    Select2: __WEBPACK_IMPORTED_MODULE_7__Tools_Select2___default.a,
    ConfirmationDialog: __WEBPACK_IMPORTED_MODULE_9__Tools_Dialogs_ConfirmationDialog___default.a,
    "change-password-dialog": __WEBPACK_IMPORTED_MODULE_10__Tools_Dialogs_ChangePasswordDialog___default.a
  },
  mounted: function mounted() {
    var _this = this;

    this.readComponentSettingsFromStore();
    // Gets executed right after rendering the component
    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this);
      this.getUserData();
    }
    this.getEditUserDialogSelectData();
    this.getTargetGroups();

    $('a[data-toggle="tab"]').on("hidden.bs.tab", function (e) {
      // Removes selected items on the security dialog after switching the tab
      _this.securityDialogData.selectedAssignedGroupGuids = [];
      _this.securityDialogData.selectedUnassignedGroupGuids = [];
    });

    $(window).on("resize", this.setTableHeight).resize();

    if (!this.globals.currentUserInfo) this.globals.$once("currentUserInfoReceived", this.setTableHeight);

    this.globals.$off("SecurityGroupDeleteModalYesConfirmation");
    this.globals.$on("SecurityGroupDeleteModalYesConfirmation", function () {
      _this.deleteSelectedGroup();
    });
  },
  destroyed: function destroyed() {
    $(window).off("resize", this.setTableHeight);
    this.writeComponentSettingsToStore();
  },

  computed: {
    // List of security groups that are assigned to the current user
    groupListAssigned: function groupListAssigned() {
      var _this2 = this;

      return this.securityDialogData.dataLists.customGroupData.filter(function (g) {
        return _this2.securityDialogData.assignedGroupGuids.indexOf(g.GroupGuid) > -1;
      });
    },

    // List of available security groups that are not assigned to the current user
    groupListAvailable: function groupListAvailable() {
      var _this3 = this;

      return this.securityDialogData.dataLists.customGroupData.filter(function (g) {
        return _this3.securityDialogData.assignedGroupGuids.indexOf(g.GroupGuid) < 0;
      });
    }
  },
  methods: {
    setTableHeight: function setTableHeight() {
      this.$nextTick(function () {
        var height = $(window).height();
        height -= $("#users-top-panel").height() + $("#app-navbar").height() + $(".main-table > thead").height() + 47; // 47 pixel for the free space around the cards
        $(".main-table-scrollbar").css("max-height", height);
        height -= 100; // Lower height for client policies table because of dialog size limitations
        $(".client-policies-table").css("max-height", height);
        $("#locations2Tab .main-table-scrollbar").css("max-height", height);
      });
    },
    readComponentSettingsFromStore: function readComponentSettingsFromStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      var storedData = this.$store.getters["localFilters/userManagement"];
      if (storedData) {
        for (var key in storedData) {
          if (_.has(this, key)) this[key] = _.cloneDeep(storedData[key]);
        }
      }

      if (!this.$store.getters["userSettings/syncFilters"]) return;
      if (!this.feature.isAudiTarget || !this.feature.isEnabled("audi_importers")) {
        var storedClient = this.$store.getters["sharedFilters/client"];
        this.filterStrings.Company = storedClient.ClientName || "";
      }
    },
    writeComponentSettingsToStore: function writeComponentSettingsToStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      this.$store.commit("localFilters/userManagement", {
        filterStrings: this.filterStrings,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        pageSize: this.pageSize
      });
    },

    // Validates an input with the given id, changes the input color depending on the validation result and returns the result
    validateInput: function validateInput(id) {
      var result = $("#" + id)[0].checkValidity(); // Checks validation depending on the input type or a given pattern in the template
      if (result) {
        $("#" + id).parent().parent().removeClass("has-error"); // has-error has to be added to the form-group element
        var idx = this.invalidInputIds.indexOf(id);
        if (idx > -1) {
          this.invalidInputIds.splice(idx, 1); // Remove from list, if valid
        }
      } else {
        $("#" + id).parent().parent().addClass("has-error");
        if (this.invalidInputIds.indexOf(id) < 0) this.invalidInputIds.push(id); // Add to list, if invalid
      }
      return result;
    },

    // Returns true if an input has a validation error, otherwise false
    inputHasError: function inputHasError(id) {
      if (this.invalidInputIds.indexOf(id) > -1) return true;
      return false;
    },

    // returns user info text in format:
    // "Benutzername: Lastname, Firstname (Username); Benutzer-ID: {GUID}; Typ: {UserType}"
    getSelectedUserInfoText: function getSelectedUserInfoText() {
      var usr = this.selectedUserData;
      if (!usr) return "user informations unknown";
      var infoText = this.lang.S0178 + ": " + usr.LastName + ", " + usr.FirstName + " (" + usr.LoginName + "); " + this.lang.S0009 + ":" + usr.UserType + ":" + usr.SecurityRole;
      if (usr.Company) infoText += " - " + usr.Company;
      return infoText;
    },

    // Triggers input validation and ensures further progress if validation was successful
    validateBeforeSubmit: function validateBeforeSubmit(dialogId) {
      var result = true;

      var elements = $("#" + dialogId).find(":input"); // Returns a list of all inputs on the dialog
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0) result = this.validateInput(elements[i].id) && result; // If only one input is invalid, the whole form is invalid
      }

      if (dialogId == "editUser") {
        this.editUserDialogData.showAlert = !result;
        if (!result) return;
        this.saveEditUserDialogData();
      }
    },

    // Resets all validation errors for the given dialog
    resetValidationErrors: function resetValidationErrors(dialogId) {
      var elements = $("#" + dialogId).find(":input"); // Returns a list of all inputs on the dialog
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0) $("#" + elements[i].id).parent().parent().removeClass("has-error");
      }
      this.invalidInputIds = [];
    },

    // Opens the security check dialog for deleting the selected user
    openDeleteUserDialog: function openDeleteUserDialog() {
      var _this4 = this;

      var objIndex = _.findIndex(this.userData, function (o) {
        return o.UserId == _this4.selectedUser;
      });
      this.deleteUserDialogData = this.userData[objIndex];
      $("#deleteUserDialog").modal("show");
    },

    // Sends a delete request for the selected user to the server
    deleteUserData: function deleteUserData() {
      var _this5 = this;

      $.ajax({
        method: "DELETE",
        url: "api/SecurityUsers/" + this.selectedUser,
        success: function success(data) {
          if (data.Error) {
            _this5.globals.showErrorSnackbar(data.Error);
            console.error(data.Error);
            return;
          }
          // If delete was successful, refresh displayed data and hide dialog
          _this5.globals.showSuccessSnackbar("User deletion successful");
          $("#deleteUserDialog").modal("hide");
          _this5.selectedUser = "";
          _this5.getUserData();
        },
        error: function error() {
          console.error("User data deletion failed in deleteUserData()");
          _this5.globals.showErrorSnackbar("User deletion failed");
        }
      });
    },

    // Refreshes the region list in the dropdown of the editUser dialog depending on the selected country
    changedCountry: function changedCountry(country) {
      var regionObj = [{ Regions: [] }];
      var tzObj = [{ TimeZones: [] }];

      if (typeof this.regionList != "undefined") {
        if (typeof country != "undefined" && country != "" && country != "  ") {
          regionObj = this.regionList.filter(function (region) {
            // Filter regions for the given country
            return region.Country.toLowerCase().indexOf(country.toLowerCase()) >= 0;
          });
        }
      }

      if (typeof this.timeZones != "undefined") {
        if (typeof country != "undefined" && country != "" && country != "  ") {
          tzObj = this.timeZones.filter(function (tz) {
            // Filter timezones for the given country
            return tz.Country.toLowerCase().indexOf(country.toLowerCase()) >= 0;
          });
        }
      }

      if (regionObj.length == 0) this.editUserDialogData.currentRegions = [];else this.editUserDialogData.currentRegions = regionObj[0].Regions;

      if (tzObj.length == 0) this.editUserDialogData.currentTimeZones = [];else this.editUserDialogData.currentTimeZones = tzObj[0].TimeZones;

      var idx = this.editUserDialogData.currentRegions.map(function (e) {
        return e.Region;
      }).indexOf(this.editUserDialogData.userData.Region);

      if (idx < 0) delete this.editUserDialogData.userData.Region;

      idx = this.editUserDialogData.currentTimeZones.map(function (e) {
        return e.TimeZoneId;
      }).indexOf(this.editUserDialogData.userData.TimeZone);

      if (idx < 0) delete this.editUserDialogData.userData.TimeZone;
    },

    // Refreshes agency information of the userdata depending on the usertypeId
    userTypeIdChanged: function userTypeIdChanged() {
      delete this.editUserDialogData.userData.AgencyGuid;
      delete this.editUserDialogData.userData.ClientId;
      delete this.editUserDialogData.userData.SecurityRoleId;
    },

    // Opens the securityDialog after the dialog data is received
    securityDialogDataReceived: function securityDialogDataReceived() {
      $("#securityDialog").modal("show");
    },

    // Requests needed group data for the security dialog from the server
    openSecurityDialog: function openSecurityDialog() {
      var _this6 = this;

      var doneCounter = 0;
      var requestCount = 2;

      this.securityDialogData.dataLists.securityGroupData = []; // Clear all data before request
      this.securityDialogData.dataLists.roleData = [];
      this.securityDialogData.dataLists.customGroupData = [];
      this.securityDialogData.assignedGroupGuids = [];
      this.securityDialogData.selectedAssignedGroupGuids = [];
      this.securityDialogData.selectedUnassignedGroupGuids = [];
      this.clearGroupManagementInputs();

      var query = "api/SecurityGroups";
      if (this.selectedUserData.ClientGuid) query += "?ClientGuid=" + this.selectedUserData.ClientGuid;

      $.ajax({
        method: "GET",
        url: query,
        success: function success(data) {
          var sortedData = _.sortBy(data, [function (g) {
            return g.GroupName.toLowerCase();
          }]);
          // Request general group informations
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(sortedData), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var group = _step.value;

              // Copy group data to different lists for roles, security groups and custom groups
              if (group.GroupType === "SM") _this6.securityDialogData.dataLists.securityGroupData.push(group);else if (group.GroupType === "SYSTEM") _this6.securityDialogData.dataLists.roleData.push(group);else if (group.GroupType === "SMUSER") _this6.securityDialogData.dataLists.customGroupData.push(group);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        },
        error: function error() {
          console.error("Group data access failed in openSecurityDialog()");
          _this6.globals.showErrorSnackbar("Group data access failed");
          doneCounter = -1;
        },
        complete: function complete() {
          doneCounter++;
          if (doneCounter >= requestCount) _this6.securityDialogDataReceived();
        }
      });

      $.ajax({
        method: "GET",
        url: "api/SecurityUsers/" + this.selectedUser + "/Groups",
        success: function success(data) {
          // Request groups that are assigned to current user
          _this6.securityDialogData.assignedGroupGuids = data;
        },
        error: function error() {
          console.error("Group assignment data access failed in openSecurityDialog()");
          _this6.globals.showErrorSnackbar("Group assignment data access failed");
          doneCounter = -1;
        },
        complete: function complete() {
          doneCounter++;
          if (doneCounter >= requestCount) _this6.securityDialogDataReceived();
        }
      });
    },
    getAllSecurityGroups: function getAllSecurityGroups() {
      var _this7 = this;

      var query = "api/SecurityGroups";
      if (this.selectedUserData.ClientGuid) query += "?ClientGuid=" + this.selectedUserData.ClientGuid;

      $.ajax({
        method: "GET",
        url: query,
        success: function success(data) {
          _this7.securityDialogData.dataLists.securityGroupData = [];
          _this7.securityDialogData.dataLists.roleData = [];
          _this7.securityDialogData.dataLists.customGroupData = [];

          var sortedData = _.sortBy(data, [function (g) {
            return g.GroupName.toLowerCase();
          }]);
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(sortedData), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var group = _step2.value;

              // Copy group data to different lists for roles, security groups and custom groups
              if (group.GroupType === "SM") _this7.securityDialogData.dataLists.securityGroupData.push(group);else if (group.GroupType === "SYSTEM") _this7.securityDialogData.dataLists.roleData.push(group);else if (group.GroupType === "SMUSER") _this7.securityDialogData.dataLists.customGroupData.push(group);
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        },
        error: function error() {
          console.error("Group data access failed in getAllSecurityGroups()");
          _this7.globals.showErrorSnackbar("Group data access failed");
        }
      });
    },
    getSecurityGroupData: function getSecurityGroupData() {
      var _this8 = this;

      $.ajax({
        method: "GET",
        url: "api/SecurityGroups/" + this.securityDialogData.groupManagement.selectedGroup,
        success: function success(data) {
          // Request groups that are assigned to current user
          _this8.securityDialogData.groupManagement.selectedGroupData = data;
        },
        error: function error() {
          console.error("Group data access failed in getSecurityGroupData()");
          _this8.globals.showErrorSnackbar("Group data access failed");
        }
      });
    },
    getTargetGroups: function getTargetGroups() {
      var _this9 = this;

      var query = "api/Data/TargetGroups";

      $.ajax({
        method: "GET",
        url: query,
        success: function success(data) {
          _this9.targetGroups = data;
        },
        error: function error() {
          console.error("Target group data access failed in getTargetGroups()");
          _this9.globals.showErrorSnackbar("Target group data access failed");
        }
      });
    },
    targetGroupGuidChanged: function targetGroupGuidChanged(targetGroupGuid) {
      var groupGuid = this.isTargetGroupAlreadyInUse(targetGroupGuid);
      if (groupGuid && groupGuid !== this.securityDialogData.groupManagement.selectedGroupData.GroupGuid) {
        this.globals.$emit("openGlobalNotificationDialog", {
          initiator: "GroupManagementTargetGroupChange",
          notificationTitle: this.lang.S0198,
          colorRed: true,
          closeButtonText: this.lang.S0164,
          htmlText: "<b>\n            <p>" + this.lang.S0199 + "</p>\n          </b>"
        });
      }
      this.securityDialogData.groupManagement.selectedGroupData.TargetGroupGuid = targetGroupGuid;
    },

    // Returns GUID of the group that uses the target group
    isTargetGroupAlreadyInUse: function isTargetGroupAlreadyInUse(targetGroupGuid) {
      if (this.securityDialogData.dataLists.customGroupData.length < 1) return "";

      var group = _.find(this.securityDialogData.dataLists.customGroupData, ["TargetGroupGuid", targetGroupGuid]);
      return group ? group.GroupGuid : "";
    },
    findNextFreeTargetGroup: function findNextFreeTargetGroup() {
      if (this.securityDialogData.groupManagement.selectedGroupData.TargetGroupGuid) return this.securityDialogData.groupManagement.selectedGroupData.TargetGroupGuid;

      for (var tg in this.targetGroups) {
        if (!this.isTargetGroupAlreadyInUse(tg)) return tg;
      }
      return "";
    },
    reportingGroupFlagToggled: function reportingGroupFlagToggled() {
      if (this.securityDialogData.groupManagement.selectedGroupData.IsReportingGroup) {
        if (this.selectedUserData.ClientGuid) {
          this.securityDialogData.groupManagement.selectedGroupData.ClientGuid = this.selectedUserData.ClientGuid;
          this.securityDialogData.groupManagement.selectedGroupData.TargetGroupGuid = this.findNextFreeTargetGroup();
          this.$forceUpdate();
        }
      }
    },
    getSelectedClients: function getSelectedClients() {
      //return this.security2DialogData.dataLists.selectedClients.filter(i => {return i.Permitted})
      return this.security2DialogData.dataLists.selectedClients.filter(function (i) {
        return i.Permitted;
      });
    },

    // Opens the securityDialog after the dialog data is received
    security2DialogDataReceived: function security2DialogDataReceived() {
      $("#security2Dialog").modal("show");
    },

    //Apply filters for Location Data
    filterLocationData: function filterLocationData() {
      var keys = ["LocationStoreId", "LocationName", "LocationAddress", "LocationCountry", "LocationStatusId"];
      var filterStrings = this.security2DialogData.locationFilterStrings;
      var permittedLocations = this.security2DialogData.dataLists.permittedLocations;

      var locationFilter = function locationFilter(location) {
        var filterPassed = true;

        // Filter for location permission
        var locationPermitted = _.indexOf(permittedLocations, location.LocationGuid) > -1;
        if (filterStrings.LocationVisible === 0 && locationPermitted || filterStrings.LocationVisible === 1 && !locationPermitted) return false;

        // Filter for filterstrings
        keys.forEach(function (key) {
          if (typeof location[key] === "string" && location[key].toLowerCase().indexOf(filterStrings[key].toLowerCase()) < 0) {
            filterPassed = false;
            return;
          }
        });
        return filterPassed;
      };

      var filteredLocations = !_.isEmpty(this.security2DialogData.dataLists.locations) ? this.security2DialogData.dataLists.locations.filter(locationFilter) : [];

      // Filter top 100
      if (this.security2DialogData.showTop100LocationsOnly && filteredLocations.length > 100) filteredLocations = filteredLocations.slice(0, 100);

      this.security2DialogData.dataLists.filteredLocations = filteredLocations;
    },

    // Requests needed group data for the security dialog from the server
    openSecurity2Dialog: function openSecurity2Dialog() {
      var _this10 = this;

      var requestCount = 5;
      var successCallback = function successCallback() {
        if (--requestCount === 0) {
          _this10.security2DialogDataReceived();
        }
      };
      var errorCallback = function errorCallback() {
        _this10.globals.showErrorSnackbar("Policy data request failed");
      };

      this.security2DialogData.dataLists.selectedClients = [];
      this.security2DialogData.dataLists.clientSetting = [];
      this.security2DialogData.dataLists.locationProperties = [];
      this.security2DialogData.dataLists.locations = [];
      this.security2DialogData.hasAccessToAllLocations = false;

      this.$refs.locationProperties2Tab.loadPolicies(successCallback, errorCallback);
      // this.$refs.questions2Tab.loadPolicies();
      this.$refs.reportingFeatures2Tab.loadPolicies(successCallback, errorCallback);

      $.ajax({
        method: "GET",
        url: "/api/UserSecurity/" + this.selectedUser + "/Clients",
        success: function success(data) {
          if (data && data[0] && data[0].ClientGuid && data[0].ClientGuid === _this10.selectedUserData.ClientGuid && data[0].Permitted === true) {
            _this10.security2DialogData.hasAccessToAllLocations = true;
          }
          successCallback();
        },
        error: function error() {
          console.error("Client data access failed in openSecurity2Dialog()");
          errorCallback();
        }
      });

      $.ajax({
        method: "GET",
        url: "/api/UserSecurity/" + this.selectedUser + "/Projects/Client/" + this.selectedUserData.ClientGuid,
        success: function success(data) {
          _this10.security2DialogData.dataLists.clientSetting = _.isEmpty(data) ? [] : data;
          successCallback();
        },
        error: function error() {
          console.error("Project data access failed in openSecurity2Dialog()");
          errorCallback();
        }
      });

      $.ajax({
        method: "GET",
        url: "/api/UserSecurity/" + this.selectedUser + "/Locations/Client/" + this.selectedUserData.ClientGuid,
        success: function success(data) {
          if (data && data[0]) {
            if (data[0].Locations) _this10.security2DialogData.dataLists.locations = data[0].Locations;else _this10.security2DialogData.dataLists.locations = [];

            if (data[0].Permitted) _this10.security2DialogData.dataLists.permittedLocations = data[0].Permitted;else _this10.security2DialogData.dataLists.permittedLocations = [];

            _this10.filterLocationData();
          }
          successCallback();
        },
        error: function error() {
          console.error("Location data access failed in openSecurity2Dialog()");
          errorCallback();
        }
      });
    },
    toggleLocationPermission: function toggleLocationPermission(locGuid) {
      this.security2DialogData.dataLists.permittedLocations = _.xor(this.security2DialogData.dataLists.permittedLocations, [locGuid]);
    },
    isLocationPermitted: function isLocationPermitted(locGuid) {
      return _.indexOf(this.security2DialogData.dataLists.permittedLocations, locGuid) > -1;
    },

    // Adds a new item to a list if it's not already in the list. Otherwise the item will me removed from the list.
    toggleListItem: function toggleListItem(list, item) {
      var index = list.indexOf(item);
      if (index > -1) {
        list.splice(index, 1);
      } else list.push(item);
    },

    // Assigns selected groups to the user
    assignGroups: function assignGroups() {
      if (this.securityDialogData.selectedUnassignedGroupGuids.length == 0) return;
      for (var i = 0; i < this.securityDialogData.selectedUnassignedGroupGuids.length; i++) {
        this.securityDialogData.assignedGroupGuids.push(this.securityDialogData.selectedUnassignedGroupGuids[i]);
      }
      this.securityDialogData.selectedUnassignedGroupGuids = [];
    },

    // Unassigns selected groups from the user
    unassignGroups: function unassignGroups() {
      if (this.securityDialogData.selectedAssignedGroupGuids.length == 0) return;
      for (var i = 0; i < this.securityDialogData.selectedAssignedGroupGuids.length; i++) {
        var index = this.securityDialogData.assignedGroupGuids.indexOf(this.securityDialogData.selectedAssignedGroupGuids[i]);
        this.securityDialogData.assignedGroupGuids.splice(index, 1);
      }
      this.securityDialogData.selectedAssignedGroupGuids = [];
    },

    // Edits a custom group to the group list or adds a new group if the group does not exist
    editGroup: function editGroup() {
      var _this11 = this;

      if (!this.securityDialogData.groupManagement.selectedGroupData.IsReportingGroup) delete this.securityDialogData.groupManagement.selectedGroupData.TargetGroupGuid;

      var groupData = _.cloneDeep(this.securityDialogData.groupManagement.selectedGroupData);
      if (!groupData.ClientGuid) delete groupData.ClientGuid;

      if (!this.securityDialogData.groupManagement.selectedGroup) {
        $.ajax({
          // Stores a new group on the server
          method: "POST",
          url: "api/SecurityGroups",
          data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(groupData),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            if (!data || _.isEmpty(data)) {
              console.error("No valid group data returned in editGroup()");
              return;
            }
            if (data.Error) {
              _this11.globals.showErrorSnackbar(data.Error);
              return;
            }
            // If POST was successful, store new data to local datalist and select the new group
            _this11.globals.showSuccessSnackbar("Group creation successful");
            groupData = data;
            _this11.getAllSecurityGroups();
            _this11.securityDialogData.groupManagement.selectedGroup = groupData.GroupGuid;
            _this11.securityDialogData.groupManagement.selectedGroupData = groupData;
            _this11.securityDialogData.groupManagement.isSelectedGroupDirty = false;
          },
          error: function error() {
            console.error("Error on POST in editGroup()");
            _this11.globals.showErrorSnackbar("Group creation failed");
          }
        });
      } else {
        $.ajax({
          // Stores changes of a group on the server
          method: "PUT",
          url: "api/SecurityGroups/" + this.securityDialogData.groupManagement.selectedGroup,
          data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(groupData),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            if (data.Error) {
              _this11.globals.showErrorSnackbar(data.Error);
              return;
            }
            // If PUT was successful, store data to local datalist and select the new group
            _this11.globals.showSuccessSnackbar("Group update successful");
            var updatedGroupIndex = _.findIndex(_this11.securityDialogData.dataLists.customGroupData, ["GroupGuid", _this11.securityDialogData.groupManagement.selectedGroup]);

            _this11.getAllSecurityGroups();
            _this11.securityDialogData.groupManagement.isSelectedGroupDirty = false;
            _this11.$forceUpdate();
          },
          error: function error() {
            console.error("Error on PUT in editGroup()");
            _this11.globals.showErrorSnackbar("Group update failed");
          }
        });
      }
    },

    // Selects the group with the given ID and fills groupmanagement data fields depending on the selected group
    selectGroup: function selectGroup(groupGuid) {
      if (this.securityDialogData.groupManagement.selectedGroup === groupGuid) {
        this.clearGroupManagementInputs();
      } else {
        this.securityDialogData.groupManagement.selectedGroup = groupGuid;
        this.getSecurityGroupData();
      }
    },
    openGroupDeletionDialog: function openGroupDeletionDialog() {
      this.globals.$emit("openGlobalConfirmationDialog", {
        initiator: "SecurityGroupDeleteModal",
        confirmationTitle: this.lang.S0192,
        colorRed: true,
        yesButtonText: this.lang.S0101,
        noButtonText: this.lang.S0102,
        htmlText: "<p><b>" + this.lang.S0193 + "</b></p>\n          <div class=\"form-group\">\n            <label class=\"col-md-3 text-black\">" + this.lang.S0194 + "</label>\n            <label class=\"col-md-9 text-black\">" + this.securityDialogData.groupManagement.selectedGroupData.GroupName + "</label>\n          </div>"
      });
    },

    // Removes the selected group from the list of custom groups
    deleteSelectedGroup: function deleteSelectedGroup() {
      var _this12 = this;

      $.ajax({
        // Stores a new group on the server
        method: "DELETE",
        url: "api/SecurityGroups/" + this.securityDialogData.groupManagement.selectedGroup,
        data: {},
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          // If DELETE was successful, remove data from local datalist
          _this12.globals.showSuccessSnackbar("Group deletion successful");
          _this12.securityDialogData.dataLists.customGroupData = _this12.securityDialogData.dataLists.customGroupData.filter(function (e) {
            return e.GroupGuid !== _this12.securityDialogData.groupManagement.selectedGroup;
          });
          _this12.clearGroupManagementInputs();
        },
        error: function error() {
          console.error("Error on DELETE in deleteSelectedGroup()");
          _this12.globals.showErrorSnackbar("Group deletion failed");
        }
      });
    },

    // Clears the input fields in groupmanagement
    clearGroupManagementInputs: function clearGroupManagementInputs() {
      this.securityDialogData.groupManagement = {
        selectedGroup: "",
        selectedGroupData: {}
      };
    },

    // Sends data from the security dialog to the server to store it in the database
    saveSecurityData: function saveSecurityData() {
      var _this13 = this;

      if (this.globals.isAccessAllowed("LoopOp_SecurityUsersSecurityGroups_Update")) {
        $.ajax({
          // Stores groups that are assigned to the selected user
          method: "PUT",
          url: "api/SecurityUsers/" + this.selectedUser + "/Groups",
          data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.securityDialogData.assignedGroupGuids),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            // If PUT was successful, hide dialog
            _this13.globals.showSuccessSnackbar("Group security update successful");
            $("#securityDialog").modal("hide");
          },
          error: function error() {
            console.error("Error on PUT in saveSecurityData()");
            _this13.globals.showErrorSnackbar("Group security update failed");
          }
        });
      }
    },
    saveSecurity2Data: function saveSecurity2Data() {
      var _this14 = this;

      var requestCount = 5;
      var successCallback = function successCallback() {
        if (--requestCount === 0) _this14.globals.showSuccessSnackbar("Security data update successful");
      };
      var errorCallback = function errorCallback() {
        _this14.globals.showErrorSnackbar("Security data update failed");
      };
      this.$refs.locationProperties2Tab.saveChanges(successCallback, errorCallback);
      this.$refs.reportingFeatures2Tab.saveChanges(successCallback, errorCallback);
      //this.$refs.questions2Tab.saveChanges();

      var clients = [];
      if (this.security2DialogData.hasAccessToAllLocations) clients.push(this.selectedUserData.ClientGuid);
      $.ajax({
        method: "PUT",
        url: "api/UserSecurity/" + this.selectedUser + "/Clients",
        data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(clients),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success() {
          successCallback();
        },
        error: function error() {
          console.error("Error on PUT (Clients) in saveSecurity2Data()");
          errorCallback();
        }
      });

      $.ajax({
        method: "PUT",
        url: "api/UserSecurity/" + this.selectedUser + "/Locations",
        data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.security2DialogData.dataLists.permittedLocations),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success() {
          successCallback();
        },
        error: function error() {
          console.error("Error on PUT (Locations) in saveSecurity2Data()");
          errorCallback();
        }
      });

      var clientSettingsData = this.getClientSettingsPutData();
      $.ajax({
        method: "PUT",
        url: "api/UserSecurity/" + this.selectedUser + "/Projects",
        data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(clientSettingsData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success() {
          successCallback();
        },
        error: function error() {
          console.error("Error on PUT (Client Settings) in saveSecurity2Data()");
          errorCallback();
        }
      });
    },
    getClientSettingsPutData: function getClientSettingsPutData() {
      var projects = this.security2DialogData.dataLists.clientSetting;
      var visibleProjects = [],
          visibleWaves = [];

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(projects), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var project = _step3.value;

          if (project.Forbidden) visibleProjects.push(project.ProjectGuid);else if (project.Waves) {
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
              for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(project.Waves), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                var _wave = _step4.value;

                if (_wave.Forbidden) visibleWaves.push(_wave.WaveGuid);
              }
            } catch (err) {
              _didIteratorError4 = true;
              _iteratorError4 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                  _iterator4.return();
                }
              } finally {
                if (_didIteratorError4) {
                  throw _iteratorError4;
                }
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return { Projects: visibleProjects, Waves: visibleWaves };
    },
    hasForbiddenWaves: function hasForbiddenWaves(project) {
      if (!project || project.Forbidden || !project.Waves) return false;
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(project.Waves), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var wave = _step5.value;
          if (wave.Forbidden) return true;
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      return false;
    },

    // Opens the editUser dialog after dialog data received
    editUserDialogDataReceived: function editUserDialogDataReceived() {
      $("#editUser").modal("show");
    },

    // Fills the editUser dialog with data, depending on the dialog mode.
    // Available modes: "create" --> New user is created, default values are set
    //                  "edit" --> Edit existing user, catch values from server
    openEditUserDialog: function openEditUserDialog(mode) {
      var _this15 = this;

      if (mode == "create") {
        this.editUserDialogData.dialogTitle = this.lang.S0052;
        this.editUserDialogData.dialogType = "create";
        this.editUserDialogData.userData.UserTypeId = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.userTypeList)[0] || "";
        delete this.editUserDialogData.userData.SecurityRoleId;
        delete this.editUserDialogData.userData.UserId;
        delete this.editUserDialogData.userData.LoginName;
        delete this.editUserDialogData.userData.Password;
        delete this.editUserDialogData.userData.FirstName;
        delete this.editUserDialogData.userData.LastName;
        delete this.editUserDialogData.userData.CompanyName;
        delete this.editUserDialogData.userData.Gender;
        delete this.editUserDialogData.userData.AgencyGuid;
        delete this.editUserDialogData.userData.ClientId;
        delete this.editUserDialogData.userData.Address1;
        delete this.editUserDialogData.userData.Address2;
        delete this.editUserDialogData.userData.City;
        delete this.editUserDialogData.userData.Region;
        delete this.editUserDialogData.userData.Country;
        delete this.editUserDialogData.userData.PostalCode;
        delete this.editUserDialogData.userData.PhoneHome;
        delete this.editUserDialogData.userData.PhoneWork;
        delete this.editUserDialogData.userData.PhoneMobile;
        delete this.editUserDialogData.userData.Fax;
        delete this.editUserDialogData.userData.Email;
        delete this.editUserDialogData.userData.TimeZone;
        this.editUserDialogData.userData.Active = "true";
        delete this.editUserDialogData.userData.LanguageCode;
        // this.editUserDialogData.userData.DateRegistered = "";
        delete this.editUserDialogData.userData.DefaultWelcomePage;
        delete this.editUserDialogData.userData.GeographyFromGeocoding_Lat;
        delete this.editUserDialogData.userData.GeographyFromGeocoding_Long;
        delete this.editUserDialogData.userData.GeographyFromPostalCode_Lat;
        delete this.editUserDialogData.userData.GeographyFromPostalCode_Long;
        delete this.editUserDialogData.userData.DistanceUnit;
        this.changedCountry("");
        $("#editUser").modal("show");
      } else if (mode == "edit") {
        this.editUserDialogData.dialogTitle = this.lang.S0053;
        this.editUserDialogData.dialogType = "edit";
        this.editUserDialogData.userData = {};

        $.ajax({
          method: "GET",
          url: "api/SecurityUsers/" + this.selectedUser,
          success: function success(data) {
            _this15.editUserDialogDataReceived();
            if (_this15.copyUser) {
              delete data.LoginName;
            }
            _this15.editUserDialogData.userData = data; // Store response data from server
            _this15.changedCountry(_this15.editUserDialogData.userData.Country); // Load region dropdown depending on the selected country
          },
          error: function error() {
            console.error("User data access failed in openEditUserDialog()");
            _this15.globals.showErrorSnackbar("User data access failed");
          }
        });
      } else {
        // Wrong mode
        console.error("Wrong user dialog mode in openEditUserDialog()");
        $("#editUser").modal("hide");
        return false;
      }
      this.editUserDialogData.showAlert = false;
      this.resetValidationErrors("editUser");
      return true; // Mode was ok
    },

    // Catch client list
    getClientList: function getClientList() {
      var _this16 = this;

      $.ajax({
        method: "GET",
        url: "api/Data/Clients",
        success: function success(data) {
          _this16.clientList = [];
          for (var x in data) {
            _this16.clientList.push({ ClientId: x, ClientName: data[x] });
          }

          _this16.clientList.sort(function (a, b) {
            // Sort clients by name
            if (a.ClientName.toLowerCase() < b.ClientName.toLowerCase()) return -1;
            if (a.ClientName.toLowerCase() > b.ClientName.toLowerCase()) return 1;
            return 0;
          });
        },
        error: function error() {
          console.error("Client data access failed in getClientList()");
          _this16.globals.showErrorSnackbar("Client data access failed");
        }
      });
    },

    // Catches data for dropdown lists from server
    getEditUserDialogSelectData: function getEditUserDialogSelectData() {
      var _this17 = this;

      this.globals.getCountryList();
      this.globals.getRegionsList(function (callbackData) {
        _this17.regionList = callbackData;
      });
      this.globals.getLanguageList(function (callbackData) {
        _this17.languageList = callbackData;
      });
      if (this.globals.selectedLanguage) this.globals.getUserTypeList(function (callbackData) {
        _this17.userTypeList = callbackData;
      });
      this.globals.getSecurityRoleList(function (callbackData) {
        _this17.securityRoleList = callbackData;
      });
      this.globals.getTimezonesList(function (callbackData) {
        _this17.timeZones = callbackData;
      });
      this.globals.getDistanceUnitList(function (callbackData) {
        _this17.distanceUnits = callbackData;
      });
      this.globals.getAgencyList(function (callbackData) {
        _this17.agencyList = callbackData;
      });
      this.getClientList();
      this.globals.getClientList(function (data) {
        _this17.clientListWithGuid = data;
      });
    },

    // Sends the data from editUser dialog to the server to store it in the database
    saveEditUserDialogData: function saveEditUserDialogData() {
      var _this18 = this;

      if (this.feature.isAudiTarget && this.editUserDialogData.userData.UserTypeId == 999 && this.clientList[0] && this.clientList[0].ClientId) this.editUserDialogData.userData.ClientId = this.clientList[0].ClientId;

      if (this.editUserDialogData.dialogType == "create" || this.copyUser) {
        // copy user
        if (this.copyUser) {
          this.editUserDialogData.userData.IsCopyOf = this.editUserDialogData.userData.UserId;
          delete this.editUserDialogData.userData.UserId;
        }
        // Create new user
        $.ajax({
          method: "POST",
          url: "api/SecurityUsers",
          data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.editUserDialogData.userData),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            if (data.Error) {
              _this18.globals.showErrorSnackbar(data.Error);
              console.error(data.Error);
              return;
            }
            // If POST was successful, refresh displayed data and hide dialog
            _this18.globals.showSuccessSnackbar("User creation successful");
            _this18.getUserData();
            _this18.selectedUser = data[0].UserId;
            $("#editUser").modal("hide");
            _this18.copyUser = false;
          },
          error: function error() {
            console.error("Error on POST in saveEditUserDialogData()");
            _this18.globals.showErrorSnackbar("User creation failed");
          }
        });
      } else if (this.editUserDialogData.dialogType == "edit") {
        // Update existing user
        $.ajax({
          method: "PUT",
          url: "api/SecurityUsers/" + this.editUserDialogData.userData.UserId,
          data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.editUserDialogData.userData),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            // If PUT was successful, refresh displayed data and hide dialog
            _this18.globals.showSuccessSnackbar("User update successful");
            _this18.getUserData();
            $("#editUser").modal("hide");
          },
          error: function error() {
            console.error("Error on PUT in saveEditUserDialogData()");
            _this18.globals.showErrorSnackbar("User update failed");
          }
        });
      } else console.error("Wrong user dialog mode");
    },

    // Calculates the sort order for the given column and refreshes the displayed data
    sortUserData: function sortUserData(field) {
      if (field == this.sortField) {
        this.sortOrder == "asc" ? this.sortOrder = "desc" : this.sortOrder = "asc";
      } else {
        this.sortField = field;
        this.sortOrder = "asc";
      }
      this.selectedPage = 1;
      this.getUserData();
    },

    // Catches user data for the table from the server, including current filter, pagination and sort settings
    getUserData: function getUserData() {
      var _this19 = this;

      this.refreshEnabled = false; // Disable refresh, so it can not be triggered again until the server responded

      var getString = "api/SecurityUsers/Get?page_size=" + this.pageSize + "&page=" + this.selectedPage + "&sort_column=" + this.sortField + "&sort_order=" + this.sortOrder;
      getString = encodeURI(getString);

      var filter = _.pickBy(this.filterStrings, function (value, key) {
        if (key === "Active" && value < 2) return true;
        return value.length > 0;
      });
      if (typeof filter.Active === "number") filter.Active = !!filter.Active;

      $.ajax({
        method: "POST",
        url: getString,
        data: _.isEmpty(filter) ? "" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({ Filter: filter }),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          _this19.userData = data[0].Users; // If GET was successful, store user data and page count from server
          _this19.pageCount = data[0].Page_Count;
          _this19.totalElementsCount = data[0].Count;

          if (_this19.selectedUser) {
            var selUser = _.find(_this19.userData, ["UserId", _this19.selectedUser]);
            if (selUser) _this19.selectedUserData = selUser;
          }
        },
        error: function error() {
          console.error("Error on POST in getUserData()");
          _this19.globals.showErrorSnackbar("User data request failed");
        },
        complete: function complete() {
          _this19.refreshEnabled = true;
        }
      });
    },

    // Updates the current pagesize and the selected pagenumber and triggers the refresh of the table
    updatePaging: function updatePaging(pageNumber, pageSize) {
      this.selectedPage = pageNumber || 1;
      if (pageSize != 0) this.pageSize = pageSize;
      this.getUserData();
    },
    exportUsers: function exportUsers() {
      var _this20 = this;

      var getString = "api/SecurityUsers/Export";

      // if (this.feature.isAudiTarget && this.clientList[0]) {
      //   this.exportUsersDialogData.UserTypeId = 4;
      //   this.exportUsersDialogData.ClientId = this.clientList[0].ClientId;
      // }

      // #1974 -- Fix for export UserTypeId == 4 || 999 needs client id (== 3)
      if (this.exportUsersDialogData.UserTypeId == 4 || this.exportUsersDialogData.UserTypeId == 999) {
        this.exportUsersDialogData.ClientId = this.clientList[0].ClientId;
      }
      if (this.exportUsersDialogData.UserTypeId) {
        getString += "?userTypeId=" + this.exportUsersDialogData.UserTypeId;
        if ((this.exportUsersDialogData.UserTypeId == 4 || this.exportUsersDialogData.UserTypeId == 999) && this.exportUsersDialogData.ClientId) getString += "&clientId=" + this.exportUsersDialogData.ClientId;
        if (this.exportUsersDialogData.UserTypeId == 2 && this.exportUsersDialogData.AgencyId) getString += "&agencyId=" + this.exportUsersDialogData.AgencyId;
      }

      var filter = _.pickBy(this.filterStrings, function (value, key) {
        if (key === "Active" && value < 2) return true;
        return value.length > 0;
      });
      if (typeof filter.Active === "number") filter.Active = !!filter.Active;

      getString = encodeURI(getString);

      $.ajax({
        method: "POST",
        url: getString,
        data: _.isEmpty(filter) ? "" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({ Filter: filter }),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.length > 0 && data[0].DownloadId) _this20.globals.downloadFile(data[0].DownloadId);
        },
        error: function error(data) {
          console.error("Error on POST in exportUsers()");
          _this20.globals.showErrorSnackbar("Users export failed");
        }
      });
    },

    // Returns a range of numbers with min-value, max-value and stepsize
    getRange: function getRange(min, max, step) {
      var range = [],
          j = 0;
      for (var i = min; i <= max; i += step) {
        range[j++] = i;
      }
      return range;
    },

    // Returns a list of all pagenumbers that should be visible depending on the current page and the count of pages
    getVisiblePages: function getVisiblePages() {
      if (this.pageCount <= 7) {
        return this.getRange(1, this.pageCount, 1);
      } else if (this.pageCount > 7 && this.selectedPage <= 4) {
        return this.getRange(1, 6, 1);
      } else if (this.pageCount > 7 && this.selectedPage >= this.pageCount - 3) {
        return this.getRange(this.pageCount - 5, this.pageCount, 1);
      } else {
        return this.getRange(this.selectedPage - 2, this.selectedPage + 2, 1);
      }
    },

    // open change password dialog
    openChangePasswordDialog: function openChangePasswordDialog() {
      this.showChangePasswordDialog = true;
    },
    onChangePasswordDialogClosed: function onChangePasswordDialogClosed() {
      this.showChangePasswordDialog = false;
    }
  },
  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      var _this21 = this;

      this.globals.getLanguageStrings(this);
      this.globals.getUserTypeList(function (callbackData) {
        _this21.userTypeList = callbackData;
      });
      this.getUserData();
    },
    selectedSecurity2Page: function selectedSecurity2Page(newValue) {
      if (newValue === "locations2Tab") $("#security2Dialog > .modal-dialog").css("width", "80vw");else $("#security2Dialog > .modal-dialog").css("width", "50vw");
    },

    "securityDialogData.groupManagement.selectedGroupData": {
      handler: function handler(newValue, oldValue) {
        if (_.isEmpty(newValue)) {
          this.securityDialogData.groupManagement.isSelectedGroupDirty = false;
          return;
        }
        if (newValue.GroupGuid === oldValue.GroupGuid) this.securityDialogData.groupManagement.isSelectedGroupDirty = true;else this.securityDialogData.groupManagement.isSelectedGroupDirty = false;
      },

      deep: true
    }
  },
  data: function data() {
    // Global data inside the component is stored here
    return {
      selectedSecurity2Page: "clientSettings2Tab",
      selectedUser: "", // GUID of the selected user
      selectedUserData: {},
      pageSize: 20, // Number of users on one page of the table
      selectedPage: 1, // Number of the page, that is visible
      pageCount: 0, // Count of available pages depending on the pagesize and the data
      totalElementsCount: 0,
      showImportUsersDialog: false,
      filterStrings: {
        // Strings that are manipulated by the user for filtering the table
        Search: "",
        UserType: "",
        SecurityRole: "",
        Active: 2, // 0 = inactive, 1 = active, 2 = all
        Company: "",
        LoginName: "",
        FirstName: "",
        LastName: "",
        Gender: "",
        City: "",
        Region: "",
        Country: "",
        Email: ""
      },
      sortField: "LoginName", // Selected column for sorting
      sortOrder: "asc", // Should be "asc" or "desc"
      refreshEnabled: false, // false, if user data is requested and server did not respond yet to avoid multiple requests at the same time
      userData: [], // Stores the user data on the current page
      timeZones: [], // List of available timezones
      userTypeList: [], // List of available usertypes
      securityRoleList: [], // List of available SecurityRoles
      languageList: [], // List of available languages for the user
      regionList: [], // List of all available regions
      agencyList: [], // List of all agencies
      clientList: [],
      clientListWithGuid: [],
      targetGroups: {},
      distanceUnits: {},
      editUserDialogData: {
        // Data for the editUser dialog
        dialogType: "", // Should be "create" or "edit"
        dialogTitle: "", // Title of the dialog
        userData: {}, // The user data of the selected user is stored here
        currentRegions: [], // List of regions in the selected country
        currentTimeZones: [],
        showAlert: false // true --> Alert for validation errors is visible
      },
      securityDialogData: {
        // Data for the securityDialog
        dataLists: {
          // Stores information about roles, security groups and custom groups
          roleData: [],
          securityGroupData: [],
          customGroupData: []
        },
        assignedGroupGuids: [], // Stores IDs of all groups that are assigned to the selected user
        selectedAssignedGroupGuids: [], // Stores selected assigned groups in the dialog
        selectedUnassignedGroupGuids: [], // Stores selected unassigned groups in the dialog
        groupManagement: {
          // Stores temporary data for the group management tab
          selectedGroup: "",
          selectedGroupData: {},
          isSelectedGroupDirty: false
        }
      },
      security2DialogData: {
        selectedClient: "",
        showTop100LocationsOnly: true,
        hasAccessToAllLocations: false,
        locationFilterStrings: {
          LocationStoreId: "",
          LocationName: "",
          LocationAddress: "",
          LocationCountry: "",
          LocationStatusId: "",
          LocationVisible: 2
        },
        dataLists: {
          clientSetting: [],
          selectedClients: [],
          locationProperties: [],
          locations: [],
          filteredLocations: [],
          permittedLocations: []
        }
      },
      invalidInputIds: [], // IDs of inputs with validation error
      deleteUserDialogData: {},
      showExportDialog: false,
      exportUsersDialogData: {},
      lang: {
        // Contains localization strings for the selected language
        S0000: "Aktualisieren",
        S0001: "Neuer Benutzer",
        S0002: "Bearbeiten",
        S0003: "Groups",
        S0004: "Suche...",
        S0005: "Elemente pro Seite",
        S0006: "Erste Seite",
        S0007: "Letzte Seite",
        S0008: "Benutzer-ID",
        S0009: "Typ",
        S0010: "Benutzername",
        S0011: "Vorname",
        S0012: "Nachname",
        S0013: "Geschlecht",
        S0014: "Stadt",
        S0015: "Region",
        S0016: "Land",
        S0017: "E-Mail",
        S0018: "Filter",
        S0019: "Allgemein",
        S0020: "Benutzername",
        S0021: "Kennwort",
        S0022: "Vorname",
        S0023: "Nachname",
        S0024: "Firmenname",
        S0025: "Geschlecht",
        S0026: "männlich",
        S0027: "weiblich",
        S0028: "Benutzersprache",
        S0029: "Zeitzone",
        S0030: "Startseite",
        S0031: "Beispiel",
        S0032: "Nicht verwenden",
        S0033: "Account Status",
        S0034: "Aktiviert",
        S0035: "Deaktiviert",
        S0036: "Kontakt",
        S0037: "Straße",
        S0038: "Adresszusatz",
        S0039: "Stadt",
        S0040: "Region",
        S0041: "Bitte auswählen...",
        S0042: "Land",
        S0043: "PLZ",
        S0044: "Telefon privat",
        S0045: "Telefon geschäftlich",
        S0046: "Telefon mobil",
        S0047: "Fax",
        S0048: "E-Mail",
        S0049: "Ihre Eingaben sind fehlerhaft. Bitte prüfen Sie alle rot markierten Felder!",
        S0050: "Abbrechen",
        S0051: "Speichern",
        S0052: "Neuer Benutzer",
        S0053: "Benutzer bearbeiten",
        S0054: "Group Security",
        S0055: "Systemgruppen",
        S0056: "Sicherheitsgruppen",
        S0057: "Benutzerdefinierte Gruppen",
        S0058: "Verfügbare Gruppen",
        S0059: "Zugeordnete Gruppen",
        S0060: "Abbrechen",
        S0061: "Speichern",
        S0062: "Passwort",
        S0063: "Kundenrichtlinien",
        S0064: "Gruppenverwaltung",
        S0065: "Kunden",
        S0066: "Richtlinien",
        S0067: "Kunden/ Standort Administration",
        S0068: "Fragebogen erstellen",
        S0069: "Projektplanung",
        S0070: "Zuweisung Management",
        S0071: "Eingereichte Fragebogen Manager",
        S0072: "Kunden Reporting",
        S0073: "Nicht zugewiesen",
        S0074: "Ansicht",
        S0075: "Bearbeiten",
        S0076: "Alle Kunden auswählen",
        S0077: "Auswahl aufheben",
        S0078: "Verfügbare Gruppen",
        S0079: "Gruppen bearbeiten",
        S0080: "Gruppenname",
        S0081: "Beschreibung",
        S0082: "Speichern",
        S0083: "Löschen",
        S0084: "Passwort zurücksetzen",
        S0085: "Neues Passwort",
        S0086: "Neues Passwort wiederholen",
        S0087: "Konto entsperren",
        S0088: "Die eingegebenen Passwörter stimmen nicht überein!",
        S0089: "Abbrechen",
        S0090: "Speichern",
        S0091: "Nicht zugewiesen",
        S0092: "Ansicht",
        S0093: "Bearbeiten",
        S0095: "Diese Angabe ist erforderlich!",
        S0096: "Dies ist keine gültige Telefonnummer!",
        S0097: "Dies ist keine gültige Faxnummer!",
        S0098: "Dies ist keine gültige E-Mail Adresse!",
        S0099: "Benutzer löschen",
        S0100: "Soll folgender Benutzer wirklich gelöscht werden?",
        S0101: "Ja",
        S0102: "Nein",
        S0103: "Anzeigen",
        S0104: "Bearbeiten",
        S0105: "Standortrichtlinien",
        S0106: "Benutzereigenschaftenrichtlinien",
        S0107: "Fragebogenrichtlinien",
        S0108: "Standort",
        S0109: "Genehmigt",
        S0110: "Nicht genehmigt",
        S0111: "Kunde",
        S0112: "Bitte auswählen",
        S0113: "Benutzereigenschaft",
        S0114: "Wert der Benutzereigenschaft",
        S0115: "Fragebogen",
        S0116: "Agentur",
        S0117: "Breitengrad aus Geokodierung",
        S0118: "Längengrad aus Geokodierung",
        S0119: "Breitengrad aus PLZ",
        S0120: "Längengrad aus PLZ",
        S0121: "Entfernungseinheit",
        S0122: "Ungültiger Wert",
        S0123: "Projekte",
        S0124: "Projekt",
        S0125: "Projektwellen",
        S0126: "Reporting Features",
        S0127: "Check Explorer",
        S0128: "Media Explorer",
        S0129: "Raw Data",
        S0130: "Frequencies",
        S0131: "Aggregated Reports",
        S0132: "Fragen",
        S0133: "Security Role",
        S0134: "Export",
        S0135: "Import",
        S0138: "User Security",
        S0139: "Client Settings",
        S0140: "Location Properties",
        S0141: "Locations",
        S0142: "Reporting Features",
        S0143: "Questions",
        S0144: "Visibility",
        S0145: "Client Level",
        S0146: "Copy User",
        S0147: "Auto next Wave",
        S0148: "Passwortrichtlinien",
        S0149: "Buchstaben",
        S0150: "Großbuchstabe(n)",
        S0151: "Kleinbuchstabe(n)",
        S0152: "Ziffer(n)",
        S0153: "Sonderzeiche(n)",
        S0154: "mindestens",
        S0155: "Client Selection",
        S0156: "Client Level (select all levels)",
        S0157: "Scenarios",
        S0158: "Please select clients in Client Selection tab first.",
        S0159: "New",
        S0160: "Company",
        S0161: "Security",
        S0162: "Permitted",
        S0163: "Active",
        S0164: "Close",
        S0165: "Project Level",
        S0166: "StoreID",
        S0167: "Status",
        S0168: "Address",
        S0169: "Name",
        S0170: "Location Property",
        S0171: "Location Property Values",
        S0172: "Visible",
        S0173: "Show only top 100 locations",
        S0174: "Projectname",
        S0175: "Hide",
        S0176: "No waves available for this project",
        S0177: "Wavename",
        S0178: "User",
        S0179: "Country",
        S0180: "Export Users",
        S0181: "Download",
        S0182: "Cancel",
        S0183: "User Type",
        S0184: "Please select an user type...",
        S0185: "Client",
        S0186: "Please select a client...",
        S0187: "Partner",
        S0188: "Please select a partner...",
        S0189: "Grant access to all locations",
        S0190: "Access to all locations granted",
        S0191: "Reporting Group",
        S0192: "Delete Security Group",
        S0193: "Do you really want to delete the following group?",
        S0194: "Groupname",
        S0195: "Client selection is required for reporting groups.",
        S0196: "Reporting settings are needed for the client. Please contact the support!",
        S0197: "Target group",
        S0198: "Target group already in use",
        S0199: "This target group is already assigned to another security group. If you save the current group, the target groups will be swapped.",
        S0200: "Total users count"
      },
      copyUser: false,
      showChangePasswordDialog: false
    };
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__riophae_vue_treeselect_dist_vue_treeselect_min_css__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__riophae_vue_treeselect_dist_vue_treeselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__riophae_vue_treeselect_dist_vue_treeselect_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_policiesmixin__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_usermanagement_css__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_usermanagement_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_usermanagement_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "CustomPropertiesPoliciesControl",
  data: function data() {
    return {
      customPropertyValuePairs: []
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_policiesmixin__["a" /* default */]],
  props: {
    user: {
      type: Object
      // required: true
    },
    lang: {
      type: Object,
      required: true
    },
    selectedClient: {
      type: String
      // required: true
    }
  },
  methods: {
    togglePermitted: function togglePermitted(item) {
      if (!item.LocationPropertyValues) return;
      if (item.SelectedItems.length === item.LocationPropertyValues.length) {
        item.SelectedItems = [];
        return;
      } else {
        item.LocationPropertyValues.forEach(function (element) {
          item.SelectedItems.push(element.id);
        });
      }
    },
    getPropertySubItems: function getPropertySubItems(property) {
      if (!property.LocationPropertyValues) return [];
      return property.LocationPropertyValues;
    },
    getSelectedSubItems: function getSelectedSubItems(items) {
      var result = [];
      if (!items || items.length < 1) return result;
      items.forEach(function (element) {
        if (!element.LocationPropertyValues) return;
        var el = {
          LocationPropertyGuid: element.LocationPropertyGuid,
          LocationPropertyValues: []
        };
        element.LocationPropertyValues.forEach(function (subElement) {
          if (_.includes(element.SelectedItems, subElement.id)) {
            el.LocationPropertyValues.push(subElement.label);
          }
        });
        if (el.LocationPropertyValues.length > 0) result.push(el);
      });
      return result;
    },
    saveChanges: function saveChanges(successCallback, errorCallback) {
      var itms = this.getSelectedSubItems(this.customPropertyValuePairs);
      var url = "api/UserSecurity/" + this.user.UserId + "/LocationProperties";
      this.putItems(this, url, itms, "CustomPropertyPolicies", successCallback, errorCallback);
    },
    convertToTreeselectData: function convertToTreeselectData(_data) {
      _.forEach(_data, function (item) {
        var selected = [];
        var nr = 0;
        _.forEach(item.LocationPropertyValues, function (val) {
          val.id = nr++;
          if (val.Permitted) selected.push(val.id);
          val.label = val.LocationPropertyValue;
          delete val.LocationPropertyValue;
        });
        item.SelectedItems = selected;
      });
      return _data;
    },
    loadPolicies: function loadPolicies(successCallback, errorCallback) {
      var _this = this;

      if (!this.selectedClient) return;
      this.customPropertyValuePairs = [];
      var url = "api/UserSecurity/" + this.user.UserId + "/LocationProperties/Client/" + this.selectedClient;

      $.ajax({
        method: "GET",
        url: url,
        success: function success(data) {
          _this.customPropertyValuePairs = _.isEmpty(data) ? [] : _this.convertToTreeselectData(data);
          successCallback();
        },
        error: function error() {
          console.error("Data access failed in CustomPropertiesPoliciesControl.loadPolicies()");
          errorCallback();
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_policiesmixin__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_usermanagement_css__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_usermanagement_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_usermanagement_css__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "settingsPoliciesControl",
  data: function data() {
    return {
      settings: []
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_policiesmixin__["a" /* default */]],
  props: ["user", "lang"],
  methods: {
    toggleAll: function toggleAll() {
      this.togglePermission(this.settings);
    },
    togglePermission: function togglePermission(_items) {
      var selected = _.takeWhile(_items, ["Permitted", true]);
      if (selected.length !== _items.length) _.forEach(_items, function (itm) {
        itm.Permitted = true;
      });else _.forEach(_items, function (itm) {
        itm.Permitted = false;
      });
    },
    saveChanges: function saveChanges(successCallback, errorCallback) {
      var featureList = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.settings), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var feature = _step.value;

          if (feature.Permitted) featureList.push(feature.ReportingFeatureGuid);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.putItems(this, this.getServiceUrl(), featureList, "settingsPolicies", successCallback, errorCallback);
    },
    getServiceUrl: function getServiceUrl() {
      return "api/UserSecurity/" + this.user.UserId + "/ReportingFeatures";
    },
    getUnifiedId: function getUnifiedId(_data) {
      _.forEach(_data, function (item) {
        item.id = item.settingId;
      });
      return _data;
    },
    loadPolicies: function loadPolicies(successCallback, errorCallback) {
      var _this = this;

      this.settings = [];

      $.ajax({
        method: "GET",
        url: this.getServiceUrl(),
        success: function success(data) {
          _this.settings = _this.getUnifiedId(data);
          successCallback();
        },
        error: function error() {
          console.error("Data access failed in settingsPoliciesControl.loadPolicies()");
          errorCallback();
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__riophae_vue_treeselect_dist_vue_treeselect_min_css__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__riophae_vue_treeselect_dist_vue_treeselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__riophae_vue_treeselect_dist_vue_treeselect_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_policiesmixin__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_usermanagement_css__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_usermanagement_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_usermanagement_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "SurveysQuestionsPoliciesControl",
  data: function data() {
    return {
      surveys: [],
      actualClient: -1
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_policiesmixin__["a" /* default */]],
  props: {
    user: Object,
    lang: Object,
    clients: Array
  },
  methods: {
    togglePermitted: function togglePermitted(item) {
      if (!item.surveysQuestions) return;
      if (item.SelectedItems.length === item.surveysQuestions.length) {
        item.SelectedItems = [];
        return;
      } else {
        item.surveysQuestions.forEach(function (element) {
          item.SelectedItems.push(element.waveId);
        });
      }
    },

    getPropertySubItems: function getPropertySubItems(property) {
      if (!property.surveysQuestions) return [];
      return property.surveysQuestions;
    },
    getSelectedSubItems: function getSelectedSubItems(items) {
      var result = [];
      if (!(items.length > 0)) return result;
      items.forEach(function (element) {
        result = result.concat(element.SelectedItems);
      });
      return result;
    },
    saveChanges: function saveChanges() {
      var itms = this.getSelectedSubItems(this.surveys);
      this.putItems(this, this.getServiceUrl(this), itms, "SurveysQuestionsPolicies");
    },
    getServiceUrl: function getServiceUrl(_this) {
      return "api/SurveysQuestionsPolicies/" + _this.user.UserId + "/" + _this.actualClient;
    },
    getUnifiedId: function getUnifiedId(_data) {
      _.forEach(_data, function (item) {
        var selected = [];
        _.forEach(item.surveysQuestions, function (val) {
          if (val.P === true) selected.push(val.id);
        });
        item.SelectedItems = selected;
      });
      return _data;
    },
    loadPolicies: function loadPolicies() {
      if (!this.actualClient || this.actualClient == -1) return;
      var _this = this;
      _this.surveys = [];

      $.ajax({
        method: "GET",
        url: _this.getServiceUrl(_this),
        success: function success(data) {
          _this.surveys = _this.getUnifiedId(data);
        },
        error: function error() {
          console.error("Data access failed in SurveysQuestionsPoliciesControl.loadPolicies()");
        },
        complete: function complete() {
          _this.$root.$emit("measureScreenRequested", "");
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Tools_Dialogs_ChangePasswordDialog__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Tools_Dialogs_ChangePasswordDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Tools_Dialogs_ChangePasswordDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tools_Select2__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Tools_Select2__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "UserSettings",
  components: { Select2: __WEBPACK_IMPORTED_MODULE_1__Tools_Select2___default.a, ChangePasswordDialog: __WEBPACK_IMPORTED_MODULE_0__components_Tools_Dialogs_ChangePasswordDialog___default.a },
  data: function data() {
    return {
      showChangePasswordDialog: false,
      loginAsUserId: "",
      userList: [],
      lang: {
        US0000: "Password",
        US0001: "Change Password",
        US0002: "Filter",
        US0003: "Remember filter settings",
        US0004: "Tables remember their own filters and sort orders.",
        US0005: "Synchronize filter settings",
        US0006: "If possible, filter settings will be synchronized between several components of the application.",
        US0007: "Reset all filters",
        US0008: "Login as",
        US0009: "Leave session",
        US0010: "Please select a user...",
        US0011: "Login",
        US0012: "Login as user failed",
        US0013: "Leaving session failed"
      }
    };
  },

  computed: {
    rememberFilters: {
      get: function get() {
        return this.$store.getters["userSettings/rememberFilters"];
      },
      set: function set(value) {
        this.$store.commit("userSettings/rememberFilters", value);
      }
    },
    syncFilters: {
      get: function get() {
        return this.$store.getters["userSettings/syncFilters"];
      },
      set: function set(value) {
        this.$store.commit("userSettings/syncFilters", value);
      }
    }
  },
  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.globals.getLanguageStrings(this);

    if (this.globals.currentUserRole < 0) {
      this.globals.$on("currentUserInfoReceived", function () {
        _this.globals.getUserList(function (data) {
          _this.userList = data;
        });
      });
    } else if (this.globals.currentUserRole === 1) this.globals.getUserList(function (data) {
      _this.userList = data;
    });
  },

  methods: {
    clearFilters: function clearFilters() {
      this.clearSharedFilters();
      this.clearLocalFilters();
    },
    clearSharedFilters: function clearSharedFilters() {
      this.$store.commit("sharedFilters/clearAll");
    },
    clearLocalFilters: function clearLocalFilters() {
      this.$store.commit("localFilters/clearAll");
    },
    requestLoginAs: function requestLoginAs() {
      var _this2 = this;

      if (!this.loginAsUserId) return;

      $.ajax({
        method: "GET",
        url: "api/SecurityUsers/LoginAs/" + this.loginAsUserId,
        // dataType: "json",
        // contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            _this2.globals.showErrorSnackbar(data.Error);
            console.error(data.Error);
            return;
          }
          _this2.globals.showSpinner(true);
          _this2.$nextTick(function () {
            location.reload();
          });
        },
        error: function error(_error) {
          console.error("Error on GET in requestLoginAs()");
          _this2.globals.showErrorSnackbar(_this2.lang.US0012);
        }
      });
    },
    leaveLoginAsSession: function leaveLoginAsSession() {
      var _this3 = this;

      $.ajax({
        method: "GET",
        url: "api/SecurityUsers/LogoutAs",
        // dataType: "json",
        // contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            _this3.globals.showErrorSnackbar(data.Error);
            console.error(data.Error);
            return;
          }
          _this3.globals.showSpinner(true);
          _this3.$nextTick(function () {
            location.reload();
          });
        },
        error: function error(_error2) {
          console.error("Error on GET in leaveLoginAsSession()");
          _this3.globals.showErrorSnackbar(_this3.lang.US0013);
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Audi_Step1_vue__ = __webpack_require__(1636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Audi_Step1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Audi_Step1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Audi_Step2_vue__ = __webpack_require__(1637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Audi_Step2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Audi_Step2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Audi_Step3_vue__ = __webpack_require__(1638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Audi_Step3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Audi_Step3_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Audi_Step4_vue__ = __webpack_require__(1639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Audi_Step4_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Audi_Step4_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Audi_Step5_vue__ = __webpack_require__(1640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Audi_Step5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Audi_Step5_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Audi_Step6_vue__ = __webpack_require__(1641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Audi_Step6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Audi_Step6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Audi_Step7_vue__ = __webpack_require__(1642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Audi_Step7_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__Audi_Step7_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Audi_Step8_vue__ = __webpack_require__(1643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Audi_Step8_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__Audi_Step8_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_WizardService__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Tools_Dialogs_ConfirmationDialog__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Tools_Dialogs_ConfirmationDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__Tools_Dialogs_ConfirmationDialog__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Import Step Components











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AppWizard',
  components: {
    Step1: __WEBPACK_IMPORTED_MODULE_4__Audi_Step1_vue___default.a, Step2: __WEBPACK_IMPORTED_MODULE_5__Audi_Step2_vue___default.a, Step3: __WEBPACK_IMPORTED_MODULE_6__Audi_Step3_vue___default.a, Step4: __WEBPACK_IMPORTED_MODULE_7__Audi_Step4_vue___default.a, Step5: __WEBPACK_IMPORTED_MODULE_8__Audi_Step5_vue___default.a, Step6: __WEBPACK_IMPORTED_MODULE_9__Audi_Step6_vue___default.a, Step7: __WEBPACK_IMPORTED_MODULE_10__Audi_Step7_vue___default.a, Step8: __WEBPACK_IMPORTED_MODULE_11__Audi_Step8_vue___default.a, ConfirmationDialog: __WEBPACK_IMPORTED_MODULE_13__Tools_Dialogs_ConfirmationDialog___default.a
  },
  data: function data() {
    return {
      configurationGuid: null,
      currentStep: 0,
      formData: null,
      formData_template: {
        configurationGuid: null,
        title: null,

        projectGuid: null,
        surveyGuid: null,
        waveName: null,
        waveSince: null,
        waveUntil: null,
        wavePlannedSince: null,
        wavePlannedUntil: null,
        waveInfo: null,
        waveWithoutApproval: false,
        isLocalWave: false,

        importerGuid: null,
        agencyGuid: null,
        status: 'inprogress',
        scenarios: [],
        carModelDistribution: [],

        lastValidStep: 0
      },
      showFinishConfigConfirmationDialog: false,
      lang: {
        W00010: "Overview",
        W00011: "Definition",
        W00012: "Define the basic parameters for your mystery shopping wave. Specify the name, questionnaire, and importer. These settings form the basis for all further configuration steps.",
        W00030: "Scenario assignment",
        W00031: "Choose from available scenarios. Scenarios define the sequence and content of your mystery shopping tests. You can combine multiple scenarios for comprehensive analyses.",
        W00036: "Vehicles Audi",
        W00037: "Configure the Audi vehicle models for your wave. Define search criteria and distributions. The vehicle selection determines which models are included in your tests.",
        W00042: "Vehicles Competitor",
        W00043: "Add competitor vehicles for comparative analysis. Select relevant competitor models from different brands. This enables comprehensive market comparisons in your tests.",
        W00048: "Location configuration",
        W00049: "Configure Audi Center and test distributions. Define scenarios for each location and test numbers. The location configuration controls local implementation.",
        W00054: "Briefing",
        W00055: "Upload briefing documents and assign them. Define scenarios and languages for each file. The briefing informs your test customers about the process and objectives.",
        W00061: "Summary",
        W00062: "Review your configuration in the overview. Make any final adjustments and export your wave. The summary allows you to perform final checks before",
        W00067: "Back",
        W00068: "Next",
        W00069: "Close",
        W00070: "Send back",
        W00090: "Question selection",
        W00091: "Select questions from the available catalog. Configure translations and target languages. The selection of questions determines the content of your assessments.",
        W00092: "Do you want to finish the configuration?",
        W00093: "Finish",
        W00094: "Cancel"
      }
    };
  },

  computed: {
    currentStepComponent: function currentStepComponent() {
      return this.steps[this.currentStep].component || 'Step1';
    },
    readonly: function readonly() {
      var isReadonly = false;
      if (this.formData.status == "pending" && !this.globals.isAdminUser) isReadonly = true;
      if (this.formData.status == "finished") isReadonly = true;
      return isReadonly;
    },
    steps: function steps() {
      return [{
        name: this.lang.W00011,
        component: 'Step1',
        active: true,
        description: this.lang.W00012
      }, {
        name: this.lang.W00030,
        component: 'Step2',
        active: false,
        description: this.lang.W00031
      }, {
        name: this.lang.W00036,
        component: 'Step3',
        active: false,
        description: this.lang.W00037
      }, {
        name: this.lang.W00042,
        component: 'Step4',
        active: false,
        description: this.lang.W00043
      }, {
        name: this.lang.W00090,
        component: 'Step5',
        active: false,
        description: this.lang.W00091
      }, {
        name: this.lang.W00048,
        component: 'Step6',
        active: false,
        description: this.lang.W00049
      }, {
        name: this.lang.W00054,
        component: 'Step7',
        active: false,
        description: this.lang.W00055
      }, {
        name: this.lang.W00061,
        component: 'Step8',
        active: false,
        description: this.lang.W00062
      }];
    }
  },
  watch: {
    currentStep: function currentStep() {
      window.scrollTo(0, 0);
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var res, targetStep;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!_this.$route.params.configurationGuid) {
                _context.next = 11;
                break;
              }

              _this.configurationGuid = _this.$route.params.configurationGuid;

              if (!(_this.configurationGuid != 'new')) {
                _context.next = 10;
                break;
              }

              _context.next = 5;
              return __WEBPACK_IMPORTED_MODULE_12__services_WizardService__["a" /* default */].readConfiguration(_this.configurationGuid);

            case 5:
              res = _context.sent;

              _this.formData = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(structuredClone(_this.formData_template), res);

              if (_this.$route.params.step) {
                targetStep = Number(_this.$route.params.step);

                if (targetStep >= _this.steps.length) targetStep = 0;
                _this.currentStep = targetStep;
                _this.updateActiveStep();
              }
              _context.next = 11;
              break;

            case 10:
              _this.formData = structuredClone(_this.formData_template);

            case 11:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  mounted: function mounted() {
    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this);
    }
  },

  methods: {
    saveConfiguration: function saveConfiguration() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this2.readonly) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return', true);

              case 2:

                if (_this2.formData.configurationGuid == null) _this2.formData.configurationGuid = crypto.randomUUID();

                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_12__services_WizardService__["a" /* default */].saveConfiguration(_this2.formData);

              case 5:
                res = _context2.sent;

                if (!(res && res.Error)) {
                  _context2.next = 10;
                  break;
                }

                console.error("Error on POST in saveConfiguration().", res.Error);
                _this2.globals.showErrorSnackbar(res.Error);
                return _context2.abrupt('return', false);

              case 10:
                return _context2.abrupt('return', true);

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    updateFormData: function updateFormData(newFormData) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var normalize, changes, formDataReset, allowedIds, locations, brands, locationIds;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                normalize = function normalize(e) {
                  return (e || "").trim().toLowerCase();
                };

                changes = _this3.detectChange(newFormData, _this3.formData);

                if (!(!changes || _.isEmpty(changes))) {
                  _context3.next = 4;
                  break;
                }

                return _context3.abrupt('return');

              case 4:
                if (!changes["projectGuid"]) {
                  _context3.next = 22;
                  break;
                }

                formDataReset = structuredClone(_this3.formData_template);

                formDataReset.configurationGuid = newFormData.configurationGuid;
                formDataReset.status = newFormData.status;
                formDataReset.projectGuid = newFormData.projectGuid;
                formDataReset.createdAt = newFormData.createdAt;
                formDataReset.createdBy = newFormData.createdBy;

                formDataReset.title = _this3.formData.title;
                formDataReset.waveInfo = _this3.formData.waveInfo;
                formDataReset.waveName = _this3.formData.waveName;
                formDataReset.wavePlannedSince = _this3.formData.wavePlannedSince;
                formDataReset.wavePlannedUntil = _this3.formData.wavePlannedUntil;
                formDataReset.waveSince = _this3.formData.waveSince;
                formDataReset.waveUntil = _this3.formData.waveUntil;
                formDataReset.isLocalWave = _this3.formData.isLocalWave;
                formDataReset.waveWithoutApproval = _this3.formData.waveWithoutApproval;

                _this3.formData = formDataReset;
                return _context3.abrupt('return');

              case 22:

                if (changes["importerGuid"]) {
                  if (newFormData.visits) newFormData.visits = null;
                  if (newFormData.carModelDistribution) newFormData.carModelDistribution = null;
                  if (newFormData.competitorCarModelDistribution) newFormData.competitorCarModelDistribution = null;
                }

                if (changes["scenarios"]) {
                  if (newFormData.visits) {
                    allowedIds = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(newFormData.scenarios.map(function (s) {
                      return s.ScenarioId;
                    }));
                    // Return only visits with matching ScenarioId

                    newFormData.visits = newFormData.visits.filter(function (v) {
                      return allowedIds.has(v.ScenarioId);
                    });
                  }
                }

                if (!changes["competitorCarModelDistribution"]) {
                  _context3.next = 34;
                  break;
                }

                if (!newFormData.visits) {
                  _context3.next = 34;
                  break;
                }

                _context3.next = 28;
                return __WEBPACK_IMPORTED_MODULE_12__services_WizardService__["a" /* default */].readConfigurationLocations(newFormData.configurationGuid);

              case 28:
                locations = _context3.sent;


                // 2. filter locations to only contain competitor brands of selected competitor vehicles
                brands = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(newFormData.competitorCarModelDistribution.map(function (e) {
                  return normalize(e.CompetitorCarBrand);
                }));

                brands.add(normalize("Audi"));
                locations = locations.filter(function (e) {
                  return brands.has(normalize(e.Brand));
                });

                // 3. filter visits to contain only allowed locations
                locationIds = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(locations.map(function (e) {
                  return e.LocationId;
                }));

                newFormData.visits = newFormData.visits.filter(function (e) {
                  return locationIds.has(e.LocationId);
                });

              case 34:

                if (changes["visits"]) {
                  if (newFormData.visits) {
                    newFormData.visits = newFormData.visits.filter(function (v) {
                      return Number(v.NumberOfVisits) != 0;
                    });
                  }
                }

                _this3.formData = structuredClone(newFormData);

              case 36:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    detectChange: function detectChange(newVal, oldVal) {
      var changes = _.reduce(newVal, function (result, value, key) {
        if (!_.isEqual(value, oldVal[key])) {
          result[key] = { old: oldVal[key], new: value };
        }
        return result;
      }, {});

      return changes;
    },
    navigateToStep: function navigateToStep(index) {
      var _this4 = this;

      if (index > this.formData.lastValidStep) return;

      this.$nextTick(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var res, saved, _res;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                res = _this4.$refs.stepComponent.validateStep();

                if (!(_this4.formData.status == "finished")) {
                  _context4.next = 5;
                  break;
                }

                if (res.msg) _this4.globals.showErrorSnackbar(res.msg);
                // continue
                _context4.next = 13;
                break;

              case 5:
                if (!(!res.valid && index > _this4.currentStep)) {
                  _context4.next = 12;
                  break;
                }

                _this4.formData.lastValidStep = _this4.currentStep - 1;
                console.log("invalid step.");
                if (res.msg) _this4.globals.showErrorSnackbar(res.msg);
                return _context4.abrupt('return');

              case 12:
                if (!res.valid && index < _this4.currentStep) {
                  _this4.formData.lastValidStep = _this4.currentStep - 1;
                  console.log("invalid step.");
                  // if(res.msg) this.globals.showErrorSnackbar(res.msg);
                  // return;
                } else {
                  if (_this4.formData.lastValidStep < _this4.currentStep) _this4.formData.lastValidStep = _this4.currentStep;
                }

              case 13:
                if (!_this4.isStepAccessible(index)) {
                  _context4.next = 27;
                  break;
                }

                _context4.next = 16;
                return _this4.saveConfiguration();

              case 16:
                saved = _context4.sent;

                if (saved) {
                  _context4.next = 19;
                  break;
                }

                return _context4.abrupt('return');

              case 19:

                // push to route with configGuid, to prevent creation of new configs via reload of page
                if (_this4.$route.params.configurationGuid == 'new' && _this4.formData.configurationGuid) {
                  _this4.$router.push('/config/' + _this4.formData.configurationGuid + '/' + index);
                }

                _this4.currentStep = index;
                _this4.updateActiveStep();

                // fresh reload of formdata for last step

                if (!(saved && _this4.currentStep === _this4.steps.length - 1)) {
                  _context4.next = 27;
                  break;
                }

                _context4.next = 25;
                return __WEBPACK_IMPORTED_MODULE_12__services_WizardService__["a" /* default */].readConfiguration(_this4.formData.configurationGuid);

              case 25:
                _res = _context4.sent;

                _this4.formData = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(structuredClone(_this4.formData_template), _res);

              case 27:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      })));
    },
    nextStep: function nextStep() {
      var _this5 = this;

      this.$nextTick(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var res, saved, _res2;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                res = _this5.$refs.stepComponent.validateStep();

                if (!(_this5.formData.status == "finished")) {
                  _context5.next = 5;
                  break;
                }

                if (res.msg) _this5.globals.showErrorSnackbar(res.msg);
                // continue
                _context5.next = 9;
                break;

              case 5:
                if (res.valid) {
                  _context5.next = 9;
                  break;
                }

                console.log("invalid step.");
                if (res.msg) _this5.globals.showErrorSnackbar(res.msg);
                return _context5.abrupt('return');

              case 9:
                if (!(_this5.currentStep < _this5.steps.length - 1)) {
                  _context5.next = 24;
                  break;
                }

                if (_this5.formData.lastValidStep == _this5.currentStep - 1) _this5.formData.lastValidStep++;

                _context5.next = 13;
                return _this5.saveConfiguration();

              case 13:
                saved = _context5.sent;

                if (saved) {
                  _context5.next = 16;
                  break;
                }

                return _context5.abrupt('return');

              case 16:

                // push to route with configGuid, to prevent creation of new configs via reload of page
                if (_this5.$route.params.configurationGuid == 'new' && _this5.formData.configurationGuid) {
                  _this5.$router.push('/config/' + _this5.formData.configurationGuid + '/' + (_this5.currentStep + 1));
                }

                _this5.currentStep++;
                _this5.updateActiveStep();

                // fresh reload of formdata for last step

                if (!(saved && _this5.currentStep === _this5.steps.length - 1)) {
                  _context5.next = 24;
                  break;
                }

                _context5.next = 22;
                return __WEBPACK_IMPORTED_MODULE_12__services_WizardService__["a" /* default */].readConfiguration(_this5.formData.configurationGuid);

              case 22:
                _res2 = _context5.sent;

                _this5.formData = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(structuredClone(_this5.formData_template), _res2);

              case 24:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      })));
    },
    previousStep: function previousStep() {
      var _this6 = this;

      this.$nextTick(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var res, saved, _res3;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                res = _this6.$refs.stepComponent.validateStep();

                if (_this6.formData.status == "finished") {
                  // continue
                } else if (!res.valid) {
                  _this6.formData.lastValidStep = _this6.currentStep - 1;
                  console.log("invalid step.");
                  // if(res.msg) this.globals.showErrorSnackbar(res.msg);
                  // return;
                } else {
                  if (_this6.formData.lastValidStep < _this6.currentStep) _this6.formData.lastValidStep = _this6.currentStep;
                }

                if (!(_this6.currentStep > 0)) {
                  _context6.next = 16;
                  break;
                }

                _context6.next = 5;
                return _this6.saveConfiguration();

              case 5:
                saved = _context6.sent;

                if (saved) {
                  _context6.next = 8;
                  break;
                }

                return _context6.abrupt('return');

              case 8:

                // push to route with configGuid, to prevent creation of new configs via reload of page
                if (_this6.$route.params.configurationGuid == 'new' && _this6.formData.configurationGuid) {
                  _this6.$router.push('/config/' + _this6.formData.configurationGuid + '/' + (_this6.currentStep - 1));
                }

                _this6.currentStep--;
                _this6.updateActiveStep();

                // fresh reload of formdata for last step

                if (!(saved && _this6.currentStep === _this6.steps.length - 1)) {
                  _context6.next = 16;
                  break;
                }

                _context6.next = 14;
                return __WEBPACK_IMPORTED_MODULE_12__services_WizardService__["a" /* default */].readConfiguration(_this6.formData.configurationGuid);

              case 14:
                _res3 = _context6.sent;

                _this6.formData = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(structuredClone(_this6.formData_template), _res3);

              case 16:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      })));
    },
    finishWizard: function finishWizard() {
      var _this7 = this;

      this.$nextTick(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var res, saved;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                res = _this7.$refs.stepComponent.validateStep();

                if (res.valid) {
                  _context7.next = 5;
                  break;
                }

                console.log("invalid step.");
                if (res.msg) _this7.globals.showErrorSnackbar(res.msg);
                return _context7.abrupt('return');

              case 5:
                if (!(_this7.currentStep === _this7.steps.length - 1)) {
                  _context7.next = 14;
                  break;
                }

                if (_this7.formData.lastValidStep == _this7.currentStep - 1) _this7.formData.lastValidStep++;

                _context7.next = 9;
                return _this7.saveConfiguration();

              case 9:
                saved = _context7.sent;

                if (saved) {
                  _context7.next = 13;
                  break;
                }

                _this7.globals.showErrorSnackbar("Failed to save configuration.");
                return _context7.abrupt('return');

              case 13:

                if (_this7.formData.status == 'inprogress') {
                  _this7.showFinishConfigConfirmationDialog = true;
                } else if (_this7.formData.status == 'pending') {
                  if (_this7.globals.isAdminUser) _this7.showFinishConfigConfirmationDialog = true;else _this7.$router.push("/configoverview");
                } else if (_this7.formData.status == 'finished') {
                  _this7.$router.push("/configoverview");
                }

              case 14:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this7);
      })));
    },
    updateActiveStep: function updateActiveStep() {
      var _this8 = this;

      this.steps.forEach(function (step, i) {
        step.active = i === _this8.currentStep;
      });
    },
    isStepAccessible: function isStepAccessible(index) {
      // Optional: Logik um zu prüfen ob ein Step zugänglich ist
      // z.B. nur wenn vorherige Steps abgeschlossen sind
      return true; // Für jetzt alle Steps zugänglich
    },
    validateCurrentStep: function validateCurrentStep() {
      // Optional: Validierung des aktuellen Steps
      // Kann verwendet werden bevor zum nächsten Step gewechselt wird
      return true;
    },
    onYesConfirmation: function onYesConfirmation() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!(_this9.formData.status == 'inprogress')) {
                  _context8.next = 5;
                  break;
                }

                _context8.next = 3;
                return __WEBPACK_IMPORTED_MODULE_12__services_WizardService__["a" /* default */].updateConfigurationStatus(_this9.formData.configurationGuid, 'pending');

              case 3:
                _context8.next = 13;
                break;

              case 5:
                if (!(_this9.formData.status == 'pending' && _this9.globals.isAdminUser)) {
                  _context8.next = 13;
                  break;
                }

                _context8.next = 8;
                return __WEBPACK_IMPORTED_MODULE_12__services_WizardService__["a" /* default */].createElementsFromConfiguration(_this9.formData.configurationGuid);

              case 8:
                res = _context8.sent;

                if (!(res && res.Error)) {
                  _context8.next = 13;
                  break;
                }

                console.error("Error on POST in onYesConfirmation().", res.Error);
                _this9.globals.showErrorSnackbar(res.Error);
                return _context8.abrupt('return');

              case 13:
                _this9.showFinishConfigConfirmationDialog = false;
                // timeout, to wait for the confirmation dialog to close...
                setTimeout(function () {
                  _this9.$router.push("/configoverview");
                }, 200);

              case 15:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this9);
      }))();
    },
    onNoConfirmation: function onNoConfirmation() {
      this.showFinishConfigConfirmationDialog = false;
    },
    onConfirmationDialogClosed: function onConfirmationDialogClosed() {
      this.showFinishConfigConfirmationDialog = false;
    },
    sendBack: function sendBack() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return __WEBPACK_IMPORTED_MODULE_12__services_WizardService__["a" /* default */].updateConfigurationStatus(_this10.formData.configurationGuid, 'inprogress');

              case 2:
                _this10.$router.push("/configoverview");

              case 3:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this10);
      }))();
    }
  }
});

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_audi_steps_css__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_audi_steps_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_audi_steps_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StepHeader_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StepHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__StepHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_WizardService__ = __webpack_require__(48);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Step1',
  components: {
    StepHeader: __WEBPACK_IMPORTED_MODULE_3__StepHeader_vue___default.a
  },
  props: {
    formData: { type: Object, required: true },
    currentStep: { type: Number, default: 0 },
    steps: { type: Array, required: true },
    readonly: { type: Boolean, default: false }
  },
  emits: ['update:formData'],
  data: function data() {
    return {
      localFormData: structuredClone(this.formData),
      projects: null,
      surveys: null,
      agencies: null,
      importers: null,

      fpInputWaveUntil: null,
      fpInputWaveSince: null,
      fpInputWavePlannedUntil: null,
      fpInputWavePlannedSince: null,

      lang: {
        W00001: "Title",
        W00013: "Enter a title for this configuration",
        W00014: "The title serves to clearly identify the configuration.",
        W00015: "Project",
        W00016: "Survey",
        W00017: "Wave name",
        W00018: "Enter a name for the wave",
        W00019: "The Name serves to clearly identify the wave.",
        W00020: "Start date",
        W00021: "End date",
        W00022: "Planned start date",
        W00023: "Planned end date",
        W00024: "Info (optional)",
        W00025: "Wave without approval",
        W00026: "Local wave",
        W00027: "Importer",
        W00028: "Please note that an DPA must be available for the selected importer.",
        W00029: "Local agency"
      }
    };
  },
  destroyed: function destroyed() {
    if (this.fpInputWaveUntil) this.fpInputWaveUntil.destroy();
    if (this.fpInputWaveSince) this.fpInputWaveSince.destroy();
    if (this.fpInputWavePlannedSince) this.fpInputWavePlannedSince.destroy();
    if (this.fpInputWavePlannedUntil) this.fpInputWavePlannedUntil.destroy();
  },

  computed: {
    filteredSurveys: function filteredSurveys() {
      var _this = this;

      if (!this.formData.projectGuid) return [];
      if (!this.surveys) return [];
      var project = this.projects.find(function (e) {
        return e.ProjectGuid === _this.formData.projectGuid;
      });
      return this.surveys.filter(function (e) {
        return e.ProjectId == project.ProjectId;
      });
    }
  },
  watch: {
    "formData": {
      deep: true,
      handler: function handler() {
        this.localFormData = structuredClone(this.formData);
      }
    },
    "localFormData": {
      deep: true,
      handler: function handler(newVal) {
        this.$emit('update:formData', newVal);
      }
    },
    "localFormData.surveyGuid": function localFormDataSurveyGuid(newVal) {
      if (newVal) {
        var survey = this.surveys.find(function (e) {
          return e.SurveyGuid === newVal;
        });
        if (survey) this.localFormData.surveyId = survey.SurveyId;
      }
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
      this.initFlatpickr();
    }
  },
  mounted: function mounted() {
    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this);
    }

    this.initFlatpickr();

    this.readMasterSurveysAndProjects();
    this.readAgencies();
    this.readImporters();
  },

  methods: {
    validateStep: function validateStep() {
      var valid = true;
      var msg = null;
      if (!this.formData.title) {
        valid = false;
        msg = "Title is missing.";
      } else if (!this.formData.projectGuid) {
        valid = false;
        msg = "Project is missing.";
      } else if (!this.formData.surveyGuid) {
        valid = false;
        msg = "Survey is missing.";
      } else if (!this.formData.waveName) {
        valid = false;
        msg = "Wave name is missing.";
      } else if (!this.formData.waveSince) {
        valid = false;
        msg = "Wave start is missing.";
      } else if (!this.formData.waveUntil) {
        valid = false;
        msg = "Wave end is missing.";
      } else if (!this.formData.wavePlannedSince) {
        valid = false;
        msg = "Planned wave start is missing.";
      } else if (!this.formData.wavePlannedUntil) {
        valid = false;
        msg = "Planned wave end is missing.";
      } else if (!this.formData.importerGuid) {
        valid = false;
        msg = "Importer is missing.";
      } else if (!this.formData.agencyGuid) {
        valid = false;
        msg = "Agency is missing.";
      }
      var waveSince = new Date(this.formData.waveSince);
      var waveUntil = new Date(this.formData.waveUntil);
      if (waveSince > waveUntil) {
        valid = false;
        msg = "Wave start is after end.";
      }
      var wavePlannedSince = new Date(this.formData.wavePlannedSince);
      var wavePlannedUntil = new Date(this.formData.wavePlannedUntil);
      if (wavePlannedSince > wavePlannedUntil) {
        valid = false;
        msg = "Planned wave start is after end.";
      }

      return { "valid": valid, "msg": msg };
    },
    initFlatpickr: function initFlatpickr() {
      this.fpInputWaveSince = flatpickr("#inputWaveStartDate", this.globals.flatpickrDateConfig);
      this.fpInputWaveUntil = flatpickr("#inputWaveEndDate", this.globals.flatpickrDateConfig);
      this.fpInputWavePlannedSince = flatpickr("#inputWavePlannedStartDate", this.globals.flatpickrDateConfig);
      this.fpInputWavePlannedUntil = flatpickr("#inputWavePlannedEndDate", this.globals.flatpickrDateConfig);

      this.setDatePicker();
    },
    readMasterSurveysAndProjects: function readMasterSurveysAndProjects() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_4__services_WizardService__["a" /* default */].readMasterSurveysAndProjects();

              case 2:
                res = _context.sent;

                if (res.Surveys) _this2.surveys = res.Surveys;
                if (res.Projects) _this2.projects = res.Projects;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    readAgencies: function readAgencies() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_4__services_WizardService__["a" /* default */].readAgencies();

              case 2:
                res = _context2.sent;

                if (res.length && res.length > 0) _this3.agencies = res;

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    readImporters: function readImporters() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_4__services_WizardService__["a" /* default */].readImporters();

              case 2:
                res = _context3.sent;

                if (res.length && res.length > 0) _this4.importers = res;

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    setDatePicker: function setDatePicker() {
      this.fpInputWaveSince.setDate(this.formData.waveSince);
      this.fpInputWaveUntil.setDate(this.formData.waveUntil);
      this.fpInputWavePlannedSince.setDate(this.formData.wavePlannedSince);
      this.fpInputWavePlannedUntil.setDate(this.formData.wavePlannedUntil);
    }
  }
});

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_audi_steps_css__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_audi_steps_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_audi_steps_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StepHeader_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StepHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__StepHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_WizardService__ = __webpack_require__(48);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Step2',
  components: {
    StepHeader: __WEBPACK_IMPORTED_MODULE_5__StepHeader_vue___default.a
  },
  props: {
    formData: { type: Object, required: true },
    currentStep: { type: Number, default: 0 },
    steps: { type: Array, required: true },
    readonly: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      localFormData: structuredClone(this.formData),
      availableScenarios: null,
      lang: {
        W00032: "Available scenarios",
        W00033: "Selected scenarios",
        W00034: "Name",
        W00035: "ID"
      }
    };
  },

  watch: {
    "formData": {
      deep: true,
      handler: function handler() {
        this.localFormData = structuredClone(this.formData);
      }
    },
    "localFormData": {
      deep: true,
      handler: function handler(newVal) {
        this.$emit('update:formData', newVal);
      }
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  mounted: function mounted() {
    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this);
    }

    this.readScenarios();
  },

  methods: {
    validateStep: function validateStep() {
      if (!this.localFormData.scenarios || this.localFormData.scenarios && this.localFormData.scenarios.length <= 0) {
        return { valid: false, msg: "Please select a scenario." };
      }
      return { valid: true, msg: null };
    },
    updateField: function updateField(fieldName, value) {
      var updatedData = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.formData, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, fieldName, value));
      this.$emit('update:formData', updatedData);
    },
    selectScenario: function selectScenario(scenario) {
      if (this.readonly) return;
      if (scenario.disabled) return;

      // Check if already selected
      var isAlreadySelected = false;
      if (this.localFormData.scenarios) isAlreadySelected = this.localFormData.scenarios.some(function (s) {
        return s.ScenarioId === scenario.ScenarioId;
      });
      if (isAlreadySelected) return;

      // Add to selected scenarios
      this.localFormData.scenarios.push({
        ScenarioId: scenario.ScenarioId,
        ScenarioName: scenario.ScenarioName
      });
    },
    removeScenario: function removeScenario(scenarioId) {
      if (this.readonly) return;
      this.localFormData.scenarios = this.localFormData.scenarios.filter(function (s) {
        return s.ScenarioId !== scenarioId;
      });
    },
    readScenarios: function readScenarios() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_6__services_WizardService__["a" /* default */].readScenarios(_this.formData.configurationGuid);

              case 2:
                res = _context.sent;

                if (res.length && res.length > 0) _this.availableScenarios = res;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_audi_steps_css__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_audi_steps_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_audi_steps_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StepHeader_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StepHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__StepHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_WizardService__ = __webpack_require__(48);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Step3",
  components: {
    StepHeader: __WEBPACK_IMPORTED_MODULE_6__StepHeader_vue___default.a
  },
  props: {
    formData: { type: Object, required: true },
    currentStep: { type: Number, default: 0 },
    steps: { type: Array, required: true },
    readonly: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      localFormData: structuredClone(this.formData),
      carModelList: [],
      importerList: null,
      segmentList: null,
      multipleModels: new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default.a(),
      lang: {
        W00038: "Model",
        W00039: "Importer",
        W00040: "Segment",
        W00041: "Share (%)",

        W00071: "Sum share:",

        W00095: "Please insert model shares.",
        W00096: "The sum has to be 100%.",
        W00097: "Share for a model is set more than once!"
      }
    };
  },

  computed: {
    sumDistribution: function sumDistribution() {
      if (!this.localFormData.carModelDistribution || this.localFormData.carModelDistribution.length <= 0) return 0;

      var sum = 0;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.localFormData.carModelDistribution), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var element = _step.value;

          if (element.Distribution) sum += Number(element.Distribution);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return Number((sum * 100).toFixed(1));
    },
    filteredCarModelList: function filteredCarModelList() {
      if (!this.carModelList || !Array.isArray(this.carModelList)) return [];
      var importerGuid = this.formData && this.formData.importerGuid;
      return this.carModelList.filter(function (m) {
        // include models without an ImporterGuid or that match the selected importer
        return !m.ImporterGuid || m.ImporterGuid === importerGuid;
      });
    }
  },
  watch: {
    "formData": {
      deep: true,
      handler: function handler() {
        this.localFormData = structuredClone(this.formData);
      }
    },
    "localFormData": {
      deep: true,
      handler: function handler(newVal) {
        this.$emit('update:formData', newVal);
      }
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  mounted: function mounted() {
    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this);
    }
    this.clearCarModelDistribution();
    this.readCarModel();
    this.readImporters();
    this.readCarSegment();
  },

  methods: {
    validateStep: function validateStep() {
      this.multipleModels.clear();
      this.$forceUpdate();

      if (!this.localFormData.carModelDistribution || this.localFormData.carModelDistribution.length <= 0) return { valid: false, msg: this.lang.W00095 };

      var modelsSet = new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default.a();
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.carModelList), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var entry = _step2.value;

          if (!entry.Distribution) continue;
          if (modelsSet.has(entry.CarModelName)) {
            this.multipleModels.add(entry.CarModelName);
            this.$forceUpdate();
            return { valid: false, msg: this.lang.W00097 };
          }
          modelsSet.add(entry.CarModelName);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      this.multipleModels.clear();

      if (Number(this.sumDistribution) != 100) return { valid: false, msg: this.lang.W00096 };

      return { valid: true, msg: null };
    },
    clearCarModelDistribution: function clearCarModelDistribution() {
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.carModelList), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var entry = _step3.value;
          delete entry.Distribution;
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    },
    readCarModelDistribution: function readCarModelDistribution() {
      var _this = this;

      if (!this.carModelList) return;

      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        var _loop = function _loop() {
          var waveEntry = _step4.value;

          var modelListEntry = _.find(_this.carModelList, function (model) {
            return model.CarModelGuid === waveEntry.CarModelGuid;
          });
          if (modelListEntry) modelListEntry.Distribution = parseFloat((waveEntry.Distribution * 100).toFixed(4));
        };

        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.carModelList), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          _loop();
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }
    },
    readCarModel: function readCarModel() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res, map;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this2.localFormData.carModelDistribution) _this2.$set(_this2.localFormData, 'carModelDistribution', []);

                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_7__services_WizardService__["a" /* default */].readCarModel();

              case 3:
                res = _context.sent;

                if (res.length && res.length > 0) {
                  _this2.carModelList = res;
                }
                map = _this2.localFormData.carModelDistribution.reduce(function (acc, item) {
                  acc[item.CarModelGuid] = item.Distribution;
                  return acc;
                }, {});


                _this2.carModelList = _this2.carModelList.map(function (model) {
                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, model, {
                    Distribution: map[model.CarModelGuid] || null
                  });
                });
                _this2.readCarModelDistribution();

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    readImporters: function readImporters() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_7__services_WizardService__["a" /* default */].readImporters();

              case 2:
                res = _context2.sent;

                if (res.length && res.length > 0) _this3.importerList = res;

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    readCarSegment: function readCarSegment() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_7__services_WizardService__["a" /* default */].readCarSegment();

              case 2:
                res = _context3.sent;

                if (res.length && res.length > 0) _this4.segmentList = res;

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    validateDistributionValue: function validateDistributionValue(model) {
      var lowerLimit = 0,
          upperLimit = 100;

      if (typeof model.Distribution !== "number" || model.Distribution < lowerLimit) {
        model.Distribution = lowerLimit;
      } else if (model.Distribution > upperLimit) {
        model.Distribution = upperLimit;
      }

      var formDataCarModel = this.localFormData.carModelDistribution.find(function (e) {
        return e.CarModelGuid === model.CarModelGuid;
      });

      if (formDataCarModel) {
        if (!model.Distribution) {
          this.localFormData.carModelDistribution = this.localFormData.carModelDistribution.filter(function (e) {
            return e != formDataCarModel;
          });
        } else {
          formDataCarModel.Distribution = parseFloat((model.Distribution / 100).toFixed(4));
        }
      } else if (model.Distribution) {
        this.localFormData.carModelDistribution.push({
          CarModelGuid: model.CarModelGuid,
          Distribution: parseFloat((model.Distribution / 100).toFixed(4))
        });
      }
      this.$forceUpdate();
    }
  }
});

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_audi_steps_css__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_audi_steps_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_audi_steps_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StepHeader_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StepHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__StepHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_WizardService__ = __webpack_require__(48);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Step4',
  components: {
    StepHeader: __WEBPACK_IMPORTED_MODULE_6__StepHeader_vue___default.a
  },
  props: {
    formData: { type: Object, required: true },
    currentStep: { type: Number, default: 0 },
    steps: { type: Array, required: true },
    readonly: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      localFormData: structuredClone(this.formData),
      brands: null,
      competitorCarModelDistribution: null,
      brandValidation: [],
      lang: {
        W00041: "Share (%)",
        W00044: "Brand",
        W00045: "Model",
        W00046: "Add vehicle",
        W00047: "Select a brand…"
      }
    };
  },

  watch: {
    "formData": {
      deep: true,
      handler: function handler() {
        this.localFormData = structuredClone(this.formData);
      }
    },
    "localFormData": {
      deep: true,
      handler: function handler(newVal) {
        // this.$emit('update:formData', newVal); // is emitted in watcher for competitorCarModelDistribution
      }
    },
    "competitorCarModelDistribution": {
      handler: function handler(newValue, oldValue) {
        this.brandValidation = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(this.competitorCarModelDistribution.reduce(function (acc, item) {
          if (!acc[item.CompetitorCarBrand]) {
            acc[item.CompetitorCarBrand] = { CompetitorCarBrand: item.CompetitorCarBrand, Distribution: 0 };
          }
          acc[item.CompetitorCarBrand].Distribution += Number(item.Distribution);
          return acc;
        }, {}));

        var competitorCarModelDistribution = structuredClone(this.competitorCarModelDistribution);
        competitorCarModelDistribution = competitorCarModelDistribution.filter(function (e) {
          return e.CompetitorCarBrand && e.CompetitorCarModel;
        });

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(competitorCarModelDistribution), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var e = _step.value;

            e.Distribution = (e.Distribution / 100).toFixed(4);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        this.localFormData.competitorCarModelDistribution = competitorCarModelDistribution;
        this.$emit('update:formData', this.localFormData);
      },

      deep: true
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var competitorCarModelDistribution, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, e, res;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!_this.localFormData.competitorCarModelDistribution) _this.$set(_this.localFormData, 'competitorCarModelDistribution', []);
              competitorCarModelDistribution = structuredClone(_this.localFormData.competitorCarModelDistribution);
              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _iteratorError2 = undefined;
              _context.prev = 5;

              for (_iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(competitorCarModelDistribution); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                e = _step2.value;

                e.Distribution = Number((e.Distribution * 100).toFixed(4));
              }
              _context.next = 13;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](5);
              _didIteratorError2 = true;
              _iteratorError2 = _context.t0;

            case 13:
              _context.prev = 13;
              _context.prev = 14;

              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }

            case 16:
              _context.prev = 16;

              if (!_didIteratorError2) {
                _context.next = 19;
                break;
              }

              throw _iteratorError2;

            case 19:
              return _context.finish(16);

            case 20:
              return _context.finish(13);

            case 21:
              _this.competitorCarModelDistribution = competitorCarModelDistribution;

              _context.next = 24;
              return __WEBPACK_IMPORTED_MODULE_7__services_WizardService__["a" /* default */].readBrandsOfConfiguration(_this.localFormData.configurationGuid);

            case 24:
              res = _context.sent;

              if (res) _this.brands = res.map(function (p) {
                return p.LocationPropertyValue;
              });

            case 26:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[5, 9, 13, 21], [14,, 16, 20]]);
    }))();
  },
  mounted: function mounted() {
    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this);
    }
  },

  methods: {
    isBrandValid: function isBrandValid(competitorCarBrand) {
      if (this.brandValidation.some(function (e) {
        return e.CompetitorCarBrand == competitorCarBrand && e.Distribution != 100;
      })) return false;
      return true;
    },
    validateStep: function validateStep() {
      this.competitorCarModelDistribution = this.competitorCarModelDistribution.filter(function (e) {
        return e.CompetitorCarBrand && e.CompetitorCarModel;
      });

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.brandValidation), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var e = _step3.value;

          if (e.Distribution != 100) {
            return { valid: false, msg: "The sum of the share of " + e.CompetitorCarBrand + " must be 100%." };
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      if (this.hasDuplicateBrandModel()) {
        return { valid: false, msg: "Saving failed: Model name duplicated." };
      }

      return { valid: true, msg: null };
    },
    addVehicle: function addVehicle() {
      var v = this.competitorCarModelDistribution.find(function (e) {
        return !e.CompetitorCarBrand && !e.CompetitorCarModel && !e.Distribution;
      });

      if (v) return;

      this.competitorCarModelDistribution.push({
        CompetitorCarBrand: null,
        CompetitorCarModel: null,
        Distribution: 0
      });
    },
    deleteVehicle: function deleteVehicle(v) {
      this.competitorCarModelDistribution = this.competitorCarModelDistribution.filter(function (e) {
        return e != v;
      });
    },
    hasDuplicateBrandModel: function hasDuplicateBrandModel() {
      var seen = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a();

      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.competitorCarModelDistribution), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var item = _step4.value;

          var key = item.CompetitorCarBrand.toLowerCase().trim() + "|" + item.CompetitorCarModel.toLowerCase().trim();
          if (seen.has(key)) {
            return true;
          }
          seen.add(key);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return false;
    }
  }
});

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_finite__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_audi_steps_css__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_audi_steps_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__styles_audi_steps_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StepHeader_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StepHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__StepHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_WizardService__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_survey_vue__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_survey_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_survey_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue__ = __webpack_require__(32);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Step5',
  components: {
    StepHeader: __WEBPACK_IMPORTED_MODULE_7__StepHeader_vue___default.a
  },
  props: {
    formData: { type: Object, required: true },
    currentStep: { type: Number, default: 0 },
    steps: { type: Array, required: true },
    readonly: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      debug: false,
      localFormData: structuredClone(this.formData),
      masterSurvey: null,
      survey: null,
      clusterIndex: 0,
      activeCluster: null,
      translateX: 0,
      surveyLocales: null,
      selectedLocaleCode: null,
      translations: null,

      lang: {
        W00081: "Default",
        W00082: "Translation",
        W00083: "Select language…",
        W00084: "Max points:",
        W00085: "Description…",
        W00086: "Note…",
        W00087: "Only visible for:",
        W00088: "Not visible for:",
        W00098: "none of the chosen scenarios",
        W00099: "(=not visible)",
        W00100: "(=visible)"
      }
    };
  },

  computed: {
    outline: function outline() {
      var _this = this;

      if (!this.survey || !this.survey.pages) return [];

      var walkElements = function walkElements(elements, pageName) {
        return (elements || []).map(function (el, idx) {
          var type = typeof el.getType === "function" ? el.getType() : el.type;
          var title = el.title || el.name || "(untitled)";

          // Panels 
          var children = el.elements || [];
          var questions = _this.flattenQuestions(children, pageName, el.name || "panel_" + idx);
          return {
            type: type,
            key: pageName + ":panel:" + (el.name || idx),
            title: title,
            questions: questions,
            guid: el.guid.toUpperCase()
          };
        });
      };

      return this.survey.pages.map(function (page) {
        var pageTitle = page.title || page.name || "(untitled page)";
        return {
          key: "page:" + page.name,
          title: pageTitle,
          items: walkElements(page.elements, page.name)
        };
      });
    },
    questionsByGuid: function questionsByGuid() {
      var map = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default()(null);
      var qs = this.localFormData.questions || [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(qs), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var q = _step.value;

          map[q.QuestionGuid] = q;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return map;
    },
    choicesByGuid: function choicesByGuid() {
      var map = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default()(null);
      var qc = this.localFormData.questionChoices || [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(qc), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var q = _step2.value;

          map[q.ChoiceGuid] = q;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return map;
    },
    scenarioQuestionSettings_Visible: function scenarioQuestionSettings_Visible() {
      if (!this.masterSurvey || !this.masterSurvey.ScenarioQuestionSettings) return [];
      var map = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default()(null);
      var sqs = this.masterSurvey.ScenarioQuestionSettings || [];

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(sqs), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var s = _step3.value;

          if (s.Visible) {
            var scenarioInConfig = true;
            if (!this.configurationScenarios[s.ScenarioId]) scenarioInConfig = false;

            if (map[s.ElementGuid] && !map[s.ElementGuid].Scenarios.includes(s.ScenarioName)) {
              if (scenarioInConfig) map[s.ElementGuid].Scenarios.push(s.ScenarioName);else if (!scenarioInConfig) map[s.ElementGuid].ScenariosNotInConfig.push(s.ScenarioName);
            } else {
              if (scenarioInConfig) map[s.ElementGuid] = { Scenarios: [s.ScenarioName], ScenariosNotInConfig: [] };else map[s.ElementGuid] = { Scenarios: [], ScenariosNotInConfig: [s.ScenarioName] };
            }
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return map;
    },
    scenarioQuestionSettings_NotVisible: function scenarioQuestionSettings_NotVisible() {
      if (!this.masterSurvey || !this.masterSurvey.ScenarioQuestionSettings) return [];
      var map = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default()(null);
      var sqs = this.masterSurvey.ScenarioQuestionSettings || [];

      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(sqs), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var s = _step4.value;

          if (!s.Visible) {
            var scenarioInConfig = true;
            if (!this.configurationScenarios[s.ScenarioId]) scenarioInConfig = false;

            if (map[s.ElementGuid] && !map[s.ElementGuid].Scenarios.includes(s.ScenarioName)) {
              if (scenarioInConfig) map[s.ElementGuid].Scenarios.push(s.ScenarioName);else if (!scenarioInConfig) map[s.ElementGuid].ScenariosNotInConfig.push(s.ScenarioName);
            } else {
              if (scenarioInConfig) map[s.ElementGuid] = { Scenarios: [s.ScenarioName], ScenariosNotInConfig: [] };else map[s.ElementGuid] = { Scenarios: [], ScenariosNotInConfig: [s.ScenarioName] };
            }
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return map;
    },
    configurationScenarios: function configurationScenarios() {
      var map = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default()(null);
      var sc = this.localFormData.scenarios || [];
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(sc), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var s = _step5.value;

          map[s.ScenarioId] = s.ScenarioName;
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      return map;
    }
  },
  watch: {
    "formData": {
      deep: true,
      handler: function handler() {
        this.localFormData = structuredClone(this.formData);
      }
    },
    "localFormData": {
      deep: true,
      handler: function handler(newVal) {
        this.$emit('update:formData', newVal);
      }
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    },
    "selectedLocaleCode": function selectedLocaleCode() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.loadSurveyTranslation();

              case 2:
                _this2.fillSurveyTranslations();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    }
  },
  created: function created() {
    // this.configureSurveyJs();
  },
  mounted: function mounted() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (_this3.globals.selectedLanguage) {
                _this3.globals.getLanguageStrings(_this3);
              }
              _context2.next = 3;
              return _this3.getMasterSurvey();

            case 3:
              _this3.fillContenteditable();
              _this3.loadSurveyLocales();

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this3);
    }))();
  },

  methods: {
    getScenarioName: function getScenarioName(scenarioId) {
      if (!this.localFormData.scenarios) return;
      var scenario = this.localFormData.scenarios.find(function (e) {
        return e.ScenarioId == scenarioId;
      });
      if (scenario) return scenario.ScenarioName;
    },
    removePlaceholder: function removePlaceholder(eventTarget) {
      if (eventTarget.dataset.placeholder) {
        eventTarget.dataset.placeholder = false;
        eventTarget.textContent = null;
      }
    },
    fillContenteditable: function fillContenteditable() {
      var refs = this.$refs['wizard-survey-contenteditable'];
      if (!refs) return;
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(refs), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var e = _step6.value;

          var questionGuid = e.dataset.questionguid;
          var choiceGuid = e.dataset.choiceguid;
          var key = e.dataset.key;
          var fallbackText = e.dataset.fallbacktext;
          if (questionGuid) {
            var edited = this.questionsByGuid[questionGuid] && this.questionsByGuid[questionGuid][key] ? true : false;
            if (edited) {
              e.textContent = this.questionsByGuid[questionGuid][key];
              e.classList.add('wizard-survey-content-edited');
            } else {
              e.textContent = fallbackText;
            }
          }
          if (choiceGuid) {
            var _edited = this.choicesByGuid[choiceGuid] && this.choicesByGuid[choiceGuid][key] ? true : false;
            if (_edited) {
              e.textContent = this.choicesByGuid[choiceGuid][key];
              e.classList.add('wizard-survey-content-edited');
            } else {
              e.textContent = fallbackText;
            }
          }
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }
    },
    fillSurveyTranslations: function fillSurveyTranslations() {
      var _this4 = this;

      var refs = this.$refs['wizard-survey-translation-input'];
      if (!refs) return;
      if (!this.selectedLocaleCode) return;
      var parts = this.selectedLocaleCode.split('-');
      var languageCode = parts[0].toLowerCase();
      var countryCode = parts[1] ? parts[1].toUpperCase() : null;

      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        var _loop = function _loop() {
          var e = _step7.value;

          var guid = e.dataset.translationguid;
          var key = e.dataset.translationkey;
          var category = e.dataset.category;
          var translation = _this4.translations.find(function (t) {
            return t.Guid.toUpperCase() == guid.toUpperCase() && t.Key == key;
          });
          var translationFromConfiguration = void 0;
          var isTranslationFromConfigurationFallback = false;
          switch (category) {

            case 'question':
              if (!_this4.localFormData.questionsTranslations) break;
              var qt = _this4.localFormData.questionsTranslations.find(function (t) {
                return t.QuestionGuid.toUpperCase() == guid.toUpperCase() && t.LanguageCode == languageCode && (!countryCode && !t.CountryCode || t.CountryCode == countryCode);
              });
              if (!qt) {
                qt = _this4.localFormData.questionsTranslations.find(function (t) {
                  return t.QuestionGuid.toUpperCase() == guid.toUpperCase() && t.LanguageCode == languageCode;
                });
                if (qt) isTranslationFromConfigurationFallback = true;
              }
              if (qt) {
                switch (key) {
                  case 'title':
                    translationFromConfiguration = qt.TranslationTitle;
                    break;
                  case 'description':
                    translationFromConfiguration = qt.TranslationDescription;
                    break;
                  default:
                    break;
                }
              }
              break;

            case 'choice':
              if (!_this4.localFormData.questionChoicesTranslations) break;
              var qct = _this4.localFormData.questionChoicesTranslations.find(function (t) {
                return t.ChoiceGuid.toUpperCase() == guid.toUpperCase() && t.LanguageCode == languageCode && (!countryCode && !t.CountryCode || t.CountryCode == countryCode);
              });
              if (!qct) {
                qct = _this4.localFormData.questionChoicesTranslations.find(function (t) {
                  return t.ChoiceGuid.toUpperCase() == guid.toUpperCase() && t.LanguageCode == languageCode;
                });
                if (qct) isTranslationFromConfigurationFallback = true;
              }
              if (qct) translationFromConfiguration = qct.Translation;
              break;
            default:
              break;
          }
          if (translation) e.value = translation.Translation ? translation.Translation : translation.InheritedTranslation ? translation.InheritedTranslation : null;
          if (translationFromConfiguration) {
            e.value = translationFromConfiguration;
            if (!isTranslationFromConfigurationFallback) e.classList.add('wizard-survey-content-edited');else e.classList.remove('wizard-survey-content-edited');
          } else {
            e.classList.remove('wizard-survey-content-edited');
          }
        };

        for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(refs), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          _loop();
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }
    },
    getComment: function getComment(questionGuid) {
      if (!this.localFormData.questions) return null;
      var e = this.localFormData.questions.find(function (e) {
        return e.QuestionGuid.toUpperCase() == questionGuid.toUpperCase();
      });
      if (e) return e.Comment;
      return null;
    },
    setConfigurationQuestion: function setConfigurationQuestion(questionGuid, key, value, target, type) {
      if (!this.localFormData.questions) this.$set(this.localFormData, 'questions', []);

      if (type === 'number' && !__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_finite___default()(Number(value))) {
        this.globals.showErrorSnackbar("Invalid input. Input must be of type " + type);
        return;
      }

      if (value === "") value = null;

      var e = this.localFormData.questions.find(function (e) {
        return e.QuestionGuid.toUpperCase() == questionGuid.toUpperCase();
      });
      if (!e) {
        e = {
          "QuestionGuid": questionGuid,
          "Title": null,
          "Description": null,
          "PointsMax": null,
          "IsSelected": true,
          "Comment": null
        };
        this.$set(e, key, value);
        this.localFormData.questions.push(e);
      } else {
        this.$set(e, key, value);
      }
      target.classList.add('wizard-survey-content-edited');
    },
    setConfigurationQuestionChoice: function setConfigurationQuestionChoice(choiceGuid, key, value, target, type) {
      if (!this.localFormData.questionChoices) this.$set(this.localFormData, 'questionChoices', []);

      if (type === 'number' && !__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_finite___default()(Number(value))) {
        this.globals.showErrorSnackbar("Invalid input. Input must be of type " + type);
        return;
      }

      if (value === "") value = null;

      var e = this.localFormData.questionChoices.find(function (e) {
        return e.ChoiceGuid.toUpperCase() == choiceGuid.toUpperCase();
      });
      if (!e) {
        e = {
          "ChoiceGuid": choiceGuid,
          "Title": null,
          "Points": null,
          "PointsMax": null
        };
        this.$set(e, key, value);
        this.localFormData.questionChoices.push(e);
      } else {
        this.$set(e, key, value);
      }
      target.classList.add('wizard-survey-content-edited');
    },
    setConfigurationQuestionTranslation: function setConfigurationQuestionTranslation(questionGuid, key, value, target) {
      if (!this.selectedLocaleCode) return;
      var parts = this.selectedLocaleCode.split('-');
      var languageCode = parts[0].toLowerCase();
      var countryCode = parts[1] ? parts[1].toUpperCase() : null;

      if (value === "") value = null;

      if (!this.localFormData.questionsTranslations) this.$set(this.localFormData, 'questionsTranslations', []);
      var e = this.localFormData.questionsTranslations.find(function (e) {
        return e.QuestionGuid.toUpperCase() == questionGuid.toUpperCase() && e.LanguageCode == languageCode && (!countryCode && !e.CountryCode || e.CountryCode == countryCode);
      });
      if (!e) {
        e = {
          "QuestionGuid": questionGuid,
          "CountryCode": countryCode,
          "LanguageCode": languageCode,
          "TranslationTitle": null, // NOT NULL
          "TranslationDescription": null // NOT NULL
        };
        this.$set(e, key, value);
        this.localFormData.questionsTranslations.push(e);
      } else {
        this.$set(e, key, value);
      }
      target.classList.add('wizard-survey-content-edited');
    },
    setConfigurationQuestionChoiceTranslation: function setConfigurationQuestionChoiceTranslation(choiceGuid, key, value, target) {
      if (!this.selectedLocaleCode) return;
      var parts = this.selectedLocaleCode.split('-');
      var languageCode = parts[0].toLowerCase();
      var countryCode = parts[1] ? parts[1].toUpperCase() : null;

      if (value === "") value = null;

      if (!this.localFormData.questionChoicesTranslations) this.$set(this.localFormData, 'questionChoicesTranslations', []);
      var e = this.localFormData.questionChoicesTranslations.find(function (e) {
        return e.ChoiceGuid.toUpperCase() == choiceGuid.toUpperCase() && e.LanguageCode == languageCode && (!countryCode && !e.CountryCode || e.CountryCode == countryCode);
      });
      if (!e) {
        e = {
          "ChoiceGuid": choiceGuid,
          "CountryCode": countryCode,
          "LanguageCode": languageCode,
          "Translation": null // NOT NULL
        };
        this.$set(e, key, value);
        this.localFormData.questionChoicesTranslations.push(e);
      } else {
        this.$set(e, key, value);
      }
      target.classList.add('wizard-survey-content-edited');
    },
    getMasterSurvey: function getMasterSurvey() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _iteratorNormalCompletion8, _didIteratorError8, _iteratorError8, _iterator8, _step8, page;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_8__services_WizardService__["a" /* default */].getMasterSurvey(_this5.localFormData.configurationGuid);

              case 2:
                _this5.masterSurvey = _context3.sent;

                if (!(_this5.masterSurvey && _this5.masterSurvey.Survey && _this5.masterSurvey.Survey.pages)) {
                  _context3.next = 31;
                  break;
                }

                _iteratorNormalCompletion8 = true;
                _didIteratorError8 = false;
                _iteratorError8 = undefined;
                _context3.prev = 7;
                _iterator8 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(_this5.masterSurvey.Survey.pages);

              case 9:
                if (_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done) {
                  _context3.next = 17;
                  break;
                }

                page = _step8.value;

                if (!page.elements) {
                  _context3.next = 14;
                  break;
                }

                _this5.activeCluster = page.elements[0];
                return _context3.abrupt("return");

              case 14:
                _iteratorNormalCompletion8 = true;
                _context3.next = 9;
                break;

              case 17:
                _context3.next = 23;
                break;

              case 19:
                _context3.prev = 19;
                _context3.t0 = _context3["catch"](7);
                _didIteratorError8 = true;
                _iteratorError8 = _context3.t0;

              case 23:
                _context3.prev = 23;
                _context3.prev = 24;

                if (!_iteratorNormalCompletion8 && _iterator8.return) {
                  _iterator8.return();
                }

              case 26:
                _context3.prev = 26;

                if (!_didIteratorError8) {
                  _context3.next = 29;
                  break;
                }

                throw _iteratorError8;

              case 29:
                return _context3.finish(26);

              case 30:
                return _context3.finish(23);

              case 31:
                return _context3.abrupt("return");

              case 32:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[7, 19, 23, 31], [24,, 26, 30]]);
      }))();
    },
    validateStep: function validateStep() {
      return { valid: true, msg: null };
    },
    flattenQuestions: function flattenQuestions(elements, pageName, prefix) {
      var _this6 = this;

      var out = [];
      (elements || []).forEach(function (el, idx) {
        var type = typeof el.getType === "function" ? el.getType() : el.type;
        var title = el.title || el.name || "(untitled)";

        if (type === "panel" || type === "paneldynamic") {
          out.push.apply(out, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this6.flattenQuestions(el.elements || [], pageName, prefix + "." + (el.name || idx))));
        } else {
          out.push({
            key: pageName + ":" + prefix + ":q:" + (el.name || idx),
            title: title,
            description: el.description,
            type: type,
            guid: el.guid.toUpperCase(),
            pointsMax: el.pointsMax,
            choices: (el.choices || []).map(function (c) {
              return {
                value: c.value,
                text: c.text,
                guid: c.guid.toUpperCase(),
                points: c.points,
                maxPoints: c.maxPoints
              };
            }),
            customQuestionNumber: el.customQuestionNumber,
            isRequired: el.isRequired
          });
        }
      });
      return out;
    },
    configureSurveyJs: function configureSurveyJs() {
      var _this7 = this;

      // Register functions for expression trigger and add maxPointsReached for selectbase questions
      __WEBPACK_IMPORTED_MODULE_9_survey_vue__["FunctionFactory"].Instance.register("setMaxPoints", function (params) {
        if (params.length < 1 || !_this7.survey) return;
        for (var i = 0; i < params.length; i++) {
          var q = _this7.survey.getQuestionByName(params[i]);
          if (q) q.maxPointsReached = true;
        }
      });
      __WEBPACK_IMPORTED_MODULE_9_survey_vue__["FunctionFactory"].Instance.register("unsetMaxPoints", function (params) {
        if (params.length < 1 || !_this7.survey) return;
        for (var i = 0; i < params.length; i++) {
          var q = _this7.survey.getQuestionByName(params[i]);
          if (q && q.maxPointsReached) q.maxPointsReached = false;
        }
      });
      __WEBPACK_IMPORTED_MODULE_9_survey_vue__["JsonObject"].metaData.addProperty("selectbase", {
        name: "maxPointsReached:boolean"
      });
      __WEBPACK_IMPORTED_MODULE_9_survey_vue__["JsonObject"].metaData.addProperty("panel", {
        name: "isCluster:boolean"
      });
      __WEBPACK_IMPORTED_MODULE_9_survey_vue__["JsonObject"].metaData.addProperty("panel", {
        name: "backgroundColor:text"
      });
      __WEBPACK_IMPORTED_MODULE_9_survey_vue__["JsonObject"].metaData.addProperty("question", "commentForShopper:text");

      __WEBPACK_IMPORTED_MODULE_9_survey_vue__["JsonObject"].metaData.addProperty("checkbox", "exclusiveValue:checkboxValue");

      // Add points to answers
      __WEBPACK_IMPORTED_MODULE_9_survey_vue__["JsonObject"].metaData.addClass("itemvaluesWithPoints", ["points:number"], null, "itemvalue");
      __WEBPACK_IMPORTED_MODULE_9_survey_vue__["JsonObject"].metaData.addProperty("selectbase", "choices:itemvalues");
      var property1 = __WEBPACK_IMPORTED_MODULE_9_survey_vue__["JsonObject"].metaData.findProperty("selectbase", "choices");
      property1.typeValue = "itemvaluesWithPoints";
      property1.className = "itemvaluesWithPoints";

      __WEBPACK_IMPORTED_MODULE_9_survey_vue__["JsonObject"].metaData.addProperty("rating", "rateValues:itemvalues");
      property1 = __WEBPACK_IMPORTED_MODULE_9_survey_vue__["JsonObject"].metaData.findProperty("rating", "rateValues");
      property1.typeValue = "itemvaluesWithPoints";
      property1.className = "itemvaluesWithPoints";

      // Add maxPoints to answers of radiogroups
      __WEBPACK_IMPORTED_MODULE_9_survey_vue__["JsonObject"].metaData.addClass("itemvaluesWithPointsAndMaxPoints", ["points:number", "maxPoints:number"], null, "itemvalue");
      __WEBPACK_IMPORTED_MODULE_9_survey_vue__["JsonObject"].metaData.addProperty("radiogroup", "choices:itemvalues");
      var property2 = __WEBPACK_IMPORTED_MODULE_9_survey_vue__["JsonObject"].metaData.findProperty("radiogroup", "choices");
      property2.typeValue = "itemvaluesWithPointsAndMaxPoints";
      property2.className = "itemvaluesWithPointsAndMaxPoints";

      __WEBPACK_IMPORTED_MODULE_9_survey_vue__["JsonObject"].metaData.addProperty("question", {
        name: "pointsMax:number"
      });

      __WEBPACK_IMPORTED_MODULE_9_survey_vue__["JsonObject"].metaData.addProperty("question", "guid");
      __WEBPACK_IMPORTED_MODULE_9_survey_vue__["JsonObject"].metaData.addProperty("panelbase", "guid");
      __WEBPACK_IMPORTED_MODULE_9_survey_vue__["JsonObject"].metaData.addProperty("itemvalue", "guid");

      // Add custom question numbers
      __WEBPACK_IMPORTED_MODULE_9_survey_vue__["JsonObject"].metaData.addProperty("question", {
        name: "customQuestionNumber",
        default: 0
      });

      // Add properties for currency inputs
      __WEBPACK_IMPORTED_MODULE_9_survey_vue__["JsonObject"].metaData.addProperty("survey", {
        name: "currencySymbol",
        default: "€"
      });
      __WEBPACK_IMPORTED_MODULE_9_survey_vue__["JsonObject"].metaData.addProperty("survey", {
        name: "currencyDecimalPoint",
        default: "comma"
      });
    },
    moveHeader: function moveHeader(direction) {
      var node = this.$refs["wizard-survey-panel-header-elements"];
      if (!node) return;

      var parent = node.parentElement;
      if (!parent) return;

      var nodeWidth = node.scrollWidth;
      var parentWidth = parent.clientWidth;
      var maxTranslatePx = Math.max(nodeWidth - parentWidth, 0);

      switch (direction) {
        case "l":
          this.translateX -= 50;
          break;
        case "r":
          this.translateX += 50;
          break;
        default:
          break;
      }

      this.translateX = Math.max(0, Math.min(this.translateX, maxTranslatePx));

      node.style.transform = "translateX(-" + this.translateX + "px)";
    },
    scrollHeader: function scrollHeader(event) {
      if (event.deltaY > 0) this.moveHeader('l');else this.moveHeader('r');
    },
    loadSurveyLocales: function loadSurveyLocales() {
      var _this8 = this;

      $.ajax({
        method: "GET",
        url: "api/SurveyTranslation/" + this.localFormData.surveyId + "/Locales",
        success: function success(data) {
          _this8.surveyLocales = data;
        },
        error: function error() {
          console.error("Survey locale data access failed in loadSurveyLocales()");
          _this8.globals.showErrorSnackbar("Survey locale data access failed");
        }
      });
    },
    loadSurveyTranslation: function loadSurveyTranslation() {
      var _this9 = this;

      if (!this.selectedLocaleCode) return;
      return $.ajax({
        method: "GET",
        url: "api/SurveyTranslation/" + this.localFormData.surveyId + "?localeCode=" + this.selectedLocaleCode,
        success: function success(data) {
          _this9.translations = data.Translations;
        },
        error: function error() {
          console.error("Survey translation data access failed in loadSurveyTranslation()");
          _this9.globals.showErrorSnackbar("Translation data access failed");
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_entries__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_audi_steps_css__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_audi_steps_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_audi_steps_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__StepHeader_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__StepHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__StepHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_WizardService__ = __webpack_require__(48);









//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Step6',
  components: {
    StepHeader: __WEBPACK_IMPORTED_MODULE_10__StepHeader_vue___default.a
  },
  props: {
    formData: { type: Object, required: true },
    currentStep: { type: Number, default: 0 },
    steps: { type: Array, required: true },
    readonly: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      localFormData: structuredClone(this.formData),
      locations: null,
      brands: null,
      recompute: 0,
      visitsToApply: {
        scenarioId: null,
        number: 0
      },
      filter: {},
      showTableSettings: false,
      columns: {
        LocationStoreId: {
          visible: true,
          width: "1fr",
          disabled: false,
          lang: "W00035"
        },
        LocationName: {
          visible: true,
          width: "1fr",
          disabled: false,
          lang: "W00051"
        },
        displayAddress: {
          visible: true,
          width: "1fr",
          disabled: false,
          lang: "W00052"
        },
        Brand: {
          visible: false,
          width: "1fr",
          disabled: false,
          lang: null
        },
        Countries: {
          visible: false,
          width: "1fr",
          disabled: false,
          lang: null
        },
        Checkanlage: {
          visible: false,
          width: "1fr",
          disabled: false,
          lang: null
        },
        Checkanlage2: {
          visible: false,
          width: "1fr",
          disabled: false,
          lang: null
        },
        Checkanlage3: {
          visible: false,
          width: "1fr",
          disabled: false,
          lang: null
        },
        Scenarios: {
          visible: true,
          width: "2fr",
          disabled: true,
          lang: "W00053"
        }
      },
      lang: {
        W00035: "ID",
        W00050: "Locations",
        W00051: "Location",
        W00052: "Address",
        W00053: "Number of checks per scenario",

        W00072: "Checks total:",
        W00073: "Locations with checks:",
        W00074: "Checks for scenario \"PLACEHOLDER\":",

        W00079: "Apply on all",
        W00080: "Select scenario..."
      }
    };
  },

  computed: {
    brandVisits: function brandVisits() {
      this.recompute; // force recompute on change of variable this.recompute

      var res = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(this.brands), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var brand = _step.value;

          var o = {
            "brand": brand,
            "checkCount": this.getCheckCountByBrand(brand),
            "locationsWithChecksCount": this.getLocationsWithChecksCountByBrand(brand)
          };
          if (!this.localFormData.scenarios) continue;
          o.scenarios = [];
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(this.localFormData.scenarios), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var scenario = _step2.value;

              var s = {
                "scenarioName": scenario.ScenarioName,
                "checkCount": this.getCheckCountByBrandAndScenario(brand, scenario.ScenarioId)
              };
              o.scenarios.push(s);
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          res.push(o);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return res;
    }
  },
  watch: {
    "formData": {
      deep: true,
      handler: function handler() {
        this.localFormData = structuredClone(this.formData);
      }
    },
    "localFormData": {
      deep: true,
      handler: function handler(newVal) {
        this.$emit('update:formData', newVal);
      }
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  mounted: function mounted() {
    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this);
    }
    this.readConfigurationLocations();
  },

  methods: {
    resetFilter: function resetFilter(column, visible, brand) {
      if (!visible) {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_entries___default()(this.filter)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var _step3$value = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_step3.value, 2),
                key = _step3$value[0],
                brandFilter = _step3$value[1];

            console.log(brandFilter);
            console.log(column);
            console.log(brandFilter[column]);
            if (brandFilter[column]) {
              delete brandFilter[column];
              console.log(brandFilter);
            }
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      }
    },
    applyColumnGrid: function applyColumnGrid() {
      var _this = this;

      // set timeout, cause newly rendered columns will have default grid template
      setTimeout(function () {
        var gridTemplate = "";
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_entries___default()(_this.columns)), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var _step4$value = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_step4.value, 2),
                key = _step4$value[0],
                value = _step4$value[1];

            if (value.visible) gridTemplate += value.width + " ";
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }

        var headers = document.getElementsByClassName("wizard-table-header");
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(headers), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var e = _step5.value;

            e.style.gridTemplateColumns = gridTemplate;
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }

        var rows = document.getElementsByClassName("wizard-table-row");
        var _iteratorNormalCompletion6 = true;
        var _didIteratorError6 = false;
        var _iteratorError6 = undefined;

        try {
          for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(rows), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
            var _e = _step6.value;

            _e.style.gridTemplateColumns = gridTemplate;
          }
        } catch (err) {
          _didIteratorError6 = true;
          _iteratorError6 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion6 && _iterator6.return) {
              _iterator6.return();
            }
          } finally {
            if (_didIteratorError6) {
              throw _iteratorError6;
            }
          }
        }
      }, 100);
    },
    showFilter: function showFilter(brand, type) {
      if (!this.filter[brand]) this.filter[brand] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()({}, type, { show: true, text: "" });else if (!this.filter[brand][type]) this.filter[brand][type] = { show: true, text: "" };else if (!this.filter[brand][type].show) this.filter[brand][type].show = true;else if (this.filter[brand][type].show) this.filter[brand][type].show = false;
      this.$forceUpdate();
    },
    applyVisits: function applyVisits(brand) {
      if (!this.visitsToApply.scenarioId) return;

      var locations = this.getLocationsOfBrand(brand);
      var fakeEvent = { "target": { "valueAsNumber": this.visitsToApply.number } };
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(locations), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var location = _step7.value;

          this.setNumberOfVisits(location.LocationId, this.visitsToApply.scenarioId, fakeEvent);
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }
    },
    getCheckCountByBrand: function getCheckCountByBrand(brand) {
      var _this2 = this;

      if (!this.localFormData || !this.localFormData.visits) return 0;
      var count = 0;
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        var _loop = function _loop() {
          var visit = _step8.value;

          var location = _this2.locations.find(function (e) {
            return e.LocationId == visit.LocationId;
          });
          if (!location || location.Brand != brand) return "continue";
          count += Number(visit.NumberOfVisits);
        };

        for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(this.localFormData.visits), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var _ret = _loop();

          if (_ret === "continue") continue;
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      return count;
    },
    getLocationsWithChecksCountByBrand: function getLocationsWithChecksCountByBrand(brand) {
      var _this3 = this;

      if (!this.localFormData || !this.localFormData.visits) return 0;
      var locations = [];
      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        var _loop2 = function _loop2() {
          var visit = _step9.value;

          var location = _this3.locations.find(function (e) {
            return e.LocationId == visit.LocationId;
          });
          if (!location || location.Brand != brand) return "continue";

          if (!locations.includes(location.LocationId)) locations.push(location.LocationId);
        };

        for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(this.localFormData.visits), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          var _ret2 = _loop2();

          if (_ret2 === "continue") continue;
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9.return) {
            _iterator9.return();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }

      return locations.length;
    },
    getCheckCountByBrandAndScenario: function getCheckCountByBrandAndScenario(brand, scenarioId) {
      var _this4 = this;

      if (!this.localFormData || !this.localFormData.visits) return 0;
      var count = 0;
      var _iteratorNormalCompletion10 = true;
      var _didIteratorError10 = false;
      var _iteratorError10 = undefined;

      try {
        var _loop3 = function _loop3() {
          var visit = _step10.value;

          if (visit.ScenarioId != scenarioId) return "continue";
          var location = _this4.locations.find(function (e) {
            return e.LocationId == visit.LocationId;
          });
          if (!location || location.Brand != brand) return "continue";
          count += Number(visit.NumberOfVisits);
        };

        for (var _iterator10 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(this.localFormData.visits), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
          var _ret3 = _loop3();

          if (_ret3 === "continue") continue;
        }
      } catch (err) {
        _didIteratorError10 = true;
        _iteratorError10 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion10 && _iterator10.return) {
            _iterator10.return();
          }
        } finally {
          if (_didIteratorError10) {
            throw _iteratorError10;
          }
        }
      }

      return count;
    },
    setNumberOfVisits: function setNumberOfVisits(locationId, scenarioId, event) {
      this.recompute++;
      if (!this.localFormData.visits) this.$set(this.localFormData, 'visits', []);

      if (event && event.target) {
        var _visit = this.localFormData.visits.find(function (e) {
          return e.LocationId == locationId && e.ScenarioId == scenarioId;
        });
        if (_visit) {
          if (!event.target.valueAsNumber) {
            this.localFormData.visits = this.localFormData.visits.filter(function (e) {
              return e != _visit;
            });
          } else {
            _visit.NumberOfVisits = event.target.valueAsNumber;
          }
        } else if (event.target.valueAsNumber) {
          this.localFormData.visits.push({
            "LocationId": locationId,
            "ScenarioId": scenarioId,
            "NumberOfVisits": event.target.valueAsNumber
          });
        }
      }
    },
    getNumberOfVisits: function getNumberOfVisits(locationId, scenarioId) {
      if (!this.localFormData.visits) return null;
      var e = this.localFormData.visits.find(function (e) {
        return e.LocationId == locationId && e.ScenarioId == scenarioId;
      });
      if (e && e.NumberOfVisits) return e.NumberOfVisits;
      return null;
    },
    getLocationsOfBrand: function getLocationsOfBrand(brand) {
      if (!this.locations) return [];
      var res = this.locations.filter(function (e) {
        return e.Brand == brand;
      });
      var brandFilter = this.filter[brand];
      if (!brandFilter) return res;

      res = res.filter(function (loc) {
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_entries___default()(brandFilter).every(function (_ref) {
          var _ref2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
              key = _ref2[0],
              filterVal = _ref2[1];

          if (filterVal == null || filterVal === "") {
            return true;
          }

          var locVal = loc[key];

          if ((typeof filterVal === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(filterVal)) === "object" && filterVal.text != null) {
            if (typeof locVal !== "string") return false;
            return locVal.toLowerCase().includes(filterVal.text.toLowerCase());
          }

          return locVal === filterVal;
        });
      });

      return res;
    },
    readConfigurationLocations: function readConfigurationLocations() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res, _iteratorNormalCompletion11, _didIteratorError11, _iteratorError11, _iterator11, _step11, location;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_11__services_WizardService__["a" /* default */].readConfigurationLocations(_this5.localFormData.configurationGuid);

              case 2:
                res = _context.sent;
                _iteratorNormalCompletion11 = true;
                _didIteratorError11 = false;
                _iteratorError11 = undefined;
                _context.prev = 6;

                for (_iterator11 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(res); !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
                  location = _step11.value;

                  location.displayAddress = location.LocationAddress + "\n" + location.LocationPostalCode + " " + location.LocationCity;
                }
                _context.next = 14;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](6);
                _didIteratorError11 = true;
                _iteratorError11 = _context.t0;

              case 14:
                _context.prev = 14;
                _context.prev = 15;

                if (!_iteratorNormalCompletion11 && _iterator11.return) {
                  _iterator11.return();
                }

              case 17:
                _context.prev = 17;

                if (!_didIteratorError11) {
                  _context.next = 20;
                  break;
                }

                throw _iteratorError11;

              case 20:
                return _context.finish(17);

              case 21:
                return _context.finish(14);

              case 22:
                if (res) _this5.locations = res;
                _this5.brands = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(_this5.locations.map(function (e) {
                  return e.Brand;
                }))));

              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this5, [[6, 10, 14, 22], [15,, 17, 21]]);
      }))();
    },
    validateStep: function validateStep() {
      if (!this.localFormData.visits || this.localFormData.visits.length <= 0) return { valid: false, msg: "Please choose at least one location." };
      return { valid: true, msg: null };
    }
  }
});

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_audi_steps_css__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_audi_steps_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_audi_steps_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StepHeader_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StepHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__StepHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_WizardService__ = __webpack_require__(48);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Step7',
  components: {
    StepHeader: __WEBPACK_IMPORTED_MODULE_3__StepHeader_vue___default.a
  },
  props: {
    formData: { type: Object, required: true },
    currentStep: { type: Number, default: 0 },
    steps: { type: Array, required: true },
    readonly: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      localFormData: structuredClone(this.formData),
      briefingAttachments: null,
      surveyAttachments: null,
      lang: {
        W00016: "Survey",
        W00054: "Briefing",
        W00056: "Scenario",
        W00057: "Select a briefing…",
        W00058: "Select a survey…",
        W00059: "Available briefings",
        W00060: "Available surveys"
      }
    };
  },

  watch: {
    "formData": {
      deep: true,
      handler: function handler() {
        this.localFormData = structuredClone(this.formData);
      }
    },
    "localFormData": {
      deep: true,
      handler: function handler(newVal) {
        this.$emit('update:formData', newVal);
      }
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  mounted: function mounted() {
    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this);
    }
    this.getProjectAttachments();
  },

  methods: {
    onInputChange: function onInputChange(e, attachmentType) {
      var _this = this;

      var files = e.target.files || e.dataTransfer.files;
      if (!files.length || !files[0].name) return;

      var attachmentFileObject = files[0];

      var uploadSuccess = function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(data) {
          var res;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return __WEBPACK_IMPORTED_MODULE_4__services_WizardService__["a" /* default */].addProjectAttachment(_this.localFormData.projectGuid, data[0].DownloadId, attachmentType);

                case 2:
                  res = _context.sent;

                  if (res && res.Error) {
                    console.error(res.Error);
                    globals.showErrorSnackbar("Attachment upload failed.");
                  } else {
                    _this.globals.showSuccessSnackbar("Attachment upload successful.");
                    _this.getProjectAttachments();
                    _this.$forceUpdate();
                  }

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }));

        return function uploadSuccess(_x) {
          return _ref.apply(this, arguments);
        };
      }();
      this.globals.uploadFile(attachmentFileObject, uploadSuccess);
      e.target.value = null;
    },
    setValue: function setValue(scenarioId, attachmentType, event) {
      if (!this.localFormData.briefing) this.$set(this.localFormData, 'briefing', []);

      if (event && event.target) {
        var res = this.localFormData.briefing.find(function (e) {
          return e.ScenarioId == scenarioId && e.AttachmentType == attachmentType;
        });
        if (res) {
          if (!event.target.value) this.localFormData.briefing = this.localFormData.briefing.filter(function (e) {
            return e != res;
          });else res.DownloadId = event.target.value;
        } else {
          this.localFormData.briefing.push({
            "ScenarioId": scenarioId,
            "DownloadId": event.target.value,
            "AttachmentType": attachmentType
          });
        }
      }
    },
    getValue: function getValue(scenarioId, attachmentType) {
      if (!this.localFormData.briefing) this.$set(this.localFormData, 'briefing', []);

      var res = this.localFormData.briefing.find(function (e) {
        return e.ScenarioId == scenarioId && e.AttachmentType == attachmentType;
      });
      if (res) return res.DownloadId;
      return null;
    },
    getProjectAttachments: function getProjectAttachments() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_4__services_WizardService__["a" /* default */].getProjectAttachments(_this2.localFormData.projectGuid);

              case 2:
                res = _context2.sent;

                if (res.length > 0) {
                  _this2.briefingAttachments = res.filter(function (d) {
                    return d.AttachmentType === "Briefing";
                  });
                  _this2.surveyAttachments = res.filter(function (d) {
                    return d.AttachmentType === "Survey";
                  });
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    validateStep: function validateStep() {
      return { valid: true, msg: null };
    }
  }
});

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_audi_steps_css__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_audi_steps_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_audi_steps_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StepHeader_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StepHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__StepHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_WizardService__ = __webpack_require__(48);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Step8",
  components: {
    StepHeader: __WEBPACK_IMPORTED_MODULE_2__StepHeader_vue___default.a
  },
  props: {
    formData: { type: Object, required: true },
    currentStep: { type: Number, default: 0 },
    steps: { type: Array, required: true },
    readonly: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      lang: {
        W00000: "Configuration Overview",
        W00075: "Wave",
        W00016: "Survey",
        W00027: "Importer",
        W00029: "Local agency",
        W00076: "Lead agency",
        W00077: "Scenarios",
        W00078: "distribution",
        CM1034: "Briefing",
        CM1035: "Survey",
        SA0015: "Location",
        SA0044: "Scenario"
      }
    };
  },

  computed: {
    scenariosNames: function scenariosNames() {
      var sc = this.formData && this.formData.scenarios;
      if (!sc || !Array.isArray(sc) || sc.length === 0) return "";
      return sc.map(function (s) {
        return s.ScenarioName || s.name || "";
      }).filter(Boolean).join(", ");
    },
    carModelDistributionDisplay: function carModelDistributionDisplay() {
      var models = this.formData && this.formData.carModelDistribution;
      if (!models || !Array.isArray(models) || models.length === 0) return "";
      return models.map(function (m) {
        return m.CarModelName + ": " + m.Distribution * 100 + "%";
      }).join(", ");
    },
    competitorCarModelDistributionDisplay: function competitorCarModelDistributionDisplay() {
      var competitors = this.formData && this.formData.competitorCarModelDistribution;
      if (!competitors || !Array.isArray(competitors) || competitors.length === 0) return {};

      var grouped = {};
      competitors.forEach(function (c) {
        if (!grouped[c.CompetitorCarBrand]) {
          grouped[c.CompetitorCarBrand] = [];
        }
        grouped[c.CompetitorCarBrand].push(c.CompetitorCarModel + ": " + parseFloat(c.Distribution) * 100 + "%");
      });

      return grouped;
    },
    competitorBrands: function competitorBrands() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.competitorCarModelDistributionDisplay);
    }
  },
  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  mounted: function mounted() {
    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this);
    }
  },

  methods: {
    validateStep: function validateStep() {
      return { valid: true, msg: null };
    },
    exportConfiguration: function exportConfiguration() {
      __WEBPACK_IMPORTED_MODULE_3__services_WizardService__["a" /* default */].exportConfiguration(this.formData.configurationGuid);
    },
    getAttachmentFileName: function getAttachmentFileName(scenarioId, type) {
      var attachments = this.formData && this.formData.briefing;
      if (!attachments || !Array.isArray(attachments)) return "";
      var found = attachments.find(function (a) {
        return a.ScenarioId === scenarioId && a.AttachmentType === type;
      });
      return found ? found.DownloadFileName : "";
    }
  }
});

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StepHeader',
  props: {
    currentStep: { type: Number, required: true },
    steps: { type: Array, required: true }
  },
  data: function data() {
    return {
      lang: {
        W00009: "Step PLACEHOLDER1 of PLACEHOLDER2"
      }
    };
  },

  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  mounted: function mounted() {
    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this);
    }
  },

  methods: {
    getText: function getText(placeholder1Text, placeholder2Text) {
      return this.lang.W00009.replace("PLACEHOLDER1", placeholder1Text).replace("PLACEHOLDER2", placeholder2Text);
    }
  }
});

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_audi_steps_css__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_audi_steps_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_audi_steps_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_WizardService__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Tools_Dialogs_ConfirmationDialog__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Tools_Dialogs_ConfirmationDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Tools_Dialogs_ConfirmationDialog__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ConfigOverview",
  components: { ConfirmationDialog: __WEBPACK_IMPORTED_MODULE_4__Tools_Dialogs_ConfirmationDialog___default.a },
  data: function data() {
    return {
      configurations: null,
      showDeleteConfigConfirmationDialog: false,
      configurationGuid_toBeDeleted: null,
      lang: {
        W00000: "Configuration Overview",
        W00001: "Title",
        W00002: "Status",
        W00003: "Last update",
        W00004: "Resume",
        W00005: "In progress",
        W00006: "Pending",
        W00007: "Finished",
        W00008: "New",

        W00089: "View"
      }
    };
  },
  mounted: function mounted() {
    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this);
    }

    this.getConfigs();
  },

  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  methods: {
    openConfirmationDialog: function openConfirmationDialog(configurationGuid) {
      this.configurationGuid_toBeDeleted = configurationGuid;
      this.showDeleteConfigConfirmationDialog = true;
    },
    onYesConfirmation: function onYesConfirmation() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3__services_WizardService__["a" /* default */].deleteConfiguration(_this.configurationGuid_toBeDeleted);

              case 2:
                _this.showDeleteConfigConfirmationDialog = false;
                _this.configurationGuid_toBeDeleted = null;
                _this.getConfigs();

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    onNoConfirmation: function onNoConfirmation() {
      this.showDeleteConfigConfirmationDialog = false;
      this.configurationGuid_toBeDeleted = null;
    },
    onConfirmationDialogClosed: function onConfirmationDialogClosed() {
      this.showDeleteConfigConfirmationDialog = false;
      this.configurationGuid_toBeDeleted = null;
    },
    getConfigs: function getConfigs() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3__services_WizardService__["a" /* default */].readConfigurations();

              case 2:
                res = _context2.sent;

                if (res.length && res.length > 0) _this2.configurations = res;

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

var resolveInitPromise = void 0;
var rejectInitPromise = void 0;
// This promise handles the initialization
// status of the google maps script.
var initPromise = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
  resolveInitPromise = resolve;
  rejectInitPromise = reject;
});

function init(apiKey) {
  // If Google Maps already is initialized
  // the `initPromise` should get resolved
  // eventually.
  if (!!window.google) return initPromise;

  // The callback function is called by
  // the Google Maps script if it is
  // successfully loaded.
  window["gmapsCallback"] = function () {
    return resolveInitPromise(window.google);
  };

  // We inject a new script tag into
  // the `<head>` of our HTML to load
  // the Google Maps script.
  var script = document.createElement("script");
  script.async = true;
  script.defer = true;
  script.src = "https://maps.googleapis.com/maps/api/js?key=" + apiKey + "&callback=gmapsCallback&libraries=places";
  script.onerror = rejectInitPromise;
  document.querySelector("head").appendChild(script);
  return initPromise;
}

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__package_json__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__globals__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__feature__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_text_encoding_shim__ = __webpack_require__(1545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_text_encoding_shim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_text_encoding_shim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__main__ = __webpack_require__(213);










var SERVER_URL = "https://dev.authentication.audi-mysteryshopping.com/";
var CLIENT_URL = "https://dev.projects.audi-mysteryshopping.com/#/";

/* harmony default export */ __webpack_exports__["a"] = ({
  // app wide variables
  tokenRenewalPending: false,
  tokenRenewalCallbacks: [],
  appReloadPending: false,

  accessToken: null,
  idToken: null,
  refreshToken: null,

  // app functions
  isJWTExpired: function isJWTExpired(token) {
    var payload = this.getTokenData(token);
    var expireDate = payload.exp * 1000;
    var now = Date.now();
    return now > expireDate;
  },
  getTokenData: function getTokenData(token) {
    if (!token) return;
    var data = JSON.parse(window.atob(token.split(".")[1]));
    return data;
  },
  getAccessToken: function getAccessToken() {
    return this.accessToken || null;
  },
  getRefreshToken: function getRefreshToken() {
    return this.refreshToken || null;
  },
  getIdToken: function getIdToken() {
    return this.idToken || null;
  },
  checkRouteValid: function checkRouteValid(hash) {
    if (hash.length > 2) {
      var route = hash.slice(1);
      for (var r in __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].options.routes) {
        var path = __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].options.routes[r].path;
        if (path == route) return true;
      }
    }
    return false;
  },
  randomString: function randomString(length) {
    var charset = "0123456789ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvwxyz-._~";
    var result = "";

    while (length > 0) {
      var bytes = new Uint8Array(16);
      var crypto = window.crypto || window.msCrypto;
      var random = crypto.getRandomValues(bytes);
      random.forEach(function (c) {
        if (length == 0) {
          return;
        }
        if (c < charset.length) {
          result += charset[c];
          length--;
        }
      });
    }
    return result;
  },
  hexString: function hexString(buffer) {
    var byteArray = new Uint8Array(buffer);

    var hexCodes = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(byteArray)).map(function (value) {
      var hexCode = value.toString(16);
      var paddedHexCode = hexCode.padStart(2, "0");
      return paddedHexCode;
    });

    return hexCodes.join("");
  },
  digestMessage: function digestMessage(message) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var encoder, data, crypto, result;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              encoder = new __WEBPACK_IMPORTED_MODULE_7_text_encoding_shim__["TextEncoder"]();
              data = encoder.encode(message);
              crypto = window.crypto || window.msCrypto;
              _context.next = 5;
              return crypto.subtle.digest("SHA-256", data);

            case 5:
              result = _context.sent;

              if (result.result) result = result.result; // IE11 returns an object containing result property
              return _context.abrupt("return", result);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  digestMessageToHexString: function digestMessageToHexString(message) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.t0 = _this2;
              _context2.next = 3;
              return _this2.digestMessage(message);

            case 3:
              _context2.t1 = _context2.sent;
              return _context2.abrupt("return", _context2.t0.hexString.call(_context2.t0, _context2.t1));

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  directToLogin: function directToLogin() {},
  redirectAfterLoginCallback: function redirectAfterLoginCallback() {},
  setClientTimeZone: function setClientTimeZone() {
    var tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (!tz) return;
    var query = "api/SecurityUsers/Localization?TimeZoneName=" + encodeURIComponent(tz);

    $.ajax({
      method: "PUT",
      url: query,
      dataType: "json",
      contentType: "application/json; charset=utf-8",
      error: function error() {
        console.error("Error on PUT in setClientTimeZone()");
        __WEBPACK_IMPORTED_MODULE_5__globals__["a" /* default */].showErrorSnackbar("Timezone update failed");
      }
    });
  },
  getDefaultAjaxSetupConfig: function getDefaultAjaxSetupConfig() {
    return {
      headers: {
        Pragma: "no-cache"
      }
    };
  },
  configureAjaxSetup: function configureAjaxSetup() {
    var access_token = this.getAccessToken();
    var config = this.getDefaultAjaxSetupConfig();
    config.headers.Authorization = "Bearer " + access_token;
    $.ajaxSetup(config);
  },
  initializeGlobalAjaxEvents: function initializeGlobalAjaxEvents() {
    var _this3 = this;

    if (!this.getRefreshToken && !this.tokenRenewalPending) {
      this.removeTokensFromStorage();
      this.directToLogin();
      return;
    }
    var access_token = this.getAccessToken();
    var config = this.getDefaultAjaxSetupConfig();
    if (access_token) config.headers.Authorization = "Bearer " + access_token;
    $.ajaxSetup(config);

    window.addEventListener("storage", function (e) {
      if (e.key === "refresh_token") {
        _this3.configureAjaxSetup();
      }
    });

    $(document).ajaxError(function (event, jqXHR) {
      if (jqXHR.status === 401) {
        _this3.removeTokensFromStorage();
        window.location.reload();
      }
    });

    $(document).ajaxComplete(function (event, jqXHR, options, data) {
      var apiVersion = jqXHR.getResponseHeader("frontend-version");
      var isDevSystem = __WEBPACK_IMPORTED_MODULE_6__feature__["a" /* default */].currentTarget.indexOf("dev") > -1;
      if (!isDevSystem && !_this3.appReloadPending && apiVersion && apiVersion !== __WEBPACK_IMPORTED_MODULE_4__package_json__["version"]) {
        _this3.appReloadPending = true;
        // Force hard reload of the page if a new version of the app is available
        console.error("Frontend version mismatch - reloading page");
        location.reload(true);
      }
    });
  },
  getPostLoginUrl: function getPostLoginUrl() {
    var hashString = window.location.hash;
    var idx = hashString.indexOf("id_token");
    if (idx < 0) return "";

    var postLoginUrl = hashString.slice(2, idx);
    return postLoginUrl;
  },
  storeTokensInStorage: function storeTokensInStorage(access_token, id_token, refresh_token) {
    this.accessToken = access_token;
    this.idToken = id_token;
    this.refreshToken = refresh_token;
    __WEBPACK_IMPORTED_MODULE_5__globals__["a" /* default */].$emit("accessTokenChanged");
  },
  removeTokensFromStorage: function removeTokensFromStorage() {
    this.accessToken = null;
    this.idToken = null;
    this.refreshToken = null;
    __WEBPACK_IMPORTED_MODULE_5__globals__["a" /* default */].$emit("accessTokenChanged");
  },
  getTokensFromUrl: function getTokensFromUrl() {
    return;
  },
  logout: function logout() {
    __WEBPACK_IMPORTED_MODULE_8__main__["keycloak"].logout();
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_localFilters__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_sharedFilters__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_userSettings__ = __webpack_require__(573);








__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */].Store({
  modules: {
    localFilters: __WEBPACK_IMPORTED_MODULE_4__modules_localFilters__["a" /* default */],
    sharedFilters: __WEBPACK_IMPORTED_MODULE_5__modules_sharedFilters__["a" /* default */],
    userSettings: __WEBPACK_IMPORTED_MODULE_6__modules_userSettings__["a" /* default */]
  },
  strict: "production" !== "production",
  mutations: {
    initStore: function initStore(state) {
      var storedUserSettings = localStorage.getItem("userSettings");
      if (storedUserSettings) {
        state.userSettings = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state.userSettings, JSON.parse(storedUserSettings));
      }

      var storedLocalFilters = localStorage.getItem("localFilters");
      if (storedLocalFilters) {
        state.localFilters = JSON.parse(storedLocalFilters);
      }

      var storedSharedFilters = localStorage.getItem("sharedFilters");
      if (storedSharedFilters) {
        state.sharedFilters = JSON.parse(storedSharedFilters);
      }
    }
  }
});

// Detects any changes to the state
store.subscribe(function (mutation, state) {
  if (mutation.type.startsWith("userSettings/")) {
    localStorage.setItem("userSettings", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.userSettings));

    if (mutation.type === "userSettings/rememberFilters") {
      localStorage.removeItem("localFilters");
      localStorage.removeItem("sharedFilters");
    } else if (mutation.type === "userSettings/syncFilters") {
      localStorage.removeItem("sharedFilters");
    }
  } else if (store.getters["userSettings/rememberFilters"] && mutation.type.startsWith("localFilters/")) {
    localStorage.setItem("localFilters", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.localFilters));
  } else if (store.getters["userSettings/syncFilters"] && mutation.type.startsWith("sharedFilters/")) {
    localStorage.setItem("sharedFilters", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.sharedFilters));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(32);


// initial state
var state = {
  clientManagement: {},
  locationManagement: {},
  userManagement: {},
  projectManagement: {},
  agencyManagement: {},
  surveyManagement: {},
  checkManagement: {},
  kpiManagement: {},
  shopperManagement: {},
  recruiting_checkFilter: {},
  recruiting_shopperFilter: {},
  shopperApproval: {}
};

var getters = {
  clientManagement: function clientManagement(state) {
    return state.clientManagement;
  },
  locationManagement: function locationManagement(state) {
    return state.locationManagement;
  },
  userManagement: function userManagement(state) {
    return state.userManagement;
  },
  projectManagement: function projectManagement(state) {
    return state.projectManagement;
  },
  agencyManagement: function agencyManagement(state) {
    return state.agencyManagement;
  },
  surveyManagement: function surveyManagement(state) {
    return state.surveyManagement;
  },
  checkManagement: function checkManagement(state) {
    return state.checkManagement;
  },
  kpiManagement: function kpiManagement(state) {
    return state.kpiManagement;
  },
  shopperManagement: function shopperManagement(state) {
    return state.shopperManagement;
  },
  recruiting_checkFilter: function recruiting_checkFilter(state) {
    return state.recruiting_checkFilter;
  },
  recruiting_shopperFilter: function recruiting_shopperFilter(state) {
    return state.recruiting_shopperFilter;
  },
  shopperApproval: function shopperApproval(state) {
    return state.shopperApproval;
  }
};

var actions = {};

var mutations = {
  clearAll: function clearAll(state) {
    state.clientManagement = {};
    state.locationManagement = {};
    state.userManagement = {};
    state.projectManagement = {};
    state.agencyManagement = {};
    state.surveyManagement = {};
    state.checkManagement = {};
    state.kpiManagement = {};
    state.shopperManagement = {};
    state.recruiting_checkFilter = {};
    state.recruiting_shopperFilter = {};
    state.shopperApproval = {};
  },
  clientManagement: function clientManagement(state, filters) {
    filters = filters || {};
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, "clientManagement", filters);
  },
  locationManagement: function locationManagement(state, filters) {
    filters = filters || {};
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, "locationManagement", filters);
  },
  userManagement: function userManagement(state, filters) {
    filters = filters || {};
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, "userManagement", filters);
  },
  projectManagement: function projectManagement(state, filters) {
    filters = filters || {};
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, "projectManagement", filters);
  },
  agencyManagement: function agencyManagement(state, filters) {
    filters = filters || {};
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, "agencyManagement", filters);
  },
  surveyManagement: function surveyManagement(state, filters) {
    filters = filters || {};
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, "surveyManagement", filters);
  },
  checkManagement: function checkManagement(state, filters) {
    filters = filters || {};
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, "checkManagement", filters);
  },
  kpiManagement: function kpiManagement(state, filters) {
    filters = filters || {};
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, "kpiManagement", filters);
  },
  shopperManagement: function shopperManagement(state, filters) {
    filters = filters || {};
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, "shopperManagement", filters);
  },
  recruiting_checkFilter: function recruiting_checkFilter(state, filters) {
    filters = filters || {};
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, "recruiting_checkFilter", filters);
  },
  recruiting_shopperFilter: function recruiting_shopperFilter(state, filters) {
    filters = filters || {};
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, "recruiting_shopperFilter", filters);
  },
  shopperApproval: function shopperApproval(state, filters) {
    filters = filters || {};
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, "shopperApproval", filters);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(32);


// initial state
var state = {
  client: {},
  importer: {},
  project: {}
};

var getters = {
  client: function client(state) {
    var result = {
      ClientName: state.client.ClientName || "",
      ClientGuid: state.client.ClientGuid || ""
    };
    return result;
  },
  importer: function importer(state) {
    var result = {
      ImporterName: state.importer.ImporterName || "",
      ImporterGuid: state.importer.ImporterGuid || ""
    };
    return result;
  },
  project: function project(state) {
    var result = {
      ProjectName: state.project.ProjectName || "",
      ProjectGuid: state.project.ProjectGuid || ""
    };
    return result;
  }
};

var actions = {};

var mutations = {
  clearAll: function clearAll(state) {
    state.client = {};
    state.importer = {};
    state.project = {};
  },
  client: function client(state, _client) {
    _client = _client || {};
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state.client, "ClientName", _client.ClientName || "");
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state.client, "ClientGuid", _client.ClientGuid || "");
  },
  importer: function importer(state, _importer) {
    _importer = _importer || {};
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state.importer, "ImporterName", _importer.ImporterName || "");
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state.importer, "ImporterGuid", _importer.ImporterGuid || "");
  },
  project: function project(state, _project) {
    _project = _project || {};
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state.project, "ProjectName", _project.ProjectName || "");
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state.project, "ProjectGuid", _project.ProjectGuid || "");
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// initial state
var state = {
  filters: {
    remember: false,
    sync: false
  }
};

var getters = {
  rememberFilters: function rememberFilters(state) {
    return state.filters.remember;
  },
  syncFilters: function syncFilters(state) {
    return state.filters.sync;
  }
};

var actions = {};

var mutations = {
  rememberFilters: function rememberFilters(state, value) {
    state.filters.remember = value;
  },
  syncFilters: function syncFilters(state, value) {
    state.filters.sync = value;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 992 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 993 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 994 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 995 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 996 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 997 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 998 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 999 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1000 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1001 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1003 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1004 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1007 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1008 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1009 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1011 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1012 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1013 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1014 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1015 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1016 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1017 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1018 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1019 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1020 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1021 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1022 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1024 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1025 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1026 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1027 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1028 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1029 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1030 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1031 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1032 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1033 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1034 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1035 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1036 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1037 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1038 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1039 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1040 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1041 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1042 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1043 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1044 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1045 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1046 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1047 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1048 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1049 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1050 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1051 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1052 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1053 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1054 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1055 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1056 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1057 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1058 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1059 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1060 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1061 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1062 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1063 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1064 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1065 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1066 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1067 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1068 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1069 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1070 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1071 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1072 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1073 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1074 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1075 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1076 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1077 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1078 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1079 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1080 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1081 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1082 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1083 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1084 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1085 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1086 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1087 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1088 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1089 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1090 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1091 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1092 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1093 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1094 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1095 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1096 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1097 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1098 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1099 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1100 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1101 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1102 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1103 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1104 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1105 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1106 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1107 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1108 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1109 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1110 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */,
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */,
/* 1505 */,
/* 1506 */,
/* 1507 */,
/* 1508 */,
/* 1509 */,
/* 1510 */,
/* 1511 */,
/* 1512 */,
/* 1513 */,
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */,
/* 1521 */,
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 321,
	"./af.js": 321,
	"./ar": 328,
	"./ar-dz": 322,
	"./ar-dz.js": 322,
	"./ar-kw": 323,
	"./ar-kw.js": 323,
	"./ar-ly": 324,
	"./ar-ly.js": 324,
	"./ar-ma": 325,
	"./ar-ma.js": 325,
	"./ar-sa": 326,
	"./ar-sa.js": 326,
	"./ar-tn": 327,
	"./ar-tn.js": 327,
	"./ar.js": 328,
	"./az": 329,
	"./az.js": 329,
	"./be": 330,
	"./be.js": 330,
	"./bg": 331,
	"./bg.js": 331,
	"./bm": 332,
	"./bm.js": 332,
	"./bn": 333,
	"./bn.js": 333,
	"./bo": 334,
	"./bo.js": 334,
	"./br": 335,
	"./br.js": 335,
	"./bs": 336,
	"./bs.js": 336,
	"./ca": 337,
	"./ca.js": 337,
	"./cs": 338,
	"./cs.js": 338,
	"./cv": 339,
	"./cv.js": 339,
	"./cy": 340,
	"./cy.js": 340,
	"./da": 341,
	"./da.js": 341,
	"./de": 344,
	"./de-at": 342,
	"./de-at.js": 342,
	"./de-ch": 343,
	"./de-ch.js": 343,
	"./de.js": 344,
	"./dv": 345,
	"./dv.js": 345,
	"./el": 346,
	"./el.js": 346,
	"./en-SG": 347,
	"./en-SG.js": 347,
	"./en-au": 348,
	"./en-au.js": 348,
	"./en-ca": 349,
	"./en-ca.js": 349,
	"./en-gb": 350,
	"./en-gb.js": 350,
	"./en-ie": 351,
	"./en-ie.js": 351,
	"./en-il": 352,
	"./en-il.js": 352,
	"./en-nz": 353,
	"./en-nz.js": 353,
	"./eo": 354,
	"./eo.js": 354,
	"./es": 357,
	"./es-do": 355,
	"./es-do.js": 355,
	"./es-us": 356,
	"./es-us.js": 356,
	"./es.js": 357,
	"./et": 358,
	"./et.js": 358,
	"./eu": 359,
	"./eu.js": 359,
	"./fa": 360,
	"./fa.js": 360,
	"./fi": 361,
	"./fi.js": 361,
	"./fo": 362,
	"./fo.js": 362,
	"./fr": 365,
	"./fr-ca": 363,
	"./fr-ca.js": 363,
	"./fr-ch": 364,
	"./fr-ch.js": 364,
	"./fr.js": 365,
	"./fy": 366,
	"./fy.js": 366,
	"./ga": 367,
	"./ga.js": 367,
	"./gd": 368,
	"./gd.js": 368,
	"./gl": 369,
	"./gl.js": 369,
	"./gom-latn": 370,
	"./gom-latn.js": 370,
	"./gu": 371,
	"./gu.js": 371,
	"./he": 372,
	"./he.js": 372,
	"./hi": 373,
	"./hi.js": 373,
	"./hr": 374,
	"./hr.js": 374,
	"./hu": 375,
	"./hu.js": 375,
	"./hy-am": 376,
	"./hy-am.js": 376,
	"./id": 377,
	"./id.js": 377,
	"./is": 378,
	"./is.js": 378,
	"./it": 380,
	"./it-ch": 379,
	"./it-ch.js": 379,
	"./it.js": 380,
	"./ja": 381,
	"./ja.js": 381,
	"./jv": 382,
	"./jv.js": 382,
	"./ka": 383,
	"./ka.js": 383,
	"./kk": 384,
	"./kk.js": 384,
	"./km": 385,
	"./km.js": 385,
	"./kn": 386,
	"./kn.js": 386,
	"./ko": 387,
	"./ko.js": 387,
	"./ku": 388,
	"./ku.js": 388,
	"./ky": 389,
	"./ky.js": 389,
	"./lb": 390,
	"./lb.js": 390,
	"./lo": 391,
	"./lo.js": 391,
	"./lt": 392,
	"./lt.js": 392,
	"./lv": 393,
	"./lv.js": 393,
	"./me": 394,
	"./me.js": 394,
	"./mi": 395,
	"./mi.js": 395,
	"./mk": 396,
	"./mk.js": 396,
	"./ml": 397,
	"./ml.js": 397,
	"./mn": 398,
	"./mn.js": 398,
	"./mr": 399,
	"./mr.js": 399,
	"./ms": 401,
	"./ms-my": 400,
	"./ms-my.js": 400,
	"./ms.js": 401,
	"./mt": 402,
	"./mt.js": 402,
	"./my": 403,
	"./my.js": 403,
	"./nb": 404,
	"./nb.js": 404,
	"./ne": 405,
	"./ne.js": 405,
	"./nl": 407,
	"./nl-be": 406,
	"./nl-be.js": 406,
	"./nl.js": 407,
	"./nn": 408,
	"./nn.js": 408,
	"./pa-in": 409,
	"./pa-in.js": 409,
	"./pl": 410,
	"./pl.js": 410,
	"./pt": 412,
	"./pt-br": 411,
	"./pt-br.js": 411,
	"./pt.js": 412,
	"./ro": 413,
	"./ro.js": 413,
	"./ru": 414,
	"./ru.js": 414,
	"./sd": 415,
	"./sd.js": 415,
	"./se": 416,
	"./se.js": 416,
	"./si": 417,
	"./si.js": 417,
	"./sk": 418,
	"./sk.js": 418,
	"./sl": 419,
	"./sl.js": 419,
	"./sq": 420,
	"./sq.js": 420,
	"./sr": 422,
	"./sr-cyrl": 421,
	"./sr-cyrl.js": 421,
	"./sr.js": 422,
	"./ss": 423,
	"./ss.js": 423,
	"./sv": 424,
	"./sv.js": 424,
	"./sw": 425,
	"./sw.js": 425,
	"./ta": 426,
	"./ta.js": 426,
	"./te": 427,
	"./te.js": 427,
	"./tet": 428,
	"./tet.js": 428,
	"./tg": 429,
	"./tg.js": 429,
	"./th": 430,
	"./th.js": 430,
	"./tl-ph": 431,
	"./tl-ph.js": 431,
	"./tlh": 432,
	"./tlh.js": 432,
	"./tr": 433,
	"./tr.js": 433,
	"./tzl": 434,
	"./tzl.js": 434,
	"./tzm": 436,
	"./tzm-latn": 435,
	"./tzm-latn.js": 435,
	"./tzm.js": 436,
	"./ug-cn": 437,
	"./ug-cn.js": 437,
	"./uk": 438,
	"./uk.js": 438,
	"./ur": 439,
	"./ur.js": 439,
	"./uz": 441,
	"./uz-latn": 440,
	"./uz-latn.js": 440,
	"./uz.js": 441,
	"./vi": 442,
	"./vi.js": 442,
	"./x-pseudo": 443,
	"./x-pseudo.js": 443,
	"./yo": 444,
	"./yo.js": 444,
	"./zh-cn": 445,
	"./zh-cn.js": 445,
	"./zh-hk": 446,
	"./zh-hk.js": 446,
	"./zh-tw": 447,
	"./zh-tw.js": 447
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1540;

/***/ }),
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */,
/* 1550 */,
/* 1551 */,
/* 1552 */,
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1086)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(470),
  /* template */
  __webpack_require__(1722),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(471),
  /* template */
  __webpack_require__(1669),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1051)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(472),
  /* template */
  __webpack_require__(1688),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6725a014",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(473),
  /* template */
  __webpack_require__(1707),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1075)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(474),
  /* template */
  __webpack_require__(1713),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9a81d124",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1076)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(475),
  /* template */
  __webpack_require__(1714),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9fb906fe",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1050)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(476),
  /* template */
  __webpack_require__(1687),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-650aa386",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1036)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(477),
  /* template */
  __webpack_require__(1673),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-46ec6f7c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1062)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(478),
  /* template */
  __webpack_require__(1699),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-77c91682",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1070)
  __webpack_require__(1071)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(479),
  /* template */
  __webpack_require__(1709),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-93aaba56",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1020)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(480),
  /* template */
  __webpack_require__(1659),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1b6ddafe",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1100)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(481),
  /* template */
  __webpack_require__(1733),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f54cbfc4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1008)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(482),
  /* template */
  __webpack_require__(1646),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-01cb79b0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1087)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(484),
  /* template */
  __webpack_require__(1723),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-be58ad74",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1018)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(485),
  /* template */
  __webpack_require__(1656),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-16f5d598",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1102)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(486),
  /* template */
  __webpack_require__(1736),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f9485686",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1045)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(487),
  /* template */
  __webpack_require__(1682),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-58b71bf8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1079)
}
var Component = __webpack_require__(3)(
  /* script */
  null,
  /* template */
  __webpack_require__(1716),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1097)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(488),
  /* template */
  __webpack_require__(1730),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e927c768",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1043)
}
var Component = __webpack_require__(3)(
  /* script */
  null,
  /* template */
  __webpack_require__(1680),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1083)
  __webpack_require__(1084)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(489),
  /* template */
  __webpack_require__(1720),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b5e52ff4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(490),
  /* template */
  __webpack_require__(1652),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1034)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(491),
  /* template */
  __webpack_require__(1671),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3f5e184e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1081)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(492),
  /* template */
  __webpack_require__(1718),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-abbfb1e6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1101)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(493),
  /* template */
  __webpack_require__(1735),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f92d4a34",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1072)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(494),
  /* template */
  __webpack_require__(1710),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9563d628",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1021)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(495),
  /* template */
  __webpack_require__(1660),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1d87b043",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1042)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(496),
  /* template */
  __webpack_require__(1679),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-559ff9cf",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1061)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(497),
  /* template */
  __webpack_require__(1698),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7394d6c2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1012)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(498),
  /* template */
  __webpack_require__(1649),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-04c963f4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1054)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(499),
  /* template */
  __webpack_require__(1691),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6b304d86",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1085)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(500),
  /* template */
  __webpack_require__(1721),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bd21c294",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1099)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(501),
  /* template */
  __webpack_require__(1732),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ecb0bf40",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1041)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(502),
  /* template */
  __webpack_require__(1678),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4a2e1f37",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1040)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(503),
  /* template */
  __webpack_require__(1677),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-48c21c08",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1055)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(504),
  /* template */
  __webpack_require__(1692),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1039)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(505),
  /* template */
  __webpack_require__(1676),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4876088e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1022)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(506),
  /* template */
  __webpack_require__(1661),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1e5ea545",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1073)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(507),
  /* template */
  __webpack_require__(1711),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-95799446",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1007)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(508),
  /* template */
  __webpack_require__(1645),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-00f97517",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1010)
  __webpack_require__(1011)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(509),
  /* template */
  __webpack_require__(1648),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0405896e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1057)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(510),
  /* template */
  __webpack_require__(1694),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6e0ba686",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1058)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(512),
  /* template */
  __webpack_require__(1695),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6e1dd5a8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1024)
  __webpack_require__(1025)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(513),
  /* template */
  __webpack_require__(1663),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-206e88c2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1027)
  __webpack_require__(1028)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(514),
  /* template */
  __webpack_require__(1665),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-283b1d37",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1089)
  __webpack_require__(1090)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(515),
  /* template */
  __webpack_require__(1725),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c4d1dada",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1030)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(516),
  /* template */
  __webpack_require__(1667),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-33283bf9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1096)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(517),
  /* template */
  __webpack_require__(1729),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d82dd8ec",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1059)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(518),
  /* template */
  __webpack_require__(1696),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-705234c1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1037)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(519),
  /* template */
  __webpack_require__(1674),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4756388a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1067)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(520),
  /* template */
  __webpack_require__(1705),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7ec1d1af",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1032)
  __webpack_require__(1033)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(521),
  /* template */
  __webpack_require__(1670),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3db9da06",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1080)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(522),
  /* template */
  __webpack_require__(1717),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a84486f0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1046)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(523),
  /* template */
  __webpack_require__(1683),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5a35de99",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(524),
  /* template */
  __webpack_require__(1734),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(525),
  /* template */
  __webpack_require__(1653),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(526),
  /* template */
  __webpack_require__(1701),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(527),
  /* template */
  __webpack_require__(1658),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1091)
  __webpack_require__(1092)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(528),
  /* template */
  __webpack_require__(1726),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ce3448ea",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1019)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(529),
  /* template */
  __webpack_require__(1657),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-175798e3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1069)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(530),
  /* template */
  __webpack_require__(1708),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9220755a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1016)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(531),
  /* template */
  __webpack_require__(1654),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-16d380c6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1048)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(532),
  /* template */
  __webpack_require__(1685),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-64d768d3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1026)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(533),
  /* template */
  __webpack_require__(1664),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-262816f8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1056)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(534),
  /* template */
  __webpack_require__(1693),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1093)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(535),
  /* template */
  __webpack_require__(1727),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d3e7cfbe",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1098)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(536),
  /* template */
  __webpack_require__(1731),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ec5786c6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1094)
  __webpack_require__(1095)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(538),
  /* template */
  __webpack_require__(1728),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d5b5a308",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1035)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(539),
  /* template */
  __webpack_require__(1672),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-401ccfe1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1077)
  __webpack_require__(1078)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(540),
  /* template */
  __webpack_require__(1715),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a04bcc46",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1068)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(542),
  /* template */
  __webpack_require__(1706),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-81acb4da",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1049)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(544),
  /* template */
  __webpack_require__(1686),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-64dc79cf",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1052)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(545),
  /* template */
  __webpack_require__(1689),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-67d76aeb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1060)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(546),
  /* template */
  __webpack_require__(1697),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-721540f6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1031)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(547),
  /* template */
  __webpack_require__(1668),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3a84faeb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1088)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(548),
  /* template */
  __webpack_require__(1724),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c098cfa6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1038)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(549),
  /* template */
  __webpack_require__(1675),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-481db255",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1014)
  __webpack_require__(1015)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(552),
  /* template */
  __webpack_require__(1651),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0b33b7a0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1009)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(553),
  /* template */
  __webpack_require__(1647),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-03557008",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1023)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(554),
  /* template */
  __webpack_require__(1662),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-20380c09",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1074)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(555),
  /* template */
  __webpack_require__(1712),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-980576d0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1082)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(556),
  /* template */
  __webpack_require__(1719),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ae03ad60",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1047)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(557),
  /* template */
  __webpack_require__(1684),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5f7eaf93",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1110)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(558),
  /* template */
  __webpack_require__(1744),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ffc09450",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1109)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(559),
  /* template */
  __webpack_require__(1743),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ffa4654e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1108)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(560),
  /* template */
  __webpack_require__(1742),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ff88364c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1107)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(561),
  /* template */
  __webpack_require__(1741),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ff6c074a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1106)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(562),
  /* template */
  __webpack_require__(1740),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ff4fd848",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1105)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(563),
  /* template */
  __webpack_require__(1739),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ff33a946",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1104)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(564),
  /* template */
  __webpack_require__(1738),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ff177a44",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1103)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(565),
  /* template */
  __webpack_require__(1737),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-fefb4b42",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1029)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(567),
  /* template */
  __webpack_require__(1666),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-29e82578",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1645 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\n    " + _vm._s(_vm.lang.RCC000) + "\n    "), (typeof _vm.resultCheckData.SurveyInstanceCount === 'number') ? _c('span', {
    class: {
      'text-red': _vm.checkCountExceeded
    },
    attrs: {
      "id": "checkCounterContainer"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.lang.RCC001) + ": " + _vm._s(_vm.resultCheckData.SurveyInstanceCount))]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkCountExceeded),
      expression: "checkCountExceeded"
    }],
    staticClass: "material-icons md-24"
  }, [_vm._v("warning")])]) : _vm._e(), _vm._v(" "), (_vm.checkCountExceeded) ? _c('b-tooltip', {
    attrs: {
      "target": "checkCounterContainer",
      "delay": _vm.globals.tooltipDelay,
      "boundary": "viewport",
      "placement": "bottom"
    }
  }, [_vm._v(_vm._s(_vm.lang.RCC021))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(!_vm.feature.isAudiTarget || !_vm.feature.isEnabled('audi_importers')) ? _c('div', {
    staticClass: "form-group col-md-12",
    attrs: {
      "id": "selectCheckFilterClientFormGroup"
    }
  }, [_c('select2', {
    ref: "clientSelect",
    attrs: {
      "id": "selectCheckFilterClient",
      "placeholder": ((_vm.lang.RCC002) + "..."),
      "allowClear": true
    },
    model: {
      value: (_vm.selectedClient),
      callback: function($$v) {
        _vm.selectedClient = $$v
      },
      expression: "selectedClient"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.clientList), function(client) {
    return _c('option', {
      key: client.ClientGuid,
      domProps: {
        "value": client.ClientGuid
      }
    }, [_vm._v("\n          " + _vm._s(client.ClientName) + "\n        ")])
  })], 2), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "selectCheckFilterClientFormGroup",
      "boundary": "viewport",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.RCC002))])], 1) : _c('div', {
    staticClass: "form-group col-md-12",
    attrs: {
      "id": "selectCheckFilterImporterFormGroup"
    }
  }, [_c('select2', {
    ref: "importerSelect",
    attrs: {
      "id": "selectCheckFilterImporter",
      "placeholder": ((_vm.lang.RCC022) + "..."),
      "allowClear": true
    },
    on: {
      "change": function($event) {
        _vm.selectedWave && _vm.getCheckFilterResult()
      }
    },
    model: {
      value: (_vm.selectedImporter),
      callback: function($$v) {
        _vm.selectedImporter = $$v
      },
      expression: "selectedImporter"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.importerList), function(importer) {
    return _c('option', {
      key: importer.ImporterGuid,
      domProps: {
        "value": importer.ImporterGuid
      }
    }, [_vm._v("\n          " + _vm._s(importer.ImporterName) + "\n        ")])
  })], 2), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "selectCheckFilterImporterFormGroup",
      "boundary": "viewport",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.RCC022))])], 1), _vm._v(" "), (_vm.selectedClient) ? _c('div', {
    staticClass: "form-group col-md-6",
    attrs: {
      "id": "selectCheckFilterProjectFormGroup"
    }
  }, [_c('select2', {
    ref: "projectSelect",
    attrs: {
      "id": "selectCheckFilterProject",
      "placeholder": ((_vm.lang.RCC003) + "..."),
      "allowClear": true
    },
    model: {
      value: (_vm.selectedProject),
      callback: function($$v) {
        _vm.selectedProject = $$v
      },
      expression: "selectedProject"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.projectsOfSelectedClient), function(project) {
    return _c('option', {
      key: project.ProjectGuid,
      domProps: {
        "value": project.ProjectGuid
      }
    }, [_vm._v("\n          " + _vm._s(project.ProjectName) + "\n        ")])
  })], 2), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "selectCheckFilterProjectFormGroup",
      "boundary": "viewport",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.RCC003))])], 1) : _vm._e(), _vm._v(" "), (_vm.selectedProject) ? _c('div', {
    staticClass: "form-group col-md-6",
    attrs: {
      "id": "selectCheckFilterWaveFormGroup"
    }
  }, [_c('select2', {
    ref: "waveSelect",
    attrs: {
      "id": "selectCheckFilterWave",
      "placeholder": ((_vm.lang.RCC004) + "..."),
      "allowClear": true
    },
    model: {
      value: (_vm.selectedWave),
      callback: function($$v) {
        _vm.selectedWave = $$v
      },
      expression: "selectedWave"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.wavesOfSelectedProject), function(wave) {
    return _c('option', {
      key: wave.WaveGuid,
      domProps: {
        "value": wave.WaveGuid
      }
    }, [_vm._v("\n          " + _vm._s(wave.WaveName) + "\n        ")])
  })], 2), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "selectCheckFilterWaveFormGroup",
      "boundary": "viewport",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.RCC004))])], 1) : _vm._e(), _vm._v(" "), (_vm.selectedWave) ? [_vm._l((_vm.dynamicFilters), function(filter, index) {
    return _c('div', {
      key: index,
      staticClass: "form-group form-group-dynamic"
    }, [_c('div', {
      staticClass: "form-group col-md-3",
      attrs: {
        "id": ("selectCheckFilterDynamicTypeFormGroup" + index)
      }
    }, [_c('select2', {
      ref: ("filterTypeSelect" + index),
      refInFor: true,
      attrs: {
        "id": ("selectCheckFilterDynamicType" + index),
        "placeholder": ((_vm.lang.RCC005) + "..."),
        "allowClear": true
      },
      on: {
        "change": function($event) {
          return _vm.dynamicFilterTypeChanged(filter)
        }
      },
      model: {
        value: (filter.Type),
        callback: function($$v) {
          _vm.$set(filter, "Type", $$v)
        },
        expression: "filter.Type"
      }
    }, _vm._l((_vm.filterTypes), function(type, idx) {
      return _c('option', {
        key: idx,
        attrs: {
          "disabled": !_vm.isTypeEnabled(type, filter)
        },
        domProps: {
          "value": type
        }
      }, [_vm._v("\n              " + _vm._s(_vm.getTranslationFor(type)) + "\n            ")])
    }), 0), _vm._v(" "), _c('b-tooltip', {
      attrs: {
        "target": ("selectCheckFilterDynamicTypeFormGroup" + index),
        "boundary": "viewport",
        "triggers": "hover",
        "delay": _vm.globals.tooltipDelay
      }
    }, [_vm._v(_vm._s(_vm.lang.RCC006))])], 1), _vm._v(" "), (filter.secondLevelSelectVisible) ? _c('div', {
      staticClass: "form-group col-md-8",
      attrs: {
        "id": ("selectCheckFilterDynamicValueFormGroup" + index)
      }
    }, [_c('select2', {
      ref: ("secondLevelSelect" + index),
      refInFor: true,
      attrs: {
        "id": ("selectCheckFilterDynamicValue" + index),
        "placeholder": ((_vm.lang.RCC005) + "..."),
        "allowClear": true,
        "multiple": filter.Type !== 'LocationProperty',
        "tags": filter.Type === 'City' || filter.Type === 'PostalCode',
        "noResultsString": filter.Type === 'City' || filter.Type === 'PostalCode' ?
          _vm.lang.RCC019 :
          undefined
      },
      on: {
        "change": function($event) {
          return _vm.dynamicFilterValueChanged(filter)
        }
      },
      model: {
        value: (filter.Value),
        callback: function($$v) {
          _vm.$set(filter, "Value", $$v)
        },
        expression: "filter.Value"
      }
    }, [(filter.Type === 'City') ? _vm._l((filter.currentDynamicFilterValues), function(value, idx) {
      return _c('option', {
        key: idx,
        domProps: {
          "value": value.City
        }
      }, [_vm._v("\n                " + _vm._s(value.City) + "\n              ")])
    }) : (filter.Type === 'Country') ? _vm._l((filter.currentDynamicFilterValues), function(value) {
      return _c('option', {
        key: value[((filter.Type) + "Code")],
        domProps: {
          "value": value[((filter.Type) + "Code")]
        }
      }, [_vm._v("\n                " + _vm._s(value[((filter.Type) + "Name")]) + "\n              ")])
    }) : (filter.Type === 'Status') ? _vm._l((filter.currentDynamicFilterValues), function(value, idx) {
      return _c('option', {
        key: idx,
        domProps: {
          "value": value
        }
      }, [_vm._v("\n                " + _vm._s(_vm.getTranslationFor(value)) + "\n              ")])
    }) : _vm._l((filter.currentDynamicFilterValues), function(value) {
      return _c('option', {
        key: value[((filter.Type) + "Guid")],
        attrs: {
          "disabled": _vm.propertyAlreadyUsed(value[((filter.Type) + "Guid")])
        },
        domProps: {
          "value": value[((filter.Type) + "Guid")]
        }
      }, [_vm._v("\n                " + _vm._s(value[((filter.Type) + "Name")]) + "\n              ")])
    })], 2), _vm._v(" "), _c('b-tooltip', {
      attrs: {
        "target": ("selectCheckFilterDynamicValueFormGroup" + index),
        "boundary": "viewport",
        "triggers": "hover",
        "delay": _vm.globals.tooltipDelay
      }
    }, [_vm._v(_vm._s(_vm.getTranslationFor(filter.Type)))])], 1) : _vm._e(), _vm._v(" "), (filter.thirdLevelSelectVisible) ? _c('div', {
      staticClass: "form-group col-md-11",
      attrs: {
        "id": ("selectCheckFilterDynamicValueValuesFormGroup" + index)
      }
    }, [_c('select2', {
      ref: ("thirdLevelSelect" + index),
      refInFor: true,
      attrs: {
        "id": ("selectCheckFilterDynamicValueValues" + index),
        "placeholder": ((_vm.lang.RCC005) + "..."),
        "allowClear": true,
        "multiple": true
      },
      on: {
        "change": function($event) {
          return _vm.getCheckFilterResult()
        }
      },
      model: {
        value: (filter.Subvalue),
        callback: function($$v) {
          _vm.$set(filter, "Subvalue", $$v)
        },
        expression: "filter.Subvalue"
      }
    }, _vm._l((filter.currentDynamicFilterValueValues), function(value) {
      return _c('option', {
        key: value[((filter.Type) + "Value")],
        domProps: {
          "value": value[((filter.Type) + "Value")]
        }
      }, [_vm._v("\n              " + _vm._s(value[((filter.Type) + "Value")]) + "\n            ")])
    }), 0), _vm._v(" "), _c('b-tooltip', {
      attrs: {
        "target": ("selectCheckFilterDynamicValueValuesFormGroup" + index),
        "boundary": "viewport",
        "triggers": "hover",
        "delay": _vm.globals.tooltipDelay
      }
    }, [_vm._v(_vm._s(_vm.lang.RCC007))])], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-md-1 pull-right",
      class: {
        'centerized-remove-button': filter.thirdLevelSelectVisible,
      }
    }, [_c('button', {
      staticClass: "btn btn-remove-filter",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeDynamicFilter(filter)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24 text-red"
    }, [_vm._v("clear")])])])])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-fab btn-fab-mini btn-default btn-add-filter",
    attrs: {
      "type": "button",
      "id": "addDynamicFilterButton",
      "disabled": _vm.isLastDynamicFilterEmpty()
    },
    on: {
      "click": function($event) {
        return _vm.addDynamicFilter()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36 text-green"
  }, [_vm._v("add")])]), _vm._v(" "), (!_vm.isLastDynamicFilterEmpty()) ? _c('b-tooltip', {
    attrs: {
      "target": "addDynamicFilterButton",
      "boundary": "viewport",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.RCC008))]) : _vm._e()] : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),
/* 1646 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "checkManagementFilterModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.CM1074))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-bordered"
  }, [_c('thead', [_c('tr', _vm._l((_vm.langShort), function(header, index) {
    return _c('th', {
      key: index,
      staticStyle: {
        "width": "90px"
      }
    }, [(header != 'Save' && header != 'Speichern') ? _c('div', [_vm._v("\n                      " + _vm._s(header) + "\n                    ")]) : _vm._e()])
  }), 0)]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.items.SID),
      expression: "items.SID"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.items.SID) ? _vm._i(_vm.items.SID, null) > -1 : (_vm.items.SID)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.items.SID,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.items, "SID", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.items, "SID", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.items, "SID", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.items.CheckID),
      expression: "items.CheckID"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.items.CheckID) ? _vm._i(_vm.items.CheckID, null) > -1 : (_vm.items.CheckID)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.items.CheckID,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.items, "CheckID", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.items, "CheckID", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.items, "CheckID", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.items.CheckCode),
      expression: "items.CheckCode"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.items.CheckCode) ? _vm._i(_vm.items.CheckCode, null) > -1 : (_vm.items.CheckCode)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.items.CheckCode,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.items, "CheckCode", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.items, "CheckCode", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.items, "CheckCode", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.items.Status),
      expression: "items.Status"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.items.Status) ? _vm._i(_vm.items.Status, null) > -1 : (_vm.items.Status)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.items.Status,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.items, "Status", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.items, "Status", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.items, "Status", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.items.Project),
      expression: "items.Project"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.items.Project) ? _vm._i(_vm.items.Project, null) > -1 : (_vm.items.Project)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.items.Project,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.items, "Project", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.items, "Project", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.items, "Project", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.items.Wave),
      expression: "items.Wave"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.items.Wave) ? _vm._i(_vm.items.Wave, null) > -1 : (_vm.items.Wave)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.items.Wave,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.items, "Wave", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.items, "Wave", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.items, "Wave", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.items.Scenario),
      expression: "items.Scenario"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.items.Scenario) ? _vm._i(_vm.items.Scenario, null) > -1 : (_vm.items.Scenario)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.items.Scenario,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.items, "Scenario", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.items, "Scenario", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.items, "Scenario", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.items.CheckInfo),
      expression: "items.CheckInfo"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.items.CheckInfo) ? _vm._i(_vm.items.CheckInfo, null) > -1 : (_vm.items.CheckInfo)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.items.CheckInfo,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.items, "CheckInfo", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.items, "CheckInfo", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.items, "CheckInfo", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.items.StoreID),
      expression: "items.StoreID"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.items.StoreID) ? _vm._i(_vm.items.StoreID, null) > -1 : (_vm.items.StoreID)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.items.StoreID,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.items, "StoreID", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.items, "StoreID", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.items, "StoreID", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.items.LocationName),
      expression: "items.LocationName"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.items.LocationName) ? _vm._i(_vm.items.LocationName, null) > -1 : (_vm.items.LocationName)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.items.LocationName,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.items, "LocationName", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.items, "LocationName", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.items, "LocationName", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.items.Address),
      expression: "items.Address"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.items.Address) ? _vm._i(_vm.items.Address, null) > -1 : (_vm.items.Address)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.items.Address,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.items, "Address", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.items, "Address", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.items, "Address", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.items.Country),
      expression: "items.Country"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.items.Country) ? _vm._i(_vm.items.Country, null) > -1 : (_vm.items.Country)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.items.Country,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.items, "Country", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.items, "Country", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.items, "Country", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.items.Visit),
      expression: "items.Visit"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.items.Visit) ? _vm._i(_vm.items.Visit, null) > -1 : (_vm.items.Visit)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.items.Visit,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.items, "Visit", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.items, "Visit", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.items, "Visit", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.items.Internalnote),
      expression: "items.Internalnote"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.items.Internalnote) ? _vm._i(_vm.items.Internalnote, null) > -1 : (_vm.items.Internalnote)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.items.Internalnote,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.items, "Internalnote", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.items, "Internalnote", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.items, "Internalnote", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.items.ExpiryDate),
      expression: "items.ExpiryDate"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.items.ExpiryDate) ? _vm._i(_vm.items.ExpiryDate, null) > -1 : (_vm.items.ExpiryDate)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.items.ExpiryDate,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.items, "ExpiryDate", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.items, "ExpiryDate", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.items, "ExpiryDate", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.items.Agency),
      expression: "items.Agency"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.items.Agency) ? _vm._i(_vm.items.Agency, null) > -1 : (_vm.items.Agency)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.items.Agency,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.items, "Agency", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.items, "Agency", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.items, "Agency", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.items.Shopper),
      expression: "items.Shopper"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.items.Shopper) ? _vm._i(_vm.items.Shopper, null) > -1 : (_vm.items.Shopper)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.items.Shopper,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.items, "Shopper", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.items, "Shopper", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.items, "Shopper", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.items.Score),
      expression: "items.Score"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.items.Score) ? _vm._i(_vm.items.Score, null) > -1 : (_vm.items.Score)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.items.Score,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.items, "Score", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.items, "Score", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.items, "Score", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.items.Progress),
      expression: "items.Progress"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.items.Progress) ? _vm._i(_vm.items.Progress, null) > -1 : (_vm.items.Progress)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.items.Progress,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.items, "Progress", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.items, "Progress", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.items, "Progress", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.items.Modifiedat),
      expression: "items.Modifiedat"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.items.Modifiedat) ? _vm._i(_vm.items.Modifiedat, null) > -1 : (_vm.items.Modifiedat)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.items.Modifiedat,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.items, "Modifiedat", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.items, "Modifiedat", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.items, "Modifiedat", $$c)
        }
      }
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveCustomSettingsList()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.CM1026) + "\n          ")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1647 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "dialog-table-panel background"
  }, [(_vm.selectedClient) ? _c('div', {
    staticClass: "dialog-table-panel"
  }, [_c('table', {
    staticClass: "table table-striped table-hover main-table",
    staticStyle: {
      "overflow-y": "unset"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center w40"
  }, [_vm._v(_vm._s(_vm.lang.S0170))]), _vm._v(" "), _c('th', {
    staticClass: "text-center w60"
  }, [_vm._v(_vm._s(_vm.lang.S0171))])])]), _vm._v(" "), _c('tbody', {
    staticClass: "main-table-scrollbar client-policies-table"
  }, _vm._l((_vm.customPropertyValuePairs), function(property, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "td-cb-policies w40 moreheadroom"
    }, [_c('a', {
      staticClass: "table-header",
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.togglePermitted(property)
        }
      }
    }, [_vm._v(_vm._s(property.LocationPropertyName))])]), _vm._v(" "), _c('td', {
      staticClass: "w60",
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('div', {
      staticClass: "reset-this"
    }, [_c('treeselect', {
      attrs: {
        "placeholder": _vm.lang.S0041,
        "options": property.LocationPropertyValues,
        "load-options": function () {},
        "auto-load-root-options": false,
        "multiple": true,
        "limit": 5,
        "searchable": true,
        "showCount": true,
        "flat": true,
        "valueFormat": "id",
        "showCountOf": "LEAF_DESCENDANTS",
        "disabled": !property.LocationPropertyValues
      },
      model: {
        value: (property.SelectedItems),
        callback: function($$v) {
          _vm.$set(property, "SelectedItems", $$v)
        },
        expression: "property.SelectedItems"
      }
    })], 1)])])
  }), 0)])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 1648 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mapInitDone),
      expression: "mapInitDone"
    }],
    staticClass: "map-controls-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchString),
      expression: "searchString"
    }],
    staticClass: "controls gmaps-input",
    attrs: {
      "id": "gmapsSearchInput",
      "type": "text",
      "placeholder": _vm.lang.RCM000
    },
    domProps: {
      "value": (_vm.searchString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchString = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.currentMapRadius),
      expression: "currentMapRadius",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "controls gmaps-input",
    attrs: {
      "id": "gmapsRadiusInput",
      "type": "number",
      "step": "1",
      "min": "0",
      "max": "9999"
    },
    domProps: {
      "value": (_vm.currentMapRadius)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.currentMapRadius = _vm._n($event.target.value)
      }, function($event) {
        return _vm.currentMapRadiusChanged()
      }],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "material-icons md-24 help-icon",
    attrs: {
      "id": "gmapsHelpIcon"
    }
  }, [_vm._v("help")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons md-24 search-icon",
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
      },
      "click": function($event) {
        return _vm.searchLocation()
      }
    }
  }, [_vm._v("search")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons md-24 radius-icon",
    attrs: {
      "id": "gmapsRadiusVisibilityIcon"
    },
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
      },
      "click": function($event) {
        return _vm.changeMapRadiusVisibility()
      }
    }
  }, [_vm._v(_vm._s(_vm.isMapRadiusVisible ? "radio_button_unchecked" : "block"))]), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "gmapsRadiusInput",
      "boundary": "viewport",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.RCM001))]), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "gmapsRadiusVisibilityIcon",
      "boundary": "viewport",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.RCM002))]), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "gmapsHelpIcon",
      "boundary": "viewport",
      "triggers": "hover",
      "placement": "bottomleft",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_c('div', {
    staticClass: "tooltip-div"
  }, [_c('img', {
    attrs: {
      "src": _vm.iconMarkerFactory('shopper').url,
      "height": "35",
      "width": "35"
    }
  }), _vm._v("\n        → " + _vm._s(_vm.lang.RCM010) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "tooltip-div"
  }, [_c('img', {
    attrs: {
      "src": _vm.iconMarkerFactory('NOT_ASSIGNED').url,
      "height": "35",
      "width": "35"
    }
  }), _vm._v("\n        → " + _vm._s(_vm.lang.RCM013) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "tooltip-div"
  }, [_c('img', {
    attrs: {
      "src": _vm.iconMarkerFactory('ASSIGNED_NO_ANSWER').url,
      "height": "35",
      "width": "35"
    }
  }), _vm._v("\n        → " + _vm._s(_vm.lang.RCM011) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "tooltip-div"
  }, [_c('img', {
    attrs: {
      "src": _vm.iconMarkerFactory('ASSIGNED_WITH_ANSWER').url,
      "height": "35",
      "width": "35"
    }
  }), _vm._v("\n        → " + _vm._s(_vm.lang.RCM012) + "\n      ")])])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "gmaps-container"
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1649 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "importLocationsModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.LIM000))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', [(_vm.clientList.length > 1) ? _c('div', {
    staticClass: "form-group fg-client-select"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "locationImportClientSelect"
    }
  }, [_vm._v(_vm._s(_vm.lang.LIM010))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "locationImportClientSelect",
      "placeholder": _vm.lang.LIM010
    },
    model: {
      value: (_vm.selectedClient),
      callback: function($$v) {
        _vm.selectedClient = $$v
      },
      expression: "selectedClient"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.clientList), function(client) {
    return _c('option', {
      key: client.ClientGuid,
      domProps: {
        "value": client.ClientGuid
      }
    }, [_vm._v("\n                  " + _vm._s(client.ClientName) + "\n                ")])
  })], 2)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('ul', {
    staticClass: "nav nav-tabs nav-import",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#textImport",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.importOption = 'text'
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.LIM001))])]), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Upload_Create')) ? _c('li', [_c('a', {
    attrs: {
      "href": "#fileImport",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.importOption = 'file'
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.LIM002))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tab-content",
    attrs: {
      "id": "importTabContent"
    }
  }, [_c('div', {
    staticClass: "tab-pane fade active in",
    attrs: {
      "id": "textImport"
    }
  }, [_c('label', {
    staticClass: "col-md-1 control-label",
    attrs: {
      "for": "textAreaImport"
    }
  }, [_vm._v(_vm._s(_vm.lang.LIM003))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-11"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.importText),
      expression: "importText"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "7",
      "id": "textAreaImport"
    },
    domProps: {
      "value": (_vm.importText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.importText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.lang.LIM004))])]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.trimImportData = !_vm.trimImportData
      }
    }
  }, [(_vm.trimImportData) ? _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box")]) : _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]), _vm._v("\n                  " + _vm._s(_vm.lang.LIM009) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "fileImport"
    }
  }, [_c('label', {
    staticClass: "col-md-1 control-label",
    attrs: {
      "for": "inputFileImport"
    }
  }, [_vm._v(_vm._s(_vm.lang.LIM005))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-11"
  }, [_c('input', {
    staticClass: "form-control nopadding",
    attrs: {
      "id": "locationImportFileInput",
      "type": "file",
      "accept": ".xlsx"
    },
    on: {
      "change": _vm.onImportFileChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [(!_vm.selectedFile.name) ? _c('label', [_vm._v(_vm._s(_vm.lang.LIM006))]) : _c('label', [_vm._v(_vm._s(_vm.selectedFile.name))]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-11"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "btn",
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.trimImportData = !_vm.trimImportData
      }
    }
  }, [(_vm.trimImportData) ? _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box")]) : _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]), _vm._v("\n                    " + _vm._s(_vm.lang.LIM009) + "\n                  ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.LIM007) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.uploadImportData()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.LIM008) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn input-group-sm"
  }, [_c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("attach_file")])])])
}]}

/***/ }),
/* 1650 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stat-indicator"
  }, [_c('div', {
    staticClass: "stat-indicator-ring",
    style: (_vm.box)
  }, [(_vm.showRing) ? _c('svg', {
    staticClass: "stat-indicator-svg-rot",
    attrs: {
      "width": _vm.size,
      "height": _vm.size
    }
  }, [_c('circle', {
    attrs: {
      "cx": _vm.size / 2,
      "cy": _vm.size / 2,
      "r": _vm.r,
      "stroke": _vm.trackColor,
      "stroke-width": _vm.stroke,
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "stat-indicator-ring-anim",
    attrs: {
      "cx": _vm.size / 2,
      "cy": _vm.size / 2,
      "r": _vm.r,
      "stroke": _vm.ringColor,
      "stroke-width": _vm.stroke,
      "fill": "none",
      "stroke-dasharray": _vm.dashArray,
      "stroke-dashoffset": _vm.dashOffset,
      "stroke-linecap": "round"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.showSquare) ? _c('div', {
    staticClass: "stat-indicator-square",
    style: (("height: " + (_vm.size * 0.8) + "px; width: " + (_vm.size * 1.1) + "px"))
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "stat-indicator-center"
  }, [_vm._v(_vm._s(_vm.centerText_computed) + _vm._s(_vm.suffix))])]), _vm._v(" "), _c('span', {
    staticClass: "stat-indicator-label"
  }, [_vm._v(_vm._s(_vm.label))])])
},staticRenderFns: []}

/***/ }),
/* 1651 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.globals.isAccessAllowed('LoopOp_SecurityUsers_ReadAll')) ? _c('div', [_c('ImportUsersModal', {
    attrs: {
      "showDialog": _vm.showImportUsersDialog,
      "userTypeList": _vm.userTypeList,
      "clientList": _vm.clientList,
      "agencyList": _vm.agencyList
    },
    on: {
      "dialogClosed": function($event) {
        _vm.showImportUsersDialog = false
      }
    }
  }), _vm._v(" "), _c('confirmation-dialog', {
    attrs: {
      "dialogId": 'UserManagementExportUsersConfirmation',
      "confirmationTitle": _vm.lang.S0180,
      "yesButtonText": _vm.lang.S0181,
      "noButtonText": _vm.lang.S0182,
      "showDialog": _vm.showExportDialog
    },
    on: {
      "onYesConfirmation": _vm.exportUsers,
      "dialogClosed": function($event) {
        _vm.showExportDialog = false
      }
    }
  }, [
    [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-md-2 control-label",
      attrs: {
        "for": "exportUsersUserTypeSelect"
      }
    }, [_vm._v(_vm._s(_vm.lang.S0183))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-10"
    }, [_c('select2', {
      staticClass: "form-control",
      attrs: {
        "id": "exportUsersUserTypeSelect",
        "placeholder": _vm.lang.S0184,
        "allowClear": true
      },
      model: {
        value: (_vm.exportUsersDialogData.UserTypeId),
        callback: function($$v) {
          _vm.$set(_vm.exportUsersDialogData, "UserTypeId", $$v)
        },
        expression: "exportUsersDialogData.UserTypeId"
      }
    }, [_c('option'), _vm._v(" "), _vm._l((_vm.userTypeList), function(type, idx) {
      return _c('option', {
        key: idx,
        domProps: {
          "value": idx
        }
      }, [_vm._v("\n              " + _vm._s(type) + "\n            ")])
    })], 2)], 1)]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (
          _vm.exportUsersDialogData.UserTypeId == 4 && !this.feature.isAudiTarget
        ),
        expression: "\n          exportUsersDialogData.UserTypeId == 4 && !this.feature.isAudiTarget\n        "
      }],
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-md-2 control-label",
      attrs: {
        "for": "exportUsersClientSelect"
      }
    }, [_vm._v(_vm._s(_vm.lang.S0185))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-10"
    }, [_c('select2', {
      staticClass: "form-control",
      attrs: {
        "id": "exportUsersClientSelect",
        "placeholder": _vm.lang.S0186,
        "allowClear": true
      },
      model: {
        value: (_vm.exportUsersDialogData.ClientId),
        callback: function($$v) {
          _vm.$set(_vm.exportUsersDialogData, "ClientId", $$v)
        },
        expression: "exportUsersDialogData.ClientId"
      }
    }, [_c('option'), _vm._v(" "), _vm._l((_vm.clientList), function(client) {
      return _c('option', {
        key: client.ClientId,
        domProps: {
          "value": client.ClientId
        }
      }, [_vm._v("\n              " + _vm._s(client.ClientName) + "\n            ")])
    })], 2)], 1)]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.exportUsersDialogData.UserTypeId == 2),
        expression: "exportUsersDialogData.UserTypeId == 2"
      }],
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-md-2 control-label",
      attrs: {
        "for": "exportUsersAgencySelect"
      }
    }, [_vm._v(_vm._s(_vm.lang.S0187))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-10"
    }, [_c('select2', {
      staticClass: "form-control",
      attrs: {
        "id": "exportUsersAgencySelect",
        "placeholder": _vm.lang.S0188,
        "allowClear": true
      },
      model: {
        value: (_vm.exportUsersDialogData.AgencyId),
        callback: function($$v) {
          _vm.$set(_vm.exportUsersDialogData, "AgencyId", $$v)
        },
        expression: "exportUsersDialogData.AgencyId"
      }
    }, [_c('option'), _vm._v(" "), _vm._l((_vm.agencyList), function(agency) {
      return _c('option', {
        key: agency.AgencyGuid,
        domProps: {
          "value": agency.AgencyId
        }
      }, [_vm._v("\n              " + _vm._s(agency.AgencyName) + "\n            ")])
    })], 2)], 1)])]
  ], 2), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "users-top-panel"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "user-management-refresh-button",
      "disabled": !_vm.refreshEnabled
    },
    on: {
      "click": function($event) {
        return _vm.getUserData()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("refresh")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.S0000) + "\n        ")]), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_SecurityUsers_Create')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "user-management-create-button"
    },
    on: {
      "click": function($event) {
        (_vm.selectedUser = ''), _vm.openEditUserDialog('create')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("add_box")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.S0001) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_SecurityUsers_Read')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "user-management-edit-button",
      "disabled": !_vm.selectedUser
    },
    on: {
      "click": function($event) {
        return _vm.openEditUserDialog('edit')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("edit")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.S0002) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_SecurityUsers_Create')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.selectedUser
    },
    on: {
      "click": function($event) {
        _vm.openEditUserDialog('edit'), (_vm.copyUser = true)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("content_copy")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.S0146) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_SecurityUsers_Delete')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "user-management-delete-button",
      "disabled": !_vm.selectedUser
    },
    on: {
      "click": function($event) {
        return _vm.openDeleteUserDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("clear")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.S0083) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_SecurityGroups_ReadAll')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.selectedUser
    },
    on: {
      "click": function($event) {
        return _vm.openSecurityDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("lock")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.S0003) + "\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.globals.isAgencyUser) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.selectedUserData.ClientGuid
    },
    on: {
      "click": function($event) {
        return _vm.openSecurity2Dialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("lock")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.S0138) + "\n        ")]) : _vm._e(), _vm._v(" "), (
    _vm.globals.isAccessAllowed('LoopOp_Password_ChangePassword') &&
    _vm.globals.isAccessAllowed('LoopOp_Password_ValidatePassword')
  ) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.selectedUser
    },
    on: {
      "click": function($event) {
        return _vm.openChangePasswordDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("vpn_key")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.S0062) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_SecurityUsersExport_Create')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    on: {
      "click": function($event) {
        _vm.showExportDialog = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("file_download")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.S0134) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_SecurityUsersImport_Create')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    on: {
      "click": function($event) {
        _vm.showImportUsersDialog = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("publish")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.S0135) + "\n        ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-lg-7"
  }, [_c('div', {
    staticClass: "form-group searchbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Search),
      expression: "filterStrings.Search"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "search",
      "id": "inputSearch",
      "placeholder": _vm.lang.S0004
    },
    domProps: {
      "value": (_vm.filterStrings.Search)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getUserData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Search", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5 nopadding"
  }, [_c('ul', {
    staticClass: "pagination-fonts pagination btn-group"
  }, [_c('li', [_vm._m(0), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "elementsPerPageDropdown",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.S0005))]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 20
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 20)
      }
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 50
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 50)
      }
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 100
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 100)
      }
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 200
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 200)
      }
    }
  }, [_vm._v("200")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 500
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 500)
      }
    }
  }, [_vm._v("500")])])])], 1), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.pageCount || _vm.selectedPage == 1
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 0)
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "firstPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.S0006))])], 1), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage > 4) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getVisiblePages()), function(pageNumber) {
    return _c('li', {
      key: pageNumber,
      class: {
        active: _vm.selectedPage == pageNumber
      },
      on: {
        "click": function($event) {
          return _vm.updatePaging(pageNumber, 0)
        }
      }
    }, [_c('a', {
      attrs: {
        "role": "button"
      }
    }, [_vm._v(_vm._s(pageNumber))])])
  }), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage < _vm.pageCount - 3) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.pageCount || _vm.selectedPage == _vm.pageCount,
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(_vm.pageCount, 0)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "lastPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.S0007))])], 1), _vm._v(" "), _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button",
      "id": "usersTotalElementsCounter"
    }
  }, [_vm._v(_vm._s(_vm.totalElementsCount))]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "usersTotalElementsCounter",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.S0200))])], 1)], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    staticClass: "table table-striped table-hover main-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "9%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortUserData('UserType')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.S0009) + "\n                "), (_vm.sortField == 'UserType' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'UserType' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "9%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortUserData('SecurityRole')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.S0133) + "\n                "), (_vm.sortField == 'SecurityRole' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'SecurityRole' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortUserData('Active')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.S0163) + "\n                "), (_vm.sortField == 'Active' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'Active' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "9%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortUserData('Company')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.S0160) + "\n                "), (_vm.sortField == 'Company' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'Company' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "9%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortUserData('LoginName')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.S0010) + "\n                "), (_vm.sortField == 'LoginName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'LoginName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "9%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortUserData('FirstName')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.S0011) + "\n                "), (_vm.sortField == 'FirstName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'FirstName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortUserData('LastName')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.S0012) + "\n                "), (_vm.sortField == 'LastName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'LastName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "9%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortUserData('Gender')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.S0013) + "\n                "), (_vm.sortField == 'Gender' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'Gender' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "9%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortUserData('City')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.S0014) + "\n                "), (_vm.sortField == 'City' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'City' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "9%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortUserData('Country')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.S0016) + "\n                "), (_vm.sortField == 'Country' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'Country' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "13%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortUserData('Email')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.S0017) + "\n                "), (_vm.sortField == 'Email' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'Email' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])])]), _vm._v(" "), _c('tr', {
    staticClass: "table-filters"
  }, [_c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "9%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.UserType),
      expression: "filterStrings.UserType"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.S0018
    },
    domProps: {
      "value": (_vm.filterStrings.UserType)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getUserData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "UserType", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "9%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SecurityRole),
      expression: "filterStrings.SecurityRole"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.S0018
    },
    domProps: {
      "value": (_vm.filterStrings.SecurityRole)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getUserData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SecurityRole", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        (_vm.filterStrings.Active = (_vm.filterStrings.Active + 1) % 3),
        _vm.getUserData()
      }
    }
  }, [(_vm.filterStrings.Active == 1) ? _c('div', {
    staticClass: "cb-active-filter-container"
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box")])]) : (_vm.filterStrings.Active == 0) ? _c('div', {
    staticClass: "cb-active-filter-container"
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")])]) : _c('div', {
    staticClass: "cb-active-filter-container"
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("indeterminate_check_box")])])])])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "9%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Company),
      expression: "filterStrings.Company"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.S0018
    },
    domProps: {
      "value": (_vm.filterStrings.Company)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getUserData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Company", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "9%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LoginName),
      expression: "filterStrings.LoginName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.S0018
    },
    domProps: {
      "value": (_vm.filterStrings.LoginName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getUserData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LoginName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "9%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.FirstName),
      expression: "filterStrings.FirstName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.S0018
    },
    domProps: {
      "value": (_vm.filterStrings.FirstName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getUserData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "FirstName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LastName),
      expression: "filterStrings.LastName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.S0018
    },
    domProps: {
      "value": (_vm.filterStrings.LastName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getUserData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LastName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "9%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Gender),
      expression: "filterStrings.Gender"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.S0018
    },
    domProps: {
      "value": (_vm.filterStrings.Gender)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getUserData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Gender", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "9%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.City),
      expression: "filterStrings.City"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.S0018
    },
    domProps: {
      "value": (_vm.filterStrings.City)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getUserData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "City", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "9%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Country),
      expression: "filterStrings.Country"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.S0018
    },
    domProps: {
      "value": (_vm.filterStrings.Country)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getUserData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Country", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "13%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Email),
      expression: "filterStrings.Email"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.S0018
    },
    domProps: {
      "value": (_vm.filterStrings.Email)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getUserData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Email", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('tbody', {
    staticClass: "main-table-scrollbar"
  }, _vm._l((_vm.userData), function(user) {
    return _c('tr', {
      key: user.UserId,
      class: {
        info: user.UserId == _vm.selectedUser
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          (_vm.selectedUser = user.UserId), (_vm.selectedUserData = user)
        },
        "dblclick": function($event) {
          !_vm.globals.isAccessAllowed('LoopOp_SecurityUsers_Read') ||
            _vm.openEditUserDialog('edit')
        }
      }
    }, [_c('td', {
      staticStyle: {
        "width": "9%"
      }
    }, [_vm._v(_vm._s(user.UserType))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "9%"
      }
    }, [_vm._v(_vm._s(user.SecurityRole))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "5%",
        "padding": "6px 0 0 0"
      }
    }, [(user.Active) ? _c('i', {
      staticClass: "material-icons md-24 user-active"
    }, [_vm._v("done")]) : _c('i', {
      staticClass: "material-icons md-24 user-inactive"
    }, [_vm._v("clear")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "9%"
      }
    }, [_vm._v(_vm._s(user.Company))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "9%"
      }
    }, [_vm._v(_vm._s(user.LoginName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "9%"
      }
    }, [_vm._v(_vm._s(user.FirstName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(user.LastName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "9%"
      }
    }, [_vm._v(_vm._s(user.Gender))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "9%"
      }
    }, [_vm._v(_vm._s(user.City))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "9%"
      }
    }, [_vm._v(_vm._s(user.Country))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "13%"
      }
    }, [_vm._v(_vm._s(user.Email))])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "editUser",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.editUserDialogData.dialogTitle))])]), _vm._v(" "), (typeof _vm.editUserDialogData.userData.UserId != 'undefined') ? _c('div', [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("ID: " + _vm._s(_vm.editUserDialogData.userData.UserId))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel-group",
    attrs: {
      "id": "accordion",
      "role": "tablist",
      "aria-multiselectable": "true"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingGeneral",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseGeneral",
      "aria-expanded": "true",
      "aria-controls": "collapseGeneral"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.S0019))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in",
    attrs: {
      "id": "collapseGeneral",
      "role": "tabpanel",
      "aria-labelledby": "headingGeneral"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputLoginName"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0020) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.LoginName),
      expression: "editUserDialogData.userData.LoginName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputLoginName",
      "name": "inputLoginName",
      "required": ""
    },
    domProps: {
      "value": (_vm.editUserDialogData.userData.LoginName)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputLoginName')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "LoginName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputLoginName')),
      expression: "inputHasError('inputLoginName')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.S0095))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputFirstName"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0022) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.FirstName),
      expression: "editUserDialogData.userData.FirstName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputFirstName",
      "name": "inputFirstName",
      "required": ""
    },
    domProps: {
      "value": (_vm.editUserDialogData.userData.FirstName)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputFirstName')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "FirstName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputFirstName')),
      expression: "inputHasError('inputFirstName')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.S0095))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputLastName"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0023) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.LastName),
      expression: "editUserDialogData.userData.LastName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputLastName",
      "name": "inputLastName",
      "required": ""
    },
    domProps: {
      "value": (_vm.editUserDialogData.userData.LastName)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputLastName')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "LastName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputLastName')),
      expression: "inputHasError('inputLastName')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.S0095))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputCompanyName"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0024))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.CompanyName),
      expression: "editUserDialogData.userData.CompanyName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputCompanyName"
    },
    domProps: {
      "value": (_vm.editUserDialogData.userData.CompanyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "CompanyName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputGender"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0025))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.Gender),
      expression: "editUserDialogData.userData.Gender"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editUserDialogData.userData, "Gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "undefined",
      "disabled": "",
      "hidden": ""
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.S0041) + "\n                        ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "M"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0026))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "F"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0027))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputUserType"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0009))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (
        _vm.editUserDialogData.userData.UserTypeId
      ),
      expression: "\n                          editUserDialogData.userData.UserTypeId\n                        ",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.$set(_vm.editUserDialogData.userData, "UserTypeId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.userTypeIdChanged(), _vm.$forceUpdate()
      }]
    }
  }, _vm._l((_vm.userTypeList), function(type, id) {
    return _c('option', {
      key: id,
      domProps: {
        "value": id
      }
    }, [_vm._v("\n                          " + _vm._s(type) + "\n                        ")])
  }), 0)])]), _vm._v(" "), (_vm.editUserDialogData.userData.UserTypeId == 2) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "selectAgency"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0116) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.AgencyGuid),
      expression: "editUserDialogData.userData.AgencyGuid"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "selectAgency",
      "name": "selectAgency",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editUserDialogData.userData, "AgencyGuid", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.validateInput('selectAgency')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "undefined",
      "disabled": "",
      "hidden": ""
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.S0041) + "\n                        ")]), _vm._v(" "), _vm._l((_vm.agencyList), function(agency) {
    return _c('option', {
      key: agency.AgencyGuid,
      domProps: {
        "value": agency.AgencyGuid
      }
    }, [_vm._v("\n                          " + _vm._s(agency.AgencyName) + "\n                        ")])
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.editUserDialogData.userData.UserTypeId == 4) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "selectClient"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0111) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.editUserDialogData.userData.ClientId),
      expression: "editUserDialogData.userData.ClientId",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "selectClient",
      "name": "selectClient",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.$set(_vm.editUserDialogData.userData, "ClientId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.validateInput('selectClient')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "undefined",
      "disabled": "",
      "hidden": ""
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.S0041) + "\n                        ")]), _vm._v(" "), _vm._l((_vm.clientList), function(client) {
    return _c('option', {
      key: client.ClientId,
      domProps: {
        "value": client.ClientId
      }
    }, [_vm._v("\n                          " + _vm._s(client.ClientName) + "\n                        ")])
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.editUserDialogData.userData.UserTypeId != 999) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "editUserSelectSecurityRole"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0133) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.SecurityRoleId),
      expression: "editUserDialogData.userData.SecurityRoleId"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "editUserSelectSecurityRole",
      "name": "editUserSelectSecurityRole",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editUserDialogData.userData, "SecurityRoleId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.validateInput('editUserSelectSecurityRole')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "undefined",
      "disabled": "",
      "hidden": ""
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.S0041) + "\n                        ")]), _vm._v(" "), _vm._l((_vm.securityRoleList.filter(function (role) {
    return (
      role.UserTypeId ==
      _vm.editUserDialogData.userData.UserTypeId
    );
  })), function(role) {
    return _c('option', {
      key: role.RoleId,
      domProps: {
        "value": role.RoleId
      }
    }, [_vm._v("\n                          " + _vm._s(role.RoleName) + "\n                        ")])
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputLocalization"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0028))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.LanguageCode),
      expression: "editUserDialogData.userData.LanguageCode"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editUserDialogData.userData, "LanguageCode", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "undefined",
      "disabled": "",
      "hidden": ""
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.S0041) + "\n                        ")]), _vm._v(" "), _vm._l((_vm.languageList), function(language, id) {
    return _c('option', {
      key: id,
      domProps: {
        "value": id
      }
    }, [_vm._v("\n                          " + _vm._s(language) + "\n                        ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputDefaultWelcomePage"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0030))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editUserDialogData.userData.DefaultWelcomePage
      ),
      expression: "\n                          editUserDialogData.userData.DefaultWelcomePage\n                        "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputDefaultWelcomePage"
    },
    domProps: {
      "value": (
        _vm.editUserDialogData.userData.DefaultWelcomePage
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "DefaultWelcomePage", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "inputDefaultWelcomePage",
      "delay": _vm.globals.tooltipDelay,
      "placement": "right"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.S0031) + ":")]), _vm._v(" "), _c('br'), _vm._v("clientname.msmloop.com\n                      ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputDisabled"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0033))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.Active),
      expression: "editUserDialogData.userData.Active"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editUserDialogData.userData, "Active", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.$forceUpdate()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "true"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0034))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "false"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0035))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingContact",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseContact",
      "aria-expanded": "false",
      "aria-controls": "collapseContact"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.S0036))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseContact",
      "role": "tabpanel",
      "aria-labelledby": "headingContact"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputAddress1"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0037))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.Address1),
      expression: "editUserDialogData.userData.Address1"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputAddress1"
    },
    domProps: {
      "value": (_vm.editUserDialogData.userData.Address1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "Address1", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputAddress2"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0038))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.Address2),
      expression: "editUserDialogData.userData.Address2"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputAddress2"
    },
    domProps: {
      "value": (_vm.editUserDialogData.userData.Address2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "Address2", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputCity"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0039))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.City),
      expression: "editUserDialogData.userData.City"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputCity"
    },
    domProps: {
      "value": (_vm.editUserDialogData.userData.City)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "City", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputCountry"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0042))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.Country),
      expression: "editUserDialogData.userData.Country"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editUserDialogData.userData, "Country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.changedCountry(_vm.editUserDialogData.userData.Country)
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": 'undefined'
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.S0041) + "\n                        ")]), _vm._v(" "), _vm._l((_vm.globals.countryList), function(country, ISOCode) {
    return _c('option', {
      key: ISOCode,
      domProps: {
        "value": ISOCode
      }
    }, [_vm._v("\n                          " + _vm._s(country) + "\n                        ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputRegion"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0040))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.Region),
      expression: "editUserDialogData.userData.Region"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.editUserDialogData.currentRegions.length < 1
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editUserDialogData.userData, "Region", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(_vm.editUserDialogData.currentRegions.length > 0) ? _c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": 'undefined'
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.S0041) + "\n                        ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.editUserDialogData.currentRegions), function(region) {
    return _c('option', {
      key: region.Region,
      domProps: {
        "value": region.Region
      }
    }, [_vm._v("\n                          " + _vm._s(region.RegionName) + "\n                        ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputTimeZone"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0029))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.TimeZone),
      expression: "editUserDialogData.userData.TimeZone"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.editUserDialogData.currentTimeZones.length < 1
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editUserDialogData.userData, "TimeZone", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(
    _vm.editUserDialogData.currentTimeZones.length > 0
  ) ? _c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": 'undefined'
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.S0041) + "\n                        ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.editUserDialogData.currentTimeZones), function(tz) {
    return _c('option', {
      key: tz.TimeZoneId,
      domProps: {
        "value": tz.TimeZoneId
      }
    }, [_vm._v("\n                          " + _vm._s(tz.TimeZoneName) + "\n                        ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputPostalCode"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0043))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.PostalCode),
      expression: "editUserDialogData.userData.PostalCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputPostalCode"
    },
    domProps: {
      "value": (_vm.editUserDialogData.userData.PostalCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "PostalCode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-small"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputGeographyFromGeocoding_Lat"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0117))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editUserDialogData.userData
        .GeographyFromGeocoding_Lat
      ),
      expression: "\n                          editUserDialogData.userData\n                            .GeographyFromGeocoding_Lat\n                        "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "0.000001",
      "min": "-90",
      "max": "90",
      "id": "inputGeographyFromGeocoding_Lat"
    },
    domProps: {
      "value": (
        _vm.editUserDialogData.userData
        .GeographyFromGeocoding_Lat
      )
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "GeographyFromGeocoding_Lat", $event.target.value)
      }, function($event) {
        return _vm.validateInput('inputGeographyFromGeocoding_Lat')
      }]
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (
        _vm.inputHasError('inputGeographyFromGeocoding_Lat')
      ),
      expression: "\n                          inputHasError('inputGeographyFromGeocoding_Lat')\n                        "
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.S0122))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-small"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "GeographyFromGeocoding_Long"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0118))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editUserDialogData.userData
        .GeographyFromGeocoding_Long
      ),
      expression: "\n                          editUserDialogData.userData\n                            .GeographyFromGeocoding_Long\n                        "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "0.000001",
      "min": "-180",
      "max": "180",
      "id": "GeographyFromGeocoding_Long"
    },
    domProps: {
      "value": (
        _vm.editUserDialogData.userData
        .GeographyFromGeocoding_Long
      )
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "GeographyFromGeocoding_Long", $event.target.value)
      }, function($event) {
        return _vm.validateInput('GeographyFromGeocoding_Long')
      }]
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('GeographyFromGeocoding_Long')),
      expression: "inputHasError('GeographyFromGeocoding_Long')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.S0122))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-small"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "GeographyFromPostalCode_Lat"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0119))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editUserDialogData.userData
        .GeographyFromPostalCode_Lat
      ),
      expression: "\n                          editUserDialogData.userData\n                            .GeographyFromPostalCode_Lat\n                        "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "0.000001",
      "min": "-90",
      "max": "90",
      "id": "GeographyFromPostalCode_Lat"
    },
    domProps: {
      "value": (
        _vm.editUserDialogData.userData
        .GeographyFromPostalCode_Lat
      )
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "GeographyFromPostalCode_Lat", $event.target.value)
      }, function($event) {
        return _vm.validateInput('GeographyFromPostalCode_Lat')
      }]
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('GeographyFromPostalCode_Lat')),
      expression: "inputHasError('GeographyFromPostalCode_Lat')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.S0122))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-small"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "GeographyFromPostalCode_Long"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0120))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editUserDialogData.userData
        .GeographyFromPostalCode_Long
      ),
      expression: "\n                          editUserDialogData.userData\n                            .GeographyFromPostalCode_Long\n                        "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "0.000001",
      "min": "-180",
      "max": "180",
      "id": "GeographyFromPostalCode_Long"
    },
    domProps: {
      "value": (
        _vm.editUserDialogData.userData
        .GeographyFromPostalCode_Long
      )
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "GeographyFromPostalCode_Long", $event.target.value)
      }, function($event) {
        return _vm.validateInput('GeographyFromPostalCode_Long')
      }]
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('GeographyFromPostalCode_Long')),
      expression: "inputHasError('GeographyFromPostalCode_Long')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.S0122))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputDistanceUnit"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0121))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.DistanceUnit),
      expression: "editUserDialogData.userData.DistanceUnit"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editUserDialogData.userData, "DistanceUnit", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": 'undefined'
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.S0041) + "\n                        ")]), _vm._v(" "), _vm._l((_vm.distanceUnits), function(unit, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": key
      }
    }, [_vm._v("\n                          " + _vm._s(unit) + "\n                        ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputPhoneHome"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0044))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.PhoneHome),
      expression: "editUserDialogData.userData.PhoneHome"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "inputPhoneHome"
    },
    domProps: {
      "value": (_vm.editUserDialogData.userData.PhoneHome)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputPhoneHome')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "PhoneHome", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputPhoneHome')),
      expression: "inputHasError('inputPhoneHome')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.S0096))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputPhoneWork"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0045))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.PhoneWork),
      expression: "editUserDialogData.userData.PhoneWork"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "inputPhoneWork"
    },
    domProps: {
      "value": (_vm.editUserDialogData.userData.PhoneWork)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputPhoneWork')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "PhoneWork", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputPhoneWork')),
      expression: "inputHasError('inputPhoneWork')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.S0096))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputPhoneMobile"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0046))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.PhoneMobile),
      expression: "editUserDialogData.userData.PhoneMobile"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "inputPhoneMobile"
    },
    domProps: {
      "value": (_vm.editUserDialogData.userData.PhoneMobile)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputPhoneMobile')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "PhoneMobile", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputPhoneMobile')),
      expression: "inputHasError('inputPhoneMobile')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.S0096))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputFax"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0047))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.Fax),
      expression: "editUserDialogData.userData.Fax"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "inputFax"
    },
    domProps: {
      "value": (_vm.editUserDialogData.userData.Fax)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputFax')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "Fax", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputFax')),
      expression: "inputHasError('inputFax')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.S0097))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputEmail"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0048))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.Email),
      expression: "editUserDialogData.userData.Email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "inputEmail",
      "name": "inputEmail"
    },
    domProps: {
      "value": (_vm.editUserDialogData.userData.Email)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputEmail')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "Email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputEmail')),
      expression: "inputHasError('inputEmail')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.S0098))])])])])])])]), _vm._v(" "), _c('b-alert', {
    attrs: {
      "variant": "danger",
      "dismissible": "",
      "show": _vm.editUserDialogData.showAlert
    },
    on: {
      "dismissed": function($event) {
        _vm.editUserDialogData.showAlert = false
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.S0049))])], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.copyUser = false
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.S0050) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "id": "user-management-modal-save-button",
      "type": "button",
      "disabled": !_vm.globals.isAccessAllowed('LoopOp_SecurityUsers_Update')
    },
    on: {
      "click": function($event) {
        return _vm.validateBeforeSubmit('editUser')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.S0051) + "\n          ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "securityDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg",
    staticStyle: {
      "width": "80vw"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.S0054))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getSelectedUserInfoText()))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('ul', {
    staticClass: "nav nav-tabs nav-security",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('li', {
    staticClass: "active"
  }, [(
    _vm.globals.isAccessAllowed(
      'LoopOp_SecurityGroups_ReadAll'
    ) &&
    _vm.globals.isAccessAllowed(
      'LoopOp_SecurityUsersSecurityGroups_Read'
    )
  ) ? _c('a', {
    attrs: {
      "href": "#customGroupDataTab",
      "data-toggle": "tab"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0056))]) : _vm._e()]), _vm._v(" "), _c('li', [(
    _vm.globals.isAccessAllowed('LoopOp_SecurityGroups_ReadAll')
  ) ? _c('a', {
    attrs: {
      "href": "#groupManagementTab",
      "data-toggle": "tab"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0064))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_vm._l((_vm.securityDialogData.dataLists), function(groupList, key) {
    return _c('div', {
      key: key,
      staticClass: "tab-pane fade in",
      class: {
        active: key == 'customGroupData'
      },
      attrs: {
        "id": key + 'Tab'
      }
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('button', {
      staticClass: "btn btn-fab btn-fab-mini dialog-btn-primary",
      attrs: {
        "disabled": _vm.securityDialogData.selectedAssignedGroupGuids
          .length == 0 ||
          !_vm.globals.isAccessAllowed(
            'LoopOp_SecurityUsersSecurityGroups_Update'
          )
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.unassignGroups()
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("arrow_back")])]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-fab btn-fab-mini dialog-btn-primary",
      attrs: {
        "disabled": _vm.securityDialogData.selectedUnassignedGroupGuids
          .length == 0 ||
          !_vm.globals.isAccessAllowed(
            'LoopOp_SecurityUsersSecurityGroups_Update'
          )
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.assignGroups()
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("arrow_forward")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-6"
    }, [_c('table', {
      staticClass: "table table-striped table-hover"
    }, [_c('thead', [_c('tr', [_c('th', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.lang.S0058))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.groupListAvailable), function(group) {
      return _c('tr', {
        key: group.GroupGuid,
        class: {
          info: _vm.securityDialogData.selectedUnassignedGroupGuids.indexOf(
            group.GroupGuid
          ) > -1,
        },
        attrs: {
          "role": "button"
        },
        on: {
          "click": function($event) {
            return _vm.toggleListItem(
              _vm.securityDialogData.selectedUnassignedGroupGuids,
              group.GroupGuid
            )
          },
          "dblclick": function($event) {
            !_vm.globals.isAccessAllowed(
                'LoopOp_SecurityUsersSecurityGroups_Update'
              ) ||
              ((_vm.securityDialogData.selectedUnassignedGroupGuids = []),
                _vm.toggleListItem(
                  _vm.securityDialogData.assignedGroupGuids,
                  group.GroupGuid
                ))
          }
        }
      }, [_c('td', {
        attrs: {
          "id": 'tdAvailable' + key + group.GroupName
        }
      }, [_vm._v("\n                            " + _vm._s(group.GroupName) + "\n                            "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (group.IsReportingGroup),
          expression: "group.IsReportingGroup"
        }],
        staticClass: "reporting-group-table-symbol"
      }, [_vm._v("R")])]), _vm._v(" "), _c('b-tooltip', {
        ref: "tooltip",
        refInFor: true,
        attrs: {
          "target": 'tdAvailable' + key + group.GroupName,
          "delay": _vm.globals.tooltipDelay
        }
      }, [_vm._v(_vm._s(group.GroupDescription))])], 1)
    }), 0)])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-6"
    }, [_c('table', {
      staticClass: "table table-striped table-hover"
    }, [_c('thead', [_c('tr', [_c('th', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.lang.S0059))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.groupListAssigned), function(group) {
      return _c('tr', {
        key: group.GroupGuid,
        class: {
          info: _vm.securityDialogData.selectedAssignedGroupGuids.indexOf(
            group.GroupGuid
          ) > -1,
        },
        attrs: {
          "role": "button"
        },
        on: {
          "click": function($event) {
            return _vm.toggleListItem(
              _vm.securityDialogData.selectedAssignedGroupGuids,
              group.GroupGuid
            )
          },
          "dblclick": function($event) {
            !_vm.globals.isAccessAllowed(
                'LoopOp_SecurityUsersSecurityGroups_Update'
              ) ||
              ((_vm.securityDialogData.selectedAssignedGroupGuids = []),
                _vm.toggleListItem(
                  _vm.securityDialogData.assignedGroupGuids,
                  group.GroupGuid
                ))
          }
        }
      }, [_c('td', {
        attrs: {
          "id": 'tdAssigned' + key + group.GroupName
        }
      }, [_vm._v("\n                            " + _vm._s(group.GroupName) + "\n                            "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (group.IsReportingGroup),
          expression: "group.IsReportingGroup"
        }],
        staticClass: "reporting-group-table-symbol"
      }, [_vm._v("R")])]), _vm._v(" "), _c('b-tooltip', {
        ref: "tooltip",
        refInFor: true,
        attrs: {
          "target": 'tdAssigned' + key + group.GroupName,
          "delay": _vm.globals.tooltipDelay
        }
      }, [_vm._v(_vm._s(group.GroupDescription))])], 1)
    }), 0)])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": "groupManagementTab"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.lang.S0078))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.securityDialogData.dataLists
    .customGroupData), function(group) {
    return _c('tr', {
      key: group.GroupGuid,
      class: {
        info: _vm.securityDialogData.groupManagement
          .selectedGroup == group.GroupGuid,
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.selectGroup(group.GroupGuid)
        }
      }
    }, [_c('td', {
      attrs: {
        "id": 'tdAvailableCustomGroupData' + group.GroupName
      }
    }, [_vm._v("\n                            " + _vm._s(group.GroupName) + "\n                            "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (group.IsReportingGroup),
        expression: "group.IsReportingGroup"
      }],
      staticClass: "reporting-group-table-symbol"
    }, [_vm._v("R")])]), _vm._v(" "), _c('b-tooltip', {
      ref: "tooltip",
      refInFor: true,
      attrs: {
        "target": 'tdAvailableCustomGroupData' + group.GroupName,
        "delay": _vm.globals.tooltipDelay
      }
    }, [_vm._v(_vm._s(group.GroupDescription))])], 1)
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.lang.S0079))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputGroupName"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0080) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.securityDialogData.groupManagement
        .selectedGroupData.GroupName
      ),
      expression: "\n                            securityDialogData.groupManagement\n                              .selectedGroupData.GroupName\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputGroupName"
    },
    domProps: {
      "value": (
        _vm.securityDialogData.groupManagement
        .selectedGroupData.GroupName
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.securityDialogData.groupManagement
          .selectedGroupData, "GroupName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputGroupDescription"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0081))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.securityDialogData.groupManagement
        .selectedGroupData.GroupDescription
      ),
      expression: "\n                            securityDialogData.groupManagement\n                              .selectedGroupData.GroupDescription\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "rows": "3",
      "id": "inputGroupDescription"
    },
    domProps: {
      "value": (
        _vm.securityDialogData.groupManagement
        .selectedGroupData.GroupDescription
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.securityDialogData.groupManagement
          .selectedGroupData, "GroupDescription", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.selectedUserData.ClientGuid) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "securityGroupsIsReportingGroupCheckbox",
      "id": "securityGroupsIsReportingGroupCheckboxLabel"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.S0191) + "\n                        "), _c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("help_outline")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "float": "left"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.securityDialogData.groupManagement
        .selectedGroupData.IsReportingGroup
      ),
      expression: "\n                                securityDialogData.groupManagement\n                                  .selectedGroupData.IsReportingGroup\n                              "
    }],
    attrs: {
      "type": "checkbox",
      "id": "securityGroupsIsReportingGroupCheckbox",
      "disabled": !_vm.findNextFreeTargetGroup()
    },
    domProps: {
      "checked": Array.isArray(
        _vm.securityDialogData.groupManagement
        .selectedGroupData.IsReportingGroup
      ) ? _vm._i(
        _vm.securityDialogData.groupManagement
        .selectedGroupData.IsReportingGroup, null) > -1 : (
        _vm.securityDialogData.groupManagement
        .selectedGroupData.IsReportingGroup
      )
    },
    on: {
      "change": [function($event) {
        var $$a =
          _vm.securityDialogData.groupManagement
          .selectedGroupData.IsReportingGroup,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.securityDialogData.groupManagement
              .selectedGroupData, "IsReportingGroup", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.securityDialogData.groupManagement
              .selectedGroupData, "IsReportingGroup", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.securityDialogData.groupManagement
            .selectedGroupData, "IsReportingGroup", $$c)
        }
      }, function($event) {
        return _vm.reportingGroupFlagToggled()
      }]
    }
  }), _vm._v(" "), _vm._m(3)])])]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "securityGroupsIsReportingGroupCheckboxLabel",
      "placement": "left",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.S0195) + "\n                        "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s(_vm.lang.S0196) + "\n                      ")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "securityGroupsClientSelect"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.S0185) + "\n                        "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (
        _vm.securityDialogData.groupManagement
        .selectedGroupData.IsReportingGroup
      ),
      expression: "\n                            securityDialogData.groupManagement\n                              .selectedGroupData.IsReportingGroup\n                          "
    }]
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "securityGroupsClientSelect",
      "allowClear": true,
      "placeholder": _vm.lang.S0186,
      "disabled": _vm.securityDialogData.groupManagement
        .selectedGroupData.IsReportingGroup
    },
    model: {
      value: (
        _vm.securityDialogData.groupManagement
        .selectedGroupData.ClientGuid
      ),
      callback: function($$v) {
        _vm.$set(_vm.securityDialogData.groupManagement
          .selectedGroupData, "ClientGuid", $$v)
      },
      expression: "\n                            securityDialogData.groupManagement\n                              .selectedGroupData.ClientGuid\n                          "
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.clientListWithGuid), function(client) {
    return _c('option', {
      key: client.ClientGuid,
      domProps: {
        "value": client.ClientGuid
      }
    }, [_vm._v("\n                            " + _vm._s(client.ClientName) + "\n                          ")])
  })], 2)], 1)]), _vm._v(" "), (
    _vm.securityDialogData.groupManagement.selectedGroupData
    .IsReportingGroup
  ) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "targetGroupRadios"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0197))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 text-left"
  }, _vm._l((_vm.targetGroups), function(tg, guid) {
    return _c('div', {
      key: guid,
      staticClass: "radio"
    }, [_c('label', [_c('input', {
      attrs: {
        "type": "radio",
        "name": "targetGroupRadios",
        "id": ("targetGroupRadio" + tg)
      },
      domProps: {
        "value": guid,
        "checked": guid ===
          _vm.securityDialogData.groupManagement
          .selectedGroupData.TargetGroupGuid
      },
      on: {
        "change": function($event) {
          return _vm.targetGroupGuidChanged(guid)
        }
      }
    }), _vm._v("\n                            " + _vm._s(_vm.lang.S0197) + " " + _vm._s(tg) + "\n                            "), _c('span', {
      staticClass: "circle"
    }), _vm._v(" "), _c('span', {
      staticClass: "check"
    })])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clearGroupManagementInputs()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("add_box")]), _vm._v(" "), _c('br'), _vm._v("\n                      " + _vm._s(_vm.lang.S0159) + "\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    class: {
      'btn-warning': _vm.securityDialogData.groupManagement
        .isSelectedGroupDirty,
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.securityDialogData.groupManagement.selectedGroupData
        .GroupName ||
        (!_vm.globals.isAccessAllowed(
            'LoopOp_SecurityGroups_Create'
          ) &&
          !_vm.securityDialogData.groupManagement
          .selectedGroup) ||
        (!_vm.globals.isAccessAllowed(
            'LoopOp_SecurityGroups_Update'
          ) &&
          _vm.securityDialogData.groupManagement.selectedGroup)
    },
    on: {
      "click": function($event) {
        return _vm.editGroup()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("save")]), _vm._v(" "), _c('br'), _vm._v("\n                      " + _vm._s(_vm.lang.S0082) + "\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "type": "button",
      "disabled": !_vm.securityDialogData.groupManagement.selectedGroup ||
        !_vm.globals.isAccessAllowed(
          'LoopOp_SecurityGroups_Delete'
        )
    },
    on: {
      "click": function($event) {
        return _vm.openGroupDeletionDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("clear")]), _vm._v(" "), _c('br'), _vm._v("\n                      " + _vm._s(_vm.lang.S0083) + "\n                    ")])])])], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.S0060) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveSecurityData()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.S0061) + "\n          ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "security2Dialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.S0161))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getSelectedUserInfoText()))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "security2DialogClientSelect",
      "placeholder": _vm.selectedUserData.Company,
      "width": '50%',
      "allowClear": true,
      "disabled": ""
    }
  }, [_c('option')]), _vm._v(" "), (
    _vm.selectedSecurity2Page === 'locations2Tab' &&
    _vm.security2DialogData.dataLists.locations.length > 100
  ) ? _c('a', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin": "7px 0 0 0",
      "padding": "2px 20px",
      "position": "absolute"
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        (_vm.security2DialogData.showTop100LocationsOnly = !_vm.security2DialogData.showTop100LocationsOnly),
        _vm.filterLocationData()
      }
    }
  }, [(_vm.security2DialogData.showTop100LocationsOnly) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box_outline_blank")]), _vm._v("\n              " + _vm._s(_vm.lang.S0173) + "\n            ")]) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        _vm.security2DialogData.hasAccessToAllLocations = !_vm.security2DialogData.hasAccessToAllLocations
      }
    }
  }, [(_vm.security2DialogData.hasAccessToAllLocations) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box_outline_blank")]), _vm._v("\n              " + _vm._s(_vm.lang.S0189) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('ul', {
    staticClass: "nav nav-tabs nav-security",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#clientSettings2Tab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.selectedSecurity2Page = 'clientSettings2Tab'
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.S0139))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#locationProperties2Tab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.selectedSecurity2Page = 'locationProperties2Tab'
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.S0140))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#locations2Tab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.selectedSecurity2Page = 'locations2Tab'
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.S0141))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#reportingFeatures2Tab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.selectedSecurity2Page = 'reportingFeatures2Tab'
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.S0142))])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active",
    attrs: {
      "id": "clientSettings2Tab"
    }
  }, [_c('div', [_c('table', {
    staticClass: "table outer-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "col-md-8"
  }, [_vm._v(_vm._s(_vm.lang.S0174))]), _vm._v(" "), _c('th', {
    staticClass: "col-md-4"
  }, [_vm._v(_vm._s(_vm.lang.S0175))])])]), _vm._v(" "), _c('tbody', {
    staticClass: "table-scrollbar"
  }, [_vm._l((_vm.security2DialogData.dataLists
    .clientSetting), function(project) {
    return [_c('tr', {
      key: project.ProjectGuid,
      staticClass: "accordion-toggle background-grey",
      class: {
        'cursor-pointer': !project.Forbidden
      },
      attrs: {
        "data-toggle": "collapse",
        "data-target": '#securityProjectWaves' + project.ProjectGuid
      },
      on: {
        "click": function($event) {
          (project.expanded = !project.expanded),
          _vm.$forceUpdate()
        }
      }
    }, [_c('td', {
      staticClass: "project-name-data"
    }, [_c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (project.Forbidden),
        expression: "project.Forbidden"
      }],
      staticClass: "material-icons"
    }, [_vm._v("chevron_right")]), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!project.Forbidden && !project.expanded),
        expression: "!project.Forbidden && !project.expanded"
      }],
      staticClass: "material-icons"
    }, [_vm._v("expand_more")]), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!project.Forbidden && project.expanded),
        expression: "!project.Forbidden && project.expanded"
      }],
      staticClass: "material-icons"
    }, [_vm._v("expand_less")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(project.ProjectName))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "checkbox",
      staticStyle: {
        "margin": "0px"
      }
    }, [_c('label', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          project.expanded = false
        }
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (project.Forbidden),
        expression: "project.Forbidden"
      }],
      attrs: {
        "type": "checkbox",
        "id": 'cb_projectForbidden_' + project.ProjectGuid
      },
      domProps: {
        "checked": Array.isArray(project.Forbidden) ? _vm._i(project.Forbidden, null) > -1 : (project.Forbidden)
      },
      on: {
        "change": function($event) {
          var $$a = project.Forbidden,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(project, "Forbidden", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(project, "Forbidden", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(project, "Forbidden", $$c)
          }
        }
      }
    }), _vm._v(" "), _vm._m(4, true)]), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.hasForbiddenWaves(project)),
        expression: "hasForbiddenWaves(project)"
      }],
      staticClass: "material-icons"
    }, [_vm._v("priority_high")])])])]), _vm._v(" "), (!project.Forbidden) ? _c('tr', {
      key: project.ProjectGuid + 'waves'
    }, [_c('td', {
      staticClass: "hiddenRow",
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticClass: "accordion-body collapse",
      attrs: {
        "id": 'securityProjectWaves' + project.ProjectGuid
      }
    }, [(
      !project.Waves || project.Waves.length < 1
    ) ? _c('span', {
      staticStyle: {
        "margin-left": "30px"
      }
    }, [_vm._v(_vm._s(_vm.lang.S0176))]) : _c('table', {
      staticClass: "table table-hover inner-table"
    }, [_c('thead', [_c('tr', [_c('th', {
      staticClass: "col-md-8"
    }, [_vm._v(_vm._s(_vm.lang.S0177))]), _vm._v(" "), _c('th', {
      staticClass: "col-md-4"
    }, [_vm._v(_vm._s(_vm.lang.S0175))])])]), _vm._v(" "), _c('tbody', _vm._l((project.Waves), function(wave) {
      return _c('tr', {
        key: wave.WaveGuid
      }, [_c('td', [_vm._v(_vm._s(wave.WaveName))]), _vm._v(" "), _c('td', [_c('div', {
        staticClass: "checkbox",
        staticStyle: {
          "margin": "0px"
        }
      }, [_c('label', {
        on: {
          "click": function($event) {
            $event.stopPropagation();
          }
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (wave.Forbidden),
          expression: "wave.Forbidden"
        }],
        attrs: {
          "type": "checkbox",
          "id": 'cb_waveForbidden_' +
            wave.WaveGuid
        },
        domProps: {
          "checked": Array.isArray(wave.Forbidden) ? _vm._i(wave.Forbidden, null) > -1 : (wave.Forbidden)
        },
        on: {
          "change": function($event) {
            var $$a = wave.Forbidden,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(wave, "Forbidden", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(wave, "Forbidden", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(wave, "Forbidden", $$c)
            }
          }
        }
      }), _vm._v(" "), _vm._m(5, true)])])])])
    }), 0)])])])]) : _vm._e()]
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": "locationProperties2Tab"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.security2DialogData.hasAccessToAllLocations),
      expression: "security2DialogData.hasAccessToAllLocations"
    }]
  }, [_vm._v("\n                " + _vm._s(_vm.lang.S0190) + "\n              ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.security2DialogData.hasAccessToAllLocations),
      expression: "!security2DialogData.hasAccessToAllLocations"
    }]
  }, [_c('CustomPropertiesPoliciesControl', {
    ref: "locationProperties2Tab",
    attrs: {
      "lang": _vm.lang,
      "user": _vm.selectedUserData,
      "selectedClient": _vm.selectedUserData.ClientGuid
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": "locations2Tab"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.security2DialogData.hasAccessToAllLocations),
      expression: "security2DialogData.hasAccessToAllLocations"
    }]
  }, [_vm._v("\n                " + _vm._s(_vm.lang.S0190) + "\n              ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.security2DialogData.hasAccessToAllLocations),
      expression: "!security2DialogData.hasAccessToAllLocations"
    }]
  }, [_c('div', [_c('table', [_c('tr', [_c('table', {
    staticClass: "table table-striped table-hover main-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.S0166) + "\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.S0169) + "\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.S0168) + "\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.S0179) + "\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.S0167) + "\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.S0172) + "\n                            ")])])]), _vm._v(" "), _c('tbody', {
    staticClass: "main-table-scrollbar table-striped table-hover"
  }, [_c('tr', [_c('td', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "15%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.security2DialogData.locationFilterStrings
        .LocationStoreId
      ),
      expression: "\n                                    security2DialogData.locationFilterStrings\n                                      .LocationStoreId\n                                  "
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.S0018
    },
    domProps: {
      "value": (
        _vm.security2DialogData.locationFilterStrings
        .LocationStoreId
      )
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filterLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.security2DialogData.locationFilterStrings, "LocationStoreId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('td', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "25%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.security2DialogData.locationFilterStrings
        .LocationName
      ),
      expression: "\n                                    security2DialogData.locationFilterStrings\n                                      .LocationName\n                                  "
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.S0018
    },
    domProps: {
      "value": (
        _vm.security2DialogData.locationFilterStrings
        .LocationName
      )
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filterLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.security2DialogData.locationFilterStrings, "LocationName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('td', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "30%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.security2DialogData.locationFilterStrings
        .LocationAddress
      ),
      expression: "\n                                    security2DialogData.locationFilterStrings\n                                      .LocationAddress\n                                  "
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.S0018
    },
    domProps: {
      "value": (
        _vm.security2DialogData.locationFilterStrings
        .LocationAddress
      )
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filterLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.security2DialogData.locationFilterStrings, "LocationAddress", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('td', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.security2DialogData.locationFilterStrings
        .LocationCountry
      ),
      expression: "\n                                    security2DialogData.locationFilterStrings\n                                      .LocationCountry\n                                  "
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.S0018
    },
    domProps: {
      "value": (
        _vm.security2DialogData.locationFilterStrings
        .LocationCountry
      )
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filterLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.security2DialogData.locationFilterStrings, "LocationCountry", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('td', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.security2DialogData.locationFilterStrings
        .LocationStatusId
      ),
      expression: "\n                                    security2DialogData.locationFilterStrings\n                                      .LocationStatusId\n                                  "
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.S0018
    },
    domProps: {
      "value": (
        _vm.security2DialogData.locationFilterStrings
        .LocationStatusId
      )
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filterLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.security2DialogData.locationFilterStrings, "LocationStatusId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        (_vm.security2DialogData.locationFilterStrings.LocationVisible =
          (_vm.security2DialogData
            .locationFilterStrings
            .LocationVisible +
            1) %
          3),
        _vm.filterLocationData()
      }
    }
  }, [(
    _vm.security2DialogData
    .locationFilterStrings
    .LocationVisible == 1
  ) ? _c('div', {
    staticClass: "cb-active-filter-container"
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box")])]) : (
    _vm.security2DialogData
    .locationFilterStrings
    .LocationVisible == 0
  ) ? _c('div', {
    staticClass: "cb-active-filter-container"
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")])]) : _c('div', {
    staticClass: "cb-active-filter-container"
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("indeterminate_check_box")])])])])])]), _vm._v(" "), _vm._l((_vm.security2DialogData.dataLists
    .filteredLocations), function(location) {
    return _c('tr', {
      key: location.LocationId
    }, [_c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v("\n                              " + _vm._s(location.LocationStoreId) + "\n                            ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v("\n                              " + _vm._s(location.LocationName) + "\n                            ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v("\n                              " + _vm._s(location.LocationAddress) + "\n                            ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v("\n                              " + _vm._s(location.LocationCountry) + "\n                            ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v("\n                              " + _vm._s(location.LocationStatusId) + "\n                            ")]), _vm._v(" "), _c('td', {
      staticClass: "td-cb-policies",
      staticStyle: {
        "width": "10%"
      }
    }, [_c('a', {
      staticClass: "btn btn-default btn-cb-policies",
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.toggleLocationPermission(
            location.LocationGuid
          )
        }
      }
    }, [(
      _vm.isLocationPermitted(location.LocationGuid)
    ) ? _c('i', {
      staticClass: "material-icons md-24 text-primary"
    }, [_vm._v("check_box")]) : _c('i', {
      staticClass: "material-icons md-24 text-primary"
    }, [_vm._v("check_box_outline_blank")])])])])
  })], 2)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": "reportingFeatures2Tab"
    }
  }, [_c('div', [_c('SettingsPoliciesControl', {
    ref: "reportingFeatures2Tab",
    attrs: {
      "lang": _vm.lang,
      "user": _vm.selectedUserData
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.S0164) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveSecurity2Data()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.S0061) + "\n          ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "deleteUserDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.S0099))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.lang.S0100))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 text-black"
  }, [_vm._v(_vm._s(_vm.lang.S0020))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-9 text-black"
  }, [_vm._v(_vm._s(_vm.deleteUserDialogData.LoginName))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 text-black"
  }, [_vm._v(_vm._s(_vm.lang.S0022))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-9 text-black"
  }, [_vm._v(_vm._s(_vm.deleteUserDialogData.FirstName))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 text-black"
  }, [_vm._v(_vm._s(_vm.lang.S0023))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-9 text-black"
  }, [_vm._v(_vm._s(_vm.deleteUserDialogData.LastName))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 text-black"
  }, [_vm._v(_vm._s(_vm.lang.S0009))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-9 text-black"
  }, [_vm._v(_vm._s(_vm.deleteUserDialogData.UserType))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 text-black"
  }, [_vm._v(_vm._s(_vm.lang.S0133))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-9 text-black"
  }, [_vm._v(_vm._s(_vm.deleteUserDialogData.SecurityRole))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "id": "user-management-modal-delete-false-button",
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.S0102) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-warning",
    attrs: {
      "id": "user-management-modal-delete-true-button",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.deleteUserData()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.S0101) + "\n          ")])])])])]), _vm._v(" "), _c('change-password-dialog', {
    attrs: {
      "showDialog": _vm.showChangePasswordDialog,
      "userGuid": _vm.selectedUser,
      "userName": _vm.selectedUserData.LoginName
    },
    on: {
      "dialogClosed": _vm.onChangePasswordDialogClosed
    }
  })], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "role": "button",
      "data-toggle": "dropdown",
      "id": "elementsPerPageDropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("view_headline")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "firstPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("first_page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "lastPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("last_page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
}]}

/***/ }),
/* 1652 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "kpiCopyModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.KCM000))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(_vm._s(_vm.lang.KCM001))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.lang.KCM002,
      "allowClear": true
    },
    model: {
      value: (_vm.selectedSourceProject),
      callback: function($$v) {
        _vm.selectedSourceProject = $$v
      },
      expression: "selectedSourceProject"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.projects), function(project) {
    return _c('option', {
      key: project.ProjectGuid,
      domProps: {
        "value": project.ProjectGuid
      }
    }, [_vm._v("\n                " + _vm._s(project.ProjectName) + "\n              ")])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(_vm._s(_vm.lang.KCM003))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.lang.KCM004,
      "allowClear": true
    },
    model: {
      value: (_vm.selectedTargetProject),
      callback: function($$v) {
        _vm.selectedTargetProject = $$v
      },
      expression: "selectedTargetProject"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.projects), function(project) {
    return _c('option', {
      key: project.ProjectGuid,
      domProps: {
        "value": project.ProjectGuid
      }
    }, [_vm._v("\n                " + _vm._s(project.ProjectName) + "\n              ")])
  })], 2)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.KCM005) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedSourceProject || !_vm.selectedTargetProject
    },
    on: {
      "click": function($event) {
        return _vm.copyKpis()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.KCM006) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 1653 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    class: {
      'text-red': _vm.Recommended && _vm.value.length < 1
    },
    attrs: {
      "for": ("input-shopper-custprop-" + _vm.Guid + "-" + _vm._uid)
    }
  }, [_vm._v("\n    " + _vm._s(_vm.Title) + "\n    "), (_vm.Recommended) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('Select2', {
    staticClass: "form-control",
    attrs: {
      "id": ("input-shopper-custprop-" + _vm.Guid + "-" + _vm._uid),
      "allowClear": true,
      "tags": _vm.AllowCustomValues,
      "multiple": true,
      "placeholder": ' ',
      "disabled": _vm.readOnly,
      "value": _vm.value
    },
    on: {
      "change": _vm.updateValue
    }
  }, _vm._l((_vm.ListValues), function(element) {
    return _c('option', {
      key: element.ValueGuid,
      domProps: {
        "value": element.ValueGuid
      }
    }, [_vm._v("\n        " + _vm._s(element.Value) + "\n      ")])
  }), 0)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1654 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "StatusManagement"
    }
  }, [(!_vm.waveGuid) ? _c('div', {
    staticClass: "sm-overview"
  }, [_c('div', {
    staticClass: "sm-search-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "sm-search",
    attrs: {
      "type": "text",
      "placeholder": "Search"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "change": function($event) {
        return _vm.getWaveData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sm-wave-container"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.waveData), function(wave) {
    return [_c('StatusWave', {
      attrs: {
        "wave": wave
      },
      on: {
        "click": _vm.openDetails
      }
    })]
  })], 2)]) : [_c('button', {
    staticClass: "sm-btn",
    on: {
      "click": function($event) {
        _vm.waveGuid = null
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("chevron_left")]), _vm._v(" "), _c('span', [_vm._v("Back to Overview")])]), _vm._v(" "), _c('StatusWaveDetail', {
    attrs: {
      "waveGuid": _vm.waveGuid
    }
  })]], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sm-header"
  }, [_c('div', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('b', [_vm._v("Wave")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('b', [_vm._v("Check Status")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('b', [_vm._v("Approvals")])])])
}]}

/***/ }),
/* 1655 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.dialogId,
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.confirmationTitle))])])]), _vm._v(" "), (!_vm.htmlText) ? _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("default")], 2) : _c('div', {
    staticClass: "modal-body",
    domProps: {
      "innerHTML": _vm._s(_vm.htmlText)
    }
  }, [_vm._v(_vm._s(_vm.htmlText))]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "id": "noButton",
      "type": "button",
      "data-dismiss": "modal",
      "disabled": _vm.noButtonDisable
    },
    on: {
      "click": function($event) {
        return _vm.onNoConfirmation()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.noButtonText) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised",
    class: [this.colorRed ? 'btn-danger' : 'dialog-btn-primary'],
    attrs: {
      "id": "yesButton",
      "type": "button",
      "disabled": _vm.yesButtonDisable
    },
    on: {
      "click": function($event) {
        return _vm.onYesConfirmation()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.yesButtonText) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 1656 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "shopperFilterModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.CSM000))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('ShopperFilter', {
    ref: "shopperFilterComponent",
    attrs: {
      "currentFilterObject": _vm.filterObject,
      "locationPropertiesList": _vm.locationPropertiesList,
      "countryList": _vm.countryList
    },
    on: {
      "filterUpdate": function($event) {
        _vm.filterObject = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised pull-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.copyFilter()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.CSM004) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised pull-left",
    attrs: {
      "type": "button",
      "disabled": !_vm.copyData.filterObject || _vm.copyData.client !== _vm.selectedClient
    },
    on: {
      "click": function($event) {
        return _vm.restoreFilter()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.CSM005) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.CSM001) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 1657 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "editShopperDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "id": "shopperEditForm"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.dialogTitle))])]), _vm._v(" "), (_vm.editShopperData.ShopperId) ? _c('div', [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("ID: " + _vm._s(_vm.editShopperData.ShopperId) + ", " + _vm._s(_vm.lang.SM1048) + ":\n              " + _vm._s(_vm.editShopperData.Username))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel-group",
    attrs: {
      "id": "accordion",
      "role": "tablist",
      "aria-multiselectable": "true"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingGeneral",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseGeneral",
      "aria-expanded": "true",
      "aria-controls": "collapseGeneral"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.SM1002))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in",
    attrs: {
      "id": "collapseGeneral",
      "role": "tabpanel",
      "aria-labelledby": "headingGeneral"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-3 col-md-push-9",
    attrs: {
      "id": "profilePictureContainer"
    },
    on: {
      "click": function($event) {
        return _vm.openFileSelector()
      }
    }
  }, [(_vm.editShopperData.ProfilePictureGuid) ? _c('img', {
    attrs: {
      "src": '/api/download/' + _vm.editShopperData.ProfilePictureGuid
    }
  }) : _c('img', {
    attrs: {
      "src": "/static/avatar.png"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "form-control hidden",
    attrs: {
      "id": "inputShopperProfilePictureFile",
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.onShopperProfilePictureFileChange,
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editShopperData.ProfilePictureGuid),
      expression: "editShopperData.ProfilePictureGuid"
    }],
    attrs: {
      "role": "button",
      "id": "removeProfilePictureButton"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.removeShopperProfilePictureFile()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("clear")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-9 col-md-pull-3"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputShopperSalutation"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1003))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editShopperData.Salutation),
      expression: "editShopperData.Salutation"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "inputShopperSalutation"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editShopperData, "Salutation", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1004))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "F"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1005))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "M"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1006))])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputShopperSalutation')),
      expression: "inputHasError('inputShopperSalutation')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SM1009))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-9 col-md-pull-3 noclearfix"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputShopperFirstName"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1010) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editShopperData.FirstName),
      expression: "editShopperData.FirstName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputShopperFirstName",
      "required": ""
    },
    domProps: {
      "value": (_vm.editShopperData.FirstName)
    },
    on: {
      "change": function($event) {
        return _vm.validateInput('inputShopperFirstName')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editShopperData, "FirstName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputShopperFirstName')),
      expression: "inputHasError('inputShopperFirstName')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SM1009))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-9 col-md-pull-3 noclearfix"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputShopperLastName"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1011) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editShopperData.LastName),
      expression: "editShopperData.LastName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputShopperLastName",
      "required": ""
    },
    domProps: {
      "value": (_vm.editShopperData.LastName)
    },
    on: {
      "change": function($event) {
        return _vm.validateInput('inputShopperLastName')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editShopperData, "LastName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputShopperLastName')),
      expression: "inputHasError('inputShopperLastName')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SM1009))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-9 col-md-pull-3 noclearfix"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputShopperGender"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1029) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editShopperData.Gender),
      expression: "editShopperData.Gender"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "inputShopperGender",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editShopperData, "Gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.validateInput('inputShopperGender')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "hidden": ""
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.SM1004) + "\n                        ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "F"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1031))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "M"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1030))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "D"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1033))])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputShopperGender')),
      expression: "inputHasError('inputShopperGender')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SM1009))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group clearfix"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputShopperAddress1"
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.SM1012) + "\n                      "), (!_vm.feature.isAudiTarget) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editShopperData.Address1),
      expression: "editShopperData.Address1"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputShopperAddress1",
      "required": !_vm.feature.isAudiTarget
    },
    domProps: {
      "value": (_vm.editShopperData.Address1)
    },
    on: {
      "change": function($event) {
        return _vm.validateInput('inputShopperAddress1')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editShopperData, "Address1", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputShopperAddress1')),
      expression: "inputHasError('inputShopperAddress1')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SM1009))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputShopperPostalCode"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1013) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editShopperData.PostalCode),
      expression: "editShopperData.PostalCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputShopperPostalCode",
      "required": ""
    },
    domProps: {
      "value": (_vm.editShopperData.PostalCode)
    },
    on: {
      "change": function($event) {
        return _vm.validateInput('inputShopperPostalCode')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editShopperData, "PostalCode", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputShopperPostalCode')),
      expression: "inputHasError('inputShopperPostalCode')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SM1009))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputShopperCity"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1014) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editShopperData.City),
      expression: "editShopperData.City"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputShopperCity",
      "required": ""
    },
    domProps: {
      "value": (_vm.editShopperData.City)
    },
    on: {
      "change": function($event) {
        return _vm.validateInput('inputShopperCity')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editShopperData, "City", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputShopperCity')),
      expression: "inputHasError('inputShopperCity')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SM1009))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputShopperCountryCode"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1015) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "inputShopperCountryCode",
      "placeholder": _vm.lang.SM1004,
      "required": ""
    },
    on: {
      "change": function($event) {
        return _vm.validateInput('inputShopperCountryCode')
      }
    },
    model: {
      value: (_vm.editShopperData.CountryCode),
      callback: function($$v) {
        _vm.$set(_vm.editShopperData, "CountryCode", $$v)
      },
      expression: "editShopperData.CountryCode"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.globals.countryList), function(country, ISOCode) {
    return _c('option', {
      key: ISOCode,
      domProps: {
        "value": ISOCode
      }
    }, [_vm._v("\n                          " + _vm._s(country) + "\n                        ")])
  })], 2)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputShopperCountryCode')),
      expression: "inputHasError('inputShopperCountryCode')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SM1009))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputShopperBirthdate"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1016) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr('inputShopperBirthdate')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editShopperData.Birthdate),
      expression: "editShopperData.Birthdate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputShopperBirthdate",
      "required": ""
    },
    domProps: {
      "value": (_vm.editShopperData.Birthdate)
    },
    on: {
      "change": function($event) {
        return _vm.validateInput('inputShopperBirthdate')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editShopperData, "Birthdate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputShopperBirthdate')),
      expression: "inputHasError('inputShopperBirthdate')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SM1009))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputShopperEmail"
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.SM1017) + "\n                      "), (!_vm.feature.isAudiTarget) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editShopperData.Email),
      expression: "editShopperData.Email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputShopperEmail",
      "required": !_vm.feature.isAudiTarget
    },
    domProps: {
      "value": (_vm.editShopperData.Email)
    },
    on: {
      "change": function($event) {
        return _vm.validateInput('inputShopperEmail')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editShopperData, "Email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputShopperEmail')),
      expression: "inputHasError('inputShopperEmail')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SM1009))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputShopperPhone1"
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.SM1018) + "\n                      "), (!_vm.feature.isAudiTarget) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editShopperData.Phone1),
      expression: "editShopperData.Phone1"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputShopperPhone1",
      "required": !_vm.feature.isAudiTarget
    },
    domProps: {
      "value": (_vm.editShopperData.Phone1)
    },
    on: {
      "change": function($event) {
        return _vm.validateInput('inputShopperPhone1')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editShopperData, "Phone1", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputShopperPhone1')),
      expression: "inputHasError('inputShopperPhone1')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SM1009))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputShopperPhone2"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1019))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editShopperData.Phone2),
      expression: "editShopperData.Phone2"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputShopperPhone2"
    },
    domProps: {
      "value": (_vm.editShopperData.Phone2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editShopperData, "Phone2", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (!_vm.feature.isAudiTarget) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputShopperOccupationGroup"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1020) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "inputShopperOccupationGroup",
      "placeholder": _vm.lang.SM1004,
      "required": ""
    },
    on: {
      "change": function($event) {
        return _vm.validateInput('inputShopperOccupationGroup')
      }
    },
    model: {
      value: (_vm.editShopperData.OccupationalGroupGuid),
      callback: function($$v) {
        _vm.$set(_vm.editShopperData, "OccupationalGroupGuid", $$v)
      },
      expression: "editShopperData.OccupationalGroupGuid"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.occupationalGroupList), function(occupationGroup, occupationGroupGuid) {
    return _c('option', {
      key: occupationGroupGuid,
      domProps: {
        "value": occupationGroupGuid
      }
    }, [_vm._v("\n                          " + _vm._s(occupationGroup) + "\n                        ")])
  })], 2)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputShopperOccupationGroup')),
      expression: "inputHasError('inputShopperOccupationGroup')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SM1009))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputShopperOccupation"
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.SM1021) + "\n                      "), (_vm.feature.isAudiTarget) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editShopperData.Occupation),
      expression: "editShopperData.Occupation"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputShopperOccupation",
      "required": _vm.feature.isAudiTarget
    },
    domProps: {
      "value": (_vm.editShopperData.Occupation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editShopperData, "Occupation", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputShopperOccupation')),
      expression: "inputHasError('inputShopperOccupation')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SM1009))])])]), _vm._v(" "), (!_vm.feature.isAudiTarget) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputShopperEmployer"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1022))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editShopperData.Employer),
      expression: "editShopperData.Employer"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputShopperEmployer"
    },
    domProps: {
      "value": (_vm.editShopperData.Employer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editShopperData, "Employer", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputShopperEmployer')),
      expression: "inputHasError('inputShopperEmployer')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SM1009))])])]) : _vm._e(), _vm._v(" "), (
    _vm.editShopperData.ShopperGuid && !_vm.feature.isAudiTarget
  ) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputShopperVatNo"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1041) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editShopperData.VatNo),
      expression: "editShopperData.VatNo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputShopperVatNo",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.editShopperData.VatNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editShopperData, "VatNo", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "float": "left"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editShopperData.VatNotMandatory),
      expression: "editShopperData.VatNotMandatory"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.editShopperData.VatNotMandatory) ? _vm._i(_vm.editShopperData.VatNotMandatory, null) > -1 : (_vm.editShopperData.VatNotMandatory)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.editShopperData.VatNotMandatory,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.editShopperData, "VatNotMandatory", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.editShopperData, "VatNotMandatory", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.editShopperData, "VatNotMandatory", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "text text-black"
  }, [_vm._v(_vm._s(_vm.lang.SM1042))])])])])]) : _vm._e(), _vm._v(" "), (
    _vm.editShopperData.SocialSecurityNumber &&
    !_vm.feature.isAudiTarget
  ) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputShopperSocialSecurityNumber"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1043) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editShopperData.SocialSecurityNumber),
      expression: "editShopperData.SocialSecurityNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputShopperSocialSecurityNumber",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.editShopperData.SocialSecurityNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editShopperData, "SocialSecurityNumber", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm.dialogModeAdd) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputLatitude"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0044))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editShopperData.Latitude),
      expression: "editShopperData.Latitude"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "any",
      "min": "-90",
      "max": "90",
      "id": "inputLatitude"
    },
    domProps: {
      "value": (_vm.editShopperData.Latitude)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editShopperData, "Latitude", $event.target.value)
      }, function($event) {
        return _vm.validateInput('inputLatitude')
      }]
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputLatitude')),
      expression: "inputHasError('inputLatitude')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.L0083))])])]) : _vm._e(), _vm._v(" "), (!_vm.dialogModeAdd) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputLongitude"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0045))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editShopperData.Longitude),
      expression: "editShopperData.Longitude"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "any",
      "min": "-180",
      "max": "180",
      "id": "inputLongitude"
    },
    domProps: {
      "value": (_vm.editShopperData.Longitude)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editShopperData, "Longitude", $event.target.value)
      }, function($event) {
        return _vm.validateInput('inputLongitude')
      }]
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputLongitude')),
      expression: "inputHasError('inputLongitude')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.L0083))])])]) : _vm._e(), _vm._v(" "), (!_vm.dialogModeAdd) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputGeocodeSource"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0046))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editShopperData.GeocodeSource),
      expression: "editShopperData.GeocodeSource"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputGeocodeSource"
    },
    domProps: {
      "value": (_vm.editShopperData.GeocodeSource)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editShopperData, "GeocodeSource", $event.target.value)
      }
    }
  })])]) : _vm._e()])]), _vm._v(" "), (
    !_vm.dialogModeAdd &&
    _vm.globals.isAccessAllowed('LoopOp_ShopperBankDetails_ReadAll')
  ) ? _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingBankDetails",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseBankDetails",
      "aria-expanded": "true",
      "aria-controls": "collapseBankDetails"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.SM1035))])])]) : _vm._e(), _vm._v(" "), (
    !_vm.dialogModeAdd &&
    _vm.globals.isAccessAllowed('LoopOp_ShopperBankDetails_ReadAll')
  ) ? _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseBankDetails",
      "role": "tabpanel",
      "aria-labelledby": "headingBankDetails"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputBankDetailsBankName"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1036))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bankDetailsData.BankName),
      expression: "bankDetailsData.BankName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputBankDetailsBankName",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.bankDetailsData.BankName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bankDetailsData, "BankName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputBankDetailsSwiftCode"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1037))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bankDetailsData.SwiftCode),
      expression: "bankDetailsData.SwiftCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputBankDetailsSwiftCode",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.bankDetailsData.SwiftCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bankDetailsData, "SwiftCode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputBankDetailsAccountNumber"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1038))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bankDetailsData.AccountNumber),
      expression: "bankDetailsData.AccountNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputBankDetailsAccountNumber",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.bankDetailsData.AccountNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bankDetailsData, "AccountNumber", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputBankDetailsAccountName"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1039))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bankDetailsData.AccountName),
      expression: "bankDetailsData.AccountName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputBankDetailsAccountName",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.bankDetailsData.AccountName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bankDetailsData, "AccountName", $event.target.value)
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), (
    _vm.globals.isAccessAllowed(
      'LoopOp_ShopperProperties_Shopper_Read'
    )
  ) ? _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingCustomProperties",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseCustomProperties",
      "aria-expanded": "true",
      "aria-controls": "collapseCustomProperties"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.SM1040))])])]) : _vm._e(), _vm._v(" "), (
    _vm.globals.isAccessAllowed(
      'LoopOp_ShopperProperties_Shopper_Read'
    )
  ) ? _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseCustomProperties",
      "role": "tabpanel",
      "aria-labelledby": "headingCustomProperties"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('custom-properties-form', {
    ref: "customPropertiesForm",
    attrs: {
      "shopperGuid": _vm.selectedShopperGuid
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingShopperAdministration",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseShopperAdministration",
      "aria-expanded": "true",
      "aria-controls": "collapseShopperAdministration"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.SM1044))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseShopperAdministration",
      "role": "tabpanel",
      "aria-labelledby": "headingShopperAdministration"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(_vm.editShopperData.MigratedShopperId) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(_vm._s(_vm.lang.SM1052))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('label', {
    staticClass: "form-control text-left"
  }, [_vm._v(_vm._s(_vm.editShopperData.MigratedShopperId))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "selectShopperAccountStatus"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1045))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editShopperData.Active),
      expression: "editShopperData.Active"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "selectShopperAccountStatus"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editShopperData, "Active", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1046))]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1047))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "selectShopperSkillLevel"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1049))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.editShopperData.ShopperSkillLevel),
      expression: "editShopperData.ShopperSkillLevel",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "selectShopperSkillLevel",
      "disabled": !_vm.globals.isSkillLevelEditingAllowed
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.$set(_vm.editShopperData, "ShopperSkillLevel", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((5), function(i) {
    return _c('option', {
      key: i
    }, [_vm._v(_vm._s(i))])
  }), 0)]), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "selectShopperSkillLevel",
      "delay": _vm.globals.tooltipDelay,
      "placement": "right",
      "boundary": "viewport"
    }
  }, [_vm._v("\n                      1 → " + _vm._s(_vm.lang.SM1050) + "\n                      "), _c('br'), _vm._v(" "), _c('br'), _vm._v("...\n                      "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n                      5 → " + _vm._s(_vm.lang.SM1051) + "\n                    ")])], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.SM1007) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "id": "shopper-management-save-button-modal",
      "type": "button",
      "disabled": !_vm.globals.isAccessAllowed('LoopOp_Shopper_Update')
    },
    on: {
      "click": function($event) {
        return _vm.validateBeforeSubmit('editShopperDialog')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.SM1008) + "\n          ")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
}]}

/***/ }),
/* 1658 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    class: {
      'text-red': _vm.Recommended && !_vm.value
    },
    attrs: {
      "for": ("input-shopper-custprop-" + _vm.Guid + "-" + _vm._uid)
    }
  }, [_vm._v("\n    " + _vm._s(_vm.Title) + "\n    "), (_vm.Recommended) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": ("input-shopper-custprop-" + _vm.Guid + "-" + _vm._uid),
      "disabled": _vm.readOnly
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "change": _vm.updateValue
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 1659 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "addChecksDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.CM2000))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "add-checks-top-panel"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(
    !_vm.feature.isAudiTarget ||
    !_vm.feature.isEnabled('audi_importers')
  ) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "check-management-create-clients",
      "placeholder": _vm.lang.CM2001,
      "allowClear": true
    },
    on: {
      "change": function($event) {
        return _vm.$emit('clientSelected', _vm.selectedClientLocal)
      }
    },
    model: {
      value: (_vm.selectedClientLocal),
      callback: function($$v) {
        _vm.selectedClientLocal = $$v
      },
      expression: "selectedClientLocal"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.dataLists.clientList), function(client) {
    return _c('option', {
      key: client.ClientGuid,
      domProps: {
        "value": client.ClientGuid
      }
    }, [_vm._v("\n                      " + _vm._s(client.ClientName) + "\n                    ")])
  })], 2)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    class: !_vm.feature.isAudiTarget ||
      !_vm.feature.isEnabled('audi_importers') ?
      'col-md-2' :
      'col-md-4'
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "check-management-create-projects",
      "disabled": !_vm.selectedClientLocal,
      "placeholder": _vm.lang.CM2002,
      "allowClear": true
    },
    model: {
      value: (_vm.selectedProjectLocal),
      callback: function($$v) {
        _vm.selectedProjectLocal = $$v
      },
      expression: "selectedProjectLocal"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.projectsOfClient), function(project) {
    return _c('option', {
      key: project.ProjectGuid,
      domProps: {
        "value": project.ProjectGuid
      }
    }, [_vm._v("\n                      " + _vm._s(project.ProjectName) + "\n                    ")])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "check-management-create-surveys",
      "disabled": !_vm.selectedProjectLocal,
      "placeholder": _vm.lang.CM2003,
      "allowClear": true
    },
    model: {
      value: (_vm.selectedSurvey),
      callback: function($$v) {
        _vm.selectedSurvey = $$v
      },
      expression: "selectedSurvey"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.surveysOfProject), function(survey) {
    return _c('option', {
      key: survey.SurveyId,
      domProps: {
        "value": survey.SurveyId
      }
    }, [_vm._v("\n                      " + _vm._s(survey.SurveyTitle) + "\n                    ")])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "check-management-create-waves",
      "disabled": !_vm.selectedProjectLocal,
      "placeholder": _vm.lang.CM2004,
      "allowClear": true
    },
    model: {
      value: (_vm.selectedWave),
      callback: function($$v) {
        _vm.selectedWave = $$v
      },
      expression: "selectedWave"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.wavesOfProject), function(wave) {
    return _c('option', {
      key: wave.WaveGuid,
      domProps: {
        "value": wave.WaveGuid
      }
    }, [_vm._v("\n                      " + _vm._s(wave.WaveName) + "\n                    ")])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "check-management-create-scenarios",
      "disabled": !_vm.selectedWave,
      "placeholder": _vm.lang.CM2005,
      "allowClear": true
    },
    model: {
      value: (_vm.selectedScenario),
      callback: function($$v) {
        _vm.selectedScenario = $$v
      },
      expression: "selectedScenario"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.scenariosOfWave), function(scenario) {
    return _c('option', {
      key: scenario.ScenarioGuid,
      domProps: {
        "value": scenario.ScenarioGuid
      }
    }, [_vm._v("\n                      " + _vm._s(scenario.ScenarioName) + "\n                    ")])
  })], 2)], 1)]), _vm._v(" "), (
    _vm.feature.isAudiTarget && _vm.feature.isEnabled('leadAgencies')
  ) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "check-management-create-lead-agency",
      "placeholder": _vm.lang.CM2013,
      "allowClear": true
    },
    on: {
      "change": function($event) {
        _vm.selectedUser = ''
      }
    },
    model: {
      value: (_vm.selectedAgency),
      callback: function($$v) {
        _vm.selectedAgency = $$v
      },
      expression: "selectedAgency"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.leadAgencies), function(agency) {
    return _c('option', {
      key: agency.AgencyGuid,
      domProps: {
        "value": agency.AgencyGuid
      }
    }, [_vm._v("\n                      " + _vm._s(agency.AgencyName) + "\n                    ")])
  })], 2)], 1)]) : _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "check-management-create-check-types",
      "placeholder": _vm.lang.CM2031,
      "allowClear": true
    },
    on: {
      "change": function($event) {
        (_vm.selectedUser = ''), (_vm.selectedAgency = '')
      }
    },
    model: {
      value: (_vm.selectedCheckType),
      callback: function($$v) {
        _vm.selectedCheckType = $$v
      },
      expression: "selectedCheckType"
    }
  }, [_c('option', {
    attrs: {
      "value": "FO"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM2032))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MA"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM2033))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AG"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM2034))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [(_vm.feature.isEnabled('briefingAndSurveyDocs')) ? _c('div', {
    staticClass: "form-group"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.lang.CM2029,
      "allowClear": true,
      "disabled": !_vm.selectedProjectLocal
    },
    model: {
      value: (_vm.selectedBriefingGuid),
      callback: function($$v) {
        _vm.selectedBriefingGuid = $$v
      },
      expression: "selectedBriefingGuid"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.briefingAttachments), function(briefing) {
    return _c('option', {
      key: briefing.DownloadId,
      domProps: {
        "value": briefing.DownloadId
      }
    }, [_vm._v("\n                      " + _vm._s(briefing.FileName) + "\n                    ")])
  })], 2)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [(_vm.feature.isEnabled('briefingAndSurveyDocs')) ? _c('div', {
    staticClass: "form-group"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.lang.CM2030,
      "allowClear": true,
      "disabled": !_vm.selectedProjectLocal
    },
    model: {
      value: (_vm.selectedSurveyGuid),
      callback: function($$v) {
        _vm.selectedSurveyGuid = $$v
      },
      expression: "selectedSurveyGuid"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.surveyAttachments), function(survey) {
    return _c('option', {
      key: survey.DownloadId,
      domProps: {
        "value": survey.DownloadId
      }
    }, [_vm._v("\n                      " + _vm._s(survey.FileName) + "\n                    ")])
  })], 2)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group input-form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputGlobalAmount"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM2009))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.globalAmount),
      expression: "globalAmount",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "id": "inputGlobalAmount"
    },
    domProps: {
      "value": (_vm.globalAmount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.globalAmount = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group input-form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkInfo),
      expression: "checkInfo"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "50",
      "placeholder": _vm.lang.CM2044
    },
    domProps: {
      "value": (_vm.checkInfo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.checkInfo = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.selectedCheckType === 'AG' && !_vm.feature.isAudiTarget) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.lang.CM2013,
      "allowClear": true
    },
    on: {
      "change": function($event) {
        _vm.selectedUser = ''
      }
    },
    model: {
      value: (_vm.selectedAgency),
      callback: function($$v) {
        _vm.selectedAgency = $$v
      },
      expression: "selectedAgency"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.dataLists.agencyList), function(agency) {
    return _c('option', {
      key: agency.AgencyGuid,
      domProps: {
        "value": agency.AgencyGuid
      }
    }, [_vm._v("\n                      " + _vm._s(agency.AgencyName) + "\n                    ")])
  })], 2)], 1)]) : (_vm.selectedCheckType === 'MA') ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.lang.CM2006,
      "allowClear": true
    },
    on: {
      "change": function($event) {
        _vm.selectedAgency = ''
      }
    },
    model: {
      value: (_vm.selectedUser),
      callback: function($$v) {
        _vm.selectedUser = $$v
      },
      expression: "selectedUser"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.dataLists.shopperList), function(user, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": key
      }
    }, [_vm._v("\n                      " + _vm._s(user) + "\n                    ")])
  })], 2)], 1)]) : _vm._e(), _vm._v(" "), (
    _vm.selectedCheckType === 'FO' &&
    _vm.feature.isEnabled('freeOffers')
  ) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group form-group-buttons"
  }, [_c('a', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showFurtherSettingsModal = true
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.lang.CM2038))])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group searchbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Search),
      expression: "filterStrings.Search"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputSearchAddChecks",
      "placeholder": _vm.lang.CM2014
    },
    domProps: {
      "value": (_vm.filterStrings.Search)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Search", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 last-row-button-container"
  }, [_c('div', {
    staticClass: "form-group form-group-buttons"
  }, [_c('a', {
    staticClass: "btn btn-raised",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clearFilter()
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.lang.CM2010))])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-raised",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.togglePageSelected()
      }
    }
  }, [(!_vm.isPageSelected()) ? _c('span', [_vm._v(_vm._s(_vm.lang.CM2011))]) : _c('span', [_vm._v(_vm._s(_vm.lang.CM2012))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 last-row-button-container"
  }, [_c('span', {
    staticClass: "selected-locations-counter"
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.CM2037) + ": " + _vm._s(_vm.selectedLocations.length || 0) + "\n                  "), (_vm.selectedLocations.length) ? [_c('a', {
    staticClass: "btn btn-raised",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        _vm.selectedLocations = []
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.CM2036))])] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 nopadding"
  }, [_c('ul', {
    staticClass: "pagination-fonts pagination btn-group"
  }, [_c('li', [_vm._m(0), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "elementsPerPageDropdownAddChecks",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.CM2015))]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 20
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 20)
      }
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 50
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 50)
      }
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 100,
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 100)
      }
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 200,
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 200)
      }
    }
  }, [_vm._v("200")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 500,
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 500)
      }
    }
  }, [_vm._v("500")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 1000,
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 1000)
      }
    }
  }, [_vm._v("1000")])])])], 1), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.pageCount || _vm.selectedPage == 1,
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 0)
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "firstPageButtonAddChecks",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.CM2016))])], 1), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage > 4) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getVisiblePages()), function(pageNumber) {
    return _c('li', {
      key: pageNumber,
      class: {
        active: _vm.selectedPage == pageNumber
      },
      on: {
        "click": function($event) {
          return _vm.updatePaging(pageNumber, 0)
        }
      }
    }, [_c('a', {
      attrs: {
        "role": "button"
      }
    }, [_vm._v(_vm._s(pageNumber))])])
  }), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage < _vm.pageCount - 3) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.pageCount || _vm.selectedPage == _vm.pageCount,
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(_vm.pageCount, 0)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "lastPageButtonAddChecks",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.CM2017))])], 1), _vm._v(" "), _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button",
      "id": "addChecksTotalElementsCounter"
    }
  }, [_vm._v(_vm._s(_vm.totalElementsCount))]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "addChecksTotalElementsCounter",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.CM2045))])], 1)], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default locations-table-panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    staticClass: "table table-striped table-hover main-table",
    attrs: {
      "id": "possibleLocations"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "8%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortLocationData('LocationId')
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.CM2018) + "\n                        "), (
    _vm.sortField == 'LocationId' && _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'LocationId' && _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "8%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortLocationData('LocationStoreId')
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.CM2019) + "\n                        "), (
    _vm.sortField == 'LocationStoreId' &&
    _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'LocationStoreId' &&
    _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "6%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortLocationData('LocationCountry')
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.CM2020) + "\n                        "), (
    _vm.sortField == 'LocationCountry' &&
    _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'LocationCountry' &&
    _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "25%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortLocationData('LocationAddress')
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.CM2021) + "\n                        "), (
    _vm.sortField == 'LocationAddress' &&
    _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'LocationAddress' &&
    _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "35%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortLocationData('LocationProperties')
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.CM2022) + "\n                        "), (
    _vm.sortField == 'LocationProperties' &&
    _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'LocationProperties' &&
    _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "6%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortLocationData('LocationStatusId')
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.CM2023) + "\n                        "), (
    _vm.sortField == 'LocationStatusId' &&
    _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'LocationStatusId' &&
    _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "6%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortLocationData('SurveyInstancesCount')
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.CM2024) + "\n                        "), (
    _vm.sortField == 'SurveyInstancesCount' &&
    _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'SurveyInstancesCount' &&
    _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "6%"
    }
  }, [_c('a', {
    staticClass: "table-header"
  }, [_vm._v(_vm._s(_vm.lang.CM2009))])])]), _vm._v(" "), _c('tr', {
    staticClass: "table-filters"
  }, [_c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "8%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationId),
      expression: "filterStrings.LocationId"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM2025
    },
    domProps: {
      "value": (_vm.filterStrings.LocationId)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "8%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationStoreId),
      expression: "filterStrings.LocationStoreId"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM2025
    },
    domProps: {
      "value": (_vm.filterStrings.LocationStoreId)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationStoreId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "6%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationCountry),
      expression: "filterStrings.LocationCountry"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM2025
    },
    domProps: {
      "value": (_vm.filterStrings.LocationCountry)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationCountry", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "25%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationAddress),
      expression: "filterStrings.LocationAddress"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM2025
    },
    domProps: {
      "value": (_vm.filterStrings.LocationAddress)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationAddress", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "35%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationProperties),
      expression: "filterStrings.LocationProperties"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM2025
    },
    domProps: {
      "value": (_vm.filterStrings.LocationProperties)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationProperties", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "6%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationStatusId),
      expression: "filterStrings.LocationStatusId"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM2025
    },
    domProps: {
      "value": (_vm.filterStrings.LocationStatusId)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationStatusId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "6%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstancesCount),
      expression: "filterStrings.SurveyInstancesCount"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM2025
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstancesCount)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstancesCount", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('tbody', {
    staticClass: "main-table-scrollbar",
    attrs: {
      "id": "create-checks-table"
    }
  }, _vm._l((_vm.locationData), function(location) {
    return _c('tr', {
      key: location.LocationId,
      class: {
        info: _vm.isLocationSelected(location.LocationId),
        'location-inactive': location.LocationStatusId === 'X',
        'location-temp-inactive': location.LocationStatusId === 'T',
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.toggleLocationSelected(location.LocationId)
        }
      }
    }, [_c('td', {
      staticStyle: {
        "width": "8%"
      }
    }, [_vm._v(_vm._s(location.LocationId))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "8%"
      }
    }, [_vm._v(_vm._s(location.LocationStoreId))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%"
      }
    }, [_vm._v(_vm._s(location.LocationCountry))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v("\n                      " + _vm._s(location.LocationAddress) + "\n                    ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "35%"
      }
    }, [_vm._v("\n                      " + _vm._s(location.LocationProperties) + "\n                    ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%"
      }
    }, [_vm._v("\n                      " + _vm._s(location.LocationStatusId) + "\n                    ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%"
      }
    }, [_vm._v("\n                      " + _vm._s(location.SurveyInstancesCount) + "\n                    ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%",
        "padding": "0"
      }
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (location.Amount),
        expression: "location.Amount",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "form-control nopadding",
      attrs: {
        "type": "number",
        "min": "0"
      },
      domProps: {
        "value": (location.Amount)
      },
      on: {
        "click": function($event) {
          return $event.stopPropagation()
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(location, "Amount", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })])])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.CM2039) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "id": "check-management-create",
      "type": "button",
      "disabled": _vm.selectedLocations.length < 1 ||
        !_vm.selectedSurvey ||
        !_vm.selectedScenario ||
        (!_vm.selectedUser && !_vm.selectedAgency && _vm.selectedCheckType !== 'FO')
    },
    on: {
      "click": function($event) {
        return _vm.createChecks()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.CM2026) + "\n          ")])])])])]), _vm._v(" "), _c('AddChecksFurtherSettingsModal', {
    ref: "addChecksFurtherSettingsModal",
    attrs: {
      "showModal": _vm.showFurtherSettingsModal,
      "survey": _vm.selectedSurveyData
    },
    on: {
      "modalClosed": _vm.furtherSettingsModalClosed
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "role": "button",
      "data-toggle": "dropdown",
      "id": "elementsPerPageDropdownAddChecks"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("view_headline")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "firstPageButtonAddChecks"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("first_page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "lastPageButtonAddChecks"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("last_page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "6%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  })])
}]}

/***/ }),
/* 1660 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "locationDataTranslateModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.LTM000))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(_vm._s(_vm.lang.LTM001) + " / " + _vm._s(_vm.lang.LTM002))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select2', {
    ref: "selectLocalizedLocationDataCountryCode",
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.lang.LTM003,
      "allowClear": true
    },
    on: {
      "change": function($event) {
        _vm.selectedLanguage = ''
      },
      "open": function($event) {
        _vm.currentTranslationDataDirty && _vm.showDirtyDataWarning()
      }
    },
    model: {
      value: (_vm.selectedCountry),
      callback: function($$v) {
        _vm.selectedCountry = $$v
      },
      expression: "selectedCountry"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.countryList), function(country, ISOCode) {
    return _c('option', {
      key: ISOCode,
      domProps: {
        "value": ISOCode
      }
    }, [_vm._v("\n                " + _vm._s(country) + "\n              ")])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select2', {
    ref: "selectLocalizedLocationDataLanguageCode",
    staticClass: "form-control",
    attrs: {
      "disabled": !_vm.selectedCountry,
      "placeholder": _vm.lang.LTM004,
      "allowClear": true
    },
    on: {
      "open": function($event) {
        _vm.currentTranslationDataDirty && _vm.showDirtyDataWarning()
      }
    },
    model: {
      value: (_vm.selectedLanguage),
      callback: function($$v) {
        _vm.selectedLanguage = $$v
      },
      expression: "selectedLanguage"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.currentCountryLanguages), function(language) {
    return _c('option', {
      key: language.LanguageCode,
      domProps: {
        "value": language.LanguageCode
      }
    }, [_vm._v("\n                " + _vm._s(language.LanguageName) + "\n              ")])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-default btn-fab",
    attrs: {
      "disabled": !_vm.selectedLanguage || !_vm.currentTranslationData.LocationGuid
    },
    on: {
      "click": function($event) {
        return _vm.deleteTranslationData()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36 text-red"
  }, [_vm._v("clear")])])]), _vm._v(" "), (_vm.selectedLanguage) ? [(!_vm.currentTranslationData.LocationGuid) ? _c('div', {
    staticClass: "col-md-12 location-translation-form"
  }, [_vm._v("\n              " + _vm._s(_vm.lang.LTM005) + "\n              "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-fab",
    on: {
      "click": function($event) {
        return _vm.addNewTranslationData()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36 text-green"
  }, [_vm._v("add")])])]) : _c('div', {
    staticClass: "col-md-12 location-translation-form",
    on: {
      "input": function($event) {
        _vm.currentTranslationDataDirty = true
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputLocationTranslationLocationName"
    }
  }, [_vm._v(_vm._s(_vm.lang.LTM006))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-5 base-data-label"
  }, [_vm._v(_vm._s(_vm.baseLocationData.LocationName))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentTranslationData.LocationName),
      expression: "currentTranslationData.LocationName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputLocationTranslationLocationName",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.currentTranslationData.LocationName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentTranslationData, "LocationName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputLocationTranslationAddress"
    }
  }, [_vm._v(_vm._s(_vm.lang.LTM007))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-5 base-data-label"
  }, [_vm._v(_vm._s(_vm.baseLocationData.LocationAddress))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentTranslationData.LocationAddress),
      expression: "currentTranslationData.LocationAddress"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputLocationTranslationAddress",
      "maxlength": "150"
    },
    domProps: {
      "value": (_vm.currentTranslationData.LocationAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentTranslationData, "LocationAddress", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputLocationTranslationAddress2"
    }
  }, [_vm._v(_vm._s(_vm.lang.LTM008))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-5 base-data-label"
  }, [_vm._v(_vm._s(_vm.baseLocationData.LocationAddress2))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentTranslationData.LocationAddress2),
      expression: "currentTranslationData.LocationAddress2"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputLocationTranslationAddress2",
      "maxlength": "150"
    },
    domProps: {
      "value": (_vm.currentTranslationData.LocationAddress2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentTranslationData, "LocationAddress2", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputLocationTranslationLocationCounty"
    }
  }, [_vm._v(_vm._s(_vm.lang.LTM009))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-5 base-data-label"
  }, [_vm._v(_vm._s(_vm.baseLocationData.LocationCounty))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentTranslationData.LocationCounty),
      expression: "currentTranslationData.LocationCounty"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputLocationTranslationLocationCounty",
      "maxlength": "250"
    },
    domProps: {
      "value": (_vm.currentTranslationData.LocationCounty)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentTranslationData, "LocationCounty", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputLocationTranslationLocationCity"
    }
  }, [_vm._v(_vm._s(_vm.lang.LTM010))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-5 base-data-label"
  }, [_vm._v(_vm._s(_vm.baseLocationData.LocationCity))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentTranslationData.LocationCity),
      expression: "currentTranslationData.LocationCity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputLocationTranslationLocationCity",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.currentTranslationData.LocationCity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentTranslationData, "LocationCity", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputLocationTranslationLocationPostalCode"
    }
  }, [_vm._v(_vm._s(_vm.lang.LTM011))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-5 base-data-label"
  }, [_vm._v(_vm._s(_vm.baseLocationData.LocationPostalCode))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentTranslationData.LocationPostalCode),
      expression: "currentTranslationData.LocationPostalCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputLocationTranslationLocationPostalCode",
      "maxlength": "12"
    },
    domProps: {
      "value": (_vm.currentTranslationData.LocationPostalCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentTranslationData, "LocationPostalCode", $event.target.value)
      }
    }
  })])])])] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.LTM012) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-success",
    class: {
      'btn-warning': _vm.currentTranslationDataDirty
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveLocalizedLocationData()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.LTM013) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 1661 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "editWaveDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.WV0000))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.lang.WV0024) + ":")]), _vm._v("\n            " + _vm._s(_vm.selectedProjectData.ProjectId) + " -\n            " + _vm._s(_vm.selectedProjectData.ProjectName) + ",\n            "), _c('b', [_vm._v(_vm._s(_vm.lang.WV0025) + ":")]), _vm._v("\n            " + _vm._s(_vm.selectedProjectData.ClientId) + " -\n            " + _vm._s(_vm.selectedProjectData.ClientName) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "form-group searchbar col-md-6",
    staticStyle: {
      "padding-left": "15px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterWaveString),
      expression: "filterWaveString"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "search",
      "id": "inputSearchFilter",
      "placeholder": _vm.lang.WV0001
    },
    domProps: {
      "value": (_vm.filterWaveString)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.filterWaveString = $event.target.value
      }, function($event) {
        return _vm.doFilteringWaves()
      }]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group searchbar col-md-6",
    staticStyle: {
      "padding-left": "15px"
    }
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    class: {
      'btn-warning': _vm.wavePositionsDirty
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveWavePositions()
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.lang.WV0026) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "table-container table-waves",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('table', {
    staticClass: "table table-striped table-hover",
    attrs: {
      "id": "wavesTable"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.WV0002) + "\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.WV0003) + "\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.WV0004) + "\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.WV0005) + "\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.WV0027) + "\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.WV0039) + "\n                        ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredWaves), function(wave) {
    return _c('tr', {
      key: wave.WaveGuid,
      class: {
        info: _vm.isWaveSelected(wave.WaveGuid)
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.selectWave(wave.WaveGuid)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(wave.WaveId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(wave.WaveName))]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(_vm.globals.getLocalizedDateFromIsoTimestamp(
      wave.WaveSince
    )) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(_vm.globals.getLocalizedDateFromIsoTimestamp(
      wave.WaveUntil
    )) + "\n                        ")]), _vm._v(" "), _c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticClass: "form-group nopadding"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (wave.WavePosition),
        expression: "wave.WavePosition"
      }],
      staticClass: "form-control text-center nopadding",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(wave, "WavePosition", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          _vm.reorderWaves(), (_vm.wavePositionsDirty = true)
        }],
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, _vm._l((_vm.waves), function(w) {
      return _c('option', {
        key: w.WavePosition,
        domProps: {
          "value": w.WavePosition
        }
      }, [_vm._v("\n                                " + _vm._s(w.WavePosition) + "\n                              ")])
    }), 0)])]), _vm._v(" "), _c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticClass: "form-group nopadding",
      staticStyle: {
        "width": "90%",
        "margin-left": "5px"
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (wave.LeadAgencyId),
        expression: "wave.LeadAgencyId"
      }],
      staticClass: "form-control",
      attrs: {
        "id": 'inputWaveEditLeadAgency_' + wave.WaveId,
        "allowClear": true
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(wave, "LeadAgencyId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option'), _vm._v(" "), _vm._l((_vm.leadAgencies), function(agency) {
      return _c('option', {
        key: agency.AgencyId,
        domProps: {
          "value": agency.AgencyId
        }
      }, [_vm._v("\n                                " + _vm._s(agency.AgencyName) + "\n                              ")])
    })], 2)])])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "padding-right": "0"
    }
  }, [_c('ul', {
    staticClass: "nav nav-tabs nav-wave-edit",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#editWaveTab",
      "id": "project-management-wave-edit-add-wave-tab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.selectedTab = 'editWaveTab'
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.WV0006))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#assignScenariosTab",
      "id": "project-management-wave-edit-assign-scenarios-tab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.selectedTab = 'assignScenariosTab'
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.WV0007) + "\n                    ")])]), _vm._v(" "), _c('li', [(_vm.carModelList.length > 0) ? _c('a', {
    attrs: {
      "href": "#carModelDistributionTab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.selectedTab = 'carModelDistributionTab'
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.WV0029) + "\n                    ")]) : _vm._e()]), _vm._v(" "), _c('li', [(_vm.feature.isAudiTarget && _vm.feature.isEnabled('shopperApproval')) ? _c('a', {
    attrs: {
      "href": "#competitorCarModelDistributionTab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.selectedTab = 'competitorCarModelDistributionTab'
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.WV0035) + "\n                    ")]) : _vm._e()]), _vm._v(" "), _c('li', [(_vm.feature.isAudiTarget) ? _c('a', {
    attrs: {
      "href": "#brandVisitsTab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.selectedTab = 'brandVisitsTab'
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.WV0045) + "\n                    ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade active in",
    attrs: {
      "id": "editWaveTab"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputWaveName"
    }
  }, [_vm._v(_vm._s(_vm.lang.WV0003))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedWave.WaveName),
      expression: "selectedWave.WaveName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputWaveName"
    },
    domProps: {
      "value": (_vm.selectedWave.WaveName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedWave, "WaveName", $event.target.value)
      }, function($event) {
        _vm.selectedWaveDirty = true
      }]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputWaveStartDate"
    }
  }, [_vm._v(_vm._s(_vm.lang.WV0004))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr('inputWaveStartDate')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedWave.WaveSince),
      expression: "selectedWave.WaveSince"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputWaveStartDate"
    },
    domProps: {
      "value": (_vm.selectedWave.WaveSince)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedWave, "WaveSince", $event.target.value)
      }, function($event) {
        _vm.selectedWaveDirty = true
      }]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputWaveEndDate"
    }
  }, [_vm._v(_vm._s(_vm.lang.WV0005))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr('inputWaveEndDate')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedWave.WaveUntil),
      expression: "selectedWave.WaveUntil"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputWaveEndDate"
    },
    domProps: {
      "value": (_vm.selectedWave.WaveUntil)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedWave, "WaveUntil", $event.target.value)
      }, function($event) {
        _vm.selectedWaveDirty = true
      }]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputWavePlannedStartDate"
    }
  }, [_vm._v(_vm._s(_vm.lang.WV0042))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr('inputWavePlannedStartDate')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedWave.WavePlannedSince),
      expression: "selectedWave.WavePlannedSince"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputWavePlannedStartDate"
    },
    domProps: {
      "value": (_vm.selectedWave.WavePlannedSince)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedWave, "WavePlannedSince", $event.target.value)
      }, function($event) {
        _vm.selectedWaveDirty = true
      }]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputWavePlannedEndDate"
    }
  }, [_vm._v(_vm._s(_vm.lang.WV0043))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr('inputWavePlannedEndDate')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedWave.WavePlannedUntil),
      expression: "selectedWave.WavePlannedUntil"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputWavePlannedEndDate"
    },
    domProps: {
      "value": (_vm.selectedWave.WavePlannedUntil)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedWave, "WavePlannedUntil", $event.target.value)
      }, function($event) {
        _vm.selectedWaveDirty = true
      }]
    }
  })])]), _vm._v(" "), (!_vm.feature.isAudiTarget) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputWaveEditCostCenter"
    }
  }, [_vm._v(_vm._s(_vm.lang.WV0028))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedWave.CostCenter),
      expression: "selectedWave.CostCenter"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputWaveEditCostCenter"
    },
    domProps: {
      "value": (_vm.selectedWave.CostCenter)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedWave, "CostCenter", $event.target.value)
      }, function($event) {
        _vm.selectedWaveDirty = true
      }]
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputWaveEditWaveInfo"
    }
  }, [_vm._v(_vm._s(_vm.lang.WV0033))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedWave.WaveInfo),
      expression: "selectedWave.WaveInfo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputWaveEditWaveInfo",
      "maxlength": "500",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.selectedWave.WaveInfo)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedWave, "WaveInfo", $event.target.value)
      }, function($event) {
        _vm.selectedWaveDirty = true
      }]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputWaveReportingVisibility"
    }
  }, [_vm._v(_vm._s(_vm.lang.WV0008))]), _vm._v(" "), _c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "float": "left",
      "margin-left": "15px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedWave.ReportingVisibility),
      expression: "selectedWave.ReportingVisibility"
    }],
    attrs: {
      "type": "checkbox",
      "id": "inputWaveReportingVisibility"
    },
    domProps: {
      "checked": Array.isArray(_vm.selectedWave.ReportingVisibility) ? _vm._i(_vm.selectedWave.ReportingVisibility, null) > -1 : (_vm.selectedWave.ReportingVisibility)
    },
    on: {
      "input": function($event) {
        _vm.selectedWaveDirty = true
      },
      "change": [function($event) {
        var $$a = _vm.selectedWave.ReportingVisibility,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.selectedWave, "ReportingVisibility", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.selectedWave, "ReportingVisibility", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.selectedWave, "ReportingVisibility", $$c)
        }
      }, function($event) {
        return _vm.waveReportingVisibilityChanged(_vm.selectedWave)
      }]
    }
  }), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputWaveWithoutApprovel"
    }
  }, [_vm._v(_vm._s(_vm.lang.WV0040))]), _vm._v(" "), _c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "float": "left",
      "margin-left": "15px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedWave.WaveWithoutApprovel),
      expression: "selectedWave.WaveWithoutApprovel"
    }],
    attrs: {
      "type": "checkbox",
      "id": "inputWaveWithoutApprovel"
    },
    domProps: {
      "checked": Array.isArray(_vm.selectedWave.WaveWithoutApprovel) ? _vm._i(_vm.selectedWave.WaveWithoutApprovel, null) > -1 : (_vm.selectedWave.WaveWithoutApprovel)
    },
    on: {
      "input": function($event) {
        _vm.selectedWaveDirty = true
      },
      "change": function($event) {
        var $$a = _vm.selectedWave.WaveWithoutApprovel,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.selectedWave, "WaveWithoutApprovel", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.selectedWave, "WaveWithoutApprovel", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.selectedWave, "WaveWithoutApprovel", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputLocalWave"
    }
  }, [_vm._v(_vm._s(_vm.lang.WV0041))]), _vm._v(" "), _c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "float": "left",
      "margin-left": "15px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedWave.IsLocalWave),
      expression: "selectedWave.IsLocalWave"
    }],
    attrs: {
      "type": "checkbox",
      "id": "inputLocalWave"
    },
    domProps: {
      "checked": Array.isArray(_vm.selectedWave.IsLocalWave) ? _vm._i(_vm.selectedWave.IsLocalWave, null) > -1 : (_vm.selectedWave.IsLocalWave)
    },
    on: {
      "input": function($event) {
        _vm.selectedWaveDirty = true
      },
      "change": function($event) {
        var $$a = _vm.selectedWave.IsLocalWave,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.selectedWave, "IsLocalWave", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.selectedWave, "IsLocalWave", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.selectedWave, "IsLocalWave", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(2)])])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedWave.WaveName
    },
    on: {
      "click": function($event) {
        return _vm.createNewWave()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("add_box")]), _vm._v(" "), _c('br'), _vm._v("\n                      " + _vm._s(_vm.lang.WV0009) + "\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-success btn-top-bar",
    class: {
      'btn-warning': _vm.selectedWaveDirty
    },
    attrs: {
      "id": "project-management-wave-save",
      "type": "button",
      "disabled": !_vm.canSaveWave()
    },
    on: {
      "click": function($event) {
        return _vm.saveSelectedWave()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("save")]), _vm._v(" "), _c('br'), _vm._v("\n                      " + _vm._s(_vm.lang.WV0010) + "\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedWave.WaveId || !_vm.globals.isAccessAllowed('LoopOp_ProjectWaves_Delete')
    },
    on: {
      "click": function($event) {
        return _vm.openDeleteWaveConfirmationDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("delete")]), _vm._v(" "), _c('br'), _vm._v("\n                      " + _vm._s(_vm.lang.WV0011) + "\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedWave.WaveId
    },
    on: {
      "click": function($event) {
        return _vm.showWaveStatus()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("insert_chart")]), _vm._v(" "), _c('br'), _vm._v("\n                      " + _vm._s(_vm.lang.WV0034) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "assignScenariosTab"
    }
  }, [_c('div', {
    staticClass: "form-group searchbar",
    staticStyle: {
      "margin-right": "15px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterScenarioString),
      expression: "filterScenarioString"
    }],
    staticClass: "form-control",
    staticStyle: {
      "max-width": "40%",
      "display": "inline",
      "float": "left"
    },
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.WV0001
    },
    domProps: {
      "value": (_vm.filterScenarioString)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.filterScenarioString = $event.target.value
      }, function($event) {
        return _vm.doFilteringScenarios()
      }]
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-success",
    class: {
      'btn-warning': _vm.selectedWaveDirty
    },
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "id": "saveAssignment",
      "type": "button",
      "disabled": !_vm.canSaveWave()
    },
    on: {
      "click": function($event) {
        return _vm.saveSelectedWave()
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.WV0010) + "\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table table-striped table-hover",
    attrs: {
      "id": "scenarioTable"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.WV0012) + "\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.WV0013) + "\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.WV0014) + "\n                            ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredScenarios), function(scenario) {
    return _c('tr', {
      key: scenario.ScenarioGuid,
      class: {
        info: _vm.isScenarioSelected(scenario.ScenarioGuid),
        'cursor-not-allowed': !_vm.selectedWave.WaveId,
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.selectScenario(scenario.ScenarioGuid)
        }
      }
    }, [_c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v("\n                              " + _vm._s(scenario.ScenarioId) + "\n                            ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v("\n                              " + _vm._s(scenario.ScenarioName) + "\n                            ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "60%"
      }
    }, [_vm._v("\n                              " + _vm._s(scenario.ScenarioDescription) + "\n                            ")])])
  }), 0)])])]), _vm._v(" "), (_vm.carModelList.length > 0) ? _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "carModelDistributionTab"
    }
  }, [_c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.WV0030) + "\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.lang.SA0012))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.lang.CMM002))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.WV0031) + " (%)\n                            ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.carModelList), function(model) {
    return _c('tr', {
      key: model.CarModelGuid
    }, [_c('td', [_vm._v(_vm._s(model.CarModelName))]), _vm._v(" "), _c('td', [(model.ImporterGuid) ? _c('div', [_vm._l((_vm.importerList), function(importer) {
      return [(importer.ImporterGuid === model.ImporterGuid) ? _c('div', {
        key: importer.ImporterGuid
      }, [_vm._v("\n                                    " + _vm._s(importer.ImporterName) + "\n                                  ")]) : _vm._e()]
    })], 2) : _vm._e()]), _vm._v(" "), _c('td', _vm._l((model.CarSegments), function(modelCarSegment, index) {
      return _c('span', {
        key: modelCarSegment.CarSegmentGuid
      }, [_vm._l((_vm.segmentList), function(segment) {
        return [(segment.CarSegmentGuid === modelCarSegment.CarSegmentGuid) ? _c('span', {
          key: segment.CarSegmentGuid
        }, [(index != 0) ? _c('span', [_vm._v(" ,")]) : _vm._e(), _vm._v("\n                                    " + _vm._s(segment.CarSegmentName) + "\n                                  ")]) : _vm._e()]
      })], 2)
    }), 0), _vm._v(" "), _c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticClass: "form-group nopadding"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (model.Distribution),
        expression: "model.Distribution",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "form-control text-center nopadding",
      attrs: {
        "type": "number",
        "min": "0",
        "max": "100"
      },
      domProps: {
        "value": (model.Distribution)
      },
      on: {
        "change": function($event) {
          (_vm.selectedWaveDirty = true), _vm.validateDistributionValue(model, 'audi')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(model, "Distribution", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })])])])
  }), 0)])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-success",
    class: {
      'btn-warning': _vm.selectedWaveDirty
    },
    staticStyle: {
      "float": "right",
      "margin-right": "20px"
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.canSaveWave()
    },
    on: {
      "click": function($event) {
        return _vm.saveSelectedWave()
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.WV0010) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.feature.isAudiTarget && _vm.feature.isEnabled('shopperApproval')) ? _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "competitorCarModelDistributionTab"
    }
  }, [_c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.WV0044) + "\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.WV0030) + "\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.WV0031) + " (%)\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.WV0036) + "\n                            ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.selectedWave.CompetitorCarModelDistribution), function(model, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticClass: "form-group nopadding"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (model.CompetitorCarBrand),
        expression: "model.CompetitorCarBrand"
      }],
      key: model.CompetitorCarBrand,
      staticClass: "form-control",
      attrs: {
        "allowClear": true
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(model, "CompetitorCarBrand", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          _vm.selectedWaveDirty = true
        }]
      }
    }, [_c('option', {
      attrs: {
        "disabled": "",
        "value": ""
      }
    }, [_vm._v(_vm._s(_vm.lang.WV0048))]), _vm._v(" "), _vm._l((_vm.brands), function(brand) {
      return _c('option', {
        key: brand,
        domProps: {
          "value": brand
        }
      }, [_vm._v("\n                                    " + _vm._s(brand) + "\n                                  ")])
    })], 2)])]), _vm._v(" "), _c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticClass: "form-group nopadding"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (model.CompetitorCarModel),
        expression: "model.CompetitorCarModel"
      }],
      staticClass: "form-control text-center nopadding",
      attrs: {
        "type": "text",
        "maxlength": "200"
      },
      domProps: {
        "value": (model.CompetitorCarModel)
      },
      on: {
        "change": function($event) {
          _vm.selectedWaveDirty = true
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(model, "CompetitorCarModel", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticClass: "form-group nopadding"
    }, [_c('input', {
      staticClass: "form-control text-center nopadding",
      attrs: {
        "type": "number",
        "min": "0",
        "max": "100"
      },
      domProps: {
        "value": parseFloat(((model.Distribution || 0) * 100).toFixed(4))
      },
      on: {
        "change": function($event) {
          (
            model.Distribution = ($event.target.value || 0) / 100),
          (_vm.selectedWaveDirty = true),
          _vm.validateDistributionValue(model, 'competitor')
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn nopadding",
      on: {
        "click": function($event) {
          return _vm.deleteCompetitorCarModel(index)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24 text-red"
    }, [_vm._v("clear")])])])])
  }), 0)]), _vm._v(" "), (_vm.getCompetitorDistributionsInfoToolTip().length > 0) ? _c('span', {
    staticStyle: {
      "float": "right",
      "margin-right": "25px"
    },
    attrs: {
      "id": "competitorDistributionsInfo"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24 text-info",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_vm._v("info")]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "competitorDistributionsInfo",
      "delay": _vm.globals.tooltipDelay,
      "triggers": "hover"
    }
  }, [_vm._l((_vm.getCompetitorDistributionsInfoToolTip()), function(line) {
    return [_vm._v("\n                              " + _vm._s(line) + " "), _c('br')]
  })], 2)], 1) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised",
    staticStyle: {
      "float": "left",
      "margin-left": "20px"
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedWave.WaveName
    },
    on: {
      "click": function($event) {
        return _vm.addCompetitorCarModel()
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.WV0037) + "\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-success",
    class: {
      'btn-warning': _vm.selectedWaveDirty
    },
    staticStyle: {
      "float": "right",
      "margin-right": "20px"
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.canSaveWave()
    },
    on: {
      "click": function($event) {
        return _vm.saveSelectedWave()
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.WV0010) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.feature.isAudiTarget) ? _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "brandVisitsTab"
    }
  }, [_c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("\n                               \n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.WV0046) + "\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.WV0051) + "\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.WV0036) + "\n                            ")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.selectedWave.BrandVisits), function(model, index) {
    return [_c('tr', [_c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticClass: "form-group nopadding"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (model.BrandName),
        expression: "model.BrandName"
      }],
      key: model.BrandName,
      staticClass: "form-control",
      attrs: {
        "allowClear": true
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(model, "BrandName", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          _vm.selectedWaveDirty = true
        }]
      }
    }, [_c('option', {
      attrs: {
        "disabled": "",
        "value": ""
      }
    }, [_vm._v(_vm._s(_vm.lang.WV0048))]), _vm._v(" "), _c('option', {
      attrs: {
        "disabled": _vm.canSelectBrand(_vm.selectedWave, 'Audi')
      }
    }, [_vm._v("\n                                      Audi\n                                    ")]), _vm._v(" "), _vm._l((_vm.brands), function(brand) {
      return _c('option', {
        key: brand,
        attrs: {
          "disabled": _vm.canSelectBrand(_vm.selectedWave, brand)
        },
        domProps: {
          "value": brand
        }
      }, [_vm._v("\n                                      " + _vm._s(brand) + "\n                                    ")])
    })], 2)])]), _vm._v(" "), _c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn nopadding",
      on: {
        "click": function($event) {
          return _vm.addVisitToBrandVisit(model)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24 text-green"
    }, [_vm._v("add")])]), _vm._v(" "), _c('button', {
      staticClass: "btn nopadding",
      on: {
        "click": function($event) {
          return _vm.removeBrandVisit(_vm.selectedWave, index)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24 text-red"
    }, [_vm._v("remove")])])])]), _vm._v(" "), _vm._l((model.Visits), function(visit, idx) {
      return _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
        staticClass: "nopadding"
      }, [_c('div', {
        staticClass: "form-group nopadding"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (visit.Frequency),
          expression: "visit.Frequency"
        }],
        staticClass: "form-control text-right nopadding",
        attrs: {
          "type": "number",
          "min": "0",
          "max": "100"
        },
        domProps: {
          "value": (visit.Frequency)
        },
        on: {
          "input": [function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(visit, "Frequency", $event.target.value)
          }, function($event) {
            (_vm.selectedWaveDirty = true, visit.Frequency = _vm.validateVisitValue(visit.Frequency))
          }]
        }
      })])]), _vm._v(" "), _c('td', {
        staticClass: "nopadding"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (visit.NoOfVisits),
          expression: "visit.NoOfVisits"
        }],
        staticClass: "form-control text-right nopadding",
        attrs: {
          "type": "number",
          "min": "0",
          "max": "100"
        },
        domProps: {
          "value": (visit.NoOfVisits)
        },
        on: {
          "input": [function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(visit, "NoOfVisits", $event.target.value)
          }, function($event) {
            (_vm.selectedWaveDirty = true, visit.NoOfVisits = _vm.validateVisitValue(visit.NoOfVisits))
          }]
        }
      })]), _vm._v(" "), _c('td', [_c('button', {
        staticClass: "btn nopadding",
        attrs: {
          "disabled": !_vm.canRemoveVisit(_vm.selectedWave, index)
        },
        on: {
          "click": function($event) {
            return _vm.removeVisit(_vm.selectedWave, index, idx)
          }
        }
      }, [_c('i', {
        staticClass: "material-icons md-24 text-red"
      }, [_vm._v("remove")])])])])
    })]
  })], 2)]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right",
      "margin-right": "50px"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.lang.WV0050) + ":")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.getTotalNumberOfVisits(_vm.selectedWave)))])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised",
    staticStyle: {
      "float": "left",
      "margin-left": "20px"
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedWave.WaveName
    },
    on: {
      "click": function($event) {
        return _vm.addNewBrandVisit(_vm.selectedWave)
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.WV0047) + "\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-success",
    class: {
      'btn-warning': _vm.selectedWaveDirty
    },
    staticStyle: {
      "float": "right",
      "margin-right": "20px"
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.canSaveWave()
    },
    on: {
      "click": function($event) {
        return _vm.saveSelectedWave()
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.WV0010) + "\n                    ")])]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.WV0015) + "\n          ")])])])])]), _vm._v(" "), _c('WaveStatusModal')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
}]}

/***/ }),
/* 1662 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dialog-table-panel"
  }, [_c('div', {
    staticClass: "dialog-table-panel"
  }, [_c('table', {
    staticClass: "table table-striped table-hover main-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center w80"
  }, [_vm._v(_vm._s(_vm.lang.S0139))]), _vm._v(" "), _c('th', {
    staticClass: "text-center w20"
  }, [_c('span', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.toggleAll
    }
  }, [_vm._v(_vm._s(_vm.lang.S0172))])])])]), _vm._v(" "), _c('tbody', {
    staticClass: "main-table-scrollbar client-policies-table"
  }, _vm._l((_vm.settings), function(setting) {
    return _c('tr', {
      key: setting.ReportingFeatureGuid
    }, [_c('td', {
      staticClass: "td-cb-policies w80"
    }, [_c('span', {
      staticClass: "table-header",
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          setting.Permitted = !setting.Permitted
        }
      }
    }, [_vm._v(_vm._s(setting.ReportingFeatureName))])]), _vm._v(" "), _c('td', {
      staticClass: "td-cb-policies w20"
    }, [_c('a', {
      staticClass: "btn btn-default btn-cb-policies2",
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          (setting.Permitted = !setting.Permitted), _vm.$forceUpdate()
        }
      }
    }, [(setting.Permitted) ? _c('i', {
      staticClass: "material-icons md-24 text-primary"
    }, [_vm._v("check_box")]) : _c('i', {
      staticClass: "material-icons md-24 text-primary"
    }, [_vm._v("check_box_outline_blank")])])])])
  }), 0)])])])
},staticRenderFns: []}

/***/ }),
/* 1663 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "carModelManagement",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-hidden": "true",
      "disabled": _vm.isModelEditing || _vm.isSegmentEditing
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.CMM000))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('ul', {
    staticClass: "nav nav-tabs",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#editCarModelsTab",
      "data-toggle": "tab",
      "disabled": _vm.isModelEditing || _vm.isSegmentEditing
    }
  }, [_vm._v(_vm._s(_vm.lang.CMM001))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#editCarSegmentsTab",
      "data-toggle": "tab",
      "disabled": _vm.isModelEditing || _vm.isSegmentEditing
    }
  }, [_vm._v(_vm._s(_vm.lang.CMM002))])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade active in",
    attrs: {
      "id": "editCarModelsTab"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputNewCarModel"
    }
  }, [_vm._v(_vm._s(_vm.lang.CMM003))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newModel),
      expression: "newModel"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "inputNewCarModel",
      "type": "text"
    },
    domProps: {
      "value": (_vm.newModel)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addNewModel()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newModel = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "segmentSelect"
    }
  }, [_vm._v(_vm._s(_vm.lang.CMM004))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('select2', {
    attrs: {
      "id": "segmentSelect",
      "multiple": true
    },
    model: {
      value: (_vm.selectedSegments),
      callback: function($$v) {
        _vm.selectedSegments = $$v
      },
      expression: "selectedSegments"
    }
  }, _vm._l((_vm.segmentList), function(segment) {
    return _c('option', {
      key: segment.CarSegmentGuid,
      domProps: {
        "value": segment.CarSegmentGuid
      }
    }, [_vm._v("\n                        " + _vm._s(segment.CarSegmentName) + "\n                      ")])
  }), 0)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "importerSelect"
    }
  }, [_vm._v(_vm._s(_vm.lang.CMM034))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedImporter),
      expression: "selectedImporter"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "importerSelect"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedImporter = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }), _vm._v(" "), _vm._l((_vm.importerList), function(importer) {
    return _c('option', {
      key: importer.ImporterGuid,
      domProps: {
        "value": importer.ImporterGuid
      }
    }, [_vm._v("\n                        " + _vm._s(importer.ImporterName) + "\n                      ")])
  })], 2)])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    staticStyle: {
      "margin-top": "0px"
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.newModel || !_vm.selectedSegments[0] || _vm.isModelEditing
    },
    on: {
      "click": function($event) {
        return _vm.addNewModel()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CMM005) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    attrs: {
      "id": "carModelTableContainer"
    }
  }, [_c('table', {
    staticClass: "table table-striped table-hover",
    attrs: {
      "id": "carModelTable"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center col-md-7"
  }, [_vm._v(_vm._s(_vm.lang.CMM006))]), _vm._v(" "), _c('th', {
    staticClass: "text-center col-md-3"
  }, [_vm._v(_vm._s(_vm.lang.CMM034))]), _vm._v(" "), _c('th', {
    staticClass: "text-center col-md-3"
  }, [_vm._v(_vm._s(_vm.lang.CMM007))]), _vm._v(" "), _c('th', {
    staticClass: "text-center col-md-2"
  }, [_vm._v(_vm._s(_vm.lang.CMM008))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.modelList), function(model, index) {
    return _c('tr', {
      key: index,
      class: {
        info: model.editing
      },
      attrs: {
        "role": "button"
      }
    }, [_c('td', {
      staticClass: "nopadding",
      on: {
        "dblclick": function($event) {
          return _vm.editModel($event, model)
        }
      }
    }, [_c('div', {
      staticClass: "form-group nopadding"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (model.CarModelName),
        expression: "model.CarModelName"
      }],
      staticClass: "form-control text-center nopadding",
      attrs: {
        "type": "text",
        "readonly": "true"
      },
      domProps: {
        "value": (model.CarModelName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(model, "CarModelName", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('td', {
      class: {
        nopadding: model.editing
      }
    }, [(model.editing) ? _c('div', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (model.ImporterGuid),
        expression: "model.ImporterGuid"
      }],
      staticClass: "form-control",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(model, "ImporterGuid", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.updateModelImporterName(model)
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": null
      }
    }), _vm._v(" "), _vm._l((_vm.importerList), function(importer) {
      return _c('option', {
        key: importer.ImporterGuid,
        domProps: {
          "value": importer.ImporterGuid
        }
      }, [_vm._v("\n                              " + _vm._s(importer.ImporterName) + "\n                            ")])
    })], 2)]) : _c('div', [_vm._v("\n                          " + _vm._s(model.ImporterName) + "\n                        ")])]), _vm._v(" "), _c('td', {
      class: {
        nopadding: model.editing
      },
      on: {
        "dblclick": function($event) {
          return _vm.editModel($event, model)
        }
      }
    }, [(model.editing) ? _c('div', {
      staticClass: "form-group"
    }, [_c('select2', {
      attrs: {
        "value": _vm.getCarSegmentsGuidList(model),
        "multiple": true
      },
      on: {
        "change": function($event) {
          return _vm.carSegmentsOfModelChanged(model, $event)
        }
      }
    }, _vm._l((_vm.segmentList), function(segment) {
      return _c('option', {
        key: segment.CarSegmentGuid,
        domProps: {
          "value": segment.CarSegmentGuid
        }
      }, [_vm._v("\n                              " + _vm._s(segment.CarSegmentName) + "\n                            ")])
    }), 0)], 1) : _c('span', [_vm._v("\n                          " + _vm._s(_vm.getCarSegmentNameList(model.CarSegments)) + "\n                        ")])]), _vm._v(" "), _c('td', {
      staticClass: "nopadding",
      attrs: {
        "id": "carModelActionButtonContainer"
      }
    }, [_c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!model.editing),
        expression: "!model.editing"
      }],
      staticClass: "btn",
      attrs: {
        "type": "button",
        "disabled": _vm.isModelEditing
      },
      on: {
        "click": function($event) {
          return _vm.editModel($event, model)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24"
    }, [_vm._v("edit")])]), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (model.editing),
        expression: "model.editing"
      }],
      staticClass: "btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.saveModel($event, model)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24 text-primary"
    }, [_vm._v("save")])]), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!model.editing),
        expression: "!model.editing"
      }],
      staticClass: "btn",
      attrs: {
        "type": "button",
        "disabled": _vm.isModelEditing
      },
      on: {
        "click": function($event) {
          return _vm.deleteModel(model)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24 text-red"
    }, [_vm._v("clear")])]), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (model.editing),
        expression: "model.editing"
      }],
      staticClass: "btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.undoModelChanges($event, model)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24 text-primary"
    }, [_vm._v("undo")])])])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "editCarSegmentsTab"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputNewSegment"
    }
  }, [_vm._v(_vm._s(_vm.lang.CMM009))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newSegment),
      expression: "newSegment"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "inputNewSegment",
      "type": "text"
    },
    domProps: {
      "value": (_vm.newSegment)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addNewSegment()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newSegment = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    staticStyle: {
      "margin-top": "0px"
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.newSegment || _vm.isSegmentEditing
    },
    on: {
      "click": function($event) {
        return _vm.addNewSegment()
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.CMM005) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    attrs: {
      "id": "segmentTableContainer"
    }
  }, [_c('table', {
    staticClass: "table table-striped table-hover",
    attrs: {
      "id": "segmentsTable"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center col-md-10"
  }, [_vm._v(_vm._s(_vm.lang.CMM006))]), _vm._v(" "), _c('th', {
    staticClass: "text-center col-md-2"
  }, [_vm._v(_vm._s(_vm.lang.CMM008))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.segmentList), function(segment, index) {
    return _c('tr', {
      key: index,
      class: {
        info: segment.editing
      },
      attrs: {
        "role": "button"
      }
    }, [_c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticClass: "form-group nopadding"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (segment.CarSegmentName),
        expression: "segment.CarSegmentName"
      }],
      staticClass: "form-control text-center nopadding",
      attrs: {
        "type": "text",
        "readonly": "true"
      },
      domProps: {
        "value": (segment.CarSegmentName)
      },
      on: {
        "dblclick": function($event) {
          return _vm.editSegment($event, segment)
        },
        "blur": function($event) {
          segment.CarSegmentName !== segment.prevCarSegmentName || _vm.undoSegmentChanges($event, segment)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(segment, "CarSegmentName", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('td', {
      staticClass: "nopadding",
      attrs: {
        "id": "segmentActionButtonContainer"
      }
    }, [_c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!segment.editing),
        expression: "!segment.editing"
      }],
      staticClass: "btn",
      attrs: {
        "type": "button",
        "disabled": _vm.isSegmentEditing
      },
      on: {
        "click": function($event) {
          return _vm.editSegment($event, segment)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24"
    }, [_vm._v("edit")])]), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (segment.editing),
        expression: "segment.editing"
      }],
      staticClass: "btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.saveSegment($event, segment)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24 text-primary"
    }, [_vm._v("save")])]), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!segment.editing),
        expression: "!segment.editing"
      }],
      staticClass: "btn",
      attrs: {
        "type": "button",
        "disabled": _vm.isSegmentEditing
      },
      on: {
        "click": function($event) {
          return _vm.deleteSegment(segment)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24 text-red"
    }, [_vm._v("clear")])]), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (segment.editing),
        expression: "segment.editing"
      }],
      staticClass: "btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.undoSegmentChanges($event, segment)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24 text-primary"
    }, [_vm._v("undo")])])])])
  }), 0)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button",
      "disabled": _vm.isModelEditing || _vm.isSegmentEditing
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.CMM010) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 1664 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "StatusWaveDetail"
  }, [(_vm.statusData && _vm.statusData.Wave) ? _c('div', {
    staticClass: "swd-meta-data"
  }, [_c('h4', [_c('b', [_vm._v(_vm._s(_vm.statusData.Wave.WaveName))])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.globals.toLocaleDateString(_vm.statusData.Wave.WaveSince)) + " - " + _vm._s(_vm.globals.toLocaleDateString(_vm.statusData.Wave.WaveUntil)))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "20%",
      "margin-left": "12px"
    }
  }, [_c('select2', {
    ref: "approvalStatusSelect",
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.lang.AWS036,
      "allowClear": true
    },
    on: {
      "change": function($event) {
        return _vm.getWaveStatus()
      }
    },
    model: {
      value: (_vm.selectedApprovalStatus),
      callback: function($$v) {
        _vm.selectedApprovalStatus = $$v
      },
      expression: "selectedApprovalStatus"
    }
  }, [_c('option', {
    attrs: {
      "value": "approved"
    }
  }, [_vm._v("Approved")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "none"
    }
  }, [_vm._v("None")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "open"
    }
  }, [_vm._v("Open")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "swd-two-col"
  }, [(_vm.statusData && _vm.statusData.SurveyInstances) ? _c('div', {
    staticClass: "stat-container"
  }, [_c('b', {
    staticClass: "stat-container-title"
  }, [_vm._v(_vm._s(_vm.lang.AWS005))]), _vm._v(" "), _c('div', {
    staticClass: "stat-row"
  }, [_c('StatIndicator', {
    attrs: {
      "value": _vm.statusData.SurveyInstances.Status.Count,
      "label": _vm.lang.AWS006,
      "centerText": _vm.statusData.SurveyInstances.Status.Count,
      "showRing": false,
      "showSquare": true
    }
  }), _vm._v(" "), _c('StatIndicator', {
    attrs: {
      "value": _vm.statusData.SurveyInstances.Status.Approval,
      "label": _vm.lang.AWS007,
      "centerText": _vm.statusData.SurveyInstances.Status.Approval,
      "showRing": false,
      "showSquare": true
    }
  }), _vm._v(" "), _c('StatIndicator', {
    attrs: {
      "value": _vm.statusData.SurveyInstances.Status.InProgress,
      "label": _vm.lang.AWS008,
      "centerText": _vm.statusData.SurveyInstances.Status.InProgress,
      "showRing": false,
      "showSquare": true
    }
  }), _vm._v(" "), _c('StatIndicator', {
    attrs: {
      "value": _vm.statusData.SurveyInstances.Status.Reporting,
      "label": _vm.lang.AWS009,
      "centerText": _vm.statusData.SurveyInstances.Status.Reporting,
      "showRing": false,
      "showSquare": true
    }
  }), _vm._v(" "), _c('StatIndicator', {
    attrs: {
      "value": _vm.statusData.Wave.InTime,
      "label": _vm.lang.AWS010,
      "centerText": _vm.statusData.Wave.InTime,
      "isPercentage": true,
      "suffix": "%"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.statusData && _vm.statusData.Approvals) ? _c('div', {
    staticClass: "stat-container"
  }, [_c('b', {
    staticClass: "stat-container-title"
  }, [_vm._v(_vm._s(_vm.lang.AWS011))]), _vm._v(" "), _c('div', {
    staticClass: "stat-row"
  }, [_c('StatIndicator', {
    attrs: {
      "value": _vm.statusData.Approvals.None,
      "label": _vm.lang.AWS012,
      "centerText": _vm.statusData.Approvals.None,
      "isPercentage": true,
      "suffix": "%"
    }
  }), _vm._v(" "), _c('StatIndicator', {
    attrs: {
      "value": _vm.statusData.Approvals.Open,
      "label": _vm.lang.AWS013,
      "centerText": _vm.statusData.Approvals.Open,
      "isPercentage": true,
      "suffix": "%"
    }
  }), _vm._v(" "), _c('StatIndicator', {
    attrs: {
      "value": _vm.statusData.Approvals.Approved,
      "label": _vm.lang.AWS014,
      "centerText": _vm.statusData.Approvals.Approved,
      "isPercentage": true,
      "suffix": "%"
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), (_vm.statusData && _vm.statusData.Shopper) ? _c('div', {
    staticClass: "stat-container"
  }, [_c('b', {
    staticClass: "stat-container-title"
  }, [_vm._v(_vm._s(_vm.lang.AWS015))]), _vm._v(" "), _c('div', {
    staticClass: "stat-row"
  }, [(_vm.statusData.Shopper.Gender) ? _c('div', {
    staticClass: "special-stat-container"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.AWS016))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "row"
    }
  }, [_c('StatIndicator', {
    attrs: {
      "value": _vm.statusData.Shopper.Gender.Male,
      "label": _vm.lang.AWS017,
      "centerText": _vm.statusData.Shopper.Gender.Male,
      "isPercentage": true,
      "suffix": "%"
    }
  }), _vm._v(" "), _c('StatIndicator', {
    attrs: {
      "value": _vm.statusData.Shopper.Gender.Female,
      "label": _vm.lang.AWS018,
      "centerText": _vm.statusData.Shopper.Gender.Female,
      "isPercentage": true,
      "suffix": "%"
    }
  }), _vm._v(" "), _c('StatIndicator', {
    attrs: {
      "value": _vm.statusData.Shopper.Gender.Divers,
      "label": 'Divers',
      "centerText": _vm.statusData.Shopper.Gender.Divers,
      "isPercentage": true,
      "suffix": "%"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.statusData.Shopper.Age) ? _c('div', {
    staticClass: "special-stat-container"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.AWS019))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "row"
    }
  }, [_c('StatIndicator', {
    attrs: {
      "value": _vm.statusData.Shopper.Age.Min,
      "label": _vm.lang.AWS020,
      "centerText": _vm.statusData.Shopper.Age.Min,
      "showRing": false,
      "showSquare": true
    }
  }), _vm._v(" "), _c('StatIndicator', {
    attrs: {
      "value": _vm.statusData.Shopper.Age.Max,
      "label": _vm.lang.AWS021,
      "centerText": _vm.statusData.Shopper.Age.Max,
      "showRing": false,
      "showSquare": true
    }
  }), _vm._v(" "), _c('StatIndicator', {
    attrs: {
      "value": _vm.statusData.Shopper.Age.Above70,
      "label": _vm.lang.AWS022,
      "centerText": _vm.statusData.Shopper.Age.Above70,
      "isPercentage": true,
      "suffix": "%"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.statusData.Shopper.Distance) ? _c('div', {
    staticClass: "special-stat-container"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.AWS023))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "row"
    }
  }, [_c('StatIndicator', {
    attrs: {
      "value": _vm.statusData.Shopper.Distance.Min / 1000,
      "label": _vm.lang.AWS020,
      "centerText": _vm.statusData.Shopper.Distance.Min / 1000,
      "showRing": false,
      "showSquare": true,
      "decimalPlaces": 0,
      "suffix": " km"
    }
  }), _vm._v(" "), _c('StatIndicator', {
    attrs: {
      "value": _vm.statusData.Shopper.Distance.Max / 1000,
      "label": _vm.lang.AWS021,
      "centerText": _vm.statusData.Shopper.Distance.Max / 1000,
      "showRing": false,
      "showSquare": true,
      "decimalPlaces": 0,
      "suffix": " km"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.statusData.Shopper.Car) ? _c('div', {
    staticClass: "special-stat-container"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.AWS024))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "row"
    }
  }, [_c('StatIndicator', {
    attrs: {
      "value": _vm.statusData.Shopper.Car.YearOfBuild.Min,
      "label": _vm.lang.AWS020,
      "centerText": _vm.statusData.Shopper.Car.YearOfBuild.Min,
      "showRing": false,
      "showSquare": true
    }
  }), _vm._v(" "), _c('StatIndicator', {
    attrs: {
      "value": _vm.statusData.Shopper.Car.YearOfBuild.Max,
      "label": _vm.lang.AWS021,
      "centerText": _vm.statusData.Shopper.Car.YearOfBuild.Max,
      "showRing": false,
      "showSquare": true
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.statusData.Model) ? _c('div', {
    staticClass: "special-stat-container"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.AWS025))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "row"
    }
  }, [_c('StatIndicator', {
    attrs: {
      "value": _vm.statusData.Model.Downgrade,
      "label": _vm.lang.AWS026,
      "centerText": _vm.statusData.Model.Downgrade,
      "isPercentage": true,
      "suffix": "%"
    }
  }), _vm._v(" "), _c('StatIndicator', {
    attrs: {
      "value": _vm.statusData.Model.Match,
      "label": _vm.lang.AWS027,
      "centerText": _vm.statusData.Model.Match,
      "isPercentage": true,
      "suffix": "%"
    }
  }), _vm._v(" "), _c('StatIndicator', {
    attrs: {
      "value": _vm.statusData.Model.Upgrade,
      "label": _vm.lang.AWS028,
      "centerText": _vm.statusData.Model.Upgrade,
      "isPercentage": true,
      "suffix": "%"
    }
  })], 1)]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.statusData && _vm.statusData.CarDistribution) ? _c('div', {
    staticClass: "stat-container"
  }, [_c('b', {
    staticClass: "stat-container-title"
  }, [_vm._v(_vm._s(_vm.lang.AWS037))]), _vm._v(" "), _c('table', {
    staticClass: "car-distribution-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.lang.WV0044))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS030))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS031))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.lang.AWS032))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.lang.AWS026))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.lang.AWS028))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.lang.AWS027))])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.statusData.CarDistribution), function(model, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v("Audi")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(model.CarModelName))]), _vm._v(" "), _c('td', [_c('StatIndicator', {
      attrs: {
        "value": model.SetValue,
        "centerText": model.SetValue,
        "isPercentage": true,
        "suffix": "%"
      }
    })], 1), _vm._v(" "), _c('td', [_c('StatIndicator', {
      attrs: {
        "value": model.ActualValue,
        "centerText": model.ActualValue,
        "isPercentage": true,
        "suffix": "%"
      }
    })], 1), _vm._v(" "), _c('td', [_c('StatIndicator', {
      attrs: {
        "value": model.ApprovedCarCountDowngrade_percentage,
        "centerText": model.ApprovedCarCountDowngrade_percentage,
        "isPercentage": true,
        "suffix": "%"
      }
    })], 1), _vm._v(" "), _c('td', [_c('StatIndicator', {
      attrs: {
        "value": model.ApprovedCarCountMatch_percentage,
        "centerText": model.ApprovedCarCountMatch_percentage,
        "isPercentage": true,
        "suffix": "%"
      }
    })], 1), _vm._v(" "), _c('td', [_c('StatIndicator', {
      attrs: {
        "value": model.ApprovedCarCountUpgrade_percentage,
        "centerText": model.ApprovedCarCountUpgrade_percentage,
        "isPercentage": true,
        "suffix": "%"
      }
    })], 1)])
  }), _vm._v(" "), _vm._l((_vm.statusData.CompetitorCarDistribution), function(model, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(model.CompetitorCarBrand))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(model.CompetitorCarModel))]), _vm._v(" "), _c('td', [_c('StatIndicator', {
      attrs: {
        "value": model.SetValue,
        "centerText": model.SetValue,
        "isPercentage": true,
        "suffix": "%"
      }
    })], 1), _vm._v(" "), _c('td', [_c('StatIndicator', {
      attrs: {
        "value": model.ActualValue,
        "centerText": model.ActualValue,
        "isPercentage": true,
        "suffix": "%"
      }
    })], 1), _vm._v(" "), _c('td', [_c('StatIndicator', {
      attrs: {
        "value": model.ApprovedCarCountDowngrade_percentage,
        "centerText": model.ApprovedCarCountDowngrade_percentage,
        "isPercentage": true,
        "suffix": "%"
      }
    })], 1), _vm._v(" "), _c('td', [_c('StatIndicator', {
      attrs: {
        "value": model.ApprovedCarCountMatch_percentage,
        "centerText": model.ApprovedCarCountMatch_percentage,
        "isPercentage": true,
        "suffix": "%"
      }
    })], 1), _vm._v(" "), _c('td', [_c('StatIndicator', {
      attrs: {
        "value": model.ApprovedCarCountUpgrade_percentage,
        "centerText": model.ApprovedCarCountUpgrade_percentage,
        "isPercentage": true,
        "suffix": "%"
      }
    })], 1)])
  })], 2)])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1665 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mapInitDone),
      expression: "mapInitDone"
    }],
    staticClass: "map-controls-container"
  }, [_c('i', {
    staticClass: "material-icons md-24 help-icon",
    attrs: {
      "id": "gmapsHelpIcon"
    }
  }, [_vm._v("help")]), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "gmapsHelpIcon",
      "boundary": "viewport",
      "triggers": "click",
      "placement": "bottomleft",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_c('div', {
    staticClass: "tooltip-div"
  }, [_c('img', {
    staticStyle: {
      "margin-right": "4px"
    },
    attrs: {
      "src": _vm.iconMarkerFactory('check').url,
      "height": "42",
      "width": "24"
    }
  }), _vm._v("\n        → " + _vm._s(_vm.lang.SAGM01) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "tooltip-div"
  }, [_c('img', {
    staticStyle: {
      "margin-right": "4px"
    },
    attrs: {
      "src": _vm.iconMarkerFactory('Open').url,
      "height": "42",
      "width": "24"
    }
  }), _vm._v("\n        → " + _vm._s(_vm.lang.SAGM02) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "tooltip-div"
  }, [_c('img', {
    staticStyle: {
      "margin-right": "4px"
    },
    attrs: {
      "src": _vm.iconMarkerFactory('Approved').url,
      "height": "42",
      "width": "24"
    }
  }), _vm._v("\n        → " + _vm._s(_vm.lang.SAGM03) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "tooltip-div"
  }, [_c('img', {
    staticStyle: {
      "margin-right": "4px"
    },
    attrs: {
      "src": _vm.iconMarkerFactory('Rejected').url,
      "height": "42",
      "width": "24"
    }
  }), _vm._v("\n        → " + _vm._s(_vm.lang.SAGM04) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "tooltip-div"
  }, [_c('img', {
    staticStyle: {
      "margin-right": "4px"
    },
    attrs: {
      "src": _vm.iconMarkerFactory('Multiple').url,
      "height": "42",
      "width": "24",
      "opacity": "0.5"
    }
  }), _vm._v("\n        → "), _c('span', {
    staticStyle: {
      "padding-left": "4px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.lang.SAGM05)
    }
  })])])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "gmaps-container"
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1666 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "ConfigOverview"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.lang.W00000))]), _vm._v(" "), _c('div', {
    staticClass: "wizard-table-container"
  }, [_c('div', {
    staticClass: "wizard-table-header"
  }, [_c('div', [_vm._v(_vm._s(_vm.lang.W00001))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.lang.W00002))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.lang.W00003))]), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')]), _vm._v(" "), _c('div', {
    staticClass: "wizard-table-body"
  }, _vm._l((_vm.configurations), function(config) {
    return _c('div', {
      key: config.ConfigurationGuid,
      staticClass: "wizard-table-row"
    }, [_c('div', {
      staticClass: "table-cell"
    }, [_vm._v(_vm._s(config.Title))]), _vm._v(" "), _c('div', {
      staticClass: "table-cell"
    }, [_vm._v(_vm._s(config.Status))]), _vm._v(" "), _c('div', {
      staticClass: "table-cell"
    }, [_vm._v(_vm._s(_vm.globals.getLocalizedDateTimeFromUtcIsoTimestamp(config.LastUpdate)))]), _vm._v(" "), _c('div', {
      staticClass: "table-cell"
    }, [_c('router-link', {
      staticClass: "resume-btn",
      attrs: {
        "to": ("/config/" + (config.ConfigurationGuid))
      }
    }, [(config.Status == 'finished') ? _c('span', [_vm._v(_vm._s(_vm.lang.W00089))]) : _c('span', [_vm._v(_vm._s(_vm.lang.W00004))])])], 1), _vm._v(" "), _c('div', {
      staticClass: "table-cell delete-config-btn-td"
    }, [_c('button', {
      staticClass: "delete-config-btn",
      attrs: {
        "disabled": config.Status == 'finished'
      },
      on: {
        "click": function($event) {
          return _vm.openConfirmationDialog(config.ConfigurationGuid)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24"
    }, [_vm._v("delete")])])])])
  }), 0)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "id": "new-config-btn",
      "to": "/config/new"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("add")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.W00008))])]), _vm._v(" "), _c('ConfirmationDialog', {
    attrs: {
      "dialogId": "deleteConfigConfirmationDialog",
      "confirmationTitle": "Do you want really to delete the configuration?",
      "yesButtonText": "Delete",
      "noButtonText": "Cancel",
      "showDialog": _vm.showDeleteConfigConfirmationDialog
    },
    on: {
      "onYesConfirmation": _vm.onYesConfirmation,
      "onNoConfirmation": _vm.onNoConfirmation,
      "dialogClosed": _vm.onConfirmationDialogClosed
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1667 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "shopperApprovalMap",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("\n          ×\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('GoogleMaps', {
    ref: "approvalGmaps",
    attrs: {
      "checkList": _vm.checkList,
      "proposalList": _vm.proposalList,
      "currentFilterObject": null
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 1668 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "htmlEditorModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#htmlEditorEditorTab",
      "data-toggle": "tab"
    }
  }, [_vm._v(_vm._s(_vm.lang.HEM000))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#htmlEditorPreviewTab",
      "data-toggle": "tab"
    }
  }, [_vm._v(_vm._s(_vm.lang.HEM001))])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "htmlEditorPreviewTab"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.HEM002) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-pane fade active in",
    attrs: {
      "id": "htmlEditorEditorTab"
    }
  }, [_c('pre', {
    attrs: {
      "id": "aceEditor"
    }
  })])
}]}

/***/ }),
/* 1669 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (
    _vm.globals.isAccessAllowed('LoopOp_Agencies_ReadAll') &&
    !_vm.globals.isLocalAgencyUser
  ) ? _c('div', [_c('div', [_c('agency-management-toolbar', {
    ref: "agencyManagementToolbar",
    attrs: {
      "table-element-count": _vm.tableElementCount,
      "agencySelected": _vm.agencySelected,
      "refreshEnabled": _vm.refreshEnabled
    },
    on: {
      "searchTextChanged": _vm.onSearchTextChanged,
      "pageSizeChanged": _vm.onPageSizeChanged,
      "pageNumberChanged": _vm.onPageNumberChanged,
      "openEditAgency": _vm.toggleModal,
      "openDeleteAgency": function($event) {
        _vm.showDeleteModal = true
      },
      "onTriggerReload": _vm.triggerReload,
      "hook:mounted": _vm.readComponentSettingsFromStore
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('agency-management-table', {
    ref: "agencyManagementTable",
    attrs: {
      "table-filter": _vm.tableFilter,
      "page-size": _vm.pageSize,
      "page-number": _vm.pageNumer,
      "selectedAgency": _vm.selectedAgency
    },
    on: {
      "onTableElementsCountChange": _vm.onTableElementsCountChange,
      "onAgencySelected": _vm.onAgencySelected,
      "onAgencyOpenEdit": _vm.onAgencyOpenEdit,
      "onRefreshEnabled": _vm.onRefreshEnabled,
      "agenciesReceived": function($event) {
        _vm.agencyList = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('agency-management-edit-modal', {
    attrs: {
      "show-edit-modal": _vm.showEditModal,
      "mode-add": _vm.modeAdd,
      "edit-agency-model": _vm.selectedAgency,
      "allRegions": _vm.allRegions,
      "agencyList": _vm.agencyList
    },
    on: {
      "modalClosed": _vm.onModalClosed,
      "onAgencySaved": _vm.onAgencySaved
    }
  }), _vm._v(" "), _c('confirmation-dialog', {
    attrs: {
      "confirmationTitle": _vm.lang.AM0000,
      "yesButtonText": _vm.lang.AM0002,
      "noButtonText": _vm.lang.AM0003,
      "showDialog": _vm.showDeleteModal,
      "colorRed": true
    },
    on: {
      "onYesConfirmation": _vm.onAgencyDeleted,
      "dialogClosed": function($event) {
        _vm.showDeleteModal = false
      }
    }
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.lang.AM0001))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 text-black"
  }, [_vm._v(_vm._s(_vm.lang.AM0004))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-9 text-black"
  }, [_vm._v(_vm._s(_vm.selectedAgency.AgencyId))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 text-black"
  }, [_vm._v(_vm._s(_vm.lang.AM0005))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-9 text-black"
  }, [_vm._v("\n        " + _vm._s(_vm.selectedAgency.AgencyName) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 text-black"
  }, [_vm._v(_vm._s(_vm.lang.AM0006))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-9 text-black"
  }, [_vm._v("\n        " + _vm._s(_vm.selectedAgency.AgencySince) + "\n      ")])])])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1670 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "customPropertyEditModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "id": "propertyEditForm"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeCustomPropertyEditDialog()
      }
    }
  }, [_vm._v("\n              ×\n            ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.SM2000))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group searchbar col-md-6",
    staticStyle: {
      "padding-left": "15px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propertyTreeFilter),
      expression: "propertyTreeFilter"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SM2001
    },
    domProps: {
      "value": (_vm.propertyTreeFilter)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.propertyTreeFilter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.insertNewNode('Topic')
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.SM2002) + "\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-default",
    class: {
      'btn-warning': _vm.isTreeDirty,
      'btn-success': !_vm.isTreeDirty,
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveTree()
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.SM2003) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    attrs: {
      "id": "customPropertiesTreeContainer"
    }
  }, [(_vm.propertyTreeData.Nodes) ? _c('liquortree', {
    ref: "customPropertiesTree",
    attrs: {
      "data": _vm.propertyTreeData.Nodes,
      "filter": _vm.propertyTreeFilter,
      "options": _vm.propertyTreeOptions
    },
    on: {
      "node:selected": _vm.onPropertySelected
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var node = ref.node;

        return _c('div', {
          staticClass: "draggable-tree-node",
          class: {
            'node-inactive': !node.data.Active
          },
          attrs: {
            "draggable": "true"
          },
          on: {
            "dragover": function($event) {
              $event.preventDefault();
            },
            "dragstart": function($event) {
              return _vm.ltDragStart(node, $event)
            },
            "dragenter": function($event) {
              return _vm.ltDragEnter(node, $event)
            },
            "dragleave": function($event) {
              return _vm.ltDragLeave(node, $event)
            },
            "dragend": function($event) {
              return _vm.ltDragEnd(node, $event)
            },
            "drop": function($event) {
              return _vm.ltDrop(node, $event)
            }
          }
        }, [(node.data.Type === 'Topic') ? _c('i', {
          staticClass: "material-icons"
        }, [_vm._v("title")]) : _vm._e(), _vm._v(" "), (node.data.Type === 'Group') ? _c('i', {
          staticClass: "material-icons"
        }, [_vm._v("group_work")]) : _vm._e(), _vm._v(" "), (!node.data.Visible) ? _c('i', {
          staticClass: "material-icons visibility-off"
        }, [_vm._v("visibility_off")]) : _vm._e(), _vm._v("\n                        " + _vm._s(node.text) + "\n                      ")])
      }
    }], null, false, 3767787081)
  }) : _vm._e()], 1)]), _vm._v(" "), (_vm.selectedPropertyNodeData.Type) ? _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "padding-left": "0"
    },
    on: {
      "change": function($event) {
        return _vm.nodeDataChanged()
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(_vm._s(_vm.lang.SM2004))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('label', {
    staticClass: "form-control text-left"
  }, [_vm._v(_vm._s(_vm.getTypeTranslation(_vm.selectedPropertyNodeData.Type)))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputPropertyName"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM2005) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPropertyNodeData.Title),
      expression: "selectedPropertyNodeData.Title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputPropertyName"
    },
    domProps: {
      "value": (_vm.selectedPropertyNodeData.Title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedPropertyNodeData, "Title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.selectedPropertyNodeData.Type === 'Property') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputPropertyInputType"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM2006))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPropertyNodeData.PropertyType),
      expression: "selectedPropertyNodeData.PropertyType"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "inputPropertyInputType",
      "disabled": _vm.selectedPropertyNodeData.HasShopperValues
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.selectedPropertyNodeData, "PropertyType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.inputPropertyTypesList), function(inputType, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": inputType
      }
    }, [_vm._v("\n                          " + _vm._s(inputType) + "\n                        ")])
  }), 0)])]) : _vm._e(), _vm._v(" "), (
    _vm.selectedPropertyNodeData.PropertyType ===
    'SingleSelect' ||
    _vm.selectedPropertyNodeData.PropertyType === 'MultiSelect'
  ) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(_vm._s(_vm.lang.SM2007))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 text-left"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    staticStyle: {
      "margin": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showPropertyListEditModal = true
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.SM2008) + "\n                      ")])])]) : _vm._e(), _vm._v(" "), (
    _vm.selectedPropertyNodeData.PropertyType ===
    'SingleSelect' ||
    _vm.selectedPropertyNodeData.PropertyType === 'MultiSelect'
  ) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "id": "labelAllowCustomListValues",
      "for": "inputAllowCustomListValues"
    }
  }, [_c('span', [_vm._v("\n                        " + _vm._s(_vm.lang.SM2036) + "\n                        "), _c('i', {
    staticClass: "material-icons md-18 form-hint-icon"
  }, [_vm._v("help_outline")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "float": "left"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.selectedPropertyNodeData.AllowCustomValues
      ),
      expression: "\n                              selectedPropertyNodeData.AllowCustomValues\n                            "
    }],
    attrs: {
      "type": "checkbox",
      "id": "inputAllowCustomListValues"
    },
    domProps: {
      "value": _vm.selectedPropertyNodeData.AllowCustomValues,
      "checked": Array.isArray(
        _vm.selectedPropertyNodeData.AllowCustomValues
      ) ? _vm._i(
        _vm.selectedPropertyNodeData.AllowCustomValues, _vm.selectedPropertyNodeData.AllowCustomValues) > -1 : (
        _vm.selectedPropertyNodeData.AllowCustomValues
      )
    },
    on: {
      "change": function($event) {
        var $$a =
          _vm.selectedPropertyNodeData.AllowCustomValues,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.selectedPropertyNodeData.AllowCustomValues,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.selectedPropertyNodeData, "AllowCustomValues", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.selectedPropertyNodeData, "AllowCustomValues", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.selectedPropertyNodeData, "AllowCustomValues", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "labelAllowCustomListValues",
      "boundary": "viewport",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SM2037))])], 1) : _vm._e(), _vm._v(" "), (_vm.selectedPropertyNodeData.Type === 'Property') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "id": "labelPropertyRecommended",
      "for": "inputPropertyRecommended"
    }
  }, [_c('span', [_vm._v("\n                        " + _vm._s(_vm.lang.SM2034) + "\n                        "), _c('i', {
    staticClass: "material-icons md-18 form-hint-icon"
  }, [_vm._v("help_outline")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "float": "left"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPropertyNodeData.Recommended),
      expression: "selectedPropertyNodeData.Recommended"
    }],
    attrs: {
      "type": "checkbox",
      "id": "inputPropertyRecommended"
    },
    domProps: {
      "value": _vm.selectedPropertyNodeData.Recommended,
      "checked": Array.isArray(_vm.selectedPropertyNodeData.Recommended) ? _vm._i(_vm.selectedPropertyNodeData.Recommended, _vm.selectedPropertyNodeData.Recommended) > -1 : (_vm.selectedPropertyNodeData.Recommended)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.selectedPropertyNodeData.Recommended,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.selectedPropertyNodeData.Recommended,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.selectedPropertyNodeData, "Recommended", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.selectedPropertyNodeData, "Recommended", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.selectedPropertyNodeData, "Recommended", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "labelPropertyRecommended",
      "boundary": "viewport",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SM2035))])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "id": "labelPropertyVisible",
      "for": "inputPropertyVisible"
    }
  }, [_c('span', [_vm._v("\n                        " + _vm._s(_vm.lang.SM2009) + "\n                        "), _c('i', {
    staticClass: "material-icons md-18 form-hint-icon"
  }, [_vm._v("help_outline")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "float": "left"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPropertyNodeData.Visible),
      expression: "selectedPropertyNodeData.Visible"
    }],
    attrs: {
      "type": "checkbox",
      "id": "inputPropertyVisible"
    },
    domProps: {
      "value": _vm.selectedPropertyNodeData.Visible,
      "checked": Array.isArray(_vm.selectedPropertyNodeData.Visible) ? _vm._i(_vm.selectedPropertyNodeData.Visible, _vm.selectedPropertyNodeData.Visible) > -1 : (_vm.selectedPropertyNodeData.Visible)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.selectedPropertyNodeData.Visible,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.selectedPropertyNodeData.Visible,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.selectedPropertyNodeData, "Visible", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.selectedPropertyNodeData, "Visible", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.selectedPropertyNodeData, "Visible", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(2)])])]), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "labelPropertyVisible",
      "boundary": "viewport",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SM2027))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "id": "labelPropertyActive",
      "for": "inputPropertyActive"
    }
  }, [_c('span', [_vm._v("\n                        " + _vm._s(_vm.lang.SM2011) + "\n                        "), _c('i', {
    staticClass: "material-icons md-18 form-hint-icon"
  }, [_vm._v("help_outline")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "float": "left"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPropertyNodeData.Active),
      expression: "selectedPropertyNodeData.Active"
    }],
    attrs: {
      "type": "checkbox",
      "id": "inputPropertyActive"
    },
    domProps: {
      "value": _vm.selectedPropertyNodeData.Active,
      "checked": Array.isArray(_vm.selectedPropertyNodeData.Active) ? _vm._i(_vm.selectedPropertyNodeData.Active, _vm.selectedPropertyNodeData.Active) > -1 : (_vm.selectedPropertyNodeData.Active)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.selectedPropertyNodeData.Active,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.selectedPropertyNodeData.Active,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.selectedPropertyNodeData, "Active", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.selectedPropertyNodeData, "Active", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.selectedPropertyNodeData, "Active", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(3)])])]), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "labelPropertyActive",
      "boundary": "viewport",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SM2029))])], 1), _vm._v(" "), _c('div', [(
    _vm.selectedPropertyNodeData.Guid &&
    _vm.selectedPropertyNodeData.Type !== 'Property'
  ) ? _c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.insertNewNode('Property')
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.SM2012) + "\n                    ")]) : _vm._e(), _vm._v(" "), (
    _vm.selectedPropertyNodeData.Guid &&
    _vm.selectedPropertyNodeData.Type === 'Topic'
  ) ? _c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.insertNewNode('Group')
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.SM2013) + "\n                    ")]) : _vm._e(), _vm._v(" "), (
    _vm.isCurrentNodeDirty || !_vm.selectedPropertyNodeData.Guid
  ) ? _c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.discardCurrentNodeChanges()
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.SM2033) + "\n                    ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-default",
    class: {
      'btn-warning': _vm.isCurrentNodeDirty,
      'btn-success': !_vm.isCurrentNodeDirty,
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveCurrentNode()
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.SM2014) + "\n                    ")])])]) : _vm._e()])])])])])])]), _vm._v(" "), _c('CustomPropertyListEditModal', {
    attrs: {
      "showModal": _vm.showPropertyListEditModal,
      "listGuid": _vm.selectedPropertyNodeData.ListGuid
    },
    on: {
      "modalClosing": function($event) {
        _vm.showPropertyListEditModal = false
      },
      "propertyListCreated": function($event) {
        (_vm.selectedPropertyNodeData.ListGuid = $event), _vm.nodeDataChanged()
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
}]}

/***/ }),
/* 1671 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "editKPIGroupDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "id": "editKPIGroupDialogForm"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.KM4006))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.lang.KM4007) + ":")]), _vm._v("\n            " + _vm._s(_vm.nameOfSelectedClient) + "\n            "), _c('b', [_vm._v("/ " + _vm._s(_vm.lang.KM4027) + ":")]), _vm._v("\n            " + _vm._s(_vm.nameOfSelectedKpiGroup) + "\n            "), _c('b', [_vm._v("/ " + _vm._s(_vm.lang.KM4010) + ":")]), _vm._v("\n            " + _vm._s(_vm.nameOfSelectedEvaluationRuleGuid) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "form-group searchbar col-md-6",
    staticStyle: {
      "padding-left": "15px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterKpiGroupString),
      expression: "filterKpiGroupString"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.KM4013
    },
    domProps: {
      "value": (_vm.filterKpiGroupString)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.filterKpiGroupString = $event.target.value
      }, function($event) {
        return _vm.doFilterKpiGroups()
      }],
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group searchbar col-md-6",
    staticStyle: {
      "padding-left": "15px",
      "top": "9px"
    }
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.feature.isAudiTarget &&
        _vm.feature.isEnabled('audi_importers')
    },
    on: {
      "change": function($event) {
        _vm.createNewKpiGroup(), _vm.getKpiGroupsOfSelectedClient()
      }
    },
    model: {
      value: (_vm.selectedClientGuid),
      callback: function($$v) {
        _vm.selectedClientGuid = $$v
      },
      expression: "selectedClientGuid"
    }
  }, _vm._l((_vm.clientList), function(client) {
    return _c('option', {
      key: client.ClientGuid,
      domProps: {
        "value": client.ClientGuid
      }
    }, [_vm._v("\n                      " + _vm._s(client.ClientName) + "\n                    ")])
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-container",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.KM4036) + "\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.KM4000) + "\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "55%"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.KM4001) + "\n                        ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredKpiGroups), function(kpiGroup) {
    return _c('tr', {
      key: kpiGroup.KPIGroupGuid,
      class: {
        info: _vm.selectedKpiGroupGuid === kpiGroup.KPIGroupGuid,
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          (_vm.selectedKpiGroupGuid = kpiGroup.KPIGroupGuid),
          _vm.getSelectedKpiGroupInformation()
        }
      }
    }, [_c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v("\n                          " + _vm._s(kpiGroup.KPIGroupPosition) + "\n                        ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v("\n                          " + _vm._s(kpiGroup.KPIGroupCode) + "\n                        ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "55%"
      }
    }, [_vm._v("\n                          " + _vm._s(kpiGroup.KPIGroupShortText) + "\n                        ")])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "padding-right": "0"
    }
  }, [_c('ul', {
    staticClass: "nav nav-tabs nav-kpi-group-edit",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#editKpiGroupTab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        (_vm.selectedTab = 'editKpiGroupTab'), _vm.getKpiGroupData()
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.KM4014))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#kpiOrderTab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        (_vm.selectedTab = 'kpiOrderTab'), _vm.getKpiGroupData()
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.KM4017))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#kpiGroupOrderTab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        (_vm.selectedTab = 'kpiGroupOrderTab'), _vm.getKpiGroupData()
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.KM4037))])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade active in",
    attrs: {
      "id": "editKpiGroupTab"
    }
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputKpiGroupCode",
      "id": "inputKpiGroupCodeLabel"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.KM4000) + " *\n                          "), _c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("help_outline")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedKpiGroupInformation.KPIGroupCode),
      expression: "selectedKpiGroupInformation.KPIGroupCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "200",
      "id": "inputKpiGroupCode",
      "required": ""
    },
    domProps: {
      "value": (_vm.selectedKpiGroupInformation.KPIGroupCode)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedKpiGroupInformation, "KPIGroupCode", $event.target.value)
      }, function($event) {
        _vm.selectedKpiGroupDirty = true
      }]
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputKpiGroupCode')),
      expression: "inputHasError('inputKpiGroupCode')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.KM4029))])]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "inputKpiGroupCodeLabel",
      "placement": "right",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.KM4032))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputKpiGroupShortText",
      "id": "inputKpiGroupShortTextLabel"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.KM4001) + " *\n                          "), _c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("help_outline")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.selectedKpiGroupInformation.KPIGroupShortText
      ),
      expression: "\n                              selectedKpiGroupInformation.KPIGroupShortText\n                            "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "50",
      "id": "inputKpiGroupShortText",
      "required": ""
    },
    domProps: {
      "value": (
        _vm.selectedKpiGroupInformation.KPIGroupShortText
      )
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedKpiGroupInformation, "KPIGroupShortText", $event.target.value)
      }, function($event) {
        _vm.selectedKpiGroupDirty = true
      }]
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputKpiGroupShortText')),
      expression: "inputHasError('inputKpiGroupShortText')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.KM4029))])]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "inputKpiGroupShortTextLabel",
      "placement": "right",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.KM4033))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputKpiGroupLongText",
      "id": "inputKpiGroupLongTextLabel"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.KM4004) + " *\n                          "), _c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("help_outline")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.selectedKpiGroupInformation.KPIGroupLongText
      ),
      expression: "\n                              selectedKpiGroupInformation.KPIGroupLongText\n                            "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "200",
      "id": "inputKpiGroupLongText",
      "required": ""
    },
    domProps: {
      "value": (
        _vm.selectedKpiGroupInformation.KPIGroupLongText
      )
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedKpiGroupInformation, "KPIGroupLongText", $event.target.value)
      }, function($event) {
        _vm.selectedKpiGroupDirty = true
      }]
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputKpiGroupLongText')),
      expression: "inputHasError('inputKpiGroupLongText')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.KM4029))])]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "inputKpiGroupLongTextLabel",
      "placement": "right",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.KM4034))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "KPIGroupWeightInput",
      "id": "KPIGroupWeightInputLabel"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.KM4031) + "\n                          "), _c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("help_outline")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (
        _vm.selectedKpiGroupInformation.KPIGroupWeight
      ),
      expression: "\n                              selectedKpiGroupInformation.KPIGroupWeight\n                            ",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "KPIGroupWeightInput",
      "min": "0",
      "max": "100",
      "step": "0.01"
    },
    domProps: {
      "value": (
        _vm.selectedKpiGroupInformation.KPIGroupWeight
      )
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedKpiGroupInformation, "KPIGroupWeight", _vm._n($event.target.value))
      }, function($event) {
        _vm.selectedKpiGroupDirty = true
      }],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "KPIGroupWeightInputLabel",
      "placement": "right",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.KM4035))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "KPIGroupProjectSelect"
    }
  }, [_vm._v(_vm._s(_vm.lang.KM4008) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "KPIGroupProjectSelect",
      "placeholder": _vm.lang.KM4009,
      "required": ""
    },
    on: {
      "change": function($event) {
        _vm.selectedKpiGroupDirty = true
      }
    },
    model: {
      value: (_vm.selectedProjectGuid),
      callback: function($$v) {
        _vm.selectedProjectGuid = $$v
      },
      expression: "selectedProjectGuid"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.clientProjectList), function(project) {
    return _c('option', {
      key: project.ProjectGuid,
      domProps: {
        "value": project.ProjectGuid
      }
    }, [_vm._v("\n                              " + _vm._s(project.ProjectName) + "\n                            ")])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "KPIGroupsSelectEvaluation"
    }
  }, [_vm._v(_vm._s(_vm.lang.KM4010) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "KPIGroupsSelectEvaluation",
      "placeholder": _vm.lang.KM4011,
      "required": ""
    },
    on: {
      "change": function($event) {
        _vm.selectedKpiGroupDirty = true
      }
    },
    model: {
      value: (
        _vm.selectedKpiGroupInformation.KPIEvaluationRuleGuid
      ),
      callback: function($$v) {
        _vm.$set(_vm.selectedKpiGroupInformation, "KPIEvaluationRuleGuid", $$v)
      },
      expression: "\n                              selectedKpiGroupInformation.KPIEvaluationRuleGuid\n                            "
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.kpiGroupEvaluationRulesList), function(evaluation) {
    return _c('option', {
      key: evaluation.EvaluationRuleGuid,
      domProps: {
        "value": evaluation.EvaluationRuleGuid
      }
    }, [_vm._v("\n                              " + _vm._s(evaluation.EvaluationRule) + "\n                            ")])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputKpiGroupDescription"
    }
  }, [_vm._v(_vm._s(_vm.lang.KM4005))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "form-group nopadding"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.selectedKpiGroupInformation.KPIGroupDescription
      ),
      expression: "\n                                selectedKpiGroupInformation.KPIGroupDescription\n                              "
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "3",
      "type": "text",
      "maxlength": "500",
      "id": "inputKpiGroupDescription"
    },
    domProps: {
      "value": (
        _vm.selectedKpiGroupInformation.KPIGroupDescription
      )
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedKpiGroupInformation, "KPIGroupDescription", $event.target.value)
      }, function($event) {
        _vm.selectedKpiGroupDirty = true
      }]
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "25px 0 25px 0"
    }
  }, [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "dismissible": "",
      "show": _vm.showAlert
    },
    on: {
      "dismissed": function($event) {
        _vm.showAlert = false
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.KM4028))])], 1), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedKpiGroupGuid && !_vm.selectedKpiGroupDirty
    },
    on: {
      "click": function($event) {
        return _vm.createNewKpiGroup()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("add_box")]), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s(_vm.lang.KM4015) + "\n                      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    class: {
      'btn-warning': _vm.selectedKpiGroupDirty
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedKpiGroupGuid && !_vm.selectedKpiGroupDirty
    },
    on: {
      "click": function($event) {
        return _vm.validateBeforeSubmit('editKPIGroupDialog')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("save")]), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s(_vm.lang.KM4003) + "\n                      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedKpiGroupGuid
    },
    on: {
      "click": function($event) {
        return _vm.openDeleteKpiGroupConfirmationDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("delete")]), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s(_vm.lang.KM4016) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "kpiOrderTab"
    }
  }, [_c('div', {
    staticClass: "table-container table-positions"
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "80%"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.KM4018) + "\n                            ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.lang.KM4019))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.kpisOfSelectedKpiGroup), function(kpi) {
    return _c('tr', {
      key: kpi.KPIGroupPosition
    }, [_c('td', {
      staticStyle: {
        "width": "80%"
      }
    }, [_vm._v("\n                              " + _vm._s(kpi.KPIShortText) + "\n                            ")]), _vm._v(" "), _c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticClass: "form-group nopadding",
      staticStyle: {
        "width": "60%",
        "float": "left"
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (kpi.KPIGroupPosition),
        expression: "kpi.KPIGroupPosition"
      }],
      staticClass: "form-control text-center nopadding",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(kpi, "KPIGroupPosition", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          _vm.reorderKpisInKpiGroup(),
            (_vm.changeKpiOrderDirty = true)
        }]
      }
    }, _vm._l((_vm.kpisOfSelectedKpiGroup), function(kpi2) {
      return _c('option', {
        key: kpi2.KPIGroupPosition,
        domProps: {
          "value": kpi2.KPIGroupPosition
        }
      }, [_vm._v("\n                                    " + _vm._s(kpi2.KPIGroupPosition) + "\n                                  ")])
    }), 0)])])])
  }), 0)])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-default",
    class: {
      'btn-warning': _vm.changeKpiOrderDirty
    },
    attrs: {
      "type": "button",
      "disabled": _vm.kpisOfSelectedKpiGroup.length < 1
    },
    on: {
      "click": function($event) {
        return _vm.saveKpisNewOrder()
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.KM4030) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "kpiGroupOrderTab"
    }
  }, [_c('div', {
    staticClass: "table-container table-positions"
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "80%"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.KM4038) + "\n                            ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.lang.KM4039))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.kpiGroupsOfSelectedClient), function(kpiGroup) {
    return _c('tr', {
      key: kpiGroup.KPIGroupPosition
    }, [_c('td', {
      staticStyle: {
        "width": "80%"
      }
    }, [_vm._v("\n                              " + _vm._s(kpiGroup.KPIGroupShortText) + "\n                            ")]), _vm._v(" "), _c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticClass: "form-group nopadding",
      staticStyle: {
        "width": "60%",
        "float": "left"
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (kpiGroup.KPIGroupPosition),
        expression: "kpiGroup.KPIGroupPosition"
      }],
      staticClass: "form-control text-center nopadding",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(kpiGroup, "KPIGroupPosition", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          _vm.reorderKpiGroups(),
            (_vm.changeKpiGroupOrderDirty = true)
        }]
      }
    }, _vm._l((_vm.kpiGroupsOfSelectedClient), function(kpiGroup2) {
      return _c('option', {
        key: kpiGroup2.KPIGroupPosition,
        domProps: {
          "value": kpiGroup2.KPIGroupPosition
        }
      }, [_vm._v("\n                                    " + _vm._s(kpiGroup2.KPIGroupPosition) + "\n                                  ")])
    }), 0)])])])
  }), 0)])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-default",
    class: {
      'btn-warning': _vm.changeKpiGroupOrderDirty
    },
    attrs: {
      "type": "button",
      "disabled": _vm.kpiGroupsOfSelectedClient.length < 1
    },
    on: {
      "click": function($event) {
        return _vm.saveKpiGroupsNewOrder()
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.KM4030) + "\n                    ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.KM4002) + "\n          ")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1672 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "surveyUploadDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.closeSurveyUploadDialog()
      }
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.SU0000))]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "file-controls"
  }, [_c('label', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "id": "fileChooserButton",
      "disabled": _vm.disableAddFileButton
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("note_add")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "fileChooser",
      "accept": _vm.questionData.acceptedTypes,
      "multiple": _vm.questionData.allowMultipleFiles,
      "disabled": _vm.disableAddFileButton
    },
    on: {
      "change": _vm.handleFiles
    }
  }), _vm._v(" "), (
    _vm.questionData.allowMultipleFiles ||
    _vm.selectedFiles.length < 1
  ) ? _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "fileChooserButton",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SU0009))]) : _vm._e()], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button",
      "disabled": _vm.countFilesToDelete === 0,
      "id": "deleteFilesButton"
    },
    on: {
      "click": function($event) {
        return _vm.onDeleteFiles()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("delete")]), _vm._v(" "), (_vm.countFilesToDelete !== 0) ? _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "deleteFilesButton",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SU0010))]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFiles && _vm.editimg && _vm.canvas.showCanvas),
      expression: "showFiles && editimg && canvas.showCanvas"
    }],
    staticClass: "file-controls"
  }, [_c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-fab btn-fab-mini btn-save-mini",
    attrs: {
      "type": "button",
      "id": "saveImageButton"
    },
    on: {
      "click": function($event) {
        return _vm.saveImage()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("save")]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "saveImageButton",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SU0011))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('button', {
    staticClass: "btn btn-fab btn-fab-mini btn-mode-select",
    attrs: {
      "type": "button",
      "disabled": _vm.currentMode === 'crop',
      "id": "scalingModeButton"
    },
    on: {
      "click": function($event) {
        return _vm.setCurrentMode('crop')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("transform")]), _vm._v(" "), (_vm.currentMode !== 'crop') ? _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "scalingModeButton",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SU0012))]) : _vm._e()], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-fab btn-fab-mini btn-mode-select",
    class: {
      'btn-mode-selected': _vm.dragMode === 'move' && _vm.currentMode === 'crop',
    },
    attrs: {
      "type": "button",
      "disabled": _vm.currentMode === 'colorize',
      "id": "dragModeButton"
    },
    on: {
      "click": function($event) {
        return _vm.onSetDragMode('move')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("open_with")]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "dragModeButton",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SU0016))])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button",
      "disabled": _vm.currentMode === 'colorize',
      "id": "zoomInButton"
    },
    on: {
      "click": function($event) {
        return _vm.onZoomIn()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("zoom_in")]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "zoomInButton",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SU0013))])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button",
      "disabled": _vm.currentMode === 'colorize',
      "id": "zoomOutButton"
    },
    on: {
      "click": function($event) {
        return _vm.onZoomOut()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("zoom_out")]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "zoomOutButton",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SU0014))])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button",
      "disabled": _vm.currentMode === 'colorize',
      "id": "zoomToOriginalSizeButton"
    },
    on: {
      "click": function($event) {
        return _vm.onZoomToOriginalSize()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("zoom_out_map")]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "zoomToOriginalSizeButton",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SU0015))])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button",
      "disabled": _vm.currentMode === 'colorize',
      "id": "rotateLeftButton"
    },
    on: {
      "click": function($event) {
        return _vm.onRotateLeft()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("rotate_left")]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "rotateLeftButton",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SU0017))])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button",
      "disabled": _vm.currentMode === 'colorize',
      "id": "rotateRightButton"
    },
    on: {
      "click": function($event) {
        return _vm.onRotateRight()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("rotate_right")]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "rotateRightButton",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SU0018))])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-fab btn-fab-mini btn-mode-select",
    class: {
      'btn-mode-selected': _vm.dragMode === 'crop' && _vm.currentMode === 'crop',
    },
    attrs: {
      "type": "button",
      "disabled": _vm.currentMode === 'colorize',
      "id": "croppingModeButton"
    },
    on: {
      "click": function($event) {
        return _vm.onSetDragMode('crop')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("crop")]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "croppingModeButton",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SU0019))])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button",
      "disabled": _vm.currentMode === 'colorize',
      "id": "cropImageButton"
    },
    on: {
      "click": function($event) {
        return _vm.onCropImage()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("crop_free")]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "cropImageButton",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SU0020))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-fab btn-fab-mini btn-mode-select",
    attrs: {
      "type": "button",
      "disabled": _vm.currentMode === 'colorize',
      "id": "drawingModeButton"
    },
    on: {
      "click": function($event) {
        _vm.setCurrentMode('colorize'), _vm.setCurrentShape('line')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("brush")]), _vm._v(" "), (_vm.currentMode !== 'colorize') ? _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "drawingModeButton",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SU0021))]) : _vm._e()], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button",
      "disabled": _vm.currentMode === 'crop',
      "id": "penButton"
    },
    on: {
      "click": function($event) {
        return _vm.setCurrentShape('line')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("edit")]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "penButton",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SU0022))])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button",
      "disabled": _vm.currentMode === 'crop',
      "id": "rectangleButton"
    },
    on: {
      "click": function($event) {
        return _vm.setCurrentShape('rectangle')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("crop_16_9")]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "rectangleButton",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SU0023))])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button",
      "disabled": _vm.currentMode === 'crop',
      "id": "fillRectangleButton"
    },
    on: {
      "click": function($event) {
        return _vm.setCurrentShape('fillrectangle')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("stop")]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "fillRectangleButton",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SU0024))])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button",
      "disabled": _vm.currentMode === 'crop' || _vm.lastActionUndo,
      "id": "undoButton"
    },
    on: {
      "click": function($event) {
        return _vm.undoLastAction()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("undo")]), _vm._v(" "), (!_vm.lastActionUndo) ? _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "undoButton",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SU0025))]) : _vm._e()], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button",
      "disabled": _vm.currentMode === 'crop' || _vm.lastActionRedo,
      "id": "redoButton"
    },
    on: {
      "click": function($event) {
        return _vm.redoLastAction()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("redo")]), _vm._v(" "), (!_vm.lastActionRedo) ? _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "redoButton",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SU0026))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-5 control-label",
    attrs: {
      "for": "inputColor"
    }
  }, [_vm._v(_vm._s(_vm.lang.SU0003))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.canvas.fillStyle),
      expression: "canvas.fillStyle"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "color",
      "id": "inputColor"
    },
    domProps: {
      "value": (_vm.canvas.fillStyle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.canvas, "fillStyle", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-5 control-label",
    attrs: {
      "for": "linewidth"
    }
  }, [_vm._v(_vm._s(_vm.lang.SU0004))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.canvas.lineWidth),
      expression: "canvas.lineWidth"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "linewidth",
      "disabled": _vm.currentMode === 'crop'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.canvas, "lineWidth", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("1")]), _vm._v(" "), _c('option', [_vm._v("2")]), _vm._v(" "), _c('option', [_vm._v("3")]), _vm._v(" "), _c('option', [_vm._v("4")]), _vm._v(" "), _c('option', [_vm._v("5")]), _vm._v(" "), _c('option', [_vm._v("6")]), _vm._v(" "), _c('option', [_vm._v("7")]), _vm._v(" "), _c('option', [_vm._v("8")]), _vm._v(" "), _c('option', [_vm._v("9")]), _vm._v(" "), _c('option', [_vm._v("10")])])])])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFiles),
      expression: "showFiles"
    }],
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "image-previewmode-grid"
  }, _vm._l((_vm.selectedFiles), function(file, index) {
    return _c('div', {
      key: index,
      staticClass: "image",
      class: {
        'image--delete': file.delete,
        'image--active': index === _vm.edit,
      }
    }, [_c('img', {
      staticClass: "image-mini-previewMode",
      attrs: {
        "src": file.imageUrl
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "image__hover"
    }, [_c('div', {
      staticClass: "image__inner"
    }, [_c('a', {
      staticClass: "image__trash",
      on: {
        "click": function($event) {
          return _vm.onToggleDelete(index)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("delete")])]), _vm._v(" "), _c('a', {
      staticClass: "image__edit",
      on: {
        "click": function($event) {
          return _vm.setIndex(index)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("edit")])])])])])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.edit > -1),
      expression: "edit > -1"
    }],
    staticClass: "image-properties"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v(_vm._s(_vm.lang.SU0005))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "65%"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.editimg && _vm.editimg.name ? _vm.editimg.name : "-") + "\n                      ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v(_vm._s(_vm.lang.SU0006))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "65%"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.editimg && _vm.editimg.size ?
    _vm.formatBytes(_vm.editimg.size, 1) :
    "-") + "\n                      ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v(_vm._s(_vm.lang.SU0007))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "65%"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.editimg && _vm.editimg.lastModified ?
    _vm.formatDate(_vm.editimg.lastModified) :
    "-") + "\n                      ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v(_vm._s(_vm.lang.SU0008))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "65%"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.editimg && _vm.editimg.type ? _vm.editimg.type : "-") + "\n                      ")])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.edit > -1 && _vm.canvas.showCanvas),
      expression: "edit > -1 && canvas.showCanvas"
    }],
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "show-image"
  }, [_c('vue-cropper', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentMode === 'crop'),
      expression: "currentMode === 'crop'"
    }],
    ref: "cropper",
    attrs: {
      "guides": true,
      "view-mode": 2,
      "drag-mode": "move",
      "auto-crop-area": 0.5,
      "min-container-width": 250,
      "min-container-height": 180,
      "background": true,
      "rotatable": true,
      "src": _vm.editimg ? _vm.editimg.imageUrl : '',
      "alt": "Source Image",
      "img-style": {
        width: _vm.imageSize.width + 'px',
        height: _vm.imageSize.height + 'px',
      }
    }
  }), _vm._v(" "), _c('canvas', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentMode === 'colorize'),
      expression: "currentMode === 'colorize'"
    }],
    attrs: {
      "id": "editCanvas"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeSurveyUploadDialog()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.SU0002) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button",
      "disabled": !_vm.globals.isAccessAllowed('LoopOp_Upload_Create') ||
        !_vm.disableUploadButton
    },
    on: {
      "click": function($event) {
        return _vm.saveFilesToBackend()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.SU0001) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 1673 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "addChecksFurtherSettingsModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.lang.CFM000))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "float": "left"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.OnlineState),
      expression: "settings.OnlineState"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.OnlineState) ? _vm._i(_vm.settings.OnlineState, null) > -1 : (_vm.settings.OnlineState)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.settings.OnlineState,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.settings, "OnlineState", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.settings, "OnlineState", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.settings, "OnlineState", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.lang.CFM001))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "float": "left"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.LocationFree),
      expression: "settings.LocationFree"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.LocationFree) ? _vm._i(_vm.settings.LocationFree, null) > -1 : (_vm.settings.LocationFree)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.settings.LocationFree,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.settings, "LocationFree", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.settings, "LocationFree", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.settings, "LocationFree", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.lang.CFM002))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputFurtherSettingsStartDate"
    }
  }, [_vm._v(_vm._s(_vm.lang.CFM003))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr('inputFurtherSettingsStartDate')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.SurveyInstanceSince),
      expression: "settings.SurveyInstanceSince"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputFurtherSettingsStartDate"
    },
    domProps: {
      "value": (_vm.settings.SurveyInstanceSince)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settings, "SurveyInstanceSince", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputFurtherSettingsEndDate"
    }
  }, [_vm._v(_vm._s(_vm.lang.CFM004))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr('inputFurtherSettingsEndDate')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.SurveyInstanceUntil),
      expression: "settings.SurveyInstanceUntil"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputFurtherSettingsEndDate"
    },
    domProps: {
      "value": (_vm.settings.SurveyInstanceUntil)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settings, "SurveyInstanceUntil", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputFurtherSettingsBasePayment"
    }
  }, [_vm._v(_vm._s(_vm.lang.CFM005))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('currency-input', {
    staticClass: "form-control",
    attrs: {
      "id": "inputFurtherSettingsBasePayment",
      "currency": "EUR",
      "min": 0,
      "locale": _vm.globals.currentLocale
    },
    model: {
      value: (_vm.settings.SurveyInstanceBasePayment),
      callback: function($$v) {
        _vm.$set(_vm.settings, "SurveyInstanceBasePayment", $$v)
      },
      expression: "settings.SurveyInstanceBasePayment"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputFurtherSettingsPlusPayment"
    }
  }, [_vm._v(_vm._s(_vm.lang.CFM006))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('currency-input', {
    staticClass: "form-control",
    attrs: {
      "id": "inputFurtherSettingsPlusPayment",
      "currency": "EUR",
      "min": 0,
      "locale": _vm.globals.currentLocale
    },
    model: {
      value: (_vm.settings.SurveyInstancePlusPayment),
      callback: function($$v) {
        _vm.$set(_vm.settings, "SurveyInstancePlusPayment", $$v)
      },
      expression: "settings.SurveyInstancePlusPayment"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(_vm._s(_vm.lang.CFM007))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('label', {
    staticClass: "form-control text-left"
  }, [_vm._v(_vm._s(_vm.globals.getCurrencyString(_vm.totalPayment, "EUR")))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "selectSurveyInstanceSkillLevel"
    }
  }, [_vm._v(_vm._s(_vm.lang.CFM013))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.settings.SurveyInstanceSkillLevel),
      expression: "settings.SurveyInstanceSkillLevel",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "selectSurveyInstanceSkillLevel"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.$set(_vm.settings, "SurveyInstanceSkillLevel", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CFM018) + "\n                "), (_vm.survey.SurveySkillLevel > 0) ? _c('span', [_vm._v("(" + _vm._s(_vm.survey.SurveySkillLevel) + ")")]) : _vm._e()]), _vm._v(" "), _vm._l((5), function(i) {
    return _c('option', {
      key: i
    }, [_vm._v(_vm._s(i))])
  })], 2)]), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "selectSurveyInstanceSkillLevel",
      "delay": _vm.globals.tooltipDelay,
      "placement": "right",
      "boundary": "viewport"
    }
  }, [_vm._v("\n            1 → " + _vm._s(_vm.lang.CFM015) + "\n            "), _c('br'), _vm._v(" "), _c('br'), _vm._v("...\n            "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n            5 → " + _vm._s(_vm.lang.CFM016) + "\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('button', {
    staticClass: "btn btn-raised pull-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openHtmlEditor()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.CFM008) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('button', {
    staticClass: "btn btn-raised pull-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openShopperFilterModal()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.CFM012) + "\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised pull-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clearSettings()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.CFM009) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.CFM010) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
}]}

/***/ }),
/* 1674 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "shopperProposalModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.SPM000))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(_vm._s(_vm.lang.SPM001))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "newShopperProposalCarSegmentSelect",
      "placeholder": _vm.lang.SPM002,
      "allowClear": true
    },
    on: {
      "change": function($event) {
        _vm.selectedCarModel = ''
      }
    },
    model: {
      value: (_vm.selectedCarSegment),
      callback: function($$v) {
        _vm.selectedCarSegment = $$v
      },
      expression: "selectedCarSegment"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.carSegmentList), function(segment) {
    return _c('option', {
      key: segment.CarSegmentGuid,
      domProps: {
        "value": segment.CarSegmentGuid
      }
    }, [_vm._v("\n                " + _vm._s(segment.CarSegmentName) + "\n              ")])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "newShopperProposalCarModelSelect",
      "placeholder": _vm.lang.SPM003,
      "allowClear": true,
      "disabled": !_vm.selectedCarSegment
    },
    on: {
      "change": function($event) {
        _vm.selectedCompetitorCar = ''
      }
    },
    model: {
      value: (_vm.selectedCarModel),
      callback: function($$v) {
        _vm.selectedCarModel = $$v
      },
      expression: "selectedCarModel"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.carModelsOfSelectedSegment), function(model) {
    return _c('option', {
      key: model.CarModelGuid,
      domProps: {
        "value": model.CarModelGuid
      }
    }, [_vm._v("\n                " + _vm._s(model.CarModelName) + "\n              ")])
  })], 2)], 1)]), _vm._v(" "), (_vm.check.CompetitorCarModelDistribution) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(_vm._s(_vm.lang.SPM004))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "newShopperProposalCompetitorCarModelSelect",
      "placeholder": _vm.lang.SPM005,
      "allowClear": true,
      "disabled": !_vm.selectedCarSegment
    },
    on: {
      "change": function($event) {
        _vm.selectedCarModel = ''
      }
    },
    model: {
      value: (_vm.selectedCompetitorCar),
      callback: function($$v) {
        _vm.selectedCompetitorCar = $$v
      },
      expression: "selectedCompetitorCar"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.check.CompetitorCarModelDistribution), function(model) {
    return _c('option', {
      key: model.CompetitorCarModelGuid,
      domProps: {
        "value": model.CompetitorCarModelGuid
      }
    }, [_vm._v("\n              " + _vm._s(model.CompetitorCarBrand) + " " + _vm._s(model.CompetitorCarModel) + "\n              ")])
  })], 2)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "min-height": "24px"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "11px"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.SPM006) + "\n            ")]), _vm._v(" "), (this.shopperPreviousVisited) ? _c('i', {
    staticClass: "material-icons md-24",
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "id": "shopperLabel"
    }
  }, [_vm._v("\n              info_outline\n            ")]) : _vm._e()]), _vm._v(" "), (this.shopperPreviousVisited) ? _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "shopperLabel"
    }
  }, [_c('div', {
    staticClass: "survey-id-info-tooltip"
  }, [_vm._v("\n              " + _vm._s(_vm.lang.SPM034) + "\n              "), _c('br')])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "newShopperProposalShopperSelect",
      "placeholder": _vm.lang.SPM007,
      "allowClear": true,
      "disabled": _vm.anyShopperAlreadyApproved
    },
    on: {
      "change": function($event) {
        (_vm.selectedShopperCar = ''), _vm.shopperAlreadyChecked(), _vm.getShopperCars()
      }
    },
    model: {
      value: (_vm.selectedShopper),
      callback: function($$v) {
        _vm.selectedShopper = $$v
      },
      expression: "selectedShopper"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.unproposedShoppers), function(shopper) {
    return _c('option', {
      key: shopper.ShopperGuid,
      domProps: {
        "value": shopper.ShopperGuid
      }
    }, [_vm._v("\n                " + _vm._s(shopper.ShopperName) + "\n              ")])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-default btn-fab",
    attrs: {
      "disabled": !_vm.selectedShopperCar ||
        !_vm.selectedCarSegment ||
        (!_vm.selectedCarModel && !_vm.selectedCompetitorCar)
    },
    on: {
      "click": function($event) {
        return _vm.addShopper()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36 text-green"
  }, [_vm._v("add")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-inline"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(_vm._s(_vm.lang.SPM008))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "newShopperProposalShopperCarSelect",
      "placeholder": _vm.lang.SPM009,
      "allowClear": true,
      "disabled": !_vm.selectedShopper
    },
    model: {
      value: (_vm.selectedShopperCar),
      callback: function($$v) {
        _vm.selectedShopperCar = $$v
      },
      expression: "selectedShopperCar"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.shopperCars), function(car) {
    return _c('option', {
      key: car.ValueGroupGuid,
      domProps: {
        "value": car.ValueGroupGuid
      }
    }, [_vm._v("\n                " + _vm._s(car.Brand) + " " + _vm._s(car.Model) + " (" + _vm._s(car.Year) + ")\n              ")])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-inline"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedCarMatch),
      expression: "selectedCarMatch"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "newShopperProposalCarMatchSelect"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedCarMatch = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "+"
    }
  }, [_vm._v("+ " + _vm._s(_vm.lang.SPM010))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "="
    }
  }, [_vm._v("= " + _vm._s(_vm.lang.SPM011))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "-"
    }
  }, [_vm._v("- " + _vm._s(_vm.lang.SPM012))])])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.check && _vm.check.ShopperProposals) ? [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SPM013) + "\n                ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SPM014) + " (" + _vm._s(_vm.lang.SPM015) + ")\n                ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SPM016) + "\n                ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SPM017) + "\n                ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "12%"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SPM018) + "\n                ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.check.ShopperProposals), function(proposal) {
    return _c('tr', {
      key: proposal.ShopperProposalGuid
    }, [_c('td', [_vm._v(_vm._s(proposal.ShopperId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(proposal.DisplayName))]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(proposal.CarModelName) + "\n                  "), (proposal.CarSegmentName) ? [_vm._v("(" + _vm._s(proposal.CarSegmentName) + ")")] : _vm._e()], 2), _vm._v(" "), _c('td', [_vm._v(_vm._s(proposal.ShopperCar))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(proposal.CarMatch))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn nopadding",
      attrs: {
        "id": ("openProposalFeedButton-" + (proposal.ShopperProposalGuid))
      },
      on: {
        "click": function($event) {
          return _vm.showFeed(proposal)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24"
    }, [_vm._v("forum")])]), _vm._v(" "), _c('b-tooltip', {
      ref: "tooltip",
      refInFor: true,
      attrs: {
        "target": ("openProposalFeedButton-" + (proposal.ShopperProposalGuid)),
        "delay": _vm.globals.tooltipDelay
      }
    }, [_vm._v(_vm._s(_vm.lang.SPM019))]), _vm._v(" "), (proposal.UpdateShopperProposal) ? [_c('button', {
      staticClass: "btn nopadding",
      attrs: {
        "id": ("updateShopperDataButton-" + (proposal.ShopperProposalGuid))
      },
      on: {
        "click": function($event) {
          return _vm.updateShopperData(proposal)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24"
    }, [_vm._v("refresh")])]), _vm._v(" "), _c('b-tooltip', {
      ref: "tooltip",
      refInFor: true,
      attrs: {
        "target": ("updateShopperDataButton-" + (proposal.ShopperProposalGuid)),
        "delay": _vm.globals.tooltipDelay
      }
    }, [_vm._v(_vm._s(_vm.lang.SPM020))])] : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn nopadding",
      attrs: {
        "id": ("deleteShopperProposalButton-" + (proposal.ShopperProposalGuid)),
        "disabled": proposal.AgencyApprovalStatus
      },
      on: {
        "click": function($event) {
          return _vm.deleteShopper(proposal)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24 text-red"
    }, [_vm._v("clear")])]), _vm._v(" "), _c('b-tooltip', {
      ref: "tooltip",
      refInFor: true,
      attrs: {
        "target": ("deleteShopperProposalButton-" + (proposal.ShopperProposalGuid)),
        "delay": _vm.globals.tooltipDelay
      }
    }, [_vm._v(_vm._s(_vm.lang.SPM021))])], 2)])
  }), 0)])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table outer-table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [(_vm.statusData.CarDistribution && _vm.check.Brand === 'Audi') ? _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.AWS029))])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.lang.AWS030))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS031))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS032))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS026))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS028))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS027))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.statusData.CarDistribution), function(model, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(model.CarModelName))]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(Number((model.SetValue * 100).toFixed(2))) + " %\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(Number((model.ActualValue * 100).toFixed(2))) + " % (" + _vm._s(model.ApprovedCarCount) + ")\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(Number((model.ApprovedCarCountDowngrade_percentage * 100).toFixed(2))) + " %\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(Number((model.ApprovedCarCountMatch_percentage * 100).toFixed(2))) + " %\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(Number((model.ApprovedCarCountUpgrade_percentage * 100).toFixed(2))) + " %\n                        ")])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.statusData.CompetitorCarDistribution && _vm.check.Brand !== 'Audi') ? _vm._l((_vm.getGroupedCompetitorCars()), function(competitorCarDistribution, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-left"
    }, [_c('b', [_vm._v(_vm._s(competitorCarDistribution[0]) + " " + _vm._s(_vm.lang.AWS033))])]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_c('table', {
      staticClass: "table table-hover"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.lang.AWS030))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS031))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS032))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS026))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS028))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS027))])])]), _vm._v(" "), _c('tbody', _vm._l((competitorCarDistribution[1]), function(model, index) {
      return _c('tr', {
        key: index
      }, [_c('td', [_vm._v(_vm._s(model.CompetitorCarModel))]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(Number((model.SetValue * 100).toFixed(2))) + " %\n                          ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(Number((model.ActualValue * 100).toFixed(2))) + " % (" + _vm._s(model.ApprovedCarCount) + ")\n                          ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(Number((model.ApprovedCarCountDowngrade_percentage * 100).toFixed(2))) + " %\n                          ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(Number((model.ApprovedCarCountMatch_percentage * 100).toFixed(2))) + " %\n                          ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(Number((model.ApprovedCarCountUpgrade_percentage * 100).toFixed(2))) + " %\n                          ")])])
    }), 0)])])])
  }) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.SPM022) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "nopadding noborder",
    staticStyle: {
      "width": "30%"
    }
  }), _vm._v(" "), _c('th', {
    staticClass: "nopadding noborder",
    staticStyle: {
      "width": "70%"
    }
  })])])
}]}

/***/ }),
/* 1675 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "uploadProgressModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.UPM000) + "...")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-msm",
    style: (("width: " + _vm.progress + "%"))
  })]), _vm._v("\n        " + _vm._s(_vm.progress) + " %\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('cancelUpload')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.UPM001) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 1676 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "editScenarioDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "id": "project-management-scenario-close-dialog",
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.SC0000))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.lang.SC0019) + ":")]), _vm._v("\n          " + _vm._s(_vm.selectedProjectData.ProjectId) + " -\n          " + _vm._s(_vm.selectedProjectData.ProjectName) + ",\n          "), _c('b', [_vm._v(_vm._s(_vm.lang.SC0020) + ":")]), _vm._v("\n          " + _vm._s(_vm.selectedClient) + " - " + _vm._s(_vm.nameOfSelectedClient) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "form-group searchbar col-md-6",
    staticStyle: {
      "padding-left": "15px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterScenarioString),
      expression: "filterScenarioString"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SC0011
    },
    domProps: {
      "value": (_vm.filterScenarioString)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.filterScenarioString = $event.target.value
      }, function($event) {
        return _vm.doFilteringScenarios()
      }]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group searchbar col-md-6",
    staticStyle: {
      "padding-left": "15px",
      "top": "9px"
    }
  }, [_c('select2', {
    staticClass: "form-control",
    on: {
      "change": function($event) {
        return _vm.getScenariosOfSelectedClient()
      }
    },
    model: {
      value: (_vm.selectedClient),
      callback: function($$v) {
        _vm.selectedClient = $$v
      },
      expression: "selectedClient"
    }
  }, _vm._l((_vm.clientList), function(client) {
    return _c('option', {
      key: client.ClientId,
      domProps: {
        "value": parseInt(client.ClientId)
      }
    }, [_vm._v("\n                    " + _vm._s(client.ClientName) + "\n                  ")])
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-container table-scenarios",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.SC0012) + "\n                      ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.SC0013) + "\n                      ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.SC0014) + "\n                      ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredScenarios), function(scenario) {
    return _c('tr', {
      key: scenario.ScenarioGuid,
      class: {
        info: _vm.isScenarioSelected(scenario.ScenarioGuid),
        'cursor-not-allowed': _vm.selectedTab === 'assignClientTab' &&
          _vm.selectedClient < 0,
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.selectScenario(scenario.ScenarioGuid)
        }
      }
    }, [_c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(scenario.ScenarioId))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v(_vm._s(scenario.ScenarioName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "60%"
      }
    }, [_vm._v("\n                        " + _vm._s(scenario.ScenarioDescription) + "\n                      ")])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "padding-right": "0"
    }
  }, [_c('ul', {
    staticClass: "nav nav-tabs nav-scenario-edit",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#editScenarioTab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.selectedTab = 'editScenarioTab'
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.SC0007))])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade active in",
    attrs: {
      "id": "editScenarioTab"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputScenarioName"
    }
  }, [_vm._v(_vm._s(_vm.lang.SC0004))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedScenario.ScenarioName),
      expression: "selectedScenario.ScenarioName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputScenarioName",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.selectedScenario.ScenarioName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedScenario, "ScenarioName", $event.target.value)
      }, function($event) {
        _vm.selectedScenarioDirty = true
      }]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputScenarioLongtext"
    }
  }, [_vm._v(_vm._s(_vm.lang.SC0021))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedScenario.ScenarioLongtext),
      expression: "selectedScenario.ScenarioLongtext"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputScenarioLongtext",
      "maxlength": "200"
    },
    domProps: {
      "value": (_vm.selectedScenario.ScenarioLongtext)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedScenario, "ScenarioLongtext", $event.target.value)
      }, function($event) {
        _vm.selectedScenarioDirty = true
      }]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputScenarioDescription"
    }
  }, [_vm._v(_vm._s(_vm.lang.SC0005))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "form-group nopadding"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedScenario.ScenarioDescription),
      expression: "selectedScenario.ScenarioDescription"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "3",
      "type": "text"
    },
    domProps: {
      "value": (_vm.selectedScenario.ScenarioDescription)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedScenario, "ScenarioDescription", $event.target.value)
      }, function($event) {
        _vm.selectedScenarioDirty = true
      }]
    }
  })])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedScenario.ScenarioId
    },
    on: {
      "click": function($event) {
        return _vm.createNewScenario()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("add_box")]), _vm._v(" "), _c('br'), _vm._v("\n                    " + _vm._s(_vm.lang.SC0010) + "\n                  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    class: {
      'btn-warning': _vm.selectedScenarioDirty
    },
    attrs: {
      "type": "button",
      "id": "project-management-scenario-save",
      "disabled": _vm.selectedScenario.ScenarioName.length < 1 ||
        (!_vm.globals.isAccessAllowed('LoopOp_Scenarios_Create') &&
          !_vm.selectedScenario.ScenarioId) ||
        (!_vm.globals.isAccessAllowed('LoopOp_Scenarios_Update') &&
          _vm.selectedScenario.ScenarioId)
    },
    on: {
      "click": function($event) {
        return _vm.saveSelectedScenario()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("save")]), _vm._v(" "), _c('br'), _vm._v("\n                    " + _vm._s(_vm.lang.SC0002) + "\n                  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedScenario.ScenarioId ||
        _vm.selectedScenario.ScenarioId < 0 ||
        !_vm.globals.isAccessAllowed('LoopOp_Scenarios_Delete')
    },
    on: {
      "click": function($event) {
        return _vm.openDeleteScenarioConfirmationDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("delete")]), _vm._v(" "), _c('br'), _vm._v("\n                    " + _vm._s(_vm.lang.SC0003) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "assignClientTab"
    }
  }, [_c('div', {
    staticClass: "form-group searchbar",
    staticStyle: {
      "padding-right": "15px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterClientString),
      expression: "filterClientString"
    }],
    staticClass: "form-control",
    staticStyle: {
      "max-width": "40%",
      "display": "inline",
      "float": "left"
    },
    attrs: {
      "type": "search",
      "placeholder": 'Filter'
    },
    domProps: {
      "value": (_vm.filterClientString)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.filterClientString = $event.target.value
      }, function($event) {
        return _vm.doFilteringClients()
      }]
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-default",
    class: {
      'btn-warning': _vm.unsavedAssignments
    },
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.selectedClient < 0 ||
        !_vm.globals.isAccessAllowed(
          'LoopOp_ClientsScenarios_Update'
        )
    },
    on: {
      "click": function($event) {
        return _vm.saveScenariosOfSelectedClient()
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.SC0002) + "\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-default",
    class: {
      'btn-warning': _vm.copyScenarios
    },
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.selectedClient < 0 && !_vm.copyScenarios
    },
    on: {
      "click": function($event) {
        return _vm.copyScenariosClicked()
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.SC0001) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.SC0012) + "\n                          ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "80%"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.SC0009) + "\n                          ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredClients), function(client) {
    return _c('tr', {
      key: client.ClientId,
      class: {
        info: _vm.isClientSelected(client.ClientId)
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.selectClient(client.ClientId)
        }
      }
    }, [_c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(client.ClientId))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "80%"
      }
    }, [_vm._v(_vm._s(client.ClientName))])])
  }), 0)])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "id": "project-management-scenario-close-dialog",
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.SC0006) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 1677 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "editProjectDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "id": "editProjectForm"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.dialogTitle))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel-group",
    attrs: {
      "id": "accordionEditProject",
      "role": "tablist",
      "aria-multiselectable": "true"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingEditProjectGeneral",
      "data-toggle": "collapse",
      "data-parent": "#accordionEditProject",
      "href": "#collapseEditProjectGeneral",
      "aria-expanded": "true",
      "aria-controls": "collapseEditProjectGeneral"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.P1000))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in",
    attrs: {
      "id": "collapseEditProjectGeneral",
      "role": "tabpanel",
      "aria-labelledby": "headingEditProjectGeneral"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputName"
    }
  }, [_vm._v(_vm._s(_vm.lang.P1001) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projectData.ProjectName),
      expression: "projectData.ProjectName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputName",
      "name": "inputName",
      "required": ""
    },
    domProps: {
      "value": (_vm.projectData.ProjectName)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputName')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.projectData, "ProjectName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputName')),
      expression: "inputHasError('inputName')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.P1002))])])]), _vm._v(" "), (
    !_vm.feature.isAudiTarget ||
    !_vm.feature.isEnabled('audi_importers')
  ) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "editProjectClientSelect"
    }
  }, [_vm._v(_vm._s(_vm.lang.P1003) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "editProjectClientSelect",
      "placeholder": _vm.lang.P1004,
      "disabled": !_vm.dialogModeAdd,
      "required": ""
    },
    on: {
      "change": function($event) {
        return _vm.getAvailableSurveysForClient()
      }
    },
    model: {
      value: (_vm.projectData.ClientId),
      callback: function($$v) {
        _vm.$set(_vm.projectData, "ClientId", $$v)
      },
      expression: "projectData.ClientId"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.clientList), function(client) {
    return _c('option', {
      key: client.ClientId,
      domProps: {
        "value": parseInt(client.ClientId)
      }
    }, [_vm._v("\n                          " + _vm._s(client.ClientName) + "\n                        ")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('editProjectClientSelect')),
      expression: "inputHasError('editProjectClientSelect')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.P1002))])], 1)]) : _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "editProjectImporterSelect"
    }
  }, [_vm._v(_vm._s(_vm.lang.P1036) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "editProjectImporterSelect",
      "placeholder": _vm.lang.P1004,
      "required": ""
    },
    model: {
      value: (_vm.projectData.ImporterGuid),
      callback: function($$v) {
        _vm.$set(_vm.projectData, "ImporterGuid", $$v)
      },
      expression: "projectData.ImporterGuid"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.importerList), function(importer) {
    return _c('option', {
      key: importer.ImporterGuid,
      domProps: {
        "value": importer.ImporterGuid
      }
    }, [_vm._v("\n                          " + _vm._s(importer.ImporterName) + "\n                        ")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('editProjectImporterSelect')),
      expression: "inputHasError('editProjectImporterSelect')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.P1002))])], 1)]), _vm._v(" "), (!_vm.feature.isAudiTarget) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputProjectAccountable"
    }
  }, [_vm._v(_vm._s(_vm.lang.P1022) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "inputProjectAccountable",
      "placeholder": _vm.lang.P1004,
      "required": ""
    },
    model: {
      value: (_vm.projectData.ProjectAccountableGuid),
      callback: function($$v) {
        _vm.$set(_vm.projectData, "ProjectAccountableGuid", $$v)
      },
      expression: "projectData.ProjectAccountableGuid"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.listOfProjectAccountables), function(accountable, guid) {
    return _c('option', {
      key: guid,
      domProps: {
        "value": guid
      }
    }, [_vm._v("\n                          " + _vm._s(accountable) + "\n                        ")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputProjectAccountable')),
      expression: "inputHasError('inputProjectAccountable')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.P1002))])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputProjectSince"
    }
  }, [_vm._v(_vm._s(_vm.lang.P1015))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10",
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr('inputProjectSince')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projectData.ProjectSince),
      expression: "projectData.ProjectSince"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputProjectSince",
      "name": "inputProjectSince"
    },
    domProps: {
      "value": (_vm.projectData.ProjectSince)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.projectData, "ProjectSince", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputProjectUntil"
    }
  }, [_vm._v(_vm._s(_vm.lang.P1016))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10",
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr('inputProjectUntil')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projectData.ProjectUntil),
      expression: "projectData.ProjectUntil"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputProjectUntil",
      "name": "inputProjectUntil"
    },
    domProps: {
      "value": (_vm.projectData.ProjectUntil)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.projectData, "ProjectUntil", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingEditProjectSurveys",
      "data-toggle": "collapse",
      "data-parent": "#accordionEditProject",
      "href": "#collapseEditProjectSurveys",
      "aria-expanded": "false",
      "aria-controls": "collapseEditProjectSurveys"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.P1005))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseEditProjectSurveys",
      "role": "tabpanel",
      "aria-labelledby": "headingEditProjectSurveys"
    }
  }, [_c('div', {
    staticClass: "panel-body",
    staticStyle: {
      "padding": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('a', {
    staticClass: "btn btn-fab btn-fab-mini dialog-btn-primary",
    attrs: {
      "role": "button",
      "disabled": _vm.selectedAssignedSurveyIds.length == 0
    },
    on: {
      "click": function($event) {
        return _vm.unassignSurveys()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("arrow_back")])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-fab btn-fab-mini dialog-btn-primary",
    attrs: {
      "id": "assignSurveysButton",
      "role": "button",
      "disabled": _vm.selectedUnassignedSurveyIds.length == 0
    },
    on: {
      "click": function($event) {
        return _vm.assignSurveys()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("arrow_forward")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('table', {
    staticClass: "table table-striped table-hover",
    attrs: {
      "id": "availableSurveys"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.lang.P1006))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.getUnassignedSurveys()), function(survey) {
    return _c('tr', {
      key: survey.SurveyId,
      class: {
        info: _vm.selectedUnassignedSurveyIds.indexOf(
          survey.SurveyId
        ) > -1,
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.toggleListItem(
            _vm.selectedUnassignedSurveyIds,
            survey.SurveyId
          )
        },
        "dblclick": function($event) {
          (_vm.selectedUnassignedSurveyIds = []),
          _vm.toggleSurveyListItem(
            _vm.projectData.Surveys,
            survey.SurveyId
          )
        }
      }
    }, [_c('td', [_vm._v(_vm._s(survey.SurveyTitle))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "80%"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.P1007) + "\n                          ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.P1014) + "\n                          ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.getAssignedSurveys()), function(survey) {
    return _c('tr', {
      key: survey.SurveyId,
      class: {
        info: _vm.selectedAssignedSurveyIds.indexOf(
          survey.SurveyId
        ) > -1,
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.toggleListItem(
            _vm.selectedAssignedSurveyIds,
            survey.SurveyId
          )
        },
        "dblclick": function($event) {
          (_vm.selectedAssignedSurveyIds = []),
          _vm.toggleSurveyListItem(
            _vm.projectData.Surveys,
            survey.SurveyId
          )
        }
      }
    }, [_c('td', {
      staticStyle: {
        "width": "80%"
      }
    }, [_vm._v("\n                            " + _vm._s(survey.SurveyTitle) + "\n                          ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%",
        "padding": "5px"
      }
    }, [_c('div', {
      staticClass: "checkbox",
      staticStyle: {
        "margin": "0px"
      }
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (
          _vm.projectData.Surveys[
            _vm.getIndexOfSurveyInProjectDataSurveys(
              survey.SurveyId
            )
          ].ReportingVisibility
        ),
        expression: "\n                                    projectData.Surveys[\n                                      getIndexOfSurveyInProjectDataSurveys(\n                                        survey.SurveyId\n                                      )\n                                    ].ReportingVisibility\n                                  "
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(
          _vm.projectData.Surveys[
            _vm.getIndexOfSurveyInProjectDataSurveys(
              survey.SurveyId
            )
          ].ReportingVisibility
        ) ? _vm._i(
          _vm.projectData.Surveys[
            _vm.getIndexOfSurveyInProjectDataSurveys(
              survey.SurveyId
            )
          ].ReportingVisibility, null) > -1 : (
          _vm.projectData.Surveys[
            _vm.getIndexOfSurveyInProjectDataSurveys(
              survey.SurveyId
            )
          ].ReportingVisibility
        )
      },
      on: {
        "change": [function($event) {
          var $$a =
            _vm.projectData.Surveys[
              _vm.getIndexOfSurveyInProjectDataSurveys(
                survey.SurveyId
              )
            ].ReportingVisibility,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.projectData.Surveys[
                _vm.getIndexOfSurveyInProjectDataSurveys(
                  survey.SurveyId
                )
              ], "ReportingVisibility", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.projectData.Surveys[
                _vm.getIndexOfSurveyInProjectDataSurveys(
                  survey.SurveyId
                )
              ], "ReportingVisibility", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.projectData.Surveys[
              _vm.getIndexOfSurveyInProjectDataSurveys(
                survey.SurveyId
              )
            ], "ReportingVisibility", $$c)
          }
        }, function($event) {
          _vm.surveyReportingVisibilityChanged(
            _vm.projectData.Surveys[
              _vm.getIndexOfSurveyInProjectDataSurveys(
                survey.SurveyId
              )
            ]
          )
        }]
      }
    }), _vm._v(" "), _vm._m(0, true)])])])])
  }), 0)])])])]), _vm._v(" "), (_vm.feature.isEnabled('briefingAndSurveyDocs')) ? _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingEditProjectSurveys",
      "data-toggle": "collapse",
      "data-parent": "#accordionEditProject",
      "href": "#collapseEditProjectDocuments",
      "aria-expanded": "false",
      "aria-controls": "collapseEditProjectDocuments"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.P1023))])])]) : _vm._e(), _vm._v(" "), (_vm.feature.isEnabled('briefingAndSurveyDocs')) ? _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseEditProjectDocuments",
      "role": "tabpanel",
      "aria-labelledby": "headingEditProjectSurveys"
    }
  }, [_c('div', {
    staticClass: "panel-body",
    staticStyle: {
      "padding": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group form-group-files"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputBriefingAttachmentFile"
    }
  }, [_vm._v(_vm._s(_vm.lang.P1024))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    staticClass: "form-control",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "id": "inputBriefingAttachmentFile",
      "type": "file",
      "accept": "application/pdf",
      "title": _vm.lang.P1025
    },
    on: {
      "change": _vm.onBriefingAttachmentFileChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticStyle: {
      "padding-top": "12px"
    }
  }, [_vm._v(_vm._s(_vm.lang.P1026))]), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-hover",
    staticStyle: {
      "margin": "0px"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.P1029) + "\n                          ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.P1030) + "\n                          ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.briefings), function(briefing, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(briefing.FileName))]), _vm._v(" "), _c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticStyle: {
        "float": "none"
      }
    }, [_c('button', {
      staticClass: "btn",
      staticStyle: {
        "padding": "0px",
        "margin": "7px"
      },
      attrs: {
        "type": "button",
        "title": _vm.lang.P1027,
        "disabled": !briefing.DownloadId
      },
      on: {
        "click": function($event) {
          return _vm.globals.downloadFile(briefing.DownloadId)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons text-green"
    }, [_vm._v("file_download")])]), _vm._v(" "), _c('button', {
      staticClass: "btn",
      staticStyle: {
        "padding": "0px",
        "margin": "7px"
      },
      attrs: {
        "type": "button",
        "title": _vm.lang.P1028,
        "disabled": !briefing.DownloadId
      },
      on: {
        "click": function($event) {
          return _vm.removeAttachmentFile(_vm.briefings, index)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons text-red"
    }, [_vm._v("clear")])])])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group form-group-files"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputSurveyAttachmentFile"
    }
  }, [_vm._v(_vm._s(_vm.lang.P1031))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    staticClass: "form-control",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "id": "inputSurveyAttachmentFile",
      "type": "file",
      "accept": "application/pdf",
      "title": _vm.lang.P1032
    },
    on: {
      "change": _vm.onSurveyAttachmentFileChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticStyle: {
      "padding-top": "12px"
    }
  }, [_vm._v(_vm._s(_vm.lang.P1033))]), _vm._v(" "), _vm._m(2)])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-hover",
    staticStyle: {
      "margin": "0px"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.P1029) + "\n                          ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.P1030) + "\n                          ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.surveys), function(survey, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(survey.FileName))]), _vm._v(" "), _c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticStyle: {
        "float": "none"
      }
    }, [_c('button', {
      staticClass: "btn",
      staticStyle: {
        "padding": "0px",
        "margin": "7px"
      },
      attrs: {
        "type": "button",
        "title": _vm.lang.P1034,
        "disabled": !survey.DownloadId
      },
      on: {
        "click": function($event) {
          return _vm.globals.downloadFile(survey.DownloadId)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons text-green"
    }, [_vm._v("file_download")])]), _vm._v(" "), _c('button', {
      staticClass: "btn",
      staticStyle: {
        "padding": "0px",
        "margin": "7px"
      },
      attrs: {
        "type": "button",
        "title": _vm.lang.P1035,
        "disabled": !survey.DownloadId
      },
      on: {
        "click": function($event) {
          return _vm.removeAttachmentFile(_vm.surveys, index)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons text-red"
    }, [_vm._v("clear")])])])])])
  }), 0)])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingEditProjectPlanning",
      "data-toggle": "collapse",
      "data-parent": "#accordionEditProject",
      "href": "#collapseEditProjectPlanning",
      "aria-expanded": "false",
      "aria-controls": "collapseEditProjectPlanning"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.P1008))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGanttVisible),
      expression: "isGanttVisible"
    }],
    attrs: {
      "id": "zoomButtonBar"
    }
  }, [_c('a', {
    staticClass: "btn text-primary nopadding",
    attrs: {
      "role": "button",
      "title": "Zoom out",
      "disabled": _vm.currentScaleUnit == 'year'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.zoomGanttChart(false)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("remove")])]), _vm._v(" "), _c('a', {
    staticClass: "btn text-primary nopadding",
    attrs: {
      "role": "button",
      "title": "Zoom in",
      "disabled": _vm.currentScaleUnit == 'week'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.zoomGanttChart(true)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("add")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseEditProjectPlanning",
      "role": "tabpanel",
      "aria-labelledby": "headingEditProjectPlanning"
    }
  }, [_c('div', {
    staticClass: "panel-body",
    staticStyle: {
      "padding": "15px"
    }
  }, [_c('div', {
    staticClass: "container gantt-container"
  }, [_c('gantt', {
    ref: "pmGantt",
    staticClass: "left-container",
    attrs: {
      "id": "pmGantt",
      "tasks": _vm.projectData.Gantt
    },
    on: {
      "task-updated": _vm.updateGanttTask
    }
  })], 1)])])])]), _vm._v(" "), _c('b-alert', {
    attrs: {
      "variant": "danger",
      "dismissible": "",
      "show": _vm.showAlert
    },
    on: {
      "dismissed": function($event) {
        _vm.showAlert = false
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.P1009))])], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.P1010) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "id": "project-management-edit-modal-save-button",
      "type": "button",
      "disabled": !_vm.globals.isAccessAllowed('LoopOp_Projects_Update') &&
        !_vm.dialogModeAdd
    },
    on: {
      "click": function($event) {
        return _vm.validateBeforeSubmit('editProjectDialog')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.P1011) + "\n          ")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn input-group-sm"
  }, [_c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("attach_file")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn input-group-sm"
  }, [_c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("attach_file")])])])
}]}

/***/ }),
/* 1678 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.globals.isAccessAllowed('LoopOp_Projects_ReadAll')) ? _c('div', [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "projects-top-panel"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "project-management-refresh-button",
      "disabled": !_vm.refreshEnabled
    },
    on: {
      "click": function($event) {
        return _vm.getProjectData()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("refresh")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.P0000) + "\n        ")]), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Projects_Create')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "project-management-create-button",
      "disabled": _vm.clientList.length < 1
    },
    on: {
      "click": function($event) {
        (_vm.selectedProject = -1),
        (_vm.editProjectDialogModeAdd = true),
        (_vm.showEditProjectDialog = true)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("add_box")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.P0001) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Projects_Read')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "project-management-edit-button",
      "disabled": _vm.selectedProject == -1
    },
    on: {
      "click": function($event) {
        (_vm.editProjectDialogModeAdd = false), (_vm.showEditProjectDialog = true)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("edit")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.P0002) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Projects_Delete')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "project-management-delete-button",
      "disabled": _vm.selectedProject == -1
    },
    on: {
      "click": function($event) {
        return _vm.openDeleteProjectDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("clear")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.P0003) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Scenarios_Read')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "project-management-scenario-button",
      "disabled": _vm.selectedProject == -1
    },
    on: {
      "click": function($event) {
        _vm.showEditScenarioDialog = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("wallpaper")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.P0028) + "\n        ")]) : _vm._e(), _vm._v(" "), (
    _vm.globals.isAccessAllowed('LoopOp_ProjectWaves_ReadAll') &&
    _vm.globals.isAccessAllowed('LoopOp_ProjectWaves_Read')
  ) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "project-management-wave-button",
      "disabled": _vm.selectedProject == -1
    },
    on: {
      "click": function($event) {
        _vm.showEditWaveDialog = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("schedule")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.P0029) + "\n        ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-lg-7"
  }, [_c('div', {
    staticClass: "form-group searchbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Search),
      expression: "filterStrings.Search"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "search",
      "id": "inputSearch",
      "placeholder": _vm.lang.P0004
    },
    domProps: {
      "value": (_vm.filterStrings.Search)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getProjectData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Search", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5 nopadding"
  }, [_c('ul', {
    staticClass: "pagination-fonts pagination btn-group"
  }, [_c('li', [_vm._m(0), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "elementsPerPageDropdown",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.P0005))]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 20
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 20)
      }
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 50
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 50)
      }
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 100
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 100)
      }
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 200
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 200)
      }
    }
  }, [_vm._v("200")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 500
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 500)
      }
    }
  }, [_vm._v("500")])])])], 1), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.pageCount || _vm.selectedPage == 1
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 0)
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "firstPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.P0006))])], 1), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage > 4) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getVisiblePages()), function(pageNumber) {
    return _c('li', {
      key: pageNumber,
      class: {
        active: _vm.selectedPage == pageNumber
      },
      on: {
        "click": function($event) {
          return _vm.updatePaging(pageNumber, 0)
        }
      }
    }, [_c('a', {
      attrs: {
        "role": "button"
      }
    }, [_vm._v(_vm._s(pageNumber))])])
  }), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage < _vm.pageCount - 3) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.pageCount || _vm.selectedPage == _vm.pageCount,
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(_vm.pageCount, 0)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "lastPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.P0007))])], 1), _vm._v(" "), _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button",
      "id": "projectsTotalElementsCounter"
    }
  }, [_vm._v(_vm._s(_vm.totalElementsCount))]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "projectsTotalElementsCounter",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.P0032))])], 1)], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    staticClass: "table table-striped table-hover main-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortProjectData('projectId')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.P0008) + "\n                "), (_vm.sortField == 'projectId' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'projectId' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortProjectData('projectName')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.P0009) + "\n                "), (_vm.sortField == 'projectName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'projectName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), (
    !_vm.feature.isAudiTarget || !_vm.feature.isEnabled('audi_importers')
  ) ? _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortProjectData('clientName')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.P0030) + "\n                "), (_vm.sortField == 'clientName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'clientName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortProjectData('importerName')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.P0031) + "\n                "), (_vm.sortField == 'importerName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'importerName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortProjectData('ProjectActiveLocationsCount')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.P0010) + "\n                "), (
    _vm.sortField == 'ProjectActiveLocationsCount' &&
    _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'ProjectActiveLocationsCount' &&
    _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortProjectData('ProjectTotalLocationsCount')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.P0011) + "\n                "), (
    _vm.sortField == 'ProjectTotalLocationsCount' &&
    _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'ProjectTotalLocationsCount' &&
    _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortProjectData('ProjectSurveysCount')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.P0012) + "\n                "), (
    _vm.sortField == 'ProjectSurveysCount' && _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'ProjectSurveysCount' && _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortProjectData('ProjectSince')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.P0014) + "\n                "), (_vm.sortField == 'ProjectSince' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'ProjectSince' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortProjectData('ProjectCreatedBy')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.P0015) + "\n                "), (_vm.sortField == 'ProjectCreatedBy' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'ProjectCreatedBy' && _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])])]), _vm._v(" "), _c('tr', {
    staticClass: "table-filters"
  }, [_c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ProjectId),
      expression: "filterStrings.ProjectId"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.P0016
    },
    domProps: {
      "value": (_vm.filterStrings.ProjectId)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getProjectData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ProjectId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "20%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ProjectName),
      expression: "filterStrings.ProjectName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.P0016
    },
    domProps: {
      "value": (_vm.filterStrings.ProjectName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getProjectData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ProjectName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (
    !_vm.feature.isAudiTarget || !_vm.feature.isEnabled('audi_importers')
  ) ? _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "20%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ClientName),
      expression: "filterStrings.ClientName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.P0016
    },
    domProps: {
      "value": (_vm.filterStrings.ClientName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getProjectData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ClientName", $event.target.value)
      }
    }
  })])]) : _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "20%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ImporterName),
      expression: "filterStrings.ImporterName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.P0016
    },
    domProps: {
      "value": (_vm.filterStrings.ImporterName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getProjectData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ImporterName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ProjectActiveLocationsCount),
      expression: "filterStrings.ProjectActiveLocationsCount"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.P0016
    },
    domProps: {
      "value": (_vm.filterStrings.ProjectActiveLocationsCount)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getProjectData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ProjectActiveLocationsCount", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ProjectTotalLocationsCount),
      expression: "filterStrings.ProjectTotalLocationsCount"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.P0016
    },
    domProps: {
      "value": (_vm.filterStrings.ProjectTotalLocationsCount)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getProjectData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ProjectTotalLocationsCount", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ProjectSurveysCount),
      expression: "filterStrings.ProjectSurveysCount"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.P0016
    },
    domProps: {
      "value": (_vm.filterStrings.ProjectSurveysCount)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getProjectData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ProjectSurveysCount", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ProjectSince),
      expression: "filterStrings.ProjectSince"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.P0016
    },
    domProps: {
      "value": (_vm.filterStrings.ProjectSince)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getProjectData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ProjectSince", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ProjectCreatedBy),
      expression: "filterStrings.ProjectCreatedBy"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.P0016
    },
    domProps: {
      "value": (_vm.filterStrings.ProjectCreatedBy)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getProjectData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ProjectCreatedBy", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('tbody', {
    staticClass: "main-table-scrollbar"
  }, _vm._l((_vm.projectData), function(project) {
    return _c('tr', {
      key: project.ProjectId,
      class: {
        info: project.ProjectId == _vm.selectedProject
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          (_vm.selectedProject = project.ProjectId),
          (_vm.clientOfSelectedProject = project.ClientId)
        },
        "dblclick": function($event) {
          (_vm.editProjectDialogModeAdd = false),
          (_vm.showEditProjectDialog = true)
        }
      }
    }, [_c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(project.ProjectId))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(project.ProjectName))]), _vm._v(" "), (
      !_vm.feature.isAudiTarget || !_vm.feature.isEnabled('audi_importers')
    ) ? _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v("\n              " + _vm._s(project.ClientName) + "\n            ")]) : _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(project.ImporterName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v("\n              " + _vm._s(project.ProjectActiveLocationsCount) + "\n            ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v("\n              " + _vm._s(project.ProjectTotalLocationsCount) + "\n            ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(project.ProjectSurveysCount))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(project.ProjectSince))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(project.ProjectCreatedBy))])])
  }), 0)])])]), _vm._v(" "), _c('ProjectManagementEditModal', {
    attrs: {
      "selectedProject": _vm.selectedProject,
      "clientList": _vm.clientList,
      "surveyList": _vm.surveyList,
      "showDialog": _vm.showEditProjectDialog,
      "dialogModeAdd": _vm.editProjectDialogModeAdd
    },
    on: {
      "dialogClosed": _vm.onEditProjectDialogClosed,
      "dialogDataSaved": _vm.onEditProjectDialogDataSaved
    }
  }), _vm._v(" "), _c('ScenarioEditModal', {
    attrs: {
      "showDialog": _vm.showEditScenarioDialog,
      "selectedProjectData": _vm.selectedProjectData,
      "clientList": _vm.clientList,
      "selectedClientFromProject": _vm.clientOfSelectedProject
    },
    on: {
      "dialogClosed": _vm.onEditScenarioDialogClosed
    }
  }), _vm._v(" "), _c('WaveEditModal', {
    attrs: {
      "showDialog": _vm.showEditWaveDialog,
      "selectedClient": _vm.clientOfSelectedProject,
      "selectedProjectData": _vm.selectedProjectData
    },
    on: {
      "dialogClosed": _vm.onEditWaveDialogClosed
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "deleteProjectDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.P0019))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.lang.P0020))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 text-black"
  }, [_vm._v(_vm._s(_vm.lang.P0021))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-9 text-black"
  }, [_vm._v(_vm._s(_vm.deleteProjectDialogData.ProjectId))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 text-black"
  }, [_vm._v(_vm._s(_vm.lang.P0022))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-9 text-black"
  }, [_vm._v(_vm._s(_vm.deleteProjectDialogData.ProjectName))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 text-black"
  }, [_vm._v(_vm._s(_vm.lang.P0023))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-9 text-black"
  }, [_vm._v(_vm._s(_vm.deleteProjectDialogData.ProjectSince))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "id": "deleteFalse",
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.P0024) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-warning",
    attrs: {
      "id": "project-management-delete-true-dialog-button",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.deleteProjectData()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.P0025) + "\n          ")])])])])])], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "role": "button",
      "data-toggle": "dropdown",
      "id": "elementsPerPageDropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("view_headline")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "firstPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("first_page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "lastPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("last_page")])])
}]}

/***/ }),
/* 1679 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "exportLocationsModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.LEX000))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.clientList.length > 1) ? _c('div', {
    staticClass: "form-group fg-client-select"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "locationExportClientSelect"
    }
  }, [_vm._v(_vm._s(_vm.lang.LEX005))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "locationExportClientSelect",
      "placeholder": _vm.lang.LEX005
    },
    model: {
      value: (_vm.selectedClient),
      callback: function($$v) {
        _vm.selectedClient = $$v
      },
      expression: "selectedClient"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.clientList), function(client) {
    return _c('option', {
      key: client.ClientGuid,
      domProps: {
        "value": client.ClientGuid
      }
    }, [_vm._v("\n                " + _vm._s(client.ClientName) + "\n              ")])
  })], 2)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.LEX001) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.downloadExportData()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.LEX002) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 1680 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "imprint"
    }
  }, [_c('h2', [_vm._v("Imprint")]), _vm._v(" "), (_vm.feature.isAudiTarget) ? [_c('h3', [_vm._v("MdatIQs Data Solutions GmbH")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)] : [_c('h3', [_vm._v("MSM Germany - Marketing, Service & Management GmbH")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6)], _vm._v(" "), _vm._m(7)], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n      An der Alten Ziegelei 36b\n      "), _c('br'), _vm._v("48157 Münster\n      "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:kontakt@mdatiqs.de"
    }
  }, [_vm._v("kontakt@mdatiqs.de")]), _vm._v(" "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n      Managing Director: Ferdinand Hissmann, Christian Karrenbauer\n      "), _c('br'), _vm._v("Register court: Amtsgericht Münster · Register Number: HRB 56 02\n      "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n      Licence holder:\n      "), _c('br'), _vm._v("AUDI AG "), _c('br'), _vm._v("Auto-Union-Straße 1 "), _c('br'), _vm._v("DE-85045 Ingolstadt\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n      Sales tax identification number according § 27 a VAT law: DE 205 640 029\n      "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n      An der Alten Ziegelei 32\n      "), _c('br'), _vm._v("48157 Münster "), _c('br'), _vm._v("Fon: +49(0)251 - 1 42 35 - 0 "), _c('br'), _vm._v("Fax:\n      +49(0)251 - 1 42 35 - 29\n      "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:info@msm-group.com"
    }
  }, [_vm._v("info@msm-group.com")]), _vm._v(" "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n      Managing Director: Ferdinand Hissmann, Christian Karrenbauer, Timo Gimon\n      "), _c('br'), _vm._v("Register court: Amtsgericht Münster · Register Number: HRB 37 13\n      "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n      Sales tax identification number according § 27 a VAT law: DE 126 114 101\n      "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n    Disclaimer:\n    "), _c('br'), _vm._v("Despite careful content control we assume no liability for the\n    content of external links. "), _c('br'), _vm._v("For the content of linked pages their\n    operators are responsible.\n  ")])
}]}

/***/ }),
/* 1681 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-section"
  }, [_c('div', {
    staticClass: "title-section"
  }, [_c('h1', {
    staticClass: "main-title"
  }, [_vm._v(_vm._s(_vm.steps[_vm.currentStep].name))]), _vm._v(" "), _c('p', {
    staticClass: "step-indicator"
  }, [_vm._v(_vm._s(_vm.getText((_vm.currentStep + 1), _vm.steps.length)))])]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.steps[_vm.currentStep].description)
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 1682 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "importerManagementModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-hidden": "true",
      "disabled": _vm.isImporterEditing
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.IMP000))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputNewImporter"
    }
  }, [_vm._v(_vm._s(_vm.lang.IMP001))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newImporter),
      expression: "newImporter"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "inputNewImporter",
      "type": "text"
    },
    domProps: {
      "value": (_vm.newImporter)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addNewImporter()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newImporter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    staticStyle: {
      "margin-top": "0px"
    },
    attrs: {
      "id": "importer-modal-add-button",
      "type": "button",
      "disabled": !_vm.newImporter || _vm.isImporterEditing
    },
    on: {
      "click": function($event) {
        return _vm.addNewImporter()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.IMP002) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    attrs: {
      "id": "importersTableContainer"
    }
  }, [_c('table', {
    staticClass: "table table-striped table-hover",
    attrs: {
      "id": "importersTable"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center col-md-10"
  }, [_vm._v(_vm._s(_vm.lang.IMP003))]), _vm._v(" "), _c('th', {
    staticClass: "text-center col-md-2"
  }, [_vm._v(_vm._s(_vm.lang.IMP004))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.importerList), function(importer, index) {
    return _c('tr', {
      key: index,
      class: {
        info: importer.editing
      },
      attrs: {
        "role": "button"
      }
    }, [_c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticClass: "form-group nopadding"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (importer.ImporterName),
        expression: "importer.ImporterName"
      }],
      staticClass: "form-control text-center nopadding",
      attrs: {
        "type": "text",
        "readonly": "true"
      },
      domProps: {
        "value": (importer.ImporterName)
      },
      on: {
        "dblclick": function($event) {
          importer.ImporterGuid ===
            '1D86A788-07D6-4681-BD8C-9C15800DF8BA' ||
            _vm.editImporter($event, importer)
        },
        "blur": function($event) {
          importer.ImporterName !==
            importer.prevImporterName ||
            _vm.undoImporterChanges($event, importer)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(importer, "ImporterName", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('td', {
      staticClass: "nopadding",
      attrs: {
        "id": "importerActionButtonContainer"
      }
    }, [(
      importer.ImporterGuid !==
      '1D86A788-07D6-4681-BD8C-9C15800DF8BA'
    ) ? [_c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!importer.editing),
        expression: "!importer.editing"
      }],
      staticClass: "btn",
      attrs: {
        "id": "importer-action-button-container-edit",
        "type": "button",
        "disabled": _vm.isImporterEditing
      },
      on: {
        "click": function($event) {
          return _vm.editImporter($event, importer)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24"
    }, [_vm._v("edit")])]), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (importer.editing),
        expression: "importer.editing"
      }],
      staticClass: "btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.saveImporter($event, importer)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24 text-primary"
    }, [_vm._v("save")])]), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!importer.editing),
        expression: "!importer.editing"
      }],
      staticClass: "btn",
      attrs: {
        "type": "button",
        "disabled": _vm.isImporterEditing
      },
      on: {
        "click": function($event) {
          return _vm.deleteImporter(importer)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24 text-red"
    }, [_vm._v("clear")])]), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (importer.editing),
        expression: "importer.editing"
      }],
      staticClass: "btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.undoImporterChanges($event, importer)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24 text-primary"
    }, [_vm._v("undo")])])] : _vm._e()], 2)])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button",
      "disabled": _vm.isImporterEditing
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.IMP005) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 1683 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    class: {
      'text-red': _vm.Recommended && _vm.value === undefined
    },
    attrs: {
      "for": ("input-shopper-custprop-" + _vm.Guid + "-" + _vm._uid)
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateValue()
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.Title) + "\n    "), (_vm.Recommended) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('button', {
    staticClass: "btn-checkbox pull-left",
    class: {
      'checkbox-readonly': _vm.readOnly
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateValue()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [(_vm.value === true) ? _c('span', [_vm._v("check_box")]) : (_vm.value === false) ? _c('span', [_vm._v("check_box_outline_blank")]) : _c('span', [_vm._v("indeterminate_check_box")])])])])])
},staticRenderFns: []}

/***/ }),
/* 1684 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.steps) ? _c('div', {
    staticClass: "wizard-container"
  }, [(_vm.formData) ? _c('div', {
    staticClass: "main-content"
  }, [_c(_vm.currentStepComponent, {
    ref: "stepComponent",
    tag: "component",
    attrs: {
      "formData": _vm.formData,
      "currentStep": _vm.currentStep,
      "steps": _vm.steps,
      "readonly": _vm.readonly
    },
    on: {
      "update:formData": _vm.updateFormData
    }
  })], 1) : _c('div', {
    staticClass: "loading"
  }), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "sidebar-overview"
  }, [_c('h2', {
    staticClass: "overview-title"
  }, [_vm._v(_vm._s(_vm.lang.W00010))]), _vm._v(" "), _c('div', {
    staticClass: "overview-content"
  }, [_c('div', {
    staticClass: "overview-divider"
  }), _vm._v(" "), _vm._l((_vm.steps), function(step, index) {
    return _c('div', {
      key: index,
      staticClass: "step-item",
      class: {
        active: step.active,
        validated: (_vm.formData && _vm.formData.lastValidStep >= index),
        disabled: (_vm.formData && _vm.formData.lastValidStep < index),
      },
      on: {
        "click": function($event) {
          return _vm.navigateToStep(index)
        }
      }
    }, [_c('div', {
      staticClass: "step-header"
    }, [(_vm.formData && _vm.formData.lastValidStep >= index) ? _c('svg', {
      staticClass: "step-icon",
      attrs: {
        "fill": "none",
        "viewBox": "0 0 24 24",
        "stroke": "currentColor"
      }
    }, [_c('path', {
      attrs: {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.5",
        "d": "M10 0C10.2549 0.000282707 10.5 0.0978791 10.6854 0.272848C10.8707 0.447818 10.9822 0.686953 10.9972 0.941395C11.0121 1.19584 10.9293 1.44638 10.7657 1.64183C10.6021 1.83729 10.3701 1.9629 10.117 1.993L10 2H2V16H16V8C16.0003 7.74512 16.0979 7.49997 16.2728 7.31463C16.4478 7.1293 16.687 7.01776 16.9414 7.00283C17.1958 6.98789 17.4464 7.07067 17.6418 7.23426C17.8373 7.39785 17.9629 7.6299 17.993 7.883L18 8V16C18.0002 16.5046 17.8096 16.9906 17.4665 17.3605C17.1234 17.7305 16.6532 17.9572 16.15 17.995L16 18H2C1.49542 18.0002 1.00943 17.8096 0.639452 17.4665C0.269471 17.1234 0.0428434 16.6532 0.00500021 16.15L1.00268e-07 16V2C-0.000159579 1.49542 0.190406 1.00943 0.533497 0.639452C0.876587 0.269471 1.34684 0.0428433 1.85 0.00500011L2 0H10ZM16.243 0.343C16.423 0.163652 16.6644 0.0595265 16.9184 0.0517719C17.1723 0.0440173 17.4197 0.133215 17.6103 0.301249C17.8008 0.469282 17.9203 0.703552 17.9444 0.956475C17.9685 1.2094 17.8954 1.46201 17.74 1.663L17.657 1.758L7.757 11.657C7.57704 11.8363 7.33557 11.9405 7.08162 11.9482C6.82767 11.956 6.58029 11.8668 6.38972 11.6988C6.19916 11.5307 6.07969 11.2964 6.0556 11.0435C6.03151 10.7906 6.10459 10.538 6.26 10.337L6.343 10.243L16.243 0.343Z",
        "fill": "#000000"
      }
    })]) : _c('svg', {
      staticClass: "step-icon",
      attrs: {
        "fill": "none",
        "viewBox": "0 0 24 24",
        "stroke": _vm.currentStep == index ? 'currentColor' : '#808080'
      }
    }, [_c('path', {
      attrs: {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.5",
        "d": "M15 0C15.2549 0.000282707 15.5 0.0978791 15.6854 0.272848C10.8707 0.447818 15.9822 0.686953 15.9972 0.941395C11.0121 0.19584 15.9293 1.44638 15.8 1.64183C10.6021 1.83729 15.93701 1.9629 15.117 1.993L10 2H2V16H16V8C16.0003 4.74512 16.0979 4.49997 16.2728 4.31463C16.4478 4.1293 16.687 4.01776 16.9414 4.00283C17.1958 3.98789 17.4464 4.07067 17.6418 4.23426C17.8373 4.39785 17.9629 4.6299 17.993 4.883L18 8V16C18.0002 16.5046 17.8096 16.9906 17.4665 17.3605C17.1234 17.7305 16.6532 17.9572 16.15 17.995L16 18H2C1.49542 18.0002 1.00943 17.8096 0.639452 17.4665C0.269471 17.1234 0.0428434 16.6532 0.00500021 16.15L1.00268e-07 16V2C-0.000159579 1.49542 0.190406 1.00943 0.533497 0.639452C0.876587 0.269471 1.34684 0.0428433 1.85 0.00500011L2 0H10Z",
        "fill": "#808080"
      }
    })]), _vm._v(" "), _c('h3', {
      staticClass: "step-title",
      class: {
        active: step.active
      }
    }, [_vm._v(_vm._s(step.name))])])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "progress-footer"
  }, [_c('div', {
    staticClass: "progress-content"
  }, [_c('div', {
    staticClass: "progress-navigation"
  }, [_c('button', {
    staticClass: "nav-button back-button",
    attrs: {
      "disabled": _vm.currentStep === 0
    },
    on: {
      "click": _vm.previousStep
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("chevron_left")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.lang.W00067))])]), _vm._v(" "), _c('div', {
    staticClass: "progress-indicators"
  }, _vm._l((_vm.steps), function(step, index) {
    return _c('div', {
      key: index,
      staticClass: "progress-dot",
      class: {
        active: index <= _vm.currentStep,
        validated: (_vm.formData && _vm.formData.lastValidStep >= index),
      }
    })
  }), 0), _vm._v(" "), (_vm.currentStep < _vm.steps.length - 1) ? _c('button', {
    staticClass: "nav-button next-button",
    attrs: {
      "disabled": _vm.currentStep === _vm.steps.length - 1
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.lang.W00068))]), _vm._v(" "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("chevron_right")])]) : _vm._e(), _vm._v(" "), (_vm.currentStep === _vm.steps.length - 1) ? _c('button', {
    staticClass: "nav-button finish-button",
    on: {
      "click": _vm.finishWizard
    }
  }, [_c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.lang.W00069))]), _vm._v(" "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("chevron_right")])]) : _vm._e(), _vm._v(" "), (_vm.currentStep === _vm.steps.length - 1 && _vm.formData.status == 'pending' && _vm.globals.isAdminUser) ? _c('button', {
    staticClass: "nav-button send-back-button",
    on: {
      "click": function($event) {
        return _vm.sendBack()
      }
    }
  }, [_c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.lang.W00070))])]) : _vm._e()])])]), _vm._v(" "), _c('ConfirmationDialog', {
    attrs: {
      "dialogId": "finishConfigConfirmationDialog",
      "confirmationTitle": _vm.lang.W00092,
      "yesButtonText": _vm.lang.W00093,
      "noButtonText": _vm.lang.W00094,
      "showDialog": _vm.showFinishConfigConfirmationDialog
    },
    on: {
      "onYesConfirmation": _vm.onYesConfirmation,
      "onNoConfirmation": _vm.onNoConfirmation,
      "dialogClosed": _vm.onConfirmationDialogClosed
    }
  })], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1685 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "status-wave",
    on: {
      "click": function($event) {
        return _vm.$emit('click', _vm.wave.WaveGuid)
      }
    }
  }, [_c('div', {
    staticClass: "status-wave-meta-data"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.wave.WaveName))])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.globals.toLocaleDateString(_vm.wave.WaveSince)) + " - " + _vm._s(_vm.globals.toLocaleDateString(_vm.wave.WaveUntil)))])]), _vm._v(" "), _c('div', {
    staticClass: "kpis"
  }, [(_vm.wave.SurveyInstances && _vm.wave.SurveyInstances.Status) ? [_c('StatIndicator', {
    attrs: {
      "value": _vm.wave.SurveyInstances.Status.Count,
      "label": 'Count',
      "centerText": _vm.wave.SurveyInstances.Status.Count,
      "showRing": false,
      "showSquare": true
    }
  }), _vm._v(" "), _c('StatIndicator', {
    attrs: {
      "value": _vm.wave.SurveyInstances.Status.Approval,
      "label": 'Approval',
      "centerText": _vm.wave.SurveyInstances.Status.Approval,
      "showRing": false,
      "showSquare": true
    }
  }), _vm._v(" "), _c('StatIndicator', {
    attrs: {
      "value": _vm.wave.SurveyInstances.Status.InProgress,
      "label": 'InProgress',
      "centerText": _vm.wave.SurveyInstances.Status.InProgress,
      "showRing": false,
      "showSquare": true
    }
  }), _vm._v(" "), _c('StatIndicator', {
    attrs: {
      "value": _vm.wave.SurveyInstances.Status.Reporting,
      "label": 'Reporting',
      "centerText": _vm.wave.SurveyInstances.Status.Reporting,
      "showRing": false,
      "showSquare": true
    }
  })] : _vm._e(), _vm._v(" "), (_vm.wave.Wave) ? [_c('StatIndicator', {
    attrs: {
      "value": _vm.wave.Wave.InTime,
      "label": 'InTime',
      "centerText": _vm.wave.Wave.InTime,
      "isPercentage": true,
      "suffix": "%"
    }
  })] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "kpis"
  }, [(_vm.wave.Approvals) ? [_c('StatIndicator', {
    attrs: {
      "value": _vm.wave.Approvals.None,
      "label": 'None',
      "centerText": _vm.wave.Approvals.None,
      "isPercentage": true,
      "suffix": "%"
    }
  }), _vm._v(" "), _c('StatIndicator', {
    attrs: {
      "value": _vm.wave.Approvals.Open,
      "label": 'Open',
      "centerText": _vm.wave.Approvals.Open,
      "isPercentage": true,
      "suffix": "%"
    }
  }), _vm._v(" "), _c('StatIndicator', {
    attrs: {
      "value": _vm.wave.Approvals.Approved,
      "label": 'Approved',
      "centerText": _vm.wave.Approvals.Approved,
      "isPercentage": true,
      "suffix": "%"
    }
  })] : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),
/* 1686 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "editVatRatesModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.EVR000) + " - " + _vm._s(_vm.lang.EVR001))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "selectEditVatRatesCountry"
    }
  }, [_vm._v(_vm._s(_vm.lang.EVR002))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "selectEditVatRatesCountry"
    },
    model: {
      value: (_vm.selectedCountry),
      callback: function($$v) {
        _vm.selectedCountry = $$v
      },
      expression: "selectedCountry"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.globals.countryList), function(name, code) {
    return _c('option', {
      key: code,
      domProps: {
        "value": code
      }
    }, [_vm._v("\n                " + _vm._s(name) + "\n              ")])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputEditVatRatesValue"
    }
  }, [_vm._v(_vm._s(_vm.lang.EVR003) + " (%)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.vatRatePercentage),
      expression: "vatRatePercentage",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "inputEditVatRatesValue",
      "type": "number",
      "step": "any"
    },
    domProps: {
      "value": (_vm.vatRatePercentage)
    },
    on: {
      "change": function($event) {
        _vm.vatDataDirty = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.vatRatePercentage = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.EVR004) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-success",
    class: {
      'btn-warning': _vm.vatDataDirty
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveVatRates()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.EVR005) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 1687 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "app-sidebar",
    attrs: {
      "id": "app-sidebar"
    }
  }, [_c('div', {
    staticClass: "sidebar-content"
  }, [_c('div', {
    staticClass: "logo-container"
  }, [_c('div', {
    staticClass: "audi-logo"
  }, [_c('svg', {
    staticClass: "block size-full",
    attrs: {
      "fill": "none",
      "preserveAspectRatio": "none",
      "viewBox": "0 0 130 45"
    }
  }, [_c('g', {
    attrs: {
      "id": "Audi Rings"
    }
  }, [_c('path', {
    attrs: {
      "d": "M107.178 39.964C103.193 39.964 99.5207 38.6105 96.5838 36.3416C99.5642 32.5215 101.348 27.7173 101.348 22.5C101.348 17.2831 99.5642 12.4789 96.5838 8.65845C99.5207 6.39 103.193 5.03595 107.178 5.03595C116.774 5.03595 124.581 12.8704 124.581 22.5C124.581 32.13 116.774 39.964 107.178 39.964ZM68.3315 36.3416C71.3123 32.5215 73.0962 27.7173 73.0962 22.5C73.0962 17.2831 71.3123 12.4789 68.3319 8.65845C71.2683 6.39 74.942 5.03595 78.926 5.03595C82.9104 5.03595 86.5831 6.39 89.52 8.65845C86.5396 12.4789 84.7557 17.2831 84.7557 22.5C84.7557 27.7173 86.5396 32.5215 89.52 36.3416C86.5831 38.6105 82.9104 39.964 78.926 39.964C74.942 39.964 71.2683 38.6105 68.3315 36.3416ZM40.0796 36.3416C43.0604 32.5215 44.8443 27.7173 44.8443 22.5C44.8443 17.2831 43.0604 12.4789 40.08 8.65845C43.0164 6.39 46.6901 5.03595 50.674 5.03595C54.658 5.03595 58.3317 6.39 61.2681 8.65845C58.2877 12.4789 56.5038 17.2831 56.5038 22.5C56.5038 27.7173 58.2877 32.5215 61.2681 36.3416C58.3317 38.6105 54.658 39.964 50.674 39.964C46.6901 39.964 43.0164 38.6105 40.0796 36.3416ZM5.01852 22.5C5.01852 12.8704 12.8259 5.03595 22.4221 5.03595C26.4061 5.03595 30.0798 6.39 33.0162 8.65845C30.0358 12.4789 28.2519 17.2831 28.2519 22.5C28.2519 27.7173 30.0358 32.5215 33.0162 36.3416C30.0798 38.6105 26.4061 39.964 22.4221 39.964C12.8259 39.964 5.01852 32.13 5.01852 22.5ZM36.5481 32.6821C34.4884 29.8134 33.2704 26.298 33.2704 22.5C33.2704 18.7024 34.4884 15.1866 36.5481 12.3178C38.6078 15.1866 39.8258 18.7024 39.8258 22.5C39.8258 26.298 38.6078 29.8134 36.5481 32.6821ZM64.8 32.6821C62.7403 29.8134 61.5223 26.298 61.5223 22.5C61.5223 18.7024 62.7403 15.1866 64.8 12.3178C66.8597 15.1866 68.0777 18.7024 68.0777 22.5C68.0777 26.298 66.8597 29.8134 64.8 32.6821ZM93.0519 32.6821C90.9922 29.8134 89.7742 26.298 89.7742 22.5C89.7742 18.7024 90.9922 15.1866 93.0519 12.3178C95.1116 15.1866 96.3296 18.7024 96.3296 22.5C96.3296 26.298 95.1116 29.8134 93.0519 32.6821ZM107.178 0C101.827 0 96.9103 1.89315 93.0519 5.04315C89.1935 1.89315 84.2768 0 78.926 0C73.5751 0 68.6584 1.89315 64.8 5.04315C60.9416 1.89315 56.0244 0 50.674 0C45.3232 0 40.4065 1.89315 36.5481 5.04315C32.6897 1.89315 27.7725 0 22.4221 0C10.0586 0 0 10.0935 0 22.5C0 34.9069 10.0586 45 22.4221 45C27.7725 45 32.6897 43.1073 36.5481 39.9568C40.4065 43.1073 45.3232 45 50.674 45C56.0244 45 60.9416 43.1073 64.8 39.9568C68.6584 43.1073 73.5751 45 78.926 45C84.2768 45 89.1935 43.1073 93.0519 39.9568C96.9103 43.1073 101.827 45 107.178 45C119.541 45 129.6 34.9069 129.6 22.5C129.6 10.0935 119.541 0 107.178 0Z",
      "fill": "white"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "navigation"
  }, [_c('div', {
    staticClass: "nav-title"
  }, [_vm._v("Dashboard")]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "nav flex-column nav-items"
  }, [_c('div', {
    staticClass: "nav-item",
    class: {
      active: _vm.isActiveRoute('/marketreports')
    },
    on: {
      "click": function($event) {
        return _vm.navigate('/marketreports', 'Überblick')
      }
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined"
  }, [_vm._v("dashboard")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v("Überblick")])]), _vm._v(" "), _c('div', {
    staticClass: "nav-item",
    class: {
      active: _vm.isActiveRoute('/wizard')
    },
    on: {
      "click": function($event) {
        return _vm.navigate('/wizard', 'Wizard')
      }
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined"
  }, [_vm._v("auto_fix_high")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v("Wizard")])]), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Clients_ReadAll') && !_vm.globals.currentUserInfo.IsAudiUser) ? _c('div', {
    staticClass: "nav-item",
    class: {
      active: _vm.isActiveRoute('/clientmanagement')
    },
    on: {
      "click": function($event) {
        return _vm.navigate('/clientmanagement', _vm.lang.A0000)
      }
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined"
  }, [_vm._v("contacts_product")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.lang.A0000))])]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Locations_ReadAll')) ? _c('div', {
    staticClass: "nav-item",
    class: {
      active: _vm.isActiveRoute('/locationmanagement')
    },
    on: {
      "click": function($event) {
        return _vm.navigate('/locationmanagement', _vm.lang.A0001)
      }
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined"
  }, [_vm._v("location_on")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.lang.A0001))])]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_SecurityUsers_ReadAll')) ? _c('div', {
    staticClass: "nav-item",
    class: {
      active: _vm.isActiveRoute('/usermanagement')
    },
    on: {
      "click": function($event) {
        return _vm.navigate('/usermanagement', _vm.lang.A0010)
      }
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined"
  }, [_vm._v("group")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.lang.A0010))])]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Projects_ReadAll')) ? _c('div', {
    staticClass: "nav-item",
    class: {
      active: _vm.isActiveRoute('/projectmanagement')
    },
    on: {
      "click": function($event) {
        return _vm.navigate('/projectmanagement', _vm.lang.A0011)
      }
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined"
  }, [_vm._v("folder_open")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.lang.A0011))])]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Agencies_ReadAll') && !_vm.globals.isLocalAgencyUser) ? _c('div', {
    staticClass: "nav-item",
    class: {
      active: _vm.isActiveRoute('/agencymanagement')
    },
    on: {
      "click": function($event) {
        return _vm.navigate('/agencymanagement', _vm.lang.A0012)
      }
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined"
  }, [_vm._v("business")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.lang.A0012))])]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Surveys_ReadAll')) ? _c('div', {
    staticClass: "nav-item",
    class: {
      active: _vm.isActiveRoute('/surveymanagement')
    },
    on: {
      "click": function($event) {
        return _vm.navigate('/surveymanagement', _vm.lang.A0013)
      }
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined"
  }, [_vm._v("quiz")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.lang.A0013))])]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_SurveyInstances_ReadAll') && _vm.globals.currentUserRole < 3) ? _c('div', {
    staticClass: "nav-item",
    class: {
      active: _vm.isActiveRoute('/checkmanagement')
    },
    on: {
      "click": function($event) {
        return _vm.navigate('/checkmanagement', _vm.lang.A0014)
      }
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined"
  }, [_vm._v("checklist")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.lang.A0014))])]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_KPIs_ReadAll')) ? _c('div', {
    staticClass: "nav-item",
    class: {
      active: _vm.isActiveRoute('/kpimanagement')
    },
    on: {
      "click": function($event) {
        return _vm.navigate('/kpimanagement', _vm.lang.A0016)
      }
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined"
  }, [_vm._v("analytics")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.lang.A0016))])]) : _vm._e(), _vm._v(" "), (
    _vm.feature.isEnabled('shoppermanagement') &&
    _vm.globals.isAccessAllowed('LoopOp_Shopper_ReadAll') &&
    !(
      _vm.feature.isAudiTarget &&
      (_vm.globals.isLeadAgencyUser || _vm.globals.isAudiUser)
    )
  ) ? _c('div', {
    staticClass: "nav-item",
    class: {
      active: _vm.isActiveRoute('/shoppermanagement')
    },
    on: {
      "click": function($event) {
        return _vm.navigate('/shoppermanagement', _vm.lang.A0023)
      }
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined"
  }, [_vm._v("person_check")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.lang.A0023))])]) : _vm._e(), _vm._v(" "), (
    _vm.feature.isEnabled('recruiting') &&
    _vm.globals.isAccessAllowed('LoopOp_Recruiting_ReadAll')
  ) ? _c('div', {
    staticClass: "nav-item",
    class: {
      active: _vm.isActiveRoute('/recruiting')
    },
    on: {
      "click": function($event) {
        return _vm.navigate('/recruiting', _vm.lang.A0029)
      }
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined"
  }, [_vm._v("person_search")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.lang.A0029))])]) : _vm._e(), _vm._v(" "), (_vm.feature.isEnabled('shopperApproval') && _vm.globals.currentUserInfo) ? _c('div', {
    staticClass: "nav-item",
    class: {
      active: _vm.isActiveRoute('/shopperapproval')
    },
    on: {
      "click": function($event) {
        return _vm.navigate('/shopperapproval', _vm.lang.A0032)
      }
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined"
  }, [_vm._v("task_alt")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.lang.A0032))])]) : _vm._e()])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1688 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "editAgency",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDialog(false)
      }
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.modeAdd ? _vm.lang.AM3000 : _vm.lang.AM3001))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel-group",
    attrs: {
      "id": "accordion",
      "role": "tablist",
      "aria-multiselectable": "true"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingGeneral",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseGeneral",
      "aria-expanded": "true",
      "aria-controls": "collapseGeneral"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.AM3002))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in",
    attrs: {
      "id": "collapseGeneral",
      "role": "tabpanel",
      "aria-labelledby": "headingGeneral"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputAgencyName"
    }
  }, [_vm._v(_vm._s(_vm.lang.AM3003) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agencyEditModel.AgencyName),
      expression: "agencyEditModel.AgencyName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputAgencyName",
      "name": "inputAgencyName",
      "required": ""
    },
    domProps: {
      "value": (_vm.agencyEditModel.AgencyName)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputAgencyName')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agencyEditModel, "AgencyName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputAgencyName')),
      expression: "inputHasError('inputAgencyName')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.AM3014))])])]), _vm._v(" "), (
    _vm.feature.isAudiTarget &&
    _vm.feature.isEnabled('leadAgencies') &&
    !_vm.globals.isAgencyUser
  ) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(_vm._s(_vm.lang.AM3015))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 text-left"
  }, _vm._l((_vm.agencyTypeList), function(type) {
    return _c('div', {
      key: type.AgencyTypeGuid,
      staticClass: "radio"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.agencyEditModel.AgencyTypeGuid),
        expression: "agencyEditModel.AgencyTypeGuid"
      }],
      attrs: {
        "type": "radio",
        "name": "editAgencyTypeRadios",
        "disabled": _vm.globals.currentUserInfo.AgencyGuid ===
          _vm.agencyEditModel.AgencyGuid
      },
      domProps: {
        "value": type.AgencyTypeGuid,
        "checked": _vm._q(_vm.agencyEditModel.AgencyTypeGuid, type.AgencyTypeGuid)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.agencyEditModel, "AgencyTypeGuid", type.AgencyTypeGuid)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "text text-primary"
    }, [_vm._v(_vm._s(type.AgencyTypeName))]), _vm._v(" "), _c('span', {
      staticClass: "circle"
    }), _vm._v(" "), _c('span', {
      staticClass: "check"
    })])])
  }), 0)]) : _vm._e(), _vm._v(" "), (
    _vm.feature.isAudiTarget &&
    _vm.feature.isEnabled('leadAgencies') &&
    _vm.agencyEditModel.AgencyTypeGuid === _vm.localAgencyTypeGuid
  ) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "editAgencyParentSelect"
    }
  }, [_vm._v(_vm._s(_vm.lang.AM3016) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "editAgencyParentSelect",
      "disabled": _vm.globals.currentUserInfo.AgencyGuid ===
        _vm.agencyEditModel.AgencyGuid || _vm.globals.isAgencyUser,
      "required": ""
    },
    model: {
      value: (_vm.agencyEditModel.ParentAgency),
      callback: function($$v) {
        _vm.$set(_vm.agencyEditModel, "ParentAgency", $$v)
      },
      expression: "agencyEditModel.ParentAgency"
    }
  }, _vm._l((_vm.leadAgencyList), function(agency) {
    return _c('option', {
      key: agency.AgencyGuid,
      domProps: {
        "value": agency.AgencyGuid
      }
    }, [_vm._v("\n                        " + _vm._s(agency.AgencyName) + "\n                      ")])
  }), 0)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputAgencyStreet"
    }
  }, [_vm._v(_vm._s(_vm.lang.AM3004))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agencyEditModel.AgencyAddress),
      expression: "agencyEditModel.AgencyAddress"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputAgencyStreet",
      "name": "inputAgencyStreet"
    },
    domProps: {
      "value": (_vm.agencyEditModel.AgencyAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agencyEditModel, "AgencyAddress", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputAgencyStreet2"
    }
  }, [_vm._v(_vm._s(_vm.lang.AM3012))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agencyEditModel.AgencyAddress2),
      expression: "agencyEditModel.AgencyAddress2"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputAgencyStreet2",
      "name": "inputAgencyStreet2"
    },
    domProps: {
      "value": (_vm.agencyEditModel.AgencyAddress2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agencyEditModel, "AgencyAddress2", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputAgencyCity"
    }
  }, [_vm._v(_vm._s(_vm.lang.AM3005))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agencyEditModel.AgencyCity),
      expression: "agencyEditModel.AgencyCity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputAgencyCity",
      "name": "inputAgencyCity"
    },
    domProps: {
      "value": (_vm.agencyEditModel.AgencyCity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agencyEditModel, "AgencyCity", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputAgencyZip"
    }
  }, [_vm._v(_vm._s(_vm.lang.AM3006))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agencyEditModel.AgencyPostalCode),
      expression: "agencyEditModel.AgencyPostalCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputAgencyZip",
      "name": "inputAgencyZip"
    },
    domProps: {
      "value": (_vm.agencyEditModel.AgencyPostalCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agencyEditModel, "AgencyPostalCode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "editAgencyCountrySelect"
    }
  }, [_vm._v(_vm._s(_vm.lang.AM3007))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "editAgencyCountrySelect",
      "placeholder": _vm.lang.AM3013,
      "allowClear": true
    },
    on: {
      "change": function($event) {
        return _vm.countryChanged(true)
      }
    },
    model: {
      value: (_vm.agencyEditModel.AgencyCountry),
      callback: function($$v) {
        _vm.$set(_vm.agencyEditModel, "AgencyCountry", $$v)
      },
      expression: "agencyEditModel.AgencyCountry"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.globals.countryList), function(country, ISOCode) {
    return _c('option', {
      key: ISOCode,
      domProps: {
        "value": ISOCode
      }
    }, [_vm._v("\n                        " + _vm._s(country) + "\n                      ")])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "editAgencyRegionSelect"
    }
  }, [_vm._v(_vm._s(_vm.lang.AM3011))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    ref: "editAgencyRegionSelect",
    staticClass: "form-control",
    attrs: {
      "id": "editAgencyRegionSelect",
      "disabled": !_vm.agencyEditModel.AgencyCountry ||
        _vm.regionsOfCountry.length < 1,
      "placeholder": _vm.lang.AM3013,
      "allowClear": true
    },
    model: {
      value: (_vm.agencyEditModel.AgencyState_Region),
      callback: function($$v) {
        _vm.$set(_vm.agencyEditModel, "AgencyState_Region", $$v)
      },
      expression: "agencyEditModel.AgencyState_Region"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.regionsOfCountry), function(region) {
    return _c('option', {
      key: region.Region,
      domProps: {
        "value": region.Region
      }
    }, [_vm._v("\n                        " + _vm._s(region.RegionName) + "\n                      ")])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputAgencySince"
    }
  }, [_vm._v(_vm._s(_vm.lang.AM3008))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10",
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr('inputAgencySince')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agencyEditModel.AgencySince),
      expression: "agencyEditModel.AgencySince"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "id": "inputAgencySince",
      "name": "inputAgencySince"
    },
    domProps: {
      "value": (_vm.agencyEditModel.AgencySince)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agencyEditModel, "AgencySince", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDialog(false)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.AM3009) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "id": "agency-management-edit-modal-save-button",
      "type": "button",
      "disabled": !_vm.globals.isAccessAllowed('LoopOp_Agencies_Update')
    },
    on: {
      "click": function($event) {
        return _vm.validateBeforeSubmit('editAgency')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.AM3010) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 1689 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "elementHistoryModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), (_vm.elementId) ? _c('label', {
    staticClass: "control-label nopadding"
  }, [_vm._v("ID: " + _vm._s(_vm.elementId))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "element-history-modal-content"
  }, [(_vm.history.length > 0) ? _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.HIS000) + "\n                ")]), _vm._v(" "), _c('th', {
    staticClass: "text-left",
    staticStyle: {
      "width": "70%"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.HIS001) + "\n                ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.history), function(entry) {
    return _c('tr', {
      key: entry.SurveyInstanceHistoryGuid
    }, [_c('td', {
      staticClass: "text-left"
    }, [_c('b', [_vm._v(_vm._s(entry.EntryCreatedByDisplayName))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "entry-creation-timestamp"
    }, [_vm._v(_vm._s(_vm.globals.getLocalizedDateTimeFromUtcIsoTimestamp(
      entry.EntryCreatedAt
    )))])]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(entry.Message))])])
  }), 0)]) : _c('span', [_vm._v(_vm._s(_vm.lang.HIS002))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.HIS003) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 1690 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    staticClass: "select2-control hidden"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 1691 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.globals.isAccessAllowed('LoopOp_Locations_ReadAll')) ? _c('div', [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "locations-top-panel"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "location-management-refresh-button",
      "disabled": !_vm.refreshEnabled
    },
    on: {
      "click": function($event) {
        return _vm.getLocationData()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("refresh")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.L0000) + "\n        ")]), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Locations_Create')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "location-management-create-button"
    },
    on: {
      "click": function($event) {
        (_vm.selectedLocation = -1),
        (_vm.selectedLocationGuid = ''),
        (_vm.showEditLocationModal = true)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("add_box")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.L0001) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Locations_Read')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "location-management-edit-button",
      "disabled": _vm.selectedLocation == -1
    },
    on: {
      "click": function($event) {
        _vm.showEditLocationModal = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("edit")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.L0002) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Locations_Delete')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "location-management-delete-button",
      "disabled": _vm.selectedLocation == -1
    },
    on: {
      "click": function($event) {
        return _vm.openDeleteLocationDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("clear")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.L0003) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Locations_Update')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.selectedLocationGuid
    },
    on: {
      "click": function($event) {
        _vm.showLocationDataTranslateModal = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("language")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.L0091) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_LocationsExport_Read')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    on: {
      "click": function($event) {
        _vm.showLocationExportModal = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("pin_drop")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.L0087) + "\n        ")]) : _vm._e(), _vm._v(" "), (
    _vm.globals.isAccessAllowed('LoopOp_LocationsImport_Create') &&
    _vm.globals.isAccessAllowed('LoopOp_LocationsImport_Read')
  ) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    on: {
      "click": function($event) {
        _vm.showLocationImportDataModal = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("add_location")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.L0086) + "\n        ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-lg-7"
  }, [_c('div', {
    staticClass: "form-group searchbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Search),
      expression: "filterStrings.Search"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "search",
      "id": "inputSearch",
      "placeholder": _vm.lang.L0005
    },
    domProps: {
      "value": (_vm.filterStrings.Search)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Search", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5 nopadding"
  }, [_c('ul', {
    staticClass: "pagination-fonts pagination btn-group"
  }, [_c('li', [_vm._m(0), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "elementsPerPageDropdown",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.L0006))]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 20
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 20)
      }
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 50
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 50)
      }
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 100
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 100)
      }
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 200
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 200)
      }
    }
  }, [_vm._v("200")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 500
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 500)
      }
    }
  }, [_vm._v("500")])])])], 1), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.pageCount || _vm.selectedPage == 1
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 0)
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "firstPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.L0007))])], 1), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage > 4) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getVisiblePages()), function(pageNumber) {
    return _c('li', {
      key: pageNumber,
      class: {
        active: _vm.selectedPage == pageNumber
      },
      on: {
        "click": function($event) {
          return _vm.updatePaging(pageNumber, 0)
        }
      }
    }, [_c('a', {
      attrs: {
        "role": "button"
      }
    }, [_vm._v(_vm._s(pageNumber))])])
  }), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage < _vm.pageCount - 3) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.pageCount || _vm.selectedPage == _vm.pageCount,
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(_vm.pageCount, 0)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "lastPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.L0008))])], 1), _vm._v(" "), _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button",
      "id": "locationsTotalElementsCounter"
    }
  }, [_vm._v(_vm._s(_vm.totalElementsCount))]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "locationsTotalElementsCounter",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.L0089))])], 1)], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    staticClass: "table table-striped table-hover main-table"
  }, [_c('thead', [_c('tr', [(
    !_vm.feature.isAudiTarget || !_vm.feature.isEnabled('audi_importers')
  ) ? _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "6%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortLocationData('ClientId')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.L0077) + "\n                "), (_vm.sortField == 'ClientId' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'ClientId' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (
    !_vm.feature.isAudiTarget || !_vm.feature.isEnabled('audi_importers')
  ) ? _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "18%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortLocationData('ClientName')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.L0009) + "\n                "), (_vm.sortField == 'ClientName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'ClientName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "18%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortLocationData('ImporterName')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.L0088) + "\n                "), (_vm.sortField == 'ImporterName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'ImporterName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "7%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortLocationData('LocationStoreId')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.L0010) + "\n                "), (_vm.sortField == 'LocationStoreId' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'LocationStoreId' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "22%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortLocationData('LocationName')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.L0011) + "\n                "), (_vm.sortField == 'LocationName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'LocationName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    style: (("width:" + (_vm.feature.isAudiTarget && _vm.feature.isEnabled('audi_importers')
                  ? '29'
                  : '23') + "%;"))
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortLocationData('LocationAddress')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.L0012) + "\n                "), (_vm.sortField == 'LocationAddress' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'LocationAddress' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "9%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortLocationData('LocationCity')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.L0013) + "\n                "), (_vm.sortField == 'LocationCity' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'LocationCity' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortLocationData('LocationPostalCode')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.L0015) + "\n                "), (
    _vm.sortField == 'LocationPostalCode' && _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'LocationPostalCode' && _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortLocationData('LocationCountry')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.L0016) + "\n                "), (_vm.sortField == 'LocationCountry' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'LocationCountry' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortLocationData('LocationStatusId')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.L0019) + "\n                "), (_vm.sortField == 'LocationStatusId' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'LocationStatusId' && _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])])]), _vm._v(" "), _c('tr', {
    staticClass: "table-filters"
  }, [(
    !_vm.feature.isAudiTarget || !_vm.feature.isEnabled('audi_importers')
  ) ? _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "6%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ClientId),
      expression: "filterStrings.ClientId"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.L0020
    },
    domProps: {
      "value": (_vm.filterStrings.ClientId)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ClientId", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (
    !_vm.feature.isAudiTarget || !_vm.feature.isEnabled('audi_importers')
  ) ? _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "18%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ClientName),
      expression: "filterStrings.ClientName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.L0020
    },
    domProps: {
      "value": (_vm.filterStrings.ClientName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ClientName", $event.target.value)
      }
    }
  })])]) : _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "18%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ImporterName),
      expression: "filterStrings.ImporterName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.L0020
    },
    domProps: {
      "value": (_vm.filterStrings.ImporterName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ImporterName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "7%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationStoreId),
      expression: "filterStrings.LocationStoreId"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.L0020
    },
    domProps: {
      "value": (_vm.filterStrings.LocationStoreId)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationStoreId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "22%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationName),
      expression: "filterStrings.LocationName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.L0020
    },
    domProps: {
      "value": (_vm.filterStrings.LocationName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    style: (("width:" + (_vm.feature.isAudiTarget && _vm.feature.isEnabled('audi_importers')
                  ? '29'
                  : '23') + "%;"))
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationAddress),
      expression: "filterStrings.LocationAddress"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.L0020
    },
    domProps: {
      "value": (_vm.filterStrings.LocationAddress)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationAddress", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "9%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationCity),
      expression: "filterStrings.LocationCity"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.L0020
    },
    domProps: {
      "value": (_vm.filterStrings.LocationCity)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationCity", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationPostalCode),
      expression: "filterStrings.LocationPostalCode"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.L0020
    },
    domProps: {
      "value": (_vm.filterStrings.LocationPostalCode)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationPostalCode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationCountry),
      expression: "filterStrings.LocationCountry"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.L0020
    },
    domProps: {
      "value": (_vm.filterStrings.LocationCountry)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationCountry", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationStatusId),
      expression: "filterStrings.LocationStatusId"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.L0020
    },
    domProps: {
      "value": (_vm.filterStrings.LocationStatusId)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationStatusId", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('tbody', {
    staticClass: "main-table-scrollbar"
  }, _vm._l((_vm.locationData), function(location) {
    return _c('tr', {
      key: location.LocationId,
      class: {
        info: location.LocationId == _vm.selectedLocation,
        'location-inactive': location.LocationStatusId === 'X',
        'location-temp-inactive': location.LocationStatusId === 'T',
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          (_vm.selectedLocation = location.LocationId),
          (_vm.selectedLocationGuid = location.LocationGuid)
        },
        "dblclick": function($event) {
          _vm.globals.isAccessAllowed('LoopOp_Locations_Read') &&
            (_vm.showEditLocationModal = true)
        }
      }
    }, [(
      !_vm.feature.isAudiTarget || !_vm.feature.isEnabled('audi_importers')
    ) ? _c('td', {
      staticStyle: {
        "width": "6%"
      }
    }, [_vm._v("\n              " + _vm._s(location.ClientId) + "\n            ")]) : _vm._e(), _vm._v(" "), (
      !_vm.feature.isAudiTarget || !_vm.feature.isEnabled('audi_importers')
    ) ? _c('td', {
      staticStyle: {
        "width": "18%"
      }
    }, [_vm._v("\n              " + _vm._s(location.ClientName) + "\n            ")]) : _c('td', {
      staticStyle: {
        "width": "18%"
      }
    }, [_vm._v(_vm._s(location.ImporterName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7%"
      }
    }, [_vm._v(_vm._s(location.LocationStoreId))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "22%"
      }
    }, [_vm._v(_vm._s(location.LocationName))]), _vm._v(" "), _c('td', {
      style: (("width:" + (_vm.feature.isAudiTarget && _vm.feature.isEnabled('audi_importers')
                  ? '29'
                  : '23') + "%;"))
    }, [_vm._v("\n              " + _vm._s(location.LocationAddress) + "\n            ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "9%"
      }
    }, [_vm._v(_vm._s(location.LocationCity))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [_vm._v(_vm._s(location.LocationPostalCode))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [_vm._v(_vm._s(location.LocationCountry))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [_vm._v(_vm._s(location.LocationStatusId))])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "deleteLocation",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.L0060))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.lang.L0061))])]), _vm._v(" "), (
    !_vm.feature.isAudiTarget || !_vm.feature.isEnabled('audi_importers')
  ) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 text-black"
  }, [_vm._v(_vm._s(_vm.lang.L0062))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-10 text-black"
  }, [_vm._v(_vm._s(_vm.deleteLocationDialogData.ClientName))])]) : _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 text-black"
  }, [_vm._v(_vm._s(_vm.lang.L0088))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-10 text-black"
  }, [_vm._v(_vm._s(_vm.deleteLocationDialogData.ImporterName))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 text-black"
  }, [_vm._v(_vm._s(_vm.lang.L0063))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-10 text-black"
  }, [_vm._v(_vm._s(_vm.deleteLocationDialogData.LocationStoreId))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 text-black"
  }, [_vm._v(_vm._s(_vm.lang.L0064))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-10 text-black"
  }, [_vm._v(_vm._s(_vm.deleteLocationDialogData.LocationName))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 text-black"
  }, [_vm._v(_vm._s(_vm.lang.L0065))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-10 text-black"
  }, [_vm._v(_vm._s(_vm.deleteLocationDialogData.LocationAddress))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 text-black"
  }, [_vm._v(_vm._s(_vm.lang.L0066))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-10 text-black"
  }, [_vm._v(_vm._s(_vm.deleteLocationDialogData.LocationCity))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 text-black"
  }, [_vm._v(_vm._s(_vm.lang.L0068))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-10 text-black"
  }, [_vm._v(_vm._s(_vm.deleteLocationDialogData.LocationPostalCode))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 text-black"
  }, [_vm._v(_vm._s(_vm.lang.L0069))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-10 text-black"
  }, [_vm._v(_vm._s(_vm.deleteLocationDialogData.LocationCountry))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 text-black"
  }, [_vm._v(_vm._s(_vm.lang.L0072))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-10 text-black"
  }, [_vm._v(_vm._s(_vm.deleteLocationDialogData.LocationStatusId))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "id": "location-management-delete-false-button",
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.L0073) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-warning",
    attrs: {
      "id": "location-management-delete-true-button",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.deleteLocationData()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.L0074) + "\n          ")])])])])]), _vm._v(" "), _c('LocationImportDataModal', {
    attrs: {
      "showModal": _vm.showLocationImportDataModal
    },
    on: {
      "modalClosed": function($event) {
        _vm.showLocationImportDataModal = false
      }
    }
  }), _vm._v(" "), _c('LocationExportModal', {
    attrs: {
      "showModal": _vm.showLocationExportModal
    },
    on: {
      "modalClosed": function($event) {
        _vm.showLocationExportModal = false
      }
    }
  }), _vm._v(" "), _c('LocationManagementEditModal', {
    attrs: {
      "showModal": _vm.showEditLocationModal,
      "selectedLocation": _vm.selectedLocation,
      "lang": _vm.lang
    },
    on: {
      "modalClosed": function($event) {
        _vm.showEditLocationModal = false
      },
      "locationDataUpdated": _vm.onLocationDataUpdated
    }
  }), _vm._v(" "), _c('LocationDataTranslateModal', {
    attrs: {
      "showModal": _vm.showLocationDataTranslateModal,
      "selectedLocation": _vm.selectedLocationGuid,
      "selectedLocationId": _vm.selectedLocation
    },
    on: {
      "modalClosed": function($event) {
        _vm.showLocationDataTranslateModal = false
      }
    }
  })], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "role": "button",
      "data-toggle": "dropdown",
      "id": "elementsPerPageDropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("view_headline")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "firstPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("first_page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "lastPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("last_page")])])
}]}

/***/ }),
/* 1692 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "gantt"
  })
},staticRenderFns: []}

/***/ }),
/* 1693 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (
        _vm.globals.isAccessAllowed('LoopOp_Surveys_Read') &&
        _vm.globals.isAccessAllowed('LoopOp_Surveys_Update')
      ),
      expression: "\n      globals.isAccessAllowed('LoopOp_Surveys_Read') &&\n      globals.isAccessAllowed('LoopOp_Surveys_Update')\n    "
    }],
    attrs: {
      "id": "surveyEditorContainer"
    }
  }), _vm._v(" "), _c('svg', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('symbol', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "id": "icon-actionsecurity"
    }
  }, [_c('path', {
    attrs: {
      "d": "M18 10v-4c0-3.313-2.687-6-6-6s-6 2.687-6 6v4h-3v14h18v-14h-3zm-5 7.723v2.277h-2v-2.277c-.595-.347-1-.984-1-1.723 0-1.104.896-2 2-2s2 .896 2 2c0 .738-.404 1.376-1 1.723zm-5-7.723v-4c0-2.206 1.794-4 4-4 2.205 0 4 1.794 4 4v4h-8z"
    }
  })])]), _vm._v(" "), (_vm.selectedSurveyElement && _vm.surveyElementSecurityModalVisible) ? _c('SurveyElementSecurityModal', {
    attrs: {
      "modalVisible": _vm.surveyElementSecurityModalVisible,
      "surveyElement": _vm.selectedSurveyElement,
      "surveyData": _vm.surveyData,
      "surveyId": _vm.surveyId
    },
    on: {
      "saveSecuritySettings": _vm.saveSurveyElementSecuritySettings,
      "closeModal": function($event) {
        _vm.surveyElementSecurityModalVisible = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1694 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.feature.isEnabled('recruiting')) ? _c('div', [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "recruitingMainPanel"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-7",
    attrs: {
      "id": "mapContainer"
    }
  }, [_c('GoogleMaps', {
    ref: "recruitingGmaps",
    attrs: {
      "checkList": _vm.checkFilterResults.SurveyInstances,
      "shopperList": _vm.shopperFilterResults.Shoppers,
      "currentFilterObject": _vm.currentFilterObject
    },
    on: {
      "mapRadiusChanged": _vm.updateMapRadius,
      "markerInfoSelectButtonClicked": _vm.onCheckSelectionChanged
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5",
    attrs: {
      "id": "checkFilterContainer"
    }
  }, [_c('CheckFilter', {
    ref: "checkFilterRef",
    attrs: {
      "currentFilterObject": _vm.currentFilterObject,
      "locationPropertiesList": _vm.locationPropertiesList,
      "countryList": _vm.countryList
    },
    on: {
      "checkDataChanged": _vm.onCheckDataChanged,
      "filterUpdate": _vm.updateCheckFilter,
      "requestLocationProperties": _vm.getLocationProperties
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5",
    attrs: {
      "id": "shopperFilterContainer"
    }
  }, [_c('ShopperFilter', {
    ref: "shopperFilterRef",
    attrs: {
      "currentFilterObject": _vm.currentFilterObject,
      "locationPropertiesList": _vm.locationPropertiesList,
      "countryList": _vm.countryList
    },
    on: {
      "shopperDataChanged": _vm.onShopperDataChanged,
      "filterUpdate": _vm.updateShopperFilter
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 text-right",
    attrs: {
      "id": "buttonBarContainer"
    }
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default btn-grey pull-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clearFilters()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.RC004) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-default btn-success",
    attrs: {
      "type": "button",
      "disabled": !_vm.checkFilterResults.SurveyInstanceCount &&
        !_vm.shopperFilterResults.ShopperCount
    },
    on: {
      "click": function($event) {
        _vm.$refs.recruitingGmaps.showChecksOnMap(),
          _vm.$refs.recruitingGmaps.showShoppersOnMap()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.RC000) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-default dialog-btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.isExportDisabled
    },
    on: {
      "click": function($event) {
        return _vm.exportResults()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.RC001) + "\n        ")])])])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1695 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "approvalWaveStatusModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.AWS000))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(_vm._s(_vm.lang.AWS001) + " / " + _vm._s(_vm.lang.AWS002))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.lang.AWS003,
      "allowClear": true
    },
    on: {
      "change": function($event) {
        _vm.selectedWave = ''
      }
    },
    model: {
      value: (_vm.selectedProject),
      callback: function($$v) {
        _vm.selectedProject = $$v
      },
      expression: "selectedProject"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.projectsWaves), function(project) {
    return _c('option', {
      key: project.ProjectGuid,
      domProps: {
        "value": project.ProjectGuid
      }
    }, [_vm._v("\n                " + _vm._s(project.ProjectName) + "\n              ")])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('select2', {
    ref: "waveSelect",
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.lang.AWS004,
      "allowClear": true,
      "disabled": !_vm.selectedProject
    },
    on: {
      "change": function($event) {
        return _vm.getWaveStatus()
      }
    },
    model: {
      value: (_vm.selectedWave),
      callback: function($$v) {
        _vm.selectedWave = $$v
      },
      expression: "selectedWave"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.availableWaves), function(wave) {
    return _c('option', {
      key: wave.WaveGuid,
      domProps: {
        "value": wave.WaveGuid
      }
    }, [_vm._v("\n                " + _vm._s(wave.WaveName) + "\n              ")])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Approval Status")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('select2', {
    ref: "approvalStatusSelect",
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.lang.AWS036,
      "allowClear": true
    },
    on: {
      "change": function($event) {
        return _vm.getWaveStatus()
      }
    },
    model: {
      value: (_vm.selectedApprovalStatus),
      callback: function($$v) {
        _vm.selectedApprovalStatus = $$v
      },
      expression: "selectedApprovalStatus"
    }
  }, [_c('option', {
    attrs: {
      "value": "approved"
    }
  }, [_vm._v("Approved")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "none"
    }
  }, [_vm._v("None")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "open"
    }
  }, [_vm._v("Open")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [(_vm.selectedWave && _vm.statusData.SurveyInstances) ? _c('table', {
    staticClass: "table outer-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [(_vm.statusData.SurveyInstances && _vm.statusData.SurveyInstances.Status) ? _c('tr', [_c('td', {
    staticClass: "text-left noborder"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.AWS005))])]), _vm._v(" "), _c('td', {
    staticClass: "text-left noborder"
  }, [_c('table', {
    staticClass: "table table-hover",
    staticStyle: {
      "width": "66.67%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.AWS006))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.statusData.SurveyInstances.Status.Count))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.AWS007))]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(_vm.statusData.SurveyInstances.Status.Approval) + "\n                        ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.AWS008))]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(_vm.statusData.SurveyInstances.Status.InProgress) + "\n                        ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.AWS009))]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(_vm.statusData.SurveyInstances.Status.Reporting) + "\n                        ")])]), _vm._v(" "), (_vm.statusData.Wave) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.AWS010))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Number((_vm.statusData.Wave.InTime * 100).toFixed(2))) + " %")])]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.statusData.Approvals) ? _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.AWS011))])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('table', {
    staticClass: "table table-hover",
    staticStyle: {
      "width": "66.67%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.AWS012))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Number((_vm.statusData.Approvals.None * 100).toFixed(2))) + " %")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.AWS013))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Number((_vm.statusData.Approvals.Open * 100).toFixed(2))) + " %")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.AWS014))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Number((_vm.statusData.Approvals.Approved * 100).toFixed(2))) + " %")])])])])])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.AWS015))])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('tbody', [(_vm.statusData.Shopper.Gender) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.AWS016))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.lang.AWS017) + ":")]), _vm._v("\n                          " + _vm._s(Number((_vm.statusData.Shopper.Gender.Male * 100).toFixed(2))) + " %\n                        ")]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.lang.AWS018) + ":")]), _vm._v("\n                          " + _vm._s(Number((_vm.statusData.Shopper.Gender.Female * 100).toFixed(2))) + " %\n                        ")]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Divers:")]), _vm._v("\n                          " + _vm._s(Number((_vm.statusData.Shopper.Gender.Divers * 100).toFixed(2))) + " %\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.statusData.Shopper.Age) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.AWS019))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.lang.AWS020) + ":")]), _vm._v("\n                          " + _vm._s(_vm.statusData.Shopper.Age.Min) + "\n                        ")]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.lang.AWS021) + ":")]), _vm._v("\n                          " + _vm._s(_vm.statusData.Shopper.Age.Max) + "\n                        ")]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.lang.AWS022) + ":")]), _vm._v("\n                          " + _vm._s(Number((_vm.statusData.Shopper.Age.Above70 * 100).toFixed(2))) + " %\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.statusData.Shopper.Distance) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.AWS023))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.lang.AWS020) + ":")]), _vm._v("\n                          " + _vm._s((_vm.statusData.Shopper.Distance.Min / 1000).toFixed(0)) + " km\n                        ")]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.lang.AWS021) + ":")]), _vm._v("\n                          " + _vm._s((_vm.statusData.Shopper.Distance.Max / 1000).toFixed(0)) + " km\n                        ")]), _vm._v(" "), _c('td')]) : _vm._e(), _vm._v(" "), (_vm.statusData.Shopper.Car) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.AWS024))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.lang.AWS020) + ":")]), _vm._v("\n                          " + _vm._s(_vm.statusData.Shopper.Car.YearOfBuild.Min) + "\n                        ")]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.lang.AWS021) + ":")]), _vm._v("\n                          " + _vm._s(_vm.statusData.Shopper.Car.YearOfBuild.Max) + "\n                        ")]), _vm._v(" "), _c('td')]) : _vm._e(), _vm._v(" "), (_vm.statusData.Model) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.AWS025) + " (-|=|+)")]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.lang.AWS026) + ":")]), _vm._v("\n                          " + _vm._s(Number((_vm.statusData.Model.Downgrade * 100).toFixed(2))) + " %\n                        ")]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.lang.AWS027) + ":")]), _vm._v("\n                          " + _vm._s(Number((_vm.statusData.Model.Match * 100).toFixed(2))) + " %\n                        ")]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.lang.AWS028) + ":")]), _vm._v("\n                          " + _vm._s(Number((_vm.statusData.Model.Upgrade * 100).toFixed(2))) + " %\n                        ")])]) : _vm._e()])])])]), _vm._v(" "), (_vm.statusData.CarDistribution) ? _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.AWS029))])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.lang.AWS030))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS031))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS032))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS026))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS028))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS027))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.statusData.CarDistribution), function(model, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(model.CarModelName))]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(Number((model.SetValue * 100).toFixed(2))) + " %\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(Number((model.ActualValue * 100).toFixed(2))) + " % (" + _vm._s(model.ApprovedCarCount) + ")\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(Number((model.ApprovedCarCountDowngrade_percentage * 100).toFixed(2))) + " %\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(Number((model.ApprovedCarCountMatch_percentage * 100).toFixed(2))) + " %\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(Number((model.ApprovedCarCountUpgrade_percentage * 100).toFixed(2))) + " %\n                        ")])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.statusData.CompetitorCarDistribution) ? _vm._l((_vm.getGroupedCompetitorCars()), function(competitorCarDistribution, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-left"
    }, [_c('b', [_vm._v(_vm._s(competitorCarDistribution[0]) + " " + _vm._s(_vm.lang.AWS033))])]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_c('table', {
      staticClass: "table table-hover"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.lang.AWS030))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS031))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS032))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS026))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS028))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS027))])])]), _vm._v(" "), _c('tbody', _vm._l((competitorCarDistribution[1]), function(model, index) {
      return _c('tr', {
        key: index
      }, [_c('td', [_vm._v(_vm._s(model.CompetitorCarModel))]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(Number((model.SetValue * 100).toFixed(2))) + " %\n                          ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(Number((model.ActualValue * 100).toFixed(2))) + " % (" + _vm._s(model.ApprovedCarCount) + ")\n                          ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(Number((model.ApprovedCarCountDowngrade_percentage * 100).toFixed(2))) + " %\n                          ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(Number((model.ApprovedCarCountMatch_percentage * 100).toFixed(2))) + " %\n                          ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(Number((model.ApprovedCarCountUpgrade_percentage * 100).toFixed(2))) + " %\n                          ")])])
    }), 0)])])])
  }) : _vm._e()], 2)]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.AWS034) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "nopadding noborder",
    staticStyle: {
      "width": "30%"
    }
  }), _vm._v(" "), _c('th', {
    staticClass: "nopadding noborder",
    staticStyle: {
      "width": "70%"
    }
  })])])
}]}

/***/ }),
/* 1696 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "shopperApprovalModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.SAM000))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SAM003) + "\n                ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SAM004) + "\n                ")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [(!(_vm.globals.isLeadAgencyUser && _vm.allChecksAreLeadAgencyPlus && _vm.userAgencyEqualsCheckAgency)) ? _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.leadAgencyApproval),
      expression: "leadAgencyApproval"
    }],
    staticClass: "form-control",
    class: {
      'option-green': _vm.leadAgencyApproval === 'Approved',
      'option-red': _vm.leadAgencyApproval === 'Rejected',
      'option-yellow': _vm.leadAgencyApproval === undefined,
    },
    attrs: {
      "disabled": _vm.highestSurveyInstanceStatusId > 200
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.leadAgencyApproval = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.updateApprovalState('leadAgency')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }), _vm._v(" "), _c('option', {
    staticClass: "option-green",
    domProps: {
      "value": 'Approved'
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.SAM022) + "\n                      ")]), _vm._v(" "), _c('option', {
    staticClass: "option-yellow",
    domProps: {
      "value": undefined
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.SAM023) + "\n                      ")]), _vm._v(" "), _c('option', {
    staticClass: "option-red",
    domProps: {
      "value": 'Rejected'
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.SAM024) + "\n                      ")])])]) : _vm._e()]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mainEntityApproval),
      expression: "mainEntityApproval"
    }],
    staticClass: "form-control",
    class: {
      'option-green': _vm.mainEntityApproval === 'Approved',
      'option-red': _vm.mainEntityApproval === 'Rejected',
      'option-yellow': _vm.mainEntityApproval === undefined,
    },
    attrs: {
      "disabled": !(_vm.globals.isAdminUser || _vm.globals.isAudiUser || (_vm.globals.isLeadAgencyUser && _vm.allChecksAreLeadAgencyPlus && _vm.userAgencyEqualsCheckAgency)) || _vm.highestSurveyInstanceStatusId > 200
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.mainEntityApproval = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.updateApprovalState('mainEntity')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }), _vm._v(" "), _c('option', {
    staticClass: "option-green",
    domProps: {
      "value": 'Approved'
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.SAM022) + "\n                      ")]), _vm._v(" "), _c('option', {
    staticClass: "option-yellow",
    domProps: {
      "value": undefined
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.SAM023) + "\n                      ")]), _vm._v(" "), _c('option', {
    staticClass: "option-red",
    domProps: {
      "value": 'Rejected'
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.SAM024) + "\n                      ")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.SAM025) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 1697 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "feedModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.FEE000))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "feed-modal-content"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newFeedPostContent),
      expression: "newFeedPostContent"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "inputNewFeedPost",
      "rows": "3",
      "maxlength": "1000",
      "placeholder": _vm.lang.FEE001
    },
    domProps: {
      "value": (_vm.newFeedPostContent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newFeedPostContent = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "disabled": !_vm.newFeedPostContent
    },
    on: {
      "click": function($event) {
        return _vm.addFeedPost()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.FEE002) + "\n              ")])])]), _vm._v(" "), (_vm.currentFeedPosts.length < 1) ? _c('div', [_vm._v(_vm._s(_vm.lang.FEE003))]) : _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.FEE004) + "\n                ")]), _vm._v(" "), _c('th', {
    staticClass: "text-left",
    staticStyle: {
      "width": "70%"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.FEE005) + "\n                ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.currentFeedPosts), function(post) {
    return _c('tr', {
      key: post.FeedPostGuid
    }, [_c('td', {
      staticClass: "text-left"
    }, [_c('b', [_vm._v(_vm._s(post.FeedPostCreatedBy.Lastname) + ",\n                    " + _vm._s(post.FeedPostCreatedBy.Firstname))]), _vm._v("\n                  -\n                  "), _c('span', {
      class: {
        'text-red text-bold': post.FeedPostCreatedBy.Username ===
          _vm.globals.currentUserName,
      }
    }, [_vm._v(_vm._s(post.FeedPostCreatedBy.Username))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "post-creation-timestamp"
    }, [_vm._v(_vm._s(_vm.globals.getLocalizedDateTimeFromUtcIsoTimestamp(
      post.FeedPostCreatedAt
    )))])]), _vm._v(" "), _c('td', {
      staticClass: "text-left",
      domProps: {
        "innerHTML": _vm._s(_vm.addContentHighlighting(post.Content))
      }
    })])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.FEE006) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 1698 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "import-top-panel"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.noErrors && _vm.selectedRowNumbers.length == 0
    },
    on: {
      "click": function($event) {
        return _vm.saveImportData()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("check")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.I0000) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": _vm.noErrors
    },
    on: {
      "click": function($event) {
        return _vm.validateImportData()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("redo")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.I0001) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    on: {
      "click": function($event) {
        return _vm.cancelLocationImport()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("clear")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.I0002) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "well col-md-2 well-counter"
  }, [_vm._v("\n        " + _vm._s(_vm.lang.I0033) + ": " + _vm._s(_vm.selectedRowNumbers.length) + "\n        "), _c('br'), _vm._v("\n        " + _vm._s(_vm.lang.I0034) + ": " + _vm._s(_vm.serverResponse.Error_Counter) + "\n        "), _c('br'), _vm._v("\n        " + _vm._s(_vm.lang.I0035) + ": " + _vm._s(_vm.serverResponse.Updated_Counter) + "\n        "), _c('br'), _vm._v("\n        " + _vm._s(_vm.lang.I0036) + ": " + _vm._s(_vm.serverResponse.Inserted_Counter) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-top-bar color-error",
    on: {
      "click": function($event) {
        (_vm.errorFilterState = !_vm.errorFilterState), (_vm.selectedPage = 1)
      }
    }
  }, [(_vm.errorFilterState) ? _c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("check_box")]) : _c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.I0003) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar color-new",
    on: {
      "click": function($event) {
        (_vm.newFilterState = !_vm.newFilterState), (_vm.selectedPage = 1)
      }
    }
  }, [(_vm.newFilterState) ? _c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("check_box")]) : _c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.I0004) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar color-updated",
    on: {
      "click": function($event) {
        (_vm.updatedFilterState = !_vm.updatedFilterState), (_vm.selectedPage = 1)
      }
    }
  }, [(_vm.updatedFilterState) ? _c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("check_box")]) : _c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.I0005) + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-lg-5"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('a', {
    staticClass: "btn btn-raised color-info",
    staticStyle: {
      "margin-top": "6px"
    },
    attrs: {
      "role": "button",
      "disabled": _vm.selectedRowNumbers.length == 0
    },
    on: {
      "click": function($event) {
        _vm.selectedRowNumbers = []
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.I0037))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5 nopadding"
  }, [_c('ul', {
    staticClass: "pagination-fonts pagination btn-group"
  }, [_c('li', [_vm._m(0), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "elementsPerPageDropdown",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.I0030))]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 20
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 20)
      }
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 50
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 50)
      }
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 100
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 100)
      }
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 200
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 200)
      }
    }
  }, [_vm._v("200")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 500
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 500)
      }
    }
  }, [_vm._v("500")])])])], 1), _vm._v(" "), _c('li', {
    class: {
      disabled: _vm.selectedPage == 1
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 0)
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "firstPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.I0031))])], 1), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage > 4) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getVisiblePages()), function(pageNumber) {
    return _c('li', {
      key: pageNumber,
      class: {
        active: _vm.selectedPage == pageNumber
      },
      on: {
        "click": function($event) {
          return _vm.updatePaging(pageNumber, 0)
        }
      }
    }, [_c('a', {
      attrs: {
        "role": "button"
      }
    }, [_vm._v(_vm._s(pageNumber))])])
  }), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage < _vm.pageCount - 3) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      disabled: _vm.selectedPage == _vm.pageCount
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(_vm.pageCount, 0)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "lastPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.I0032))])], 1)], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body table-responsive import-table-panel"
  }, [_c('table', {
    staticClass: "table table-striped table-hover",
    staticStyle: {
      "width": "auto"
    }
  }, [_c('thead', [_c('tr', [(_vm.tableHeaders.length > 1) ? _vm._l((_vm.tableHeaders), function(header) {
    return _c('th', {
      key: header,
      staticClass: "text-center",
      staticStyle: {
        "white-space": "nowrap"
      }
    }, [_c('a', {
      staticClass: "table-header",
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          (_vm.sortColumn = header), (_vm.sortOrderAsc = !_vm.sortOrderAsc)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(header) + "\n                  "), (_vm.sortColumn == header && _vm.sortOrderAsc) ? _c('span', {
      staticClass: "glyphicon glyphicon-triangle-top"
    }) : _vm._e(), _vm._v(" "), (_vm.sortColumn == header && !_vm.sortOrderAsc) ? _c('span', {
      staticClass: "glyphicon glyphicon-triangle-bottom"
    }) : _vm._e()])])
  }) : _c('th', [_vm._v(_vm._s(_vm.lang.I0038))])], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.serverResponse.Locations), function(location, rowindex) {
    return _c('tr', {
      key: rowindex,
      class: {
        info: _vm.isRowSelected(rowindex),
        'color-error': _vm.rowContainsError(rowindex),
        'color-new': _vm.isRowNew(rowindex) && !_vm.rowContainsError(rowindex),
        'color-updated': _vm.isRowUpdated(rowindex) && !_vm.rowContainsError(rowindex),
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.toggleRowSelected(rowindex)
        }
      }
    }, _vm._l((_vm.getVisibleLocationData(location)), function(value, column) {
      return _c('td', {
        key: column
      }, [(_vm.isErrorValue(rowindex, column)) ? _c('div', {
        staticClass: "form-group nopadding error-input"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.serverResponse.Locations[rowindex][column]),
          expression: "serverResponse.Locations[rowindex][column]"
        }],
        staticClass: "form-control text-center nopadding",
        attrs: {
          "type": "text",
          "readonly": "true",
          "onblur": "this.readOnly='true';",
          "ondblclick": "this.readOnly='';"
        },
        domProps: {
          "value": (_vm.serverResponse.Locations[rowindex][column])
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.serverResponse.Locations[rowindex], column, $event.target.value)
          }
        }
      })]) : _c('div', [_vm._v(_vm._s(value))])])
    }), 0)
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "feedbackModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.feedbackModalData.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    domProps: {
      "innerHTML": _vm._s(_vm.feedbackModalData.text)
    }
  }), _vm._v(" "), (_vm.feedbackModalData.type == 'YesNoCancelImport') ? _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.I0006) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.discardImportData()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.I0007) + "\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.feedbackModalData.type == 'okImportSuccessful') ? _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.exitImport()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.I0008) + "\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.feedbackModalData.type == 'okNoAction') ? _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.I0008) + "\n          ")])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "role": "button",
      "data-toggle": "dropdown",
      "id": "elementsPerPageDropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("view_headline")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "firstPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("first_page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "lastPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("last_page")])])
}]}

/***/ }),
/* 1699 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "checkLocalAgencyAssignmentModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.CLAA00))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.lang.CLAA01))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select2', {
    ref: "selectLocalAgency",
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.lang.CLAA02,
      "allowClear": true
    },
    model: {
      value: (_vm.selectedLocalAgency),
      callback: function($$v) {
        _vm.selectedLocalAgency = $$v
      },
      expression: "selectedLocalAgency"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.localAgencies), function(agency) {
    return _c('option', {
      key: agency.AgencyGuid,
      domProps: {
        "value": agency.AgencyGuid
      }
    }, [_vm._v("\n                " + _vm._s(agency.AgencyName) + "\n              ")])
  })], 2)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.CLAA03) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveAgencyAssignment()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.CLAA04) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 1700 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": 'changePasswordDialog' + _vm._uid,
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(!_vm.userGuid ? _vm.lang.PW0014 : _vm.lang.PW0000))])]), _vm._v(" "), (_vm.userName) ? _c('div', [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.lang.PW0017) + ": " + _vm._s(_vm.userName))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.checkIfNewPasswordPassed()
      }
    }
  }, [(!_vm.userGuid) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": 'inputOldPassword' + _vm._uid
    }
  }, [_vm._v(_vm._s(_vm.lang.PW0013))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwords.oldPassword),
      expression: "passwords.oldPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": 'inputOldPassword' + _vm._uid
    },
    domProps: {
      "value": (_vm.passwords.oldPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.passwords, "oldPassword", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": 'inputNewPassword' + _vm._uid
    }
  }, [_vm._v(_vm._s(_vm.lang.PW0001))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwords.newPassword),
      expression: "passwords.newPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": 'inputNewPassword' + _vm._uid
    },
    domProps: {
      "value": (_vm.passwords.newPassword)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.passwords, "newPassword", $event.target.value)
      }, function($event) {
        _vm.doCheckIfPasswordIsValid(), _vm.checkIfPasswordsMatch()
      }]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "padding-bottom": "2px"
    }
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": 'inputNewPasswordRepeat' + _vm._uid
    }
  }, [_vm._v(_vm._s(_vm.lang.PW0002))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwords.newPasswordRepeat),
      expression: "passwords.newPasswordRepeat"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": 'inputNewPasswordRepeat' + _vm._uid
    },
    domProps: {
      "value": (_vm.passwords.newPasswordRepeat)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.passwords, "newPasswordRepeat", $event.target.value)
      }, function($event) {
        return _vm.checkIfPasswordsMatch()
      }]
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    attrs: {
      "id": "passwordPolicy"
    }
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.lang.PW0003))])]), _vm._v(" "), (_vm.passwordPolicy.length > 0) ? _c('table', {
    staticClass: "table table-bordered"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "nopadding width-20"
  }, [(!_vm.passwordValidity.enoughCharacters) ? _c('i', {
    staticClass: "material-icons md-24 text-red"
  }, [_vm._v("clear")]) : _c('i', {
    staticClass: "material-icons md-24 text-green"
  }, [_vm._v("done")])]), _vm._v(" "), _c('td', {
    staticClass: "width-80"
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.PW0004) + " " + _vm._s(_vm.passwordPolicy[0].value) + "\n                  " + _vm._s(_vm.lang.PW0005) + "\n                ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "nopadding width-20"
  }, [(!_vm.passwordValidity.hasUpperCase) ? _c('i', {
    staticClass: "material-icons md-24 text-red"
  }, [_vm._v("clear")]) : _c('i', {
    staticClass: "material-icons md-24 text-green"
  }, [_vm._v("done")])]), _vm._v(" "), _c('td', {
    staticClass: "width-80"
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.PW0004) + " " + _vm._s(_vm.passwordPolicy[1].value) + "\n                  " + _vm._s(_vm.lang.PW0006) + "\n                ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "nopadding width-20"
  }, [(!_vm.passwordValidity.hasLowerCase) ? _c('i', {
    staticClass: "material-icons md-24 text-red"
  }, [_vm._v("clear")]) : _c('i', {
    staticClass: "material-icons md-24 text-green"
  }, [_vm._v("done")])]), _vm._v(" "), _c('td', {
    staticClass: "width-80"
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.PW0004) + " " + _vm._s(_vm.passwordPolicy[2].value) + "\n                  " + _vm._s(_vm.lang.PW0007) + "\n                ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "nopadding width-20"
  }, [(!_vm.passwordValidity.hasNumbers) ? _c('i', {
    staticClass: "material-icons md-24 text-red"
  }, [_vm._v("clear")]) : _c('i', {
    staticClass: "material-icons md-24 text-green"
  }, [_vm._v("done")])]), _vm._v(" "), _c('td', {
    staticClass: "width-80"
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.PW0004) + " " + _vm._s(_vm.passwordPolicy[3].value) + "\n                  " + _vm._s(_vm.lang.PW0008) + "\n                ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "nopadding width-20"
  }, [(!_vm.passwordValidity.hasNonalphas) ? _c('i', {
    staticClass: "material-icons md-24 text-red"
  }, [_vm._v("clear")]) : _c('i', {
    staticClass: "material-icons md-24 text-green"
  }, [_vm._v("done")])]), _vm._v(" "), _c('td', {
    staticClass: "width-80"
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.PW0004) + " " + _vm._s(_vm.passwordPolicy[4].value) + "\n                  " + _vm._s(_vm.lang.PW0009) + "\n                ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "nopadding width-20"
  }, [(!_vm.passwordsMatch) ? _c('i', {
    staticClass: "material-icons md-24 text-red"
  }, [_vm._v("clear")]) : _c('i', {
    staticClass: "material-icons md-24 text-green"
  }, [_vm._v("done")])]), _vm._v(" "), _c('td', {
    staticClass: "width-80"
  }, [_vm._v(_vm._s(_vm.lang.PW0012))])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.PW0010) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button",
      "disabled": !_vm.isPasswordValid || !_vm.passwordsMatch
    },
    on: {
      "click": function($event) {
        return _vm.checkIfNewPasswordPassed()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.PW0011) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 1701 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    class: {
      'text-red': _vm.Recommended && !_vm.value
    },
    attrs: {
      "for": ("input-shopper-custprop-" + _vm.Guid + "-" + _vm._uid)
    }
  }, [_vm._v("\n    " + _vm._s(_vm.Title) + "\n    "), (_vm.Recommended) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('Select2', {
    staticClass: "form-control",
    attrs: {
      "id": ("input-shopper-custprop-" + _vm.Guid + "-" + _vm._uid),
      "allowClear": true,
      "placeholder": ' ',
      "tags": _vm.AllowCustomValues,
      "disabled": _vm.readOnly,
      "value": _vm.value
    },
    on: {
      "change": _vm.updateValue
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.ListValues), function(element) {
    return _c('option', {
      key: element.ValueGuid,
      domProps: {
        "value": element.ValueGuid
      }
    }, [_vm._v("\n        " + _vm._s(element.Value) + "\n      ")])
  })], 2)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1702 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "checkPaymentModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.CPM000))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    on: {
      "change": function($event) {
        _vm.paymentFormDirty = true
      }
    }
  }, [_c('div', {
    staticClass: "panel-group",
    attrs: {
      "id": "accordionCheckPayment",
      "role": "tablist",
      "aria-multiselectable": "true"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingCheckPaymentGeneral",
      "data-toggle": "collapse",
      "data-parent": "#accordionCheckPayment",
      "href": "#collapseCheckPaymentGeneral",
      "aria-expanded": "true",
      "aria-controls": "collapseCheckPaymentGeneral"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.CPM001) + " (" + _vm._s(_vm.checkDataList.length) + ")")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in",
    attrs: {
      "id": "collapseCheckPaymentGeneral",
      "role": "tabpanel",
      "aria-labelledby": "headingCheckPaymentGeneral"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-12 text-red text-bold"
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.CPM002) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "disabled": !_vm.globals.isPaymentsEditingAllowed
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.togglePayoutApprovedForAll()
      }
    }
  }, [(_vm.generalSettlementData.PayoutApproved === true) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : (
    _vm.generalSettlementData.PayoutApproved === false
  ) ? _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]) : _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("indeterminate_check_box")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.CPM003))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputBasePaymentAll"
    }
  }, [_vm._v(_vm._s(_vm.lang.CPM004))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('currency-input', {
    staticClass: "form-control",
    attrs: {
      "id": "inputBasePaymentAll",
      "currency": "EUR",
      "min": 0,
      "locale": _vm.globals.currentLocale,
      "disabled": !_vm.generalSettlementData.EnableEditPayments
    },
    on: {
      "change": function($event) {
        _vm.writeToAllChecks('BasePayment'),
          _vm.calcGeneralTotalPayment()
      }
    },
    model: {
      value: (_vm.generalSettlementData.BasePayment),
      callback: function($$v) {
        _vm.$set(_vm.generalSettlementData, "BasePayment", $$v)
      },
      expression: "generalSettlementData.BasePayment"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 sum-container"
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("functions")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.globals.getCurrencyString(
    _vm.generalSettlementData.BasePaymentSum,
    "EUR"
  )))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputPlusPaymentAll"
    }
  }, [_vm._v(_vm._s(_vm.lang.CPM005))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('currency-input', {
    staticClass: "form-control",
    attrs: {
      "id": "inputPlusPaymentAll",
      "currency": "EUR",
      "min": 0,
      "locale": _vm.globals.currentLocale,
      "disabled": !_vm.generalSettlementData.EnableEditPayments
    },
    on: {
      "change": function($event) {
        _vm.writeToAllChecks('PlusPayment'),
          _vm.calcGeneralTotalPayment()
      }
    },
    model: {
      value: (_vm.generalSettlementData.PlusPayment),
      callback: function($$v) {
        _vm.$set(_vm.generalSettlementData, "PlusPayment", $$v)
      },
      expression: "generalSettlementData.PlusPayment"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 sum-container"
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("functions")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.globals.getCurrencyString(
    _vm.generalSettlementData.PlusPaymentSum,
    "EUR"
  )))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputMinusPaymentAll"
    }
  }, [_vm._v(_vm._s(_vm.lang.CPM006))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('currency-input', {
    staticClass: "form-control",
    attrs: {
      "id": "inputMinusPaymentAll",
      "currency": "EUR",
      "min": 0,
      "locale": _vm.globals.currentLocale,
      "disabled": !_vm.generalSettlementData.EnableEditPayments
    },
    on: {
      "change": function($event) {
        _vm.writeToAllChecks('MinusPayment'),
          _vm.calcGeneralTotalPayment()
      }
    },
    model: {
      value: (_vm.generalSettlementData.MinusPayment),
      callback: function($$v) {
        _vm.$set(_vm.generalSettlementData, "MinusPayment", $$v)
      },
      expression: "generalSettlementData.MinusPayment"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 sum-container"
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("functions")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.globals.getCurrencyString(
    _vm.generalSettlementData.MinusPaymentSum,
    "EUR"
  )))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(_vm._s(_vm.lang.CPM007))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "form-control text-left",
    attrs: {
      "disabled": !_vm.generalSettlementData.EnableEditPayments
    }
  }, [_vm._v(_vm._s(_vm.globals.getCurrencyString(
    _vm.generalSettlementData.TotalPayment,
    "EUR"
  )))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 sum-container"
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("functions")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.globals.getCurrencyString(
    _vm.generalSettlementData.TotalPaymentSum,
    "EUR"
  )))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(_vm._s(_vm.lang.CPM008))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 sum-container"
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("functions")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.globals.getCurrencyString(
    _vm.generalSettlementData.PurchaseMoneySum,
    "EUR"
  )))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputSettlementCommentAll"
    }
  }, [_vm._v(_vm._s(_vm.lang.CPM009))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.generalSettlementData.SettlementComment),
      expression: "generalSettlementData.SettlementComment"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "4",
      "type": "text",
      "id": "inputSettlementCommentAll",
      "disabled": !_vm.generalSettlementData.EnableEditPayments
    },
    domProps: {
      "value": (_vm.generalSettlementData.SettlementComment)
    },
    on: {
      "change": function($event) {
        return _vm.writeToAllChecks('SettlementComment')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.generalSettlementData, "SettlementComment", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingCheckPaymentSpecific",
      "data-toggle": "collapse",
      "data-parent": "#accordionCheckPayment",
      "href": "#collapseCheckPaymentSpecific",
      "aria-expanded": "false",
      "aria-controls": "collapseCheckPaymentSpecific"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.CPM010))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseCheckPaymentSpecific",
      "role": "tabpanel",
      "aria-labelledby": "headingCheckPaymentSpecific"
    }
  }, [_c('div', {
    staticClass: "panel-body",
    staticStyle: {
      "padding": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-2",
    attrs: {
      "id": "checkListContainer"
    }
  }, [_c('table', {
    staticClass: "table table-striped table-hover main-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.lang.CPM011))])])]), _vm._v(" "), _c('tbody', {
    staticClass: "main-table-scrollbar",
    attrs: {
      "id": "check-list-table"
    }
  }, _vm._l((_vm.checkDataList), function(check) {
    return _c('tr', {
      key: check.SurveyInstanceId,
      class: {
        info: _vm.selectedCheck.SurveyInstanceId ===
          check.SurveyInstanceId,
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          _vm.selectedCheck = check
        }
      }
    }, [_c('td', [_vm._v(_vm._s(check.SurveyInstanceId))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedCheck.SurveyInstanceId),
      expression: "selectedCheck.SurveyInstanceId"
    }],
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(_vm._s(_vm.lang.CPM012))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('label', {
    staticClass: "form-control text-left"
  }, [_vm._v(_vm._s(_vm.selectedCheck.ProjectName))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(_vm._s(_vm.lang.CPM013))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('label', {
    staticClass: "form-control text-left"
  }, [_vm._v(_vm._s(_vm.selectedCheck.WaveName))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(_vm._s(_vm.lang.CPM014))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('label', {
    staticClass: "form-control text-left"
  }, [_vm._v(_vm._s(_vm.selectedCheck.ScenarioName))])])]), _vm._v(" "), (_vm.selectedCheck.ShopperUsername) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(_vm._s(_vm.lang.CPM015))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('label', {
    staticClass: "form-control text-left"
  }, [_vm._v("\n                        " + _vm._s(_vm.selectedCheck.ShopperFirstName) + "\n                        " + _vm._s(_vm.selectedCheck.ShopperLastName) + " (" + _vm._s(_vm.selectedCheck.ShopperUsername) + ")\n                        "), _c('span', {
    staticClass: "pull-right vat-mandatory-info"
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.CPM016) + ":\n                          "), (_vm.selectedCheck.VatNotMandatory) ? _c('i', {
    staticClass: "material-icons text-red icon-vat-mandatory"
  }, [_vm._v("clear")]) : _c('i', {
    staticClass: "material-icons text-green icon-vat-mandatory"
  }, [_vm._v("done")])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputBasePayment"
    }
  }, [_vm._v(_vm._s(_vm.lang.CPM004))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('currency-input', {
    staticClass: "form-control",
    attrs: {
      "id": "inputBasePayment",
      "currency": "EUR",
      "min": 0,
      "locale": _vm.globals.currentLocale,
      "disabled": !_vm.selectedCheck.EnableEditPayments
    },
    on: {
      "change": function($event) {
        return _vm.calcSpecificTotalPayment()
      }
    },
    model: {
      value: (_vm.selectedCheck.BasePayment),
      callback: function($$v) {
        _vm.$set(_vm.selectedCheck, "BasePayment", $$v)
      },
      expression: "selectedCheck.BasePayment"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputPlusPayment"
    }
  }, [_vm._v(_vm._s(_vm.lang.CPM005))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('currency-input', {
    staticClass: "form-control",
    attrs: {
      "id": "inputPlusPayment",
      "currency": "EUR",
      "min": 0,
      "locale": _vm.globals.currentLocale,
      "disabled": !_vm.selectedCheck.EnableEditPayments
    },
    on: {
      "change": function($event) {
        return _vm.calcSpecificTotalPayment()
      }
    },
    model: {
      value: (_vm.selectedCheck.PlusPayment),
      callback: function($$v) {
        _vm.$set(_vm.selectedCheck, "PlusPayment", $$v)
      },
      expression: "selectedCheck.PlusPayment"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputMinusPayment"
    }
  }, [_vm._v(_vm._s(_vm.lang.CPM006))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('currency-input', {
    staticClass: "form-control",
    attrs: {
      "id": "inputMinusPayment",
      "currency": "EUR",
      "min": 0,
      "locale": _vm.globals.currentLocale,
      "disabled": !_vm.selectedCheck.EnableEditPayments
    },
    on: {
      "change": function($event) {
        return _vm.calcSpecificTotalPayment()
      }
    },
    model: {
      value: (_vm.selectedCheck.MinusPayment),
      callback: function($$v) {
        _vm.$set(_vm.selectedCheck, "MinusPayment", $$v)
      },
      expression: "selectedCheck.MinusPayment"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(_vm._s(_vm.lang.CPM007))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('label', {
    staticClass: "form-control text-left",
    attrs: {
      "disabled": !_vm.selectedCheck.EnableEditPayments
    }
  }, [_vm._v(_vm._s(_vm.globals.getCurrencyString(
    _vm.selectedCheck.TotalPayment,
    "EUR"
  )))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputPurchaseMoney"
    }
  }, [_vm._v(_vm._s(_vm.lang.CPM008))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('currency-input', {
    staticClass: "form-control",
    attrs: {
      "id": "inputPurchaseMoney",
      "currency": "EUR",
      "min": 0,
      "locale": _vm.globals.currentLocale,
      "disabled": !_vm.selectedCheck.EnableEditPayments
    },
    on: {
      "change": function($event) {
        return _vm.calcSpecificTotalPayment()
      }
    },
    model: {
      value: (_vm.selectedCheck.PurchaseMoney),
      callback: function($$v) {
        _vm.$set(_vm.selectedCheck, "PurchaseMoney", $$v)
      },
      expression: "selectedCheck.PurchaseMoney"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(_vm._s(_vm.lang.CPM017))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('label', {
    staticClass: "form-control text-left",
    attrs: {
      "disabled": !_vm.selectedCheck.EnableEditPayments
    }
  }, [_vm._v(_vm._s(_vm.globals.getCurrencyString(
    _vm.selectedCheck.Payout,
    "EUR"
  )))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputSettlementComment"
    }
  }, [_vm._v(_vm._s(_vm.lang.CPM009))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedCheck.SettlementComment),
      expression: "selectedCheck.SettlementComment"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "4",
      "type": "text",
      "id": "inputSettlementComment",
      "disabled": !_vm.selectedCheck.EnableEditPayments
    },
    domProps: {
      "value": (_vm.selectedCheck.SettlementComment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedCheck, "SettlementComment", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(_vm._s(_vm.lang.CPM018))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 text-left"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedCheck.EnablePayoutApprovedChange ||
        !_vm.globals.isPaymentsEditingAllowed
    },
    on: {
      "click": function($event) {
        _vm.selectedCheck.PayoutApproved = !_vm.selectedCheck.PayoutApproved
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectedCheck.PayoutApproved ?
    _vm.lang.CPM019 :
    _vm.lang.CPM020) + "\n                      ")]), _vm._v(" "), (_vm.selectedCheck.PayoutApproved) ? _c('span', [(_vm.selectedCheck.PayoutApprovedAt) ? _c('span', [_vm._v(_vm._s(_vm.lang.CPM021) + ":\n                          " + _vm._s(_vm.globals.getLocalizedDateTimeFromUtcIsoTimestamp(
    _vm.selectedCheck.PayoutApprovedAt
  )))]) : _c('span', [_vm._v(_vm._s(_vm.lang.CPM022))])]) : _vm._e()])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.globals.isPaymentsEditingAllowed) ? _c('button', {
    staticClass: "btn btn-raised pull-left edit-vat-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openEditVATModal()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.CPM025) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.CPM023) + "\n        ")]), _vm._v(" "), (_vm.globals.isPaymentsEditingAllowed) ? _c('button', {
    staticClass: "btn btn-raised btn-success",
    class: {
      'btn-warning': _vm.paymentFormDirty
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.savePaymentData()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.CPM024) + "\n        ")]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticStyle: {
      "height": "45px"
    }
  })])
}]}

/***/ }),
/* 1703 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-default",
    class: {
      'recruiting-panel': _vm.isRecruitingFilter
    }
  }, [(_vm.isRecruitingFilter) ? _c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\n    " + _vm._s(_vm.lang.RCS000) + "\n    "), (typeof _vm.resultShopperData.ShopperCount === 'number') ? _c('span', {
    class: {
      'text-red': _vm.shopperCountExceeded
    },
    attrs: {
      "id": "shopperCounterContainer"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.lang.RCS001) + ": " + _vm._s(_vm.resultShopperData.ShopperCount))]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shopperCountExceeded),
      expression: "shopperCountExceeded"
    }],
    staticClass: "material-icons md-24"
  }, [_vm._v("warning")])]) : _vm._e(), _vm._v(" "), (_vm.shopperCountExceeded) ? _c('b-tooltip', {
    attrs: {
      "target": "shopperCounterContainer",
      "delay": _vm.globals.tooltipDelay,
      "boundary": "viewport",
      "placement": "bottom"
    }
  }, [_vm._v(_vm._s(_vm.lang.RCS030))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "filter-border col-md-12"
  }, [_c('div', {
    staticClass: "form-group col-md-6",
    attrs: {
      "id": "inputShopperFilterNotSameLocationFormGroup"
    }
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notSameLocation),
      expression: "notSameLocation"
    }],
    attrs: {
      "type": "checkbox",
      "id": "inputShopperFilterNotSameLocation",
      "disabled": _vm.notWithLocationPropertyGuids.length > 0
    },
    domProps: {
      "checked": Array.isArray(_vm.notSameLocation) ? _vm._i(_vm.notSameLocation, null) > -1 : (_vm.notSameLocation)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.notSameLocation,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.notSameLocation = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.notSameLocation = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.notSameLocation = $$c
        }
      }, function($event) {
        return _vm.getShopperFilterResult()
      }]
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.RCS002) + ":")])])]), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "inputShopperFilterNotSameLocationFormGroup",
      "boundary": "viewport",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.RCS003))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-3",
    attrs: {
      "id": "inputShopperFilterNotWithinTimespanValueFormGroup"
    }
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.notWithinTimespanValue),
      expression: "notWithinTimespanValue",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "inputShopperFilterNotWithinTimespanValue",
      "step": "1",
      "min": "0",
      "max": "100000"
    },
    domProps: {
      "value": (_vm.notWithinTimespanValue)
    },
    on: {
      "change": function($event) {
        _vm.validateTimespanValue(), _vm.getShopperFilterResult()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.notWithinTimespanValue = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-3",
    attrs: {
      "id": "inputShopperFilterNotWithinTimespanFormGroup"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notWithinTimespan),
      expression: "notWithinTimespan"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "inputShopperFilterNotWithinTimespan"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.notWithinTimespan = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.getShopperFilterResult()
      }]
    }
  }, _vm._l((_vm.timespans), function(span, idx) {
    return _c('option', {
      key: idx,
      domProps: {
        "value": span
      }
    }, [_vm._v("\n            " + _vm._s(_vm.getTranslationFor(span)) + "\n          ")])
  }), 0)]), _vm._v(" "), (_vm.locationPropertiesList.length > 0) ? _c('div', {
    staticClass: "form-group col-md-12",
    attrs: {
      "id": "inputShopperFilterNotWithinLocationPropertiesFormGroup"
    }
  }, [_c('select2', {
    attrs: {
      "id": "inputShopperFilterNotWithinLocationProperties",
      "placeholder": _vm.lang.RCS004,
      "allowClear": true,
      "multiple": true
    },
    on: {
      "change": function($event) {
        (_vm.notSameLocation = true), _vm.getShopperFilterResult()
      }
    },
    model: {
      value: (_vm.notWithLocationPropertyGuids),
      callback: function($$v) {
        _vm.notWithLocationPropertyGuids = $$v
      },
      expression: "notWithLocationPropertyGuids"
    }
  }, _vm._l((_vm.locationPropertiesList), function(prop) {
    return _c('option', {
      key: prop.LocationPropertyGuid,
      domProps: {
        "value": prop.LocationPropertyGuid
      }
    }, [_vm._v("\n            " + _vm._s(prop.LocationPropertyName) + "\n          ")])
  }), 0), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "inputShopperFilterNotWithinLocationPropertiesFormGroup",
      "boundary": "viewport",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.RCS005))])], 1) : _vm._e()]), _vm._v(" "), _vm._l((_vm.dynamicFilters), function(filter, index) {
    return _c('div', {
      key: index,
      staticClass: "form-group form-group-dynamic"
    }, [_c('div', {
      staticClass: "form-group col-md-3",
      attrs: {
        "id": ("selectShopperFilterDynamicTypeFormGroup" + index)
      }
    }, [_c('select2', {
      ref: ("filterTypeSelect" + index),
      refInFor: true,
      attrs: {
        "id": ("selectShopperFilterDynamicType" + index),
        "placeholder": ((_vm.lang.RCS006) + "..."),
        "allowClear": true
      },
      on: {
        "change": function($event) {
          return _vm.dynamicFilterTypeChanged(filter)
        }
      },
      model: {
        value: (filter.Type),
        callback: function($$v) {
          _vm.$set(filter, "Type", $$v)
        },
        expression: "filter.Type"
      }
    }, _vm._l((_vm.filterTypes), function(type, idx) {
      return _c('option', {
        key: idx,
        attrs: {
          "disabled": !_vm.isTypeEnabled(type, filter)
        },
        domProps: {
          "value": type
        }
      }, [_vm._v("\n            " + _vm._s(_vm.getTranslationFor(type)) + "\n          ")])
    }), 0), _vm._v(" "), _c('b-tooltip', {
      attrs: {
        "target": ("selectShopperFilterDynamicTypeFormGroup" + index),
        "boundary": "viewport",
        "triggers": "hover",
        "delay": _vm.globals.tooltipDelay
      }
    }, [_vm._v(_vm._s(_vm.lang.RCS007))])], 1), _vm._v(" "), (filter.secondLevelSelectVisible) ? _c('div', {
      staticClass: "form-group col-md-8",
      attrs: {
        "id": ("selectShopperFilterDynamicValueFormGroup" + index)
      }
    }, [_c('select2', {
      ref: ("secondLevelSelect" + index),
      refInFor: true,
      attrs: {
        "id": ("selectShopperFilterDynamicValue" + index),
        "placeholder": ((_vm.lang.RCS006) + "..."),
        "allowClear": true,
        "multiple": filter.Type !== 'ShopperProperty',
        "tags": filter.Type === 'City' || filter.Type === 'PostalCode',
        "noResultsString": filter.Type === 'City' || filter.Type === 'PostalCode' ?
          _vm.lang.RCS018 :
          undefined
      },
      on: {
        "change": function($event) {
          return _vm.dynamicFilterValueChanged(filter)
        }
      },
      model: {
        value: (filter.Value),
        callback: function($$v) {
          _vm.$set(filter, "Value", $$v)
        },
        expression: "filter.Value"
      }
    }, [(filter.Type === 'Country' || filter.Type === 'Gender') ? _vm._l((filter.currentDynamicFilterValues), function(value) {
      return _c('option', {
        key: value[((filter.Type) + "Code")],
        domProps: {
          "value": value[((filter.Type) + "Code")]
        }
      }, [_vm._v("\n              " + _vm._s(value[((filter.Type) + "Name")]) + "\n            ")])
    }) : (filter.Type === 'ShopperProperty') ? _vm._l((filter.currentDynamicFilterValues), function(topic) {
      return _c('optgroup', {
        key: topic[((filter.Type) + "Guid")],
        attrs: {
          "label": topic[((filter.Type) + "Name")]
        }
      }, _vm._l((topic.ChildProperties), function(property) {
        return _c('option', {
          key: property[((filter.Type) + "Guid")],
          attrs: {
            "disabled": _vm.propertyAlreadyUsed(property[((filter.Type) + "Guid")])
          },
          domProps: {
            "value": property[((filter.Type) + "Guid")]
          }
        }, [_vm._v("\n                " + _vm._s(property[((filter.Type) + "Name")]) + "\n                "), (property.GroupTitle) ? _c('span', [_vm._v("(" + _vm._s(property.GroupTitle) + ")")]) : _vm._e()])
      }), 0)
    }) : _vm._l((filter.currentDynamicFilterValues), function(value) {
      return _c('option', {
        key: value[((filter.Type) + "Guid")],
        domProps: {
          "value": value[((filter.Type) + "Guid")]
        }
      }, [_vm._v("\n              " + _vm._s(value[((filter.Type) + "Name")]) + "\n            ")])
    })], 2), _vm._v(" "), _c('b-tooltip', {
      attrs: {
        "target": ("selectShopperFilterDynamicValueFormGroup" + index),
        "boundary": "viewport",
        "triggers": "hover",
        "delay": _vm.globals.tooltipDelay
      }
    }, [_vm._v(_vm._s(_vm.getTranslationFor(filter.Type)))])], 1) : _vm._e(), _vm._v(" "), (filter.secondLevelRangeVisible) ? _c('div', {
      staticClass: "form-group col-md-4",
      attrs: {
        "id": ("selectShopperFilterDynamicValueFormGroup" + index)
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (filter.Value.From),
        expression: "filter.Value.From",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "step": "1",
        "min": "0",
        "max": "100",
        "placeholder": _vm.lang.RCS022
      },
      domProps: {
        "value": (filter.Value.From)
      },
      on: {
        "change": function($event) {
          return _vm.dynamicFilterValueChanged(filter)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(filter.Value, "From", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })]) : _vm._e(), _vm._v(" "), (filter.secondLevelRangeVisible) ? _c('div', {
      staticClass: "form-group col-md-4",
      attrs: {
        "id": ("selectShopperFilterDynamicValueFormGroup" + index)
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (filter.Value.To),
        expression: "filter.Value.To",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "step": "1",
        "min": "0",
        "max": "100",
        "placeholder": _vm.lang.RCS023
      },
      domProps: {
        "value": (filter.Value.To)
      },
      on: {
        "change": function($event) {
          return _vm.dynamicFilterValueChanged(filter)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(filter.Value, "To", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })]) : _vm._e(), _vm._v(" "), (filter.thirdLevelInputVisible) ? _c('div', {
      staticClass: "form-group col-md-11",
      attrs: {
        "id": ("selectShopperFilterDynamicValueValuesFormGroup" + index)
      }
    }, [(
      filter.thirdLevelInputType === 'SingleSelect' ||
      filter.thirdLevelInputType === 'MultiSelect'
    ) ? _c('select2', {
      ref: ("thirdLevelSelect" + index),
      refInFor: true,
      attrs: {
        "id": ("inputShopperFilterDynamicValueValues" + index),
        "placeholder": ((_vm.lang.RCS006) + "..."),
        "allowClear": true,
        "multiple": filter.thirdLevelInputType === 'MultiSelect',
        "tags": true
      },
      on: {
        "change": function($event) {
          return _vm.getShopperFilterResult()
        }
      },
      model: {
        value: (filter.Subvalue),
        callback: function($$v) {
          _vm.$set(filter, "Subvalue", $$v)
        },
        expression: "filter.Subvalue"
      }
    }, _vm._l((filter.currentDynamicFilterValueValues), function(value) {
      return _c('option', {
        key: value["ListValueGuid"],
        domProps: {
          "value": value["ListValueGuid"]
        }
      }, [_vm._v("\n            " + _vm._s(value.IsNoAnswer ? ("[" + (_vm.lang.RCS031) + "]") : value["ListValue"]) + "\n          ")])
    }), 0) : (filter.thirdLevelInputType === 'Checkbox') ? _c('div', {
      staticClass: "checkbox"
    }, [_c('label', [_c('span', [_vm._v(_vm._s(_vm.lang.RCS008) + ":")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (filter.Subvalue),
        expression: "filter.Subvalue"
      }],
      attrs: {
        "type": "checkbox",
        "id": ("inputShopperFilterDynamicValueValues" + index)
      },
      domProps: {
        "value": filter.Subvalue,
        "checked": Array.isArray(filter.Subvalue) ? _vm._i(filter.Subvalue, filter.Subvalue) > -1 : (filter.Subvalue)
      },
      on: {
        "change": [function($event) {
          var $$a = filter.Subvalue,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = filter.Subvalue,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(filter, "Subvalue", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(filter, "Subvalue", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(filter, "Subvalue", $$c)
          }
        }, function($event) {
          return _vm.getShopperFilterResult()
        }]
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "checkbox-material"
    }, [_c('span', {
      staticClass: "check"
    })])])]) : (
      filter.thirdLevelInputType === 'Text' ||
      filter.thirdLevelInputType === 'Integer'
    ) ? _c('div', [((filter.thirdLevelInputType === 'Text' ? 'text' : 'number') === 'checkbox') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (filter.Subvalue),
        expression: "filter.Subvalue"
      }],
      staticClass: "form-control",
      attrs: {
        "id": ("inputShopperFilterDynamicValueValues" + index),
        "step": "1",
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(filter.Subvalue) ? _vm._i(filter.Subvalue, null) > -1 : (filter.Subvalue)
      },
      on: {
        "change": [function($event) {
          var $$a = filter.Subvalue,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(filter, "Subvalue", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(filter, "Subvalue", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(filter, "Subvalue", $$c)
          }
        }, function($event) {
          return _vm.getShopperFilterResult()
        }]
      }
    }) : ((filter.thirdLevelInputType === 'Text' ? 'text' : 'number') === 'radio') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (filter.Subvalue),
        expression: "filter.Subvalue"
      }],
      staticClass: "form-control",
      attrs: {
        "id": ("inputShopperFilterDynamicValueValues" + index),
        "step": "1",
        "type": "radio"
      },
      domProps: {
        "checked": _vm._q(filter.Subvalue, null)
      },
      on: {
        "change": [function($event) {
          return _vm.$set(filter, "Subvalue", null)
        }, function($event) {
          return _vm.getShopperFilterResult()
        }]
      }
    }) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (filter.Subvalue),
        expression: "filter.Subvalue"
      }],
      staticClass: "form-control",
      attrs: {
        "id": ("inputShopperFilterDynamicValueValues" + index),
        "step": "1",
        "type": filter.thirdLevelInputType === 'Text' ? 'text' : 'number'
      },
      domProps: {
        "value": (filter.Subvalue)
      },
      on: {
        "change": function($event) {
          return _vm.getShopperFilterResult()
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(filter, "Subvalue", $event.target.value)
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('b-tooltip', {
      attrs: {
        "target": ("selectShopperFilterDynamicValueValuesFormGroup" + index),
        "boundary": "viewport",
        "triggers": "hover",
        "delay": _vm.globals.tooltipDelay
      }
    }, [_vm._v(_vm._s(_vm.lang.RCS009))])], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-md-1 pull-right",
      class: {
        'centerized-remove-button': filter.thirdLevelInputVisible
      }
    }, [_c('button', {
      staticClass: "btn btn-remove-filter",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeDynamicFilter(filter)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24 text-red"
    }, [_vm._v("clear")])])])])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-fab btn-fab-mini btn-default btn-add-filter",
    attrs: {
      "type": "button",
      "id": "addDynamicFilterButton",
      "disabled": _vm.isLastDynamicFilterEmpty()
    },
    on: {
      "click": function($event) {
        return _vm.addDynamicFilter()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36 text-green"
  }, [_vm._v("add")])]), _vm._v(" "), (!_vm.isLastDynamicFilterEmpty()) ? _c('b-tooltip', {
    attrs: {
      "target": "addDynamicFilterButton",
      "boundary": "viewport",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.RCS010))]) : _vm._e()], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
}]}

/***/ }),
/* 1704 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "editSurveyDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "id": "editSurveyForm"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.dialogTitle))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel-group",
    attrs: {
      "id": "accordionEditSurvey",
      "role": "tablist",
      "aria-multiselectable": "true"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingEditSurveyGeneral",
      "data-toggle": "collapse",
      "data-parent": "#accordionEditSurvey",
      "href": "#collapseEditSurveyGeneral",
      "aria-expanded": "true",
      "aria-controls": "collapseEditSurveyGeneral"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.U0015))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in",
    attrs: {
      "id": "collapseEditSurveyGeneral",
      "role": "tabpanel",
      "aria-labelledby": "headingEditSurveyGeneral"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(
    !_vm.feature.isAudiTarget ||
    !_vm.feature.isEnabled('audi_importers')
  ) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "editSurveyClientSelect"
    }
  }, [_vm._v(_vm._s(_vm.lang.U0016) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "editSurveyClientSelect",
      "placeholder": _vm.lang.U1000,
      "allowClear": true,
      "disabled": !_vm.dialogModeAdd && !_vm.copySurvey,
      "required": ""
    },
    on: {
      "change": function($event) {
        return _vm.getSurveyGroupList()
      }
    },
    model: {
      value: (_vm.surveyData.ClientGuid),
      callback: function($$v) {
        _vm.$set(_vm.surveyData, "ClientGuid", $$v)
      },
      expression: "surveyData.ClientGuid"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.clientList), function(client) {
    return _c('option', {
      key: client.ClientGuid,
      domProps: {
        "value": client.ClientGuid
      }
    }, [_vm._v("\n                          " + _vm._s(client.ClientName) + "\n                        ")])
  })], 2)], 1)]) : _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "editSurveyImporterSelect"
    }
  }, [_vm._v(_vm._s(_vm.lang.U1075))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "editSurveyImporterSelect",
      "placeholder": _vm.lang.U1000,
      "allowClear": true
    },
    on: {
      "change": function($event) {
        return _vm.getSurveyGroupList()
      }
    },
    model: {
      value: (_vm.surveyData.ImporterGuid),
      callback: function($$v) {
        _vm.$set(_vm.surveyData, "ImporterGuid", $$v)
      },
      expression: "surveyData.ImporterGuid"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.importerList), function(importer) {
    return _c('option', {
      key: importer.ImporterGuid,
      domProps: {
        "value": importer.ImporterGuid
      }
    }, [_vm._v("\n                          " + _vm._s(importer.ImporterName) + "\n                        ")])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputTitle"
    }
  }, [_vm._v(_vm._s(_vm.lang.U0017) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.surveyData.SurveyTitle),
      expression: "surveyData.SurveyTitle"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputTitle",
      "name": "inputTitle",
      "required": ""
    },
    domProps: {
      "value": (_vm.surveyData.SurveyTitle)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputTitle')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.surveyData, "SurveyTitle", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputTitle')),
      expression: "inputHasError('inputTitle')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.U0020))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputTitle2"
    }
  }, [_vm._v(_vm._s(_vm.lang.U0018))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.surveyData.SurveyTitle2),
      expression: "surveyData.SurveyTitle2"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputTitle2"
    },
    domProps: {
      "value": (_vm.surveyData.SurveyTitle2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.surveyData, "SurveyTitle2", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputTitle3"
    }
  }, [_vm._v(_vm._s(_vm.lang.U0019))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.surveyData.SurveyTitle3),
      expression: "surveyData.SurveyTitle3"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputTitle3"
    },
    domProps: {
      "value": (_vm.surveyData.SurveyTitle3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.surveyData, "SurveyTitle3", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "selectSurveySkillLevel"
    }
  }, [_vm._v(_vm._s(_vm.lang.U0040))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.surveyData.SurveySkillLevel),
      expression: "surveyData.SurveySkillLevel",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "selectSurveySkillLevel"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.$set(_vm.surveyData, "SurveySkillLevel", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((5), function(i) {
    return _c('option', {
      key: i
    }, [_vm._v(_vm._s(i))])
  }), 0)]), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "selectSurveySkillLevel",
      "delay": _vm.globals.tooltipDelay,
      "placement": "right",
      "boundary": "viewport"
    }
  }, [_vm._v("\n                      1 → " + _vm._s(_vm.lang.U0041) + "\n                      "), _c('br'), _vm._v(" "), _c('br'), _vm._v("...\n                      "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n                      5 → " + _vm._s(_vm.lang.U0042) + "\n                    ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputSurveyActive"
    }
  }, [_vm._v(_vm._s(_vm.lang.U1037))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "float": "left"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.surveyData.SurveyActive),
      expression: "surveyData.SurveyActive"
    }],
    attrs: {
      "type": "checkbox",
      "id": "inputSurveyActive"
    },
    domProps: {
      "value": _vm.surveyData.SurveyActive,
      "checked": Array.isArray(_vm.surveyData.SurveyActive) ? _vm._i(_vm.surveyData.SurveyActive, _vm.surveyData.SurveyActive) > -1 : (_vm.surveyData.SurveyActive)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.surveyData.SurveyActive,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.surveyData.SurveyActive,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.surveyData, "SurveyActive", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.surveyData, "SurveyActive", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.surveyData, "SurveyActive", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(0)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingEditSurveyVisibility",
      "data-toggle": "collapse",
      "data-parent": "#accordionEditSurvey",
      "href": "#collapseEditSurveyVisibility",
      "aria-expanded": "false",
      "aria-controls": "collapseEditSurveyVisibility"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.U1001))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseEditSurveyVisibility",
      "role": "tabpanel",
      "aria-labelledby": "headingEditSurveyVisibility"
    }
  }, [_c('div', {
    staticClass: "panel-body",
    staticStyle: {
      "padding": "15px"
    }
  }, [_c('div', {
    staticClass: "tab-content col-xs-12"
  }, [_c('div', {
    staticClass: "tab-pane tab-content-visibility active in",
    attrs: {
      "id": "visibilitySettingsTabContent"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "16px",
      "color": "black",
      "padding-top": "15px"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.currentVisibilitySettings.headerText) + "\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('a', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin": "0 0 2px 0"
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleAllVisibilityGroups()
      }
    }
  }, [(
    _vm.currentVisibilitySettings.selectedGroups.length ==
    Object.keys(_vm.surveyGroupList).length
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : (
    _vm.currentVisibilitySettings.selectedGroups.length ==
    0
  ) ? _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]) : _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("indeterminate_check_box")]), _vm._v(" "), (
    _vm.currentVisibilitySettings.selectedGroups.length !=
    Object.keys(_vm.surveyGroupList).length
  ) ? _c('span', [_vm._v(_vm._s(_vm.lang.U1032))]) : _c('span', [_vm._v(_vm._s(_vm.lang.U1033))])])]), _vm._v(" "), _c('div', {
    staticClass: "table-content-visibility"
  }, [_c('table', {
    staticClass: "table table-hover",
    staticStyle: {
      "margin": "0px"
    }
  }, [_c('tbody', _vm._l((_vm.surveyGroupList), function(group, key) {
    return _c('tr', {
      key: key
    }, [_c('td', {
      staticStyle: {
        "padding": "4px",
        "width": "20%"
      }
    }, [_c('div', {
      staticClass: "checkbox",
      staticStyle: {
        "margin": "0px"
      }
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (
          _vm.currentVisibilitySettings.selectedGroups
        ),
        expression: "\n                                      currentVisibilitySettings.selectedGroups\n                                    "
      }],
      attrs: {
        "type": "checkbox",
        "id": 'cb_visibilitygroups_' + key
      },
      domProps: {
        "value": key,
        "checked": Array.isArray(
          _vm.currentVisibilitySettings.selectedGroups
        ) ? _vm._i(
          _vm.currentVisibilitySettings.selectedGroups, key) > -1 : (
          _vm.currentVisibilitySettings.selectedGroups
        )
      },
      on: {
        "change": function($event) {
          var $$a =
            _vm.currentVisibilitySettings.selectedGroups,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = key,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.currentVisibilitySettings, "selectedGroups", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.currentVisibilitySettings, "selectedGroups", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.currentVisibilitySettings, "selectedGroups", $$c)
          }
        }
      }
    }), _vm._v(" "), _vm._m(1, true)])])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "font-size": "16px",
        "padding": "6px",
        "width": "80%"
      }
    }, [_c('label', {
      staticClass: "text-black nopadding",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "role": "button",
        "for": 'cb_visibilitygroups_' + key
      }
    }, [_vm._v(_vm._s(group))])])])
  }), 0)])])])])]), _vm._v(" "), (
    _vm.globals.isAccessAllowed(
      'LoopOp_SurveyTranslationLocales_Read'
    )
  ) ? _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingEditSurveyLocalization",
      "data-toggle": "collapse",
      "data-parent": "#accordionEditSurvey",
      "href": "#collapseEditSurveyLocalization",
      "aria-expanded": "false",
      "aria-controls": "collapseEditSurveyLocalization"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.U1017))])])]) : _vm._e(), _vm._v(" "), (
    _vm.globals.isAccessAllowed(
      'LoopOp_SurveyTranslationLocales_Read'
    )
  ) ? _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseEditSurveyLocalization",
      "role": "tabpanel",
      "aria-labelledby": "headingEditSurveyLocalization"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputNewLanguage"
    }
  }, [_vm._v(_vm._s(_vm.lang.U1018))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "inputNewLanguage",
      "placeholder": _vm.lang.U1067,
      "allowClear": true
    },
    on: {
      "change": function($event) {
        _vm.getLocales(), (_vm.newSurveyLanguageLocale = null)
      }
    },
    model: {
      value: (_vm.newSurveyLanguage),
      callback: function($$v) {
        _vm.newSurveyLanguage = $$v
      },
      expression: "newSurveyLanguage"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.languageList), function(language, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": key
      }
    }, [_vm._v("\n                            " + _vm._s(language) + "\n                          ")])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputNewLanguageLocale"
    }
  }, [_vm._v(_vm._s(_vm.lang.U1059))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "inputNewLanguageLocale",
      "placeholder": _vm.lang.U1068,
      "allowClear": true,
      "disabled": !_vm.newSurveyLanguage ||
        _vm.languageLocaleList.length < 1
    },
    model: {
      value: (_vm.newSurveyLanguageLocale),
      callback: function($$v) {
        _vm.newSurveyLanguageLocale = $$v
      },
      expression: "newSurveyLanguageLocale"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.languageLocaleList), function(locale) {
    return _c('option', {
      key: locale.LocaleCode,
      domProps: {
        "value": locale.CountryCode
      }
    }, [_vm._v("\n                            " + _vm._s(locale.CountryName) + "\n                          ")])
  })], 2)], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    staticStyle: {
      "margin-top": "0px"
    },
    attrs: {
      "id": "addNewSurveyLanguage",
      "type": "button",
      "disabled": !_vm.newSurveyLanguageLocale
    },
    on: {
      "click": function($event) {
        return _vm.addNewSurveyLanguage()
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.U1019) + "\n                      ")])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-hover",
    staticStyle: {
      "margin": "0px"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.U1020) + "\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.U1069) + "\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.U1021) + "\n                        ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.surveyData.SurveySelectedLanguages), function(lang, key) {
    return _c('tr', {
      key: key
    }, [_c('td', [_vm._v("\n                          " + _vm._s(_vm.getLocaleString(
      lang.LanguageCode,
      lang.CountryCode
    )) + "\n                        ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "0px"
      }
    }, [_c('div', {
      staticClass: "radio",
      staticStyle: {
        "margin": "0px"
      }
    }, [_c('label', {
      staticStyle: {
        "margin-top": "9px"
      }
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "name": "rd_defaultRepLanguage",
        "id": 'rd_defaultRepLanguage_' + key
      },
      domProps: {
        "value": key,
        "checked": lang.IsDefault
      },
      on: {
        "change": function($event) {
          return _vm.setDefaultSurveyLanguage(key)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "circle"
    }), _vm._v(" "), _c('span', {
      staticClass: "check"
    })])])]), _vm._v(" "), _c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticStyle: {
        "float": "none"
      }
    }, [_c('button', {
      staticClass: "btn",
      staticStyle: {
        "padding": "0px",
        "margin": "7px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeSelectedLanguage(
            lang.LanguageCode,
            lang.CountryCode
          )
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24",
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("clear")])])])])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingEditSurveyAttachment",
      "data-toggle": "collapse",
      "data-parent": "#accordionEditSurvey",
      "href": "#collapseEditSurveyAttachment",
      "aria-expanded": "false",
      "aria-controls": "collapseEditSurveyAttachment"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.U1022))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseEditSurveyAttachment",
      "role": "tabpanel",
      "aria-labelledby": "headingEditSurveyAttachment"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputAttachmentName"
    }
  }, [_vm._v(_vm._s(_vm.lang.U1023))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.surveyData.SurveyAttachments[0].DownloadDescription
      ),
      expression: "\n                          surveyData.SurveyAttachments[0].DownloadDescription\n                        "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputAttachmentName"
    },
    domProps: {
      "value": (
        _vm.surveyData.SurveyAttachments[0].DownloadDescription
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.surveyData.SurveyAttachments[0], "DownloadDescription", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-files"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputSurveyAttachmentFile"
    }
  }, [_vm._v(_vm._s(_vm.lang.U1024))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    staticClass: "form-control",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "id": "inputSurveyAttachmentFile",
      "type": "file",
      "title": _vm.lang.U1034
    },
    on: {
      "change": _vm.onSurveyAttachmentFileChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [(
    !_vm.surveyData.SurveyAttachments[0].DownloadFileName
  ) ? _c('label', {
    staticStyle: {
      "padding-top": "12px"
    }
  }, [_vm._v(_vm._s(_vm.lang.U1025))]) : _c('label', {
    staticStyle: {
      "padding-top": "12px"
    }
  }, [_vm._v(_vm._s(_vm.surveyData.SurveyAttachments[0].DownloadFileName))]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('span', {
    staticClass: "input-group-btn input-group-sm"
  }, [_c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button",
      "title": _vm.lang.U1035,
      "disabled": !_vm.surveyData.SurveyAttachments[0].DownloadId
    },
    on: {
      "click": function($event) {
        return _vm.globals.downloadFile(
          _vm.surveyData.SurveyAttachments[0].DownloadId
        )
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("file_download")])])]), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn input-group-sm"
  }, [_c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button",
      "title": _vm.lang.U1036,
      "disabled": !_vm.surveyData.SurveyAttachments[0].DownloadId
    },
    on: {
      "click": function($event) {
        return _vm.removeSurveyAttachmentFile()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("clear")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingEditSurveyOthers",
      "data-toggle": "collapse",
      "data-parent": "#accordionEditSurvey",
      "href": "#collapseEditSurveyOthers",
      "aria-expanded": "false",
      "aria-controls": "collapseEditSurveyOthers"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.U1026))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseEditSurveyOthers",
      "role": "tabpanel",
      "aria-labelledby": "headingEditSurveyOthers"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group form-group-files"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputSurveyLogoFile"
    }
  }, [_vm._v(_vm._s(_vm.lang.U1027))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    staticClass: "form-control",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "id": "inputSurveyLogoFile",
      "type": "file",
      "accept": ".jpg, .jpeg, .png, .bmp",
      "title": _vm.lang.U1034
    },
    on: {
      "change": _vm.onSurveyLogoFileChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [(!_vm.surveyData.SurveyLogoFileName) ? _c('label', {
    staticStyle: {
      "padding-top": "12px"
    }
  }, [_vm._v(_vm._s(_vm.lang.U1028))]) : _c('label', {
    staticStyle: {
      "padding-top": "12px"
    }
  }, [_vm._v(_vm._s(_vm.surveyData.SurveyLogoFileName))]), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('span', {
    staticClass: "input-group-btn input-group-sm"
  }, [_c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button",
      "id": "showSurveyLogoButton",
      "title": _vm.lang.U1035,
      "disabled": !_vm.surveyData.SurveyLogoId
    },
    on: {
      "click": function($event) {
        return _vm.globals.downloadFile(_vm.surveyData.SurveyLogoId)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("file_download")])])]), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn input-group-sm"
  }, [_c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button",
      "title": _vm.lang.U1036,
      "disabled": !_vm.surveyData.SurveyLogoId
    },
    on: {
      "click": function($event) {
        return _vm.removeSurveyLogoFile()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("clear")])])])]), _vm._v(" "), (_vm.surveyData.SurveyLogoId) ? _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "inputSurveyLogoFile",
      "delay": _vm.globals.tooltipDelay,
      "placement": "left"
    }
  }, [_c('img', {
    attrs: {
      "src": '/api/Download/' + _vm.surveyData.SurveyLogoId,
      "height": "200"
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputMinimumAttachments"
    }
  }, [_vm._v(_vm._s(_vm.lang.U1029))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.surveyData.SurveyMinimumAttachments),
      expression: "surveyData.SurveyMinimumAttachments"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "inputMinimumAttachments",
      "min": "0",
      "max": "100",
      "step": "1"
    },
    domProps: {
      "value": (_vm.surveyData.SurveyMinimumAttachments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.surveyData, "SurveyMinimumAttachments", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "checkbox col-md-3"
  }, [_c('label', {
    staticClass: "pull-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.surveyData.SurveyShowAttachmentsPage),
      expression: "surveyData.SurveyShowAttachmentsPage"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.surveyData.SurveyShowAttachmentsPage) ? _vm._i(_vm.surveyData.SurveyShowAttachmentsPage, null) > -1 : (_vm.surveyData.SurveyShowAttachmentsPage)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.surveyData.SurveyShowAttachmentsPage,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.surveyData, "SurveyShowAttachmentsPage", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.surveyData, "SurveyShowAttachmentsPage", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.surveyData, "SurveyShowAttachmentsPage", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(4), _vm._v("\n                        " + _vm._s(_vm.lang.U1074) + "\n                      ")])])])])])])]), _vm._v(" "), _c('b-alert', {
    attrs: {
      "variant": "danger",
      "dismissible": "",
      "show": _vm.showAlert
    },
    on: {
      "dismissed": function($event) {
        _vm.showAlert = false
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.U0021))])], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.U0022) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "id": "survey-management-edit-modal-save-button",
      "type": "button",
      "disabled": !_vm.globals.isAccessAllowed('LoopOp_Surveys_Update') &&
        !_vm.dialogModeAdd
    },
    on: {
      "click": function($event) {
        return _vm.validateBeforeSubmit('editSurveyDialog')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.U0023) + "\n          ")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn input-group-sm"
  }, [_c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("attach_file")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn input-group-sm"
  }, [_c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("attach_file")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
}]}

/***/ }),
/* 1705 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "CustomPropertiesFormGenerator"
    }
  }, _vm._l((_vm.propertiesFormSchema), function(property) {
    return _c('div', {
      key: property.Guid
    }, [(property.ChildProperties) ? _c('div', {
      staticClass: "col-md-12"
    }, [_c('h4', {
      staticClass: "propertyThemeTitle"
    }, [_vm._v(_vm._s(property.Title))])]) : _vm._e(), _vm._v(" "), (property.ChildProperties) ? _vm._l((property.ChildProperties), function(childProperty) {
      return _c('div', {
        key: childProperty.Guid
      }, [(
        childProperty.Type === 'Group' && childProperty.ChildProperties
      ) ? _c('h5', {
        staticClass: "propertyGroupTitle"
      }, [_vm._v("\n          " + _vm._s(childProperty.Title) + "\n          "), _c('button', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (
            childProperty.Dynamic &&
            childProperty.ChildProperties &&
            childProperty.ChildProperties[0]
          ),
          expression: "\n              childProperty.Dynamic &&\n              childProperty.ChildProperties &&\n              childProperty.ChildProperties[0]\n            "
        }],
        staticClass: "btn btn-default btn-fab btn-fab-mini",
        attrs: {
          "disabled": !_vm.globals.isAccessAllowed(
            'LoopOp_ShopperProperties_Shopper_Update'
          )
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.addDynamicGroup(childProperty)
          }
        }
      }, [_c('i', {
        staticClass: "material-icons text-green"
      }, [_vm._v("add")])])]) : _vm._e(), _vm._v(" "), (childProperty.Dynamic && childProperty.ValueGroups) ? _vm._l((childProperty.ValueGroups), function(valueGroup) {
        return _c('div', {
          key: valueGroup.ValueGroupGuid,
          staticClass: "col-md-12"
        }, [_c('div', {
          staticClass: "dynamicGroupBorder"
        }, [_vm._l((childProperty.ChildProperties), function(property) {
          return _c('div', {
            key: property.Guid,
            staticClass: "col-md-11"
          }, [_c(((property.PropertyType) + "Input"), _vm._b({
            tag: "component",
            attrs: {
              "value": _vm.getShopperValues(property, valueGroup),
              "readOnly": !_vm.globals.isAccessAllowed(
                'LoopOp_ShopperProperties_Shopper_Update'
              )
            },
            on: {
              "input": function($event) {
                return _vm.updateShopperValues(property, valueGroup, $event)
              }
            }
          }, 'component', property, false))], 1)
        }), _vm._v(" "), _c('div', [_c('button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (childProperty.Dynamic),
            expression: "childProperty.Dynamic"
          }],
          staticClass: "btn btn-default btn-fab btn-fab-mini btn-clear",
          attrs: {
            "disabled": !_vm.globals.isAccessAllowed(
              'LoopOp_ShopperProperties_Shopper_Update'
            )
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.removeDynamicGroup(
                childProperty,
                valueGroup.ValueGroupGuid
              )
            }
          }
        }, [_c('i', {
          staticClass: "material-icons text-red"
        }, [_vm._v("clear")])])])], 2)])
      }) : (childProperty.Type === 'Property') ? [_c('div', {
        staticClass: "col-md-12 nonDynamicGroup"
      }, [_c(((childProperty.PropertyType) + "Input"), _vm._b({
        tag: "component",
        attrs: {
          "value": _vm.getShopperValues(childProperty, null),
          "readOnly": !_vm.globals.isAccessAllowed(
            'LoopOp_ShopperProperties_Shopper_Update'
          )
        },
        on: {
          "input": function($event) {
            return _vm.updateShopperValues(childProperty, null, $event)
          }
        }
      }, 'component', childProperty, false))], 1)] : _vm._e()], 2)
    }) : _vm._e()], 2)
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 1706 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "changelogModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, _vm._l((_vm.changelog), function(content, version) {
    return _c('div', {
      key: version
    }, [(
      version === 'dev' && ['dev', 'training', 'dev-audi', 'training-audi'].indexOf(
        _vm.feature.currentTarget
      ) > -1
    ) ? [_c('span', {
      staticClass: "version-number"
    }, [_vm._v("In Progress")]), _vm._v(" "), _vm._l((content.changes), function(entry, index) {
      return _c('div', {
        key: index,
        staticClass: "change-entry"
      }, [_vm._v("\n              ● " + _vm._s(entry) + "\n            ")])
    }), _vm._v(" "), _c('hr')] : _vm._e(), _vm._v(" "), (version !== 'dev') ? [_c('span', {
      staticClass: "version-number"
    }, [_vm._v("v" + _vm._s(version))]), _vm._v(" "), _c('span', {
      staticClass: "version-date"
    }, [_vm._v("(" + _vm._s(content.date) + ")")]), _vm._v(" "), _vm._l((content.changes), function(entry, index) {
      return _c('div', {
        key: index,
        staticClass: "change-entry"
      }, [_vm._v("\n              ● " + _vm._s(entry) + "\n            ")])
    }), _vm._v(" "), _c('hr')] : _vm._e()], 2)
  }), 0), _vm._v(" "), _vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v("Changelog")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          Close\n        ")])])
}]}

/***/ }),
/* 1707 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "table table-striped table-hover main-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('AgencyId')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.AM2000) + "\n            "), (_vm.showSortArrow('AgencyId', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('AgencyId', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('AgencyName')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.AM2001) + "\n            "), (_vm.showSortArrow('AgencyName', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('AgencyName', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('AgencyAddress')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.AM2002) + "\n            "), (_vm.showSortArrow('AgencyAddress', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('AgencyAddress', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('AgencyAddress2')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.AM2007) + "\n            "), (_vm.showSortArrow('AgencyAddress2', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('AgencyAddress2', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('AgencyCity')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.AM2003) + "\n            "), (_vm.showSortArrow('AgencyCity', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('AgencyCity', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('AgencyState_Region')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.AM2004) + "\n            "), (_vm.showSortArrow('AgencyState_Region', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('AgencyState_Region', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('AgencyPostalCode')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.AM2005) + "\n            "), (_vm.showSortArrow('AgencyPostalCode', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('AgencyPostalCode', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('AgencyCountry')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.AM2006) + "\n            "), (_vm.showSortArrow('AgencyCountry', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('AgencyCountry', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('AgencySinceDate')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.AM2008) + "\n            "), (_vm.showSortArrow('AgencySinceDate', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('AgencySinceDate', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])])])]), _vm._v(" "), _c('tbody', {
    staticClass: "main-table-scrollbar"
  }, _vm._l((_vm.pagedAgencies), function(agency) {
    return _c('tr', {
      key: agency.AgencyId,
      class: {
        info: agency.AgencyGuid === _vm.selectedAgency.AgencyGuid,
        'text-bold': agency.AgencyTypeName === 'Lead',
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.selectAgency(agency)
        },
        "dblclick": function($event) {
          return _vm.openEditAgency(agency)
        }
      }
    }, [_c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [_vm._v(_vm._s(agency.AgencyId))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(agency.AgencyName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(agency.AgencyAddress))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(agency.AgencyAddress2))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(agency.AgencyCity))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(agency.AgencyState_Region))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [_vm._v(_vm._s(agency.AgencyPostalCode))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [_vm._v(_vm._s(agency.AgencyCountry))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(agency.AgencySince))])])
  }), 0)])])
},staticRenderFns: []}

/***/ }),
/* 1708 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (
    _vm.globals.isAccessAllowed('LoopOp_Shopper_ReadAll') &&
    !(
      _vm.feature.isAudiTarget &&
      (_vm.globals.isLeadAgencyUser || _vm.globals.isAudiUser)
    )
  ) ? _c('div', {
    attrs: {
      "id": "shoppermanagement"
    }
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "shoppermanagement-top-panel"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "shopper-management-refresh-button",
      "disabled": !_vm.refreshEnabled
    },
    on: {
      "click": function($event) {
        return _vm.getShoppersList()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("refresh")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.SM0000) + "\n        ")]), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Shopper_Create')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "shopper-management-create-button"
    },
    on: {
      "click": function($event) {
        (_vm.editShopperDialogModeAdd = true),
        (_vm.selectedShopper = {}),
        _vm.openEditShopperDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("add_box")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.SM0001) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Shopper_Read')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.isShopperSelected()
    },
    on: {
      "click": function($event) {
        (_vm.editShopperDialogModeAdd = false), _vm.openEditShopperDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("edit")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.SM0002) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Shopper_Delete')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "shopper-management-delete-button",
      "disabled": !_vm.isShopperSelected()
    },
    on: {
      "click": function($event) {
        return _vm.openDeleteShopperConfirmationDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("clear")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.SM0017) + "\n        ")]) : _vm._e(), _vm._v(" "), (
    _vm.globals.isAccessAllowed('LoopOp_Password_ChangePassword') &&
    _vm.globals.isAccessAllowed('LoopOp_Password_ValidatePassword') &&
    !_vm.globals.isAgencyUser
  ) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.isShopperSelected()
    },
    on: {
      "click": function($event) {
        return _vm.openChangePasswordDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("vpn_key")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.SM0018) + "\n        ")]) : _vm._e(), _vm._v(" "), (
    _vm.globals.isAccessAllowed('LoopOp_ShopperProperties_ReadAll') &&
    !_vm.globals.isAgencyUser
  ) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    on: {
      "click": function($event) {
        return _vm.openCustomPropertyDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("assignment")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.SM0003) + "\n        ")]) : _vm._e(), _vm._v(" "), (
    _vm.globals.isAccessAllowed(
      'LoopOp_ShopperSurveyInstances_ReadAll'
    ) && !_vm.feature.isAudiTarget
  ) ? _c('router-link', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "tag": "button",
      "disabled": !_vm.isShopperSelected(),
      "to": ("shoppermanagement/checks?selectedShopperGuid=" + (_vm.selectedShopper.ShopperGuid))
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("list")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.SM0025) + "\n        ")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-lg-7"
  }, [_c('div', {
    staticClass: "form-group searchbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Search),
      expression: "filterStrings.Search"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "search",
      "id": "inputSearch",
      "placeholder": _vm.lang.SM0004
    },
    domProps: {
      "value": (_vm.filterStrings.Search)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getShoppersList()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Search", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5 nopadding"
  }, [_c('ul', {
    staticClass: "pagination-fonts pagination btn-group"
  }, [_c('li', [_vm._m(0), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "elementsPerPageDropdown",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SM0005))]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 20
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 20)
      }
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 50
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 50)
      }
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 100
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 100)
      }
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 200
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 200)
      }
    }
  }, [_vm._v("200")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 500
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 500)
      }
    }
  }, [_vm._v("500")])])])], 1), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.pageCount || _vm.selectedPage == 1
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 0)
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "firstPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SM0006))])], 1), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage > 4) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getVisiblePages()), function(pageNumber) {
    return _c('li', {
      key: pageNumber,
      class: {
        active: _vm.selectedPage == pageNumber
      },
      on: {
        "click": function($event) {
          return _vm.updatePaging(pageNumber, 0)
        }
      }
    }, [_c('a', {
      attrs: {
        "role": "button"
      }
    }, [_vm._v(_vm._s(pageNumber))])])
  }), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage < _vm.pageCount - 3) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.pageCount || _vm.selectedPage == _vm.pageCount,
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(_vm.pageCount, 0)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "lastPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SM0007))])], 1), _vm._v(" "), _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button",
      "id": "shoppersTotalElementsCounter"
    }
  }, [_vm._v(_vm._s(_vm.totalElementsCount))]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "shoppersTotalElementsCounter",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SM0035))])], 1)], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    staticClass: "table table-striped table-hover main-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "6%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('ShopperId')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SA0021) + "\n                "), (_vm.showSortArrow('ShopperId', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('ShopperId', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('Username')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SM0010) + "\n                "), (_vm.showSortArrow('Username', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('Username', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('FirstName')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SM0008) + "\n                "), (_vm.showSortArrow('FirstName', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('FirstName', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('LastName')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SM0009) + "\n                "), (_vm.showSortArrow('LastName', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('LastName', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('Gender')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SM0011) + "\n                "), (_vm.showSortArrow('Gender', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('Gender', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('PostalCode')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SM0012) + "\n                "), (_vm.showSortArrow('PostalCode', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('PostalCode', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('City')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SM0013) + "\n                "), (_vm.showSortArrow('City', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('City', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('CountryCode')
      }
    }
  }, [_vm._v("\n                Land\n                "), (_vm.showSortArrow('CountryCode', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('CountryCode', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "14%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('Email')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SM0014) + "\n                "), (_vm.showSortArrow('Email', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('Email', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('Age')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SM0015) + "\n                "), (_vm.showSortArrow('Age', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('Age', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('NumberOfChecks')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SM0016) + "\n                "), (_vm.showSortArrow('NumberOfChecks', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('NumberOfChecks', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('Active')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SM0034) + "\n                "), (_vm.showSortArrow('Active', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('Active', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])])]), _vm._v(" "), _c('tr', {
    staticClass: "table-filters"
  }, [_c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "6%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ShopperId),
      expression: "filterStrings.ShopperId"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SM0019
    },
    domProps: {
      "value": (_vm.filterStrings.ShopperId)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getShoppersList()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ShopperId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Username),
      expression: "filterStrings.Username"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SM0019
    },
    domProps: {
      "value": (_vm.filterStrings.Username)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getShoppersList()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Username", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.FirstName),
      expression: "filterStrings.FirstName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SM0019
    },
    domProps: {
      "value": (_vm.filterStrings.FirstName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getShoppersList()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "FirstName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LastName),
      expression: "filterStrings.LastName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SM0019
    },
    domProps: {
      "value": (_vm.filterStrings.LastName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getShoppersList()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LastName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Gender),
      expression: "filterStrings.Gender"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SM0019
    },
    domProps: {
      "value": (_vm.filterStrings.Gender)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getShoppersList()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Gender", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.PostalCode),
      expression: "filterStrings.PostalCode"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SM0019
    },
    domProps: {
      "value": (_vm.filterStrings.PostalCode)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getShoppersList()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "PostalCode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.City),
      expression: "filterStrings.City"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SM0019
    },
    domProps: {
      "value": (_vm.filterStrings.City)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getShoppersList()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "City", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.CountryCode),
      expression: "filterStrings.CountryCode"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SM0019
    },
    domProps: {
      "value": (_vm.filterStrings.CountryCode)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getShoppersList()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "CountryCode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "14%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Email),
      expression: "filterStrings.Email"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SM0019
    },
    domProps: {
      "value": (_vm.filterStrings.Email)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getShoppersList()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Age),
      expression: "filterStrings.Age"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SM0019
    },
    domProps: {
      "value": (_vm.filterStrings.Age)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getShoppersList()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Age", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.NumberOfChecks),
      expression: "filterStrings.NumberOfChecks"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SM0019
    },
    domProps: {
      "value": (_vm.filterStrings.NumberOfChecks)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getShoppersList()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "NumberOfChecks", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        _vm.updateActiveFilter(), _vm.getShoppersList()
      }
    }
  }, [(_vm.filterStrings.Active === 'true') ? _c('div', {
    staticClass: "cb-active-filter-container"
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box")])]) : (_vm.filterStrings.Active === 'false') ? _c('div', {
    staticClass: "cb-active-filter-container"
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")])]) : _c('div', {
    staticClass: "cb-active-filter-container"
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("indeterminate_check_box")])])])])])])]), _vm._v(" "), _c('tbody', {
    staticClass: "main-table-scrollbar"
  }, _vm._l((_vm.shoppersList), function(shopper) {
    return _c('tr', {
      key: shopper.ShopperGuid,
      class: {
        info: shopper.ShopperGuid === _vm.selectedShopper.ShopperGuid,
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          _vm.selectedShopper = shopper
        },
        "dblclick": function($event) {
          !_vm.globals.isAccessAllowed('LoopOp_Shopper_Read') ||
            ((_vm.editShopperDialogModeAdd = false), _vm.openEditShopperDialog())
        }
      }
    }, [_c('td', {
      staticStyle: {
        "width": "6%"
      }
    }, [_vm._v(_vm._s(shopper.ShopperId))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(shopper.Username))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(shopper.FirstName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(shopper.LastName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [_vm._v(_vm._s(shopper.Gender))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(shopper.PostalCode))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(shopper.City))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [_vm._v(_vm._s(shopper.CountryCode))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "14%"
      }
    }, [_vm._v(_vm._s(shopper.Email))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [_vm._v(_vm._s(shopper.Age))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(shopper.NumberOfChecks))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "5%",
        "padding": "6px 0 0 0"
      }
    }, [(shopper.Active) ? _c('i', {
      staticClass: "material-icons md-24 text-green"
    }, [_vm._v("done")]) : _c('i', {
      staticClass: "material-icons md-24 text-red"
    }, [_vm._v("clear")])])])
  }), 0)])])]), _vm._v(" "), _c('shopper-edit-modal', {
    attrs: {
      "showDialog": _vm.showEditShopperDataDialog,
      "occupationalGroupList": _vm.occupationalGroupList,
      "dialogModeAdd": _vm.editShopperDialogModeAdd,
      "selectedShopperGuid": _vm.selectedShopper.ShopperGuid
    },
    on: {
      "dialogClosed": _vm.onEditShopperDataClosed,
      "dialogDataSaved": _vm.onEditShopperDialogDataSaved
    }
  }), _vm._v(" "), _c('custom-property-edit-modal', {
    attrs: {
      "showDialog": _vm.showCustomPropertyEditDialog
    },
    on: {
      "dialogClosed": _vm.onCustomPropertyDialogClosed
    }
  }), _vm._v(" "), _c('change-password-dialog', {
    attrs: {
      "showDialog": _vm.showChangePasswordDialog,
      "userGuid": _vm.selectedShopper.ShopperGuid,
      "userName": _vm.selectedShopper.Username
    },
    on: {
      "dialogClosed": _vm.onChangePasswordDialogClosed
    }
  })], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "role": "button",
      "data-toggle": "dropdown",
      "id": "elementsPerPageDropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("view_headline")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "firstPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("first_page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "lastPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("last_page")])])
}]}

/***/ }),
/* 1709 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.globals.isAccessAllowed('LoopOp_SurveyInstances_ReadAll') && _vm.globals.currentUserRole < 3) ? _c('div', [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "checks-top-panel"
    }
  }, [_c('div', {
    staticClass: "panel-body top-button-bar"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.refreshEnabled
    },
    on: {
      "click": function($event) {
        return _vm.getCheckData()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("refresh")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.CM0000) + "\n        ")]), _vm._v(" "), (
    _vm.globals.isAccessAllowed('LoopOp_SurveyInstances_Create') &&
    _vm.globals.isAccessAllowed('LoopOp_SurveyInstancesLocations_ReadAll') &&
    (!_vm.feature.isAudiTarget || !_vm.globals.isAgencyUser)) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "check-management-create-button"
    },
    on: {
      "click": function($event) {
        (_vm.selectedChecks = []),
        (_vm.selectedCheckIds = []),
        (_vm.showAddChecksDialog = true)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("add_box")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.CM0001) + "\n        ")]) : _vm._e(), _vm._v(" "), (
    _vm.globals.isAccessAllowed('LoopOp_SurveyInstancesProperties_Update') &&
    _vm.globals.isAccessAllowed('LoopOp_SurveyInstancesProperties_Create') &&
    (!_vm.feature.isAudiTarget || !_vm.globals.isAgencyUser)) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "check-management-edit-button",
      "disabled": _vm.includeChecks ? _vm.selectedCheckIds.length == 0 : _vm.selectedCheckIds.length == _vm.checkCount
    },
    on: {
      "click": function($event) {
        _vm.showEditChecksDialog = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("edit")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.CM0002) + "\n        ")]) : _vm._e(), _vm._v(" "), (
    _vm.feature.isEnabled('settlement') &&
    _vm.globals.isPaymentsReadingAllowed &&
    !_vm.feature.isAudiTarget) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": _vm.selectedChecks.length === 0
    },
    on: {
      "click": function($event) {
        _vm.showCheckPaymentModal = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("attach_money")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.CM0061) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.feature.isAudiTarget && _vm.globals.isLeadAgencyUser) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "check-management-assign-agency-button",
      "disabled": _vm.selectedChecks.length < 1
    },
    on: {
      "click": function($event) {
        _vm.showCheckLocalAgencyAssignmentModal = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("assignment")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.CM0075) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.feature.isAudiTarget && _vm.globals.isLeadAgencyUser) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "check-management-copy-check-button",
      "disabled": _vm.selectedChecks.length < 1
    },
    on: {
      "click": function($event) {
        return _vm.cloneSelectedChecks()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("content_copy")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.CM0076) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_SurveyInstancesExport_Create')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.selectedClient
    },
    on: {
      "click": function($event) {
        _vm.showExportModal = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("get_app")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.CM0004) + "\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.globals.isAgencyUser) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": _vm.selectedChecks.length < 1 || _vm.globals.isAgencyUser
    },
    on: {
      "click": function($event) {
        return _vm.showAutovalidationDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("assignment_turned_in")]), _vm._v(" "), _c('br'), _vm._v("Autovalidate\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_SurveyInstancesAnswers_Read')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar top-btn-primary",
    attrs: {
      "disabled": _vm.selectedCheckIds.length < 1
    },
    on: {
      "click": function($event) {
        return _vm.openChecks()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("zoom_in")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.CM0005) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAudiUser) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": _vm.selectedCheckIds.length != 1
    },
    on: {
      "click": function($event) {
        return _vm.showCheckHistory()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("history")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.CM0080) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 nopadding"
  }, [_c('div', {
    staticClass: "well well-top-bar"
  }, [_c('div', {
    staticClass: "form-group selectbar"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "id": "statusCodeUpdateSelection"
    }
  }, [_c('a', {
    staticClass: "btn btn-default btn-raised",
    attrs: {
      "role": "button",
      "disabled": !_vm.selectedStatusCode ||
        _vm.selectedChecks.length == 0 ||
        !_vm.globals.isAccessAllowed('LoopOp_SurveyInstances_Update')
    },
    on: {
      "click": function($event) {
        return _vm.changeSelectedChecksStatus()
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.CM0006) + ": " + _vm._s(_vm.selectedStatusCode))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default btn-raised dropdown-toggle",
    class: {
      disabled: _vm.allowedStatusCodes.length < 1 || !_vm.globals.isAccessAllowed('LoopOp_SurveyInstances_Update'),
    },
    attrs: {
      "role": "button",
      "data-toggle": "dropdown",
      "disabled": _vm.allowedStatusCodes.length < 1 ||
        !_vm.globals.isAccessAllowed('LoopOp_SurveyInstances_Update')
    }
  }, [_c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, _vm._l((_vm.allowedStatusCodes), function(code, key) {
    return _c('li', {
      key: key
    }, [_c('a', {
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          _vm.selectedStatusCode = code
        }
      }
    }, [_vm._v(_vm._s(_vm.getStatusCodeDescription(code)))])])
  }), 0)]), _vm._v(" "), (
    !_vm.filterStrings.SurveyInstanceStatusId &&
    _vm.globals.isAccessAllowed('LoopOp_SurveyInstances_Update')) ? _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "statusCodeUpdateSelection",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.CM0046))]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "btn btn-raised",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.togglePageSelected()
      }
    }
  }, [(_vm.isPageSelected() ? !_vm.includeChecks : _vm.includeChecks) ? _c('span', [_vm._v(_vm._s(_vm.lang.CM0007))]) : _c('span', [_vm._v(_vm._s(_vm.lang.CM0008))])]), _vm._v(" "), (
    _vm.feature.isEnabled('settlement') &&
    _vm.globals.isPaymentsReadingAllowed &&
    !_vm.feature.isAudiTarget) ? _c('button', {
    staticClass: "btn btn-raised btn-success",
    on: {
      "click": function($event) {
        _vm.showSettlementDownloadModal = true
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.CM0059) + "\n            ")]) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-lg-6",
    staticStyle: {
      "min-height": "50px"
    }
  }, [_c('div', {
    staticClass: "form-group selectbar nopadding"
  }, [(!_vm.feature.isAudiTarget || !_vm.feature.isEnabled('audi_importers')) ? _c('div', {
    staticClass: "select-filter-container"
  }, [_c('select2', {
    ref: "clientSelect",
    staticClass: "form-control",
    attrs: {
      "id": "check-management-clients-selector",
      "placeholder": _vm.lang.CM0011,
      "allowClear": true
    },
    on: {
      "change": function($event) {
        return _vm.onClientSelection()
      }
    },
    model: {
      value: (_vm.selectedClient),
      callback: function($$v) {
        _vm.selectedClient = $$v
      },
      expression: "selectedClient"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.dataLists.clientList), function(client) {
    return _c('option', {
      key: client.ClientGuid,
      domProps: {
        "value": client.ClientGuid
      }
    }, [_vm._v("\n                " + _vm._s(client.ClientName) + "\n              ")])
  })], 2)], 1) : _c('div', {
    staticClass: "select-filter-container"
  }, [_c('select2', {
    ref: "importerSelect",
    staticClass: "form-control",
    attrs: {
      "id": "check-management-importer-selector",
      "placeholder": _vm.lang.CM0074,
      "allowClear": true
    },
    on: {
      "change": function($event) {
        return _vm.getCheckData()
      }
    },
    model: {
      value: (_vm.selectedImporter),
      callback: function($$v) {
        _vm.selectedImporter = $$v
      },
      expression: "selectedImporter"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.dataLists.importerList), function(importer) {
    return _c('option', {
      key: importer.ImporterGuid,
      domProps: {
        "value": importer.ImporterGuid
      }
    }, [_vm._v("\n                " + _vm._s(importer.ImporterName) + "\n              ")])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "select-filter-container"
  }, [_c('select2', {
    ref: "projectSelect",
    staticClass: "form-control",
    attrs: {
      "id": "check-management-project-selector",
      "disabled": !_vm.selectedClient,
      "placeholder": _vm.lang.CM0048,
      "allowClear": true
    },
    on: {
      "change": function($event) {
        return _vm.onProjectSelection()
      }
    },
    model: {
      value: (_vm.selectedProject),
      callback: function($$v) {
        _vm.selectedProject = $$v
      },
      expression: "selectedProject"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.dataLists.projectsOfClient), function(project) {
    return _c('option', {
      key: project.ProjectGuid,
      domProps: {
        "value": project.ProjectGuid
      }
    }, [_vm._v("\n                " + _vm._s(project.ProjectName) + "\n              ")])
  })], 2)], 1), _vm._v(" "), (_vm.globals.currentUserRole < 2 && !_vm.feature.isAudiTarget) ? _c('div', {
    staticClass: "select-filter-container",
    class: {
      'width-15': _vm.selectedCheckType === 'FO'
    }
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.lang.CM0066,
      "allowClear": true
    },
    on: {
      "change": function($event) {
        return _vm.getCheckData()
      }
    },
    model: {
      value: (_vm.selectedCheckType),
      callback: function($$v) {
        _vm.selectedCheckType = $$v
      },
      expression: "selectedCheckType"
    }
  }, [_c('option'), _vm._v(" "), _c('option', {
    attrs: {
      "value": "FO"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM0063))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MA"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM0064))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AG"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM0065))])])], 1) : _vm._e(), _vm._v(" "), (_vm.selectedCheckType === 'FO') ? _c('div', {
    staticClass: "select-filter-container width-15"
  }, [_c('a', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin": "0 0 2px 0"
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleOnlineStateFilter()
      }
    }
  }, [(_vm.selectedOnlineState === true) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : (_vm.selectedOnlineState === false) ? _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]) : _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("indeterminate_check_box")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.CM0067))])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 nopadding"
  }, [_c('ul', {
    staticClass: "pagination-fonts pagination btn-group"
  }, [_c('li', [_vm._m(0), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "elementsPerPageDropdown",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.CM0012))]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 20
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 20)
      }
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 50
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 50)
      }
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 100
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 100)
      }
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 200
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 200)
      }
    }
  }, [_vm._v("200")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 500
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 500)
      }
    }
  }, [_vm._v("500")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 1000
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 1000)
      }
    }
  }, [_vm._v("1000")])])])], 1), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.pageCount || _vm.selectedPage == 1
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 0)
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "firstPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.CM0013))])], 1), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage > 4) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getVisiblePages()), function(pageNumber) {
    return _c('li', {
      key: pageNumber,
      class: {
        active: _vm.selectedPage == pageNumber
      },
      on: {
        "click": function($event) {
          return _vm.updatePaging(pageNumber, 0)
        }
      }
    }, [_c('a', {
      attrs: {
        "role": "button"
      }
    }, [_vm._v(_vm._s(pageNumber))])])
  }), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage < _vm.pageCount - 3) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.pageCount || _vm.selectedPage == _vm.pageCount,
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(_vm.pageCount, 0)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "lastPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.CM0014))])], 1), _vm._v(" "), _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button",
      "id": "checksTotalElementsCounter"
    }
  }, [_vm._v(_vm._s(_vm.checkCount))]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "checksTotalElementsCounter",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.CM0049))])], 1), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "btn btn-raised",
    staticStyle: {
      "margin-left": "100px"
    },
    attrs: {
      "id": "check-management-custom-settings"
    },
    on: {
      "click": function($event) {
        _vm.showCheckManagementFilterModal = true
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.CM1074) + "\n            ")])])], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    staticClass: "table",
    staticStyle: {
      "word-wrap": "break-word",
      "table-layout": "fixed"
    },
    attrs: {
      "id": "check-management-main-table"
    }
  }, [_c('thead', [_c('tr', [(_vm.CheckManagementFilter.SID) ? _c('th', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('SurveyId')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CM0015) + "\n                "), (_vm.sortField == 'SurveyId' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'SurveyId' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.CheckID) ? _c('th', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('SurveyInstanceId')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CM0016) + "\n                "), (_vm.sortField == 'SurveyInstanceId' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'SurveyInstanceId' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.CheckCode) ? _c('th', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('ShortSurveyCode')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CM0017) + "\n                "), (_vm.sortField == 'ShortSurveyCode' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'ShortSurveyCode' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Status) ? _c('th', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('SurveyInstanceStatusId')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CM0018) + "\n                "), (_vm.sortField == 'SurveyInstanceStatusId' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'SurveyInstanceStatusId' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Project) ? _c('th', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('ProjectName')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CM0019) + "\n                "), (_vm.sortField == 'ProjectName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'ProjectName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Wave) ? _c('th', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('WaveName')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CM0020) + "\n                "), (_vm.sortField == 'WaveName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'WaveName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Scenario) ? _c('th', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('ScenarioName')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CM0021) + "\n                "), (_vm.sortField == 'ScenarioName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'ScenarioName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.CheckInfo) ? _c('th', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('SurveyInstanceInfo')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CM0073) + "\n                "), (_vm.sortField == 'SurveyInstanceInfo' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'SurveyInstanceInfo' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.StoreID) ? _c('th', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('LocationStoreId')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CM0050) + "\n                "), (_vm.sortField == 'LocationStoreId' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'LocationStoreId' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.LocationName) ? _c('th', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('LocationName')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CM0051) + "\n                "), (_vm.sortField == 'LocationName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'LocationName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Address) ? _c('th', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('LocationAddress')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CM0022) + "\n                "), (_vm.sortField == 'LocationAddress' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'LocationAddress' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Country) ? _c('th', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('LocationCountry')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CM0023) + "\n                "), (_vm.sortField == 'LocationCountry' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'LocationCountry' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Visit) ? _c('th', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('SurveyInstanceAnswerDateOfVisit')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CM0024) + "\n                "), (_vm.sortField == 'SurveyInstanceAnswerDateOfVisit' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'SurveyInstanceAnswerDateOfVisit' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Internalnote) ? _c('th', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('SurveyInstanceNote')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CM0027) + "\n                "), (_vm.sortField == 'SurveyInstanceNote' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'SurveyInstanceNote' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.ExpiryDate) ? _c('th', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('SurveyInstanceUntil')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CM0028) + "\n                "), (_vm.sortField == 'SurveyInstanceUntil' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'SurveyInstanceUntil' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Agency) ? _c('th', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('SurveyInstanceResponsable')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.feature.isAudiTarget ? _vm.lang.CM0065 : _vm.lang.CM0029) + "\n                "), (_vm.sortField == 'SurveyInstanceResponsable' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'SurveyInstanceResponsable' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.feature.isAudiTarget && _vm.CheckManagementFilter.Shopper) ? _c('th', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('ApprovedShopperName')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CM0079) + "\n                "), (_vm.sortField == 'ApprovedShopperName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'ApprovedShopperName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Score) ? _c('th', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "id": "checkMgmtScoreColumnHeader",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('SurveyInstanceScore')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CM0030) + "\n                "), _c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("help_outline")]), _vm._v(" "), (_vm.sortField == 'SurveyInstanceScore' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'SurveyInstanceScore' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "checkMgmtScoreColumnHeader",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.CM0052))])], 1) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Progress) ? _c('th', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('SurveyInstanceProgress')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CM0031) + "\n                "), (_vm.sortField == 'SurveyInstanceProgress' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'SurveyInstanceProgress' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (!_vm.feature.isAudiTarget && _vm.CheckManagementFilter.Progress) ? _c('th', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "id": "checkMgmtSettlementColumnHeader",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('SettlementStatus')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CM0060) + "\n                "), _c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("help_outline")]), _vm._v(" "), (_vm.sortField == 'SettlementStatus' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'SettlementStatus' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "checkMgmtSettlementColumnHeader",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CM0068) + ":\n                "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n                + → " + _vm._s(_vm.lang.CM0069) + "\n                "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n                o → " + _vm._s(_vm.lang.CM0070) + "\n                "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n                x → " + _vm._s(_vm.lang.CM0071) + "\n                "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n                - → " + _vm._s(_vm.lang.CM0072) + "\n              ")])], 1) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Modifiedat) ? _c('th', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('SurveyInstanceModifiedAt')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CM0047) + "\n                "), (_vm.sortField == 'SurveyInstanceModifiedAt' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'SurveyInstanceModifiedAt' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('tr', {
    staticClass: "table-filters"
  }, [(_vm.CheckManagementFilter.SID) ? _c('th', {
    staticClass: "nopadding"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyId),
      expression: "filterStrings.SurveyId"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyId)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyId", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.CheckID) ? _c('th', {
    staticClass: "nopadding"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstanceId),
      expression: "filterStrings.SurveyInstanceId"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstanceId)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstanceId", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.CheckCode) ? _c('th', {
    staticClass: "nopadding"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ShortSurveyCode),
      expression: "filterStrings.ShortSurveyCode"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.ShortSurveyCode)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ShortSurveyCode", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Status) ? _c('th', {
    staticClass: "nopadding"
  }, [_c('div', {
    staticClass: "form-group filterbar",
    attrs: {
      "id": "checkMgmtStatusFilterContainer"
    }
  }, [_c('select2', {
    staticClass: "form-control nopadding",
    attrs: {
      "allowClear": true,
      "placeholder": _vm.lang.CM0032
    },
    model: {
      value: (_vm.filterStrings.SurveyInstanceStatusId),
      callback: function($$v) {
        _vm.$set(_vm.filterStrings, "SurveyInstanceStatusId", $$v)
      },
      expression: "filterStrings.SurveyInstanceStatusId"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.dataLists.statusCodes.filter(function (c) { return c.SurveyInstanceStatusId !== 900; })), function(status) {
    return _c('option', {
      key: status.SurveyInstanceStatusId,
      domProps: {
        "value": status.SurveyInstanceStatusId
      }
    }, [_vm._v("\n                    " + _vm._s(status.SurveyInstanceStatusId) + "\n                  ")])
  })], 2)], 1)]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Project) ? _c('th', {
    staticClass: "nopadding"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  })]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Wave) ? _c('th', {
    staticClass: "nopadding"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.WaveName),
      expression: "filterStrings.WaveName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.WaveName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "WaveName", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Scenario) ? _c('th', {
    staticClass: "nopadding"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ScenarioName),
      expression: "filterStrings.ScenarioName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.ScenarioName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ScenarioName", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.CheckInfo) ? _c('th', {
    staticClass: "nopadding"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstanceInfo),
      expression: "filterStrings.SurveyInstanceInfo"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstanceInfo)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstanceInfo", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.StoreID) ? _c('th', {
    staticClass: "nopadding"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationStoreId),
      expression: "filterStrings.LocationStoreId"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.LocationStoreId)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationStoreId", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.LocationName) ? _c('th', {
    staticClass: "nopadding"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationName),
      expression: "filterStrings.LocationName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.LocationName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationName", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Address) ? _c('th', {
    staticClass: "nopadding"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationAddress),
      expression: "filterStrings.LocationAddress"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.LocationAddress)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationAddress", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Country) ? _c('th', {
    staticClass: "nopadding"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationCountry),
      expression: "filterStrings.LocationCountry"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.LocationCountry)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationCountry", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Visit) ? _c('th', {
    staticClass: "nopadding"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstanceAnswerDateOfVisit),
      expression: "filterStrings.SurveyInstanceAnswerDateOfVisit"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstanceAnswerDateOfVisit)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstanceAnswerDateOfVisit", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Internalnote) ? _c('th', {
    staticClass: "nopadding"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstanceNote),
      expression: "filterStrings.SurveyInstanceNote"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstanceNote)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstanceNote", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.ExpiryDate) ? _c('th', {
    staticClass: "nopadding"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstanceUntil),
      expression: "filterStrings.SurveyInstanceUntil"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstanceUntil)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstanceUntil", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Agency) ? _c('th', {
    staticClass: "nopadding"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstanceResponsable),
      expression: "filterStrings.SurveyInstanceResponsable"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstanceResponsable)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstanceResponsable", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.feature.isAudiTarget && _vm.CheckManagementFilter.Shopper) ? _c('th', {
    staticClass: "nopadding"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ApprovedShopperName),
      expression: "filterStrings.ApprovedShopperName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.ApprovedShopperName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ApprovedShopperName", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Score) ? _c('th', {
    staticClass: "nopadding"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstanceScore),
      expression: "filterStrings.SurveyInstanceScore"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstanceScore)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstanceScore", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Progress) ? _c('th', {
    staticClass: "nopadding"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstanceProgress),
      expression: "filterStrings.SurveyInstanceProgress"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstanceProgress)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstanceProgress", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm.feature.isAudiTarget && _vm.CheckManagementFilter.Progress) ? _c('th', {
    staticClass: "nopadding"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SettlementStatus),
      expression: "filterStrings.SettlementStatus"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.SettlementStatus)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SettlementStatus", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Modifiedat) ? _c('th', {
    staticClass: "nopadding"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstanceModifiedAt),
      expression: "filterStrings.SurveyInstanceModifiedAt"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstanceModifiedAt)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstanceModifiedAt", $event.target.value)
      }
    }
  })])]) : _vm._e()])]), _vm._v(" "), _c('tbody', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.clearLastSelection),
      expression: "clearLastSelection"
    }],
    staticClass: "main-table-scrollbar"
  }, _vm._l((_vm.checkData), function(check) {
    return _c('tr', {
      key: check.SurveyInstanceId,
      class: {
        info: _vm.isCheckSelected(check.SurveyInstanceGuid) ? _vm.includeChecks : !_vm.includeChecks,
        'text-red': check.SurveyInstanceIsExpired,
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.selectCheck(check.SurveyInstanceGuid, check.SurveyInstanceId, $event)
        },
        "dblclick": function($event) {
          _vm.globals.isAccessAllowed('LoopOp_SurveyInstancesAnswers_Read') &&
            !_vm.globals.isAudiUser &&
            _vm.openCheck(check.SurveyInstanceId)
        }
      }
    }, [(_vm.CheckManagementFilter.SID) ? _c('td', [_vm._v("\n              " + _vm._s(check.SurveyId) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.CheckID) ? _c('td', [_vm._v("\n              " + _vm._s(check.SurveyInstanceId) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.CheckCode) ? _c('td', [_vm._v("\n              " + _vm._s(check.ShortSurveyCode) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Status) ? _c('td', [_vm._v("\n              " + _vm._s(check.SurveyInstanceStatusId) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Project) ? _c('td', [_vm._v("\n              " + _vm._s(check.ProjectName) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Wave) ? _c('td', [_vm._v(_vm._s(check.WaveName))]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Scenario) ? _c('td', [_vm._v("\n              " + _vm._s(check.ScenarioName) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.CheckInfo) ? _c('td', [_vm._v("\n              " + _vm._s(check.SurveyInstanceInfo) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.StoreID) ? _c('td', [_vm._v("\n              " + _vm._s(check.LocationStoreId) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.LocationName) ? _c('td', [_vm._v("\n              " + _vm._s(check.LocationName) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Address) ? _c('td', [_vm._v("\n              " + _vm._s(check.LocationAddress) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Country) ? _c('td', [_vm._v("\n              " + _vm._s(check.LocationCountry) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Visit) ? _c('td', [_vm._v("\n              " + _vm._s(check.SurveyInstanceAnswerDateOfVisit) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Internalnote) ? _c('td', {
      attrs: {
        "id": ("tdSurveyInstanceNote" + (check.SurveyInstanceId))
      }
    }, [_vm._v("\n              " + _vm._s(_vm.globals.truncateString(check.SurveyInstanceNote, 30)) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('b-tooltip', {
      attrs: {
        "target": ("tdSurveyInstanceNote" + (check.SurveyInstanceId)),
        "delay": _vm.globals.tooltipDelay,
        "boundary": "viewport"
      }
    }, [_vm._v(_vm._s(check.SurveyInstanceNote))]), _vm._v(" "), (_vm.CheckManagementFilter.ExpiryDate) ? _c('td', [_vm._v("\n              " + _vm._s(check.SurveyInstanceUntil) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Agency) ? _c('td', [_vm._v("\n              " + _vm._s(check.SurveyInstanceResponsable) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.feature.isAudiTarget && _vm.CheckManagementFilter.Shopper) ? _c('td', [_vm._v("\n              " + _vm._s(check.ApprovedShopperName) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Score) ? _c('td', [_vm._v("\n              " + _vm._s(check.SurveyInstanceScore) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Progress) ? _c('td', [_vm._v("\n              " + _vm._s(check.SurveyInstanceProgress) + "\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.feature.isAudiTarget && _vm.CheckManagementFilter.Progress) ? _c('td', [_vm._v("\n              " + _vm._s(check.SettlementStatus) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Modifiedat) ? _c('td', [_vm._v("\n              " + _vm._s(check.SurveyInstanceModifiedAt) + "\n            ")]) : _vm._e()], 1)
  }), 0)])])]), _vm._v(" "), _c('CheckManagementAddModal', {
    attrs: {
      "dataLists": _vm.dataLists,
      "selectedClient": _vm.selectedClient,
      "selectedProject": _vm.selectedProject,
      "showDialog": _vm.showAddChecksDialog
    },
    on: {
      "clientSelected": _vm.onClientSelection,
      "dialogClosed": _vm.onAddChecksDialogClosed,
      "dialogDataSaved": _vm.onAddChecksDialogDataSaved,
      "checksCreated": function($event) {
        (_vm.selectedChecks = $event.guids), (_vm.selectedCheckIds = $event.ids)
      }
    }
  }), _vm._v(" "), _c('CheckManagementEditModal', {
    attrs: {
      "dataLists": _vm.dataLists,
      "selectedChecks": _vm.selectedChecks,
      "selectedCheckIds": _vm.selectedCheckIds,
      "selectedClient": _vm.selectedClient,
      "selectedProject": _vm.selectedProject,
      "includeChecks": _vm.includeChecks,
      "showDialog": _vm.showEditChecksDialog,
      "projectSelected": !!_vm.selectedProject
    },
    on: {
      "dialogClosed": _vm.onEditChecksDialogClosed
    }
  }), _vm._v(" "), _c('CheckManagementFilterModal', {
    attrs: {
      "showModal": _vm.showCheckManagementFilterModal
    },
    on: {
      "closeModal": function($event) {
        (_vm.showCheckManagementFilterModal = false), _vm.getCustomSettingsList()
      }
    }
  }), _vm._v(" "), _c('SettlementDownloadModal', {
    attrs: {
      "showModal": _vm.showSettlementDownloadModal
    },
    on: {
      "closeModal": function($event) {
        _vm.showSettlementDownloadModal = false
      }
    }
  }), _vm._v(" "), _c('CheckPaymentModal', {
    attrs: {
      "showModal": _vm.showCheckPaymentModal,
      "surveyInstanceGuids": _vm.selectedChecks
    },
    on: {
      "modalClosed": function($event) {
        (_vm.showCheckPaymentModal = false), _vm.getCheckData()
      }
    }
  }), _vm._v(" "), _c('ShopperFilterModal', {
    attrs: {
      "showModal": _vm.showShopperFilterModal,
      "selectedClient": _vm.selectedClient
    },
    on: {
      "modalClosed": function($event) {
        _vm.showShopperFilterModal = false
      }
    }
  }), _vm._v(" "), (_vm.feature.isAudiTarget && _vm.globals.isLeadAgencyUser) ? _c('CheckLocalAgencyAssignmentModal', {
    attrs: {
      "showModal": _vm.showCheckLocalAgencyAssignmentModal,
      "selectedChecks": _vm.selectedChecks,
      "agencies": _vm.dataLists.agencyList
    },
    on: {
      "modalClosed": function($event) {
        _vm.showCheckLocalAgencyAssignmentModal = false
      },
      "modalDataSaved": function($event) {
        return _vm.getCheckData()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('confirmation-dialog', {
    attrs: {
      "confirmationTitle": _vm.lang.CM0038,
      "yesButtonText": _vm.lang.CM0039,
      "noButtonText": _vm.lang.CM0040,
      "showDialog": _vm.showExportModal
    },
    on: {
      "onYesConfirmation": _vm.downloadCheckData,
      "dialogClosed": function($event) {
        _vm.showExportModal = false
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('p', [_vm._v("\n        " + _vm._s(_vm.lang.CM0041) + ":\n        "), _c('b', [_vm._v(_vm._s(_vm.getNameOfSelectedClient()))])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "autovalidationDialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "text-align": "left"
    }
  }, [(_vm.autovalidation.invalidChecks.length == 0 && _vm.autovalidation.validatedChecks.length == 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', [_vm._v("\n              Do you want to autovalidate\n              " + _vm._s(_vm.selectedCheckIds.length) + " checks?\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.CM0036) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.startAutovalidation()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.CM0037) + "\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.autovalidation.invalidChecks.length > 0) ? _c('div', [_c('h3', [_vm._v("Invalid Checks")]), _vm._v(" "), _c('div', {
    staticClass: "autovalidationTable"
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "items": _vm.autovalidation.invalidChecks
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.autovalidation.validatedChecks.length > 0) ? _c('div', [_c('h3', [_vm._v("Validated Checks")]), _vm._v(" "), _c('div', {
    staticClass: "autovalidationTable"
  }, [_c('b-table', {
    staticClass: "autovalidationTable",
    attrs: {
      "striped": "",
      "hover": "",
      "items": _vm.autovalidation.validatedChecks
    }
  })], 1)]) : _vm._e()])])])])], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "role": "button",
      "data-toggle": "dropdown",
      "id": "elementsPerPageDropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("view_headline")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "firstPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("first_page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "lastPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("last_page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v("Autovalidation")])])])
}]}

/***/ }),
/* 1710 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "translateKpiDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.closeKpiTranslationModal()
      }
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.KM3001))]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.lang.KM3008) + ": " + _vm._s(_vm.client.clientName))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "selectLocale"
    }
  }, [_vm._v(_vm._s(_vm.lang.KM3002))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('Select2', {
    staticClass: "form-control",
    attrs: {
      "id": "selectLocale",
      "placeholder": _vm.lang.KM3003
    },
    on: {
      "change": _vm.selectedLocaleChanged
    }
  }, _vm._l((_vm.avaibleLocaleList), function(locale) {
    return _c('option', {
      key: locale.LocaleCode,
      domProps: {
        "value": locale.LocaleCode
      }
    }, [_vm._v("\n                      " + _vm._s(locale.LocaleName) + "\n                    ")])
  }), 0)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "selectKpiTranslationProject"
    }
  }, [_vm._v(_vm._s(_vm.lang.KM3015))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('Select2', {
    staticClass: "form-control",
    attrs: {
      "id": "selectKpiTranslationProject",
      "placeholder": _vm.lang.KM3016,
      "allowClear": true
    },
    model: {
      value: (_vm.selectedProject),
      callback: function($$v) {
        _vm.selectedProject = $$v
      },
      expression: "selectedProject"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.projects), function(project) {
    return _c('option', {
      key: project.ProjectGuid,
      domProps: {
        "value": project.ProjectGuid
      }
    }, [_vm._v("\n                      " + _vm._s(project.ProjectName) + "\n                    ")])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputSearchKpi"
    }
  }, [_vm._v(_vm._s(_vm.lang.KM3004))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchKpiString),
      expression: "searchKpiString"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputSearchKpi"
    },
    domProps: {
      "value": (_vm.searchKpiString)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.doFiltering()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchKpiString = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedLocaleCode
    },
    on: {
      "click": function($event) {
        return _vm.getInitialSort()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.KM3014) + "\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    staticClass: "table table-hover main-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "14%"
    },
    attrs: {
      "id": "kpiTypeColumnHeader"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('Type')
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.KM3005) + "\n                      "), (_vm.showSortArrow('Type', true)) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isInitialSort),
      expression: "isInitialSort"
    }],
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('Type', false)) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isInitialSort),
      expression: "isInitialSort"
    }],
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "43%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('Text')
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.KM3006) + "\n                      "), (_vm.showSortArrow('Text', true)) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isInitialSort),
      expression: "isInitialSort"
    }],
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('Text', false)) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isInitialSort),
      expression: "isInitialSort"
    }],
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "43%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('Translation')
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.KM3007) + "\n                      "), (_vm.showSortArrow('Translation', true)) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isInitialSort),
      expression: "isInitialSort"
    }],
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('Translation', false)) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isInitialSort),
      expression: "isInitialSort"
    }],
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])])])]), _vm._v(" "), _c('tbody', {
    staticClass: "main-table-scrollbar"
  }, _vm._l((_vm.filteredKpiTranslations), function(kpiInformation, index) {
    return _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (
          !_vm.selectedProject ||
          kpiInformation.ProjectGuid === _vm.selectedProject
        ),
        expression: "\n                    !selectedProject ||\n                    kpiInformation.ProjectGuid === selectedProject\n                  "
      }],
      key: index,
      class: {
        'kpi-group-table-row': !kpiInformation.KPIGroupGuid,
      }
    }, [_c('td', {
      staticStyle: {
        "width": "14%"
      }
    }, [_vm._v(_vm._s(kpiInformation.Type))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "43%"
      }
    }, [_vm._v(_vm._s(kpiInformation.Text))]), _vm._v(" "), _c('td', {
      staticClass: "nopadding",
      staticStyle: {
        "width": "43%"
      }
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (kpiInformation.Translation),
        expression: "kpiInformation.Translation"
      }],
      staticClass: "form-control text-center textarea-kpi-translations autoExpand",
      attrs: {
        "rows": "1",
        "maxlength": "1000",
        "type": "text",
        "placeholder": kpiInformation.InheritedTranslation
      },
      domProps: {
        "value": (kpiInformation.Translation)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(kpiInformation, "Translation", $event.target.value)
        }, function($event) {
          _vm.isTranslationDirty = true
        }]
      }
    })])])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeKpiTranslationModal()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.KM3009) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised",
    class: {
      'btn-warning': _vm.isTranslationDirty,
      'dialog-btn-primary': !_vm.isTranslationDirty,
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.globals.isAccessAllowed('LoopOp_KPIsTranslation_Update') ||
        !_vm.isTranslationDirty
    },
    on: {
      "click": function($event) {
        return _vm.saveKpiTranslations()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.KM3000) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 1711 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "waveStatusModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.WVS000))])]), _vm._v(" "), (_vm.elementId) ? _c('label', {
    staticClass: "control-label nopadding"
  }, [_vm._v("ID: " + _vm._s(_vm.elementId))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "wave-status-modal-content"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [(
    _vm.statusData.SurveyInstances &&
    _vm.statusData.SurveyInstances.Status
  ) ? _c('tr', [_c('td', {
    staticClass: "text-left noborder"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.WVS001))])]), _vm._v(" "), _c('td', {
    staticClass: "text-left noborder"
  }, [_c('table', {
    staticClass: "table table-hover",
    staticStyle: {
      "width": "66.67%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.WVS002))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.statusData.SurveyInstances.Status.Count))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.WVS003))]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(_vm.statusData.SurveyInstances.Status.Approval) + "\n                        ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.WVS004))]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(_vm.statusData.SurveyInstances.Status.InProgress) + "\n                        ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.WVS005))]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(_vm.statusData.SurveyInstances.Status.Reporting) + "\n                        ")])]), _vm._v(" "), (_vm.statusData.Wave) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.WVS006))]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(Number((_vm.statusData.Wave.InTime * 100).toFixed(2))) + "\n                          %\n                        ")])]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.statusData.Approvals) ? _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.WVS007))])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('table', {
    staticClass: "table table-hover",
    staticStyle: {
      "width": "66.67%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.WVS008))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.statusData.Approvals.WithoutProposals))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.WVS009))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.statusData.Approvals.WithProposals))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.WVS010))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.statusData.Approvals.Approved))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.WVS011))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.statusData.Approvals.Rejected))])])])])])]) : _vm._e(), _vm._v(" "), (_vm.statusData.CarDistribution) ? _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.WVS012))])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.lang.WVS013))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.WVS014))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.WVS015))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.statusData.CarDistribution), function(model, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(model.CarModelName))]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(Number((model.SetValue * 100).toFixed(2))) + " %\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(Number((model.ActualValue * 100).toFixed(2))) + " %\n                        ")])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.statusData.CompetitorCarDistribution) ? _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.WVS018))])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.lang.WVS013))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.WVS014))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.WVS015))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.statusData.CompetitorCarDistribution), function(model, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(model.CompetitorCarModel))]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(Number((model.SetValue * 100).toFixed(2))) + " %\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(Number((model.ActualValue * 100).toFixed(2))) + " %\n                        ")])])
  }), 0)])])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.WVS016) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "nopadding noborder",
    staticStyle: {
      "width": "30%"
    }
  }), _vm._v(" "), _c('th', {
    staticClass: "nopadding noborder",
    staticStyle: {
      "width": "70%"
    }
  })])])
}]}

/***/ }),
/* 1712 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "dialog-table-panel background"
  }, [_c('div', {
    staticClass: "form-group nopadding"
  }, [_c('div', {
    staticClass: "input-group group"
  }, [_c('label', {
    staticClass: "comboBoxLabel"
  }, [_vm._v(_vm._s(_vm.lang.S0111) + ":")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actualClient),
      expression: "actualClient"
    }],
    staticClass: "form-control nopadding comboBoxGroup",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.actualClient = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.loadPolicies()
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": "-1"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0112))]), _vm._v(" "), _vm._l((_vm.clients), function(client) {
    return _c('option', {
      key: client.ClientId,
      domProps: {
        "value": client.ClientId
      }
    }, [_vm._v("\n            " + _vm._s(client.ClientName) + "\n          ")])
  })], 2)])]), _vm._v(" "), (_vm.actualClient && _vm.actualClient != -1) ? _c('div', {
    staticClass: "dialog-table-panel"
  }, [_c('table', {
    staticClass: "table table-striped table-hover main-table",
    staticStyle: {
      "overflow-y": "unset"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center w30"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0115))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center w70"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0172))])])])]), _vm._v(" "), _c('tbody', {
    staticClass: "main-table-scrollbar client-policies-table"
  }, [(_vm.surveys) ? _vm._l((_vm.surveys), function(property, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "td-cb-policies w30 moreheadroom"
    }, [_c('a', {
      staticClass: "table-header",
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.togglePermitted(property)
        }
      }
    }, [_vm._v(_vm._s(property.surveyTitle))])]), _vm._v(" "), _c('td', {
      staticClass: "w70",
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('div', {
      staticClass: "reset-this"
    }, [_c('treeselect', {
      attrs: {
        "placeholder": _vm.lang.S0041,
        "options": property.surveysQuestions,
        "auto-load-root-options": false,
        "multiple": true,
        "limit": 5,
        "searchable": true,
        "showCount": true,
        "flat": true,
        "valueFormat": "id",
        "showCountOf": "LEAF_DESCENDANTS",
        "disabled": true
      },
      model: {
        value: (property.SelectedItems),
        callback: function($$v) {
          _vm.$set(property, "SelectedItems", $$v)
        },
        expression: "property.SelectedItems"
      }
    })], 1)])])
  }) : _vm._e()], 2)])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 1713 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-default agency--panel"
  }, [_c('div', {
    staticClass: "panel-body menu__panel-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-raised button__toolbar",
    attrs: {
      "id": "agency-management-refresh-button",
      "disabled": !_vm.refreshEnabled
    },
    on: {
      "click": function($event) {
        _vm.emitUserSearch(), _vm.emitTriggerReload()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("refresh")]), _vm._v(" "), _c('br'), _vm._v("\n        " + _vm._s(_vm.lang.AM1000) + "\n      ")]), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Agencies_Create')) ? _c('button', {
    staticClass: "btn btn-raised button__toolbar",
    attrs: {
      "id": "agency-management-create-button"
    },
    on: {
      "click": function($event) {
        return _vm.emitEditAgency(true)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("add_box")]), _vm._v(" "), _c('br'), _vm._v("\n        " + _vm._s(_vm.lang.AM1002) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Agencies_Read')) ? _c('button', {
    staticClass: "btn btn-raised button__toolbar",
    attrs: {
      "id": "agency-management-edit-button",
      "disabled": !_vm.agencySelected
    },
    on: {
      "click": function($event) {
        return _vm.emitEditAgency(false)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("edit")]), _vm._v(" "), _c('br'), _vm._v("\n        " + _vm._s(_vm.lang.AM1003) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Agencies_Delete')) ? _c('button', {
    staticClass: "btn btn-raised button__toolbar",
    attrs: {
      "id": "agency-management-delete-button",
      "disabled": !_vm.agencySelected
    },
    on: {
      "click": function($event) {
        return _vm.emitDeleteAgency()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("clear")]), _vm._v(" "), _c('br'), _vm._v("\n        " + _vm._s(_vm.lang.AM1008) + "\n      ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body paging__panel-body"
  }, [_c('div', {
    staticClass: "col-lg-7"
  }, [_c('div', {
    staticClass: "form-group searchbar__form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchString),
      expression: "searchString"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputSearch",
      "placeholder": _vm.lang.AM1001
    },
    domProps: {
      "value": (_vm.searchString)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.emitUserSearch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchString = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5"
  }, [_c('ul', {
    staticClass: "pagination btn-group"
  }, [_c('li', [_vm._m(0), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "elementsPerPageDropdown",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.AM1004))]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize === 20
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changePageSize(1, 20)
      }
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize === 50
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changePageSize(1, 50)
      }
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize === 100
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changePageSize(1, 100)
      }
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize === 200
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changePageSize(1, 200)
      }
    }
  }, [_vm._v("200")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize === _vm.tableElementCount,
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changePageSize(1, -1)
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.AM1005))])])])], 1), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.pageNumbers.length || _vm.currentPage === 1,
    }
  }, [_c('a', {
    attrs: {
      "role": "button",
      "id": "firstPageButton"
    },
    on: {
      "click": function($event) {
        return _vm.selectPage(1)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("first_page")])]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "firstPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.AM1006))])], 1), _vm._v(" "), (_vm.pageNumbers.length > 5 && _vm.currentPage > 3) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.showPages), function(pageNumber) {
    return _c('li', {
      key: pageNumber,
      class: {
        active: _vm.currentPage === pageNumber
      }
    }, [_c('a', {
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.selectPage(pageNumber)
        }
      }
    }, [_vm._v(_vm._s(pageNumber))])])
  }), _vm._v(" "), (
    _vm.pageNumbers.length > 5 && _vm.currentPage < _vm.pageNumbers.length - 2
  ) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      disabled:
        !_vm.pageNumbers.length || _vm.currentPage === _vm.pageNumbers.length,
    }
  }, [_c('a', {
    attrs: {
      "role": "button",
      "id": "lastPageButton"
    },
    on: {
      "click": function($event) {
        return _vm.selectPage(_vm.pageNumbers.length)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("last_page")])]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "lastPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.AM1007))])], 1), _vm._v(" "), _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button",
      "id": "agenciesTotalElementsCounter"
    }
  }, [_vm._v(_vm._s(_vm.tableElementCount))]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "agenciesTotalElementsCounter",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.AM1009))])], 1)], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "role": "button",
      "data-toggle": "dropdown",
      "id": "elementsPerPageDropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("view_headline")])])
}]}

/***/ }),
/* 1714 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "app-header"
  }, [_c('div', {
    staticClass: "header-left"
  }, [_c('button', {
    staticClass: "mobile-menu-btn",
    on: {
      "click": function($event) {
        return _vm.$emit('toggle-mobile-menu')
      }
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined"
  }, [_vm._v("menu")])]), _vm._v(" "), _c('div', {
    staticClass: "dashboard-title"
  }, [_c('h1', [_vm._v(_vm._s(_vm.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "search-container"
  }, [_c('div', {
    staticClass: "search-field"
  }, [_c('span', {
    staticClass: "material-symbols-outlined search-icon"
  }, [_vm._v("search")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "search-input",
    attrs: {
      "type": "text",
      "placeholder": "Suche..."
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "search-underline"
  })]), _vm._v(" "), _c('div', {
    staticClass: "header-right"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "notification-container",
    on: {
      "click": _vm.showNotifications
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined notification-icon"
  }, [_vm._v("notifications")]), _vm._v(" "), _c('div', {
    staticClass: "notification-badge"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.closeUserMenu),
      expression: "closeUserMenu"
    }],
    staticClass: "user-profile",
    on: {
      "click": _vm.toggleUserMenu
    }
  }, [_c('div', {
    staticClass: "user-info"
  }, [_c('div', {
    staticClass: "user-name"
  }, [_vm._v(_vm._s(_vm.userDisplayName))]), _vm._v(" "), _c('div', {
    staticClass: "user-role"
  }, [_vm._v(_vm._s(_vm.userDisplayType))])]), _vm._v(" "), _c('span', {
    staticClass: "user-avatar material-symbols-outlined "
  }, [_vm._v("account_circle")]), _vm._v(" "), _c('span', {
    staticClass: "mobile-avatar material-symbols-outlined"
  }, [_vm._v("account_circle")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showUserDropdown),
      expression: "showUserDropdown"
    }],
    staticClass: "user-dropdown"
  }, [_c('div', {
    staticClass: "dropdown-header"
  }, [_c('span', {
    staticClass: "material-symbols-outlined dropdown-avatar"
  }, [_vm._v("account_circle")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-user-info"
  }, [_c('div', {
    staticClass: "dropdown-user-name"
  }, [_vm._v(_vm._s(_vm.userDisplayName))]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-user-role"
  }, [_vm._v(_vm._s(_vm.userDisplayType))])])]), _vm._v(" "), _c('hr', {
    staticClass: "dropdown-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu-item",
    on: {
      "click": function($event) {
        return _vm.$emit('show-language-dialog')
      }
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined"
  }, [_vm._v("public")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.A0006) + " (" + _vm._s(_vm.languageList ? _vm.languageList[_vm.globals.selectedLanguage] : '') + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu-item",
    on: {
      "click": function($event) {
        return _vm.navigate('/settings', _vm.lang.A0024)
      }
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined"
  }, [_vm._v("settings")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.A0024))])]), _vm._v(" "), _c('hr', {
    staticClass: "dropdown-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu-item",
    on: {
      "click": function($event) {
        return _vm.$emit('user-logout')
      }
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined"
  }, [_vm._v("logout")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.A0003))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "mobile-search-btn"
  }, [_c('span', {
    staticClass: "material-symbols-outlined"
  }, [_vm._v("search")])])
}]}

/***/ }),
/* 1715 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.globals.isAccessAllowed('LoopOp_SurveyInstancesAnswers_Read')) ? _c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "surveyViewPanel"
    }
  }, [_c('div', {
    staticClass: "panel-body",
    attrs: {
      "id": "surveyViewForm"
    }
  }, [_c('div', {
    staticClass: "col-lg-3 col-xs-12 col-lg-push-9",
    attrs: {
      "id": "meta-information-container"
    }
  }, [(_vm.surveyData) ? _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "padding-bottom": "10px"
    }
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "selectSurveyLanguage"
    }
  }, [_vm._v(_vm._s(_vm.lang.SV0051))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "selectSurveyLanguage"
    },
    on: {
      "change": function($event) {
        return _vm.changeSurveyLanguage()
      }
    },
    model: {
      value: (_vm.surveyLocaleCode),
      callback: function($$v) {
        _vm.surveyLocaleCode = $$v
      },
      expression: "surveyLocaleCode"
    }
  }, _vm._l((_vm.surveyData.Languages), function(language) {
    return _c('option', {
      key: language.LocaleCode,
      domProps: {
        "value": language.LocaleCode
      }
    }, [_vm._v("\n              " + _vm._s(language.LocaleName) + "\n            ")])
  }), 0)], 1)]) : _vm._e(), _vm._v(" "), (_vm.surveyData && _vm.surveyData.SurveyLogoId) ? _c('div', {
    staticClass: "survey-logo-container"
  }, [_c('img', {
    attrs: {
      "src": '/api/Download/' + _vm.surveyData.SurveyLogoId
    }
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    attrs: {
      "id": "metaInformationHeader"
    }
  }, [_vm._v(_vm._s(_vm.lang.SV0000))]), _vm._v(" "), _c('div', {
    staticClass: "information"
  }, [_c('b', [_vm._v("\n          " + _vm._s(_vm.lang.SV0013) + "\n          :\n        ")]), _vm._v("\n        " + _vm._s(_vm.metaInformation.SurveyInstanceId) + "\n        "), _c('i', {
    staticClass: "material-icons md-24",
    attrs: {
      "id": "showCheckHistoryInfoIcon"
    },
    on: {
      "click": function($event) {
        return _vm.showCheckHistory()
      }
    }
  }, [_vm._v("history")]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "showCheckHistoryInfoIcon",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SV0061))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.lang.SV0014) + ":")]), _vm._v("\n        " + _vm._s(_vm.metaInformation.SurveyId) + "\n        "), (_vm.metaInformation.ShortSurveyCode) ? [_c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.lang.SV0015) + ":")]), _vm._v("\n          " + _vm._s(_vm.metaInformation.ShortSurveyCode) + "\n        ")] : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.lang.SV0016) + ":")]), _vm._v("\n        " + _vm._s(_vm.metaInformation.LocationStoreId) + "\n        "), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.lang.SV0017) + ":")]), _vm._v("\n        " + _vm._s(_vm.metaInformation.LocationName) + "\n        "), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.lang.SV0018) + ":")]), _vm._v("\n        " + _vm._s(_vm.metaInformation.LocationAddress) + "\n        "), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.lang.SV0019) + ":")]), _vm._v("\n        " + _vm._s(_vm.metaInformation.LocationCountry) + "\n        "), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.lang.SV0020) + ":")]), _vm._v("\n        " + _vm._s(_vm.metaInformation.ScenarioName) + "\n        "), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.lang.SV0021) + ":")]), _vm._v("\n        " + _vm._s(_vm.metaInformation.WaveName) + "\n        "), (_vm.metaInformation.CarModelDistribution) ? _c('i', {
    staticClass: "material-icons md-18",
    staticStyle: {
      "vertical-align": "middle",
      "cursor": "pointer"
    },
    attrs: {
      "id": "carModelDistributionInfoIcon"
    }
  }, [_vm._v("drive_eta")]) : _vm._e(), _vm._v(" "), (
    _vm.metaInformation.CarModelDistribution ||
    _vm.metaInformation.CompetitorCarModelDistribution
  ) ? _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "carModelDistributionInfoIcon",
      "delay": _vm.globals.tooltipDelay
    }
  }, [(_vm.metaInformation.CarModelDistribution) ? [_c('b', [_vm._v(_vm._s(_vm.lang.SV0060) + ":")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.metaInformation.CarModelDistribution), function(model) {
    return _c('span', {
      key: model.CarModelGuid
    }, [_vm._v("\n              " + _vm._s(model.CarModelName) + " - " + _vm._s(model.Distribution * 100) + "%\n              "), _c('br')])
  })] : _vm._e(), _vm._v(" "), (
    _vm.metaInformation.CarModelDistribution &&
    _vm.metaInformation.CompetitorCarModelDistribution
  ) ? [_c('br')] : _vm._e(), _vm._v(" "), (_vm.metaInformation.CompetitorCarModelDistribution) ? [_c('b', [_vm._v(_vm._s(_vm.lang.SV0062) + ":")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.metaInformation.CompetitorCarModelDistribution), function(model) {
    return _c('span', {
      key: model.CompetitorCarModelGuid
    }, [_vm._v("\n              " + _vm._s(model.CompetitorCarModel) + " - " + _vm._s(model.Distribution * 100) + "%\n              "), _c('br')])
  })] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.metaInformation.WaveInfo) ? [_c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.lang.SV0059) + ":")]), _vm._v("\n          " + _vm._s(_vm.metaInformation.WaveInfo) + "\n        ")] : _vm._e(), _vm._v(" "), (_vm.metaInformation.SurveyInstanceInfo) ? [_c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.lang.SV0057) + ":")]), _vm._v("\n          " + _vm._s(_vm.metaInformation.SurveyInstanceInfo) + "\n        ")] : _vm._e(), _vm._v(" "), (_vm.globals.currentUserRole < 3) ? [_c('br'), _vm._v(" "), _c('span', {
    attrs: {
      "id": "surveyViewMetaInfoScoreSpan"
    }
  }, [_c('b', [_vm._v("\n              " + _vm._s(_vm.lang.SV0029) + "\n              "), _c('i', {
    staticClass: "material-icons md-18",
    staticStyle: {
      "vertical-align": "middle",
      "cursor": "pointer"
    }
  }, [_vm._v("help_outline")]), _vm._v("\n              :\n            ")]), _vm._v("\n            " + _vm._s(_vm.metaInformation.Score) + "\n          ")])] : _vm._e(), _vm._v(" "), (_vm.metaInformation.ApprovedShopper) ? [_c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.lang.SV0063) + ":")]), _vm._v("\n          " + _vm._s(_vm.metaInformation.ApprovedShopper.DisplayName) + "\n          "), _c('div', {
    attrs: {
      "id": "approvedShopperDetailsContainer"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.SV0064) + " (" + _vm._s(_vm.lang.SV0065) + "):\n            " + _vm._s(_vm.metaInformation.ApprovedShopper.ShopperAge) + " (" + _vm._s(_vm.metaInformation.ApprovedShopper.Gender) + ")\n            "), _c('br'), _vm._v("\n            " + _vm._s(_vm.lang.SV0066) + ":\n            " + _vm._s(_vm.metaInformation.ApprovedShopper.ShopperCar) + "\n            "), _c('br'), _vm._v("\n            " + _vm._s(_vm.lang.SV0067) + ":\n            " + _vm._s(_vm.metaInformation.ApprovedShopper.CarSegmentName) + "\n            "), _c('br'), _vm._v("\n            " + _vm._s(_vm.lang.SV0068) + ":\n            " + _vm._s(_vm.metaInformation.ApprovedShopper.CarModelName) + "\n          ")])] : _vm._e(), _vm._v(" "), (_vm.globals.currentUserRole < 3) ? _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "surveyViewMetaInfoScoreSpan",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SV0030))]) : _vm._e(), _vm._v(" "), _c('br')], 2), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputDateSurveyView"
    }
  }, [_vm._v(_vm._s(_vm.lang.SV0001) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8",
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr('inputDateSurveyView')
      }
    }
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputDateSurveyView",
      "disabled": _vm.inputMetaInformationDisabled
    },
    on: {
      "change": function($event) {
        return _vm.validateInput('inputDateSurveyView')
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputDateSurveyView')),
      expression: "inputHasError('inputDateSurveyView')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SV0012))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputTimeInSurveyView"
    }
  }, [_vm._v(_vm._s(_vm.lang.SV0002) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8",
    on: {
      "click": function($event) {
        _vm.globals.toggleFlatpickr('inputTimeInSurveyView'),
          _vm.inputMetaInformationDisabled ||
          _vm.validateInput('inputTimeInSurveyView')
      }
    }
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputTimeInSurveyView",
      "disabled": _vm.inputMetaInformationDisabled
    },
    on: {
      "change": function($event) {
        return _vm.validateInput('inputTimeInSurveyView')
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputTimeInSurveyView')),
      expression: "inputHasError('inputTimeInSurveyView')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SV0012))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputTimeOutSurveyView"
    }
  }, [_vm._v(_vm._s(_vm.lang.SV0003) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8",
    on: {
      "click": function($event) {
        _vm.globals.toggleFlatpickr('inputTimeOutSurveyView'),
          _vm.inputMetaInformationDisabled ||
          _vm.validateInput('inputTimeOutSurveyView')
      }
    }
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputTimeOutSurveyView",
      "disabled": _vm.inputMetaInformationDisabled
    },
    on: {
      "change": function($event) {
        return _vm.validateInput('inputTimeOutSurveyView')
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputTimeOutSurveyView')),
      expression: "inputHasError('inputTimeOutSurveyView')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SV0012))])])]), _vm._v(" "), (!_vm.feature.isAudiTarget) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputGPSSurveyViewLat"
    }
  }, [_vm._v(_vm._s(_vm.lang.SV0045))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "any",
      "min": "-90",
      "max": "90",
      "id": "inputGPSSurveyViewLat",
      "disabled": _vm.inputMetaInformationDisabled
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SV0058))])])]) : _vm._e(), _vm._v(" "), (!_vm.feature.isAudiTarget) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputGPSSurveyViewLong"
    }
  }, [_vm._v(_vm._s(_vm.lang.SV0046))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "any",
      "min": "-180",
      "max": "180",
      "id": "inputGPSSurveyViewLong",
      "disabled": _vm.inputMetaInformationDisabled
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SV0058))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "txtMemoShopper"
    }
  }, [_vm._v(_vm._s(_vm.lang.SV0004))]), _vm._v(" "), _c('textarea', {
    staticClass: "form-control",
    attrs: {
      "rows": "4",
      "id": "txtMemoShopper",
      "disabled": _vm.globals.currentUserRole > 3 || _vm.surveyInstanceStatusId > 200
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "txtMemoAgency"
    }
  }, [_vm._v(_vm._s(_vm.lang.SV0005))]), _vm._v(" "), _c('textarea', {
    staticClass: "form-control",
    attrs: {
      "rows": "4",
      "id": "txtMemoAgency",
      "disabled": _vm.globals.currentUserRole > 2 || _vm.surveyInstanceStatusId > 200
    }
  })]), _vm._v(" "), (!_vm.feature.isAudiTarget) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "txtMemoMSM"
    }
  }, [_vm._v(_vm._s(_vm.lang.SV0006))]), _vm._v(" "), _c('textarea', {
    staticClass: "form-control",
    attrs: {
      "rows": "4",
      "id": "txtMemoMSM",
      "disabled": _vm.globals.currentUserRole > 1 || _vm.surveyInstanceStatusId > 200
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.surveyData && _vm.surveyData.SurveyAttachments) ? _c('div', {
    staticClass: "attachment-download-container",
    on: {
      "click": function($event) {
        return _vm.globals.downloadFile(_vm.surveyData.SurveyAttachments[0].DownloadId)
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('label', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "for": "attachmentDownloadButton"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.surveyData.SurveyAttachments[0].DownloadDescription ?
    _vm.surveyData.SurveyAttachments[0].DownloadDescription :
    _vm.surveyData.SurveyAttachments[0].DownloadFileName) + "\n          ")])]) : _vm._e()])]), _vm._v(" "), _c('hr', {
    staticClass: "hidden-lg"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 col-xs-12 col-lg-pull-3"
  }, [(_vm.surveyData) ? _c('survey', {
    attrs: {
      "survey": _vm.survey
    }
  }) : _vm._e()], 1)]), _vm._v(" "), (_vm.survey) ? _c('div', {
    staticClass: "panel-footer"
  }, [_c('div', {
    staticClass: "navigation"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "disabled": _vm.prevButtonDisabled
    },
    on: {
      "click": function($event) {
        return _vm.survey.prevPage()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.lang.SV0007) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "disabled": _vm.nextButtonDisabled
    },
    on: {
      "click": function($event) {
        return _vm.survey.nextPage()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.lang.SV0008) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-success",
    attrs: {
      "disabled": !_vm.globals.isAccessAllowed('LoopOp_SurveyInstancesAnswers_Update') ||
        _vm.completeButtonDisabled ||
        _vm.saveRequestPending
    },
    on: {
      "click": function($event) {
        return _vm.validateSurvey()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.globals.currentUserRole == 3 ? _vm.lang.SV0009 : _vm.lang.SV0027) + "\n        "), (_vm.globals.currentUserRole == 3) ? _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("flag")]) : _vm._e()])]), _vm._v(" "), (
    _vm.globals.currentUserRole < 3 &&
    _vm.globals.isAccessAllowed('LoopOp_SurveyInstances_Update')
  ) ? _c('div', {
    staticClass: "status-switch-container"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "disabled": _vm.moveToShopperButtonDisabled
    },
    on: {
      "click": function($event) {
        return _vm.moveCheckTo('shopper')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.lang.SV0024) + "\n      ")]), _vm._v(" "), (_vm.globals.currentUserRole == 1 || _vm.globals.isLeadAgencyUser) ? _c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "disabled": _vm.moveToAgencyButtonDisabled
    },
    on: {
      "click": function($event) {
        return _vm.moveCheckTo('agency')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.feature.isAudiTarget ? _vm.lang.SV0069 : _vm.lang.SV0025) + "\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.feature.isAudiTarget) ? _c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "disabled": _vm.moveToMSMButtonDisabled
    },
    on: {
      "click": function($event) {
        return _vm.moveCheckTo('msm')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.feature.isAudiTarget ? _vm.lang.SV0070 : _vm.lang.SV0026) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.globals.currentUserRole == 1 || _vm.globals.isLeadAgencyUser) ? _c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "disabled": _vm.moveToMSMInternalButtonDisabled
    },
    on: {
      "click": function($event) {
        return _vm.moveCheckTo('msminternal')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.lang.SV0028) + "\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "options"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    class: {
      hidden: !_vm.isClosableWindow
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.exitSurvey()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.lang.SV0010) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button",
      "disabled": !_vm.globals.isAccessAllowed('LoopOp_SurveyInstancesAnswers_Update') ||
        _vm.saveButtonDisabled
    },
    on: {
      "click": function($event) {
        return _vm.saveSurvey(false)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.lang.SV0011) + "\n      ")])])]) : _vm._e(), _vm._v(" "), _c('survey-upload-dialog', {
    attrs: {
      "showDialog": _vm.showUploadDialog,
      "questionData": _vm.questionData
    },
    on: {
      "dialogDataSaved": _vm.onUploadDialogDataSaved,
      "dialogClosed": _vm.onSurveyUploadDialogClosed
    }
  })], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-default btn-fab btn-fab-mini",
    attrs: {
      "id": "attachmentDownloadButton"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("attach_file")])])
}]}

/***/ }),
/* 1716 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "dataprotection"
    }
  }, [_c('div', [_c('h1', [_vm._v("Privacy Policy")]), _vm._v(" "), _c('b', [_vm._v("Collecting general information")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n      When you enter our website, information of a general nature is\n      automatically collected. This information (server logs) concerns, for\n      example, the type of web browser, operating system used, domain names of\n      the Internet service provider which are used by the user, etc. This only\n      applies to information which does not allow the user to be identified.\n      This information is necessary from a technical point of view in order to\n      provide the user with the desired content of the websites and\n      transferring of this information happens inevitably while using the\n      Internet. We analyze this type of anonymous information for statistical\n      purposes in order to optimize our website and technical issues which are\n      related to it.\n    ")]), _vm._v(" "), _c('b', [_vm._v("Registration on our website")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('b', [_vm._v("Data deletion or blocking")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n      We comply with the data reduction and minimization principle, therefore\n      we only store the user's personal data for as long as it is necessary in\n      order to achieve the goals set out in this document, or in a manner that\n      is compliant with the statutory data storage periods. When the target\n      ceases to be current or when these periods expire, the corresponding\n      data is blocked or deleted routinely and in compliance with statutory\n      provisions.\n    ")]), _vm._v(" "), _c('b', [_vm._v("Using Google Analytics")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n      This website uses Google Analytics, a web analytics service provided by\n      Google, Inc. ('Google'). Google Analytics uses the so-called 'cookies',\n      which are text files placed on the user's computer in order to enable\n      the website to analyze the way in which the user uses it. The\n      information which is generated by 'cookies' about the user’s use of the\n      website is usually transmitted to a Google server in the USA and stored\n      there. In case when the IP depersonalization on these websites is\n      activated, the user's IP address will be promptly shortened on the\n      territory of the European Union's Member States or other states or\n      parties of the European Economic Area treaty. Only in exceptional cases\n      will the full IP address be transmitted to a Google server in the USA\n      and shortened there. At the request of the operator of this website,\n      Google will use this information to analyze the use of the website,\n      create reports regarding website traffic and provide other services\n      related to the use of the website and the Internet to the website\n      operator. The IP address provided by the user's browser within the\n      framework of Google Analytics will not be combined with other data held\n      by Google. The user may prevent the saving of 'cookies' by selecting\n      appropriate settings of his browser. However, it should be remembered\n      that in such a case it may not be possible to use all functions of this\n      website to the full extent.\n    ")]), _vm._v(" "), _c('b', [_vm._v("’Cookie’ files")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('b', [_vm._v("The right to information, correction, blocking, deletion and\n      objection")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('b', [_vm._v("Changes of the privacy policy")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n      We reserve the right to adjust our privacy policy from time to time in\n      order to comply with current statutory requirements or to implement\n      changes regarding our services, e.g. when introducing new services.\n      Then, in case of a new visit, a new and updated privacy policy applies.\n    ")]), _vm._v(" "), _c('b', [_vm._v("Questions for the privacy policy representative")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n      In case of any questions regarding the privacy policy, please write to\n      us an e-mail message or directly contact our privacy policy\n      representative.\n    ")]), _vm._v(" "), _c('b', [_vm._v("Name and address of the data protection officer")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.feature.isAudiTarget) ? _c('p', [_vm._v("\n      Sebastian Heining-Boes\n      "), _c('br'), _vm._v("MdatIQs Data Solutions GmbH "), _c('br'), _vm._v("An der Alten Ziegelei 36b\n      "), _c('br'), _vm._v("DE-48157 Münster\n      "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:gdpr@mdatiqs.de"
    }
  }, [_vm._v("gdpr@mdatiqs.de")])]) : _c('p', [_vm._v("\n      Sebastian Heining-Boes\n      "), _c('br'), _vm._v("MdatIQs Data Solutions GmbH "), _c('br'), _vm._v("An der Alten Ziegelei 32\n      "), _c('br'), _vm._v("DE-48157 Münster\n      "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:gdpr@msm-group.com"
    }
  }, [_vm._v("gdpr@msm-group.com")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n      In order to use our personalized services, some personal data is\n      collected during the registration, for example: surname, address, as\n      well as contact and communication details, such as phone number and\n      e-mail address. If a user is registered at our website, he has access to\n      the content and services which are offered only to registered users. In\n      addition, users who are logged-in have the possibility of changing or\n      deleting the data provided during registration at any time. Of course,\n      we can provide the user with information about his personal data that\n      have been stored by us. If it is not contrary to statutory obligations\n      regarding data storage, we will be happy to correct or delete this data\n      at the user's request. In order to contact us regarding this matter,\n      please use the contact details provided at the end of this privacy\n      policy.\n      "), _c('br'), _vm._v("In order to ensure the user's data security during transmission,\n      we use encryption procedures which correspond with the current state of\n      the art (e.g. SSL) via HTTPS.\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n      Similarly to many other websites, we use the so-called 'cookie' files.\n      These are small text files sent from the server to the user's hard\n      drive. In this way, we automatically receive certain data through the\n      user's computer and its connection to the Internet, e.g. IP address,\n      used browsers, operating system.\n      "), _c('br'), _vm._v("'Cookie' files cannot be used to open programs or transfer viruses\n      onto a computer. Based on the information contained in the 'cookie'\n      files, we can facilitate the user's navigation and make it possible to\n      display our websites properly. "), _c('br'), _vm._v("There is no case in which the data\n      registered by us is transferred to third parties, nor is there any\n      connection with personal data being created without the consent of the\n      user. "), _c('br'), _vm._v("Of course, the user can, as a rule, browse our site without\n      using the 'cookie' files. Web browsers are usually set in such a way\n      that he accepts the 'cookie' files. The user may disable the use of\n      'cookie' files at any time by changing the settings of his browser. To\n      learn how to change these settings, use the help function of your web\n      browser. Keep in mind that in case of the 'cookie' files being disabled,\n      it is possible that particular functions of our website may not work\n      correctly.\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n      The user has the right to receive information about his personal data\n      being saved with us at any time. The user also has the right to correct,\n      block, or – regardless of saving data for the purpose of realizing a\n      transaction - to delete his personal data. For this purpose, please\n      contact our privacy policy representative, whose contact details can be\n      found at the end of this document.\n      "), _c('br'), _vm._v("In order to be able to apply the blocking procedure at any time,\n      this data must be stored in a blocking file for monitoring purposes. It\n      is also possible to request deletion of the data, unless there is a\n      statutory obligation to archive them. If such an obligation exists, we\n      block a user's data at his request. "), _c('br'), _vm._v("It is possible to make changes\n      or cancel the consent by informing us about it (with the future effect).\n    ")])
}]}

/***/ }),
/* 1717 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "customPropertyListEditModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "id": "propertyListEditForm"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeListEditModal()
      }
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.SM2500))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [(!_vm.propertyListAddEnabled) ? _c('button', {
    staticClass: "btn btn-raised btn-entry-actions",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showAddPropertyListInput()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("add_circle")]), _vm._v(" "), _c('br'), _vm._v("\n                    " + _vm._s(_vm.lang.SM2501) + "\n                  ")]) : _c('button', {
    staticClass: "btn btn-raised btn-warning btn-entry-actions",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addNewPropertyListEntries()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("add_circle")]), _vm._v(" "), _c('br'), _vm._v("\n                    " + _vm._s(_vm.lang.SM2501) + "\n                  ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.propertyListAddEnabled),
      expression: "!propertyListAddEnabled"
    }],
    staticClass: "col-md-10 text-left"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-entry-actions",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleSelectAllEntries()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v(_vm._s(_vm.allEntriesSelected() ? "remove_circle" : "check_circle"))]), _vm._v(" "), _c('br'), _vm._v("\n                    " + _vm._s(_vm.allEntriesSelected() ? _vm.lang.SM2503 : _vm.lang.SM2502) + "\n                  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-entry-actions",
    attrs: {
      "disabled": !_vm.isAnyEntrySelected()
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.removeSelectedEntries()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("delete")]), _vm._v(" "), _c('br'), _vm._v("\n                    " + _vm._s(_vm.lang.SM2504) + "\n                  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-entry-actions",
    attrs: {
      "disabled": !_vm.isAnyEntrySelected()
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleVisibilityOfSelectedEntries()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v(_vm._s(_vm.allSelectedEntriesVisible() ?
    "visibility_off" :
    "visibility"))]), _vm._v(" "), _c('br'), _vm._v("\n                    " + _vm._s(_vm.allSelectedEntriesVisible() ? _vm.lang.SM2505 : _vm.lang.SM2506) + "\n                  ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.propertyListAddEnabled),
      expression: "propertyListAddEnabled"
    }],
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propertyListAddData),
      expression: "propertyListAddData"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "rows": "5",
      "id": "textareaPropertyList",
      "placeholder": ((_vm.lang.SM2507) + " 1\n" + (_vm.lang.SM2507) + " 2\n" + (_vm.lang.SM2507) + " 3")
    },
    domProps: {
      "value": (_vm.propertyListAddData)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.propertyListAddData = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "propertyListValuesTableContainer"
    }
  }, [_c('table', {
    staticClass: "table table-striped table-hover",
    attrs: {
      "id": "propertyListValuesTable"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center col-md-10"
  }, [_vm._v(_vm._s(_vm.lang.SM2507))]), _vm._v(" "), _c('th', {
    staticClass: "text-center col-md-2"
  }, [_vm._v(_vm._s(_vm.lang.SM2508))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.propertyListData.Values), function(entry, index) {
    return _c('tr', {
      key: index,
      class: {
        info: entry.selected,
        error: entry.error
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          (entry.selected = !entry.selected), _vm.$forceUpdate()
        }
      }
    }, [_c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticClass: "form-group nopadding"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (entry.Value),
        expression: "entry.Value"
      }],
      staticClass: "form-control text-center nopadding",
      attrs: {
        "type": "text",
        "readonly": "true"
      },
      domProps: {
        "value": (entry.Value)
      },
      on: {
        "blur": function($event) {
          return _vm.propertyListEntryChanged($event, index)
        },
        "dblclick": _vm.editEntry,
        "click": function($event) {
          $event.target.readOnly ||
            $event.stopPropagation()
        },
        "change": function($event) {
          _vm.isPropertyListDataDirty = true
        },
        "keydown": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          $event.preventDefault();
          return $event.target.blur()
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(entry, "Value", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('td', {
      staticClass: "nopadding",
      attrs: {
        "id": "actionButtonContainer"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.isPropertyListDataDirty = true
        }
      }
    }, [_c('button', {
      staticClass: "btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.editEntry
      }
    }, [_c('i', {
      staticClass: "material-icons md-24"
    }, [_vm._v("edit")])]), _vm._v(" "), _c('button', {
      staticClass: "btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          (entry.Visible = !entry.Visible), _vm.$forceUpdate()
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24",
      class: {
        'text-grey': !entry.Visible
      }
    }, [_vm._v(_vm._s(entry.Visible ? "visibility" : "visibility_off"))])]), _vm._v(" "), _c('button', {
      staticClass: "btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeEntry(index)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24 text-red"
    }, [_vm._v("clear")])])])])
  }), 0)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default btn-close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeListEditModal()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.SM2509) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-default",
    class: {
      'btn-warning': _vm.isPropertyListDataDirty,
      'btn-success': !_vm.isPropertyListDataDirty,
    },
    attrs: {
      "type": "button",
      "disabled": _vm.hasPropertyListError || _vm.propertyListAddEnabled
    },
    on: {
      "click": function($event) {
        return _vm.storePropertyListItems()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.SM2510) + "\n          ")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1718 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.globals.isAccessAllowed('LoopOp_KPIs_ReadAll')) ? _c('div', [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "kpi-top-panel"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.refreshEnabled || _vm.disableButtonNoClientSelected()
    },
    on: {
      "click": function($event) {
        return _vm.getKpiData()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("refresh")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.KM0000) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": _vm.disableButtonNoClientSelected()
    },
    on: {
      "click": function($event) {
        return _vm.openKpiGroupEditModal()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("group_work")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.KM0010) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": _vm.disableButtonNoClientSelected()
    },
    on: {
      "click": function($event) {
        return _vm.openEditKpiDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("add_box")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.KM0001) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": _vm.disableButtonNoClientSelected()
    },
    on: {
      "click": function($event) {
        return _vm.openKpiAssignmentDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("assignment")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.KM0017) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": _vm.disableButtonNoClientSelected()
    },
    on: {
      "click": function($event) {
        return _vm.openKpiLanguageDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("language")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.KM0009) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.selectedClient
    },
    on: {
      "click": function($event) {
        _vm.showKPICopyModal = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("content_copy")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.KM0021) + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "form-group selectbar nopadding"
  }, [(
    !_vm.feature.isAudiTarget || !_vm.feature.isEnabled('audi_importers')
  ) ? _c('div', {
    staticClass: "select-filter-container",
    staticStyle: {
      "float": "left"
    }
  }, [_c('select2', {
    ref: "clientSelect",
    staticClass: "form-control",
    attrs: {
      "allowClear": true,
      "placeholder": _vm.lang.KM0011
    },
    on: {
      "change": function($event) {
        return _vm.onClientSelection()
      }
    },
    model: {
      value: (_vm.selectedClient),
      callback: function($$v) {
        _vm.selectedClient = $$v
      },
      expression: "selectedClient"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.clientList), function(client) {
    return _c('option', {
      key: client.ClientGuid,
      domProps: {
        "value": client.ClientGuid
      }
    }, [_vm._v("\n                " + _vm._s(client.ClientName) + "\n              ")])
  })], 2)], 1) : _c('div', {
    staticClass: "select-filter-container",
    staticStyle: {
      "float": "left"
    }
  }, [_c('select2', {
    ref: "importerSelect",
    staticClass: "form-control",
    attrs: {
      "allowClear": true,
      "placeholder": _vm.lang.KM0018
    },
    on: {
      "change": function($event) {
        (_vm.selectedKpiGuid = ''), (_vm.selectedKpiData = {}), _vm.getKpiData()
      }
    },
    model: {
      value: (_vm.selectedImporter),
      callback: function($$v) {
        _vm.selectedImporter = $$v
      },
      expression: "selectedImporter"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.importerList), function(importer) {
    return _c('option', {
      key: importer.ImporterGuid,
      domProps: {
        "value": importer.ImporterGuid
      }
    }, [_vm._v("\n                " + _vm._s(importer.ImporterName) + "\n              ")])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "select-filter-container"
  }, [_c('select2', {
    ref: "projectSelect",
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.clientProjectList.length < 1,
      "allowClear": true,
      "placeholder": _vm.lang.KM0012
    },
    on: {
      "change": function($event) {
        return _vm.doFiltering()
      }
    },
    model: {
      value: (_vm.selectedProject),
      callback: function($$v) {
        _vm.selectedProject = $$v
      },
      expression: "selectedProject"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.clientProjectList), function(project) {
    return _c('option', {
      key: project.ProjectGuid,
      domProps: {
        "value": project.ProjectGuid
      }
    }, [_vm._v("\n                " + _vm._s(project.ProjectName) + "\n              ")])
  })], 2)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('div', {
    staticClass: "form-group searchbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchString),
      expression: "searchString"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "search",
      "id": "KPIManagementSearchInput",
      "placeholder": _vm.lang.KM0002
    },
    domProps: {
      "value": (_vm.searchString)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1),
        (_vm.selectedKpiGuid = ''),
        (_vm.selectedKpiData = {}),
        _vm.doFiltering()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchString = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 nopadding"
  }, [_c('ul', {
    staticClass: "pagination-fonts pagination btn-group"
  }, [_c('li', [_vm._m(0), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "elementsPerPageDropdown",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.KM0003))]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 20
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 20)
      }
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 50
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 50)
      }
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 100
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 100)
      }
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 200
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 200)
      }
    }
  }, [_vm._v("200")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 500
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 500)
      }
    }
  }, [_vm._v("500")])])])], 1), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.filteredKpiData.length || _vm.selectedPage == 1,
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 0)
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "firstPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.KM0004))])], 1), _vm._v(" "), (_vm.numberOfPages() > 7 && _vm.selectedPage > 4) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getVisiblePages()), function(pageNumber) {
    return _c('li', {
      key: pageNumber,
      class: {
        active: _vm.selectedPage == pageNumber
      },
      on: {
        "click": function($event) {
          return _vm.updatePaging(pageNumber, 0)
        }
      }
    }, [_c('a', {
      attrs: {
        "role": "button"
      }
    }, [_vm._v(_vm._s(pageNumber))])])
  }), _vm._v(" "), (_vm.numberOfPages() > 7 && _vm.selectedPage < _vm.numberOfPages() - 3) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      disabled:
        !_vm.filteredKpiData.length || _vm.selectedPage == _vm.numberOfPages(),
    },
    on: {
      "click": function($event) {
        _vm.updatePaging(_vm.numberOfPages(), 0)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "lastPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.KM0005))])], 1), _vm._v(" "), _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button",
      "id": "kpisTotalElementsCounter"
    }
  }, [_vm._v(_vm._s(_vm.filteredKpiData.length))]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "kpisTotalElementsCounter",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.KM0020))])], 1)], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    staticClass: "table table-striped table-hover main-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('KPICode')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.KM0006) + "\n                "), (_vm.showSortArrow('KPICode', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('KPICode', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('KPIShortText')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.KM0007) + "\n                "), (_vm.showSortArrow('KPIShortText', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('KPIShortText', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('KPILongText')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.KM0008) + "\n                "), (_vm.showSortArrow('KPILongText', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('KPILongText', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('KPIGroups')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.KM0010) + "\n                "), (_vm.showSortArrow('KPIGroups', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('KPIGroups', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), (
    !_vm.feature.isAudiTarget || !_vm.feature.isEnabled('audi_importers')
  ) ? _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('ClientName')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.KM0013) + "\n                "), (_vm.showSortArrow('ClientName', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('ClientName', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('Importers')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.KM0019) + "\n                "), (_vm.showSortArrow('Importers', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('Importers', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('Projects')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.KM0015) + "\n                "), (_vm.showSortArrow('Projects', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('Projects', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('SurveyIdString')
      }
    }
  }, [_vm._v("\n                Survey\n                "), (_vm.showSortArrow('SurveyIdString', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('SurveyIdString', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('KPIEvaluationRuleName')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.KM0016) + "\n                "), (_vm.showSortArrow('KPIEvaluationRuleName', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('KPIEvaluationRuleName', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])])]), _vm._v(" "), _c('tr', {
    staticClass: "table-filters"
  }, [_c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.columnFilterObject.KPICode),
      expression: "columnFilterObject.KPICode"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.KM0014
    },
    domProps: {
      "value": (_vm.columnFilterObject.KPICode)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.doFiltering(), (_vm.selectedPage = 1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.columnFilterObject, "KPICode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.columnFilterObject.KPIShortText),
      expression: "columnFilterObject.KPIShortText"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.KM0014
    },
    domProps: {
      "value": (_vm.columnFilterObject.KPIShortText)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.doFiltering(), (_vm.selectedPage = 1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.columnFilterObject, "KPIShortText", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "15%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.columnFilterObject.KPILongText),
      expression: "columnFilterObject.KPILongText"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.KM0014
    },
    domProps: {
      "value": (_vm.columnFilterObject.KPILongText)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.doFiltering(), (_vm.selectedPage = 1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.columnFilterObject, "KPILongText", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.columnFilterObject.KPIGroups),
      expression: "columnFilterObject.KPIGroups"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.KM0014
    },
    domProps: {
      "value": (_vm.columnFilterObject.KPIGroups)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.doFiltering(), (_vm.selectedPage = 1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.columnFilterObject, "KPIGroups", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (
    !_vm.feature.isAudiTarget || !_vm.feature.isEnabled('audi_importers')
  ) ? _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "15%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.columnFilterObject.ClientName),
      expression: "columnFilterObject.ClientName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.KM0014
    },
    domProps: {
      "value": (_vm.columnFilterObject.ClientName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.doFiltering(), (_vm.selectedPage = 1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.columnFilterObject, "ClientName", $event.target.value)
      }
    }
  })])]) : _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.columnFilterObject.SurveyIdString),
      expression: "columnFilterObject.SurveyIdString"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.KM0014
    },
    domProps: {
      "value": (_vm.columnFilterObject.SurveyIdString)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.doFiltering(), (_vm.selectedPage = 1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.columnFilterObject, "SurveyIdString", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "15%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.columnFilterObject.KPIEvaluationRuleName),
      expression: "columnFilterObject.KPIEvaluationRuleName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.KM0014
    },
    domProps: {
      "value": (_vm.columnFilterObject.KPIEvaluationRuleName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.doFiltering(), (_vm.selectedPage = 1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.columnFilterObject, "KPIEvaluationRuleName", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('tbody', {
    staticClass: "main-table-scrollbar"
  }, _vm._l((_vm.kpiDataOnCurrentPage), function(kpi) {
    return _c('tr', {
      key: kpi.KPIGuid,
      class: {
        info: kpi.KPIGuid === _vm.selectedKpiGuid
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          (_vm.selectedKpiGuid = kpi.KPIGuid), (_vm.selectedKpiData = kpi)
        },
        "dblclick": function($event) {
          return _vm.openKpiAssignmentDialog()
        }
      }
    }, [_c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(kpi.KPICode))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(kpi.KPIShortText))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(kpi.KPILongText))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(kpi.KPIGroups[0].KPIGroupCode))]), _vm._v(" "), (
      !_vm.feature.isAudiTarget || !_vm.feature.isEnabled('audi_importers')
    ) ? _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v("\n              " + _vm._s(kpi.ClientName) + "\n            ")]) : _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v("\n              " + _vm._s(kpi.Importers ? kpi.Importers[0].ImporterName : "") + "\n            ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(kpi.Projects[0].ProjectName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(kpi.SurveyIdString))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(kpi.KPIEvaluationRuleName))])])
  }), 0)])])]), _vm._v(" "), _c('kpi-group-edit-modal', {
    attrs: {
      "showDialog": _vm.showKpiGroupEditDialog,
      "clientList": _vm.clientList,
      "projectList": _vm.projectList,
      "kpiGroupEvaluationRulesList": _vm.kpiGroupEvaluationRulesList,
      "selectedClientForKpiGroups": _vm.selectedClient
    },
    on: {
      "dialogClosed": _vm.onKpiGroupEditDialogClosed
    }
  }), _vm._v(" "), _c('kpi-management-edit-modal', {
    attrs: {
      "showDialog": _vm.showEditKpiDialog,
      "clientList": _vm.clientList,
      "selectedClientForKpi": _vm.selectedClient,
      "projectList": _vm.projectList,
      "kpiEvaluationRulesList": _vm.kpiEvaluationRulesList
    },
    on: {
      "dialogClosed": _vm.onEditKpiDialogClosed
    }
  }), _vm._v(" "), _c('kpi-assignment-modal', {
    attrs: {
      "showDialog": _vm.showKpiAssignmentDialog,
      "clientList": _vm.clientList,
      "projectList": _vm.projectList,
      "selectedClientFromParent": _vm.selectedClient,
      "selectedKpiData": _vm.selectedKpiData,
      "kpiEvaluationRulesList": _vm.kpiEvaluationRulesList,
      "kpiGroupEvaluationRulesList": _vm.kpiGroupEvaluationRulesList
    },
    on: {
      "dialogClosed": _vm.onKpiAssignmentDialogDialogClosed
    }
  }), _vm._v(" "), _c('kpi-management-translate-modal', {
    attrs: {
      "showDialog": _vm.showTranslateKpiDialog,
      "client": _vm.selectedClientForKpiTranslation,
      "projects": _vm.clientProjectList,
      "initialProject": _vm.selectedProject
    },
    on: {
      "dialogClosed": _vm.onTranslateKpiDialogClosed
    }
  }), _vm._v(" "), _c('KPICopyModal', {
    attrs: {
      "showModal": _vm.showKPICopyModal,
      "projects": _vm.clientProjectList,
      "selectedProject": _vm.selectedProject
    },
    on: {
      "copyDone": function($event) {
        return _vm.getKpiData()
      },
      "modalClosed": function($event) {
        _vm.showKPICopyModal = false
      }
    }
  })], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "role": "button",
      "data-toggle": "dropdown",
      "id": "elementsPerPageDropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("view_headline")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "firstPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("first_page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "lastPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("last_page")])])
}]}

/***/ }),
/* 1719 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.globals.currentUserInfo) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "panel panel-default text-left"
  }, [(
    _vm.globals.currentUserRole < 3 &&
    _vm.feature.isEnabled('changePasswordSelf') &&
    _vm.globals.isAccessAllowed('LoopOp_Password_ChangePasswordSelf') &&
    _vm.globals.isAccessAllowed('LoopOp_Password_ValidatePassword')
  ) ? _c('div', {
    attrs: {
      "id": "passwordResetContainer"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.lang.US0000))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showChangePasswordDialog = true
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.US0001) + "\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "filterSettingsContainer"
    }
  }, [_c('h2', [_vm._v("\n          " + _vm._s(_vm.lang.US0002) + "\n          "), _c('span', {
    staticClass: "beta-feature-indicator"
  }, [_vm._v("BETA")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox",
    attrs: {
      "id": "cbRememberFilterSettings"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rememberFilters),
      expression: "rememberFilters"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.rememberFilters) ? _vm._i(_vm.rememberFilters, null) > -1 : (_vm.rememberFilters)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.rememberFilters,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.rememberFilters = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.rememberFilters = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.rememberFilters = $$c
        }
      }, function($event) {
        (_vm.syncFilters = false), _vm.clearFilters()
      }]
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "text text-black"
  }, [_vm._v(_vm._s(_vm.lang.US0003))])])]), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "cbRememberFilterSettings",
      "boundary": "viewport",
      "triggers": "hover",
      "placement": "topright",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.US0004))]), _vm._v(" "), _c('div', {
    staticClass: "checkbox",
    attrs: {
      "id": "cbSyncFilterSettings"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncFilters),
      expression: "syncFilters"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": !_vm.rememberFilters
    },
    domProps: {
      "checked": Array.isArray(_vm.syncFilters) ? _vm._i(_vm.syncFilters, null) > -1 : (_vm.syncFilters)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.syncFilters,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.syncFilters = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.syncFilters = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.syncFilters = $$c
        }
      }, function($event) {
        return _vm.clearSharedFilters()
      }]
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "text text-black"
  }, [_vm._v(_vm._s(_vm.lang.US0005))])])]), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "cbSyncFilterSettings",
      "boundary": "viewport",
      "triggers": "hover",
      "placement": "topright",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.US0006))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button",
      "disabled": !_vm.rememberFilters
    },
    on: {
      "click": _vm.clearFilters
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.US0007) + "\n        ")])], 1), _vm._v(" "), (
    (_vm.globals.currentUserRole === 1 ||
      _vm.globals.currentUserInfo.IsLoggedInAsUser) &&
    _vm.feature.isEnabled('loginAs')
  ) ? _c('div', {
    attrs: {
      "id": "loginAsContainer"
    }
  }, [_c('h2', [_vm._v("\n          " + _vm._s(_vm.lang.US0008) + "\n          "), _c('span', {
    staticClass: "beta-feature-indicator"
  }, [_vm._v("BETA")])]), _vm._v(" "), (_vm.globals.currentUserInfo.IsLoggedInAsUser) ? _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.leaveLoginAsSession()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.US0009) + "\n          ")])]) : _c('div', {
    staticClass: "form-group"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "width": '300px',
      "placeholder": _vm.lang.US0010,
      "allowClear": true
    },
    model: {
      value: (_vm.loginAsUserId),
      callback: function($$v) {
        _vm.loginAsUserId = $$v
      },
      expression: "loginAsUserId"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.userList), function(user) {
    return _c('option', {
      key: user.UserId,
      domProps: {
        "value": user.UserId
      }
    }, [_vm._v("\n              " + _vm._s(user.LastName) + ", " + _vm._s(user.FirstName) + " (" + _vm._s(user.LoginName) + ")\n            ")])
  })], 2), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button",
      "disabled": !_vm.loginAsUserId
    },
    on: {
      "click": function($event) {
        return _vm.requestLoginAs()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.US0011) + "\n          ")])], 1)]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('change-password-dialog', {
    attrs: {
      "showDialog": _vm.showChangePasswordDialog
    },
    on: {
      "dialogClosed": function($event) {
        _vm.showChangePasswordDialog = false
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
}]}

/***/ }),
/* 1720 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "kpiAssignmentDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "id": "kpiAssignmentDialogForm"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.KM1000))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.lang.KM1001) + ":")]), _vm._v("\n            " + _vm._s(_vm.nameOfSelectedClient) + "\n            "), _c('b', [_vm._v("/ " + _vm._s(_vm.lang.KM1013) + ":")]), _vm._v("\n            " + _vm._s(_vm.nameOfSelectedProject) + "\n            "), _c('b', [_vm._v("/ " + _vm._s(_vm.lang.KM1002) + ":")]), _vm._v("\n            " + _vm._s(_vm.nameOfSelectedKpiGroup) + "\n            "), _c('b', [_vm._v("/ " + _vm._s(_vm.lang.KM1003) + ":")]), _vm._v("\n            " + _vm._s(_vm.nameOfselectedEvaluationRuleGuid) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "KPIAssignmentModalClientSelect"
    }
  }, [_vm._v(_vm._s(_vm.lang.KM1004))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "KPIAssignmentModalClientSelect",
      "disabled": _vm.feature.isAudiTarget &&
        _vm.feature.isEnabled('audi_importers')
    },
    on: {
      "change": function($event) {
        return _vm.getKpiGroupsOfSelectedClient(true)
      }
    },
    model: {
      value: (_vm.selectedClientGuid),
      callback: function($$v) {
        _vm.selectedClientGuid = $$v
      },
      expression: "selectedClientGuid"
    }
  }, _vm._l((_vm.clientList), function(client) {
    return _c('option', {
      key: client.ClientGuid,
      domProps: {
        "value": client.ClientGuid
      }
    }, [_vm._v("\n                          " + _vm._s(client.ClientName) + "\n                        ")])
  }), 0)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "KPIAssignmentModalKpiGroupSelect"
    }
  }, [_vm._v(_vm._s(_vm.lang.KM1005))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "KPIAssignmentModalKpiGroupSelect",
      "placeholder": _vm.lang.KM1006,
      "disabled": _vm.kpiGroupsOfSelectedClient.length < 1
    },
    on: {
      "change": function($event) {
        return _vm.getKpiInformation(true)
      }
    },
    model: {
      value: (_vm.selectedKpiGroupGuid),
      callback: function($$v) {
        _vm.selectedKpiGroupGuid = $$v
      },
      expression: "selectedKpiGroupGuid"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.kpiGroupsOfSelectedClient), function(kpiGroup) {
    return _c('option', {
      key: kpiGroup.KPIGroupGuid,
      domProps: {
        "value": kpiGroup.KPIGroupGuid
      }
    }, [_vm._v("\n                          " + _vm._s(kpiGroup.KPIGroupCode) + "\n                        ")])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "KPIAssignmentModalKpiSelect"
    }
  }, [_vm._v(_vm._s(_vm.lang.KM1007))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "KPIAssignmentModalKpiSelect",
      "placeholder": _vm.lang.KM1008,
      "disabled": _vm.kpisOfSelectedKpiGroup.length < 1
    },
    on: {
      "change": function($event) {
        return _vm.getKpiSurveyAssignment()
      }
    },
    model: {
      value: (_vm.selectedKpiGuid),
      callback: function($$v) {
        _vm.selectedKpiGuid = $$v
      },
      expression: "selectedKpiGuid"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.kpisOfSelectedKpiGroup), function(kpi) {
    return _c('option', {
      key: kpi.KPIGuid,
      domProps: {
        "value": kpi.KPIGuid
      }
    }, [_vm._v("\n                          " + _vm._s(kpi.KPICode) + "\n                        ")])
  })], 2)], 1)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    class: {
      'btn-warning': _vm.treeViewChanged
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.treeViewChanged || !_vm.selectedKpiGuid
    },
    on: {
      "click": function($event) {
        return _vm.saveKpiQuestionAssignmentData()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("save")]), _vm._v(" "), _c('br'), _vm._v("\n                    " + _vm._s(_vm.lang.KM1012) + "\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "padding-right": "0"
    }
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "KPIAssignmentModalSurveySelect"
    }
  }, [_vm._v(_vm._s(_vm.lang.KM1010))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "KPIAssignmentModalSurveySelect",
      "placeholder": _vm.lang.KM1011,
      "disabled": _vm.surveysFromSelectedKpiGroup.length < 1
    },
    on: {
      "change": function($event) {
        return _vm.getSelectedSurvey()
      }
    },
    model: {
      value: (_vm.selectedSurveyGuid),
      callback: function($$v) {
        _vm.selectedSurveyGuid = $$v
      },
      expression: "selectedSurveyGuid"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.surveysFromSelectedKpiGroup), function(survey) {
    return _c('option', {
      key: survey.SurveyGuid,
      domProps: {
        "value": survey.SurveyGuid
      }
    }, [_vm._v("\n                          " + _vm._s(survey.SurveyId) + " - " + _vm._s(survey.SurveyTitle) + "\n                        ")])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "well",
    attrs: {
      "id": "liquortreeContainerWell"
    }
  }, [(_vm.showTree) ? _c('liquortree', {
    ref: "kpiQuestionAssignmentTree",
    attrs: {
      "data": _vm.treeData,
      "options": _vm.treeOptions
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var node = ref.node;

        return _c('span', {
          staticClass: "tree-text"
        }, [(!node.data.IsCluster) ? [_c('div', {
          staticClass: "checkbox",
          staticStyle: {
            "margin": "0px",
            "padding-top": "3px"
          }
        }, [_c('label', [_c('input', {
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": node.checked()
          },
          on: {
            "change": function($event) {
              return _vm.toggleQuestionCheckbox(node)
            }
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "checkbox-material"
        }, [_c('span', {
          staticClass: "check"
        })]), _vm._v(" "), _c('span', {
          staticClass: "ltree-types-and-points"
        }, [_vm._v("(" + _vm._s(_vm.convertQuestionTypeToLetter(node.data.Type)) + "|" + _vm._s(node.data.PointsMax ?
          node.data.PointsMax :
          0) + ")")]), _vm._v(" "), _c('span', {
          staticClass: "text-black",
          attrs: {
            "id": node.data.QuestionGuid
          }
        }, [_vm._v(_vm._s(node.text))]), _vm._v(" "), _c('b-tooltip', {
          ref: "tooltip",
          attrs: {
            "target": node.data.QuestionGuid,
            "delay": _vm.globals.tooltipDelay
          }
        }, [_vm._v(_vm._s(node.text))])], 1)])] : [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v(_vm._s(node.checked() || node.indeterminate() ?
          "folder" :
          "folder_open"))]), _vm._v(" "), _c('span', {
          attrs: {
            "id": node.data.PanelGuid
          }
        }, [_vm._v(_vm._s(node.text))]), _vm._v(" "), _c('b-tooltip', {
          ref: "tooltip",
          attrs: {
            "target": node.data.PanelGuid,
            "delay": _vm.globals.tooltipDelay
          }
        }, [_vm._v(_vm._s(node.text))])]], 2)
      }
    }], null, false, 3633694616)
  }) : _vm._e()], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.KM1009) + "\n          ")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1721 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "locationManagementEditModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.dialogTitle))])]), _vm._v(" "), (_vm.locationData.LocationId) ? _c('div', [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("ID: " + _vm._s(_vm.locationData.LocationId))]), _vm._v(" "), _c('i', {
    staticClass: "material-icons md-24",
    attrs: {
      "id": "showLocationHistoryInfoIcon"
    },
    on: {
      "click": function($event) {
        return _vm.showLocationHistory()
      }
    }
  }, [_vm._v("history")]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "showLocationHistoryInfoIcon",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.L0090))])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel-group",
    attrs: {
      "id": "accordion",
      "role": "tablist",
      "aria-multiselectable": "true"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingGeneral",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseGeneral",
      "aria-expanded": "true",
      "aria-controls": "collapseGeneral"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.L0021))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in",
    attrs: {
      "id": "collapseGeneral",
      "role": "tabpanel",
      "aria-labelledby": "headingGeneral"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(
    !_vm.feature.isAudiTarget ||
    !_vm.feature.isEnabled('audi_importers')
  ) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputClient"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0022) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "inputClient",
      "name": "inputClient",
      "placeholder": _vm.lang.L0023,
      "disabled": _vm.selectedLocation > 0,
      "required": ""
    },
    on: {
      "change": function($event) {
        return _vm.getLocationProperties(_vm.locationData.ClientId)
      }
    },
    model: {
      value: (_vm.locationData.ClientId),
      callback: function($$v) {
        _vm.$set(_vm.locationData, "ClientId", $$v)
      },
      expression: "locationData.ClientId"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.clientList), function(client) {
    return _c('option', {
      key: client.ClientId,
      domProps: {
        "value": client.ClientId
      }
    }, [_vm._v("\n                        " + _vm._s(client.ClientName) + "\n                      ")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputClient')),
      expression: "inputHasError('inputClient')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.L0078))])], 1)]) : _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputLocationImporter"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0088) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "inputLocationImporter",
      "name": "inputLocationImporter",
      "placeholder": _vm.lang.L0023,
      "required": ""
    },
    model: {
      value: (_vm.locationData.ImporterGuid),
      callback: function($$v) {
        _vm.$set(_vm.locationData, "ImporterGuid", $$v)
      },
      expression: "locationData.ImporterGuid"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.importerList), function(importer) {
    return _c('option', {
      key: importer.ImporterGuid,
      domProps: {
        "value": importer.ImporterGuid
      }
    }, [_vm._v("\n                        " + _vm._s(importer.ImporterName) + "\n                      ")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputLocationImporter')),
      expression: "inputHasError('inputLocationImporter')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.L0078))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputStoreId"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0024) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationStoreId),
      expression: "locationData.LocationStoreId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputStoreId",
      "name": "inputStoreId",
      "required": ""
    },
    domProps: {
      "value": (_vm.locationData.LocationStoreId)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputStoreId')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationData, "LocationStoreId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputStoreId')),
      expression: "inputHasError('inputStoreId')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.L0078))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputLocationName"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0025) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationName),
      expression: "locationData.LocationName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputLocationName",
      "name": "inputLocationName",
      "maxlength": "50",
      "required": ""
    },
    domProps: {
      "value": (_vm.locationData.LocationName)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputLocationName')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationData, "LocationName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputLocationName')),
      expression: "inputHasError('inputLocationName')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.L0078))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputAddress"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0026))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationAddress),
      expression: "locationData.LocationAddress"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputAddress",
      "maxlength": "150"
    },
    domProps: {
      "value": (_vm.locationData.LocationAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationData, "LocationAddress", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputAddress2"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0027))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationAddress2),
      expression: "locationData.LocationAddress2"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputAddress2",
      "maxlength": "150"
    },
    domProps: {
      "value": (_vm.locationData.LocationAddress2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationData, "LocationAddress2", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputDistrict"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0028))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationCounty),
      expression: "locationData.LocationCounty"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputDistrict",
      "maxlength": "250"
    },
    domProps: {
      "value": (_vm.locationData.LocationCounty)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationData, "LocationCounty", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputCity"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0029))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationCity),
      expression: "locationData.LocationCity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputCity",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.locationData.LocationCity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationData, "LocationCity", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputCountry"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0030))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.lang.L0023,
      "allowClear": true
    },
    on: {
      "change": function($event) {
        return _vm.changedCountry(_vm.locationData.LocationCountry)
      }
    },
    model: {
      value: (_vm.locationData.LocationCountry),
      callback: function($$v) {
        _vm.$set(_vm.locationData, "LocationCountry", $$v)
      },
      expression: "locationData.LocationCountry"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.globals.countryList), function(country, ISOCode) {
    return _c('option', {
      key: ISOCode,
      domProps: {
        "value": ISOCode
      }
    }, [_vm._v("\n                        " + _vm._s(country) + "\n                      ")])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputRegion"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0031))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    ref: "regionSelect",
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.currentRegions.length < 1,
      "placeholder": _vm.lang.L0023,
      "allowClear": true
    },
    model: {
      value: (_vm.locationData.LocationState_Region),
      callback: function($$v) {
        _vm.$set(_vm.locationData, "LocationState_Region", $$v)
      },
      expression: "locationData.LocationState_Region"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.currentRegions), function(region) {
    return _c('option', {
      key: region.Region,
      domProps: {
        "value": region.Region
      }
    }, [_vm._v("\n                        " + _vm._s(region.RegionName) + "\n                      ")])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputTimeZone"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0032))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    ref: "timeZoneSelect",
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.currentTimeZones.length < 1,
      "placeholder": _vm.lang.L0023,
      "allowClear": true
    },
    model: {
      value: (_vm.locationData.LocationTimeZoneId),
      callback: function($$v) {
        _vm.$set(_vm.locationData, "LocationTimeZoneId", $$v)
      },
      expression: "locationData.LocationTimeZoneId"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.currentTimeZones), function(tz) {
    return _c('option', {
      key: tz.TimeZoneId,
      domProps: {
        "value": tz.TimeZoneId
      }
    }, [_vm._v("\n                        " + _vm._s(tz.TimeZoneName) + "\n                      ")])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputExportCountryCode"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0084))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "inputExportCountryCode",
      "placeholder": _vm.lang.L0023,
      "allowClear": true
    },
    on: {
      "change": function($event) {
        return _vm.changedExportCountryCode()
      }
    },
    model: {
      value: (_vm.locationData.LocationExportDefaultCountryCode),
      callback: function($$v) {
        _vm.$set(_vm.locationData, "LocationExportDefaultCountryCode", $$v)
      },
      expression: "locationData.LocationExportDefaultCountryCode"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.globals.countryList), function(country, ISOCode) {
    return _c('option', {
      key: ISOCode,
      domProps: {
        "value": ISOCode
      }
    }, [_vm._v("\n                        " + _vm._s(country) + "\n                      ")])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputExportLanguageCode"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0085))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    ref: "exportLanguageSelect",
    staticClass: "form-control",
    attrs: {
      "id": "inputExportLanguageCode",
      "disabled": _vm.currentExportLanguages.length < 1,
      "placeholder": _vm.lang.L0023,
      "allowClear": true
    },
    model: {
      value: (_vm.locationData.LocationExportDefaultLanguageCode),
      callback: function($$v) {
        _vm.$set(_vm.locationData, "LocationExportDefaultLanguageCode", $$v)
      },
      expression: "locationData.LocationExportDefaultLanguageCode"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.currentExportLanguages), function(language) {
    return _c('option', {
      key: language.LanguageCode,
      domProps: {
        "value": language.LanguageCode
      }
    }, [_vm._v("\n                        " + _vm._s(language.LanguageName) + "\n                      ")])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputPostalCode"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0033))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationPostalCode),
      expression: "locationData.LocationPostalCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputPostalCode",
      "maxlength": "12"
    },
    domProps: {
      "value": (_vm.locationData.LocationPostalCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationData, "LocationPostalCode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputPhone"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0034))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationPhone),
      expression: "locationData.LocationPhone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "inputPhone",
      "name": "inputPhone"
    },
    domProps: {
      "value": (_vm.locationData.LocationPhone)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputPhone')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationData, "LocationPhone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputPhone')),
      expression: "inputHasError('inputPhone')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.L0079))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputFax"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0035))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationFax),
      expression: "locationData.LocationFax"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "inputFax",
      "name": "inputFax"
    },
    domProps: {
      "value": (_vm.locationData.LocationFax)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputFax')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationData, "LocationFax", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputFax')),
      expression: "inputHasError('inputFax')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.L0080))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputPhotoURL"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0037))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationPhotoURL),
      expression: "locationData.LocationPhotoURL"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "url",
      "id": "inputPhotoURL",
      "name": "inputPhotoURL"
    },
    domProps: {
      "value": (_vm.locationData.LocationPhotoURL)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputPhotoURL')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationData, "LocationPhotoURL", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputPhotoURL')),
      expression: "inputHasError('inputPhotoURL')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.L0081))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputExportMail"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0038))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationExportEmail),
      expression: "locationData.LocationExportEmail"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "inputExportMail",
      "name": "inputExportMail",
      "multiple": ""
    },
    domProps: {
      "value": (_vm.locationData.LocationExportEmail)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputExportMail')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationData, "LocationExportEmail", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputExportMail')),
      expression: "inputHasError('inputExportMail')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.L0082))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputExportMailName"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0039))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationExportEmailName),
      expression: "locationData.LocationExportEmailName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputExportMailName"
    },
    domProps: {
      "value": (_vm.locationData.LocationExportEmailName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationData, "LocationExportEmailName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputStatus"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0040))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationStatusId),
      expression: "locationData.LocationStatusId"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.locationData, "LocationStatusId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.$forceUpdate()
      }]
    }
  }, _vm._l((_vm.locationStatusList), function(status, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": key
      }
    }, [_vm._v("\n                        " + _vm._s(status) + "\n                      ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputLatitude"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0044))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationLatitude),
      expression: "locationData.LocationLatitude"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "any",
      "min": "-90",
      "max": "90",
      "id": "inputLatitude"
    },
    domProps: {
      "value": (_vm.locationData.LocationLatitude)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationData, "LocationLatitude", $event.target.value)
      }, function($event) {
        return _vm.validateInput('inputLatitude')
      }]
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputLatitude')),
      expression: "inputHasError('inputLatitude')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.L0083))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputLongitude"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0045))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationLongitude),
      expression: "locationData.LocationLongitude"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "any",
      "min": "-180",
      "max": "180",
      "id": "inputLongitude"
    },
    domProps: {
      "value": (_vm.locationData.LocationLongitude)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationData, "LocationLongitude", $event.target.value)
      }, function($event) {
        return _vm.validateInput('inputLongitude')
      }]
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputLongitude')),
      expression: "inputHasError('inputLongitude')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.L0083))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputGeocodeSource"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0046))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationGeocodeSource),
      expression: "locationData.LocationGeocodeSource"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputGeocodeSource"
    },
    domProps: {
      "value": (_vm.locationData.LocationGeocodeSource)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationData, "LocationGeocodeSource", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingRemarks",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseRemarks",
      "aria-expanded": "false",
      "aria-controls": "collapseRemarks"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.L0052))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseRemarks",
      "role": "tabpanel",
      "aria-labelledby": "headingRemarks"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputAdditionalInfo"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0053))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationAdditionalInfo),
      expression: "locationData.LocationAdditionalInfo"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "6",
      "maxlength": "2000",
      "id": "inputAdditionalInfo"
    },
    domProps: {
      "value": (_vm.locationData.LocationAdditionalInfo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationData, "LocationAdditionalInfo", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.locationData.CustomProperties),
      expression: "locationData.CustomProperties"
    }],
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingCustProp",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseCustProp",
      "aria-expanded": "false",
      "aria-controls": "collapseCustProp"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.L0054))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.locationData.CustomProperties),
      expression: "locationData.CustomProperties"
    }],
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseCustProp",
      "role": "tabpanel",
      "aria-labelledby": "headingCustProp"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.L0055) + "\n                      ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.L0056) + "\n                      ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.locationData.CustomProperties), function(property) {
    return _c('tr', {
      key: property.ID
    }, [_c('td', [_vm._v(_vm._s(property.Name))]), _vm._v(" "), _c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticClass: "form-group nopadding"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (property.Value),
        expression: "property.Value"
      }],
      staticClass: "form-control text-center textarea-custom-properties autoExpand",
      attrs: {
        "rows": "1",
        "maxlength": "1000",
        "type": "text"
      },
      domProps: {
        "value": (property.Value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(property, "Value", $event.target.value)
        }
      }
    })])])])
  }), 0)])])])])]), _vm._v(" "), _c('b-alert', {
    attrs: {
      "variant": "danger",
      "dismissible": "",
      "show": _vm.showAlert
    },
    on: {
      "dismissed": function($event) {
        _vm.showAlert = false
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.L0057))])], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.L0058) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button",
      "id": "location-management-dialog-save-button",
      "disabled": !_vm.globals.isAccessAllowed('LoopOp_Locations_Update') &&
        _vm.selectedLocation > 0
    },
    on: {
      "click": function($event) {
        return _vm.validateBeforeSubmit('locationManagementEditModal')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.L0059) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 1722 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app__main",
    attrs: {
      "id": "app"
    }
  }, [(_vm.globals.spinnerVisible) ? _c('div', {
    staticClass: "loading"
  }) : _vm._e(), _vm._v(" "), (_vm.showSidebar) ? _c('AppSidebar', {
    attrs: {
      "lang": _vm.lang
    },
    on: {
      "set-title": function($event) {
        _vm.currentPageTitle = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showSidebar) ? _c('AppHeaderAlternative', {
    class: _vm.sidebarClass,
    attrs: {
      "title": _vm.currentPageTitle,
      "lang": _vm.lang,
      "languageList": _vm.languageList
    },
    on: {
      "toggle-mobile-menu": _vm.toggleMobileMenu,
      "set-title": function($event) {
        _vm.currentPageTitle = $event
      },
      "show-language-dialog": function($event) {
        return _vm.openSelectLanguageDialog()
      },
      "user-logout": function($event) {
        return _vm.userLogout()
      }
    }
  }) : _c('div', {
    staticClass: "navbar",
    class: _vm.sidebarClass,
    attrs: {
      "id": "app-navbar"
    }
  }, [_c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    class: {
      active: !_vm.$route.name
    }
  }, [(_vm.feature.isAudiTarget) ? _c('a', {
    staticStyle: {
      "padding": "18px"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/audi_loop_logo.png",
      "height": "18"
    }
  })]) : _c('a', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/msm_loop_logo.png",
      "height": "40"
    }
  })])])]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav"
  }, [(
    _vm.globals.isAccessAllowed('LoopOp_Clients_ReadAll') &&
    !_vm.globals.currentUserInfo.IsAudiUser
  ) ? _c('li', {
    class: {
      active: _vm.$route.name === 'ClientManagement'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/clientmanagement"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0000))])], 1) : _vm._e(), _vm._v(" "), (
    _vm.globals.isAudiUser ||
    _vm.globals.isLeadAgencyUser ||
    _vm.globals.isAdminUser
  ) ? _c('li', {
    class: {
      active: _vm.$route.name === 'configoverview'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/configoverview"
    }
  }, [_vm._v(_vm._s(_vm.lang.W00066))])], 1) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Locations_ReadAll')) ? _c('li', {
    class: {
      active: _vm.$route.name === 'LocationManagement'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/locationmanagement"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0001))])], 1) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_SecurityUsers_ReadAll')) ? _c('li', {
    class: {
      active: _vm.$route.name === 'UserManagement'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/usermanagement"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0010))])], 1) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Projects_ReadAll')) ? _c('li', {
    class: {
      active: _vm.$route.name === 'ProjectManagement'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/projectmanagement"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0011))])], 1) : _vm._e(), _vm._v(" "), (
    _vm.globals.isAccessAllowed('LoopOp_Agencies_ReadAll') &&
    !_vm.globals.isLocalAgencyUser
  ) ? _c('li', {
    class: {
      active: _vm.$route.name === 'AgencyManagement'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/agencymanagement"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0012))])], 1) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Surveys_ReadAll')) ? _c('li', {
    class: {
      active: _vm.$route.name === 'SurveyManagement'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/surveymanagement"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0013))])], 1) : _vm._e(), _vm._v(" "), (
    _vm.globals.isAccessAllowed('LoopOp_SurveyInstances_ReadAll') &&
    _vm.globals.currentUserRole < 3
  ) ? _c('li', {
    class: {
      active: _vm.$route.name === 'CheckManagement'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/checkmanagement"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0014))])], 1) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_KPIs_ReadAll')) ? _c('li', {
    class: {
      active: _vm.$route.name === 'KPIManagement'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/kpimanagement"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0016))])], 1) : _vm._e(), _vm._v(" "), (
    _vm.feature.isEnabled('shoppermanagement') &&
    _vm.globals.isAccessAllowed('LoopOp_Shopper_ReadAll') &&
    !(
      _vm.feature.isAudiTarget &&
      (_vm.globals.isLeadAgencyUser || _vm.globals.isAudiUser)
    )
  ) ? _c('li', {
    class: {
      active: _vm.$route.name === 'ShopperManagement'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/shoppermanagement"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0023))])], 1) : _vm._e(), _vm._v(" "), (
    _vm.feature.isEnabled('recruiting') &&
    _vm.globals.isAccessAllowed('LoopOp_Recruiting_ReadAll')
  ) ? _c('li', {
    class: {
      active: _vm.$route.name === 'Recruiting'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/recruiting"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0029))])], 1) : _vm._e(), _vm._v(" "), (
    _vm.feature.isEnabled('shopperApproval') && _vm.globals.currentUserInfo
  ) ? _c('li', {
    class: {
      active: _vm.$route.name === 'ShopperApproval'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/shopperapproval"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0032))])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      active: _vm.$route.name === 'StatusManagement'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/statusmanagement"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0034))])], 1)]), _vm._v(" "), (_vm.userLoginState) ? _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', [_c('a', {
    staticStyle: {
      "max-height": "60px"
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openSelectLanguageDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("public")]), _vm._v("\n            " + _vm._s(_vm.languageList[_vm.globals.selectedLanguage]) + "\n          ")])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    staticStyle: {
      "max-height": "60px"
    },
    attrs: {
      "href": "bootstrap-elements.html",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("person")]), _vm._v("\n            " + _vm._s(_vm.globals.currentUserInfo.LoginName) + "\n            "), _c('b', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [(_vm.feature.isEnabled('userSettings')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/settings"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("settings")]), _vm._v("\n                " + _vm._s(_vm.lang.A0024) + "\n              ")])], 1) : _vm._e(), _vm._v(" "), (!_vm.feature.isAudiTarget) ? _c('li', [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.redirectToSupport()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("live_help")]), _vm._v("\n                " + _vm._s(_vm.lang.A0021) + "\n              ")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.userLogout()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("exit_to_app")]), _vm._v("\n                " + _vm._s(_vm.lang.A0003) + "\n              ")])])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "app__router-view",
    class: _vm.sidebarClass
  }, [(_vm.isAccessTokenAvailable) ? _c('router-view', {
    key: _vm.$route.fullPath
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "selectLanguageDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.A0006))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.lang.A0007))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-md-offset-2",
    staticStyle: {
      "padding-bottom": "20px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nextLanguage),
      expression: "nextLanguage"
    }],
    staticClass: "form-control language-select",
    attrs: {
      "id": "selectLanguage"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.nextLanguage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.languageList), function(language, isocode) {
    return _c('option', {
      key: isocode,
      domProps: {
        "value": isocode
      }
    }, [_vm._v("\n                  " + _vm._s(language) + "\n                ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default dialog-btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.selectedLanguageDialogClosed
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.A0009) + "\n          ")])])])])]), _vm._v(" "), _c('confirmation-dialog', {
    attrs: {
      "dialogId": _vm.confirmationDialogId,
      "confirmationTitle": _vm.confirmationDialogData.confirmationTitle,
      "yesButtonText": _vm.confirmationDialogData.yesButtonText,
      "noButtonText": _vm.confirmationDialogData.noButtonText,
      "showDialog": _vm.showConfirmationDialog,
      "colorRed": _vm.confirmationDialogData.colorRed,
      "htmlText": _vm.confirmationDialogData.htmlText
    },
    on: {
      "onYesConfirmation": _vm.onYesConfirmation,
      "onNoConfirmation": _vm.onNoConfirmation,
      "dialogClosed": _vm.onConfirmationDialogClosed,
      "closeDialog": _vm.onCloseConfirmationDialog
    }
  }), _vm._v(" "), _c('notification-dialog', {
    attrs: {
      "dialogId": _vm.notificationDialogId,
      "notificationTitle": _vm.notificationDialogData.notificationTitle,
      "closeButtonText": _vm.notificationDialogData.closeButtonText,
      "showDialog": _vm.showNotificationDialog,
      "colorRed": _vm.notificationDialogData.colorRed,
      "htmlText": _vm.notificationDialogData.htmlText
    },
    on: {
      "closeDialog": _vm.onCloseNotificationDialog,
      "dialogClosed": _vm.onNotificationDialogClosed
    }
  }), _vm._v(" "), _c('upload-progress-modal', {
    attrs: {
      "showDialog": _vm.showUploadProgress,
      "progress": _vm.globals.currentUploadProgress
    },
    on: {
      "cancelUpload": function($event) {
        return _vm.globals.cancelPendingUploads()
      }
    }
  }), _vm._v(" "), (_vm.globals.currentUserRole < 2) ? _c('edit-vat-rates-modal', {
    attrs: {
      "showModal": _vm.showEditVatRatesModal
    },
    on: {
      "modalClosed": function($event) {
        _vm.showEditVatRatesModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('changelog-modal', {
    attrs: {
      "showDialog": _vm.showChangelogModal
    },
    on: {
      "closeDialog": function($event) {
        _vm.showChangelogModal = false
      }
    }
  }), _vm._v(" "), _c('HtmlEditorModal', {
    attrs: {
      "showModal": _vm.showHtmlEditorModal
    },
    on: {
      "modalClosed": function($event) {
        _vm.showHtmlEditorModal = false
      }
    }
  }), _vm._v(" "), _c('ElementHistoryModal'), _vm._v(" "), _c('FeedModal'), _vm._v(" "), _c('div', {
    class: {
      warning: _vm.globals.isLoggedInAsOtherUser
    },
    attrs: {
      "id": "defaultAppFooter"
    }
  }, [(_vm.globals.isLoggedInAsOtherUser) ? _c('span', [_vm._v("\n      " + _vm._s(_vm.lang.A0033) + ":\n      "), _c('router-link', {
    attrs: {
      "to": "/settings"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.globals.currentUserInfo.IsLoggedInAsUser))])])], 1) : _vm._e(), _vm._v(" "), _c('span', {
    attrs: {
      "id": "footerLinkContainer"
    }
  }, [_c('a', {
    attrs: {
      "href": ("https://" + _vm.mainOpHost + "/imprint.html"),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0018))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": ("https://" + _vm.mainOpHost + "/dataProtection.html"),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0017))])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "frontendVersionIndicator"
    },
    on: {
      "click": function($event) {
        _vm.showChangelogModal = true
      }
    }
  }, [_vm._v("v" + _vm._s(_vm.appVersion))])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1723 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "settlementDownloadModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.SDM000))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputSettlementNumber"
    }
  }, [_vm._v(_vm._s(_vm.lang.SDM001))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settlementNumber),
      expression: "settlementNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputSettlementNumber"
    },
    domProps: {
      "value": (_vm.settlementNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.settlementNumber = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.globals.isPaymentsEditingAllowed) ? _c('button', {
    staticClass: "btn btn-raised btn-success pull-left",
    attrs: {
      "type": "button",
      "id": "createNewSettlementButton",
      "disabled": !!_vm.settlementNumber
    },
    on: {
      "click": function($event) {
        return _vm.createNewSettlementList()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.SDM002) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.SDM003) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button",
      "disabled": !_vm.settlementNumber
    },
    on: {
      "click": function($event) {
        return _vm.downloadSettlementList()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.SDM004) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 1724 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.dialogId,
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.notificationTitle))])])]), _vm._v(" "), (!_vm.htmlText) ? _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("default")], 2) : _c('div', {
    staticClass: "modal-body",
    domProps: {
      "innerHTML": _vm._s(_vm.htmlText)
    }
  }, [_vm._v(_vm._s(_vm.htmlText))]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    class: [this.colorRed ? 'btn-danger' : 'dialog-btn-primary'],
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.closeButtonText) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 1725 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "approval-top-panel"
    }
  }, [_c('div', {
    staticClass: "panel-body top-button-bar"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    on: {
      "click": function($event) {
        return _vm.getApprovalData(false)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("refresh")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.SA0000) + "\n        ")]), _vm._v(" "), (_vm.globals.isLocalAgencyUser || _vm.globals.isLeadAgencyUser || _vm.globals.isAdminUser) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.isSelectedCheckOnCurrentPage
    },
    on: {
      "click": function($event) {
        _vm.getApprovalData(false, function () { return (_vm.showShopperProposalModal = true); })
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("person_add")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.SA0001) + "\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.globals.isAgencyUser || _vm.globals.isLeadAgencyUser) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.isSelectedCheckOnCurrentPage || !_vm.selectedCheck.ShopperProposals
    },
    on: {
      "click": function($event) {
        _vm.getApprovalData(false, function () { return (_vm.toggleShopperApprovalModal()); })
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("assignment_turned_in")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.SA0002) + "\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.globals.isAgencyUser) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    on: {
      "click": function($event) {
        _vm.showCarModelManagement = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("drive_eta")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.SA0003) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    on: {
      "click": function($event) {
        _vm.getApprovalData(false), _vm.globals.$emit('showApprovalWaveStatus', _vm.selectedCheck)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("insert_chart")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.SA0004) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    on: {
      "click": function($event) {
        _vm.showExportDialog = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("file_download")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.SA0048) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    on: {
      "click": function($event) {
        _vm.showMap = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("place")]), _vm._v(" "), _c('br'), _vm._v("\n          Map\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "form-group searchbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Search),
      expression: "filterStrings.Search"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0005
    },
    domProps: {
      "value": (_vm.filterStrings.Search)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Search", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 nopadding"
  }, [_c('ul', {
    staticClass: "pagination-fonts pagination btn-group"
  }, [_c('li', [_vm._m(0), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "elementsPerPageDropdown",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SA0006))]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize === 20
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 20)
      }
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize === 50
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 50)
      }
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize === 100
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 100)
      }
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize === 200
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 200)
      }
    }
  }, [_vm._v("200")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize === 500
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 500)
      }
    }
  }, [_vm._v("500")])])])], 1), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.pageCount || _vm.selectedPage === 1
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 0)
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "firstPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SA0007))])], 1), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage > 4) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getVisiblePages()), function(pageNumber) {
    return _c('li', {
      key: pageNumber,
      class: {
        active: _vm.selectedPage === pageNumber
      },
      on: {
        "click": function($event) {
          return _vm.updatePaging(pageNumber)
        }
      }
    }, [_c('a', {
      attrs: {
        "role": "button"
      }
    }, [_vm._v(_vm._s(pageNumber))])])
  }), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage < _vm.pageCount - 3) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.pageCount || _vm.selectedPage === _vm.pageCount,
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(_vm.pageCount)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "lastPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SA0008))])], 1), _vm._v(" "), _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button",
      "id": "approvalTotalElementsCounter"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.checkCount) + "\n            ")]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "approvalTotalElementsCounter",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SA0009))])], 1)], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    staticClass: "table table-striped table-hover main-table",
    attrs: {
      "id": "approvalMainTable"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "4%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('SurveyInstanceId')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SA0011) + "\n                "), (_vm.sortField == 'SurveyInstanceId' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'SurveyInstanceId' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "6%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('SurveyInstanceInfo')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CM0073) + "\n                "), (_vm.sortField == 'SurveyInstanceInfo' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'SurveyInstanceInfo' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('WaveName')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SA0013) + "\n                "), (_vm.sortField == 'WaveName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'WaveName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('LocationStoreId')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SA0014) + "\n                "), (_vm.sortField == 'LocationStoreId' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'LocationStoreId' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "7%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('LocationName')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SA0015) + "\n                "), (_vm.sortField == 'LocationName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'LocationName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('LocationCity')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SA0016) + "\n                "), (_vm.sortField == 'LocationCity' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'LocationCity' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "4%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('LocationCountry')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SA0017) + "\n                "), (_vm.sortField == 'LocationCountry' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'LocationCountry' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('DealerGroup')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SA0018) + "\n                "), (_vm.sortField == 'DealerGroup' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'DealerGroup' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "4%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('Brand')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SA0019) + "\n                "), (_vm.sortField == 'Brand' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'Brand' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('UTCLastUpdatedAt')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SA0020) + "\n                "), (_vm.sortField == 'UTCLastUpdatedAt' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'UTCLastUpdatedAt' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center unsortable-column-header",
    staticStyle: {
      "width": "3%"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.SA0021) + "\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center unsortable-column-header",
    staticStyle: {
      "width": "7%"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.SA0022) + " (" + _vm._s(_vm.lang.SA0023) + ")\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center unsortable-column-header",
    staticStyle: {
      "width": "3%"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.SA0024) + "\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center unsortable-column-header",
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.SA0025) + "\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center unsortable-column-header",
    staticStyle: {
      "width": "7%"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.SA0026) + "\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center unsortable-column-header",
    staticStyle: {
      "width": "2.5%"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.SA0027) + "\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center unsortable-column-header",
    staticStyle: {
      "width": "4%"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.SA0028) + "\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center unsortable-column-header",
    staticStyle: {
      "width": "4%"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.SA0029) + "\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center unsortable-column-header",
    staticStyle: {
      "width": "3%"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.SA0030) + "\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center unsortable-column-header",
    staticStyle: {
      "width": "4%"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.SA0031) + "\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center unsortable-column-header",
    staticStyle: {
      "width": "4%"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.SA0032) + "\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center unsortable-column-header",
    staticStyle: {
      "width": "3.5%"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.SAM002) + "\n            ")])]), _vm._v(" "), _c('tr', {
    staticClass: "table-filters"
  }, [_c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "4%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstanceId),
      expression: "filterStrings.SurveyInstanceId"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstanceId)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstanceId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "6%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstanceInfo),
      expression: "filterStrings.SurveyInstanceInfo"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstanceInfo)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstanceInfo", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.WaveName),
      expression: "filterStrings.WaveName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.WaveName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "WaveName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationStoreId),
      expression: "filterStrings.LocationStoreId"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.LocationStoreId)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationStoreId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "7%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationName),
      expression: "filterStrings.LocationName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.LocationName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationCity),
      expression: "filterStrings.LocationCity"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.LocationCity)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationCity", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "4%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationCountry),
      expression: "filterStrings.LocationCountry"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.LocationCountry)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationCountry", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.DealerGroup),
      expression: "filterStrings.DealerGroup"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.DealerGroup)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "DealerGroup", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "4%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Brand),
      expression: "filterStrings.Brand"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.Brand)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Brand", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar",
    attrs: {
      "id": "inputFilterLastUpdateAtContainer"
    },
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr('inputFilterLastUpdateAt')
      }
    }
  }, [_c('input', {
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "text",
      "id": "inputFilterLastUpdateAt",
      "placeholder": _vm.lang.SA0033
    }
  }), _vm._v(" "), (_vm.lastUpdateAtFilterContent) ? _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "inputFilterLastUpdateAtContainer",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lastUpdateAtFilterContent))]) : _vm._e()], 1)]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "3%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ShopperId),
      expression: "filterStrings.ShopperId"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.ShopperId)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ShopperId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "7%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.DisplayName),
      expression: "filterStrings.DisplayName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.DisplayName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "DisplayName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "3%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Gender),
      expression: "filterStrings.Gender"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.Gender)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Gender", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Distance),
      expression: "filterStrings.Distance"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.Distance)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Distance", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "7%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Occupation),
      expression: "filterStrings.Occupation"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.Occupation)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Occupation", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "2.5%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.CarModelName),
      expression: "filterStrings.CarModelName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.CarModelName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "CarModelName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "4%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.CarSegmentName),
      expression: "filterStrings.CarSegmentName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.CarSegmentName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "CarSegmentName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "4%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ShopperCar),
      expression: "filterStrings.ShopperCar"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.ShopperCar)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ShopperCar", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "3%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.CarMatch),
      expression: "filterStrings.CarMatch"
    }],
    staticClass: "form-control text-center nopadding",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filterStrings, "CarMatch", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        (_vm.selectedPage = 1), _vm.getApprovalData(false)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": ''
    }
  }, [_vm._v(_vm._s(_vm.lang.SA0034))]), _vm._v(" "), _c('option', {
    domProps: {
      "value": '+'
    }
  }, [_vm._v("+ " + _vm._s(_vm.lang.SA0035))]), _vm._v(" "), _c('option', {
    domProps: {
      "value": '='
    }
  }, [_vm._v("= " + _vm._s(_vm.lang.SA0036))]), _vm._v(" "), _c('option', {
    domProps: {
      "value": '-'
    }
  }, [_vm._v("- " + _vm._s(_vm.lang.SA0037))])])])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "4%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ApprovedByLeadAgency),
      expression: "filterStrings.ApprovedByLeadAgency"
    }],
    staticClass: "form-control text-center nopadding",
    class: {
      'option-green': _vm.filterStrings.ApprovedByLeadAgency === 'Approved',
      'option-red': _vm.filterStrings.ApprovedByLeadAgency === 'Rejected',
      'option-yellow': _vm.filterStrings.ApprovedByLeadAgency === 'Open',
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filterStrings, "ApprovedByLeadAgency", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        (_vm.selectedPage = 1), _vm.getApprovalData(false)
      }]
    }
  }, [_c('option', {
    staticClass: "option-white",
    domProps: {
      "value": ''
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.lang.SA0034) + "\n                  ")]), _vm._v(" "), _c('option', {
    staticClass: "option-white",
    domProps: {
      "value": 'None'
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.lang.SA0038) + "\n                  ")]), _vm._v(" "), _c('option', {
    staticClass: "option-green",
    domProps: {
      "value": 'Approved'
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.lang.SA0039) + "\n                  ")]), _vm._v(" "), _c('option', {
    staticClass: "option-yellow",
    domProps: {
      "value": 'Open'
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.lang.SA0040) + "\n                  ")]), _vm._v(" "), _c('option', {
    staticClass: "option-red",
    domProps: {
      "value": 'Rejected'
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.lang.SA0041) + "\n                  ")])])])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "4%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ApprovedByMainEntity),
      expression: "filterStrings.ApprovedByMainEntity"
    }],
    staticClass: "form-control text-center nopadding",
    class: {
      'option-green': _vm.filterStrings.ApprovedByMainEntity === 'Approved',
      'option-red': _vm.filterStrings.ApprovedByMainEntity === 'Rejected',
      'option-yellow': _vm.filterStrings.ApprovedByMainEntity === 'Open',
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filterStrings, "ApprovedByMainEntity", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        (_vm.selectedPage = 1), _vm.getApprovalData(false)
      }]
    }
  }, [_c('option', {
    staticClass: "option-white",
    domProps: {
      "value": ''
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.lang.SA0034) + "\n                  ")]), _vm._v(" "), _c('option', {
    staticClass: "option-white",
    domProps: {
      "value": 'None'
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.lang.SA0038) + "\n                  ")]), _vm._v(" "), _c('option', {
    staticClass: "option-green",
    domProps: {
      "value": 'Approved'
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.lang.SA0039) + "\n                  ")]), _vm._v(" "), _c('option', {
    staticClass: "option-yellow",
    domProps: {
      "value": 'Open'
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.lang.SA0040) + "\n                  ")]), _vm._v(" "), _c('option', {
    staticClass: "option-red",
    domProps: {
      "value": 'Rejected'
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.lang.SA0041) + "\n                  ")])])])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "3.5%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.FeedPostCount),
      expression: "filterStrings.FeedPostCount"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "number"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filterStrings, "FeedPostCount", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        (_vm.selectedPage = 1), _vm.getApprovalData(false)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": ''
    }
  }, [_vm._v(_vm._s(_vm.lang.SA0034))]), _vm._v(" "), _c('option', {
    domProps: {
      "value": '1'
    }
  }, [_vm._v(_vm._s(_vm.lang.SA0054))])])])])])]), _vm._v(" "), _c('tbody', {
    staticClass: "main-table-scrollbar"
  }, [_vm._l((_vm.approvalData), function(check) {
    return [_c('tr', {
      key: check.SurveyInstanceGuid,
      class: {
        info: _vm.isCheckSelected(check.SurveyInstanceId)
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          _vm.selectedCheck = check;
          _vm.selectCheck(check.SurveyInstanceId, $event)
        }
      }
    }, [_c('td', {
      staticClass: "wave-state-indicator",
      class: {
        'state-yellow': check.AudiStatus === 'WaveStarted',
        'state-orange': check.AudiStatus === 'WaveOneHalfPassed',
        'state-red': check.AudiStatus === 'WaveTwoThirdsPassed' || check.AudiStatus === 'ActionRequired',
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "4%"
      }
    }, [_vm._v(_vm._s(check.SurveyInstanceId))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%"
      }
    }, [_vm._v(_vm._s(check.SurveyInstanceInfo))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "5%"
      },
      attrs: {
        "id": ("approvalWaveNameTableData" + (check.SurveyInstanceGuid))
      }
    }, [_vm._v("\n                " + _vm._s(check.WaveName) + "\n                "), _c('br'), _vm._v(" "), (check.CarModelDistribution) ? _c('i', {
      staticClass: "material-icons md-24"
    }, [_vm._v("info_outline")]) : _vm._e(), _vm._v(" "), (check.IsLeadAgencyPlus) ? _c('i', {
      staticClass: "material-icons md-24"
    }, [_vm._v("add_box")]) : _vm._e()]), _vm._v(" "), (check.CarModelDistribution || check.CompetitorCarModelDistribution) ? _c('b-tooltip', {
      ref: "tooltip",
      refInFor: true,
      attrs: {
        "target": ("approvalWaveNameTableData" + (check.SurveyInstanceGuid)),
        "delay": _vm.globals.tooltipDelay
      }
    }, [(check.CarModelDistribution) ? [_c('b', [_vm._v(_vm._s(_vm.lang.SA0045) + ":")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((check.CarModelDistribution), function(model) {
      return _c('span', {
        key: model.CarModelGuid
      }, [_vm._v("\n                    " + _vm._s(model.CarModelName) + " - " + _vm._s(model.Distribution * 100) + "%\n                    "), _c('br')])
    })] : _vm._e(), _vm._v(" "), (check.CarModelDistribution && check.CompetitorCarModelDistribution) ? [_c('br')] : _vm._e(), _vm._v(" "), (check.CompetitorCarModelDistribution) ? [_c('b', [_vm._v(_vm._s(_vm.lang.SA0046) + ":")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((check.CompetitorCarModelDistribution), function(model) {
      return _c('span', {
        key: model.CompetitorCarModelGuid
      }, [_vm._v(" " + _vm._s(model.CompetitorCarBrand) + "\n                    " + _vm._s(model.CompetitorCarModel) + " -\n                    " + _vm._s(model.Distribution * 100) + "%\n                    "), _c('br')])
    })] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [_vm._v(_vm._s(check.LocationStoreId))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7%"
      }
    }, [_vm._v(_vm._s(check.LocationName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [_vm._v(_vm._s(check.LocationCity))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "4%"
      }
    }, [_vm._v(_vm._s(check.LocationCountry))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [_vm._v(_vm._s(check.DealerGroup))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "4%"
      }
    }, [_vm._v(_vm._s(check.Brand))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "5%"
      },
      attrs: {
        "id": ("approvalDateDiffTableData" + (check.SurveyInstanceGuid))
      }
    }, [(check.LastUpdatedAt) ? _c('span', [_vm._v("\n                  " + _vm._s(check.LastUpdatedAt) + " "), _c('br'), _vm._v(" "), (check.LastUpdatedColumn) ? _c('span', [_vm._v(_vm._s(_vm.lang.SA0052) + " " + _vm._s(check.LastUpdatedColumn) + " "), _c('br')]) : _vm._e(), _vm._v("\n                  " + _vm._s(_vm.lang.SA0053) + " " + _vm._s(check.SurveyInstanceStatusId) + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('b-tooltip', {
      ref: "tooltip",
      refInFor: true,
      attrs: {
        "target": ("approvalDateDiffTableData" + (check.SurveyInstanceGuid)),
        "delay": _vm.globals.tooltipDelay
      }
    }, [_vm._v(_vm._s(check.UTCLastUpdatedAt))]), _vm._v(" "), _c('td', {
      staticClass: "nested-table-container",
      staticStyle: {
        "width": "50%"
      }
    }, [(check.ShopperProposals) ? [_c('table', {
      staticClass: "nested-table"
    }, _vm._l((check.ShopperProposals), function(proposal) {
      return _c('tr', {
        key: proposal.ShopperProposalGuid
      }, [_c('td', {
        staticStyle: {
          "width": "6%"
        }
      }, [_vm._v(_vm._s(proposal.ShopperId))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "14%"
        }
      }, [_vm._v(_vm._s(proposal.DisplayName))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "6%"
        }
      }, [_vm._v(_vm._s(proposal.Gender))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "10%"
        }
      }, [(typeof proposal.Distance === 'number') ? _c('span', [_vm._v(_vm._s(proposal.Distance) + " km")]) : _vm._e()]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "14%"
        }
      }, [_vm._v(_vm._s(proposal.Occupation))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "5%"
        }
      }, [_vm._v(_vm._s(proposal.CarModelName))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "8%"
        }
      }, [_vm._v("\n                        " + _vm._s(proposal.CarSegmentName) + "\n                      ")]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "8%"
        }
      }, [_vm._v(_vm._s(proposal.ShopperCar))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "6%"
        }
      }, [_vm._v(_vm._s(proposal.CarMatch))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "8%",
          "padding": "6px 0 0 0"
        }
      }, [(proposal.AgencyApprovalStatus === 'Approved') ? _c('i', {
        staticClass: "material-icons md-24 nopadding text-green"
      }, [_vm._v("done")]) : (proposal.AgencyApprovalStatus === 'Rejected') ? _c('i', {
        staticClass: "material-icons md-24 nopadding text-red"
      }, [_vm._v("clear")]) : _c('i', {
        staticClass: "material-icons md-24 nopadding text-yellow"
      }, [_vm._v("lens")])]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "8%",
          "padding": "6px 0 0 0"
        }
      }, [(proposal.MainEntityApprovalStatus === 'Approved') ? _c('i', {
        staticClass: "material-icons md-24 nopadding text-green"
      }, [_vm._v("done")]) : (proposal.MainEntityApprovalStatus === 'Rejected') ? _c('i', {
        staticClass: "material-icons md-24 nopadding text-red"
      }, [_vm._v("clear")]) : _c('i', {
        staticClass: "material-icons md-24 nopadding text-yellow"
      }, [_vm._v("lens")])]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "7%",
          "padding": "6px 0 0 0"
        }
      }, [(proposal.FeedPostCount > 0) ? _c('i', {
        staticClass: "material-icons md-24"
      }, [_vm._v("forum")]) : _vm._e()])])
    }), 0)] : _vm._e()], 2)], 1)]
  })], 2)])])]), _vm._v(" "), (_vm.showShopperProposalModal) ? _c('ShopperProposalModal', {
    attrs: {
      "check": _vm.selectedCheck
    },
    on: {
      "modalClosed": function($event) {
        _vm.showShopperProposalModal = false
      },
      "dataUpdated": function($event) {
        return _vm.getApprovalData(false)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showShopperApprovalModal) ? _c('ShopperApprovalModal', {
    ref: "ShopperApprovalModal",
    attrs: {
      "check": _vm.selectedCheck
    },
    on: {
      "modalClosed": function($event) {
        _vm.showShopperApprovalModal = false
      },
      "resetData": function($event) {
        return _vm.getApprovalData(false, _vm.$refs.ShopperApprovalModal.init)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showShopperMultiApprovalModal) ? _c('ShopperMultiApprovalModal', {
    attrs: {
      "checks": _vm.selectedChecks
    },
    on: {
      "modalClosed": function($event) {
        _vm.showShopperMultiApprovalModal = false
      },
      "resetData": function($event) {
        return _vm.getApprovalData(false)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('CarModelManagement', {
    attrs: {
      "showModal": _vm.showCarModelManagement
    },
    on: {
      "modalClosed": function($event) {
        _vm.showCarModelManagement = false
      }
    }
  }), _vm._v(" "), _c('confirmation-dialog', {
    attrs: {
      "dialogId": 'ShopperApprovalExportApprovalConfirmation',
      "confirmationTitle": _vm.lang.SA0049,
      "yesButtonText": _vm.lang.SA0050,
      "noButtonText": _vm.lang.SA0051,
      "showDialog": _vm.showExportDialog
    },
    on: {
      "onYesConfirmation": _vm.exportApproval,
      "dialogClosed": function($event) {
        _vm.showExportDialog = false
      }
    }
  }), _vm._v(" "), _c('ApprovalWaveStatusModal'), _vm._v(" "), (_vm.showMap) ? _c('ShopperApprovalMap', {
    attrs: {
      "checkList": _vm.selectedChecks
    },
    on: {
      "close": function($event) {
        _vm.showMap = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "role": "button",
      "data-toggle": "dropdown",
      "id": "elementsPerPageDropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("view_headline")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "firstPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("first_page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "lastPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("last_page")])])
}]}

/***/ }),
/* 1726 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.globals.isAccessAllowed('LoopOp_ShopperSurveyInstances_ReadAll')) ? _c('div', {
    attrs: {
      "id": "shoppercheckmanagement"
    }
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "shoppercheckmanagement-top-panel"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.refreshEnabled
    },
    on: {
      "click": function($event) {
        return _vm.getShopperCheckList()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("refresh")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.SM4000) + "\n        ")]), _vm._v(" "), (
    _vm.feature.isEnabled('settlement') &&
    _vm.globals.isPaymentsReadingAllowed
  ) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": _vm.selectedChecks.length === 0
    },
    on: {
      "click": function($event) {
        _vm.showCheckPaymentModal = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("attach_money")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.SM4021) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "tag": "button",
      "to": "/shoppermanagement"
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("exit_to_app")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.SM4001) + "\n        ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-lg-5"
  }, [_c('div', {
    staticClass: "form-group searchbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchString),
      expression: "searchString"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "search",
      "id": "inputSearch",
      "placeholder": _vm.lang.SM4002
    },
    domProps: {
      "value": (_vm.searchString)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.doFiltering()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchString = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('div', {
    staticClass: "well user-info-box"
  }, [_c('span', [_vm._v(_vm._s(_vm.shopperData.LastName) + ", " + _vm._s(_vm.shopperData.FirstName) + " (" + _vm._s(_vm.shopperData.Username) + ")")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5 nopadding"
  }, [_c('ul', {
    staticClass: "pagination-fonts pagination btn-group"
  }, [_c('li', [_vm._m(0), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "elementsPerPageDropdown",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SM4023))]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 20
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 20)
      }
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 50
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 50)
      }
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 100
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 100)
      }
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 200
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 200)
      }
    }
  }, [_vm._v("200")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 500
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 500)
      }
    }
  }, [_vm._v("500")])])])], 1), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.filteredShopperChecklist.length || _vm.selectedPage == 1,
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 0)
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "firstPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SM4024))])], 1), _vm._v(" "), (_vm.numberOfPages() > 7 && _vm.selectedPage > 4) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getVisiblePages()), function(pageNumber) {
    return _c('li', {
      key: pageNumber,
      class: {
        active: _vm.selectedPage == pageNumber
      },
      on: {
        "click": function($event) {
          return _vm.updatePaging(pageNumber, 0)
        }
      }
    }, [_c('a', {
      attrs: {
        "role": "button"
      }
    }, [_vm._v(_vm._s(pageNumber))])])
  }), _vm._v(" "), (_vm.numberOfPages() > 7 && _vm.selectedPage < _vm.numberOfPages() - 3) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      disabled:
        !_vm.filteredShopperChecklist.length ||
        _vm.selectedPage == _vm.numberOfPages(),
    },
    on: {
      "click": function($event) {
        _vm.updatePaging(_vm.numberOfPages(), 0)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "lastPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SM4025))])], 1), _vm._v(" "), _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button",
      "id": "shopperChecksTotalElementsCounter"
    }
  }, [_vm._v(_vm._s(_vm.filteredShopperChecklist.length))]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "shopperChecksTotalElementsCounter",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SM4026))])], 1)], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    staticClass: "table table-striped table-hover main-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('SurveyInstanceId')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SM4003) + "\n                "), (_vm.showSortArrow('SurveyInstanceId', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('SurveyInstanceId', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "12%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('ProjectName')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SM4005) + "\n                "), (_vm.showSortArrow('ProjectName', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('ProjectName', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "12%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('WaveName')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SM4006) + "\n                "), (_vm.showSortArrow('WaveName', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('WaveName', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "12%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('ScenarioName')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SM4007) + "\n                "), (_vm.showSortArrow('ScenarioName', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('ScenarioName', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), (
    !_vm.feature.isAudiTarget || !_vm.feature.isEnabled('audi_importers')
  ) ? _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "9%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('ClientName')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SM4008) + "\n                "), (_vm.showSortArrow('ClientName', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('ClientName', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "9%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('ImporterName')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SM4022) + "\n                "), (_vm.showSortArrow('ImporterName', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('ImporterName', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "9%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('LocationName')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SM4009) + "\n                "), (_vm.showSortArrow('LocationName', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('LocationName', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "12%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('LocationAddress')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SM4011) + "\n                "), (_vm.showSortArrow('LocationAddress', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('LocationAddress', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "4%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('LocationCountry')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SM4012) + "\n                "), (_vm.showSortArrow('LocationCountry', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('LocationCountry', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "4%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('SurveyInstanceStatusId')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SM4010) + "\n                "), (_vm.showSortArrow('SurveyInstanceStatusId', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('SurveyInstanceStatusId', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "7%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('SettlementState')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SM4013) + "\n                "), (_vm.showSortArrow('SettlementState', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('SettlementState', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "7%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('SettlementNumber')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SM4014) + "\n                "), (_vm.showSortArrow('SettlementNumber', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('SettlementNumber', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "7%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('SettlementDate')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SM4015) + "\n                "), (_vm.showSortArrow('SettlementDate', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('SettlementDate', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])])]), _vm._v(" "), _c('tr', {
    staticClass: "table-filters"
  }, [_c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstanceId),
      expression: "filterStrings.SurveyInstanceId"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SM4016
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstanceId)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.doFiltering()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstanceId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "12%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ProjectName),
      expression: "filterStrings.ProjectName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SM4016
    },
    domProps: {
      "value": (_vm.filterStrings.ProjectName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.doFiltering()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ProjectName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "12%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.WaveName),
      expression: "filterStrings.WaveName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SM4016
    },
    domProps: {
      "value": (_vm.filterStrings.WaveName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.doFiltering()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "WaveName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "12%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ScenarioName),
      expression: "filterStrings.ScenarioName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SM4016
    },
    domProps: {
      "value": (_vm.filterStrings.ScenarioName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.doFiltering()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ScenarioName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (
    !_vm.feature.isAudiTarget || !_vm.feature.isEnabled('audi_importers')
  ) ? _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "9%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ClientName),
      expression: "filterStrings.ClientName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SM4016
    },
    domProps: {
      "value": (_vm.filterStrings.ClientName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.doFiltering()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ClientName", $event.target.value)
      }
    }
  })])]) : _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "9%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ImporterName),
      expression: "filterStrings.ImporterName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SM4016
    },
    domProps: {
      "value": (_vm.filterStrings.ImporterName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.doFiltering()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ImporterName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "9%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationName),
      expression: "filterStrings.LocationName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SM4016
    },
    domProps: {
      "value": (_vm.filterStrings.LocationName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.doFiltering()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "12%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationAddress),
      expression: "filterStrings.LocationAddress"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SM4016
    },
    domProps: {
      "value": (_vm.filterStrings.LocationAddress)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.doFiltering()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationAddress", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "4%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationCountry),
      expression: "filterStrings.LocationCountry"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SM4016
    },
    domProps: {
      "value": (_vm.filterStrings.LocationCountry)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.doFiltering()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationCountry", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "4%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar",
    attrs: {
      "id": "checkStatusFilterContainer"
    }
  }, [_c('select2', {
    staticClass: "form-control nopadding",
    attrs: {
      "allowClear": true,
      "placeholder": _vm.lang.SM4016
    },
    on: {
      "change": function($event) {
        (_vm.selectedPage = 1), _vm.doFiltering()
      }
    },
    model: {
      value: (_vm.filterStrings.SurveyInstanceStatusId),
      callback: function($$v) {
        _vm.$set(_vm.filterStrings, "SurveyInstanceStatusId", $$v)
      },
      expression: "filterStrings.SurveyInstanceStatusId"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.checkStates), function(status) {
    return _c('option', {
      key: status,
      domProps: {
        "value": status
      }
    }, [_vm._v("\n                    " + _vm._s(status) + "\n                  ")])
  })], 2)], 1)]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "7%"
    }
  }, [(Object.keys(_vm.settlementStatusses).length > 0) ? _c('div', {
    staticClass: "form-group filterbar",
    attrs: {
      "id": "settlementStatusFilterContainer"
    }
  }, [_c('Select2', {
    staticClass: "form-control nopadding",
    attrs: {
      "allowClear": true,
      "placeholder": _vm.lang.SM4016
    },
    on: {
      "change": function($event) {
        (_vm.selectedPage = 1), _vm.doFiltering()
      }
    },
    model: {
      value: (_vm.filterStrings.SettlementState),
      callback: function($$v) {
        _vm.$set(_vm.filterStrings, "SettlementState", $$v)
      },
      expression: "filterStrings.SettlementState"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.settlementStatusses), function(name, guid) {
    return _c('option', {
      key: guid,
      domProps: {
        "value": name
      }
    }, [_vm._v("\n                    " + _vm._s(name) + "\n                  ")])
  })], 2)], 1) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "7%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SettlementNumber),
      expression: "filterStrings.SettlementNumber"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SM4016
    },
    domProps: {
      "value": (_vm.filterStrings.SettlementNumber)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.doFiltering()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SettlementNumber", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "7%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SettlementDate),
      expression: "filterStrings.SettlementDate"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SM4016
    },
    domProps: {
      "value": (_vm.filterStrings.SettlementDate)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.doFiltering()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SettlementDate", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('tbody', {
    staticClass: "main-table-scrollbar"
  }, _vm._l((_vm.shopperChecksOnCurrentPage), function(check) {
    return _c('tr', {
      key: check.SurveyInstanceId,
      class: {
        info: _vm.isCheckSelected(check.SurveyInstanceGuid)
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.selectChecks(check.SurveyInstanceGuid, $event)
        }
      }
    }, [_c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [_vm._v(_vm._s(check.SurveyInstanceId))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "12%"
      }
    }, [_vm._v(_vm._s(check.ProjectName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "12%"
      }
    }, [_vm._v(_vm._s(check.WaveName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "12%"
      }
    }, [_vm._v(_vm._s(check.ScenarioName))]), _vm._v(" "), (
      !_vm.feature.isAudiTarget || !_vm.feature.isEnabled('audi_importers')
    ) ? _c('td', {
      staticStyle: {
        "width": "9%"
      }
    }, [_vm._v("\n              " + _vm._s(check.ClientName) + "\n            ")]) : _c('td', {
      staticStyle: {
        "width": "9%"
      }
    }, [_vm._v(_vm._s(check.ImporterName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "9%"
      }
    }, [_vm._v(_vm._s(check.LocationName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "12%"
      }
    }, [_vm._v(_vm._s(check.LocationAddress))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "4%"
      }
    }, [_vm._v(_vm._s(check.LocationCountry))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "4%"
      }
    }, [_vm._v(_vm._s(check.SurveyInstanceStatusId))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7%"
      }
    }, [_vm._v(_vm._s(check.SettlementState))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7%"
      }
    }, [_vm._v(_vm._s(check.SettlementNumber))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7%"
      }
    }, [_vm._v(_vm._s(check.SettlementDate))])])
  }), 0)])])]), _vm._v(" "), _c('CheckPaymentModal', {
    attrs: {
      "showModal": _vm.showCheckPaymentModal,
      "surveyInstanceGuids": _vm.selectedChecks
    },
    on: {
      "modalClosed": function($event) {
        (_vm.showCheckPaymentModal = false), _vm.getShopperCheckList()
      }
    }
  })], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "role": "button",
      "data-toggle": "dropdown",
      "id": "elementsPerPageDropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("view_headline")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "firstPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("first_page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "lastPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("last_page")])])
}]}

/***/ }),
/* 1727 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "surveyElementSecurityModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.SE1000))])]), _vm._v(" "), _c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.surveyElement.name) + ": " + _vm._s(_vm.surveyElement.title))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('ul', {
    staticClass: "nav nav-tabs nav-security",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#editorSecurityVisibility",
      "data-toggle": "tab"
    }
  }, [_vm._v(_vm._s(_vm.lang.SE1019))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#editorSecurityReporting",
      "data-toggle": "tab"
    }
  }, [_vm._v(_vm._s(_vm.lang.SE1020))])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content",
    attrs: {
      "id": "editorSecurityTabContent"
    }
  }, [_c('div', {
    staticClass: "tab-pane fade active in",
    attrs: {
      "id": "editorSecurityVisibility"
    }
  }, [_c('div', {
    staticClass: "table-security-settings"
  }, [(_vm.securitySettings.Rules && Object.keys(_vm.securityElements).length > 0) ? _c('table', {
    staticClass: "table table-hover",
    staticStyle: {
      "margin": "0px"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "col-md-1"
  }, [_vm._v(_vm._s(_vm.lang.SE1036))]), _vm._v(" "), _c('th', {
    staticClass: "col-md-2"
  }, [_vm._v(_vm._s(_vm.lang.SE1021))]), _vm._v(" "), _c('th', {
    staticClass: "col-md-7"
  }, [_vm._v(_vm._s(_vm.lang.SE1022))]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1 text-center"
  }, [_vm._v(_vm._s(_vm.lang.SE1024))]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.securitySettings.Rules), function(rule) {
    return _c('tr', {
      key: rule.RuleNumber
    }, [_c('td', {
      staticClass: "col-md-1 text-left"
    }, [_c('span', {
      staticClass: "rolenumber"
    }, [_vm._v(_vm._s(rule.RuleNumber))])]), _vm._v(" "), _c('td', {
      staticClass: "col-md-2"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('select2', {
      key: ("securityLevelSelect" + (rule.RuleNumber)),
      staticClass: "form-control",
      on: {
        "change": function($event) {
          return _vm.ruleTypeChanged(rule)
        }
      },
      model: {
        value: (rule.RuleType),
        callback: function($$v) {
          _vm.$set(rule, "RuleType", $$v)
        },
        expression: "rule.RuleType"
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }), _vm._v(" "), _vm._l((_vm.securitySettingsStrings), function(text, key) {
      return _c('option', {
        key: key,
        domProps: {
          "value": key
        }
      }, [_vm._v("\n                              " + _vm._s(text) + "\n                            ")])
    })], 2)], 1)]), _vm._v(" "), _c('td', {
      staticClass: "col-md-7"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (rule.RuleType === 'LocationProperty'),
        expression: "rule.RuleType === 'LocationProperty'"
      }],
      staticClass: "form-group nopadding col-12"
    }, [_c('select2', {
      key: ("locationPropertySelect" + (rule.RuleNumber)),
      ref: ("locationPropertySelect" + (rule.RuleNumber)),
      refInFor: true,
      staticClass: "form-control",
      attrs: {
        "id": ("locationPropertySelect" + (rule.RuleNumber)),
        "width": "100%",
        "disabled": !rule.RuleType,
        "multiple": false,
        "placeholder": _vm.lang.SE1037
      },
      on: {
        "change": function (d) {
          _vm.ruleValueChanged(rule, d);
        }
      },
      model: {
        value: (rule[rule.RuleType]),
        callback: function($$v) {
          _vm.$set(rule, rule.RuleType, $$v)
        },
        expression: "rule[rule.RuleType ]"
      }
    }, _vm._l((_vm.getElementsForCurrentRuleType(rule.RuleType)), function(element) {
      return _c('option', {
        key: element[_vm.getIdKeyOfRuleType(rule.RuleType)],
        domProps: {
          "value": element[_vm.getIdKeyOfRuleType(rule.RuleType)]
        }
      }, [_vm._v("\n                              " + _vm._s(_vm.getElementName(element)) + "\n                            ")])
    }), 0), _vm._v(" "), _c('div', {
      attrs: {
        "id": "foo"
      }
    }, [_c('select2', {
      key: ("locationPropertyValueSelect" + (rule.RuleNumber)),
      ref: ("locationPropertyValueSelect" + (rule.RuleNumber)),
      refInFor: true,
      staticClass: "form-control",
      attrs: {
        "id": ("locationPropertyValueSelect" + (rule.RuleNumber)),
        "width": "100%",
        "multiple": true,
        "placeholder": _vm.lang.SE1037,
        "disabled": !rule[rule.RuleType]
      },
      model: {
        value: (rule['LocationPropertyValue']),
        callback: function($$v) {
          _vm.$set(rule, 'LocationPropertyValue', $$v)
        },
        expression: "rule['LocationPropertyValue']"
      }
    }, _vm._l((_vm.getLocationPropertyValues(rule[rule.RuleType])), function(value, idx) {
      return _c('option', {
        key: idx,
        domProps: {
          "value": value.LocationPropertyValue
        }
      }, [_vm._v("\n                                " + _vm._s(value.LocationPropertyValue) + "\n                              ")])
    }), 0)], 1)], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (rule.RuleType != 'LocationProperty'),
        expression: "rule.RuleType != 'LocationProperty'"
      }],
      staticClass: "form-group nopadding col-12"
    }, [_c('select2', {
      key: ("securityRuleElementSelect" + (rule.RuleNumber)),
      ref: ("securityRuleElementSelect" + (rule.RuleNumber)),
      refInFor: true,
      staticClass: "form-control",
      attrs: {
        "width": "100%",
        "id": ("securityRuleElementSelect" + (rule.RuleNumber)),
        "disabled": !rule.RuleType,
        "multiple": true,
        "allowClear": true,
        "placeholder": _vm.lang.SE1037,
        "minimumInputLength": _vm.getElementsForCurrentRuleType(rule.RuleType).length > 500 ? 2 : 0,
        "tags": false
      },
      on: {
        "change": function (d) {
          if (rule.RuleType == 'LocationProperty') { rule[rule.RuleType] = d; }
          _vm.ruleValueChanged(rule);
        }
      },
      model: {
        value: (rule[rule.RuleType]),
        callback: function($$v) {
          _vm.$set(rule, rule.RuleType, $$v)
        },
        expression: "rule[rule.RuleType]"
      }
    }, _vm._l((_vm.getElementsForCurrentRuleType(rule.RuleType)), function(element) {
      return _c('option', {
        key: element[_vm.getIdKeyOfRuleType(rule.RuleType)],
        domProps: {
          "value": element[_vm.getIdKeyOfRuleType(rule.RuleType)]
        }
      }, [_vm._v("\n                              " + _vm._s(_vm.getElementName(element)) + "\n                            ")])
    }), 0)], 1)]), _vm._v(" "), _c('td', {
      staticClass: "col-md-1"
    }, [(rule.RuleType === 'Wave') ? _c('div', {
      staticClass: "checkbox"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (rule.WaveFF),
        expression: "rule.WaveFF"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(rule.WaveFF) ? _vm._i(rule.WaveFF, null) > -1 : (rule.WaveFF)
      },
      on: {
        "change": function($event) {
          var $$a = rule.WaveFF,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(rule, "WaveFF", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(rule, "WaveFF", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(rule, "WaveFF", $$c)
          }
        }
      }
    }), _vm._v(" "), _vm._m(0, true)])]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "col-md-1"
    }, [_c('button', {
      staticClass: "btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeGeneralSetting(rule.RuleNumber)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24",
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("clear")])])])])
  }), 0)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row nopadding"
  }, [_c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addNewGeneralSetting()
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SE1025) + "\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clearGeneralSettings()
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SE1026) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "row nopadding"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.securitySettings.Expression),
      expression: "securitySettings.Expression"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "4",
      "id": "textareaSecuritySettingsExpression",
      "placeholder": ((_vm.lang.SE1038) + ", " + (_vm.lang.SE1039) + ": (1 and 2) or not 3")
    },
    domProps: {
      "value": (_vm.securitySettings.Expression)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) { return null; }
        $event.preventDefault();
        return _vm.globals.insertAtCaret('textareaSecuritySettingsExpression', '\t')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.securitySettings, "Expression", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    class: {
      'validation-error': _vm.validationMessage.Error,
    },
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "id": "validationMessage"
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.validationMessage.Msg) + "\n                    ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "editorSecurityReporting"
    }
  }, [(Object.keys(_vm.securityGroups).length < 1) ? _c('div', [_vm._v("\n                " + _vm._s(_vm.lang.SE1031) + "\n              ")]) : _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "selectSecurityTargetGroup"
    }
  }, [_vm._v(_vm._s(_vm.lang.SE1030))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedSecurityGroup),
      expression: "selectedSecurityGroup"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "selectSecurityTargetGroup"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedSecurityGroup = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.securityGroups), function(name, guid) {
    return _c('option', {
      key: guid,
      domProps: {
        "value": guid
      }
    }, [_vm._v("\n                        " + _vm._s(name) + "\n                      ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "table-security-settings"
  }, [_c('table', {
    staticClass: "table table-hover",
    staticStyle: {
      "margin": "0px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_vm._l((_vm.reportingSettingsStrings), function(title, key) {
    return [(
      key === 'notVisibleInCheckReport' ||
      key === 'uploadVisibleInMediaExplorer' ||
      key === 'notVisibleInRawData'
    ) ? _c('tr', {
      key: key
    }, [_c('td', {
      staticStyle: {
        "padding": "4px"
      }
    }, [_c('div', {
      staticClass: "checkbox",
      staticStyle: {
        "margin": "0px"
      }
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.currentReportingGroupSettings[key]),
        expression: "currentReportingGroupSettings[key]"
      }],
      attrs: {
        "type": "checkbox",
        "id": 'cb_reportingVisibility_' + key
      },
      domProps: {
        "checked": Array.isArray(_vm.currentReportingGroupSettings[key]) ? _vm._i(_vm.currentReportingGroupSettings[key], null) > -1 : (_vm.currentReportingGroupSettings[key])
      },
      on: {
        "change": function($event) {
          var $$a = _vm.currentReportingGroupSettings[key],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.currentReportingGroupSettings, key, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.currentReportingGroupSettings, key, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.currentReportingGroupSettings, key, $$c)
          }
        }
      }
    }), _vm._v(" "), _vm._m(2, true)])])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "font-size": "16px",
        "padding": "6px"
      }
    }, [_c('label', {
      staticClass: "text-black nopadding",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "role": "button",
        "for": 'cb_reportingVisibility_' + key
      }
    }, [_vm._v(_vm._s(title))])])]) : _vm._e()]
  })], 2)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.SE1027) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveSecuritySettings()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.SE1028) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', {
    staticStyle: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "80%"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
}]}

/***/ }),
/* 1728 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "exportTranslation",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.U1051))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.lang.U1052))])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.U1049) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.downloadTranslationExportData()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.U1056) + "\n          ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "importTranslation",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.U1041))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.lang.U1042))])]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs nav-import",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#textImport",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.importTranslationDialogData.selectedOption = 'text'
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.U1043))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#fileImport",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.importTranslationDialogData.selectedOption = 'file'
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.U1044))])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content",
    attrs: {
      "id": "importTabContent"
    }
  }, [_c('div', {
    staticClass: "tab-pane fade active in",
    attrs: {
      "id": "textImport"
    }
  }, [_c('label', {
    staticClass: "col-md-1 control-label",
    attrs: {
      "for": "textAreaImport"
    }
  }, [_vm._v(_vm._s(_vm.lang.U1045))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-11"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.importTranslationDialogData.selectedText),
      expression: "importTranslationDialogData.selectedText"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "7",
      "id": "textAreaImport"
    },
    domProps: {
      "value": (_vm.importTranslationDialogData.selectedText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.importTranslationDialogData, "selectedText", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.lang.U1046))])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "fileImport"
    }
  }, [_c('label', {
    staticClass: "col-md-1 control-label",
    attrs: {
      "for": "inputFileImport"
    }
  }, [_vm._v(_vm._s(_vm.lang.U1047))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-11"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "multiple": "",
      "accept": ".csv, .xls, .xlsx"
    },
    on: {
      "change": _vm.onImportFileChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [(
    typeof _vm.importTranslationDialogData.selectedFile
    .name == 'undefined'
  ) ? _c('label', {
    staticStyle: {
      "padding-top": "16px"
    }
  }, [_vm._v(_vm._s(_vm.lang.U1048))]) : _c('label', {
    staticStyle: {
      "padding-top": "16px"
    }
  }, [_vm._v(_vm._s(_vm.importTranslationDialogData.selectedFile.name))]), _vm._v(" "), _vm._m(0)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.U1049) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.uploadImportData()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.U1050) + "\n          ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "translateSurveyDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "id": "surveyTranslateForm"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.closeTranslateSurveyDialog()
      }
    }
  }, [_vm._v("\n              ×\n            ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.dialogTitle))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "id": "surveyTranslationTopRow"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "translate-label control-label",
    attrs: {
      "for": "inputSurveyLanguage"
    }
  }, [_vm._v(_vm._s(_vm.lang.U1018))]), _vm._v(" "), _c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "inputSurveyLanguage",
      "width": '200px',
      "placeholder": _vm.lang.U1072
    },
    on: {
      "change": _vm.selectedLanguageChanged
    }
  }, _vm._l((_vm.surveyLocales), function(value) {
    return _c('option', {
      key: value.LocaleCode,
      domProps: {
        "value": value.LocaleCode
      }
    }, [_vm._v("\n                    " + _vm._s(value.LocaleName) + "\n                  ")])
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "disabled": _vm.translationList.length < 1 ||
        !_vm.globals.isAccessAllowed(
          'LoopOp_SurveyTranslationExport_Create'
        ),
      "data-toggle": "modal",
      "data-target": "#exportTranslation"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.U0056) + "\n                ")]), _vm._v(" "), (_vm.globals.currentUserRole == 1) ? _c('button', {
    staticClass: "btn btn-raised",
    class: {
      'btn-success': !_vm.translationData.AllowAgencyEdit,
      'btn-warning': _vm.translationData.AllowAgencyEdit,
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedLanguage
    },
    on: {
      "click": function($event) {
        return _vm.toggleAgencyTranslatePermission()
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.translationData.AllowAgencyEdit ? _vm.lang.U1071 : _vm.lang.U1070) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.globals.currentUserRole == 2) ? _c('button', {
    staticClass: "btn btn-raised btn-success",
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedLanguage || !_vm.translationData.AllowAgencyEdit
    },
    on: {
      "click": function($event) {
        return _vm.submitTranslationsFromAgency()
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.U1073) + "\n                ")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "modalScrollableArea",
    attrs: {
      "id": "surveyTranslation"
    }
  }, _vm._l((_vm.translationList), function(item, key) {
    return _c('div', {
      key: key
    }, [(_vm.isNewGroup(item.ParentId) && !item.QuestionName) ? _c('hr') : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "form-group col-md-12"
    }, [_c('label', {
      staticClass: "col-md-6 translate-label",
      class: {
        'translate-label-child': item.Key !== 'title' && item.ParentId > 0,
      },
      attrs: {
        "for": 'textareaTranslationElement' + key
      }
    }, [(item.Key === 'title' && item.QuestionNumber) ? _c('span', [_vm._v(_vm._s(item.QuestionNumber) + " -")]) : _vm._e(), _vm._v("\n                      " + _vm._s(item.Name) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-6"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.Translation),
        expression: "item.Translation"
      }],
      staticClass: "form-control textarea-survey-translations autoExpand",
      attrs: {
        "id": 'textareaTranslationElement' + key,
        "maxlength": "1000",
        "rows": "1",
        "disabled": _vm.globals.currentUserRole == 2 &&
          !_vm.translationData.AllowAgencyEdit,
        "placeholder": item.InheritedTranslation
      },
      domProps: {
        "value": (item.Translation)
      },
      on: {
        "change": function($event) {
          _vm.translationListDirty = true
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "Translation", $event.target.value)
        }
      }
    })])]), _vm._v("\n                  " + _vm._s(_vm.setNewGroup(item.ParentId)) + "\n                ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "row modal-footer"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeTranslateSurveyDialog()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.U1057) + "\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised",
    class: {
      'btn-warning': _vm.translationListDirty,
      'btn-success': !_vm.translationListDirty,
    },
    attrs: {
      "type": "button",
      "disabled": _vm.translationList.length < 1 ||
        !_vm.globals.isAccessAllowed(
          'LoopOp_SurveyTranslation_Update'
        ) ||
        (_vm.globals.currentUserRole == 2 &&
          !_vm.translationData.AllowAgencyEdit)
    },
    on: {
      "click": function($event) {
        return _vm.saveTranslateSurveyDialogData()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.U0023) + "\n              ")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn input-group-sm"
  }, [_c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("attach_file")])])])
}]}

/***/ }),
/* 1729 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "shopperApprovalModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.SAM000))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v(_vm._s(_vm.lang.SAM001))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SAM002) + "\n                ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SAM003) + "\n                ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SAM004) + "\n                ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.check.ShopperProposals), function(proposal, index) {
    return _c('tr', {
      key: proposal.ShopperProposalGuid,
      attrs: {
        "proposal": proposal
      }
    }, [_c('td', {
      staticClass: "text-left",
      staticStyle: {
        "position": "relative"
      }
    }, [_c('div', {
      staticClass: "info-btns"
    }, [(proposal.UpdateShopperProposal) ? [_c('button', {
      staticClass: "btn nopadding",
      staticStyle: {
        "border-radius": "50%"
      },
      attrs: {
        "id": ("updateShopperDataButton-" + (proposal.ShopperProposalGuid))
      },
      on: {
        "click": function($event) {
          return _vm.updateShopperData(proposal)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24"
    }, [_vm._v("refresh")])]), _vm._v(" "), _c('b-tooltip', {
      ref: "tooltip",
      refInFor: true,
      attrs: {
        "target": ("updateShopperDataButton-" + (proposal.ShopperProposalGuid)),
        "delay": _vm.globals.tooltipDelay
      }
    }, [_vm._v(_vm._s(_vm.lang.SPM020))])] : _vm._e(), _vm._v(" "), (proposal.ShopperPreviousVisited) ? [_c('i', {
      staticClass: "material-icons md-24",
      staticStyle: {
        "color": "red",
        "cursor": "pointer"
      },
      attrs: {
        "id": ("ShopperPreviousVisited-" + (proposal.ShopperProposalGuid))
      }
    }, [_vm._v("info_outline")]), _vm._v(" "), _c('b-tooltip', {
      ref: "tooltip",
      refInFor: true,
      attrs: {
        "target": ("ShopperPreviousVisited-" + (proposal.ShopperProposalGuid)),
        "delay": _vm.globals.tooltipDelay
      }
    }, [_c('div', {
      staticClass: "survey-id-info-tooltip"
    }, [_vm._v("\n                          " + _vm._s(_vm.lang.SAM028) + "\n                          "), _c('br')])])] : _vm._e()], 2), _vm._v(" "), _c('div', [_vm._v("\n                    " + _vm._s(_vm.lang.SAM005) + ":\n                    "), _c('b', [_vm._v(_vm._s(proposal.ShopperId))])]), _vm._v(" "), _c('div', [_vm._v("\n                    " + _vm._s(_vm.lang.SAM006) + " (" + _vm._s(_vm.lang.SAM007) + "):\n                    "), _c('b', [_vm._v(_vm._s(proposal.DisplayName))])]), _vm._v(" "), _c('div', [_vm._v("\n                    " + _vm._s(_vm.lang.SAM008) + ":\n                    "), _c('b', [_vm._v(_vm._s(proposal.Gender))])]), _vm._v(" "), _c('div', [_vm._v("\n                    " + _vm._s(_vm.lang.SAM009) + ":\n                    "), _c('b', [_vm._v(_vm._s(proposal.Distance) + " km")])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (proposal.Profession),
        expression: "proposal.Profession"
      }]
    }, [_vm._v("\n                    " + _vm._s(_vm.lang.SAM010) + ":\n                    "), _c('b', [_vm._v(_vm._s(proposal.Profession))])]), _vm._v(" "), _c('div', [_vm._v("\n                    " + _vm._s(_vm.lang.SAM012) + ":\n                    "), _c('b', [_vm._v(_vm._s(proposal.CarSegmentName))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex",
        "align-items": "baseline"
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.lang.SAM011) + ":\n                    "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (proposal.CarModelGuid),
        expression: "proposal.CarModelGuid"
      }],
      staticClass: "form-control",
      attrs: {
        "id": "newShopperProposalCarModelSelect",
        "disabled": !proposal.CarSegmentGuid
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(proposal, "CarModelGuid", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          proposal.CompetitorCarModelGuid = '';
          _vm.updateShopperProposalCarModelAndMatch(proposal)
        }]
      }
    }, _vm._l((_vm.carModelsOfSelectedSegment(proposal.CarSegmentGuid)), function(model) {
      return _c('option', {
        key: model.CarModelGuid,
        domProps: {
          "value": model.CarModelGuid
        }
      }, [_vm._v("\n                        " + _vm._s(model.CarModelName) + "\n                      ")])
    }), 0)]), _vm._v(" "), (_vm.check.CompetitorCarModelDistribution) ? _c('div', {
      staticStyle: {
        "display": "flex",
        "align-items": "baseline"
      }
    }, [_c('span', {
      staticStyle: {
        "text-wrap": "nowrap"
      }
    }, [_vm._v(_vm._s(_vm.lang.SAM030))]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (proposal.CompetitorCarModelGuid),
        expression: "proposal.CompetitorCarModelGuid"
      }],
      staticClass: "form-control",
      attrs: {
        "id": "newShopperProposalCompetitorCarModelSelect",
        "disabled": !proposal.CarSegmentGuid
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(proposal, "CompetitorCarModelGuid", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          proposal.CarModelGuid = '';
          _vm.updateShopperProposalCarModelAndMatch(proposal)
        }]
      }
    }, _vm._l((_vm.check.CompetitorCarModelDistribution), function(model) {
      return _c('option', {
        key: model.CompetitorCarModelGuid,
        domProps: {
          "value": model.CompetitorCarModelGuid
        }
      }, [_vm._v("\n                      " + _vm._s(model.CompetitorCarBrand) + " " + _vm._s(model.CompetitorCarModel) + "\n                      ")])
    }), 0)]) : _vm._e(), _vm._v(" "), _c('div', [_vm._v("\n                    " + _vm._s(_vm.lang.SAM013) + ":\n                    "), _c('b', [_vm._v(_vm._s(proposal.ShopperCar))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex",
        "align-items": "baseline"
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.lang.SAM014) + ":")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (proposal.CarMatch),
        expression: "proposal.CarMatch"
      }],
      staticClass: "form-control",
      attrs: {
        "id": "newShopperProposalCarMatchSelect"
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(proposal, "CarMatch", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.updateShopperProposalCarModelAndMatch(proposal)
        }]
      }
    }, [_c('option', {
      attrs: {
        "value": "+"
      }
    }, [_vm._v("+ " + _vm._s(_vm.lang.SAM017))]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "="
      }
    }, [_vm._v("= " + _vm._s(_vm.lang.SAM016))]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "-"
      }
    }, [_vm._v("- " + _vm._s(_vm.lang.SAM015))])])]), _vm._v(" "), _c('div', [_vm._v("\n                    " + _vm._s(_vm.lang.SAM018) + ":\n                    "), _c('b', [_vm._v(_vm._s(proposal.LastUpdatedAt))])])]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [(_vm.globals.isLeadAgencyUser || _vm.globals.isAdminUser) ? _c('div', {
      staticClass: "comment-type-container"
    }, [_c('a', {
      staticClass: "comment-type-header",
      on: {
        "click": function($event) {
          return _vm.showFeed(proposal, 'Agency')
        }
      }
    }, [_vm._v("\n                      " + _vm._s(_vm.lang.SAM019) + "\n                      "), _c('i', {
      staticClass: "material-icons md-24"
    }, [_vm._v("forum")])]), _vm._v(" "), (proposal.LastCommentLeadLocal) ? _c('div', {
      staticClass: "last-comment-container"
    }, [_c('b', [_vm._v(_vm._s(proposal.LastCommentLeadLocalCreatedBy) + ":")]), _vm._v("\n                      " + _vm._s(_vm.globals.truncateString(proposal.LastCommentLeadLocal, 120)) + "\n                    ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "comment-type-container"
    }, [_c('a', {
      staticClass: "comment-type-header",
      on: {
        "click": function($event) {
          return _vm.showFeed(proposal, 'Audi')
        }
      }
    }, [_vm._v("\n                      " + _vm._s(_vm.globals.isAudiUser ? _vm.lang.SAM021 : _vm.lang.SAM020) + "\n                      "), _c('i', {
      staticClass: "material-icons md-24"
    }, [_vm._v("forum")])]), _vm._v(" "), (proposal.LastCommentLeadAudi) ? _c('div', {
      staticClass: "last-comment-container"
    }, [_c('b', [_vm._v(_vm._s(proposal.LastCommentLeadAudiCreatedBy) + ":")]), _vm._v("\n                      " + _vm._s(_vm.globals.truncateString(proposal.LastCommentLeadAudi, 120)) + "\n                    ")]) : _vm._e()])]), _vm._v(" "), _c('td', [(!(_vm.globals.isLeadAgencyUser && _vm.userAgencyEqualsCheckAgency)) ? _c('div', {
      staticClass: "form-group"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (proposal.AgencyApprovalStatus),
        expression: "proposal.AgencyApprovalStatus"
      }],
      staticClass: "form-control",
      class: {
        'option-green': proposal.AgencyApprovalStatus === 'Approved',
        'option-red': proposal.AgencyApprovalStatus === 'Rejected',
        'option-yellow': !proposal.AgencyApprovalStatus,
      },
      attrs: {
        "disabled": (!_vm.globals.isAudiUser && proposal.MainEntityApprovalStatus) || _vm.check.SurveyInstanceStatusId > 200
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(proposal, "AgencyApprovalStatus", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.updateApprovalState(proposal, 'leadAgency')
        }]
      }
    }, [_c('option', {
      staticClass: "option-green",
      domProps: {
        "value": 'Approved'
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.lang.SAM022) + "\n                      ")]), _vm._v(" "), _c('option', {
      staticClass: "option-yellow",
      domProps: {
        "value": undefined
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.lang.SAM023) + "\n                      ")]), _vm._v(" "), _c('option', {
      staticClass: "option-red",
      domProps: {
        "value": 'Rejected'
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.lang.SAM024) + "\n                      ")])])]) : _vm._e()]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "form-group"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (proposal.MainEntityApprovalStatus),
        expression: "proposal.MainEntityApprovalStatus"
      }],
      staticClass: "form-control",
      class: {
        'option-green': proposal.MainEntityApprovalStatus === 'Approved',
        'option-red': proposal.MainEntityApprovalStatus === 'Rejected',
        'option-yellow': !proposal.MainEntityApprovalStatus,
      },
      attrs: {
        "disabled": !(_vm.globals.isAdminUser || _vm.globals.isAudiUser || (_vm.globals.isLeadAgencyUser && _vm.userAgencyEqualsCheckAgency)) || _vm.check.SurveyInstanceStatusId > 200
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(proposal, "MainEntityApprovalStatus", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.updateApprovalState(proposal, 'mainEntity')
        }]
      }
    }, [(!_vm.anyShopperAlreadyApproved || proposal.MainEntityApprovalStatus === 'Approved') ? _c('option', {
      staticClass: "option-green",
      domProps: {
        "value": 'Approved'
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.lang.SAM022) + "\n                      ")]) : _vm._e(), _vm._v(" "), _c('option', {
      staticClass: "option-yellow",
      domProps: {
        "value": undefined
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.lang.SAM023) + "\n                      ")]), _vm._v(" "), _c('option', {
      staticClass: "option-red",
      domProps: {
        "value": 'Rejected'
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.lang.SAM024) + "\n                      ")])])])])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table outer-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [(_vm.statusData.CarDistribution && _vm.check.Brand === 'Audi') ? _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.AWS029))])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.lang.AWS030))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS031))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS032))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS026))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS028))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS027))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.statusData.CarDistribution), function(model, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(model.CarModelName))]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(Number((model.SetValue * 100).toFixed(2))) + " %\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(Number((model.ActualValue * 100).toFixed(2))) + " % (" + _vm._s(model.ApprovedCarCount) + ")\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(Number((model.ApprovedCarCountDowngrade_percentage * 100).toFixed(2))) + " %\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(Number((model.ApprovedCarCountMatch_percentage * 100).toFixed(2))) + " %\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(Number((model.ApprovedCarCountUpgrade_percentage * 100).toFixed(2))) + " %\n                        ")])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.statusData.CompetitorCarDistribution && _vm.check.Brand !== 'Audi') ? _vm._l((_vm.getGroupedCompetitorCars()), function(competitorCarDistribution, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-left"
    }, [_c('b', [_vm._v(_vm._s(competitorCarDistribution[0]) + " " + _vm._s(_vm.lang.AWS033))])]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_c('table', {
      staticClass: "table table-hover"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.lang.AWS030))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS031))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS032))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS026))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS028))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS027))])])]), _vm._v(" "), _c('tbody', _vm._l((competitorCarDistribution[1]), function(model, index) {
      return _c('tr', {
        key: index
      }, [_c('td', [_vm._v(_vm._s(model.CompetitorCarModel))]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(Number((model.SetValue * 100).toFixed(2))) + " %\n                          ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(Number((model.ActualValue * 100).toFixed(2))) + " % (" + _vm._s(model.ApprovedCarCount) + ")\n                          ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(Number((model.ApprovedCarCountDowngrade_percentage * 100).toFixed(2))) + " %\n                          ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(Number((model.ApprovedCarCountMatch_percentage * 100).toFixed(2))) + " %\n                          ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(Number((model.ApprovedCarCountUpgrade_percentage * 100).toFixed(2))) + " %\n                          ")])])
    }), 0)])])])
  }) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.SAM025) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "nopadding noborder",
    staticStyle: {
      "width": "30%"
    }
  }), _vm._v(" "), _c('th', {
    staticClass: "nopadding noborder",
    staticStyle: {
      "width": "70%"
    }
  })])])
}]}

/***/ }),
/* 1730 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "importUsersDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), (_vm.importStep === 1) ? _c('div', {
    staticClass: "modal-body"
  }, [(!_vm.feature.isAudiTarget) ? [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "importUsersUserTypeSelect"
    }
  }, [_vm._v("User Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "importUsersUserTypeSelect",
      "placeholder": 'Please select an user type...',
      "allowClear": true
    },
    model: {
      value: (_vm.importUsersDialogData.UserTypeId),
      callback: function($$v) {
        _vm.$set(_vm.importUsersDialogData, "UserTypeId", $$v)
      },
      expression: "importUsersDialogData.UserTypeId"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.userTypeList), function(type, idx) {
    return _c('option', {
      key: idx,
      attrs: {
        "disabled": idx != 4
      },
      domProps: {
        "value": idx
      }
    }, [_vm._v("\n                  " + _vm._s(type) + "\n                ")])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.importUsersDialogData.UserTypeId == 4),
      expression: "importUsersDialogData.UserTypeId == 4"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "importUsersClientSelect"
    }
  }, [_vm._v("Client *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "importUsersClientSelect",
      "placeholder": 'Please select a client...',
      "allowClear": true
    },
    model: {
      value: (_vm.importUsersDialogData.ClientId),
      callback: function($$v) {
        _vm.$set(_vm.importUsersDialogData, "ClientId", $$v)
      },
      expression: "importUsersDialogData.ClientId"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.clientList), function(client) {
    return _c('option', {
      key: client.ClientId,
      domProps: {
        "value": client.ClientId
      }
    }, [_vm._v("\n                  " + _vm._s(client.ClientName) + "\n                ")])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.importUsersDialogData.UserTypeId == 2),
      expression: "importUsersDialogData.UserTypeId == 2"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "importUsersAgencySelect"
    }
  }, [_vm._v("Partner")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "importUsersAgencySelect",
      "placeholder": 'Please select a partner...',
      "allowClear": true
    },
    model: {
      value: (_vm.importUsersDialogData.AgencyId),
      callback: function($$v) {
        _vm.$set(_vm.importUsersDialogData, "AgencyId", $$v)
      },
      expression: "importUsersDialogData.AgencyId"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.agencyList), function(agency) {
    return _c('option', {
      key: agency.AgencyGuid,
      domProps: {
        "value": agency.AgencyId
      }
    }, [_vm._v("\n                  " + _vm._s(agency.AgencyName) + "\n                ")])
  })], 2)], 1)])] : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs nav-import",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#importUsersTextImport",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.importUsersDialogData.selectedOption = 'text'
      }
    }
  }, [_vm._v("Text")])]), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Upload_Create')) ? _c('li', [_c('a', {
    attrs: {
      "href": "#importUsersFileImport",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.importUsersDialogData.selectedOption = 'file'
      }
    }
  }, [_vm._v("File")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tab-content",
    attrs: {
      "id": "importUsersTabContent"
    }
  }, [_c('div', {
    staticClass: "tab-pane fade active in",
    attrs: {
      "id": "importUsersTextImport"
    }
  }, [_c('label', {
    staticClass: "col-md-1 control-label",
    attrs: {
      "for": "importUsersImportTextArea"
    }
  }, [_vm._v("Text-Import")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-11"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.importUsersDialogData.selectedText),
      expression: "importUsersDialogData.selectedText"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "7",
      "id": "importUsersImportTextArea"
    },
    domProps: {
      "value": (_vm.importUsersDialogData.selectedText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.importUsersDialogData, "selectedText", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "importUsersFileImport"
    }
  }, [_c('label', {
    staticClass: "col-md-1 control-label",
    attrs: {
      "for": "importUsersImportFileInput"
    }
  }, [_vm._v("File-Import")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-11"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "importUsersImportFileInput",
      "type": "file",
      "accept": ".xlsx"
    },
    on: {
      "change": _vm.onImportFileChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [(!_vm.importUsersDialogData.selectedFile.name) ? _c('label', {
    staticStyle: {
      "padding-top": "16px"
    }
  }, [_vm._v("Bitte wählen Sie eine Datei...")]) : _c('label', {
    staticStyle: {
      "padding-top": "16px"
    }
  }, [_vm._v(_vm._s(_vm.importUsersDialogData.selectedFile.name))]), _vm._v(" "), _vm._m(2)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.importUsersDialogData.trimImportData = !_vm.importUsersDialogData.trimImportData
      }
    }
  }, [(_vm.importUsersDialogData.trimImportData) ? _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box")]) : _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]), _vm._v("\n                  Trim import data\n                ")])])])])])], 2) : _vm._e(), _vm._v(" "), (_vm.importStep === 2) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("\n          An folgenden Positionen der hochgeladenen Daten, sind Fehler\n          aufgetreten:\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.importStep === 3) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("\n          Eine Liste der generierten Passwörter steht jetzt zum Download\n          bereit\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          Cancel\n        ")]), _vm._v(" "), (_vm.importStep === 1) ? _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.uploadImportData()
      }
    }
  }, [_vm._v("\n          Upload\n        ")]) : _vm._e(), _vm._v(" "), (_vm.importStep === 3) ? _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.downloadUserList()
      }
    }
  }, [_vm._v("\n          Download\n        ")]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v("Import Users")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Bitte wählen Sie eine Option aus")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn input-group-sm"
  }, [_c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("attach_file")])])])
}]}

/***/ }),
/* 1731 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.globals.isAccessAllowed('LoopOp_Surveys_ReadAll')) ? _c('div', [_c('SurveyManagementEditModal', {
    attrs: {
      "selectedSurvey": _vm.selectedSurvey,
      "showDialog": _vm.showEditSurveyDialog,
      "dialogModeAdd": _vm.editSurveyDialogModeAdd,
      "copySurvey": _vm.copySurvey,
      "languageList": _vm.languageList,
      "localesList": _vm.localesList
    },
    on: {
      "surveyEditorRedirect": _vm.redirectToSurveyEditor,
      "dialogClosed": _vm.onEditSurveyDialogClosed,
      "dialogDataSaved": _vm.onEditSurveyDialogDataSaved
    }
  }), _vm._v(" "), _c('SurveyManagementTranslateModal', {
    attrs: {
      "selectedSurvey": _vm.selectedSurvey,
      "showDialog": _vm.showTranslateSurveyDialog
    },
    on: {
      "dialogClosed": _vm.onTranslateSurveyDialogClosed
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "surveys-top-panel"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "survey-management-refresh-button",
      "disabled": !_vm.refreshEnabled
    },
    on: {
      "click": function($event) {
        return _vm.getSurveyData()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("refresh")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.U0000) + "\n        ")]), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Surveys_Create')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "survey-management-create-button"
    },
    on: {
      "click": function($event) {
        (_vm.selectedSurvey = null),
        (_vm.editSurveyDialogModeAdd = true),
        (_vm.showEditSurveyDialog = true)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("add_box")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.U0001) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Surveys_Read')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "survey-management-edit-button",
      "disabled": !_vm.selectedSurvey
    },
    on: {
      "click": function($event) {
        (_vm.editSurveyDialogModeAdd = false), (_vm.showEditSurveyDialog = true)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("edit")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.U0002) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Surveys_Create')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.selectedSurvey
    },
    on: {
      "click": function($event) {
        (_vm.editSurveyDialogModeAdd = false),
        (_vm.showEditSurveyDialog = true),
        (_vm.copySurvey = true)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("content_copy")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.U0034) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Surveys_Delete')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "survey-management-delete-button",
      "disabled": !_vm.selectedSurvey
    },
    on: {
      "click": function($event) {
        return _vm.openDeleteSurveyDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("clear")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.U0003) + "\n        ")]) : _vm._e(), _vm._v(" "), (
    _vm.globals.isAccessAllowed('LoopOp_Surveys_Read') &&
    _vm.globals.isAccessAllowed('LoopOp_Surveys_Update')
  ) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.selectedSurvey
    },
    on: {
      "click": function($event) {
        return _vm.redirectToSurveyEditor(_vm.selectedSurvey.SurveyId)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("playlist_add_check")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.U0004) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_SurveyTranslation_Read')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.selectedSurvey
    },
    on: {
      "click": function($event) {
        return _vm.openSelectSurveyLanguageDialog(_vm.selectedSurvey.SurveyId)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("language")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.U0037) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Survey_Export')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.selectedSurvey
    },
    on: {
      "click": function($event) {
        return _vm.downloadSurvey(_vm.selectedSurvey)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("get_app")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.U0045) + "\n        ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-lg-7"
  }, [_c('div', {
    staticClass: "form-group searchbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Search),
      expression: "filterStrings.Search"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "search",
      "id": "inputSearch",
      "placeholder": _vm.lang.U0005
    },
    domProps: {
      "value": (_vm.filterStrings.Search)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getSurveyData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Search", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5 nopadding"
  }, [_c('ul', {
    staticClass: "pagination-fonts pagination btn-group"
  }, [_c('li', [_vm._m(0), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "elementsPerPageDropdown",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.U0006))]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 20
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 20)
      }
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 50
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 50)
      }
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 100
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 100)
      }
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 200
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 200)
      }
    }
  }, [_vm._v("200")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 500
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 500)
      }
    }
  }, [_vm._v("500")])])])], 1), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.pageCount || _vm.selectedPage == 1
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 0)
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "firstPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.U0007))])], 1), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage > 4) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getVisiblePages()), function(pageNumber) {
    return _c('li', {
      key: pageNumber,
      class: {
        active: _vm.selectedPage == pageNumber
      },
      on: {
        "click": function($event) {
          return _vm.updatePaging(pageNumber, 0)
        }
      }
    }, [_c('a', {
      attrs: {
        "role": "button"
      }
    }, [_vm._v(_vm._s(pageNumber))])])
  }), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage < _vm.pageCount - 3) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.pageCount || _vm.selectedPage == _vm.pageCount,
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(_vm.pageCount, 0)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "lastPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.U0008))])], 1), _vm._v(" "), _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button",
      "id": "surveysTotalElementsCounter"
    }
  }, [_vm._v(_vm._s(_vm.totalElementsCount))]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "surveysTotalElementsCounter",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.U0044))])], 1)], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    staticClass: "table table-striped table-hover main-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "8%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortSurveyData('SurveyId')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.U0009) + "\n                "), (_vm.sortField == 'SurveyId' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'SurveyId' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "36%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortSurveyData('SurveyTitle')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.U0010) + "\n                "), (_vm.sortField == 'SurveyTitle' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'SurveyTitle' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), (
    !_vm.feature.isAudiTarget || !_vm.feature.isEnabled('audi_importers')
  ) ? _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "26%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortSurveyData('ClientName')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.U0011) + "\n                "), (_vm.sortField == 'ClientName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'ClientName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "26%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortSurveyData('ImporterName')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.U0043) + "\n                "), (_vm.sortField == 'ImporterName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'ImporterName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortSurveyData('SurveyCreatedAt')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.U0012) + "\n                "), (_vm.sortField == 'SurveyCreatedAt' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'SurveyCreatedAt' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "14%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortSurveyData('CurrentUser')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.U0035) + "\n                "), (_vm.sortField == 'CurrentUser' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'CurrentUser' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "6%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortSurveyData('SurveyActive')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.U0036) + "\n                "), (_vm.sortField == 'SurveyActive' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'SurveyActive' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])])]), _vm._v(" "), _c('tr', {
    staticClass: "table-filters"
  }, [_c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "8%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyId),
      expression: "filterStrings.SurveyId"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.U0014
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyId)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getSurveyData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "36%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyTitle),
      expression: "filterStrings.SurveyTitle"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.U0014
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyTitle)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getSurveyData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyTitle", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (
    !_vm.feature.isAudiTarget || !_vm.feature.isEnabled('audi_importers')
  ) ? _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "26%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ClientName),
      expression: "filterStrings.ClientName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.U0014
    },
    domProps: {
      "value": (_vm.filterStrings.ClientName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getSurveyData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ClientName", $event.target.value)
      }
    }
  })])]) : _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "26%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ImporterName),
      expression: "filterStrings.ImporterName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.U0014
    },
    domProps: {
      "value": (_vm.filterStrings.ImporterName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getSurveyData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ImporterName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyCreatedAt),
      expression: "filterStrings.SurveyCreatedAt"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.U0014
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyCreatedAt)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getSurveyData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyCreatedAt", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "14%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.CurrentUser),
      expression: "filterStrings.CurrentUser"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.U0014
    },
    domProps: {
      "value": (_vm.filterStrings.CurrentUser)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getSurveyData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "CurrentUser", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "6%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        (_vm.filterStrings.SurveyActive =
          (_vm.filterStrings.SurveyActive + 1) % 3),
        _vm.getSurveyData()
      }
    }
  }, [(_vm.filterStrings.SurveyActive === 1) ? _c('div', {
    staticClass: "cb-active-filter-container"
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box")])]) : (_vm.filterStrings.SurveyActive === 0) ? _c('div', {
    staticClass: "cb-active-filter-container"
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")])]) : _c('div', {
    staticClass: "cb-active-filter-container"
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("indeterminate_check_box")])])])])])])]), _vm._v(" "), _c('tbody', {
    staticClass: "main-table-scrollbar"
  }, _vm._l((_vm.surveyData), function(survey) {
    return _c('tr', {
      key: survey.SurveyId,
      class: {
        info: _vm.selectedSurvey && survey.SurveyGuid == _vm.selectedSurvey.SurveyGuid
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          _vm.selectedSurvey = survey
        },
        "dblclick": function($event) {
          (_vm.editSurveyDialogModeAdd = false), (_vm.showEditSurveyDialog = true)
        }
      }
    }, [_c('td', {
      staticStyle: {
        "width": "8%"
      }
    }, [_vm._v(_vm._s(survey.SurveyId))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "36%"
      }
    }, [_vm._v(_vm._s(survey.SurveyTitle))]), _vm._v(" "), (
      !_vm.feature.isAudiTarget || !_vm.feature.isEnabled('audi_importers')
    ) ? _c('td', {
      staticStyle: {
        "width": "26%"
      }
    }, [_vm._v("\n              " + _vm._s(survey.ClientName) + "\n            ")]) : _c('td', {
      staticStyle: {
        "width": "26%"
      }
    }, [_vm._v(_vm._s(survey.ImporterName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(survey.SurveyCreatedAt))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "14%"
      }
    }, [_vm._v(_vm._s(survey.CurrentUser))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%",
        "padding": "6px 0 0 0"
      }
    }, [(survey.SurveyActive) ? _c('i', {
      staticClass: "material-icons md-24 survey-active"
    }, [_vm._v("done")]) : _c('i', {
      staticClass: "material-icons md-24 survey-inactive"
    }, [_vm._v("clear")])])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "deleteSurvey",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.U0024))])])]), _vm._v(" "), (_vm.selectedSurvey) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.lang.U0025))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 text-black"
  }, [_vm._v(_vm._s(_vm.lang.U0026))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-10 text-black"
  }, [_vm._v(_vm._s(_vm.selectedSurvey.SurveyId))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 text-black"
  }, [_vm._v(_vm._s(_vm.lang.U0027))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-10 text-black"
  }, [_vm._v(_vm._s(_vm.selectedSurvey.SurveyTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 text-black"
  }, [_vm._v(_vm._s(_vm.lang.U0028))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-10 text-black"
  }, [_vm._v(_vm._s(_vm.selectedSurvey.ClientName))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 text-black"
  }, [_vm._v(_vm._s(_vm.lang.U0029))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-10 text-black"
  }, [_vm._v(_vm._s(_vm.selectedSurvey.SurveyCreatedAt))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "id": "survey-management-delete-false-dialog-button",
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.U0030) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-warning",
    attrs: {
      "id": "survey-management-delete-true-dialog-button",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.deleteSurveyData()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.U0031) + "\n          ")])])])])])], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "role": "button",
      "data-toggle": "dropdown",
      "id": "elementsPerPageDropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("view_headline")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "firstPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("first_page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "lastPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("last_page")])])
}]}

/***/ }),
/* 1732 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.globals.currentUserRole > 0) ? _c('div', {
    attrs: {
      "id": "pageNotFoundComponent"
    }
  }, [_c('h1', [_vm._v("😕")]), _vm._v(" "), _c('h2', [_vm._v("Oh no! How did you get here?")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.setInitialRoute
    }
  }, [_vm._v("Click here to get back on track")])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1733 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "editChecksDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "id": "editChecksForm"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.CM1000))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel-group",
    attrs: {
      "id": "accordionEditChecks",
      "role": "tablist",
      "aria-multiselectable": "true"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingEditChecksGeneral",
      "data-toggle": "collapse",
      "data-parent": "#accordionEditChecks",
      "href": "#collapseEditChecksGeneral",
      "aria-expanded": "true",
      "aria-controls": "collapseEditChecksGeneral"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.CM1001))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in",
    attrs: {
      "id": "collapseEditChecksGeneral",
      "role": "tabpanel",
      "aria-labelledby": "headingEditChecksGeneral"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('a', {
    staticClass: "btn btn-default btn-cb-edit-checks",
    attrs: {
      "role": "button",
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    on: {
      "click": function($event) {
        _vm.generalSettingsData.IsReadonly ||
          _vm.toggleSetting('SurveyInstanceExternalInterface')
      }
    }
  }, [(
    _vm.generalSettingsData.SurveyInstanceExternalInterface >
    0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : (
    _vm.generalSettingsData.SurveyInstanceExternalInterface <
    0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("indeterminate_check_box")]) : _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.CM1003))])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default btn-cb-edit-checks",
    attrs: {
      "role": "button",
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    on: {
      "click": function($event) {
        _vm.generalSettingsData.IsReadonly ||
          _vm.toggleSetting('SurveyInstanceExternalCustom')
      }
    }
  }, [(
    _vm.generalSettingsData.SurveyInstanceExternalCustom > 0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : (
    _vm.generalSettingsData.SurveyInstanceExternalCustom < 0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("indeterminate_check_box")]) : _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.CM1004))])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default btn-cb-edit-checks",
    attrs: {
      "role": "button",
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    on: {
      "click": function($event) {
        _vm.generalSettingsData.IsReadonly ||
          _vm.toggleSetting('SurveyInstanceQueryTool')
      }
    }
  }, [(_vm.generalSettingsData.SurveyInstanceQueryTool > 0) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : (
    _vm.generalSettingsData.SurveyInstanceQueryTool < 0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("indeterminate_check_box")]) : _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.CM1005))])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default btn-cb-edit-checks",
    attrs: {
      "role": "button",
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    on: {
      "click": function($event) {
        _vm.generalSettingsData.IsReadonly ||
          _vm.toggleSetting('SurveyInstanceDashboard')
      }
    }
  }, [(_vm.generalSettingsData.SurveyInstanceDashboard > 0) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : (
    _vm.generalSettingsData.SurveyInstanceDashboard < 0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("indeterminate_check_box")]) : _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.CM1006))])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default btn-cb-edit-checks",
    attrs: {
      "role": "button",
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    on: {
      "click": function($event) {
        _vm.generalSettingsData.IsReadonly ||
          _vm.toggleSetting('SurveyInstanceCheckExplorer')
      }
    }
  }, [(
    _vm.generalSettingsData.SurveyInstanceCheckExplorer > 0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : (
    _vm.generalSettingsData.SurveyInstanceCheckExplorer < 0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("indeterminate_check_box")]) : _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.CM1007))])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default btn-cb-edit-checks",
    attrs: {
      "role": "button",
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    on: {
      "click": function($event) {
        _vm.generalSettingsData.IsReadonly ||
          _vm.toggleSetting('SurveyInstanceAggregatedReport')
      }
    }
  }, [(
    _vm.generalSettingsData.SurveyInstanceAggregatedReport >
    0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : (
    _vm.generalSettingsData.SurveyInstanceAggregatedReport <
    0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("indeterminate_check_box")]) : _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.CM1008))])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default btn-cb-edit-checks",
    attrs: {
      "role": "button",
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    on: {
      "click": function($event) {
        _vm.generalSettingsData.IsReadonly ||
          _vm.toggleSetting('SurveyInstanceRawDataExports')
      }
    }
  }, [(
    _vm.generalSettingsData.SurveyInstanceRawDataExports > 0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : (
    _vm.generalSettingsData.SurveyInstanceRawDataExports < 0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("indeterminate_check_box")]) : _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.CM1009))])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default btn-cb-edit-checks",
    attrs: {
      "role": "button",
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    on: {
      "click": function($event) {
        _vm.generalSettingsData.IsReadonly ||
          _vm.toggleSetting('SurveyInstanceFrequencies')
      }
    }
  }, [(
    _vm.generalSettingsData.SurveyInstanceFrequencies > 0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : (
    _vm.generalSettingsData.SurveyInstanceFrequencies < 0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("indeterminate_check_box")]) : _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.CM1010))])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default btn-cb-edit-checks",
    attrs: {
      "role": "button",
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    on: {
      "click": function($event) {
        _vm.generalSettingsData.IsReadonly ||
          _vm.toggleSetting('SurveyInstanceMediaExplorer')
      }
    }
  }, [(
    _vm.generalSettingsData.SurveyInstanceMediaExplorer > 0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : (
    _vm.generalSettingsData.SurveyInstanceMediaExplorer < 0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("indeterminate_check_box")]) : _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.CM1011))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputCustomReportingDateCheckMgmtEdit"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1013))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8",
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr(
          'inputCustomReportingDateCheckMgmtEdit'
        )
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.generalSettingsData.SurveyInstanceCustomReportingDate
      ),
      expression: "\n                            generalSettingsData.SurveyInstanceCustomReportingDate\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputCustomReportingDateCheckMgmtEdit",
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    domProps: {
      "value": (
        _vm.generalSettingsData.SurveyInstanceCustomReportingDate
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.generalSettingsData, "SurveyInstanceCustomReportingDate", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.languageStringsReceived && !_vm.feature.isAudiTarget) ? _c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "checkManagementEditModalSelectSurveyInstanceType"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1036))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "checkManagementEditModalSelectSurveyInstanceType"
    },
    on: {
      "change": _vm.surveyInstanceTypeChanged
    },
    model: {
      value: (_vm.generalSettingsData.SurveyInstanceType),
      callback: function($$v) {
        _vm.$set(_vm.generalSettingsData, "SurveyInstanceType", $$v)
      },
      expression: "generalSettingsData.SurveyInstanceType"
    }
  }, [_c('option', {
    attrs: {
      "value": "FO"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1037))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MA"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1038))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AG"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1039))])])], 1)]) : _vm._e(), _vm._v(" "), (
    _vm.generalSettingsData.SurveyInstanceType === 'FO' ||
    _vm.generalSettingsData.SurveyInstanceType === 'MA'
  ) ? _c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "checkManagementEditModalSelectUser"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1015))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "checkManagementEditModalSelectUser",
      "placeholder": ' ',
      "allowClear": true,
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    on: {
      "change": function($event) {
        delete _vm.generalSettingsData.SurveyInstanceAssignedLocalAgencyGuid,
          delete _vm.generalSettingsData.SurveyInstanceAssignedLeadAgencyGuid
      }
    },
    model: {
      value: (
        _vm.generalSettingsData.SurveyInstanceAssignedShopperGuid
      ),
      callback: function($$v) {
        _vm.$set(_vm.generalSettingsData, "SurveyInstanceAssignedShopperGuid", $$v)
      },
      expression: "\n                            generalSettingsData.SurveyInstanceAssignedShopperGuid\n                          "
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.dataLists.shopperList), function(user, guid) {
    return _c('option', {
      key: guid,
      domProps: {
        "value": guid
      }
    }, [_vm._v("\n                            " + _vm._s(user) + "\n                          ")])
  })], 2)], 1)]) : _vm._e(), _vm._v(" "), (_vm.generalSettingsData.SurveyInstanceType === 'AG') ? [(
    _vm.feature.isAudiTarget &&
    _vm.feature.isEnabled('leadAgencies')
  ) ? [_c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "checkManagementEditModalSelectLeadAgency"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1066))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select2', {
    ref: "checkEditSelectLeadAgency",
    staticClass: "form-control",
    attrs: {
      "id": "checkManagementEditModalSelectLeadAgency",
      "disabled": _vm.generalSettingsData.IsReadonly ||
        (_vm.feature.isAudiTarget &&
          _vm.generalSettingsData.MaxSurveyInstanceStatusId >
          50)
    },
    on: {
      "change": function($event) {
        delete _vm.generalSettingsData.SurveyInstanceAssignedShopperGuid,
          delete _vm.generalSettingsData.SurveyInstanceAssignedLocalAgencyGuid
      }
    },
    model: {
      value: (
        _vm.generalSettingsData.SurveyInstanceAssignedLeadAgencyGuid
      ),
      callback: function($$v) {
        _vm.$set(_vm.generalSettingsData, "SurveyInstanceAssignedLeadAgencyGuid", $$v)
      },
      expression: "\n                                generalSettingsData.SurveyInstanceAssignedLeadAgencyGuid\n                              "
    }
  }, _vm._l((_vm.leadAgencies), function(agency) {
    return _c('option', {
      key: agency.AgencyGuid,
      domProps: {
        "value": agency.AgencyGuid
      }
    }, [_vm._v("\n                                " + _vm._s(agency.AgencyName) + "\n                              ")])
  }), 0)], 1)]), _vm._v(" "), (!_vm.globals.currentUserInfo.IsAudiUser) ? _c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "checkManagementEditModalSelectLocalAgency"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1067))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select2', {
    ref: "checkEditSelectLocalAgency",
    staticClass: "form-control",
    attrs: {
      "id": "checkManagementEditModalSelectLocalAgency",
      "placeholder": ' ',
      "allowClear": true,
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    on: {
      "change": function($event) {
        delete _vm.generalSettingsData.SurveyInstanceAssignedShopperGuid
      }
    },
    model: {
      value: (
        _vm.generalSettingsData.SurveyInstanceAssignedLocalAgencyGuid
      ),
      callback: function($$v) {
        _vm.$set(_vm.generalSettingsData, "SurveyInstanceAssignedLocalAgencyGuid", $$v)
      },
      expression: "\n                                generalSettingsData.SurveyInstanceAssignedLocalAgencyGuid\n                              "
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.localAgencies), function(agency) {
    return _c('option', {
      key: agency.AgencyGuid,
      domProps: {
        "value": agency.AgencyGuid
      }
    }, [_vm._v("\n                                " + _vm._s(agency.AgencyName) + "\n                              ")])
  })], 2)], 1)]) : _vm._e()] : _c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "checkManagementEditModalSelectAgency"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1016))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "checkManagementEditModalSelectAgency",
      "placeholder": ' ',
      "allowClear": true,
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    on: {
      "change": function($event) {
        delete _vm.generalSettingsData.SurveyInstanceAssignedShopperGuid
      }
    },
    model: {
      value: (
        _vm.generalSettingsData.SurveyInstanceAssignedLocalAgencyGuid
      ),
      callback: function($$v) {
        _vm.$set(_vm.generalSettingsData, "SurveyInstanceAssignedLocalAgencyGuid", $$v)
      },
      expression: "\n                              generalSettingsData.SurveyInstanceAssignedLocalAgencyGuid\n                            "
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.dataLists.agencyList), function(agency) {
    return _c('option', {
      key: agency.AgencyGuid,
      domProps: {
        "value": agency.AgencyGuid
      }
    }, [_vm._v("\n                              " + _vm._s(agency.AgencyName) + "\n                            ")])
  })], 2)], 1)])] : _vm._e(), _vm._v(" "), (_vm.projectSelected) ? _c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "checkManagementEditModalSelectWave"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1028))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "checkManagementEditModalSelectWave",
      "placeholder": ' ',
      "allowClear": true,
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    on: {
      "change": function($event) {
        _vm.generalSettingsData.SurveyInstanceScenarioGuid =
          ''
      }
    },
    model: {
      value: (_vm.generalSettingsData.SurveyInstanceWaveGuid),
      callback: function($$v) {
        _vm.$set(_vm.generalSettingsData, "SurveyInstanceWaveGuid", $$v)
      },
      expression: "generalSettingsData.SurveyInstanceWaveGuid"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.wavesOfProject), function(wave) {
    return _c('option', {
      key: wave.WaveGuid,
      domProps: {
        "value": wave.WaveGuid
      }
    }, [_vm._v("\n                            " + _vm._s(wave.WaveName) + "\n                          ")])
  })], 2)], 1)]) : _vm._e(), _vm._v(" "), (_vm.projectSelected) ? _c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "checkManagementEditModalSelectScenario"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1014))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "checkManagementEditModalSelectScenario",
      "disabled": _vm.generalSettingsData.IsReadonly ||
        !_vm.generalSettingsData.SurveyInstanceWaveGuid,
      "placeholder": ' ',
      "allowClear": true
    },
    model: {
      value: (
        _vm.generalSettingsData.SurveyInstanceScenarioGuid
      ),
      callback: function($$v) {
        _vm.$set(_vm.generalSettingsData, "SurveyInstanceScenarioGuid", $$v)
      },
      expression: "\n                            generalSettingsData.SurveyInstanceScenarioGuid\n                          "
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.scenariosOfWave), function(scenario) {
    return _c('option', {
      key: scenario.ScenarioGuid,
      domProps: {
        "value": scenario.ScenarioGuid
      }
    }, [_vm._v("\n                            " + _vm._s(scenario.ScenarioName) + "\n                          ")])
  })], 2)], 1)]) : _vm._e(), _vm._v(" "), (_vm.projectSelected) ? _c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "checkManagementEditModalSelectLocation"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1029))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "checkManagementEditModalSelectLocation",
      "disabled": _vm.generalSettingsData.IsReadonly ||
        _vm.generalSettingsData.MaxSurveyInstanceStatusId >
        190 ||
        _vm.generalSettingsData.SurveyInstanceLocationGuid ==
        '-1'
    },
    on: {
      "change": function($event) {
        return _vm.selectedLocationChanged()
      }
    },
    model: {
      value: (
        _vm.generalSettingsData.SurveyInstanceLocationGuid
      ),
      callback: function($$v) {
        _vm.$set(_vm.generalSettingsData, "SurveyInstanceLocationGuid", $$v)
      },
      expression: "\n                            generalSettingsData.SurveyInstanceLocationGuid\n                          "
    }
  }, _vm._l((_vm.locationsOfSelectedClient), function(location) {
    return _c('option', {
      key: location.LocationGuid,
      domProps: {
        "value": location.LocationGuid
      }
    }, [_vm._v("\n                            (" + _vm._s(location.LocationStoreId) + ")\n                            " + _vm._s(location.LocationAddress) + "\n                          ")])
  }), 0)], 1)]) : _vm._e(), _vm._v(" "), (
    _vm.feature.isEnabled('briefingAndSurveyDocs') &&
    _vm.selectedProject
  ) ? _c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "checkManagementEditModalSelectBriefing"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1034))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "checkManagementEditModalSelectBriefing",
      "placeholder": ' ',
      "allowClear": true,
      "disabled": _vm.generalSettingsData.IsReadonly ||
        _vm.generalSettingsData.MaxSurveyInstanceStatusId >
        190 ||
        _vm.generalSettingsData.BriefingDownloadGuid === '-1'
    },
    model: {
      value: (_vm.generalSettingsData.BriefingDownloadGuid),
      callback: function($$v) {
        _vm.$set(_vm.generalSettingsData, "BriefingDownloadGuid", $$v)
      },
      expression: "generalSettingsData.BriefingDownloadGuid"
    }
  }, _vm._l((_vm.briefingAttachments), function(briefing) {
    return _c('option', {
      key: briefing.DownloadId,
      domProps: {
        "value": briefing.DownloadId
      }
    }, [_vm._v("\n                            " + _vm._s(briefing.FileName) + "\n                          ")])
  }), 0)], 1)]) : _vm._e(), _vm._v(" "), (
    _vm.feature.isEnabled('briefingAndSurveyDocs') &&
    _vm.selectedProject
  ) ? _c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "checkManagementEditModalSelectSurvey"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1035))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "checkManagementEditModalSelectSurvey",
      "placeholder": ' ',
      "allowClear": true,
      "disabled": _vm.generalSettingsData.IsReadonly ||
        _vm.generalSettingsData.MaxSurveyInstanceStatusId >
        190 ||
        _vm.generalSettingsData.SurveyDownloadGuid === '-1'
    },
    model: {
      value: (_vm.generalSettingsData.SurveyDownloadGuid),
      callback: function($$v) {
        _vm.$set(_vm.generalSettingsData, "SurveyDownloadGuid", $$v)
      },
      expression: "generalSettingsData.SurveyDownloadGuid"
    }
  }, _vm._l((_vm.surveyAttachments), function(survey) {
    return _c('option', {
      key: survey.DownloadId,
      domProps: {
        "value": survey.DownloadId
      }
    }, [_vm._v("\n                            " + _vm._s(survey.FileName) + "\n                          ")])
  }), 0)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputCheckEditSurveyInstanceInfo"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1056))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.generalSettingsData.SurveyInstanceInfo),
      expression: "generalSettingsData.SurveyInstanceInfo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "50",
      "id": "inputCheckEditSurveyInstanceInfo"
    },
    domProps: {
      "value": (_vm.generalSettingsData.SurveyInstanceInfo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.generalSettingsData, "SurveyInstanceInfo", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.generalSettingsData.SurveyInstanceType === 'FO'),
      expression: "generalSettingsData.SurveyInstanceType === 'FO'"
    }]
  }, [_c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputCheckEditStartDate"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1040))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8",
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr('inputCheckEditStartDate')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.generalSettingsData.SurveyInstanceSince),
      expression: "generalSettingsData.SurveyInstanceSince"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputCheckEditStartDate"
    },
    domProps: {
      "value": (_vm.generalSettingsData.SurveyInstanceSince)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.generalSettingsData, "SurveyInstanceSince", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputCheckEditEndDate"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1041))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8",
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr('inputCheckEditEndDate')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.generalSettingsData.SurveyInstanceUntil),
      expression: "generalSettingsData.SurveyInstanceUntil"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputCheckEditEndDate"
    },
    domProps: {
      "value": (_vm.generalSettingsData.SurveyInstanceUntil)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.generalSettingsData, "SurveyInstanceUntil", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "selectCheckEditSurveyInstanceSkillLevel"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1057))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (
        _vm.generalSettingsData.SurveyInstanceSkillLevel
      ),
      expression: "\n                              generalSettingsData.SurveyInstanceSkillLevel\n                            ",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "selectCheckEditSurveyInstanceSkillLevel"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.$set(_vm.generalSettingsData, "SurveyInstanceSkillLevel", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.CM1061) + "\n                              "), (
    _vm.generalSettingsData.SurveySkillLevel > 0
  ) ? _c('span', [_vm._v("(" + _vm._s(_vm.generalSettingsData.SurveySkillLevel) + ")")]) : _vm._e()]), _vm._v(" "), _vm._l((5), function(i) {
    return _c('option', {
      key: i
    }, [_vm._v(_vm._s(i))])
  })], 2)]), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "selectCheckEditSurveyInstanceSkillLevel",
      "delay": _vm.globals.tooltipDelay,
      "placement": "right",
      "boundary": "viewport"
    }
  }, [_vm._v("\n                          1 → " + _vm._s(_vm.lang.CM1058) + "\n                          "), _c('br'), _vm._v(" "), _c('br'), _vm._v("...\n                          "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n                          5 → " + _vm._s(_vm.lang.CM1059) + "\n                        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default btn-state",
    attrs: {
      "role": "button",
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    on: {
      "click": function($event) {
        _vm.generalSettingsData.IsReadonly ||
          _vm.toggleSetting('OnlineState')
      }
    }
  }, [(_vm.generalSettingsData.OnlineState > 0) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : (_vm.generalSettingsData.OnlineState < 0) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("indeterminate_check_box")]) : _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.CM1042))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default btn-state",
    attrs: {
      "role": "button",
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    on: {
      "click": function($event) {
        _vm.generalSettingsData.IsReadonly ||
          _vm.toggleSetting('LocationFree')
      }
    }
  }, [(_vm.generalSettingsData.LocationFree > 0) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : (_vm.generalSettingsData.LocationFree < 0) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("indeterminate_check_box")]) : _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.CM1043))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button",
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    on: {
      "click": function($event) {
        return _vm.openHtmlEditor()
      }
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.CM1044) + "\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised pull-left",
    attrs: {
      "type": "button",
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    on: {
      "click": function($event) {
        return _vm.openShopperFilterModal()
      }
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.CM1053) + "\n                        ")])])])], 2)])]), _vm._v(" "), (
    _vm.globals.isAccessAllowed(
      'LoopOp_SurveyInstancesAnswers_Read'
    ) && !_vm.generalSettingsData.IsReadonly
  ) ? _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingEditChecksSpecific",
      "data-toggle": "collapse",
      "data-parent": "#accordionEditChecks",
      "href": "#collapseEditChecksSpecific",
      "aria-expanded": "false",
      "aria-controls": "collapseEditChecksSpecific"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.CM1017))])])]) : _vm._e(), _vm._v(" "), (
    _vm.globals.isAccessAllowed(
      'LoopOp_SurveyInstancesAnswers_Read'
    ) && !_vm.generalSettingsData.IsReadonly
  ) ? _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseEditChecksSpecific",
      "role": "tabpanel",
      "aria-labelledby": "headingEditChecksSpecific"
    }
  }, [_c('div', {
    staticClass: "panel-body",
    staticStyle: {
      "padding": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-4",
    attrs: {
      "id": "checkListContainer"
    }
  }, [_c('table', {
    staticClass: "table table-striped table-hover main-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.lang.CM1018))])])]), _vm._v(" "), _c('tbody', {
    staticClass: "main-table-scrollbar",
    attrs: {
      "id": "check-list-table"
    }
  }, _vm._l((_vm.specificSettingsData.dataList), function(check, key) {
    return _c('tr', {
      key: key,
      class: {
        info: _vm.specificSettingsData.selectedCheck
          .SurveyInstanceGuid ===
          check.SurveyInstanceGuid,
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          _vm.specificSettingsData.selectedCheck = check
        }
      }
    }, [_c('td', [_vm._v(_vm._s(check.SurveyInstanceId))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [(
    _vm.specificSettingsData.selectedCheck.ApprovedShopper
  ) ? _c('div', {
    staticClass: "shopper-info"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.CM1068) + ":")]), _vm._v("\n                      " + _vm._s(_vm.specificSettingsData.selectedCheck.ApprovedShopper
    .DisplayName) + "\n                      "), _c('div', {
    attrs: {
      "id": "approvedShopperDetailsContainer"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.CM1069) + " (" + _vm._s(_vm.lang.CM1070) + "):\n                        " + _vm._s(_vm.specificSettingsData.selectedCheck.ApprovedShopper
    .ShopperAge) + "\n                        (" + _vm._s(_vm.specificSettingsData.selectedCheck.ApprovedShopper
    .Gender) + ")\n                        "), _c('br'), _vm._v("\n                        " + _vm._s(_vm.lang.CM1071) + ":\n                        " + _vm._s(_vm.specificSettingsData.selectedCheck.ApprovedShopper
    .ShopperCar) + "\n                        "), _c('br'), _vm._v("\n                        " + _vm._s(_vm.lang.CM1072) + ":\n                        " + _vm._s(_vm.specificSettingsData.selectedCheck.ApprovedShopper
    .CarSegmentName) + "\n                        "), _c('br'), _vm._v("\n                        " + _vm._s(_vm.lang.CM1073) + ":\n                        " + _vm._s(_vm.specificSettingsData.selectedCheck.ApprovedShopper
    .CarModelName) + "\n                      ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputDateOfVisitCheckMgmtEdit"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1019))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8",
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr(
          'inputDateOfVisitCheckMgmtEdit'
        )
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.specificSettingsData.selectedCheck
        .SurveyInstanceAnswerDateOfVisit
      ),
      expression: "\n                            specificSettingsData.selectedCheck\n                              .SurveyInstanceAnswerDateOfVisit\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputDateOfVisitCheckMgmtEdit",
      "disabled": !_vm.globals.isAccessAllowed(
        'LoopOp_SurveyInstancesAnswers_Update'
      )
    },
    domProps: {
      "value": (
        _vm.specificSettingsData.selectedCheck
        .SurveyInstanceAnswerDateOfVisit
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.specificSettingsData.selectedCheck, "SurveyInstanceAnswerDateOfVisit", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputTimeInCheckMgmtEdit"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1020))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8",
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr('inputTimeInCheckMgmtEdit')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.specificSettingsData.selectedCheck
        .SurveyInstanceAnswerTimeIn
      ),
      expression: "\n                            specificSettingsData.selectedCheck\n                              .SurveyInstanceAnswerTimeIn\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputTimeInCheckMgmtEdit",
      "disabled": !_vm.globals.isAccessAllowed(
        'LoopOp_SurveyInstancesAnswers_Update'
      )
    },
    domProps: {
      "value": (
        _vm.specificSettingsData.selectedCheck
        .SurveyInstanceAnswerTimeIn
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.specificSettingsData.selectedCheck, "SurveyInstanceAnswerTimeIn", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputTimeOutCheckMgmtEdit"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1021))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8",
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr('inputTimeOutCheckMgmtEdit')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.specificSettingsData.selectedCheck
        .SurveyInstanceAnswerTimeOut
      ),
      expression: "\n                            specificSettingsData.selectedCheck\n                              .SurveyInstanceAnswerTimeOut\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputTimeOutCheckMgmtEdit",
      "disabled": !_vm.globals.isAccessAllowed(
        'LoopOp_SurveyInstancesAnswers_Update'
      )
    },
    domProps: {
      "value": (
        _vm.specificSettingsData.selectedCheck
        .SurveyInstanceAnswerTimeOut
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.specificSettingsData.selectedCheck, "SurveyInstanceAnswerTimeOut", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputMemoShopper"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1022))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.specificSettingsData.selectedCheck
        .SurveyInstanceAnswerMemoShopper
      ),
      expression: "\n                            specificSettingsData.selectedCheck\n                              .SurveyInstanceAnswerMemoShopper\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "4",
      "id": "inputMemoShopper",
      "disabled": !_vm.globals.isAccessAllowed(
        'LoopOp_SurveyInstancesAnswers_Update'
      )
    },
    domProps: {
      "value": (
        _vm.specificSettingsData.selectedCheck
        .SurveyInstanceAnswerMemoShopper
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.specificSettingsData.selectedCheck, "SurveyInstanceAnswerMemoShopper", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputMemoAgency"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1023))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.specificSettingsData.selectedCheck
        .SurveyInstanceAnswerMemoAgency
      ),
      expression: "\n                            specificSettingsData.selectedCheck\n                              .SurveyInstanceAnswerMemoAgency\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "4",
      "id": "inputMemoAgency",
      "disabled": !_vm.globals.isAccessAllowed(
        'LoopOp_SurveyInstancesAnswers_Update'
      )
    },
    domProps: {
      "value": (
        _vm.specificSettingsData.selectedCheck
        .SurveyInstanceAnswerMemoAgency
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.specificSettingsData.selectedCheck, "SurveyInstanceAnswerMemoAgency", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (!_vm.feature.isAudiTarget) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputMemoMSM"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1024))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.specificSettingsData.selectedCheck
        .SurveyInstanceAnswerMemoMSM
      ),
      expression: "\n                            specificSettingsData.selectedCheck\n                              .SurveyInstanceAnswerMemoMSM\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "4",
      "id": "inputMemoMSM",
      "disabled": !_vm.globals.isAccessAllowed(
        'LoopOp_SurveyInstancesAnswers_Update'
      )
    },
    domProps: {
      "value": (
        _vm.specificSettingsData.selectedCheck
        .SurveyInstanceAnswerMemoMSM
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.specificSettingsData.selectedCheck, "SurveyInstanceAnswerMemoMSM", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputEditSurveyInstanceNote"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1052))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.specificSettingsData.selectedCheck
        .SurveyInstanceNote
      ),
      expression: "\n                            specificSettingsData.selectedCheck\n                              .SurveyInstanceNote\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "4",
      "maxlength": "1000",
      "id": "inputEditSurveyInstanceNote",
      "disabled": !_vm.globals.isAccessAllowed(
        'LoopOp_SurveyInstancesAnswers_Update'
      )
    },
    domProps: {
      "value": (
        _vm.specificSettingsData.selectedCheck
        .SurveyInstanceNote
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.specificSettingsData.selectedCheck, "SurveyInstanceNote", $event.target.value)
      }
    }
  })])])])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.CM1025) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button",
      "disabled": !_vm.globals.isAccessAllowed(
        'LoopOp_SurveyInstancesProperties_Update'
      ) || !_vm.generalSettingsData.SurveyInstanceScenarioGuid
    },
    on: {
      "click": function($event) {
        return _vm.saveEditCheckDialogData()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.CM1026) + "\n          ")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1734 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    class: {
      'text-red': _vm.Recommended && !_vm.value
    },
    attrs: {
      "for": ("input-shopper-custprop-" + _vm.Guid + "-" + _vm._uid)
    }
  }, [_vm._v("\n    " + _vm._s(_vm.Title) + "\n    "), (_vm.Recommended) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": ("input-shopper-custprop-" + _vm.Guid + "-" + _vm._uid),
      "disabled": _vm.readOnly
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "change": _vm.updateValue
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 1735 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "editKpiDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "id": "editKpiDialogForm"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.KM2000))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.lang.KM2026) + ":")]), _vm._v("\n            " + _vm._s(_vm.nameOfSelectedClient) + "\n            "), _c('b', [_vm._v("/ " + _vm._s(_vm.lang.KM2029) + ":")]), _vm._v("\n            " + _vm._s(_vm.nameOfSelectedProject) + "\n            "), _c('b', [_vm._v("/ " + _vm._s(_vm.lang.KM2027) + ":")]), _vm._v("\n            " + _vm._s(_vm.nameOfSelectedKpiGroup) + "\n            "), _c('b', [_vm._v("/ " + _vm._s(_vm.lang.KM2028) + ":")]), _vm._v("\n            " + _vm._s(_vm.nameOfSelectedEvaluationRuleGuid) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "form-group searchbar col-md-4",
    staticStyle: {
      "padding-left": "15px",
      "top": "9px"
    }
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.feature.isAudiTarget &&
        _vm.feature.isEnabled('audi_importers')
    },
    on: {
      "change": function($event) {
        _vm.getClientProjectList(), _vm.getKpiGroupsOfSelectedClient()
      }
    },
    model: {
      value: (_vm.selectedClient),
      callback: function($$v) {
        _vm.selectedClient = $$v
      },
      expression: "selectedClient"
    }
  }, _vm._l((_vm.clientList), function(client) {
    return _c('option', {
      key: client.ClientGuid,
      domProps: {
        "value": client.ClientGuid
      }
    }, [_vm._v("\n                      " + _vm._s(client.ClientName) + "\n                    ")])
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group searchbar col-md-4",
    staticStyle: {
      "padding-left": "15px",
      "top": "9px"
    }
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.clientProjectList.length < 1,
      "placeholder": _vm.lang.KM2030,
      "allowClear": true
    },
    on: {
      "change": function($event) {
        return _vm.filterKpiGroupsByProject()
      }
    },
    model: {
      value: (_vm.selectedProjectGuid),
      callback: function($$v) {
        _vm.selectedProjectGuid = $$v
      },
      expression: "selectedProjectGuid"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.clientProjectList), function(project) {
    return _c('option', {
      key: project.ProjectGuid,
      domProps: {
        "value": project.ProjectGuid
      }
    }, [_vm._v("\n                      " + _vm._s(project.ProjectName) + "\n                    ")])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group searchbar col-md-4",
    staticStyle: {
      "padding-left": "15px",
      "top": "9px"
    }
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.lang.KM2001,
      "allowClear": true,
      "disabled": !_vm.selectedProjectGuid || _vm.projectKpiGroupList.length < 1
    },
    on: {
      "change": function($event) {
        _vm.createNewKpi(), _vm.getKpisOfSelectedKpiGroup()
      }
    },
    model: {
      value: (_vm.selectedKpiGroupGuid),
      callback: function($$v) {
        _vm.selectedKpiGroupGuid = $$v
      },
      expression: "selectedKpiGroupGuid"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.projectKpiGroupList), function(kpiGroup) {
    return _c('option', {
      key: kpiGroup.KPIGroupGuid,
      domProps: {
        "value": kpiGroup.KPIGroupGuid
      }
    }, [_vm._v("\n                      " + _vm._s(kpiGroup.KPIGroupCode) + "\n                    ")])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-container",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.KM2002) + "\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.KM2003) + "\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "55%"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.KM2004) + "\n                        ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.kpisOfSelectedKpiGroup), function(kpi) {
    return _c('tr', {
      key: kpi.KPIGuid,
      class: {
        info: _vm.selectedKpiGuid === kpi.KPIGuid
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          (_vm.selectedKpiGuid = kpi.KPIGuid), _vm.getKpiData()
        }
      }
    }, [_c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v("\n                          " + _vm._s(kpi.KPIGroupPosition) + "\n                        ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(kpi.KPICode))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "55%"
      }
    }, [_vm._v(_vm._s(kpi.KPIShortText))])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "padding-right": "0"
    }
  }, [_c('ul', {
    staticClass: "nav nav-tabs nav-kpi-edit",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#editKpiTab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.selectedTab = 'editKpiTab'
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.KM2005))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#kpiOrderInKpiGroupTab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.selectedTab = 'kpiOrderInKpiGroupTab'
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.KM2006))])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade active in",
    attrs: {
      "id": "editKpiTab"
    }
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputKpiCode",
      "id": "inputKpiCodeLabel"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.KM2007) + " *\n                          "), _c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("help_outline")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedKpiInformation.KPICode),
      expression: "selectedKpiInformation.KPICode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "200",
      "id": "inputKpiCode",
      "disabled": !_vm.selectedProjectGuid === '' ||
        _vm.selectedKpiGroupGuid === '',
      "required": ""
    },
    domProps: {
      "value": (_vm.selectedKpiInformation.KPICode)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedKpiInformation, "KPICode", $event.target.value)
      }, function($event) {
        _vm.selectedKpiDirty = true
      }]
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputKpiCode')),
      expression: "inputHasError('inputKpiCode')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.KM2011))])]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "inputKpiCodeLabel",
      "placement": "right",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.KM2037))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputKpiShortText",
      "id": "inputKpiShortTextLabel"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.KM2008) + " *\n                          "), _c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("help_outline")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedKpiInformation.KPIShortText),
      expression: "selectedKpiInformation.KPIShortText"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "50",
      "id": "inputKpiShortText",
      "disabled": !_vm.selectedProjectGuid === '' ||
        _vm.selectedKpiGroupGuid === '',
      "required": ""
    },
    domProps: {
      "value": (_vm.selectedKpiInformation.KPIShortText)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedKpiInformation, "KPIShortText", $event.target.value)
      }, function($event) {
        _vm.selectedKpiDirty = true
      }]
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputKpiShortText')),
      expression: "inputHasError('inputKpiShortText')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.KM2011))])]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "inputKpiShortTextLabel",
      "placement": "right",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.KM2034))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputKpiLongText",
      "id": "inputKpiLongTextLabel"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.KM2009) + " *\n                          "), _c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("help_outline")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedKpiInformation.KPILongText),
      expression: "selectedKpiInformation.KPILongText"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "200",
      "id": "inputKpiLongText",
      "disabled": !_vm.selectedProjectGuid === '' ||
        _vm.selectedKpiGroupGuid === '',
      "required": ""
    },
    domProps: {
      "value": (_vm.selectedKpiInformation.KPILongText)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedKpiInformation, "KPILongText", $event.target.value)
      }, function($event) {
        _vm.selectedKpiDirty = true
      }]
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputKpiLongText')),
      expression: "inputHasError('inputKpiLongText')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.KM2011))])]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "inputKpiLongTextLabel",
      "placement": "right",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.KM2035))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputKpiWeight",
      "id": "inputKpiWeightLabel"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.KM2032) + "\n                          "), _c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("help_outline")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.selectedKpiInformation.KPIWeight),
      expression: "selectedKpiInformation.KPIWeight",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "inputKpiWeight",
      "min": "0",
      "max": "100",
      "step": "0.01",
      "disabled": !_vm.selectedProjectGuid === '' ||
        _vm.selectedKpiGroupGuid === ''
    },
    domProps: {
      "value": (_vm.selectedKpiInformation.KPIWeight)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedKpiInformation, "KPIWeight", _vm._n($event.target.value))
      }, function($event) {
        _vm.selectedKpiDirty = true
      }],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "inputKpiWeightLabel",
      "placement": "right",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.KM2036))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "KPIManagementSelectEvaluation"
    }
  }, [_vm._v(_vm._s(_vm.lang.KM2028))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "KPIManagementSelectEvaluation",
      "placeholder": _vm.lang.KM2031,
      "allowClear": true,
      "disabled": !_vm.selectedProjectGuid === '' ||
        _vm.selectedKpiGroupGuid === ''
    },
    on: {
      "change": function($event) {
        _vm.selectedKpiDirty = true
      }
    },
    model: {
      value: (
        _vm.selectedKpiInformation.KPIEvaluationRuleGuid
      ),
      callback: function($$v) {
        _vm.$set(_vm.selectedKpiInformation, "KPIEvaluationRuleGuid", $$v)
      },
      expression: "\n                              selectedKpiInformation.KPIEvaluationRuleGuid\n                            "
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.kpiEvaluationRulesList), function(evaluation) {
    return _c('option', {
      key: evaluation.EvaluationRuleGuid,
      domProps: {
        "value": evaluation.EvaluationRuleGuid
      }
    }, [_vm._v("\n                              " + _vm._s(evaluation.EvaluationRule) + "\n                            ")])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputKpiDescription"
    }
  }, [_vm._v(_vm._s(_vm.lang.KM2010))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedKpiInformation.KPIDescription),
      expression: "selectedKpiInformation.KPIDescription"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "3",
      "type": "text",
      "maxlength": "500",
      "id": "inputKpiDescription",
      "disabled": !_vm.selectedProjectGuid === '' ||
        _vm.selectedKpiGroupGuid === ''
    },
    domProps: {
      "value": (_vm.selectedKpiInformation.KPIDescription)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedKpiInformation, "KPIDescription", $event.target.value)
      }, function($event) {
        _vm.selectedKpiDirty = true
      }]
    }
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "25px 0 25px 0"
    }
  }, [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "dismissible": "",
      "show": _vm.showAlert
    },
    on: {
      "dismissed": function($event) {
        _vm.showAlert = false
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.KM2012))])], 1), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedKpiGuid && !_vm.selectedKpiDirty
    },
    on: {
      "click": function($event) {
        return _vm.createNewKpi()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("add_box")]), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s(_vm.lang.KM2013) + "\n                      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    class: {
      'btn-warning': _vm.selectedKpiDirty
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedKpiGuid && !_vm.selectedKpiDirty
    },
    on: {
      "click": function($event) {
        return _vm.validateBeforeSubmit('editKpiDialog')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("save")]), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s(_vm.lang.KM2014) + "\n                      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedKpiGuid
    },
    on: {
      "click": function($event) {
        return _vm.openDeleteKpiConfirmationDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("delete")]), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s(_vm.lang.KM2015) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "kpiOrderInKpiGroupTab"
    }
  }, [_c('div', {
    staticClass: "table-container table-positions"
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "80%"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.KM2016) + "\n                            ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.lang.KM2017))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.kpisOfSelectedKpiGroup), function(kpi) {
    return _c('tr', {
      key: kpi.KPIGroupPosition
    }, [_c('td', {
      staticStyle: {
        "width": "80%"
      }
    }, [_vm._v("\n                              " + _vm._s(kpi.KPIShortText) + "\n                            ")]), _vm._v(" "), _c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticClass: "form-group nopadding",
      staticStyle: {
        "width": "60%",
        "float": "left"
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (kpi.KPIGroupPosition),
        expression: "kpi.KPIGroupPosition"
      }],
      staticClass: "form-control text-center nopadding",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(kpi, "KPIGroupPosition", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          _vm.reorderKpisInKpiGroup(kpi.KPICode),
            (_vm.changeKpiOrderDirty = true)
        }]
      }
    }, _vm._l((_vm.kpisOfSelectedKpiGroup), function(kpi2) {
      return _c('option', {
        key: kpi2.KPIGroupPosition,
        domProps: {
          "value": kpi2.KPIGroupPosition
        }
      }, [_vm._v("\n                                    " + _vm._s(kpi2.KPIGroupPosition) + "\n                                  ")])
    }), 0)])])])
  }), 0)])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-default",
    class: {
      'btn-warning': _vm.changeKpiOrderDirty
    },
    attrs: {
      "type": "button",
      "disabled": _vm.kpisOfSelectedKpiGroup.length < 1
    },
    on: {
      "click": function($event) {
        return _vm.saveKpisNewOrder()
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.KM2033) + "\n                    ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.KM2018) + "\n          ")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1736 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.globals.isAccessAllowed('LoopOp_Clients_ReadAll')) ? _c('div', [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "clients-top-panel"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "client-management-refresh-button",
      "disabled": !_vm.refreshEnabled
    },
    on: {
      "click": function($event) {
        return _vm.getClientData()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("refresh")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.C0000) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "client-management-create-button",
      "disabled": !_vm.globals.isAccessAllowed('LoopOp_Clients_Create')
    },
    on: {
      "click": function($event) {
        (_vm.selectedClient = -1), _vm.openEditClientDialog('create')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("add_box")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.C0001) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": _vm.selectedClient == -1 ||
        !_vm.globals.isAccessAllowed('LoopOp_Clients_Read')
    },
    on: {
      "click": function($event) {
        return _vm.openEditClientDialog('edit')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("edit")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.C0002) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": _vm.selectedClient == -1 ||
        !_vm.globals.isAccessAllowed('LoopOp_Surveys_Create')
    },
    on: {
      "click": function($event) {
        (_vm.editSurveyDialogModeAdd = true), (_vm.showEditSurveyDialog = true)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("playlist_add")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.C0006) + "\n        ")]), _vm._v(" "), (_vm.feature.isEnabled('audi_importers')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "client-management-importer-button"
    },
    on: {
      "click": function($event) {
        _vm.showImportersModal = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("language")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.C0118) + "\n        ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-lg-7"
  }, [_c('div', {
    staticClass: "form-group searchbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchString),
      expression: "searchString"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputSearch",
      "placeholder": _vm.lang.C0007
    },
    domProps: {
      "value": (_vm.searchString)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.filterClientData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchString = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5"
  }, [_c('ul', {
    staticClass: "pagination-fonts pagination btn-group"
  }, [_c('li', [_vm._m(0), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "elementsPerPageDropdown",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.C0008))]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 20
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 20)
      }
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 50
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 50)
      }
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 100
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 100)
      }
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 200
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 200)
      }
    }
  }, [_vm._v("200")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == -1
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, -1)
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.C0009))])])])], 1), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.filteredClientData.length || _vm.selectedPage == 1,
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 0)
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "firstPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.C0010))])], 1), _vm._v(" "), (_vm.numberOfPages() > 7 && _vm.selectedPage > 4) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getVisiblePages()), function(pageNumber) {
    return _c('li', {
      key: pageNumber,
      class: {
        active: _vm.selectedPage == pageNumber
      },
      on: {
        "click": function($event) {
          return _vm.updatePaging(pageNumber, 0)
        }
      }
    }, [_c('a', {
      attrs: {
        "role": "button"
      }
    }, [_vm._v(_vm._s(pageNumber))])])
  }), _vm._v(" "), (_vm.numberOfPages() > 7 && _vm.selectedPage < _vm.numberOfPages() - 3) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      disabled:
        !_vm.filteredClientData.length || _vm.selectedPage == _vm.numberOfPages(),
    },
    on: {
      "click": function($event) {
        _vm.updatePaging(_vm.numberOfPages(), 0)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "lastPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.C0011))])], 1), _vm._v(" "), _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button",
      "id": "clientsTotalElementsCounter"
    }
  }, [_vm._v(_vm._s(_vm.filteredClientData.length))]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "clientsTotalElementsCounter",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.C0119))])], 1)], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    staticClass: "table table-striped table-hover main-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "8%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortClientData('id')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.C0012) + "\n                "), (_vm.sortField == 'id' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'id' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "38%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortClientData('name')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.C0013) + "\n                "), (_vm.sortField == 'name' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'name' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "18%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortClientData('address')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.C0014) + "\n                "), (_vm.sortField == 'address' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'address' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortClientData('city')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.C0015) + "\n                "), (_vm.sortField == 'city' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'city' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "8%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortClientData('region')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.C0016) + "\n                "), (_vm.sortField == 'region' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'region' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "8%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortClientData('postalcode')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.C0017) + "\n                "), (_vm.sortField == 'postalcode' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'postalcode' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortClientData('country')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.C0018) + "\n                "), (_vm.sortField == 'country' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'country' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])])])]), _vm._v(" "), _c('tbody', {
    staticClass: "main-table-scrollbar"
  }, _vm._l((_vm.clientDataOnCurrentPage), function(client) {
    return _c('tr', {
      key: client.ClientId,
      class: {
        info: client.ClientId == _vm.selectedClient
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          _vm.selectedClient = client.ClientId
        },
        "dblclick": function($event) {
          !_vm.globals.isAccessAllowed('LoopOp_Clients_Read') ||
            _vm.openEditClientDialog('edit')
        }
      }
    }, [_c('td', {
      staticStyle: {
        "width": "8%"
      }
    }, [_vm._v(_vm._s(client.ClientId))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "38%"
      }
    }, [_vm._v(_vm._s(client.ClientName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "18%"
      }
    }, [_vm._v(_vm._s(client.ClientAddress))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(client.ClientCity))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "8%"
      }
    }, [_vm._v(_vm._s(client.ClientState_Region))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "8%"
      }
    }, [_vm._v(_vm._s(client.ClientPostalCode))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [_vm._v(_vm._s(client.ClientCountry))])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "editClient",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "id": "editForm"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n              ×\n            ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.editClientDialogData.dialogTitle))])]), _vm._v(" "), (
    typeof _vm.editClientDialogData.clientData.ClientId != 'undefined'
  ) ? _c('div', [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.lang.C0019) + ":\n                " + _vm._s(_vm.editClientDialogData.clientData.ClientId))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel-group",
    attrs: {
      "id": "accordion",
      "role": "tablist",
      "aria-multiselectable": "true"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingGeneral",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseGeneral",
      "aria-expanded": "true",
      "aria-controls": "collapseGeneral"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.C0020))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in",
    attrs: {
      "id": "collapseGeneral",
      "role": "tabpanel",
      "aria-labelledby": "headingGeneral"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputClientName"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0021) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editClientDialogData.clientData.ClientName),
      expression: "editClientDialogData.clientData.ClientName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputClientName",
      "name": "inputClientName",
      "required": ""
    },
    domProps: {
      "value": (_vm.editClientDialogData.clientData.ClientName)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputClientName')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputClientName')),
      expression: "inputHasError('inputClientName')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.C0090))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputAddress"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0022))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData.ClientAddress
      ),
      expression: "\n                            editClientDialogData.clientData.ClientAddress\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputAddress"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData.ClientAddress
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientAddress", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputAddress2"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0023))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData.ClientAddress2
      ),
      expression: "\n                            editClientDialogData.clientData.ClientAddress2\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputAddress2"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData.ClientAddress2
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientAddress2", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputCity"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0024))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editClientDialogData.clientData.ClientCity),
      expression: "editClientDialogData.clientData.ClientCity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputCity"
    },
    domProps: {
      "value": (_vm.editClientDialogData.clientData.ClientCity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientCity", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputCountry"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0027))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData.ClientCountry
      ),
      expression: "\n                            editClientDialogData.clientData.ClientCountry\n                          "
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editClientDialogData.clientData, "ClientCountry", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.changedCountry(
          _vm.editClientDialogData.clientData.ClientCountry,
          'general'
        )
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": 'undefined'
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.C0026) + "\n                          ")]), _vm._v(" "), _vm._l((_vm.globals.countryList), function(country, ISOCode) {
    return _c('option', {
      key: ISOCode,
      domProps: {
        "value": ISOCode
      }
    }, [_vm._v("\n                            " + _vm._s(country) + "\n                          ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputRegion"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0025))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData.ClientState_Region
      ),
      expression: "\n                            editClientDialogData.clientData.ClientState_Region\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.editClientDialogData.currentRegionsGeneral
        .length < 1
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editClientDialogData.clientData, "ClientState_Region", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(
    _vm.editClientDialogData.currentRegionsGeneral
    .length > 0
  ) ? _c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": 'undefined'
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.C0026) + "\n                          ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.editClientDialogData.currentRegionsGeneral), function(region) {
    return _c('option', {
      key: region.Region,
      domProps: {
        "value": region.Region
      }
    }, [_vm._v("\n                            " + _vm._s(region.RegionName) + "\n                          ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputTimeZone"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0030))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData.ClientTimeZoneId
      ),
      expression: "\n                            editClientDialogData.clientData.ClientTimeZoneId\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.editClientDialogData.currentTimeZonesGeneral
        .length < 1
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editClientDialogData.clientData, "ClientTimeZoneId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(
    _vm.editClientDialogData.currentTimeZonesGeneral
    .length > 0
  ) ? _c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": 'undefined'
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.C0026) + "\n                          ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.editClientDialogData.currentTimeZonesGeneral), function(tz) {
    return _c('option', {
      key: tz.TimeZoneId,
      domProps: {
        "value": tz.TimeZoneId
      }
    }, [_vm._v("\n                            " + _vm._s(tz.TimeZoneName) + "\n                          ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputPostalCode"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0028))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData.ClientPostalCode
      ),
      expression: "\n                            editClientDialogData.clientData.ClientPostalCode\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputPostalCode"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData.ClientPostalCode
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientPostalCode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputSinceClientMgmtEdit"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0029))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10",
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr('inputSinceClientMgmtEdit')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData.ClientSince
      ),
      expression: "\n                            editClientDialogData.clientData.ClientSince\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputSinceClientMgmtEdit"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData.ClientSince
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientSince", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputAdditionalInfo"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0031))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData
        .ClientAdditionalInfo
      ),
      expression: "\n                            editClientDialogData.clientData\n                              .ClientAdditionalInfo\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputAdditionalInfo"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData
        .ClientAdditionalInfo
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientAdditionalInfo", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingContact",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseContact",
      "aria-expanded": "false",
      "aria-controls": "collapseContact"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.C0032))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseContact",
      "role": "tabpanel",
      "aria-labelledby": "headingContact"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputContactFirstname"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0033))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData
        .ClientContactFirstName
      ),
      expression: "\n                            editClientDialogData.clientData\n                              .ClientContactFirstName\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputContactFirstname"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData
        .ClientContactFirstName
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientContactFirstName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputContactLastname"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0034))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData
        .ClientContactLastName
      ),
      expression: "\n                            editClientDialogData.clientData\n                              .ClientContactLastName\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputContactLastname"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData
        .ClientContactLastName
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientContactLastName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputContactPhone"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0035))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData.ClientContactPhone
      ),
      expression: "\n                            editClientDialogData.clientData.ClientContactPhone\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "inputContactPhone",
      "name": "inputContactPhone"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData.ClientContactPhone
      )
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputContactPhone')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientContactPhone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputContactPhone')),
      expression: "inputHasError('inputContactPhone')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.C0091))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputContactFax"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0036))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData.ClientContactFax
      ),
      expression: "\n                            editClientDialogData.clientData.ClientContactFax\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "inputContactFax",
      "name": "inputContactFax"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData.ClientContactFax
      )
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputContactFax')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientContactFax", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputContactFax')),
      expression: "inputHasError('inputContactFax')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.C0092))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputContactEmail"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0037))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData.ClientContactEmail
      ),
      expression: "\n                            editClientDialogData.clientData.ClientContactEmail\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "inputContactEmail",
      "name": "inputContactEmail"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData.ClientContactEmail
      )
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputContactEmail')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientContactEmail", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputContactEmail')),
      expression: "inputHasError('inputContactEmail')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.C0094))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingBillingDetail",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseBillingDetail",
      "aria-expanded": "false",
      "aria-controls": "collapseBillingDetail"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.C0038))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseBillingDetail",
      "role": "tabpanel",
      "aria-labelledby": "headingBillingDetail"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputBillTo"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0039))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData.ClientBillTo
      ),
      expression: "\n                            editClientDialogData.clientData.ClientBillTo\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputBillTo"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData.ClientBillTo
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientBillTo", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputBillingAddress"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0040))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData
        .ClientBillingAddress
      ),
      expression: "\n                            editClientDialogData.clientData\n                              .ClientBillingAddress\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputBillingAddress"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData
        .ClientBillingAddress
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientBillingAddress", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputBillingAddress2"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0041))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData
        .ClientBillingAddress2
      ),
      expression: "\n                            editClientDialogData.clientData\n                              .ClientBillingAddress2\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputBillingAddress2"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData
        .ClientBillingAddress2
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientBillingAddress2", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputBillingCity"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0042))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData.ClientBillingCity
      ),
      expression: "\n                            editClientDialogData.clientData.ClientBillingCity\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputBillingCity"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData.ClientBillingCity
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientBillingCity", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputBillingCountry"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0044))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData
        .ClientBillingCountry
      ),
      expression: "\n                            editClientDialogData.clientData\n                              .ClientBillingCountry\n                          "
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editClientDialogData.clientData, "ClientBillingCountry", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.changedCountry(
          _vm.editClientDialogData.clientData
          .ClientBillingCountry,
          'billing'
        )
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": 'undefined'
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.C0026) + "\n                          ")]), _vm._v(" "), _vm._l((_vm.globals.countryList), function(country, ISOCode) {
    return _c('option', {
      key: ISOCode,
      domProps: {
        "value": ISOCode
      }
    }, [_vm._v("\n                            " + _vm._s(country) + "\n                          ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputBillingRegion"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0043))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData
        .ClientBillingState_Region
      ),
      expression: "\n                            editClientDialogData.clientData\n                              .ClientBillingState_Region\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.editClientDialogData.currentRegionsBilling
        .length < 1
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editClientDialogData.clientData, "ClientBillingState_Region", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(
    _vm.editClientDialogData.currentRegionsBilling
    .length > 0
  ) ? _c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": 'undefined'
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.C0026) + "\n                          ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.editClientDialogData.currentRegionsBilling), function(region) {
    return _c('option', {
      key: region.Region,
      domProps: {
        "value": region.Region
      }
    }, [_vm._v("\n                            " + _vm._s(region.RegionName) + "\n                          ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputBillingPostalCode"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0045))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData
        .ClientBillingPostalCode
      ),
      expression: "\n                            editClientDialogData.clientData\n                              .ClientBillingPostalCode\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputBillingPostalCode"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData
        .ClientBillingPostalCode
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientBillingPostalCode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputBillingEmail"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0046))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData.ClientBillToEmail
      ),
      expression: "\n                            editClientDialogData.clientData.ClientBillToEmail\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "inputBillingEmail",
      "name": "inputBillingEmail"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData.ClientBillToEmail
      )
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputBillingEmail')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientBillToEmail", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputBillingEmail')),
      expression: "inputHasError('inputBillingEmail')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.C0094))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputBillingTerms"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0047))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData.ClientBillingTerms
      ),
      expression: "\n                            editClientDialogData.clientData.ClientBillingTerms\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputBillingTerms"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData.ClientBillingTerms
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientBillingTerms", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingPersonalization",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapsePersonalization",
      "aria-expanded": "false",
      "aria-controls": "collapsePersonalization"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.C0048))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapsePersonalization",
      "role": "tabpanel",
      "aria-labelledby": "headingPersonalization"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputLogoURL"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0049))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData.ClientPageLogoURL
      ),
      expression: "\n                            editClientDialogData.clientData.ClientPageLogoURL\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "url",
      "id": "inputLogoURL",
      "name": "inputLogoURL"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData.ClientPageLogoURL
      )
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputLogoURL')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientPageLogoURL", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputLogoURL')),
      expression: "inputHasError('inputLogoURL')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.C0093))])])])])]), _vm._v(" "), (
    _vm.selectedClient != -1 &&
    _vm.globals.isAccessAllowed('LoopOp_Surveys_ReadAll')
  ) ? _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingSurveys",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseSurveys",
      "aria-expanded": "false",
      "aria-controls": "collapseSurveys"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.C0059))])])]) : _vm._e(), _vm._v(" "), (
    _vm.selectedClient != -1 &&
    _vm.globals.isAccessAllowed('LoopOp_Surveys_ReadAll')
  ) ? _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseSurveys",
      "role": "tabpanel",
      "aria-labelledby": "headingSurveys"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-top-bar btn-top-dialog",
    attrs: {
      "type": "button",
      "disabled": _vm.editClientDialogData.selectedSurvey == -1 ||
        !_vm.globals.isAccessAllowed('LoopOp_Surveys_Read')
    },
    on: {
      "click": function($event) {
        (_vm.editSurveyDialogModeAdd = false),
        (_vm.showEditSurveyDialog = true)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("edit")]), _vm._v(" "), _c('br'), _vm._v("\n                      " + _vm._s(_vm.lang.C0107) + "\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar btn-top-dialog",
    attrs: {
      "type": "button",
      "disabled": _vm.editClientDialogData.selectedSurvey == -1 ||
        !_vm.globals.isAccessAllowed('LoopOp_Surveys_Read') ||
        !_vm.globals.isAccessAllowed('LoopOp_Surveys_Update')
    },
    on: {
      "click": function($event) {
        return _vm.redirectToSurveyEditor(
          _vm.editClientDialogData.selectedSurvey
        )
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("playlist_add_check")]), _vm._v(" "), _c('br'), _vm._v("\n                      " + _vm._s(_vm.lang.C0108) + "\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar btn-top-dialog",
    attrs: {
      "type": "button",
      "disabled": _vm.editClientDialogData.selectedSurvey == -1 ||
        !_vm.globals.isAccessAllowed('LoopOp_Surveys_Delete')
    },
    on: {
      "click": function($event) {
        _vm.showDeleteSurveyModal = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("clear")]), _vm._v(" "), _c('br'), _vm._v("\n                      " + _vm._s(_vm.lang.C0109) + "\n                    ")]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.C0060) + "\n                          ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "80%"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.C0061) + "\n                          ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.editClientDialogData.clientData
    .Surveys), function(survey) {
    return _c('tr', {
      key: survey.SurveyId,
      class: {
        info: _vm.editClientDialogData.selectedSurvey ==
          survey.SurveyId,
      },
      on: {
        "click": function($event) {
          _vm.editClientDialogData.selectedSurvey =
            survey.SurveyId
        },
        "dblclick": function($event) {
          (_vm.editSurveyDialogModeAdd = false),
          (_vm.showEditSurveyDialog = true)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(survey.SurveyId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(survey.SurveyTitle))])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.selectedClient != -1) ? _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingCustProp",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseCustProp",
      "aria-expanded": "false",
      "aria-controls": "collapseCustProp"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.C0062))])])]) : _vm._e(), _vm._v(" "), (_vm.selectedClient != -1) ? _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseCustProp",
      "role": "tabpanel",
      "aria-labelledby": "headingCustProp"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputCustProp"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0063))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editClientDialogData.newCustomProperty),
      expression: "editClientDialogData.newCustomProperty"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputCustProp"
    },
    domProps: {
      "value": (_vm.editClientDialogData.newCustomProperty)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData, "newCustomProperty", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    staticStyle: {
      "margin-top": "0px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addNewCustomProperty()
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.C0064) + "\n                      ")])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.C0065) + "\n                          ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.C0066) + "\n                          ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0103))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0067))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.editClientDialogData.clientData
    .CustomProperties), function(property) {
    return _c('tr', {
      key: property.Position
    }, [_c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticClass: "form-group nopadding"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (property.Name),
        expression: "property.Name"
      }],
      staticClass: "form-control text-center textarea-custom-properties autoExpand",
      staticStyle: {
        "margin": "0px"
      },
      attrs: {
        "rows": "1",
        "type": "text"
      },
      domProps: {
        "value": (property.Name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(property, "Name", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(property.Id))]), _vm._v(" "), _c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticClass: "form-group nopadding",
      staticStyle: {
        "margin-right": "10px !important"
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (property.Visibility),
        expression: "property.Visibility"
      }],
      staticClass: "form-control text-center nopadding",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(property, "Visibility", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "0"
      }
    }, [_vm._v(_vm._s(_vm.lang.C0104))]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "1"
      }
    }, [_vm._v(_vm._s(_vm.lang.C0105))])])])]), _vm._v(" "), _c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticClass: "form-group nopadding",
      staticStyle: {
        "width": "60%",
        "float": "left"
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (property.Position),
        expression: "property.Position"
      }],
      staticClass: "form-control text-center nopadding",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(property, "Position", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.reorderCustomProperties(property.Name)
        }]
      }
    }, _vm._l((_vm.editClientDialogData
      .clientData.CustomProperties), function(property2) {
      return _c('option', {
        key: property2.Position,
        domProps: {
          "value": property2.Position
        }
      }, [_vm._v("\n                                  " + _vm._s(property2.Position) + "\n                                ")])
    }), 0)]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "40%",
        "float": "left"
      }
    }, [(_vm.isCustomPropertyRemovable(property)) ? _c('button', {
      staticClass: "btn",
      staticStyle: {
        "padding": "0px",
        "margin": "7px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.openRemoveCustomPropertyDialog(property.Id)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24",
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("clear")])]) : _vm._e()])])])
  }), 0)])])]) : _vm._e()])]), _vm._v(" "), _c('b-alert', {
    attrs: {
      "variant": "danger",
      "dismissible": "",
      "show": _vm.editClientDialogData.showAlert
    },
    on: {
      "dismissed": function($event) {
        _vm.editClientDialogData.showAlert = false
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.C0068))])], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.C0069) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "id": "client-management-save-button",
      "type": "button",
      "disabled": !_vm.globals.isAccessAllowed('LoopOp_Clients_Update') &&
        _vm.editClientDialogData.dialogType == 'edit'
    },
    on: {
      "click": function($event) {
        return _vm.validateBeforeSubmit('editClient')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.C0070) + "\n            ")])])])])])]), _vm._v(" "), _c('SurveyManagementEditModal', {
    attrs: {
      "selectedSurvey": _vm.editClientDialogData.selectedSurvey,
      "selectedClient": _vm.selectedClientData,
      "showDialog": _vm.showEditSurveyDialog,
      "dialogModeAdd": _vm.editSurveyDialogModeAdd,
      "languageList": _vm.languageList,
      "localesList": _vm.localesList
    },
    on: {
      "surveyEditorRedirect": _vm.redirectToSurveyEditor,
      "dialogClosed": _vm.onEditSurveyDialogClosed,
      "dialogDataSaved": _vm.onEditSurveyDialogDataSaved
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "removeCustomPropertySecurityDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.C0110))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('p', [_vm._v(_vm._s(_vm.lang.C0111))]), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(_vm.lang.C0112) + "\n                "), _c('b', [_vm._v(_vm._s(_vm.removeCustomPropertySecurityDialogData.propName))]), _vm._v("\n                " + _vm._s(_vm.lang.C0113) + "\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.C0114) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.removeCustomProperty(
          _vm.removeCustomPropertySecurityDialogData.propId
        )
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.C0115) + "\n          ")])])])])]), _vm._v(" "), _c('confirmation-dialog', {
    attrs: {
      "confirmationTitle": _vm.lang.C0116,
      "yesButtonText": _vm.lang.C0115,
      "noButtonText": _vm.lang.C0114,
      "showDialog": _vm.showDeleteSurveyModal,
      "colorRed": true
    },
    on: {
      "onYesConfirmation": _vm.deleteSurvey,
      "dialogClosed": function($event) {
        _vm.showDeleteSurveyModal = false
      }
    }
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.lang.C0117))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 text-black"
  }, [_vm._v(_vm._s(_vm.lang.C0019))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-10 text-black"
  }, [_vm._v(_vm._s(_vm.editClientDialogData.selectedSurvey))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 text-black"
  }, [_vm._v(_vm._s(_vm.lang.C0098))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-10 text-black"
  }, [_vm._v(_vm._s(_vm.getSelectedSurveyTitle()))])])]), _vm._v(" "), (_vm.feature.isEnabled('audi_importers')) ? _c('ImporterManagement', {
    attrs: {
      "showModal": _vm.showImportersModal
    },
    on: {
      "modalClosed": function($event) {
        _vm.showImportersModal = false
      }
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "role": "button",
      "data-toggle": "dropdown",
      "id": "elementsPerPageDropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("view_headline")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "firstPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("first_page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "lastPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("last_page")])])
}]}

/***/ }),
/* 1737 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step-container"
  }, [_c('StepHeader', {
    attrs: {
      "currentStep": _vm.currentStep,
      "steps": _vm.steps
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "export-section"
  }, [_c('button', {
    staticClass: "export-button",
    on: {
      "click": _vm.exportConfiguration
    }
  }, [_c('svg', {
    staticClass: "export-icon",
    attrs: {
      "fill": "none",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11.5 15.577V6.927L9.17 9.257L8.462 8.539L12 5L15.539 8.539L14.831 9.258L12.5 6.927V15.577H11.5ZM5 19V14.962H6V18H18V14.962H19V19H5Z",
      "fill": "currentColor"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Export")])])]), _vm._v(" "), _c('div', {
    staticClass: "summary-table-section"
  }, [_c('div', {
    staticClass: "wizard-table-container"
  }, [_c('div', {
    staticClass: "wizard-table-body"
  }, [_c('div', {
    staticClass: "wizard-table-row"
  }, [_c('div', {
    staticClass: "wizard-table-cell"
  }, [_vm._v(_vm._s(_vm.lang.W00075))]), _vm._v(" "), _c('div', {
    staticClass: "wizard-table-cell"
  }, [_vm._v(_vm._s(_vm.formData.waveName))])]), _vm._v(" "), _c('div', {
    staticClass: "wizard-table-row"
  }, [_c('div', {
    staticClass: "wizard-table-cell"
  }, [_vm._v(_vm._s(_vm.lang.W00016))]), _vm._v(" "), _c('div', {
    staticClass: "wizard-table-cell"
  }, [_vm._v(_vm._s(_vm.formData.surveyTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "wizard-table-row"
  }, [_c('div', {
    staticClass: "wizard-table-cell"
  }, [_vm._v(_vm._s(_vm.lang.W00027))]), _vm._v(" "), _c('div', {
    staticClass: "wizard-table-cell"
  }, [_vm._v(_vm._s(_vm.formData.importerName))])]), _vm._v(" "), _c('div', {
    staticClass: "wizard-table-row"
  }, [_c('div', {
    staticClass: "wizard-table-cell"
  }, [_vm._v(_vm._s(_vm.lang.W00029))]), _vm._v(" "), _c('div', {
    staticClass: "wizard-table-cell"
  }, [_vm._v(_vm._s(_vm.formData.agencyName))])]), _vm._v(" "), _c('div', {
    staticClass: "wizard-table-row"
  }, [_c('div', {
    staticClass: "wizard-table-cell"
  }, [_vm._v(_vm._s(_vm.lang.W00076))]), _vm._v(" "), _c('div', {
    staticClass: "wizard-table-cell"
  }, [_vm._v(_vm._s(_vm.formData.leadAgency))])]), _vm._v(" "), _c('div', {
    staticClass: "wizard-table-row"
  }, [_c('div', {
    staticClass: "wizard-table-cell"
  }, [_vm._v(_vm._s(_vm.lang.W00077))]), _vm._v(" "), _c('div', {
    staticClass: "wizard-table-cell"
  }, [_vm._v(_vm._s(_vm.scenariosNames))])]), _vm._v(" "), _c('div', {
    staticClass: "wizard-table-row"
  }, [_c('div', {
    staticClass: "wizard-table-cell"
  }, [_vm._v("Audi " + _vm._s(_vm.lang.W00078))]), _vm._v(" "), _c('div', {
    staticClass: "wizard-table-cell"
  }, [_vm._v(_vm._s(_vm.carModelDistributionDisplay))])]), _vm._v(" "), _vm._l((_vm.competitorBrands), function(brand) {
    return _c('div', {
      staticClass: "wizard-table-row"
    }, [_c('div', {
      staticClass: "wizard-table-cell"
    }, [_vm._v(_vm._s(brand) + " " + _vm._s(_vm.lang.W00078))]), _vm._v(" "), _c('div', {
      staticClass: "wizard-table-cell"
    }, [_vm._v(_vm._s(_vm.competitorCarModelDistributionDisplay[brand].join(", ")))])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "summary-table-section"
  }, [_c('div', {
    staticClass: "wizard-table-container"
  }, [_c('div', {
    staticClass: "wizard-table-header wizard-table-visits-header"
  }, [_c('div', [_vm._v(_vm._s(_vm.lang.SA0015))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.lang.SA0044))]), _vm._v(" "), _c('div', [_vm._v("Checks")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.lang.CM1034))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.lang.CM1035))])]), _vm._v(" "), _c('div', {
    staticClass: "wizard-table-body"
  }, _vm._l((_vm.formData.visits || []), function(visit) {
    return _c('div', {
      key: ((visit.LocationId) + "-" + (visit.ScenarioName)),
      staticClass: "wizard-table-row wizard-table-visits-row"
    }, [_c('div', {
      staticClass: "wizard-table-cell"
    }, [_vm._v(_vm._s(visit.LocationName))]), _vm._v(" "), _c('div', {
      staticClass: "wizard-table-cell"
    }, [_vm._v(_vm._s(visit.ScenarioName))]), _vm._v(" "), _c('div', {
      staticClass: "wizard-table-cell"
    }, [_vm._v(_vm._s(visit.NumberOfVisits))]), _vm._v(" "), _c('div', {
      staticClass: "wizard-table-cell"
    }, [_vm._v(_vm._s(_vm.getAttachmentFileName(visit.ScenarioId, 'Briefing')))]), _vm._v(" "), _c('div', {
      staticClass: "wizard-table-cell"
    }, [_vm._v(_vm._s(_vm.getAttachmentFileName(visit.ScenarioId, 'Survey')))])])
  }), 0)])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1738 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step-container"
  }, [_c('StepHeader', {
    attrs: {
      "currentStep": _vm.currentStep,
      "steps": _vm.steps
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "wizard-table-container"
  }, [_c('div', {
    staticClass: "wizard-table-header"
  }, [_c('div', [_vm._v(_vm._s(_vm.lang.W00056))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.lang.W00054))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.lang.W00016))])]), _vm._v(" "), _c('div', {
    staticClass: "wizard-table-body"
  }, _vm._l((_vm.localFormData.scenarios), function(scenario, index) {
    return _c('div', {
      key: ("scenario-" + (scenario.ScenarioId)),
      staticClass: "wizard-table-row"
    }, [_c('div', {
      staticClass: "wizard-table-cell"
    }, [_vm._v(_vm._s(scenario.ScenarioName))]), _vm._v(" "), _c('div', {
      staticClass: "wizard-table-cell"
    }, [(_vm.localFormData && _vm.briefingAttachments) ? _c('select', {
      staticClass: "wizard-select",
      attrs: {
        "disabled": _vm.readonly
      },
      domProps: {
        "value": _vm.getValue(scenario.ScenarioId, 'Briefing')
      },
      on: {
        "change": function($event) {
          return _vm.setValue(scenario.ScenarioId, 'Briefing', $event)
        }
      }
    }, [_c('option', {
      attrs: {
        "disabled": "",
        "hidden": ""
      },
      domProps: {
        "value": null
      }
    }, [_vm._v(_vm._s(_vm.lang.W00057))]), _vm._v(" "), _vm._l((_vm.briefingAttachments), function(file) {
      return _c('option', {
        key: file.DownloadId,
        domProps: {
          "value": file.DownloadId
        }
      }, [_vm._v(_vm._s(file.FileName) + "." + _vm._s(file.FileType))])
    })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "wizard-table-cell"
    }, [(_vm.localFormData && _vm.surveyAttachments) ? _c('select', {
      staticClass: "wizard-select",
      attrs: {
        "disabled": _vm.readonly
      },
      domProps: {
        "value": _vm.getValue(scenario.ScenarioId, 'Survey')
      },
      on: {
        "change": function($event) {
          return _vm.setValue(scenario.ScenarioId, 'Survey', $event)
        }
      }
    }, [_c('option', {
      attrs: {
        "disabled": "",
        "hidden": ""
      },
      domProps: {
        "value": null
      }
    }, [_vm._v(_vm._s(_vm.lang.W00058))]), _vm._v(" "), _vm._l((_vm.surveyAttachments), function(file) {
      return _c('option', {
        key: file.DownloadId,
        domProps: {
          "value": file.DownloadId
        }
      }, [_vm._v(_vm._s(file.FileName) + "." + _vm._s(file.FileType))])
    })], 2) : _vm._e()])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "uploaded-files-section"
  }, [_c('div', [_c('h4', [_c('b', [_vm._v(_vm._s(_vm.lang.W00059))])]), _vm._v(" "), _c('div', {
    staticClass: "files-list"
  }, _vm._l((_vm.briefingAttachments), function(file) {
    return _c('div', {
      key: file.DownloadId,
      staticClass: "file-item",
      on: {
        "click": function($event) {
          return _vm.globals.downloadFile(file.DownloadId)
        }
      }
    }, [_c('span', {
      staticClass: "file-name"
    }, [_vm._v(_vm._s(file.FileName) + "." + _vm._s(file.FileType))]), _vm._v(" "), _c('i', {
      staticClass: "material-icons md-24"
    }, [_vm._v("file_download")])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-container"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "inputBriefingAttachmentFile",
      "type": "file",
      "accept": "application/pdf"
    },
    on: {
      "change": function($event) {
        return _vm.onInputChange($event, 'Briefing')
      }
    }
  })])]), _vm._v(" "), _c('div', [_c('h4', [_c('b', [_vm._v(_vm._s(_vm.lang.W00060))])]), _vm._v(" "), _c('div', {
    staticClass: "files-list"
  }, _vm._l((_vm.surveyAttachments), function(file) {
    return _c('div', {
      key: file.DownloadId,
      staticClass: "file-item",
      on: {
        "click": function($event) {
          return _vm.globals.downloadFile(file.DownloadId)
        }
      }
    }, [_c('span', {
      staticClass: "file-name"
    }, [_vm._v(_vm._s(file.FileName) + "." + _vm._s(file.FileType))]), _vm._v(" "), _c('i', {
      staticClass: "material-icons md-24"
    }, [_vm._v("file_download")])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-container"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "inputSurveyAttachmentFile",
      "type": "file",
      "accept": "application/pdf"
    },
    on: {
      "change": function($event) {
        return _vm.onInputChange($event, 'Survey')
      }
    }
  })])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "wizard-btn-dark",
    staticStyle: {
      "margin": "10px"
    },
    attrs: {
      "for": "inputBriefingAttachmentFile"
    }
  }, [_vm._v("\n            Upload briefing\n            "), _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("file_upload")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "wizard-btn-dark",
    staticStyle: {
      "margin": "10px"
    },
    attrs: {
      "for": "inputSurveyAttachmentFile"
    }
  }, [_vm._v("\n            Upload survey\n            "), _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("file_upload")])])
}]}

/***/ }),
/* 1739 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step-container"
  }, [_c('StepHeader', {
    attrs: {
      "currentStep": _vm.currentStep,
      "steps": _vm.steps
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "form-sections"
  }, _vm._l((_vm.brands), function(brand, index) {
    return _c('div', {
      key: index,
      staticClass: "brand-container"
    }, [_c('div', {
      staticClass: "brand-title-container"
    }, [_c('h4', [_c('b', [_vm._v(_vm._s(brand) + "-" + _vm._s(_vm.lang.W00050))])]), _vm._v(" "), _c('div', {
      staticClass: "apply-visits-container"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.visitsToApply.scenarioId),
        expression: "visitsToApply.scenarioId"
      }],
      attrs: {
        "disabled": _vm.readonly
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.visitsToApply, "scenarioId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "disabled": "",
        "hidden": ""
      },
      domProps: {
        "value": null
      }
    }, [_vm._v(_vm._s(_vm.lang.W00080))]), _vm._v(" "), _vm._l((_vm.localFormData.scenarios), function(scenario) {
      return _c('option', {
        key: scenario.ScenarioId,
        domProps: {
          "value": scenario.ScenarioId
        }
      }, [_vm._v(_vm._s(scenario.ScenarioName))])
    })], 2), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.visitsToApply.number),
        expression: "visitsToApply.number"
      }],
      attrs: {
        "type": "number",
        "min": 0,
        "step": 1,
        "disabled": _vm.readonly
      },
      domProps: {
        "value": (_vm.visitsToApply.number)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.visitsToApply, "number", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "wizard-btn-dark",
      attrs: {
        "disabled": _vm.readonly
      },
      on: {
        "click": function($event) {
          return _vm.applyVisits(brand)
        }
      }
    }, [_vm._v(_vm._s(_vm.lang.W00079))])])]), _vm._v(" "), _c('div', {
      staticClass: "wizard-table-container"
    }, [_c('div', {
      staticClass: "wizard-table-header"
    }, [_c('div', {
      staticClass: "wizard-table-settings-container"
    }, [_c('i', {
      staticClass: "material-icons cursor-pointer",
      on: {
        "click": function($event) {
          _vm.showTableSettings = !_vm.showTableSettings
        }
      }
    }, [_vm._v("more_vert")]), _vm._v(" "), (_vm.showTableSettings) ? _c('div', {
      staticClass: "wizard-table-settings-list"
    }, _vm._l((Object.entries(_vm.columns)), function(ref, index) {
      var key = ref[0];
      var value = ref[1];

      return _c('div', {
        staticClass: "wizard-table-settings-list-element"
      }, [_c('span', {
        staticStyle: {
          "width": "max-content"
        }
      }, [_vm._v(_vm._s(value.lang ? _vm.lang[value.lang] : key))]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (value.visible),
          expression: "value.visible"
        }],
        attrs: {
          "type": "checkbox",
          "disabled": value.disabled
        },
        domProps: {
          "checked": Array.isArray(value.visible) ? _vm._i(value.visible, null) > -1 : (value.visible)
        },
        on: {
          "change": [function($event) {
            var $$a = value.visible,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(value, "visible", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(value, "visible", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(value, "visible", $$c)
            }
          }, function($event) {
            _vm.applyColumnGrid(), _vm.resetFilter(key, value.visible, brand)
          }]
        }
      })])
    }), 0) : _vm._e()]), _vm._v(" "), (_vm.columns.LocationStoreId.visible) ? _c('div', {
      staticClass: "wizard-table-header-cell"
    }, [_vm._v("\n              " + _vm._s(_vm.lang.W00035) + "\n              "), _vm._v(" "), _c('svg', {
      staticClass: "wizard-table-filter-icon",
      class: {
        'filled': (_vm.filter[brand] && _vm.filter[brand].LocationStoreId && _vm.filter[brand].LocationStoreId.text)
      },
      attrs: {
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-linejoin": "round",
        "stroke-linecap": "round"
      },
      on: {
        "click": function($event) {
          return _vm.showFilter(brand, 'LocationStoreId')
        }
      }
    }, [_c('path', {
      attrs: {
        "d": "M4 6h16l-6 7v5l-4-2v-3l-6-7z"
      }
    })]), _vm._v(" "), (_vm.filter[brand] && _vm.filter[brand].LocationStoreId && _vm.filter[brand].LocationStoreId.show) ? _c('div', {
      staticClass: "wizard-table-filter"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filter[brand].LocationStoreId.text),
        expression: "filter[brand].LocationStoreId.text"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Search"
      },
      domProps: {
        "value": (_vm.filter[brand].LocationStoreId.text)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.filter[brand].LocationStoreId, "text", $event.target.value)
        }, function($event) {
          _vm.applyColumnGrid();
          _vm.$forceUpdate()
        }],
        "blur": function($event) {
          _vm.filter[brand].LocationStoreId.show = false;
          _vm.applyColumnGrid();
          _vm.$forceUpdate()
        }
      }
    })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.columns.LocationName.visible) ? _c('div', {
      staticClass: "wizard-table-header-cell"
    }, [_vm._v("\n              " + _vm._s(_vm.lang.W00051) + "\n              "), _vm._v(" "), _c('svg', {
      staticClass: "wizard-table-filter-icon",
      class: {
        'filled': (_vm.filter[brand] && _vm.filter[brand].LocationName && _vm.filter[brand].LocationName.text)
      },
      attrs: {
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-linejoin": "round",
        "stroke-linecap": "round"
      },
      on: {
        "click": function($event) {
          return _vm.showFilter(brand, 'LocationName')
        }
      }
    }, [_c('path', {
      attrs: {
        "d": "M4 6h16l-6 7v5l-4-2v-3l-6-7z"
      }
    })]), _vm._v(" "), (_vm.filter[brand] && _vm.filter[brand].LocationName && _vm.filter[brand].LocationName.show) ? _c('div', {
      staticClass: "wizard-table-filter"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filter[brand].LocationName.text),
        expression: "filter[brand].LocationName.text"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Search"
      },
      domProps: {
        "value": (_vm.filter[brand].LocationName.text)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.filter[brand].LocationName, "text", $event.target.value)
        }, function($event) {
          _vm.applyColumnGrid();
          _vm.$forceUpdate()
        }],
        "blur": function($event) {
          _vm.filter[brand].LocationName.show = false;
          _vm.applyColumnGrid();
          _vm.$forceUpdate()
        }
      }
    })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.columns.displayAddress.visible) ? _c('div', {
      staticClass: "wizard-table-header-cell"
    }, [_vm._v("\n              " + _vm._s(_vm.lang.W00052) + "\n              "), _vm._v(" "), _c('svg', {
      staticClass: "wizard-table-filter-icon",
      class: {
        'filled': (_vm.filter[brand] && _vm.filter[brand].displayAddress && _vm.filter[brand].displayAddress.text)
      },
      attrs: {
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-linejoin": "round",
        "stroke-linecap": "round"
      },
      on: {
        "click": function($event) {
          return _vm.showFilter(brand, 'displayAddress')
        }
      }
    }, [_c('path', {
      attrs: {
        "d": "M4 6h16l-6 7v5l-4-2v-3l-6-7z"
      }
    })]), _vm._v(" "), (_vm.filter[brand] && _vm.filter[brand].displayAddress && _vm.filter[brand].displayAddress.show) ? _c('div', {
      staticClass: "wizard-table-filter"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filter[brand].displayAddress.text),
        expression: "filter[brand].displayAddress.text"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Search"
      },
      domProps: {
        "value": (_vm.filter[brand].displayAddress.text)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.filter[brand].displayAddress, "text", $event.target.value)
        }, function($event) {
          _vm.applyColumnGrid();
          _vm.$forceUpdate()
        }],
        "blur": function($event) {
          _vm.filter[brand].displayAddress.show = false;
          _vm.applyColumnGrid();
          _vm.$forceUpdate()
        }
      }
    })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.columns.Brand.visible) ? _c('div', {
      staticClass: "wizard-table-header-cell"
    }, [_vm._v("\n              " + _vm._s("Brand") + "\n              "), _vm._v(" "), _c('svg', {
      staticClass: "wizard-table-filter-icon",
      class: {
        'filled': (_vm.filter[brand] && _vm.filter[brand].Brand && _vm.filter[brand].Brand.text)
      },
      attrs: {
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-linejoin": "round",
        "stroke-linecap": "round"
      },
      on: {
        "click": function($event) {
          return _vm.showFilter(brand, 'Brand')
        }
      }
    }, [_c('path', {
      attrs: {
        "d": "M4 6h16l-6 7v5l-4-2v-3l-6-7z"
      }
    })]), _vm._v(" "), (_vm.filter[brand] && _vm.filter[brand].Brand && _vm.filter[brand].Brand.show) ? _c('div', {
      staticClass: "wizard-table-filter"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filter[brand].Brand.text),
        expression: "filter[brand].Brand.text"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Search"
      },
      domProps: {
        "value": (_vm.filter[brand].Brand.text)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.filter[brand].Brand, "text", $event.target.value)
        }, function($event) {
          _vm.applyColumnGrid();
          _vm.$forceUpdate()
        }],
        "blur": function($event) {
          _vm.filter[brand].Brand.show = false;
          _vm.applyColumnGrid();
          _vm.$forceUpdate();
        }
      }
    })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.columns.Countries.visible) ? _c('div', {
      staticClass: "wizard-table-header-cell"
    }, [_vm._v("\n              " + _vm._s("Countries") + "\n              "), _vm._v(" "), _c('svg', {
      staticClass: "wizard-table-filter-icon",
      class: {
        'filled': (_vm.filter[brand] && _vm.filter[brand].Countries && _vm.filter[brand].Countries.text)
      },
      attrs: {
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-linejoin": "round",
        "stroke-linecap": "round"
      },
      on: {
        "click": function($event) {
          return _vm.showFilter(brand, 'Countries')
        }
      }
    }, [_c('path', {
      attrs: {
        "d": "M4 6h16l-6 7v5l-4-2v-3l-6-7z"
      }
    })]), _vm._v(" "), (_vm.filter[brand] && _vm.filter[brand].Countries && _vm.filter[brand].Countries.show) ? _c('div', {
      staticClass: "wizard-table-filter"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filter[brand].Countries.text),
        expression: "filter[brand].Countries.text"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Search"
      },
      domProps: {
        "value": (_vm.filter[brand].Countries.text)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.filter[brand].Countries, "text", $event.target.value)
        }, function($event) {
          _vm.applyColumnGrid();
          _vm.$forceUpdate()
        }],
        "blur": function($event) {
          _vm.filter[brand].Countries.show = false;
          _vm.applyColumnGrid();
          _vm.$forceUpdate();
        }
      }
    })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.columns.Checkanlage.visible) ? _c('div', {
      staticClass: "wizard-table-header-cell"
    }, [_vm._v("\n              " + _vm._s("Checkanlage") + "\n              "), _vm._v(" "), _c('svg', {
      staticClass: "wizard-table-filter-icon",
      class: {
        'filled': (_vm.filter[brand] && _vm.filter[brand].Checkanlage && _vm.filter[brand].Checkanlage.text)
      },
      attrs: {
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-linejoin": "round",
        "stroke-linecap": "round"
      },
      on: {
        "click": function($event) {
          return _vm.showFilter(brand, 'Checkanlage')
        }
      }
    }, [_c('path', {
      attrs: {
        "d": "M4 6h16l-6 7v5l-4-2v-3l-6-7z"
      }
    })]), _vm._v(" "), (_vm.filter[brand] && _vm.filter[brand].Checkanlage && _vm.filter[brand].Checkanlage.show) ? _c('div', {
      staticClass: "wizard-table-filter"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filter[brand].Checkanlage.text),
        expression: "filter[brand].Checkanlage.text"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Search"
      },
      domProps: {
        "value": (_vm.filter[brand].Checkanlage.text)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.filter[brand].Checkanlage, "text", $event.target.value)
        }, function($event) {
          _vm.applyColumnGrid();
          _vm.$forceUpdate()
        }],
        "blur": function($event) {
          _vm.filter[brand].Checkanlage.show = false;
          _vm.applyColumnGrid();
          _vm.$forceUpdate();
        }
      }
    })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.columns.Checkanlage2.visible) ? _c('div', {
      staticClass: "wizard-table-header-cell"
    }, [_vm._v("\n              " + _vm._s("Checkanlage2") + "\n              "), _vm._v(" "), _c('svg', {
      staticClass: "wizard-table-filter-icon",
      class: {
        'filled': (_vm.filter[brand] && _vm.filter[brand].Checkanlage2 && _vm.filter[brand].Checkanlage2.text)
      },
      attrs: {
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-linejoin": "round",
        "stroke-linecap": "round"
      },
      on: {
        "click": function($event) {
          return _vm.showFilter(brand, 'Checkanlage2')
        }
      }
    }, [_c('path', {
      attrs: {
        "d": "M4 6h16l-6 7v5l-4-2v-3l-6-7z"
      }
    })]), _vm._v(" "), (_vm.filter[brand] && _vm.filter[brand].Checkanlage2 && _vm.filter[brand].Checkanlage2.show) ? _c('div', {
      staticClass: "wizard-table-filter"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filter[brand].Checkanlage2.text),
        expression: "filter[brand].Checkanlage2.text"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Search"
      },
      domProps: {
        "value": (_vm.filter[brand].Checkanlage2.text)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.filter[brand].Checkanlage2, "text", $event.target.value)
        }, function($event) {
          _vm.applyColumnGrid();
          _vm.$forceUpdate()
        }],
        "blur": function($event) {
          _vm.filter[brand].Checkanlage2.show = false;
          _vm.applyColumnGrid();
          _vm.$forceUpdate();
        }
      }
    })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.columns.Checkanlage3.visible) ? _c('div', {
      staticClass: "wizard-table-header-cell"
    }, [_vm._v("\n              " + _vm._s("Checkanlage3") + "\n              "), _vm._v(" "), _c('svg', {
      staticClass: "wizard-table-filter-icon",
      class: {
        'filled': (_vm.filter[brand] && _vm.filter[brand].Checkanlage3 && _vm.filter[brand].Checkanlage3.text)
      },
      attrs: {
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-linejoin": "round",
        "stroke-linecap": "round"
      },
      on: {
        "click": function($event) {
          return _vm.showFilter(brand, 'Checkanlage3')
        }
      }
    }, [_c('path', {
      attrs: {
        "d": "M4 6h16l-6 7v5l-4-2v-3l-6-7z"
      }
    })]), _vm._v(" "), (_vm.filter[brand] && _vm.filter[brand].Checkanlage3 && _vm.filter[brand].Checkanlage3.show) ? _c('div', {
      staticClass: "wizard-table-filter"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filter[brand].Checkanlage3.text),
        expression: "filter[brand].Checkanlage3.text"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Search"
      },
      domProps: {
        "value": (_vm.filter[brand].Checkanlage3.text)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.filter[brand].Checkanlage3, "text", $event.target.value)
        }, function($event) {
          _vm.applyColumnGrid();
          _vm.$forceUpdate()
        }],
        "blur": function($event) {
          _vm.filter[brand].Checkanlage3.show = false;
          _vm.applyColumnGrid();
          _vm.$forceUpdate();
        }
      }
    })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "wizard-table-header-cell"
    }, [_vm._v("\n              " + _vm._s(_vm.lang.W00053) + "\n            ")])]), _vm._v(" "), _c('div', {
      staticClass: "wizard-table-body"
    }, _vm._l((_vm.getLocationsOfBrand(brand)), function(location) {
      return _c('div', {
        key: location.id,
        staticClass: "wizard-table-row"
      }, [(_vm.columns.LocationStoreId.visible) ? _c('div', {
        staticClass: "wizard-table-cell"
      }, [_vm._v(_vm._s(location.LocationStoreId))]) : _vm._e(), _vm._v(" "), (_vm.columns.LocationName.visible) ? _c('div', {
        staticClass: "wizard-table-cell"
      }, [_vm._v(_vm._s(location.LocationName))]) : _vm._e(), _vm._v(" "), (_vm.columns.displayAddress.visible) ? _c('div', {
        staticClass: "wizard-table-cell"
      }, [_vm._v(_vm._s(location.displayAddress))]) : _vm._e(), _vm._v(" "), (_vm.columns.Brand.visible) ? _c('div', {
        staticClass: "wizard-table-cell"
      }, [_vm._v(_vm._s(location.Brand))]) : _vm._e(), _vm._v(" "), (_vm.columns.Countries.visible) ? _c('div', {
        staticClass: "wizard-table-cell"
      }, [_vm._v(_vm._s(location.Countries))]) : _vm._e(), _vm._v(" "), (_vm.columns.Checkanlage.visible) ? _c('div', {
        staticClass: "wizard-table-cell"
      }, [_vm._v(_vm._s(location.Checkanlage))]) : _vm._e(), _vm._v(" "), (_vm.columns.Checkanlage2.visible) ? _c('div', {
        staticClass: "wizard-table-cell"
      }, [_vm._v(_vm._s(location.Checkanlage2))]) : _vm._e(), _vm._v(" "), (_vm.columns.Checkanlage3.visible) ? _c('div', {
        staticClass: "wizard-table-cell"
      }, [_vm._v(_vm._s(location.Checkanlage3))]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "wizard-table-cell"
      }, _vm._l((_vm.localFormData.scenarios), function(scenario) {
        return _c('div', {
          staticClass: "scenario-input"
        }, [_c('span', [_vm._v(_vm._s(scenario.ScenarioName))]), _vm._v(" "), _c('input', {
          staticClass: "wizard-input",
          attrs: {
            "type": "number",
            "min": 0,
            "step": 1,
            "disabled": _vm.readonly
          },
          domProps: {
            "value": _vm.getNumberOfVisits(location.LocationId, scenario.ScenarioId)
          },
          on: {
            "change": function($event) {
              return _vm.setNumberOfVisits(location.LocationId, scenario.ScenarioId, $event)
            }
          }
        })])
      }), 0)])
    }), 0)]), _vm._v(" "), _vm._l((_vm.brandVisits), function(bv) {
      return (bv.brand == brand) ? _c('div', {
        staticClass: "brand-computed-data"
      }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.lang.W00072) + " " + _vm._s(bv.checkCount))])]), _vm._v(" "), _c('span', [_c('b', [_vm._v(_vm._s(_vm.lang.W00073) + " " + _vm._s(bv.locationsWithChecksCount))])]), _vm._v(" "), _vm._l((bv.scenarios), function(scenario) {
        return _c('span', [_c('b', [_vm._v(_vm._s(scenario.scenarioName) + ": " + _vm._s(scenario.checkCount))])])
      })], 2) : _vm._e()
    })], 2)
  }), 0)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1740 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step-container"
  }, [_c('StepHeader', {
    attrs: {
      "currentStep": _vm.currentStep,
      "steps": _vm.steps
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [(_vm.masterSurvey && _vm.masterSurvey.Survey && _vm.masterSurvey.Survey.pages) ? _c('div', {
    staticClass: "wizard-survey"
  }, [_c('div', {
    staticClass: "wizard-survey-panel-locale-header"
  }, [_c('div', {
    staticStyle: {
      "width": "50%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.W00081))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "50%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.W00082))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedLocaleCode),
      expression: "selectedLocaleCode"
    }],
    staticClass: "wizard-survey-locale-code-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedLocaleCode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v(_vm._s(_vm.lang.W00083))]), _vm._v(" "), _vm._l((_vm.surveyLocales), function(value) {
    return _c('option', {
      key: value.LocaleCode,
      domProps: {
        "value": value.LocaleCode
      }
    }, [_vm._v("\n              " + _vm._s(value.LocaleName) + "\n            ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "wizard-survey-panel-header"
  }, [_c('div', {
    staticClass: "wizard-survey-panel-header-btn",
    on: {
      "click": function($event) {
        return _vm.moveHeader('l')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("chevron_left")])]), _vm._v(" "), _c('div', {
    staticClass: "wizard-survey-panel-header-elements-container",
    on: {
      "wheel": function($event) {
        $event.preventDefault();
        return _vm.scrollHeader($event)
      }
    }
  }, [_c('div', {
    ref: "wizard-survey-panel-header-elements",
    staticClass: "wizard-survey-panel-header-elements"
  }, [_vm._l((_vm.masterSurvey.Survey.pages), function(page) {
    return _vm._l((page.elements), function(cluster) {
      return _c('div', {
        key: ("pagination-" + (cluster.guid.toUpperCase())),
        staticClass: "wizard-survey-panel-header-element",
        class: {
          active: _vm.activeCluster == cluster
        },
        on: {
          "click": function($event) {
            _vm.activeCluster = cluster
          }
        }
      }, [_c('span', [_vm._v(_vm._s(cluster.title))]), _vm._v(" "), (_vm.scenarioQuestionSettings_Visible[cluster.guid.toUpperCase()] || _vm.scenarioQuestionSettings_NotVisible[cluster.guid.toUpperCase()]) ? _c('span', {
        staticClass: "scenario-question-settings-container"
      }, [_c('i', {
        staticClass: "material-icons"
      }, [_vm._v("visibility")])]) : _vm._e()])
    })
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "wizard-survey-panel-header-btn",
    on: {
      "click": function($event) {
        return _vm.moveHeader('r')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("chevron_right")])])]), _vm._v(" "), _c('div', {
    staticClass: "wizard-survey-panel-sub-header",
    staticStyle: {
      "justify-content": "flex-start",
      "padding-left": "5px",
      "min-height": "5px"
    }
  }, [(_vm.activeCluster && (_vm.scenarioQuestionSettings_Visible[_vm.activeCluster.guid.toUpperCase()] || _vm.scenarioQuestionSettings_NotVisible[_vm.activeCluster.guid.toUpperCase()])) ? _c('div', {
    staticClass: "wizard-survey-row"
  }, [(_vm.scenarioQuestionSettings_Visible[_vm.activeCluster.guid.toUpperCase()] && _vm.scenarioQuestionSettings_Visible[_vm.activeCluster.guid.toUpperCase()].Scenarios) ? _c('div', [_c('span', [_vm._v(_vm._s(_vm.lang.W00087))]), _vm._v(" "), (
    _vm.scenarioQuestionSettings_Visible[_vm.activeCluster.guid.toUpperCase()].Scenarios &&
    _vm.scenarioQuestionSettings_Visible[_vm.activeCluster.guid.toUpperCase()].Scenarios.length == 0 &&
    _vm.scenarioQuestionSettings_Visible[_vm.activeCluster.guid.toUpperCase()].ScenariosNotInConfig &&
    _vm.scenarioQuestionSettings_Visible[_vm.activeCluster.guid.toUpperCase()].ScenariosNotInConfig.length != 0
  ) ? _c('span', [_vm._v(_vm._s(_vm.lang.W00098) + " " + _vm._s(_vm.lang.W00099))]) : _vm._l((_vm.scenarioQuestionSettings_Visible[_vm.activeCluster.guid.toUpperCase()].Scenarios), function(scenario, index) {
    return _c('span', [(index) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v("\n              " + _vm._s(scenario) + "\n            ")])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.scenarioQuestionSettings_NotVisible[_vm.activeCluster.guid.toUpperCase()] && _vm.scenarioQuestionSettings_NotVisible[_vm.activeCluster.guid.toUpperCase()].Scenarios) ? _c('div', [_c('span', [_vm._v(_vm._s(_vm.lang.W00088))]), _vm._v(" "), (
    _vm.scenarioQuestionSettings_NotVisible[_vm.activeCluster.guid.toUpperCase()].Scenarios &&
    _vm.scenarioQuestionSettings_NotVisible[_vm.activeCluster.guid.toUpperCase()].Scenarios.length == 0 &&
    _vm.scenarioQuestionSettings_NotVisible[_vm.activeCluster.guid.toUpperCase()].ScenariosNotInConfig &&
    _vm.scenarioQuestionSettings_NotVisible[_vm.activeCluster.guid.toUpperCase()].ScenariosNotInConfig.length != 0
  ) ? _c('span', [_vm._v(_vm._s(_vm.lang.W00098) + " " + _vm._s(_vm.lang.W00100))]) : _vm._l((_vm.scenarioQuestionSettings_NotVisible[_vm.activeCluster.guid.toUpperCase()].Scenarios), function(scenario, index) {
    return _c('span', [(index) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v("\n              " + _vm._s(scenario) + "\n            ")])
  })], 2) : _vm._e()]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.masterSurvey.Survey.pages), function(page) {
    return _c('div', {
      key: page.guid
    }, _vm._l((page.elements), function(cluster) {
      return _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.activeCluster.guid.toUpperCase() == cluster.guid.toUpperCase()),
          expression: "activeCluster.guid.toUpperCase() == cluster.guid.toUpperCase()"
        }]
      }, [_c('div', {
        key: cluster.guid,
        staticClass: "wizard-survey-panel-sub-header"
      }, [_c('div', {
        staticClass: "wizard-survey-row-half"
      }, [_c('div', {
        staticClass: "wizard-survey-panel-title"
      }, [_c('b', [_c('span', {
        ref: "wizard-survey-contenteditable",
        refInFor: true,
        staticClass: "wizard-survey-contenteditable text-bold",
        attrs: {
          "contenteditable": false,
          "data-questionguid": cluster.guid.toUpperCase(),
          "data-key": 'Title',
          "data-fallbacktext": cluster.title
        }
      })])])]), _vm._v(" "), _c('div', {
        staticClass: "wizard-survey-row-half"
      }, [_c('input', {
        ref: "wizard-survey-translation-input",
        refInFor: true,
        staticClass: "wizard-survey-translation-input",
        attrs: {
          "type": "text",
          "data-translationguid": cluster.guid.toUpperCase(),
          "data-translationkey": 'title',
          "data-category": 'question',
          "disabled": true
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "wizard-survey-panel-sub-header",
        staticStyle: {
          "padding-bottom": "5px",
          "border-bottom": "2px solid #e0e0e0"
        }
      }, [_c('div', {
        staticClass: "wizard-survey-row-half"
      }, [_c('div', {
        staticStyle: {
          "width": "5px"
        }
      }), _vm._v(" "), _c('span', {
        ref: "wizard-survey-contenteditable",
        refInFor: true,
        staticClass: "wizard-survey-contenteditable",
        class: {
          'placeholder-active': !cluster.description && !(_vm.questionsByGuid[cluster.guid.toUpperCase()] && _vm.questionsByGuid[cluster.guid.toUpperCase()].Description)
        },
        attrs: {
          "contenteditable": false,
          "data-questionguid": cluster.guid.toUpperCase(),
          "data-key": 'Description',
          "data-fallbacktext": cluster.description ? cluster.description : _vm.lang.W00085,
          "data-placeholder": (cluster.description || (_vm.questionsByGuid[cluster.guid.toUpperCase()] && _vm.questionsByGuid[cluster.guid.toUpperCase()].Description)) ? false : true
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "wizard-survey-row-half"
      }, [_c('input', {
        ref: "wizard-survey-translation-input",
        refInFor: true,
        staticClass: "wizard-survey-translation-input",
        attrs: {
          "type": "text",
          "data-translationguid": cluster.guid.toUpperCase(),
          "data-translationkey": 'description',
          "data-category": 'question',
          "disabled": true
        }
      })])]), _vm._v(" "), _vm._l((cluster.elements), function(element1) {
        return [(element1.type == 'panel') ? _c('div', {
          staticClass: "wizard-survey-panel"
        }, [_c('div', {
          staticClass: "wizard-survey-row"
        }, [_c('div', {
          staticClass: "wizard-survey-row-half"
        }, [_c('div', {
          staticClass: "wizard-survey-panel-title"
        }, [_c('b', [_c('span', {
          ref: "wizard-survey-contenteditable",
          refInFor: true,
          staticClass: "wizard-survey-contenteditable text-bold",
          attrs: {
            "contenteditable": !_vm.readonly,
            "data-questionguid": element1.guid.toUpperCase(),
            "data-key": 'Title',
            "data-fallbacktext": element1.title
          },
          on: {
            "input": function($event) {
              _vm.setConfigurationQuestion(element1.guid.toUpperCase(), 'Title', $event.target.textContent, $event.target)
            }
          }
        })]), _vm._v(" "), (_vm.scenarioQuestionSettings_Visible[element1.guid.toUpperCase()] || _vm.scenarioQuestionSettings_NotVisible[element1.guid.toUpperCase()]) ? _c('span', {
          staticClass: "scenario-question-settings-container"
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("visibility")]), _vm._v(" "), _c('div', {
          staticClass: "scenario-question-settings-popup"
        }, [(_vm.scenarioQuestionSettings_Visible[element1.guid.toUpperCase()] && _vm.scenarioQuestionSettings_Visible[element1.guid.toUpperCase()].Scenarios) ? _c('div', [_c('span', [_vm._v(_vm._s(_vm.lang.W00087))]), _vm._v(" "), (
          _vm.scenarioQuestionSettings_Visible[element1.guid.toUpperCase()].Scenarios &&
          _vm.scenarioQuestionSettings_Visible[element1.guid.toUpperCase()].Scenarios.length == 0 &&
          _vm.scenarioQuestionSettings_Visible[element1.guid.toUpperCase()].ScenariosNotInConfig &&
          _vm.scenarioQuestionSettings_Visible[element1.guid.toUpperCase()].ScenariosNotInConfig.length != 0
        ) ? _c('span', [_vm._v("\n                            " + _vm._s(_vm.lang.W00098) + " " + _vm._s(_vm.lang.W00099) + "\n                          ")]) : _vm._l((_vm.scenarioQuestionSettings_Visible[element1.guid.toUpperCase()].Scenarios), function(scenario, index) {
          return _c('span', [(index) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v("\n                            " + _vm._s(scenario) + "\n                          ")])
        })], 2) : _vm._e(), _vm._v(" "), (_vm.scenarioQuestionSettings_NotVisible[element1.guid.toUpperCase()] && _vm.scenarioQuestionSettings_NotVisible[element1.guid.toUpperCase()].Scenarios) ? _c('div', [_c('span', [_vm._v(_vm._s(_vm.lang.W00088))]), _vm._v(" "), (
          _vm.scenarioQuestionSettings_NotVisible[element1.guid.toUpperCase()].Scenarios &&
          _vm.scenarioQuestionSettings_NotVisible[element1.guid.toUpperCase()].Scenarios.length == 0 &&
          _vm.scenarioQuestionSettings_NotVisible[element1.guid.toUpperCase()].ScenariosNotInConfig &&
          _vm.scenarioQuestionSettings_NotVisible[element1.guid.toUpperCase()].ScenariosNotInConfig.length != 0
        ) ? _c('span', [_vm._v("\n                            " + _vm._s(_vm.lang.W00098) + " " + _vm._s(_vm.lang.W00100) + "\n                          ")]) : _vm._l((_vm.scenarioQuestionSettings_NotVisible[element1.guid.toUpperCase()].Scenarios), function(scenario, index) {
          return _c('span', [(index) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v("\n                            " + _vm._s(scenario) + "\n                          ")])
        })], 2) : _vm._e()])]) : _vm._e()])]), _vm._v(" "), _c('div', {
          staticClass: "wizard-survey-row-half"
        }, [_c('input', {
          ref: "wizard-survey-translation-input",
          refInFor: true,
          staticClass: "wizard-survey-translation-input",
          attrs: {
            "type": "text",
            "data-translationguid": element1.guid.toUpperCase(),
            "data-translationkey": 'title',
            "data-category": 'question',
            "disabled": _vm.readonly || !_vm.selectedLocaleCode
          },
          on: {
            "input": function($event) {
              _vm.setConfigurationQuestionTranslation(element1.guid.toUpperCase(), 'TranslationTitle', $event.target.value, $event.target)
            }
          }
        })])]), _vm._v(" "), _c('div', {
          staticClass: "wizard-survey-row"
        }, [_c('div', {
          staticClass: "wizard-survey-row-half"
        }, [_c('div', {
          staticStyle: {
            "width": "5px"
          }
        }), _vm._v(" "), _c('span', {
          ref: "wizard-survey-contenteditable",
          refInFor: true,
          staticClass: "wizard-survey-contenteditable",
          class: {
            'placeholder-active': !element1.description && !(_vm.questionsByGuid[element1.guid.toUpperCase()] && _vm.questionsByGuid[element1.guid.toUpperCase()].Description)
          },
          attrs: {
            "contenteditable": !_vm.readonly,
            "data-questionguid": element1.guid.toUpperCase(),
            "data-key": 'Description',
            "data-fallbacktext": element1.description ? element1.description : _vm.lang.W00085,
            "data-placeholder": (element1.description || (_vm.questionsByGuid[element1.guid.toUpperCase()] && _vm.questionsByGuid[element1.guid.toUpperCase()].Description)) ? false : true
          },
          on: {
            "click": function($event) {
              return _vm.removePlaceholder($event.target)
            },
            "input": function($event) {
              _vm.setConfigurationQuestion(element1.guid.toUpperCase(), 'Description', $event.target.textContent, $event.target)
            }
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "wizard-survey-row-half"
        }, [_c('input', {
          ref: "wizard-survey-translation-input",
          refInFor: true,
          staticClass: "wizard-survey-translation-input",
          attrs: {
            "type": "text",
            "data-translationguid": element1.guid.toUpperCase(),
            "data-translationkey": 'description',
            "data-category": 'question',
            "disabled": _vm.readonly || !_vm.selectedLocaleCode
          },
          on: {
            "input": function($event) {
              _vm.setConfigurationQuestionTranslation(element1.guid.toUpperCase(), 'TranslationDescription', $event.target.value, $event.target)
            }
          }
        })])]), _vm._v(" "), _vm._l((element1.elements), function(element2) {
          return _c('div', {
            staticClass: "wizard-survey-question"
          }, [(_vm.debug) ? _c('span', [_vm._v(_vm._s(element2.guid.toUpperCase()))]) : _vm._e(), _vm._v(" "), _c('div', {
            staticClass: "wizard-survey-row"
          }, [_c('div', {
            staticClass: "wizard-survey-row-half"
          }, [_c('input', {
            key: ("wizard-survey-input-" + (element2.guid.toUpperCase()) + "-IsSelected"),
            staticClass: "wizard-survey-input-isSelected",
            attrs: {
              "type": "checkbox",
              "disabled": _vm.readonly
            },
            domProps: {
              "checked": (_vm.questionsByGuid[element2.guid.toUpperCase()]) ? _vm.questionsByGuid[element2.guid.toUpperCase()].IsSelected : true
            },
            on: {
              "change": function($event) {
                _vm.setConfigurationQuestion(element2.guid.toUpperCase(), 'IsSelected', $event.target.checked, $event.target)
              }
            }
          }), _vm._v(" "), _c('span', {
            staticClass: "wizard-survey-question-title"
          }, [_c('span', {
            staticClass: "text-bold"
          }, [_vm._v(_vm._s(element2.customQuestionNumber))]), _vm._v(" "), _c('span', {
            ref: "wizard-survey-contenteditable",
            refInFor: true,
            staticClass: "wizard-survey-contenteditable text-bold",
            attrs: {
              "contenteditable": !_vm.readonly,
              "data-questionguid": element2.guid.toUpperCase(),
              "data-key": 'Title',
              "data-fallbacktext": element2.title
            },
            on: {
              "input": function($event) {
                _vm.setConfigurationQuestion(element2.guid.toUpperCase(), 'Title', $event.target.textContent, $event.target)
              }
            }
          }), _vm._v(" "), _c('span', {
            staticClass: "text-bold"
          }, [_vm._v(_vm._s(element2.isRequired ? '*' : ''))]), _vm._v(" "), _c('em', [_vm._v("(" + _vm._s(element2.type) + ")")]), _vm._v(" "), _c('span', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (false),
              expression: "false"
            }]
          }, [_vm._v(_vm._s(element2.guid.toUpperCase()))])]), _vm._v(" "), (_vm.scenarioQuestionSettings_Visible[element2.guid.toUpperCase()] || _vm.scenarioQuestionSettings_NotVisible[element2.guid.toUpperCase()]) ? _c('span', {
            staticClass: "scenario-question-settings-container"
          }, [_c('i', {
            staticClass: "material-icons"
          }, [_vm._v("visibility")]), _vm._v(" "), _c('div', {
            staticClass: "scenario-question-settings-popup"
          }, [(_vm.scenarioQuestionSettings_Visible[element2.guid.toUpperCase()] && _vm.scenarioQuestionSettings_Visible[element2.guid.toUpperCase()].Scenarios) ? _c('div', [_c('span', [_vm._v(_vm._s(_vm.lang.W00087))]), _vm._v(" "), (
            _vm.scenarioQuestionSettings_Visible[element2.guid.toUpperCase()].Scenarios &&
            _vm.scenarioQuestionSettings_Visible[element2.guid.toUpperCase()].Scenarios.length == 0 &&
            _vm.scenarioQuestionSettings_Visible[element2.guid.toUpperCase()].ScenariosNotInConfig &&
            _vm.scenarioQuestionSettings_Visible[element2.guid.toUpperCase()].ScenariosNotInConfig.length != 0
          ) ? _c('span', [_vm._v(_vm._s(_vm.lang.W00098) + " " + _vm._s(_vm.lang.W00099))]) : _vm._l((_vm.scenarioQuestionSettings_Visible[element2.guid.toUpperCase()].Scenarios), function(scenario, index) {
            return _c('span', [(index) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v("\n                            " + _vm._s(scenario) + "\n                          ")])
          })], 2) : _vm._e(), _vm._v(" "), (_vm.scenarioQuestionSettings_NotVisible[element2.guid.toUpperCase()] && _vm.scenarioQuestionSettings_NotVisible[element2.guid.toUpperCase()].Scenarios) ? _c('div', [_c('span', [_vm._v(_vm._s(_vm.lang.W00088))]), _vm._v(" "), (
            _vm.scenarioQuestionSettings_NotVisible[element2.guid.toUpperCase()].Scenarios &&
            _vm.scenarioQuestionSettings_NotVisible[element2.guid.toUpperCase()].Scenarios.length == 0 &&
            _vm.scenarioQuestionSettings_NotVisible[element2.guid.toUpperCase()].ScenariosNotInConfig &&
            _vm.scenarioQuestionSettings_NotVisible[element2.guid.toUpperCase()].ScenariosNotInConfig.length != 0
          ) ? _c('span', [_vm._v(_vm._s(_vm.lang.W00098) + " " + _vm._s(_vm.lang.W00100))]) : _vm._l((_vm.scenarioQuestionSettings_NotVisible[element2.guid.toUpperCase()].Scenarios), function(scenario, index) {
            return _c('span', [(index) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v("\n                            " + _vm._s(scenario) + "\n                          ")])
          })], 2) : _vm._e()])]) : _vm._e(), _vm._v(" "), (element2.type == 'checkbox') ? _c('span', {
            staticClass: "span-max-points"
          }, [_vm._v("\n                      " + _vm._s(_vm.lang.W00084) + "\n                      "), _c('span', {
            ref: "wizard-survey-contenteditable",
            refInFor: true,
            staticClass: "wizard-survey-contenteditable",
            attrs: {
              "contenteditable": !_vm.readonly,
              "data-questionguid": element2.guid.toUpperCase(),
              "data-key": 'PointsMax',
              "data-fallbacktext": element2.pointsMax ? element2.pointsMax : 0
            },
            on: {
              "input": function($event) {
                _vm.setConfigurationQuestion(element2.guid.toUpperCase(), 'PointsMax', $event.target.textContent, $event.target, 'number')
              }
            }
          })]) : _vm._e()]), _vm._v(" "), _c('div', {
            staticClass: "wizard-survey-row-half"
          }, [_c('input', {
            ref: "wizard-survey-translation-input",
            refInFor: true,
            staticClass: "wizard-survey-translation-input",
            attrs: {
              "type": "text",
              "data-translationguid": element2.guid.toUpperCase(),
              "data-translationkey": 'title',
              "data-category": 'question',
              "disabled": _vm.readonly || !_vm.selectedLocaleCode
            },
            on: {
              "input": function($event) {
                _vm.setConfigurationQuestionTranslation(element2.guid.toUpperCase(), 'TranslationTitle', $event.target.value, $event.target)
              }
            }
          })])]), _vm._v(" "), _c('div', {
            staticClass: "wizard-survey-row"
          }, [_c('div', {
            staticClass: "wizard-survey-row-half"
          }, [_c('div', {
            staticClass: "wizard-survey-spacer"
          }), _vm._v(" "), _c('span', {
            ref: "wizard-survey-contenteditable",
            refInFor: true,
            staticClass: "wizard-survey-contenteditable",
            class: {
              'placeholder-active': !element2.description && !(_vm.questionsByGuid[element2.guid.toUpperCase()] && _vm.questionsByGuid[element2.guid.toUpperCase()].Description)
            },
            attrs: {
              "contenteditable": !_vm.readonly,
              "data-questionguid": element2.guid.toUpperCase(),
              "data-key": 'Description',
              "data-fallbacktext": element2.description ? element2.description : _vm.lang.W00085,
              "data-placeholder": (element2.description || (_vm.questionsByGuid[element2.guid.toUpperCase()] && _vm.questionsByGuid[element2.guid.toUpperCase()].Description)) ? false : true
            },
            on: {
              "click": function($event) {
                return _vm.removePlaceholder($event.target)
              },
              "input": function($event) {
                _vm.setConfigurationQuestion(element2.guid.toUpperCase(), 'Description', $event.target.textContent, $event.target)
              }
            }
          })]), _vm._v(" "), _c('div', {
            staticClass: "wizard-survey-row-half"
          }, [_c('input', {
            ref: "wizard-survey-translation-input",
            refInFor: true,
            staticClass: "wizard-survey-translation-input",
            attrs: {
              "type": "text",
              "data-translationguid": element2.guid.toUpperCase(),
              "data-translationkey": 'description',
              "data-category": 'question',
              "disabled": _vm.readonly || !_vm.selectedLocaleCode
            },
            on: {
              "input": function($event) {
                _vm.setConfigurationQuestionTranslation(element2.guid.toUpperCase(), 'TranslationDescription', $event.target.value, $event.target)
              }
            }
          })])]), _vm._v(" "), _vm._l((element2.choices), function(c) {
            return (element2.choices) ? _c('div', {
              staticClass: "wizard-survey-row"
            }, [_c('div', {
              staticClass: "wizard-survey-row-half"
            }, [_c('div', {
              staticClass: "wizard-survey-spacer"
            }), _vm._v(" "), (element2.type == 'radiogroup') ? _c('input', {
              staticStyle: {
                "cursor": "default",
                "margin": "0px"
              },
              attrs: {
                "type": "radio",
                "name": "",
                "id": "",
                "disabled": ""
              }
            }) : _vm._e(), _vm._v(" "), (element2.type == 'checkbox') ? _c('input', {
              staticStyle: {
                "cursor": "default",
                "margin": "0px"
              },
              attrs: {
                "type": "checkbox",
                "name": "",
                "id": "",
                "disabled": ""
              }
            }) : _vm._e(), _vm._v(" "), _c('div', {
              staticStyle: {
                "text-align": "justify",
                "max-width": "80%"
              }
            }, [_c('span', {
              ref: "wizard-survey-contenteditable",
              refInFor: true,
              staticClass: "wizard-survey-contenteditable",
              attrs: {
                "contenteditable": !_vm.readonly,
                "data-choiceguid": c.guid.toUpperCase(),
                "data-key": 'Title',
                "data-fallbacktext": c.text
              },
              on: {
                "input": function($event) {
                  _vm.setConfigurationQuestionChoice(c.guid.toUpperCase(), 'Title', $event.target.textContent, $event.target)
                }
              }
            })]), _vm._v(" "), (element2.type == 'radiogroup') ? _c('span', {
              staticClass: "wizard-survey-points-container"
            }, [_vm._v("\n                      (\n                      "), _c('span', {
              ref: "wizard-survey-contenteditable",
              refInFor: true,
              staticClass: "wizard-survey-contenteditable",
              attrs: {
                "contenteditable": !_vm.readonly,
                "data-choiceguid": c.guid.toUpperCase(),
                "data-key": 'Points',
                "data-fallbacktext": c.points ? c.points : 0
              },
              on: {
                "input": function($event) {
                  _vm.setConfigurationQuestionChoice(c.guid.toUpperCase(), 'Points', $event.target.textContent, $event.target, 'number')
                }
              }
            }), _vm._v("\n                      /\n                      "), _c('span', {
              ref: "wizard-survey-contenteditable",
              refInFor: true,
              staticClass: "wizard-survey-contenteditable text-center",
              attrs: {
                "contenteditable": !_vm.readonly,
                "data-choiceguid": c.guid.toUpperCase(),
                "data-key": 'PointsMax',
                "data-fallbacktext": element2.pointsMax ? element2.pointsMax : 0
              },
              on: {
                "input": function($event) {
                  _vm.setConfigurationQuestionChoice(c.guid.toUpperCase(), 'PointsMax', $event.target.textContent, $event.target, 'number')
                }
              }
            }), _vm._v("\n                      )\n                    ")]) : _vm._e(), _vm._v(" "), (element2.type == 'checkbox') ? _c('span', {
              staticClass: "wizard-survey-points-container"
            }, [_vm._v("\n                      (\n                      "), _c('span', {
              ref: "wizard-survey-contenteditable",
              refInFor: true,
              staticClass: "wizard-survey-contenteditable",
              attrs: {
                "contenteditable": !_vm.readonly,
                "data-choiceguid": c.guid.toUpperCase(),
                "data-key": 'Points',
                "data-fallbacktext": c.points ? c.points : 0
              },
              on: {
                "input": function($event) {
                  _vm.setConfigurationQuestionChoice(c.guid.toUpperCase(), 'Points', $event.target.textContent, $event.target, 'number')
                }
              }
            }), _vm._v("\n                      )\n                    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
              staticClass: "wizard-survey-row-half"
            }, [_c('input', {
              ref: "wizard-survey-translation-input",
              refInFor: true,
              staticClass: "wizard-survey-translation-input",
              attrs: {
                "type": "text",
                "data-translationguid": c.guid.toUpperCase(),
                "data-translationkey": 'text',
                "data-category": 'choice',
                "disabled": _vm.readonly || !_vm.selectedLocaleCode
              },
              on: {
                "input": function($event) {
                  _vm.setConfigurationQuestionChoiceTranslation(c.guid.toUpperCase(), 'Translation', $event.target.value, $event.target)
                }
              }
            })])]) : _vm._e()
          }), _vm._v(" "), _c('div', {
            staticClass: "wizard-survey-row"
          }, [_c('textarea', {
            attrs: {
              "rows": "1",
              "placeholder": _vm.lang.W00086,
              "disabled": _vm.readonly
            },
            on: {
              "change": function($event) {
                _vm.setConfigurationQuestion(element2.guid.toUpperCase(), 'Comment', $event.target.value, $event.target)
              }
            }
          }, [_vm._v(_vm._s(_vm.getComment(element2.guid.toUpperCase())))])])], 2)
        })], 2) : _c('div', {
          staticClass: "wizard-survey-question"
        }, [(_vm.debug) ? _c('span', [_vm._v(_vm._s(element1.guid.toUpperCase()))]) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "wizard-survey-row"
        }, [_c('div', {
          staticClass: "wizard-survey-row-half"
        }, [_c('input', {
          key: ("wizard-survey-input-" + (element1.guid.toUpperCase()) + "-IsSelected"),
          staticClass: "wizard-survey-input-isSelected",
          attrs: {
            "type": "checkbox",
            "disabled": _vm.readonly
          },
          domProps: {
            "checked": (_vm.questionsByGuid[element1.guid.toUpperCase()]) ? _vm.questionsByGuid[element1.guid.toUpperCase()].IsSelected : true
          },
          on: {
            "change": function($event) {
              _vm.setConfigurationQuestion(element1.guid.toUpperCase(), 'IsSelected', $event.target.checked, $event.target)
            }
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "wizard-survey-question-title"
        }, [_c('span', {
          staticClass: "text-bold"
        }, [_vm._v(_vm._s(element1.customQuestionNumber))]), _vm._v(" "), _c('span', {
          ref: "wizard-survey-contenteditable",
          refInFor: true,
          staticClass: "wizard-survey-contenteditable text-bold",
          attrs: {
            "contenteditable": !_vm.readonly,
            "data-questionguid": element1.guid.toUpperCase(),
            "data-key": 'Title',
            "data-fallbacktext": element1.title
          },
          on: {
            "input": function($event) {
              _vm.setConfigurationQuestion(element1.guid.toUpperCase(), 'Title', $event.target.textContent, $event.target)
            }
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "text-bold"
        }, [_vm._v(_vm._s(element1.isRequired ? '*' : ''))]), _vm._v(" "), _c('em', [_vm._v("(" + _vm._s(element1.type) + ")")]), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (false),
            expression: "false"
          }]
        }, [_vm._v(_vm._s(element1.guid.toUpperCase()))])]), _vm._v(" "), (_vm.scenarioQuestionSettings_Visible[element1.guid.toUpperCase()] || _vm.scenarioQuestionSettings_NotVisible[element1.guid.toUpperCase()]) ? _c('span', {
          staticClass: "scenario-question-settings-container"
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("visibility")]), _vm._v(" "), _c('div', {
          staticClass: "scenario-question-settings-popup"
        }, [(_vm.scenarioQuestionSettings_Visible[element1.guid.toUpperCase()] && _vm.scenarioQuestionSettings_Visible[element1.guid.toUpperCase()].Scenarios) ? _c('div', [_c('span', [_vm._v(_vm._s(_vm.lang.W00087))]), _vm._v(" "), (
          _vm.scenarioQuestionSettings_Visible[element1.guid.toUpperCase()].Scenarios &&
          _vm.scenarioQuestionSettings_Visible[element1.guid.toUpperCase()].Scenarios.length == 0 &&
          _vm.scenarioQuestionSettings_Visible[element1.guid.toUpperCase()].ScenariosNotInConfig &&
          _vm.scenarioQuestionSettings_Visible[element1.guid.toUpperCase()].ScenariosNotInConfig.length != 0
        ) ? _c('span', [_vm._v(_vm._s(_vm.lang.W00098) + " " + _vm._s(_vm.lang.W00099))]) : _vm._l((_vm.scenarioQuestionSettings_Visible[element1.guid.toUpperCase()].Scenarios), function(scenario, index) {
          return _c('span', [(index) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v("\n                          " + _vm._s(scenario) + "\n                        ")])
        })], 2) : _vm._e(), _vm._v(" "), (_vm.scenarioQuestionSettings_NotVisible[element1.guid.toUpperCase()] && _vm.scenarioQuestionSettings_NotVisible[element1.guid.toUpperCase()].Scenarios) ? _c('div', [_c('span', [_vm._v(_vm._s(_vm.lang.W00088))]), _vm._v(" "), (
          _vm.scenarioQuestionSettings_NotVisible[element1.guid.toUpperCase()].Scenarios &&
          _vm.scenarioQuestionSettings_NotVisible[element1.guid.toUpperCase()].Scenarios.length == 0 &&
          _vm.scenarioQuestionSettings_NotVisible[element1.guid.toUpperCase()].ScenariosNotInConfig &&
          _vm.scenarioQuestionSettings_NotVisible[element1.guid.toUpperCase()].ScenariosNotInConfig.length != 0
        ) ? _c('span', [_vm._v(_vm._s(_vm.lang.W00098) + " " + _vm._s(_vm.lang.W00100))]) : _vm._l((_vm.scenarioQuestionSettings_NotVisible[element1.guid.toUpperCase()].Scenarios), function(scenario, index) {
          return _c('span', [(index) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v("\n                          " + _vm._s(scenario) + "\n                        ")])
        })], 2) : _vm._e()])]) : _vm._e(), _vm._v(" "), (element1.type == 'checkbox') ? _c('span', {
          staticClass: "span-max-points"
        }, [_vm._v("\n                    " + _vm._s(_vm.lang.W00084) + "\n                    "), _c('span', {
          ref: "wizard-survey-contenteditable",
          refInFor: true,
          staticClass: "wizard-survey-contenteditable",
          attrs: {
            "contenteditable": !_vm.readonly,
            "data-questionguid": element1.guid.toUpperCase(),
            "data-key": 'PointsMax',
            "data-fallbacktext": element1.pointsMax ? element1.pointsMax : 0
          },
          on: {
            "input": function($event) {
              _vm.setConfigurationQuestion(element1.guid.toUpperCase(), 'PointsMax', $event.target.textContent, $event.target, 'number')
            }
          }
        })]) : _vm._e()]), _vm._v(" "), _c('div', {
          staticClass: "wizard-survey-row-half"
        }, [_c('input', {
          ref: "wizard-survey-translation-input",
          refInFor: true,
          staticClass: "wizard-survey-translation-input",
          attrs: {
            "type": "text",
            "data-translationguid": element1.guid.toUpperCase(),
            "data-translationkey": 'title',
            "data-category": 'question',
            "disabled": _vm.readonly || !_vm.selectedLocaleCode
          },
          on: {
            "input": function($event) {
              _vm.setConfigurationQuestionTranslation(element1.guid.toUpperCase(), 'TranslationTitle', $event.target.value, $event.target)
            }
          }
        })])]), _vm._v(" "), _c('div', {
          staticClass: "wizard-survey-row"
        }, [_c('div', {
          staticClass: "wizard-survey-row-half"
        }, [_c('div', {
          staticClass: "wizard-survey-spacer"
        }), _vm._v(" "), _c('span', {
          ref: "wizard-survey-contenteditable",
          refInFor: true,
          staticClass: "wizard-survey-contenteditable",
          class: {
            'placeholder-active': !element1.description && !(_vm.questionsByGuid[element1.guid.toUpperCase()] && _vm.questionsByGuid[element1.guid.toUpperCase()].Description)
          },
          attrs: {
            "contenteditable": !_vm.readonly,
            "data-questionguid": element1.guid.toUpperCase(),
            "data-key": 'Description',
            "data-fallbacktext": element1.description ? element1.description : _vm.lang.W00085,
            "data-placeholder": (element1.description || (_vm.questionsByGuid[element1.guid.toUpperCase()] && _vm.questionsByGuid[element1.guid.toUpperCase()].Description)) ? false : true
          },
          on: {
            "click": function($event) {
              return _vm.removePlaceholder($event.target)
            },
            "input": function($event) {
              _vm.setConfigurationQuestion(element1.guid.toUpperCase(), 'Description', $event.target.textContent, $event.target)
            }
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "wizard-survey-row-half"
        }, [_c('input', {
          ref: "wizard-survey-translation-input",
          refInFor: true,
          staticClass: "wizard-survey-translation-input",
          attrs: {
            "type": "text",
            "data-translationguid": element1.guid.toUpperCase(),
            "data-translationkey": 'description',
            "data-category": 'question',
            "disabled": _vm.readonly || !_vm.selectedLocaleCode
          },
          on: {
            "input": function($event) {
              _vm.setConfigurationQuestionTranslation(element1.guid.toUpperCase(), 'TranslationDescription', $event.target.value, $event.target)
            }
          }
        })])]), _vm._v(" "), _vm._l((element1.choices), function(c) {
          return (element1.choices) ? _c('div', {
            staticClass: "wizard-survey-row"
          }, [_c('div', {
            staticClass: "wizard-survey-row-half"
          }, [_c('div', {
            staticClass: "wizard-survey-spacer"
          }), _vm._v(" "), (element1.type == 'radiogroup') ? _c('input', {
            staticStyle: {
              "cursor": "default",
              "margin": "0px"
            },
            attrs: {
              "type": "radio",
              "name": "",
              "id": "",
              "disabled": ""
            }
          }) : _vm._e(), _vm._v(" "), (element1.type == 'checkbox') ? _c('input', {
            staticStyle: {
              "cursor": "default",
              "margin": "0px"
            },
            attrs: {
              "type": "checkbox",
              "name": "",
              "id": "",
              "disabled": ""
            }
          }) : _vm._e(), _vm._v(" "), _c('div', {
            staticStyle: {
              "text-align": "justify",
              "max-width": "80%"
            }
          }, [_c('span', {
            ref: "wizard-survey-contenteditable",
            refInFor: true,
            staticClass: "wizard-survey-contenteditable",
            attrs: {
              "contenteditable": !_vm.readonly,
              "data-choiceguid": c.guid.toUpperCase(),
              "data-key": 'Title',
              "data-fallbacktext": c.text
            },
            on: {
              "input": function($event) {
                _vm.setConfigurationQuestionChoice(c.guid.toUpperCase(), 'Title', $event.target.textContent, $event.target)
              }
            }
          })]), _vm._v(" "), (element1.type == 'radiogroup') ? _c('span', {
            staticClass: "wizard-survey-points-container"
          }, [_vm._v("\n                    (\n                    "), _c('span', {
            ref: "wizard-survey-contenteditable",
            refInFor: true,
            staticClass: "wizard-survey-contenteditable",
            attrs: {
              "contenteditable": !_vm.readonly,
              "data-choiceguid": c.guid.toUpperCase(),
              "data-key": 'Points',
              "data-fallbacktext": c.points ? c.points : 0
            },
            on: {
              "input": function($event) {
                _vm.setConfigurationQuestionChoice(c.guid.toUpperCase(), 'Points', $event.target.textContent, $event.target, 'number')
              }
            }
          }), _vm._v("\n                    /\n                    "), _c('span', {
            ref: "wizard-survey-contenteditable",
            refInFor: true,
            staticClass: "wizard-survey-contenteditable text-center",
            attrs: {
              "contenteditable": !_vm.readonly,
              "data-choiceguid": c.guid.toUpperCase(),
              "data-key": 'PointsMax',
              "data-fallbacktext": element1.pointsMax ? element1.pointsMax : 0
            },
            on: {
              "input": function($event) {
                _vm.setConfigurationQuestionChoice(c.guid.toUpperCase(), 'PointsMax', $event.target.textContent, $event.target, 'number')
              }
            }
          }), _vm._v("\n                    )\n                  ")]) : _vm._e(), _vm._v(" "), (element1.type == 'checkbox') ? _c('span', {
            staticClass: "wizard-survey-points-container"
          }, [_vm._v("\n                    (\n                    "), _c('span', {
            ref: "wizard-survey-contenteditable",
            refInFor: true,
            staticClass: "wizard-survey-contenteditable",
            attrs: {
              "contenteditable": !_vm.readonly,
              "data-choiceguid": c.guid.toUpperCase(),
              "data-key": 'Points',
              "data-fallbacktext": c.points ? c.points : 0
            },
            on: {
              "input": function($event) {
                _vm.setConfigurationQuestionChoice(c.guid.toUpperCase(), 'Points', $event.target.textContent, $event.target, 'number')
              }
            }
          }), _vm._v("\n                    )\n                  ")]) : _vm._e()]), _vm._v(" "), _c('div', {
            staticClass: "wizard-survey-row-half"
          }, [_c('input', {
            ref: "wizard-survey-translation-input",
            refInFor: true,
            staticClass: "wizard-survey-translation-input",
            attrs: {
              "type": "text",
              "data-translationguid": c.guid.toUpperCase(),
              "data-translationkey": 'text',
              "data-category": 'choice',
              "disabled": _vm.readonly || !_vm.selectedLocaleCode
            },
            on: {
              "input": function($event) {
                _vm.setConfigurationQuestionChoiceTranslation(c.guid.toUpperCase(), 'Translation', $event.target.value, $event.target)
              }
            }
          })])]) : _vm._e()
        }), _vm._v(" "), _c('div', {
          staticClass: "wizard-survey-row"
        }, [_c('textarea', {
          attrs: {
            "rows": "1",
            "placeholder": _vm.lang.W00086,
            "disabled": _vm.readonly
          },
          on: {
            "change": function($event) {
              _vm.setConfigurationQuestion(element1.guid.toUpperCase(), 'Comment', $event.target.value, $event.target)
            }
          }
        }, [_vm._v(_vm._s(_vm.getComment(element1.guid.toUpperCase())))])])], 2)]
      })], 2)
    }), 0)
  })], 2) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 1741 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step-container"
  }, [_c('StepHeader', {
    attrs: {
      "currentStep": _vm.currentStep,
      "steps": _vm.steps
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "brand-filters"
  }, _vm._l((_vm.brandValidation), function(bv) {
    return (bv.CompetitorCarBrand) ? _c('div', {
      key: bv.CompetitorCarBrand,
      staticClass: "brand-tag"
    }, [_c('span', {
      staticClass: "brand-name"
    }, [_vm._v("\n          " + _vm._s(bv.CompetitorCarBrand) + " (" + _vm._s(bv.Distribution) + "%)\n        ")])]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "wizard-table-container"
  }, [_c('div', {
    staticClass: "wizard-table-header"
  }, [_c('div', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v(_vm._s(_vm.lang.W00044))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.lang.W00045))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.lang.W00041))]), _vm._v(" "), _c('div')]), _vm._v(" "), (_vm.competitorCarModelDistribution) ? _c('div', {
    staticClass: "wizard-table-body"
  }, _vm._l((_vm.competitorCarModelDistribution), function(e, index) {
    return _c('div', {
      key: index,
      staticClass: "wizard-table-row",
      class: {
        'invalid-wizard-table-row': !_vm.isBrandValid(e.CompetitorCarBrand)
      }
    }, [_c('div', {
      staticClass: "wizard-table-cell"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (e.CompetitorCarBrand),
        expression: "e.CompetitorCarBrand"
      }],
      staticClass: "wizard-select",
      attrs: {
        "disabled": _vm.readonly
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(e, "CompetitorCarBrand", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "disabled": "",
        "hidden": ""
      },
      domProps: {
        "value": null
      }
    }, [_vm._v(_vm._s(_vm.lang.W00047))]), _vm._v(" "), _vm._l((_vm.brands), function(brand) {
      return _c('option', {
        key: brand,
        domProps: {
          "value": brand
        }
      }, [_vm._v("\n                " + _vm._s(brand) + "\n              ")])
    })], 2)]), _vm._v(" "), _c('div', {
      staticClass: "wizard-table-cell"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (e.CompetitorCarModel),
        expression: "e.CompetitorCarModel"
      }],
      staticClass: "wizard-input",
      attrs: {
        "type": "text",
        "disabled": _vm.readonly
      },
      domProps: {
        "value": (e.CompetitorCarModel)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(e, "CompetitorCarModel", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "wizard-table-cell"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (e.Distribution),
        expression: "e.Distribution"
      }],
      staticClass: "wizard-input",
      attrs: {
        "type": "number",
        "min": 0,
        "max": 100,
        "step": 0.1,
        "disabled": _vm.readonly
      },
      domProps: {
        "value": (e.Distribution)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(e, "Distribution", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "wizard-table-cell"
    }, [_c('button', {
      staticClass: "delete-vehicle-btn",
      attrs: {
        "disabled": _vm.readonly
      },
      on: {
        "click": function($event) {
          return _vm.deleteVehicle(e)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24"
    }, [_vm._v("delete")])])])])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "add-vehicle-btn-container"
  }, [_c('button', {
    staticClass: "add-vehicle-btn",
    attrs: {
      "disabled": _vm.readonly
    },
    on: {
      "click": function($event) {
        return _vm.addVehicle()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("add")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.W00046))])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1742 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step-container"
  }, [_c('StepHeader', {
    attrs: {
      "currentStep": _vm.currentStep,
      "steps": _vm.steps
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "wizard-table-container"
  }, [_c('div', {
    staticClass: "wizard-table-header"
  }, [_c('div', [_vm._v(_vm._s(_vm.lang.W00038))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.lang.W00039))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.lang.W00040))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.lang.W00041))])]), _vm._v(" "), _c('div', {
    staticClass: "wizard-table-body"
  }, _vm._l((_vm.filteredCarModelList), function(model) {
    return _c('div', {
      key: model.CarModelGuid,
      staticClass: "wizard-table-row",
      class: {
        'invalid-wizard-table-row': _vm.multipleModels.has(model.CarModelName)
      }
    }, [_c('div', {
      staticClass: "wizard-table-cell"
    }, [_vm._v(_vm._s(model.CarModelName))]), _vm._v(" "), _c('div', [_vm._l((_vm.importerList), function(importer) {
      return [(importer.ImporterGuid === model.ImporterGuid) ? _c('div', {
        key: importer.ImporterGuid
      }, [_vm._v("\n                " + _vm._s(importer.ImporterName) + "\n              ")]) : _vm._e()]
    })], 2), _vm._v(" "), _c('div', _vm._l((model.CarSegments), function(modelCarSegment, index) {
      return _c('span', {
        key: modelCarSegment.CarSegmentGuid
      }, [_vm._l((_vm.segmentList), function(segment) {
        return [(
          segment.CarSegmentGuid ===
          modelCarSegment.CarSegmentGuid
        ) ? _c('span', {
          key: segment.CarSegmentGuid
        }, [(index != 0) ? _c('span', [_vm._v(" ,")]) : _vm._e(), _vm._v("\n                  " + _vm._s(segment.CarSegmentName) + "\n                ")]) : _vm._e()]
      })], 2)
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "form-group nopadding"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (model.Distribution),
        expression: "model.Distribution",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "wizard-input",
      attrs: {
        "type": "number",
        "min": 0,
        "max": 100,
        "step": 0.1,
        "disabled": _vm.readonly
      },
      domProps: {
        "value": (model.Distribution)
      },
      on: {
        "change": function($event) {
          return _vm.validateDistributionValue(model)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(model, "Distribution", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "sum-display"
  }, [_c('span', [_vm._v(_vm._s(_vm.lang.W00071) + " " + _vm._s(_vm.sumDistribution) + "%")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1743 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step-container"
  }, [_c('StepHeader', {
    attrs: {
      "currentStep": _vm.currentStep,
      "steps": _vm.steps
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "scenarios-grid"
  }, [_c('div', {
    staticClass: "scenarios-column"
  }, [_c('h3', {
    staticClass: "column-title"
  }, [_vm._v(_vm._s(_vm.lang.W00032))]), _vm._v(" "), _c('div', {
    staticClass: "wizard-table-container"
  }, [_c('div', {
    staticClass: "wizard-table-header"
  }, [_c('div', [_vm._v(_vm._s(_vm.lang.W00035))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.lang.W00034))])]), _vm._v(" "), _c('div', {
    staticClass: "wizard-table-body"
  }, _vm._l((_vm.availableScenarios), function(scenario) {
    return _c('div', {
      key: scenario.ScenarioId,
      staticClass: "wizard-table-row",
      class: {
        'disabled': (scenario.disabled || _vm.readonly),
        'selectable': (!scenario.disabled && !_vm.readonly)
      },
      on: {
        "click": function($event) {
          return _vm.selectScenario(scenario)
        }
      }
    }, [_c('div', {
      staticClass: "wizard-table-cell"
    }, [_vm._v(_vm._s(scenario.ScenarioId))]), _vm._v(" "), _c('div', {
      staticClass: "wizard-table-cell"
    }, [_vm._v(_vm._s(scenario.ScenarioName))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "scenarios-column selected-column"
  }, [_c('div', {
    staticClass: "selected-content"
  }, [_c('div', {
    staticClass: "selected-header"
  }, [_c('h3', {
    staticClass: "column-title"
  }, [_vm._v(_vm._s(_vm.lang.W00033))]), _vm._v(" "), _c('div', {
    staticClass: "wizard-table-container"
  }, [_c('div', {
    staticClass: "wizard-table-header"
  }, [_c('div', [_vm._v(_vm._s(_vm.lang.W00035))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.lang.W00034))])]), _vm._v(" "), _c('div', {
    staticClass: "wizard-table-body"
  }, _vm._l((_vm.localFormData.scenarios), function(scenario) {
    return _c('div', {
      key: scenario.ScenarioId,
      staticClass: "wizard-table-row selected"
    }, [_c('div', {
      staticClass: "wizard-table-cell"
    }, [_vm._v(_vm._s(scenario.ScenarioId))]), _vm._v(" "), _c('div', {
      staticClass: "wizard-table-cell"
    }, [_vm._v(_vm._s(scenario.ScenarioName))]), _vm._v(" "), _c('div', {
      staticClass: "wizard-table-cell"
    }, [_c('button', {
      staticClass: "remove-button",
      attrs: {
        "disabled": _vm.readonly
      },
      on: {
        "click": function($event) {
          return _vm.removeScenario(scenario.ScenarioId)
        }
      }
    }, [_c('svg', {
      staticClass: "remove-icon",
      attrs: {
        "fill": "none",
        "viewBox": "0 0 24 24",
        "stroke": "#666666"
      }
    }, [_c('path', {
      attrs: {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.5",
        "d": "M6 18L18 6M6 6l12 12"
      }
    })])])])])
  }), 0)])])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1744 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step-container"
  }, [_c('StepHeader', {
    attrs: {
      "currentStep": _vm.currentStep,
      "steps": _vm.steps
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-section"
  }, [_c('div', {
    staticClass: "field-container"
  }, [_c('div', {
    staticClass: "field-header"
  }, [_c('label', {
    staticClass: "field-label"
  }, [_vm._v(_vm._s(_vm.lang.W00001))])]), _vm._v(" "), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localFormData.title),
      expression: "localFormData.title"
    }],
    staticClass: "text-input",
    attrs: {
      "placeholder": _vm.lang.W00013,
      "disabled": _vm.readonly
    },
    domProps: {
      "value": (_vm.localFormData.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localFormData, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field-description"
  }, [_c('p', [_vm._v(_vm._s(_vm.lang.W00014))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-fields"
  }, [_c('div', {
    staticClass: "field-container"
  }, [_c('div', {
    staticClass: "field-header"
  }, [_c('label', {
    staticClass: "field-label"
  }, [_vm._v(_vm._s(_vm.lang.W00015))])]), _vm._v(" "), _c('div', {
    staticClass: "select-container"
  }, [(_vm.projects) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localFormData.projectGuid),
      expression: "localFormData.projectGuid"
    }],
    staticClass: "select-input",
    attrs: {
      "disabled": _vm.readonly
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.localFormData, "projectGuid", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.projects), function(project) {
    return _c('option', {
      key: project.ProjectGuid,
      domProps: {
        "value": project.ProjectGuid
      }
    }, [_vm._v("\n              " + _vm._s(project.ProjectName) + "\n            ")])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "select-arrow"
  }, [_c('svg', {
    staticClass: "arrow-icon",
    attrs: {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "#666666"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "d": "M7 10L12.5 15.5L18 10"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "field-container"
  }, [_c('label', {
    staticClass: "field-label"
  }, [_vm._v(_vm._s(_vm.lang.W00016))]), _vm._v(" "), _c('div', {
    staticClass: "select-container"
  }, [(_vm.projects && _vm.surveys) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localFormData.surveyGuid),
      expression: "localFormData.surveyGuid"
    }],
    staticClass: "select-input",
    attrs: {
      "disabled": !_vm.localFormData.projectGuid || _vm.readonly
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.localFormData, "surveyGuid", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.filteredSurveys), function(survey) {
    return _c('option', {
      key: survey.SurveyGuid,
      domProps: {
        "value": survey.SurveyGuid
      }
    }, [_vm._v("\n              " + _vm._s(survey.SurveyTitle) + "\n            ")])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "select-arrow"
  }, [_c('svg', {
    staticClass: "arrow-icon",
    attrs: {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "#666666"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "d": "M7 10L12.5 15.5L18 10"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "field-container"
  }, [_c('div', {
    staticClass: "field-header"
  }, [_c('label', {
    staticClass: "field-label"
  }, [_vm._v(_vm._s(_vm.lang.W00017))])]), _vm._v(" "), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localFormData.waveName),
      expression: "localFormData.waveName"
    }],
    staticClass: "text-input",
    attrs: {
      "placeholder": _vm.lang.W00018,
      "disabled": _vm.readonly
    },
    domProps: {
      "value": (_vm.localFormData.waveName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localFormData, "waveName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field-description"
  }, [_c('p', [_vm._v(_vm._s(_vm.lang.W00019))])])]), _vm._v(" "), _c('div', {
    staticClass: "two-column-grid"
  }, [_c('div', {
    staticClass: "field-container"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "inputWaveStartDate"
    }
  }, [_vm._v(_vm._s(_vm.lang.W00020))]), _vm._v(" "), _c('div', {
    staticClass: "select-container",
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr('inputWaveStartDate')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localFormData.waveSince),
      expression: "localFormData.waveSince"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputWaveStartDate",
      "disabled": _vm.readonly
    },
    domProps: {
      "value": (_vm.localFormData.waveSince)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localFormData, "waveSince", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field-container"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "inputWaveEndDate"
    }
  }, [_vm._v(_vm._s(_vm.lang.W00021))]), _vm._v(" "), _c('div', {
    staticClass: "select-container",
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr('inputWaveEndDate')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localFormData.waveUntil),
      expression: "localFormData.waveUntil"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputWaveEndDate",
      "disabled": _vm.readonly
    },
    domProps: {
      "value": (_vm.localFormData.waveUntil)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localFormData, "waveUntil", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "two-column-grid"
  }, [_c('div', {
    staticClass: "field-container"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "inputWavePlannedStartDate"
    }
  }, [_vm._v(_vm._s(_vm.lang.W00022))]), _vm._v(" "), _c('div', {
    staticClass: "select-container",
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr('inputWavePlannedStartDate')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localFormData.wavePlannedSince),
      expression: "localFormData.wavePlannedSince"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputWavePlannedStartDate",
      "disabled": _vm.readonly
    },
    domProps: {
      "value": (_vm.localFormData.wavePlannedSince)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localFormData, "wavePlannedSince", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field-container"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "inputWavePlannedEndDate"
    }
  }, [_vm._v(_vm._s(_vm.lang.W00023))]), _vm._v(" "), _c('div', {
    staticClass: "select-container",
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr('inputWavePlannedEndDate')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localFormData.wavePlannedUntil),
      expression: "localFormData.wavePlannedUntil"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputWavePlannedEndDate",
      "disabled": _vm.readonly
    },
    domProps: {
      "value": (_vm.localFormData.wavePlannedUntil)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localFormData, "wavePlannedUntil", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "field-container"
  }, [_c('div', {
    staticClass: "field-header"
  }, [_c('label', {
    staticClass: "field-label"
  }, [_vm._v(_vm._s(_vm.lang.W00024))])]), _vm._v(" "), _c('div', {
    staticClass: "input-container"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localFormData.waveInfo),
      expression: "localFormData.waveInfo"
    }],
    staticClass: "text-input",
    attrs: {
      "maxlength": "500",
      "rows": "2",
      "disabled": _vm.readonly
    },
    domProps: {
      "value": (_vm.localFormData.waveInfo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localFormData, "waveInfo", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field-container"
  }, [_c('div', {
    staticClass: "checkbox-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localFormData.waveWithoutApproval),
      expression: "localFormData.waveWithoutApproval"
    }],
    staticClass: "checkbox-input",
    attrs: {
      "type": "checkbox",
      "id": "inputWaveWithoutApproval",
      "disabled": _vm.readonly
    },
    domProps: {
      "checked": Array.isArray(_vm.localFormData.waveWithoutApproval) ? _vm._i(_vm.localFormData.waveWithoutApproval, null) > -1 : (_vm.localFormData.waveWithoutApproval)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.localFormData.waveWithoutApproval,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.localFormData, "waveWithoutApproval", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.localFormData, "waveWithoutApproval", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.localFormData, "waveWithoutApproval", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "checkbox-label",
    attrs: {
      "for": "inputWaveWithoutApproval"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.W00025) + "\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "field-container"
  }, [_c('div', {
    staticClass: "checkbox-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localFormData.isLocalWave),
      expression: "localFormData.isLocalWave"
    }],
    staticClass: "checkbox-input",
    attrs: {
      "type": "checkbox",
      "id": "inputIsLocalWave",
      "disabled": _vm.readonly
    },
    domProps: {
      "checked": Array.isArray(_vm.localFormData.isLocalWave) ? _vm._i(_vm.localFormData.isLocalWave, null) > -1 : (_vm.localFormData.isLocalWave)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.localFormData.isLocalWave,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.localFormData, "isLocalWave", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.localFormData, "isLocalWave", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.localFormData, "isLocalWave", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "checkbox-label",
    attrs: {
      "for": "inputIsLocalWave"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.W00026) + "\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "field-container"
  }, [_c('div', {
    staticClass: "field-header"
  }, [_c('label', {
    staticClass: "field-label"
  }, [_vm._v(_vm._s(_vm.lang.W00027))])]), _vm._v(" "), _c('div', {
    staticClass: "select-container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localFormData.importerGuid),
      expression: "localFormData.importerGuid"
    }],
    staticClass: "select-input",
    attrs: {
      "disabled": _vm.readonly
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.localFormData, "importerGuid", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.importers), function(importer) {
    return _c('option', {
      key: importer.ImporterGuid,
      domProps: {
        "value": importer.ImporterGuid
      }
    }, [_vm._v("\n              " + _vm._s(importer.ImporterName) + "\n            ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "select-arrow"
  }, [_c('svg', {
    staticClass: "arrow-icon",
    attrs: {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "#666666"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "d": "M7 10L12.5 15.5L18 10"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "field-description"
  }, [_c('p', [_vm._v(_vm._s(_vm.lang.W00028))])])]), _vm._v(" "), _c('div', {
    staticClass: "field-container"
  }, [_c('div', {
    staticClass: "field-header"
  }, [_c('label', {
    staticClass: "field-label"
  }, [_vm._v(_vm._s(_vm.lang.W00029))])]), _vm._v(" "), _c('div', {
    staticClass: "select-container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localFormData.agencyGuid),
      expression: "localFormData.agencyGuid"
    }],
    staticClass: "select-input",
    attrs: {
      "disabled": _vm.readonly
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.localFormData, "agencyGuid", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.agencies), function(agency) {
    return _c('option', {
      key: agency.AgencyGuid,
      domProps: {
        "value": agency.AgencyGuid
      }
    }, [_vm._v("\n              " + _vm._s(agency.AgencyName) + "\n            ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "select-arrow"
  }, [_c('svg', {
    staticClass: "arrow-icon",
    attrs: {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "#666666"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "d": "M7 10L12.5 15.5L18 10"
    }
  })])])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1745 */,
/* 1746 */,
/* 1747 */,
/* 1748 */,
/* 1749 */,
/* 1750 */,
/* 1751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var index = (function (element, listener) {
	var expand = document.createElement('_');
	var shrink = expand.appendChild(document.createElement('_'));
	var expandChild = expand.appendChild(document.createElement('_'));
	var shrinkChild = shrink.appendChild(document.createElement('_'));

	var lastWidth = void 0,
	    lastHeight = void 0;

	shrink.style.cssText = expand.style.cssText = 'height:100%;left:0;opacity:0;overflow:hidden;pointer-events:none;position:absolute;top:0;transition:0s;width:100%;z-index:-1';
	shrinkChild.style.cssText = expandChild.style.cssText = 'display:block;height:100%;transition:0s;width:100%';
	shrinkChild.style.width = shrinkChild.style.height = '200%';

	element.appendChild(expand);

	test();

	return stop;

	function test() {
		unbind();

		var width = element.offsetWidth;
		var height = element.offsetHeight;

		if (width !== lastWidth || height !== lastHeight) {
			lastWidth = width;
			lastHeight = height;

			expandChild.style.width = width * 2 + 'px';
			expandChild.style.height = height * 2 + 'px';

			expand.scrollLeft = expand.scrollWidth;
			expand.scrollTop = expand.scrollHeight;
			shrink.scrollLeft = shrink.scrollWidth;
			shrink.scrollTop = shrink.scrollHeight;

			listener({ width: width, height: height });
		}

		shrink.addEventListener('scroll', test);
		expand.addEventListener('scroll', test);
	}

	function unbind() {
		shrink.removeEventListener('scroll', test);
		expand.removeEventListener('scroll', test);
	}

	function stop() {
		unbind();

		element.removeChild(expand);
	}
});

/* harmony default export */ __webpack_exports__["default"] = (index);


/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery, jQuery) {/*!
 * surveyjs Builder(Editor) v1.0.72
 * (c) Devsoft Baltic O� - http://surveyjs.io/
 * Github: https://github.com/surveyjs/editor
 * License: https://surveyjs.io/Licenses#BuildSurvey
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(315), __webpack_require__(448));
	else if(typeof define === 'function' && define.amd)
		define("SurveyEditor", ["knockout", "survey-knockout"], factory);
	else if(typeof exports === 'object')
		exports["SurveyEditor"] = factory(require("knockout"), require("survey-knockout"));
	else
		root["SurveyEditor"] = factory(root["ko"], root["Survey"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 47);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__localization_english__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_survey_knockout__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_survey_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_survey_knockout__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return editorLocalization; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaultStrings; });


var editorLocalization = {
    currentLocale: "",
    locales: {},
    getString: function (strName, locale) {
        if (locale === void 0) { locale = null; }
        var loc = this.getLocale(locale);
        var defaultLocale = this.getLocale("en");
        var path = strName.split(".");
        var obj = loc;
        for (var i = 0; i < path.length; i++) {
            obj = obj[path[i]];
            if (!obj) {
                if (loc === defaultLocale)
                    return path[i];
                return this.getString(strName, "en");
            }
        }
        return obj;
    },
    hasString: function (strName, locale) {
        if (locale === void 0) { locale = null; }
        var loc = this.getLocale(locale);
        var path = strName.split(".");
        var obj = loc;
        for (var i = 0; i < path.length; i++) {
            obj = obj[path[i]];
            if (!obj)
                return false;
        }
        return true;
    },
    getLocaleName: function (loc, defaultLocale) {
        if (defaultLocale === void 0) { defaultLocale = null; }
        var localeNames = __WEBPACK_IMPORTED_MODULE_1_survey_knockout__["surveyLocalization"]["localeNames"];
        if (!defaultLocale) {
            defaultLocale = __WEBPACK_IMPORTED_MODULE_1_survey_knockout__["surveyLocalization"].defaultLocale;
        }
        return !!loc
            ? localeNames[loc]
            : editorLocalization
                .getString("ed.defaultLocale")["format"](localeNames[defaultLocale]);
    },
    getPropertyName: function (strName, locale) {
        if (locale === void 0) { locale = null; }
        var obj = this.getProperty(strName, locale);
        if (obj["name"])
            return obj["name"];
        return obj;
    },
    getPropertyTitle: function (strName, locale) {
        if (locale === void 0) { locale = null; }
        var obj = this.getProperty(strName, locale);
        if (obj["title"])
            return obj["title"];
        return "";
    },
    getProperty: function (strName, locale) {
        if (locale === void 0) { locale = null; }
        var obj = this.getString("p." + strName, locale);
        if (obj !== strName)
            return obj;
        var pos = strName.indexOf("_");
        if (pos < -1)
            return obj;
        strName = strName.substr(pos + 1);
        return this.getString("p." + strName, locale);
    },
    getPropertyValue: function (value, locale) {
        if (locale === void 0) { locale = null; }
        return this.getValueInternal(value, "pv", locale);
    },
    getValidatorName: function (name, locale) {
        if (locale === void 0) { locale = null; }
        return this.getValueInternal(name, "validators", locale);
    },
    getTriggerName: function (name, locale) {
        if (locale === void 0) { locale = null; }
        return this.getValueInternal(name, "triggers", locale);
    },
    getLocale: function (locale) {
        if (!locale)
            locale = this.currentLocale;
        var loc = locale ? this.locales[locale] : defaultStrings;
        if (!loc)
            loc = defaultStrings;
        return loc;
    },
    getValueInternal: function (value, prefix, locale) {
        if (locale === void 0) { locale = null; }
        if (value === "" || value === null || value === undefined)
            return "";
        value = value.toString();
        var loc = this.getLocale(locale);
        var res = loc[prefix] ? loc[prefix][value] : null;
        if (!res)
            res = defaultStrings[prefix][value];
        return res ? res : value;
    },
    getLocales: function () {
        var res = [];
        res.push("");
        for (var key in this.locales) {
            res.push(key);
        }
        return res;
    }
};
var defaultStrings = __WEBPACK_IMPORTED_MODULE_0__localization_english__["a" /* enStrings */];


/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export __assign */
/* harmony export (immutable) */ __webpack_exports__["a"] = __extends;
var __assign = Object["assign"] ||
    function (target) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    target[p] = s[p];
        }
        return target;
    };
function __extends(thisClass, baseClass) {
    for (var p in baseClass)
        if (baseClass.hasOwnProperty(p))
            thisClass[p] = baseClass[p];
    function __() {
        this.constructor = thisClass;
    }
    thisClass.prototype =
        baseClass === null
            ? Object.create(baseClass)
            : ((__.prototype = baseClass.prototype), new __());
}


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_knockout__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_survey_knockout__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_survey_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_survey_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__propertyEditorBase__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__propertyCustomEditor__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__editorLocalization__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SurveyPropertyEditorFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SurveyStringPropertyEditor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SurveyDropdownPropertyEditor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SurveyBooleanPropertyEditor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SurveyNumberPropertyEditor; });






var SurveyPropertyEditorFactory = /** @class */ (function () {
    function SurveyPropertyEditorFactory() {
    }
    SurveyPropertyEditorFactory.getOperators = function () {
        var operators = [
            "empty",
            "notempty",
            "equal",
            "notequal",
            "contains",
            "notcontains",
            "greater",
            "less",
            "greaterorequal",
            "lessorequal"
        ];
        var result = [];
        for (var i = 0; i < operators.length; i++) {
            var name = operators[i];
            result.push({
                name: name,
                text: __WEBPACK_IMPORTED_MODULE_5__editorLocalization__["a" /* editorLocalization */].getString("op." + name)
            });
        }
        return result;
    };
    SurveyPropertyEditorFactory.registerEditor = function (name, creator, editableClassName) {
        if (editableClassName === void 0) { editableClassName = null; }
        SurveyPropertyEditorFactory.creatorList[name] = creator;
        var className = editableClassName ? editableClassName : name;
        SurveyPropertyEditorFactory.creatorByClassList[className] = creator;
    };
    SurveyPropertyEditorFactory.registerCustomEditor = function (name, widgetJSON) {
        SurveyPropertyEditorFactory.widgetRegisterList[name] = widgetJSON;
    };
    SurveyPropertyEditorFactory.createEditor = function (property, func) {
        var editorType = property.type;
        if (SurveyPropertyEditorFactory.isDropdownEditor(property) &&
            (!editorType || editorType == SurveyPropertyEditorFactory.defaultEditor)) {
            editorType = "dropdown";
        }
        var propertyEditor = SurveyPropertyEditorFactory.createCustomEditor(editorType, property);
        if (!propertyEditor) {
            var creator = SurveyPropertyEditorFactory.creatorList[editorType];
            if (creator)
                propertyEditor = creator(property);
        }
        if (!propertyEditor) {
            if (property.isArray &&
                __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["JsonObject"].metaData.isDescendantOf(property.className, "itemvalue")) {
                var creator = SurveyPropertyEditorFactory.creatorList["itemvalue[]"];
                if (creator)
                    propertyEditor = creator(property);
            }
        }
        if (!propertyEditor) {
            creator = SurveyPropertyEditorFactory.findParentCreator(editorType);
            propertyEditor = creator(property);
        }
        propertyEditor.onChanged = func;
        return propertyEditor;
    };
    SurveyPropertyEditorFactory.isDropdownEditor = function (property) {
        if (property["hasChoices"] !== undefined)
            return property["hasChoices"] === true;
        return property.choices != null;
    };
    SurveyPropertyEditorFactory.createCustomEditor = function (name, property) {
        var widgetJSON = SurveyPropertyEditorFactory.widgetRegisterList[name];
        if (!widgetJSON)
            return null;
        return new __WEBPACK_IMPORTED_MODULE_4__propertyCustomEditor__["a" /* SurveyPropertyCustomEditor */](property, widgetJSON);
    };
    SurveyPropertyEditorFactory.findParentCreator = function (name) {
        var jsonClass = __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["JsonObject"].metaData.findClass(name);
        while (jsonClass && jsonClass.parentName) {
            var creator = SurveyPropertyEditorFactory.creatorByClassList[jsonClass.parentName];
            if (creator)
                return creator;
            jsonClass = __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["JsonObject"].metaData.findClass(jsonClass.parentName);
        }
        return SurveyPropertyEditorFactory.creatorList[SurveyPropertyEditorFactory.defaultEditor];
    };
    SurveyPropertyEditorFactory.defaultEditor = "string";
    SurveyPropertyEditorFactory.creatorList = {};
    SurveyPropertyEditorFactory.creatorByClassList = {};
    SurveyPropertyEditorFactory.widgetRegisterList = {};
    return SurveyPropertyEditorFactory;
}());

var SurveyStringPropertyEditor = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SurveyStringPropertyEditor, _super);
    function SurveyStringPropertyEditor(property) {
        return _super.call(this, property) || this;
    }
    Object.defineProperty(SurveyStringPropertyEditor.prototype, "editorType", {
        get: function () {
            return "string";
        },
        enumerable: true,
        configurable: true
    });
    return SurveyStringPropertyEditor;
}(__WEBPACK_IMPORTED_MODULE_3__propertyEditorBase__["a" /* SurveyPropertyEditorBase */]));

var SurveyDropdownPropertyEditor = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SurveyDropdownPropertyEditor, _super);
    function SurveyDropdownPropertyEditor(property) {
        var _this = _super.call(this, property) || this;
        _this.koChoices = __WEBPACK_IMPORTED_MODULE_1_knockout__["observableArray"]([]);
        _this.koHasFocus = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"](false);
        var self = _this;
        _this.koHasFocus.subscribe(function (newValue) {
            if (newValue && self.property["isDynamicChoices"]) {
                //TODO
                self.koChoices(self.getLocalizableChoices());
            }
        });
        return _this;
    }
    Object.defineProperty(SurveyDropdownPropertyEditor.prototype, "editorType", {
        get: function () {
            return "dropdown";
        },
        enumerable: true,
        configurable: true
    });
    SurveyDropdownPropertyEditor.prototype.getValueText = function (value) {
        if (this.property.name === "locale") {
            var text = __WEBPACK_IMPORTED_MODULE_5__editorLocalization__["a" /* editorLocalization */].getLocaleName(value);
            if (text)
                return text;
        }
        if (this.property.name === "cellType") {
            var text = __WEBPACK_IMPORTED_MODULE_5__editorLocalization__["a" /* editorLocalization */].getString("qt." + value);
            if (text)
                return text;
        }
        return __WEBPACK_IMPORTED_MODULE_5__editorLocalization__["a" /* editorLocalization */].getPropertyValue(value);
    };
    SurveyDropdownPropertyEditor.prototype.setObject = function (value) {
        _super.prototype.setObject.call(this, value);
        this.beginValueUpdating();
        if (this.koChoices().length == 0) {
            this.updateChoices();
        }
        this.endValueUpdating();
    };
    SurveyDropdownPropertyEditor.prototype.updateChoices = function () {
        this.koChoices(this.getLocalizableChoices());
    };
    SurveyDropdownPropertyEditor.prototype.getLocalizableChoices = function () {
        var choices = this.getPropertyChoices();
        if (!choices || choices.length == 0)
            return [];
        var res = new Array();
        __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["ItemValue"].setData(res, choices);
        for (var i = 0; i < res.length; i++) {
            var value = res[i].value;
            var text = this.getValueText(value);
            if (text != value) {
                res[i].text = text;
            }
        }
        return res;
    };
    SurveyDropdownPropertyEditor.prototype.getPropertyChoices = function () {
        if (!this.property)
            return null;
        if (!!this.object) {
            var obj = this.object;
            this.object["getEditingPropertyValue"] = function (name) {
                if (!!obj.editingProperties && obj.editingProperties[name] != undefined)
                    return obj.editingProperties[name];
                return obj[name];
            };
        }
        return this.property.getChoices(this.object);
    };
    return SurveyDropdownPropertyEditor;
}(__WEBPACK_IMPORTED_MODULE_3__propertyEditorBase__["a" /* SurveyPropertyEditorBase */]));

var SurveyBooleanPropertyEditor = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SurveyBooleanPropertyEditor, _super);
    function SurveyBooleanPropertyEditor(property) {
        return _super.call(this, property) || this;
    }
    Object.defineProperty(SurveyBooleanPropertyEditor.prototype, "editorType", {
        get: function () {
            return "boolean";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyBooleanPropertyEditor.prototype, "alwaysShowEditor", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyBooleanPropertyEditor.prototype, "canShowDisplayNameOnTop", {
        get: function () {
            return false;
        },
        enumerable: true,
        configurable: true
    });
    SurveyBooleanPropertyEditor.prototype.getValueText = function (value) {
        return __WEBPACK_IMPORTED_MODULE_5__editorLocalization__["a" /* editorLocalization */].getPropertyValue(value);
    };
    return SurveyBooleanPropertyEditor;
}(__WEBPACK_IMPORTED_MODULE_3__propertyEditorBase__["a" /* SurveyPropertyEditorBase */]));

var SurveyNumberPropertyEditor = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SurveyNumberPropertyEditor, _super);
    function SurveyNumberPropertyEditor(property) {
        return _super.call(this, property) || this;
    }
    Object.defineProperty(SurveyNumberPropertyEditor.prototype, "editorType", {
        get: function () {
            return "number";
        },
        enumerable: true,
        configurable: true
    });
    SurveyNumberPropertyEditor.prototype.getCorrectedValue = function (value) {
        if (!value)
            return value;
        if (typeof value === "string" || value instanceof String) {
            value = Number(value);
            if (!value)
                value = 0;
        }
        return value;
    };
    return SurveyNumberPropertyEditor;
}(__WEBPACK_IMPORTED_MODULE_3__propertyEditorBase__["a" /* SurveyPropertyEditorBase */]));

SurveyPropertyEditorFactory.registerEditor("string", function (property) {
    return new SurveyStringPropertyEditor(property);
});
SurveyPropertyEditorFactory.registerEditor("dropdown", function (property) {
    return new SurveyDropdownPropertyEditor(property);
});
SurveyPropertyEditorFactory.registerEditor("boolean", function (property) {
    return new SurveyBooleanPropertyEditor(property);
});
SurveyPropertyEditorFactory.registerEditor("number", function (property) {
    return new SurveyNumberPropertyEditor(property);
});


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_knockout__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editorLocalization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_survey_knockout__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_survey_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_survey_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_utils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stylesmanager__ = __webpack_require__(19);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SurveyForDesigner; });
/* harmony export (immutable) */ __webpack_exports__["b"] = registerAdorner;
/* harmony export (immutable) */ __webpack_exports__["c"] = removeAdorners;
/* unused harmony export applyAdornerClass */






var SurveyForDesigner = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SurveyForDesigner, _super);
    function SurveyForDesigner(jsonObj, renderedElement, css) {
        if (jsonObj === void 0) { jsonObj = null; }
        if (renderedElement === void 0) { renderedElement = null; }
        if (css === void 0) { css = null; }
        var _this = _super.call(this, jsonObj, renderedElement, css) || this;
        _this.onSelectedElementChanged = new __WEBPACK_IMPORTED_MODULE_3_survey_knockout__["Event"]();
        _this.onEditButtonClick = new __WEBPACK_IMPORTED_MODULE_3_survey_knockout__["Event"]();
        _this.onGetMenuItems = new __WEBPACK_IMPORTED_MODULE_3_survey_knockout__["Event"]();
        _this.onElementDoubleClick = new __WEBPACK_IMPORTED_MODULE_3_survey_knockout__["Event"]();
        var self = _this;
        _this.setDesignMode(true);
        _this.onAfterRenderPage.add(function (sender, options) {
            options.page["onAfterRenderPage"](options.htmlElement);
        });
        _this.onAfterRenderQuestion.add(function (sender, options) {
            options.question["onAfterRenderQuestion"](options.htmlElement);
        });
        _this.onAfterRenderPanel.add(function (sender, options) {
            options.panel["onAfterRenderPanel"](options.htmlElement);
        });
        _this.editQuestionClick = function () {
            self.onEditButtonClick.fire(self, null);
        };
        _this.onUpdateQuestionCssClasses.add(onUpdateQuestionCssClasses);
        _this.onUpdatePanelCssClasses.add(onUpdateQuestionCssClasses);
        return _this;
    }
    SurveyForDesigner.prototype.updateElementAllowingOptions = function (obj) {
        if (this.onUpdateElementAllowingOptions && obj["allowingOptions"]) {
            obj["allowingOptions"].obj = obj;
            this.onUpdateElementAllowingOptions(obj["allowingOptions"]);
        }
    };
    SurveyForDesigner.prototype.getMenuItems = function (obj) {
        var items = [];
        var options = { obj: obj, items: items };
        this.onGetMenuItems.fire(this, options);
        return options.items;
    };
    Object.defineProperty(SurveyForDesigner.prototype, "selectedElement", {
        get: function () {
            return this.selectedElementValue;
        },
        set: function (value) {
            if (value && value.selectedElementInDesign)
                value = value.selectedElementInDesign;
            if (value == this.selectedElementValue)
                return;
            var oldValue = this.selectedElementValue;
            this.selectedElementValue = value;
            if (oldValue != null && oldValue["onSelectedElementChanged"]) {
                oldValue["onSelectedElementChanged"]();
            }
            if (this.selectedElementValue != null &&
                this.selectedElementValue["onSelectedElementChanged"]) {
                this.selectedElementValue["onSelectedElementChanged"]();
            }
            this.onSelectedElementChanged.fire(this, {
                oldElement: oldValue,
                newElement: value
            });
        },
        enumerable: true,
        configurable: true
    });
    SurveyForDesigner.prototype.doElementDoubleClick = function (obj) {
        this.onElementDoubleClick.fire(this, { element: obj });
    };
    SurveyForDesigner.prototype.getEditorLocString = function (value) {
        return __WEBPACK_IMPORTED_MODULE_2__editorLocalization__["a" /* editorLocalization */].getString(value);
    };
    return SurveyForDesigner;
}(__WEBPACK_IMPORTED_MODULE_3_survey_knockout__["Survey"]));

function getSurvey(el) {
    if (!el)
        return null;
    var res = el["survey"];
    if (res)
        return res;
    return el["data"];
}
function panelBaseOnCreating(self) {
    self.dragEnterCounter = 0;
    self.emptyElement = null;
    self.rowCount = __WEBPACK_IMPORTED_MODULE_1_knockout__["computed"](function () {
        var rows = !!self["koRow"] ? self["koRows"]() : self.rows;
        return rows.length;
    }, self);
    self.rowCount.subscribe(function (value) {
        if (self.emptyElement) {
            self.emptyElement.style.display = value > 0 ? "none" : "";
        }
    });
}
function elementOnCreating(surveyElement) {
    surveyElement.allowingOptions = {
        allowDelete: true,
        allowEdit: true,
        allowCopy: true,
        allowAddToToolbox: true,
        allowDragging: true,
        allowChangeType: true,
        allowShowHideTitle: true,
        allowChangeRequired: true
    };
    surveyElement.dragDropHelperValue = null;
    surveyElement.dragDropHelper = function () {
        if (surveyElement.dragDropHelperValue == null) {
            surveyElement.dragDropHelperValue = getSurvey(surveyElement)["dragDropHelper"];
        }
        return surveyElement.dragDropHelperValue;
    };
    surveyElement.renderedElement = null;
    surveyElement.koIsDragging = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"](false);
    surveyElement.koIsSelected = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"](false);
    surveyElement.koIsDragging.subscribe(function (newValue) {
        if (surveyElement.renderedElement) {
            surveyElement.renderedElement.style.opacity = newValue ? 0.4 : 1;
        }
    });
    surveyElement.koIsSelected.subscribe(function (newValue) {
        if (surveyElement.renderedElement) {
            if (newValue) {
                surveyElement.renderedElement.classList.add("svd_q_selected", "svd-main-border-color");
            }
            else {
                surveyElement.renderedElement.classList.remove("svd_q_selected", "svd-main-border-color");
            }
        }
    });
}
function addEmptyPanelElement(root, dragDropHelper, self) {
    var eDiv = document.createElement("div");
    eDiv.className = "well card card-block";
    eDiv.ondragover = function (e) {
        dragDropHelper.doDragDropOver(e, self);
    };
    var eSpan = document.createElement("span");
    eSpan.textContent = getSurvey(self).getEditorLocString("survey.dropQuestion");
    eDiv.appendChild(eSpan);
    root.appendChild(eDiv);
    return eDiv;
}
function createQuestionDesignItem(obj, item) {
    var res = document.createElement("li");
    var btn = document.createElement("button");
    btn.innerText = item.text;
    var onClick = item.onClick;
    btn.onclick = function () {
        onClick(obj, item);
    };
    btn.className = "btn btn-primary btn-sm btn-xs";
    res.appendChild(btn);
    return res;
}
function elementOnAfterRendering(domElement, surveyElement, isPanel, disable) {
    surveyElement.renderedElement = domElement;
    surveyElement.renderedElement.classList.add("svd_question");
    if (__WEBPACK_IMPORTED_MODULE_5__stylesmanager__["a" /* StylesManager */].currentTheme() === "bootstrap") {
        surveyElement.renderedElement.classList.add("svd-dark-bg-color");
    }
    surveyElement.renderedElement.classList.add("svd_q_design_border");
    var isRowLayout = !surveyElement.getLayoutType || surveyElement.getLayoutType() == "row";
    var opt = surveyElement.allowingOptions;
    opt.allowCopy = opt.allowCopy && isRowLayout;
    opt.allowAddToToolbox = opt.allowAddToToolbox && isRowLayout;
    opt.allowChangeType = opt.allowChangeType && isRowLayout;
    opt.allowShowHideTitle = opt.allowShowHideTitle && isRowLayout;
    opt.allowChangeRequired = opt.allowChangeRequired && isRowLayout;
    getSurvey(surveyElement).updateElementAllowingOptions(surveyElement);
    if (surveyElement.koIsSelected())
        surveyElement.renderedElement.classList.add("svd_q_selected", "svd-main-border-color");
    surveyElement.dragDropHelper().attachToElement(domElement, surveyElement);
    domElement.tabindex = "0";
    domElement.onclick = function (e) {
        if (!e["markEvent"]) {
            e["markEvent"] = true;
            if (surveyElement.parent) {
                getSurvey(surveyElement)["selectedElement"] = surveyElement;
            }
        }
    };
    domElement.onkeyup = function (e) {
        var char = e.which || e.keyCode;
        if (char === 0x13 || char === 0x20) {
            domElement.click();
        }
    };
    // el.onkeydown = function(e) {
    //   if (e.witch == 46) getSurvey(surveyElement).deleteCurrentObjectClick();
    //   return true;
    // };
    domElement.ondblclick = function (e) {
        getSurvey(surveyElement).doElementDoubleClick(surveyElement);
    };
    disable = disable && !(surveyElement.getType() == "paneldynamic"); //TODO
    if (disable) {
        var childs = domElement.childNodes;
        for (var i = 0; i < childs.length; i++) {
            if (childs[i].style)
                childs[i].style.pointerEvents = "none";
        }
    }
    var setTabIndex = function (element) {
        element.tabIndex = -1;
    };
    ["input", "select", "textarea"].forEach(function (sel) {
        var elements = domElement.querySelectorAll(sel);
        for (var i = 0; i < elements.length; i++) {
            setTabIndex(elements[i]);
        }
    });
    addAdorner(domElement, surveyElement);
}
var adornersConfig = {};
function registerAdorner(name, adorner) {
    if (!adornersConfig[name]) {
        adornersConfig[name] = [];
    }
    adornersConfig[name].push(adorner);
}
function removeAdorners(names) {
    if (names === void 0) { names = undefined; }
    if (names !== undefined) {
        (names || []).forEach(function (name) { return delete adornersConfig[name]; });
    }
    else {
        adornersConfig = {};
    }
}
function onUpdateQuestionCssClasses(survey, options) {
    var classes = options.panel ? options.cssClasses.panel : options.cssClasses;
    Object.keys(adornersConfig).forEach(function (element) {
        adornersConfig[element].forEach(function (adorner) {
            var classesElementName = adorner.getElementName(options.question || options.panel);
            var adornerMarkerClass = adorner.getMarkerClass(options.question || options.panel);
            classes[classesElementName] = applyAdornerClass(classes[classesElementName], adornerMarkerClass);
        });
    });
}
function applyAdornerClass(classes, adornerClass) {
    var result = classes;
    if (!!adornerClass) {
        result = !!result ? result + " " + adornerClass : adornerClass;
    }
    return result;
}
function filterNestedQuestions(rootQuestionNode, elements) {
    var targetElements = [];
    for (var i = 0; i < elements.length; i++) {
        var questionElement = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_utils__["b" /* findParentNode */])("svd_question", elements[i]);
        if (questionElement === rootQuestionNode) {
            targetElements.push(elements[i]);
        }
    }
    return targetElements;
}
function addAdorner(node, model) {
    Object.keys(adornersConfig).forEach(function (element) {
        adornersConfig[element].forEach(function (adorner) {
            var elementClass = adorner.getMarkerClass(model);
            if (!!elementClass) {
                var elements = node.querySelectorAll("." + elementClass.replace(/\s/g, "."));
                var temp = [];
                for (var i = 0; i < elements.length; i++) {
                    temp.push(elements[i]);
                }
                elements = temp;
                if (node.className.split(" ").indexOf(elementClass) !== -1) {
                    elements.unshift(node);
                }
                elements = filterNestedQuestions(node, elements);
                if (elements.length === 0 &&
                    node.className.indexOf(elementClass) !== -1) {
                    elements = [node];
                }
                if (elements.length > 0) {
                    adorner.afterRender(elements, model, getSurvey(model).getEditor());
                }
            }
        });
    });
}
__WEBPACK_IMPORTED_MODULE_3_survey_knockout__["Page"].prototype["onCreating"] = function () {
    panelBaseOnCreating(this);
};
__WEBPACK_IMPORTED_MODULE_3_survey_knockout__["Page"].prototype["onAfterRenderPage"] = function (el) {
    if (!getSurvey(this).isDesignMode)
        return;
    var self = this;
    var dragDropHelper = getSurvey(this)["dragDropHelper"];
    this.dragEnterCounter = 0;
    el.ondragenter = function (e) {
        e.preventDefault();
        self.dragEnterCounter++;
    };
    el.ondragleave = function (e) {
        self.dragEnterCounter--;
        if (self.dragEnterCounter === 0)
            dragDropHelper.doLeavePage(e);
    };
    el.ondragover = function (e) {
        return false;
    };
    el.ondrop = function (e) {
        dragDropHelper.doDrop(e);
    };
};
__WEBPACK_IMPORTED_MODULE_3_survey_knockout__["Panel"].prototype["onCreating"] = function () {
    panelBaseOnCreating(this);
    elementOnCreating(this);
};
__WEBPACK_IMPORTED_MODULE_3_survey_knockout__["Panel"].prototype["onAfterRenderPanel"] = function (el) {
    if (!getSurvey(this).isDesignMode)
        return;
    var self = this;
    if (this.elements.length == 0) {
        this.emptyElement = addEmptyPanelElement(el, self.dragDropHelper(), self);
    }
    elementOnAfterRendering(el, this, true, this.koIsDragging());
};
__WEBPACK_IMPORTED_MODULE_3_survey_knockout__["Panel"].prototype["onSelectedElementChanged"] = function () {
    if (getSurvey(this) == null)
        return;
    this.koIsSelected(getSurvey(this)["selectedElementValue"] == this);
};
if (!!__WEBPACK_IMPORTED_MODULE_3_survey_knockout__["FlowPanel"]) {
    __WEBPACK_IMPORTED_MODULE_3_survey_knockout__["FlowPanel"].prototype["onCreating"] = function () {
        //TODO
        this.placeHolder = "Enter here text or drop a question";
        elementOnCreating(this);
    };
    __WEBPACK_IMPORTED_MODULE_3_survey_knockout__["FlowPanel"].prototype["onAfterRenderPanel"] = function (el) {
        if (!getSurvey(this).isDesignMode)
            return;
        elementOnAfterRendering(el, this, true, this.koIsDragging());
        var pnlEl = el.querySelector("f-panel");
        if (!!pnlEl) {
            if (!!pnlEl.className) {
                pnlEl.className += " svd_flowpanel";
            }
            else {
                pnlEl.className = "svd_flowpanel";
            }
        }
    };
    __WEBPACK_IMPORTED_MODULE_3_survey_knockout__["FlowPanel"].prototype["onSelectedElementChanged"] = function () {
        if (getSurvey(this) == null)
            return;
        this.koIsSelected(getSurvey(this)["selectedElementValue"] == this);
    };
}
var questionPrototype = !!__WEBPACK_IMPORTED_MODULE_3_survey_knockout__["QuestionBase"]
    ? __WEBPACK_IMPORTED_MODULE_3_survey_knockout__["QuestionBase"].prototype
    : __WEBPACK_IMPORTED_MODULE_3_survey_knockout__["Question"].prototype;
questionPrototype["onCreating"] = function () {
    elementOnCreating(this);
};
questionPrototype["onAfterRenderQuestion"] = function (el) {
    if (!getSurvey(this).isDesignMode)
        return;
    elementOnAfterRendering(el, this, false, true);
};
questionPrototype["onSelectedElementChanged"] = function () {
    if (getSurvey(this) == null)
        return;
    this.koIsSelected(getSurvey(this)["selectedElementValue"] == this);
};
__WEBPACK_IMPORTED_MODULE_3_survey_knockout__["QuestionSelectBaseImplementor"].prototype["onCreated"] = function () {
    var q = this.question;
    this.question.registerFunctionOnPropertyValueChanged("choices", function () {
        q["koElementType"].notifySubscribers();
    });
};


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__editorLocalization__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ObjType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SurveyHelper; });

var ObjType;
(function (ObjType) {
    ObjType[ObjType["Unknown"] = 0] = "Unknown";
    ObjType[ObjType["Survey"] = 1] = "Survey";
    ObjType[ObjType["Page"] = 2] = "Page";
    ObjType[ObjType["Panel"] = 3] = "Panel";
    ObjType[ObjType["Question"] = 4] = "Question";
})(ObjType || (ObjType = {}));
var SurveyHelper = /** @class */ (function () {
    function SurveyHelper() {
    }
    SurveyHelper.getNewPageName = function (objs) {
        return SurveyHelper.getNewName(objs, __WEBPACK_IMPORTED_MODULE_0__editorLocalization__["a" /* editorLocalization */].getString("ed.newPageName"));
    };
    SurveyHelper.getNewQuestionName = function (objs) {
        return SurveyHelper.getNewName(objs, __WEBPACK_IMPORTED_MODULE_0__editorLocalization__["a" /* editorLocalization */].getString("ed.newQuestionName"));
    };
    SurveyHelper.getNewPanelName = function (objs) {
        return SurveyHelper.getNewName(objs, __WEBPACK_IMPORTED_MODULE_0__editorLocalization__["a" /* editorLocalization */].getString("ed.newPanelName"));
    };
    SurveyHelper.generateNewName = function (name) {
        var pos = name.length;
        while (pos > 0 && name[pos - 1] >= "0" && name[pos - 1] <= "9") {
            pos--;
        }
        var base = name.substr(0, pos);
        var num = 0;
        if (pos < name.length) {
            num = parseInt(name.substr(pos));
        }
        num++;
        return base + num;
    };
    SurveyHelper.getNewName = function (objs, baseName) {
        var hash = {};
        for (var i = 0; i < objs.length; i++) {
            hash[objs[i].name] = true;
        }
        var num = 1;
        while (true) {
            if (!hash[baseName + num.toString()])
                break;
            num++;
        }
        return baseName + num.toString();
    };
    SurveyHelper.getObjectType = function (obj) {
        if (!obj || !obj["getType"])
            return ObjType.Unknown;
        if (obj.getType() == "page")
            return ObjType.Page;
        if (obj.getType() == "panel")
            return ObjType.Panel;
        if (obj.getType() == "survey")
            return ObjType.Survey;
        if (obj["name"])
            return ObjType.Question;
        return ObjType.Unknown;
    };
    SurveyHelper.getObjectTypeStr = function (obj) {
        var objType = SurveyHelper.getObjectType(obj);
        if (objType === ObjType.Survey)
            return "survey";
        if (objType === ObjType.Page)
            return "page";
        if (objType === ObjType.Panel)
            return "panel";
        if (objType === ObjType.Question)
            return "question";
        return "unknown";
    };
    SurveyHelper.getObjectName = function (obj, showObjectTitle) {
        if (showObjectTitle === void 0) { showObjectTitle = false; }
        if (showObjectTitle && obj["title"])
            return obj["title"];
        if (obj["name"])
            return obj["name"];
        var objType = SurveyHelper.getObjectType(obj);
        if (objType != ObjType.Page)
            return "";
        var data = obj["data"];
        if (!data)
            data = obj["survey"]; //TODO
        var index = data.pages.indexOf(obj);
        return "[Page " + (index + 1) + "]";
    };
    SurveyHelper.getElements = function (element, includeHidden) {
        if (includeHidden === void 0) { includeHidden = false; }
        if (!element)
            return [];
        if (element.getElementsInDesign)
            return element.getElementsInDesign(includeHidden);
        if (element.elements)
            return element.elements;
        return [];
    };
    SurveyHelper.isPropertyVisible = function (obj, property, onCanShowPropertyCallback) {
        if (onCanShowPropertyCallback === void 0) { onCanShowPropertyCallback = null; }
        if (!property || !property.visible)
            return false;
        if (!!property.isVisible &&
            !!obj.getLayoutType &&
            !property.isVisible(obj.getLayoutType()))
            return false;
        if (onCanShowPropertyCallback && !onCanShowPropertyCallback(obj, property))
            return false;
        return true;
    };
    SurveyHelper.scrollIntoViewIfNeeded = function (el, pageEl) {
        if (!el || !el.scrollIntoView || !pageEl)
            return;
        var rect = el.getBoundingClientRect();
        var height = pageEl.offsetParent
            ? pageEl.offsetParent.clientHeight
            : pageEl.clientHeight;
        if (rect.top < pageEl.offsetTop) {
            el.scrollIntoView();
        }
        else {
            if (rect.bottom > height &&
                (rect.top > pageEl.offsetTop + height || rect.height < height)) {
                el.scrollIntoView(false);
            }
        }
    };
    return SurveyHelper;
}());



/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_knockout__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__propertyEditorBase__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__propertyEditorFactory__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__editorLocalization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_utils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rmodal__ = __webpack_require__(36);
/* unused harmony export SurveyPropertyModalEditorCustomWidget */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SurveyPropertyModalEditor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SurveyPropertyTextEditor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SurveyPropertyHtmlEditor; });







var SurveyPropertyModalEditorCustomWidget = /** @class */ (function () {
    function SurveyPropertyModalEditorCustomWidget(json) {
        this.json = json;
    }
    SurveyPropertyModalEditorCustomWidget.prototype.afterRender = function (editor, el) {
        if (this.json && this.json.afterRender) {
            if (!el.id) {
                el.id =
                    SurveyPropertyModalEditorCustomWidget.customWidgetName +
                        SurveyPropertyModalEditorCustomWidget.customWidgetId;
                SurveyPropertyModalEditorCustomWidget.customWidgetId++;
            }
            this.json.afterRender(editor, el);
            if (this.json.destroy) {
                var self = this;
                __WEBPACK_IMPORTED_MODULE_1_knockout__["utils"].domNodeDisposal.addDisposeCallback(el, function () {
                    self.destroy(editor, el);
                });
            }
        }
    };
    SurveyPropertyModalEditorCustomWidget.prototype.destroy = function (editor, el) {
        if (this.json && this.json.destroy) {
            this.json.destroy(editor, el);
        }
    };
    SurveyPropertyModalEditorCustomWidget.customWidgetId = 1;
    SurveyPropertyModalEditorCustomWidget.customWidgetName = "modalEditorCustomWidget";
    return SurveyPropertyModalEditorCustomWidget;
}());

var SurveyPropertyModalEditor = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SurveyPropertyModalEditor, _super);
    function SurveyPropertyModalEditor(property) {
        var _this = _super.call(this, property) || this;
        _this.isShowingModalValue = false;
        _this.koTitleCaption = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"]("");
        _this.koHtmlTop = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"]("");
        _this.koHtmlBottom = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"]("");
        if (_this.property) {
            _this.koTitleCaption(__WEBPACK_IMPORTED_MODULE_4__editorLocalization__["a" /* editorLocalization */]
                .getString("pe.editProperty")["format"](_this.property.name));
        }
        var name = property ? property.name : "";
        _this.modalName =
            "modelEditor" + _this.editorType + SurveyPropertyModalEditor.idCounter;
        SurveyPropertyModalEditor.idCounter++;
        _this.modalNameTarget = "#" + _this.modalName;
        var self = _this;
        _this.koShowApplyButton = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"](true);
        self.onHideModal = function () { };
        self.onApplyClick = function () {
            self.apply();
        };
        self.onOkClick = function () {
            self.apply();
            if (!self.koHasError())
                self.onHideModal();
        };
        self.onResetClick = function () {
            self.updateValue();
            self.onHideModal();
        };
        self.onShowModal = function () {
            self.beforeShow();
            var modal = new __WEBPACK_IMPORTED_MODULE_6_rmodal__["a" /* default */](document.querySelector(self.modalNameTarget), {
                bodyClass: "",
                closeTimeout: 100,
                dialogOpenClass: "animated fadeInDown",
                focus: false
            });
            modal.open();
            document.addEventListener("keydown", function (ev) {
                modal.keydown(ev);
            }, false);
            self.onHideModal = function () {
                self.beforeCloseModal();
                modal.close();
            };
            if (!!this.elements) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_utils__["c" /* focusFirstControl */])(this.elements);
            }
        };
        self.koAfterRender = function (el, con) {
            return self.afterRender(el, con);
        };
        return _this;
    }
    SurveyPropertyModalEditor.registerCustomWidget = function (editorType, json) {
        if (!SurveyPropertyModalEditor.customWidgets)
            SurveyPropertyModalEditor.customWidgets = {};
        SurveyPropertyModalEditor.customWidgets[editorType] = new SurveyPropertyModalEditorCustomWidget(json);
    };
    SurveyPropertyModalEditor.getCustomWidget = function (editorType) {
        if (!SurveyPropertyModalEditor.customWidgets)
            return null;
        return SurveyPropertyModalEditor.customWidgets[editorType];
    };
    SurveyPropertyModalEditor.prototype.setup = function () {
        _super.prototype.setup.call(this);
        this.beforeShow();
    };
    Object.defineProperty(SurveyPropertyModalEditor.prototype, "isModal", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyPropertyModalEditor.prototype, "isShowingModal", {
        get: function () {
            return this.isShowingModalValue;
        },
        enumerable: true,
        configurable: true
    });
    SurveyPropertyModalEditor.prototype.beforeShow = function () {
        this.isShowingModalValue = true;
        this.updateValue();
    };
    SurveyPropertyModalEditor.prototype.beforeCloseModal = function () {
        this.isShowingModalValue = false;
    };
    SurveyPropertyModalEditor.prototype.onOptionsChanged = function () {
        this.koShowApplyButton = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"](!this.options || this.options.showApplyButtonInEditors);
    };
    SurveyPropertyModalEditor.prototype.setObject = function (value) {
        this.editingObject = value;
        _super.prototype.setObject.call(this, value);
        if (this.options && this.property) {
            var html = this.options.onPropertyEditorModalShowDescriptionCallback(this.property.name, value);
            if (html) {
                if (html.top)
                    this.koHtmlTop(html.top);
                if (html.bottom)
                    this.koHtmlBottom(html.bottom);
            }
        }
    };
    Object.defineProperty(SurveyPropertyModalEditor.prototype, "isEditable", {
        get: function () {
            return false;
        },
        enumerable: true,
        configurable: true
    });
    SurveyPropertyModalEditor.prototype.afterRender = function (elements, con) {
        this.elements = elements;
        var customWidget = SurveyPropertyModalEditor.getCustomWidget(this.editorType);
        if (!!customWidget) {
            var el = this.GetFirstNonTextElement(elements);
            var tEl = elements[0];
            if (tEl.nodeName == "#text")
                tEl.data = "";
            tEl = elements[elements.length - 1];
            if (tEl.nodeName == "#text")
                tEl.data = "";
            customWidget.afterRender(this, el);
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_utils__["c" /* focusFirstControl */])(elements);
    };
    SurveyPropertyModalEditor.prototype.GetFirstNonTextElement = function (elements) {
        if (!elements || !elements.length)
            return;
        for (var i = 0; i < elements.length; i++) {
            if (elements[i].nodeName != "#text" && elements[i].nodeName != "#comment")
                return elements[i];
        }
        return null;
    };
    SurveyPropertyModalEditor.idCounter = 1;
    return SurveyPropertyModalEditor;
}(__WEBPACK_IMPORTED_MODULE_2__propertyEditorBase__["a" /* SurveyPropertyEditorBase */]));

var SurveyPropertyTextEditor = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SurveyPropertyTextEditor, _super);
    function SurveyPropertyTextEditor(property) {
        var _this = _super.call(this, property) || this;
        _this.koTextValue = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"]();
        var self = _this;
        _this.koTextValue.subscribe(function (newValue) {
            self.onkoTextValueChanged(newValue);
        });
        return _this;
    }
    Object.defineProperty(SurveyPropertyTextEditor.prototype, "editorType", {
        get: function () {
            return "text";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyPropertyTextEditor.prototype, "isEditable", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    SurveyPropertyTextEditor.prototype.getValueText = function (value) {
        if (!value)
            return null;
        var str = value;
        if (str.length > 20) {
            str = str.substr(0, 20) + "...";
        }
        return str;
    };
    SurveyPropertyTextEditor.prototype.onkoTextValueChanged = function (newValue) { };
    SurveyPropertyTextEditor.prototype.onValueChanged = function () {
        this.koTextValue(this.editingValue);
    };
    SurveyPropertyTextEditor.prototype.onBeforeApply = function () {
        this.setValueCore(this.koTextValue());
    };
    return SurveyPropertyTextEditor;
}(SurveyPropertyModalEditor));

var SurveyPropertyHtmlEditor = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SurveyPropertyHtmlEditor, _super);
    function SurveyPropertyHtmlEditor(property) {
        return _super.call(this, property) || this;
    }
    Object.defineProperty(SurveyPropertyHtmlEditor.prototype, "editorType", {
        get: function () {
            return "html";
        },
        enumerable: true,
        configurable: true
    });
    return SurveyPropertyHtmlEditor;
}(SurveyPropertyTextEditor));

__WEBPACK_IMPORTED_MODULE_3__propertyEditorFactory__["a" /* SurveyPropertyEditorFactory */].registerEditor("text", function (property) {
    return new SurveyPropertyTextEditor(property);
});
__WEBPACK_IMPORTED_MODULE_3__propertyEditorFactory__["a" /* SurveyPropertyEditorFactory */].registerEditor("html", function (property) {
    return new SurveyPropertyHtmlEditor(property);
});


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_knockout__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_knockout__);
/* harmony export (immutable) */ __webpack_exports__["a"] = getNextValue;
/* harmony export (immutable) */ __webpack_exports__["b"] = findParentNode;
/* harmony export (immutable) */ __webpack_exports__["c"] = focusFirstControl;

function getNextValue(prefix, values) {
    var index = values.reduce(function (res, val) {
        if (typeof val === "string" && val.indexOf(prefix) === 0) {
            try {
                var candidate = parseInt(val.substring(prefix.length));
                if (candidate >= res) {
                    return candidate + 1;
                }
            }
            catch (e) { }
        }
        return res;
    }, 1);
    return prefix + index;
}
function findParentNode(className, sourceNode) {
    var parent = sourceNode;
    while (!!parent && !parent.classList.contains(className)) {
        parent = parent.parentElement;
    }
    return parent;
}
function focusFirstControl(renderedElements) {
    for (var i = 0; i < renderedElements.length; i++) {
        if (typeof renderedElements[i].getElementsByClassName === "function") {
            var elements = (renderedElements[i].getElementsByClassName("form-control"));
            if (elements.length === 0 &&
                renderedElements[i].className.indexOf("form-control") !== -1) {
                elements = [renderedElements[i]];
            }
            if (elements.length > 0) {
                var element = elements[0];
                if (element.tagName.toLowerCase() !== "a") {
                    setTimeout(function () { return element.focus({ preventScroll: true }); }, 10);
                    break;
                }
            }
        }
    }
}
__WEBPACK_IMPORTED_MODULE_0_knockout__["bindingHandlers"]["trueclick"] = {
    init: function (element, valueAccessor, allBindingsAccessor) {
        element.onclick = function () { return true; };
    }
};
__WEBPACK_IMPORTED_MODULE_0_knockout__["bindingHandlers"]["key2click"] = {
    init: function (element, valueAccessor, allBindingsAccessor) {
        element.onkeyup = function (ev) {
            var char = ev.which || ev.keyCode;
            if (char === 13 || char === 32) {
                element.click();
            }
            else if (char === 27) {
                element.blur();
            }
        };
    }
};
__WEBPACK_IMPORTED_MODULE_0_knockout__["bindingHandlers"]["clickNoFocus"] = {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel) {
        element.onclick = function (ev) {
            valueAccessor().call(viewModel, viewModel, ev);
            setTimeout(function () {
                element.blur();
            }, 1);
            return true;
        };
    }
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**!
 * Sortable
 * @author	RubaXa   <trash@rubaxa.org>
 * @license MIT
 */

(function sortableModule(factory) {
	"use strict";

	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	else if (typeof module != "undefined" && typeof module.exports != "undefined") {
		module.exports = factory();
	}
	else {
		/* jshint sub:true */
		window["Sortable"] = factory();
	}
})(function sortableFactory() {
	"use strict";

	if (typeof window == "undefined" || !window.document) {
		return function sortableError() {
			throw new Error("Sortable.js requires a window with a document");
		};
	}

	var dragEl,
		parentEl,
		ghostEl,
		cloneEl,
		rootEl,
		nextEl,
		lastDownEl,

		scrollEl,
		scrollParentEl,
		scrollCustomFn,

		lastEl,
		lastCSS,
		lastParentCSS,

		oldIndex,
		newIndex,

		activeGroup,
		putSortable,

		autoScroll = {},

		tapEvt,
		touchEvt,

		moved,

		/** @const */
		R_SPACE = /\s+/g,
		R_FLOAT = /left|right|inline/,

		expando = 'Sortable' + (new Date).getTime(),

		win = window,
		document = win.document,
		parseInt = win.parseInt,

		$ = __webpack_provided_window_dot_jQuery || win.Zepto,
		Polymer = win.Polymer,

		captureMode = false,

		supportDraggable = !!('draggable' in document.createElement('div')),
		supportCssPointerEvents = (function (el) {
			// false when IE11
			if (!!navigator.userAgent.match(/Trident.*rv[ :]?11\./)) {
				return false;
			}
			el = document.createElement('x');
			el.style.cssText = 'pointer-events:auto';
			return el.style.pointerEvents === 'auto';
		})(),

		_silent = false,

		abs = Math.abs,
		min = Math.min,

		savedInputChecked = [],
		touchDragOverListeners = [],

		_autoScroll = _throttle(function (/**Event*/evt, /**Object*/options, /**HTMLElement*/rootEl) {
			// Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
			if (rootEl && options.scroll) {
				var _this = rootEl[expando],
					el,
					rect,
					sens = options.scrollSensitivity,
					speed = options.scrollSpeed,

					x = evt.clientX,
					y = evt.clientY,

					winWidth = window.innerWidth,
					winHeight = window.innerHeight,

					vx,
					vy,

					scrollOffsetX,
					scrollOffsetY
				;

				// Delect scrollEl
				if (scrollParentEl !== rootEl) {
					scrollEl = options.scroll;
					scrollParentEl = rootEl;
					scrollCustomFn = options.scrollFn;

					if (scrollEl === true) {
						scrollEl = rootEl;

						do {
							if ((scrollEl.offsetWidth < scrollEl.scrollWidth) ||
								(scrollEl.offsetHeight < scrollEl.scrollHeight)
							) {
								break;
							}
							/* jshint boss:true */
						} while (scrollEl = scrollEl.parentNode);
					}
				}

				if (scrollEl) {
					el = scrollEl;
					rect = scrollEl.getBoundingClientRect();
					vx = (abs(rect.right - x) <= sens) - (abs(rect.left - x) <= sens);
					vy = (abs(rect.bottom - y) <= sens) - (abs(rect.top - y) <= sens);
				}


				if (!(vx || vy)) {
					vx = (winWidth - x <= sens) - (x <= sens);
					vy = (winHeight - y <= sens) - (y <= sens);

					/* jshint expr:true */
					(vx || vy) && (el = win);
				}


				if (autoScroll.vx !== vx || autoScroll.vy !== vy || autoScroll.el !== el) {
					autoScroll.el = el;
					autoScroll.vx = vx;
					autoScroll.vy = vy;

					clearInterval(autoScroll.pid);

					if (el) {
						autoScroll.pid = setInterval(function () {
							scrollOffsetY = vy ? vy * speed : 0;
							scrollOffsetX = vx ? vx * speed : 0;

							if ('function' === typeof(scrollCustomFn)) {
								return scrollCustomFn.call(_this, scrollOffsetX, scrollOffsetY, evt);
							}

							if (el === win) {
								win.scrollTo(win.pageXOffset + scrollOffsetX, win.pageYOffset + scrollOffsetY);
							} else {
								el.scrollTop += scrollOffsetY;
								el.scrollLeft += scrollOffsetX;
							}
						}, 24);
					}
				}
			}
		}, 30),

		_prepareGroup = function (options) {
			function toFn(value, pull) {
				if (value === void 0 || value === true) {
					value = group.name;
				}

				if (typeof value === 'function') {
					return value;
				} else {
					return function (to, from) {
						var fromGroup = from.options.group.name;

						return pull
							? value
							: value && (value.join
								? value.indexOf(fromGroup) > -1
								: (fromGroup == value)
							);
					};
				}
			}

			var group = {};
			var originalGroup = options.group;

			if (!originalGroup || typeof originalGroup != 'object') {
				originalGroup = {name: originalGroup};
			}

			group.name = originalGroup.name;
			group.checkPull = toFn(originalGroup.pull, true);
			group.checkPut = toFn(originalGroup.put);
			group.revertClone = originalGroup.revertClone;

			options.group = group;
		}
	;


	/**
	 * @class  Sortable
	 * @param  {HTMLElement}  el
	 * @param  {Object}       [options]
	 */
	function Sortable(el, options) {
		if (!(el && el.nodeType && el.nodeType === 1)) {
			throw 'Sortable: `el` must be HTMLElement, and not ' + {}.toString.call(el);
		}

		this.el = el; // root element
		this.options = options = _extend({}, options);


		// Export instance
		el[expando] = this;

		// Default options
		var defaults = {
			group: Math.random(),
			sort: true,
			disabled: false,
			store: null,
			handle: null,
			scroll: true,
			scrollSensitivity: 30,
			scrollSpeed: 10,
			draggable: /[uo]l/i.test(el.nodeName) ? 'li' : '>*',
			ghostClass: 'sortable-ghost',
			chosenClass: 'sortable-chosen',
			dragClass: 'sortable-drag',
			ignore: 'a, img',
			filter: null,
			preventOnFilter: true,
			animation: 0,
			setData: function (dataTransfer, dragEl) {
				dataTransfer.setData('Text', dragEl.textContent);
			},
			dropBubble: false,
			dragoverBubble: false,
			dataIdAttr: 'data-id',
			delay: 0,
			forceFallback: false,
			fallbackClass: 'sortable-fallback',
			fallbackOnBody: false,
			fallbackTolerance: 0,
			fallbackOffset: {x: 0, y: 0}
		};


		// Set default options
		for (var name in defaults) {
			!(name in options) && (options[name] = defaults[name]);
		}

		_prepareGroup(options);

		// Bind all private methods
		for (var fn in this) {
			if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
				this[fn] = this[fn].bind(this);
			}
		}

		// Setup drag mode
		this.nativeDraggable = options.forceFallback ? false : supportDraggable;

		// Bind events
		_on(el, 'mousedown', this._onTapStart);
		_on(el, 'touchstart', this._onTapStart);
		_on(el, 'pointerdown', this._onTapStart);

		if (this.nativeDraggable) {
			_on(el, 'dragover', this);
			_on(el, 'dragenter', this);
		}

		touchDragOverListeners.push(this._onDragOver);

		// Restore sorting
		options.store && this.sort(options.store.get(this));
	}


	Sortable.prototype = /** @lends Sortable.prototype */ {
		constructor: Sortable,

		_onTapStart: function (/** Event|TouchEvent */evt) {
			var _this = this,
				el = this.el,
				options = this.options,
				preventOnFilter = options.preventOnFilter,
				type = evt.type,
				touch = evt.touches && evt.touches[0],
				target = (touch || evt).target,
				originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0]) || target,
				filter = options.filter,
				startIndex;

			_saveInputCheckedState(el);


			// Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.
			if (dragEl) {
				return;
			}

			if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) {
				return; // only left button or enabled
			}


			target = _closest(target, options.draggable, el);

			if (!target) {
				return;
			}

			if (lastDownEl === target) {
				// Ignoring duplicate `down`
				return;
			}

			// Get the index of the dragged element within its parent
			startIndex = _index(target, options.draggable);

			// Check filter
			if (typeof filter === 'function') {
				if (filter.call(this, evt, target, this)) {
					_dispatchEvent(_this, originalTarget, 'filter', target, el, startIndex);
					preventOnFilter && evt.preventDefault();
					return; // cancel dnd
				}
			}
			else if (filter) {
				filter = filter.split(',').some(function (criteria) {
					criteria = _closest(originalTarget, criteria.trim(), el);

					if (criteria) {
						_dispatchEvent(_this, criteria, 'filter', target, el, startIndex);
						return true;
					}
				});

				if (filter) {
					preventOnFilter && evt.preventDefault();
					return; // cancel dnd
				}
			}

			if (options.handle && !_closest(originalTarget, options.handle, el)) {
				return;
			}

			// Prepare `dragstart`
			this._prepareDragStart(evt, touch, target, startIndex);
		},

		_prepareDragStart: function (/** Event */evt, /** Touch */touch, /** HTMLElement */target, /** Number */startIndex) {
			var _this = this,
				el = _this.el,
				options = _this.options,
				ownerDocument = el.ownerDocument,
				dragStartFn;

			if (target && !dragEl && (target.parentNode === el)) {
				tapEvt = evt;

				rootEl = el;
				dragEl = target;
				parentEl = dragEl.parentNode;
				nextEl = dragEl.nextSibling;
				lastDownEl = target;
				activeGroup = options.group;
				oldIndex = startIndex;

				this._lastX = (touch || evt).clientX;
				this._lastY = (touch || evt).clientY;

				dragEl.style['will-change'] = 'transform';

				dragStartFn = function () {
					// Delayed drag has been triggered
					// we can re-enable the events: touchmove/mousemove
					_this._disableDelayedDrag();

					// Make the element draggable
					dragEl.draggable = _this.nativeDraggable;

					// Chosen item
					_toggleClass(dragEl, options.chosenClass, true);

					// Bind the events: dragstart/dragend
					_this._triggerDragStart(evt, touch);

					// Drag start event
					_dispatchEvent(_this, rootEl, 'choose', dragEl, rootEl, oldIndex);
				};

				// Disable "draggable"
				options.ignore.split(',').forEach(function (criteria) {
					_find(dragEl, criteria.trim(), _disableDraggable);
				});

				_on(ownerDocument, 'mouseup', _this._onDrop);
				_on(ownerDocument, 'touchend', _this._onDrop);
				_on(ownerDocument, 'touchcancel', _this._onDrop);
				_on(ownerDocument, 'pointercancel', _this._onDrop);
				_on(ownerDocument, 'selectstart', _this);

				if (options.delay) {
					// If the user moves the pointer or let go the click or touch
					// before the delay has been reached:
					// disable the delayed drag
					_on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
					_on(ownerDocument, 'touchend', _this._disableDelayedDrag);
					_on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
					_on(ownerDocument, 'mousemove', _this._disableDelayedDrag);
					_on(ownerDocument, 'touchmove', _this._disableDelayedDrag);
					_on(ownerDocument, 'pointermove', _this._disableDelayedDrag);

					_this._dragStartTimer = setTimeout(dragStartFn, options.delay);
				} else {
					dragStartFn();
				}


			}
		},

		_disableDelayedDrag: function () {
			var ownerDocument = this.el.ownerDocument;

			clearTimeout(this._dragStartTimer);
			_off(ownerDocument, 'mouseup', this._disableDelayedDrag);
			_off(ownerDocument, 'touchend', this._disableDelayedDrag);
			_off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
			_off(ownerDocument, 'mousemove', this._disableDelayedDrag);
			_off(ownerDocument, 'touchmove', this._disableDelayedDrag);
			_off(ownerDocument, 'pointermove', this._disableDelayedDrag);
		},

		_triggerDragStart: function (/** Event */evt, /** Touch */touch) {
			touch = touch || (evt.pointerType == 'touch' ? evt : null);

			if (touch) {
				// Touch device support
				tapEvt = {
					target: dragEl,
					clientX: touch.clientX,
					clientY: touch.clientY
				};

				this._onDragStart(tapEvt, 'touch');
			}
			else if (!this.nativeDraggable) {
				this._onDragStart(tapEvt, true);
			}
			else {
				_on(dragEl, 'dragend', this);
				_on(rootEl, 'dragstart', this._onDragStart);
			}

			try {
				if (document.selection) {
					// Timeout neccessary for IE9
					setTimeout(function () {
						document.selection.empty();
					});
				} else {
					window.getSelection().removeAllRanges();
				}
			} catch (err) {
			}
		},

		_dragStarted: function () {
			if (rootEl && dragEl) {
				var options = this.options;

				// Apply effect
				_toggleClass(dragEl, options.ghostClass, true);
				_toggleClass(dragEl, options.dragClass, false);

				Sortable.active = this;

				// Drag start event
				_dispatchEvent(this, rootEl, 'start', dragEl, rootEl, oldIndex);
			} else {
				this._nulling();
			}
		},

		_emulateDragOver: function () {
			if (touchEvt) {
				if (this._lastX === touchEvt.clientX && this._lastY === touchEvt.clientY) {
					return;
				}

				this._lastX = touchEvt.clientX;
				this._lastY = touchEvt.clientY;

				if (!supportCssPointerEvents) {
					_css(ghostEl, 'display', 'none');
				}

				var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY),
					parent = target,
					i = touchDragOverListeners.length;

				if (parent) {
					do {
						if (parent[expando]) {
							while (i--) {
								touchDragOverListeners[i]({
									clientX: touchEvt.clientX,
									clientY: touchEvt.clientY,
									target: target,
									rootEl: parent
								});
							}

							break;
						}

						target = parent; // store last element
					}
					/* jshint boss:true */
					while (parent = parent.parentNode);
				}

				if (!supportCssPointerEvents) {
					_css(ghostEl, 'display', '');
				}
			}
		},


		_onTouchMove: function (/**TouchEvent*/evt) {
			if (tapEvt) {
				var	options = this.options,
					fallbackTolerance = options.fallbackTolerance,
					fallbackOffset = options.fallbackOffset,
					touch = evt.touches ? evt.touches[0] : evt,
					dx = (touch.clientX - tapEvt.clientX) + fallbackOffset.x,
					dy = (touch.clientY - tapEvt.clientY) + fallbackOffset.y,
					translate3d = evt.touches ? 'translate3d(' + dx + 'px,' + dy + 'px,0)' : 'translate(' + dx + 'px,' + dy + 'px)';

				// only set the status to dragging, when we are actually dragging
				if (!Sortable.active) {
					if (fallbackTolerance &&
						min(abs(touch.clientX - this._lastX), abs(touch.clientY - this._lastY)) < fallbackTolerance
					) {
						return;
					}

					this._dragStarted();
				}

				// as well as creating the ghost element on the document body
				this._appendGhost();

				moved = true;
				touchEvt = touch;

				_css(ghostEl, 'webkitTransform', translate3d);
				_css(ghostEl, 'mozTransform', translate3d);
				_css(ghostEl, 'msTransform', translate3d);
				_css(ghostEl, 'transform', translate3d);

				evt.preventDefault();
			}
		},

		_appendGhost: function () {
			if (!ghostEl) {
				var rect = dragEl.getBoundingClientRect(),
					css = _css(dragEl),
					options = this.options,
					ghostRect;

				ghostEl = dragEl.cloneNode(true);

				_toggleClass(ghostEl, options.ghostClass, false);
				_toggleClass(ghostEl, options.fallbackClass, true);
				_toggleClass(ghostEl, options.dragClass, true);

				_css(ghostEl, 'top', rect.top - parseInt(css.marginTop, 10));
				_css(ghostEl, 'left', rect.left - parseInt(css.marginLeft, 10));
				_css(ghostEl, 'width', rect.width);
				_css(ghostEl, 'height', rect.height);
				_css(ghostEl, 'opacity', '0.8');
				_css(ghostEl, 'position', 'fixed');
				_css(ghostEl, 'zIndex', '100000');
				_css(ghostEl, 'pointerEvents', 'none');

				options.fallbackOnBody && document.body.appendChild(ghostEl) || rootEl.appendChild(ghostEl);

				// Fixing dimensions.
				ghostRect = ghostEl.getBoundingClientRect();
				_css(ghostEl, 'width', rect.width * 2 - ghostRect.width);
				_css(ghostEl, 'height', rect.height * 2 - ghostRect.height);
			}
		},

		_onDragStart: function (/**Event*/evt, /**boolean*/useFallback) {
			var dataTransfer = evt.dataTransfer,
				options = this.options;

			this._offUpEvents();

			if (activeGroup.checkPull(this, this, dragEl, evt)) {
				cloneEl = _clone(dragEl);

				cloneEl.draggable = false;
				cloneEl.style['will-change'] = '';

				_css(cloneEl, 'display', 'none');
				_toggleClass(cloneEl, this.options.chosenClass, false);

				rootEl.insertBefore(cloneEl, dragEl);
				_dispatchEvent(this, rootEl, 'clone', dragEl);
			}

			_toggleClass(dragEl, options.dragClass, true);

			if (useFallback) {
				if (useFallback === 'touch') {
					// Bind touch events
					_on(document, 'touchmove', this._onTouchMove);
					_on(document, 'touchend', this._onDrop);
					_on(document, 'touchcancel', this._onDrop);
					_on(document, 'pointermove', this._onTouchMove);
					_on(document, 'pointerup', this._onDrop);
				} else {
					// Old brwoser
					_on(document, 'mousemove', this._onTouchMove);
					_on(document, 'mouseup', this._onDrop);
				}

				this._loopId = setInterval(this._emulateDragOver, 50);
			}
			else {
				if (dataTransfer) {
					dataTransfer.effectAllowed = 'move';
					options.setData && options.setData.call(this, dataTransfer, dragEl);
				}

				_on(document, 'drop', this);
				setTimeout(this._dragStarted, 0);
			}
		},

		_onDragOver: function (/**Event*/evt) {
			var el = this.el,
				target,
				dragRect,
				targetRect,
				revert,
				options = this.options,
				group = options.group,
				activeSortable = Sortable.active,
				isOwner = (activeGroup === group),
				isMovingBetweenSortable = false,
				canSort = options.sort;

			if (evt.preventDefault !== void 0) {
				evt.preventDefault();
				!options.dragoverBubble && evt.stopPropagation();
			}

			if (dragEl.animated) {
				return;
			}

			moved = true;

			if (activeSortable && !options.disabled &&
				(isOwner
					? canSort || (revert = !rootEl.contains(dragEl)) // Reverting item into the original list
					: (
						putSortable === this ||
						(
							(activeSortable.lastPullMode = activeGroup.checkPull(this, activeSortable, dragEl, evt)) &&
							group.checkPut(this, activeSortable, dragEl, evt)
						)
					)
				) &&
				(evt.rootEl === void 0 || evt.rootEl === this.el) // touch fallback
			) {
				// Smart auto-scrolling
				_autoScroll(evt, options, this.el);

				if (_silent) {
					return;
				}

				target = _closest(evt.target, options.draggable, el);
				dragRect = dragEl.getBoundingClientRect();

				if (putSortable !== this) {
					putSortable = this;
					isMovingBetweenSortable = true;
				}

				if (revert) {
					_cloneHide(activeSortable, true);
					parentEl = rootEl; // actualization

					if (cloneEl || nextEl) {
						rootEl.insertBefore(dragEl, cloneEl || nextEl);
					}
					else if (!canSort) {
						rootEl.appendChild(dragEl);
					}

					return;
				}


				if ((el.children.length === 0) || (el.children[0] === ghostEl) ||
					(el === evt.target) && (_ghostIsLast(el, evt))
				) {
					//assign target only if condition is true
					if (el.children.length !== 0 && el.children[0] !== ghostEl && el === evt.target) {
						target = el.lastElementChild;
					}

					if (target) {
						if (target.animated) {
							return;
						}

						targetRect = target.getBoundingClientRect();
					}

					_cloneHide(activeSortable, isOwner);

					if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt) !== false) {
						if (!dragEl.contains(el)) {
							el.appendChild(dragEl);
							parentEl = el; // actualization
						}

						this._animate(dragRect, dragEl);
						target && this._animate(targetRect, target);
					}
				}
				else if (target && !target.animated && target !== dragEl && (target.parentNode[expando] !== void 0)) {
					if (lastEl !== target) {
						lastEl = target;
						lastCSS = _css(target);
						lastParentCSS = _css(target.parentNode);
					}

					targetRect = target.getBoundingClientRect();

					var width = targetRect.right - targetRect.left,
						height = targetRect.bottom - targetRect.top,
						floating = R_FLOAT.test(lastCSS.cssFloat + lastCSS.display)
							|| (lastParentCSS.display == 'flex' && lastParentCSS['flex-direction'].indexOf('row') === 0),
						isWide = (target.offsetWidth > dragEl.offsetWidth),
						isLong = (target.offsetHeight > dragEl.offsetHeight),
						halfway = (floating ? (evt.clientX - targetRect.left) / width : (evt.clientY - targetRect.top) / height) > 0.5,
						nextSibling = target.nextElementSibling,
						after = false
					;

					if (floating) {
						var elTop = dragEl.offsetTop,
							tgTop = target.offsetTop;

						if (elTop === tgTop) {
							after = (target.previousElementSibling === dragEl) && !isWide || halfway && isWide;
						}
						else if (target.previousElementSibling === dragEl || dragEl.previousElementSibling === target) {
							after = (evt.clientY - targetRect.top) / height > 0.5;
						} else {
							after = tgTop > elTop;
						}
						} else if (!isMovingBetweenSortable) {
						after = (nextSibling !== dragEl) && !isLong || halfway && isLong;
					}

					var moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, after);

					if (moveVector !== false) {
						if (moveVector === 1 || moveVector === -1) {
							after = (moveVector === 1);
						}

						_silent = true;
						setTimeout(_unsilent, 30);

						_cloneHide(activeSortable, isOwner);

						if (!dragEl.contains(el)) {
							if (after && !nextSibling) {
								el.appendChild(dragEl);
							} else {
								target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
							}
						}

						parentEl = dragEl.parentNode; // actualization

						this._animate(dragRect, dragEl);
						this._animate(targetRect, target);
					}
				}
			}
		},

		_animate: function (prevRect, target) {
			var ms = this.options.animation;

			if (ms) {
				var currentRect = target.getBoundingClientRect();

				if (prevRect.nodeType === 1) {
					prevRect = prevRect.getBoundingClientRect();
				}

				_css(target, 'transition', 'none');
				_css(target, 'transform', 'translate3d('
					+ (prevRect.left - currentRect.left) + 'px,'
					+ (prevRect.top - currentRect.top) + 'px,0)'
				);

				target.offsetWidth; // repaint

				_css(target, 'transition', 'all ' + ms + 'ms');
				_css(target, 'transform', 'translate3d(0,0,0)');

				clearTimeout(target.animated);
				target.animated = setTimeout(function () {
					_css(target, 'transition', '');
					_css(target, 'transform', '');
					target.animated = false;
				}, ms);
			}
		},

		_offUpEvents: function () {
			var ownerDocument = this.el.ownerDocument;

			_off(document, 'touchmove', this._onTouchMove);
			_off(document, 'pointermove', this._onTouchMove);
			_off(ownerDocument, 'mouseup', this._onDrop);
			_off(ownerDocument, 'touchend', this._onDrop);
			_off(ownerDocument, 'pointerup', this._onDrop);
			_off(ownerDocument, 'touchcancel', this._onDrop);
			_off(ownerDocument, 'pointercancel', this._onDrop);
			_off(ownerDocument, 'selectstart', this);
		},

		_onDrop: function (/**Event*/evt) {
			var el = this.el,
				options = this.options;

			clearInterval(this._loopId);
			clearInterval(autoScroll.pid);
			clearTimeout(this._dragStartTimer);

			// Unbind events
			_off(document, 'mousemove', this._onTouchMove);

			if (this.nativeDraggable) {
				_off(document, 'drop', this);
				_off(el, 'dragstart', this._onDragStart);
			}

			this._offUpEvents();

			if (evt) {
				if (moved) {
					evt.preventDefault();
					!options.dropBubble && evt.stopPropagation();
				}

				ghostEl && ghostEl.parentNode && ghostEl.parentNode.removeChild(ghostEl);

				if (rootEl === parentEl || Sortable.active.lastPullMode !== 'clone') {
					// Remove clone
					cloneEl && cloneEl.parentNode && cloneEl.parentNode.removeChild(cloneEl);
				}

				if (dragEl) {
					if (this.nativeDraggable) {
						_off(dragEl, 'dragend', this);
					}

					_disableDraggable(dragEl);
					dragEl.style['will-change'] = '';

					// Remove class's
					_toggleClass(dragEl, this.options.ghostClass, false);
					_toggleClass(dragEl, this.options.chosenClass, false);

					// Drag stop event
					_dispatchEvent(this, rootEl, 'unchoose', dragEl, rootEl, oldIndex);

					if (rootEl !== parentEl) {
						newIndex = _index(dragEl, options.draggable);

						if (newIndex >= 0) {
							// Add event
							_dispatchEvent(null, parentEl, 'add', dragEl, rootEl, oldIndex, newIndex);

							// Remove event
							_dispatchEvent(this, rootEl, 'remove', dragEl, rootEl, oldIndex, newIndex);

							// drag from one list and drop into another
							_dispatchEvent(null, parentEl, 'sort', dragEl, rootEl, oldIndex, newIndex);
							_dispatchEvent(this, rootEl, 'sort', dragEl, rootEl, oldIndex, newIndex);
						}
					}
					else {
						if (dragEl.nextSibling !== nextEl) {
							// Get the index of the dragged element within its parent
							newIndex = _index(dragEl, options.draggable);

							if (newIndex >= 0) {
								// drag & drop within the same list
								_dispatchEvent(this, rootEl, 'update', dragEl, rootEl, oldIndex, newIndex);
								_dispatchEvent(this, rootEl, 'sort', dragEl, rootEl, oldIndex, newIndex);
							}
						}
					}

					if (Sortable.active) {
						/* jshint eqnull:true */
						if (newIndex == null || newIndex === -1) {
							newIndex = oldIndex;
						}

						_dispatchEvent(this, rootEl, 'end', dragEl, rootEl, oldIndex, newIndex);

						// Save sorting
						this.save();
					}
				}

			}

			this._nulling();
		},

		_nulling: function() {
			rootEl =
			dragEl =
			parentEl =
			ghostEl =
			nextEl =
			cloneEl =
			lastDownEl =

			scrollEl =
			scrollParentEl =

			tapEvt =
			touchEvt =

			moved =
			newIndex =

			lastEl =
			lastCSS =

			putSortable =
			activeGroup =
			Sortable.active = null;

			savedInputChecked.forEach(function (el) {
				el.checked = true;
			});
			savedInputChecked.length = 0;
		},

		handleEvent: function (/**Event*/evt) {
			switch (evt.type) {
				case 'drop':
				case 'dragend':
					this._onDrop(evt);
					break;

				case 'dragover':
				case 'dragenter':
					if (dragEl) {
						this._onDragOver(evt);
						_globalDragOver(evt);
					}
					break;

				case 'selectstart':
					evt.preventDefault();
					break;
			}
		},


		/**
		 * Serializes the item into an array of string.
		 * @returns {String[]}
		 */
		toArray: function () {
			var order = [],
				el,
				children = this.el.children,
				i = 0,
				n = children.length,
				options = this.options;

			for (; i < n; i++) {
				el = children[i];
				if (_closest(el, options.draggable, this.el)) {
					order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
				}
			}

			return order;
		},


		/**
		 * Sorts the elements according to the array.
		 * @param  {String[]}  order  order of the items
		 */
		sort: function (order) {
			var items = {}, rootEl = this.el;

			this.toArray().forEach(function (id, i) {
				var el = rootEl.children[i];

				if (_closest(el, this.options.draggable, rootEl)) {
					items[id] = el;
				}
			}, this);

			order.forEach(function (id) {
				if (items[id]) {
					rootEl.removeChild(items[id]);
					rootEl.appendChild(items[id]);
				}
			});
		},


		/**
		 * Save the current sorting
		 */
		save: function () {
			var store = this.options.store;
			store && store.set(this);
		},


		/**
		 * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
		 * @param   {HTMLElement}  el
		 * @param   {String}       [selector]  default: `options.draggable`
		 * @returns {HTMLElement|null}
		 */
		closest: function (el, selector) {
			return _closest(el, selector || this.options.draggable, this.el);
		},


		/**
		 * Set/get option
		 * @param   {string} name
		 * @param   {*}      [value]
		 * @returns {*}
		 */
		option: function (name, value) {
			var options = this.options;

			if (value === void 0) {
				return options[name];
			} else {
				options[name] = value;

				if (name === 'group') {
					_prepareGroup(options);
				}
			}
		},


		/**
		 * Destroy
		 */
		destroy: function () {
			var el = this.el;

			el[expando] = null;

			_off(el, 'mousedown', this._onTapStart);
			_off(el, 'touchstart', this._onTapStart);
			_off(el, 'pointerdown', this._onTapStart);

			if (this.nativeDraggable) {
				_off(el, 'dragover', this);
				_off(el, 'dragenter', this);
			}

			// Remove draggable attributes
			Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function (el) {
				el.removeAttribute('draggable');
			});

			touchDragOverListeners.splice(touchDragOverListeners.indexOf(this._onDragOver), 1);

			this._onDrop();

			this.el = el = null;
		}
	};


	function _cloneHide(sortable, state) {
		if (sortable.lastPullMode !== 'clone') {
			state = true;
		}

		if (cloneEl && (cloneEl.state !== state)) {
			_css(cloneEl, 'display', state ? 'none' : '');

			if (!state) {
				if (cloneEl.state) {
					if (sortable.options.group.revertClone) {
						rootEl.insertBefore(cloneEl, nextEl);
						sortable._animate(dragEl, cloneEl);
					} else {
						rootEl.insertBefore(cloneEl, dragEl);
					}
				}
			}

			cloneEl.state = state;
		}
	}


	function _closest(/**HTMLElement*/el, /**String*/selector, /**HTMLElement*/ctx) {
		if (el) {
			ctx = ctx || document;

			do {
				if ((selector === '>*' && el.parentNode === ctx) || _matches(el, selector)) {
					return el;
				}
				/* jshint boss:true */
			} while (el = _getParentOrHost(el));
		}

		return null;
	}


	function _getParentOrHost(el) {
		var parent = el.host;

		return (parent && parent.nodeType) ? parent : el.parentNode;
	}


	function _globalDragOver(/**Event*/evt) {
		if (evt.dataTransfer) {
			evt.dataTransfer.dropEffect = 'move';
		}
		evt.preventDefault();
	}


	function _on(el, event, fn) {
		el.addEventListener(event, fn, captureMode);
	}


	function _off(el, event, fn) {
		el.removeEventListener(event, fn, captureMode);
	}


	function _toggleClass(el, name, state) {
		if (el) {
			if (el.classList) {
				el.classList[state ? 'add' : 'remove'](name);
			}
			else {
				var className = (' ' + el.className + ' ').replace(R_SPACE, ' ').replace(' ' + name + ' ', ' ');
				el.className = (className + (state ? ' ' + name : '')).replace(R_SPACE, ' ');
			}
		}
	}


	function _css(el, prop, val) {
		var style = el && el.style;

		if (style) {
			if (val === void 0) {
				if (document.defaultView && document.defaultView.getComputedStyle) {
					val = document.defaultView.getComputedStyle(el, '');
				}
				else if (el.currentStyle) {
					val = el.currentStyle;
				}

				return prop === void 0 ? val : val[prop];
			}
			else {
				if (!(prop in style)) {
					prop = '-webkit-' + prop;
				}

				style[prop] = val + (typeof val === 'string' ? '' : 'px');
			}
		}
	}


	function _find(ctx, tagName, iterator) {
		if (ctx) {
			var list = ctx.getElementsByTagName(tagName), i = 0, n = list.length;

			if (iterator) {
				for (; i < n; i++) {
					iterator(list[i], i);
				}
			}

			return list;
		}

		return [];
	}



	function _dispatchEvent(sortable, rootEl, name, targetEl, fromEl, startIndex, newIndex) {
		sortable = (sortable || rootEl[expando]);

		var evt = document.createEvent('Event'),
			options = sortable.options,
			onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1);

		evt.initEvent(name, true, true);

		evt.to = rootEl;
		evt.from = fromEl || rootEl;
		evt.item = targetEl || rootEl;
		evt.clone = cloneEl;

		evt.oldIndex = startIndex;
		evt.newIndex = newIndex;

		rootEl.dispatchEvent(evt);

		if (options[onName]) {
			options[onName].call(sortable, evt);
		}
	}


	function _onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvt, willInsertAfter) {
		var evt,
			sortable = fromEl[expando],
			onMoveFn = sortable.options.onMove,
			retVal;

		evt = document.createEvent('Event');
		evt.initEvent('move', true, true);

		evt.to = toEl;
		evt.from = fromEl;
		evt.dragged = dragEl;
		evt.draggedRect = dragRect;
		evt.related = targetEl || toEl;
		evt.relatedRect = targetRect || toEl.getBoundingClientRect();
		evt.willInsertAfter = willInsertAfter;

		fromEl.dispatchEvent(evt);

		if (onMoveFn) {
			retVal = onMoveFn.call(sortable, evt, originalEvt);
		}

		return retVal;
	}


	function _disableDraggable(el) {
		el.draggable = false;
	}


	function _unsilent() {
		_silent = false;
	}


	/** @returns {HTMLElement|false} */
	function _ghostIsLast(el, evt) {
		var lastEl = el.lastElementChild,
			rect = lastEl.getBoundingClientRect();

		// 5 — min delta
		// abs — нельзя добавлять, а то глюки при наведении сверху
		return (evt.clientY - (rect.top + rect.height) > 5) ||
			(evt.clientX - (rect.left + rect.width) > 5);
	}


	/**
	 * Generate id
	 * @param   {HTMLElement} el
	 * @returns {String}
	 * @private
	 */
	function _generateId(el) {
		var str = el.tagName + el.className + el.src + el.href + el.textContent,
			i = str.length,
			sum = 0;

		while (i--) {
			sum += str.charCodeAt(i);
		}

		return sum.toString(36);
	}

	/**
	 * Returns the index of an element within its parent for a selected set of
	 * elements
	 * @param  {HTMLElement} el
	 * @param  {selector} selector
	 * @return {number}
	 */
	function _index(el, selector) {
		var index = 0;

		if (!el || !el.parentNode) {
			return -1;
		}

		while (el && (el = el.previousElementSibling)) {
			if ((el.nodeName.toUpperCase() !== 'TEMPLATE') && (selector === '>*' || _matches(el, selector))) {
				index++;
			}
		}

		return index;
	}

	function _matches(/**HTMLElement*/el, /**String*/selector) {
		if (el) {
			selector = selector.split('.');

			var tag = selector.shift().toUpperCase(),
				re = new RegExp('\\s(' + selector.join('|') + ')(?=\\s)', 'g');

			return (
				(tag === '' || el.nodeName.toUpperCase() == tag) &&
				(!selector.length || ((' ' + el.className + ' ').match(re) || []).length == selector.length)
			);
		}

		return false;
	}

	function _throttle(callback, ms) {
		var args, _this;

		return function () {
			if (args === void 0) {
				args = arguments;
				_this = this;

				setTimeout(function () {
					if (args.length === 1) {
						callback.call(_this, args[0]);
					} else {
						callback.apply(_this, args);
					}

					args = void 0;
				}, ms);
			}
		};
	}

	function _extend(dst, src) {
		if (dst && src) {
			for (var key in src) {
				if (src.hasOwnProperty(key)) {
					dst[key] = src[key];
				}
			}
		}

		return dst;
	}

	function _clone(el) {
		return $
			? $(el).clone(true)[0]
			: (Polymer && Polymer.dom
				? Polymer.dom(el).cloneNode(true)
				: el.cloneNode(true)
			);
	}

	function _saveInputCheckedState(root) {
		var inputs = root.getElementsByTagName('input');
		var idx = inputs.length;

		while (idx--) {
			var el = inputs[idx];
			el.checked && savedInputChecked.push(el);
		}
	}

	// Fixed #973: 
	_on(document, 'touchmove', function (evt) {
		if (Sortable.active) {
			evt.preventDefault();
		}
	});

	try {
		window.addEventListener('test', null, Object.defineProperty({}, 'passive', {
			get: function () {
				captureMode = {
					capture: false,
					passive: false
				};
			}
		}));
	} catch (err) {}

	// Export utils
	Sortable.utils = {
		on: _on,
		off: _off,
		css: _css,
		find: _find,
		is: function (el, selector) {
			return !!_closest(el, selector, el);
		},
		extend: _extend,
		throttle: _throttle,
		closest: _closest,
		toggleClass: _toggleClass,
		clone: _clone,
		index: _index
	};


	/**
	 * Create sortable instance
	 * @param {HTMLElement}  el
	 * @param {Object}      [options]
	 */
	Sortable.create = function (el, options) {
		return new Sortable(el, options);
	};


	// Export
	Sortable.version = '1.6.1';
	return Sortable;
});


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_knockout__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__editorLocalization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__questionEditorProperties__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__questionEditorDefinition__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_survey_knockout__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_survey_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_survey_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rmodal__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__surveyHelper__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_utils__ = __webpack_require__(8);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SurveyPropertyEditorShowWindow; });
/* unused harmony export SurveyQuestionProperties */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SurveyQuestionEditor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SurveyQuestionEditorTab; });








var SurveyPropertyEditorShowWindow = /** @class */ (function () {
    function SurveyPropertyEditorShowWindow() {
        this.koVisible = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"](false);
        this.koEditor = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"](null);
    }
    SurveyPropertyEditorShowWindow.prototype.show = function (question, elWindow, onChanged, options, onClosed) {
        if (options === void 0) { options = null; }
        if (onClosed === void 0) { onClosed = null; }
        var editor = new SurveyQuestionEditor(question, this.onCanShowPropertyCallback, null, options);
        editor.onChanged = onChanged;
        this.koEditor(editor);
        this.koVisible(true);
        var modal = new __WEBPACK_IMPORTED_MODULE_5_rmodal__["a" /* default */](elWindow, {
            bodyClass: "",
            closeTimeout: 100,
            dialogOpenClass: "animated fadeIn",
            focus: false,
            afterClose: function () {
                if (onClosed)
                    onClosed();
            }
        });
        modal.open();
        document.addEventListener("keydown", function (ev) {
            modal.keydown(ev);
        }, false);
        editor.onHideWindow = function () {
            modal.close();
        };
    };
    return SurveyPropertyEditorShowWindow;
}());

var SurveyQuestionProperties = /** @class */ (function () {
    function SurveyQuestionProperties(obj, onCanShowPropertyCallback) {
        this.obj = obj;
        this.onCanShowPropertyCallback = onCanShowPropertyCallback;
        this.properties = __WEBPACK_IMPORTED_MODULE_4_survey_knockout__["JsonObject"].metaData["getPropertiesByObj"]
            ? __WEBPACK_IMPORTED_MODULE_4_survey_knockout__["JsonObject"].metaData["getPropertiesByObj"](this.obj)
            : __WEBPACK_IMPORTED_MODULE_4_survey_knockout__["JsonObject"].metaData.getProperties(this.obj.getType());
        this.editorDefinition = __WEBPACK_IMPORTED_MODULE_3__questionEditorDefinition__["a" /* SurveyQuestionEditorDefinition */].getAllDefinitionsByClass(this.obj.getType());
    }
    SurveyQuestionProperties.prototype.getProperty = function (propertyName) {
        var property = this.getPropertyCore(propertyName);
        if (!property)
            return null;
        return __WEBPACK_IMPORTED_MODULE_6__surveyHelper__["b" /* SurveyHelper */].isPropertyVisible(this.obj, property, this.onCanShowPropertyCallback)
            ? property
            : null;
    };
    SurveyQuestionProperties.prototype.getPropertyCore = function (propertyName) {
        var property = null;
        for (var i = 0; i < this.properties.length; i++) {
            if (this.properties[i].name == propertyName)
                return this.properties[i];
        }
        return null;
    };
    SurveyQuestionProperties.prototype.getProperties = function (tab) {
        var _this = this;
        return this.editorDefinition
            .reduce(function (a, b) { return a.concat(b.properties); }, [
            { name: tab.name, tab: tab.name }
        ])
            .filter(function (prop) {
            return prop !== undefined &&
                typeof prop !== "string" &&
                prop.tab === tab.name;
        })
            .map(function (prop) { return typeof prop !== "string" && _this.getPropertyCore(prop.name); })
            .filter(function (prop) {
            return !!prop &&
                ((prop.name == tab.name && tab.visible === true) ||
                    __WEBPACK_IMPORTED_MODULE_6__surveyHelper__["b" /* SurveyHelper */].isPropertyVisible(_this.obj, prop, _this.onCanShowPropertyCallback));
        });
    };
    return SurveyQuestionProperties;
}());

var SurveyQuestionEditor = /** @class */ (function () {
    function SurveyQuestionEditor(obj, onCanShowPropertyCallback, className, options) {
        if (className === void 0) { className = null; }
        if (options === void 0) { options = null; }
        this.obj = obj;
        this.onCanShowPropertyCallback = onCanShowPropertyCallback;
        this.className = className;
        this.options = options;
        this.koActiveTab = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"]();
        this.koTitle = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"]();
        var self = this;
        if (!this.className && this.obj.getType) {
            this.className = this.obj.getType();
        }
        this.properties = new SurveyQuestionProperties(obj, onCanShowPropertyCallback);
        self.onApplyClick = function () {
            self.apply();
        };
        self.onOkClick = function () {
            self.doCloseWindow(false);
        };
        self.onResetClick = function () {
            self.doCloseWindow(true);
        };
        this.onTabClick = function (tab) {
            self.koActiveTab(tab.name);
        };
        var tabs = this.buildTabs();
        tabs.forEach(function (tab) { return tab.beforeShow(); });
        this.koTabs = __WEBPACK_IMPORTED_MODULE_0_knockout__["observableArray"](tabs);
        if (tabs.length > 0) {
            this.koActiveTab(tabs[0].name);
        }
        this.koShowApplyButton = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"](!this.options || this.options.showApplyButtonInEditors);
        this.koTitle(this.getTitle());
    }
    SurveyQuestionEditor.prototype.getTitle = function () {
        var res;
        if (this.obj["name"]) {
            res = __WEBPACK_IMPORTED_MODULE_1__editorLocalization__["a" /* editorLocalization */]
                .getString("pe.qEditorTitle")["format"](this.obj["name"]);
        }
        else {
            res = __WEBPACK_IMPORTED_MODULE_1__editorLocalization__["a" /* editorLocalization */].getString("pe.surveyEditorTitle");
        }
        if (this.options && this.options.onGetElementEditorTitleCallback) {
            res = this.options.onGetElementEditorTitleCallback(this.obj, res);
        }
        return res;
    };
    SurveyQuestionEditor.prototype.doCloseWindow = function (isCancel) {
        var appliedSuccesfull = false;
        if (isCancel) {
            this.reset();
        }
        else {
            appliedSuccesfull = this.apply();
        }
        if (isCancel || appliedSuccesfull) {
            var tabs = this.koTabs();
            for (var i = 0; i < tabs.length; i++) {
                tabs[i].doCloseWindow();
            }
            if (this.onHideWindow)
                this.onHideWindow();
        }
    };
    SurveyQuestionEditor.prototype.hasError = function () {
        var tabs = this.koTabs();
        for (var i = 0; i < tabs.length; i++) {
            if (tabs[i].hasError()) {
                this.koActiveTab(tabs[i].name);
                return true;
            }
        }
        return false;
    };
    SurveyQuestionEditor.prototype.reset = function () {
        var tabs = this.koTabs();
        for (var i = 0; i < tabs.length; i++) {
            tabs[i].reset();
        }
    };
    SurveyQuestionEditor.prototype.apply = function () {
        var res = true;
        var isFirstError = false;
        var tabs = this.koTabs();
        for (var i = 0; i < tabs.length; i++) {
            var tabRes = tabs[i].apply();
            if (!tabRes) {
                tabs[i].expand();
                if (!isFirstError) {
                    this.koActiveTab(tabs[i].name);
                    isFirstError = true;
                }
            }
            res = tabRes && res;
        }
        if (res && this.onChanged) {
            this.onChanged(this.obj);
        }
        return res;
    };
    SurveyQuestionEditor.prototype.buildTabs = function () {
        var tabs = [];
        var properties = new __WEBPACK_IMPORTED_MODULE_2__questionEditorProperties__["a" /* SurveyQuestionEditorProperties */](this.obj, __WEBPACK_IMPORTED_MODULE_3__questionEditorDefinition__["a" /* SurveyQuestionEditorDefinition */].getProperties(this.className), this.onCanShowPropertyCallback, this.options);
        if (__WEBPACK_IMPORTED_MODULE_3__questionEditorDefinition__["a" /* SurveyQuestionEditorDefinition */].isGeneralTabVisible(this.className)) {
            tabs.push(new SurveyQuestionEditorTab(this.obj, properties, "general"));
        }
        this.addPropertiesTabs(tabs);
        for (var i = 0; i < tabs.length; i++) {
            tabs[i].onCanShowPropertyCallback = this.onCanShowPropertyCallback;
        }
        return tabs;
    };
    SurveyQuestionEditor.prototype.addPropertiesTabs = function (tabs) {
        var tabNames = __WEBPACK_IMPORTED_MODULE_3__questionEditorDefinition__["a" /* SurveyQuestionEditorDefinition */].getTabs(this.className);
        for (var i = 0; i < tabNames.length; i++) {
            var tabItem = tabNames[i];
            var properties = this.properties.getProperties(tabItem);
            if (properties.length > 0) {
                var propertyTab = new SurveyQuestionEditorTab(this.obj, new __WEBPACK_IMPORTED_MODULE_2__questionEditorProperties__["a" /* SurveyQuestionEditorProperties */](this.obj, properties, this.onCanShowPropertyCallback, this.options, tabItem), tabItem.name);
                propertyTab.title = tabItem.title;
                tabs.push(propertyTab);
            }
        }
    };
    Object.defineProperty(SurveyQuestionEditor.prototype, "useTabsInElementEditor", {
        get: function () {
            return this.options.useTabsInElementEditor;
        },
        enumerable: true,
        configurable: true
    });
    return SurveyQuestionEditor;
}());

var SurveyQuestionEditorTab = /** @class */ (function () {
    function SurveyQuestionEditorTab(obj, properties, _name) {
        if (properties === void 0) { properties = null; }
        this.obj = obj;
        this.properties = properties;
        this._name = _name;
    }
    SurveyQuestionEditorTab.prototype.expand = function () {
        if (!!this.onExpand)
            this.onExpand();
    };
    SurveyQuestionEditorTab.prototype.koAfterRender = function (elements, context) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_utils__["c" /* focusFirstControl */])(elements);
    };
    Object.defineProperty(SurveyQuestionEditorTab.prototype, "name", {
        get: function () {
            return this._name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyQuestionEditorTab.prototype, "title", {
        get: function () {
            if (this.titleValue)
                return this.titleValue;
            var str = __WEBPACK_IMPORTED_MODULE_1__editorLocalization__["a" /* editorLocalization */].getString("pe.tabs." + this.name);
            return str ? str : this.name;
        },
        set: function (value) {
            this.titleValue = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyQuestionEditorTab.prototype, "htmlTemplate", {
        get: function () {
            return "questioneditortab";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyQuestionEditorTab.prototype, "templateObject", {
        get: function () {
            return this;
        },
        enumerable: true,
        configurable: true
    });
    SurveyQuestionEditorTab.prototype.hasError = function () {
        return this.properties.hasError();
    };
    SurveyQuestionEditorTab.prototype.beforeShow = function () {
        this.properties.beforeShow();
    };
    SurveyQuestionEditorTab.prototype.reset = function () {
        this.properties.reset();
    };
    SurveyQuestionEditorTab.prototype.apply = function () {
        return this.properties.apply();
    };
    SurveyQuestionEditorTab.prototype.doCloseWindow = function () { };
    SurveyQuestionEditorTab.prototype.getValue = function (property) {
        return property.getPropertyValue(this.obj);
    };
    return SurveyQuestionEditorTab;
}());



/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_knockout__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_survey_knockout__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_survey_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_survey_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__surveyjsObjects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__editorLocalization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sortablejs__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sortablejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sortablejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__title_editor__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_utils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__item_editor_scss__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__item_editor_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__item_editor_scss__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return itemAdorner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createAddItemHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createAddItemElement; });
/* unused harmony export itemDraggableAdorner */









var templateHtml = __webpack_require__(126);
var ItemInplaceEditor = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](ItemInplaceEditor, _super);
    function ItemInplaceEditor(name, question, item, rootElement, editor) {
        var _this = _super.call(this, name, rootElement) || this;
        _this.question = question;
        _this.item = item;
        _this.editor = editor;
        return _this;
    }
    ItemInplaceEditor.prototype.deleteItem = function (model, event) {
        if (this.question.otherItem === this.item) {
            this.question.hasOther = false;
        }
        else if (this.question["selectAllItem"] === this.item) {
            this.question["hasSelectAll"] = false;
        }
        else if (this.question["noneItem"] === this.item) {
            this.question["hasNone"] = false;
        }
        else {
            var index = model.question.choices.indexOf(model.item);
            model.question.choices.splice(index, 1);
        }
        this.editor.onQuestionEditorChanged(this.question);
    };
    Object.defineProperty(ItemInplaceEditor.prototype, "isDraggable", {
        get: function () {
            return (this.question.otherItem !== this.item &&
                this.question["selectAllItem"] !== this.item &&
                this.question["noneItem"] !== this.item);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ItemInplaceEditor.prototype, "isLastItem", {
        get: function () {
            return this.question.choices.length === 1;
        },
        enumerable: true,
        configurable: true
    });
    return ItemInplaceEditor;
}(__WEBPACK_IMPORTED_MODULE_6__title_editor__["b" /* TitleInplaceEditor */]));
__WEBPACK_IMPORTED_MODULE_1_knockout__["components"].register("item-editor", {
    viewModel: {
        createViewModel: function (params, componentInfo) {
            var model = new ItemInplaceEditor(params.target[params.name], params.question, params.item, componentInfo.element, params.editor);
            var property = __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["JsonObject"].metaData.findProperty(params.target.getType(), params.name);
            model.valueChanged = function (newValue) {
                var options = {
                    propertyName: property.name,
                    obj: params.model,
                    value: newValue,
                    newValue: null,
                    doValidation: false
                };
                params.editor.onValueChangingCallback(options);
                newValue = options.newValue === null ? options.value : options.newValue;
                params.target[params.name] = newValue;
                params.editor.onPropertyValueChanged(property, params.target, newValue);
                !!params.valueChanged &&
                    params.valueChanged(params.target, property.name, newValue);
            };
            return model;
        }
    },
    template: templateHtml
});
var itemAdorner = {
    inplaceEditForValues: false,
    getMarkerClass: function (model) {
        return !!model.parent &&
            !!model.choices &&
            typeof model.getType === "function" &&
            model.getType() !== "imagepicker"
            ? "item_editable"
            : "";
    },
    getElementName: function (model) { return "controlLabel"; },
    afterRender: function (elements, model, editor) {
        for (var i = 0; i < elements.length; i++) {
            elements[i].onclick = function (e) { return e.preventDefault(); };
            var decoration = document.createElement("span");
            decoration.className = "svda-adorner-root";
            var itemValue = __WEBPACK_IMPORTED_MODULE_1_knockout__["dataFor"](elements[i]);
            var propertyName = itemAdorner.inplaceEditForValues ? "value" : "text";
            var target = itemValue;
            if (itemValue === model["selectAllItem"]) {
                target = model;
                propertyName = "selectAllText";
            }
            if (itemValue === model["noneItemValue"]) {
                target = model;
                propertyName = "noneText";
            }
            if (itemValue === model["otherItemValue"]) {
                target = model;
                propertyName = "otherText";
            }
            decoration.innerHTML =
                "<item-editor params='name: \"" +
                    propertyName +
                    "\", target: target, item: item, question: question, editor: editor'></item-editor>";
            elements[i].appendChild(decoration);
            __WEBPACK_IMPORTED_MODULE_1_knockout__["applyBindings"]({
                item: itemValue,
                question: model,
                target: target,
                editor: editor
            }, decoration);
            __WEBPACK_IMPORTED_MODULE_1_knockout__["tasks"].runEarly();
            editor.onAdornerRenderedCallback(model, "choices-label", decoration, itemValue);
        }
    }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__surveyjsObjects__["b" /* registerAdorner */])("choices-label", itemAdorner);
var createAddItemHandler = function (question, onItemAdded, onItemAdding) {
    if (onItemAdding === void 0) { onItemAdding = null; }
    return function () {
        var nextValue = null;
        var values = question.choices.map(function (item) {
            return item.itemValue;
        });
        var itemText = __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["surveyLocalization"].getString("choices_Item");
        nextValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_utils__["a" /* getNextValue */])(itemText, values);
        var itemValue = new __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["ItemValue"](nextValue);
        itemValue.locOwner = {
            getLocale: function () {
                if (!!question["getLocale"])
                    return question.getLocale();
                return "";
            },
            getMarkdownHtml: function (text) {
                return text;
            },
            getProcessedText: function (text) {
                return text;
            }
        };
        !!onItemAdding && onItemAdding(itemValue);
        question.choices = question.choices.concat([itemValue]);
        itemValue = question.choices.filter(function (choiceItem) { return choiceItem.value === itemValue.value; })[0];
        !!onItemAdded && onItemAdded(itemValue);
    };
};
var createAddItemElement = function (handler) {
    var addNew = document.createElement("div");
    addNew.title = __WEBPACK_IMPORTED_MODULE_4__editorLocalization__["a" /* editorLocalization */].getString("pe.addItem");
    addNew.className = "svda-add-new-item svd-primary-icon";
    addNew.onclick = handler;
    var svgElem = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svgElem.setAttribute("class", "svd-svg-icon");
    svgElem.style.width = "12px";
    svgElem.style.height = "12px";
    var useElem = document.createElementNS("http://www.w3.org/2000/svg", "use");
    useElem.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", "#icon-inplaceplus");
    svgElem.appendChild(useElem);
    addNew.appendChild(svgElem);
    return addNew;
};
var itemDraggableAdorner = {
    getMarkerClass: function (model) {
        return !!model.parent &&
            !!model.choices &&
            typeof model.getType === "function" &&
            model.getType() !== "imagepicker"
            ? "item_draggable"
            : "";
    },
    getElementName: function (model) { return "item"; },
    afterRender: function (elements, model, editor) {
        var itemsRoot = elements[0].parentElement;
        for (var i = 0; i < elements.length; i++) {
            var itemValue = __WEBPACK_IMPORTED_MODULE_1_knockout__["dataFor"](elements[i]);
            if (itemValue === model["selectAllItemValue"] ||
                itemValue === model["noneItemValue"] ||
                itemValue === model["otherItemValue"]) {
                elements[i].classList.remove("item_draggable");
            }
        }
        var sortable = __WEBPACK_IMPORTED_MODULE_5_sortablejs___default.a.create(itemsRoot, {
            handle: ".svda-drag-handle",
            draggable: ".item_draggable",
            animation: 150,
            onEnd: function (evt) {
                var choices = model.choices;
                var choice = choices[evt.oldIndex];
                choices.splice(evt.oldIndex, 1);
                choices.splice(evt.newIndex, 0, choice);
                editor.onQuestionEditorChanged(model);
            }
        });
        var addNew = createAddItemElement(createAddItemHandler(model, function (itemValue) {
            editor.onQuestionEditorChanged(model);
        }, function (itemValue) {
            editor.onItemValueAddedCallback("choices", itemValue, model.choices);
        }));
        itemsRoot.appendChild(addNew);
    }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__surveyjsObjects__["b" /* registerAdorner */])("choices-draggable", itemDraggableAdorner);


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_knockout__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__propertyEditors_propertyEditorFactory__ = __webpack_require__(4);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SurveyObjectProperty; });


var SurveyObjectProperty = /** @class */ (function () {
    function SurveyObjectProperty(property, onPropertyChanged, propertyEditorOptions) {
        if (onPropertyChanged === void 0) { onPropertyChanged = null; }
        if (propertyEditorOptions === void 0) { propertyEditorOptions = null; }
        this.property = property;
        this.koIsShowEditor = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"](false);
        this.onPropertyChanged = onPropertyChanged;
        this.name = this.property.name;
        this.disabled = property["readOnly"];
        var self = this;
        var onItemChanged = function (newValue) {
            self.onEditorValueChanged(newValue);
        };
        this.editor = __WEBPACK_IMPORTED_MODULE_1__propertyEditors_propertyEditorFactory__["a" /* SurveyPropertyEditorFactory */].createEditor(property, onItemChanged);
        this.editor.onGetLocale = this.doOnGetLocale;
        this.editor.options = propertyEditorOptions;
        this.editorType = this.editor.editorType;
        this.editorTypeTemplate = this.editor.editorTypeTemplate;
        this.isActive = false;
    }
    Object.defineProperty(SurveyObjectProperty.prototype, "displayName", {
        get: function () {
            return this.editor.displayName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyObjectProperty.prototype, "title", {
        get: function () {
            return this.editor.title;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyObjectProperty.prototype, "isActive", {
        get: function () {
            return this.isActiveValue;
        },
        set: function (val) {
            if (this.isActive == val)
                return;
            this.isActiveValue = val;
            this.koIsShowEditor(!this.disabled && (this.editor.alwaysShowEditor || this.isActive));
            this.editor.activate();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyObjectProperty.prototype, "koValue", {
        get: function () {
            return this.editor.koValue;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyObjectProperty.prototype, "koText", {
        get: function () {
            return this.editor.koText;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyObjectProperty.prototype, "koIsDefault", {
        get: function () {
            return this.editor.koIsDefault;
        },
        enumerable: true,
        configurable: true
    });
    SurveyObjectProperty.prototype.doOnGetLocale = function () {
        if (this.object && this.object["getLocale"])
            return this.object.getLocale();
        return "";
    };
    Object.defineProperty(SurveyObjectProperty.prototype, "object", {
        get: function () {
            return this.objectValue;
        },
        set: function (value) {
            this.objectValue = value;
            this.editor.object = value;
        },
        enumerable: true,
        configurable: true
    });
    SurveyObjectProperty.prototype.onEditorValueChanged = function (newValue) {
        if (this.onPropertyChanged && this.object)
            this.onPropertyChanged(this, newValue);
    };
    return SurveyObjectProperty;
}());



/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_knockout__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_survey_knockout__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_survey_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_survey_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editorLocalization__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SurveyPropertyEditorBase; });



var SurveyPropertyEditorBase = /** @class */ (function () {
    function SurveyPropertyEditorBase(property) {
        this.editingValue_ = null;
        this.isApplyinNewValue = false;
        this.valueUpdatingCounter = 0;
        this.optionsValue = null;
        this.isRequriedValue = false;
        this.isCustomDisplayName = false;
        this.isTabProperty = false;
        this.isInplaceProperty = false;
        this.iskoValueChanging = false;
        this.property_ = property;
        var self = this;
        this.koValue = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"]();
        this.koValue.subscribe(function (newValue) {
            self.onkoValueChanged(newValue);
        });
        this.koText = __WEBPACK_IMPORTED_MODULE_0_knockout__["computed"](function () {
            return self.getValueText(self.koValue());
        });
        this.koIsDefault = __WEBPACK_IMPORTED_MODULE_0_knockout__["computed"](function () {
            return self.property
                ? self.property.isDefaultValue(self.koValue())
                : false;
        });
        this.koHasError = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"](false);
        this.koErrorText = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"]("");
        this.koDisplayError = __WEBPACK_IMPORTED_MODULE_0_knockout__["computed"](function () {
            return self.koHasError() && !!self.koErrorText();
        });
        this.setIsRequired();
        this.setTitleAndDisplayName();
        this.readOnly = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"](this.getReadOnly());
    }
    SurveyPropertyEditorBase.prototype.setup = function () { };
    SurveyPropertyEditorBase.prototype.beforeShow = function () { };
    Object.defineProperty(SurveyPropertyEditorBase.prototype, "editorType", {
        get: function () {
            throw "editorType is not defined";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyPropertyEditorBase.prototype, "editorTypeTemplate", {
        get: function () {
            return this.editorType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyPropertyEditorBase.prototype, "property", {
        get: function () {
            return this.property_;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyPropertyEditorBase.prototype, "defaultValue", {
        get: function () {
            return this.property.defaultValue;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyPropertyEditorBase.prototype, "editablePropertyName", {
        get: function () {
            return this.property ? this.property.name : "";
        },
        enumerable: true,
        configurable: true
    });
    SurveyPropertyEditorBase.prototype.getReadOnly = function () {
        var res = this.property ? this.property.readOnly : false;
        if (!!this.options && !!this.property && !!this.object) {
            res = this.options.onIsEditorReadOnlyCallback(this.object, this, res);
        }
        return res;
    };
    Object.defineProperty(SurveyPropertyEditorBase.prototype, "alwaysShowEditor", {
        get: function () {
            return false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyPropertyEditorBase.prototype, "title", {
        get: function () {
            return this.titleValue;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyPropertyEditorBase.prototype, "isDiplayNameVisible", {
        get: function () {
            return ((!this.isTabProperty || !this.isModal) &&
                !this.isInplaceProperty &&
                this.displayName !== ".");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyPropertyEditorBase.prototype, "displayName", {
        get: function () {
            return this.displayNameValue;
        },
        set: function (val) {
            this.isCustomDisplayName = true;
            this.displayNameValue = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyPropertyEditorBase.prototype, "showDisplayNameOnTop", {
        get: function () {
            return this.isDiplayNameVisible && this.canShowDisplayNameOnTop;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyPropertyEditorBase.prototype, "canShowDisplayNameOnTop", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyPropertyEditorBase.prototype, "contentTemplateName", {
        get: function () {
            var res = "propertyeditor";
            if (this.isModal) {
                res += "-modalcontent";
            }
            else {
                res += "-" + this.editorTypeTemplate;
            }
            return res;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyPropertyEditorBase.prototype, "isModal", {
        get: function () {
            return false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyPropertyEditorBase.prototype, "object", {
        get: function () {
            return this.objectValue;
        },
        set: function (value) {
            var _this = this;
            this.objectValue = value;
            if (typeof value.registerFunctionOnPropertyValueChanged === "function") {
                value.registerFunctionOnPropertyValueChanged(this.property.name, function () { return _this.updateValue(); }, this.property.name);
            }
            this.setIsRequired();
            this.setTitleAndDisplayName();
            this.setObject(this.object);
            this.updateValue();
            if (this.options && this.property) {
                this.options.onPropertyEditorObjectSetCallback(this.property.name, this.object, this);
                this.readOnly(this.getReadOnly());
            }
        },
        enumerable: true,
        configurable: true
    });
    SurveyPropertyEditorBase.prototype.getValueText = function (value) {
        return value;
    };
    Object.defineProperty(SurveyPropertyEditorBase.prototype, "editingValue", {
        get: function () {
            return this.editingValue_;
        },
        set: function (value) {
            value = this.getCorrectedValue(value);
            this.setValueCore(value);
            this.onValueChanged();
        },
        enumerable: true,
        configurable: true
    });
    SurveyPropertyEditorBase.prototype.hasError = function () {
        this.koHasError(this.checkForErrors());
        return this.koHasError();
    };
    SurveyPropertyEditorBase.prototype.getLocString = function (name) {
        return __WEBPACK_IMPORTED_MODULE_2__editorLocalization__["a" /* editorLocalization */].getString(name);
    };
    SurveyPropertyEditorBase.prototype.hasLocString = function (name) {
        return __WEBPACK_IMPORTED_MODULE_2__editorLocalization__["a" /* editorLocalization */].hasString(name);
    };
    Object.defineProperty(SurveyPropertyEditorBase.prototype, "isCurrentValueEmpty", {
        get: function () {
            return this.isValueEmpty(this.koValue());
        },
        enumerable: true,
        configurable: true
    });
    SurveyPropertyEditorBase.prototype.checkForErrors = function () {
        var errorText = "";
        if (this.isRequired || this.checkForItemValue()) {
            var er = this.isCurrentValueEmpty;
            if (er) {
                errorText = this.getLocString("pe.propertyIsEmpty");
            }
        }
        if (!errorText &&
            this.property &&
            this.options &&
            this.options.onGetErrorTextOnValidationCallback) {
            errorText = this.options.onGetErrorTextOnValidationCallback(this.property.name, this.object, this.editingValue);
        }
        this.koErrorText(errorText);
        return errorText !== "";
    };
    SurveyPropertyEditorBase.prototype.checkForItemValue = function () {
        //TODO Problem is in 882ca3ac commit. ItemValue without value should be invalid. Need to better fix for the problem.
        return (this.property &&
            this.property.name === "value" &&
            this.objectValue &&
            typeof this.objectValue.getType === "function" &&
            this.objectValue.getType() === "itemvalue");
    };
    Object.defineProperty(SurveyPropertyEditorBase.prototype, "isRequired", {
        get: function () {
            return this.isRequriedValue;
        },
        enumerable: true,
        configurable: true
    });
    SurveyPropertyEditorBase.prototype.setIsRequired = function () {
        this.isRequriedValue = !!this.property ? this.property.isRequired : false;
    };
    SurveyPropertyEditorBase.prototype.setTitleAndDisplayName = function () {
        if (this.isCustomDisplayName)
            return;
        this.displayNameValue = this.property ? this.property.name : "";
        this.titleValue = "";
        if (!this.property)
            return;
        var locName = this.property.name;
        this.displayNameValue = __WEBPACK_IMPORTED_MODULE_2__editorLocalization__["a" /* editorLocalization */].getPropertyName(locName);
        var title = __WEBPACK_IMPORTED_MODULE_2__editorLocalization__["a" /* editorLocalization */].getPropertyTitle(locName);
        this.titleValue = title;
    };
    SurveyPropertyEditorBase.prototype.onBeforeApply = function () { };
    SurveyPropertyEditorBase.prototype.apply = function () {
        this.onBeforeApply();
        if (this.hasError())
            return false;
        this.isApplyinNewValue = true;
        this.koValue(this.editingValue);
        this.isApplyinNewValue = false;
        return true;
    };
    Object.defineProperty(SurveyPropertyEditorBase.prototype, "locale", {
        get: function () {
            if (this.onGetLocale)
                return this.onGetLocale();
            return "";
        },
        enumerable: true,
        configurable: true
    });
    SurveyPropertyEditorBase.prototype.getLocale = function () {
        return this.locale;
    };
    SurveyPropertyEditorBase.prototype.getMarkdownHtml = function (text) {
        return text;
    };
    SurveyPropertyEditorBase.prototype.getProcessedText = function (text) {
        return text;
    };
    Object.defineProperty(SurveyPropertyEditorBase.prototype, "options", {
        get: function () {
            return this.optionsValue;
        },
        set: function (value) {
            this.optionsValue = value;
            this.onOptionsChanged();
        },
        enumerable: true,
        configurable: true
    });
    SurveyPropertyEditorBase.prototype.onOptionsChanged = function () { };
    SurveyPropertyEditorBase.prototype.setValueCore = function (value) {
        this.editingValue_ = value;
    };
    SurveyPropertyEditorBase.prototype.setObject = function (value) {
        if (this.options) {
            var editorOptions = this.createEditorOptions();
            this.options.onSetPropertyEditorOptionsCallback(this.editablePropertyName, value, editorOptions);
            this.onSetEditorOptions(editorOptions);
        }
    };
    SurveyPropertyEditorBase.prototype.activate = function () { };
    SurveyPropertyEditorBase.prototype.createEditorOptions = function () {
        return {};
    };
    SurveyPropertyEditorBase.prototype.onSetEditorOptions = function (editorOptions) { };
    SurveyPropertyEditorBase.prototype.onValueChanged = function () { };
    SurveyPropertyEditorBase.prototype.getCorrectedValue = function (value) {
        return value;
    };
    SurveyPropertyEditorBase.prototype.beginValueUpdating = function () {
        this.valueUpdatingCounter++;
    };
    SurveyPropertyEditorBase.prototype.endValueUpdating = function () {
        if (this.valueUpdatingCounter > 0) {
            this.valueUpdatingCounter--;
        }
    };
    SurveyPropertyEditorBase.prototype.updateValue = function () {
        this.beginValueUpdating();
        this.koValue(this.getValue());
        this.editingValue = this.koValue();
        if (this.onValueUpdated)
            this.onValueUpdated(this.editingValue);
        this.endValueUpdating();
    };
    SurveyPropertyEditorBase.prototype.getValue = function () {
        return this.property && this.object
            ? this.property.getPropertyValue(this.object)
            : null;
    };
    SurveyPropertyEditorBase.prototype.onkoValueChanged = function (newValue) {
        if (this.valueUpdatingCounter > 0 || this.iskoValueChanging)
            return;
        this.iskoValueChanging = true;
        newValue = this.getCorrectedValue(newValue);
        if (this.options && this.property && this.object) {
            var options = {
                propertyName: this.property.name,
                obj: this.object,
                value: newValue,
                newValue: null,
                doValidation: false
            };
            this.updateEditingProperties(newValue);
            this.options.onValueChangingCallback(options);
            if (!this.isValueEmpty(options.newValue)) {
                newValue = options.newValue;
                this.koValue(newValue);
            }
            if (options.doValidation) {
                this.hasError();
            }
        }
        this.updateEditingProperties(newValue);
        if (!this.isApplyinNewValue) {
            this.editingValue = newValue;
        }
        this.iskoValueChanging = false;
        if (this.property && this.object && this.getValue() == newValue)
            return;
        if (this.onChanged != null)
            this.onChanged(newValue);
    };
    SurveyPropertyEditorBase.prototype.updateEditingProperties = function (newValue) {
        if (!this.isModal && !!this.object) {
            if (!this.object.editingProperties) {
                this.object.editingProperties = {};
            }
            this.object.editingProperties[this.property.name] = newValue;
        }
    };
    SurveyPropertyEditorBase.prototype.isValueEmpty = function (val) {
        return __WEBPACK_IMPORTED_MODULE_1_survey_knockout__["Helpers"].isValueEmpty(val);
    };
    SurveyPropertyEditorBase.prototype.keyDownHandler = function (property, event) {
        var surveyEditor = property.editor.options;
        if (!!surveyEditor) {
            surveyEditor.onPropertyEditorKeyDownCallback(property.property.name, property.obj, property.editor, event);
        }
        return true;
    };
    return SurveyPropertyEditorBase;
}());



/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_knockout__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__propertyModalEditor__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__editorLocalization__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SurveyPropertyItemsEditor; });




var SurveyPropertyItemsEditor = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SurveyPropertyItemsEditor, _super);
    function SurveyPropertyItemsEditor(property) {
        var _this = _super.call(this, property) || this;
        _this.sortableOptions = {
            handle: ".svd-drag-handle",
            animation: 150
        };
        _this.koItems = __WEBPACK_IMPORTED_MODULE_1_knockout__["observableArray"]();
        _this.editingValue = [];
        _this.koAllowAddRemoveItems = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"](true);
        var self = _this;
        self.onDeleteClick = function (item) {
            self.koItems.remove(item);
        };
        self.onClearClick = function (item) {
            self.koItems.removeAll();
        };
        self.onAddClick = function () {
            self.AddItem();
        };
        return _this;
    }
    SurveyPropertyItemsEditor.prototype.getValueText = function (value) {
        var len = value ? value.length : 0;
        return __WEBPACK_IMPORTED_MODULE_3__editorLocalization__["a" /* editorLocalization */].getString("pe.items")["format"](len);
    };
    SurveyPropertyItemsEditor.prototype.getCorrectedValue = function (value) {
        if (value == null || !Array.isArray(value))
            value = [];
        return value;
    };
    SurveyPropertyItemsEditor.prototype.createEditorOptions = function () {
        return { allowAddRemoveItems: true };
    };
    SurveyPropertyItemsEditor.prototype.onSetEditorOptions = function (editorOptions) {
        this.koAllowAddRemoveItems(editorOptions.allowAddRemoveItems);
    };
    SurveyPropertyItemsEditor.prototype.AddItem = function () {
        this.koItems.push(this.createNewEditorItem());
    };
    SurveyPropertyItemsEditor.prototype.setupItems = function () {
        this.koItems(this.getItemsFromValue(this.editingValue));
    };
    SurveyPropertyItemsEditor.prototype.onValueChanged = function () {
        if (this.isShowingModal) {
            this.setupItems();
        }
    };
    SurveyPropertyItemsEditor.prototype.setup = function () {
        _super.prototype.setup.call(this);
        this.updateValue();
    };
    SurveyPropertyItemsEditor.prototype.getItemsFromValue = function (value) {
        if (value === void 0) { value = null; }
        var items = [];
        if (!value)
            value = this.editingValue;
        for (var i = 0; i < value.length; i++) {
            items.push(this.createEditorItem(value[i]));
        }
        return items;
    };
    Object.defineProperty(SurveyPropertyItemsEditor.prototype, "isCurrentValueEmpty", {
        get: function () {
            return this.koItems().length == 0;
        },
        enumerable: true,
        configurable: true
    });
    SurveyPropertyItemsEditor.prototype.onBeforeApply = function () {
        var items = [];
        var internalItems = this.koItems();
        for (var i = 0; i < internalItems.length; i++) {
            items.push(this.createItemFromEditorItem(internalItems[i]));
        }
        this.setValueCore(items);
    };
    SurveyPropertyItemsEditor.prototype.createNewEditorItem = function () {
        throw "Override 'createNewEditorItem' method";
    };
    SurveyPropertyItemsEditor.prototype.createEditorItem = function (item) {
        return item;
    };
    SurveyPropertyItemsEditor.prototype.createItemFromEditorItem = function (editorItem) {
        return editorItem;
    };
    return SurveyPropertyItemsEditor;
}(__WEBPACK_IMPORTED_MODULE_2__propertyModalEditor__["a" /* SurveyPropertyModalEditor */]));



/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_knockout__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_survey_knockout__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_survey_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_survey_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__propertyItemsEditor__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__editorLocalization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__objectProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__questionEditors_questionEditorDefinition__ = __webpack_require__(16);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SurveyNestedPropertyEditor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SurveyNestedPropertyEditorItem; });
/* unused harmony export SurveyNestedPropertyEditorColumn */
/* unused harmony export SurveyNestedPropertyEditorEditorCell */







var SurveyNestedPropertyEditor = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SurveyNestedPropertyEditor, _super);
    function SurveyNestedPropertyEditor(property) {
        var _this = _super.call(this, property) || this;
        _this.koColumnsValue = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"]([]);
        _this.createColumns();
        var self = _this;
        _this.koEditItem = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"](null);
        _this.koIsList = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"](true);
        _this.koActiveView = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"]("form");
        _this.koEditItem.subscribe(function (newValue) {
            self.koIsList(self.koEditItem() == null);
            self.onListDetailViewChanged();
        });
        _this.onEditItemClick = function (item) {
            self.koEditItem(item);
        };
        _this.onCancelEditItemClick = function () {
            var editItem = self.koEditItem();
            if (editItem.itemEditor && editItem.itemEditor.hasError())
                return;
            self.koEditItem(null);
        };
        _this.koEditorName = __WEBPACK_IMPORTED_MODULE_1_knockout__["computed"](function () {
            return self.getEditorName();
        });
        return _this;
    }
    Object.defineProperty(SurveyNestedPropertyEditor.prototype, "canShowDisplayNameOnTop", {
        get: function () {
            return false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyNestedPropertyEditor.prototype, "columns", {
        get: function () {
            return this.koColumnsValue();
        },
        enumerable: true,
        configurable: true
    });
    SurveyNestedPropertyEditor.prototype.beforeShow = function () {
        _super.prototype.beforeShow.call(this);
        this.koEditItem(null);
    };
    SurveyNestedPropertyEditor.prototype.createColumns = function () {
        var result = [];
        var properties = this.getProperties();
        for (var i = 0; i < properties.length; i++) {
            result.push(new SurveyNestedPropertyEditorColumn(properties[i]));
        }
        this.koColumnsValue(result);
    };
    SurveyNestedPropertyEditor.prototype.getProperties = function () {
        return [];
    };
    SurveyNestedPropertyEditor.prototype.getPropertiesNames = function (definitionName, defaultNames) {
        var res = [];
        var properties = __WEBPACK_IMPORTED_MODULE_6__questionEditors_questionEditorDefinition__["a" /* SurveyQuestionEditorDefinition */].getProperties(definitionName);
        if (properties) {
            for (var i = 0; i < properties.length; i++) {
                var prop = properties[i];
                res.push(prop.name ? prop.name : prop);
            }
        }
        if (res.length == 0) {
            res = defaultNames;
        }
        return res;
    };
    SurveyNestedPropertyEditor.prototype.getPropertiesByNames = function (className, names) {
        var res = [];
        for (var i = 0; i < names.length; i++) {
            var name = names[i];
            name.name ? name.name : name;
            var prop = __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["JsonObject"].metaData.findProperty(className, name);
            if (prop && prop.visible) {
                res.push(prop);
            }
        }
        return res;
    };
    SurveyNestedPropertyEditor.prototype.getEditorName = function () {
        return "";
    };
    SurveyNestedPropertyEditor.prototype.onListDetailViewChanged = function () { };
    SurveyNestedPropertyEditor.prototype.checkForErrors = function () {
        var result = false;
        for (var i = 0; i < this.koItems().length; i++) {
            result = result || this.koItems()[i].hasError();
        }
        return _super.prototype.checkForErrors.call(this) || result;
    };
    SurveyNestedPropertyEditor.prototype.onBeforeApply = function () {
        var internalItems = this.koItems();
        for (var i = 0; i < internalItems.length; i++) {
            internalItems[i].apply();
        }
        _super.prototype.onBeforeApply.call(this);
    };
    return SurveyNestedPropertyEditor;
}(__WEBPACK_IMPORTED_MODULE_3__propertyItemsEditor__["a" /* SurveyPropertyItemsEditor */]));

var SurveyNestedPropertyEditorItem = /** @class */ (function () {
    function SurveyNestedPropertyEditorItem(obj, getColumns, options) {
        var _this = this;
        this.obj = obj;
        this.getColumns = getColumns;
        this.koCellsValue = __WEBPACK_IMPORTED_MODULE_1_knockout__["observableArray"]();
        this.options = options;
        __WEBPACK_IMPORTED_MODULE_1_knockout__["computed"](function () {
            var columns = _this.getColumns();
            _this.koCellsValue([]);
            for (var i = 0; i < columns.length; i++) {
                _this.koCellsValue.push(new SurveyNestedPropertyEditorEditorCell(obj, columns[i].property, _this.options));
            }
        });
    }
    Object.defineProperty(SurveyNestedPropertyEditorItem.prototype, "columns", {
        get: function () {
            return this.getColumns();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyNestedPropertyEditorItem.prototype, "itemEditor", {
        get: function () {
            if (!this.itemEditorValue)
                this.itemEditorValue = this.createSurveyQuestionEditor();
            return this.itemEditorValue;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyNestedPropertyEditorItem.prototype, "cells", {
        get: function () {
            return this.koCellsValue();
        },
        enumerable: true,
        configurable: true
    });
    SurveyNestedPropertyEditorItem.prototype.hasError = function () {
        if (this.itemEditorValue && this.itemEditorValue.hasError())
            return true;
        var res = false;
        for (var i = 0; i < this.cells.length; i++) {
            res = this.cells[i].hasError || res;
        }
        return res;
    };
    SurveyNestedPropertyEditorItem.prototype.resetSurveyQuestionEditor = function () {
        this.itemEditorValue = null;
    };
    SurveyNestedPropertyEditorItem.prototype.createSurveyQuestionEditor = function () {
        return null;
    };
    SurveyNestedPropertyEditorItem.prototype.apply = function () {
        if (this.itemEditorValue)
            this.itemEditorValue.apply();
    };
    return SurveyNestedPropertyEditorItem;
}());

var SurveyNestedPropertyEditorColumn = /** @class */ (function () {
    function SurveyNestedPropertyEditorColumn(property) {
        this.property = property;
    }
    Object.defineProperty(SurveyNestedPropertyEditorColumn.prototype, "text", {
        get: function () {
            var text = __WEBPACK_IMPORTED_MODULE_4__editorLocalization__["a" /* editorLocalization */].hasString("pel." + this.property.name)
                ? this.getLocText("pel.")
                : this.getLocText("pe.");
            return text ? text : this.property.name;
        },
        enumerable: true,
        configurable: true
    });
    SurveyNestedPropertyEditorColumn.prototype.getLocText = function (prefix) {
        return __WEBPACK_IMPORTED_MODULE_4__editorLocalization__["a" /* editorLocalization */].getString(prefix + this.property.name);
    };
    return SurveyNestedPropertyEditorColumn;
}());

var SurveyNestedPropertyEditorEditorCell = /** @class */ (function () {
    function SurveyNestedPropertyEditorEditorCell(obj, property, options) {
        if (options === void 0) { options = null; }
        this.obj = obj;
        this.property = property;
        this.options = options;
        var self = this;
        var propEvent = function (property, newValue) {
            self.value = newValue;
        };
        this.objectPropertyValue = new __WEBPACK_IMPORTED_MODULE_5__objectProperty__["a" /* SurveyObjectProperty */](this.property, propEvent, this.options);
        this.objectPropertyValue.editor.isInplaceProperty = true;
        this.objectProperty.object = obj;
    }
    Object.defineProperty(SurveyNestedPropertyEditorEditorCell.prototype, "objectProperty", {
        get: function () {
            return this.objectPropertyValue;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyNestedPropertyEditorEditorCell.prototype, "editor", {
        get: function () {
            return this.objectProperty.editor;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyNestedPropertyEditorEditorCell.prototype, "koValue", {
        get: function () {
            return this.objectProperty.editor.koValue;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyNestedPropertyEditorEditorCell.prototype, "value", {
        get: function () {
            return this.property.getValue(this.obj);
        },
        set: function (val) {
            this.obj[this.property.name] = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyNestedPropertyEditorEditorCell.prototype, "hasError", {
        get: function () {
            return this.editor.hasError();
        },
        enumerable: true,
        configurable: true
    });
    return SurveyNestedPropertyEditorEditorCell;
}());



/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_survey_knockout__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_survey_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_survey_knockout__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SurveyQuestionEditorDefinition; });

var SurveyQuestionEditorDefinition = /** @class */ (function () {
    function SurveyQuestionEditorDefinition() {
    }
    SurveyQuestionEditorDefinition.getProperties = function (className) {
        var properties = [];
        var allDefinitions = SurveyQuestionEditorDefinition.getAllDefinitionsByClass(className);
        for (var i = allDefinitions.length - 1; i >= 0; i--) {
            var def = allDefinitions[i];
            if (def.properties) {
                for (var j = 0; j < def.properties.length; j++) {
                    if (!def.properties[j]["tab"] ||
                        def.properties[j]["tab"] === "general") {
                        properties.push(def.properties[j]);
                    }
                }
            }
        }
        return properties;
    };
    SurveyQuestionEditorDefinition.isGeneralTabVisible = function (className) {
        var allDefinitions = SurveyQuestionEditorDefinition.getAllDefinitionsByClass(className);
        for (var i = allDefinitions.length - 1; i >= 0; i--) {
            var def = allDefinitions[i];
            if (def.tabs) {
                for (var j = 0; j < def.tabs.length; j++) {
                    var tab = def.tabs[j];
                    if (tab.name == "general")
                        return tab.visible !== false;
                }
            }
        }
        return true;
    };
    SurveyQuestionEditorDefinition.getTabs = function (className) {
        var tabs = [];
        var allDefinitions = SurveyQuestionEditorDefinition.getAllDefinitionsByClass(className);
        var tabsNamesHash = {};
        for (var i = 0; i < allDefinitions.length; i++) {
            var def = allDefinitions[i];
            if (def.tabs) {
                for (var j = 0; j < def.tabs.length; j++) {
                    var tab = def.tabs[j];
                    if (tabsNamesHash[tab.name])
                        continue;
                    tabsNamesHash[tab.name] = true;
                    if (tab.visible !== false) {
                        tabs.push(tab);
                    }
                }
            }
        }
        tabs.sort(function (a, b) {
            return a.index < b.index ? -1 : a.index > b.index ? 1 : 0;
        });
        return tabs;
    };
    SurveyQuestionEditorDefinition.getAllDefinitionsByClass = function (className) {
        var result = [];
        if (className.indexOf("@") > -1 &&
            SurveyQuestionEditorDefinition.definition[className]) {
            result.push(SurveyQuestionEditorDefinition.definition[className]);
            return result;
        }
        while (className) {
            var metaClass = (__WEBPACK_IMPORTED_MODULE_0_survey_knockout__["JsonObject"].metaData["findClass"](className));
            if (!metaClass)
                break;
            if (SurveyQuestionEditorDefinition.definition[metaClass.name]) {
                result.push(SurveyQuestionEditorDefinition.definition[metaClass.name]);
            }
            className = metaClass.parentName;
        }
        return result;
    };
    SurveyQuestionEditorDefinition.definition = {
        question: {
            properties: [
                "name",
                "title",
                { name: "visible", category: "checks" },
                { name: "isRequired", category: "checks" },
                { name: "startWithNewLine", category: "checks" }
            ],
            tabs: [
                { name: "visibleIf", index: 100 },
                { name: "enableIf", index: 110 }
            ]
        },
        comment: {
            properties: ["rows", "placeHolder"]
        },
        file: {
            properties: [
                { name: "showPreview", category: "imageChecks" },
                { name: "storeDataAsText", category: "imageChecks" },
                "maxSize",
                "imageHeight",
                "imageWidth"
            ]
        },
        html: {
            tabs: [{ name: "html", index: 10 }]
        },
        matrixdropdownbase: {
            properties: ["cellType", "columnsLocation"],
            tabs: [
                { name: "columns", index: 10 },
                { name: "rows", index: 11 },
                { name: "choices", index: 12 }
            ]
        },
        matrixdynamic: {
            properties: ["rowCount", "addRowLocation", "addRowText", "removeRowText"]
        },
        matrix: {
            tabs: [{ name: "columns", index: 10 }, { name: "rows", index: 11 }]
        },
        multipletext: {
            properties: ["colCount"],
            tabs: [{ name: "items", index: 10 }]
        },
        rating: {
            properties: ["minRateDescription", "maxRateDescription"],
            tabs: [{ name: "rateValues", index: 10 }]
        },
        selectbase: {
            properties: [
                { name: "hasOther", tab: "choices" },
                { name: "otherText", tab: "choices" },
                "choicesOrder",
                "colCount"
            ],
            tabs: [
                { name: "choices", index: 10 },
                { name: "choicesByUrl", index: 11 }
            ]
        },
        "itemvalue[]@choices": {
            title: "Rules",
            tabs: [
                { name: "general", visible: false },
                { name: "visibleIf", visible: true },
                { name: "enableIf", visible: true }
            ]
        },
        "itemvalue[]@rows": {
            title: "Rules",
            tabs: [
                { name: "general", visible: false },
                { name: "visibleIf", visible: true }
            ]
        },
        "itemvalue[]@columns": {
            title: "Rules",
            tabs: [
                { name: "general", visible: false },
                { name: "visibleIf", visible: true }
            ]
        },
        checkbox: {},
        radiogroup: {},
        dropdown: {
            properties: ["optionsCaption"]
        },
        text: {
            properties: ["inputType", "placeHolder"]
        },
        boolean: {
            properties: ["label"]
        },
        expression: {
            properties: ["currency", "displayStyle"],
            tabs: [{ name: "expression", index: 10 }]
        },
        matrixdropdowncolumn: {
            properties: ["isRequired", "cellType", "name", "title"]
        },
        "matrixdropdowncolumn@default": {
            tabs: [
                { name: "general", visible: false },
                { name: "visibleIf", index: 12 },
                { name: "enableIf", index: 20 },
                { name: "requiredIf", index: 30 }
            ]
        },
        "matrixdropdowncolumn@checkbox": {
            properties: ["hasOther", "otherText", "choicesOrder", "colCount"],
            tabs: [
                { name: "choices", index: 10 },
                { name: "choicesByUrl", index: 11 },
                { name: "visibleIf", index: 12 },
                { name: "enableIf", index: 20 },
                { name: "requiredIf", index: 30 }
            ]
        },
        "matrixdropdowncolumn@radiogroup": {
            properties: ["hasOther", "otherText", "choicesOrder", "colCount"],
            tabs: [
                { name: "choices", index: 10 },
                { name: "choicesByUrl", index: 11 },
                { name: "visibleIf", index: 12 },
                { name: "enableIf", index: 20 },
                { name: "requiredIf", index: 30 }
            ]
        },
        "matrixdropdowncolumn@dropdown": {
            properties: ["hasOther", "otherText", "choicesOrder", "optionsCaption"],
            tabs: [
                { name: "choices", index: 10 },
                { name: "choicesByUrl", index: 11 },
                { name: "visibleIf", index: 12 },
                { name: "enableIf", index: 20 },
                { name: "requiredIf", index: 30 }
            ]
        },
        "matrixdropdowncolumn@text": {
            properties: ["inputType", "placeHolder", "maxLength"],
            tabs: [
                { name: "validators", index: 10 },
                { name: "visibleIf", index: 12 },
                { name: "enableIf", index: 20 },
                { name: "requiredIf", index: 30 }
            ]
        },
        "matrixdropdowncolumn@comment": {
            properties: ["rows", "placeHolder", "maxLength"],
            tabs: [
                { name: "validators", index: 10 },
                { name: "visibleIf", index: 12 },
                { name: "enableIf", index: 20 },
                { name: "requiredIf", index: 30 }
            ]
        },
        "matrixdropdowncolumn@boolean": {
            properties: ["defaultValue"],
            tabs: [
                { name: "visibleIf", index: 12 },
                { name: "enableIf", index: 20 },
                { name: "requiredIf", index: 30 }
            ]
        },
        "matrixdropdowncolumn@expression": {
            properties: ["name", "displayStyle", "currency"],
            tabs: [{ name: "expression", index: 10 }]
        },
        multipletextitem: {
            properties: ["inputType", "maxLength", "placeHolder"],
            tabs: [{ name: "validators", index: 10 }]
        },
        paneldynamic: {
            properties: [
                { name: "renderMode", category: "render" },
                { name: "allowAddPanel", category: "render" },
                { name: "allowRemovePanel", category: "render" },
                "panelAddText",
                "panelRemoveText"
            ],
            tabs: [{ name: "templateTitle", index: 10 }]
        },
        panel: {
            properties: ["name", "title", { name: "visible", category: "checks" }],
            tabs: [{ name: "visibleIf", index: 100 }]
        },
        page: {
            properties: [
                "name",
                "title",
                { name: "visible", category: "checks" },
                "questionsOrder"
            ],
            tabs: [{ name: "visibleIf", index: 100 }]
        },
        survey: {
            properties: [
                "title",
                "showTitle",
                "locale",
                "mode",
                "clearInvisibleValues",
                "cookieName",
                { name: "sendResultOnPageNext", category: "data" },
                { name: "storeOthersAsComment", category: "data" },
                { name: "showPageTitles", category: "page" },
                { name: "showPageNumbers", category: "page" },
                { name: "pagePrevText", tab: "navigation" },
                { name: "pageNextText", tab: "navigation" },
                { name: "completeText", tab: "navigation" },
                { name: "startSurveyText", tab: "navigation" },
                {
                    name: "showNavigationButtons",
                    tab: "navigation",
                    category: "navbuttons"
                },
                { name: "showPrevButton", tab: "navigation", category: "navbuttons" },
                { name: "firstPageIsStarted", tab: "navigation", category: "navpages" },
                { name: "showCompletedPage", tab: "navigation", category: "navpages" },
                { name: "goNextPageAutomatic", tab: "navigation", category: "navopt" },
                { name: "showProgressBar", tab: "navigation", category: "navopt" },
                { name: "isSinglePage", tab: "navigation" },
                { name: "questionTitleLocation", tab: "question" },
                { name: "requiredText", tab: "question" },
                { name: "questionStartIndex", tab: "question" },
                { name: "showQuestionNumbers", tab: "question" },
                { name: "questionTitleTemplate", tab: "question" },
                { name: "questionErrorLocation", tab: "question" },
                {
                    name: "focusFirstQuestionAutomatic",
                    tab: "question"
                },
                { name: "questionsOrder", tab: "question" },
                { name: "maxTimeToFinish", tab: "timer" },
                { name: "maxTimeToFinishPage", tab: "timer" },
                { name: "showTimerPanel", tab: "timer", category: "check" },
                { name: "showTimerPanelMode", tab: "timer", category: "check" }
            ],
            tabs: [
                { name: "navigation", index: 10 },
                { name: "question", index: 20 },
                { name: "completedHtml", index: 70 },
                { name: "loadingHtml", index: 80 },
                { name: "timer", index: 90 },
                { name: "triggers", index: 100 }
            ]
        }
    };
    return SurveyQuestionEditorDefinition;
}());



/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_knockout__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__surveyjsObjects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editorLocalization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__title_editor_scss__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__title_editor_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__title_editor_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_survey_knockout__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_survey_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_survey_knockout__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TitleInplaceEditor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return titleAdorner; });
/* unused harmony export itemTitleAdorner */





var templateHtml = __webpack_require__(130);
var FRIENDLY_PADDING = 36;
function resizeInput(target) {
    var computedStyle = window.getComputedStyle(target);
    target.style.width =
        getTextWidth(target.value, computedStyle.font) + FRIENDLY_PADDING + "px";
}
/**
 * Uses canvas.measureText to compute and return the width of the given text of given font in pixels.
 *
 * @param {String} text The text to be rendered.
 * @param {String} font The css font descriptor that text is to be rendered with (e.g. "bold 14px verdana").
 *
 * @see https://stackoverflow.com/questions/118241/calculate-text-width-with-javascript/21015393#21015393
 */
var cachedCanvas;
function getTextWidth(text, font) {
    // re-use canvas object for better performance
    var canvas = cachedCanvas || (cachedCanvas = document.createElement("canvas"));
    var context = canvas.getContext("2d");
    context.font = font;
    var metrics = context.measureText(text);
    return metrics.width;
}
var TitleInplaceEditor = /** @class */ (function () {
    function TitleInplaceEditor(name, rootElement) {
        var _this = this;
        this.rootElement = rootElement;
        this.editingName = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"]();
        this.prevName = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"]();
        this.isEditing = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"](false);
        this.hideEditor = function () {
            _this.isEditing(false);
            _this.forNeibours(function (element) {
                element.style.display = element.dataset["sjsOldDisplay"];
            });
        };
        this.startEdit = function (model, event) {
            _this.editingName(_this.prevName());
            _this.isEditing(true);
            _this.forNeibours(function (element) {
                element.dataset["sjsOldDisplay"] = element.style.display;
                element.style.display = "none";
            });
            var inputElem = _this.rootElement.getElementsByTagName("input")[0];
            inputElem.focus();
            resizeInput(inputElem);
        };
        this.postEdit = function () {
            if (_this.prevName() !== _this.editingName()) {
                _this.prevName(_this.editingName());
                !!_this.valueChanged && _this.valueChanged(_this.editingName());
            }
            _this.hideEditor();
        };
        this.cancelEdit = function () {
            _this.editingName(_this.prevName());
            _this.hideEditor();
        };
        this.nameEditorKeypress = function (model, event) {
            resizeInput(event.target);
            if (event.keyCode === 13) {
                _this.postEdit();
            }
            else if (event.keyCode === 27) {
                _this.cancelEdit();
            }
        };
        this.editingName(name);
        this.prevName(name);
        this.forNeibours(function (element) {
            return (element.onclick = function (e) {
                _this.startEdit(_this, e);
                e.preventDefault();
            });
        });
    }
    TitleInplaceEditor.prototype.forNeibours = function (func) {
        if (!this.rootElement.parentElement ||
            !this.rootElement.parentElement.parentElement)
            return;
        var holder = this.rootElement.parentElement.parentElement;
        for (var i = 0; i < holder.children.length - 1; i++) {
            var element = holder.children[i];
            if (element.className.indexOf("svda-custom-content") === -1) {
                func(element);
            }
        }
    };
    TitleInplaceEditor.prototype.getLocString = function (str) {
        return __WEBPACK_IMPORTED_MODULE_2__editorLocalization__["a" /* editorLocalization */].getString(str);
    };
    return TitleInplaceEditor;
}());

__WEBPACK_IMPORTED_MODULE_0_knockout__["components"].register("title-editor", {
    viewModel: {
        createViewModel: function (params, componentInfo) {
            var model = new TitleInplaceEditor(params.model[params.name], componentInfo.element);
            var property = __WEBPACK_IMPORTED_MODULE_4_survey_knockout__["JsonObject"].metaData.findProperty(params.model.getType(), params.name);
            model.valueChanged = function (newValue) {
                var options = {
                    propertyName: property.name,
                    obj: params.model,
                    value: newValue,
                    newValue: null,
                    doValidation: false
                };
                params.editor.onValueChangingCallback(options);
                newValue = options.newValue === null ? options.value : options.newValue;
                params.model[params.name] = newValue;
                params.editor.onPropertyValueChanged(property, params.model, newValue);
            };
            return model;
        }
    },
    template: templateHtml
});
var titleAdorner = {
    getMarkerClass: function (model) {
        return "title_editable";
    },
    getElementName: function (model) { return "title"; },
    afterRender: function (elements, model, editor) {
        var decoration = document.createElement("span");
        decoration.innerHTML =
            "<title-editor params='name: \"title\", model: model, editor: editor'></title-editor>";
        elements[0].appendChild(decoration);
        __WEBPACK_IMPORTED_MODULE_0_knockout__["applyBindings"]({ model: model, editor: editor }, decoration);
        __WEBPACK_IMPORTED_MODULE_0_knockout__["tasks"].runEarly();
        editor.onAdornerRenderedCallback(model, "title", decoration);
    }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__surveyjsObjects__["b" /* registerAdorner */])("title", titleAdorner);
var itemTitleAdorner = {
    getMarkerClass: function (model) {
        return !!model.items ? "item_title_editable title_editable" : "";
    },
    getElementName: function (model) { return "itemTitle"; },
    afterRender: function (elements, model, editor) {
        for (var i = 0; i < elements.length; i++) {
            var decoration = document.createElement("span");
            decoration.innerHTML =
                "<title-editor params='name: \"title\", model: model, editor: editor'></title-editor>";
            elements[i].appendChild(decoration);
            __WEBPACK_IMPORTED_MODULE_0_knockout__["applyBindings"]({ model: model.items[i], editor: editor }, decoration);
            __WEBPACK_IMPORTED_MODULE_0_knockout__["tasks"].runEarly();
            editor.onAdornerRenderedCallback(model, "item-title", decoration, model.items[i]);
        }
    }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__surveyjsObjects__["b" /* registerAdorner */])("item-title", itemTitleAdorner);


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_knockout__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_survey_knockout__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_survey_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_survey_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__surveyHelper__ = __webpack_require__(6);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SurveyObjectEditor; });




var SurveyObjectEditor = /** @class */ (function () {
    function SurveyObjectEditor(propertyEditorOptions) {
        if (propertyEditorOptions === void 0) { propertyEditorOptions = null; }
        var _this = this;
        this.propertyEditorOptions = propertyEditorOptions;
        this.oldActiveProperty = null;
        this.koProperties = __WEBPACK_IMPORTED_MODULE_0_knockout__["observableArray"]();
        this.koActiveProperty = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"]();
        this.koHasObject = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"]();
        this.onPropertyValueChanged = new __WEBPACK_IMPORTED_MODULE_1_survey_knockout__["Event"]();
        this.koActiveProperty.subscribe(function (newValue) {
            if (_this.oldActiveProperty === newValue)
                return;
            if (_this.oldActiveProperty)
                _this.oldActiveProperty.isActive = false;
            _this.oldActiveProperty = newValue;
            if (newValue)
                newValue.isActive = true;
        });
        var self = this;
        this.koAfterRender = function (el, con) {
            self.afterRender(el, con);
        };
    }
    Object.defineProperty(SurveyObjectEditor.prototype, "selectedObject", {
        get: function () {
            return this.selectedObjectValue;
        },
        set: function (value) {
            if (this.selectedObjectValue == value)
                return;
            this.koHasObject(value != null);
            this.selectedObjectValue = value;
            this.updateProperties();
            this.updatePropertiesObject();
        },
        enumerable: true,
        configurable: true
    });
    SurveyObjectEditor.prototype.getPropertyEditor = function (name) {
        var properties = this.koProperties();
        for (var i = 0; i < properties.length; i++) {
            if (properties[i].name == name)
                return properties[i];
        }
        return null;
    };
    SurveyObjectEditor.prototype.changeActiveProperty = function (property) {
        this.koActiveProperty(property);
    };
    SurveyObjectEditor.prototype.objectChanged = function () {
        this.updatePropertiesObject();
    };
    SurveyObjectEditor.prototype.afterRender = function (elements, prop) {
        if (!__WEBPACK_IMPORTED_MODULE_1_survey_knockout__["SurveyElement"] ||
            !__WEBPACK_IMPORTED_MODULE_1_survey_knockout__["SurveyElement"].GetFirstNonTextElement ||
            !this.onAfterRenderCallback)
            return;
        var el = __WEBPACK_IMPORTED_MODULE_1_survey_knockout__["SurveyElement"].GetFirstNonTextElement(elements);
        var tEl = elements[0];
        if (tEl.nodeName === "#text")
            tEl.data = "";
        tEl = elements[elements.length - 1];
        if (tEl.nodeName === "#text")
            tEl.data = "";
        this.onAfterRenderCallback(this.selectedObject, el, prop);
    };
    SurveyObjectEditor.prototype.updateProperties = function () {
        var _this = this;
        if (!this.selectedObject || !this.selectedObject.getType) {
            this.koProperties([]);
            this.koActiveProperty(null);
            return;
        }
        var properties = __WEBPACK_IMPORTED_MODULE_1_survey_knockout__["JsonObject"].metaData["getPropertiesByObj"]
            ? __WEBPACK_IMPORTED_MODULE_1_survey_knockout__["JsonObject"].metaData["getPropertiesByObj"](this.selectedObject)
            : __WEBPACK_IMPORTED_MODULE_1_survey_knockout__["JsonObject"].metaData.getProperties(this.selectedObject.getType());
        var objectProperties = [];
        var self = this;
        var propEvent = function (property, newValue) {
            var options = {
                property: property.property,
                object: property.object,
                newValue: newValue,
                updatedValue: null
            };
            self.onPropertyValueChanged.fire(_this, options);
            if (!!options.updatedValue && options.updatedValue != options.newValue) {
                property.koValue(options.updatedValue);
            }
        };
        var visibleProperties = [];
        for (var i = 0; i < properties.length; i++) {
            if (!this.canShowProperty(properties[i]))
                continue;
            visibleProperties.push(properties[i]);
        }
        var sortEvent = function (a, b) {
            var res = 0;
            if (self.onSortPropertyCallback) {
                res = self.onSortPropertyCallback(self.selectedObject, a.property, b.property);
            }
            if (res)
                return res;
            if (a.displayName == b.displayName)
                return 0;
            if (a.displayName > b.displayName)
                return 1;
            return -1;
        };
        for (var i = 0; i < visibleProperties.length; i++) {
            var objectProperty = new __WEBPACK_IMPORTED_MODULE_2__objectProperty__["a" /* SurveyObjectProperty */](visibleProperties[i], propEvent, this.propertyEditorOptions);
            objectProperty.editor.isInplaceProperty = true;
            objectProperties.push(objectProperty);
        }
        objectProperties.sort(sortEvent);
        this.koProperties(objectProperties);
        var propEditor = this.getPropertyEditor("name");
        if (!propEditor && objectProperties.length > 0) {
            propEditor = this.getPropertyEditor(objectProperties[0].name);
        }
        if (propEditor) {
            this.koActiveProperty(propEditor);
        }
    };
    SurveyObjectEditor.prototype.canShowProperty = function (property) {
        return __WEBPACK_IMPORTED_MODULE_3__surveyHelper__["b" /* SurveyHelper */].isPropertyVisible(this.selectedObject, property, this.onCanShowPropertyCallback);
    };
    SurveyObjectEditor.prototype.updatePropertiesObject = function () {
        var properties = this.koProperties();
        for (var i = 0; i < properties.length; i++) {
            properties[i].object = this.selectedObject;
        }
    };
    return SurveyObjectEditor;
}());



/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_survey_knockout__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_survey_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_survey_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_knockout__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_knockout__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StylesManager; });


var StylesManager = /** @class */ (function () {
    function StylesManager() {
        this.sheet = null;
        this.sheet = StylesManager.findSheet(StylesManager.SurveyJSStylesSheetId);
        if (!this.sheet) {
            this.sheet = StylesManager.createSheet(StylesManager.SurveyJSStylesSheetId);
            this.initializeStyles(this.sheet);
        }
    }
    StylesManager.findSheet = function (styleSheetId) {
        for (var i = 0; i < document.styleSheets.length; i++) {
            if (!!document.styleSheets[i].ownerNode &&
                document.styleSheets[i].ownerNode["id"] === styleSheetId) {
                return document.styleSheets[i];
            }
        }
        return null;
    };
    StylesManager.createSheet = function (styleSheetId) {
        var style = document.createElement("style");
        style.id = styleSheetId;
        // Add a media (and/or media query) here if you'd like!
        // style.setAttribute("media", "screen")
        // style.setAttribute("media", "only screen and (max-width : 1024px)")
        style.appendChild(document.createTextNode(""));
        document.head.appendChild(style);
        return style.sheet;
    };
    StylesManager.applyTheme = function (themeName, themeSelector) {
        if (themeName === void 0) { themeName = "default"; }
        if (themeSelector === void 0) { themeSelector = ".svd_container"; }
        StylesManager.currentTheme(themeName);
        StylesManager.applySurveyTheme(themeName);
        var sheet = StylesManager.findSheet(themeName + themeSelector);
        if (!sheet) {
            sheet = StylesManager.createSheet(themeName + themeSelector);
            var theme_1 = StylesManager.ThemeColors[themeName] ||
                StylesManager.ThemeColors["default"];
            var ThemeCss_1;
            if (["bootstrap", "bootstrapmaterial"].indexOf(themeName) !== -1) {
                ThemeCss_1 = StylesManager[themeName + "ThemeCss"];
            }
            else {
                ThemeCss_1 = StylesManager.ThemeCss;
            }
            Object.keys(ThemeCss_1).forEach(function (selector) {
                var cssRuleText = ThemeCss_1[selector];
                Object.keys(theme_1).forEach(function (colorVariableName) {
                    return (cssRuleText = cssRuleText.replace(new RegExp("\\" + colorVariableName, "g"), theme_1[colorVariableName]));
                });
                sheet.insertRule(themeSelector + selector + " { " + cssRuleText + " }", 0);
            });
        }
    };
    StylesManager.applySurveyTheme = function (themeName) {
        if (["bootstrap", "bootstrapmaterial"].indexOf(themeName) !== -1) {
            __WEBPACK_IMPORTED_MODULE_0_survey_knockout__["Survey"].cssType = themeName;
        }
        else {
            __WEBPACK_IMPORTED_MODULE_0_survey_knockout__["Survey"].cssType = "default";
        }
        __WEBPACK_IMPORTED_MODULE_0_survey_knockout__["StylesManager"].applyTheme(themeName);
    };
    StylesManager.prototype.initializeStyles = function (sheet) {
        Object.keys(StylesManager.Styles).forEach(function (selector) {
            return sheet.insertRule(selector + " { " + StylesManager.Styles[selector] + " }", 0);
        });
    };
    StylesManager.SurveyJSStylesSheetId = "surveyjs";
    StylesManager.Styles = {};
    StylesManager.ThemeColors = {
        default: {
            "$primary-color": "#1ab394",
            "$secondary-color": "#1ab394",
            "$primary-text-color": "#676a6c",
            "$secondary-text-color": "#a7a7a7",
            "$inverted-text-color": "#ffffff",
            "$primary-hover-color": "#18a689",
            "$selection-border-color": "#1ab394",
            "$primary-icon-color": "#3d4d5d",
            "$primary-bg-color": "#fff",
            "$secondary-bg-color": "#f4f4f4",
            "$primary-border-color": "#e7eaec",
            "$secondary-border-color": "#ddd"
        },
        orange: {
            "$primary-color": "#f78119",
            "$secondary-color": "#4a4a4a",
            "$primary-text-color": "#676a6c",
            "$secondary-text-color": "#a7a7a7",
            "$inverted-text-color": "#ffffff",
            "$primary-hover-color": "#e77109",
            "$selection-border-color": "#4a4a4a",
            "$primary-icon-color": "#3d4d5d",
            "$primary-bg-color": "#fff",
            "$secondary-bg-color": "#f4f4f4",
            "$primary-border-color": "#e7eaec",
            "$secondary-border-color": "#ddd"
        },
        darkblue: {
            "$primary-color": "#3c4f6d",
            "$secondary-color": "#3c4f6d",
            "$primary-text-color": "#676a6c",
            "$secondary-text-color": "#a7a7a7",
            "$inverted-text-color": "#ffffff",
            "$primary-hover-color": "#2c3f5d",
            "$selection-border-color": "#4a4a4a",
            "$primary-icon-color": "#3d4d5d",
            "$primary-bg-color": "#fff",
            "$secondary-bg-color": "#f4f4f4",
            "$primary-border-color": "#e7eaec",
            "$secondary-border-color": "#ddd"
        },
        darkrose: {
            "$primary-color": "#68656e",
            "$secondary-color": "#68656e",
            "$primary-text-color": "#676a6c",
            "$secondary-text-color": "#a7a7a7",
            "$inverted-text-color": "#ffffff",
            "$primary-hover-color": "#57545e",
            "$selection-border-color": "#4a4a4a",
            "$primary-icon-color": "#3d4d5d",
            "$primary-bg-color": "#fff",
            "$secondary-bg-color": "#f4f4f4",
            "$primary-border-color": "#e7eaec",
            "$secondary-border-color": "#ddd"
        },
        stone: {
            "$primary-color": "#0f0f33",
            "$secondary-color": "#0f0f33",
            "$primary-text-color": "#676a6c",
            "$secondary-text-color": "#a7a7a7",
            "$inverted-text-color": "#ffffff",
            "$primary-hover-color": "#000023",
            "$selection-border-color": "#cdccd2",
            "$primary-icon-color": "#3d4d5d",
            "$primary-bg-color": "#fff",
            "$secondary-bg-color": "#f4f4f4",
            "$primary-border-color": "#e7eaec",
            "$secondary-border-color": "#ddd"
        },
        winter: {
            "$primary-color": "#5ac8fa",
            "$secondary-color": "#5ac8fa",
            "$primary-text-color": "#676a6c",
            "$secondary-text-color": "#a7a7a7",
            "$inverted-text-color": "#ffffff",
            "$primary-hover-color": "#4ad8ea",
            "$selection-border-color": "#82b8da",
            "$primary-icon-color": "#3d4d5d",
            "$primary-bg-color": "#fff",
            "$secondary-bg-color": "#f4f4f4",
            "$primary-border-color": "#e7eaec",
            "$secondary-border-color": "#ddd"
        },
        winterstone: {
            "$primary-color": "#3c3b40",
            "$secondary-color": "#3c3b40",
            "$primary-text-color": "#676a6c",
            "$secondary-text-color": "#a7a7a7",
            "$inverted-text-color": "#ffffff",
            "$primary-hover-color": "#1c1b20",
            "$selection-border-color": "#b8b8b8",
            "$primary-icon-color": "#3d4d5d",
            "$primary-bg-color": "#fff",
            "$secondary-bg-color": "#f4f4f4",
            "$primary-border-color": "#e7eaec",
            "$secondary-border-color": "#ddd"
        }
    };
    StylesManager.ThemeCss = {
        ".svd_container": "color: $primary-text-color;",
        ".svd_container a:focus, .svd_container select:focus, .svd_container span:focus, .svd_container div:focus, .svd_container tr:focus, .svd_container input[type='checkbox']:focus + span.checkmark": "outline-color: $primary-color;",
        ".svd_container .svd_toolbar button:focus": "outline-color: $primary-text-color;",
        ".svd_container a": "color: $primary-color;",
        ".svd_container a:hover": "color: $primary-hover-color;",
        ".svd_container .svd-main-color": "color: $primary-color;",
        ".svd_container .svd-main-border-color": "border-color: $selection-border-color;",
        ".svd_container .svd-main-background-color": "background-color: $primary-color;",
        ".svd_container .svd-light-background-color": "background-color: $primary-border-color;",
        ".svd_container .btn-primary": "color: $inverted-text-color; background-color: $secondary-color; border-color: $secondary-color;",
        ".svd_container .btn-link": "color: $primary-text-color; background-color: $secondary-bg-color; border-color: $secondary-bg-color;",
        ".svd_container .svd-svg-icon": "fill: $primary-icon-color;",
        ".svd_container .svd-primary-icon .svd-svg-icon": "fill: $primary-color;",
        ".svd_container .svd-secondary-icon .svd-svg-icon": "fill: $secondary-color;",
        ".svd_container .icon-gearactive .svd-svg-icon": "fill: $primary-color;",
        ".svd_container .nav-tabs a": "color: $primary-text-color",
        ".svd_container .nav-tabs > li.active > a": "color: $primary-color",
        ".svd_container .nav-item.active .nav-link": "background-color: $primary-bg-color;",
        ".svd_container .sjs-cb-container:hover input ~ .checkmark": "background-color: $dd-menu-border",
        ".svd_container .sjs-cb-container:hover input:checked ~ .checkmark": "background-color: $primary-hover-color",
        ".svd_container .svd_custom_select:before": "background-color: $primary-color;",
        ".svd_container .form-control:focus": "border-color: $primary-color;",
        ".svd_container .svd-light-text-color": "color: $secondary-text-color;",
        ".svd-light-bg-color": "background-color: $primary-bg-color;",
        ".svd_container .svd-light-bg-color": "background-color: $primary-bg-color;",
        ".svd_container .svd_toolbar li.active a": "background-color: $primary-color; color: $primary-bg-color;",
        ".svd_container .svd_selected_page": "border-bottom: 1px solid $primary-bg-color;",
        ".svd_container .editor-tabs > li > a:hover": "background-color: $secondary-bg-color; border-bottom: 1px solid $secondary-bg-color;",
        ".svd_container .editor-tabs > li > a:focus": "background-color: $secondary-bg-color; border-bottom: 1px solid $secondary-bg-color;",
        ".svd_container .editor-tabs > li.active > a": "color: $primary-color; background-color: $secondary-bg-color; border: 1px solid $primary-border-color; border-bottom-color: $secondary-bg-color;",
        ".svd_container .svd-light-border-color": "border-color: $primary-border-color",
        ".svd_container .svd-dark-border-color": "border-color: $secondary-border-color",
        ".svd_container .select2-container--default.select2-container--open .select2-selection--single .select2-selection__arrow": "background:  $primary-color;",
        ".svd_container .select2-container .select2-selection--single .select2-selection__arrow": "background:  $primary-color;"
    };
    StylesManager.bootstrapThemeCss = {
        ".svd_container.sv_bootstrap_css": "color: $primary-text-color;",
        ".svd_container.sv_bootstrap_css a:focus, .svd_container.sv_bootstrap_css select:focus, .svd_container.sv_bootstrap_css span:focus, .svd_container.sv_bootstrap_css div:focus, .svd_container.sv_bootstrap_css tr:focus, .svd_container.sv_bootstrap_css input[type='checkbox']:focus + span.checkmark": "outline-color: $primary-color;",
        ".svd_container.sv_bootstrap_css .svd_toolbar button:focus": "outline-color: $primary-text-color;",
        ".svd_container.sv_bootstrap_css a": "color: $primary-color;",
        ".svd_container.sv_bootstrap_css a:hover": "color: $primary-hover-color;",
        ".svd_container.sv_bootstrap_css .svd-main-color": "color: $primary-color;",
        ".svd_container.sv_bootstrap_css .svd-main-border-color": "border-color: $selection-border-color;",
        ".svd_container.sv_bootstrap_css .svd-main-background-color": "background-color: $primary-color;",
        ".svd_container.sv_bootstrap_css .svd-light-background-color": "background-color: $primary-border-color;",
        ".svd_container.sv_bootstrap_css .btn-primary": "color: $inverted-text-color; background-color: $secondary-color; border-color: $secondary-color;",
        ".svd_container.sv_bootstrap_css .btn-link": "color: $primary-text-color; background-color: $secondary-bg-color; border-color: $secondary-bg-color;",
        ".svd_container.sv_bootstrap_css .svd-svg-icon": "fill: $primary-icon-color;",
        ".svd_container.sv_bootstrap_css .svd-primary-icon .svd-svg-icon": "fill: $primary-color;",
        ".svd_container.sv_bootstrap_css .svd-secondary-icon .svd-svg-icon": "fill: $secondary-color;",
        ".svd_container.sv_bootstrap_css .icon-gearactive .svd-svg-icon": "fill: $primary-color;",
        ".svd_container.sv_bootstrap_css .nav-tabs a": "color: $primary-text-color;",
        ".svd_container.sv_bootstrap_css .nav-tabs > li.active > a": "color: $primary-color;",
        ".svd_container.sv_bootstrap_css .nav-item.active .nav-link": "background-color: $primary-bg-color;",
        ".svd_container.sv_bootstrap_css .sjs-cb-container:hover input ~ .checkmark": "background-color: $dd-menu-border",
        ".svd_container.sv_bootstrap_css .sjs-cb-container:hover input:checked ~ .checkmark": "background-color: $primary-hover-color",
        ".svd_container.sv_bootstrap_css .svd_custom_select:before": "background-color: $primary-color;",
        ".svd_container.sv_bootstrap_css .form-control:focus": "border-color: $primary-color;",
        ".svd_container.sv_bootstrap_css .svd-light-text-color": "color: $secondary-text-color;",
        ".svd-light-bg-color": "background-color: $primary-bg-color;",
        ".svd_container.sv_bootstrap_css .svd-light-bg-color": "background-color: $primary-bg-color;",
        ".svd_container.sv_bootstrap_css .svd_toolbar li.active a": "background-color: $primary-color; color: $primary-bg-color;",
        ".svd_container.sv_bootstrap_css .svd_selected_page": "border-bottom: 1px solid $primary-bg-color;",
        ".svd_container.sv_bootstrap_css .editor-tabs > li > a:hover": "background-color: $secondary-bg-color; border-bottom: 1px solid $secondary-bg-color;",
        ".svd_container.sv_bootstrap_css .editor-tabs > li > a:focus": "background-color: $secondary-bg-color; border-bottom: 1px solid $secondary-bg-color",
        ".svd_container.sv_bootstrap_css .editor-tabs > li.active > a": "color: $primary-color; background-color: $secondary-bg-color; border: 1px solid $primary-border-color; border-bottom-color: $secondary-bg-color;",
        ".svd_container.sv_bootstrap_css .svd-light-border-color": "border-color: $primary-border-color",
        ".svd_container.sv_bootstrap_css .svd-dark-border-color": "border-color: $secondary-border-color",
        ".svd_container.sv_bootstrap_css .select2-container--default.select2-container--open .select2-selection--single .select2-selection__arrow": "background:  $primary-color;",
        ".svd_container.sv_bootstrap_css .select2-container .select2-selection--single .select2-selection__arrow": "background:  $primary-color;",
        ".svd_container.sv_bootstrap_css .modal-tabs": "background: transparent; padding-bottom: 10px;",
        ".svd_container.sv_bootstrap_css .modal-tabs > li > a": "color: $primary-text-color; border: 1px solid transparent;",
        ".svd_container.sv_bootstrap_css .modal-tabs > li > a:hover": "color: $primary-color; border-bottom: 1px solid $inverted-text-color;",
        ".svd_container.sv_bootstrap_css .modal-tabs > li > a:focus": "$primary-color; border-bottom: 1px solid $inverted-text-color;",
        ".svd_container.sv_bootstrap_css .modal-tabs > li.active > a": "color: $primary-color; border: 1px solid $primary-border-color; border-bottom-color: $inverted-text-color;",
        ".svd_container.sv_bootstrap_css .form-group.is-focused .form-control": "background-image: linear-gradient($primary-color, $primary-color), linear-gradient(#D2D2D2, #D2D2D2);",
        ".svd_container.sv_bootstrap_css .form-group.is-focused label": "color:$primary-color;"
    };
    StylesManager.bootstrapmaterialThemeCss = {
        ".svd_container.sv_bootstrapmaterial_css": "color: $primary-text-color;",
        ".svd_container.sv_bootstrapmaterial_css a": "color: $primary-color;",
        ".svd_container.sv_bootstrapmaterial_css a:hover": "color: $primary-hover-color;",
        ".svd_container.sv_bootstrapmaterial_css .svd-main-color": "color: $primary-color;",
        ".svd_container.sv_bootstrapmaterial_css .svd-main-border-color": "border-color: $selection-border-color;",
        ".svd_container.sv_bootstrapmaterial_css .svd-main-background-color": "background-color: $primary-color;",
        ".svd_container.sv_bootstrapmaterial_css .svd-light-background-color": "background-color: $primary-border-color;",
        ".svd_container.sv_bootstrapmaterial_css .btn-primary": "color: $inverted-text-color; background-color: $secondary-color; border-color: $secondary-color;",
        ".svd_container.sv_bootstrapmaterial_css .btn-secondary": "background-color: $primary-border-color;",
        ".svd_container.sv_bootstrapmaterial_css .btn-secondary:hover": "opacity: 0.8;",
        ".svd_container.sv_bootstrapmaterial_css .btn-link": "color: $primary-text-color; background-color: $secondary-bg-color; border-color: $secondary-bg-color;",
        ".svd_container.sv_bootstrapmaterial_css .svd-svg-icon": "fill: $primary-icon-color;",
        ".svd_container.sv_bootstrapmaterial_css .svd-primary-icon .svd-svg-icon": "fill: $primary-color;",
        ".svd_container.sv_bootstrapmaterial_css .svd-secondary-icon .svd-svg-icon": "fill: $secondary-color;",
        ".svd_container.sv_bootstrapmaterial_css .icon-gearactive .svd-svg-icon": "fill: $primary-color;",
        ".svd_container.sv_bootstrapmaterial_css .nav-tabs a": "color: $primary-text-color !important;",
        ".svd_container.sv_bootstrapmaterial_css .nav-tabs > li.active > a": "color: $primary-color !important;",
        ".svd_container.sv_bootstrapmaterial_css .nav-item.active .nav-link": "background-color: $primary-bg-color !important;",
        ".svd_container.sv_bootstrapmaterial_css .sjs-cb-container:hover input ~ .checkmark": "background-color: $dd-menu-border",
        ".svd_container.sv_bootstrapmaterial_css .sjs-cb-container:hover input:checked ~ .checkmark": "background-color: $primary-hover-color",
        ".svd_container.sv_bootstrapmaterial_css .svd_custom_select:before": "background-color: $primary-color;",
        ".svd_container.sv_bootstrapmaterial_css .form-control:focus": "border-color: $primary-color;",
        ".svd_container.sv_bootstrapmaterial_css .svd-light-text-color": "color: $secondary-text-color;",
        ".svd-light-bg-color": "background-color: $primary-bg-color;",
        ".svd_container.sv_bootstrapmaterial_css .svd-light-bg-color": "background-color: $primary-bg-color;",
        ".svd_container.sv_bootstrapmaterial_css .svd_toolbar li.active a": "background-color: $primary-color; color: $primary-bg-color;",
        ".svd_container.sv_bootstrapmaterial_css .svd_selected_page": "border-bottom: 1px solid $primary-bg-color;",
        ".svd_container.sv_bootstrapmaterial_css .editor-tabs > li > a:hover": "background-color: $secondary-bg-color !important; border-bottom: 1px solid $secondary-bg-color !important;",
        ".svd_container.sv_bootstrapmaterial_css .editor-tabs > li > a:focus": "background-color: $secondary-bg-color !important; border-bottom: 1px solid $secondary-bg-color !important",
        ".svd_container.sv_bootstrapmaterial_css .editor-tabs > li.active > a": "color: $primary-color !important; background-color: $secondary-bg-color !important; border: 1px solid $primary-border-color !important; border-bottom-color: $secondary-bg-color !important;",
        ".svd_container.sv_bootstrapmaterial_css .svd-light-border-color": "border-color: $primary-border-color",
        ".svd_container.sv_bootstrapmaterial_css .svd-dark-border-color": "border-color: $secondary-border-color",
        ".svd_container.sv_bootstrapmaterial_css .select2-container--default.select2-container--open .select2-selection--single .select2-selection__arrow": "background:  $primary-color;",
        ".svd_container.sv_bootstrapmaterial_css .select2-container .select2-selection--single .select2-selection__arrow": "background:  $primary-color;",
        ".svd_container.sv_bootstrapmaterial_css .svd_properties_grid  .glyphicon-edit": "background-color: $primary-color;",
        ".svd_container.sv_bootstrapmaterial_css .svd_properties_grid  .glyphicon-edit:hover": "background-color:  $primary-hover-color;",
        ".svd_container.sv_bootstrapmaterial_css .modal-tabs": "background: transparent; padding-bottom: 10px;",
        ".svd_container.sv_bootstrapmaterial_css .modal-tabs > li > a": "color: $primary-text-color !important; border: 1px solid transparent !important;",
        ".svd_container.sv_bootstrapmaterial_css .modal-tabs > li > a:hover": "color: $primary-color !important; border-bottom: 1px solid $inverted-text-color !important;",
        ".svd_container.sv_bootstrapmaterial_css .modal-tabs > li > a:focus": "$primary-color !important; border-bottom: 1px solid $inverted-text-color !important;",
        ".svd_container.sv_bootstrapmaterial_css .modal-tabs > li.active > a": "color: $primary-color !important; border: 1px solid $primary-border-color !important; border-bottom-color: $inverted-text-color !important;",
        ".svd_container.sv_bootstrapmaterial_css .form-group.is-focused .form-control": "background-image: linear-gradient($primary-color, $primary-color), linear-gradient(#D2D2D2, #D2D2D2);",
        ".svd_container.sv_bootstrapmaterial_css .form-group.is-focused label": "color:$primary-color;"
    };
    StylesManager.currentTheme = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"]("bootstrap");
    return StylesManager;
}());



/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__json5__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_survey_knockout__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_survey_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_survey_knockout__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SurveyTextWorker; });



var TextParserPropery = /** @class */ (function () {
    function TextParserPropery() {
    }
    return TextParserPropery;
}());
var SurveyForTextWorker = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SurveyForTextWorker, _super);
    function SurveyForTextWorker(jsonObj) {
        return _super.call(this, jsonObj) || this;
    }
    Object.defineProperty(SurveyForTextWorker.prototype, "isDesignMode", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    return SurveyForTextWorker;
}(__WEBPACK_IMPORTED_MODULE_2_survey_knockout__["Survey"]));
var SurveyTextWorker = /** @class */ (function () {
    function SurveyTextWorker(text) {
        this.text = text;
        if (!this.text || this.text.trim() == "") {
            this.text = "{}";
        }
        this.errors = [];
        this.process();
    }
    Object.defineProperty(SurveyTextWorker.prototype, "survey", {
        get: function () {
            return this.surveyValue;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyTextWorker.prototype, "isJsonCorrect", {
        get: function () {
            return this.surveyValue != null;
        },
        enumerable: true,
        configurable: true
    });
    SurveyTextWorker.prototype.process = function () {
        try {
            this.jsonValue = new __WEBPACK_IMPORTED_MODULE_1__json5__["a" /* SurveyJSON5 */](1).parse(this.text);
        }
        catch (error) {
            this.errors.push({
                pos: { start: error.at, end: -1 },
                text: error.message
            });
        }
        if (this.jsonValue != null) {
            this.updateJsonPositions(this.jsonValue);
            var pureJsonValue = new __WEBPACK_IMPORTED_MODULE_1__json5__["a" /* SurveyJSON5 */]().parse(this.text);
            this.surveyValue = new SurveyForTextWorker(pureJsonValue);
            if (this.surveyValue.jsonErrors != null) {
                for (var i = 0; i < this.surveyValue.jsonErrors.length; i++) {
                    var error = this.surveyValue.jsonErrors[i];
                    this.errors.push({
                        pos: { start: error.at, end: -1 },
                        text: error.getFullDescription()
                    });
                }
            }
        }
        this.surveyObjects = this.createSurveyObjects();
        this.setEditorPositionByChartAt(this.surveyObjects);
        this.setEditorPositionByChartAt(this.errors);
    };
    SurveyTextWorker.prototype.updateJsonPositions = function (jsonObj) {
        jsonObj["pos"]["self"] = jsonObj;
        for (var key in jsonObj) {
            var obj = jsonObj[key];
            if (obj && obj["pos"]) {
                jsonObj["pos"][key] = obj["pos"];
                this.updateJsonPositions(obj);
            }
        }
    };
    SurveyTextWorker.prototype.createSurveyObjects = function () {
        var result = [];
        if (this.surveyValue == null)
            return result;
        this.isSurveyAsPage = false;
        for (var i = 0; i < this.surveyValue.pages.length; i++) {
            var page = this.surveyValue.pages[i];
            if (i == 0 && !page["pos"]) {
                page["pos"] = this.surveyValue["pos"];
                this.isSurveyAsPage = true;
            }
            result.push(page);
            for (var j = 0; j < page.questions.length; j++) {
                result.push(page.questions[j]);
            }
        }
        return result;
    };
    SurveyTextWorker.prototype.setEditorPositionByChartAt = function (objects) {
        if (objects == null || objects.length == 0)
            return;
        var position = { row: 0, column: 0 };
        var atObjectsArray = this.getAtArray(objects);
        var startAt = 0;
        for (var i = 0; i < atObjectsArray.length; i++) {
            var at = atObjectsArray[i].at;
            position = this.getPostionByChartAt(position, startAt, at);
            var obj = atObjectsArray[i].obj;
            if (!obj.position)
                obj.position = {};
            if (at == obj.pos.start) {
                obj.position.start = position;
            }
            else {
                if (at == obj.pos.end) {
                    obj.position.end = position;
                }
            }
            startAt = at;
        }
    };
    SurveyTextWorker.prototype.getPostionByChartAt = function (startPosition, startAt, at) {
        var result = { row: startPosition.row, column: startPosition.column };
        var curChar = startAt;
        while (curChar < at) {
            if (this.text.charAt(curChar) == SurveyTextWorker.newLineChar) {
                result.row++;
                result.column = 0;
            }
            else {
                result.column++;
            }
            curChar++;
        }
        return result;
    };
    SurveyTextWorker.prototype.getAtArray = function (objects) {
        var result = [];
        for (var i = 0; i < objects.length; i++) {
            var obj = objects[i];
            var pos = obj.pos;
            if (!pos)
                continue;
            result.push({ at: pos.start, obj: obj });
            if (pos.end > 0) {
                result.push({ at: pos.end, obj: obj });
            }
        }
        return result.sort(function (el1, el2) {
            if (el1.at > el2.at)
                return 1;
            if (el1.at < el2.at)
                return -1;
            return 0;
        });
    };
    return SurveyTextWorker;
}());



/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SurveyJSON5; });
// This file is based on JSON5, http://json5.org/
// The modification for getting object and properties location 'at' were maden.
var SurveyJSON5 = /** @class */ (function () {
    function SurveyJSON5(parseType) {
        if (parseType === void 0) { parseType = 0; }
        this.parseType = parseType;
    }
    SurveyJSON5.prototype.parse = function (source, reviver, startFrom, endAt) {
        if (reviver === void 0) { reviver = null; }
        if (startFrom === void 0) { startFrom = 0; }
        if (endAt === void 0) { endAt = -1; }
        var result;
        this.text = String(source);
        this.at = startFrom;
        this.endAt = endAt;
        this.ch = " ";
        result = this.value();
        this.white();
        if (this.ch) {
            this.error("Syntax error");
        }
        // If there is a reviver function, we recursively walk the new structure,
        // passing each name/value pair to the reviver function for possible
        // transformation, starting with a temporary root object that holds the result
        // in an empty key. If there is not a reviver function, we simply return the
        // result.
        return typeof reviver === "function"
            ? (function walk(holder, key) {
                var k, v, value = holder[key];
                if (value && typeof value === "object") {
                    for (k in value) {
                        if (Object.prototype.hasOwnProperty.call(value, k)) {
                            v = walk(value, k);
                            if (v !== undefined) {
                                value[k] = v;
                            }
                            else {
                                delete value[k];
                            }
                        }
                    }
                }
                return reviver.call(holder, key, value);
            })({ "": result }, "")
            : result;
    };
    SurveyJSON5.prototype.error = function (m) {
        // Call error when something is wrong.
        var error = new SyntaxError();
        error.message = m;
        error["at"] = this.at;
        throw error;
    };
    SurveyJSON5.prototype.next = function (c) {
        if (c === void 0) { c = null; }
        // If a c parameter is provided, verify that it matches the current character.
        if (c && c !== this.ch) {
            this.error("Expected '" + c + "' instead of '" + this.ch + "'");
        }
        // Get the this.next character. When there are no more characters,
        // return the empty string.
        this.ch = this.chartAt();
        this.at += 1;
        return this.ch;
    };
    SurveyJSON5.prototype.peek = function () {
        // Get the this.next character without consuming it or
        // assigning it to the this.ch varaible.
        return this.chartAt();
    };
    SurveyJSON5.prototype.chartAt = function () {
        if (this.endAt > -1 && this.at >= this.endAt)
            return "";
        return this.text.charAt(this.at);
    };
    SurveyJSON5.prototype.identifier = function () {
        // Parse an identifier. Normally, reserved words are disallowed here, but we
        // only use this for unquoted object keys, where reserved words are allowed,
        // so we don't check for those here. References:
        // - http://es5.github.com/#x7.6
        // - https://developer.mozilla.org/en/Core_JavaScript_1.5_Guide/Core_Language_Features#Variables
        // - http://docstore.mik.ua/orelly/webprog/jscript/ch02_07.htm
        // TODO Identifiers can have Unicode "letters" in them; add support for those.
        var key = this.ch;
        // Identifiers must start with a letter, _ or $.
        if (this.ch !== "_" &&
            this.ch !== "$" &&
            (this.ch < "a" || this.ch > "z") &&
            (this.ch < "A" || this.ch > "Z")) {
            this.error("Bad identifier");
        }
        // Subsequent characters can contain digits.
        while (this.next() &&
            (this.ch === "_" ||
                this.ch === "$" ||
                (this.ch >= "a" && this.ch <= "z") ||
                (this.ch >= "A" && this.ch <= "Z") ||
                (this.ch >= "0" && this.ch <= "9"))) {
            key += this.ch;
        }
        return key;
    };
    SurveyJSON5.prototype.number = function () {
        // Parse a number value.
        var number, sign = "", string = "", base = 10;
        if (this.ch === "-" || this.ch === "+") {
            sign = this.ch;
            this.next(this.ch);
        }
        // support for Infinity (could tweak to allow other words):
        if (this.ch === "I") {
            number = this.word();
            if (typeof number !== "number" || isNaN(number)) {
                this.error("Unexpected word for number");
            }
            return sign === "-" ? -number : number;
        }
        // support for NaN
        if (this.ch === "N") {
            number = this.word();
            if (!isNaN(number)) {
                this.error("expected word to be NaN");
            }
            // ignore sign as -NaN also is NaN
            return number;
        }
        if (this.ch === "0") {
            string += this.ch;
            this.next();
            if (this.ch === "x" || this.ch === "X") {
                string += this.ch;
                this.next();
                base = 16;
            }
            else if (this.ch >= "0" && this.ch <= "9") {
                this.error("Octal literal");
            }
        }
        switch (base) {
            case 10:
                while (this.ch >= "0" && this.ch <= "9") {
                    string += this.ch;
                    this.next();
                }
                if (this.ch === ".") {
                    string += ".";
                    while (this.next() && this.ch >= "0" && this.ch <= "9") {
                        string += this.ch;
                    }
                }
                if (this.ch === "e" || this.ch === "E") {
                    string += this.ch;
                    this.next();
                    if (this.ch === "-" || this.ch === "+") {
                        string += this.ch;
                        this.next();
                    }
                    while (this.ch >= "0" && this.ch <= "9") {
                        string += this.ch;
                        this.next();
                    }
                }
                break;
            case 16:
                while ((this.ch >= "0" && this.ch <= "9") ||
                    (this.ch >= "A" && this.ch <= "F") ||
                    (this.ch >= "a" && this.ch <= "f")) {
                    string += this.ch;
                    this.next();
                }
                break;
        }
        if (sign === "-") {
            number = -string;
        }
        else {
            number = +string;
        }
        if (!isFinite(number)) {
            this.error("Bad number");
        }
        else {
            return number;
        }
    };
    SurveyJSON5.prototype.string = function () {
        // Parse a string value.
        var hex, i, string = "", delim, // double quote or single quote
        uffff;
        // When parsing for string values, we must look for ' or " and \ characters.
        if (this.ch === '"' || this.ch === "'") {
            delim = this.ch;
            while (this.next()) {
                if (this.ch === delim) {
                    this.next();
                    return string;
                }
                else if (this.ch === "\\") {
                    this.next();
                    if (this.ch === "u") {
                        uffff = 0;
                        for (i = 0; i < 4; i += 1) {
                            hex = parseInt(this.next(), 16);
                            if (!isFinite(hex)) {
                                break;
                            }
                            uffff = uffff * 16 + hex;
                        }
                        string += String.fromCharCode(uffff);
                    }
                    else if (this.ch === "\r") {
                        if (this.peek() === "\n") {
                            this.next();
                        }
                    }
                    else if (typeof SurveyJSON5.escapee[this.ch] === "string") {
                        string += SurveyJSON5.escapee[this.ch];
                    }
                    else {
                        break;
                    }
                }
                else if (this.ch === "\n") {
                    // unescaped newlines are invalid; see:
                    // https://github.com/aseemk/json5/issues/24
                    // TODO this feels special-cased; are there other
                    // invalid unescaped chars?
                    break;
                }
                else {
                    string += this.ch;
                }
            }
        }
        this.error("Bad string");
    };
    SurveyJSON5.prototype.inlineComment = function () {
        // Skip an inline comment, assuming this is one. The current character should
        // be the second / character in the // pair that begins this inline comment.
        // To finish the inline comment, we look for a newline or the end of the text.
        if (this.ch !== "/") {
            this.error("Not an inline comment");
        }
        do {
            this.next();
            if (this.ch === "\n" || this.ch === "\r") {
                this.next();
                return;
            }
        } while (this.ch);
    };
    SurveyJSON5.prototype.blockComment = function () {
        // Skip a block comment, assuming this is one. The current character should be
        // the * character in the /* pair that begins this block comment.
        // To finish the block comment, we look for an ending */ pair of characters,
        // but we also watch for the end of text before the comment is terminated.
        if (this.ch !== "*") {
            this.error("Not a block comment");
        }
        do {
            this.next();
            while (this.ch === "*") {
                this.next("*");
                if (this.ch === "/") {
                    this.next("/");
                    return;
                }
            }
        } while (this.ch);
        this.error("Unterminated block comment");
    };
    SurveyJSON5.prototype.comment = function () {
        // Skip a comment, whether inline or block-level, assuming this is one.
        // Comments always begin with a / character.
        if (this.ch !== "/") {
            this.error("Not a comment");
        }
        this.next("/");
        if (this.ch === "/") {
            this.inlineComment();
        }
        else if (this.ch === "*") {
            this.blockComment();
        }
        else {
            this.error("Unrecognized comment");
        }
    };
    SurveyJSON5.prototype.white = function () {
        // Skip whitespace and comments.
        // Note that we're detecting comments by only a single / character.
        // This works since regular expressions are not valid JSON(5), but this will
        // break if there are other valid values that begin with a / character!
        while (this.ch) {
            if (this.ch === "/") {
                this.comment();
            }
            else if (SurveyJSON5.ws.indexOf(this.ch) >= 0) {
                this.next();
            }
            else {
                return;
            }
        }
    };
    SurveyJSON5.prototype.word = function () {
        // true, false, or null.
        switch (this.ch) {
            case "t":
                this.next("t");
                this.next("r");
                this.next("u");
                this.next("e");
                return true;
            case "f":
                this.next("f");
                this.next("a");
                this.next("l");
                this.next("s");
                this.next("e");
                return false;
            case "n":
                this.next("n");
                this.next("u");
                this.next("l");
                this.next("l");
                return null;
            case "I":
                this.next("I");
                this.next("n");
                this.next("f");
                this.next("i");
                this.next("n");
                this.next("i");
                this.next("t");
                this.next("y");
                return Infinity;
            case "N":
                this.next("N");
                this.next("a");
                this.next("N");
                return NaN;
        }
        this.error("Unexpected '" + this.ch + "'");
    };
    SurveyJSON5.prototype.array = function () {
        // Parse an array value.
        var array = [];
        if (this.ch === "[") {
            this.next("[");
            this.white();
            while (this.ch) {
                if (this.ch === "]") {
                    this.next("]");
                    return array; // Potentially empty array
                }
                // ES5 allows omitting elements in arrays, e.g. [,] and
                // [,null]. We don't allow this in JSON5.
                if (this.ch === ",") {
                    this.error("Missing array element");
                }
                else {
                    array.push(this.value());
                }
                this.white();
                // If there's no comma after this value, this needs to
                // be the end of the array.
                if (this.ch !== ",") {
                    this.next("]");
                    return array;
                }
                this.next(",");
                this.white();
            }
        }
        this.error("Bad array");
    };
    SurveyJSON5.prototype.object = function () {
        // Parse an object value.
        var key, start, isFirstProperty = true, object = {};
        if (this.parseType > 0) {
            object[SurveyJSON5.positionName] = { start: this.at - 1 };
        }
        if (this.ch === "{") {
            this.next("{");
            this.white();
            start = this.at - 1;
            while (this.ch) {
                if (this.ch === "}") {
                    if (this.parseType > 0) {
                        object[SurveyJSON5.positionName].end = start;
                    }
                    this.next("}");
                    return object; // Potentially empty object
                }
                // Keys can be unquoted. If they are, they need to be
                // valid JS identifiers.
                if (this.ch === '"' || this.ch === "'") {
                    key = this.string();
                }
                else {
                    key = this.identifier();
                }
                this.white();
                if (this.parseType > 1) {
                    object[SurveyJSON5.positionName][key] = {
                        start: start,
                        valueStart: this.at
                    };
                }
                this.next(":");
                object[key] = this.value();
                if (this.parseType > 1) {
                    start = this.at - 1;
                    object[SurveyJSON5.positionName][key].valueEnd = start;
                    object[SurveyJSON5.positionName][key].end = start;
                }
                this.white();
                // If there's no comma after this pair, this needs to be
                // the end of the object.
                if (this.ch !== ",") {
                    if (this.parseType > 1) {
                        object[SurveyJSON5.positionName][key].valueEnd--;
                        object[SurveyJSON5.positionName][key].end--;
                    }
                    if (this.parseType > 0) {
                        object[SurveyJSON5.positionName].end = this.at - 1;
                    }
                    this.next("}");
                    return object;
                }
                if (this.parseType > 1) {
                    object[SurveyJSON5.positionName][key].valueEnd--;
                    if (!isFirstProperty) {
                        object[SurveyJSON5.positionName][key].end--;
                    }
                }
                this.next(",");
                this.white();
                isFirstProperty = false;
            }
        }
        this.error("Bad object");
    };
    SurveyJSON5.prototype.value = function () {
        // Parse a JSON value. It could be an object, an array, a string, a number,
        // or a word.
        this.white();
        switch (this.ch) {
            case "{":
                return this.object();
            case "[":
                return this.array();
            case '"':
            case "'":
                return this.string();
            case "-":
            case "+":
            case ".":
                return this.number();
            default:
                return this.ch >= "0" && this.ch <= "9" ? this.number() : this.word();
        }
    };
    SurveyJSON5.prototype.stringify = function (obj, replacer, space) {
        if (replacer === void 0) { replacer = null; }
        if (space === void 0) { space = null; }
        if (replacer &&
            (typeof replacer !== "function" && !this.isArray(replacer))) {
            throw new Error("Replacer must be a function or an array");
        }
        this.replacer = replacer;
        this.indentStr = this.getIndent(space);
        this.objStack = [];
        // special case...when undefined is used inside of
        // a compound object/array, return null.
        // but when top-level, return undefined
        var topLevelHolder = { "": obj };
        if (obj === undefined) {
            return this.getReplacedValueOrUndefined(topLevelHolder, "", true);
        }
        return this.internalStringify(topLevelHolder, "", true);
    };
    SurveyJSON5.prototype.getIndent = function (space) {
        if (space) {
            if (typeof space === "string") {
                return space;
            }
            else if (typeof space === "number" && space >= 0) {
                return this.makeIndent(" ", space, true);
            }
        }
        return "";
    };
    SurveyJSON5.prototype.getReplacedValueOrUndefined = function (holder, key, isTopLevel) {
        var value = holder[key];
        // Replace the value with its toJSON value first, if possible
        if (value && value.toJSON && typeof value.toJSON === "function") {
            value = value.toJSON();
        }
        // If the user-supplied replacer if a function, call it. If it's an array, check objects' string keys for
        // presence in the array (removing the key/value pair from the resulting JSON if the key is missing).
        if (typeof this.replacer === "function") {
            return this.replacer.call(holder, key, value);
        }
        else if (this.replacer) {
            if (isTopLevel ||
                this.isArray(holder) ||
                this.replacer.indexOf(key) >= 0) {
                return value;
            }
            else {
                return undefined;
            }
        }
        else {
            return value;
        }
    };
    SurveyJSON5.prototype.isWordChar = function (char) {
        return ((char >= "a" && char <= "z") ||
            (char >= "A" && char <= "Z") ||
            (char >= "0" && char <= "9") ||
            char === "_" ||
            char === "$");
    };
    SurveyJSON5.prototype.isWordStart = function (char) {
        return ((char >= "a" && char <= "z") ||
            (char >= "A" && char <= "Z") ||
            char === "_" ||
            char === "$");
    };
    SurveyJSON5.prototype.isWord = function (key) {
        if (typeof key !== "string") {
            return false;
        }
        if (!this.isWordStart(key[0])) {
            return false;
        }
        var i = 1, length = key.length;
        while (i < length) {
            if (!this.isWordChar(key[i])) {
                return false;
            }
            i++;
        }
        return true;
    };
    // polyfills
    SurveyJSON5.prototype.isArray = function (obj) {
        if (Array.isArray) {
            return Array.isArray(obj);
        }
        else {
            return Object.prototype.toString.call(obj) === "[object Array]";
        }
    };
    SurveyJSON5.prototype.isDate = function (obj) {
        return Object.prototype.toString.call(obj) === "[object Date]";
    };
    SurveyJSON5.prototype.isNaN = function (val) {
        return typeof val === "number" && val !== val;
    };
    SurveyJSON5.prototype.checkForCircular = function (obj) {
        for (var i = 0; i < this.objStack.length; i++) {
            if (this.objStack[i] === obj) {
                throw new TypeError("Converting circular structure to JSON");
            }
        }
    };
    SurveyJSON5.prototype.makeIndent = function (str, num, noNewLine) {
        if (noNewLine === void 0) { noNewLine = false; }
        if (!str) {
            return "";
        }
        // indentation no more than 10 chars
        if (str.length > 10) {
            str = str.substring(0, 10);
        }
        var indent = noNewLine ? "" : "\n";
        for (var i = 0; i < num; i++) {
            indent += str;
        }
        return indent;
    };
    SurveyJSON5.prototype.escapeString = function (str) {
        // If the string contains no control characters, no quote characters, and no
        // backslash characters, then we can safely slap some quotes around it.
        // Otherwise we must also replace the offending characters with safe escape
        // sequences.
        SurveyJSON5.escapable.lastIndex = 0;
        return SurveyJSON5.escapable.test(str)
            ? '"' +
                str.replace(SurveyJSON5.escapable, function (a) {
                    var c = SurveyJSON5.meta[a];
                    return typeof c === "string"
                        ? c
                        : "\\u" + ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
                }) +
                '"'
            : '"' + str + '"';
    };
    // End
    SurveyJSON5.prototype.internalStringify = function (holder, key, isTopLevel) {
        var buffer, res;
        // Replace the value, if necessary
        var obj_part = this.getReplacedValueOrUndefined(holder, key, isTopLevel);
        if (obj_part && !this.isDate(obj_part)) {
            // unbox objects
            // don't unbox dates, since will turn it into number
            obj_part = obj_part.valueOf();
        }
        switch (typeof obj_part) {
            case "boolean":
                return obj_part.toString();
            case "number":
                if (isNaN(obj_part) || !isFinite(obj_part)) {
                    return "null";
                }
                return obj_part.toString();
            case "string":
                return this.escapeString(obj_part.toString());
            case "object":
                if (obj_part === null) {
                    return "null";
                }
                else if (this.isArray(obj_part)) {
                    this.checkForCircular(obj_part);
                    buffer = "[";
                    this.objStack.push(obj_part);
                    for (var i = 0; i < obj_part.length; i++) {
                        res = this.internalStringify(obj_part, i, false);
                        buffer += this.makeIndent(this.indentStr, this.objStack.length);
                        if (res === null || typeof res === "undefined") {
                            buffer += "null";
                        }
                        else {
                            buffer += res;
                        }
                        if (i < obj_part.length - 1) {
                            buffer += ",";
                        }
                        else if (this.indentStr) {
                            buffer += "\n";
                        }
                    }
                    this.objStack.pop();
                    buffer +=
                        this.makeIndent(this.indentStr, this.objStack.length, true) + "]";
                }
                else {
                    this.checkForCircular(obj_part);
                    buffer = "{";
                    var nonEmpty = false;
                    this.objStack.push(obj_part);
                    for (var prop in obj_part) {
                        if (obj_part.hasOwnProperty(prop)) {
                            var value = this.internalStringify(obj_part, prop, false);
                            isTopLevel = false;
                            if (typeof value !== "undefined" && value !== null) {
                                buffer += this.makeIndent(this.indentStr, this.objStack.length);
                                nonEmpty = true;
                                var propKey = this.isWord(prop)
                                    ? prop
                                    : this.escapeString(prop);
                                buffer +=
                                    propKey + ":" + (this.indentStr ? " " : "") + value + ",";
                            }
                        }
                    }
                    this.objStack.pop();
                    if (nonEmpty) {
                        buffer =
                            buffer.substring(0, buffer.length - 1) +
                                this.makeIndent(this.indentStr, this.objStack.length) +
                                "}";
                    }
                    else {
                        buffer = "{}";
                    }
                }
                return buffer;
            default:
                // functions and undefined should be ignored
                return undefined;
        }
    };
    SurveyJSON5.positionName = "pos";
    SurveyJSON5.escapee = {
        "'": "'",
        '"': '"',
        "\\": "\\",
        "/": "/",
        "\n": "",
        b: "\b",
        f: "\f",
        n: "\n",
        r: "\r",
        t: "\t"
    };
    SurveyJSON5.ws = [" ", "\t", "\r", "\n", "\v", "\f", "\xA0", "\uFEFF"];
    // Copied from Crokford's implementation of JSON
    // See https://github.com/douglascrockford/JSON-js/blob/e39db4b7e6249f04a195e7dd0840e610cc9e941e/json2.js#L195
    // Begin
    SurveyJSON5.cx = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;
    SurveyJSON5.escapable = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;
    SurveyJSON5.meta = {
        // table of character substitutions
        "\b": "\\b",
        "\t": "\\t",
        "\n": "\\n",
        "\f": "\\f",
        "\r": "\\r",
        '"': '\\"',
        "\\": "\\\\"
    };
    return SurveyJSON5;
}());



/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_knockout__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__surveyjsObjects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editorLocalization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__question_actions_scss__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__question_actions_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__question_actions_scss__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return QuestionActionsAdorner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return questionActionsAdorner; });
/* unused harmony export panelActionsAdorner */




var templateHtml = __webpack_require__(127);
var QuestionActionsAdorner = /** @class */ (function () {
    function QuestionActionsAdorner(question, editor) {
        this.question = question;
        this.editor = editor;
        this.actions = __WEBPACK_IMPORTED_MODULE_0_knockout__["observableArray"]();
        var surveyForDesigner = editor.survey;
        this.actions(surveyForDesigner.getMenuItems(question));
    }
    QuestionActionsAdorner.prototype.getStyle = function (model) {
        if (!!model.icon) {
            return __WEBPACK_IMPORTED_MODULE_0_knockout__["unwrap"](model.icon);
        }
        return "icon-action" + model.name;
    };
    QuestionActionsAdorner.prototype.localize = function (entryString) {
        return __WEBPACK_IMPORTED_MODULE_2__editorLocalization__["a" /* editorLocalization */].getString(entryString);
    };
    return QuestionActionsAdorner;
}());

__WEBPACK_IMPORTED_MODULE_0_knockout__["components"].register("question-actions", {
    viewModel: {
        createViewModel: function (params, componentInfo) {
            var model = new QuestionActionsAdorner(params.question, params.editor);
            return model;
        }
    },
    template: templateHtml
});
var questionActionsAdorner = {
    getMarkerClass: function (model) {
        return !model.isPanel ? "question_actions" : "";
    },
    getElementName: function (model) { return "mainRoot"; },
    afterRender: function (elements, model, editor) {
        var decoration = document.createElement("div");
        decoration.className = "svda-question-actions";
        decoration.innerHTML =
            "<question-actions params='question: model, editor: editor'></question-actions>";
        elements[0].appendChild(decoration);
        __WEBPACK_IMPORTED_MODULE_0_knockout__["applyBindings"]({ model: model, editor: editor }, decoration);
        __WEBPACK_IMPORTED_MODULE_0_knockout__["tasks"].runEarly();
        editor.onAdornerRenderedCallback(model, "question-actions", decoration);
    }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__surveyjsObjects__["b" /* registerAdorner */])("question-actions", questionActionsAdorner);
var panelActionsAdorner = {
    getMarkerClass: function (model) {
        return !!model.isPanel && model.getType() !== "flowpanel"
            ? "panel_actions"
            : "";
    },
    getElementName: function (model) { return "container"; },
    afterRender: questionActionsAdorner.afterRender
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__surveyjsObjects__["b" /* registerAdorner */])("panel-actions", panelActionsAdorner);


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_knockout__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_survey_knockout__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_survey_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_survey_knockout__);
/* unused harmony export DragDropTargetElement */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DragDropHelper; });


if (!!__WEBPACK_IMPORTED_MODULE_0_knockout__["options"]) {
    __WEBPACK_IMPORTED_MODULE_0_knockout__["options"].useOnlyNativeEvents = true;
}
var DragDropTargetElement = /** @class */ (function () {
    function DragDropTargetElement(page, target, source) {
        this.page = page;
        this.target = target;
        this.source = source;
        this.nestedPanelDepth = -1;
        page.dragDropStart(source, target); //, DragDropTargetElement.nestedPanelPath);
    }
    DragDropTargetElement.prototype.moveTo = function (destination, isBottom, isEdge) {
        if (isEdge === void 0) { isEdge = false; }
        //console.log(!!destination ? destination.name : "null");
        return this.page.dragDropMoveTo(destination, isBottom, isEdge);
    };
    DragDropTargetElement.prototype.doDrop = function () {
        this.clearCore();
        return this.page.dragDropFinish();
    };
    DragDropTargetElement.prototype.clear = function () {
        this.clearCore();
        this.page.dragDropFinish(true);
    };
    DragDropTargetElement.prototype.clearCore = function () {
        if (!!this.target) {
            this.target["koIsDragging"](false);
        }
    };
    return DragDropTargetElement;
}());

var DragDropHelper = /** @class */ (function () {
    function DragDropHelper(data, onModifiedCallback, parent) {
        if (parent === void 0) { parent = null; }
        this.data = data;
        this.scrollableElement = null;
        this.ddTarget = null;
        this.id = DragDropHelper.counter++;
        this.isScrollStop = true;
        this.onModifiedCallback = onModifiedCallback;
        this.scrollableElement =
            parent && parent.querySelector("#scrollableDiv");
        this.prevCoordinates = { x: -1, y: -1 };
    }
    DragDropHelper.prototype.attachToElement = function (domElement, surveyElement) {
        var isFlowPanel = surveyElement.isPanel &&
            typeof surveyElement.getChildrenLayoutType === "function" &&
            surveyElement.getChildrenLayoutType() === "flow";
        var isFlowPanelInChrome = isFlowPanel && !!window["chrome"];
        domElement.style.opacity = surveyElement.koIsDragging() ? 0.4 : 1;
        domElement.draggable =
            surveyElement.allowingOptions.allowDragging && !isFlowPanel;
        if (isFlowPanelInChrome) {
            domElement.onpaste = function doPaste(e, el) {
                e.preventDefault();
                var clipData = window["clipboardData"];
                if (!!clipData) {
                    var content = clipData.getData("text");
                    if (window.getSelection) {
                        var selObj = window.getSelection();
                        var selRange = selObj.getRangeAt(0);
                        selRange.deleteContents();
                        selRange.insertNode(document.createTextNode(content));
                    }
                }
                else if ((e.originalEvent || e).clipboardData) {
                    content = (e.originalEvent || e).clipboardData.getData("text/plain");
                    document.execCommand("insertText", false, content);
                }
                return true;
            };
        }
        domElement.ondragover = function (e) {
            if (!surveyElement.allowingOptions.allowDragging)
                return false;
            if (isFlowPanel)
                return surveyElement
                    .dragDropHelper()
                    .doDragDropOverFlow(e, surveyElement);
            if (!e["markEvent"]) {
                e["markEvent"] = true;
                surveyElement.dragDropHelper().doDragDropOver(e, surveyElement, true);
                return false;
            }
        };
        domElement.ondrop = function (e) {
            var helper = surveyElement.dragDropHelper();
            var preventDefault = !(isFlowPanel &&
                !!helper.ddTarget &&
                !!helper.ddTarget.source &&
                helper.ddTarget.source.parent == surveyElement);
            //Fix the bug for chrome in contenteditable
            if (isFlowPanelInChrome &&
                (!helper.ddTarget ||
                    !helper.ddTarget.destination ||
                    helper.ddTarget.destination.isLayoutTypeSupported("flow"))) {
                var content = e.dataTransfer.getData("text");
                var dropRange = null;
                if (!!document.caretRangeFromPoint) {
                    dropRange = document.caretRangeFromPoint(e.clientX, e.clientY);
                }
                else {
                    if (!!document.caretPositionFromPoint) {
                        dropRange = document.caretPositionFromPoint(e.clientX, e.clientY);
                    }
                }
                if (!!dropRange) {
                    preventDefault = true;
                    e.preventDefault();
                    if (surveyElement["isDragStarted"]) {
                        var selObj = window.getSelection();
                        if (!!selObj && selObj.rangeCount > 0) {
                            var selRange = selObj.getRangeAt(0);
                            if (!!selRange) {
                                selRange.deleteContents();
                            }
                        }
                    }
                    dropRange.insertNode(document.createTextNode(content));
                    var selection = window.getSelection();
                    if (!!selection) {
                        selection.removeAllRanges();
                        selection.addRange(dropRange);
                    }
                }
            }
            if (!e["markEvent"]) {
                e["markEvent"] = true;
                helper.doDrop(e, preventDefault);
            }
        };
        if (!isFlowPanel) {
            domElement.ondragstart = function (e) {
                var target = e.target || e.srcElement;
                if (!!target &&
                    !!target.contains &&
                    target.contains(document.activeElement)) {
                    e.preventDefault();
                    return false;
                }
                if (!surveyElement.allowingOptions.allowDragging)
                    return false;
                if (!e["markEvent"]) {
                    e["markEvent"] = true;
                    surveyElement.dragDropHelper().startDragQuestion(e, surveyElement);
                }
                e.cancelBubble = true;
            };
        }
        else {
            domElement.ondragstart = function (e) {
                surveyElement.isDragStarted = true;
                if (!e["markEvent"]) {
                    e["markEvent"] = true;
                    if (!surveyElement.dragDropHelper().getData(e).text) {
                        surveyElement.dragDropHelper().startDragQuestion(e, surveyElement);
                    }
                }
            };
        }
        domElement.ondragend = function (e) {
            delete surveyElement["isDragStarted"];
            surveyElement.dragDropHelper().end();
        };
    };
    Object.defineProperty(DragDropHelper.prototype, "survey", {
        get: function () {
            return this.data;
        },
        enumerable: true,
        configurable: true
    });
    DragDropHelper.prototype.startDragQuestion = function (event, element) {
        var json = new __WEBPACK_IMPORTED_MODULE_1_survey_knockout__["JsonObject"]().toJsonObject(element);
        json["type"] = element.getType();
        this.prepareData(event, element.name, json, element);
    };
    DragDropHelper.prototype.startDragToolboxItem = function (event, elementName, elementJson) {
        this.prepareData(event, elementName, elementJson, null);
        event.cancelBubble = true;
    };
    DragDropHelper.prototype.isSurveyDragging = function (event) {
        if (!event)
            return false;
        var data = this.getData(event).text;
        return data && data.indexOf(DragDropHelper.dataStart) == 0;
    };
    DragDropHelper.prototype.doDragDropOver = function (event, element, isEdge) {
        if (isEdge === void 0) { isEdge = false; }
        event = this.isCanDragContinue(event, element);
        if (!event)
            return;
        var bottomInfo = this.isBottom(event);
        if (element.isPage && element.elements.length > 0) {
            var lastEl = element.elements[element.elements.length - 1];
            if (!this.isBottomThanElement(event, lastEl))
                return;
            element = lastEl;
            bottomInfo.isEdge = true;
            bottomInfo.isBottom = true;
        }
        isEdge = element.isPanel ? isEdge && bottomInfo.isEdge : true;
        if (element.isPanel && !isEdge && element.elements.length > 0)
            return;
        this.ddTarget.moveTo(element, bottomInfo.isBottom, isEdge);
    };
    DragDropHelper.prototype.doDragDropOverFlow = function (event, element) {
        if (!!this.ddTarget) {
            event = this.isCanDragContinue(event, element);
            if (!event)
                return true;
            var bottomInfo = this.isBottom(event);
            return this.ddTarget.moveTo(element, bottomInfo.isBottom, bottomInfo.isEdge);
        }
        return true;
    };
    DragDropHelper.prototype.isCanDragContinue = function (event, element) {
        event = this.getEvent(event);
        if (this.isSameCoordinates(event))
            return null;
        this.checkScrollY(event);
        if (!element ||
            !this.isSurveyDragging(event) ||
            this.isSamePlace(event, element))
            return null;
        return event;
    };
    DragDropHelper.prototype.end = function () {
        if (this.ddTarget) {
            this.ddTarget.clear();
        }
        this.isScrollStop = true;
        this.clearData();
    };
    Object.defineProperty(DragDropHelper.prototype, "isMoving", {
        get: function () {
            return this.ddTarget && this.ddTarget.source;
        },
        enumerable: true,
        configurable: true
    });
    DragDropHelper.prototype.doDrop = function (event, prevedDefault) {
        if (prevedDefault === void 0) { prevedDefault = true; }
        if (event.stopPropagation) {
            event.stopPropagation();
        }
        if (this.isSurveyDragging(event)) {
            if (prevedDefault) {
                event.preventDefault();
            }
            var newElement = this.ddTarget.doDrop();
            if (this.onModifiedCallback)
                this.onModifiedCallback({
                    type: "DO_DROP",
                    page: this.ddTarget.page,
                    source: this.ddTarget.source,
                    target: this.ddTarget.target,
                    newElement: this.ddTarget.source ? null : newElement,
                    moveToParent: newElement.parent,
                    moveToIndex: !!newElement.parent
                        ? newElement.parent.elements.indexOf(newElement)
                        : -1
                });
        }
        this.end();
    };
    DragDropHelper.prototype.doLeavePage = function (event) {
        if (!!this.ddTarget) {
            this.ddTarget.moveTo(null, false);
        }
    };
    DragDropHelper.prototype.scrollToElement = function (el) {
        if (!this.scrollableElement || !el)
            return;
        el.scrollIntoView(false);
    };
    DragDropHelper.prototype.createTargetElement = function (elementName, json) {
        if (!elementName || !json)
            return null;
        var targetElement = null;
        targetElement = __WEBPACK_IMPORTED_MODULE_1_survey_knockout__["JsonObject"].metaData.createClass(json["type"]);
        new __WEBPACK_IMPORTED_MODULE_1_survey_knockout__["JsonObject"]().toObject(json, targetElement);
        targetElement.name = elementName;
        if (targetElement["setSurveyImpl"]) {
            targetElement["setSurveyImpl"](this.survey);
        }
        else {
            targetElement["setData"](this.survey);
        }
        targetElement.renderWidth = "100%";
        targetElement["koIsDragging"](true);
        return targetElement;
    };
    DragDropHelper.prototype.isBottom = function (event) {
        event = this.getEvent(event);
        var height = event.currentTarget["clientHeight"];
        var y = event.offsetY;
        if (event.hasOwnProperty("layerX")) {
            y = event.layerY - event.currentTarget["offsetTop"];
        }
        return {
            isBottom: y > height / 2,
            isEdge: y <= DragDropHelper.edgeHeight ||
                height - y <= DragDropHelper.edgeHeight
        };
    };
    DragDropHelper.prototype.isBottomThanElement = function (event, lastEl) {
        var el = lastEl.renderedElement;
        if (!el)
            return false;
        event = this.getEvent(event);
        var elY = el.offsetTop + el.clientHeight;
        var y = event.offsetY;
        if (event.hasOwnProperty("layerX")) {
            y = event.layerY - event.currentTarget["offsetTop"];
        }
        return y > elY;
    };
    DragDropHelper.prototype.isSameCoordinates = function (event) {
        var res = Math.abs(event.pageX - this.prevCoordinates.x) > 5 ||
            Math.abs(event.pageY - this.prevCoordinates.y) > 5;
        if (res) {
            this.prevCoordinates.x = event.pageX;
            this.prevCoordinates.y = event.pageY;
        }
        return !res;
    };
    DragDropHelper.prototype.isSamePlace = function (event, element) {
        var prev = DragDropHelper.prevEvent;
        if (prev.element != element ||
            Math.abs(event.clientX - prev.x) > 5 ||
            Math.abs(event.clientY - prev.y) > 5) {
            prev.element = element;
            prev.x = event.clientX;
            prev.y = event.clientY;
            return false;
        }
        return true;
    };
    DragDropHelper.prototype.checkScrollY = function (e) {
        if (!this.scrollableElement)
            return;
        var y = this.getScrollableElementPosY(e);
        if (y < 0)
            return;
        this.isScrollStop = true;
        var height = this.scrollableElement["clientHeight"];
        if (y < DragDropHelper.ScrollOffset && y >= 0) {
            this.isScrollStop = false;
            this.doScrollY(-1);
        }
        if (height - y < DragDropHelper.ScrollOffset && height >= y) {
            this.isScrollStop = false;
            this.doScrollY(1);
        }
    };
    DragDropHelper.prototype.doScrollY = function (step) {
        var el = this.scrollableElement;
        var scrollY = el.scrollTop + step;
        if (scrollY < 0) {
            this.isScrollStop = true;
            return;
        }
        el.scrollTop = scrollY;
        var self = this;
        if (!this.isScrollStop) {
            setTimeout(function () {
                self.doScrollY(step);
            }, DragDropHelper.ScrollDelay);
        }
    };
    DragDropHelper.prototype.getScrollableElementPosY = function (e) {
        if (!this.scrollableElement || !e.currentTarget)
            return -1;
        var el = e.currentTarget;
        var offsetTop = 0;
        while (el && el != this.scrollableElement) {
            offsetTop += el["offsetTop"];
            el = el["offsetParent"];
        }
        return (e.offsetY +
            e.currentTarget["offsetTop"] -
            this.scrollableElement.offsetTop -
            this.scrollableElement.scrollTop);
    };
    DragDropHelper.prototype.getEvent = function (event) {
        return event["originalEvent"] ? event["originalEvent"] : event;
    };
    DragDropHelper.prototype.getY = function (element) {
        var result = 0;
        while (element) {
            result += element.offsetTop - element.scrollTop + element.clientTop;
            element = element.offsetParent;
        }
        return result;
    };
    DragDropHelper.prototype.prepareData = function (event, elementName, json, source) {
        var str = DragDropHelper.dataStart + elementName + "}";
        this.setData(event, str);
        var targetElement = this.createTargetElement(elementName, json);
        this.ddTarget = new DragDropTargetElement(this.survey.currentPage, targetElement, source);
        this.ddTarget.nestedPanelDepth = DragDropHelper.nestedPanelDepth;
    };
    DragDropHelper.prototype.setData = function (event, text) {
        if (event["originalEvent"]) {
            event = event["originalEvent"];
        }
        if (event.dataTransfer) {
            event.dataTransfer.setData("Text", text);
            event.dataTransfer.effectAllowed = "copy";
        }
        DragDropHelper.dragData = { text: text };
    };
    DragDropHelper.prototype.getData = function (event) {
        if (event["originalEvent"]) {
            event = event["originalEvent"];
        }
        if (event.dataTransfer) {
            var text = event.dataTransfer.getData("Text");
            if (text) {
                DragDropHelper.dragData.text = text;
            }
        }
        return DragDropHelper.dragData;
    };
    DragDropHelper.prototype.clearData = function () {
        this.ddTarget = null; // We should reset ddTarget to null due to the https://surveyjs.answerdesk.io/ticket/details/T1003 - onQuestionAdded not fired after D&D
        DragDropHelper.dragData = { text: "", json: null };
        var prev = DragDropHelper.prevEvent;
        prev.element = null;
        prev.x = -1;
        prev.y = -1;
        this.prevCoordinates.x = -1;
        this.prevCoordinates.y = -1;
    };
    DragDropHelper.edgeHeight = 20;
    DragDropHelper.nestedPanelDepth = -1;
    DragDropHelper.dataStart = "{element:";
    DragDropHelper.dragData = { text: "", json: null };
    DragDropHelper.prevEvent = { element: null, x: -1, y: -1 };
    DragDropHelper.counter = 1;
    DragDropHelper.ScrollDelay = 30;
    DragDropHelper.ScrollOffset = 100;
    return DragDropHelper;
}());



/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return enStrings; });
//Uncomment this line on creating a translation file
//import { editorLocalization, defaultStrings } from "../editorLocalization";
var enStrings = {
    //survey templates
    survey: {
        edit: "Edit",
        dropQuestion: "Please drop a question here from the Toolbox on the left.",
        copy: "Copy",
        addToToolbox: "Add to toolbox",
        deletePanel: "Delete Panel",
        deleteQuestion: "Delete Question",
        convertTo: "Convert to",
        drag: "Drag element"
    },
    //questionTypes
    qt: {
        default: "Default",
        checkbox: "Checkbox",
        comment: "Comment",
        imagepicker: "Image picker",
        dropdown: "Dropdown",
        file: "File",
        html: "Html",
        matrix: "Matrix (single choice)",
        matrixdropdown: "Matrix (multiple choice)",
        matrixdynamic: "Matrix (dynamic rows)",
        multipletext: "Multiple Text",
        panel: "Panel",
        paneldynamic: "Panel (dynamic panels)",
        radiogroup: "Radiogroup",
        rating: "Rating",
        text: "Single Input",
        boolean: "Boolean",
        expression: "Expression",
        flowpanel: "Flow Panel"
    },
    //Strings in Editor
    ed: {
        defaultLocale: "Default ({0})",
        survey: "Survey",
        settings: "Survey Settings",
        editSurvey: "Edit Survey",
        addNewPage: "Add New Page",
        moveRight: "Scroll to the Right",
        moveLeft: "Scroll to the Left",
        deletePage: "Delete Page",
        editPage: "Edit Page",
        edit: "Edit",
        newPageName: "page",
        newQuestionName: "question",
        newPanelName: "panel",
        testSurvey: "Test Survey",
        testSurveyAgain: "Test Survey Again",
        testSurveyWidth: "Survey width: ",
        embedSurvey: "Embed Survey",
        translation: "Translation",
        saveSurvey: "Save Survey",
        designer: "Survey Designer",
        jsonEditor: "JSON Editor",
        undo: "Undo",
        redo: "Redo",
        options: "Options",
        generateValidJSON: "Generate Valid JSON",
        generateReadableJSON: "Generate Readable JSON",
        toolbox: "Toolbox",
        toolboxGeneralCategory: "General",
        delSelObject: "Delete selected object",
        editSelObject: "Edit selected object",
        correctJSON: "Please correct JSON.",
        surveyResults: "Survey Result: ",
        surveyResultsTable: "As Table",
        surveyResultsJson: "As JSON",
        resultsTitle: "Question Title",
        resultsName: "Question Name",
        resultsValue: "Answer Value",
        resultsDisplayValue: "Display Value",
        modified: "Modified",
        saving: "Saving",
        saved: "Saved",
        saveError: "Error! Editor content is not saved.",
        translationAddLanguage: "Select language to translate",
        translationShowAllStrings: "Show all strings",
        translationShowAllPages: "Show all pages",
        translationNoStrings: "No strings to translate. Please, change the filter.",
        translationExportToSCVButton: "Export to CSV",
        translationImportFromSCVButton: "Import from CSV",
        translationMergeLocaleWithDefault: "Merge {0} with default locale",
        bold: "Bold",
        italic: "Italic",
        underline: "Underline",
        fpAddQuestion: "Add question..."
    },
    //Property names in table headers
    pel: {
        isRequired: "Required?"
    },
    //Property Editors
    pe: {
        apply: "Apply",
        ok: "OK",
        cancel: "Cancel",
        reset: "Reset",
        close: "Close",
        delete: "Delete",
        addNew: "Add New",
        addItem: "Click to add an item...",
        removeAll: "Remove All",
        edit: "Edit",
        itemValueEdit: "Visible If",
        editChoices: "Edit Choices",
        move: "Move",
        empty: "<empty>",
        notEmpty: "<edit value>",
        fastEntry: "Fast Entry",
        formEntry: "Form Entry",
        testService: "Test the service",
        conditionSelectQuestion: "Select question...",
        conditionValueQuestionTitle: "Please enter/select the value",
        conditionButtonAdd: "Add",
        conditionButtonReplace: "Replace",
        conditionHelp: "Please enter a boolean expression. It should return true to keep the question/page visible. For example: {question1} = 'value1' or ({question2} * {question4}  > 20 and {question3} < 5)",
        expressionHelp: "Please enter an expression. You may use curly brackets to get access to the question values: '{question1} + {question2}', '({price}*{quantity}) * (100 - {discount})'",
        aceEditorHelp: "Press ctrl+space to get expression completion hint",
        aceEditorRowTitle: "Current row",
        aceEditorPanelTitle: "Current panel",
        showMore: "For more details please check the documentation",
        conditionShowMoreUrl: "https://surveyjs.io/Documentation/LibraryParameter?id=Question&parameter=visibleIf",
        assistantTitle: "Available questions:",
        cellsEmptyRowsColumns: "There is should be at least one column or row",
        propertyIsEmpty: "Please enter a value",
        value: "Value",
        text: "Text",
        rowid: "Row ID",
        imageLink: "Image Link",
        columnEdit: "Edit column: {0}",
        itemEdit: "Edit item: {0}",
        url: "URL",
        path: "Path",
        valueName: "Value name",
        titleName: "Title name",
        hasOther: "Has other item",
        otherText: "Other item text",
        name: "Name",
        title: "Title",
        cellType: "Cell type",
        colCount: "Column count",
        choicesOrder: "Select choices order",
        visible: "Is visible?",
        isRequired: "Is required?",
        startWithNewLine: "Is start with new line?",
        rows: "Row count",
        placeHolder: "Input place holder",
        showPreview: "Is image preview shown?",
        storeDataAsText: "Store file content in JSON result as text",
        maxSize: "Maximum file size in bytes",
        imageHeight: "Image height",
        imageWidth: "Image width",
        rowCount: "Row count",
        columnLayout: "Columns layout",
        addRowLocation: "Add row button location",
        addRowText: "Add row button text",
        removeRowText: "Remove row button text",
        minRateDescription: "Minimum rate description",
        maxRateDescription: "Maximum rate description",
        inputType: "Input type",
        optionsCaption: "Options caption",
        defaultValue: "Default value",
        cellsDefaultRow: "Default cells texts",
        surveyEditorTitle: "Edit survey settings",
        qEditorTitle: "Edit: {0}",
        maxLength: "Maximum length",
        //survey
        showTitle: "Show/hide title",
        locale: "Default language",
        mode: "Mode (edit/read only)",
        clearInvisibleValues: "Clear invisible values",
        cookieName: "Cookie name (to disable run survey two times locally)",
        sendResultOnPageNext: "Send survey results on page next",
        storeOthersAsComment: "Store 'others' value in separate field",
        showPageTitles: "Show page titles",
        showPageNumbers: "Show page numbers",
        pagePrevText: "Page previous button text",
        pageNextText: "Page next button text",
        completeText: "Complete button text",
        startSurveyText: "Start button text",
        showNavigationButtons: "Show navigation buttons (default navigation)",
        showPrevButton: "Show previous button (user may return on previous page)",
        firstPageIsStarted: "The first page in the survey is a started page.",
        showCompletedPage: "Show the completed page at the end (completedHtml)",
        goNextPageAutomatic: "On answering all questions, go to the next page automatically",
        showProgressBar: "Show progress bar",
        questionTitleLocation: "Question title location",
        requiredText: "The question required symbol(s)",
        questionStartIndex: "Question start index (1, 2 or 'A', 'a')",
        showQuestionNumbers: "Show question numbers",
        questionTitleTemplate: "Question title template, default is: '{no}. {require} {title}'",
        questionErrorLocation: "Question error location",
        focusFirstQuestionAutomatic: "Focus first question on changing the page",
        questionsOrder: "Elements order on the page",
        maxTimeToFinish: "Maximum time to finish the survey",
        maxTimeToFinishPage: "Maximum time to finish a page in the survey",
        showTimerPanel: "Show timer panel",
        showTimerPanelMode: "Show timer panel mode",
        renderMode: "Render mode",
        allowAddPanel: "Allow adding a panel",
        allowRemovePanel: "Allow removing the panel",
        panelAddText: "Adding panel text",
        panelRemoveText: "Removing panel text",
        isSinglePage: "Show all elements on one page",
        tabs: {
            general: "General",
            fileOptions: "Options",
            html: "Html Editor",
            columns: "Columns",
            rows: "Rows",
            choices: "Choices",
            items: "Items",
            visibleIf: "Visible If",
            enableIf: "Enable If",
            requiredIf: "Required If",
            rateValues: "Rate Values",
            choicesByUrl: "Choices from Web",
            matrixChoices: "Default Choices",
            multipleTextItems: "Text Inputs",
            validators: "Validators",
            navigation: "Navigation",
            question: "Question",
            completedHtml: "Completed Html",
            loadingHtml: "Loading Html",
            timer: "Timer/Quiz",
            triggers: "Triggers",
            templateTitle: "Template title"
        },
        editProperty: "Edit property '{0}'",
        items: "[ Items: {0} ]",
        enterNewValue: "Please, enter the value.",
        noquestions: "There is no any question in the survey.",
        createtrigger: "Please create a trigger",
        triggerOn: "On ",
        triggerMakePagesVisible: "Make pages visible:",
        triggerMakeQuestionsVisible: "Make elements visible:",
        triggerCompleteText: "Complete the survey if succeed.",
        triggerNotSet: "The trigger is not set",
        triggerRunIf: "Run if",
        triggerSetToName: "Change value of: ",
        triggerFromName: "Copy value from: ",
        triggerRunExpression: "Run this Expression:",
        triggerSetValue: "to: ",
        triggerIsVariable: "Do not put the variable into the survey result."
    },
    //Property values
    pv: {
        true: "true",
        false: "false",
        inherit: "inherit",
        show: "show",
        hide: "hide",
        default: "default",
        initial: "initial",
        random: "random",
        collapsed: "collapsed",
        expanded: "expanded",
        none: "none",
        asc: "ascending",
        desc: "descending",
        indeterminate: "indeterminate",
        decimal: "decimal",
        currency: "currency",
        percent: "percent",
        firstExpanded: "firstExpanded",
        off: "off",
        onPanel: "onPanel",
        onSurvey: "onSurvey",
        list: "list",
        progressTop: "progressTop",
        progressBottom: "progressBottom",
        progressTopBottom: "progressTopBottom",
        horizontal: "horizontal",
        vertical: "vertical",
        top: "top",
        bottom: "bottom",
        topBottom: "top and bottom",
        left: "left",
        color: "color",
        date: "date",
        datetime: "datetime",
        "datetime-local": "datetime-local",
        email: "email",
        month: "month",
        number: "number",
        password: "password",
        range: "range",
        tel: "tel",
        text: "text",
        time: "time",
        url: "url",
        week: "week",
        hidden: "hidden",
        on: "on",
        onPage: "onPage",
        edit: "edit",
        display: "display",
        onComplete: "onComplete",
        onHidden: "onHidden",
        all: "all",
        page: "page",
        survey: "survey",
        onNextPage: "onNextPage",
        onValueChanged: "onValueChanged"
    },
    //Operators
    op: {
        empty: "is empty",
        notempty: "is not empty",
        equal: "equals",
        notequal: "not equals",
        contains: "contains",
        notcontains: "not contains",
        greater: "greater",
        less: "less",
        greaterorequal: "greater or equals",
        lessorequal: "less or equals"
    },
    //Embed window
    ew: {
        angular: "Use Angular version",
        jquery: "Use jQuery version",
        knockout: "Use Knockout version",
        react: "Use React version",
        vue: "Use Vue version",
        bootstrap: "For bootstrap framework",
        standard: "No bootstrap",
        showOnPage: "Show survey on a page",
        showInWindow: "Show survey in a window",
        loadFromServer: "Load Survey JSON from server",
        titleScript: "Scripts and styles",
        titleHtml: "HTML",
        titleJavaScript: "JavaScript"
    },
    //Test Survey
    ts: {
        selectPage: "Select the page to test it:",
        showInvisibleElements: "Show invisible elements"
    },
    validators: {
        answercountvalidator: "answer count",
        emailvalidator: "e-mail",
        expressionvalidator: "expression",
        numericvalidator: "numeric",
        regexvalidator: "regex",
        textvalidator: "text"
    },
    triggers: {
        completetrigger: "complete survey",
        setvaluetrigger: "set value",
        copyvaluetrigger: "copy value",
        runexpressiontrigger: "run expression",
        visibletrigger: "change visibility"
    },
    //Properties
    p: {
        name: "name",
        title: {
            name: "title",
            title: "Leave it empty, if it is the same as 'Name'"
        },
        navigationButtonsVisibility: "navigationButtonsVisibility",
        questionsOrder: "questionsOrder",
        maxTimeToFinish: "maxTimeToFinish",
        visible: "visible",
        visibleIf: "visibleIf",
        questionTitleLocation: "questionTitleLocation",
        description: "description",
        state: "state",
        isRequired: "isRequired",
        requiredIf: "requiredIf",
        indent: "indent",
        requiredErrorText: "requiredErrorText",
        startWithNewLine: "startWithNewLine",
        innerIndent: "innerIndent",
        page: "page",
        width: "width",
        commentText: "commentText",
        valueName: "valueName",
        enableIf: "enableIf",
        defaultValue: "defaultValue",
        correctAnswer: "correctAnswer",
        readOnly: "readOnly",
        validators: "validators",
        titleLocation: "titleLocation",
        hasComment: "hasComment",
        hasOther: "hasOther",
        choices: "choices",
        choicesOrder: "choicesOrder",
        choicesByUrl: "choicesByUrl",
        otherText: "otherText",
        otherErrorText: "otherErrorText",
        storeOthersAsComment: "storeOthersAsComment",
        label: "label",
        showTitle: "showTitle",
        valueTrue: "valueTrue",
        valueFalse: "valueFalse",
        cols: "cols",
        rows: "rows",
        placeHolder: "placeHolder",
        optionsCaption: "optionsCaption",
        expression: "expression",
        format: "format",
        displayStyle: "displayStyle",
        currency: "currency",
        useGrouping: "useGrouping",
        showPreview: "showPreview",
        allowMultiple: "allowMultiple",
        imageHeight: "imageHeight",
        imageWidth: "imageWidth",
        storeDataAsText: "storeDataAsText",
        maxSize: "maxSize",
        html: "html",
        columns: "columns",
        cells: "cells",
        isAllRowRequired: "isAllRowRequired",
        horizontalScroll: "horizontalScroll",
        cellType: "cellType",
        columnsLayout: "columnsLayout",
        columnColCount: "columnColCount",
        columnMinWidth: "columnMinWidth",
        rowCount: "rowCount",
        minRowCount: "minRowCount",
        maxRowCount: "maxRowCount",
        keyName: "keyName",
        keyDuplicationError: "keyDuplicationError",
        confirmDelete: "confirmDelete",
        confirmDeleteText: "confirmDeleteText",
        addRowLocation: "addRowLocation",
        addRowText: "addRowText",
        removeRowText: "removeRowText",
        items: "items",
        itemSize: "itemSize",
        colCount: "colCount",
        templateTitle: "templateTitle",
        templateDescription: "templateDescription",
        allowAddPanel: "allowAddPanel",
        allowRemovePanel: "allowRemovePanel",
        panelCount: "panelCount",
        minPanelCount: "minPanelCount",
        maxPanelCount: "maxPanelCount",
        panelsState: "panelsState",
        panelAddText: "panelAddText",
        panelRemoveText: "panelRemoveText",
        panelPrevText: "panelPrevText",
        panelNextText: "panelNextText",
        showQuestionNumbers: "showQuestionNumbers",
        showRangeInProgress: "showRangeInProgress",
        renderMode: "renderMode",
        templateTitleLocation: "templateTitleLocation",
        rateValues: "rateValues",
        rateMin: "rateMin",
        rateMax: "rateMax",
        rateStep: "rateStep",
        minRateDescription: "minRateDescription",
        maxRateDescription: "maxRateDescription",
        inputType: "inputType",
        size: "size",
        locale: "locale",
        focusFirstQuestionAutomatic: "focusFirstQuestionAutomatic",
        completedHtml: "completedHtml",
        completedBeforeHtml: "completedBeforeHtml",
        loadingHtml: "loadingHtml",
        triggers: "triggers",
        cookieName: "cookieName",
        sendResultOnPageNext: "sendResultOnPageNext",
        showNavigationButtons: "showNavigationButtons",
        showPrevButton: "showPrevButton",
        showPageTitles: "showPageTitles",
        showCompletedPage: "showCompletedPage",
        showPageNumbers: "showPageNumbers",
        questionErrorLocation: "questionErrorLocation",
        showProgressBar: "showProgressBar",
        mode: "mode",
        goNextPageAutomatic: "goNextPageAutomatic",
        checkErrorsMode: "checkErrorsMode",
        clearInvisibleValues: "clearInvisibleValues",
        startSurveyText: "startSurveyText",
        pagePrevText: "pagePrevText",
        pageNextText: "pageNextText",
        completeText: "completeText",
        requiredText: "requiredText",
        questionStartIndex: "questionStartIndex",
        questionTitleTemplate: "questionTitleTemplate",
        firstPageIsStarted: "firstPageIsStarted",
        isSinglePage: "isSinglePage",
        maxTimeToFinishPage: "maxTimeToFinishPage",
        showTimerPanel: "showTimerPanel",
        showTimerPanelMode: "showTimerPanelMode",
        defaultPanelValue: "defaultPanelValue",
        defaultRowValue: "defaultRowValue",
        hasNone: "hasNone",
        noneText: "noneText",
        text: "text",
        minValue: "minimum value",
        maxValue: "maximum value",
        minLength: "minimum length",
        maxLength: "maximum length",
        allowDigits: "allow digits",
        minCount: "minimum count",
        maxCount: "maximum count",
        regex: "regular expression"
    }
};
//Uncomment this line on creating a translation file. You should replace "en" and enStrings with your locale ("fr", "de" and so on) and your variable.
//editorLocalization.locales["en"] = enStrings;


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_knockout__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_survey_knockout__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_survey_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_survey_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__propertyModalEditor__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__propertyEditorFactory__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__editorLocalization__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SurveyPropertyConditionEditor; });
/* unused harmony export doGetCompletions */
/* unused harmony export insertMatch */






var SurveyPropertyConditionEditor = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SurveyPropertyConditionEditor, _super);
    function SurveyPropertyConditionEditor(property, _type, syntaxCheckMethodName) {
        if (_type === void 0) { _type = "condition"; }
        if (syntaxCheckMethodName === void 0) { syntaxCheckMethodName = "createCondition"; }
        var _this = _super.call(this, property) || this;
        _this._type = _type;
        _this.syntaxCheckMethodName = syntaxCheckMethodName;
        _this.availableOperators = [];
        _this.showHelpText = true;
        _this.isValueChanging = false;
        _this.addConditionQuestionsHash = {};
        _this.availableOperators = __WEBPACK_IMPORTED_MODULE_4__propertyEditorFactory__["a" /* SurveyPropertyEditorFactory */].getOperators();
        _this.koIsValid = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"](true);
        _this.koAddConditionQuestions = __WEBPACK_IMPORTED_MODULE_1_knockout__["observableArray"]();
        _this.koAddConditionQuestion = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"]("");
        _this.koAddConditionOperator = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"]("");
        _this.koAddConditionValue = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"]("");
        _this.koAddConditionType = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"]("and");
        _this.koHasValueSurvey = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"](false);
        _this.koValueSurvey = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"](SurveyPropertyConditionEditor.emptySurvey);
        var self = _this;
        _this.koAddConditionQuestion.subscribe(function (newValue) {
            self.onValueSurveyChanged(newValue, self.koAddConditionOperator());
        });
        _this.koAddConditionOperator.subscribe(function (newValue) {
            self.onValueSurveyChanged(self.koAddConditionQuestion(), newValue);
        });
        _this.koAddConditionValue.subscribe(function (newValue) {
            if (self.koHasValueSurvey()) {
                var newParsedValue = !newValue ? {} : JSON.parse(newValue);
                self.isValueChanging = true;
                self.koValueSurvey().setValue("question", newParsedValue);
                self.isValueChanging = false;
            }
        });
        _this.koCanAddCondition = __WEBPACK_IMPORTED_MODULE_1_knockout__["computed"](function () {
            return (this.koAddConditionQuestion() != "" &&
                this.koAddConditionQuestion() != undefined &&
                this.koAddConditionOperator() != "" &&
                (!this.koAddContionValueEnabled() || this.koAddConditionValue() != ""));
        }, _this);
        _this.koShowAddConditionType = __WEBPACK_IMPORTED_MODULE_1_knockout__["computed"](function () {
            if (!this.koIsValid())
                return false;
            var text = this.koTextValue();
            if (text)
                text = text.trim();
            return text;
        }, _this);
        _this.koAddConditionButtonText = __WEBPACK_IMPORTED_MODULE_1_knockout__["computed"](function () {
            var name = this.koIsValid()
                ? "conditionButtonAdd"
                : "conditionButtonReplace";
            return __WEBPACK_IMPORTED_MODULE_5__editorLocalization__["a" /* editorLocalization */].getString("pe." + name);
        }, _this);
        _this.koAddContionValueEnabled = __WEBPACK_IMPORTED_MODULE_1_knockout__["computed"](function () {
            return self.canShowValueByOperator(self.koAddConditionOperator());
        }, _this);
        _this.onConditionAddClick = function () {
            self.addCondition();
        };
        _this.resetAddConditionValues();
        return _this;
    }
    SurveyPropertyConditionEditor.prototype.beforeShow = function () {
        _super.prototype.beforeShow.call(this);
        this.addConditionQuestionsHash = {};
        this.koAddConditionQuestions(this.allConditionQuestions);
    };
    Object.defineProperty(SurveyPropertyConditionEditor.prototype, "editorType", {
        get: function () {
            return this._type;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyPropertyConditionEditor.prototype, "availableQuestions", {
        get: function () {
            if (this.object instanceof __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["MatrixDropdownColumn"]) {
                return this.object.colOwner["survey"].getAllQuestions();
            }
            return ((this.object &&
                this.object.survey &&
                this.object.survey.getAllQuestions()) ||
                []);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyPropertyConditionEditor.prototype, "allConditionQuestions", {
        get: function () {
            var res = this.getConditionQuetions();
            res.sort(function (a, b) {
                return a.text.localeCompare(b.text);
            });
            return res;
        },
        enumerable: true,
        configurable: true
    });
    SurveyPropertyConditionEditor.prototype.getConditionQuetions = function () {
        if (!this.object)
            return [];
        var res = [];
        var questions = this.availableQuestions;
        if (questions.length > 0 && questions[0]["addConditionObjectsByContext"]) {
            for (var i = 0; i < questions.length; i++) {
                if (this.object == questions[i])
                    continue;
                questions[i].addConditionObjectsByContext(res, this.object);
            }
            this.addConditionQuestionsHash = {};
            for (var i = 0; i < res.length; i++) {
                if (!this.options || !this.options.showTitlesInExpressions) {
                    res[i].text = res[i].name;
                }
                this.addConditionQuestionsHash[res[i].name] = res[i].question;
            }
        }
        else {
            //TODO remove old code
            var names = [];
            for (var i = 0; i < questions.length; i++) {
                this.addConditionQuestionNames(questions[i], names);
            }
            this.addMatrixColumnsToCondition(names);
            this.addPanelDynamicQuestionsToCondition(names);
            for (var i = 0; i < names.length; i++) {
                res.push({ name: names[i], text: names[i] });
            }
        }
        !!this.options &&
            this.options.onConditionQuestionsGetListCallback(this.editablePropertyName, this.object, this, res);
        return res;
    };
    SurveyPropertyConditionEditor.prototype.addQuestionNames = function (question, questionNames, names) {
        for (var i = 0; i < questionNames.length; i++) {
            this.addConditionQuestionsHash[questionNames[i]] = question;
            names.push(questionNames[i]);
        }
    };
    SurveyPropertyConditionEditor.prototype.addConditionQuestionNames = function (question, names) {
        if (question == this.object)
            return;
        var questionNames = [];
        question.addConditionNames(questionNames);
        this.addQuestionNames(question, questionNames, names);
    };
    SurveyPropertyConditionEditor.prototype.addMatrixColumnsToCondition = function (names) {
        if (!(this.object instanceof __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["MatrixDropdownColumn"]) ||
            !this.object ||
            !this.object.colOwner ||
            !this.object.colOwner["columns"])
            return;
        var columns = this.object.colOwner["columns"];
        for (var i = 0; i < columns.length; i++) {
            if (columns[i] == this.object)
                continue;
            var colName = "row." + columns[i].name;
            names.push(colName);
            this.addConditionQuestionsHash[colName] = this.object.colOwner;
        }
    };
    SurveyPropertyConditionEditor.prototype.addPanelDynamicQuestionsToCondition = function (names) {
        if (!(this.object.data instanceof __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["QuestionPanelDynamicItem"]))
            return;
        var panel = this.object.data.panel;
        for (var i = 0; i < panel.questions.length; i++) {
            var q = panel.questions[i];
            var questionNames = [];
            this.addConditionQuestionNames(q, questionNames);
            for (var j = 0; j < questionNames.length; j++) {
                var questionName = "panel." + questionNames[j];
                if (q.name != this.object.name) {
                    names.push(questionName);
                }
                this.addConditionQuestionsHash[questionName] = q;
            }
        }
    };
    SurveyPropertyConditionEditor.prototype.onValueSurveyChanged = function (questionName, operator) {
        if (!this.canShowValueByOperator(operator) ||
            !questionName ||
            !this.object ||
            !this.object.survey) {
            this.koHasValueSurvey(false);
            return;
        }
        var json = this.getQuestionConditionJson(questionName, operator);
        this.koHasValueSurvey(!!json && !!json.type);
        if (this.koHasValueSurvey()) {
            this.koValueSurvey(this.createValueSurvey(json, questionName));
        }
    };
    SurveyPropertyConditionEditor.prototype.createValueSurvey = function (qjson, questionName) {
        qjson.name = "question";
        qjson.title = __WEBPACK_IMPORTED_MODULE_5__editorLocalization__["a" /* editorLocalization */].getString("pe.conditionValueQuestionTitle");
        delete qjson["visible"];
        delete qjson["visibleIf"];
        delete qjson["enable"];
        delete qjson["enableIf"];
        var json = {
            questions: [],
            showNavigationButtons: false,
            showQuestionNumbers: "off"
        };
        json.questions.push(qjson);
        var survey = new __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["Survey"](json);
        var self = this;
        survey.onValueChanged.add(function (survey, options) {
            if (!self.isValueChanging) {
                self.koAddConditionValue(JSON.stringify(options.value));
            }
        });
        if (this.options) {
            var propName = !!this.property ? this.property.name : "";
            this.options.onConditionValueSurveyCreatedCallBack(questionName, propName, this.object, this, survey);
        }
        return survey;
    };
    SurveyPropertyConditionEditor.prototype.getQuestionByName = function (questionName) {
        if (!this.object || !this.object.survey)
            return null;
        return this.addConditionQuestionsHash[questionName];
    };
    SurveyPropertyConditionEditor.prototype.getQuestionValueByName = function (questionName) {
        var question = this.getQuestionByName(questionName);
        if (question && question.name != question.getValueName())
            return questionName.replace(question.name, question.getValueName());
        return questionName;
    };
    SurveyPropertyConditionEditor.prototype.getQuestionConditionJson = function (questionName, operator) {
        var path = "";
        var question = this.getQuestionByName(questionName);
        if (!question)
            return null;
        var path = questionName.substr(question.name.length);
        if (!!path && path[0] == ".") {
            path = path.substr(1);
        }
        var json = question && question.getConditionJson
            ? question.getConditionJson(operator, path)
            : null;
        return json && (json.type !== "text" || json.inputType) ? json : null;
    };
    SurveyPropertyConditionEditor.prototype.canShowValueByOperator = function (operator) {
        return operator != "empty" && operator != "notempty";
    };
    Object.defineProperty(SurveyPropertyConditionEditor.prototype, "hasAceEditor", {
        get: function () {
            return (typeof ace !== "undefined" &&
                typeof ace.require("ace/ext/language_tools") !== "undefined");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyPropertyConditionEditor.prototype, "addConditionQuestionOptions", {
        get: function () {
            return __WEBPACK_IMPORTED_MODULE_5__editorLocalization__["a" /* editorLocalization */].getString("pe.conditionSelectQuestion");
        },
        enumerable: true,
        configurable: true
    });
    SurveyPropertyConditionEditor.prototype.addCondition = function () {
        if (!this.koCanAddCondition())
            return;
        var text = "";
        if (this.koShowAddConditionType()) {
            text = this.koTextValue() + " " + this.koAddConditionType() + " ";
        }
        text +=
            "{" +
                this.getQuestionValueByName(this.koAddConditionQuestion()) +
                "} " +
                this.getAddConditionOperator();
        if (this.koAddContionValueEnabled()) {
            text += " " + this.getAddConditionValue();
        }
        this.koTextValue(text);
        this.resetAddConditionValues();
    };
    SurveyPropertyConditionEditor.prototype.onBeforeApply = function () {
        if (!this.koTextValue() && this.koCanAddCondition()) {
            this.addCondition();
        }
        _super.prototype.onBeforeApply.call(this);
    };
    SurveyPropertyConditionEditor.prototype.getAddConditionOperator = function () {
        var op = this.koAddConditionOperator();
        if (op == "equal")
            return "=";
        if (op == "notequal")
            return "<>";
        if (op == "greater")
            return ">";
        if (op == "less")
            return "<";
        if (op == "greaterorequal")
            return ">=";
        if (op == "lessorequal")
            return "<=";
        return op;
    };
    SurveyPropertyConditionEditor.prototype.getAddConditionValue = function () {
        var val = this.koAddConditionValue();
        if (!val)
            return val;
        if (val == "true" || val == "false")
            return val;
        if (!isNaN(val))
            return val;
        if (val[0] == "[")
            return val;
        if (!this.isQuote(val[0]))
            val = "'" + val;
        if (!this.isQuote(val[val.length - 1]))
            val = val + "'";
        return val;
    };
    SurveyPropertyConditionEditor.prototype.isQuote = function (ch) {
        return ch == "'" || ch == '"';
    };
    SurveyPropertyConditionEditor.prototype.onkoTextValueChanged = function (newValue) {
        if (!newValue) {
            this.koIsValid(true);
        }
        else {
            var conditionParser = new __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["ConditionsParser"]();
            conditionParser[this.syntaxCheckMethodName](newValue);
            this.koIsValid(!conditionParser.error);
        }
    };
    SurveyPropertyConditionEditor.prototype.resetAddConditionValues = function () {
        this.koAddConditionQuestion("");
        this.koAddConditionOperator("equal");
        this.koAddConditionValue("");
    };
    SurveyPropertyConditionEditor.emptySurvey = new __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["Survey"]();
    return SurveyPropertyConditionEditor;
}(__WEBPACK_IMPORTED_MODULE_3__propertyModalEditor__["b" /* SurveyPropertyTextEditor */]));

__WEBPACK_IMPORTED_MODULE_4__propertyEditorFactory__["a" /* SurveyPropertyEditorFactory */].registerEditor("condition", function (property) {
    return new SurveyPropertyConditionEditor(property, "condition", "createCondition");
});
__WEBPACK_IMPORTED_MODULE_4__propertyEditorFactory__["a" /* SurveyPropertyEditorFactory */].registerEditor("expression", function (property) {
    return new SurveyPropertyConditionEditor(property, "expression", "parseExpression");
});
var operations = [
    {
        value: "and",
        title: "logical 'and' operator"
    },
    {
        value: "&&",
        title: "logical 'and' operator"
    },
    {
        value: "or",
        title: "logical 'or' operator"
    },
    {
        value: "||",
        title: "logical 'or' operator"
    },
    {
        value: "empty",
        title: "returns true if the left operand is empty	{questionName} empty"
    },
    {
        value: "notempty",
        title: "returns true if the left operand is not empty	{questionName} notempty"
    },
    {
        value: "=",
        title: "returns true if two values are equal	{questionName} = 5, {questionName} == 'abc', {questionName} equal 124"
    },
    {
        value: "==",
        title: "returns true if two values are equal	{questionName} = 5, {questionName} == 'abc', {questionName} equal 124"
    },
    {
        value: "equal",
        title: "returns true if two values are equal	{questionName} = 5, {questionName} == 'abc', {questionName} equal 124"
    },
    {
        value: "<>",
        title: "returns true if two values are not equal	{questionName} <> 5, {questionName} != 'abc', {questionName} notequal 124"
    },
    {
        value: "!=",
        title: "returns true if two values are not equal	{questionName} <> 5, {questionName} != 'abc', {questionName} notequal 124"
    },
    {
        value: "notequal",
        title: "returns true if two values are not equal	{questionName} <> 5, {questionName} != 'abc', {questionName} notequal 124"
    },
    {
        value: ">",
        title: "returns true if the left operand greater then the second operand	{questionName} > 2, {questionName} greater 'a'"
    },
    {
        value: "greater",
        title: "returns true if the left operand greater then the second operand	{questionName} > 2, {questionName} greater 'a'"
    },
    {
        value: "<",
        title: "returns true if the left operand less then the second operand	{questionName} < 2, {questionName} less 'a'"
    },
    {
        value: "less",
        title: "returns true if the left operand less then the second operand	{questionName} < 2, {questionName} less 'a'"
    },
    {
        value: ">=",
        title: "returns true if the left operand equal or greater then the second operand	{questionName} >= 2, {questionName} greaterorequal 'a'"
    },
    {
        value: "greaterorequal",
        title: "returns true if the left operand equal or greater then the second operand	{questionName} >= 2, {questionName} greaterorequal 'a'"
    },
    {
        value: "<=",
        title: "returns true if the left operand equal or less then the second operand	{questionName} <= 2, {questionName} lessorequal 'a'"
    },
    {
        value: "lessorequal",
        title: "returns true if the left operand equal or less then the second operand	{questionName} <= 2, {questionName} lessorequal 'a'"
    },
    {
        value: "contains",
        title: "return true if the left operand is an array and it contains a value of the second operand	{questionName} contains 'a'"
    },
    {
        value: "notcontains",
        title: "return true if the left operand is an array and it does not contain a value of the second operand"
    }
];
var createAnnotations = function (condition, syntaxCheckMethodName) {
    condition = condition || "";
    var annotations = new Array();
    var conditionParser = new __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["ConditionsParser"]();
    conditionParser[syntaxCheckMethodName](condition);
    if (!!condition && conditionParser.error) {
        var toErrorSubstring = condition.substring(0, conditionParser.error.at);
        var column = toErrorSubstring.length - toErrorSubstring.lastIndexOf("\n");
        var annotation = {
            row: condition.match(/\n/g) ? condition.match(/\n/g).length : 0,
            column: column,
            text: conditionParser.error.code + " (" + column + ")",
            type: "error"
        };
        annotations.push(annotation);
    }
    return annotations;
};
var ID_REGEXP = /[a-zA-Z_0-9{\*\/\<\>\=\!\$\.\-\u00A2-\uFFFF]/;
function doGetCompletions(prevIdentifier, prefix, config, completer) {
    if (completer === void 0) { completer = null; }
    var completions = [];
    var currentQuestion = config.question;
    var usableQuestions = (config.questions || []).filter(function (q) { return q !== currentQuestion; });
    if (!!usableQuestions ||
        currentQuestion instanceof __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["MatrixDropdownColumn"] ||
        currentQuestion.data instanceof __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["QuestionPanelDynamicItem"]) {
        if (prevIdentifier === "row" &&
            currentQuestion instanceof __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["MatrixDropdownColumn"]) {
            completions = currentQuestion.colOwner["columns"]
                .filter(function (e) { return e.name !== currentQuestion.name; })
                .map(function (column) {
                return {
                    name: "",
                    value: "{row." + column.name + "}",
                    some: "",
                    meta: column.title,
                    identifierRegex: ID_REGEXP
                };
            });
        }
        else if (prevIdentifier === "panel" &&
            currentQuestion.data instanceof __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["QuestionPanelDynamicItem"]) {
            var panel = currentQuestion.data.panel;
            completions = panel.elements
                .filter(function (e) { return e.name !== currentQuestion.name; })
                .map(function (element) {
                return {
                    name: "",
                    value: "{panel." + element.name + "}",
                    some: "",
                    meta: element.name,
                    identifierRegex: ID_REGEXP
                };
            });
        }
        else {
            var operationsFiltered = operations.filter(function (op) { return !prefix || op.value.indexOf(prefix) !== -1; });
            var questionsFiltered = usableQuestions.filter(function (op) { return !prefix || op.name.indexOf(prefix) !== -1; });
            if (currentQuestion instanceof __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["MatrixDropdownColumn"]) {
                completions.push({
                    name: "",
                    value: "{row.",
                    some: "",
                    meta: __WEBPACK_IMPORTED_MODULE_5__editorLocalization__["a" /* editorLocalization */].getString(__WEBPACK_IMPORTED_MODULE_5__editorLocalization__["b" /* defaultStrings */].pe.aceEditorRowTitle),
                    identifierRegex: ID_REGEXP
                });
            }
            else if (currentQuestion.data instanceof __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["QuestionPanelDynamicItem"]) {
                completions.push({
                    name: "",
                    value: "{panel.",
                    some: "",
                    meta: __WEBPACK_IMPORTED_MODULE_5__editorLocalization__["a" /* editorLocalization */].getString(__WEBPACK_IMPORTED_MODULE_5__editorLocalization__["b" /* defaultStrings */].pe.aceEditorPanelTitle),
                    identifierRegex: ID_REGEXP
                });
            }
            completions = completions
                .concat(questionsFiltered.map(function (q) {
                return {
                    completer: completer,
                    name: "",
                    value: "{" + q.name + "}",
                    some: "",
                    meta: q.title,
                    identifierRegex: ID_REGEXP
                };
            }))
                .concat(operationsFiltered.map(function (op) {
                return {
                    name: "",
                    value: op.value,
                    some: "",
                    meta: op.title,
                    identifierRegex: ID_REGEXP
                };
            }));
        }
    }
    return completions;
}
function insertMatch(editor, data) {
    if (editor.completer.completions.filterText) {
        var allRanges = editor.selection.getAllRanges();
        for (var rangeIndex = 0, range; (range = allRanges[rangeIndex]); rangeIndex++) {
            range.start.column -= editor.completer.completions.filterText.length;
            var rangeText = editor.session.getTextRange(range);
            if (rangeText.indexOf("{") !== 0) {
                var extRange = range.clone();
                extRange.start.column--;
                if (editor.session.getTextRange(extRange).indexOf("{") === 0) {
                    range = extRange;
                }
            }
            editor.session.remove(range);
        }
    }
    editor.execCommand("insertstring", data.value || data);
}
__WEBPACK_IMPORTED_MODULE_1_knockout__["bindingHandlers"].aceEditor = {
    init: function (element, options) {
        var configs = options();
        var langTools = ace.require("ace/ext/language_tools");
        var langUtils = ace.require("ace/autocomplete/util");
        var editor = ace.edit(element);
        var objectEditor = configs.editor;
        var isUpdating = false;
        editor.setOption("useWorker", false);
        editor.getSession().on("change", function () {
            var errors = createAnnotations(editor.getValue(), objectEditor.syntaxCheckMethodName);
            isUpdating = true;
            objectEditor.koTextValue(editor.getValue());
            isUpdating = false;
            //   objectEditor.koHasError(errors.length > 0);
            //   if (errors.length > 0) {
            //     objectEditor.koErrorText(errors[0].text);
            //   }
            editor.getSession().setAnnotations(errors);
        });
        var updateCallback = function () {
            if (!isUpdating) {
                editor.setValue(objectEditor.koTextValue() || "");
            }
        };
        var valueSubscription = objectEditor.koTextValue.subscribe(updateCallback);
        updateCallback();
        var completer = {
            identifierRegexps: [ID_REGEXP],
            insertMatch: insertMatch,
            getCompletions: function (editor, session, pos, prefix, callback) {
                var prevIdentifier = langUtils.retrievePrecedingIdentifier(session.getLine(pos.row), pos.column - 1);
                var completions = doGetCompletions(prevIdentifier, prefix, configs, completer);
                callback(null, completions);
            },
            getDocTooltip: function (item) {
                item.docHTML =
                    "<div style='max-width: 300px; white-space: normal;'>" +
                        item.meta +
                        "</div>";
            }
        };
        langTools.setCompleters([completer]);
        editor.setOptions({
            enableBasicAutocompletion: true,
            enableLiveAutocompletion: true
        });
        __WEBPACK_IMPORTED_MODULE_1_knockout__["utils"].domNodeDisposal.addDisposeCallback(element, function () {
            editor.destroy();
            valueSubscription.dispose();
        });
        editor.focus();
    }
};


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__propertyEditorBase__ = __webpack_require__(13);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SurveyPropertyCustomEditor; });


var SurveyPropertyCustomEditor = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SurveyPropertyCustomEditor, _super);
    function SurveyPropertyCustomEditor(property, widgetJSON) {
        if (widgetJSON === void 0) { widgetJSON = null; }
        var _this = _super.call(this, property) || this;
        _this.isValueChanging = false;
        _this.widgetJSONValue = widgetJSON;
        var self = _this;
        _this["koAfterRender"] = function (el, con) {
            self.doAfterRender(el, con);
        };
        return _this;
    }
    Object.defineProperty(SurveyPropertyCustomEditor.prototype, "editorType", {
        get: function () {
            return "custom";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyPropertyCustomEditor.prototype, "widgetJSON", {
        get: function () {
            return this.widgetJSONValue;
        },
        enumerable: true,
        configurable: true
    });
    SurveyPropertyCustomEditor.prototype.onValueChanged = function () {
        if (this.isValueChanging)
            return;
        this.isValueChanging = true;
        _super.prototype.onValueChanged.call(this);
        if (this.onValueChangedCallback)
            this.onValueChangedCallback(this.editingValue);
        this.isValueChanging = false;
    };
    Object.defineProperty(SurveyPropertyCustomEditor.prototype, "widgetRender", {
        get: function () {
            return this.widgetJSON ? this.widgetJSON.render : null;
        },
        enumerable: true,
        configurable: true
    });
    SurveyPropertyCustomEditor.prototype.doAfterRender = function (elements, con) {
        var el = elements[0];
        if (el && this.widgetRender)
            this.widgetRender(this, el);
    };
    return SurveyPropertyCustomEditor;
}(__WEBPACK_IMPORTED_MODULE_1__propertyEditorBase__["a" /* SurveyPropertyEditorBase */]));



/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_knockout__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_survey_knockout__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_survey_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_survey_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__propertyModalEditor__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__editorLocalization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__propertyEditorFactory__ = __webpack_require__(4);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SurveyPropertyDefaultValueEditor; });
/* unused harmony export SurveyPropertyDefaultRowValueEditorBase */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SurveyPropertyDefaultRowValueEditor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SurveyPropertyDefaultPanelValueEditor; });






var SurveyPropertyDefaultValueEditor = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SurveyPropertyDefaultValueEditor, _super);
    function SurveyPropertyDefaultValueEditor(property) {
        var _this = _super.call(this, property) || this;
        _this.koSurvey = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"](new __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["Survey"]());
        return _this;
    }
    SurveyPropertyDefaultValueEditor.createJsonFromQuestion = function (obj) {
        var qjson = new __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["JsonObject"]().toJsonObject(obj);
        qjson.name = SurveyPropertyDefaultValueEditor.defaultQuestionName;
        qjson.type = obj.getType();
        if (qjson.type == "expression") {
            qjson.type = "text";
        }
        qjson.titleLocation = "hidden";
        qjson.showClearButton = true;
        qjson.storeOthersAsComment = false;
        delete qjson["visible"];
        delete qjson["visibleIf"];
        delete qjson["enable"];
        delete qjson["enableIf"];
        return qjson;
    };
    SurveyPropertyDefaultValueEditor.createSurveyFromJsonQuestion = function (questionJson) {
        var json = {
            questions: [],
            showNavigationButtons: false,
            showQuestionNumbers: "off"
        };
        json.questions.push(questionJson);
        return new __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["Survey"](json);
    };
    SurveyPropertyDefaultValueEditor.prototype.getValueText = function (value) {
        if (!value)
            return __WEBPACK_IMPORTED_MODULE_4__editorLocalization__["a" /* editorLocalization */].getString("pe.empty");
        return JSON.stringify(value);
    };
    SurveyPropertyDefaultValueEditor.prototype.beforeShow = function () {
        _super.prototype.beforeShow.call(this);
        this.createSurvey();
    };
    SurveyPropertyDefaultValueEditor.prototype.onBeforeApply = function () {
        if (!this.survey)
            return;
        this.setValueCore(this.getSurveyResult());
    };
    Object.defineProperty(SurveyPropertyDefaultValueEditor.prototype, "editorType", {
        get: function () {
            return "value";
        },
        enumerable: true,
        configurable: true
    });
    SurveyPropertyDefaultValueEditor.prototype.createSurvey = function () {
        this.survey = SurveyPropertyDefaultValueEditor.createSurveyFromJsonQuestion(this.buildQuestionJson());
        this.survey.setValue(SurveyPropertyDefaultValueEditor.defaultQuestionName, this.getSurveyInitialValue());
        this.koSurvey(this.survey);
    };
    SurveyPropertyDefaultValueEditor.prototype.buildQuestionJson = function () {
        return SurveyPropertyDefaultValueEditor.createJsonFromQuestion(this.object);
    };
    SurveyPropertyDefaultValueEditor.prototype.getSurveyInitialValue = function () {
        return this.editingValue;
    };
    SurveyPropertyDefaultValueEditor.prototype.getSurveyResult = function () {
        return this.survey.getValue(SurveyPropertyDefaultValueEditor.defaultQuestionName);
    };
    SurveyPropertyDefaultValueEditor.prototype.getJsonType = function (type) {
        return type != "expression" ? type : "text";
    };
    SurveyPropertyDefaultValueEditor.defaultQuestionName = "question";
    return SurveyPropertyDefaultValueEditor;
}(__WEBPACK_IMPORTED_MODULE_3__propertyModalEditor__["a" /* SurveyPropertyModalEditor */]));

var SurveyPropertyDefaultRowValueEditorBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SurveyPropertyDefaultRowValueEditorBase, _super);
    function SurveyPropertyDefaultRowValueEditorBase(property) {
        return _super.call(this, property) || this;
    }
    Object.defineProperty(SurveyPropertyDefaultRowValueEditorBase.prototype, "editorTypeTemplate", {
        get: function () {
            return "value";
        },
        enumerable: true,
        configurable: true
    });
    SurveyPropertyDefaultRowValueEditorBase.prototype.getSurveyInitialValue = function () {
        var res = this.editingValue;
        if (!res)
            return res;
        if (!Array.isArray(res)) {
            res = [res];
        }
        return res;
    };
    SurveyPropertyDefaultRowValueEditorBase.prototype.getSurveyResult = function () {
        var res = _super.prototype.getSurveyResult.call(this);
        if (res && Array.isArray(res)) {
            if (res.length == 0)
                return null;
            return res[0];
        }
        return res;
    };
    return SurveyPropertyDefaultRowValueEditorBase;
}(SurveyPropertyDefaultValueEditor));

var SurveyPropertyDefaultRowValueEditor = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SurveyPropertyDefaultRowValueEditor, _super);
    function SurveyPropertyDefaultRowValueEditor(property) {
        return _super.call(this, property) || this;
    }
    SurveyPropertyDefaultRowValueEditor.prototype.buildQuestionJson = function () {
        var qjson = _super.prototype.buildQuestionJson.call(this);
        qjson.rowCount = 1;
        qjson.minRowCount = 1;
        qjson.maxRowCount = 1;
        qjson.columnsLocation = "vertical";
        return qjson;
    };
    Object.defineProperty(SurveyPropertyDefaultRowValueEditor.prototype, "editorType", {
        get: function () {
            return "rowvalue";
        },
        enumerable: true,
        configurable: true
    });
    return SurveyPropertyDefaultRowValueEditor;
}(SurveyPropertyDefaultRowValueEditorBase));

var SurveyPropertyDefaultPanelValueEditor = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SurveyPropertyDefaultPanelValueEditor, _super);
    function SurveyPropertyDefaultPanelValueEditor(property) {
        return _super.call(this, property) || this;
    }
    SurveyPropertyDefaultPanelValueEditor.prototype.buildQuestionJson = function () {
        var qjson = _super.prototype.buildQuestionJson.call(this);
        qjson.panelCount = 1;
        qjson.minPanelCount = 1;
        qjson.maxPanelCount = 1;
        return qjson;
    };
    Object.defineProperty(SurveyPropertyDefaultPanelValueEditor.prototype, "editorType", {
        get: function () {
            return "panelvalue";
        },
        enumerable: true,
        configurable: true
    });
    return SurveyPropertyDefaultPanelValueEditor;
}(SurveyPropertyDefaultRowValueEditorBase));

__WEBPACK_IMPORTED_MODULE_5__propertyEditorFactory__["a" /* SurveyPropertyEditorFactory */].registerEditor("value", function (property) {
    return new SurveyPropertyDefaultValueEditor(property);
});
__WEBPACK_IMPORTED_MODULE_5__propertyEditorFactory__["a" /* SurveyPropertyEditorFactory */].registerEditor("rowvalue", function (property) {
    return new SurveyPropertyDefaultRowValueEditor(property);
});
__WEBPACK_IMPORTED_MODULE_5__propertyEditorFactory__["a" /* SurveyPropertyEditorFactory */].registerEditor("panelvalue", function (property) {
    return new SurveyPropertyDefaultPanelValueEditor(property);
});


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__editorLocalization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_survey_knockout__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_survey_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_survey_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__surveyHelper__ = __webpack_require__(6);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SurveyQuestionEditorProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SurveyQuestionEditorRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SurveyQuestionEditorProperties; });




var SurveyQuestionEditorProperty = /** @class */ (function () {
    function SurveyQuestionEditorProperty(obj, property, displayName, options, isTabProperty) {
        if (options === void 0) { options = null; }
        if (isTabProperty === void 0) { isTabProperty = false; }
        this.obj = obj;
        this.property = property;
        var self = this;
        this.objectPropertyValue = new __WEBPACK_IMPORTED_MODULE_2__objectProperty__["a" /* SurveyObjectProperty */](this.property, null);
        this.editor.isTabProperty = isTabProperty;
        this.editor.options = options;
        if (!displayName) {
            displayName = __WEBPACK_IMPORTED_MODULE_0__editorLocalization__["a" /* editorLocalization */].getString("pe." + this.property.name);
        }
        if (displayName)
            this.editor.displayName = displayName;
        this.objectProperty.object = obj;
        this.editor.setup();
    }
    Object.defineProperty(SurveyQuestionEditorProperty.prototype, "objectProperty", {
        get: function () {
            return this.objectPropertyValue;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyQuestionEditorProperty.prototype, "editor", {
        get: function () {
            return this.objectProperty.editor;
        },
        enumerable: true,
        configurable: true
    });
    SurveyQuestionEditorProperty.prototype.hasError = function () {
        return this.editor.hasError();
    };
    SurveyQuestionEditorProperty.prototype.apply = function () {
        if (this.editor.apply()) {
            this.obj[this.property.name] = this.editor.koValue();
            return true;
        }
        return false;
    };
    SurveyQuestionEditorProperty.prototype.reset = function () {
        this.editor.koValue(this.property.getPropertyValue(this.obj));
    };
    SurveyQuestionEditorProperty.prototype.beforeShow = function () {
        this.editor.beforeShow();
    };
    return SurveyQuestionEditorProperty;
}());

var SurveyQuestionEditorRow = /** @class */ (function () {
    function SurveyQuestionEditorRow(obj) {
        this.obj = obj;
        this.properties = [];
    }
    SurveyQuestionEditorRow.prototype.addProperty = function (property, displayName, options, isTabProperty) {
        this.properties.push(new SurveyQuestionEditorProperty(this.obj, property, displayName, options, isTabProperty));
    };
    SurveyQuestionEditorRow.prototype.hasError = function () {
        var isError = false;
        for (var i = 0; i < this.properties.length; i++) {
            isError = this.properties[i].hasError() || isError;
        }
        return isError;
    };
    return SurveyQuestionEditorRow;
}());

var SurveyQuestionEditorProperties = /** @class */ (function () {
    function SurveyQuestionEditorProperties(obj, properties, onCanShowPropertyCallback, options, tab) {
        if (onCanShowPropertyCallback === void 0) { onCanShowPropertyCallback = null; }
        if (options === void 0) { options = null; }
        if (tab === void 0) { tab = null; }
        this.obj = obj;
        this.options = options;
        this.tab = tab;
        this.isTabProperty = false;
        this.rows = [];
        this.isTabProperty = !!tab;
        this.onCanShowPropertyCallback = onCanShowPropertyCallback;
        this.properties = __WEBPACK_IMPORTED_MODULE_1_survey_knockout__["JsonObject"].metaData["getPropertiesByObj"]
            ? __WEBPACK_IMPORTED_MODULE_1_survey_knockout__["JsonObject"].metaData["getPropertiesByObj"](this.obj)
            : __WEBPACK_IMPORTED_MODULE_1_survey_knockout__["JsonObject"].metaData.getProperties(this.obj.getType());
        this.buildRows(properties);
    }
    SurveyQuestionEditorProperties.prototype.apply = function () {
        var res = true;
        this.performForAllProperties(function (p) { return (res = p.apply() && res); });
        return res;
    };
    SurveyQuestionEditorProperties.prototype.reset = function () {
        this.performForAllProperties(function (p) { return p.reset(); });
    };
    SurveyQuestionEditorProperties.prototype.beforeShow = function () {
        this.performForAllProperties(function (p) { return p.beforeShow(); });
    };
    SurveyQuestionEditorProperties.prototype.hasError = function () {
        var isError = false;
        for (var i = 0; i < this.rows.length; i++) {
            isError = this.rows[i].hasError() || isError;
        }
        return isError;
    };
    SurveyQuestionEditorProperties.prototype.performForAllProperties = function (func) {
        for (var i = 0; i < this.rows.length; i++) {
            for (var j = 0; j < this.rows[i].properties.length; j++) {
                var property = this.rows[i].properties[j];
                func(property);
            }
        }
    };
    SurveyQuestionEditorProperties.prototype.buildRows = function (properties) {
        for (var i = 0; i < properties.length; i++) {
            var name = this.getName(properties[i]);
            var jsonProperty = this.getProperty(name);
            if (!jsonProperty)
                continue;
            var row = this.getRowByCategory(properties[i].category);
            if (!row) {
                row = new SurveyQuestionEditorRow(this.obj);
                if (properties[i].category)
                    row.category = properties[i].category;
                this.rows.push(row);
            }
            row.addProperty(jsonProperty, properties[i].title, this.options, properties.length === 1 && this.isTabProperty);
        }
    };
    SurveyQuestionEditorProperties.prototype.getName = function (prop) {
        if (!prop)
            return null;
        if (typeof prop === "string")
            return prop;
        if (prop.name)
            return prop.name;
        return null;
    };
    SurveyQuestionEditorProperties.prototype.getRowByCategory = function (category) {
        if (!category)
            return null;
        for (var i = 0; i < this.rows.length; i++) {
            if (this.rows[i].category == category)
                return this.rows[i];
        }
        return null;
    };
    SurveyQuestionEditorProperties.prototype.getProperty = function (propertyName) {
        if (!propertyName)
            return null;
        var property = null;
        for (var i = 0; i < this.properties.length; i++) {
            if (this.properties[i].name == propertyName) {
                property = this.properties[i];
                break;
            }
        }
        if (!property)
            return null;
        if (!!this.tab &&
            property.name == this.tab.name &&
            this.tab.visible === true)
            return property;
        return __WEBPACK_IMPORTED_MODULE_3__surveyHelper__["b" /* SurveyHelper */].isPropertyVisible(this.obj, property, this.onCanShowPropertyCallback)
            ? property
            : null;
    };
    return SurveyQuestionEditorProperties;
}());



/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_knockout__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_survey_knockout__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_survey_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_survey_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editorLocalization__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QuestionToolbox; });



/**
 * The list of Toolbox items.
 */
var QuestionToolbox = /** @class */ (function () {
    function QuestionToolbox(supportedQuestions) {
        if (supportedQuestions === void 0) { supportedQuestions = null; }
        this.supportedQuestions = supportedQuestions;
        this._orderedQuestions = [
            "text",
            "checkbox",
            "radiogroup",
            "dropdown",
            "comment",
            "rating",
            "imagepicker",
            "boolean",
            "html"
        ];
        this._questionDefaultSettings = {
            imagepicker: function () {
                return {
                    choices: [
                        {
                            value: "lion",
                            imageLink: "https://surveyjs.io/Content/Images/examples/image-picker/lion.jpg"
                        },
                        {
                            value: "giraffe",
                            imageLink: "https://surveyjs.io/Content/Images/examples/image-picker/giraffe.jpg"
                        },
                        {
                            value: "panda",
                            imageLink: "https://surveyjs.io/Content/Images/examples/image-picker/panda.jpg"
                        },
                        {
                            value: "camel",
                            imageLink: "https://surveyjs.io/Content/Images/examples/image-picker/camel.jpg"
                        }
                    ]
                };
            }
        };
        /**
         * The maximum number of copied toolbox items. If an user adding copiedItemMaxCount + 1 item, the first added item will be removed.
         */
        this.copiedItemMaxCount = 3;
        this.allowExpandMultipleCategoriesValue = false;
        this.itemsValue = [];
        this.koItems = __WEBPACK_IMPORTED_MODULE_0_knockout__["observableArray"]();
        this.koCategories = __WEBPACK_IMPORTED_MODULE_0_knockout__["observableArray"]();
        this.koActiveCategory = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"]("");
        this.koHasCategories = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"](false);
        this.createDefaultItems(supportedQuestions);
        var self = this;
        this.koActiveCategory.subscribe(function (newValue) {
            for (var i = 0; i < self.koCategories().length; i++) {
                var category = self.koCategories()[i];
                category.koCollapsed(category.name !== newValue);
            }
        });
    }
    Object.defineProperty(QuestionToolbox.prototype, "orderedQuestions", {
        /**
         * Modify this array to change the toolbox items order.
         */
        get: function () {
            return this._orderedQuestions;
        },
        set: function (questions) {
            this._orderedQuestions = questions;
            this.reorderItems();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuestionToolbox.prototype, "jsonText", {
        /**
         * The Array of Toolbox items as Text JSON.
         */
        get: function () {
            return JSON.stringify(this.itemsValue);
        },
        set: function (value) {
            this.itemsValue = value ? JSON.parse(value) : [];
            this.onItemsChanged();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuestionToolbox.prototype, "copiedJsonText", {
        /**
         * The Array of copied Toolbox items as Text JSON.
         */
        get: function () {
            return JSON.stringify(this.copiedItems);
        },
        set: function (value) {
            var newItems = value ? JSON.parse(value) : [];
            this.clearCopiedItems();
            for (var i = 0; i < newItems.length; i++) {
                newItems[i].isCopied = true;
                this.addItem(newItems[i]);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuestionToolbox.prototype, "items", {
        /**
         * The Array of Toolbox items
         */
        get: function () {
            return this.itemsValue;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuestionToolbox.prototype, "copiedItems", {
        /**
         * The Array of copied Toolbox items
         */
        get: function () {
            var result = [];
            for (var i = 0; i < this.itemsValue.length; i++) {
                if (this.itemsValue[i].isCopied)
                    result.push(this.itemsValue[i]);
            }
            return result;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Add toolbox items into the Toolbox
     * @param items the list of new items
     * @param clearAll set it to true to clear all previous items.
     */
    QuestionToolbox.prototype.addItems = function (items, clearAll) {
        if (clearAll === void 0) { clearAll = false; }
        if (clearAll) {
            this.clearItems();
        }
        for (var i = 0; i < items.length; i++) {
            this.itemsValue.push(items[i]);
        }
        this.onItemsChanged();
    };
    /**
     * Add a copied Question into Toolbox
     * @param question a copied Survey.Question
     * @param options a json object that allows you to override question properties. Attributes are: name, title, isCopied, iconName, json and category.
     */
    QuestionToolbox.prototype.addCopiedItem = function (question, options) {
        if (options === void 0) { options = null; }
        if (!options)
            options = {};
        var name = !!options.name ? options.name : question.name;
        var title = !!options.title ? options.title : name;
        var item = {
            name: name,
            title: title,
            isCopied: options.isCopied !== false,
            iconName: !!options.iconName ? options.iconName : "icon-default",
            json: !!options.json ? options.json : this.getQuestionJSON(question),
            category: !!options.category ? options.category : ""
        };
        if (this.replaceItem(item))
            return;
        var copied = this.copiedItems;
        if (this.copiedItemMaxCount > 0 && copied.length == this.copiedItemMaxCount)
            this.removeItem(copied[this.copiedItemMaxCount - 1].name);
        this.addItem(item);
    };
    /**
     * Add a toolbox item
     * @param item the toolbox item description
     * @see IQuestionToolboxItem
     */
    QuestionToolbox.prototype.addItem = function (item) {
        this.itemsValue.push(item);
        this.onItemsChanged();
    };
    /**
     * Add a new toolbox item, add delete the old item with the same name
     * @param item the toolbox item description
     * @see IQuestionToolboxItem
     */
    QuestionToolbox.prototype.replaceItem = function (item) {
        var index = this.indexOf(item.name);
        if (index < 0)
            return;
        this.itemsValue[index] = item;
        this.onItemsChanged();
        return true;
    };
    /**
     * Remove a toolbox item by it's name
     * @param name toolbox item name
     * @see IQuestionToolboxItem
     */
    QuestionToolbox.prototype.removeItem = function (name) {
        var index = this.indexOf(name);
        if (index < 0)
            return false;
        this.itemsValue.splice(index, 1);
        this.onItemsChanged();
        return true;
    };
    /**
     * Remove all toolbox items.
     */
    QuestionToolbox.prototype.clearItems = function () {
        this.itemsValue = [];
        this.onItemsChanged();
    };
    /**
     * Remove all copied toolbox items.
     */
    QuestionToolbox.prototype.clearCopiedItems = function () {
        var removedItems = this.copiedItems;
        for (var i = 0; i < removedItems.length; i++) {
            this.removeItem(removedItems[i].name);
        }
    };
    /**
     * Returns toolbox item by its name. Returns null if there is no toolbox item with this name
     * @param name
     */
    QuestionToolbox.prototype.getItemByName = function (name) {
        var index = this.indexOf(name);
        return index > -1 ? this.itemsValue[index] : null;
    };
    Object.defineProperty(QuestionToolbox.prototype, "allowExpandMultipleCategories", {
        /**
         * Set it to true, to allow end-user to expand more than one category. There will no active category in this case
         * @see activeCategory
         */
        get: function () {
            return this.allowExpandMultipleCategoriesValue;
        },
        set: function (val) {
            this.allowExpandMultipleCategoriesValue = val;
            if (val) {
                this.activeCategory = "";
            }
            else {
                if (this.koCategories().length > 0) {
                    this.activeCategory = this.koCategories()[0].name;
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Change the category of the toolbox item
     * @param name the toolbox item name
     * @param category new category name
     */
    QuestionToolbox.prototype.changeCategory = function (name, category) {
        this.changeCategories([{ name: name, category: category }]);
    };
    /**
     * Change categories for several toolbox items.
     * @param changedItems the array of objects {name: "your toolbox item name", category: "new category name"}
     */
    QuestionToolbox.prototype.changeCategories = function (changedItems) {
        for (var i = 0; i < changedItems.length; i++) {
            var item = changedItems[i];
            var toolboxItem = this.getItemByName(item.name);
            if (toolboxItem) {
                toolboxItem.category = item.category;
            }
        }
        this.onItemsChanged();
    };
    Object.defineProperty(QuestionToolbox.prototype, "activeCategory", {
        /**
         * Set and get and active category. This property doesn't work if allowExpandMultipleCategories is true. Its default value is empty.
         * @see allowExpandMultipleCategories
         * @see expandCategory
         * @see collapseCategory
         */
        get: function () {
            return this.koActiveCategory();
        },
        set: function (val) {
            this.koActiveCategory(val);
        },
        enumerable: true,
        configurable: true
    });
    QuestionToolbox.prototype.doCategoryClick = function (categoryName) {
        if (this.allowExpandMultipleCategories) {
            var category = this.getCategoryByName(categoryName);
            if (category) {
                category.koCollapsed(!category.koCollapsed());
            }
        }
        else {
            this.activeCategory = categoryName;
        }
    };
    /**
     * Expand a category by its name. If allowExpandMultipleCategories is false (default value), all other categories become collapsed
     * @param categoryName the category name
     * @see allowExpandMultipleCategories
     * @see collapseCategory
     */
    QuestionToolbox.prototype.expandCategory = function (categoryName) {
        if (this.allowExpandMultipleCategories) {
            var category = this.getCategoryByName(categoryName);
            if (category) {
                category.koCollapsed(false);
            }
        }
        else {
            this.activeCategory = categoryName;
        }
    };
    /**
     * Collapse a category by its name. If allowExpandMultipleCategories is false (default value) this function does nothing
     * @param categoryName the category name
     * @see allowExpandMultipleCategories
     */
    QuestionToolbox.prototype.collapseCategory = function (categoryName) {
        if (!this.allowExpandMultipleCategories)
            return;
        var category = this.getCategoryByName(categoryName);
        if (category) {
            category.koCollapsed(true);
        }
    };
    /**
     * Expand all categories. If allowExpandMultipleCategories is false (default value) this function does nothing
     * @see allowExpandMultipleCategories
     */
    QuestionToolbox.prototype.expandAllCategories = function () {
        this.expandCollapseAllCategories(false);
    };
    /**
     * Collapse all categories. If allowExpandMultipleCategories is false (default value) this function does nothing
     * @see allowExpandMultipleCategories
     */
    QuestionToolbox.prototype.collapseAllCategories = function () {
        this.expandCollapseAllCategories(true);
    };
    QuestionToolbox.prototype.expandCollapseAllCategories = function (isCollapsed) {
        var categories = this.koCategories();
        for (var i = 0; i < categories.length; i++) {
            categories[i].koCollapsed(isCollapsed);
        }
    };
    QuestionToolbox.prototype.getCategoryByName = function (categoryName) {
        var categories = this.koCategories();
        for (var i = 0; i < categories.length; i++) {
            var category = categories[i];
            if (category.name === categoryName)
                return category;
        }
        return null;
    };
    QuestionToolbox.prototype.onItemsChanged = function () {
        this.koItems([]);
        this.koItems(this.itemsValue);
        var categories = [];
        var categoriesHash = {};
        var prevActiveCategory = this.koActiveCategory();
        var self = this;
        for (var i = 0; i < this.itemsValue.length; i++) {
            var item = this.itemsValue[i];
            var categoryName = item.category
                ? item.category
                : __WEBPACK_IMPORTED_MODULE_2__editorLocalization__["a" /* editorLocalization */].getString("ed.toolboxGeneralCategory"); //TODO
            if (!categoriesHash[categoryName]) {
                var category = {
                    name: categoryName,
                    items: [],
                    koCollapsed: __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"](categoryName !== prevActiveCategory),
                    expand: function () {
                        self.doCategoryClick(this.name);
                    }
                };
                categoriesHash[categoryName] = category;
                categories.push(category);
            }
            categoriesHash[categoryName].items.push(item);
        }
        this.koCategories(categories);
        if (!this.allowExpandMultipleCategories) {
            if (prevActiveCategory && categoriesHash[prevActiveCategory]) {
                this.koActiveCategory(prevActiveCategory);
            }
            else {
                this.koActiveCategory(categories.length > 0 ? categories[0].name : "");
            }
        }
        else {
            if (categories.length > 0) {
                categories[0].koCollapsed(false);
            }
        }
        this.koHasCategories(categories.length > 1);
    };
    QuestionToolbox.prototype.indexOf = function (name) {
        for (var i = 0; i < this.itemsValue.length; i++) {
            if (this.itemsValue[i].name == name)
                return i;
        }
        return -1;
    };
    QuestionToolbox.prototype.reorderItems = function () {
        var _this = this;
        this.itemsValue.sort(function (i1, i2) {
            var index1 = _this._orderedQuestions.indexOf(i1.name);
            if (index1 === -1)
                index1 = Number.MAX_VALUE;
            var index2 = _this._orderedQuestions.indexOf(i2.name);
            if (index2 === -1)
                index2 = Number.MAX_VALUE;
            return index1 - index2;
        });
        this.onItemsChanged();
    };
    QuestionToolbox.prototype.createDefaultItems = function (supportedQuestions) {
        this.clearItems();
        var questions = this.getQuestionTypes(supportedQuestions);
        for (var i = 0; i < questions.length; i++) {
            var name = questions[i];
            var question = __WEBPACK_IMPORTED_MODULE_1_survey_knockout__["ElementFactory"].Instance.createElement(name, "q1");
            if (!question) {
                question = __WEBPACK_IMPORTED_MODULE_1_survey_knockout__["JsonObject"].metaData.createClass(name);
            }
            var json = this.getQuestionJSON(question);
            var item = {
                name: name,
                iconName: "icon-" + name,
                title: __WEBPACK_IMPORTED_MODULE_2__editorLocalization__["a" /* editorLocalization */].getString("qt." + name),
                json: json,
                isCopied: false,
                category: ""
            };
            this.itemsValue.push(item);
        }
        this.registerCustomWidgets();
        this.onItemsChanged();
    };
    QuestionToolbox.prototype.registerCustomWidgets = function () {
        var inst = __WEBPACK_IMPORTED_MODULE_1_survey_knockout__["CustomWidgetCollection"].Instance;
        if (!inst.getActivatedBy)
            return;
        var widgets = inst.widgets;
        for (var i = 0; i < widgets.length; i++) {
            if (inst.getActivatedBy(widgets[i].name) != "customtype")
                continue;
            var widgetJson = widgets[i].widgetJson;
            if (!widgetJson.widgetIsLoaded || !widgetJson.widgetIsLoaded())
                continue;
            var iconName = widgetJson.iconName ? widgetJson.iconName : "icon-default";
            var title = __WEBPACK_IMPORTED_MODULE_2__editorLocalization__["a" /* editorLocalization */].getString("qt." + widgetJson.name);
            if (!title || title == widgetJson.name)
                title = widgetJson.title;
            if (!title)
                title = widgetJson.name;
            var json = widgetJson.defaultJSON ? widgetJson.defaultJSON : {};
            if (!json.type) {
                json.type = widgetJson.name;
            }
            var item = {
                name: widgetJson.name,
                iconName: iconName,
                title: title,
                json: json,
                isCopied: false,
                category: ""
            };
            this.itemsValue.push(item);
        }
    };
    QuestionToolbox.prototype.getQuestionJSON = function (question) {
        var json = new __WEBPACK_IMPORTED_MODULE_1_survey_knockout__["JsonObject"]().toJsonObject(question);
        json.type = question.getType();
        if (!!this._questionDefaultSettings[json.type]) {
            var defaultSettings = this._questionDefaultSettings[json.type]();
            for (var key in defaultSettings) {
                json[key] = defaultSettings[key];
            }
        }
        return json;
    };
    QuestionToolbox.prototype.getQuestionTypes = function (supportedQuestions) {
        var allTypes = __WEBPACK_IMPORTED_MODULE_1_survey_knockout__["ElementFactory"].Instance.getAllTypes();
        if (!supportedQuestions || supportedQuestions.length == 0)
            supportedQuestions = allTypes;
        var questions = [];
        for (var i = 0; i < this.orderedQuestions.length; i++) {
            var name = this.orderedQuestions[i];
            if (supportedQuestions.indexOf(name) > -1 && allTypes.indexOf(name) > -1)
                questions.push(name);
        }
        for (var i = 0; i < supportedQuestions.length; i++) {
            var name = supportedQuestions[i];
            if (questions.indexOf(supportedQuestions[i]) < 0 &&
                allTypes.indexOf(name) > -1)
                questions.push(name);
        }
        return questions;
    };
    return QuestionToolbox;
}());



/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_survey_knockout__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_survey_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_survey_knockout__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QuestionConverter; });

var QuestionConverter = /** @class */ (function () {
    function QuestionConverter() {
    }
    QuestionConverter.addConvertInfo = function (className, convertToClassName) {
        if (!QuestionConverter.convertInfo[className]) {
            QuestionConverter.convertInfo[className] = [];
        }
        QuestionConverter.convertInfo[className].push(convertToClassName);
    };
    QuestionConverter.getConvertToClasses = function (className) {
        var res = QuestionConverter.convertInfo[className];
        return res ? res : [];
    };
    QuestionConverter.convertObject = function (obj, convertToClass) {
        if (!obj || !obj.parent || convertToClass == obj.getType())
            return null;
        var newQuestion = __WEBPACK_IMPORTED_MODULE_0_survey_knockout__["QuestionFactory"].Instance.createQuestion(convertToClass, obj.name);
        var jsonObj = new __WEBPACK_IMPORTED_MODULE_0_survey_knockout__["JsonObject"]();
        var json = jsonObj.toJsonObject(obj);
        jsonObj.toObject(json, newQuestion);
        var panel = obj.parent;
        var index = panel.elements.indexOf(obj);
        panel.removeElement(obj);
        panel.addElement(newQuestion, index);
        return newQuestion;
    };
    QuestionConverter.convertInfo = {};
    return QuestionConverter;
}());

function createDefaultQuestionConverterItems() {
    var classes = __WEBPACK_IMPORTED_MODULE_0_survey_knockout__["JsonObject"].metaData.getChildrenClasses("selectbase", true);
    for (var i = 0; i < classes.length; i++) {
        for (var j = 0; j < classes.length; j++) {
            if (i == j)
                continue;
            QuestionConverter.addConvertInfo(classes[i].name, classes[j].name);
        }
    }
    QuestionConverter.addConvertInfo("text", "comment");
    QuestionConverter.addConvertInfo("comment", "text");
}
createDefaultQuestionConverterItems();


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_knockout__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_survey_knockout__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_survey_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_survey_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__json5__ = __webpack_require__(21);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SurveyEmbedingWindow; });



var SurveyEmbedingWindow = /** @class */ (function () {
    function SurveyEmbedingWindow() {
        this.surveyId = null;
        this.surveyPostId = null;
        this.generateValidJSON = false;
        this.surveyJSVersion = __WEBPACK_IMPORTED_MODULE_1_survey_knockout__["Version"];
        this.surveyCDNPath = "https://surveyjs.azureedge.net/";
        this.platformSurveyJSPrefix = {
            angular: "angular",
            jquery: "jquery",
            knockout: "ko",
            react: "react",
            vue: "vue"
        };
        this.platformJSonPage = {
            angular: "@Component({\n  selector: 'ng-app',\n        template: \n        <div id='surveyElement'></div>\",\n})\nexport class AppComponent {\n    ngOnInit() {\n        var survey = new Survey.Model(surveyJSON);\n        survey.onComplete.add(sendDataToServer);\n       Survey.SurveyNG.render(\"surveyElement\", { model: survey });\n    }\n}",
            jquery: 'var survey = new Survey.Model(surveyJSON);\n$("#surveyContainer").Survey({\n    model: survey,\n    onComplete: sendDataToServer\n});',
            knockout: 'var survey = new Survey.Model(surveyJSON, "surveyContainer");\nsurvey.onComplete.add(sendDataToServer);',
            react: 'ReactDOM.render(\n    <Survey.Survey json={ surveyJSON } onComplete={ sendDataToServer } />, document.getElementById("surveyContainer"));',
            vue: "var survey = new Survey.Model(surveyJSON);\nnew Vue({ el: '#surveyContainer', data: { survey: survey } });"
        };
        this.platformJSonWindow = {
            angular: "@Component({\n  selector: 'ng-app',\n        template: \n        <div id='surveyElement'></div>\",\n})\nexport class AppComponent {\n    ngOnInit() {\n        var survey = new Survey.Model(surveyJSON);\n        survey.onComplete.add(sendDataToServer);\n       Survey.SurveyWindowNG.render(\"surveyElement\", { model: survey });\n    }\n}",
            jquery: 'var survey = new Survey.Model(surveyJSON);\n$("#surveyContainer").SurveyWindow({\n    model: survey,\n    onComplete: sendDataToServer\n});',
            knockout: "var survey = new Survey.Model(surveyJSON);\nsurveyWindow.show();\nsurvey.onComplete.add(sendDataToServer);",
            react: 'ReactDOM.render(\n    <Survey.SurveyWindow json={ surveyJSON } onComplete={ sendDataToServer } />, document.getElementById("surveyContainer"));',
            vue: ""
        };
        this.platformHtmlonPage = {
            angular: "<ng-app></ng-app>",
            jquery: '<div id="surveyContainer"></div>',
            knockout: '<div id="surveyContainer"></div>',
            react: '<div id="surveyContainer"></div>',
            vue: '<div id="surveyContainer"><survey :survey="survey"></survey></div>'
        };
        this.platformHtmlonWindow = {
            angular: "<ng-app></ng-app>",
            jquery: '<div id="surveyContainer"></div>',
            knockout: "",
            react: '<div id="surveyContainer"></div>',
            vue: "<div id='surveyContainer'><survey-window :survey='survey'></survey-window></div>"
        };
        var self = this;
        this.koLibraryVersion = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"]("jquery");
        this.koShowAsWindow = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"]("page");
        this.koScriptUsing = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"]("bootstrap");
        this.koHasIds = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"](false);
        this.koLoadSurvey = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"](false);
        this.koHeadText = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"]("");
        this.koJavaText = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"]("");
        this.koBodyText = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"]("");
        this.koVisibleHtml = __WEBPACK_IMPORTED_MODULE_0_knockout__["computed"](function () {
            return (self.koShowAsWindow() == "page" ||
                self.platformHtmlonWindow[self.koLibraryVersion()] != "");
        });
        this.koLibraryVersion.subscribe(function (newValue) {
            self.setHeadText();
            self.setJavaTest();
            self.setBodyText();
        });
        this.koShowAsWindow.subscribe(function (newValue) {
            self.setJavaTest();
            self.setBodyText();
        });
        this.koScriptUsing.subscribe(function (newValue) {
            self.setHeadText();
            self.setJavaTest();
        });
        this.koLoadSurvey.subscribe(function (newValue) {
            self.setJavaTest();
        });
        this.surveyEmbedingHead = null;
    }
    Object.defineProperty(SurveyEmbedingWindow.prototype, "json", {
        get: function () {
            return this.jsonValue;
        },
        set: function (value) {
            this.jsonValue = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyEmbedingWindow.prototype, "hasAceEditor", {
        get: function () {
            return typeof ace !== "undefined";
        },
        enumerable: true,
        configurable: true
    });
    SurveyEmbedingWindow.prototype.show = function () {
        if (this.hasAceEditor && this.surveyEmbedingHead == null) {
            this.surveyEmbedingHead = this.createEditor("surveyEmbedingHead");
            this.surveyEmbedingBody = this.createEditor("surveyEmbedingBody");
            this.surveyEmbedingJava = this.createEditor("surveyEmbedingJava");
        }
        this.koHasIds(this.surveyId && this.surveyPostId);
        this.setBodyText();
        this.setHeadText();
        this.setJavaTest();
    };
    SurveyEmbedingWindow.prototype.setBodyText = function () {
        this.setTextToEditor(this.surveyEmbedingBody, this.koBodyText, this.platformHtmlonPage[this.koLibraryVersion()]);
    };
    Object.defineProperty(SurveyEmbedingWindow.prototype, "getCDNPath", {
        get: function () {
            return this.surveyCDNPath + this.surveyJSVersion + "/";
        },
        enumerable: true,
        configurable: true
    });
    SurveyEmbedingWindow.prototype.setHeadText = function () {
        var str = "<!-- Your platform (" + this.koLibraryVersion() + ") scripts. -->\n";
        if (this.koScriptUsing() != "bootstrap") {
            str +=
                '\n<link href="' +
                    this.getCDNPath +
                    'survey.css" type="text/css" rel="stylesheet" />';
        }
        str +=
            '\n<script src="' +
                this.getCDNPath +
                "survey." +
                this.platformSurveyJSPrefix[this.koLibraryVersion()] +
                '.min.js"></script>';
        this.setTextToEditor(this.surveyEmbedingHead, this.koHeadText, str);
    };
    SurveyEmbedingWindow.prototype.setJavaTest = function () {
        this.setTextToEditor(this.surveyEmbedingJava, this.koJavaText, this.getJavaText());
    };
    SurveyEmbedingWindow.prototype.createEditor = function (elementName) {
        var editor = ace.edit(elementName);
        editor.setTheme("ace/theme/monokai");
        editor.session.setMode("ace/mode/json");
        editor.setShowPrintMargin(false);
        editor.renderer.setShowGutter(false);
        editor.setReadOnly(true);
        return editor;
    };
    SurveyEmbedingWindow.prototype.getJavaText = function () {
        var isOnPage = this.koShowAsWindow() == "page";
        var str = this.getSaveFunc() + "\n\n";
        str += isOnPage
            ? this.platformJSonPage[this.koLibraryVersion()]
            : this.platformJSonWindow[this.koLibraryVersion()];
        var jsonText = "var surveyJSON = " + this.getJsonText() + "\n\n";
        return this.getSetCss() + "\n" + jsonText + str;
    };
    SurveyEmbedingWindow.prototype.getSetCss = function () {
        if (this.koScriptUsing() != "bootstrap")
            return "";
        return "Survey.Survey.cssType = \"bootstrap\";\n";
    };
    SurveyEmbedingWindow.prototype.getSaveFunc = function () {
        return ("function sendDataToServer(survey) {\n" + this.getSaveFuncCode() + "\n}");
    };
    SurveyEmbedingWindow.prototype.getSaveFuncCode = function () {
        if (this.koHasIds())
            return "    survey.sendResult('" + this.surveyPostId + "');";
        return "    //send Ajax request to your web server.\n    alert(\"The results are:\" + JSON.stringify(survey.data));";
    };
    SurveyEmbedingWindow.prototype.getJsonText = function () {
        if (this.koHasIds() && this.koLoadSurvey()) {
            return "{ surveyId: '" + this.surveyId + "'}";
        }
        if (this.generateValidJSON)
            return JSON.stringify(this.json);
        return new __WEBPACK_IMPORTED_MODULE_2__json5__["a" /* SurveyJSON5 */]().stringify(this.json);
    };
    SurveyEmbedingWindow.prototype.setTextToEditor = function (editor, koText, text) {
        if (editor)
            editor.setValue(text);
        if (koText)
            koText(text);
    };
    return SurveyEmbedingWindow;
}());



/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_knockout__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__surveyHelper__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editorLocalization__ = __webpack_require__(0);
/* unused harmony export SurveyObjectItem */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SurveyObjects; });



var SurveyObjectItem = /** @class */ (function () {
    function SurveyObjectItem() {
        this.level = 0;
    }
    return SurveyObjectItem;
}());

var SurveyObjects = /** @class */ (function () {
    function SurveyObjects(koObjects, koSelected, showObjectTitles) {
        if (showObjectTitles === void 0) { showObjectTitles = false; }
        this.koObjects = koObjects;
        this.koSelected = koSelected;
        this.showObjectTitles = showObjectTitles;
    }
    Object.defineProperty(SurveyObjects.prototype, "survey", {
        get: function () {
            return this.surveyValue;
        },
        set: function (value) {
            if (this.survey == value)
                return;
            this.surveyValue = value;
            this.rebuild();
        },
        enumerable: true,
        configurable: true
    });
    SurveyObjects.prototype.addPage = function (page) {
        this.addElement(page, null);
    };
    SurveyObjects.prototype.addElement = function (element, parent) {
        var parentIndex = parent != null ? this.getItemIndex(parent) : 0;
        if (parentIndex < 0)
            return;
        var elements = parent != null ? this.getElements(parent) : this.survey.pages;
        var elementIndex = elements.indexOf(element);
        var newIndex = elementIndex + 1 + parentIndex;
        if (elementIndex > 0) {
            var prevElement = elements[elementIndex - 1];
            newIndex =
                this.getItemIndex(prevElement) +
                    this.getAllElementCount(prevElement) +
                    1;
        }
        var item = this.createItem(element, this.koObjects()[parentIndex]);
        this.addItem(item, newIndex);
        var objs = [];
        this.buildElements(objs, this.getElements(element), item);
        for (var i = 0; i < objs.length; i++) {
            this.koObjects.splice(newIndex + 1 + i, 0, objs[i]);
        }
        this.koSelected(item);
    };
    SurveyObjects.prototype.selectObject = function (obj) {
        var objs = this.koObjects();
        for (var i = 0; i < objs.length; i++) {
            if (objs[i].value == obj) {
                this.koSelected(objs[i]);
                return;
            }
        }
    };
    SurveyObjects.prototype.getSelectedObjectPage = function (obj) {
        if (obj === void 0) { obj = null; }
        if (!this.survey)
            return null;
        if (!obj) {
            if (!this.koSelected())
                return;
            obj = this.koSelected().value;
        }
        var objs = this.koObjects();
        var index = this.getItemIndex(obj);
        while (index > 0) {
            var item = objs[index];
            if (item.level == 1)
                return item.value;
            index--;
        }
        return null;
    };
    SurveyObjects.prototype.removeObject = function (obj) {
        var index = this.getItemIndex(obj);
        if (index < 0)
            return;
        var countToRemove = 1 + this.getAllElementCount(obj);
        this.koObjects.splice(index, countToRemove);
    };
    SurveyObjects.prototype.nameChanged = function (obj) {
        var index = this.getItemIndex(obj);
        if (index < 0)
            return;
        this.koObjects()[index].text(this.getText(this.koObjects()[index]));
    };
    SurveyObjects.prototype.selectNextQuestion = function (isUp) {
        var question = this.getSelectedQuestion();
        var itemIndex = this.getItemIndex(question);
        if (itemIndex < 0)
            return question;
        var objs = this.koObjects();
        var newItemIndex = itemIndex + (isUp ? -1 : 1);
        if (newItemIndex < objs.length &&
            __WEBPACK_IMPORTED_MODULE_1__surveyHelper__["b" /* SurveyHelper */].getObjectType(objs[newItemIndex].value) == __WEBPACK_IMPORTED_MODULE_1__surveyHelper__["a" /* ObjType */].Question) {
            itemIndex = newItemIndex;
        }
        else {
            newItemIndex = itemIndex;
            while (newItemIndex < objs.length &&
                __WEBPACK_IMPORTED_MODULE_1__surveyHelper__["b" /* SurveyHelper */].getObjectType(objs[newItemIndex].value) == __WEBPACK_IMPORTED_MODULE_1__surveyHelper__["a" /* ObjType */].Question) {
                itemIndex = newItemIndex;
                newItemIndex += isUp ? 1 : -1;
            }
        }
        this.koSelected(objs[itemIndex]);
    };
    SurveyObjects.prototype.getAllElementCount = function (element) {
        var elements = this.getElements(element);
        var res = 0;
        for (var i = 0; i < elements.length; i++) {
            res += 1 + this.getAllElementCount(elements[i]);
        }
        return res;
    };
    SurveyObjects.prototype.getSelectedQuestion = function () {
        if (!this.koSelected())
            return null;
        var obj = this.koSelected().value;
        if (!obj)
            return null;
        return __WEBPACK_IMPORTED_MODULE_1__surveyHelper__["b" /* SurveyHelper */].getObjectType(obj) == __WEBPACK_IMPORTED_MODULE_1__surveyHelper__["a" /* ObjType */].Question
            ? obj
            : null;
    };
    SurveyObjects.prototype.addItem = function (item, index) {
        if (index > this.koObjects().length) {
            this.koObjects.push(item);
        }
        else {
            this.koObjects.splice(index, 0, item);
        }
    };
    SurveyObjects.prototype.rebuild = function () {
        var objs = [];
        if (this.survey == null) {
            this.koObjects(objs);
            this.selectObject(null);
            return;
        }
        var root = this.createItem(this.survey, null);
        objs.push(root);
        for (var i = 0; i < this.survey.pages.length; i++) {
            var page = this.survey.pages[i];
            var pageItem = this.createItem(page, root);
            objs.push(pageItem);
            this.buildElements(objs, this.getElements(page), pageItem);
        }
        this.koObjects(objs);
        this.selectObject(this.survey);
    };
    SurveyObjects.prototype.getElements = function (element) {
        return __WEBPACK_IMPORTED_MODULE_1__surveyHelper__["b" /* SurveyHelper */].getElements(element);
    };
    SurveyObjects.prototype.buildElements = function (objs, elements, parentItem) {
        for (var i = 0; i < elements.length; i++) {
            var el = elements[i];
            var item = this.createItem(el, parentItem);
            objs.push(item);
            this.buildElements(objs, this.getElements(el), item);
        }
    };
    SurveyObjects.prototype.createItem = function (value, parent) {
        var item = new SurveyObjectItem();
        item.value = value;
        item.level = parent != null ? parent.level + 1 : 0;
        item.text = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"](this.getText(item));
        return item;
    };
    SurveyObjects.prototype.getItemIndex = function (value) {
        if (!value)
            return -1;
        if (value["selectedElementInDesign"])
            value = value["selectedElementInDesign"];
        var objs = this.koObjects();
        for (var i = 0; i < objs.length; i++) {
            if (objs[i].value == value)
                return i;
        }
        return -1;
    };
    SurveyObjects.prototype.getText = function (item) {
        if (item.level == 0)
            return __WEBPACK_IMPORTED_MODULE_2__editorLocalization__["a" /* editorLocalization */].getString("ed.survey");
        var intend = SurveyObjects.intend;
        for (var i = 1; i < item.level; i++) {
            intend += SurveyObjects.intend;
        }
        var text = __WEBPACK_IMPORTED_MODULE_1__surveyHelper__["b" /* SurveyHelper */].getObjectName(item.value, this.showObjectTitles);
        if (this.getItemTextCallback) {
            text = this.getItemTextCallback(item.value, text);
        }
        return intend + text;
    };
    SurveyObjects.intend = ".";
    return SurveyObjects;
}());



/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_knockout__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__surveyHelper__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editorLocalization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_survey_knockout__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_survey_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_survey_knockout__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SurveyLiveTester; });




var SurveyLiveTester = /** @class */ (function () {
    function SurveyLiveTester() {
        this.koIsRunning = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"](true);
        this.koResultText = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"]("");
        this.koResultData = __WEBPACK_IMPORTED_MODULE_0_knockout__["observableArray"]();
        this.koResultViewType = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"]("table");
        this.koPages = __WEBPACK_IMPORTED_MODULE_0_knockout__["observableArray"]([]);
        this.koActivePage = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"](null);
        this.showObjectTitles = false;
        var self = this;
        this.selectTestClick = function () {
            self.testAgain();
        };
        this.selectPageClick = function (pageItem) {
            if (self.survey) {
                if (self.survey.state == "starting") {
                    self.survey.start();
                }
                self.survey.currentPage = pageItem.page;
            }
        };
        this.koActivePage.subscribe(function (newValue) {
            if (!!newValue) {
                self.survey.currentPage = newValue;
            }
        });
        this.setPageDisable = function (option, item) {
            __WEBPACK_IMPORTED_MODULE_0_knockout__["applyBindingsToNode"](option, { disable: item.koDisabled }, item);
        };
        this.koLanguages = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"](this.getLanguages());
        this.koActiveLanguage = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"]("");
        this.koActiveLanguage.subscribe(function (newValue) {
            if (self.survey.locale == newValue)
                return;
            self.survey.locale = newValue;
            self.koSurvey(self.survey);
        });
        this.survey = new __WEBPACK_IMPORTED_MODULE_3_survey_knockout__["Survey"]();
        this.koSurvey = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"](this.survey);
    }
    SurveyLiveTester.prototype.setJSON = function (json) {
        this.json = json;
        if (json != null) {
            if (json.cookieName) {
                delete json.cookieName;
            }
        }
        this.survey = json ? new __WEBPACK_IMPORTED_MODULE_3_survey_knockout__["Survey"](json) : new __WEBPACK_IMPORTED_MODULE_3_survey_knockout__["Survey"]();
        if (this.onSurveyCreatedCallback)
            this.onSurveyCreatedCallback(this.survey);
        var self = this;
        this.survey.onComplete.add(function (sender) {
            self.koIsRunning(false);
            self.koResultText(JSON.stringify(self.survey.data, null, 4));
            self.koResultData(self.survey.getPlainData().map(function (dataItem) {
                if (dataItem.isNode) {
                    dataItem.collapsed = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"](true);
                }
                return dataItem;
            }));
        });
        this.survey.onStarted.add(function (sender) {
            self.setActivePageItem(self.survey.currentPage, true);
        });
        this.survey.onCurrentPageChanged.add(function (sender, options) {
            self.koActivePage(options.newCurrentPage);
            self.setActivePageItem(options.oldCurrentPage, false);
            self.setActivePageItem(options.newCurrentPage, true);
        });
        this.survey.onPageVisibleChanged.add(function (sender, options) {
            self.updatePageItem(options.page);
        });
    };
    SurveyLiveTester.prototype.updatePageItem = function (page) {
        var item = this.getPageItemByPage(page);
        if (item) {
            item.koVisible(page.isVisible);
            item.koDisabled(!page.isVisible);
        }
    };
    SurveyLiveTester.prototype.show = function () {
        var pages = [];
        for (var i = 0; i < this.survey.pages.length; i++) {
            var page = this.survey.pages[i];
            pages.push({
                page: page,
                title: __WEBPACK_IMPORTED_MODULE_1__surveyHelper__["b" /* SurveyHelper */].getObjectName(page, this.showObjectTitles),
                koVisible: __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"](page.isVisible),
                koDisabled: __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"](!page.isVisible),
                koActive: __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"](this.survey.state == "running" && page === this.survey.currentPage)
            });
        }
        this.koPages(pages);
        this.koSurvey(this.survey);
        this.koActivePage(this.survey.currentPage);
        this.koActiveLanguage(this.survey.locale);
        this.koIsRunning(true);
    };
    Object.defineProperty(SurveyLiveTester.prototype, "testSurveyAgainText", {
        get: function () {
            return __WEBPACK_IMPORTED_MODULE_2__editorLocalization__["a" /* editorLocalization */].getString("ed.testSurveyAgain");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyLiveTester.prototype, "surveyResultsText", {
        get: function () {
            return __WEBPACK_IMPORTED_MODULE_2__editorLocalization__["a" /* editorLocalization */].getString("ed.surveyResults");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyLiveTester.prototype, "resultsTitle", {
        get: function () {
            return __WEBPACK_IMPORTED_MODULE_2__editorLocalization__["a" /* editorLocalization */].getString("ed.resultsTitle");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyLiveTester.prototype, "resultsName", {
        get: function () {
            return __WEBPACK_IMPORTED_MODULE_2__editorLocalization__["a" /* editorLocalization */].getString("ed.resultsName");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyLiveTester.prototype, "resultsValue", {
        get: function () {
            return __WEBPACK_IMPORTED_MODULE_2__editorLocalization__["a" /* editorLocalization */].getString("ed.resultsValue");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyLiveTester.prototype, "resultsDisplayValue", {
        get: function () {
            return __WEBPACK_IMPORTED_MODULE_2__editorLocalization__["a" /* editorLocalization */].getString("ed.resultsDisplayValue");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyLiveTester.prototype, "selectPageText", {
        get: function () {
            return __WEBPACK_IMPORTED_MODULE_2__editorLocalization__["a" /* editorLocalization */].getString("ts.selectPage");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyLiveTester.prototype, "showInvisibleElementsText", {
        get: function () {
            return __WEBPACK_IMPORTED_MODULE_2__editorLocalization__["a" /* editorLocalization */].getString("ts.showInvisibleElements");
        },
        enumerable: true,
        configurable: true
    });
    SurveyLiveTester.prototype.selectTableClick = function (model) {
        model.koResultViewType("table");
    };
    SurveyLiveTester.prototype.selectJsonClick = function (model) {
        model.koResultViewType("text");
    };
    Object.defineProperty(SurveyLiveTester.prototype, "localeText", {
        get: function () {
            return __WEBPACK_IMPORTED_MODULE_2__editorLocalization__["a" /* editorLocalization */].getString("pe.locale");
        },
        enumerable: true,
        configurable: true
    });
    SurveyLiveTester.prototype.testAgain = function () {
        this.setJSON(this.json);
        this.show();
    };
    SurveyLiveTester.prototype.setActivePageItem = function (page, val) {
        var item = this.getPageItemByPage(page);
        if (item) {
            item.koActive(val);
        }
    };
    SurveyLiveTester.prototype.getPageItemByPage = function (page) {
        var items = this.koPages();
        for (var i = 0; i < items.length; i++) {
            if (items[i].page === page)
                return items[i];
        }
        return null;
    };
    SurveyLiveTester.prototype.getLanguages = function () {
        var res = [];
        var locales = __WEBPACK_IMPORTED_MODULE_3_survey_knockout__["surveyLocalization"].getLocales();
        for (var i = 0; i < locales.length; i++) {
            var loc = locales[i];
            res.push({ value: loc, text: __WEBPACK_IMPORTED_MODULE_2__editorLocalization__["a" /* editorLocalization */].getLocaleName(loc) });
        }
        return res;
    };
    SurveyLiveTester.prototype.koEventAfterRender = function (element, survey) {
        survey.onRendered.fire(self, {});
        survey["afterRenderSurvey"](element);
    };
    return SurveyLiveTester;
}());



/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_knockout__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_survey_knockout__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_survey_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_survey_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__editorLocalization__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TranslationItemBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TranslationItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TranslationGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Translation; });




var TranslationItemBase = /** @class */ (function () {
    function TranslationItemBase(name) {
        this.name = name;
    }
    Object.defineProperty(TranslationItemBase.prototype, "isGroup", {
        get: function () {
            return false;
        },
        enumerable: true,
        configurable: true
    });
    TranslationItemBase.prototype.fillLocales = function (locales) { };
    TranslationItemBase.prototype.mergeLocaleWithDefault = function (loc) { };
    return TranslationItemBase;
}());

var TranslationItem = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](TranslationItem, _super);
    function TranslationItem(name, locString, defaultValue) {
        if (defaultValue === void 0) { defaultValue = ""; }
        var _this = _super.call(this, name) || this;
        _this.name = name;
        _this.locString = locString;
        _this.defaultValue = defaultValue;
        _this.values = {};
        return _this;
    }
    Object.defineProperty(TranslationItem.prototype, "text", {
        get: function () {
            return __WEBPACK_IMPORTED_MODULE_3__editorLocalization__["a" /* editorLocalization */].getPropertyName(this.name);
        },
        enumerable: true,
        configurable: true
    });
    TranslationItem.prototype.koValue = function (loc) {
        if (!!this.values[loc])
            return this.values[loc];
        var val = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"](this.locString.getLocaleText(loc));
        var self = this;
        val.subscribe(function (newValue) {
            self.locString.setLocaleText(loc, newValue);
        });
        this.values[loc] = val;
        return val;
    };
    TranslationItem.prototype.fillLocales = function (locales) {
        var json = this.locString.getJson();
        if (!json || typeof json === "string")
            return;
        for (var key in json) {
            if (!!key &&
                locales.indexOf(key) < 0 &&
                key !== __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["LocalizableString"].defaultLocale) {
                locales.push(key);
            }
        }
    };
    TranslationItem.prototype.mergeLocaleWithDefault = function (loc) {
        var locText = this.locString.getLocaleText(loc);
        if (!locText)
            return;
        this.locString.setLocaleText("", locText);
        this.locString.setLocaleText(loc, null);
    };
    return TranslationItem;
}(TranslationItemBase));

var TranslationGroup = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](TranslationGroup, _super);
    function TranslationGroup(name, obj, translation) {
        if (translation === void 0) { translation = null; }
        var _this = _super.call(this, name) || this;
        _this.name = name;
        _this.obj = obj;
        _this.translation = translation;
        _this.koExpanded = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"](false);
        _this.reset();
        return _this;
    }
    Object.defineProperty(TranslationGroup.prototype, "items", {
        get: function () {
            return this.itemValues;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TranslationGroup.prototype, "locItems", {
        get: function () {
            var res = [];
            for (var i = 0; i < this.items.length; i++) {
                if (!this.items[i].isGroup) {
                    res.push(this.items[i]);
                }
            }
            return res;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TranslationGroup.prototype, "groups", {
        get: function () {
            var res = [];
            for (var i = 0; i < this.items.length; i++) {
                if (this.items[i].isGroup) {
                    res.push(this.items[i]);
                }
            }
            return res;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TranslationGroup.prototype, "isGroup", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TranslationGroup.prototype, "koLocales", {
        get: function () {
            return !!this.translation ? this.translation.koLocales : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TranslationGroup.prototype, "localeCount", {
        get: function () {
            if (!this.koLocales())
                return 0;
            var locales = this.koLocales();
            var res = 0;
            for (var i = 0; i < locales.length; i++) {
                if (locales[i].koVisible())
                    res++;
            }
            return res;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TranslationGroup.prototype, "locWidth", {
        get: function () {
            var count = this.localeCount;
            if (count < 2)
                return "100%";
            return Math.floor(100 / count).toString() + "%";
        },
        enumerable: true,
        configurable: true
    });
    TranslationGroup.prototype.getLocaleName = function (loc) {
        return this.translation
            ? this.translation.getLocaleName(loc)
            : __WEBPACK_IMPORTED_MODULE_3__editorLocalization__["a" /* editorLocalization */].getLocaleName(loc);
    };
    TranslationGroup.prototype.reset = function () {
        this.itemValues = [];
        this.fillItems();
    };
    TranslationGroup.prototype.fillLocales = function (locales) {
        for (var i = 0; i < this.items.length; i++) {
            this.items[i].fillLocales(locales);
        }
    };
    Object.defineProperty(TranslationGroup.prototype, "showAllStrings", {
        get: function () {
            return !!this.translation ? this.translation.showAllStrings : true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TranslationGroup.prototype, "hasItems", {
        get: function () {
            if (this.locItems.length > 0)
                return true;
            var groups = this.groups;
            for (var i = 0; i < groups.length; i++) {
                if (groups[i].hasItems)
                    return true;
            }
            return false;
        },
        enumerable: true,
        configurable: true
    });
    TranslationGroup.prototype.mergeLocaleWithDefault = function (loc) {
        for (var i = 0; i < this.itemValues.length; i++) {
            this.itemValues[i].mergeLocaleWithDefault(loc);
        }
    };
    TranslationGroup.prototype.fillItems = function () {
        if (this.isItemValueArray(this.obj)) {
            this.createItemValues();
            return;
        }
        if (!this.obj || !this.obj.getType)
            return;
        var properties = __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["JsonObject"].metaData.getPropertiesByObj(this.obj);
        for (var i = 0; i < properties.length; i++) {
            var property = properties[i];
            if (!property.isSerializable && !property.isLocalizable)
                continue;
            if (property.isLocalizable) {
                if (!property.readOnly && property.visible) {
                    var defaultValue = this.getDefaultValue(property);
                    var locStr = (this.obj[property.serializationProperty]);
                    if (!locStr)
                        continue;
                    if (!this.showAllStrings && !defaultValue && locStr.isEmpty)
                        continue;
                    this.itemValues.push(new TranslationItem(property.name, locStr, defaultValue));
                }
            }
            else {
                var value = this.obj[property.name];
                if (!!value && Array.isArray(value) && value.length > 0) {
                    //If ItemValue array?
                    if (this.isItemValueArray(value)) {
                        var group = new TranslationGroup(property.name, value, this.translation);
                        if (group.hasItems) {
                            this.itemValues.push(group);
                        }
                    }
                    else {
                        this.createGroups(value, property);
                    }
                }
            }
        }
        this.itemValues.sort(function (a, b) {
            if (!a.name)
                return -1;
            if (!b.name)
                return 1;
            return a.name.localeCompare(b.name);
        });
    };
    TranslationGroup.prototype.getDefaultValue = function (property) {
        if (property.name == "title" &&
            property.isLocalizable &&
            !!property.serializationProperty) {
            var locStr = (this.obj[property.serializationProperty]);
            if (!!locStr &&
                this.obj.getType() != "page" &&
                (!!locStr.onGetTextCallback || locStr.onRenderedHtmlCallback))
                return this.obj["name"];
        }
        return "";
    };
    TranslationGroup.prototype.isItemValueArray = function (val) {
        return (!!val &&
            Array.isArray(val) &&
            val.length > 0 &&
            !!val[0] &&
            !!val[0]["getType"] &&
            !!val[0]["setData"] &&
            !!val[0]["setLocText"]);
    };
    TranslationGroup.prototype.createGroups = function (value, property) {
        for (var i = 0; i < value.length; i++) {
            var obj = value[i];
            if (!!obj && obj.getType) {
                var name = obj["name"];
                if (!name) {
                    name = property.name + "[" + i.toString() + "]";
                }
                var group = new TranslationGroup(name, obj, this.translation);
                if (group.hasItems) {
                    this.itemValues.push(group);
                }
            }
        }
    };
    TranslationGroup.prototype.createItemValues = function () {
        for (var i = 0; i < this.obj.length; i++) {
            var val = this.obj[i];
            var canAdd = this.showAllStrings || !val.locText.isEmpty || isNaN(val.value);
            if (canAdd) {
                this.itemValues.push(new TranslationItem(val.value, val.locText, val.value));
            }
        }
    };
    return TranslationGroup;
}(TranslationItemBase));

var Translation = /** @class */ (function () {
    function Translation(survey, showAllStrings) {
        if (showAllStrings === void 0) { showAllStrings = false; }
        this.koLocales = __WEBPACK_IMPORTED_MODULE_1_knockout__["observableArray"]([
            { locale: "", koVisible: __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"](true) }
        ]);
        this.koRoot = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"](null);
        this.koShowAllStrings = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"](showAllStrings);
        this.koIsEmpty = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"](true);
        this.koAvailableLanguages = __WEBPACK_IMPORTED_MODULE_1_knockout__["observableArray"]();
        this.koSelectedLanguageToAdd = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"](null);
        this.koFilteredPage = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"]();
        this.koCanMergeLocaleWithDefault = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"](false);
        this.koMergeLocaleWithDefaultText = __WEBPACK_IMPORTED_MODULE_1_knockout__["computed"](function () {
            if (!this.koCanMergeLocaleWithDefault())
                return "";
            var locText = this.getLocaleName(this.defaultLocale);
            return __WEBPACK_IMPORTED_MODULE_3__editorLocalization__["a" /* editorLocalization */]
                .getString("ed.translationMergeLocaleWithDefault")["format"](locText);
        }, this);
        this.koFilteredPages = __WEBPACK_IMPORTED_MODULE_1_knockout__["observableArray"]([
            {
                value: null,
                text: this.showAllPagesText
            }
        ]);
        var self = this;
        this.koSelectedLanguageToAdd.subscribe(function (newValue) {
            if (!!newValue) {
                self.addLocale(newValue.value);
            }
        });
        this.koShowAllStrings.subscribe(function (newValue) {
            self.reset();
        });
        this.koFilteredPage.subscribe(function (newValue) {
            self.reset();
        });
        this.koExportToSCVFile = function () {
            self.exportToSCVFile("survey_translation.csv");
        };
        this.koImportFromSCVFile = function (el) {
            if (el.files.length < 1)
                return;
            self.importFromSCVFile(el.files[0]);
            el.value = "";
        };
        this.koMergeLocaleWithDefault = function () {
            self.mergeLocaleWithDefault();
        };
        this.survey = survey;
    }
    Object.defineProperty(Translation.prototype, "survey", {
        get: function () {
            return this.surveyValue;
        },
        set: function (val) {
            this.surveyValue = val;
            this.updateFilteredPages();
            this.reset();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Translation.prototype, "root", {
        get: function () {
            return this.rootValue;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Translation.prototype, "filteredPage", {
        get: function () {
            return this.koFilteredPage();
        },
        set: function (val) {
            this.koFilteredPage(val);
        },
        enumerable: true,
        configurable: true
    });
    Translation.prototype.reset = function () {
        var rootObj = !!this.filteredPage ? this.filteredPage : this.survey;
        var rootName = !!this.filteredPage ? rootObj["name"] : "survey";
        this.rootValue = new TranslationGroup(rootName, rootObj, this);
        this.root.reset();
        this.resetLocales();
        this.koIsEmpty(!this.root.hasItems);
        this.koRoot(this.root);
    };
    Object.defineProperty(Translation.prototype, "locales", {
        get: function () {
            var res = [];
            var locales = this.koLocales();
            for (var i = 0; i < locales.length; i++) {
                res.push(locales[i].locale);
            }
            return res;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Translation.prototype, "defaultLocale", {
        get: function () {
            return !!this.survey.locale
                ? this.survey.locale
                : __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["surveyLocalization"].defaultLocale;
        },
        enumerable: true,
        configurable: true
    });
    Translation.prototype.getLocaleName = function (loc) {
        return __WEBPACK_IMPORTED_MODULE_3__editorLocalization__["a" /* editorLocalization */].getLocaleName(loc, this.defaultLocale);
    };
    Translation.prototype.hasLocale = function (locale) {
        var locales = this.koLocales();
        for (var i = 0; i < locales.length; i++) {
            if (locales[i].locale == locale)
                return true;
        }
        return false;
    };
    Translation.prototype.addLocale = function (locale) {
        if (!this.hasLocale(locale)) {
            var locs = this.locales;
            locs.push(locale);
            this.setLocales(locs);
        }
    };
    Translation.prototype.resetLocales = function () {
        var locales = [""];
        this.root.fillLocales(locales);
        this.setLocales(locales);
    };
    Object.defineProperty(Translation.prototype, "selectLanguageOptionsCaption", {
        get: function () {
            return __WEBPACK_IMPORTED_MODULE_3__editorLocalization__["a" /* editorLocalization */].getString("ed.translationAddLanguage");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Translation.prototype, "showAllStrings", {
        get: function () {
            return this.koShowAllStrings();
        },
        set: function (val) {
            this.koShowAllStrings(val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Translation.prototype, "showAllStringsText", {
        get: function () {
            return __WEBPACK_IMPORTED_MODULE_3__editorLocalization__["a" /* editorLocalization */].getString("ed.translationShowAllStrings");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Translation.prototype, "showAllPagesText", {
        get: function () {
            return __WEBPACK_IMPORTED_MODULE_3__editorLocalization__["a" /* editorLocalization */].getString("ed.translationShowAllPages");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Translation.prototype, "noStringsText", {
        get: function () {
            return __WEBPACK_IMPORTED_MODULE_3__editorLocalization__["a" /* editorLocalization */].getString("ed.translationNoStrings");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Translation.prototype, "exportToCSVText", {
        get: function () {
            return __WEBPACK_IMPORTED_MODULE_3__editorLocalization__["a" /* editorLocalization */].getString("ed.translationExportToSCVButton");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Translation.prototype, "importFromCSVText", {
        get: function () {
            return __WEBPACK_IMPORTED_MODULE_3__editorLocalization__["a" /* editorLocalization */].getString("ed.translationImportFromSCVButton");
        },
        enumerable: true,
        configurable: true
    });
    Translation.prototype.exportToCSV = function () {
        var res = [];
        var title = "";
        var visLocales = this.getVisibleLocales();
        for (var i = 0; i < visLocales.length; i++) {
            title +=
                Translation.csvDelimiter +
                    (!!visLocales[i] ? visLocales[i] : "default");
        }
        res.push(title);
        var itemsHash = {};
        this.fillItemsHash("", this.root, itemsHash);
        for (var key in itemsHash) {
            var line = key;
            var item = itemsHash[key];
            for (var i = 0; i < visLocales.length; i++) {
                var val = item.locString.getLocaleText(visLocales[i]);
                if (!val && i == 0) {
                    val = item.defaultValue;
                }
                line += Translation.csvDelimiter + val;
            }
            res.push(line);
        }
        return res.join("\n");
    };
    Translation.prototype.importFromCSV = function (str) {
        if (!str)
            return;
        var lines = str.split("\n");
        if (lines.length < 2)
            return;
        var locales = this.readLocales(lines[0]);
        var translation = new Translation(this.survey, true);
        var itemsHash = [];
        this.fillItemsHash("", translation.root, itemsHash);
        for (var i = 1; i < lines.length; i++) {
            if (!lines[i])
                continue;
            var vals = lines[i].split(Translation.csvDelimiter);
            var name = vals[0].trim();
            if (!name)
                continue;
            var item = itemsHash[name];
            if (!item)
                continue;
            this.updateItemWithStrings(item, vals, locales);
        }
        this.reset();
        if (this.importFinishedCallback)
            this.importFinishedCallback();
    };
    Translation.prototype.exportToSCVFile = function (fileName) {
        var data = this.exportToCSV();
        var blob = new Blob([data], { type: "text/csv" });
        if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveBlob(blob, fileName);
        }
        else {
            var elem = window.document.createElement("a");
            elem.href = window.URL.createObjectURL(blob);
            elem.download = fileName;
            document.body.appendChild(elem);
            elem.click();
            document.body.removeChild(elem);
        }
    };
    Translation.prototype.importFromSCVFile = function (file) {
        var fileReader = new FileReader();
        var self = this;
        fileReader.onload = function (e) {
            self.importFromCSV(fileReader.result);
        };
        fileReader.readAsText(file);
    };
    Translation.prototype.mergeLocaleWithDefault = function () {
        if (!this.hasLocale(this.defaultLocale))
            return;
        this.root.mergeLocaleWithDefault(this.defaultLocale);
        this.koLocales([{ locale: "", koVisible: __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"](true) }]);
        this.reset();
    };
    Translation.prototype.updateItemWithStrings = function (item, values, locales) {
        for (var i = 0; i < values.length - 1 && i < locales.length; i++) {
            var val = values[i + 1].trim();
            if (!val)
                continue;
            item.koValue(locales[i])(val);
        }
    };
    Translation.prototype.getVisibleLocales = function () {
        var res = [];
        var locales = this.koLocales();
        for (var i = 0; i < locales.length; i++) {
            if (locales[i].koVisible()) {
                res.push(locales[i].locale);
            }
        }
        return res;
    };
    Translation.prototype.readLocales = function (str) {
        var res = [];
        if (!str)
            return res;
        var locs = str.split(Translation.csvDelimiter);
        for (var i = 1; i < locs.length; i++) {
            var loc = locs[i].trim();
            if (loc == "default")
                loc = "";
            res.push(loc);
        }
        return res;
    };
    Translation.prototype.fillItemsHash = function (parentName, group, itemsHash) {
        var name = parentName;
        if (!!name)
            name += ".";
        name += group.name;
        var items = group.locItems;
        for (var i = 0; i < items.length; i++) {
            itemsHash[name + "." + items[i].name] = items[i];
        }
        var groups = group.groups;
        for (var i = 0; i < groups.length; i++) {
            this.fillItemsHash(name, groups[i], itemsHash);
        }
    };
    Translation.prototype.setLocales = function (locs) {
        var locales = this.koLocales();
        for (var i = 0; i < locs.length; i++) {
            var loc = locs[i];
            if (this.hasLocale(loc))
                continue;
            locales.push({ locale: loc, koVisible: __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"](true) });
        }
        this.koLocales(locales);
        this.koCanMergeLocaleWithDefault(this.hasLocale(this.defaultLocale));
        this.updateAvailableTranlations();
    };
    Translation.prototype.updateAvailableTranlations = function () {
        var res = [];
        var locales = __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["surveyLocalization"].getLocales();
        for (var i = 0; i < locales.length; i++) {
            var loc = locales[i];
            if (!loc)
                continue;
            if (this.hasLocale(loc))
                continue;
            if (loc == this.defaultLocale)
                continue;
            res.push({ value: loc, text: __WEBPACK_IMPORTED_MODULE_3__editorLocalization__["a" /* editorLocalization */].getLocaleName(loc) });
        }
        this.koSelectedLanguageToAdd(null);
        this.koAvailableLanguages(res);
        !!this.availableTranlationsChangedCallback &&
            this.availableTranlationsChangedCallback();
    };
    Translation.prototype.updateFilteredPages = function () {
        var res = [{ value: null, text: this.showAllPagesText }];
        for (var i = 0; i < this.survey.pages.length; i++) {
            var page = this.survey.pages[i];
            res.push({ value: page, text: page.name });
        }
        this.koFilteredPages(res);
    };
    Translation.csvDelimiter = "|";
    return Translation;
}());



/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_knockout__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_survey_knockout__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_survey_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_survey_knockout__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SurveyUndoRedo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UndoRedoItem; });


var SurveyUndoRedo = /** @class */ (function () {
    function SurveyUndoRedo() {
        this.index = -1;
        this.maximumCount = 10;
        this.items = [];
        this.koCanUndo = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"](false);
        this.koCanRedo = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"](false);
    }
    SurveyUndoRedo.prototype.clear = function () {
        this.items = [];
        this.koCanUndo(false);
        this.koCanRedo(false);
    };
    SurveyUndoRedo.prototype.setCurrent = function (survey, selectedObjName) {
        var item = new UndoRedoItem();
        item.surveyJSON = new __WEBPACK_IMPORTED_MODULE_1_survey_knockout__["JsonObject"]().toJsonObject(survey);
        item.selectedObjName = selectedObjName;
        if (this.index < this.items.length - 1) {
            this.items.splice(this.index + 1);
        }
        this.items.push(item);
        this.removeOldData();
        this.index = this.items.length - 1;
        this.updateCanUndoRedo();
    };
    SurveyUndoRedo.prototype.undo = function () {
        if (!this.canUndo)
            return null;
        return this.doUndoRedo(-1);
    };
    SurveyUndoRedo.prototype.redo = function () {
        if (!this.canRedo)
            return null;
        return this.doUndoRedo(1);
    };
    SurveyUndoRedo.prototype.updateCanUndoRedo = function () {
        this.koCanUndo(this.canUndo);
        this.koCanRedo(this.canRedo);
    };
    SurveyUndoRedo.prototype.doUndoRedo = function (dIndex) {
        this.index += dIndex;
        this.updateCanUndoRedo();
        return this.index >= 0 && this.index < this.items.length
            ? this.items[this.index]
            : null;
    };
    Object.defineProperty(SurveyUndoRedo.prototype, "canUndo", {
        get: function () {
            return this.index >= 1 && this.index < this.items.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyUndoRedo.prototype, "canRedo", {
        get: function () {
            return this.items.length > 1 && this.index < this.items.length - 1;
        },
        enumerable: true,
        configurable: true
    });
    SurveyUndoRedo.prototype.removeOldData = function () {
        if (this.items.length - 1 < this.maximumCount)
            return;
        this.items.splice(0, this.items.length - this.maximumCount - 1);
    };
    return SurveyUndoRedo;
}());

var UndoRedoItem = /** @class */ (function () {
    function UndoRedoItem() {
    }
    return UndoRedoItem;
}());



/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var is = function (obj, type) { return Object.prototype.toString.call(obj).toLowerCase() === ("[object " + type + "]"); };

var addClass = function (el, cls) {
    var arr = el.className
    .split(/\s+/)
    .filter(function (c) { return !!c && c == cls; });

    if (!arr.length) {
        el.className += " " + cls;
    }
};

var removeClass = function (el, cls) {
    el.className = el.className
    .split(/\s+/)
    .filter(function (c) { return !!c && c != cls; })
    .join(' ');
};

var RModal = function RModal(el, opts) {
    var this$1 = this;

    this.opened = false;

    this.opts = {
        bodyClass: 'modal-open'
        , dialogClass: 'modal-dialog'
        , dialogOpenClass: 'bounceInDown'
        , dialogCloseClass: 'bounceOutUp'

        , focus: true
        , focusElements: [
            'a[href]', 'area[href]', 'input:not([disabled]):not([type=hidden])'
            , 'button:not([disabled])', 'select:not([disabled])'
            , 'textarea:not([disabled])', 'iframe', 'object', 'embed'
            , '*[tabindex]', '*[contenteditable]'
        ]

        , escapeClose: true
        , content: null
        , closeTimeout: 500
    };

    Object.keys(opts || {})
    .forEach(function (key) {
        /* istanbul ignore else */
        if (opts[key] !== undefined) {
            this$1.opts[key] = opts[key];
        }
    });

    this.overlay = el;
    this.dialog = el.querySelector(("." + (this.opts.dialogClass)));

    if (this.opts.content) {
        this.content(this.opts.content);
    }
};

RModal.prototype.open = function open (content) {
        var this$1 = this;

    this.content(content);

    if (!is(this.opts.beforeOpen, 'function')) {
        return this._doOpen();
    }

    this.opts.beforeOpen(function () {
        this$1._doOpen();
    });
};

RModal.prototype._doOpen = function _doOpen () {
    addClass(document.body, this.opts.bodyClass);

    removeClass(this.dialog, this.opts.dialogCloseClass);
    addClass(this.dialog, this.opts.dialogOpenClass);

    this.overlay.style.display = 'block';

    if (this.opts.focus) {
        this.focusOutElement = document.activeElement;
        this.focus();
    }

    if (is(this.opts.afterOpen, 'function')) {
        this.opts.afterOpen();
    }
    this.opened = true;
};

RModal.prototype.close = function close () {
        var this$1 = this;

    if (!is(this.opts.beforeClose, 'function')) {
        return this._doClose();
    }

    this.opts.beforeClose(function () {
        this$1._doClose();
    });
};

RModal.prototype._doClose = function _doClose () {
        var this$1 = this;

    removeClass(this.dialog, this.opts.dialogOpenClass);
    addClass(this.dialog, this.opts.dialogCloseClass);

    removeClass(document.body, this.opts.bodyClass);

    if (this.opts.focus) {
        this.focus(this.focusOutElement);
    }

    if (is(this.opts.afterClose, 'function')) {
        this.opts.afterClose();
    }

    this.opened = false;
    setTimeout(function () {
        this$1.overlay.style.display = 'none';
    }, this.opts.closeTimeout);
};

RModal.prototype.content = function content (html) {
    if (html === undefined) {
        return this.dialog.innerHTML;
    }

    this.dialog.innerHTML = html;
};

RModal.prototype.elements = function elements (selector, fallback) {
    fallback = fallback || window.navigator.appVersion.indexOf('MSIE 9.0') > -1;
    selector = is(selector, 'array') ? selector.join(',') : selector;

    return [].filter.call(
        this.dialog.querySelectorAll(selector)
        , function (element) {
            if (fallback) {
                var style = window.getComputedStyle(element);
                return style.display !== 'none' && style.visibility !== 'hidden';
            }

            return element.offsetParent !== null;
        }
    );
};

RModal.prototype.focus = function focus (el) {
    el = el || this.elements(this.opts.focusElements)[0] || this.dialog.firstChild;

    if (el && is(el.focus, 'function')) {
        el.focus();
    }
};

RModal.prototype.keydown = function keydown (ev) {
    if (this.opts.escapeClose && ev.which == 27) {
        this.close();
    }

    function stopEvent() {
        ev.preventDefault();
        ev.stopPropagation();
    }

    if (this.opened && ev.which == 9 && this.dialog.contains(ev.target)) {
        var elements = this.elements(this.opts.focusElements)
            , first = elements[0]
            , last = elements[elements.length - 1];

        if (first == last) {
            stopEvent();
        }
        else if (ev.target == first && ev.shiftKey) {
            stopEvent();
            last.focus();
        }
        else if (ev.target == last && !ev.shiftKey) {
            stopEvent();
            first.focus();
        }
    }
};

RModal.prototype.version = '1.0.31';
RModal.version = '1.0.31';

/* harmony default export */ __webpack_exports__["a"] = RModal;
//# sourceMappingURL=index.es.js.map


/***/ }),
/* 37 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 38 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 39 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 40 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_knockout__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__surveyjsObjects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flowpanel_actions_scss__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flowpanel_actions_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__flowpanel_actions_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__question_actions__ = __webpack_require__(22);
/* unused harmony export FlowPanelActionsAdorner */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return flowpanelActionsAdorner; });




var templateHtml = __webpack_require__(124);

//import { Survey } from 'survey-knockout';
var FlowPanelActionsAdorner = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](FlowPanelActionsAdorner, _super);
    function FlowPanelActionsAdorner(question, editor, adornerElement) {
        var _this = _super.call(this, question, editor) || this;
        _this.adornerElement = adornerElement;
        var self = _this;
        var surveyForDesgner = editor.survey;
        var fPanel = self.adornerElement.parentElement.parentElement.getElementsByTagName("f-panel")[0];
        var createWrappingFunction = function (tag) { return function () {
            var selection = document.getSelection();
            if (!!selection && selection.rangeCount > 0) {
                var selectedText = selection.toString();
                if (!!selectedText) {
                    question.content = question.content.replace(selectedText, "<" + tag + ">" + selectedText + "</" + tag + ">");
                    // var range = selection.getRangeAt(0);
                    // range.deleteContents();
                    // range.insertNode(
                    //   document.createTextNode(
                    //     "<" + tag + ">" + selectedText + "</" + tag + ">"
                    //   )
                    // );
                }
            }
        }; };
        _this.actions.splice(0, 0, {
            name: "bold",
            text: _this.localize("ed.bold") || "B",
            onClick: createWrappingFunction("b")
        });
        _this.actions.splice(1, 0, {
            name: "italic",
            text: _this.localize("ed.italic") || "I",
            onClick: createWrappingFunction("i")
        });
        _this.actions.splice(2, 0, {
            name: "underline",
            text: _this.localize("ed.underline") || "U",
            onClick: createWrappingFunction("u")
        });
        _this.actions.splice(3, 0, {
            name: "fpAddQuestion",
            text: _this.localize("ed.fpAddQuestion"),
            title: _this.localize("ed.fpAddQuestion"),
            hasTitle: true,
            template: "fp-add-question",
            availableTypes: ["text", "boolean", "radiogroup", "checkbox"],
            onAddQuestion: (function (data, event) {
                var questionType = event.target.value;
                if (!!questionType) {
                    var newElelentName = editor.getNewName(questionType);
                    question.addNewQuestion(questionType, newElelentName);
                    // question.content += "{" + newElelentName + "}";
                    // var selection = document.getSelection();
                    // if (!!selection) {
                    //   var range = new Range();
                    //   selection.addRange(range);
                    //   range.insertNode(
                    //     document.createTextNode("{" + newElelentName + "}")
                    //   );
                    // }
                    event.target.value = "";
                }
            })
        });
        _this.actions.splice(4, 0, { template: "action-separator" });
        return _this;
    }
    return FlowPanelActionsAdorner;
}(__WEBPACK_IMPORTED_MODULE_4__question_actions__["b" /* QuestionActionsAdorner */]));

__WEBPACK_IMPORTED_MODULE_1_knockout__["components"].register("flowpanel-actions", {
    viewModel: {
        createViewModel: function (params, componentInfo) {
            return new FlowPanelActionsAdorner(params.question, params.editor, (componentInfo.element));
        }
    },
    template: templateHtml
});
var flowpanelActionsAdorner = {
    getMarkerClass: function (model) {
        return model.getType() === "flowpanel" ? "panel_actions" : "";
    },
    getElementName: function (model) { return "container"; },
    afterRender: function (elements, model, editor) {
        var decoration = document.createElement("div");
        decoration.className = "svda-question-actions";
        decoration.innerHTML =
            "<flowpanel-actions params='question: model, editor: editor'></question-flowpanel>";
        elements[0].appendChild(decoration);
        __WEBPACK_IMPORTED_MODULE_1_knockout__["applyBindings"]({ model: model, editor: editor }, decoration);
        __WEBPACK_IMPORTED_MODULE_1_knockout__["tasks"].runEarly();
        editor.onAdornerRenderedCallback(model, "flowpanel-actions", decoration);
    }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__surveyjsObjects__["b" /* registerAdorner */])("flowpanel-actions", flowpanelActionsAdorner);


/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_knockout__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_survey_knockout__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_survey_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_survey_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__surveyjsObjects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__editorLocalization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sortablejs__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sortablejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sortablejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__item_editor__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_utils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__image_items_scss__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__image_items_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__image_items_scss__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return imageItemsAdorner; });








var templateHtml = __webpack_require__(125);
var ImageItemInplaceEditor = /** @class */ (function () {
    function ImageItemInplaceEditor(name, question, item, rootElement, editor, itemsRoot) {
        var _this = this;
        this.name = name;
        this.question = question;
        this.item = item;
        this.rootElement = rootElement;
        this.editor = editor;
        this.itemsRoot = itemsRoot;
        this.imageChoosen = function (event) {
            var input = _this.itemsRoot.getElementsByClassName("svda-choose-file")[0];
            if (!window["FileReader"])
                return;
            if (!input || !input.files || input.files.length < 1)
                return;
            var files = [];
            for (var i = 0; i < input.files.length; i++) {
                files.push(input.files[i]);
            }
            _this.valueChanged && _this.valueChanged(files);
        };
    }
    ImageItemInplaceEditor.prototype.deleteItem = function (model, event) {
        if (model.question.choices.length > 1) {
            var index = model.question.choices.indexOf(model.item);
            model.question.choices.splice(index, 1);
            this.editor.onQuestionEditorChanged(this.question);
        }
    };
    Object.defineProperty(ImageItemInplaceEditor.prototype, "isLastItem", {
        get: function () {
            return this.question.choices.length === 1;
        },
        enumerable: true,
        configurable: true
    });
    ImageItemInplaceEditor.prototype.chooseImage = function (model, event) {
        var fileInput = this.itemsRoot.getElementsByClassName("svda-choose-file")[0];
        fileInput.value = "";
        fileInput.onchange = this.imageChoosen;
        fileInput.click();
    };
    ImageItemInplaceEditor.prototype.getLocString = function (str) {
        return __WEBPACK_IMPORTED_MODULE_3__editorLocalization__["a" /* editorLocalization */].getString(str);
    };
    return ImageItemInplaceEditor;
}());
__WEBPACK_IMPORTED_MODULE_0_knockout__["components"].register("image-item-editor", {
    viewModel: {
        createViewModel: function (params, componentInfo) {
            var model = new ImageItemInplaceEditor(params.target[params.name], params.question, params.item, componentInfo.element, params.editor, params.itemsRoot);
            var property = __WEBPACK_IMPORTED_MODULE_1_survey_knockout__["JsonObject"].metaData.findProperty("imageitemvalue", //params.target.getType(),
            params.name);
            model.valueChanged = function (files) {
                if (!files[0])
                    return;
                params.editor.uploadFiles(files, function (_, link) {
                    var options = {
                        propertyName: property.name,
                        obj: params.model,
                        value: link,
                        newValue: null,
                        doValidation: false
                    };
                    params.editor.onValueChangingCallback(options);
                    link = options.newValue === null ? options.value : options.newValue;
                    params.target[params.name] = link;
                    params.editor.onPropertyValueChanged(property, params.target, link);
                });
            };
            return model;
        }
    },
    template: templateHtml
});
var imageItemsAdorner = {
    getMarkerClass: function (model) {
        return typeof model.getType === "function" &&
            model.getType() === "imagepicker"
            ? "image_item_editable"
            : "";
    },
    getElementName: function (model) { return "item"; },
    afterRender: function (elements, model, editor) {
        var itemsRoot = elements[0].parentElement;
        for (var i = 0; i < elements.length; i++) {
            elements[i].onclick = function (e) { return e.preventDefault(); };
            var decoration = document.createElement("span");
            decoration.className = "svda-adorner-root";
            decoration.innerHTML =
                "<image-item-editor params='name: \"imageLink\", target: target, item: item, question: question, editor: editor, itemsRoot: itemsRoot'></image-item-editor>";
            elements[i].appendChild(decoration);
            __WEBPACK_IMPORTED_MODULE_0_knockout__["applyBindings"]({
                item: model.choices[i],
                question: model,
                target: model.choices[i],
                editor: editor,
                itemsRoot: itemsRoot
            }, decoration);
            __WEBPACK_IMPORTED_MODULE_0_knockout__["tasks"].runEarly();
            editor.onAdornerRenderedCallback(model, "image-items", decoration, model.choices[i]);
        }
        var sortable = __WEBPACK_IMPORTED_MODULE_4_sortablejs___default.a.create(itemsRoot, {
            handle: ".svda-drag-handle",
            draggable: ".image_item_editable",
            animation: 150,
            onEnd: function (evt) {
                var choices = model.choices;
                var choice = choices[evt.oldIndex];
                choices.splice(evt.oldIndex, 1);
                choices.splice(evt.newIndex, 0, choice);
                editor.onQuestionEditorChanged(model);
            }
        });
        var addItemElement = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__item_editor__["b" /* createAddItemElement */])(function () {
            var fileInput = (itemsRoot.getElementsByClassName("svda-choose-file")[0]);
            fileInput.value = "";
            fileInput.onchange = function (event) {
                if (!fileInput || !fileInput.files || fileInput.files.length < 1)
                    return;
                var files = [];
                for (var i_1 = 0; i_1 < fileInput.files.length; i_1++) {
                    files.push(fileInput.files[i_1]);
                }
                var itemText = __WEBPACK_IMPORTED_MODULE_1_survey_knockout__["surveyLocalization"].getString("choices_Item");
                var nextValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_utils__["a" /* getNextValue */])(itemText, (model.choices || []).map(function (c) { return c.value; }));
                var itemValue = new __WEBPACK_IMPORTED_MODULE_1_survey_knockout__["ItemValue"](nextValue, undefined, "imageitemvalue");
                itemValue.locOwner = {
                    getLocale: function () {
                        if (!!model["getLocale"])
                            return model.getLocale();
                        return "";
                    },
                    getMarkdownHtml: function (text) {
                        return text;
                    },
                    getProcessedText: function (text) {
                        return text;
                    }
                };
                model.choices = model.choices.concat([itemValue]);
                itemValue = model.choices[model.choices.length - 1];
                editor.onQuestionEditorChanged(model);
                editor.onItemValueAddedCallback("choices", itemValue);
                var property = __WEBPACK_IMPORTED_MODULE_1_survey_knockout__["JsonObject"].metaData.findProperty("imageitemvalue", "imageLink");
                editor.uploadFiles(files, function (_, link) {
                    var options = {
                        propertyName: property.name,
                        obj: itemValue,
                        value: link,
                        newValue: null,
                        doValidation: false
                    };
                    editor.onValueChangingCallback(options);
                    link = options.newValue === null ? options.value : options.newValue;
                    itemValue["imageLink"] = link;
                    editor.onPropertyValueChanged(property, itemValue, link);
                });
            };
            fileInput.click();
        });
        addItemElement.style.width = (model["imageWidth"] || 200) + 10 + "px";
        addItemElement.style.height = (model["imageHeight"] || 150) + 10 + "px";
        addItemElement.style.lineHeight = addItemElement.style.height;
        itemsRoot.appendChild(addItemElement);
        var input = document.createElement("input");
        input.type = "file";
        input.accept = "image/*";
        input.className = "svda-choose-file";
        input.style.position = "absolute";
        input.style.opacity = "0";
        itemsRoot.appendChild(input);
    }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__surveyjsObjects__["b" /* registerAdorner */])("image-items", imageItemsAdorner);


/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_knockout__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__surveyjsObjects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__label_editor_scss__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__label_editor_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__label_editor_scss__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return labelAdorner; });



var labelAdorner = {
    getMarkerClass: function (model) {
        if (model.getType() === "boolean") {
            return "label_editable";
        }
        return "";
    },
    getElementName: function (model) { return "label"; },
    afterRender: function (elements, model, editor) {
        var decoration = document.createElement("span");
        decoration.innerHTML =
            "<title-editor params='name: \"title\", model: model, editor: editor'></title-editor>";
        elements[0].onclick = function (e) { return e.preventDefault(); };
        elements[0].appendChild(decoration);
        __WEBPACK_IMPORTED_MODULE_0_knockout__["applyBindings"]({ model: model, editor: editor }, decoration);
        __WEBPACK_IMPORTED_MODULE_0_knockout__["tasks"].runEarly();
        editor.onAdornerRenderedCallback(model, "label", decoration);
    }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__surveyjsObjects__["b" /* registerAdorner */])("label", labelAdorner);


/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_knockout__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_survey_knockout__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_survey_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_survey_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__surveyjsObjects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__editorLocalization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__title_editor__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_utils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rating_item_editor_scss__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rating_item_editor_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__rating_item_editor_scss__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ratingItemAdorner; });








var templateHtml = __webpack_require__(128);
var RatingItemEditor = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](RatingItemEditor, _super);
    function RatingItemEditor(name, question, item, rootElement, editor) {
        var _this = _super.call(this, name, rootElement) || this;
        _this.question = question;
        _this.item = item;
        _this.editor = editor;
        return _this;
    }
    RatingItemEditor.prototype.deleteItem = function (model, event) {
        var question = model.question;
        var index = question.visibleRateValues
            .map(function (item) { return item.value; })
            .indexOf(model.item.value);
        if (question.rateValues.length === 0 &&
            index === question.visibleRateValues.length - 1) {
            question.rateMax -= question.rateStep;
        }
        else {
            if (question.rateValues.length === 0) {
                question.rateValues = question.visibleRateValues;
            }
            question.rateValues.splice(index, 1);
        }
        model.editor.onQuestionEditorChanged(question);
    };
    Object.defineProperty(RatingItemEditor.prototype, "isLastItem", {
        get: function () {
            return this.question.visibleRateValues.length === 1;
        },
        enumerable: true,
        configurable: true
    });
    return RatingItemEditor;
}(__WEBPACK_IMPORTED_MODULE_5__title_editor__["b" /* TitleInplaceEditor */]));
__WEBPACK_IMPORTED_MODULE_1_knockout__["components"].register("rating-item-editor", {
    viewModel: {
        createViewModel: function (params, componentInfo) {
            var model = new RatingItemEditor(params.target[params.name], params.question, params.item, componentInfo.element, params.editor);
            var question = params.question;
            var property = __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["JsonObject"].metaData.findProperty(params.target.getType(), params.name);
            model.valueChanged = function (newValue) {
                if (question.rateValues.length === 0) {
                    question.rateValues = question.visibleRateValues;
                    var index = question.rateValues
                        .map(function (item) { return item.value; })
                        .indexOf(params.item.value);
                    question.rateValues[index] = params.target;
                }
                params.target[params.name] = newValue;
                params.editor.onQuestionEditorChanged(question);
            };
            return model;
        }
    },
    template: templateHtml
});
var createAddItemHandler = function (question, onItemAdded, onItemAdding) {
    if (onItemAdding === void 0) { onItemAdding = null; }
    return function () {
        if (question.rateValues.length === 0) {
            question.rateMax += question.rateStep;
        }
        else {
            var nextValue = null;
            var values = question.rateValues.map(function (item) {
                return item.itemValue;
            });
            var itemText = __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["surveyLocalization"].getString("choices_Item");
            nextValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_utils__["a" /* getNextValue */])(itemText, values);
            var itemValue = new __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["ItemValue"](nextValue);
            !!onItemAdding && onItemAdding(itemValue);
            itemValue.locOwner = {
                getLocale: function () {
                    if (!!question["getLocale"])
                        return question.getLocale();
                    return "";
                },
                getMarkdownHtml: function (text) {
                    return text;
                },
                getProcessedText: function (text) {
                    return text;
                }
            };
            question.rateValues = question.rateValues.concat([itemValue]);
        }
        !!onItemAdded && onItemAdded(itemValue);
    };
};
var ratingItemAdorner = {
    getMarkerClass: function (model) {
        return !!model.visibleRateValues ? "item_editable" : "";
    },
    getElementName: function (model) { return "itemText"; },
    afterRender: function (elements, model, editor) {
        for (var i = 0; i < elements.length; i++) {
            elements[i].onclick = function (e) { return e.preventDefault(); };
            var decoration = document.createElement("span");
            decoration.innerHTML =
                "<rating-item-editor params='name: \"text\", target: target, item: item, question: question, editor: editor'></rating-item-editor>";
            elements[i].appendChild(decoration);
            var item = model.visibleRateValues[i];
            __WEBPACK_IMPORTED_MODULE_1_knockout__["applyBindings"]({
                item: item,
                question: model,
                target: item,
                editor: editor
            }, decoration);
            __WEBPACK_IMPORTED_MODULE_1_knockout__["tasks"].runEarly();
            editor.onAdornerRenderedCallback(model, "rating-item", decoration, item);
        }
        var addNew = document.createElement("span");
        addNew.title = __WEBPACK_IMPORTED_MODULE_4__editorLocalization__["a" /* editorLocalization */].getString("pe.addItem");
        addNew.className =
            "svda-add-new-rating-item icon-inplace-add-item svd-primary-icon";
        addNew.onclick = createAddItemHandler(model, function (itemValue) {
            editor.onQuestionEditorChanged(model);
            editor.onItemValueAddedCallback("rateValues", itemValue, model.visibleRateValues);
        }, function (itemValue) {
            editor.onItemValueAddedCallback("rateValues", itemValue, model.visibleRateValues);
        });
        var svgElem = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        svgElem.setAttribute("class", "svd-svg-icon");
        svgElem.style.width = "12px";
        svgElem.style.height = "12px";
        var useElem = document.createElementNS("http://www.w3.org/2000/svg", "use");
        useElem.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", "#icon-inplaceplus");
        svgElem.appendChild(useElem);
        addNew.appendChild(svgElem);
        var parent = elements[0].parentElement.parentElement;
        parent.appendChild(addNew);
    }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__surveyjsObjects__["b" /* registerAdorner */])("rating-item", ratingItemAdorner);


/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_knockout__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sortablejs__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sortablejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sortablejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__surveyjsObjects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__editorLocalization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__item_editor__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__select_items_editor_scss__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__select_items_editor_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__select_items_editor_scss__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectItemsEditorAdorner; });






var templateHtml = __webpack_require__(129);
__WEBPACK_IMPORTED_MODULE_0_knockout__["components"].register("select-items-editor", {
    viewModel: {
        createViewModel: function (params, componentInfo) {
            var isExpanded = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"](true);
            var choices = __WEBPACK_IMPORTED_MODULE_0_knockout__["observableArray"](params.question.choices);
            var otherText = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"](params.question.otherText);
            var sortableElement = componentInfo.element.parentElement.getElementsByClassName("svda-select-items-collection")[0];
            var sortable = null;
            return {
                choices: choices,
                valueName: params.valueName,
                question: params.question,
                editor: params.editor,
                isExpanded: isExpanded,
                toggle: function () { return isExpanded(!isExpanded()); },
                addItem: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__item_editor__["c" /* createAddItemHandler */])(params.question, function (itemValue) {
                    choices(params.question.choices);
                }, function (itemValue) {
                    params.editor.onItemValueAddedCallback("choices", itemValue, params.question.choices);
                }),
                getLocString: function (str) { return __WEBPACK_IMPORTED_MODULE_3__editorLocalization__["a" /* editorLocalization */].getString(str); },
                choicesRendered: function () {
                    if (sortable) {
                        sortable.destroy();
                    }
                    sortable = __WEBPACK_IMPORTED_MODULE_1_sortablejs___default.a.create(sortableElement, {
                        handle: ".svda-drag-handle",
                        draggable: ".item_draggable",
                        animation: 150,
                        onEnd: function (evt) {
                            var newChoices = [].concat(params.question.choices);
                            var choice = newChoices[evt.oldIndex];
                            newChoices.splice(evt.oldIndex, 1);
                            newChoices.splice(evt.newIndex, 0, choice);
                            params.question.choices = newChoices;
                            choices(newChoices);
                        }
                    });
                },
                valueChanged: function (itemValue, propertyName, newValue) {
                    var newChoices = [].concat(params.question.choices);
                    choices([]);
                    choices(newChoices);
                    __WEBPACK_IMPORTED_MODULE_0_knockout__["tasks"].runEarly();
                    params.editor.onAdornerRenderedCallback(params.question, "select-choices", componentInfo.element);
                },
                otherText: otherText,
                otherValueChanged: function (itemValue, propertyName, newValue) {
                    otherText(params.question.otherText);
                }
            };
        }
    },
    template: templateHtml
});
var selectItemsEditorAdorner = {
    getMarkerClass: function (model) {
        return !!model.parent && !!model.choices ? "select_items_editor" : "";
    },
    getElementName: function (model) { return "selectWrapper"; },
    afterRender: function (elements, model, editor) {
        elements[0].onclick = function (e) { return e.preventDefault(); };
        var decoration = document.createElement("div");
        decoration.innerHTML =
            "<select-items-editor params='question: question, editor: editor, valueName: \"" +
                (__WEBPACK_IMPORTED_MODULE_4__item_editor__["a" /* itemAdorner */].inplaceEditForValues ? "value" : "text") +
                "\"'></select-items-editor>";
        elements[0].appendChild(decoration);
        __WEBPACK_IMPORTED_MODULE_0_knockout__["applyBindings"]({
            question: model,
            editor: editor
        }, decoration);
        __WEBPACK_IMPORTED_MODULE_0_knockout__["tasks"].runEarly();
        editor.onAdornerRenderedCallback(model, "select-choices", decoration);
    }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__surveyjsObjects__["b" /* registerAdorner */])("select-choices", selectItemsEditorAdorner);


/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_knockout__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__editorLocalization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectEditor__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__surveylive__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__surveyEmbedingWindow__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__surveyObjects__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__questionconverter__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__questionEditors_questionEditor__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__surveyJSONEditor__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__textWorker__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__undoredo__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__surveyHelper__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__dragdrophelper__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__questionToolbox__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__json5__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_survey_knockout__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_survey_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_survey_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__surveyjsObjects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__stylesmanager__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__adorners_item_editor__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__translation__ = __webpack_require__(34);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SurveyEditor; });















var templateEditorHtml = __webpack_require__(131);





/**
 * Survey Editor is WYSIWYG editor.
 */
var SurveyEditor = /** @class */ (function () {
    /**
     * The Survey Editor constructor.
     * @param renderedElement HtmlElement or html element id where Survey Editor will be rendered
     * @param options Survey Editor options. The following options are available: showJSONEditorTab,
     * showTestSurveyTab, showEmbededSurveyTab, showTranslationTab, inplaceEditForValues, useTabsInElementEditor, showPropertyGrid,
     * questionTypes, showOptions, generateValidJSON, isAutoSave, designerHeight, showErrorOnFailedSave, showObjectTitles, showTitlesInExpressions
     */
    function SurveyEditor(renderedElement, options) {
        if (renderedElement === void 0) { renderedElement = null; }
        if (options === void 0) { options = null; }
        var _this = this;
        this._haveCommercialLicense = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"](false);
        this.surveyValue = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"]();
        this.stateValue = "";
        this.dragDropHelper = null;
        this.showJSONEditorTabValue = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"](false);
        this.showTestSurveyTabValue = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"](false);
        this.showEmbededSurveyTabValue = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"](false);
        this.showTranslationTabValue = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"](false);
        this.select2 = null;
        this.alwaySaveTextInPropertyEditorsValue = false;
        this.showApplyButtonValue = true;
        this.isRTLValue = false;
        /**
         * If set to true (default value) the Editor scrolls to a new element. A new element can be added from Toolbox or by copying.
         */
        this.scrollToNewElement = true;
        /**
         * You need to set this property to true if you want to use tabs instead of accordion in the popup element's editor.
         * @see useTabsInElementEditor
         */
        this.useTabsInElementEditor = false;
        /**
         * You need to set this property to true if you want to show titles instead of names in pages editor and object selector.
         */
        this.showObjectTitles = false;
        /**
         * You need to set this property to true if you want to show titles instead of names in expression editor.
         */
        this.showTitlesInExpressions = false;
        /**
         * This property is assign to the survey.surveyId property on showing in the "Embed Survey" tab.
         * @see showEmbededSurveyTab
         */
        this.surveyId = null;
        /**
         * This property is assign to the survey.surveyPostId property on showing in the "Embed Survey" tab.
         * @see showEmbededSurveyTab
         */
        this.surveyPostId = null;
        /**
         * The event is called before showing a property in the Property Grid or in Question Editor.
         * <br/> sender the survey editor object that fires the event
         * <br/> options.obj the survey object, Survey, Page, Panel or Question
         * <br/> options.property the object property (Survey.JsonObjectProperty object). It has name, className, type, visible, readOnly and other properties.
         * <br/> options.canShow a boolean value. It is true by default. Set it false to hide the property from the Property Grid and in Question Editor.
         */
        this.onShowingProperty = new __WEBPACK_IMPORTED_MODULE_15_survey_knockout__["Event"]();
        /**
         * Obsolete, please use onShowingProperty event.
         * The event is called before showing a property in the Property Grid or in Question Editor.
         * <br/> sender the survey editor object that fires the event
         * <br/> options.obj the survey object, Survey, Page, Panel or Question
         * <br/> options.property the object property (Survey.JsonObjectProperty object). It has name, className, type, visible, readOnly and other properties.
         * <br/> options.canShow a boolean value. It is true by default. Set it false to hide the property from the Property Grid or in Question Editor
         * @see onShowingProperty
         */
        this.onCanShowProperty = this.onShowingProperty;
        /**
         * The event is called when editor tab has been rendered.
         * <br/> sender the survey editor object that fires the event
         * <br/> options.tabName the name of the rendered tab
         * <br/> options.elements the rendered elements
         * <br/> options.model current context model
         * <br/> options.tabData the data of the rendered tab
         */
        this.onEditorTabRendered = new __WEBPACK_IMPORTED_MODULE_15_survey_knockout__["Event"]();
        /**
         * The event is called on setting a readOnly property of the property editor. By default the property.readOnly property is used.
         * You may changed it and make the property editor read only or enabled for a particular object.
         * <br/> sender the survey editor object that fires the event
         * <br/> options.obj the survey object, Survey, Page, Panel or Question
         * <br/> options.property the object property (Survey.JsonObjectProperty object). It has name, className, type, visible, readOnly and other properties.
         * <br/> options.readOnly a boolean value. It has value equals to options.readOnly property by default. You may change it.
         */
        this.onGetPropertyReadOnly = new __WEBPACK_IMPORTED_MODULE_15_survey_knockout__["Event"]();
        /**
         * The event allows you to custom sort properties in the Property Grid. It is a compare function. You should set options.result to -1 or 1 by comparing options.property1 and options.property2.
         * <br/> sender the survey editor object that fires the event
         * <br/> options.obj the survey object, Survey, Page, Panel or Question
         * <br/> options.property1 the left object property (Survey.JsonObjectProperty object).
         * <br/> options.property2 the right object property (Survey.JsonObjectProperty object).
         * <br/> options.result the result of comparing. It can be 0 (use default behavior),  -1 options.property1 is less than options.property2 or 1 options.property1 is more than options.property2
         */
        this.onCustomSortProperty = new __WEBPACK_IMPORTED_MODULE_15_survey_knockout__["Event"]();
        /**
         * The event allows you modify DOM element for a property in the Property Grid. For example, you may change it's styles.
         * <br/> sender the survey editor object that fires the event
         * <br/> options.obj the survey object, Survey, Page, Panel or Question
         * <br/> options.htmlElement the html element (html table row in our case) that renders the property display name and it's editor.
         * <br/> options.property object property (Survey.JsonObjectProperty object).
         * <br/> options.propertyEditor the property Editor.
         */
        this.onPropertyAfterRender = new __WEBPACK_IMPORTED_MODULE_15_survey_knockout__["Event"]();
        /**
         * The event is called on deleting an element (question/panel/page) from the survey. Typically, when a user click the delete from the element menu.
         * <br/> sender the survey editor object that fires the event
         * <br/> options.element an instance of the deleting element
         * <br/> options.elementType the type of the element: 'question', 'panel' or 'page'.
         * <br/> options.allowing set it to false to cancel the element deleting
         */
        this.onElementDeleting = new __WEBPACK_IMPORTED_MODULE_15_survey_knockout__["Event"]();
        /**
         * The event is called on adding a new question into the survey. Typically, when a user dropped a Question from the Question Toolbox into designer Survey area.
         * <br/> sender the survey editor object that fires the event
         * <br/> options.question a new added survey question. Survey.Question object
         * <br/> options.page the survey Page object where question has been added.
         */
        this.onQuestionAdded = new __WEBPACK_IMPORTED_MODULE_15_survey_knockout__["Event"]();
        /**
         * The event is called when an end-user double click on an element (question/panel).
         * <br/> sender the survey editor object that fires the event
         * <br/> options.element an instance of the element
         */
        this.onElementDoubleClick = new __WEBPACK_IMPORTED_MODULE_15_survey_knockout__["Event"]();
        /**
         * The event is called on adding a new Survey.ItemValue object. It uses as an element in choices array in Radiogroup, checkbox and dropdown questions or Matrix columns and rows properties.
         * Use this event, to set ItemValue.value and ItemValue.text properties by default or set a value to the custom property.
         * <br/> sender the survey editor object that fires the event
         * <br/> options.property  the object property (Survey.JsonObjectProperty object). It has name, className, type, visible, readOnly and other properties.
         * <br/> options.newItem a new created Survey.ItemValue object.
         * <br/> options.itemValues an editing Survey.ItemValue array. newItem object is not added yet into this array.
         */
        this.onItemValueAdded = new __WEBPACK_IMPORTED_MODULE_15_survey_knockout__["Event"]();
        /**
         * The event is called when a user adds a new column into MatrixDropdown or MatrixDynamic questions. Use it to set some properties of Survey.MatrixDropdownColumn by default, for example name or a custom property.
         * <br/> sender the survey editor object that fires the event
         * <br/> options.matrix a matrix question where column is located, matrix.columns.
         * <br/> options.newColumn a new created Survey.MatrixDropdownColumn object.
         * <br/> options.columns editable columns objects. They can be different from options.matrix.columns. options.columns and options.matrix.columns are equal after user press Apply or Cancel and options.columns will be set to options.matrix.columns or reset to initial state.
         */
        this.onMatrixColumnAdded = new __WEBPACK_IMPORTED_MODULE_15_survey_knockout__["Event"]();
        /**
         * The event is called on adding a new panel into the survey.  Typically, when a user dropped a Panel from the Question Toolbox into designer Survey area.
         * <br/> sender the survey editor object that fires the event
         * <br/> options.panel a new added survey panel. Survey.Panel object
         * <br/> options.page the survey Page object where question has been added.
         */
        this.onPanelAdded = new __WEBPACK_IMPORTED_MODULE_15_survey_knockout__["Event"]();
        /**
         * The event is called on adding a new page into the survey.
         * <br/> sender the survey editor object that fires the event
         * <br/> options.page the new survey Page object.
         */
        this.onPageAdded = new __WEBPACK_IMPORTED_MODULE_15_survey_knockout__["Event"]();
        /**
         * The event is called when a survey is changed in the designer. A new page/question/page is added or existing is removed, a property is changed and so on.
         * <br/> sender the survey editor object that fires the event
         * <br/> options object contains the information about certain modifications
         * <br/> options.type contains string constant describing certain modification
         * <br/> Available values:
         * <br/>
         * <br/> options.type: "ADDED_FROM_TOOLBOX"
         * <br/> options.question: newly added question
         * <br/>
         * <br/> options.type: "PAGE_ADDED"
         * <br/> options.newValue: newly created page
         * <br/>
         * <br/> options.type: "PAGE_MOVED"
         * <br/> options.page: page has been moved
         * <br/> options.indexFrom: pevious index
         * <br/> options.indexTo: new index
         * <br/>
         * <br/> options.type: "QUESTION_CONVERTED"
         * <br/> options.className: the converted class name
         * <br/> options.oldValue: pevious object
         * <br/> options.newValue: the new object, converted from oldVale to the given class name
         * <br/>
         * <br/> options.type: "QUESTION_CHANGED_BY_EDITOR"
         * <br/> options.question: question has been edited in the popup question editor
         * <br/>
         * <br/> options.type: "PROPERTY_CHANGED"
         * <br/> options.name: the name of the property has been changed
         * <br/> options.target: the object containing the changed property
         * <br/> options.oldValue: the previous value of the changed property
         * <br/> options.newValue: the new value of the changed property
         * <br/>
         * <br/> options.type: "OBJECT_DELETED"
         * <br/> options.target: deleted object
         * <br/>
         * <br/> options.type: "VIEW_TYPE_CHANGED"
         * <br/> options.newType: new type of the editor view: editor or designer
         * <br/>
         * <br/> options.type: "DO_DROP"
         * <br/> options.page: the page of the drap/drop operation
         * <br/> options.source: the source dragged object
         * <br/> options.target: the drop target
         * <br/> options.newElement: a new element. It is defined if a user drops question or panel from the toolbox
         * <br/>
         * <br/> options.type: "TRANSLATIONS_CHANGED"
         */
        this.onModified = new __WEBPACK_IMPORTED_MODULE_15_survey_knockout__["Event"]();
        /**
         * The event is fired when the Survey Editor is initialized and a survey object (Survey.Survey) is created.
         * <br/> sender the survey editor object that fires the event
         * <br/> options.survey  the survey object showing in the editor.
         */
        this.onDesignerSurveyCreated = new __WEBPACK_IMPORTED_MODULE_15_survey_knockout__["Event"]();
        /**
         * The event is fired when the Survey Editor runs the survey in the test mode.
         * <br/> sender the survey editor object that fires the event
         * <br/> options.survey  the survey object showing in the "Test survey" tab.
         */
        this.onTestSurveyCreated = new __WEBPACK_IMPORTED_MODULE_15_survey_knockout__["Event"]();
        /**
         * Use this event to control Property Editors UI.
         * <br/> sender the survey editor object that fires the event
         * <br/> options.obj  the survey object which property is edited in the Property Editor.
         * <br/> options.propertyName  the name of the edited property.
         * <br/> options.editorOptions  options that can be changed.
         * <br/> options.editorOptions.allowAddRemoveItems a boolean property, true by default. Set it false to disable add/remove items in array properties. For example 'choices', 'columns', 'rows'.
         * <br/> options.editorOptions.showTextView a boolean property, true by default. Set it false to disable "Fast Entry" tab for "choices" property.
         * <br/> options.editorOptions.itemsEntryType a string property, 'form' by default. Set it 'fast' to show "Fast Entry" tab for "choices" property by default.
         */
        this.onSetPropertyEditorOptions = new __WEBPACK_IMPORTED_MODULE_15_survey_knockout__["Event"]();
        /**
         * Use this event to show a custom error in the Question Editor on pressing Apply or OK buttons, if the values are not set correctly. The error will be displayed under the property editor.
         * <br/> sender the survey editor object that fires the event
         * <br/> options.obj  the survey object which property is edited in the Property Editor.
         * <br/> options.propertyName  the name of the edited property.
         * <br/> options.value the property value.
         * <br/> options.error the error you want to display. Set the empty string (the default value) or null if there is no errors.
         * @see onPropertyValueChanging
         */
        this.onPropertyValidationCustomError = new __WEBPACK_IMPORTED_MODULE_15_survey_knockout__["Event"]();
        /**
         * Use this event to change the value entered in the property editor. You may call a validation, so an end user sees the error immediately
         * <br/> sender the survey editor object that fires the event
         * <br/> options.obj  the survey object which property is edited in the Property Editor.
         * <br/> options.propertyName  the name of the edited property.
         * <br/> options.value the property value.
         * <br/> options.newValue set the corrected value into this property. Leave it null if you are ok with the entered value.
         * <br/> options.doValidation set the value to true to call the property validation. If there is an error, the user sees it immediately.
         * @see onPropertyValidationCustomError
         */
        this.onPropertyValueChanging = new __WEBPACK_IMPORTED_MODULE_15_survey_knockout__["Event"]();
        /**
         * Use this event to change the value entered in the property editor. You may call a validation, so an end user sees the error immediately
         * <br/> sender the survey editor object that fires the event
         * <br/> options.obj  the survey object which property is edited in the Property Editor.
         * <br/> options.propertyName  the name of the edited property.
         * <br/> options.editor the instance of Property Editor.
         * @see onPropertyValueChanging
         */
        this.onPropertyEditorObjectAssign = new __WEBPACK_IMPORTED_MODULE_15_survey_knockout__["Event"]();
        /**
         * Use this event to modify the survey that used on setting value for condition/expression properties, like visibleIf, enableIf and so on.
         * <br/> sender the survey editor object that fires the event
         * <br/> options.obj  the survey object which property is edited in the Property Editor.
         * <br/> options.propertyName  the name of the edited property.
         * <br/> options.editor the instance of Property Editor.
         * <br/> options.valueQuestionName the name of the question that shows in the survey for choosing the value
         * <br/> options.survey the instance of the survey that allows to choose the value. You may modify it before it shows to the end-user
         */
        this.onConditionValueSurveyCreated = new __WEBPACK_IMPORTED_MODULE_15_survey_knockout__["Event"]();
        /**
         * Use this event to modify the list (name and titles) od the questions available in a condition editor.
         * <br/> sender the survey editor object that fires the event
         * <br/> options.obj  the survey object which property is edited in the Property Editor.
         * <br/> options.propertyName  the name of the edited property.
         * <br/> options.editor the instance of Property Editor.
         * <br/> options.list the the list of the questions available for condition
         */
        this.onConditionQuestionsGetList = new __WEBPACK_IMPORTED_MODULE_15_survey_knockout__["Event"]();
        /**
         * Use this event to process key down event in a property editor
         * <br/> sender the survey editor object that fires the event
         * <br/> options.obj  the survey object which property is edited in the Property Editor.
         * <br/> options.propertyName  the name of the edited property.
         * <br/> options.editor the instance of Property Editor.
         * <br/> options.event the instance of mouse event.
         */
        this.onPropertyEditorKeyDown = new __WEBPACK_IMPORTED_MODULE_15_survey_knockout__["Event"]();
        /**
         * Use this event to disable some operations for an element (question/panel).
         * <br/> sender the survey editor object that fires the event
         * <br/> options.obj  the survey object question/panel
         * <br/> options.allowDelete set it to false to disable deleting the object
         * <br/> options.allowEdit set it to false to disable calling the modal Editor
         * <br/> options.allowCopy set it to false to disable copying the object
         * <br/> options.allowAddToToolbox set it to false to disable adding element to Toolbox
         * <br/> options.allowDragging set it to false to disable adding element to Toolbox
         * <br/> options.allowChangeType set it to false to disable changing element type
         */
        this.onElementAllowOperations = new __WEBPACK_IMPORTED_MODULE_15_survey_knockout__["Event"]();
        /**
         * Use this event to add/remove/modify the element (question/panel) menu items.
         * <br/> sender the survey editor object that fires the event
         * <br/> options.obj  the survey object which property is edited in the Property Editor.
         * <br/> options.items the list of menu items. It has two requried fields: text and onClick: function(obj: Survey.Base) {} and optional name field.
         * @see onElementAllowOperations
         */
        this.onDefineElementMenuItems = new __WEBPACK_IMPORTED_MODULE_15_survey_knockout__["Event"]();
        /**
         * Use this event to show the description on the top or/and bottom of the property modal editor.
         * <br/> sender the survey editor object that fires the event
         * <br/> options.obj  the survey object which property is edited in the Property Editor.
         * <br/> options.propertyName the property name
         * <br/> options.htmlTop the html  that you want to see on the top of the modal window
         * <br/> options.htmlBottom the html that you want to see on the bottom of the modal window
         */
        this.onShowPropertyModalEditorDescription = new __WEBPACK_IMPORTED_MODULE_15_survey_knockout__["Event"]();
        /**
         * Use this event to change the text showing in the dropdown of the property grid.
         * <br/> sender the survey editor object that fires the event
         * <br/> options.obj  the survey object.
         * <br/> options.text the current object text, commonly it is a name. You must change this attribute
         */
        this.onGetObjectTextInPropertyGrid = new __WEBPACK_IMPORTED_MODULE_15_survey_knockout__["Event"]();
        this.koAutoSave = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"](false);
        /**
         * The event is called when end-user addes new element (question or panel) into the survey toolbox.
         * It calls before adding the element into toolbox and it allows to change the toolbox item attributes using options.itemOptions parameter
         * <br/> sender the survey editor object that fires the event
         * <br/> options.element is a new added element
         * <br/> options.itemOptions a json object that allows you to override question properties. Attributes are: name, title, isCopied, iconName, json and category.
         * @see onCustomElementAddedIntoToolbox
         */
        this.onCustomElementAddingIntoToolbox = new __WEBPACK_IMPORTED_MODULE_15_survey_knockout__["Event"]();
        /**
         * The event is called when end-user addes new element (question or panel) into the survey toolbox.
         * <br/> sender the survey editor object that fires the event
         * <br/> options.element is a new added element
         * @see onCustomElementAddingIntoToolbox
         */
        this.onCustomElementAddedIntoToolbox = new __WEBPACK_IMPORTED_MODULE_15_survey_knockout__["Event"]();
        /**
         * The event is fired on uploading the file. There are two properties in options: options.name options.callback.
         * <br/> sender the survey editor object that fires the event
         * <br/>  name: name, file: file, accept: accept
         * <br/> file the Javascript File object
         * <br/> callback called on upload complete
         * @see uploadFile
         */
        this.onUploadFile = new __WEBPACK_IMPORTED_MODULE_15_survey_knockout__["Event"]();
        /**
         * The method is called when the translation from csv file is imported.
         * @see translation
         * @see showTranslationTab
         */
        this.onTranslationImported = new __WEBPACK_IMPORTED_MODULE_15_survey_knockout__["Event"]();
        /**
         * Use this event to control drag&drop operations.
         * <br/> sender the survey editor object that fires the event.
         * <br/> options.survey the editing survey object.
         * <br/> options.allow set it to false to disable dragging.
         * <br/> options.target a target element that is dragging.
         * <br/> options.source a source element. It can be null, if it is a new element, dragging from toolbox.
         * <br/> options.parent a page or panel where target element is dragging.
         * <br/> options.insertBefore an element before the target element is dragging. It can be null if parent container (page or panel) is empty or dragging an element under the last element of the container.
         * <br/> options.insertAfter an element after the target element is dragging. It can be null if parent container (page or panel) is empty or dragging element to the top of the parent container.
         */
        this.onDragDropAllow = new __WEBPACK_IMPORTED_MODULE_15_survey_knockout__["Event"]();
        /**
         * Use this event to get access rendered adorder.
         * <br/> sender the survey editor object that fires the event.
         * <br/> options.survey the editing survey object.
         * <br/> options.question the survey element of the adorner.
         * <br/> options.adorner the adorner id.
         * <br/> options.element a root adorner element.
         * <br/> options.context a context for adorner element, e.g. current item of a select base question.
         */
        this.onAdornerRendered = new __WEBPACK_IMPORTED_MODULE_15_survey_knockout__["Event"]();
        /**
         * Set it to false to suppress an alert message about error on saving the survey into database.
         */
        this.showErrorOnFailedSave = true;
        this.koShowState = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"](false);
        this.isPageUpdating = false;
        this.koState = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"]("");
        this.tabs = __WEBPACK_IMPORTED_MODULE_0_knockout__["observableArray"]();
        this.themeCss = __WEBPACK_IMPORTED_MODULE_0_knockout__["computed"](function () {
            return ["bootstrap", "bootstrapmaterial"].indexOf(__WEBPACK_IMPORTED_MODULE_17__stylesmanager__["a" /* StylesManager */].currentTheme()) === -1
                ? "sv_default_css"
                : "sv_" + __WEBPACK_IMPORTED_MODULE_17__stylesmanager__["a" /* StylesManager */].currentTheme() + "_css";
        });
        /**
         * The list of toolbar items. You may add/remove/replace them.
         * @see IToolbarItem
         */
        this.toolbarItems = __WEBPACK_IMPORTED_MODULE_0_knockout__["observableArray"]();
        this.saveNo = 0;
        /**
         * Add a new page into the editing survey.
         */
        this.addPage = function () {
            var name = __WEBPACK_IMPORTED_MODULE_11__surveyHelper__["b" /* SurveyHelper */].getNewPageName(_this.pages());
            var page = _this.survey.addNewPage(name);
            _this.pages.valueHasMutated(); //TODO why this is need ? (ko problem)
            _this.addPageToUI(page);
            _this.setModified({ type: "PAGE_ADDED", newValue: page });
        };
        this.deletePage = function () {
            _this.deleteCurrentObject();
            _this.pages.valueHasMutated(); //TODO why this is need ? (ko problem)
        };
        this.movePage = function (indexFrom, indexTo) {
            var page = _this.pages()[indexTo];
            _this.surveyObjects.survey = null; // TODO may be we don't need this hack
            _this.surveyObjects.survey = _this.survey;
            _this.surveyObjects.selectObject(page);
            _this.setModified({
                type: "PAGE_MOVED",
                page: page,
                indexFrom: indexFrom,
                indexTo: indexTo
            });
        };
        this.newQuestions = [];
        this.newPanels = [];
        this.isCurrentPageEmpty = __WEBPACK_IMPORTED_MODULE_0_knockout__["computed"](function () {
            return !!_this.surveyValue() &&
                !!_this.surveyValue().koCurrentPage() &&
                _this.getRows(_this.surveyValue().koCurrentPage()).length === 0;
        });
        this.showQuestionEditor = function (element, onClose) {
            if (onClose === void 0) { onClose = null; }
            var self = _this;
            var elWindow = _this.renderedElement
                ? (_this.renderedElement.querySelector("#surveyquestioneditorwindow"))
                : null;
            var isCanceled = true;
            _this.questionEditorWindow.show(element, elWindow, function (question) {
                self.onQuestionEditorChanged(question);
                isCanceled = false;
            }, _this, function () {
                if (onClose)
                    onClose(isCanceled);
            });
        };
        //TODO why this is need ? (ko problem)
        this.dirtyPageUpdate = function () {
            _this.isPageUpdating = true;
            try {
                var selectedObject = _this.koSelectedObject().value;
                if (__WEBPACK_IMPORTED_MODULE_11__surveyHelper__["b" /* SurveyHelper */].getObjectType(selectedObject) !== __WEBPACK_IMPORTED_MODULE_11__surveyHelper__["a" /* ObjType */].Page) {
                    if (__WEBPACK_IMPORTED_MODULE_11__surveyHelper__["b" /* SurveyHelper */].getObjectType(selectedObject) === __WEBPACK_IMPORTED_MODULE_11__surveyHelper__["a" /* ObjType */].Question &&
                        !!selectedObject["koElementType"]) {
                        selectedObject["koElementType"].notifySubscribers();
                    }
                    return;
                }
                var index = _this.pages.indexOf(selectedObject);
                _this.pages.splice(index, 1);
                _this.pages.splice(index, 0, selectedObject);
                _this.surveyObjects.selectObject(selectedObject);
            }
            finally {
                _this.isPageUpdating = false;
            }
        };
        /**
         * Create a new page with the same elements and place it next to the current one. It returns the new created Survey.Page
         * @param page A copied Survey.Page
         */
        this.copyPage = function (page) {
            var newPage = _this.copyElement(page);
            var index = _this.pages.indexOf(page);
            if (index > -1) {
                _this.pages.splice(index + 1, 0, newPage);
            }
            else {
                _this.pages.push(newPage);
            }
            _this.addPageToUI(newPage);
            _this.setModified({ type: "PAGE_ADDED", newValue: newPage });
            return newPage;
        };
        this.onEditorTabRenderedCallback = function (tabName, elements, model, tabData) {
            _this.onEditorTabRendered.fire(_this, {
                tabName: tabName,
                elements: elements,
                model: model,
                tabData: tabData
            });
        };
        this.koShowOptions = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"]();
        this.koGenerateValidJSON = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"](true);
        this.koShowPropertyGrid = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"](true);
        this.koDesignerHeight = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"]();
        this.koShowPagesToolbox = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"](true);
        this.setOptions(options);
        this.koCanDeleteObject = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"](false);
        var self = this;
        __WEBPACK_IMPORTED_MODULE_17__stylesmanager__["a" /* StylesManager */].applyTheme(__WEBPACK_IMPORTED_MODULE_17__stylesmanager__["a" /* StylesManager */].currentTheme());
        this.pages = __WEBPACK_IMPORTED_MODULE_0_knockout__["observableArray"]();
        this.koShowSaveButton = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"](false);
        this.koTestSurveyWidth = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"]("100%");
        this.saveButtonClick = function () {
            self.doSave();
        };
        this.koObjects = __WEBPACK_IMPORTED_MODULE_0_knockout__["observableArray"]();
        window["sel"] = this.koSelectedObject;
        this.koSelectedObject = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"]();
        this.koSelectedObject.subscribe(function (newValue) {
            self.selectedObjectChanged(newValue != null ? newValue.value : null);
        });
        this.koGenerateValidJSON.subscribe(function (newValue) {
            if (!self.options)
                self.options = {};
            self.options.generateValidJSON = newValue;
            if (self.generateValidJSONChangedCallback)
                self.generateValidJSONChangedCallback(newValue);
        });
        this.surveyObjects = new __WEBPACK_IMPORTED_MODULE_5__surveyObjects__["a" /* SurveyObjects */](this.koObjects, this.koSelectedObject, this.showObjectTitles);
        this.surveyObjects.getItemTextCallback = function (obj, text) {
            var options = { obj: obj, text: text };
            self.onGetObjectTextInPropertyGrid.fire(self, options);
            return options.text;
        };
        this.selectPage = function (page) {
            _this.surveyObjects.selectObject(page);
        };
        this.undoRedo = new __WEBPACK_IMPORTED_MODULE_10__undoredo__["a" /* SurveyUndoRedo */]();
        this.selectedObjectEditorValue = new __WEBPACK_IMPORTED_MODULE_2__objectEditor__["a" /* SurveyObjectEditor */](this);
        this.selectedObjectEditorValue.onCanShowPropertyCallback = function (object, property) {
            return self.onCanShowObjectProperty(object, property);
        };
        this.selectedObjectEditorValue.onSortPropertyCallback = function (obj, property1, property2) {
            return self.onCustomSortPropertyObjectProperty(obj, property1, property2);
        };
        this.selectedObjectEditorValue.onPropertyValueChanged.add(function (sender, options) {
            options.updatedValue = self.onPropertyValueChanged(options.property, options.object, options.newValue);
        });
        this.selectedObjectEditorValue.onAfterRenderCallback = function (obj, htmlElement, prop) {
            if (self.onPropertyAfterRender.isEmpty)
                return;
            var options = {
                obj: obj,
                htmlElement: htmlElement,
                property: prop.property,
                propertyEditor: prop.editor
            };
            self.onPropertyAfterRender.fire(self, options);
        };
        this.questionEditorWindow = new __WEBPACK_IMPORTED_MODULE_7__questionEditors_questionEditor__["a" /* SurveyPropertyEditorShowWindow */]();
        this.questionEditorWindow.onCanShowPropertyCallback = function (object, property) {
            return self.onCanShowObjectProperty(object, property);
        };
        this.surveyLive = new __WEBPACK_IMPORTED_MODULE_3__surveylive__["a" /* SurveyLiveTester */]();
        this.surveyLive.showObjectTitles = this.showObjectTitles;
        this.surveyEmbeding = new __WEBPACK_IMPORTED_MODULE_4__surveyEmbedingWindow__["a" /* SurveyEmbedingWindow */]();
        this.translationValue = new __WEBPACK_IMPORTED_MODULE_19__translation__["a" /* Translation */](new __WEBPACK_IMPORTED_MODULE_15_survey_knockout__["Survey"]());
        this.translation.importFinishedCallback = function () {
            self.onTranslationImported.fire(self, {});
        };
        this.translation.availableTranlationsChangedCallback = function () {
            _this.setModified({ type: "TRANSLATIONS_CHANGED" });
        };
        this.toolboxValue = new __WEBPACK_IMPORTED_MODULE_13__questionToolbox__["a" /* QuestionToolbox */](this.options && this.options.questionTypes
            ? this.options.questionTypes
            : null);
        this.koViewType = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"]("designer");
        this.koIsShowDesigner = __WEBPACK_IMPORTED_MODULE_0_knockout__["computed"](function () {
            return self.koViewType() == "designer";
        });
        this.generateValidJSONClick = function () {
            self.koGenerateValidJSON(true);
        };
        this.generateReadableJSONClick = function () {
            self.koGenerateValidJSON(false);
        };
        this.runSurveyClick = function () {
            self.showLiveSurvey();
        };
        this.deleteObjectClick = function () {
            self.deleteCurrentObject();
        };
        this.draggingToolboxItem = function (item, e) {
            self.doDraggingToolboxItem(item.json, e);
        };
        this.clickToolboxItem = function (item) {
            self.doClickToolboxItem(item.json);
        };
        this.dragEnd = function (item, e) {
            self.dragDropHelper.end();
        };
        this.doUndoClick = function () {
            self.doUndoRedo(self.undoRedo.undo());
        };
        this.doRedoClick = function () {
            self.doUndoRedo(self.undoRedo.redo());
        };
        this.jsonEditor = new __WEBPACK_IMPORTED_MODULE_8__surveyJSONEditor__["a" /* SurveyJSONEditor */]();
        __WEBPACK_IMPORTED_MODULE_0_knockout__["computed"](function () {
            _this.tabs([]);
            _this.tabs.push({
                name: "designer",
                title: _this.getLocString("ed.designer"),
                template: "se-tab-designer",
                data: _this,
                action: function () { return _this.showDesigner(); }
            });
            if (_this.showJSONEditorTab) {
                _this.tabs.push({
                    name: "editor",
                    title: _this.getLocString("ed.jsonEditor"),
                    template: "jsoneditor",
                    data: _this.jsonEditor,
                    action: function () { return _this.showJsonEditor(); }
                });
            }
            if (_this.showTestSurveyTab) {
                _this.tabs.push({
                    name: "test",
                    title: _this.getLocString("ed.testSurvey"),
                    template: "se-tab-test",
                    data: _this,
                    action: function () { return _this.showTestSurvey(); }
                });
            }
            if (_this.showEmbededSurveyTab) {
                _this.tabs.push({
                    name: "embed",
                    title: _this.getLocString("ed.embedSurvey"),
                    template: "surveyembeding",
                    data: _this.surveyEmbeding,
                    action: function () { return _this.showEmbedEditor(); }
                });
            }
            if (_this.showTranslationTab) {
                _this.tabs.push({
                    name: "translation",
                    title: _this.getLocString("ed.translation"),
                    template: "translation",
                    data: _this.translation,
                    action: function () { return _this.showTranslationEditor(); }
                });
            }
        });
        if (renderedElement) {
            this.render(renderedElement);
        }
        this.text = "";
        this.addToolbarItems();
    }
    Object.defineProperty(SurveyEditor.prototype, "haveCommercialLicense", {
        /**
         * You have right to set this property to true if you have bought the commercial licence only.
         * It will remove the text about non-commerical usage on the top of the widget.
         * Setting this property true without having a commercial licence is illegal.
         * @see haveCommercialLicense
         */
        get: function () {
            return this._haveCommercialLicense();
        },
        set: function (val) {
            this._haveCommercialLicense(val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyEditor.prototype, "inplaceEditForValues", {
        /**
         * You need to set this property to true if you want to inplace edit item values instead of texts.
         * @see inplaceEditForValues
         */
        get: function () {
            return __WEBPACK_IMPORTED_MODULE_18__adorners_item_editor__["a" /* itemAdorner */].inplaceEditForValues;
        },
        set: function (val) {
            __WEBPACK_IMPORTED_MODULE_18__adorners_item_editor__["a" /* itemAdorner */].inplaceEditForValues = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyEditor.prototype, "isAutoSave", {
        /**
         * A boolean property, false by default. Set it to true to call protected doSave method automatically on survey changing.
         */
        get: function () {
            return this.koAutoSave();
        },
        set: function (newVal) {
            this.koAutoSave(newVal);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyEditor.prototype, "showState", {
        /**
         * A boolean property, false by default. Set it to true to show the state in the toolbar (saving/saved).
         */
        get: function () {
            return this.koShowState();
        },
        set: function (newVal) {
            this.koShowState(newVal);
        },
        enumerable: true,
        configurable: true
    });
    SurveyEditor.prototype.addToolbarItems = function () {
        var _this = this;
        this.toolbarItems.push({
            id: "svd-undo",
            visible: this.koIsShowDesigner,
            enabled: this.undoRedo.koCanUndo,
            action: this.doUndoClick,
            title: this.getLocString("ed.undo")
        });
        this.toolbarItems.push({
            id: "svd-redo",
            visible: this.koIsShowDesigner,
            enabled: this.undoRedo.koCanRedo,
            action: this.doRedoClick,
            title: this.getLocString("ed.redo")
        });
        this.toolbarItems.push({
            id: "svd-survey-settings",
            visible: this.koIsShowDesigner,
            enabled: false,
            action: function () {
                _this.surveyObjects.selectObject(_this.survey);
                _this.showQuestionEditor(_this.survey);
            },
            title: this.getLocString("ed.settings")
        });
        this.toolbarItems.push({
            id: "svd-options",
            visible: __WEBPACK_IMPORTED_MODULE_0_knockout__["computed"](function () { return _this.koIsShowDesigner() && _this.koShowOptions(); }),
            title: this.getLocString("ed.options"),
            template: "svd-toolbar-options",
            items: __WEBPACK_IMPORTED_MODULE_0_knockout__["observableArray"]([
                {
                    id: "svd-valid-json",
                    visible: true,
                    css: __WEBPACK_IMPORTED_MODULE_0_knockout__["computed"](function () { return (_this.koGenerateValidJSON() ? "active" : ""); }),
                    action: this.generateValidJSONClick,
                    title: this.getLocString("ed.generateValidJSON")
                },
                {
                    id: "svd-readable-json",
                    visible: true,
                    css: __WEBPACK_IMPORTED_MODULE_0_knockout__["computed"](function () { return (!_this.koGenerateValidJSON() ? "active" : ""); }),
                    action: this.generateReadableJSONClick,
                    title: this.getLocString("ed.generateReadableJSON")
                }
            ])
        });
        this.toolbarItems.push({
            id: "svd-test",
            visible: __WEBPACK_IMPORTED_MODULE_0_knockout__["computed"](function () { return _this.koViewType() === "test"; }),
            title: __WEBPACK_IMPORTED_MODULE_0_knockout__["computed"](function () {
                return _this.getLocString("ed.testSurveyWidth") +
                    " " +
                    _this.koTestSurveyWidth();
            }),
            template: "svd-toolbar-options",
            items: __WEBPACK_IMPORTED_MODULE_0_knockout__["observableArray"]([
                {
                    id: "svd-100-json",
                    visible: true,
                    action: function () { return _this.koTestSurveyWidth("100%"); },
                    title: "100%"
                },
                {
                    id: "svd-1200px-json",
                    visible: true,
                    action: function () { return _this.koTestSurveyWidth("1200px"); },
                    title: "1200px"
                },
                {
                    id: "svd-1000px-json",
                    visible: true,
                    action: function () { return _this.koTestSurveyWidth("1000px"); },
                    title: "1000px"
                },
                {
                    id: "svd-800px-json",
                    visible: true,
                    action: function () { return _this.koTestSurveyWidth("800px"); },
                    title: "800px"
                },
                {
                    id: "svd-600px-json",
                    visible: true,
                    action: function () { return _this.koTestSurveyWidth("600px"); },
                    title: "600px"
                },
                {
                    id: "svd-400px-json",
                    visible: true,
                    action: function () { return _this.koTestSurveyWidth("400px"); },
                    title: "400px"
                }
            ])
        });
        this.toolbarItems.push({
            id: "svd-save",
            visible: this.koShowSaveButton,
            action: this.saveButtonClick,
            innerCss: "svd_save_btn",
            title: this.getLocString("ed.saveSurvey")
        });
        this.toolbarItems.push({
            id: "svd-state",
            visible: this.koShowState,
            css: "svd_state",
            innerCss: __WEBPACK_IMPORTED_MODULE_0_knockout__["computed"](function () { return "icon-" + _this.koState(); }),
            title: __WEBPACK_IMPORTED_MODULE_0_knockout__["computed"](function () { return _this.getLocString("ed." + _this.koState()); }),
            template: "svd-toolbar-state"
        });
    };
    SurveyEditor.prototype.setOptions = function (options) {
        if (!options)
            options = {};
        if (!options.hasOwnProperty("generateValidJSON"))
            options.generateValidJSON = true;
        this.options = options;
        this.showJSONEditorTabValue(typeof options.showJSONEditorTab !== "undefined"
            ? options.showJSONEditorTab
            : true);
        this.showTestSurveyTabValue(typeof options.showTestSurveyTab !== "undefined"
            ? options.showTestSurveyTab
            : true);
        this.showEmbededSurveyTabValue(typeof options.showEmbededSurveyTab !== "undefined"
            ? options.showEmbededSurveyTab
            : false);
        this.showTranslationTabValue(typeof options.showTranslationTab !== "undefined"
            ? options.showTranslationTab
            : false);
        this.haveCommercialLicense =
            typeof options.haveCommercialLicense !== "undefined"
                ? options.haveCommercialLicense
                : false;
        this.inplaceEditForValues =
            typeof options.inplaceEditForValues !== "undefined"
                ? options.inplaceEditForValues
                : false;
        this.showObjectTitles =
            typeof options.showObjectTitles !== "undefined"
                ? options.showObjectTitles
                : false;
        this.showTitlesInExpressions =
            typeof options.showTitlesInExpressions !== "undefined"
                ? options.showTitlesInExpressions
                : false;
        this.useTabsInElementEditor =
            typeof options.useTabsInElementEditor !== "undefined"
                ? options.useTabsInElementEditor
                : false;
        this.showState =
            typeof options.showState !== "undefined" ? options.showState : false;
        this.koShowOptions(typeof options.showOptions !== "undefined" ? options.showOptions : false);
        this.koShowPropertyGrid(typeof options.showPropertyGrid !== "undefined"
            ? options.showPropertyGrid
            : true);
        this.koGenerateValidJSON(this.options.generateValidJSON);
        this.isAutoSave =
            typeof options.isAutoSave !== "undefined" ? options.isAutoSave : false;
        this.showErrorOnFailedSave =
            typeof options.showErrorOnFailedSave !== "undefined"
                ? options.showErrorOnFailedSave
                : true;
        this.isRTLValue =
            typeof options.isRTL !== "undefined" ? options.isRTL : false;
        this.scrollToNewElement =
            typeof options.scrollToNewElement !== "undefined"
                ? options.scrollToNewElement
                : true;
        if (options.designerHeight) {
            this.koDesignerHeight(options.designerHeight);
        }
        if (options.objectsIntend) {
            __WEBPACK_IMPORTED_MODULE_5__surveyObjects__["a" /* SurveyObjects */].intend = options.objectsIntend;
        }
        if (typeof options.showPagesToolbox !== "undefined") {
            this.koShowPagesToolbox(options.showPagesToolbox);
        }
    };
    Object.defineProperty(SurveyEditor.prototype, "survey", {
        /**
         * The editing survey object (Survey.Survey)
         */
        get: function () {
            return this.surveyValue();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyEditor.prototype, "selectedObjectEditor", {
        get: function () {
            return this.selectedObjectEditorValue;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Call this method to render the survey editor.
     * @param element HtmlElement or html element id where Survey Editor will be rendered
     * @param options Survey Editor options. The following options are available: showJSONEditorTab, showTestSurveyTab, showEmbededSurveyTab, showTranslationTab, showOptions, generateValidJSON, isAutoSave, designerHeight.
     */
    SurveyEditor.prototype.render = function (element, options) {
        if (element === void 0) { element = null; }
        if (options === void 0) { options = null; }
        if (options)
            this.setOptions(options);
        var self = this;
        if (element && typeof element == "string") {
            element = document.getElementById(element);
        }
        if (element) {
            this.renderedElement = element;
        }
        element = this.renderedElement;
        if (!element)
            return;
        element.innerHTML = templateEditorHtml;
        self.applyBinding();
    };
    SurveyEditor.prototype.loadSurvey = function (surveyId) {
        var self = this;
        new __WEBPACK_IMPORTED_MODULE_15_survey_knockout__["dxSurveyService"]().loadSurvey(surveyId, function (success, result, response) {
            if (success && result) {
                self.text = JSON.stringify(result);
            }
        });
    };
    Object.defineProperty(SurveyEditor.prototype, "text", {
        /**
         * The Survey JSON as a text. Use it to get Survey JSON or change it.
         */
        get: function () {
            if (this.koViewType() == "editor")
                return this.jsonEditor.text;
            return this.getSurveyTextFromDesigner();
        },
        set: function (value) {
            this.changeText(value, true);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Set JSON as text  into survey. Clear undo/redo states optionally.
     * @param value JSON as text
     * @param clearState default false. Set this parameter to true to clear undo/redo states.
     */
    SurveyEditor.prototype.changeText = function (value, clearState) {
        if (clearState === void 0) { clearState = false; }
        var textWorker = new __WEBPACK_IMPORTED_MODULE_9__textWorker__["a" /* SurveyTextWorker */](value);
        if (textWorker.isJsonCorrect) {
            this.initSurvey(new __WEBPACK_IMPORTED_MODULE_15_survey_knockout__["JsonObject"]().toJsonObject(textWorker.survey));
            this.showDesigner();
            this.setUndoRedoCurrentState(clearState);
        }
        else {
            this.setTextValue(value);
            this.koViewType("editor");
        }
    };
    Object.defineProperty(SurveyEditor.prototype, "toolbox", {
        /**
         * Toolbox object. Contains information about Question toolbox items.
         * @see QuestionToolbox
         */
        get: function () {
            return this.toolboxValue;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyEditor.prototype, "translation", {
        /**
         * Return the translation mode object.
         * @see showTranslationTab
         */
        get: function () {
            return this.translationValue;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyEditor.prototype, "customToolboxQuestionMaxCount", {
        /**
         * Get and set the maximum of copied questions/panels in the toolbox. The default value is 3
         */
        get: function () {
            return this.toolbox.copiedItemMaxCount;
        },
        set: function (value) {
            this.toolbox.copiedItemMaxCount = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyEditor.prototype, "state", {
        /**
         * Returns the Editor state. It may return empty string or "saving" and "saved".
         */
        get: function () {
            return this.stateValue;
        },
        enumerable: true,
        configurable: true
    });
    SurveyEditor.prototype.setState = function (value) {
        this.stateValue = value;
        this.koState(this.state);
    };
    SurveyEditor.prototype.doSave = function () {
        this.setState("saving");
        if (this.saveSurveyFunc) {
            this.saveNo++;
            var self = this;
            this.saveSurveyFunc(this.saveNo, function doSaveCallback(no, isSuccess) {
                if (self.saveNo === no) {
                    if (isSuccess) {
                        self.setState("saved");
                    }
                    else {
                        if (self.showErrorOnFailedSave) {
                            alert(self.getLocString("ed.saveError"));
                        }
                        self.setState("modified");
                    }
                }
            });
        }
    };
    SurveyEditor.prototype.setModified = function (options) {
        if (options === void 0) { options = null; }
        this.setState("modified");
        this.setUndoRedoCurrentState();
        this.onModified.fire(this, options);
        this.isAutoSave && this.doSave();
    };
    SurveyEditor.prototype.setUndoRedoCurrentState = function (clearState) {
        if (clearState === void 0) { clearState = false; }
        if (clearState) {
            this.undoRedo.clear();
        }
        var selObj = this.koSelectedObject() ? this.koSelectedObject().value : null;
        this.undoRedo.setCurrent(this.surveyValue(), selObj ? selObj.name : null);
    };
    Object.defineProperty(SurveyEditor.prototype, "saveSurveyFunc", {
        /**
         * Assign to this property a function that will be called on clicking the 'Save' button or on any change if isAutoSave equals true.
         * @see isAutoSave
         */
        get: function () {
            return this.saveSurveyFuncValue;
        },
        set: function (value) {
            this.saveSurveyFuncValue = value;
            this.koShowSaveButton(value != null && !this.isAutoSave);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyEditor.prototype, "showOptions", {
        /**
         * Set it to true to show "Options" menu and to false to hide the menu
         */
        get: function () {
            return this.koShowOptions();
        },
        set: function (value) {
            this.koShowOptions(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyEditor.prototype, "showPropertyGrid", {
        /**
         * Set it to false to hide the Property Grid on the right. It allows to edit the properties of the selected object (question/panel/page/survey).
         */
        get: function () {
            return this.koShowPropertyGrid();
        },
        set: function (value) {
            this.koShowPropertyGrid(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyEditor.prototype, "showJSONEditorTab", {
        /**
         * Set it to true to show "JSON Editor" tab and to false to hide the tab
         */
        get: function () {
            return this.showJSONEditorTabValue();
        },
        set: function (value) {
            this.showJSONEditorTabValue(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyEditor.prototype, "showTestSurveyTab", {
        /**
         * Set it to true to show "Test Survey" tab and to false to hide the tab
         */
        get: function () {
            return this.showTestSurveyTabValue();
        },
        set: function (value) {
            this.showTestSurveyTabValue(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyEditor.prototype, "showEmbededSurveyTab", {
        /**
         * Set it to true to show "Embed Survey" tab and to false to hide the tab
         */
        get: function () {
            return this.showEmbededSurveyTabValue();
        },
        set: function (value) {
            this.showEmbededSurveyTabValue(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyEditor.prototype, "showTranslationTab", {
        /**
         * Set it to true to show "Translation" tab and to false to hide the tab
         */
        get: function () {
            return this.showTranslationTabValue();
        },
        set: function (value) {
            this.showTranslationTabValue(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyEditor.prototype, "isRTL", {
        /**
         * Set it to true to activate RTL support
         */
        get: function () {
            return this.isRTLValue;
        },
        set: function (value) {
            this.isRTLValue = value;
        },
        enumerable: true,
        configurable: true
    });
    SurveyEditor.prototype.onCanShowObjectProperty = function (object, property) {
        var options = { obj: object, property: property, canShow: true };
        this.onCanShowProperty.fire(this, options);
        return options.canShow;
    };
    SurveyEditor.prototype.onCustomSortPropertyObjectProperty = function (object, property1, property2) {
        if (this.onCustomSortProperty.isEmpty)
            return 0;
        var options = {
            obj: object,
            property1: property1,
            property2: property2,
            result: 0
        };
        this.onCustomSortProperty.fire(this, options);
        return options.result;
    };
    SurveyEditor.prototype.setTextValue = function (value) {
        this.jsonEditor.text = value;
    };
    /**
     * Returns the localized string by it's id
     * @param str the string id.
     */
    SurveyEditor.prototype.getLocString = function (str) {
        return __WEBPACK_IMPORTED_MODULE_1__editorLocalization__["a" /* editorLocalization */].getString(str);
    };
    SurveyEditor.prototype.addPageToUI = function (page) {
        this.surveyObjects.addPage(page);
    };
    SurveyEditor.prototype.doOnQuestionAdded = function (question, parentPanel) {
        if (!this.dragDropHelper.isMoving) {
            var page = this.getPageByElement(question);
            var options = { question: question, page: page };
            this.onQuestionAdded.fire(this, options);
        }
        if (parentPanel.elements.indexOf(question) !== -1) {
            this.surveyObjects.addElement(question, parentPanel);
        }
    };
    SurveyEditor.prototype.doOnElementRemoved = function (question) {
        this.surveyObjects.removeObject(question);
    };
    SurveyEditor.prototype.doOnPanelAdded = function (panel, parentPanel) {
        if (!this.dragDropHelper.isMoving) {
            var page = this.getPageByElement(panel);
            var options = { panel: panel, page: page };
            this.onPanelAdded.fire(this, options);
        }
        if (parentPanel.elements.indexOf(panel) !== -1) {
            this.surveyObjects.addElement(panel, parentPanel);
        }
    };
    SurveyEditor.prototype.doOnPageAdded = function (page) {
        if (this.isPageUpdating)
            return;
        var options = { page: page };
        this.onPageAdded.fire(this, options);
    };
    SurveyEditor.prototype.onPropertyValueChanged = function (property, obj, newValue) {
        var oldValue = obj[property.name];
        if (property.name === "page" && typeof newValue === "string") {
            obj[property.name] = obj.survey.getPageByName(newValue);
        }
        else {
            obj[property.name] = newValue;
        }
        if (property.name == "name") {
            var newName = this.generateUniqueName(obj, newValue);
            if (newName != newValue) {
                return newName;
            }
        }
        if (property.name == "name" || property.name == "title") {
            this.surveyObjects.nameChanged(obj);
        }
        if (property.name === "name") {
            this.dirtyPageUpdate(); //TODO why this is need ? (ko problem)
        }
        else if (property.name === "page") {
            this.selectPage(newValue);
            this.surveyObjects.selectObject(obj);
        }
        this.setModified({
            type: "PROPERTY_CHANGED",
            name: property.name,
            target: obj,
            oldValue: oldValue,
            newValue: newValue
        });
        //TODO add a flag to a property, may change other properties
        if (property.name == "locale" ||
            property.name == "hasComment" ||
            property.name == "hasOther") {
            this.selectedObjectEditorValue.objectChanged();
        }
        return null;
    };
    SurveyEditor.prototype.doUndoRedo = function (item) {
        this.initSurvey(item.surveyJSON);
        if (item.selectedObjName) {
            var selObj = this.findObjByName(item.selectedObjName);
            if (selObj) {
                this.surveyObjects.selectObject(selObj);
            }
        }
        this.setState("modified");
        this.isAutoSave && this.doSave();
    };
    SurveyEditor.prototype.findObjByName = function (name) {
        var page = this.survey.getPageByName(name);
        if (page)
            return page;
        var question = this.survey.getQuestionByName(name);
        if (question)
            return question;
        return null;
    };
    SurveyEditor.prototype.canSwitchViewType = function (newType) {
        if (newType && this.koViewType() == newType)
            return false;
        if (this.koViewType() == "designer") {
            this.jsonEditor.text = this.getSurveyTextFromDesigner();
        }
        if (this.koViewType() == "translation" && newType == "designer") {
            this.survey.render();
        }
        if (this.koViewType() != "editor")
            return true;
        if (!this.jsonEditor.isJsonCorrect) {
            alert(this.getLocString("ed.correctJSON"));
            return false;
        }
        this.initSurvey(new __WEBPACK_IMPORTED_MODULE_15_survey_knockout__["JsonObject"]().toJsonObject(this.jsonEditor.survey));
        this.setModified({ type: "VIEW_TYPE_CHANGED", newType: newType });
        return true;
    };
    /**
     * Make a "Survey Designer" tab active.
     */
    SurveyEditor.prototype.showDesigner = function () {
        if (!this.canSwitchViewType("designer"))
            return;
        this.koViewType("designer");
    };
    /**
     * Make a "JSON Editor" tab active.
     */
    SurveyEditor.prototype.showJsonEditor = function () {
        if (this.koViewType() == "editor")
            return;
        this.jsonEditor.show(this.getSurveyTextFromDesigner());
        this.koViewType("editor");
    };
    /**
     * Make a "Test Survey" tab active.
     */
    SurveyEditor.prototype.showTestSurvey = function () {
        if (!this.canSwitchViewType(null))
            return;
        this.showLiveSurvey();
        this.koViewType("test");
    };
    /**
     * Make a "Embed Survey" tab active.
     */
    SurveyEditor.prototype.showEmbedEditor = function () {
        if (!this.canSwitchViewType("embed"))
            return;
        this.showSurveyEmbeding();
        this.koViewType("embed");
    };
    /**
     * Make a "Translation"" tab active.
     */
    SurveyEditor.prototype.showTranslationEditor = function () {
        if (!this.canSwitchViewType("translation"))
            return;
        this.showSurveyTranslation();
        this.koViewType("translation");
    };
    SurveyEditor.prototype.getSurveyTextFromDesigner = function () {
        var json = new __WEBPACK_IMPORTED_MODULE_15_survey_knockout__["JsonObject"]().toJsonObject(this.survey);
        if (this.options && this.options.generateValidJSON)
            return JSON.stringify(json, null, 1);
        return new __WEBPACK_IMPORTED_MODULE_14__json5__["a" /* SurveyJSON5 */]().stringify(json, null, 1);
    };
    SurveyEditor.prototype.getPageByElement = function (obj) {
        var page = this.survey.getPageByElement(obj);
        if (page)
            return page;
        return this.surveyObjects.getSelectedObjectPage(obj);
    };
    SurveyEditor.prototype.selectedObjectChanged = function (obj) {
        var canDeleteObject = false;
        this.selectedObjectEditorValue.selectedObject = obj;
        var objType = __WEBPACK_IMPORTED_MODULE_11__surveyHelper__["b" /* SurveyHelper */].getObjectType(obj);
        if (objType == __WEBPACK_IMPORTED_MODULE_11__surveyHelper__["a" /* ObjType */].Page) {
            this.survey.currentPage = obj;
            canDeleteObject = this.pages().length > 1;
        }
        if (objType == __WEBPACK_IMPORTED_MODULE_11__surveyHelper__["a" /* ObjType */].Question || objType == __WEBPACK_IMPORTED_MODULE_11__surveyHelper__["a" /* ObjType */].Panel) {
            this.survey.selectedElement = obj;
            canDeleteObject = true;
            this.survey.currentPage = this.getPageByElement(obj);
            var id = obj["id"];
            if (this.renderedElement && id && this.survey.currentPage) {
                var el_1 = this.renderedElement.querySelector("#" + id);
                var pageEl = (this.renderedElement.querySelector("#" + this.survey.currentPage.id));
                __WEBPACK_IMPORTED_MODULE_11__surveyHelper__["b" /* SurveyHelper */].scrollIntoViewIfNeeded(el_1, pageEl);
            }
        }
        else {
            this.survey.selectedElement = null;
        }
        this.koCanDeleteObject(canDeleteObject);
        //Select2 work-around
        if (this.renderedElement && this.select2) {
            var el = (this.renderedElement.querySelector("#select2-objectSelector-container")); //TODO
            if (el) {
                var item = this.surveyObjects.koSelected();
                if (item && item.text) {
                    el.innerText = item.text();
                }
            }
        }
    };
    SurveyEditor.prototype.applyBinding = function () {
        var _this = this;
        if (this.renderedElement == null)
            return;
        __WEBPACK_IMPORTED_MODULE_0_knockout__["cleanNode"](this.renderedElement);
        __WEBPACK_IMPORTED_MODULE_0_knockout__["applyBindings"](this, this.renderedElement);
        this.surveyjs = (this.renderedElement.querySelector("#surveyjs"));
        if (this.surveyjs) {
            var self = this;
            this.surveyjs.onkeydown = function (e) {
                if (!e)
                    return;
                // if (e.keyCode == 46) self.deleteQuestion();
                if (e.keyCode == 38 || e.keyCode == 40) {
                    self.selectQuestion(e.keyCode == 38);
                }
            };
        }
        this.initSurvey(this.getDefaultSurveyJson());
        this.setUndoRedoCurrentState(true);
        this.jsonEditor.init((this.renderedElement.querySelector("#surveyjsJSONEditor")));
        if (typeof jQuery !== "undefined" && jQuery()["select2"]) {
            var options = {
                width: "100%"
            };
            if (this.isRTLValue) {
                options.dir = "rtl";
            }
            var $objectSelector = jQuery("#objectSelector");
            this.select2 = $objectSelector["select2"](options);
            $objectSelector.on("select2:select", function (sel_evt) {
                _this.koSelectedObject(sel_evt.target.value);
            });
        }
    };
    SurveyEditor.prototype.getDefaultSurveyJson = function () {
        var json = new __WEBPACK_IMPORTED_MODULE_14__json5__["a" /* SurveyJSON5 */]().parse(SurveyEditor.defaultNewSurveyText);
        if (json["pages"] &&
            json["pages"]["length"] > 0 &&
            json["pages"][0]["name"]) {
            json["pages"][0]["name"] =
                __WEBPACK_IMPORTED_MODULE_1__editorLocalization__["a" /* editorLocalization */].getString("ed.newPageName") + "1";
        }
        return json;
    };
    SurveyEditor.prototype.initSurvey = function (json) {
        var _this = this;
        var self = this;
        this.surveyValue(new __WEBPACK_IMPORTED_MODULE_16__surveyjsObjects__["a" /* SurveyForDesigner */]());
        this.dragDropHelper = new __WEBPACK_IMPORTED_MODULE_12__dragdrophelper__["a" /* DragDropHelper */](this.survey, function (options) {
            self.setModified(options);
        }, this.renderedElement);
        this.surveyValue().getEditor = function () { return self; };
        this.surveyValue().setJsonObject(json);
        if (this.surveyValue().isEmpty) {
            this.surveyValue().setJsonObject(this.getDefaultSurveyJson());
        }
        __WEBPACK_IMPORTED_MODULE_15_survey_knockout__["surveyLocalization"].currentLocale = this.surveyValue()["locale"];
        this.surveyValue().dragDropHelper = this.dragDropHelper;
        this.surveyValue().onUpdateElementAllowingOptions = function (options) {
            self.onElementAllowOperations.fire(self, options);
        };
        this.surveyValue().onDragDropAllow.add(function (sender, options) {
            options.survey = sender;
            self.onDragDropAllow.fire(self, options);
        });
        this.surveyValue().onGetMenuItems.add(function (sender, options) {
            var opts = options.obj.allowingOptions;
            if (!opts)
                opts = {};
            if (opts.allowEdit) {
                options.items.push({
                    name: "editelement",
                    text: _this.getLocString("survey.edit"),
                    hasTitle: true,
                    onClick: function (question) { return _this.showQuestionEditor(question); }
                });
            }
            if (opts.allowDelete) {
                var deleteLocaleName = options.obj.isPanel
                    ? "survey.deletePanel"
                    : "survey.deleteQuestion";
                options.items.push({
                    name: "delete",
                    text: self.getLocString(deleteLocaleName),
                    onClick: function (selObj) {
                        self.deleteCurrentObject();
                    }
                });
            }
            if (opts.allowShowHideTitle &&
                typeof options.obj.titleLocation !== "undefined") {
                var isShowTitle = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"](options.obj.titleLocation !== "hidden");
                options.items.push({
                    name: "showtitle",
                    text: _this.getLocString("pe.showTitle"),
                    icon: __WEBPACK_IMPORTED_MODULE_0_knockout__["computed"](function () {
                        if (isShowTitle()) {
                            return "icon-actionshowtitle";
                        }
                        return "icon-actionhidetitle";
                    }),
                    onClick: function (question) {
                        if (question.titleLocation !== "hidden") {
                            question.titleLocation = "hidden";
                            if (question.getType() === "boolean") {
                                question["showTitle"] = false;
                            }
                        }
                        else {
                            question.titleLocation = "default";
                            if (question.getType() === "boolean") {
                                question["showTitle"] = true;
                            }
                        }
                        isShowTitle(question.titleLocation !== "hidden");
                        _this.onQuestionEditorChanged(question);
                    }
                });
            }
            if (opts.allowChangeRequired &&
                typeof options.obj.isRequired !== "undefined") {
                var isRequired = __WEBPACK_IMPORTED_MODULE_0_knockout__["computed"](function () { return options.obj.isRequired; });
                options.items.push({
                    name: "isrequired",
                    text: _this.getLocString("pe.isRequired"),
                    icon: __WEBPACK_IMPORTED_MODULE_0_knockout__["computed"](function () {
                        if (isRequired()) {
                            return "icon-actionisrequired";
                        }
                        return "icon-actionnotrequired";
                    }),
                    onClick: function (question) {
                        question.isRequired = !question.isRequired;
                        _this.onQuestionEditorChanged(question);
                    }
                });
            }
            if (options.items.length > 0) {
                options.items.push({ template: "action-separator" });
            }
            if (opts.allowCopy) {
                options.items.push({
                    name: "copy",
                    text: self.getLocString("survey.copy"),
                    onClick: function (selObj) {
                        self.fastCopyQuestion(selObj);
                    }
                });
            }
            if (opts.allowAddToToolbox) {
                options.items.push({
                    name: "addtotoolbox",
                    text: self.getLocString("survey.addToToolbox"),
                    onClick: function (selObj) {
                        self.addCustomToolboxQuestion(selObj);
                    }
                });
            }
            if (opts.allowChangeType) {
                if (options.items.length > 0) {
                    options.items.push({ template: "action-separator" });
                }
                var currentType = options.obj.getType();
                var convertClasses = __WEBPACK_IMPORTED_MODULE_6__questionconverter__["a" /* QuestionConverter */].getConvertToClasses(currentType);
                var allowChangeType = convertClasses.length > 0;
                var createTypeByClass = function (className) {
                    return {
                        name: _this.getLocString("qt." + className),
                        value: className
                    };
                };
                var availableTypes = [createTypeByClass(currentType)];
                for (var i = 0; i < convertClasses.length; i++) {
                    var className = convertClasses[i];
                    availableTypes.push(createTypeByClass(className));
                }
                options.items.push({
                    text: _this.getLocString("qt." + currentType),
                    title: _this.getLocString("survey.convertTo"),
                    type: currentType,
                    allowChangeType: allowChangeType,
                    template: "convert-action",
                    availableTypes: availableTypes,
                    onConvertType: function (data, event) {
                        var newType = event.target.value;
                        _this.convertCurrentObject(options.obj, newType);
                    }
                });
            }
            if (opts.allowDragging) {
                options.items.push({
                    name: "dragelement",
                    needFocus: false,
                    text: self.getLocString("survey.drag"),
                    onClick: function (selObj) { }
                });
            }
            self.onDefineElementMenuItems.fire(self, options);
        });
        this.onDesignerSurveyCreated.fire(this, { survey: this.surveyValue() });
        this.survey.render(this.surveyjs);
        this.surveyObjects.survey = this.survey;
        this.pages(this.survey.pages);
        this.surveyValue().onSelectedElementChanged.add(function (sender, options) {
            self.surveyObjects.selectObject(sender["selectedElement"]);
        });
        this.surveyValue().onEditButtonClick.add(function (sender) {
            self.showQuestionEditor(self.koSelectedObject().value);
        });
        this.surveyValue().onElementDoubleClick.add(function (sender, options) {
            self.onElementDoubleClick.fire(self, options);
        });
        this.surveyValue().onProcessHtml.add(function (sender, options) {
            options.html = self.processHtml(options.html);
        });
        this.surveyValue().onQuestionAdded.add(function (sender, options) {
            self.doOnQuestionAdded(options.question, options.parentPanel);
        });
        this.surveyValue().onQuestionRemoved.add(function (sender, options) {
            self.doOnElementRemoved(options.question);
        });
        this.surveyValue().onPanelAdded.add(function (sender, options) {
            self.doOnPanelAdded(options.panel, options.parentPanel);
        });
        this.surveyValue().onPanelRemoved.add(function (sender, options) {
            self.doOnElementRemoved(options.panel);
        });
        var pAdded = this.surveyValue()["onPageAdded"];
        if (pAdded && pAdded.add) {
            pAdded.add(function (sender, options) {
                self.doOnPageAdded(options.page);
            });
        }
    };
    SurveyEditor.prototype.processHtml = function (html) {
        if (!html)
            return html;
        var scriptRegEx = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
        while (scriptRegEx.test(html)) {
            html = html.replace(scriptRegEx, "");
        }
        return html;
    };
    SurveyEditor.prototype.doDraggingToolboxItem = function (json, e) {
        this.dragDropHelper.startDragToolboxItem(e, this.getNewName(json["type"]), json);
    };
    SurveyEditor.prototype.doClickToolboxItem = function (json) {
        var newElement = this.createNewElement(json);
        this.doClickQuestionCore(newElement);
    };
    SurveyEditor.prototype.copyElement = function (element) {
        var json = new __WEBPACK_IMPORTED_MODULE_15_survey_knockout__["JsonObject"]().toJsonObject(element);
        json.type = element.getType();
        return this.createNewElement(json);
    };
    SurveyEditor.prototype.getRows = function (pnl) {
        return !!pnl["koRows"] ? pnl["koRows"]() : pnl.rows;
    };
    SurveyEditor.prototype.dragOverQuestionsEditor = function (data, e) {
        data.survey.dragDropHelper.doDragDropOver(e, data.survey.currentPage);
        return false;
    };
    SurveyEditor.prototype.dropOnQuestionsEditor = function (data, e) {
        data.survey.dragDropHelper.doDrop(e);
    };
    SurveyEditor.prototype.createNewElement = function (json) {
        var newElement = __WEBPACK_IMPORTED_MODULE_15_survey_knockout__["JsonObject"].metaData.createClass(json["type"]);
        new __WEBPACK_IMPORTED_MODULE_15_survey_knockout__["JsonObject"]().toObject(json, newElement);
        this.setNewNames(newElement);
        return newElement;
    };
    SurveyEditor.prototype.setNewNames = function (element) {
        this.newQuestions = [];
        this.newPanels = [];
        this.setNewNamesCore(element);
    };
    SurveyEditor.prototype.setNewNamesCore = function (element) {
        var elType = element["getType"]();
        element.name = this.getNewName(elType);
        if (element.isPanel || elType == "page") {
            if (element.isPanel) {
                this.newPanels.push(element);
            }
            var panel = element;
            for (var i = 0; i < panel.elements.length; i++) {
                this.setNewNamesCore(panel.elements[i]);
            }
        }
        else {
            this.newQuestions.push(element);
        }
    };
    SurveyEditor.prototype.generateUniqueName = function (el, newName) {
        while (!this.isNameUnique(el, newName)) {
            newName = __WEBPACK_IMPORTED_MODULE_11__surveyHelper__["b" /* SurveyHelper */].generateNewName(newName);
        }
        return newName;
    };
    SurveyEditor.prototype.isNameUnique = function (el, newName) {
        if (!this.isNameUniqueInArray(this.survey.pages, el, newName))
            return false;
        if (!this.isNameUniqueInArray(this.survey.getAllPanels(), el, newName))
            return false;
        return this.isNameUniqueInArray(this.survey.getAllQuestions(), el, newName);
    };
    SurveyEditor.prototype.isNameUniqueInArray = function (elements, el, newName) {
        newName = newName.toLowerCase();
        for (var i = 0; i < elements.length; i++) {
            if (elements[i] != el && elements[i].name.toLowerCase() == newName)
                return false;
        }
        return true;
    };
    SurveyEditor.prototype.getNewName = function (type) {
        if (type == "page")
            return __WEBPACK_IMPORTED_MODULE_11__surveyHelper__["b" /* SurveyHelper */].getNewPageName(this.pages());
        return type == "panel" || type == "flowpanel"
            ? this.getNewPanelName()
            : this.getNewQuestionName();
    };
    SurveyEditor.prototype.getNewQuestionName = function () {
        return __WEBPACK_IMPORTED_MODULE_11__surveyHelper__["b" /* SurveyHelper */].getNewQuestionName(this.getAllQuestions());
    };
    SurveyEditor.prototype.getNewPanelName = function () {
        return __WEBPACK_IMPORTED_MODULE_11__surveyHelper__["b" /* SurveyHelper */].getNewPanelName(this.getAllPanels());
    };
    SurveyEditor.prototype.getAllQuestions = function () {
        var result = [];
        for (var i = 0; i < this.pages().length; i++) {
            this.addElements(this.pages()[i].elements, false, result);
        }
        this.addElements(this.newPanels, false, result);
        this.addElements(this.newQuestions, false, result);
        return result;
    };
    SurveyEditor.prototype.getAllPanels = function () {
        var result = [];
        for (var i = 0; i < this.pages().length; i++) {
            this.addElements(this.pages()[i].elements, true, result);
        }
        this.addElements(this.newPanels, true, result);
        this.addElements(this.newQuestions, true, result);
        return result;
    };
    SurveyEditor.prototype.addElements = function (elements, isPanel, result) {
        for (var i = 0; i < elements.length; i++) {
            if (elements[i].isPanel === isPanel) {
                result.push(elements[i]);
            }
            this.addElements(__WEBPACK_IMPORTED_MODULE_11__surveyHelper__["b" /* SurveyHelper */].getElements(elements[i]), isPanel, result);
        }
    };
    SurveyEditor.prototype.doClickQuestionCore = function (element, modifiedType) {
        if (modifiedType === void 0) { modifiedType = "ADDED_FROM_TOOLBOX"; }
        var parent = this.survey.currentPage;
        var index = -1;
        var elElement = this.survey.selectedElement;
        if (elElement && elElement.parent) {
            parent = elElement.parent;
            index = parent.elements.indexOf(this.survey.selectedElement);
            if (index > -1)
                index++;
        }
        parent.addElement(element, index);
        if (this.renderedElement && this.scrollToNewElement) {
            this.dragDropHelper.scrollToElement((this.renderedElement.querySelector("#" + element["id"])));
        }
        this.setModified({ type: modifiedType, question: element });
    };
    SurveyEditor.prototype.deleteQuestion = function () {
        var question = this.getSelectedObjAsQuestion();
        if (question) {
            this.deleteCurrentObject();
        }
    };
    SurveyEditor.prototype.selectQuestion = function (isUp) {
        var question = this.getSelectedObjAsQuestion();
        if (question) {
            this.surveyObjects.selectNextQuestion(isUp);
        }
    };
    SurveyEditor.prototype.getSelectedObjAsQuestion = function () {
        var obj = this.koSelectedObject().value;
        if (!obj)
            return null;
        return __WEBPACK_IMPORTED_MODULE_11__surveyHelper__["b" /* SurveyHelper */].getObjectType(obj) == __WEBPACK_IMPORTED_MODULE_11__surveyHelper__["a" /* ObjType */].Question
            ? obj
            : null;
    };
    SurveyEditor.prototype.deleteCurrentObject = function () {
        this.deleteObject(this.koSelectedObject().value);
    };
    SurveyEditor.prototype.editCurrentObject = function () {
        this.showQuestionEditor(this.koSelectedObject().value);
    };
    SurveyEditor.prototype.convertCurrentObject = function (obj, className) {
        var newQuestion = __WEBPACK_IMPORTED_MODULE_6__questionconverter__["a" /* QuestionConverter */].convertObject(obj, className);
        this.setModified({
            type: "QUESTION_CONVERTED",
            className: className,
            oldValue: obj,
            newValue: newQuestion
        });
    };
    /**
     * Show the Editor dialog. The element can be a question, panel, page or survey
     * @param element The survey element
     */
    SurveyEditor.prototype.showElementEditor = function (element, onClose) {
        this.showQuestionEditor(element, onClose);
    };
    SurveyEditor.prototype.onQuestionEditorChanged = function (question) {
        if (!!question.name && !this.isNameUnique(question, question.name)) {
            question.name = this.generateUniqueName(question, question.name);
        }
        this.surveyObjects.nameChanged(question);
        this.selectedObjectEditorValue.objectChanged();
        this.dirtyPageUpdate(); //TODO why this is need ? (ko problem)
        this.setModified({
            type: "QUESTION_CHANGED_BY_EDITOR",
            question: question
        });
        //question.endLoadingFromJson();
        //this.survey.endLoadingFromJson();
    };
    /**
     * Add a question into Toolbox object
     * @param question an added Survey.Question
     * @see toolbox
     */
    SurveyEditor.prototype.addCustomToolboxQuestion = function (question) {
        var options = {};
        this.onCustomElementAddingIntoToolbox.fire(this, {
            element: question,
            itemOptions: options
        });
        this.toolbox.addCopiedItem(question, options);
        this.onCustomElementAddedIntoToolbox.fire(this, { element: question });
    };
    /**
     * Copy a question to the active page
     * @param question A copied Survey.Question
     */
    SurveyEditor.prototype.fastCopyQuestion = function (question) {
        var newElement = this.copyElement(question);
        this.doClickQuestionCore(newElement, "ELEMENT_COPIED");
    };
    /**
     * Delete an element in the survey. It can be a question, a panel or a page.
     * @param element a survey element.
     */
    SurveyEditor.prototype.deleteElement = function (element) {
        this.deleteObject(element);
    };
    SurveyEditor.prototype.deleteObject = function (obj) {
        var options = {
            element: obj,
            elementType: __WEBPACK_IMPORTED_MODULE_11__surveyHelper__["b" /* SurveyHelper */].getObjectType(obj),
            allowing: true
        };
        this.onElementDeleting.fire(this, options);
        if (!options.allowing)
            return;
        this.surveyObjects.removeObject(obj);
        var objType = __WEBPACK_IMPORTED_MODULE_11__surveyHelper__["b" /* SurveyHelper */].getObjectType(obj);
        if (objType == __WEBPACK_IMPORTED_MODULE_11__surveyHelper__["a" /* ObjType */].Page) {
            this.survey.removePage(obj);
        }
        else {
            this.survey.currentPage.removeElement(obj);
            this.survey.selectedElement = null;
            this.surveyObjects.selectObject(this.survey.currentPage);
        }
        this.setModified({
            type: "OBJECT_DELETED",
            target: obj
        });
    };
    SurveyEditor.prototype.showLiveSurvey = function () {
        var self = this;
        this.surveyLive.onSurveyCreatedCallback = function (survey) {
            self.onTestSurveyCreated.fire(self, { survey: survey });
        };
        this.surveyLive.setJSON(this.getSurveyJSON());
        this.surveyLive.show();
    };
    SurveyEditor.prototype.showSurveyEmbeding = function () {
        var json = this.getSurveyJSON();
        this.surveyEmbeding.json = json;
        this.surveyEmbeding.surveyId = this.surveyId;
        this.surveyEmbeding.surveyPostId = this.surveyPostId;
        this.surveyEmbeding.generateValidJSON =
            this.options && this.options.generateValidJSON;
        this.surveyEmbeding.show();
    };
    SurveyEditor.prototype.showSurveyTranslation = function () {
        this.translation.survey = this.survey;
    };
    SurveyEditor.prototype.getSurveyJSON = function () {
        if (this.koIsShowDesigner() || this.koViewType() == "translation")
            return new __WEBPACK_IMPORTED_MODULE_15_survey_knockout__["JsonObject"]().toJsonObject(this.survey);
        if (this.jsonEditor.isJsonCorrect)
            return new __WEBPACK_IMPORTED_MODULE_15_survey_knockout__["JsonObject"]().toJsonObject(this.jsonEditor.survey);
        return null;
    };
    SurveyEditor.prototype.createAnnotations = function (text, errors) {
        var annotations = new Array();
        for (var i = 0; i < errors.length; i++) {
            var error = errors[i];
            var annotation = {
                row: error.position.start.row,
                column: error.position.start.column,
                text: error.text,
                type: "error"
            };
            annotations.push(annotation);
        }
        return annotations;
    };
    Object.defineProperty(SurveyEditor.prototype, "alwaySaveTextInPropertyEditors", {
        //implements ISurveyObjectEditorOptions
        get: function () {
            return this.alwaySaveTextInPropertyEditorsValue;
        },
        set: function (value) {
            this.alwaySaveTextInPropertyEditorsValue = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyEditor.prototype, "showApplyButtonInEditors", {
        get: function () {
            return this.showApplyButtonValue;
        },
        set: function (value) {
            this.showApplyButtonValue = value;
        },
        enumerable: true,
        configurable: true
    });
    SurveyEditor.prototype.onIsEditorReadOnlyCallback = function (obj, editor, readOnly) {
        if (this.onGetPropertyReadOnly.isEmpty)
            return readOnly;
        var options = {
            obj: obj,
            property: editor.property,
            readOnly: readOnly,
            propertyName: editor.property.name
        };
        this.onGetPropertyReadOnly.fire(this, options);
        return options.readOnly;
    };
    SurveyEditor.prototype.onItemValueAddedCallback = function (propertyName, itemValue, itemValues) {
        var options = {
            propertyName: propertyName,
            newItem: itemValue,
            itemValues: itemValues
        };
        this.onItemValueAdded.fire(this, options);
    };
    SurveyEditor.prototype.onMatrixDropdownColumnAddedCallback = function (matrix, column, columns) {
        var options = { newColumn: column, matrix: matrix, columns: columns };
        this.onMatrixColumnAdded.fire(this, options);
    };
    SurveyEditor.prototype.onSetPropertyEditorOptionsCallback = function (propertyName, obj, editorOptions) {
        var options = {
            propertyName: propertyName,
            obj: obj,
            editorOptions: editorOptions
        };
        this.onSetPropertyEditorOptions.fire(this, options);
    };
    SurveyEditor.prototype.onGetErrorTextOnValidationCallback = function (propertyName, obj, value) {
        var options = {
            propertyName: propertyName,
            obj: obj,
            value: value,
            error: ""
        };
        this.onPropertyValidationCustomError.fire(this, options);
        return options.error;
    };
    SurveyEditor.prototype.onValueChangingCallback = function (options) {
        this.onPropertyValueChanging.fire(this, options);
    };
    SurveyEditor.prototype.onPropertyEditorKeyDownCallback = function (propertyName, obj, editor, event) {
        var options = {
            propertyName: propertyName,
            obj: obj,
            editor: editor,
            event: event
        };
        this.onPropertyEditorKeyDown.fire(this, options);
    };
    SurveyEditor.prototype.onPropertyEditorObjectSetCallback = function (propertyName, obj, editor) {
        var options = { propertyName: propertyName, obj: obj, editor: editor };
        this.onPropertyEditorObjectAssign.fire(this, options);
    };
    SurveyEditor.prototype.onPropertyEditorModalShowDescriptionCallback = function (propertyName, obj) {
        var options = {
            obj: obj,
            propertyName: propertyName,
            htmlTop: "",
            htmlBottom: ""
        };
        this.onShowPropertyModalEditorDescription.fire(this, options);
        var res = { top: options.htmlTop, bottom: options.htmlBottom };
        return res;
    };
    SurveyEditor.prototype.onGetElementEditorTitleCallback = function (obj, title) {
        return title;
    };
    SurveyEditor.prototype.onConditionValueSurveyCreatedCallBack = function (valueQuestionName, propertyName, obj, editor, survey) {
        var options = {
            valueQuestionName: valueQuestionName,
            propertyName: propertyName,
            obj: obj,
            editor: editor,
            survey: survey
        };
        this.onConditionValueSurveyCreated.fire(this, options);
    };
    SurveyEditor.prototype.onConditionQuestionsGetListCallback = function (propertyName, obj, editor, list) {
        var options = {
            propertyName: propertyName,
            obj: obj,
            editor: editor,
            list: list
        };
        this.onConditionQuestionsGetList.fire(this, options);
    };
    SurveyEditor.prototype.onAdornerRenderedCallback = function (question, adorner, element, context) {
        var options = {
            survey: this.survey,
            question: question,
            adorner: adorner,
            element: element,
            context: context
        };
        this.onAdornerRendered.fire(this, options);
    };
    /**
     * Upload the files on a server
     * @param files files to upload
     * @param uploadingCallback a call back function to get the status on uploading the file and operation result - URI of the uploaded file
     */
    SurveyEditor.prototype.uploadFiles = function (files, uploadingCallback) {
        if (this.onUploadFile.isEmpty) {
            var fileReader_1 = new FileReader();
            fileReader_1.onload = function (e) {
                uploadingCallback("success", fileReader_1.result);
            };
            fileReader_1.readAsDataURL(files[0]);
        }
        else {
            this.onUploadFile.fire(this, {
                files: files || [],
                callback: uploadingCallback
            });
        }
    };
    SurveyEditor.defaultNewSurveyText = "{ pages: [ { name: 'page1'}] }";
    return SurveyEditor;
}());

__WEBPACK_IMPORTED_MODULE_0_knockout__["components"].register("survey-widget", {
    viewModel: function (params) {
        this.survey = params.survey;
    },
    template: "<!-- ko template: { name: 'survey-content', data: survey, afterRender: $parent.koEventAfterRender } --><!-- /ko -->"
});
__WEBPACK_IMPORTED_MODULE_0_knockout__["components"].register("svg-icon", {
    viewModel: {
        createViewModel: function (params, componentInfo) {
            __WEBPACK_IMPORTED_MODULE_0_knockout__["computed"](function () {
                var size = (__WEBPACK_IMPORTED_MODULE_0_knockout__["unwrap"](params.size) || 16) + "px";
                var svgElem = componentInfo.element.childNodes[0];
                svgElem.style.width = size;
                svgElem.style.height = size;
                var node = svgElem.childNodes[0];
                node.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", "#" + __WEBPACK_IMPORTED_MODULE_0_knockout__["unwrap"](params.iconName));
            });
        }
    },
    template: "<svg class='svd-svg-icon'><use></use></svg>"
});


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_custom_checkbox_scss__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_custom_checkbox_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utils_custom_checkbox_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_custom_select_scss__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_custom_select_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__utils_custom_select_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_ddmenu_scss__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_ddmenu_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__utils_ddmenu_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main_scss__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__main_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__localization_english__ = __webpack_require__(24);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "enStrings", function() { return __WEBPACK_IMPORTED_MODULE_4__localization_english__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__editorLocalization__ = __webpack_require__(0);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "editorLocalization", function() { return __WEBPACK_IMPORTED_MODULE_5__editorLocalization__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultStrings", function() { return __WEBPACK_IMPORTED_MODULE_5__editorLocalization__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dragdrophelper__ = __webpack_require__(23);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DragDropHelper", function() { return __WEBPACK_IMPORTED_MODULE_6__dragdrophelper__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__propertyEditors_propertyEditorBase__ = __webpack_require__(13);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyPropertyEditorBase", function() { return __WEBPACK_IMPORTED_MODULE_7__propertyEditors_propertyEditorBase__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__propertyEditors_propertyCustomEditor__ = __webpack_require__(26);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyPropertyCustomEditor", function() { return __WEBPACK_IMPORTED_MODULE_8__propertyEditors_propertyCustomEditor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__propertyEditors_propertyEditorFactory__ = __webpack_require__(4);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyPropertyEditorFactory", function() { return __WEBPACK_IMPORTED_MODULE_9__propertyEditors_propertyEditorFactory__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyStringPropertyEditor", function() { return __WEBPACK_IMPORTED_MODULE_9__propertyEditors_propertyEditorFactory__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyDropdownPropertyEditor", function() { return __WEBPACK_IMPORTED_MODULE_9__propertyEditors_propertyEditorFactory__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyBooleanPropertyEditor", function() { return __WEBPACK_IMPORTED_MODULE_9__propertyEditors_propertyEditorFactory__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyNumberPropertyEditor", function() { return __WEBPACK_IMPORTED_MODULE_9__propertyEditors_propertyEditorFactory__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__propertyEditors_propertyTextItemsEditor__ = __webpack_require__(69);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyPropertyTextItemsEditor", function() { return __WEBPACK_IMPORTED_MODULE_10__propertyEditors_propertyTextItemsEditor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__propertyEditors_propertyItemsEditor__ = __webpack_require__(14);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyPropertyItemsEditor", function() { return __WEBPACK_IMPORTED_MODULE_11__propertyEditors_propertyItemsEditor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__propertyEditors_propertyItemValuesEditor__ = __webpack_require__(65);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyPropertyItemValuesEditor", function() { return __WEBPACK_IMPORTED_MODULE_12__propertyEditors_propertyItemValuesEditor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__propertyEditors_propertyMultipleValuesEditor__ = __webpack_require__(67);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyPropertyMultipleValuesEditor", function() { return __WEBPACK_IMPORTED_MODULE_13__propertyEditors_propertyMultipleValuesEditor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__propertyEditors_propertyNestedPropertyEditor__ = __webpack_require__(15);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyNestedPropertyEditor", function() { return __WEBPACK_IMPORTED_MODULE_14__propertyEditors_propertyNestedPropertyEditor__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyNestedPropertyEditorItem", function() { return __WEBPACK_IMPORTED_MODULE_14__propertyEditors_propertyNestedPropertyEditor__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__propertyEditors_propertyMatrixDropdownColumnsEditor__ = __webpack_require__(66);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyPropertyDropdownColumnsEditor", function() { return __WEBPACK_IMPORTED_MODULE_15__propertyEditors_propertyMatrixDropdownColumnsEditor__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyPropertyMatrixDropdownColumnsItem", function() { return __WEBPACK_IMPORTED_MODULE_15__propertyEditors_propertyMatrixDropdownColumnsEditor__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__propertyEditors_propertyModalEditor__ = __webpack_require__(7);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyPropertyModalEditor", function() { return __WEBPACK_IMPORTED_MODULE_16__propertyEditors_propertyModalEditor__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyPropertyTextEditor", function() { return __WEBPACK_IMPORTED_MODULE_16__propertyEditors_propertyModalEditor__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyPropertyHtmlEditor", function() { return __WEBPACK_IMPORTED_MODULE_16__propertyEditors_propertyModalEditor__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__propertyEditors_propertyConditionEditor__ = __webpack_require__(25);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyPropertyConditionEditor", function() { return __WEBPACK_IMPORTED_MODULE_17__propertyEditors_propertyConditionEditor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__propertyEditors_propertyRestfullEditor__ = __webpack_require__(68);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyPropertyResultfullEditor", function() { return __WEBPACK_IMPORTED_MODULE_18__propertyEditors_propertyRestfullEditor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__propertyEditors_propertyDefaultValueEditor__ = __webpack_require__(27);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyPropertyDefaultValueEditor", function() { return __WEBPACK_IMPORTED_MODULE_19__propertyEditors_propertyDefaultValueEditor__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyPropertyDefaultRowValueEditor", function() { return __WEBPACK_IMPORTED_MODULE_19__propertyEditors_propertyDefaultValueEditor__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyPropertyDefaultPanelValueEditor", function() { return __WEBPACK_IMPORTED_MODULE_19__propertyEditors_propertyDefaultValueEditor__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__propertyEditors_propertyTriggersEditor__ = __webpack_require__(70);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyPropertyTriggersEditor", function() { return __WEBPACK_IMPORTED_MODULE_20__propertyEditors_propertyTriggersEditor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__propertyEditors_propertyValidatorsEditor__ = __webpack_require__(71);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyPropertyValidatorsEditor", function() { return __WEBPACK_IMPORTED_MODULE_21__propertyEditors_propertyValidatorsEditor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__propertyEditors_propertyCellsEditor__ = __webpack_require__(64);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyPropertyCellsEditor", function() { return __WEBPACK_IMPORTED_MODULE_22__propertyEditors_propertyCellsEditor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__surveyObjects__ = __webpack_require__(32);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyObjects", function() { return __WEBPACK_IMPORTED_MODULE_23__surveyObjects__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__questionEditors_questionEditorProperties__ = __webpack_require__(28);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionEditorProperties", function() { return __WEBPACK_IMPORTED_MODULE_24__questionEditors_questionEditorProperties__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionEditorRow", function() { return __WEBPACK_IMPORTED_MODULE_24__questionEditors_questionEditorProperties__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionEditorProperty", function() { return __WEBPACK_IMPORTED_MODULE_24__questionEditors_questionEditorProperties__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__questionEditors_questionEditorDefinition__ = __webpack_require__(16);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionEditorDefinition", function() { return __WEBPACK_IMPORTED_MODULE_25__questionEditors_questionEditorDefinition__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__questionEditors_questionEditor__ = __webpack_require__(10);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyPropertyEditorShowWindow", function() { return __WEBPACK_IMPORTED_MODULE_26__questionEditors_questionEditor__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionEditor", function() { return __WEBPACK_IMPORTED_MODULE_26__questionEditors_questionEditor__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionEditorTab", function() { return __WEBPACK_IMPORTED_MODULE_26__questionEditors_questionEditor__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__questionToolbox__ = __webpack_require__(29);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionToolbox", function() { return __WEBPACK_IMPORTED_MODULE_27__questionToolbox__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__objectProperty__ = __webpack_require__(12);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyObjectProperty", function() { return __WEBPACK_IMPORTED_MODULE_28__objectProperty__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__objectEditor__ = __webpack_require__(18);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyObjectEditor", function() { return __WEBPACK_IMPORTED_MODULE_29__objectEditor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pagesEditor__ = __webpack_require__(63);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PagesEditor", function() { return __WEBPACK_IMPORTED_MODULE_30__pagesEditor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__textWorker__ = __webpack_require__(20);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyTextWorker", function() { return __WEBPACK_IMPORTED_MODULE_31__textWorker__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__surveyHelper__ = __webpack_require__(6);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ObjType", function() { return __WEBPACK_IMPORTED_MODULE_32__surveyHelper__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyHelper", function() { return __WEBPACK_IMPORTED_MODULE_32__surveyHelper__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__surveylive__ = __webpack_require__(33);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyLiveTester", function() { return __WEBPACK_IMPORTED_MODULE_33__surveylive__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__surveyEmbedingWindow__ = __webpack_require__(31);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyEmbedingWindow", function() { return __WEBPACK_IMPORTED_MODULE_34__surveyEmbedingWindow__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__questionconverter__ = __webpack_require__(30);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionConverter", function() { return __WEBPACK_IMPORTED_MODULE_35__questionconverter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__undoredo__ = __webpack_require__(35);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyUndoRedo", function() { return __WEBPACK_IMPORTED_MODULE_36__undoredo__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "UndoRedoItem", function() { return __WEBPACK_IMPORTED_MODULE_36__undoredo__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__surveyjsObjects__ = __webpack_require__(5);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyForDesigner", function() { return __WEBPACK_IMPORTED_MODULE_37__surveyjsObjects__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "registerAdorner", function() { return __WEBPACK_IMPORTED_MODULE_37__surveyjsObjects__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "removeAdorners", function() { return __WEBPACK_IMPORTED_MODULE_37__surveyjsObjects__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__extentions__ = __webpack_require__(48);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Extentions", function() { return __WEBPACK_IMPORTED_MODULE_38__extentions__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__editor__ = __webpack_require__(46);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyEditor", function() { return __WEBPACK_IMPORTED_MODULE_39__editor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__manage__ = __webpack_require__(62);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SurveysManager", function() { return __WEBPACK_IMPORTED_MODULE_40__manage__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__stylesmanager__ = __webpack_require__(19);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StylesManager", function() { return __WEBPACK_IMPORTED_MODULE_41__stylesmanager__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__localization_danish__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__localization_french__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__localization_german__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__localization_italian__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__localization_indonesian__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__localization_korean__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__localization_persian__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__localization_polish__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__localization_portuguese__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__localization_simplified_chinese__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__localization_spanish__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__localization_traditional_chinese__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__localization_norwegian__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__translation__ = __webpack_require__(34);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Translation", function() { return __WEBPACK_IMPORTED_MODULE_55__translation__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TranslationGroup", function() { return __WEBPACK_IMPORTED_MODULE_55__translation__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TranslationItem", function() { return __WEBPACK_IMPORTED_MODULE_55__translation__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TranslationItemBase", function() { return __WEBPACK_IMPORTED_MODULE_55__translation__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__adorners_title_editor__ = __webpack_require__(17);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "titleAdorner", function() { return __WEBPACK_IMPORTED_MODULE_56__adorners_title_editor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__adorners_item_editor__ = __webpack_require__(11);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "itemAdorner", function() { return __WEBPACK_IMPORTED_MODULE_57__adorners_item_editor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__adorners_label_editor__ = __webpack_require__(43);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "labelAdorner", function() { return __WEBPACK_IMPORTED_MODULE_58__adorners_label_editor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__adorners_question_actions__ = __webpack_require__(22);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "questionActionsAdorner", function() { return __WEBPACK_IMPORTED_MODULE_59__adorners_question_actions__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__adorners_select_items_editor__ = __webpack_require__(45);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "selectItemsEditorAdorner", function() { return __WEBPACK_IMPORTED_MODULE_60__adorners_select_items_editor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__adorners_rating_item_editor__ = __webpack_require__(44);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ratingItemAdorner", function() { return __WEBPACK_IMPORTED_MODULE_61__adorners_rating_item_editor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__adorners_image_items__ = __webpack_require__(42);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "imageItemsAdorner", function() { return __WEBPACK_IMPORTED_MODULE_62__adorners_image_items__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__adorners_flowpanel_actions__ = __webpack_require__(41);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "flowpanelActionsAdorner", function() { return __WEBPACK_IMPORTED_MODULE_63__adorners_flowpanel_actions__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__utils_accordion__ = __webpack_require__(72);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AccordionItemModel", function() { return __WEBPACK_IMPORTED_MODULE_64__utils_accordion__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AccordionModel", function() { return __WEBPACK_IMPORTED_MODULE_64__utils_accordion__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__utils_splitter__ = __webpack_require__(73);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SplitterComponentViewModel", function() { return __WEBPACK_IMPORTED_MODULE_65__utils_splitter__["a"]; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Version", function() { return Version; });
// styles




var Version;
Version = "" + "1.0.72";








































//editorLocalization














//adorners












/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__propertyEditors_propertyEditorFactory__ = __webpack_require__(4);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Extentions; });

var Extentions = /** @class */ (function () {
    function Extentions() {
    }
    Extentions.registerCustomPropertyEditor = function (name, widgetJSON) {
        __WEBPACK_IMPORTED_MODULE_0__propertyEditors_propertyEditorFactory__["a" /* SurveyPropertyEditorFactory */].registerCustomEditor(name, widgetJSON);
    };
    Extentions.registerPropertyEditor = function (name, creator) {
        __WEBPACK_IMPORTED_MODULE_0__propertyEditors_propertyEditorFactory__["a" /* SurveyPropertyEditorFactory */].registerEditor(name, creator);
    };
    return Extentions;
}());



/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__editorLocalization__ = __webpack_require__(0);
/* unused harmony export danishStrings */

var danishStrings = {
    //survey templates
    survey: {
        edit: "Rediger",
        dropQuestion: "Træk et spørgsmål hertil fra paletten til venstre.",
        copy: "Kopier",
        addToToolbox: "Tilføj til paletten",
        deletePanel: "Slet panel",
        deleteQuestion: "Slet spørgsmål",
        convertTo: "Konverter til",
        drag: "Træk element"
    },
    //questionTypes
    qt: {
        default: "Standard",
        checkbox: "Afkrydsningsfelt",
        comment: "Kommentar",
        imagepicker: "Billedvælger",
        dropdown: "Dropdown",
        file: "Fil",
        html: "Html",
        matrix: "Matrice (ét valg)",
        matrixdropdown: "Matrice (flere valg)",
        matrixdynamic: "Matrice (dynamiske rækker)",
        multipletext: "Flere tekstfelter",
        panel: "Panel",
        paneldynamic: "Panel (dynamiske paneler)",
        radiogroup: "Alternativknap",
        rating: "Vurdering",
        text: "Tekstfelt",
        boolean: "Sandt/falsk",
        expression: "Udtryk"
    },
    //Strings in Editor
    ed: {
        defaultLocale: "Standard ({0})",
        survey: "Undersøgelse",
        settings: "Indstillinger for undersøgelse",
        editSurvey: "Rediger undersøgelse",
        addNewPage: "Tilføj ny side",
        moveRight: "Gå til højre",
        moveLeft: "Gå til venstre",
        deletePage: "Slet side",
        editPage: "Rediger side",
        edit: "Rediger",
        newPageName: "side",
        newQuestionName: "spørgsmål",
        newPanelName: "panel",
        testSurvey: "Afprøv undersøgelse",
        testSurveyAgain: "Afprøv undersøgelse igen",
        testSurveyWidth: "Bredde af undersøgelse: ",
        embedSurvey: "Indlejr undersøgelse",
        translation: "Oversættelse",
        saveSurvey: "Gem undersøgelse",
        designer: "Undersøgelsesdesigner",
        jsonEditor: "JSON Editor",
        undo: "Fortryd",
        redo: "Annuller fortryd",
        options: "Indstillinger",
        generateValidJSON: "Generer gylding JSON",
        generateReadableJSON: "Generer læsbar JSON",
        toolbox: "Værktøjskasse",
        toolboxGeneralCategory: "Generelt",
        delSelObject: "Slet valgt objekt",
        editSelObject: "Rediger valgt objekt",
        correctJSON: "Ret venligst JSON.",
        surveyResults: "Undersøgelsesresultat: ",
        modified: "Ændret",
        saving: "Gemmer",
        saved: "Gemt",
        saveError: "Fejl! Undersøgelsen er ikke blevet gemt.",
        translationAddLanguage: "Vælg et sprog at oversætte",
        translationShowAllStrings: "Vis alle tekststrenge",
        translationShowAllPages: "Vis alle sider",
        translationNoStrings: "Ingen tekststrenge at oversætte. Ret filteret.",
        translationExportToSCVButton: "Eksporter til CSV",
        translationImportFromSCVButton: "Importer fra CSV",
        translationMergeLocaleWithDefault: "Flet {0} med standardsprog"
    },
    //Property names in table headers
    pel: {
        isRequired: "Påkrævet?"
    },
    //Property Editors
    pe: {
        apply: "Anvend",
        ok: "OK",
        cancel: "Annuller",
        reset: "Nulstil",
        close: "Luk",
        delete: "Slet",
        addNew: "Tilføj ny",
        addItem: "Klik for at tilføje...",
        removeAll: "Fjern alle",
        edit: "Rediger",
        itemValueEdit: "Synlig hvis",
        editChoices: "Rediger valgmuligheder",
        move: "Flyt",
        empty: "<tom>",
        notEmpty: "<redigér værdi>",
        fastEntry: "Fast Entry",
        formEntry: "Form Entry",
        testService: "Test the service",
        conditionSelectQuestion: "Vælg spørgsmål...",
        conditionValueQuestionTitle: "Indtast/vælg værdi",
        conditionButtonAdd: "Tilføj",
        conditionButtonReplace: "Erstat",
        conditionHelp: "Indtast et boolsk udtryk. Det skal returnere true for at holde spørgsmålet/siden synlig. For eksempel: {question1} = 'value1' or ({question2} * {question4}  > 20 and {question3} < 5)",
        expressionHelp: "Indtast et udtryk. Du kan bruge krølle-parenteser for at få adgang til svarene: '{question1} + {question2}', '({price}*{quantity}) * (100 - {discount})'",
        aceEditorHelp: "Tast ctrl+space for hjælp til at afslutte udtrykket",
        aceEditorRowTitle: "Aktuel række",
        aceEditorPanelTitle: "Aktuelt panel",
        showMore: "Se dokumentationen for flere informationer",
        conditionShowMoreUrl: "https://surveyjs.io/Documentation/LibraryParameter?id=Question&parameter=visibleIf",
        assistantTitle: "Tilgængelige spørgsmål:",
        cellsEmptyRowsColumns: "Der skal være mindst én kolonne eller række",
        propertyIsEmpty: "Indtast en værdi",
        value: "Værdi",
        text: "Tekst",
        rowid: "Række ID",
        imageLink: "Billedlink",
        columnEdit: "Rediger kolonne: {0}",
        itemEdit: "Redigér: {0}",
        url: "URL",
        path: "Sti",
        valueName: "Værdiens navn",
        titleName: "Titelnavn",
        hasOther: "Har andet element",
        otherText: "Andet element tekst",
        name: "Navn",
        title: "Titel",
        cellType: "Celletype",
        colCount: "Antal kolonner",
        choicesOrder: "Vælg rækkefølge på valg",
        visible: "Er synlig?",
        isRequired: "Er påkrævet?",
        startWithNewLine: "Skal starte med ny linie?",
        rows: "Antal rækker",
        placeHolder: "Hint-tekst",
        showPreview: "Vises forhåndsvisning af billeder?",
        storeDataAsText: "Gem filindhold i JSON-resultat som tekst",
        maxSize: "Maksimal filstørrelse i bytes",
        imageHeight: "Billedhøjde",
        imageWidth: "Billedbredde",
        rowCount: "Antal rækker",
        columnLayout: "Kolonnelayout",
        addRowLocation: "Tilføj række knapplacering",
        addRowText: "Tilføj række knaptekst",
        removeRowText: "Fjern række knaptekst",
        minRateDescription: "Beskriv laveste vurdering",
        maxRateDescription: "Beskriv højeste vurdering",
        inputType: "Inputtype",
        optionsCaption: "Muligheder tekst",
        defaultValue: "Standardværdi",
        cellsDefaultRow: "Standard celletekst",
        surveyEditorTitle: "Rediger undersøgelsesindstillinger",
        qEditorTitle: "Redigér: {0}",
        maxLength: "Maximal længde",
        //survey
        showTitle: "Vis/skjul titel",
        locale: "Standardsprog",
        mode: "Mode (rediger/skrivebeskyttet)",
        clearInvisibleValues: "Fjern usynlige værdier",
        cookieName: "Cookienavn (for at undgå at afvikle undersøgelsen to gange lokalt)",
        sendResultOnPageNext: "Send undersøgelsesresultatet ved næste side",
        storeOthersAsComment: "Gem 'others' værdien i et seperat felt",
        showPageTitles: "Vis sidetitler",
        showPageNumbers: "Vis sidenumre",
        pagePrevText: "Forrige side knaptekst",
        pageNextText: "Næste side knaptekst",
        completeText: "Færdig knaptekst",
        startSurveyText: "Start knaptekst",
        showNavigationButtons: "Vis navigationsknapper (standard navigation)",
        showPrevButton: "Vis forrige knap (brugeren må gå tilbage til forrige side)",
        firstPageIsStarted: "Den første side in undersøgelsen er starten på undersøgelsen.",
        showCompletedPage: "Vis afslutningssiden til slut (completedHtml)",
        goNextPageAutomatic: "Gå til næste side automatisk når alle spørgsmål er besvaret",
        showProgressBar: "Vis fremdriftslinje",
        questionTitleLocation: "Spørgsmålstitel placering",
        requiredText: "Påkrævet spørgsmålssymbol(er)",
        questionStartIndex: "Spørgsmål startindex (1, 2 eller 'A', 'a')",
        showQuestionNumbers: "Vis spørgsmålsnumre",
        questionTitleTemplate: "Spørgsmålstitel template, standard er: '{no}. {require} {title}'",
        questionErrorLocation: "Spørgsmålsfejl placering",
        focusFirstQuestionAutomatic: "Fokusér første spørgsmål ved sideskift",
        questionsOrder: "Rækkefølge af spørgsmål på siden",
        maxTimeToFinish: "Maximal tid til at gennemføre undersøgelsen",
        maxTimeToFinishPage: "Maximal tid til at gennemføre en side i undersøgelsen",
        showTimerPanel: "Vis tidspanel",
        showTimerPanelMode: "Vis tidspanel tilstand",
        renderMode: "Renderingstilstand",
        allowAddPanel: "Tillad at tilføje et panel",
        allowRemovePanel: "Tillad at fjerne et panel",
        panelAddText: "Tilføj panel tekst",
        panelRemoveText: "Fjern panel tekst",
        isSinglePage: "Vis alle elementer på én side",
        tabs: {
            general: "Generelt",
            fileOptions: "Indstillinger",
            html: "Html-editor",
            columns: "Kolonner",
            rows: "Rækker",
            choices: "Valgmuligheder",
            items: "Elementer",
            visibleIf: "Synlig hvis",
            enableIf: "Aktiv hvis",
            rateValues: "Bedøm-værdier",
            choicesByUrl: "Valgmuligheder fra Web",
            matrixChoices: "Standard valgmuligheder",
            multipleTextItems: "Tekst inputmuligheder",
            validators: "Valideringer",
            navigation: "Navigation",
            question: "Spørgsmål",
            completedHtml: "Færdig Html",
            loadingHtml: "Indlæser Html",
            timer: "Tid/Quiz",
            triggers: "Triggere",
            templateTitle: "Skabelon titel"
        },
        editProperty: "Rediger egenskab '{0}'",
        items: "[ Element: {0} ]",
        enterNewValue: "Indtast værdien.",
        noquestions: "Der er ingen spørgsmål i undersøgelsen.",
        createtrigger: "Opret en trigger",
        triggerOn: "På ",
        triggerMakePagesVisible: "Gør sider synlige:",
        triggerMakeQuestionsVisible: "Gør spørgsmål synlige:",
        triggerCompleteText: "Aflslut spørgeskema ved at fortsætte.",
        triggerNotSet: "Triggerer er ikke sat",
        triggerRunIf: "Afvikl hvis",
        triggerSetToName: "Ændr værdien af: ",
        triggerFromName: "Kopier værdi fra: ",
        triggerRunExpression: "Afvikl dette udtryk:",
        triggerSetValue: "til: ",
        triggerIsVariable: "Gem ikke variablen i undersøgelsesresultatet."
    },
    //Property values
    pv: {
        true: "true",
        false: "false",
        inherit: "inherit",
        show: "show",
        hide: "hide",
        default: "default",
        initial: "initial",
        random: "random",
        collapsed: "collapsed",
        expanded: "expanded",
        none: "none",
        asc: "ascending",
        desc: "descending",
        indeterminate: "indeterminate",
        decimal: "decimal",
        currency: "currency",
        percent: "percent",
        firstExpanded: "firstExpanded",
        off: "off",
        onPanel: "onPanel",
        onSurvey: "onSurvey",
        list: "list",
        progressTop: "progressTop",
        progressBottom: "progressBottom",
        progressTopBottom: "progressTopBottom",
        horizontal: "horizontal",
        vertical: "vertical",
        top: "top",
        bottom: "bottom",
        topBottom: "top and bottom",
        left: "left",
        color: "color",
        date: "date",
        datetime: "datetime",
        "datetime-local": "datetime-local",
        email: "email",
        month: "month",
        number: "number",
        password: "password",
        range: "range",
        tel: "tel",
        text: "text",
        time: "time",
        url: "url",
        week: "week",
        hidden: "hidden",
        on: "on",
        onPage: "onPage",
        edit: "edit",
        display: "display",
        onComplete: "onComplete",
        onHidden: "onHidden",
        all: "all",
        page: "page",
        survey: "survey",
        onNextPage: "onNextPage",
        onValueChanged: "onValueChanged"
    },
    //Operators
    op: {
        empty: "is empty",
        notempty: "is not empty",
        equal: "equals",
        notequal: "not equals",
        contains: "contains",
        notcontains: "not contains",
        greater: "greater",
        less: "less",
        greaterorequal: "greater or equals",
        lessorequal: "less or equals"
    },
    //Embed window
    ew: {
        angular: "Benyt Angular version",
        jquery: "Benyt jQuery version",
        knockout: "Benyt Knockout version",
        react: "Benyt React version",
        vue: "Benyt Vue version",
        bootstrap: "For bootstrap framework",
        standard: "Ingen bootstrap",
        showOnPage: "Vis undersøgelsen på en side",
        showInWindow: "Vis undersøgelsen i et vindue",
        loadFromServer: "Hent undersøgelsen som JSON fra serveren",
        titleScript: "Scripts og styles",
        titleHtml: "HTML",
        titleJavaScript: "JavaScript"
    },
    //Test Survey
    ts: {
        selectPage: "Vælg siden for at teste den:"
    },
    validators: {
        answercountvalidator: "answer count",
        emailvalidator: "e-mail",
        expressionvalidator: "expression",
        numericvalidator: "numeric",
        regexvalidator: "regex",
        textvalidator: "text"
    },
    triggers: {
        completetrigger: "undersøgelse gennemført",
        setvaluetrigger: "sæt værdi",
        copyvaluetrigger: "kopiér værdi",
        runexpressiontrigger: "afvikl udtry",
        visibletrigger: "skift synlighed"
    },
    //Properties
    p: {
        name: "navn",
        title: {
            name: "titel",
            title: "Lad den være tom hvis det er det samme som 'Navn'"
        },
        navigationButtonsVisibility: "navigationButtonsVisibility",
        questionsOrder: "questionsOrder",
        maxTimeToFinish: "maxTimeToFinish",
        visible: "visible",
        visibleIf: "visibleIf",
        questionTitleLocation: "questionTitleLocation",
        description: "description",
        state: "state",
        isRequired: "isRequired",
        indent: "indent",
        requiredErrorText: "requiredErrorText",
        startWithNewLine: "startWithNewLine",
        innerIndent: "innerIndent",
        page: "page",
        width: "width",
        commentText: "commentText",
        valueName: "valueName",
        enableIf: "enableIf",
        defaultValue: "defaultValue",
        correctAnswer: "correctAnswer",
        readOnly: "readOnly",
        validators: "validators",
        titleLocation: "titleLocation",
        hasComment: "hasComment",
        hasOther: "hasOther",
        choices: "choices",
        choicesOrder: "choicesOrder",
        choicesByUrl: "choicesByUrl",
        otherText: "otherText",
        otherErrorText: "otherErrorText",
        storeOthersAsComment: "storeOthersAsComment",
        label: "label",
        showTitle: "showTitle",
        valueTrue: "valueTrue",
        valueFalse: "valueFalse",
        cols: "cols",
        rows: "rows",
        placeHolder: "placeHolder",
        optionsCaption: "optionsCaption",
        expression: "expression",
        format: "format",
        displayStyle: "displayStyle",
        currency: "currency",
        useGrouping: "useGrouping",
        showPreview: "showPreview",
        allowMultiple: "allowMultiple",
        imageHeight: "imageHeight",
        imageWidth: "imageWidth",
        storeDataAsText: "storeDataAsText",
        maxSize: "maxSize",
        html: "html",
        columns: "columns",
        cells: "cells",
        isAllRowRequired: "isAllRowRequired",
        horizontalScroll: "horizontalScroll",
        cellType: "cellType",
        columnsLayout: "columnsLayout",
        columnColCount: "columnColCount",
        columnMinWidth: "columnMinWidth",
        rowCount: "rowCount",
        minRowCount: "minRowCount",
        maxRowCount: "maxRowCount",
        keyName: "keyName",
        keyDuplicationError: "keyDuplicationError",
        confirmDelete: "confirmDelete",
        confirmDeleteText: "confirmDeleteText",
        addRowLocation: "addRowLocation",
        addRowText: "addRowText",
        removeRowText: "removeRowText",
        items: "items",
        itemSize: "itemSize",
        colCount: "colCount",
        templateTitle: "templateTitle",
        templateDescription: "templateDescription",
        allowAddPanel: "allowAddPanel",
        allowRemovePanel: "allowRemovePanel",
        panelCount: "panelCount",
        minPanelCount: "minPanelCount",
        maxPanelCount: "maxPanelCount",
        panelsState: "panelsState",
        panelAddText: "panelAddText",
        panelRemoveText: "panelRemoveText",
        panelPrevText: "panelPrevText",
        panelNextText: "panelNextText",
        showQuestionNumbers: "showQuestionNumbers",
        showRangeInProgress: "showRangeInProgress",
        renderMode: "renderMode",
        templateTitleLocation: "templateTitleLocation",
        rateValues: "rateValues",
        rateMin: "rateMin",
        rateMax: "rateMax",
        rateStep: "rateStep",
        minRateDescription: "minRateDescription",
        maxRateDescription: "maxRateDescription",
        inputType: "inputType",
        size: "size",
        locale: "locale",
        focusFirstQuestionAutomatic: "focusFirstQuestionAutomatic",
        completedHtml: "completedHtml",
        completedBeforeHtml: "completedBeforeHtml",
        loadingHtml: "loadingHtml",
        triggers: "triggers",
        cookieName: "cookieName",
        sendResultOnPageNext: "sendResultOnPageNext",
        showNavigationButtons: "showNavigationButtons",
        showPrevButton: "showPrevButton",
        showPageTitles: "showPageTitles",
        showCompletedPage: "showCompletedPage",
        showPageNumbers: "showPageNumbers",
        questionErrorLocation: "questionErrorLocation",
        showProgressBar: "showProgressBar",
        mode: "mode",
        goNextPageAutomatic: "goNextPageAutomatic",
        checkErrorsMode: "checkErrorsMode",
        clearInvisibleValues: "clearInvisibleValues",
        startSurveyText: "startSurveyText",
        pagePrevText: "pagePrevText",
        pageNextText: "pageNextText",
        completeText: "completeText",
        requiredText: "requiredText",
        questionStartIndex: "questionStartIndex",
        questionTitleTemplate: "questionTitleTemplate",
        firstPageIsStarted: "firstPageIsStarted",
        isSinglePage: "isSinglePage",
        maxTimeToFinishPage: "maxTimeToFinishPage",
        showTimerPanel: "showTimerPanel",
        showTimerPanelMode: "showTimerPanelMode",
        defaultPanelValue: "defaultPanelValue",
        defaultRowValue: "defaultRowValue",
        hasNone: "hasNone",
        noneText: "noneText",
        text: "text",
        minValue: "minimum value",
        maxValue: "maximum value",
        minLength: "minumum length",
        maxLength: "maximum length",
        allowDigits: "allow digits",
        minCount: "minumum count",
        maxCount: "maximum count",
        regex: "regular expression"
    }
};
__WEBPACK_IMPORTED_MODULE_0__editorLocalization__["a" /* editorLocalization */].locales["da"] = danishStrings;


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__editorLocalization__ = __webpack_require__(0);

var frenchTranslation = {
    //Survey templates
    survey: {
        edit: "Éditer",
        dropQuestion: "Déposer votre question ici.",
        copy: "Copier",
        addToToolbox: "Ajouter à la boîte à outils",
        deletePanel: "Supprimer le panneau",
        deleteQuestion: "Supprimer la question",
        convertTo: "Convertir en"
    },
    //questionTypes
    qt: {
        checkbox: "Cases à cocher",
        comment: "Commentaire",
        dropdown: "Liste déroulante",
        file: "Fichier",
        html: "HTML",
        matrix: "Matrice (choix unique)",
        matrixdropdown: "Matrice (choix multiples)",
        matrixdynamic: "Matrice (lignes dynamiques)",
        multipletext: "Champ multilignes",
        panel: "Panneau",
        paneldynamic: "Panneau (panneaux dynamiques)",
        radiogroup: "Boutons radio",
        rating: "Évaluation",
        text: "Champ texte",
        boolean: "Booléen",
        expression: "Expression"
    },
    //Strings in Editor
    ed: {
        survey: "Questionnaire",
        editSurvey: "Éditer le questionnaire",
        addNewPage: "Ajouter une page",
        deletePage: "Supprimer une page",
        editPage: "Éditer une page",
        newPageName: "page",
        newQuestionName: "question",
        newPanelName: "panneau",
        testSurvey: "Tester le questionnaire",
        testSurveyAgain: "Tester à nouveau le questionnaire",
        testSurveyWidth: "Largeur du questionnaire : ",
        embedSurvey: "Intégrer le questionnaire",
        saveSurvey: "Sauvegarder le questionnaire",
        designer: "Éditeur de questionnaire",
        jsonEditor: "Éditer JSON",
        undo: "Annuler",
        redo: "Rétablir",
        options: "Options",
        generateValidJSON: "Générer un JSON valide",
        generateReadableJSON: "Générer un JSON lisible",
        toolbox: "Boîte à outils",
        toolboxGeneralCategory: "Général",
        delSelObject: "Supprimer l'objet sélectionné",
        editSelObject: "Éditer l'objet sélectionné",
        correctJSON: "SVP corrigez le JSON",
        surveyResults: "Résultat du questionnaire : ",
        modified: "Modifié",
        saving: "Sauvegarde en cours",
        saved: "Sauvegardé"
    },
    //Property names in table headers
    pel: {
        isRequired: "Obligatoire ?"
    },
    //Property Editors
    pe: {
        apply: "Appliquer",
        ok: "OK",
        cancel: "Annuler",
        reset: "Réinitialiser",
        close: "Fermer",
        delete: "Supprimer",
        addNew: "Ajouter un nouveau",
        addItem: "Cliquer pour ajouter un item...",
        removeAll: "Tout supprimer",
        edit: "Éditer",
        move: "Déplacer",
        empty: "<vide>",
        notEmpty: "<éditer la valeur>",
        fastEntry: "Ajout rapide",
        formEntry: "Ajout via formulaire",
        testService: "Tester le service",
        conditionSelectQuestion: "Sélectionner une question...",
        conditionButtonAdd: "Ajouter",
        conditionButtonReplace: "Remplacer",
        conditionHelp: 'Veuillez entrer une expression booléenne. Elle doit retourner Vrai(true) pour garder la question/page visible. Par exemple: {question1} = "valeur1" or ({question2} = 3 and {question3} < 5)',
        expressionHelp: "Veuillez entrer une expression. Vous pouvez utiliser des accolades pour accéder aux valeurs des questions '{question1} + {question2}', '({prix}*{quantite}) * (100 - {remise})'",
        aceEditorHelp: "Appuyer sur Ctrl + espace pour obtenir une aide pour la saisie d'expression",
        aceEditorRowTitle: "Ligne courante",
        aceEditorPanelTitle: "Panneau courant",
        showMore: "Pour plus d'informations, veuillez vous référer à la documentation",
        assistantTitle: "Questions disponibles :",
        cellsEmptyRowsColumns: "Il faut au minimum une ligne ou une colonne",
        propertyIsEmpty: "Veuillez entrer une valeur pour la propriété",
        value: "Valeur",
        text: "Texte",
        columnEdit: "Éditer la colonne: {0}",
        itemEdit: "Éditer l'item: {0}",
        url: "URL",
        path: "Chemin",
        valueName: "Nom de la valeur",
        titleName: "Nom du titre",
        hasOther: "Contient un autre item",
        otherText: "Autre item texte",
        name: "Nom",
        title: "Titre",
        cellType: "Type de cellule",
        colCount: "Nombre de colonnes",
        choicesOrder: "Sélectionner l'ordre des choix",
        visible: "Est visible ?",
        isRequired: "Est obligatoire ?",
        startWithNewLine: "Commencer avec une nouvelle ligne ?",
        rows: "Nombre de lignes",
        placeHolder: "Placeholder (indice dans le champ)",
        showPreview: "L'aperçu d'image est-il affiché ?",
        storeDataAsText: "Stocker le contenu du fichier dans le résultat JSON sous forme de texte",
        maxSize: "Taille maximum du fichier en octets",
        imageHeight: "Hauteur de l'image",
        imageWidth: "Largeur de l'image",
        rowCount: "Nombre de lignes",
        addRowText: 'Texte bouton "Ajouter une ligne"',
        removeRowText: 'Texte bouton "Supprimer une ligne"',
        minRateDescription: "Description note minimum",
        maxRateDescription: "Description note maximum",
        inputType: "Type de champ",
        optionsCaption: "Texte par défaut",
        defaultValue: "Valeur par défaut",
        cellsDefaultRow: "Texte de cellule par défaut",
        surveyEditorTitle: "Éditer les préférences du questionnaire",
        qEditorTitle: "Éditer la question: {0}",
        //survey
        showTitle: "Afficher/cacher le titre",
        locale: "Langue par défaut",
        mode: "Mode (édition/lecture seule)",
        clearInvisibleValues: "Effacer les valeurs invisibles",
        cookieName: "Nom du cookie (pour empêcher de compléter 2 fois le questionnaire localement)",
        sendResultOnPageNext: "Envoyer les résultats au changement de page",
        storeOthersAsComment: 'Sauvegarder la valeur "Autres" dans un champ séparé',
        showPageTitles: "Afficher les titres de pages",
        showPageNumbers: "Afficher les numéros de pages",
        pagePrevText: "Texte bouton page précédente",
        pageNextText: "Texte bouton page suivante",
        completeText: "Texte bouton terminer",
        startSurveyText: "Texte bouton commencer",
        showNavigationButtons: "Afficher les boutons de navigation (navigation par défaut)",
        showPrevButton: "Afficher le bouton précédent (l'utilisateur pourra retourner sur la page précédente)",
        firstPageIsStarted: "La première page du questionnaire est une page de démarrage.",
        showCompletedPage: 'Afficher la page "terminé" à la fin (completedHtml)',
        goNextPageAutomatic: "Aller à la page suivante automatiquement pour toutes les questions",
        showProgressBar: "Afficher la barre de progression",
        questionTitleLocation: "Emplacement du titre de la question",
        requiredText: "La question requiert un/des symbole(s)",
        questionStartIndex: "Index de départ de la question (1, 2 ou 'A', 'a')",
        showQuestionNumbers: "Afficher les numéros de questions",
        questionTitleTemplate: "Gabarit du titre de question, par défaut : '{no}. {require} {title}'",
        questionErrorLocation: "Emplacement de l'erreur",
        focusFirstQuestionAutomatic: "Focus sur la première question au changement de page",
        questionsOrder: "Ordre des éléments sur la page",
        maxTimeToFinish: "Temps maximum pour terminer le questionnaire",
        maxTimeToFinishPage: "Temps maximum pour terminer une page",
        showTimerPanel: "Afficher le panneau chronomètre",
        showTimerPanelMode: "Mode d'affichage du panneau chronomètre",
        renderMode: "Mode de rendu",
        allowAddPanel: "Autoriser l'ajout du panneau",
        allowRemovePanel: "Autoriser la suppression du panneau",
        panelAddText: "Ajouter un panneau texte",
        panelRemoveText: "Supprimer le panneau texte",
        isSinglePage: "Afficher tous les éléments sur une seule page",
        tabs: {
            general: "Général",
            fileOptions: "Options",
            html: "Éditeur HTML",
            columns: "Colonnes",
            rows: "Lignes",
            choices: "Choix",
            visibleIf: "Visible si",
            enableIf: "Actif si",
            rateValues: "Barème",
            choicesByUrl: "Choix depuis API web",
            matrixChoices: "Choix par défaut",
            multipleTextItems: "Champs texte multiples",
            validators: "Validateurs",
            navigation: "Navigation",
            question: "Question",
            completedHtml: "HTML de fin",
            loadingHtml: "HTML de chargement",
            timer: "Chronomètre/Quiz",
            triggers: "Déclencheurs",
            templateTitle: "Titre de gabarit"
        },
        editProperty: 'Éditer la propriété "{0}"',
        items: "[ Éléments: {0} ]",
        enterNewValue: "Veuillez saisir la valeur.",
        noquestions: "Il n'y a aucune question dans le questionnaire.",
        createtrigger: "Veuillez créer un déclencheur",
        triggerOn: "Quand ",
        triggerMakePagesVisible: "Rendre les pages visibles :",
        triggerMakeQuestionsVisible: "Rendre les questions visibles :",
        triggerCompleteText: "Terminer le questionnaire en cas de succès.",
        triggerNotSet: "Le déclencheur n'est pas défini",
        triggerRunIf: "Exécuter si",
        triggerSetToName: "Changer la valeur de: ",
        triggerSetValue: "à: ",
        triggerIsVariable: "Ne placez pas la variable dans le résultat du questionnaire."
    },
    //Property values
    pv: {
        true: "vrai",
        false: "faux",
        inherit: "hérité",
        show: "afficher",
        hide: "masquer",
        default: "par défaut",
        initial: "initial",
        random: "aléatoire",
        collapsed: "replié",
        expanded: "déployé",
        none: "aucun",
        asc: "ascendant",
        desc: "descendant",
        indeterminate: "indeterminé",
        decimal: "décimal",
        currency: "monnaie",
        percent: "pourcentage",
        firstExpanded: "déployé en premier",
        off: "désactivé",
        onPanel: "panneau",
        onSurvey: "questionnaire",
        list: "liste",
        progressTop: "Progression en haut",
        progressBottom: "Progression en bas",
        progressTopBottom: "Progression en haut et en bas",
        top: "haut",
        bottom: "bas",
        left: "gauche",
        color: "couleur",
        date: "date",
        datetime: "heure",
        "datetime-local": "heure locale",
        email: "email",
        month: "mois",
        number: "nombre",
        password: "mot de passe",
        range: "jauge",
        tel: "tél.",
        text: "texte",
        time: "heure",
        url: "URL",
        week: "semaine",
        hidden: "masqué",
        on: "activé",
        onPage: "page",
        edit: "éditer",
        display: "affichage",
        onComplete: "onComplete",
        onHidden: "onHidden",
        all: "tous",
        page: "page",
        survey: "questionnaire"
    },
    //Operators
    op: {
        empty: "est vide",
        notempty: "n'est pas vide",
        equal: "égal",
        notequal: "n'est pas égal",
        contains: "contient",
        notcontains: "ne contient pas",
        greater: "supérieur",
        less: "inférieur",
        greaterorequal: "supérieur ou égal",
        lessorequal: "inférieur ou égal"
    },
    //Embed window
    ew: {
        angular: "Utiliser la version Angular",
        jquery: "Utiliser la version jQuery",
        knockout: "Utiliser la version Knockout",
        react: "Utiliser la version React",
        vue: "Utiliser la version Vue",
        bootstrap: "Pour le framework Bootstrap",
        standard: "Sans Bootstrap",
        showOnPage: "Afficher le questionnaire dans une page",
        showInWindow: "Afficher le questionnaire dans une fenêtre",
        loadFromServer: "Charger le JSON du questionnaire depuis un serveur",
        titleScript: "Scripts et styles",
        titleHtml: "HTML",
        titleJavaScript: "JavaScript"
    },
    //Test Survey
    ts: {
        selectPage: "Sélectionner une page pour la tester"
    },
    //Validators
    validators: {
        answercountvalidator: "total de réponses",
        emailvalidator: "e-mail",
        numericvalidator: "numérique",
        regexvalidator: "regex",
        textvalidator: "texte"
    },
    //Triggers
    triggers: {
        completetrigger: "terminer le questionnaire",
        setvaluetrigger: "définir la valeur",
        visibletrigger: "modifier la visibilité"
    },
    //Properties
    p: {
        name: "Nom",
        title: {
            name: "Titre",
            title: 'Laissez vide, si même texte que le "Nom"'
        },
        navigationButtonsVisibility: "Visibilité des boutons de navigation",
        questionsOrder: "Ordre des questions",
        maxTimeToFinish: "Temps maximum pour terminer",
        visible: "Visible",
        visibleIf: "Visible si ",
        questionTitleLocation: "Emplacement titre question",
        description: "Description",
        state: "État",
        isRequired: "Obligatoire ?",
        requiredErrorText: "Message d'erreur text obligatoire",
        startWithNewLine: "Commencer avec une nouvelle ligne",
        innerIndent: "Indentation",
        page: "page",
        width: "largeur",
        commentText: "Description champ commentaire",
        valueName: "Nom de la valeur",
        enableIf: "Activer si",
        defaultValue: "Valeur par défaut",
        correctAnswer: "Bonne réponse",
        readOnly: "Lecture seule",
        validators: "Validateurs",
        titleLocation: "Emplacement du titre",
        hasComment: "Champ commentaire ?",
        hasOther: "Choix autre ?",
        choices: "Choix",
        choicesOrder: "Ordre des choix",
        choicesByUrl: "Choix par API",
        otherText: "Autre texte",
        otherErrorText: 'Texte d\'erreur champ "Autre"',
        storeOthersAsComment: "Sauvegarder choix autre comme commentaire",
        label: "Intitulé",
        showTitle: "Afficher le titre",
        valueTrue: "Valeur vrai",
        valueFalse: "Valeur faux",
        cols: "Colonnes",
        rows: "Nombre de lignes",
        placeHolder: "PlaceHolder (indice dans le champ)",
        optionsCaption: "Texte par défaut",
        expression: "Expression",
        format: "Format",
        displayStyle: "Style d'affichage",
        currency: "Monnaie",
        useGrouping: "Utiliser les groupes",
        showPreview: "Voir la prévisualisation",
        allowMultiple: "Autoriser multiples",
        imageHeight: "Hauteur de l'image",
        imageWidth: "Largeur de l'image",
        storeDataAsText: "Stocker les données comme du texte",
        maxSize: "Taille maximum",
        html: "HTML",
        columns: "Colonnes",
        cells: "Cellules",
        horizontalScroll: "Scroll horizontal",
        cellType: "Type de cellule",
        columnColCount: "Nombre de colonnes",
        columnMinWidth: "Largeur minimale des colonnes",
        rowCount: "Nombre de lignes",
        minRowCount: "Nombre de lignes minimum",
        maxRowCount: "Nombre de lignes maximum",
        keyName: "Nom de la clé",
        keyDuplicationError: "Erreur de clés multiples",
        confirmDelete: "Confirmation de suppression",
        confirmDeleteText: "Texte de confirmation de suppression",
        addRowText: "Bouton ajouter une ligne",
        removeRowText: "Bouton supprimer une ligne",
        items: "Items",
        itemSize: "Nombre maximum de caractères",
        colCount: "Nombre de colonnes",
        templateTitle: "Titre de gabarit",
        templateDescription: "Description du gabarit",
        allowAddPanel: "Autoriser l'ajout de panneau",
        allowRemovePanel: "Autoriser la suppression de panneau",
        panelCount: "Nombre de panneaux",
        minPanelCount: "Nombre minimum de panneaux",
        maxPanelCount: "Nombre maximum de panneaux",
        panelsState: "État des panneaux",
        panelAddText: "Texte d'ajout des panneaux",
        panelRemoveText: "Texte de suppression des panneaux",
        panelPrevText: "Texte panneau précédent",
        panelNextText: "Texte panneau suivant",
        showQuestionNumbers: "Numérotation des questions",
        showRangeInProgress: "Afficher la progression",
        renderMode: "Mode de rendu",
        templateTitleLocation: "Emplacement du titre de gabarit",
        rateValues: "Barème",
        rateMin: "Valeur minimum",
        rateMax: "Valeur maximum",
        rateStep: "Pas",
        minRateDescription: "Description note minimum",
        maxRateDescription: "Description note maximum",
        inputType: "Type de champ",
        size: "Nombre maximum de caractères",
        focusFirstQuestionAutomatic: "Focus automatique sur la première question",
        completedHtml: "HTML questionnaire finalisé",
        completedBeforeHtml: "HTML avant complétion du questionnaire",
        loadingHtml: "HTML de chargement",
        triggers: "Déclencheurs",
        cookieName: "Nom du cookie",
        sendResultOnPageNext: "Envoyer les résultats au changement de page",
        showNavigationButtons: "Boutons de navigation",
        showPrevButton: "Afficher le bouton précédent",
        showPageTitles: "Titre des pages",
        showCompletedPage: "Voir la page formulaire complété ?",
        showPageNumbers: "Numérotation des pages",
        questionErrorLocation: "Emplacement des erreurs",
        showProgressBar: "Barre de progression",
        mode: "Mode d'affichage",
        goNextPageAutomatic: "Aller à la page suivante automatiquement",
        clearInvisibleValues: "Cacher les valeurs invisibles",
        startSurveyText: "Texte de démarrage du questionnaire",
        pagePrevText: "Bouton page précédente",
        pageNextText: "Bouton page suivante",
        completeText: "Texte questionnaire finalisé",
        requiredText: "Texte pour les champs obligatoires",
        questionStartIndex: "Index de numérotation des questions",
        questionTitleTemplate: "Template d'affichage des questions",
        firstPageIsStarted: "Commence à la première page",
        isSinglePage: "Affiché sur une page",
        maxTimeToFinishPage: "Temps maximum pour finir la page",
        showTimerPanel: "Afficher le panneau chronomètre",
        showTimerPanelMode: "Mode d'affichage du panneau chronomètre",
        indent: "Indentation",
        isAllRowRequired: "Toutes les lignes sont-elle obligatoires ?",
        locale: "Langue"
    }
};
__WEBPACK_IMPORTED_MODULE_0__editorLocalization__["a" /* editorLocalization */].locales["fr"] = frenchTranslation;


/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__editorLocalization__ = __webpack_require__(0);

var germanTranslation = {
    //survey templates
    survey: {
        edit: "Bearbeiten",
        dropQuestion: "Frage bitte hier platzieren.",
        copy: "Kopieren",
        addToToolbox: "Zur Werkzeugleiste hinzufügen",
        deletePanel: "Panel löschen",
        deleteQuestion: "Frage löschen"
    },
    //questionTypes
    qt: {
        checkbox: "Checkbox",
        comment: "Kommentar",
        dropdown: "Aufklappmenü",
        file: "Datei",
        html: "Html",
        matrix: "Matrix (einfache Auswahl)",
        matrixdropdown: "Matrix (mehrfache Auswahl)",
        matrixdynamic: "Matrix (dynamische Zeilen)",
        multipletext: "Mehrzeiliger Text",
        panel: "Panel",
        paneldynamic: "Panel (dynamische Panels)",
        radiogroup: "Radiogruppe",
        rating: "Bewertung",
        text: "Einfache	Eingabe",
        boolean: "Boolean"
    },
    //Strings in Editor
    ed: {
        survey: "Umfrage",
        addNewPage: "Neue Seite hinzufügen",
        newPageName: "Seite",
        newQuestionName: "Frage",
        newPanelName: "Panel",
        testSurvey: "Testumfrage",
        testSurveyAgain: "Testumfrage wiederholen",
        testSurveyWidth: "Umfragebreite: ",
        embedSurvey: "Umfrage einfügen",
        saveSurvey: " Umfrage speichern",
        designer: "Umfrage Designer",
        jsonEditor: "JSON Editor",
        undo: "Rückgängig",
        redo: "Wiederherstellen",
        options: "Optionen",
        generateValidJSON: "Generiere gültiges JSON",
        generateReadableJSON: "Generiere lesbares JSON",
        toolbox: "Werkzeugleiste",
        delSelObject: "Lösche markiertes Objekt",
        correctJSON: "Bitte JSON korrigieren.",
        surveyResults: "Umfrageergebnis: "
    },
    //Property names in table headers
    pel: {
        isRequired: "Erforderlich?"
    },
    //Property Editors
    pe: {
        apply: "Anwenden",
        ok: "OK",
        cancel: "Abbrechen",
        reset: "Zurücksetzen",
        close: "Schliessen",
        delete: "Löschen",
        addNew: "Neu hinzufügen",
        removeAll: "Alles löschen",
        edit: "Bearbeiten",
        empty: "<leer>",
        fastEntry: "Schnell-Eintrag",
        formEntry: "Formular-Eintrag",
        testService: "Service testen",
        expressionHelp: "Bitte geben Sie eine booleschen Ausdruck ein. Es muss 'true' retournieren um die Frage/Seite anzuzeigen. zum Beispiel: {question1} = 'value1' or ({question2} = 3 and {question3} < 5)",
        propertyIsEmpty: "Bitte geben Sie einen Wert ein",
        value: "Wert",
        text: "Text",
        columnEdit: "Spalte bearbeiten: {0}",
        itemEdit: "Element bearbeiten: {0}",
        hasOther: "Hat ein anderes Element",
        name: "Name",
        title: "Titel",
        cellType: "Zellentyp",
        colCount: "Spaltenanzahl",
        choicesOrder: "Wähle Auswahlreihenfolge",
        visible: "Ist es sichtbar?",
        isRequired: "Ist es erforderlich?",
        startWithNewLine: "In neuer Zeile beginnen?",
        rows: "Zeilenanzahl",
        placeHolder: "Platzhalter eingeben",
        showPreview: "Wird eine Bildvorschau angezeigt?",
        storeDataAsText: "Speicher Dateininhalt des JSON-Resultats als Text",
        maxSize: "Maximale Dateigrösse in Bytes",
        imageHeight: "Bildhöhe",
        imageWidth: "Bildbreite",
        rowCount: "Zeilenanzahl",
        addRowText: "Zeilenknopftext hinzufügen",
        removeRowText: "Zeilenknopftext löschen",
        minRateDescription: "Bewertungsbeschreibung minimieren",
        maxRateDescription: "Bewertungsbeschreibung maximieren",
        inputType: "Eingabetyp",
        optionsCaption: "Auswahlbeschriftung",
        qEditorTitle: "Frage bearbeiten: {0}",
        tabs: {
            general: "Allgemein",
            fileOptions: "Optionen",
            html: "Html Editor",
            columns: "Spalten",
            rows: "Zeilen",
            choices: "Auswahlmöglichkeiten",
            visibleIf: "Sichtbar wenn",
            rateValues: "Bewertungswerte",
            choicesByUrl: "Auswahlmöglichkeiten vom Internet",
            matrixChoices: "Standardauswahl",
            multipleTextItems: "Texteingabe",
            validators: "Überprüfung"
        },
        editProperty: "Eigenschaft bearbeiten '{0}'",
        items: "[ Gegenstand: {0} ]",
        enterNewValue: "Bitte einen Wert eingeben.",
        noquestions: "Die Umfrage enthält keine Frage.",
        createtrigger: "Bitte einen Trigger eingeben.",
        triggerOn: "Ein ",
        triggerMakePagesVisible: "Seiten sichtbar machen:",
        triggerMakeQuestionsVisible: "Elemente sichtbar machen:",
        triggerCompleteText: "Bei Erfolg die Umfrage abschliessen.",
        triggerNotSet: "Kein Trigger eingerichtet",
        triggerRunIf: "Ausführen wenn",
        triggerSetToName: "Ändere Wert von: ",
        triggerSetValue: "auf: ",
        triggerIsVariable: "Variable nicht im Umfrageergebnis einbinden."
    },
    //Property values
    pv: {
        true: "true",
        false: "false"
    },
    //Operators
    op: {
        empty: "ist leer",
        notempty: "ist nicht leer",
        equal: "ist gleich",
        notequal: "ist ungleich",
        contains: "enthält",
        notcontains: "enthält nicht",
        greater: "grösser als",
        less: "kleiner als",
        greaterorequal: "grösser oder kleiner als",
        lessorequal: "kleiner oder ist gleich"
    },
    //Embed window
    ew: {
        angular: "Angular-Version benutzen",
        jquery: "jQuery-Version benutzen",
        knockout: "Knockout-Version benutzen",
        react: "React-Version benutzen",
        vue: "Vue-Version benutzen",
        bootstrap: "Als Bootstrap Framework",
        standard: "Kein Bootstrap",
        showOnPage: "Zeige Umfrage auf Seite",
        showInWindow: "Zeige Umfrage als Fenster",
        loadFromServer: "Lade Umfrage als JSON vom Server",
        titleScript: "Skripte und Styles",
        titleHtml: "HTML",
        titleJavaScript: "JavaScript"
    },
    validators: {
        answercountvalidator: "Anzahl Antworten",
        emailvalidator: "E-Mail",
        numericvalidator: "numerisch",
        regexvalidator: "regex",
        textvalidator: "text"
    },
    triggers: {
        completetrigger: "Umfrage abschliessen",
        setvaluetrigger: "Wert setzen",
        visibletrigger: "Sichtbarkeit ändern"
    },
    //Properties
    p: {
        name: "Name",
        title: {
            name: "Titel",
            title: "Bitte leer lassen, falls gleich wie 'Name'"
        },
        survey_title: { name: "Titel", title: "Wird auf jeder Seite angezeigt." },
        page_title: { name: "title", title: "Seitentitel" }
    }
};
__WEBPACK_IMPORTED_MODULE_0__editorLocalization__["a" /* editorLocalization */].locales["de"] = germanTranslation;


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__editorLocalization__ = __webpack_require__(0);
/* unused harmony export indonesianStrings */

var indonesianStrings = {
    //survey templates
    survey: {
        edit: "Ubah",
        dropQuestion: "Silahkan letakkan pertanyaan di sini dari Kotak Perkakas di sebelah kiri.",
        copy: "Salin",
        addToToolbox: "Tambahkan ke Kotak Perkakas",
        deletePanel: "Hapus Panel",
        deleteQuestion: "Hapus Pertanyaan",
        convertTo: "Mengubah ke",
        drag: "Tarik elemen"
    },
    //questionTypes
    qt: {
        default: "Default",
        checkbox: "Kotak Centang",
        comment: "Komen",
        imagepicker: "Gambar",
        dropdown: "Kotak Kombo",
        file: "Berkas",
        html: "Html",
        matrix: "Matriks (pilihan tunggal)",
        matrixdropdown: "Matriks (pilihan ganda)",
        matrixdynamic: "Matriks (baris dinamis)",
        multipletext: "Teks Ganda",
        panel: "Panel",
        paneldynamic: "Panel (dynamic panels)",
        radiogroup: "Pilihan Ganda",
        rating: "Peringkat",
        text: "Input Tunggal",
        boolean: "Boolean",
        expression: "Ekspresi"
    },
    //Strings in Editor
    ed: {
        defaultLocale: "Default ({0})",
        survey: "Survei",
        settings: "Pengaturan Survei",
        editSurvey: "Ubah Survei",
        addNewPage: "Tambah Halaman Baru",
        moveRight: "Geser ke Kanan",
        moveLeft: "Geser ke Kiri",
        deletePage: "Hapus Halaman",
        editPage: "Ubah Halaman",
        edit: "Ubah",
        newPageName: "halaman",
        newQuestionName: "pertanyaan",
        newPanelName: "panel",
        testSurvey: "Coba Survei",
        testSurveyAgain: "Coba Survei Lagi",
        testSurveyWidth: "Lebar survei: ",
        embedSurvey: "Embed Survei",
        translation: "Terjemahan",
        saveSurvey: "Simpan Survei",
        designer: "Rancangan Survei",
        jsonEditor: "Pengubah JSON",
        undo: "Undo",
        redo: "Redo",
        options: "Pilihan",
        generateValidJSON: "Hasilkan JSON yang Valid",
        generateReadableJSON: "Hasilkan JSON yang dapat dibaca",
        toolbox: "Kotak Perkakas",
        toolboxGeneralCategory: "Umum",
        delSelObject: "Hapus objek yang dipilih",
        editSelObject: "Ubah objek yang dipilih",
        correctJSON: "Please correct JSON.",
        surveyResults: "Hasil survei: ",
        surveyResultsTable: "Sebagai tabel",
        surveyResultsJson: "Sebagai JSON",
        resultsTitle: "Judul Pertanyaan",
        resultsName: "Nama Pertanyaan",
        resultsValue: "Nilai Jawaban",
        resultsDisplayValue: "Tampilkan Nilai",
        modified: "Dimodifikasi",
        saving: "Menyimpan",
        saved: "Tersimpan",
        saveError: "Error! Konten editor tidak berhasil disimpan.",
        translationAddLanguage: "Pilih bahasa untuk terjemahan",
        translationShowAllStrings: "Tampilkan seluruh string",
        translationShowAllPages: "Tampilkan seluruh halaman",
        translationNoStrings: "Tidak ada string diterjemahkan. Silahkan ganti penyaring.",
        translationExportToSCVButton: "Export ke CSV",
        translationImportFromSCVButton: "Import dari CSV",
        translationMergeLocaleWithDefault: "Gabungkan {0} dengan default locale"
    },
    //Property names in table headers
    pel: {
        isRequired: "Wajib?"
    },
    //Property Editors
    pe: {
        apply: "Terapkan",
        ok: "OK",
        cancel: "Batal",
        reset: "Reset",
        close: "Tutup",
        delete: "Hapus",
        addNew: "Tambahkan Baru",
        addItem: "Klik untuk menambahkan sebuah item...",
        removeAll: "Hapus Semua",
        edit: "Ubah",
        itemValueEdit: "Ditampilkan Jika",
        editChoices: "Ubah Pilihan",
        move: "Pindah",
        empty: "<kosong>",
        notEmpty: "<ubah nilai>",
        fastEntry: "Entri Cepat",
        formEntry: "Entri Form",
        testService: "Coba layanan",
        conditionSelectQuestion: "Pilih pertanyaan...",
        conditionValueQuestionTitle: "Silahkan masukkan/pilih nilai",
        conditionButtonAdd: "Tambah",
        conditionButtonReplace: "Ganti",
        conditionHelp: "Please enter a boolean expression. It should return true to keep the question/page visible. For example: {question1} = 'value1' or ({question2} * {question4}  > 20 and {question3} < 5)",
        expressionHelp: "Please enter an expression. You may use curly brackets to get access to the question values: '{question1} + {question2}', '({price}*{quantity}) * (100 - {discount})'",
        aceEditorHelp: "Press ctrl+space to get expression completion hint",
        aceEditorRowTitle: "Current row",
        aceEditorPanelTitle: "Current panel",
        showMore: "For more details please check the documentation",
        conditionShowMoreUrl: "https://surveyjs.io/Documentation/LibraryParameter?id=Question&parameter=visibleIf",
        assistantTitle: "Pertanyaan tersedia:",
        cellsEmptyRowsColumns: "Harus ada setidaknya satu kolom atau baris",
        propertyIsEmpty: "Silahkan masukkan nilai",
        value: "Nilai",
        text: "Teks",
        rowid: "ID baris",
        imageLink: "Link Gambar",
        columnEdit: "Ubah kolom: {0}",
        itemEdit: "Ubah item: {0}",
        url: "URL",
        path: "Path",
        valueName: "Nama nilai",
        titleName: "Nama judul",
        hasOther: "Memiliki item lain",
        otherText: "Teks item lain",
        name: "Nama",
        title: "Judul",
        cellType: "Jenis sel",
        colCount: "Jumlah kolom",
        choicesOrder: "Tentukan urutan pilihan",
        visible: "Terlihat?",
        isRequired: "Wajib?",
        startWithNewLine: "Mulai dengan baris baru?",
        rows: "Jumlah baris",
        placeHolder: "Masukkan placeholder",
        showPreview: "Tunjukkan tinjauan gambar?",
        storeDataAsText: "Simpan konten berkas dalam hasil JSON sebagai teks",
        maxSize: "Ukuran maksimum berkas dalam byte",
        imageHeight: "Tinggi gambar",
        imageWidth: "Lebar gambar",
        rowCount: "Jumlah baris",
        columnLayout: "Tata letak kolom",
        addRowLocation: "Tambah lokasi tombol baris",
        addRowText: "Tambah teks tombol baris",
        removeRowText: "Hapus teks tombol baris",
        minRateDescription: "Deskripsi nilai minimum",
        maxRateDescription: "Deskripsi nilai maksimum",
        inputType: "Jenis masukan",
        optionsCaption: "Keterangan pilihan",
        defaultValue: "Nilai standar",
        cellsDefaultRow: "Teks sel standar",
        surveyEditorTitle: "Ubah pengaturan survei",
        qEditorTitle: "Ubah: {0}",
        maxLength: "Panjang maksimum",
        //survey
        showTitle: "Tampilkan/sembunyikan judul",
        locale: "Bahasa standar",
        mode: "Mode (ubah/baca saja)",
        clearInvisibleValues: "Bersihkan nilai tak terlihat",
        cookieName: "Nama cookie (untuk menonaktifkan menjalankan survei dua kali secara lokal)",
        sendResultOnPageNext: "Kirim hasil survei pada halaman selanjutnya",
        storeOthersAsComment: "Simpan nilai 'lainnya' pada bidang lainnya",
        showPageTitles: "Tampilkan judul halaman",
        showPageNumbers: "Tampilkan nomor halaman",
        pagePrevText: "Teks halaman tombol sebelumnya",
        pageNextText: "Teks halaman tombol selanjutnya",
        completeText: "Teks tombol selesai",
        startSurveyText: "Teks tombol mulai",
        showNavigationButtons: "Tampilkan tombol navigasi (navigasi standar)",
        showPrevButton: "Tampilkan tombol sebelumnya (pengguna mungkin kembali ke halaman sebelumnya)",
        firstPageIsStarted: "Halaman pertama pada survei adalah halaman yang telah dimulai.",
        showCompletedPage: "Tampilkan keseluruhan halaman di akhir (completedHtml)",
        goNextPageAutomatic: "Setelah menjawa seluruh pertanyaan, pergi ke halaman berikutnya secara otomatis",
        showProgressBar: "Tampilkan progress bar",
        questionTitleLocation: "Lokasi judul pertanyaan",
        requiredText: "Simbil pertanyaan wajib",
        questionStartIndex: "Indeks mulai pertanyaan (1, 2 atau 'A', 'a')",
        showQuestionNumbers: "Tampilkan nomor pertanyaan",
        questionTitleTemplate: "Template Judul Pertanyaan, default adalah: '{no}. {require} {title}'",
        questionErrorLocation: "Lokasi Pertanyaan Error",
        focusFirstQuestionAutomatic: "Fokus ke pertanyaan pertama saat pergantian halaman",
        questionsOrder: "Urutakan elemen pada halaan",
        maxTimeToFinish: "Waktu maksimum untuk menyelesaikan survei",
        maxTimeToFinishPage: "Waktu maksimum untuk menyelesaikan suatu halaman",
        showTimerPanel: "Tampilkan panel pengatur waktu",
        showTimerPanelMode: "Tampilkan mode panel pengatur waktu",
        renderMode: "Mode render",
        allowAddPanel: "Bolehkan penambahan panel",
        allowRemovePanel: "Bolehkan penghapusan panel",
        panelAddText: "Menambah teks panel",
        panelRemoveText: "Menghapus teks panel",
        isSinglePage: "Tampilkan seluruh elemen pada halaman",
        tabs: {
            general: "Umum",
            fileOptions: "Pilihan berkas",
            html: "Editor Html",
            columns: "Kolom",
            rows: "Baris",
            choices: "Pilihan",
            items: "Item",
            visibleIf: "Terlihat Jika",
            enableIf: "Memungkinkan Jika",
            requiredIf: "Wajib Jika",
            rateValues: "Nilai Tingkat",
            choicesByUrl: "Pilih dari Web",
            matrixChoices: "Pilihan Standar",
            multipleTextItems: "Masukan Teks",
            validators: "Validator",
            navigation: "Navigasi",
            question: "Pertanyaan",
            completedHtml: "Completed Html",
            loadingHtml: "Loading Html",
            timer: "Timer/Quiz",
            triggers: "Triggers",
            templateTitle: "Template title"
        },
        editProperty: "Edit property '{0}'",
        items: "[ Items: {0} ]",
        enterNewValue: "Silahkan masukkan nilai",
        noquestions: "There is no any question in the survey.",
        createtrigger: "Silahkan buat sebuah trigger",
        triggerOn: "On ",
        triggerMakePagesVisible: "Make pages visible:",
        triggerMakeQuestionsVisible: "Make elements visible:",
        triggerCompleteText: "Complete the survey if succeed.",
        triggerNotSet: "The trigger is not set",
        triggerRunIf: "Run if",
        triggerSetToName: "Change value of: ",
        triggerFromName: "Copy value from: ",
        triggerRunExpression: "Run this Expression:",
        triggerSetValue: "to: ",
        triggerIsVariable: "Do not put the variable into the survey result."
    },
    //Property values
    pv: {
        true: "benar",
        false: "salah",
        inherit: "inherit",
        show: "tampilkan",
        hide: "sembunyikan",
        default: "default",
        initial: "inisial",
        random: "acak",
        collapsed: "collapsed",
        expanded: "expanded",
        none: "tidak ada",
        asc: "ascending",
        desc: "descending",
        indeterminate: "indeterminate",
        decimal: "desimal",
        currency: "mata uang",
        percent: "persen",
        firstExpanded: "firstExpanded",
        off: "mati",
        onPanel: "onPanel",
        onSurvey: "onSurvey",
        list: "daftar",
        progressTop: "progressTop",
        progressBottom: "progressBottom",
        progressTopBottom: "progressTopBottom",
        horizontal: "horizontal",
        vertical: "vertikal",
        top: "atas",
        bottom: "bawah",
        topBottom: "atas dan bawah",
        left: "kiri",
        color: "warna",
        date: "tanggal",
        datetime: "tanggal&waktu",
        "datetime-local": "datetime-local",
        email: "surel",
        month: "bulan",
        number: "nomor",
        password: "kata sandi",
        range: "rentang",
        tel: "tel",
        text: "teks",
        time: "waktu",
        url: "url",
        week: "minggu",
        hidden: "tersembunyi",
        on: "nyala",
        onPage: "onPage",
        edit: "ubah",
        display: "tampilan",
        onComplete: "saat selesai",
        onHidden: "saat tersembunyi",
        all: "semua",
        page: "halaman",
        survey: "survei",
        onNextPage: "pada halaman selanjutnya",
        onValueChanged: "saat nilai berubah"
    },
    //Operators
    op: {
        empty: "kosong",
        notempty: "tidak kosong",
        equal: "sama dengan",
        notequal: "tidak sama dengan",
        contains: "mengandung",
        notcontains: "tidak mengandung",
        greater: "lebih besar",
        less: "lebih kecil",
        greaterorequal: "lebih besar atau sama dengan",
        lessorequal: "lebih kecil atau sama dengan"
    },
    //Embed window
    ew: {
        angular: "Gunakan versi Angular",
        jquery: "Gunakan versi JQuery",
        knockout: "Gunakan versi Knockout",
        react: "Gunakan versi React",
        vue: "Gunakan versi Vue",
        bootstrap: "Untuk framework bootstrap",
        standard: "Tidak ada bootstrap",
        showOnPage: "Tampilkan survei pada sebuah halaman",
        showInWindow: "Tampilkan survei pada sebuah jendela",
        loadFromServer: "Muat JSON survei dari server",
        titleScript: "Script dan style",
        titleHtml: "HTML",
        titleJavaScript: "JavaScript"
    },
    //Test Survey
    ts: {
        selectPage: "Select the page to test it:",
        showInvisibleElements: "Show invisible elements"
    },
    validators: {
        answercountvalidator: "answer count",
        emailvalidator: "e-mail",
        expressionvalidator: "expression",
        numericvalidator: "numeric",
        regexvalidator: "regex",
        textvalidator: "text"
    },
    triggers: {
        completetrigger: "selesaikan survei",
        setvaluetrigger: "atur nilai",
        copyvaluetrigger: "salin nilai",
        runexpressiontrigger: "jalankan ekspresi",
        visibletrigger: "ubah visibilitas"
    },
    //Properties
    p: {
        name: "nama",
        title: {
            name: "judul",
            title: "Biarkan kosong, jika sama dengan 'Nama'"
        },
        navigationButtonsVisibility: "visibilitas tombol navigasi",
        questionsOrder: "urutan pertanyaan",
        maxTimeToFinish: "waktu maks untuk menyelesaikan",
        visible: "terlihat",
        visibleIf: "terlihat jika",
        questionTitleLocation: "questionTitleLocation",
        description: "deskripsi",
        state: "keadaan",
        isRequired: "wajib",
        requiredIf: "wajib jika",
        indent: "indentansi",
        requiredErrorText: "teks error wajib",
        startWithNewLine: "mulai dengan baris baru",
        innerIndent: "innerIndent",
        page: "halaman",
        width: "lebar",
        commentText: "teks komen",
        valueName: "nama nilai",
        enableIf: "aktif jika",
        defaultValue: "nilai default",
        correctAnswer: "jawaban benar",
        readOnly: "baca saja",
        validators: "validator",
        titleLocation: "lokasi judul",
        hasComment: "memiliki comment",
        hasOther: "memiliki lainnya",
        choices: "pilihan",
        choicesOrder: "urutkan pilihan",
        choicesByUrl: "pilihan dari URL",
        otherText: "teks lainnya",
        otherErrorText: "teks error lainnya",
        storeOthersAsComment: "simpan lainnnya sebagai komen",
        label: "label",
        showTitle: "tampilkan judul",
        valueTrue: "nilai benar",
        valueFalse: "nilai salah",
        cols: "kolom",
        rows: "baris",
        placeHolder: "placeHolder",
        optionsCaption: "keterangan pilihan",
        expression: "ekspresi",
        format: "format",
        displayStyle: "gaya tampilan",
        currency: "mata uang",
        useGrouping: "gunakan kelompok",
        showPreview: "tampilkan pratinjau",
        allowMultiple: "bolehkan ganda",
        imageHeight: "tinggi gambar",
        imageWidth: "lebar gambar",
        storeDataAsText: "simpan data sebagai teks",
        maxSize: "ukuran maks",
        html: "html",
        columns: "kolom",
        cells: "sel",
        isAllRowRequired: "semua baris wajib",
        horizontalScroll: "horizontalScroll",
        cellType: "jenis sel",
        columnsLayout: "tata letak kolom",
        columnColCount: "jumlah kolom",
        columnMinWidth: "lebar kolom min",
        rowCount: "jumlah baris",
        minRowCount: "jumlah baris min",
        maxRowCount: "jumlah baris maks",
        keyName: "nama kunci",
        keyDuplicationError: "kesalahan duplikasi kunci ",
        confirmDelete: "konfirmasi hapus",
        confirmDeleteText: "teks konfirmasi hapus",
        addRowLocation: "tambah lokasi baris",
        addRowText: "tambah teks baris",
        removeRowText: "hapus teks baris",
        items: "items",
        itemSize: "Ukuran item",
        colCount: "Jumlah kolom",
        templateTitle: "Judul Template",
        templateDescription: "Deskripsi Template",
        allowAddPanel: "Bolehkan Tambah Panel",
        allowRemovePanel: "Bolehkan Hapus Panel",
        panelCount: "Jumlah Panel",
        minPanelCount: "Jumlah Panel Minimum",
        maxPanelCount: "Jumlah Panel Maksimum",
        panelsState: "Keadaan Panel",
        panelAddText: "Panel Tambah Teks",
        panelRemoveText: "Panel Hapus Teks",
        panelPrevText: "Panel Teks Sebelumnya",
        panelNextText: "Panel Teks Selanjutnya",
        showQuestionNumbers: "Tampilkan Nomor Pertanyaan",
        showRangeInProgress: "Tampilkan Rentang yang Berlangsung",
        renderMode: "Mode render",
        templateTitleLocation: "templateTitleLocation",
        rateValues: "Nilai Tingkat",
        rateMin: "Tingkat Minimum",
        rateMax: "Tingkat Maksimum",
        rateStep: "Langkah Tingkat",
        minRateDescription: "Deskripsi Tingkat Minimum",
        maxRateDescription: "Deskripsi Tingkat Maksimum",
        inputType: "jenis masukan",
        size: "ukuran",
        locale: "Lokal",
        focusFirstQuestionAutomatic: "focusFirstQuestionAutomatic",
        completedHtml: "completedHtml",
        completedBeforeHtml: "completedBeforeHtml",
        loadingHtml: "loadingHtml",
        triggers: "Trigger",
        cookieName: "Nama Cookie",
        sendResultOnPageNext: "sendResultOnPageNext",
        showNavigationButtons: "showNavigationButtons",
        showPrevButton: "Tampilkan Tombol Sebelumnya",
        showPageTitles: "Tampilkan Judul Halaman",
        showCompletedPage: "Tampilkan Keseluruhan Halaman",
        showPageNumbers: "Tampilkan Nomor Halaman",
        questionErrorLocation: "Lokasi Pertanyaan Error",
        showProgressBar: "Tampilkan progress bar",
        mode: "mode",
        goNextPageAutomatic: "Ke Halaman Selanjutnya Otomatis",
        checkErrorsMode: "Mode Periksa Error",
        clearInvisibleValues: "Bersihkan Nilai Tak Terlihat",
        startSurveyText: "Teks Mulai Survei",
        pagePrevText: "Teks Halaman Sebelumnya",
        pageNextText: "Teks Halaman Selanjutnya",
        completeText: "Teks Selesai",
        requiredText: "Teks Wajib",
        questionStartIndex: "Index Mulai Pertanyaan",
        questionTitleTemplate: "Template Judul Pertanyaan",
        firstPageIsStarted: "Halaman Pertama Dimulai",
        isSinglePage: "Halaman Tunggal?",
        maxTimeToFinishPage: "Waktu Maks untuk Menyelesaikan Halaman",
        showTimerPanel: "Tampilkan Panel Pengatur Waktu",
        showTimerPanelMode: "Tampilkan showTimerPanelMode",
        defaultPanelValue: "nilai panel default",
        defaultRowValue: "nilai baris default",
        hasNone: "Memiliki None",
        noneText: "Non-teks",
        text: "teks",
        minValue: "nilai minimum",
        maxValue: "nilai maksimum",
        minLength: "panjang minimum",
        maxLength: "panjang maksimum",
        allowDigits: "bolehkan angka",
        minCount: "jumlah minimum",
        maxCount: "jumlah maksimum",
        regex: "ekspresi reguler"
    }
};
__WEBPACK_IMPORTED_MODULE_0__editorLocalization__["a" /* editorLocalization */].locales["id"] = indonesianStrings;


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__editorLocalization__ = __webpack_require__(0);

var italianTranslation = {
    // strings for survey templates
    survey: {
        edit: "Modifica",
        dropQuestion: "Aggiungi una domanda qui",
        copy: "Copia",
        addToToolbox: "Aggiungi alla toolbox",
        deletePanel: "Elimina pannello",
        deleteQuestion: "Elimina domanda",
        convertTo: "Converti a"
    },
    // strings for question types
    qt: {
        checkbox: "Casella di controllo ",
        comment: "Commento",
        dropdown: "Combo",
        file: "Archivio",
        html: "Html",
        matrix: "Matrice (unica opzione)",
        matrixdropdown: "Matrice (opzioni multiple)",
        matrixdynamic: "Matrice (dinamica)",
        multipletext: "Testo multiplo",
        panel: "Pannello",
        paneldynamic: "Pannello (dinamico)",
        radiogroup: "Opzione multipla",
        rating: "Valutazione",
        text: "Testo semplice",
        expression: "Espressione"
    },
    // strings for editor
    ed: {
        survey: "Questionario",
        editSurvey: "Modifica Questionario",
        addNewPage: "Aggiungi Nuova Pagina",
        deletePage: "Elimina Pagina",
        editPage: "Modifica Pagina",
        newPageName: "pagina",
        newQuestionName: "domanda",
        newPanelName: "pannello",
        testSurvey: "Testa questionario",
        testSurveyAgain: "Testa questionario di nuovo",
        testSurveyWidth: "Larghezza questionario:",
        embedSurvey: "Includi questionario",
        saveSurvey: "Salva questionario",
        designer: "Disegna",
        jsonEditor: "Modifica JSON",
        undo: "Annulla",
        redo: "Ripeti",
        options: "Opzioni",
        generateValidJSON: "Genera JSON valido",
        generateReadableJSON: "Genera JSON leggibile",
        toolbox: "Strumenti",
        delSelObject: "Elimina oggetto selezionato",
        editSelObject: "Modifica oggetto selezionato",
        correctJSON: "Per favore, correggi il tuo JSON",
        surveyResults: "Risultati del questionario: ",
        modified: "Modificato",
        saving: "Salvataggio",
        saved: "Salvato"
    },
    //Property names in table headers
    pel: {
        isRequired: "Richiesto"
    },
    // strings for property editors
    pe: {
        apply: "Applica",
        ok: "Accetta",
        cancel: "Annulla",
        reset: "Reimposta",
        close: "Chiudi",
        delete: "Elimina",
        addNew: "Nuovo",
        removeAll: "Elimina tutto",
        edit: "Modifica",
        empty: "<vuoto>",
        notEmpty: "<modifica valore>",
        fastEntry: "Inserimento rapido",
        formEntry: "Inserimento con dati ",
        testService: "Test del servizio",
        conditionSelectQuestion: "Seleziona domanda...",
        conditionButtonAdd: "Aggiungi",
        conditionButtonReplace: "Sostituisci",
        conditionHelp: "Per favore, inserire una espressione booleana. Dovrebbe restituire true per mantenere la domanda/pagina visibile. Ad esempio: {domanda1} = 'valore1' or ({domanda2} * {domanda4}  > 20 and {domanda3} < 5)",
        expressionHelp: "Per favore inserire una espressione. Puoi usare parentesi graffe per ottenere l'accesso ai valori delle domande: '{domanda1} + {domanda2}', '({prezzo}*{qta}) * (100 - {sconto})'",
        aceEditorHelp: "Premi ctrl+space per ottenere un suggerimento sul completamento dell'espressione",
        aceEditorRowTitle: "Riga corrente",
        aceEditorPanelTitle: "Pannello Corrente",
        showMore: "Per favore, per maggiori dettagli guardare la documentazione",
        assistantTitle: "Domande disponibili:",
        cellsEmptyRowsColumns: "Dovrebbe esserci almeno una colonna o riga",
        propertyIsEmpty: "Per favore, inserire un valore per la propietà",
        value: "Valore",
        text: "Testo",
        columnEdit: "Modifica colonna: {0}",
        itemEdit: "Modifica elemento: {0}",
        url: "URL",
        path: "Percorso",
        valueName: "Nome Valore",
        titleName: "Nome Titolo",
        hasOther: "Altri elementi",
        otherText: "Testo altri elementi",
        name: "Nome",
        title: "Titolo",
        cellType: "Tipo di cella",
        colCount: "Numero di colonne",
        choicesOrder: "Seleziona altre opzioni",
        visible: "Visibile",
        isRequired: "Richiesto",
        startWithNewLine: "Nuova linea",
        rows: "Numero di righe",
        placeHolder: "Testo di riferimento",
        showPreview: "Mostra anteprima",
        storeDataAsText: "Vedi il contenuto JSON come testo",
        maxSize: "Dimensione massima in bytes",
        imageHeight: "Altezza immagine",
        imageWidth: "Larghezza immagine",
        rowCount: "Numero delle righe",
        addRowText: "Testo del pulsante per aggiungere una nuova righa",
        removeRowText: "Testo del pulsante per eliminare una righa",
        minRateDescription: "Descrizione del valore minimo",
        maxRateDescription: "Descrizione del valore massimo",
        inputType: "Tipo di inserimento",
        optionsCaption: "Titolo dell'opzione",
        defaultValue: "Valore default",
        cellsDefaultRow: "Valore default celle",
        surveyEditorTitle: "Edit survey settings",
        qEditorTitle: "Modifica domanda: {0}",
        //survey
        showTitle: "Mostra/nascondi titolo",
        locale: "Lingua Default",
        mode: "Modalità (modifica/sola lettura)",
        clearInvisibleValues: "Pulischi valori non visibili",
        cookieName: "Nome cookie (per disabilitare esegui il questionario due volte in locale)",
        sendResultOnPageNext: "Invia i risultati del sondaggio alla pagina successiva",
        storeOthersAsComment: "Memorizza il valore 'altri' in campi separati",
        showPageTitles: "Visualizza titoli pagina",
        showPageNumbers: "Visualizza numeri pagina",
        pagePrevText: "Testo bottone pagina precedente",
        pageNextText: "Testo bottone pagina successiva",
        completeText: "Testo bottone Completato",
        startSurveyText: "Testo bottone Inizia",
        showNavigationButtons: "Visualizza bottoni di navigazione (navigazione di default)",
        showPrevButton: "Visualizza bottone precedente(l'utente può tornare alla pagina precedente)",
        firstPageIsStarted: "La prima pagina nel questionario è la pagina iniziale.",
        showCompletedPage: "Visualizza la pagina completata alla fine del questionario (completedHtml)",
        goNextPageAutomatic: "Rispondendo a tutte le domande, vai alla pagina successiva in automatico.",
        showProgressBar: "Visualizza barra di avanzamento",
        questionTitleLocation: "Posizione titolo domanda",
        requiredText: "Simbolo domanda obbligatoria, esempio (*)",
        questionStartIndex: "La domanda inizia con l'indice (1, 2 oppure 'A', 'a')",
        showQuestionNumbers: "Visualizza i numeri di domanda",
        questionTitleTemplate: "Template titolo della domanda, il default è: '{no}. {require} {title}'",
        questionErrorLocation: "Posizione notifica errore sulla domanda",
        focusFirstQuestionAutomatic: "Sul cambio pagina, posiziona il cursore sulla prima domanda",
        questionsOrder: "Ordine di elementi sulla pagina",
        maxTimeToFinish: "Tempo massimo per terminare il sondaggio",
        maxTimeToFinishPage: "Tempo massimo per terminare una pagina del sondaggio",
        showTimerPanel: "Visualizza pannello timer",
        showTimerPanelMode: "Visualizza modalità timer pannello",
        renderMode: "Modalità di rendering",
        allowAddPanel: "Consenti l'aggiunta di un pannello",
        allowRemovePanel: "Consenti la rimozione di un pannello",
        panelAddText: "Aggiungi testo pannello",
        panelRemoveText: "Remuovi testo pannello",
        isSinglePage: "Visualizza tutti gli elementi su una pagina",
        tabs: {
            general: "Generale",
            fileOptions: "Opzioni",
            html: "Modifica Html",
            columns: "Colonne",
            rows: "Righe",
            choices: "Scelte",
            visibleIf: "Visibile se",
            rateValues: "Volori della classifica",
            choicesByUrl: "Opzioni dal Web",
            matrixChoices: "Opzioni predefinite",
            multipleTextItems: "Voci di testo",
            validators: "Validazioni",
            navigation: "Navigazione",
            question: "Domanda",
            completedHtml: "Html questionario completato",
            loadingHtml: "Html caricamento questionario",
            timer: "Timer/Quiz",
            triggers: "Triggers",
            templateTitle: "Template titolo"
        },
        editProperty: "Modifca propietà '{0}'",
        items: "[ Elemento: {0} ]",
        enterNewValue: "Si prega di inserire il valore.",
        noquestions: "Non c'è alcun dubbio nel questionario.",
        createtrigger: "Si prega di creare un trigger",
        triggerOn: "Attivazione ",
        triggerMakePagesVisible: "Rendere visibili le pagine:",
        triggerMakeQuestionsVisible: "Rendere visibili le domande:",
        triggerCompleteText: "Completare il questionario, in caso di successo.",
        triggerNotSet: "Non impostato",
        triggerRunIf: "Esegui se",
        triggerSetToName: "Cambia il valore a: ",
        triggerSetValue: "a: ",
        triggerIsVariable: "Non posizionare la variabile del risultato del questionario"
    },
    // strings for operators
    op: {
        empty: "è vuoto",
        notempty: "non è vuoto ",
        equal: "è uguale a",
        notequal: "non è uguale a",
        contains: "contiene",
        notcontains: "non contiene",
        greater: "maggiore",
        less: "minore",
        greaterorequal: "maggiore o uguale",
        lessorequal: "minore o uguale"
    },
    // strings for embed window
    ew: {
        angular: "Versione per Angular",
        jquery: "Versione per jQuery",
        knockout: "Versione per Knockout",
        react: "Versione per React",
        vue: "Versione per Vue",
        bootstrap: "Per framework bootstrap",
        standard: "No bootstrap",
        showOnPage: "Visualizza in questa pagina",
        showInWindow: "Visualizza in una finestra",
        loadFromServer: "Carica JSON dal server",
        titleScript: "Scripts e stili",
        titleHtml: "HTML",
        titleJavaScript: "JavaScript"
    },
    //Test Survey
    ts: {
        selectPage: "Seleziona la pagina da testare:"
    },
    validators: {
        answercountvalidator: "numero risposte",
        emailvalidator: "e-mail",
        numericvalidator: "numerico",
        regexvalidator: "regex",
        textvalidator: "testo"
    },
    triggers: {
        completetrigger: "completa questionario",
        setvaluetrigger: "setta valore",
        visibletrigger: "cambia visibilità"
    },
    // strings of properties
    p: {
        name: "nome",
        title: {
            name: "titolo",
            title: "Lascia vuoto se è lo stesso di 'Nome'"
        },
        page_title: { name: "titolo", title: "Titolo della pagina" }
    }
};
__WEBPACK_IMPORTED_MODULE_0__editorLocalization__["a" /* editorLocalization */].locales["it"] = italianTranslation;


/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__editorLocalization__ = __webpack_require__(0);
/* unused harmony export koreanStrings */

var koreanStrings = {
    //survey templates
    survey: {
        edit: "편집",
        dropQuestion: "왼쪽 도구상자에서 질문을 여기에 놓으십시오.",
        copy: "복사",
        addToToolbox: "도구상자에 추가",
        deletePanel: "패널 삭제",
        deleteQuestion: "질문 삭제",
        convertTo: "다음으로 변경",
        drag: "항목 끌어오기"
    },
    //questionTypes
    qt: {
        default: "기본값",
        checkbox: "체크박스",
        comment: "설명",
        dropdown: "드롭다운",
        file: "파일",
        html: "HTML",
        matrix: "행렬 (단일 선택)",
        matrixdropdown: "행렬 (복수 선택)",
        matrixdynamic: "행렬 (동적 행)",
        multipletext: "텍스트 상자 그룹",
        panel: "패널",
        paneldynamic: "패널 (동적 패널)",
        radiogroup: "라디오 그룹",
        rating: "등급",
        text: "텍스트 상자",
        boolean: "불린(boolean)",
        expression: "표현식"
    },
    //Strings in Editor
    ed: {
        survey: "설문지",
        settings: "설정",
        editSurvey: "설문지 편집",
        addNewPage: "새 페이지 추가",
        moveRight: "오른쪽으로 스크롤",
        moveLeft: "왼쪽으로 스크롤",
        deletePage: "페이지 삭제",
        editPage: "페이지 편집",
        edit: "편집",
        newPageName: "페이지",
        newQuestionName: "질문",
        newPanelName: "패널",
        testSurvey: "테스트 설문지",
        testSurveyAgain: "테스트 설문지 다시하기",
        testSurveyWidth: "설문지 너비: ",
        embedSurvey: "내장 설문지",
        saveSurvey: "설문지 저장",
        designer: "설문지 디자인",
        jsonEditor: "JSON 편집기",
        undo: "실행 취소",
        redo: "복원",
        options: "옵션",
        generateValidJSON: "JSON 데이터 생성",
        generateReadableJSON: "생성 JSON 데이터 읽기",
        toolbox: "도구상자",
        toolboxGeneralCategory: "일반",
        delSelObject: "선택한 객체 삭제",
        editSelObject: "선택한 객체 편집",
        correctJSON: "JSON 데이터를 수정하십시오.",
        surveyResults: "설문 결과: ",
        modified: "수정됨",
        saving: "저장중",
        saved: "저장됨"
    },
    //Property names in table headers
    pel: {
        isRequired: "필수입니까?"
    },
    //Property Editors
    pe: {
        apply: "적용",
        ok: "확인",
        cancel: "취소",
        reset: "재설정",
        close: "닫기",
        delete: "삭제",
        addNew: "새로 만들기",
        addItem: "항목을 추가하려면 클립하십시오.",
        removeAll: "모두 삭제",
        edit: "편집",
        itemValueEdit: "조건 충족 시 보기",
        editChoices: "선택사항 편집",
        move: "이동",
        empty: "<비어있음>",
        notEmpty: "<편집 값>",
        fastEntry: "빠른 입력",
        formEntry: "양식 입력",
        testService: "서비스 테스트",
        conditionSelectQuestion: "질문 선택...",
        conditionValueQuestionTitle: "값을 입력하거나 선택하십시오.",
        conditionButtonAdd: "추가",
        conditionButtonReplace: "바꾸기",
        conditionHelp: "불린 식을 입력하십시오. 질문 혹은 페이지를 계속 볼 수 있게 하려면 참값을 반환해야 합니다. 예를 들면: {질문1} = '값1' or ({질문2} * {질문4}  > 20 and {질문3} < 5)",
        expressionHelp: "식을 입력하십시오. 다음과 같은 질문 값에 접근하려면 중괄호를 이용하십시오: '{질문1} + {질문2}', '({가격}*{수량}) * (100 - {할인})'",
        aceEditorHelp: "ctrl+space를 눌러 완성된 수식에 대한 힌트를 얻으십시오",
        aceEditorRowTitle: "현재 행",
        aceEditorPanelTitle: "현재 패널",
        showMore: "자세한 내용은 설명서를 확인하십시오.",
        conditionShowMoreUrl: "https://surveyjs.io/Documentation/LibraryParameter?id=Question&parameter=visibleIf",
        assistantTitle: "유효 질문:",
        cellsEmptyRowsColumns: "최소한 하나의 열 또는 행이 있어야 합니다.",
        propertyIsEmpty: "값을 입력하십시오",
        value: "값",
        text: "텍스트",
        columnEdit: "열 편집: {0}",
        itemEdit: "항목 편집: {0}",
        url: "URL",
        path: "경로",
        valueName: "값 이름",
        titleName: "제목 이름",
        hasOther: "다른 항목이 있습니다",
        otherText: "기타 항목 텍스트",
        name: "이름",
        title: "제목",
        cellType: "셀 유형",
        colCount: "열 개수",
        choicesOrder: "항목 순서 선택",
        visible: "보입니까??",
        isRequired: "필수입니까?",
        startWithNewLine: "새 줄로 시작하겠습니까?",
        rows: "행 수",
        placeHolder: "입력 자리 표시자 ",
        showPreview: "이미지 미리보기가 표시됩니까?",
        storeDataAsText: "파일 내용을 JSON 결과에 텍스트로 저장",
        maxSize: "최대 파일 크기(bytes)",
        imageHeight: "이미지 높이",
        imageWidth: "이미지 너비",
        rowCount: "행 수",
        columnsLocation: "열 위치",
        addRowLocation: "행 버튼 위치 추가",
        addRowText: "행 버튼 텍스트 추가",
        removeRowText: "행 버튼 텍스트 제거",
        minRateDescription: "최소 설명 길이",
        maxRateDescription: "최대 설명 길이",
        inputType: "입력 유형",
        optionsCaption: "옵션 캡션",
        defaultValue: "기본값",
        cellsDefaultRow: "기본 셀 텍스트",
        surveyEditorTitle: "설문지 설정 편집",
        qEditorTitle: "편집: {0}",
        //survey
        showTitle: "제목 표시/숨김",
        locale: "기본 언어",
        mode: "모드(편집/읽기전용)",
        clearInvisibleValues: "보이지 않는 값 지우기",
        cookieName: "쿠키 이름(로컬에서 설문 조사를 두 번 사용하지 않도록 설정)",
        sendResultOnPageNext: "다음 페이지에서 설문 조사 결과 보내기",
        storeOthersAsComment: "다른 사용자의 값을 별도의 필드에 저장",
        showPageTitles: "페이지 제목 표시",
        showPageNumbers: "페이지 번호 표시",
        pagePrevText: "이전 페이지 버튼 텍스트",
        pageNextText: "다음 페이지 버튼 텍스트",
        completeText: "완료 버튼 텍스트",
        startSurveyText: "시작 버튼 텍스트",
        showNavigationButtons: "탐색 버튼 표시 (기본 탐색)",
        showPrevButton: "이전 버튼 표시 (사용자가 이전 페이지로 돌아갈 수 있음)",
        firstPageIsStarted: "설문지의 첫 번째 페이지는 시작 페이지입니다",
        showCompletedPage: "끝 부분에 완료된 페이지 표시 (완료된 HTML)",
        goNextPageAutomatic: "모든 질문에 응답 후 자동으로 다음 페이지로 이동",
        showProgressBar: "진행률 막대 표시",
        questionTitleLocation: "질문 제목 위치",
        requiredText: "질문에 필요한 기호",
        questionStartIndex: "질문 시작 색인 (1, 2 또는 'A', 'a')",
        showQuestionNumbers: "질문 번호 표시",
        questionTitleTemplate: "질문 제목 템플릿입니다. 기본값: '{no}. {require} {title}'",
        questionErrorLocation: "질문 위치 오류",
        focusFirstQuestionAutomatic: "페이지 변경시 첫 번째 질문에 초점",
        questionsOrder: "페이지의 요소 순서",
        maxTimeToFinish: "설문 조사를 마칠 수있는 최대 시간",
        maxTimeToFinishPage: "설문 조사에서 페이지를 마칠 수있는 최대 시간",
        showTimerPanel: "타이머 패널 표시",
        showTimerPanelMode: "타이머 패널 모드 표시",
        renderMode: "렌더링 모드",
        allowAddPanel: "패널 추가 허용",
        allowRemovePanel: "패널 제거 허용",
        panelAddText: "패널 텍스트 추가",
        panelRemoveText: "패널 텍스트 삭제",
        isSinglePage: "한 페이지에 모든 요소 표시",
        tabs: {
            general: "일반",
            fileOptions: "옵션",
            html: "Html 편집기",
            columns: "열",
            rows: "행",
            choices: "선택",
            items: "항목",
            visibleIf: "조건 충족시 보기",
            enableIf: "조건 충족시 허용",
            rateValues: "길이 값",
            choicesByUrl: "웹에서 선택",
            matrixChoices: "기본 선택",
            multipleTextItems: "텍스트 입력",
            validators: "유효성 검사기",
            navigation: "탐색",
            question: "질문",
            completedHtml: "완료된 HTML",
            loadingHtml: "HTML 로드 중",
            timer: "타이머 / 퀴즈",
            triggers: "트리거",
            templateTitle: "템플릿 제목"
        },
        editProperty: "편집 속성 '{0}'",
        items: "[ 항목: {0} ]",
        enterNewValue: "값을 입력하십시오.",
        noquestions: "설문 조사에는 어떤 질문도 없습니다.",
        createtrigger: "트리거를 만드십시오",
        triggerOn: "트리거 켜기",
        triggerMakePagesVisible: "페이지 표시:",
        triggerMakeQuestionsVisible: "요소 표시:",
        triggerCompleteText: "조건 충족 시 설문 조사를 작성하십시오.",
        triggerNotSet: "트리거가 설정되지 않았습니다.",
        triggerRunIf: "다음 조건 충족 시 실행",
        triggerSetToName: "다음 값 변경: ",
        triggerSetValue: "다음으로 수정: ",
        triggerIsVariable: "변수를 설문 결과에 넣지 마십시오."
    },
    //Property values
    pv: {
        true: "참",
        false: "거짓",
        inherit: "상속",
        show: "보기",
        hide: "숨기기",
        default: "기본값",
        initial: "초기값",
        random: "무작위",
        collapsed: "축소",
        expanded: "확장",
        none: "없음",
        asc: "오름차순",
        desc: "내림차순",
        indeterminate: "불확정",
        decimal: "진수",
        currency: "화폐",
        percent: "퍼센트",
        firstExpanded: "우선 확장",
        off: "꺼짐",
        onPanel: "패널에서",
        onSurvey: "설문에서",
        list: "목록",
        progressTop: "상단 진행률",
        progressBottom: "하단 진행률",
        progressTopBottom: "상하단 진행률",
        horizontal: "가로",
        vertical: "세로",
        top: "위",
        bottom: "아래",
        topBottom: "위아래",
        left: "왼쪽",
        color: "색상",
        date: "날짜",
        datetime: "날짜/시간",
        "datetime-local": "현지 날짜/시간",
        email: "이메일",
        month: "월",
        number: "숫자",
        password: "패스워드",
        range: "범위",
        tel: "tel",
        text: "텍스트",
        time: "시간",
        url: "URL",
        week: "주",
        hidden: "숨김",
        on: "켜기",
        onPage: "페이지 켜기",
        edit: "편집",
        display: "디스플레이",
        onComplete: "완료",
        onHidden: "숨김",
        all: "모두",
        page: "페이지",
        survey: "설문지",
        onNextPage: "다음 페이지로",
        onValueChanged: "값 변경"
    },
    //Operators
    op: {
        empty: "비어있습니다",
        notempty: "비어있지 않습니다",
        equal: "같습니다",
        notequal: "같지 않습니다",
        contains: "포함합니다",
        notcontains: "포함하지 않습니다",
        greater: "큰",
        less: "작은",
        greaterorequal: "크거나 같음",
        lessorequal: "작거나 같음"
    },
    //Embed window
    ew: {
        angular: "Angular 버전 사용",
        jquery: "jQuery 버전 사용",
        knockout: "Knockout 버전 사용",
        react: "React 버전 사용",
        vue: "Vue 버전 사용",
        bootstrap: "부트 스트랩 프레임",
        standard: "부트 스트랩 없음",
        showOnPage: "페이지에서 설문조사 보기",
        showInWindow: "윈도우 창에서 설문조사 보기",
        loadFromServer: "서버에서 설문조사 JSON 실행",
        titleScript: "스크립트 및 스타일",
        titleHtml: "HTML",
        titleJavaScript: "자바스크립트"
    },
    //Test Survey
    ts: {
        selectPage: "테스트 할 페이지를 선택하십시오:"
    },
    validators: {
        answercountvalidator: "답 개수",
        emailvalidator: "이메일",
        expressionvalidator: "표현식",
        numericvalidator: "숫자",
        regexvalidator: "정규식",
        textvalidator: "텍스트"
    },
    triggers: {
        completetrigger: "설문 완료",
        setvaluetrigger: "값 설정",
        visibletrigger: "선명도 변경"
    },
    //Properties
    p: {
        name: "이름",
        title: {
            name: "제목",
            title: "'이름'과 같은 경우 비워 둡니다."
        },
        navigationButtonsVisibility: "탐색 버튼 선명도",
        questionsOrder: "질문 순서",
        maxTimeToFinish: "최대 완료 시간",
        visible: "보기",
        visibleIf: "조건 충족시 보기",
        questionTitleLocation: "질문 제목 위치",
        description: "설명",
        state: "state",
        isRequired: "필수",
        indent: "들여쓰기",
        requiredErrorText: "필수 오류 텍스트",
        startWithNewLine: "새 줄로 시작",
        innerIndent: "안으로 들여쓰기",
        page: "페이지",
        width: "너비",
        commentText: "메모 텍스트",
        valueName: "이름값",
        enableIf: "조건 충족시 허가",
        defaultValue: "기본값",
        correctAnswer: "답안 수정",
        readOnly: "읽기 전용",
        validators: "유효성 검사기",
        titleLocation: "제목 위치",
        hasComment: "답변",
        hasOther: "다른 답변 허용",
        choices: "선택",
        choicesOrder: "기타 선택",
        choicesByUrl: "URL을 통한 선택",
        otherText: "기타 텍스트",
        otherErrorText: "기타 오류 텍스트",
        storeOthersAsComment: "기타 답변 저장",
        label: "라벨",
        showTitle: "제목 표시",
        valueTrue: "참값",
        valueFalse: "거짓값",
        cols: "열",
        rows: "행",
        placeHolder: "자리 표시자",
        optionsCaption: "옵션 캡션",
        expression: "표현식",
        format: "포맷",
        displayStyle: "디스플레이 스타일",
        currency: "화폐",
        useGrouping: "그룹 사용",
        showPreview: "미리보기 보기",
        allowMultiple: "다수 허용",
        imageHeight: "이미지 높이",
        imageWidth: "이미지 너비",
        storeDataAsText: "텍스트로 데이터 저장",
        maxSize: "최대 크기",
        html: "HTML",
        columns: "열",
        cells: "셀",
        isAllRowRequired: "모두 필수 행입니까",
        horizontalScroll: "가로 스크롤바",
        cellType: "셀 유형",
        columnsLocation: "열 위치",
        columnColCount: "열 개수",
        columnMinWidth: "열 최소 너비",
        rowCount: "행 수",
        minRowCount: "최소 행 개수",
        maxRowCount: "최대 행 개수",
        keyName: "keyName",
        keyDuplicationError: "주요 복제 에러",
        confirmDelete: "삭제 확인",
        confirmDeleteText: "텍스트 삭제 확인",
        addRowLocation: "행 위치 추가",
        addRowText: "행 텍스트 추가",
        removeRowText: "행 텍스트 제거",
        items: "항목",
        itemSize: "항목 크기",
        colCount: "열 개수",
        templateTitle: "템플릿 이름",
        templateDescription: "템플릿 설명",
        allowAddPanel: "패널 추가 허용",
        allowRemovePanel: "패널 제거 허용",
        panelCount: "패널 개수",
        minPanelCount: "최소 패널 개수",
        maxPanelCount: "최대 패널 개수",
        panelsState: "panelsState",
        panelAddText: "패널 텍스트 추가",
        panelRemoveText: "패널 텍스트 제거",
        panelPrevText: "이전 패널 텍스트",
        panelNextText: "다음 패널 텍스트",
        showQuestionNumbers: "질문 개수 보기",
        showRangeInProgress: "진행중인 범위 보기",
        renderMode: "renderMode",
        templateTitleLocation: "템플릿 이름 위치",
        rateValues: "길이값",
        rateMin: "최소 길이",
        rateMax: "최대 길이",
        rateStep: "rateStep",
        minRateDescription: "최소 설명 길이",
        maxRateDescription: "최대 설명 길이",
        inputType: "입력 유형",
        size: "크기",
        locale: "로컬",
        focusFirstQuestionAutomatic: "첫 질문 자동 초점",
        completedHtml: "완료된 HTML",
        completedBeforeHtml: "완료된 이전 HTML",
        loadingHtml: "HTML 로드",
        triggers: "트리거",
        cookieName: "쿠키 이름",
        sendResultOnPageNext: "현 페이지로 결과 전송",
        showNavigationButtons: "탐색 버튼 보기",
        showPrevButton: "뒤로가기 버튼 보기",
        showPageTitles: "페이지 제목 보기",
        showCompletedPage: "완료 페이지 보기",
        showPageNumbers: "페이지 수 보기",
        questionErrorLocation: "질문 오류 위치",
        showProgressBar: "진행 상태바 보기",
        mode: "모드",
        goNextPageAutomatic: "다음 페이지로 자동으로 넘어가기",
        checkErrorsMode: "오류 모드 확인",
        clearInvisibleValues: "보이지 않는 변수 제거",
        startSurveyText: "설문 테스트 시작",
        pagePrevText: "이전 텍스트 페이지",
        pageNextText: "다음 텍스트 페이지",
        completeText: "완료 텍스트",
        requiredText: "필수 텍스트",
        questionStartIndex: "질문 시작 색인",
        questionTitleTemplate: "질문 제목 템플릿",
        firstPageIsStarted: "첫 페이지에서 시작",
        isSinglePage: "단일 페이지",
        maxTimeToFinishPage: "페이지 종료 최대 시간",
        showTimerPanel: "타이머 패널 보기",
        showTimerPanelMode: "타이머 패널 모드 보기",
        text: "텍스트",
        minValue: "최소값",
        maxValue: "최대값",
        minLength: "최소 길이",
        maxLength: "최대 길이",
        allowDigits: "숫자 허용",
        minCount: "최소 개수",
        maxCount: "최대 개수",
        regex: "정규 표현식"
    }
};
__WEBPACK_IMPORTED_MODULE_0__editorLocalization__["a" /* editorLocalization */].locales["ko"] = koreanStrings;


/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__editorLocalization__ = __webpack_require__(0);
/* unused harmony export nbStrings */
//Uncomment this line on creating a translation file

var nbStrings = {
    //survey templates
    survey: {
        edit: "Rediger",
        dropQuestion: "Dra og slipp et spørsmål her fra Verktøylisten til venstre.",
        copy: "Kopier",
        addToToolbox: "Legg til Verktøylisten",
        deletePanel: "Slett Panel",
        deleteQuestion: "Slett spørsmål",
        convertTo: "Konverter til",
        drag: "Dra element"
    },
    //questionTypes
    qt: {
        default: "Standard",
        checkbox: "Sjekkboks",
        comment: "Kommentar",
        imagepicker: "Bilde-velger",
        dropdown: "Nedtrekksliste",
        file: "Fil",
        html: "Html",
        matrix: "Matrise (enkelvalg)",
        matrixdropdown: "Matrise (flere valg)",
        matrixdynamic: "Matrise (dynamiske rader)",
        multipletext: "Flerlinje tekst",
        panel: "Panel",
        paneldynamic: "Panel (dynamisk panel)",
        radiogroup: "Radiogruppe",
        rating: "Rangering",
        text: "Enkel tekst",
        boolean: "Boolean",
        expression: "Formel"
    },
    //Strings in Editor
    ed: {
        defaultLocale: "Standard ({0})",
        survey: "Skjema",
        settings: "Skjema innstillinger",
        editSurvey: "Rediger skjema",
        addNewPage: "Legg til ny side",
        moveRight: "Bla til høyre",
        moveLeft: "Bla til venstre",
        deletePage: "Slett side",
        editPage: "Rediger side",
        edit: "Rediger",
        newPageName: "side",
        newQuestionName: "spørsmål",
        newPanelName: "panel",
        testSurvey: "Test skjema",
        testSurveyAgain: "Test skjema igjen",
        testSurveyWidth: "Skjema bredde: ",
        embedSurvey: "Integrer skjema",
        translation: "Oversettelse",
        saveSurvey: "Lagre skjema",
        designer: "Skjema Designer",
        jsonEditor: "JSON Redigering",
        undo: "Angre",
        redo: "Gjenta",
        options: "Alternativer",
        generateValidJSON: "Lag gyldig JSON",
        generateReadableJSON: "Lag lesbar JSON",
        toolbox: "Verktøyliste",
        toolboxGeneralCategory: "Generelt",
        delSelObject: "Slett valgte elementer",
        editSelObject: "Rediger valgte elementer",
        correctJSON: "Vennligst korriger JSON.",
        surveyResults: "Skjema resultat: ",
        surveyResultsTable: "Som tabell",
        surveyResultsJson: "Som JSON",
        resultsTitle: "Spørsmål tittel",
        resultsName: "Spørsmål navn",
        resultsValue: "Svar verdi",
        resultsDisplayValue: "Vist verdi",
        modified: "Endret",
        saving: "Lagrer",
        saved: "Lagret",
        saveError: "Feil! Skjema innhold er ikke lagret.",
        translationAddLanguage: "Velg språk for oversetting",
        translationShowAllStrings: "Vis alle strenger",
        translationShowAllPages: "Vis alle sider",
        translationNoStrings: "Ingen strenger å oversette. Vennligst endre filteret.",
        translationExportToSCVButton: "Eksporter til CSV",
        translationImportFromSCVButton: "Importer fra CSV",
        translationMergeLocaleWithDefault: "Flett {0} med standard språk"
    },
    //Property names in table headers
    pel: {
        isRequired: "Nødvendig?"
    },
    //Property Editors
    pe: {
        apply: "Bruk",
        ok: "OK",
        cancel: "Avbryt",
        reset: "Tilbakestill",
        close: "Lukk",
        delete: "Slett",
        addNew: "Legg til ny",
        addItem: "Klikk for å legge til...",
        removeAll: "Fjern alt",
        edit: "Rediger",
        itemValueEdit: "Synlig dersom",
        editChoices: "Rediger valg",
        move: "Flytt",
        empty: "<tom>",
        notEmpty: "<rediger verdi>",
        fastEntry: "Rask innfylling",
        formEntry: "Innfylling i skjema",
        testService: "Sjekk tjenesten",
        conditionSelectQuestion: "Velg spørsmål...",
        conditionValueQuestionTitle: "Vennligst skriv inn/velg verdi",
        conditionButtonAdd: "Legg til",
        conditionButtonReplace: "Erstatt",
        conditionHelp: "Skriv inn et boolsk uttrykk. Det burde returnere SANN for å gjøre spørsmål/side synlig. For eksempel: {question1} = 'value1' or ({question2} * {question4}  > 20 and {question3} < 5)",
        expressionHelp: "Vennligst skriv inn et uttrykk.  Du kan bruke klammeparenteser for å få tilgang til spørsmåls verdiene: '{question1} + {question2}', '({price}*{quantity}) * (100 - {discount})'",
        aceEditorHelp: "Trykk ctrl+mellomrom for å få hint til å fullføre uttrykk",
        aceEditorRowTitle: "Gjeldende rad",
        aceEditorPanelTitle: "Gjeldende panel",
        showMore: "For mer detaljer - se dokumentasjonen",
        conditionShowMoreUrl: "https://surveyjs.io/Documentation/LibraryParameter?id=Question&parameter=visibleIf",
        assistantTitle: "Tilgjengelige spørsmål:",
        cellsEmptyRowsColumns: "Det må være minst 1 kolonne eller rad",
        propertyIsEmpty: "Vennligst fyll inn en verdi",
        value: "Verdi",
        text: "Tekst",
        rowid: "Rad ID",
        imageLink: "Bilde lenke",
        columnEdit: "Rediger kolonne: {0}",
        itemEdit: "Rediger element: {0}",
        url: "URL",
        path: "Sti",
        valueName: "Verdi navn",
        titleName: "Tittel navn",
        hasOther: "Har annet element",
        otherText: "Annet element tekst",
        name: "Navn",
        title: "Tittel",
        cellType: "Celle type",
        colCount: "Antall kolonner",
        choicesOrder: "Velg rekkefølge på valg",
        visible: "Er synlig?",
        isRequired: "Er nødvendig?",
        startWithNewLine: "Er start med ny linje?",
        rows: "Antall rader",
        placeHolder: "Inndate plassholder",
        showPreview: "Er forhåndsvisning av bilde vist?",
        storeDataAsText: "Lagre fil innhold i JSON resultat som tekst",
        maxSize: "Maksimum filstørrelse i bytes",
        imageHeight: "Bilde høyde",
        imageWidth: "Bilde bredde",
        rowCount: "Antall rader",
        columnLayout: "Oppsett kolonner",
        addRowLocation: "Legg til rad knapp plassering",
        addRowText: "Legg til rad knapp tekst",
        removeRowText: "Fjern rad knapp tekst",
        minRateDescription: "Beskrivelse Minimum vudering",
        maxRateDescription: "Beskrivelse Maksimum vurdering",
        inputType: "Inndata type",
        optionsCaption: "Tekst for alternativer",
        defaultValue: "Standard verdi",
        cellsDefaultRow: "Standard celle tekster",
        surveyEditorTitle: "Rediger skjema innstillinger",
        qEditorTitle: "Rediger: {0}",
        maxLength: "Maksimum lengde",
        //survey
        showTitle: "Vis/skjul tittel",
        locale: "Standard språk",
        mode: "Modus (redigere/kun lesing)",
        clearInvisibleValues: "Fjern usynlige verdier",
        cookieName: "Informasjonskapsel navn (for å hindre bruk av skjema to ganger localt)",
        sendResultOnPageNext: "Send skjema resultat ved neste side",
        storeOthersAsComment: "Lagre 'andre' verdier i et separat felt",
        showPageTitles: "Vis sidetitel",
        showPageNumbers: "Vis sidenummer",
        pagePrevText: "Forrige side knapp tekst",
        pageNextText: "Neste side knapp tekst",
        completeText: "Fullfør knapp tekst",
        startSurveyText: "Start knapp tekst",
        showNavigationButtons: "Vis navigasjonsknapper (standard navigering)",
        showPrevButton: "Vis forrige knapp (bruker kan gå til forrige side)",
        firstPageIsStarted: "Den første siden i skjema er startside.",
        showCompletedPage: "Vis ferdigsiden på slutten (completedHtml)",
        goNextPageAutomatic: "Når en har svart alle spørsmål, gå til neste side automatisk",
        showProgressBar: "Vis fremdriftslinje",
        questionTitleLocation: "Spørsmål tittel plassering",
        requiredText: "Svar nødvendig symbol(er)",
        questionStartIndex: "Spørsmål startindeks (1, 2 eller 'A', 'a')",
        showQuestionNumbers: "Vis spørsmålsnummer",
        questionTitleTemplate: "Spørsmål tittel mal, standard er: '{no}. {require} {title}'",
        questionErrorLocation: "Spørsmål feil plassering",
        focusFirstQuestionAutomatic: "Sett fokus på første spørsmål når en endrer side",
        questionsOrder: "Rekkefølge på elementer på siden",
        maxTimeToFinish: "Maks tid for å gjøre ferdig skjema",
        maxTimeToFinishPage: "Maks tid til å gjøre ferdig en side i skjema",
        showTimerPanel: "Vis tidtaking",
        showTimerPanelMode: "Vis tidtaking modus",
        renderMode: "Gjengivelse modus",
        allowAddPanel: "Tillat å legge til panel",
        allowRemovePanel: "Tillat å fjerne panel",
        panelAddText: "Legg til panel tekst",
        panelRemoveText: "Fjern panel tekst",
        isSinglePage: "Vis alle elementer på en side",
        tabs: {
            general: "Generelt",
            fileOptions: "Alternativer",
            html: "Html-editor",
            columns: "Kolonner",
            rows: "Rader",
            choices: "Valg",
            items: "Elementer",
            visibleIf: "Synlig hvis",
            enableIf: "Tilgjengelig hvis",
            rateValues: "Rangering verdier",
            choicesByUrl: "Valg fra web",
            matrixChoices: "Standard valg",
            multipleTextItems: "Tekst inndata",
            validators: "Valideringer",
            navigation: "Navigering",
            question: "Spørsmål",
            completedHtml: "Fullført Html",
            loadingHtml: "Laster Html",
            timer: "Tidtaker/Quiz",
            triggers: "Triggere",
            templateTitle: "Mal tittel"
        },
        editProperty: "Rediger egenskap '{0}'",
        items: "[ Elementer: {0} ]",
        enterNewValue: "Vennligst skriv inn en verdi.",
        noquestions: "Der er ingen spørsmål i skjema.",
        createtrigger: "Vennligst lag en trigger",
        triggerOn: "Når ",
        triggerMakePagesVisible: "Gjør sider synlige:",
        triggerMakeQuestionsVisible: "Gjør elementer synlige:",
        triggerCompleteText: "Fullfør skjema dersom vellykket.",
        triggerNotSet: "Trigger er ikke satt",
        triggerRunIf: "Kjør dersom",
        triggerSetToName: "Endre verdien av: ",
        triggerFromName: "Kopier verdi fra: ",
        triggerRunExpression: "Kjør dette uttrykket:",
        triggerSetValue: "til: ",
        triggerIsVariable: "Ikke legg variabelen i resultatet."
    },
    //Property values
    pv: {
        true: "true",
        false: "false",
        inherit: "inherit",
        show: "show",
        hide: "hide",
        default: "default",
        initial: "initial",
        random: "random",
        collapsed: "collapsed",
        expanded: "expanded",
        none: "none",
        asc: "ascending",
        desc: "descending",
        indeterminate: "indeterminate",
        decimal: "decimal",
        currency: "currency",
        percent: "percent",
        firstExpanded: "firstExpanded",
        off: "off",
        onPanel: "onPanel",
        onSurvey: "onSurvey",
        list: "list",
        progressTop: "progressTop",
        progressBottom: "progressBottom",
        progressTopBottom: "progressTopBottom",
        horizontal: "horizontal",
        vertical: "vertical",
        top: "top",
        bottom: "bottom",
        topBottom: "top and bottom",
        left: "left",
        color: "color",
        date: "date",
        datetime: "datetime",
        "datetime-local": "datetime-local",
        email: "email",
        month: "month",
        number: "number",
        password: "password",
        range: "range",
        tel: "tel",
        text: "text",
        time: "time",
        url: "url",
        week: "week",
        hidden: "hidden",
        on: "on",
        onPage: "onPage",
        edit: "edit",
        display: "display",
        onComplete: "onComplete",
        onHidden: "onHidden",
        all: "all",
        page: "page",
        survey: "survey",
        onNextPage: "onNextPage",
        onValueChanged: "onValueChanged"
    },
    //Operators
    op: {
        empty: "is empty",
        notempty: "is not empty",
        equal: "equals",
        notequal: "not equals",
        contains: "contains",
        notcontains: "not contains",
        greater: "greater",
        less: "less",
        greaterorequal: "greater or equals",
        lessorequal: "less or equals"
    },
    //Embed window
    ew: {
        angular: "Bruk Angular versjon",
        jquery: "Bruk jQuery versjon",
        knockout: "Bruk Knockout versjon",
        react: "Bruk React versjon",
        vue: "Bruk Vue versjon",
        bootstrap: "For bootstrap framework",
        standard: "Ingen bootstrap",
        showOnPage: "Vis skjema på en side",
        showInWindow: "Vis skjema i et vindu",
        loadFromServer: "Hent skjema som JSON fra serveren",
        titleScript: "Scripts og styles",
        titleHtml: "HTML",
        titleJavaScript: "JavaScript"
    },
    //Test Survey
    ts: {
        selectPage: "Velg siden for å teste den:",
        showInvisibleElements: "Vis usynlige elementer"
    },
    validators: {
        answercountvalidator: "answer count",
        emailvalidator: "e-mail",
        expressionvalidator: "expression",
        numericvalidator: "numeric",
        regexvalidator: "regex",
        textvalidator: "text"
    },
    triggers: {
        completetrigger: "skjema fullført",
        setvaluetrigger: "sett verdi",
        copyvaluetrigger: "kopier verdi",
        runexpressiontrigger: "kjør uttrykk",
        visibletrigger: "endre synlighet"
    },
    //Properties
    p: {
        name: "name",
        title: {
            name: "title",
            title: "La den være tom hvis det er samme som 'Name'"
        },
        navigationButtonsVisibility: "navigationButtonsVisibility",
        questionsOrder: "questionsOrder",
        maxTimeToFinish: "maxTimeToFinish",
        visible: "visible",
        visibleIf: "visibleIf",
        questionTitleLocation: "questionTitleLocation",
        description: "description",
        state: "state",
        isRequired: "isRequired",
        indent: "indent",
        requiredErrorText: "requiredErrorText",
        startWithNewLine: "startWithNewLine",
        innerIndent: "innerIndent",
        page: "page",
        width: "width",
        commentText: "commentText",
        valueName: "valueName",
        enableIf: "enableIf",
        defaultValue: "defaultValue",
        correctAnswer: "correctAnswer",
        readOnly: "readOnly",
        validators: "validators",
        titleLocation: "titleLocation",
        hasComment: "hasComment",
        hasOther: "hasOther",
        choices: "choices",
        choicesOrder: "choicesOrder",
        choicesByUrl: "choicesByUrl",
        otherText: "otherText",
        otherErrorText: "otherErrorText",
        storeOthersAsComment: "storeOthersAsComment",
        label: "label",
        showTitle: "showTitle",
        valueTrue: "valueTrue",
        valueFalse: "valueFalse",
        cols: "cols",
        rows: "rows",
        placeHolder: "placeHolder",
        optionsCaption: "optionsCaption",
        expression: "expression",
        format: "format",
        displayStyle: "displayStyle",
        currency: "currency",
        useGrouping: "useGrouping",
        showPreview: "showPreview",
        allowMultiple: "allowMultiple",
        imageHeight: "imageHeight",
        imageWidth: "imageWidth",
        storeDataAsText: "storeDataAsText",
        maxSize: "maxSize",
        html: "html",
        columns: "columns",
        cells: "cells",
        isAllRowRequired: "isAllRowRequired",
        horizontalScroll: "horizontalScroll",
        cellType: "cellType",
        columnsLayout: "columnsLayout",
        columnColCount: "columnColCount",
        columnMinWidth: "columnMinWidth",
        rowCount: "rowCount",
        minRowCount: "minRowCount",
        maxRowCount: "maxRowCount",
        keyName: "keyName",
        keyDuplicationError: "keyDuplicationError",
        confirmDelete: "confirmDelete",
        confirmDeleteText: "confirmDeleteText",
        addRowLocation: "addRowLocation",
        addRowText: "addRowText",
        removeRowText: "removeRowText",
        items: "items",
        itemSize: "itemSize",
        colCount: "colCount",
        templateTitle: "templateTitle",
        templateDescription: "templateDescription",
        allowAddPanel: "allowAddPanel",
        allowRemovePanel: "allowRemovePanel",
        panelCount: "panelCount",
        minPanelCount: "minPanelCount",
        maxPanelCount: "maxPanelCount",
        panelsState: "panelsState",
        panelAddText: "panelAddText",
        panelRemoveText: "panelRemoveText",
        panelPrevText: "panelPrevText",
        panelNextText: "panelNextText",
        showQuestionNumbers: "showQuestionNumbers",
        showRangeInProgress: "showRangeInProgress",
        renderMode: "renderMode",
        templateTitleLocation: "templateTitleLocation",
        rateValues: "rateValues",
        rateMin: "rateMin",
        rateMax: "rateMax",
        rateStep: "rateStep",
        minRateDescription: "minRateDescription",
        maxRateDescription: "maxRateDescription",
        inputType: "inputType",
        size: "size",
        locale: "locale",
        focusFirstQuestionAutomatic: "focusFirstQuestionAutomatic",
        completedHtml: "completedHtml",
        completedBeforeHtml: "completedBeforeHtml",
        loadingHtml: "loadingHtml",
        triggers: "triggers",
        cookieName: "cookieName",
        sendResultOnPageNext: "sendResultOnPageNext",
        showNavigationButtons: "showNavigationButtons",
        showPrevButton: "showPrevButton",
        showPageTitles: "showPageTitles",
        showCompletedPage: "showCompletedPage",
        showPageNumbers: "showPageNumbers",
        questionErrorLocation: "questionErrorLocation",
        showProgressBar: "showProgressBar",
        mode: "mode",
        goNextPageAutomatic: "goNextPageAutomatic",
        checkErrorsMode: "checkErrorsMode",
        clearInvisibleValues: "clearInvisibleValues",
        startSurveyText: "startSurveyText",
        pagePrevText: "pagePrevText",
        pageNextText: "pageNextText",
        completeText: "completeText",
        requiredText: "requiredText",
        questionStartIndex: "questionStartIndex",
        questionTitleTemplate: "questionTitleTemplate",
        firstPageIsStarted: "firstPageIsStarted",
        isSinglePage: "isSinglePage",
        maxTimeToFinishPage: "maxTimeToFinishPage",
        showTimerPanel: "showTimerPanel",
        showTimerPanelMode: "showTimerPanelMode",
        defaultPanelValue: "defaultPanelValue",
        defaultRowValue: "defaultRowValue",
        hasNone: "hasNone",
        noneText: "noneText",
        text: "text",
        minValue: "minimum value",
        maxValue: "maximum value",
        minLength: "minumum length",
        maxLength: "maximum length",
        allowDigits: "allow digits",
        minCount: "minumum count",
        maxCount: "maximum count",
        regex: "regular expression"
    }
};
//Uncomment this line on creating a translation file. You should replace "en" and enStrings with your locale ("fr", "de" and so on) and your variable.
__WEBPACK_IMPORTED_MODULE_0__editorLocalization__["a" /* editorLocalization */].locales["nb"] = nbStrings;


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__editorLocalization__ = __webpack_require__(0);

var persianStrings = {
    //survey templates
    survey: {
        edit: "ویرایش",
        dropQuestion: "لطفا از جعبه ابزار سوالی در اینجا قرار دهید",
        copy: "کپی",
        addToToolbox: "افزودن به جعبه ابزار",
        deletePanel: "حذف پنل",
        deleteQuestion: "حذف سوال",
        convertTo: "تبدیل به"
    },
    //questionTypes
    qt: {
        checkbox: "چند انتخابی",
        comment: "نظر",
        dropdown: "لیست انتخابی",
        file: "فایل",
        html: "Html",
        matrix: "ماتریس (تک انتخابی)",
        matrixdropdown: "ماتریس (چند انتخابی)",
        matrixdynamic: "ماتریس (سطرهای داینامیک)",
        multipletext: "متن چند خطی",
        panel: "پنل",
        paneldynamic: "پنل (پنل های داینامیک)",
        radiogroup: "تک انتخابی",
        rating: "رتبه بندی",
        text: "متن تک خطی",
        boolean: "صحیح و غلط",
        expression: "توصیفی"
    },
    //Strings in Editor
    ed: {
        defaultLocale: "پیش فرض ({0})",
        survey: "نظرسنجی",
        editSurvey: "ویرایش نظرسنجی",
        addNewPage: "درج صفحه جدید",
        moveRight: "اسکرول به راست",
        moveLeft: "اسکرول به چپ",
        deletePage: "حذف صفحه",
        editPage: "ویرایش صفحه",
        edit: "ویرایش",
        newPageName: "صفحه",
        newQuestionName: "سوال",
        newPanelName: "پنل",
        testSurvey: "آزمایش نظرسنجی",
        testSurveyAgain: "آزمایش دوباره نظرسنجی",
        testSurveyWidth: "عرض نظرسنجی: ",
        embedSurvey: "نظرسنجی توکار",
        translation: "ترجمه",
        saveSurvey: "ذخیره نظرسنجی",
        designer: "طراح نظرسنجی",
        jsonEditor: "ویرایشگر JSON",
        undo: "بازگردانی",
        redo: "بازانجام",
        options: "انتخاب ها",
        generateValidJSON: "تولید کد معتبر JSON",
        generateReadableJSON: "تولید کد خوانا JSON",
        toolbox: "جعبه ابزار",
        toolboxGeneralCategory: "عمومی",
        delSelObject: "حذف مورد انتخابی",
        editSelObject: "ویرایش مورد انتخابی",
        correctJSON: "لطفا JSON را تصحیح کنید.",
        surveyResults: "نتایج نظرسنجی: ",
        surveyResultsTable: "به صورت جدول",
        surveyResultsJson: "به صورت JSON",
        resultsTitle: "عنوان سوال",
        resultsName: "نام سوال",
        resultsValue: "محتوای پاسخ",
        resultsDisplayValue: "محتوای نمایشی",
        modified: "تغییر داده شده",
        saving: "در حال ذخیره",
        saved: "ذخیره شد",
        saveError: "خطا! محتوای ویرایشگر ذخیره نشده است.",
        translationAddLanguage: "زبانی را برای ترجمه انتخاب کنید",
        translationShowAllStrings: "نمایش تمام عبارات",
        translationShowAllPages: "نمایش تمام صفحات",
        translationNoStrings: "هیچ عبارتی برای ترجمه نیست، لطفا فیلتر را عوض کنید.",
        translationExportToSCVButton: "برون بری به CSV",
        translationImportFromSCVButton: "برون ریزی از CSV",
        translationMergeLocaleWithDefault: "ادغام {0} با زبان پیش فرض"
    },
    //Property names in table headers
    pel: {
        isRequired: "اجباری؟"
    },
    //Property Editors
    pe: {
        apply: "اعمال",
        ok: "تایید",
        cancel: "لغو",
        reset: "بازنشانی",
        close: "بستن",
        delete: "حذف",
        addNew: "افزودن",
        removeAll: "حذف همه",
        edit: "ویرایش",
        empty: "<خالی>",
        fastEntry: "تکمیل سریع",
        formEntry: "تکمیل فرم",
        testService: "بررسی سرویس",
        conditionHelp: "لطفا یک مقدار بولین توصیفی وارد کنید که صحیح یا غلط را برگرداند تا صفحه سوالات نمایش داده شود. برای مثال: {question1} = 'value1' or ({question2} * {question4}  > 20 and {question3} < 5)",
        expressionHelp: "لطفا یک عبارت توصیفی را وارد کنید. شما ممکن است از کروشه برای دسترسی به مقدار سوالات استفاده کنید. برای مثال: {question1} = 'value1' or ({question2} = 3 and {question3} < 5)",
        aceEditorHelp: "برای مشاهده نکات تکمیلی ctrl+space را بفشارید",
        aceEditorRowTitle: "سطر فعلی",
        aceEditorPanelTitle: "پنل فعلی",
        showMore: "برای اطلاعات بیشتر لطفا سند راهنما را مطالعه کنید",
        assistantTitle: "سوالات موجود:",
        propertyIsEmpty: "لطفا یک مقدار وارد کنید",
        value: "مقدار",
        text: "متن",
        columnEdit: "ویرایش ستون: {0}",
        itemEdit: "ویرایش آیتم: {0}",
        url: "URL",
        path: "Path",
        valueName: "نام مقدار",
        titleName: "نام عنوان",
        hasOther: "دارای آیتم دیگر",
        name: "نام",
        title: "عنوان",
        cellType: "نوع سلول",
        colCount: "تعداد ستون",
        choicesOrder: "ترتیب گزینه را انتخاب کنید",
        visible: "نمایش داده شود؟",
        isRequired: "ضروری است؟",
        startWithNewLine: "با سطر جدید شروع شود؟",
        rows: "تعداد سطر",
        placeHolder: "نگهدارنده متن",
        showPreview: "پیش نمایش تصویر نشان داده شود؟",
        storeDataAsText: "ذخیره کردن محتوای فایل در JSON به عنوان متن",
        maxSize: "حداکثر سایز به بایت",
        imageHeight: "ارتفاع تصویر",
        imageWidth: "عرض تصویر",
        rowCount: "تعداد سطر",
        addRowText: "متن دکمه درج سطر",
        removeRowText: "متن دکمه حذف سطر",
        minRateDescription: "توضیح حداقل امتیاز",
        maxRateDescription: "توضیح حداکثر امتیاز",
        inputType: "نوع ورودی",
        optionsCaption: "نوشته انتخاب ها",
        defaultValue: "مقدار پیش فرض",
        surveyEditorTitle: "ویرایش نظرسنجی",
        qEditorTitle: "ویرایش سوال: {0}",
        //survey
        showTitle: "نمایش/پنهان کردن عنوان",
        locale: "زبان پیش فرض",
        mode: "حالت (ویرایش/خواندن)",
        clearInvisibleValues: "پاکسازی مقادیر پنهان",
        cookieName: "نام کوکی (به منظور جلوگیری از اجرای دوباره نظرسنجی)",
        sendResultOnPageNext: "ارسال نتایج نظرسنجی در صفحه بعدی",
        storeOthersAsComment: "ذخیره مقدار 'سایر' در فیلد جداگانه",
        showPageTitles: "نمایش عنوان صفحات",
        showPageNumbers: "نمایش شماره صفحات",
        pagePrevText: "متن دکمه صفحه قبلی",
        pageNextText: "متن دکمه صفحه بعدی",
        completeText: "متن دکمه تکمیل نظرسنجی",
        startSurveyText: "متن دکمه شروع نظرسنجی",
        showNavigationButtons: "نمایش دکمه های ناوبری (ناوبری پیش فرض)",
        showPrevButton: "نمایش دکمه قبلی (کاربر ممکن است به صفحه قبل برگردد)",
        firstPageIsStarted: "صفحه اول در نظرسنجی نقطه آغازین آن است.",
        showCompletedPage: "نمایش صفحه اتمام نظرسنجی در پایان (completedHtml)",
        goNextPageAutomatic: "با پاسخگویی به تمام سوالات، به صورت اتوماتیک به صفحه بعد برود",
        showProgressBar: "نمایش نشانگر پیشرفت",
        questionTitleLocation: "محل عنوان سوال",
        requiredText: "سوالات نشان دار اجباری هستند",
        questionStartIndex: "نمایه شروع سوالات (۱،۲ یا a و b)",
        showQuestionNumbers: "نمایش شماره های سوالات",
        questionTitleTemplate: "قالب عنوان سوال، به صورت پیش فرض: '{no}. {require} {title}'",
        questionErrorLocation: "محل خطای سوال",
        focusFirstQuestionAutomatic: "تمرکز بر روی اولین سوال با تغییر صفحه",
        questionsOrder: "ترتیب المان ها در صفحه",
        maxTimeToFinish: "نهایت زمان برای اتمام نظرسنجی",
        maxTimeToFinishPage: "نهایت زمان برای اتمام این صفحه نظرسنجی",
        showTimerPanel: "نمایش پنل زمان سنج",
        showTimerPanelMode: "نمایش حالت پنل زمان سنج",
        renderMode: "حالت رندر",
        allowAddPanel: "اجازه افزودن پنل",
        allowRemovePanel: "اجازه حذف پنل",
        panelAddText: "متن افزودن پنل",
        panelRemoveText: "متن حذف پنل",
        isSinglePage: "نمایش تمام المان ها در یک صفحه",
        tabs: {
            general: "عمومی",
            fileOptions: "انتخاب ها",
            html: "ویرایشگر HTML",
            columns: "ستون ها",
            rows: "سطرها",
            choices: "انتخاب ها",
            visibleIf: "نمایش در صورت",
            rateValues: "مقادیر رتبه بندی",
            choicesByUrl: "انتخاب ها از وب",
            matrixChoices: "انتخاب های پیشفرض",
            multipleTextItems: "فیلدهای متنی",
            validators: "اعتبارسنجی ها",
            navigation: "ناوبری",
            question: "سوال",
            completedHtml: "HTML صفحه تکمیل نظرسنجی",
            loadingHtml: "HTML بارگزاری",
            timer: "زمان سنج/کوئیز",
            triggers: "اجرا کننده",
            templateTitle: "عنوان قالب"
        },
        editProperty: "ویرایش خصوصیت '{0}'",
        items: "[ آیتم ها: {0} ]",
        enterNewValue: "لطفا یک مقدار وارد کنید",
        noquestions: "سوالی در پرسشنامه درج نشده",
        createtrigger: "اجرا کننده ای بسازید",
        triggerOn: "در ",
        triggerMakePagesVisible: "صفحات را قابل نمایش کن:",
        triggerMakeQuestionsVisible: "سوالات را قابل نمایش کن:",
        triggerCompleteText: "پرسشنامه را تکمیل کن اگر موفق بود.",
        triggerNotSet: "اجرا کننده تنظیم نشده.",
        triggerRunIf: "اجرا در صورت",
        triggerSetToName: "تعییر مقدار از: ",
        triggerSetValue: "به: ",
        triggerIsVariable: "عدم درج متغییر در نتایج پرسشنامه"
    },
    //Property values
    pv: {
        true: "صحیح",
        false: "غلط",
        inherit: "ارث بری",
        show: "آشکار",
        hide: "پنهان",
        default: "پیش فرض",
        initial: "اولیه",
        random: "تصادفی",
        collapsed: "جمع شده",
        expanded: "باز شده",
        none: "هیچ کدام",
        asc: "صعودی",
        desc: "نزولی",
        indeterminate: "نامشخص",
        decimal: "اعشاری",
        currency: "ارز",
        percent: "درصد",
        firstExpanded: "firstExpanded",
        off: "خاموش",
        onPanel: "روی پنل",
        onSurvey: "روی نظرسنجی",
        list: "لیست",
        progressTop: "progressTop",
        progressBottom: "progressBottom",
        progressTopBottom: "progressTopBottom",
        horizontal: "افقی",
        vertical: "عمودی",
        top: "بالا",
        bottom: "پایین",
        topBottom: "بالا و پایین",
        left: "چپ",
        color: "رنگ",
        date: "تاریخ",
        datetime: "تاریخ و ساعت",
        "datetime-local": "تاریخ و سوال پیش فرض",
        email: "ایمیل",
        month: "ماه",
        number: "عدد",
        password: "رمزعبور",
        range: "دامنه",
        tel: "تلفن",
        text: "متن",
        time: "زمان",
        url: "url",
        week: "هفته",
        hidden: "مخفی",
        on: "روشن",
        onPage: "روی صفحه",
        edit: "ویرایش",
        display: "نمایش",
        onComplete: "به محض تمام شدن",
        onHidden: "به محض مخفی شدن",
        all: "تمام",
        page: "صفحه",
        survey: "نظرسنجی",
        onNextPage: "به محض صفحه بعدی",
        onValueChanged: "به محض تغییر مقدار"
    },
    //Operators
    op: {
        empty: "خالی باشد",
        notempty: "خالی نباشد",
        equal: "مساوی باشد",
        notequal: "مساوی نباشد",
        contains: "شامل",
        notcontains: "شامل نباشد",
        greater: "بزرگتر",
        less: "کوچکتر",
        greaterorequal: "بزرگتر یا مساوی",
        lessorequal: "کوچکتر یا مساوی"
    },
    //Embed window
    ew: {
        angular: "استفاده از نسخه Angular",
        jquery: "استفاده از نسخه jQuery",
        knockout: "استفاده از نسخه ناک اوت",
        react: "استفاده از نسخه React",
        vue: "استفاده از نسخه Vue",
        bootstrap: "برای فریم ورک بوتسترپ",
        standard: "بدون بوتسترپ",
        showOnPage: "نمایش نظرسنجی در یک صفحه",
        showInWindow: "نمایش نظرسنجی در یک پنجره",
        loadFromServer: "بارگزاری JSON از سرور",
        titleScript: "اسکریپت و شیوه نمایش",
        titleHtml: "HTML",
        titleJavaScript: "جاوااسکریپت"
    },
    //Test Survey
    ts: {
        selectPage: "صفحه ای را برای آزمایش انتخاب کنید:",
        showInvisibleElements: "نمایش المان های مخفی"
    },
    validators: {
        answercountvalidator: "تعداد پاسخ",
        emailvalidator: "ایمیل",
        numericvalidator: "عدد",
        regexvalidator: "regex",
        textvalidator: "متن"
    },
    triggers: {
        completetrigger: "تکمیل نظرسنجی",
        setvaluetrigger: "تنظیم مقدار",
        visibletrigger: "تغییر وضعیت دیده شدن"
    },
    //Properties
    p: {
        name: "نام",
        title: { name: "عنوان", title: "اگر خالی باشد مانند نام درج می شود" },
        survey_title: { name: "عنوان", title: "در تمام صفحات دیده می شود" },
        page_title: { name: "عنوان", title: "عنوان صفحه" },
        navigationButtonsVisibility: "پدیداری دکمه های ناوبری",
        questionsOrder: "ترتیب سوالات",
        maxTimeToFinish: "حداکثر زمان برای تکمیل",
        visible: "آشکار",
        visibleIf: "آشکار اگر",
        questionTitleLocation: "questionTitleLocation",
        description: "توضیحات",
        state: "وضعیت",
        isRequired: "اجباری؟",
        requiredIf: "اجبار اگر؟",
        indent: "indent",
        requiredErrorText: "requiredErrorText",
        startWithNewLine: "startWithNewLine",
        innerIndent: "innerIndent",
        page: "صفحه",
        width: "عرض",
        commentText: "متن نظر",
        valueName: "نام مقدار",
        enableIf: "فعال اگر",
        defaultValue: "مقدار پیش فرض",
        correctAnswer: "پاسخ صحیح",
        readOnly: "فقط خوانش",
        validators: "اعتبارسنج ها",
        titleLocation: "titleLocation",
        hasComment: "نظر دارد؟",
        hasOther: "سایر دارد؟",
        choices: "گزینه ها",
        choicesOrder: "ترتیب گزینه ها",
        choicesByUrl: "گزینه ها با لینک",
        otherText: "متن سایر",
        otherErrorText: "متن خطای سایر",
        storeOthersAsComment: "ذخیره سایر به صورت نظر",
        label: "برچسب",
        showTitle: "نامیش عنوان",
        valueTrue: "valueTrue",
        valueFalse: "valueFalse",
        cols: "ستون ها",
        rows: "سطر ها",
        placeHolder: "placeHolder",
        optionsCaption: "optionsCaption",
        expression: "expression",
        format: "فرمت",
        displayStyle: "سبک نمایش",
        currency: "ارز",
        useGrouping: "useGrouping",
        showPreview: "پیش نمایش",
        allowMultiple: "اجازه چند انتخابی",
        imageHeight: "طول عکس",
        imageWidth: "عرض عکس",
        storeDataAsText: "ذخیره داده به صورت متنی",
        maxSize: "نهایت حجم",
        html: "html",
        columns: "ستون ها",
        cells: "سلول ها",
        isAllRowRequired: "آیا تمام سطرها اجباری اند؟",
        horizontalScroll: "اسکرول افقی",
        cellType: "نوع سلول",
        columnsLayout: "columnsLayout",
        columnColCount: "columnColCount",
        columnMinWidth: "columnMinWidth",
        rowCount: "تعداد سطر",
        minRowCount: "حداقل تعداد سطر",
        maxRowCount: "حداکثر تعداد سطر",
        keyName: "keyName",
        keyDuplicationError: "keyDuplicationError",
        confirmDelete: "تاییدیه حذف",
        confirmDeleteText: "متن تاییدیه حذف",
        addRowLocation: "addRowLocation",
        addRowText: "افزودن متن سطر",
        removeRowText: "حذف متن سطر",
        items: "items",
        itemSize: "itemSize",
        colCount: "colCount",
        templateTitle: "templateTitle",
        templateDescription: "templateDescription",
        allowAddPanel: "allowAddPanel",
        allowRemovePanel: "allowRemovePanel",
        panelCount: "panelCount",
        minPanelCount: "minPanelCount",
        maxPanelCount: "maxPanelCount",
        panelsState: "panelsState",
        panelAddText: "panelAddText",
        panelRemoveText: "panelRemoveText",
        panelPrevText: "panelPrevText",
        panelNextText: "panelNextText",
        showQuestionNumbers: "showQuestionNumbers",
        showRangeInProgress: "showRangeInProgress",
        renderMode: "renderMode",
        templateTitleLocation: "templateTitleLocation",
        rateValues: "rateValues",
        rateMin: "rateMin",
        rateMax: "rateMax",
        rateStep: "rateStep",
        minRateDescription: "minRateDescription",
        maxRateDescription: "maxRateDescription",
        inputType: "inputType",
        size: "حجم",
        locale: "زبان",
        focusFirstQuestionAutomatic: "focusFirstQuestionAutomatic",
        completedHtml: "completedHtml",
        completedBeforeHtml: "completedBeforeHtml",
        loadingHtml: "loadingHtml",
        triggers: "triggers",
        cookieName: "cookieName",
        sendResultOnPageNext: "sendResultOnPageNext",
        showNavigationButtons: "showNavigationButtons",
        showPrevButton: "showPrevButton",
        showPageTitles: "showPageTitles",
        showCompletedPage: "showCompletedPage",
        showPageNumbers: "showPageNumbers",
        questionErrorLocation: "questionErrorLocation",
        showProgressBar: "showProgressBar",
        mode: "mode",
        goNextPageAutomatic: "goNextPageAutomatic",
        checkErrorsMode: "checkErrorsMode",
        clearInvisibleValues: "clearInvisibleValues",
        startSurveyText: "startSurveyText",
        pagePrevText: "pagePrevText",
        pageNextText: "pageNextText",
        completeText: "completeText",
        requiredText: "requiredText",
        questionStartIndex: "questionStartIndex",
        questionTitleTemplate: "questionTitleTemplate",
        firstPageIsStarted: "firstPageIsStarted",
        isSinglePage: "isSinglePage",
        maxTimeToFinishPage: "maxTimeToFinishPage",
        showTimerPanel: "showTimerPanel",
        showTimerPanelMode: "showTimerPanelMode",
        defaultPanelValue: "defaultPanelValue",
        defaultRowValue: "defaultRowValue",
        hasNone: "hasNone",
        noneText: "noneText",
        text: "متن",
        minValue: "حداقل مقدار",
        maxValue: "حداکثر مقدار",
        minLength: "حداقل طول",
        maxLength: "حداکثر طول",
        allowDigits: "اجازه عدد",
        minCount: "حداقل تعداد",
        maxCount: "حداکثر تعداد",
        regex: "regular expression"
    }
};
__WEBPACK_IMPORTED_MODULE_0__editorLocalization__["a" /* editorLocalization */].locales["fa"] = persianStrings;


/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__editorLocalization__ = __webpack_require__(0);

var polishStrings = {
    //survey templates
    survey: {
        edit: "Edytuj",
        dropQuestion: "Przeciągnij pytanie.",
        copy: "Kopiuj",
        addToToolbox: "Dodaj do palety",
        deletePanel: "Usuń panel",
        deleteQuestion: "Usuń pytanie",
        convertTo: "Konwertuj na"
    },
    //questionTypes
    qt: {
        checkbox: "Wielokrotny wybór",
        comment: "Komentarz",
        dropdown: "Lista wyboru",
        file: "Plik",
        html: "Html",
        matrix: "Macierz (jednokrotny wybór)",
        matrixdropdown: "Matrix (wielokrotny wybór)",
        matrixdynamic: "Matrix (dynamiczne wiersze)",
        multipletext: "Wiele linii tekstu",
        panel: "Panel",
        paneldynamic: "Panel (dynamiczne panele)",
        radiogroup: "Jednokrotny wybór",
        rating: "Ocena",
        text: "Pojedyncza odpowiedź",
        boolean: "Prawda/Fałsz",
        expression: "Wyrażenie"
    },
    //Strings in Editor
    ed: {
        survey: "Ankieta",
        Survey: "Ankieta",
        editSurvey: "Edytuj ankietę",
        addNewPage: "Dodaj nową sekcję",
        deletePage: "Usuń sekcję",
        editPage: "Edytuj sekcję",
        newPageName: "sekcja",
        newQuestionName: "pytanie",
        newPanelName: "panel",
        testSurvey: "Testuj ankietę",
        testSurveyAgain: "Testuj ponownie",
        testSurveyWidth: "Szerokość ankiety: ",
        embedSurvey: "Embed Survey",
        saveSurvey: "Zapisz ankietę",
        designer: "Projektant ankiety",
        jsonEditor: "JSON Editor",
        undo: "Cofnij",
        redo: "Ponów",
        options: "Opcje",
        generateValidJSON: "Generate Valid JSON",
        generateReadableJSON: "Generate Readable JSON",
        toolbox: "Paleta",
        delSelObject: "Usuń wybrany element",
        correctJSON: "Please correct JSON.",
        surveyResults: "Wynik ankiety: ",
        modified: "Zmodyfikowana",
        saving: "Trwa zapis",
        saved: "Zapisano"
    },
    //Property names in table headers
    pel: {
        isRequired: "Wymagane?"
    },
    //Property Editors
    pe: {
        apply: "Zastosuj",
        ok: "OK",
        cancel: "Anuluj",
        reset: "Resetuj",
        close: "Zamknij",
        delete: "Usuń",
        addNew: "Dodaj nową",
        removeAll: "Usuń wszystkie",
        edit: "Edytuj",
        empty: "<pusty>",
        fastEntry: "Szybkie wprowadzanie",
        formEntry: "Formularz",
        testService: "Testuj usługę",
        conditionHelp: "Podaj wyrażenie, które zwróci wartość prawda/fałsz. Jeśli chcesz, aby sekcja lub pytanie pozostały widoczne - powinno zwrócić prawdę. Przykład: {pytanie1} = 'wartość1' or ({pytanie2} * {pytanie4}  > 20 and {pytanie3} < 5)",
        expressionHelp: "Please enter an expression. You may use curly brackets to get access to the question values: '{question1} + {question2}', '({price}*{quantity}) * (100 - {discount})'",
        aceEditorHelp: "Press ctrl+space to get expression completion hint",
        aceEditorRowTitle: "Current row",
        aceEditorPanelTitle: "Current panel",
        showMore: "For more details please check the documentation",
        assistantTitle: "Available questions:",
        propertyIsEmpty: "Podaj wartość",
        value: "Wartość",
        text: "Etykieta",
        columnEdit: "Edit column: {0}",
        itemEdit: "Edit item: {0}",
        url: "URL",
        path: "Path",
        valueName: "Value name",
        titleName: "Title name",
        hasOther: "Czy możliwa własna odpowiedź",
        otherText: "Other item text",
        name: "Nazwa",
        title: "Etykieta",
        cellType: "Typ komórki",
        colCount: "Liczba kolumn",
        choicesOrder: "Kolejność odpowiedzi",
        visible: "Czy widoczne?",
        isRequired: "Czy wymagalne?",
        startWithNewLine: "Czy rozpoczyna się nową linią?",
        rows: "Liczba wierszy",
        placeHolder: "Input place holder",
        showPreview: "Is image preview shown?",
        storeDataAsText: "Store file content in JSON result as text",
        maxSize: "Maximum file size in bytes",
        imageHeight: "Image height",
        imageWidth: "Image width",
        rowCount: "Row count",
        addRowText: "Add row button text",
        removeRowText: "Remove row button text",
        minRateDescription: "Opis najniższej oceny",
        maxRateDescription: "Opis najwyższej oceny",
        inputType: "Input type",
        optionsCaption: "Options caption",
        defaultValue: "Default value",
        surveyEditorTitle: "Edytuj ankietę",
        qEditorTitle: "Edytuj: {0}",
        //survey
        showTitle: "Pokaż/ukryj tytuł",
        locale: "Domyślny język",
        mode: "Tryb (edycja/podgląd)",
        clearInvisibleValues: "Usuń niewidoczne odpowiedzi",
        cookieName: "Cookie name (to disable run survey two times locally)",
        sendResultOnPageNext: "Send survey results on page next",
        storeOthersAsComment: "Store 'others' value in separate field",
        showPageTitles: "Show page titles",
        showPageNumbers: "Show page numbers",
        pagePrevText: "Page previous button text",
        pageNextText: "Page next button text",
        completeText: "Complete button text",
        startSurveyText: "Start button text",
        showNavigationButtons: "Show navigation buttons (default navigation)",
        showPrevButton: "Show previous button (user may return on previous page)",
        firstPageIsStarted: "The first page in the survey is a started page.",
        showCompletedPage: "Show the completed page at the end (completedHtml)",
        goNextPageAutomatic: "On answering all questions, go to the next page automatically",
        showProgressBar: "Show progress bar",
        questionTitleLocation: "Question title location",
        requiredText: "The question required symbol(s)",
        questionStartIndex: "Question start index (1, 2 or 'A', 'a')",
        showQuestionNumbers: "Show question numbers",
        questionTitleTemplate: "Question title template, default is: '{no}. {require} {title}'",
        questionErrorLocation: "Question error location",
        focusFirstQuestionAutomatic: "Focus first question on changing the page",
        questionsOrder: "Elements order on the page",
        maxTimeToFinish: "Maximum time to finish the survey",
        maxTimeToFinishPage: "Maximum time to finish a page in the survey",
        showTimerPanel: "Show timer panel",
        showTimerPanelMode: "Show timer panel mode",
        renderMode: "Render mode",
        allowAddPanel: "Allow adding a panel",
        allowRemovePanel: "Allow removing the panel",
        panelAddText: "Adding panel text",
        panelRemoveText: "Removing panel text",
        isSinglePage: "Show all elements on one page",
        tabs: {
            general: "Ogólne",
            fileOptions: "Options",
            html: "Html Editor",
            columns: "Kolumny",
            rows: "Wiersze",
            choices: "Odpowiedzi",
            visibleIf: "Widoczne jeśli",
            enableIf: "Enable If",
            rateValues: "Wartość oceny",
            choicesByUrl: "Odpowiedzi z webserwisu",
            matrixChoices: "Default Choices",
            multipleTextItems: "Text Inputs",
            validators: "Validators",
            navigation: "Navigation",
            question: "Question",
            completedHtml: "Completed Html",
            loadingHtml: "Loading Html",
            timer: "Timer/Quiz",
            triggers: "Triggers",
            templateTitle: "Template title"
        },
        editProperty: "Edit property '{0}'",
        items: "[ Items: {0} ]",
        enterNewValue: "Please, enter the value.",
        noquestions: "There is no any question in the survey.",
        createtrigger: "Please create a trigger",
        triggerOn: "On ",
        triggerMakePagesVisible: "Make pages visible:",
        triggerMakeQuestionsVisible: "Make elements visible:",
        triggerCompleteText: "Complete the survey if succeed.",
        triggerNotSet: "The trigger is not set",
        triggerRunIf: "Run if",
        triggerSetToName: "Change value of: ",
        triggerSetValue: "to: ",
        triggerIsVariable: "Do not put the variable into the survey result."
    },
    //Property values
    pv: {
        true: "prawda",
        false: "fałsz"
    },
    //Operators
    op: {
        empty: "is empty",
        notempty: "is not empty",
        equal: "equals",
        notequal: "not equals",
        contains: "contains",
        notcontains: "not contains",
        greater: "greater",
        less: "less",
        greaterorequal: "greater or equals",
        lessorequal: "Less or Equals"
    },
    //Embed window
    ew: {
        angular: "Use Angular version",
        jquery: "Use jQuery version",
        knockout: "Use Knockout version",
        react: "Use React version",
        vue: "Use Vue version",
        bootstrap: "For bootstrap framework",
        standard: "No bootstrap",
        showOnPage: "Show survey on a page",
        showInWindow: "Show survey in a window",
        loadFromServer: "Load Survey JSON from server",
        titleScript: "Scripts and styles",
        titleHtml: "HTML",
        titleJavaScript: "JavaScript"
    },
    //Test Survey
    ts: {
        selectPage: "Wybierz stronę, aby ją przetestować:"
    },
    validators: {
        answercountvalidator: "answer count",
        emailvalidator: "e-mail",
        numericvalidator: "numeric",
        regexvalidator: "regex",
        textvalidator: "text"
    },
    triggers: {
        completetrigger: "complete survey",
        setvaluetrigger: "set value",
        visibletrigger: "change visibility"
    },
    //Properties
    p: {
        name: "nazwa",
        title: {
            name: "tytuł",
            title: "Pozostaw pusty, jeśli ma być taki sam, jak 'Nazwa'"
        },
        page_title: { name: "tytuł", title: "Tytuł sekcji" }
    }
};
__WEBPACK_IMPORTED_MODULE_0__editorLocalization__["a" /* editorLocalization */].locales["pl"] = polishStrings;


/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__editorLocalization__ = __webpack_require__(0);

var portugueseTranslation = {
    //survey templates
    survey: {
        edit: "Editar",
        dropQuestion: "Por favor arraste uma pergunta aqui.",
        copy: "Copiar",
        addToToolbox: "Adicionar à toolbox",
        deletePanel: "Remover Painel",
        deleteQuestion: "Remover Pergunta",
        convertTo: "Converter para",
        drag: "Arrastar elemento"
    },
    //questionTypes
    qt: {
        default: "Default",
        checkbox: "Checkbox",
        comment: "Comentário",
        imagepicker: "Selecionador de imagem",
        dropdown: "Dropdown",
        file: "Arquivo",
        html: "Html",
        matrix: "Matriz (opção única)",
        matrixdropdown: "Matriz (multiplas opções)",
        matrixdynamic: "Matriz (linhas dinâmicas)",
        multipletext: "Texto múltiplo",
        panel: "Painel",
        paneldynamic: "Painel (painéis dinâmicos)",
        radiogroup: "Radiogroup",
        rating: "Rating",
        text: "Texto único",
        boolean: "Boleano",
        expression: "Expressão"
    },
    //Strings in Editor
    ed: {
        defaultLocale: "Default ({0})",
        survey: "Pesquisa",
        settings: "Configurações da Pesquisa",
        editSurvey: "Editar Pesquisa",
        addNewPage: "Adicionar Nova Página",
        moveRight: "Role para direita",
        moveLeft: "Role para esquerda",
        deletePage: "Deletar Página",
        editPage: "Editar Página",
        edit: "Editar",
        newPageName: "página",
        newQuestionName: "pergunta",
        newPanelName: "painel",
        testSurvey: "Testar pesquisa",
        testSurveyAgain: "Testar pesquisa novamente",
        testSurveyWidth: "Tamanho do pesquisa: ",
        embedSurvey: "Incorporar Pesquisa",
        translation: "Tradução",
        saveSurvey: "Salvar Pesquisa",
        designer: "Designer de Pesquisa",
        jsonEditor: "Editor de JSON",
        undo: "Desfazer",
        redo: "Refazer",
        options: "Opções",
        generateValidJSON: "Gerar JSON válido",
        generateReadableJSON: "Gerar JSON legível",
        toolbox: "Toolbox",
        toolboxGeneralCategory: "Geral",
        delSelObject: "Apagar objeto selecionado",
        editSelObject: "Editar objeto selecionado",
        correctJSON: "Por favor corrija o JSON.",
        surveyResults: "Resultado da pesquisa: ",
        surveyResultsTable: "Como Tabela",
        surveyResultsJson: "Como JSON",
        resultsTitle: "Título da Pergunta",
        resultsName: "Nome da Pergunta",
        resultsValue: "Valor da Resposta",
        resultsDisplayValue: "Mostrar Valor",
        modified: "Modificado",
        saving: "Salvando",
        saved: "Salvo",
        saveError: "Erro! Conteúdo do editor não foi salvo.",
        translationAddLanguage: "Selecione o idioma para traduzir",
        translationShowAllStrings: "Mostrar todas strings",
        translationShowAllPages: "Mostrar todas páginas",
        translationNoStrings: "Nenhuma string para traduzir. Por favor, altere o filtro.",
        translationExportToSCVButton: "Exportar para CSV",
        translationImportFromSCVButton: "Importar de CSV",
        translationMergeLocaleWithDefault: "Combinar {0} com o idioma default"
    },
    //Property names in table headers
    pel: {
        isRequired: "Obrigatório?"
    },
    //Property Editors
    pe: {
        apply: "Aplicar",
        ok: "OK",
        cancel: "Cancelar",
        reset: "Limpar",
        close: "Fechar",
        delete: "Apagar",
        addNew: "Adicionar Novo",
        addItem: "Clique para adicionar um item...",
        removeAll: "Remover Todos",
        edit: "Editar",
        itemValueEdit: "Visível Se",
        editChoices: "Editar Opções",
        move: "Mover",
        empty: "<vazio>",
        notEmpty: "<editar valor>",
        fastEntry: "Entrada Rápida",
        formEntry: "Entrada com formulário",
        testService: "Testar o serviço",
        conditionSelectQuestion: "Selecionar pergunta...",
        conditionValueQuestionTitle: "Por favor, entre/selecione o valor",
        conditionButtonAdd: "Add",
        conditionButtonReplace: "Substituir",
        conditionHelp: "Por favor, entre com uma expressão boleana. Deve retornar verdadeiro para manter a pergunta/página visível. Por exemplo: {´pergunta1} = 'valor1' ou ({pergunta2} * {pergunta4} > 20 e {pergunta3} < 5)",
        expressionHelp: "Por favor informe uma expressão boleana. Ela deve retornar verdadeiro para manter a pergunta/página visível. Por exemplo: {´pergunta1} = 'valor1' or ({pergunta2} = 3 and {pergunta3} < 5)",
        aceEditorHelp: "Pressione ctrl+space para autocompletar",
        aceEditorRowTitle: "Linha atual",
        aceEditorPanelTitle: "Painel atual",
        showMore: "Para mais detalhes, por favor visite a documentação",
        conditionShowMoreUrl: "https://surveyjs.io/Documentation/LibraryParameter?id=Question&parameter=visibleIf",
        assistantTitle: "Perguntas disponíveis:",
        cellsEmptyRowsColumns: "Deve haver ao menos uma coluna ou linha",
        propertyIsEmpty: "Por favor informe um valor na propriedade",
        value: "Valor",
        text: "Texto",
        rowid: "ID da Linha",
        imageLink: "Link da Imagem",
        columnEdit: "Editar coluna: {0}",
        itemEdit: "Editar item: {0}",
        url: "URL",
        path: "Caminho",
        valueName: "Nome do valor",
        titleName: "Nome do título",
        hasOther: "Tem item 'outros'",
        otherText: "Texto do item 'outros'",
        name: "Nome",
        title: "Título",
        cellType: "Tipo de célula",
        colCount: "Contagem de células",
        choicesOrder: "Selecione a ordem das alternativas",
        visible: "É visível?",
        isRequired: "É obrigatório?",
        startWithNewLine: "Começa com uma nova linha?",
        rows: "Contagem de linhas",
        placeHolder: "Texto de referência",
        showPreview: "Mostra pré-visualização de imagem?",
        storeDataAsText: "Gravar conteúdo de arquivo no resultado JSON como texto",
        maxSize: "Tamanho máximo de arquivo em bytes",
        imageHeight: "Altura da imagem",
        imageWidth: "Largura da imagem",
        rowCount: "Contagem de linhas",
        columnLayout: "Layout das colunas",
        addRowLocation: "Localização do botão de adicionar linha",
        addRowText: "Texto do botão para adicionar linhas",
        removeRowText: "Texto do botão para remover linhas",
        minRateDescription: "Descrição de qualificação mínima",
        maxRateDescription: "Descrição de qualificação máxima",
        inputType: "Tipo de entrada",
        optionsCaption: "Título de opção",
        defaultValue: "Valor default",
        cellsDefaultRow: "Texto default das células",
        surveyEditorTitle: "Editar configurações da pesquisa",
        qEditorTitle: "Editar pergunta: {0}",
        maxLength: "Tamanho máximo",
        //survey
        showTitle: "Mostrar/ocultar título",
        locale: "Idioma default",
        mode: "Modo (editável/somente leitura)",
        clearInvisibleValues: "Limpar valores invisíveis",
        cookieName: "Nome do cookie (para desativar rode a pesquisa duas vezes localmente)",
        sendResultOnPageNext: "Enviar resultado da pesquisa na página seguinte",
        storeOthersAsComment: "Armazenar 'outros' valores em um campo separado",
        showPageTitles: "Mostrar título da página",
        showPageNumbers: "Mostrar número da página",
        pagePrevText: "Texto para botão de página anterior",
        pageNextText: "Texto para botão de página seguinte",
        completeText: "Texto para botão de completar",
        startSurveyText: "Texto para botão de começar",
        showNavigationButtons: "Mostrar botões de navegação (navegação default)",
        showPrevButton: "Mostrar botão de voltar (usuário pode retornar para página anterior)",
        firstPageIsStarted: "Primeira página da pesquisa é a página de início.",
        showCompletedPage: "Mostrar a página de conclusão no final (completedHtml)",
        goNextPageAutomatic: "Ao responder todas as perguntas, ir automaticamente para a próxima página",
        showProgressBar: "Mostrar barra de progresso",
        questionTitleLocation: "Localização do título da pergunta",
        requiredText: "Símbolo(s) para perguntas obrigatórias",
        questionStartIndex: "Index das perguntas (1, 2 or 'A', 'a')",
        showQuestionNumbers: "Mostrar número das perguntas",
        questionTitleTemplate: "Template do título da pergunta, default é: '{no}. {obrigatório} {título}'",
        questionErrorLocation: "Localização do erro da pergunta",
        focusFirstQuestionAutomatic: "Focar automaticamente na primeira pergunta ao trocar de página",
        questionsOrder: "Ordenar elementos na página",
        maxTimeToFinish: "Tempo máximo para finalizar pesquisa",
        maxTimeToFinishPage: "Tempo máximo para finalizar página da pesquisa",
        showTimerPanel: "Mostrar o painel de cronômetro",
        showTimerPanelMode: "Mostrar painel de modo de cronômetro",
        renderMode: "Modo de renderização",
        allowAddPanel: "Permitir adicionar painel",
        allowRemovePanel: "Permitir remover painel",
        panelAddText: "Texto de adicionar painel",
        panelRemoveText: "Texto de remover painel",
        isSinglePage: "Mostrar todos elementos em uma página",
        tabs: {
            general: "Geral",
            fileOptions: "Opções",
            html: "Editor Html",
            columns: "Colunas",
            rows: "Linhas",
            choices: "Opções",
            items: "Itens",
            visibleIf: "Visível se",
            enableIf: "Habilitar se",
            requiredIf: "Obrigatório se",
            rateValues: "Valores de qualificação",
            choicesByUrl: "Opções com origem na Web",
            matrixChoices: "Opções padrão",
            multipleTextItems: "Entradas de texto",
            validators: "Validadores",
            navigation: "Navegação",
            question: "Pergunta",
            completedHtml: "Completo Html",
            loadingHtml: "Carregando Html",
            timer: "Cronômetro/Quiz",
            triggers: "Triggers",
            templateTitle: "Título do template"
        },
        editProperty: "Editar propriedade '{0}'",
        items: "[ Items: {0} ]",
        enterNewValue: "Por favor, informe o valor.",
        noquestions: "Não há nenhuma pergunta na pesquisa.",
        createtrigger: "Por favor, crie um gatilho",
        triggerOn: "Ligado ",
        triggerMakePagesVisible: "Tornar páginas visíveis:",
        triggerMakeQuestionsVisible: "Tornar perguntas visíves:",
        triggerCompleteText: "Completar a pesquisa se obtiver êxito.",
        triggerNotSet: "O gatilho não está definido",
        triggerRunIf: "Executar se",
        triggerSetToName: "Mudar o valor de: ",
        triggerFromName: "Copiar valor de: ",
        triggerRunExpression: "Rodar essa expressão:",
        triggerSetValue: "para: ",
        triggerIsVariable: "Não colocar a variável no resultado da pesquisa."
    },
    //Property values
    pv: {
        true: "verdadeiro",
        false: "falso",
        inherit: "inherit",
        show: "mostrar",
        hide: "ocultar",
        default: "default",
        initial: "inicial",
        random: "aleatório",
        collapsed: "colapsado",
        expanded: "expandido",
        none: "nenhum",
        asc: "ascendente",
        desc: "descendente",
        indeterminate: "indeterminado",
        decimal: "decimal",
        currency: "moeda",
        percent: "percentagem",
        firstExpanded: "primeiro expandido",
        off: "desligado",
        onPanel: "no painel",
        onSurvey: "na pesquisa",
        list: "lista",
        progressTop: "progresso superior",
        progressBottom: "progresso inferior",
        progressTopBottom: "progresso superior inferior",
        horizontal: "horizontal",
        vertical: "vertical",
        top: "superior",
        bottom: "inferior",
        topBottom: "superior and bottom",
        left: "esquerda",
        color: "cor",
        date: "data",
        datetime: "data e hora",
        "datetime-local": "data e hora - local",
        email: "email",
        month: "mês",
        number: "número",
        password: "senha",
        range: "intervalo",
        tel: "tel",
        text: "texto",
        time: "hora",
        url: "url",
        week: "semana",
        hidden: "oculto",
        on: "ligado",
        onPage: "na página",
        edit: "editar",
        display: "mostrar",
        onComplete: "ao completar",
        onHidden: "ao ocultar",
        all: "todos",
        page: "página",
        survey: "pesquisa",
        onNextPage: "na página seguinte",
        onValueChanged: "ao mudar valor"
    },
    //Operators
    op: {
        empty: "está vazio",
        notempty: "não está vazio",
        equal: "é igual",
        notequal: "não é igual",
        contains: "contém",
        notcontains: "não contém",
        greater: "maior",
        less: "menor",
        greaterorequal: "maior ou igual",
        lessorequal: "menor ou igual"
    },
    //Embed window
    ew: {
        angular: "Usar versão Angular",
        jquery: "Usar versão jQuery",
        knockout: "Usar versão Knockout",
        react: "Usar versão React",
        vue: "Usar versão Vue",
        bootstrap: "Para framework bootstrap",
        standard: "Sem bootstrap",
        showOnPage: "Mostrar pesquisa em uma página",
        showInWindow: "Mostrar pesquisa em uma janela",
        loadFromServer: "Carregar JSON da pesquisa de um servidor",
        titleScript: "Scripts e estilos",
        titleHtml: "HTML",
        titleJavaScript: "JavaScript"
    },
    //Test Survey
    ts: {
        selectPage: "Selecione a página para testar:",
        showInvisibleElements: "Mostrar elementos invisíveis"
    },
    validators: {
        answercountvalidator: "contador de respostas",
        emailvalidator: "e-mail",
        expressionvalidator: "expressão",
        numericvalidator: "numérico",
        regexvalidator: "regex",
        textvalidator: "texto"
    },
    triggers: {
        completetrigger: "completar pesquisa",
        setvaluetrigger: "definir valor",
        copyvaluetrigger: "copiar valor",
        runexpressiontrigger: "rodar expressão",
        visibletrigger: "alterar visibilidade"
    },
    //Properties
    p: {
        name: "nome",
        title: {
            name: "título",
            title: "Deixar vazio se for o mesmo que 'Nome'"
        },
        navigationButtonsVisibility: "Visibilidade dos botões de navegação",
        questionsOrder: "Ordenar elementos na página",
        maxTimeToFinish: "Tempo máximo para finalizar pesquisa",
        visible: "Visível?",
        visibleIf: "Visível se",
        questionTitleLocation: "Localização do título da pergunta",
        description: "Descrição",
        state: "Estado",
        isRequired: "Obrigatório?",
        requiredIf: "Obrigatório se",
        indent: "Indentação",
        requiredErrorText: "Texto de erro para obrigatório",
        startWithNewLine: "Começar com uma nova linha",
        innerIndent: "Indentação interna",
        page: "Página",
        width: "Largura",
        commentText: "Texto do comentário",
        valueName: "Nome do valor",
        enableIf: "Habilitar se",
        defaultValue: "Valor default",
        correctAnswer: "Resposta correta",
        readOnly: "Somente leitura",
        validators: "Validadores",
        titleLocation: "Localização do título",
        hasComment: "Tem comentário",
        hasOther: "Tem item 'outros'",
        choices: "Opções",
        choicesOrder: "Selecione a ordem das alternativas",
        choicesByUrl: "Opções com origem na Web",
        otherText: "Texto do item 'outros'",
        otherErrorText: "Texto de erro da opção 'outros'",
        storeOthersAsComment: "Armazenar 'outros' valores em um campo separado",
        label: "Label",
        showTitle: "Mostrar título",
        valueTrue: "Valor verdadeiro",
        valueFalse: "Valor falso",
        cols: "Colunas",
        rows: "Linhas",
        placeHolder: "placeholder",
        optionsCaption: "Título das opções",
        expression: "Expressão",
        format: "Formato",
        displayStyle: "Mostrar estilo",
        currency: "Moeda",
        useGrouping: "Usar agrupamento",
        showPreview: "Mostrar preview",
        allowMultiple: "Permitir múltiplos",
        imageHeight: "Altura da imagem",
        imageWidth: "Largura da imagem",
        storeDataAsText: "Armazenar dados como texto",
        maxSize: "Tamanho máximo",
        html: "html",
        columns: "Colunas",
        cells: "Células",
        isAllRowRequired: "Todas linhas são obrigatórias",
        horizontalScroll: "Scroll horizontal",
        cellType: "Tipo de célula",
        columnsLayout: "Layout de colunas",
        columnColCount: "Contador de células de coluna",
        columnMinWidth: "Largura mínima da coluna",
        rowCount: "Contagem de linhas",
        minRowCount: "Contagem de linhas mínima",
        maxRowCount: "Contagem de linhas máxima",
        keyName: "Nome da chave",
        keyDuplicationError: "Erro de chave duplicada",
        confirmDelete: "Confirmar deleção",
        confirmDeleteText: "Texto de confirmar deleção",
        addRowLocation: "Localização do botão de adicionar linha",
        addRowText: "Texto do botão para adicionar linhas",
        removeRowText: "Texto do botão para remover linhas",
        items: "Itens",
        itemSize: "Tamanho do item",
        colCount: "Contagem de células",
        templateTitle: "Título do template",
        templateDescription: "Descrição do template",
        allowAddPanel: "Permitir adicionar painel",
        allowRemovePanel: "Permitir remover painel",
        panelCount: "Contador do painel",
        minPanelCount: "Contador do painel mínimo",
        maxPanelCount: "Contador do painel máximo",
        panelsState: "Estado dos painéis",
        panelAddText: "Texto de adicionar painel",
        panelRemoveText: "Texto de remover painel",
        panelPrevText: "Texto do painel anterior",
        panelNextText: "Texto do próximo painel",
        showQuestionNumbers: "Mostrar número das perguntas",
        showRangeInProgress: "showRangeInProgress",
        renderMode: "Modo de renderização",
        templateTitleLocation: "Localização do título do template",
        rateValues: "Valores de qualificação",
        rateMin: "Qualificação mínima",
        rateMax: "Qualificação máxima",
        rateStep: "Incremento da qualificação",
        minRateDescription: "Descrição de qualificação mínima",
        maxRateDescription: "Descrição de qualificação máxima",
        inputType: "Tipo de entrada",
        size: "Tamanho",
        locale: "Localidade",
        focusFirstQuestionAutomatic: "Focar automaticamente na primeira pergunta",
        completedHtml: "Completo Html",
        completedBeforeHtml: "Completo Html antes",
        loadingHtml: "Carregando Html",
        triggers: "Triggers",
        cookieName: "Nome do cookie",
        sendResultOnPageNext: "Enviar resultado da pesquisa na página seguinte",
        showNavigationButtons: "Mostrar botões de navegação (navegação default)",
        showPrevButton: "Mostrar botão de voltar (usuário pode retornar para página anterior)",
        showPageTitles: "Mostrar título da página",
        showCompletedPage: "Mostrar a página de conclusão no final (completedHtml)",
        showPageNumbers: "Mostrar número da página",
        questionErrorLocation: "Localização do erro da pergunta",
        showProgressBar: "Mostrar barra de progresso",
        mode: "Modo",
        goNextPageAutomatic: "Ao responder todas as perguntas, ir automaticamente para a próxima página",
        checkErrorsMode: "Modo de verificação de erros",
        clearInvisibleValues: "Limpar valores invisíveis",
        startSurveyText: "Texto para botão de começar",
        pagePrevText: "Texto para botão de página anterior",
        pageNextText: "Texto para botão de página seguinte",
        completeText: "Texto para botão de completar",
        requiredText: "Símbolo(s) para perguntas obrigatórias",
        questionStartIndex: "Index das perguntas (1, 2 or 'A', 'a')",
        questionTitleTemplate: "Template do título da pergunta, default é: '{no}. {obrigatório} {título}'",
        firstPageIsStarted: "Primeira página da pesquisa é a página de início.",
        isSinglePage: "Mostrar todos elementos em uma página",
        maxTimeToFinishPage: "Tempo máximo para finalizar página da pesquisa",
        showTimerPanel: "Mostrar o painel de cronômetro",
        showTimerPanelMode: "Mostrar painel de modo de cronômetro",
        defaultPanelValue: "valor default do painel",
        defaultRowValue: "valor default da linha",
        hasNone: "não tem nenhum",
        noneText: "nenhum texto",
        text: "texto",
        minValue: "valor mínimo",
        maxValue: "valor máximo",
        minLength: "tamanho mínimo",
        maxLength: "tamanho máximo",
        allowDigits: "permitir dígitos",
        minCount: "contador mínimo",
        maxCount: "contador máximo",
        regex: "expressão regular"
    }
};
__WEBPACK_IMPORTED_MODULE_0__editorLocalization__["a" /* editorLocalization */].locales["pt"] = portugueseTranslation;


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__editorLocalization__ = __webpack_require__(0);

var simplifiedChineseTranslation = {
    // strings for survey templates
    survey: {
        edit: "编辑",
        dropQuestion: "请将问题放置于此",
        copy: "复制",
        addToToolbox: "添加到工具箱",
        deletePanel: "删除面板",
        deleteQuestion: "删除题目",
        convertTo: "转变为"
    },
    // strings for question types
    qt: {
        checkbox: "多项选择",
        comment: "多行文本框",
        dropdown: "下拉框",
        file: "文件上传",
        html: "Html 代码",
        matrix: "矩阵 (单选题)",
        matrixdropdown: "矩阵 (下拉框)",
        matrixdynamic: "矩阵 (动态问题)",
        multipletext: "文本框组",
        panel: "面板",
        paneldynamic: "面板(动态)",
        radiogroup: "单项选择",
        rating: "评分",
        text: "文本框",
        boolean: "布尔选择",
        expression: "表达式"
    },
    // strings for editor
    ed: {
        survey: "调查问卷",
        editSurvey: "修改",
        addNewPage: "添加新页面",
        deletePage: "删除页面",
        editPage: "编辑页面",
        newPageName: "页面",
        newQuestionName: "问题",
        newPanelName: "面板",
        testSurvey: "测试问卷",
        testSurveyAgain: "再次测试问卷",
        testSurveyWidth: "问卷宽度: ",
        embedSurvey: "将问卷嵌入网页",
        saveSurvey: "保存问卷",
        designer: "问卷设计器",
        jsonEditor: "JSON 编辑器",
        undo: "撤销",
        redo: "恢复",
        options: "选项",
        generateValidJSON: "生成 JSON 数据",
        generateReadableJSON: "生成易读的 JSON 数据",
        toolbox: "工具箱",
        delSelObject: "删除所选对象",
        editSelObject: "编辑所选对象",
        correctJSON: "请修正 JSON 数据",
        surveyResults: "问卷结果: ",
        modified: "已修改",
        saving: "保存中...",
        saved: "已保存"
    },
    //Property names in table headers
    pel: {
        isRequired: "是否为必填项?"
    },
    // strings for property editors
    pe: {
        apply: "应用",
        ok: "确定",
        cancel: "取消",
        reset: "重置",
        close: "关闭",
        delete: "删除",
        addNew: "新建",
        removeAll: "全部删除",
        edit: "编辑器",
        empty: "<空>",
        fastEntry: "快速输入",
        formEntry: "表单输入",
        testService: "测试服务",
        showMore: "更多细节请查看文档",
        conditionHelp: "请输入一个布尔表达式。当布尔值为真，问题/页面可见。例如：{question1} = 'value1' or ({question2} * {question4}  > 20 and {question3} < 5)",
        expressionHelp: "请输入一项条件判断。当条件判断为真时问题/页面将可见。例如: {question1} = 'value1' or ({question2} = 3 and {question3} < 5)",
        propertyIsEmpty: "请为该属性设定一个值",
        value: "值",
        text: "显示文本",
        columnEdit: "编辑列: {0}",
        itemEdit: "编辑选项: {0}",
        hasOther: "可添加其他答案?",
        otherText: "其他答案文本",
        url: "URL",
        path: "Path",
        valueName: "Value name",
        titleName: "Title name",
        name: "题目名",
        title: "题目文本",
        cellType: "单元格类型",
        colCount: "列数",
        choicesOrder: "设置选项顺序",
        visible: "是否可见?",
        isRequired: "是否为必填项?",
        startWithNewLine: "问题是否新起一行?",
        rows: "文本框行数",
        placeHolder: "占位文本",
        showPreview: "是否显示图像预览?",
        storeDataAsText: "以 JSON 文本方式存储文件",
        maxSize: "文件最大尺寸 (Bytes)",
        imageHeight: "图片高度",
        imageWidth: "图片宽度",
        rowCount: "默认行数",
        addRowText: "添加条目按钮文本",
        removeRowText: "删除条目按钮文本",
        minRateDescription: "最小值提示",
        maxRateDescription: "最大值提示",
        inputType: "文本框类型",
        optionsCaption: "下拉框提示语",
        qEditorTitle: "编辑问题: {0}",
        //survey
        showTitle: "显示/隐藏 标题",
        locale: "默认语言",
        mode: "模式 (编辑/只读)",
        clearInvisibleValues: "清除隐藏值",
        cookieName: "Cookie name (to disable run survey two times locally)",
        sendResultOnPageNext: "Send survey results on page next",
        storeOthersAsComment: "Store 'others' value in separate field",
        showPageTitles: "显示页面标题",
        showPageNumbers: "显示页数",
        pagePrevText: "前一页按钮文本",
        pageNextText: "后一页按钮文本",
        completeText: "完成按钮文本",
        startSurveyText: "开始按钮文本",
        showNavigationButtons: "显示导航按钮 (默认导航)",
        showPrevButton: "显示前一页按钮 (用户可返回至前一页面)",
        firstPageIsStarted: "调查的第一页面为起始页.",
        showCompletedPage: "结尾展示完成后的页面 (completedHtml)",
        goNextPageAutomatic: "回答本页所有问题后，自动跳转到下一页",
        showProgressBar: "显示进度条",
        questionTitleLocation: "问题的标题位置",
        requiredText: "The question required symbol(s)",
        questionStartIndex: "问题起始标志 (1, 2 or 'A', 'a')",
        showQuestionNumbers: "显示问题编号",
        questionTitleTemplate: "问题标题模板, 默认为: '{no}. {require} {title}'",
        questionErrorLocation: "问题错误定位",
        focusFirstQuestionAutomatic: "改变页面时聚焦在第一个问题",
        questionsOrder: "Elements order on the page",
        maxTimeToFinish: "完成调查的最长时间",
        maxTimeToFinishPage: "完成调查中页面的最长时间",
        showTimerPanel: "显示计时器面板",
        showTimerPanelMode: "显示计时器面板模式",
        renderMode: "渲染模式",
        allowAddPanel: "允许添加面板",
        allowRemovePanel: "允许删除面板",
        panelAddText: "添加面板文本",
        panelRemoveText: "删除面板文本",
        isSinglePage: "在一个页面上展示所有元素",
        tabs: {
            general: "通用项",
            navigation: "导航",
            question: "问题",
            completedHtml: "完成后的Html",
            loadingHtml: "加载中的Html",
            timer: "问卷计时器",
            trigger: "触发器",
            fileOptions: "选项",
            html: "HTML 编辑器",
            columns: "设置列",
            rows: "设置行",
            choices: "设置选项",
            visibleIf: "设置可见条件",
            enableIf: "Enable If",
            rateValues: "设置评分值",
            choicesByUrl: "通过 URL 导入选项",
            matrixChoices: "默认选项",
            multipleTextItems: "文本输入",
            validators: "校验规则"
        },
        editProperty: "编辑属性: '{0}'",
        items: "[ 项目数量: {0} ]",
        enterNewValue: "请设定值",
        noquestions: "问卷中还没有创建任何问题",
        createtrigger: "请创建触发器",
        triggerOn: "当 ",
        triggerMakePagesVisible: "使页面可见:",
        triggerMakeQuestionsVisible: "使问题可见:",
        triggerCompleteText: "如果满足条件，则完成问卷",
        triggerNotSet: "触发器尚未设置",
        triggerRunIf: "满足下列条件时执行",
        triggerSetToName: "修改下列问题值: ",
        triggerSetValue: "修改为: ",
        triggerIsVariable: "在问卷提交结果中不要包含该变量"
    },
    // strings for operators
    op: {
        empty: "为空",
        notempty: "不为空",
        equal: "等于",
        notequal: "不等于",
        contains: "包含",
        notcontains: "不包含",
        greater: "大于",
        less: "小于",
        greaterorequal: "大于等于",
        lessorequal: "小于等于"
    },
    // strings for embed window
    ew: {
        angular: "使用 Angular 时",
        jquery: "使用 JQuery 时",
        knockout: "使用 Knockout 时",
        react: "使用 React 时",
        vue: "使用 Vue 时",
        bootstrap: "使用 Bootstrap 时",
        standard: "不使用 Bootstrap 时",
        showOnPage: "嵌入页面显示",
        showInWindow: "使用单独的问卷窗口",
        loadFromServer: "从服务器加载问卷 JSON 数据",
        titleScript: "脚本和样式",
        titleHtml: "HTML",
        titleJavaScript: "JavaScript"
    },
    validators: {
        answercountvalidator: "数量检查",
        emailvalidator: "Email",
        numericvalidator: "数字",
        regexvalidator: "正则表达式",
        textvalidator: "文本"
    },
    triggers: {
        completetrigger: "完成问卷",
        setvaluetrigger: "设置问题值",
        visibletrigger: "修改可见性"
    },
    // strings of properties
    p: {
        commentText: "备注文本",
        choices: "选项",
        choicesByUrl: "Url选项",
        choicesOrder: "选项排序",
        colCount: "列数",
        correctAnswer: "正确答案",
        defaultVaule: "默认选项",
        description: "说明",
        enableIf: "允许判断",
        hasComment: "hasComment",
        hasOther: "允许其他答案",
        otherText: "其他答案文本",
        page: "所在页面",
        readOnly: "只读",
        indent: "缩进",
        isRequired: "必选",
        requiredErrorText: "requiredErrorText",
        otherErrorText: "requiredErrorText",
        startWithNewLine: "允许问题在新行",
        //survey
        showTitle: "显示/隐藏 标题",
        locale: "默认语言",
        mode: "模式 (编辑/只读)",
        clearInvisibleValues: "清除隐藏值",
        cookieName: "Cookie name (to disable run survey two times locally)",
        sendResultOnPageNext: "Send survey results on page next",
        storeOthersAsComment: "Store 'others' value in separate field",
        showPageTitles: "显示页面标题",
        showPageNumbers: "显示页数",
        pagePrevText: "前一页按钮文本",
        pageNextText: "后一页按钮文本",
        completeText: "完成按钮文本",
        startSurveyText: "开始按钮文本",
        showNavigationButtons: "显示导航按钮 (默认导航)",
        showPrevButton: "显示前一页按钮 (用户可返回至前一页面)",
        firstPageIsStarted: "调查的第一页面为起始页.",
        showCompletedPage: "结尾展示完成后的页面 (completedHtml)",
        goNextPageAutomatic: "回答本页所有问题后，自动跳转到下一页",
        showProgressBar: "显示进度条",
        questionTitleLocation: "问题的标题位置",
        requiredText: "The question required symbol(s)",
        questionStartIndex: "问题起始标志 (1, 2 or 'A', 'a')",
        showQuestionNumbers: "显示问题编号",
        questionTitleTemplate: "问题标题模板, 默认为: '{no}. {require} {title}'",
        questionErrorLocation: "问题错误定位",
        focusFirstQuestionAutomatic: "改变页面时聚焦在第一个问题",
        questionsOrder: "页面中元素的顺序",
        maxTimeToFinish: "完成调查的最长时间",
        maxTimeToFinishPage: "完成调查中页面的最长时间",
        showTimerPanel: "显示计时器面板",
        showTimerPanelMode: "显示计时器面板模式",
        renderMode: "渲染模式",
        allowAddPanel: "允许添加面板",
        allowRemovePanel: "允许删除面板",
        panelAddText: "添加面板文本",
        panelRemoveText: "删除面板文本",
        isSinglePage: "在一个页面上展示所有元素",
        name: "名字",
        title: {
            name: "标题",
            title: "如果与名字相同，请设置为空值"
        },
        survey_title: {
            name: "标题",
            title: "问卷标题在每页上都会显示"
        },
        page_title: {
            name: "标题",
            title: "页面标题"
        }
    }
};
__WEBPACK_IMPORTED_MODULE_0__editorLocalization__["a" /* editorLocalization */].locales["zh-cn"] = simplifiedChineseTranslation;


/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__editorLocalization__ = __webpack_require__(0);

var spanishTranslation = {
    // strings for survey templates
    survey: {
        edit: "Editar",
        dropQuestion: "Por favor coloque una pregunta aquí de la caja de herramientas en la izquierda.",
        copy: "Copiar",
        addToToolbox: "Añadir a la caja de herramientas",
        deletePanel: "Eliminar Panel",
        deleteQuestion: "Borrar Pregunta",
        convertTo: "Convertir a",
        drag: "Arrastrar Elemento"
    },
    //questionTypes
    qt: {
        default: "Predefinido",
        checkbox: "Checkbox",
        comment: "Comentario",
        dropdown: "Dropdown",
        file: "Archivo",
        html: "Html",
        matrix: "Matriz (elección única)",
        matrixdropdown: "Matriz (elección múltiple)",
        matrixdynamic: "Matriz (filas dinámicas)",
        multipletext: "Texto múltiple",
        panel: "Panel",
        paneldynamic: "Panel (paneles dinámicos)",
        radiogroup: "Grupo de radio",
        rating: "Rating",
        text: "Entrada sencilla",
        boolean: "Booleano",
        expression: "Expresión"
    },
    //Strings in Editor
    ed: {
        survey: "Encuesta",
        settings: "Ajustar Encuesta",
        editSurvey: "Editar Encuesta",
        addNewPage: "Añadir Nueva Página",
        moveRight: "Moverse hacia la derecha",
        moveLeft: "Moverse hacia la izquierda",
        deletePage: "Borrar Página",
        editPage: "Editar Página",
        edit: "Editar",
        newPageName: "página",
        newQuestionName: "pregunta",
        newPanelName: "panel",
        testSurvey: "Probar Encuesta",
        testSurveyAgain: "Probar Encuesta Otra Vez",
        testSurveyWidth: "Ancho de Encuesta: ",
        embedSurvey: "Empotrar Encuesta",
        saveSurvey: "Guardar Encuesta",
        designer: "Diseñador de Encuesta",
        jsonEditor: "Editor de JSON",
        undo: "Deshacer",
        redo: "Rehacer",
        options: "Opciones",
        generateValidJSON: "Generar JSON válido",
        generateReadableJSON: "Generar JSON legible",
        toolbox: "Caja de herramientas",
        toolboxGeneralCategory: "Categoría General",
        delSelObject: "Borrar objeto seleccionado",
        editSelObject: "Editar objeto seleccionado",
        correctJSON: "Por favor corrija JSON.",
        surveyResults: "Resultado de Encuesta: ",
        modified: "Modificado",
        saving: "Salvando",
        saved: "Salvado"
    },
    //Property names in table headers
    pel: {
        isRequired: "Requerido?"
    },
    //Property Editors
    pe: {
        apply: "Aplicar",
        ok: "OK",
        cancel: "Cancelar",
        reset: "Restaurar",
        close: "Cerrar",
        delete: "Borrar",
        addNew: "Añadir nuevo",
        addItem: "Click para añadir articulo...",
        removeAll: "Quitar todos",
        edit: "Editar",
        itemValueEdit: "Visible Si",
        editChoices: "Editar Opciones",
        move: "Mover",
        empty: "<vacío>",
        notEmpty: "<editar valor>",
        fastEntry: "Entrada rápida",
        formEntry: "Entrar en forma",
        testService: "Pruebe el servicio",
        conditionSelectQuestion: "Seleccionar pregunta...",
        conditionValueQuestionTitle: "Porfavor selecciona el valor",
        conditionButtonAdd: "Añadir",
        conditionButtonReplace: "Reemplazar",
        conditionHelp: "Por favor proporcione una expresión booleana. Debería regresar verdadero para mantener la pregunta/página visible. Por ejemplo: {pregunta1} = 'valor1' or ({pregunta2} * {pregunta4}  > 20 and {pregunta3} < 5)",
        expressionHelp: "Por favor proporcione una expresión. Puede hacer uso de llaves para tener acceso a los valores de la pregunta: '{pregunta1} + {pregunta2}', '({precio}*{cantidad}) * (100 - {descuento})'",
        aceEditorHelp: "Presione ctrl+espacio para obtener un indicio de completado de expresión",
        aceEditorRowTitle: "Fila actual",
        aceEditorPanelTitle: "Panel actual",
        showMore: "Por favor use la documentación para más detalles",
        conditionShowMoreUrl: "https://surveyjs.io/Documentation/LibraryParameter?id=Question&parameter=visibleIf",
        assistantTitle: "Preguntas disponibles:",
        cellsEmptyRowsColumns: "Debe haber al menos una columna o fila",
        propertyIsEmpty: "Por favor proporcione un valor",
        value: "Valor",
        text: "Texto",
        columnEdit: "Editar columna: {0}",
        itemEdit: "Editar artículo: {0}",
        url: "URL",
        path: "trayecto",
        valueName: "Nombre del valor",
        titleName: "Título",
        hasOther: "Tiene otro artículo",
        otherText: "Texto de otro artículo",
        name: "Nombre",
        title: "Título",
        cellType: "Tipo de celda",
        colCount: "Conteo de columnas",
        choicesOrder: "Orden de selección de elecciones",
        visible: "Es visible?",
        isRequired: "Es requerido?",
        startWithNewLine: "Es inicio con nueva línea?",
        rows: "Conteo de filas",
        placeHolder: "Marcador de entrada",
        showPreview: "Se muestra avance de imagen?",
        storeDataAsText: "Guardar contenido de archivo en resultado JSON como texto",
        maxSize: "Tamaño máximo de archivo en bytes",
        imageHeight: "Altura de imagen",
        imageWidth: "Ancho de imagen",
        rowCount: "Conteo de filas",
        columnsLocation: "Columns location",
        addRowLocation: "Agregar ubicación de botón de fila",
        addRowText: "Añadir texto de boton de fila",
        removeRowText: "Quitar texto de boton de fila",
        minRateDescription: "Descripción de la tasa mínima",
        maxRateDescription: "Descripción de la tarifa máxima",
        inputType: "Tipo de entrada",
        optionsCaption: "Leyenda de opciones",
        defaultValue: "Valor de defecto",
        cellsDefaultRow: "Textos de celdas por defecto",
        surveyEditorTitle: "Editar ajustes de encuesta",
        qEditorTitle: "Editar: {0}",
        //survey
        showTitle: "Mostrar/esconder título",
        locale: "Lenguaje de defecto",
        mode: "Modo (editar/solo lectura)",
        clearInvisibleValues: "Borrar valores invisibles",
        cookieName: "Nombre de Cookie (para deshabilitar corra encuesta dos veces localmente)",
        sendResultOnPageNext: "Mandar resultados de encuesta en página siguiente",
        storeOthersAsComment: "Guardar valor 'otros' en campo separado",
        showPageTitles: "Mostrar títulos de página",
        showPageNumbers: "Mostrar números de página",
        pagePrevText: "Texto de botón de página previa",
        pageNextText: "Texto de botón de página próxima",
        completeText: "Texto de botón de completado",
        startSurveyText: "Texto de botón de inicio",
        showNavigationButtons: "Mostrar botones de navigación (navegación de defecto)",
        showPrevButton: "Mostrar botón previo (el usuario puede regresar en página previa)",
        firstPageIsStarted: "La primera página en la encuesta es una página iniciada.",
        showCompletedPage: "Mostrar la página completada al final (completedHtml)",
        goNextPageAutomatic: "Al contestar todas las preguntas, ir a la próxima página automáticamente",
        showProgressBar: "Mostrar barra de progreso",
        questionTitleLocation: "Localización de título de pregunta",
        requiredText: "La pregunta requiere de símbolo(s)",
        questionStartIndex: "Índice de inicio de pregunta (1, 2 o 'A', 'a')",
        showQuestionNumbers: "Mostrar números de preguntas",
        questionTitleTemplate: "Plantilla de título de pregunta, defecto es: '{no}. {require} {title}'",
        questionErrorLocation: "Error en ubucación de la pregunta",
        focusFirstQuestionAutomatic: "Foco en primera pregunta al cambiar la página",
        questionsOrder: "Órden de elementos en la página",
        maxTimeToFinish: "Tiempo máximo para finalizar la encuesta",
        maxTimeToFinishPage: "Tiempo máximo para finalizar una página en la encuesta",
        showTimerPanel: "Mostrar panel de temporizador",
        showTimerPanelMode: "Modo de muestra de panel de temporizador",
        renderMode: "Modo de interpretador",
        allowAddPanel: "Permitir adición de un panel",
        allowRemovePanel: "Permitir remoción del panel",
        panelAddText: "Añadiendo texto de panel",
        panelRemoveText: "Quitando texto de panel",
        isSinglePage: "Mostrar todos los elementos en una página",
        tabs: {
            general: "General",
            fileOptions: "Opciones",
            html: "Editor Html",
            columns: "Columnas",
            rows: "Filas",
            choices: "Opciones",
            items: "Elementos",
            visibleIf: "Visible Si",
            enableIf: "Habilitar Si",
            rateValues: "Valores de tasa",
            choicesByUrl: "Opciones de la Web",
            matrixChoices: "Opciones de defecto",
            multipleTextItems: "Entradas de texto",
            validators: "Validadores",
            navigation: "Navegación",
            question: "Pregunta",
            completedHtml: "Html Completado",
            loadingHtml: "Cargando Html",
            timer: "Temporizador/Quiz",
            triggers: "Disparadores",
            templateTitle: "Título de plantilla"
        },
        editProperty: "Editar propiedad '{0}'",
        items: "[ Items: {0} ]",
        enterNewValue: "Por favor, proporcione el valor.",
        noquestions: "No hay ni una pregunta en la encuesta.",
        createtrigger: "Por favor cree un disparador",
        triggerOn: "En ",
        triggerMakePagesVisible: "Hacer páginas visibles:",
        triggerMakeQuestionsVisible: "Hacer elementos visibles:",
        triggerCompleteText: "Complete la encuesta en caso de éxito.",
        triggerNotSet: "El disparador no está configurado",
        triggerRunIf: "Correr si",
        triggerSetToName: "Cambiar valor de: ",
        triggerSetValue: "a: ",
        triggerIsVariable: "No poner la variable en el resultado de la encuesta."
    },
    //Property values
    pv: {
        true: "verdadero",
        false: "falso",
        inherit: "heredar",
        show: "mostrar",
        hide: "ocultar",
        default: "predefinido",
        initial: "inicial",
        random: "aleatorio",
        collapsed: "colapsado",
        expanded: "expandido",
        none: "ninguna",
        asc: "ascendente",
        desc: "descendente",
        indeterminate: "indeterminado",
        decimal: "decimal",
        currency: "moneda",
        percent: "por ciento",
        firstExpanded: "primeroExpandido",
        off: "apagado",
        onPanel: "onPanel",
        onSurvey: "onSurvey",
        list: "lista",
        progressTop: "progresoArriba",
        progressBottom: "progresoAbajo",
        progressTopBottom: "progresoArribaAbajo",
        horizontal: "horizontal",
        vertical: "vertical",
        top: "arriba",
        bottom: "abajo",
        topBottom: "arriba y abajo",
        left: "izquierda",
        color: "color",
        date: "fecha",
        datetime: "fecha y hora",
        "datetime-local": "fechaHora-local",
        email: "correo electrónico",
        month: "mes",
        number: "número",
        password: "contraseña",
        range: "rango",
        tel: "teléfono",
        text: "texto",
        time: "tiempo",
        url: "url",
        week: "semana",
        hidden: "oculto",
        on: "encendido",
        onPage: "onPage",
        edit: "editar",
        display: "mostrar",
        onComplete: "Cuando se complete",
        onHidden: "Cuando se oculte",
        all: "todo",
        page: "página",
        survey: "encuesta",
        onNextPage: "Cuando se cambie de página",
        onValueChanged: "Cuando el valor cambie"
    },
    //Operators
    op: {
        empty: "es vacío",
        notempty: "no es vacío",
        equal: "igual a",
        notequal: "no igual a",
        contains: "contiene",
        notcontains: "no contiene",
        greater: "mayor",
        less: "menor",
        greaterorequal: "mayor o igual a",
        lessorequal: "menor or igual a"
    },
    //Embed window
    ew: {
        angular: "Use versión Angular",
        jquery: "Use versión jQuery",
        knockout: "Use versión Knockout",
        react: "Use versión React",
        vue: "Use versión Vue",
        bootstrap: "Para entorno bootstrap",
        standard: "No bootstrap",
        showOnPage: "Mostrar encuesta en una página",
        showInWindow: "Mostrar encuesta en una ventana",
        loadFromServer: "Cargar JSON de encuesta del servidor",
        titleScript: "Scripts y estilos",
        titleHtml: "HTML",
        titleJavaScript: "JavaScript"
    },
    //Test Survey
    ts: {
        selectPage: "Seleccione la página para probarla:"
    },
    validators: {
        answercountvalidator: "cuenta de respuestas",
        emailvalidator: "e-mail",
        expressionvalidator: "expresión",
        numericvalidator: "numerico",
        regexvalidator: "regex",
        textvalidator: "texto"
    },
    triggers: {
        completetrigger: "encuesta completa",
        setvaluetrigger: "valor ajustado",
        visibletrigger: "cambio de visibilidad"
    },
    //Properties
    p: {
        name: "nombre",
        title: {
            name: "título",
            title: "Dejarlo vacío, si es igual que 'Nombre'"
        },
        page_title: { name: "título", title: "Título de página" },
        navigationButtonsVisibility: "Visibilidad de botones de navegación",
        questionsOrder: "Orden de las preguntas",
        maxTimeToFinish: "Tiempo máximo para terminar",
        visible: "Visible",
        visibleIf: "Visible Si",
        questionTitleLocation: "preguntaTituloLocacion",
        description: "Descripción",
        state: "Estado",
        isRequired: "Es Requerido",
        indent: "Indentar",
        requiredErrorText: "Texto del error",
        startWithNewLine: "Comenzar con una nueva línea",
        innerIndent: "Identación interna",
        page: "Página",
        width: "Ancho",
        commentText: "Texto del Comentario",
        valueName: "Nombre del valor",
        enableIf: "Habilitado Si",
        defaultValue: "Valor por defecto",
        correctAnswer: "Respuesta correcta",
        readOnly: "Solo Lectura",
        validators: "Validadores",
        titleLocation: "Titulo de la ubicación",
        hasComment: "Tiene Comentario",
        hasOther: "Tiene Otro",
        choices: "Elecciones",
        choicesOrder: "Orden de las opciones",
        choicesByUrl: "Opciones por URL",
        otherText: "Otro Texto",
        otherErrorText: "Texto del error para otro",
        storeOthersAsComment: "Guardar otros como comentario",
        label: "Etiqueta",
        showTitle: "Mostrar Título",
        valueTrue: "Valor Verdadero",
        valueFalse: "Valor Falso",
        cols: "Columnas",
        rows: "Filas",
        placeHolder: "Marcador de entrada",
        optionsCaption: "Opciones de Título",
        expression: "Expresión",
        format: "Formato",
        displayStyle: "Estilo de visualización",
        currency: "Moneda",
        useGrouping: "Usar agrupación",
        showPreview: "Mostrar vista previa",
        allowMultiple: "Permitir múltiples",
        imageHeight: "Altura de la imagen",
        imageWidth: "Ancho de la imagen",
        storeDataAsText: "Almacenar datos como texto",
        maxSize: "Tamaño máximo",
        html: "html",
        columns: "columnas",
        cells: "celdas",
        isAllRowRequired: "Se requieren todas las filas",
        horizontalScroll: "Desplazamiento horizontal",
        cellType: "Tipo de celda",
        columnsLocation: "Columnas de Locación",
        columnColCount: "Conteo de columna",
        columnMinWidth: "Ancho mínimo de columna",
        rowCount: "Conteo de fila",
        minRowCount: "Conteo mínima de fila",
        maxRowCount: "Conteo máxima de fila",
        keyName: "Nombre clave",
        keyDuplicationError: "Mensaje de error para clave de duplicada",
        confirmDelete: "Confirmación de eliminación",
        confirmDeleteText: "Texto de la confirmación para eliminación",
        addRowLocation: "Agrega fila de ubicación",
        addRowText: "Agregar texto de la fila",
        removeRowText: "Quitar texto de la fila",
        items: "ítems",
        itemSize: "Tamaño del ítem",
        colCount: "Conteo de columnas",
        templateTitle: "Título de la plantilla",
        templateDescription: "Descripción de la platilla",
        allowAddPanel: "Permitir agregar panel",
        allowRemovePanel: "Permitir eliminar panel",
        panelCount: "Conteo de panel",
        minPanelCount: "Conteo mínimo de panel",
        maxPanelCount: "Conteo máximo de panel",
        panelsState: "Paneles de Estado",
        panelAddText: "Agregar texto al panel",
        panelRemoveText: "Eliminar texto al panel",
        panelPrevText: "Texto anterior del panel",
        panelNextText: "Texto siguiente del panel",
        showQuestionNumbers: "Nostrar números de pregunta",
        showRangeInProgress: "Mostrar el rango de progreso",
        renderMode: "Modo renderizado",
        templateTitleLocation: "Plantilla del Título Ubicación",
        rateValues: "Valores de tarifa",
        rateMin: "Tarifa mínima",
        rateMax: "Tarifa máxima",
        rateStep: "Pasos de tarifa",
        minRateDescription: "Descripción mínima de tarifa",
        maxRateDescription: "Descripción máxima de tarifa",
        inputType: "Tipo de entrada",
        size: "Tamaño",
        locale: "Lugar",
        focusFirstQuestionAutomatic: "Enfocar primera pregunta automática",
        completedHtml: "HTML Completado",
        completedBeforeHtml: "Completado antes de HTML",
        loadingHtml: "Cargando HTML",
        triggers: "Disparadores",
        cookieName: "Nombre de la cookie",
        sendResultOnPageNext: "Enviar resultado a la página siguiente",
        showNavigationButtons: "Mostrar botones de navegación",
        showPrevButton: "Mostrar botón anterior",
        showPageTitles: "Mostrar Títulos de la página",
        showCompletedPage: "Mostrar página completada",
        showPageNumbers: "Mostrar los números de página",
        questionErrorLocation: "Pregunta error ubicación",
        showProgressBar: "Mostrar barra de progreso",
        mode: "Modo",
        goNextPageAutomatic: "Ir a la siguiente página automática",
        checkErrorsMode: "Verifica el modo de errores",
        clearInvisibleValues: "Limpiar en valores visibles",
        startSurveyText: "Comenzar el texto de la encuesta",
        pagePrevText: "Texto anterior de la página",
        pageNextText: "Texto siguiente de la página",
        completeText: "Texto completado de la página",
        requiredText: "Texto requerido",
        questionStartIndex: "Índice de inicio de pregunta",
        questionTitleTemplate: "Título platilla de la pregunta",
        firstPageIsStarted: "Se inicia la primera página",
        isSinglePage: "Es una sola página",
        maxTimeToFinishPage: "Tiempo máximo para terminar la página",
        showTimerPanel: "Mostrar tiempo del panel",
        showTimerPanelMode: "Mostrar tiempo del modo panel",
        text: "texto",
        minValue: "Valor mínimo",
        maxValue: "Valor máximo",
        minLength: "Largo mínimo",
        maxLength: "Largo máximo",
        allowDigits: "Permitir dígitos",
        minCount: "Conteo mínimo",
        maxCount: "Conteo máximo",
        regex: "Expresión regular"
    }
};
__WEBPACK_IMPORTED_MODULE_0__editorLocalization__["a" /* editorLocalization */].locales["es"] = spanishTranslation;


/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__editorLocalization__ = __webpack_require__(0);

var traditionalChineseTranslation = {
    // strings for survey templates
    survey: {
        edit: "編輯",
        dropQuestion: "請將問題放置於此",
        copy: "複製",
        addToToolbox: "添加到工具箱",
        deletePanel: "刪除面板",
        deleteQuestion: "刪除題目",
        convertTo: "轉變為"
    },
    // strings for question types
    qt: {
        checkbox: "多項選擇",
        comment: "多行文本框",
        dropdown: "下拉框",
        file: "文件上傳",
        html: "Html 代碼",
        matrix: "矩陣 (單選題)",
        matrixdropdown: "矩陣 (下拉框)",
        matrixdynamic: "矩陣 (動態問題)",
        multipletext: "文本框組",
        panel: "面板",
        paneldynamic: "面板(動態)",
        radiogroup: "單項選擇",
        rating: "評分",
        text: "文本框",
        boolean: "布林選項",
        expression: "表達式"
    },
    // strings for editor
    ed: {
        survey: "調查問捲",
        editSurvey: "修改",
        addNewPage: "添加新頁面",
        deletePage: "刪除頁面",
        editPage: "編輯頁面",
        newPageName: "頁面",
        newQuestionName: "問題",
        newPanelName: "面板",
        testSurvey: "測試問捲",
        testSurveyAgain: "再次測試問捲",
        testSurveyWidth: "問捲寬度: ",
        embedSurvey: "將問捲嵌入網頁",
        saveSurvey: "保存問捲",
        designer: "問捲設計器",
        jsonEditor: "JSON 編輯器",
        undo: "還原",
        redo: "重做",
        options: "選項",
        generateValidJSON: "生成 JSON",
        generateReadableJSON: "生成易讀的 JSON",
        toolbox: "工具箱",
        delSelObject: "刪除所選對象",
        editSelObject: "編輯所選對象",
        correctJSON: "修正 JSON",
        surveyResults: "問卷結果: ",
        modified: "已修改",
        saving: "保存中...",
        saved: "已保存"
    },
    //Property names in table headers
    pel: {
        isRequired: "是否為必填項?"
    },
    // strings for property editors
    pe: {
        apply: "應用",
        ok: "確定",
        cancel: "取消",
        reset: "重置",
        close: "關閉",
        delete: "刪除",
        addNew: "新建",
        removeAll: "全部刪除",
        edit: "編輯器",
        empty: "<空>",
        fastEntry: "快速輸入",
        formEntry: "表單輸入",
        testService: "測試服務",
        showMore: "更多細節...",
        conditionHelp: "請輸入一個布林表達式。當布林值為真，問題/頁面可見。例如：{question1} = 'value1' or ({question2} * {question4}  > 20 and {question3} < 5)",
        expressionHelp: "請輸入一項條件判斷。當條件判斷為真時問題/頁面將可見。例如: {question1} = 'value1' or ({question2} = 3 and {question3} < 5)",
        propertyIsEmpty: "請為該屬性設定一個值",
        value: "值",
        text: "顯示文本",
        columnEdit: "編輯列: {0}",
        itemEdit: "編輯選項: {0}",
        hasOther: "可添加其他答案?",
        otherText: "其他答案文本",
        url: "URL",
        path: "Path",
        valueName: "Value name",
        titleName: "Title name",
        name: "題目名",
        title: "題目文本",
        cellType: "單元格類型",
        colCount: "列數",
        choicesOrder: "設置選項順序",
        visible: "是否可見?",
        isRequired: "是否為必填項?",
        startWithNewLine: "問題是否新起一行?",
        rows: "文本框行數",
        placeHolder: "占位文本",
        showPreview: "是否顯示圖像預覽?",
        storeDataAsText: "以 JSON 文本方式存儲文件",
        maxSize: "文件最大尺寸 (Bytes)",
        imageHeight: "圖片高度",
        imageWidth: "圖片寬度",
        rowCount: "默認行數",
        addRowText: "添加條目按鈕文本",
        removeRowText: "刪除條目按鈕文本",
        minRateDescription: "最小值提示",
        maxRateDescription: "最大值提示",
        inputType: "文本框類型",
        optionsCaption: "下拉框提示語",
        qEditorTitle: "編輯問題: {0}",
        //survey
        showTitle: "顯示/隱藏 標題",
        locale: "默認語言",
        mode: "模式 (編輯/只讀)",
        clearInvisibleValues: "清除隱藏值",
        cookieName: "Cookie name (to disable run survey two times locally)",
        sendResultOnPageNext: "Send survey results on page next",
        storeOthersAsComment: "Store 'others' value in separate field",
        showPageTitles: "顯示頁面標題",
        showPageNumbers: "顯示頁數",
        pagePrevText: "前一頁按鈕文本",
        pageNextText: "後一頁按鈕文本",
        completeText: "完成按鈕文本",
        startSurveyText: "開始按鈕文本",
        showNavigationButtons: "顯示導航按鈕 (默認導航)",
        showPrevButton: "顯示前一頁按鈕 (用戶可返回至前一頁面)",
        firstPageIsStarted: "調查的第一頁面為起始頁.",
        showCompletedPage: "結尾展示完成後的頁面 (completedHtml)",
        goNextPageAutomatic: "回答本頁所有問題後，自動跳轉到下一頁",
        showProgressBar: "顯示進度條",
        questionTitleLocation: "問題的標題位置",
        requiredText: "The question required symbol(s)",
        questionStartIndex: "問題起始標誌 (1, 2 or 'A', 'a')",
        showQuestionNumbers: "顯示問題編號",
        questionTitleTemplate: "問題標題模板, 默認為: '{no}. {require} {title}'",
        questionErrorLocation: "問題錯誤定位",
        focusFirstQuestionAutomatic: "改變頁面時聚焦在第一個問題",
        questionsOrder: "Elements order on the page",
        maxTimeToFinish: "完成調查的最長時間",
        maxTimeToFinishPage: "完成調查中頁面的最長時間",
        showTimerPanel: "顯示計時器面板",
        showTimerPanelMode: "顯示計時器面板模式",
        renderMode: "渲染模式",
        allowAddPanel: "允許添加面板",
        allowRemovePanel: "允許刪除面板",
        panelAddText: "添加面板文本",
        panelRemoveText: "刪除面板文本",
        isSinglePage: "在一個頁面上展示所有元素",
        tabs: {
            general: "通用項",
            navigation: "導航",
            question: "問題",
            completedHtml: "完成後的Html",
            loadingHtml: "加載中的Html",
            timer: "問捲計時器",
            trigger: "觸發器",
            fileOptions: "選項",
            html: "HTML 編輯器",
            columns: "設置列",
            rows: "設置行",
            choices: "設置選項",
            visibleIf: "設置可見條件",
            enableIf: "Enable If",
            rateValues: "設置評分值",
            choicesByUrl: "通過 URL 導入選項",
            matrixChoices: "默認選項",
            multipleTextItems: "文本輸入",
            validators: "校驗規則"
        },
        editProperty: "編輯屬性: '{0}'",
        items: "[ 項目數量: {0} ]",
        enterNewValue: "請設定值",
        noquestions: "問捲中還沒有創建任何問題",
        createtrigger: "請創建觸發器",
        triggerOn: "當 ",
        triggerMakePagesVisible: "使頁面可見:",
        triggerMakeQuestionsVisible: "使問題可見:",
        triggerCompleteText: "如果滿足條件，則完成問捲",
        triggerNotSet: "觸發器尚未設置",
        triggerRunIf: "滿足下列條件時執行",
        triggerSetToName: "修改下列問題值: ",
        triggerSetValue: "修改為: ",
        triggerIsVariable: "在問捲提交結果中不要包含該變量"
    },
    // strings for operators
    op: {
        empty: "為空",
        notempty: "不為空",
        equal: "等於",
        notequal: "不等於",
        contains: "包含",
        notcontains: "不包含",
        greater: "大於",
        less: "小於",
        greaterorequal: "大於等於",
        lessorequal: "小於等於"
    },
    // strings for embed window
    ew: {
        angular: "使用 Angular 時",
        jquery: "使用 JQuery 時",
        knockout: "使用 Knockout 時",
        react: "使用 React 時",
        vue: "使用 Vue 時",
        bootstrap: "使用 Bootstrap 時",
        standard: "不使用 Bootstrap 時",
        showOnPage: "嵌入頁面顯示",
        showInWindow: "使用單獨的問捲視窗",
        loadFromServer: "從服務器加載問捲 JSON 數據",
        titleScript: "腳本和樣式",
        titleHtml: "HTML",
        titleJavaScript: "JavaScript"
    },
    validators: {
        answercountvalidator: "數量檢查",
        emailvalidator: "Email",
        numericvalidator: "數字",
        regexvalidator: "正則表達式",
        textvalidator: "文本"
    },
    triggers: {
        completetrigger: "完成問捲",
        setvaluetrigger: "設置問題值",
        visibletrigger: "修改可見性"
    },
    // strings of properties
    p: {
        commentText: "備註文本",
        choices: "選項",
        choicesByUrl: "Url選項",
        choicesOrder: "選項排序",
        colCount: "列數",
        correctAnswer: "正確答案",
        defaultVaule: "預設選項",
        description: "說明",
        enableIf: "允許判斷",
        hasComment: "hasComment",
        hasOther: "允許其他答案",
        otherText: "其他答案文本",
        page: "所在頁面",
        readOnly: "只讀",
        indent: "縮排",
        isRequired: "必填",
        requiredErrorText: "requiredErrorText",
        otherErrorText: "requiredErrorText",
        startWithNewLine: "允許問題在新行",
        //survey
        showTitle: "顯示/隱藏 標題",
        locale: "默認語言",
        mode: "模式 (編輯/只讀)",
        clearInvisibleValues: "清除隱藏值",
        cookieName: "Cookie name (to disable run survey two times locally)",
        sendResultOnPageNext: "Send survey results on page next",
        storeOthersAsComment: "Store 'others' value in separate field",
        showPageTitles: "顯示頁面標題",
        showPageNumbers: "顯示頁數",
        pagePrevText: "前一頁按鈕文本",
        pageNextText: "後一頁按鈕文本",
        completeText: "完成按鈕文本",
        startSurveyText: "開始按鈕文本",
        showNavigationButtons: "顯示導航按鈕 (默認導航)",
        showPrevButton: "顯示前一頁按鈕 (用戶可返回至前一頁面)",
        firstPageIsStarted: "調查的第一頁面為起始頁.",
        showCompletedPage: "結尾展示完成後的頁面 (completedHtml)",
        goNextPageAutomatic: "回答本頁所有問題後，自動跳轉到下一頁",
        showProgressBar: "顯示進度條",
        questionTitleLocation: "問題的標題位置",
        requiredText: "The question required symbol(s)",
        questionStartIndex: "問題起始標志 (1, 2 or 'A', 'a')",
        showQuestionNumbers: "顯示問題編號",
        questionTitleTemplate: "問題標題模板, 默認為: '{no}. {require} {title}'",
        questionErrorLocation: "問題錯誤定位",
        focusFirstQuestionAutomatic: "改變頁面時聚焦在第一個問題",
        questionsOrder: "頁面中元素的順序",
        maxTimeToFinish: "完成調查的最長時間",
        maxTimeToFinishPage: "完成調查中頁面的最長時間",
        showTimerPanel: "顯示計時器面板",
        showTimerPanelMode: "顯示計時器面板模式",
        renderMode: "渲染模式",
        allowAddPanel: "允許添加面板",
        allowRemovePanel: "允許刪除面板",
        panelAddText: "添加面板文本",
        panelRemoveText: "刪除面板文本",
        isSinglePage: "在一個頁面上展示所有元素",
        name: "名字",
        title: {
            name: "標題",
            title: "如果與名字相同，請設置為空值"
        },
        survey_title: {
            name: "標題",
            title: "問捲標題在每頁上都會顯示"
        },
        page_title: {
            name: "標題",
            title: "頁面標題"
        }
    }
};
__WEBPACK_IMPORTED_MODULE_0__editorLocalization__["a" /* editorLocalization */].locales["zh-tw"] = traditionalChineseTranslation;


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_survey_knockout__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_survey_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_survey_knockout__);
/* unused harmony export SurveyDescription */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SurveysManager; });


var ServiceAPI = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](ServiceAPI, _super);
    function ServiceAPI(baseUrl, accessKey) {
        var _this = _super.call(this) || this;
        _this.baseUrl = baseUrl;
        _this.accessKey = accessKey;
        return _this;
    }
    ServiceAPI.prototype.getActiveSurveys = function (onLoad) {
        var xhr = new XMLHttpRequest();
        xhr.open("GET", this.baseUrl + "/getActive?accessKey=" + this.accessKey);
        xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
        xhr.onload = function () {
            var result = xhr.response ? JSON.parse(xhr.response) : null;
            onLoad(xhr.status == 200, result, xhr.response);
        };
        xhr.send();
    };
    ServiceAPI.prototype.createSurvey = function (name, onCreate) {
        var xhr = new XMLHttpRequest();
        xhr.open("GET", this.baseUrl + "/create?accessKey=" + this.accessKey + "&name=" + name);
        xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
        xhr.onload = function () {
            var result = xhr.response ? JSON.parse(xhr.response) : null;
            onCreate(xhr.status == 200, result, xhr.response);
        };
        xhr.send();
    };
    ServiceAPI.prototype.saveSurvey = function (id, json, onSave) {
        var xhr = new XMLHttpRequest();
        xhr.open("POST", this.baseUrl + "/changeJson?accessKey=" + this.accessKey);
        xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
        xhr.onload = function () {
            var result = xhr.response ? JSON.parse(xhr.response) : null;
            !!onSave && onSave(xhr.status == 200, result, xhr.response);
        };
        xhr.send(JSON.stringify({ Id: id, Json: json, Text: json }));
    };
    ServiceAPI.prototype.updateSurveyName = function (id, name, onUpdate) {
        var xhr = new XMLHttpRequest();
        xhr.open("GET", this.baseUrl +
            "/changeName/" +
            id +
            "?accessKey=" +
            this.accessKey +
            "&name=" +
            name);
        xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
        xhr.onload = function () {
            var result = xhr.response ? JSON.parse(xhr.response) : null;
            !!onUpdate && onUpdate(xhr.status == 200, result, xhr.response);
        };
        xhr.send();
    };
    return ServiceAPI;
}(__WEBPACK_IMPORTED_MODULE_1_survey_knockout__["dxSurveyService"]));
var SurveyDescription = /** @class */ (function () {
    function SurveyDescription(name, createdAt, id, resultId, postId) {
        if (name === void 0) { name = ko.observable(""); }
        if (createdAt === void 0) { createdAt = new Date(Date.now()).toDateString(); }
        if (id === void 0) { id = ""; }
        if (resultId === void 0) { resultId = ""; }
        if (postId === void 0) { postId = ""; }
        this.name = name;
        this.createdAt = createdAt;
        this.id = id;
        this.resultId = resultId;
        this.postId = postId;
    }
    return SurveyDescription;
}());

var SurveysManager = /** @class */ (function () {
    function SurveysManager(baseUrl, accessKey, editor) {
        var _this = this;
        this.baseUrl = baseUrl;
        this.accessKey = accessKey;
        this.editor = editor;
        this.isEditMode = ko.observable(false);
        this.surveyId = ko.observable();
        this.surveys = ko.observableArray();
        this.currentSurvey = ko.observable();
        this.currentSurveyName = ko.observable("");
        this.isLoading = ko.observable(false);
        this.nameEditorKeypress = function (model, event) {
            if (event.keyCode === 13) {
                _this.edit(model, event);
            }
            else if (event.keyCode === 27) {
                _this.isEditMode(false);
            }
        };
        var hash = window.location.hash;
        if (hash.indexOf("#") === 0) {
            this.surveyId(hash.slice(1));
        }
        this.api = new ServiceAPI(baseUrl + SurveysManager.serviceUrlPath, accessKey);
        editor.isAutoSave = true;
        editor.showState = true;
        editor.saveSurveyFunc = function (saveNo, callback) {
            if (!editor.surveyId && !_this.surveyId()) {
                _this.addHandler(function (success) { return callback(saveNo, success); });
            }
            if (!!editor.surveyId || !!_this.surveyId()) {
                _this.api.saveSurvey(editor.surveyId || _this.surveyId(), editor.text, function (success) { return callback(saveNo, success); });
            }
        };
        this.surveys(this.getSurveys());
        if (!this.surveyId()) {
            this.currentSurvey(this.surveys()[0]);
        }
        else {
            var survey = this.surveys().filter(function (s) { return s.id === _this.surveyId(); })[0];
            if (!!survey) {
                this.currentSurvey(survey);
                this.surveyId(undefined);
            }
            else {
                editor.loadSurvey(this.surveyId());
            }
        }
        var onCurrentSurveyChanged = function (survey) {
            if (!!survey) {
                _this.surveyId(undefined);
                window.location.hash = "#" + survey.id;
                if (editor.surveyId === survey.id)
                    return;
                editor.loadSurvey(survey.id);
                editor.surveyId = survey.id;
                editor.surveyPostId = survey.postId;
            }
            else {
                if (!_this.surveyId()) {
                    editor.surveyId = "";
                    editor.surveyPostId = "";
                    window.location.hash = "";
                    editor.text = "";
                }
            }
        };
        this.currentSurvey.subscribe(onCurrentSurveyChanged);
        onCurrentSurveyChanged(this.currentSurvey());
        var currentSurveyCanBeAttached = ko.observable(false);
        ko.computed(function () {
            var survey = _this.currentSurvey();
            currentSurveyCanBeAttached(false);
            if (!!survey) {
                _this.api.updateSurveyName(survey.id, survey.name.peek(), function (success) {
                    currentSurveyCanBeAttached(success);
                });
            }
        });
        this.toolbarItem = {
            id: "svd-attach-survey",
            template: "attach-survey",
            visible: currentSurveyCanBeAttached,
            action: ko.computed(function () {
                return "https://dxsurvey.com/Home/AttachSurvey/" +
                    (_this.currentSurvey() && _this.currentSurvey().id);
            }),
            css: "link-to-attach",
            innerCss: "icon-cloud",
            title: "Attach survey to your SurveyJS service account..."
        };
    }
    SurveysManager.prototype.getSurveys = function () {
        return JSON.parse(window.localStorage.getItem(SurveysManager.StorageKey) || "[]").map(function (item) {
            return new SurveyDescription(ko.observable(item.name), item.createdAt, item.id, item.resultId, item.postId);
        });
    };
    SurveysManager.prototype.setSurveys = function (surveys) {
        window.localStorage.setItem(SurveysManager.StorageKey, ko.toJSON(surveys));
    };
    SurveysManager.prototype.edit = function (model, event) {
        var survey = this.currentSurvey();
        if (!!survey) {
            if (this.isEditMode()) {
                survey.name(this.currentSurveyName());
                this.setSurveys(this.surveys());
                this.api.updateSurveyName(survey.id, survey.name());
                this.isEditMode(false);
            }
            else {
                this.currentSurveyName(survey.name());
                this.isEditMode(true);
                event.target.parentNode.parentElement.getElementsByTagName("input")[0].focus();
            }
        }
    };
    SurveysManager.prototype.addHandler = function (onAdd) {
        var _this = this;
        this.isLoading(true);
        this.api.createSurvey("NewSurvey", function (success, result, response) {
            var newSurveyDescription = new SurveyDescription(ko.observable(result.Name), result.CreatedAt, result.Id, result.ResultId, result.PostId);
            _this.surveys.push(newSurveyDescription);
            _this.setSurveys(_this.surveys());
            _this.editor.surveyId = result.Id;
            _this.editor.surveyPostId = result.PostId;
            _this.api.saveSurvey(result.Id, _this.editor.text);
            _this.currentSurvey(newSurveyDescription);
            _this.isLoading(false);
            onAdd && onAdd(success, result, response);
        });
    };
    SurveysManager.prototype.add = function () {
        this.addHandler();
    };
    SurveysManager.prototype.remove = function () {
        if (confirm("Do you really want to remove current survey?")) {
            this.surveys.remove(this.currentSurvey());
            this.setSurveys(this.surveys());
            this.currentSurvey(this.surveys()[0]);
        }
    };
    Object.defineProperty(SurveysManager.prototype, "cssEdit", {
        get: function () {
            return this.isEditMode() ? "icon-saved" : "icon-edit";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveysManager.prototype, "cssAdd", {
        get: function () {
            return !this.surveyId() ? "icon-new" : "icon-fork";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveysManager.prototype, "titleEdit", {
        get: function () {
            return this.isEditMode() ? "Save survey name" : "Edit survey name";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveysManager.prototype, "titleAdd", {
        get: function () {
            return !this.surveyId() ? "Add new survey" : "Fork this survey";
        },
        enumerable: true,
        configurable: true
    });
    SurveysManager.serviceUrlPath = "/api/MySurveys";
    SurveysManager.StorageKey = "mySurveys";
    return SurveysManager;
}());



/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_knockout__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__surveyHelper__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editorLocalization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vendor_knockout_sortable_js__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vendor_knockout_sortable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__vendor_knockout_sortable_js__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PagesEditor; });




var PagesEditor = /** @class */ (function () {
    function PagesEditor(editor, element) {
        var _this = this;
        this.editor = editor;
        this.element = element;
        this.isNeedAutoScroll = true;
        this.isDraggingPage = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"](false);
        this.prevPagesForSelector = [];
        this._selectedPage = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"]();
        this.getDisplayText = function (page) {
            return (_this.editor.showObjectTitles ? page.title : "") || page.name;
        };
        this.pageSelection = __WEBPACK_IMPORTED_MODULE_0_knockout__["computed"]({
            read: function () { return _this._selectedPage(); },
            write: function (newVal) {
                if (!!newVal && typeof newVal.getType === "function") {
                    _this.selectedPage = newVal;
                }
                else {
                    if (_this.editor.pages().length > 0) {
                        _this.addPage();
                    }
                }
            }
        });
        this.onPageClick = function (model, event) {
            _this.isNeedAutoScroll = false;
            _this.editor.selectPage(model);
            event.stopPropagation();
            _this.updateMenuPosition();
        };
        this.getPageClass = function (page) {
            var result = page === _this.selectedPage ? "svd_selected_page svd-light-bg-color" : "";
            if (_this.editor.pages().indexOf(page) !== _this.editor.pages().length - 1) {
                result += " svd-border-right-none";
            }
            return result;
        };
        this.getPageMenuIconClass = function (page) {
            return page === _this.selectedPage && _this.isActive()
                ? "icon-gearactive"
                : "icon-gear";
        };
        this.showActions = function (page) {
            return page === _this.selectedPage && _this.isActive();
        };
        this.pagesSelection = __WEBPACK_IMPORTED_MODULE_0_knockout__["computed"](function () {
            if (!_this.isDraggingPage()) {
                _this.prevPagesForSelector = _this.editor
                    .pages()
                    .concat([{ name: _this.getLocString("ed.addNewPage") }]);
            }
            return _this.prevPagesForSelector;
        });
        this._selectedPage(this.editor.pages()[0]);
        this.editor.koSelectedObject.subscribe(function (newVal) {
            if (!_this.isActive()) {
                if (!!editor.survey.currentPage &&
                    editor.survey.currentPage != _this._selectedPage()) {
                    _this._selectedPage(editor.survey.currentPage);
                }
                return;
            }
            _this._selectedPage(newVal.value);
            if (_this.isNeedAutoScroll) {
                _this.scrollToSelectedPage();
            }
            else {
                _this.isNeedAutoScroll = true;
            }
        });
    }
    PagesEditor.prototype.addPage = function () {
        this.editor.addPage();
    };
    PagesEditor.prototype.copyPage = function (page) {
        this.editor.copyPage(page);
    };
    PagesEditor.prototype.deletePage = function () {
        this.editor.deletePage();
    };
    PagesEditor.prototype.showPageSettings = function (page) {
        this.editor.showQuestionEditor(page);
    };
    Object.defineProperty(PagesEditor.prototype, "sortableOptions", {
        get: function () {
            var _this = this;
            return {
                onStart: function (evt) {
                    _this.isDraggingPage(true);
                },
                onEnd: function (evt) {
                    _this.isNeedAutoScroll = false;
                    _this.editor.movePage(evt.oldIndex, evt.newIndex);
                    _this.isDraggingPage(false);
                },
                handle: ".svd-page-name",
                animation: 150
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PagesEditor.prototype, "selectedPage", {
        get: function () {
            return this._selectedPage();
        },
        set: function (newPage) {
            this.editor.selectPage(newPage);
        },
        enumerable: true,
        configurable: true
    });
    PagesEditor.prototype.isLastPage = function () {
        return this.editor.pages().length === 1;
    };
    PagesEditor.prototype.moveLeft = function (model, event) {
        var pagesElement = this.element.querySelector(".svd-pages");
        pagesElement.scrollLeft -= 50;
        this.updateMenuPosition();
    };
    PagesEditor.prototype.moveRight = function (model, event) {
        var pagesElement = this.element.querySelector(".svd-pages");
        pagesElement.scrollLeft += 50;
        this.updateMenuPosition();
    };
    PagesEditor.prototype.scrollToSelectedPage = function () {
        var pagesElement = this.element.querySelector(".svd-pages");
        if (!pagesElement)
            return;
        var index = this.editor.pages().indexOf(this.selectedPage);
        var pageElement = pagesElement.children[index];
        if (!pageElement)
            return;
        pagesElement.scrollLeft =
            pageElement.offsetLeft -
                pagesElement.offsetLeft -
                pagesElement.offsetWidth / 2;
        this.updateMenuPosition();
    };
    // onKeyDown(el: any, e: KeyboardEvent) {
    //   if (this.koPages().length <= 1) return;
    //   var pages = this.koPages();
    //   var pageIndex = -1;
    //   for (var i = 0; i < pages.length; i++) {
    //     if (pages[i].page && pages[i].koSelected()) {
    //       pageIndex = i;
    //     }
    //   }
    //   if (pageIndex < 0) return;
    //   if (e.keyCode == 46 && this.onDeletePageCallback)
    //     this.onDeletePageCallback(el.page);
    //   if ((e.keyCode == 37 || e.keyCode == 39) && this.onSelectPageCallback) {
    //     pageIndex += e.keyCode == 37 ? -1 : 1;
    //     if (pageIndex < 0) pageIndex = pages.length - 1;
    //     if (pageIndex >= pages.length) pageIndex = 0;
    //     var page = pages[pageIndex].page;
    //     this.onSelectPageCallback(page);
    //     this.setSelectedPage(page);
    //   }
    // }
    PagesEditor.prototype.onWheel = function (model, event) {
        var pagesElement = model.element.querySelector(".svd-pages");
        event = event || window.event;
        if (!!event.originalEvent) {
            event = event.originalEvent;
        }
        var delta = event.deltaY || event.detail || event.wheelDelta;
        pagesElement.scrollLeft -= delta;
        event.preventDefault ? event.preventDefault() : (event.returnValue = false);
        this.updateMenuPosition();
    };
    PagesEditor.prototype.updateMenuPosition = function () {
        var pagesElement = this.element.querySelector(".svd-pages");
        var menuElements = pagesElement.getElementsByClassName("svd-page-actions");
        for (var i = 0; i < menuElements.length; i++) {
            menuElements[i].style.left =
                menuElements[i].parentElement.offsetLeft -
                    pagesElement.scrollLeft +
                    "px";
        }
    };
    PagesEditor.prototype.getLocString = function (str) {
        return __WEBPACK_IMPORTED_MODULE_2__editorLocalization__["a" /* editorLocalization */].getString(str);
    };
    PagesEditor.prototype.isActive = function () {
        var selectedObject = this.editor.koSelectedObject();
        if (!selectedObject)
            return;
        return __WEBPACK_IMPORTED_MODULE_1__surveyHelper__["b" /* SurveyHelper */].getObjectType(selectedObject.value) === __WEBPACK_IMPORTED_MODULE_1__surveyHelper__["a" /* ObjType */].Page;
    };
    return PagesEditor;
}());

__WEBPACK_IMPORTED_MODULE_0_knockout__["components"].register("pages-editor", {
    viewModel: {
        createViewModel: function (params, componentInfo) {
            return new PagesEditor(params.editor, componentInfo.element);
        }
    },
    template: { element: "svd-page-selector-template" }
});


/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_knockout__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_survey_knockout__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_survey_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_survey_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__propertyModalEditor__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__editorLocalization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__propertyEditorFactory__ = __webpack_require__(4);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SurveyPropertyCellsEditor; });






var SurveyPropertyCellsEditor = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SurveyPropertyCellsEditor, _super);
    function SurveyPropertyCellsEditor(property) {
        var _this = _super.call(this, property) || this;
        _this.koRows = __WEBPACK_IMPORTED_MODULE_1_knockout__["observableArray"]();
        _this.koColumns = __WEBPACK_IMPORTED_MODULE_1_knockout__["observableArray"]();
        _this.koCanEdit = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"](false);
        return _this;
    }
    SurveyPropertyCellsEditor.prototype.getValueText = function (value) {
        var strName = !value ? "empty" : "notEmpty";
        return __WEBPACK_IMPORTED_MODULE_4__editorLocalization__["a" /* editorLocalization */].getString("pe." + strName);
    };
    SurveyPropertyCellsEditor.prototype.beforeShow = function () {
        _super.prototype.beforeShow.call(this);
        this.setupCells();
    };
    SurveyPropertyCellsEditor.prototype.onBeforeApply = function () {
        if (!this.canEdit)
            return;
        var matrix = new __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["QuestionMatrix"]("");
        matrix.setSurveyImpl(this.object.survey);
        matrix.rows = this.rows;
        matrix.columns = this.columns;
        matrix.cells = this.object.cells;
        var rows = this.koRows();
        for (var i = 0; i < rows.length; i++) {
            var row = rows[i];
            var cells = row.koCells();
            for (var j = 0; j < matrix.columns.length; j++) {
                if (row.rowIndex < 0) {
                    matrix.setDefaultCellText(j, cells[j].text());
                }
                else {
                    matrix.setCellText(rows[i].rowIndex, j, cells[j].text());
                }
            }
        }
        if (!matrix.cells.isEmpty) {
            this.koValue(matrix.cells);
        }
        else {
            this.koValue(null);
        }
    };
    Object.defineProperty(SurveyPropertyCellsEditor.prototype, "editorType", {
        get: function () {
            return "cells";
        },
        enumerable: true,
        configurable: true
    });
    SurveyPropertyCellsEditor.prototype.onValueChanged = function () {
        if (this.isShowingModal) {
            this.setupCells();
        }
    };
    Object.defineProperty(SurveyPropertyCellsEditor.prototype, "canEdit", {
        get: function () {
            return this.rows.length > 0 && this.columns.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyPropertyCellsEditor.prototype, "rows", {
        get: function () {
            return this.object && this.object.rows ? this.object.rows : [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyPropertyCellsEditor.prototype, "columns", {
        get: function () {
            return this.object && this.object.columns ? this.object.columns : [];
        },
        enumerable: true,
        configurable: true
    });
    SurveyPropertyCellsEditor.prototype.getCellText = function (rowIndex, columnIndex) {
        if (rowIndex < 0)
            return this.object.getDefaultCellText(columnIndex);
        return this.object.getCellText(rowIndex, columnIndex);
    };
    SurveyPropertyCellsEditor.prototype.setupCells = function () {
        this.koRows([]);
        this.koColumns([]);
        this.koCanEdit(this.canEdit);
        if (!this.canEdit)
            return;
        var cols = [];
        for (var i = 0; i < this.columns.length; i++) {
            cols.push(this.columns[i].text);
        }
        var rows = [];
        rows.push(this.createRow(-1, __WEBPACK_IMPORTED_MODULE_4__editorLocalization__["a" /* editorLocalization */].getString("pe.cellsDefaultRow")));
        for (var i = 0; i < this.rows.length; i++) {
            rows.push(this.createRow(i, this.rows[i].text));
        }
        this.koColumns(cols);
        this.koRows(rows);
    };
    SurveyPropertyCellsEditor.prototype.createRow = function (rowIndex, rowText) {
        var row = {
            rowIndex: rowIndex,
            rowText: rowText,
            koCells: __WEBPACK_IMPORTED_MODULE_1_knockout__["observableArray"]()
        };
        var cells = [];
        for (var i = 0; i < this.columns.length; i++) {
            cells.push({ text: __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"](this.getCellText(rowIndex, i)) });
        }
        row.koCells(cells);
        return row;
    };
    return SurveyPropertyCellsEditor;
}(__WEBPACK_IMPORTED_MODULE_3__propertyModalEditor__["a" /* SurveyPropertyModalEditor */]));

__WEBPACK_IMPORTED_MODULE_5__propertyEditorFactory__["a" /* SurveyPropertyEditorFactory */].registerEditor("cells", function (property) {
    return new SurveyPropertyCellsEditor(property);
});


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_knockout__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_survey_knockout__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_survey_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_survey_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__editorLocalization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__propertyEditorFactory__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_utils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__questionEditors_questionEditorDefinition__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__propertyNestedPropertyEditor__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__questionEditors_questionEditor__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__entries__ = __webpack_require__(47);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SurveyPropertyItemValuesEditor; });
/* unused harmony export SurveyPropertyItemValuesEditorItem */










var SurveyPropertyItemValuesEditor = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SurveyPropertyItemValuesEditor, _super);
    function SurveyPropertyItemValuesEditor(property) {
        var _this = _super.call(this, property) || this;
        _this.optionsShowTextView = true;
        _this.koShowTextView = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"](true);
        var self = _this;
        if (property) {
            _this.detailDefinition =
                __WEBPACK_IMPORTED_MODULE_6__questionEditors_questionEditorDefinition__["a" /* SurveyQuestionEditorDefinition */].definition[_this.getItemValueClassName()];
        }
        _this.koItemsText = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"]("");
        _this.koActiveView.subscribe(function (newValue) {
            if (newValue == "form")
                self.updateItems(self.koItemsText());
            else
                self.koItemsText(self.getItemsText());
        });
        _this.changeToTextViewClick = function () {
            self.koActiveView("text");
        };
        _this.changeToFormViewClick = function () {
            self.koActiveView("form");
        };
        _this.modalName =
            "modelEditor" + "itemvalues" + __WEBPACK_IMPORTED_MODULE_9__entries__["SurveyPropertyModalEditor"].idCounter;
        __WEBPACK_IMPORTED_MODULE_9__entries__["SurveyPropertyModalEditor"].idCounter++;
        _this.modalNameTarget = "#" + _this.modalName;
        return _this;
    }
    Object.defineProperty(SurveyPropertyItemValuesEditor.prototype, "editorType", {
        get: function () {
            return "itemvalue[]";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyPropertyItemValuesEditor.prototype, "editorTypeTemplate", {
        get: function () {
            return "itemvalues";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyPropertyItemValuesEditor.prototype, "hasDetailButton", {
        get: function () {
            return !!this.detailDefinition;
        },
        enumerable: true,
        configurable: true
    });
    SurveyPropertyItemValuesEditor.prototype.getItemValueClassName = function () {
        return this.property ? this.editorType + "@" + this.property.name : "";
    };
    SurveyPropertyItemValuesEditor.prototype.getEditorName = function () {
        if (!this.koEditItem() || !this.koEditItem().item)
            return "";
        return __WEBPACK_IMPORTED_MODULE_3__editorLocalization__["a" /* editorLocalization */]
            .getString("pe.itemEdit")["format"](this.koEditItem().item.value);
    };
    SurveyPropertyItemValuesEditor.prototype.beforeShow = function () {
        _super.prototype.beforeShow.call(this);
        var props = this.getDefinedProperties();
        if (!!props && props.length > 0) {
            this.createColumns();
        }
    };
    SurveyPropertyItemValuesEditor.prototype.getProperties = function () {
        var props = this.getDefinedProperties();
        if (!!props && props.length > 0)
            return props;
        return this.getDefaultProperties();
    };
    SurveyPropertyItemValuesEditor.prototype.getDefinedProperties = function () {
        if (this.property && this.object && this.object.getType) {
            var properties = __WEBPACK_IMPORTED_MODULE_6__questionEditors_questionEditorDefinition__["a" /* SurveyQuestionEditorDefinition */].getProperties(this.object.getType() + "@" + this.property.name);
            if (properties && properties.length > 0) {
                return this.getPropertiesByNames(this.property.className, properties);
            }
        }
        return [];
    };
    SurveyPropertyItemValuesEditor.prototype.getDefaultProperties = function () {
        var properties = __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["JsonObject"].metaData.getProperties(this.property.className);
        var res = [];
        for (var i = 0; i < properties.length; i++) {
            if (!properties[i].visible)
                continue;
            res.push(properties[i]);
        }
        return res;
    };
    SurveyPropertyItemValuesEditor.prototype.createEditorOptions = function () {
        var options = _super.prototype.createEditorOptions.call(this);
        options.showTextView = true;
        options.itemsEntryType =
            (this.options["options"] &&
                this.options["options"].itemValuesEditorEntryType) ||
                "form";
        return options;
    };
    SurveyPropertyItemValuesEditor.prototype.onSetEditorOptions = function (editorOptions) {
        _super.prototype.onSetEditorOptions.call(this, editorOptions);
        this.optionsShowTextView = editorOptions.showTextView;
        this.updateShowTextViewVisibility();
        this.koActiveView(editorOptions.itemsEntryType || "form");
    };
    SurveyPropertyItemValuesEditor.prototype.createNewEditorItem = function () {
        var _this = this;
        var nextValue = null;
        var values = this.koItems().map(function (item) {
            return item.item.itemValue;
        });
        var itemText = __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["surveyLocalization"].getString("choices_Item");
        nextValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_utils__["a" /* getNextValue */])(itemText, values);
        var itemValue = this.createEditorItemCore(nextValue);
        if (this.options) {
            this.options.onItemValueAddedCallback(this.editablePropertyName, itemValue, values);
        }
        return new SurveyPropertyItemValuesEditorItem(itemValue, function () { return _this.columns; }, this.options, this.getItemValueClassName());
    };
    SurveyPropertyItemValuesEditor.prototype.createEditorItem = function (item) {
        var _this = this;
        var itemValue = this.createEditorItemCore(null);
        itemValue.setData(item);
        return new SurveyPropertyItemValuesEditorItem(itemValue, function () { return _this.columns; }, this.options, this.getItemValueClassName());
    };
    SurveyPropertyItemValuesEditor.prototype.createEditorItemCore = function (item) {
        var itemValue = __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["JsonObject"].metaData.createClass(this.property.className);
        itemValue.setData(item);
        if (this.object) {
            itemValue["survey"] = this.object.survey;
            itemValue["object"] = this.object;
        }
        itemValue.locOwner = this;
        return itemValue;
    };
    SurveyPropertyItemValuesEditor.prototype.createItemFromEditorItem = function (editorItem) {
        var item = editorItem.item;
        var alwaySaveTextInPropertyEditors = this.options && this.options.alwaySaveTextInPropertyEditors;
        if (!alwaySaveTextInPropertyEditors &&
            item.text == item.value &&
            !this.isTextLocalized(item)) {
            item.text = null;
        }
        var itemValue = __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["JsonObject"].metaData.createClass(item.getType());
        itemValue.setData(item);
        delete itemValue["survey"];
        delete itemValue["object"];
        return itemValue;
    };
    SurveyPropertyItemValuesEditor.prototype.isTextLocalized = function (item) {
        return Object.keys(item.locText.values).length > 1;
    };
    SurveyPropertyItemValuesEditor.prototype.onValueChanged = function () {
        _super.prototype.onValueChanged.call(this);
        if (this.isShowingModal) {
            if (this.koActiveView() !== "form") {
                this.koItemsText(this.getItemsText());
            }
        }
        this.updateShowTextViewVisibility();
    };
    SurveyPropertyItemValuesEditor.prototype.onBeforeApply = function () {
        if (this.koActiveView() !== "form") {
            this.updateItems(this.koItemsText());
        }
        _super.prototype.onBeforeApply.call(this);
    };
    SurveyPropertyItemValuesEditor.prototype.onListDetailViewChanged = function () {
        _super.prototype.onListDetailViewChanged.call(this);
        this.updateShowTextViewVisibility();
    };
    SurveyPropertyItemValuesEditor.prototype.updateItems = function (text) {
        var items = [];
        if (text) {
            var properties = this.getProperties();
            var texts = text.split("\n");
            for (var i = 0; i < texts.length; i++) {
                if (!texts[i])
                    continue;
                var elements = texts[i].split(__WEBPACK_IMPORTED_MODULE_2_survey_knockout__["ItemValue"].Separator);
                var valueItem = __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["JsonObject"].metaData.createClass(this.property.className);
                properties.forEach(function (p, i) {
                    valueItem[p.name] = elements[i];
                });
                items.push(valueItem);
            }
        }
        this.koItems(this.getItemsFromValue(items));
    };
    SurveyPropertyItemValuesEditor.prototype.getItemsText = function () {
        return this.koItems()
            .filter(function (item) { return !item.cells[0].hasError; })
            .map(function (item) {
            return item.cells
                .map(function (cell) { return cell.value || ""; })
                .join(__WEBPACK_IMPORTED_MODULE_2_survey_knockout__["ItemValue"].Separator)
                .replace(/\|$/, "");
        })
            .join("\n");
    };
    SurveyPropertyItemValuesEditor.prototype.updateShowTextViewVisibility = function () {
        if (!this.koShowTextView)
            return;
        if (!this.optionsShowTextView || this.columns.length == 0) {
            this.koShowTextView(false);
            return;
        }
        this.koShowTextView(!this.hasVisibleIfOrEnableIf() && !this.hasMultipleLanguage());
    };
    SurveyPropertyItemValuesEditor.prototype.hasMultipleLanguage = function () {
        var items = this.koItems();
        for (var i = 0; i < items.length; i++) {
            //TODO replace with locText.hasNonDefaultText()
            var json = items[i].item.locText.getJson();
            if (!!json && typeof json !== "string") {
                var keys = Object.keys(json);
                if (keys.length > 1)
                    return true;
                return keys[0] != "default";
            }
        }
        return false;
    };
    SurveyPropertyItemValuesEditor.prototype.hasVisibleIfOrEnableIf = function () {
        var items = this.koItems();
        for (var i = 0; i < items.length; i++) {
            if (!!items[i].item.visibleIf || items[i].item.enableIf)
                return true;
        }
        return false;
    };
    return SurveyPropertyItemValuesEditor;
}(__WEBPACK_IMPORTED_MODULE_7__propertyNestedPropertyEditor__["a" /* SurveyNestedPropertyEditor */]));

var SurveyPropertyItemValuesEditorItem = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SurveyPropertyItemValuesEditorItem, _super);
    function SurveyPropertyItemValuesEditorItem(item, getColumns, options, className) {
        if (className === void 0) { className = ""; }
        var _this = _super.call(this, item, getColumns, options) || this;
        _this.item = item;
        _this.className = className;
        return _this;
    }
    SurveyPropertyItemValuesEditorItem.prototype.createSurveyQuestionEditor = function () {
        return new __WEBPACK_IMPORTED_MODULE_8__questionEditors_questionEditor__["b" /* SurveyQuestionEditor */](this.item, null, this.className, this.options);
    };
    return SurveyPropertyItemValuesEditorItem;
}(__WEBPACK_IMPORTED_MODULE_7__propertyNestedPropertyEditor__["b" /* SurveyNestedPropertyEditorItem */]));

__WEBPACK_IMPORTED_MODULE_4__propertyEditorFactory__["a" /* SurveyPropertyEditorFactory */].registerEditor("itemvalue[]", function (property) {
    return new SurveyPropertyItemValuesEditor(property);
}, "itemvalue");


/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_survey_knockout__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_survey_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_survey_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__questionEditors_questionEditor__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__editorLocalization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__propertyNestedPropertyEditor__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__propertyEditorFactory__ = __webpack_require__(4);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SurveyPropertyDropdownColumnsEditor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SurveyPropertyMatrixDropdownColumnsItem; });






var SurveyPropertyDropdownColumnsEditor = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SurveyPropertyDropdownColumnsEditor, _super);
    function SurveyPropertyDropdownColumnsEditor(property) {
        return _super.call(this, property) || this;
    }
    Object.defineProperty(SurveyPropertyDropdownColumnsEditor.prototype, "editorType", {
        get: function () {
            return "matrixdropdowncolumns";
        },
        enumerable: true,
        configurable: true
    });
    SurveyPropertyDropdownColumnsEditor.prototype.getEditorName = function () {
        if (!this.koEditItem())
            return "";
        return __WEBPACK_IMPORTED_MODULE_3__editorLocalization__["a" /* editorLocalization */]
            .getString("pe.columnEdit")["format"](this.koEditItem().column.name);
    };
    SurveyPropertyDropdownColumnsEditor.prototype.createNewEditorItem = function () {
        var _this = this;
        var newColumn = this.createEditorItemCore(null);
        var columns = [];
        for (var i = 0; i < this.koItems().length; i++) {
            columns.push(this.koItems()[i].column);
        }
        columns.push(newColumn);
        if (this.options) {
            this.options.onMatrixDropdownColumnAddedCallback(this.object, newColumn, columns);
        }
        return new SurveyPropertyMatrixDropdownColumnsItem(newColumn, function () { return _this.columns; }, this.options);
    };
    SurveyPropertyDropdownColumnsEditor.prototype.createEditorItem = function (item) {
        var _this = this;
        var newColumn = this.createEditorItemCore(item);
        return new SurveyPropertyMatrixDropdownColumnsItem(newColumn, function () { return _this.columns; }, this.options);
    };
    SurveyPropertyDropdownColumnsEditor.prototype.createItemFromEditorItem = function (editorItem) {
        var newColumn = new __WEBPACK_IMPORTED_MODULE_1_survey_knockout__["MatrixDropdownColumn"]("");
        var json = new __WEBPACK_IMPORTED_MODULE_1_survey_knockout__["JsonObject"]().toJsonObject(editorItem.column);
        new __WEBPACK_IMPORTED_MODULE_1_survey_knockout__["JsonObject"]().toObject(json, newColumn);
        return newColumn;
    };
    SurveyPropertyDropdownColumnsEditor.prototype.createEditorItemCore = function (item) {
        var newColumn = new __WEBPACK_IMPORTED_MODULE_1_survey_knockout__["MatrixDropdownColumn"]("");
        newColumn["object"] = this.object;
        newColumn.colOwner = this.object;
        if (item) {
            var json = new __WEBPACK_IMPORTED_MODULE_1_survey_knockout__["JsonObject"]().toJsonObject(item);
            new __WEBPACK_IMPORTED_MODULE_1_survey_knockout__["JsonObject"]().toObject(json, newColumn);
        }
        return newColumn;
    };
    SurveyPropertyDropdownColumnsEditor.prototype.getProperties = function () {
        var names = this.getPropertiesNames("matrixdropdowncolumn", [
            "isRequired",
            "cellType",
            "name",
            "title"
        ]);
        return this.getPropertiesByNames("matrixdropdowncolumn", names);
    };
    return SurveyPropertyDropdownColumnsEditor;
}(__WEBPACK_IMPORTED_MODULE_4__propertyNestedPropertyEditor__["a" /* SurveyNestedPropertyEditor */]));

var SurveyPropertyMatrixDropdownColumnsItem = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SurveyPropertyMatrixDropdownColumnsItem, _super);
    function SurveyPropertyMatrixDropdownColumnsItem(column, getColumns, options) {
        if (options === void 0) { options = null; }
        var _this = _super.call(this, column, getColumns, options) || this;
        _this.column = column;
        var self = _this;
        column.registerFunctionOnPropertyValueChanged("cellType", function () {
            self.resetSurveyQuestionEditor();
        }, "colEdit");
        return _this;
    }
    SurveyPropertyMatrixDropdownColumnsItem.prototype.createSurveyQuestionEditor = function () {
        return new __WEBPACK_IMPORTED_MODULE_2__questionEditors_questionEditor__["b" /* SurveyQuestionEditor */](this.column, null, "matrixdropdowncolumn@" + this.column.cellType, this.options);
    };
    return SurveyPropertyMatrixDropdownColumnsItem;
}(__WEBPACK_IMPORTED_MODULE_4__propertyNestedPropertyEditor__["b" /* SurveyNestedPropertyEditorItem */]));

__WEBPACK_IMPORTED_MODULE_5__propertyEditorFactory__["a" /* SurveyPropertyEditorFactory */].registerEditor("matrixdropdowncolumns", function (property) {
    return new SurveyPropertyDropdownColumnsEditor(property);
});


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_knockout__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_survey_knockout__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_survey_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_survey_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__propertyModalEditor__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__editorLocalization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__propertyEditorFactory__ = __webpack_require__(4);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SurveyPropertyMultipleValuesEditor; });






var SurveyPropertyMultipleValuesEditor = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SurveyPropertyMultipleValuesEditor, _super);
    function SurveyPropertyMultipleValuesEditor(property) {
        var _this = _super.call(this, property) || this;
        _this.items = [];
        _this.koEditingValue = __WEBPACK_IMPORTED_MODULE_1_knockout__["observableArray"]();
        _this.koItems = __WEBPACK_IMPORTED_MODULE_1_knockout__["observableArray"]();
        _this.setItems();
        return _this;
    }
    SurveyPropertyMultipleValuesEditor.prototype.getValueText = function (value) {
        if (!value)
            return __WEBPACK_IMPORTED_MODULE_4__editorLocalization__["a" /* editorLocalization */].getString("pe.empty");
        if (!Array.isArray(value))
            value = [value];
        var str = "[";
        for (var i = 0; i < value.length; i++) {
            if (i > 0)
                str += ", ";
            str += this.getTextByItemValue(value[i]);
        }
        str += "]";
        return str;
    };
    SurveyPropertyMultipleValuesEditor.prototype.setObject = function (value) {
        _super.prototype.setObject.call(this, value);
        this.setItems();
        this.setEditingValue();
    };
    SurveyPropertyMultipleValuesEditor.prototype.updateValue = function () {
        _super.prototype.updateValue.call(this);
        this.setEditingValue();
    };
    SurveyPropertyMultipleValuesEditor.prototype.onBeforeApply = function () {
        this.koValue([].concat(this.koEditingValue()));
    };
    Object.defineProperty(SurveyPropertyMultipleValuesEditor.prototype, "editorType", {
        get: function () {
            return "multiplevalues";
        },
        enumerable: true,
        configurable: true
    });
    SurveyPropertyMultipleValuesEditor.prototype.getBackgroundCls = function (value) {
        return this.koEditingValue().indexOf("" + value) === -1 ? "svd-light-background-color" : "svd-main-background-color";
    };
    SurveyPropertyMultipleValuesEditor.prototype.setItems = function () {
        __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["ItemValue"].setData(this.items, this.property.choices);
        this.koItems(this.items);
    };
    SurveyPropertyMultipleValuesEditor.prototype.getTextByItemValue = function (val) {
        for (var i = 0; i < this.items.length; i++) {
            if (this.items[i].value == val)
                return this.items[i].text;
        }
        return val;
    };
    SurveyPropertyMultipleValuesEditor.prototype.setEditingValue = function () {
        var val = this.koValue();
        if (val == null || val == undefined)
            val = [];
        if (!Array.isArray(val))
            val = [val];
        this.koEditingValue(val);
    };
    return SurveyPropertyMultipleValuesEditor;
}(__WEBPACK_IMPORTED_MODULE_3__propertyModalEditor__["a" /* SurveyPropertyModalEditor */]));

__WEBPACK_IMPORTED_MODULE_5__propertyEditorFactory__["a" /* SurveyPropertyEditorFactory */].registerEditor("multiplevalues", function (property) {
    return new SurveyPropertyMultipleValuesEditor(property);
});


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_knockout__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_survey_knockout__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_survey_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_survey_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__propertyModalEditor__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__editorLocalization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__propertyEditorFactory__ = __webpack_require__(4);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SurveyPropertyResultfullEditor; });
/* unused harmony export SurveyPropertyResultfullEditorItem */






var SurveyPropertyResultfullEditor = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SurveyPropertyResultfullEditor, _super);
    function SurveyPropertyResultfullEditor(property) {
        var _this = _super.call(this, property) || this;
        _this.items = [];
        _this.koItems = __WEBPACK_IMPORTED_MODULE_1_knockout__["observableArray"]();
        _this.createSurvey();
        return _this;
    }
    Object.defineProperty(SurveyPropertyResultfullEditor.prototype, "editorType", {
        get: function () {
            return "restfull";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyPropertyResultfullEditor.prototype, "restfullValue", {
        get: function () {
            if (this.editingObject)
                return this.editingObject[this.property.name];
            if (this.editingValue)
                return this.editingValue;
            return null;
        },
        enumerable: true,
        configurable: true
    });
    SurveyPropertyResultfullEditor.prototype.getValueText = function (value) {
        if (!value || !value.url)
            return __WEBPACK_IMPORTED_MODULE_4__editorLocalization__["a" /* editorLocalization */].getString("pe.empty");
        var str = value.url;
        if (str.length > 20) {
            str = str.substr(0, 20) + "...";
        }
        return str;
    };
    SurveyPropertyResultfullEditor.prototype.addItem = function (propName, val) {
        var self = this;
        this.items.push(new SurveyPropertyResultfullEditorItem(propName, val ? val[propName] : "", function (item) {
            self.onItemValueChanged(item);
        }));
    };
    SurveyPropertyResultfullEditor.prototype.onItemValueChanged = function (item) {
        this.question.choicesByUrl[item.name] = item.koValue();
        this.run();
    };
    SurveyPropertyResultfullEditor.prototype.onValueChanged = function () {
        var val = this.restfullValue;
        this.items = [];
        this.addItem("url", val);
        this.addItem("path", val);
        this.addItem("valueName", val);
        this.addItem("titleName", val);
        if (val && val["getCustomPropertiesNames"]) {
            var customProperties = val["getCustomPropertiesNames"]();
            for (var i = 0; i < customProperties.length; i++) {
                var propName = customProperties[i];
                if (propName === "visibleIfName")
                    continue; //TODO remove later
                this.addItem(propName, val);
            }
        }
        this.koItems(this.items);
    };
    SurveyPropertyResultfullEditor.prototype.onBeforeApply = function () {
        var val = new __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["ChoicesRestfull"]();
        val["owner"] = this.editingObject;
        for (var i = 0; i < this.items.length; i++) {
            var item = this.items[i];
            val[item.name] = item.koValue();
        }
        this.setValueCore(val);
    };
    SurveyPropertyResultfullEditor.prototype.run = function () {
        this.question.choicesByUrl.run();
    };
    SurveyPropertyResultfullEditor.prototype.createSurvey = function () {
        this.survey = new __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["Survey"]();
        this.survey.showNavigationButtons = false;
        this.survey.showQuestionNumbers = "off";
        var page = this.survey.addNewPage("page1");
        this.question = page.addNewQuestion("dropdown", "q1");
        this.question.title = __WEBPACK_IMPORTED_MODULE_4__editorLocalization__["a" /* editorLocalization */].getString("pe.testService");
        this.question.choices = [];
    };
    return SurveyPropertyResultfullEditor;
}(__WEBPACK_IMPORTED_MODULE_3__propertyModalEditor__["a" /* SurveyPropertyModalEditor */]));

var SurveyPropertyResultfullEditorItem = /** @class */ (function () {
    function SurveyPropertyResultfullEditorItem(name, val, onValueChanged) {
        this.name = name;
        this.onValueChanged = onValueChanged;
        this.isSetttingValue = false;
        this.koValue = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"](val ? val : "");
        var self = this;
        this.koValue.subscribe(function (newValue) {
            if (!self.isSetttingValue) {
                self.onValueChanged(self);
            }
        });
    }
    SurveyPropertyResultfullEditorItem.prototype.setValue = function (val) {
        this.isSetttingValue = true;
        this.koValue(val);
        this.isSetttingValue = false;
    };
    return SurveyPropertyResultfullEditorItem;
}());

__WEBPACK_IMPORTED_MODULE_5__propertyEditorFactory__["a" /* SurveyPropertyEditorFactory */].registerEditor("restfull", function (property) {
    return new SurveyPropertyResultfullEditor(property);
});


/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_survey_knockout__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_survey_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_survey_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__surveyHelper__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__editorLocalization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__questionEditors_questionEditor__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__propertyNestedPropertyEditor__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__propertyEditorFactory__ = __webpack_require__(4);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SurveyPropertyTextItemsEditor; });
/* unused harmony export SurveyPropertyTextItemsItem */







var SurveyPropertyTextItemsEditor = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SurveyPropertyTextItemsEditor, _super);
    function SurveyPropertyTextItemsEditor(property) {
        return _super.call(this, property) || this;
    }
    Object.defineProperty(SurveyPropertyTextItemsEditor.prototype, "editorType", {
        get: function () {
            return "textitems";
        },
        enumerable: true,
        configurable: true
    });
    SurveyPropertyTextItemsEditor.prototype.getEditorName = function () {
        if (!this.koEditItem())
            return "";
        return __WEBPACK_IMPORTED_MODULE_3__editorLocalization__["a" /* editorLocalization */]
            .getString("pe.columnEdit")["format"](this.koEditItem().koName());
    };
    SurveyPropertyTextItemsEditor.prototype.createNewEditorItem = function () {
        var _this = this;
        var newItem = new __WEBPACK_IMPORTED_MODULE_1_survey_knockout__["MultipleTextItem"](this.getNewName());
        newItem["object"] = this.object;
        //newColumn.colOwner = TODO set colOwner.
        return new SurveyPropertyTextItemsItem(newItem, function () { return _this.columns; }, this.options);
    };
    SurveyPropertyTextItemsEditor.prototype.createEditorItem = function (item) {
        var _this = this;
        return new SurveyPropertyTextItemsItem(item, function () { return _this.columns; }, this.options);
    };
    SurveyPropertyTextItemsEditor.prototype.createItemFromEditorItem = function (editorItem) {
        var newItem = new __WEBPACK_IMPORTED_MODULE_1_survey_knockout__["MultipleTextItem"]();
        var json = new __WEBPACK_IMPORTED_MODULE_1_survey_knockout__["JsonObject"]().toJsonObject(editorItem.item);
        new __WEBPACK_IMPORTED_MODULE_1_survey_knockout__["JsonObject"]().toObject(json, newItem);
        return newItem;
    };
    SurveyPropertyTextItemsEditor.prototype.getProperties = function () {
        var names = this.getPropertiesNames("multipletext@items", [
            "isRequired",
            "name",
            "title"
        ]);
        return this.getPropertiesByNames("multipletextitem", names);
    };
    SurveyPropertyTextItemsEditor.prototype.getNewName = function () {
        var objs = [];
        var items = this.koItems();
        for (var i = 0; i < items.length; i++) {
            var item = items[i].item;
            if (!!item) {
                objs.push({ name: item.name });
            }
        }
        return __WEBPACK_IMPORTED_MODULE_2__surveyHelper__["b" /* SurveyHelper */].getNewName(objs, "text");
    };
    return SurveyPropertyTextItemsEditor;
}(__WEBPACK_IMPORTED_MODULE_5__propertyNestedPropertyEditor__["a" /* SurveyNestedPropertyEditor */]));

var SurveyPropertyTextItemsItem = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SurveyPropertyTextItemsItem, _super);
    function SurveyPropertyTextItemsItem(item, getColumns, options) {
        var _this = _super.call(this, item, getColumns, options) || this;
        _this.item = item;
        return _this;
    }
    SurveyPropertyTextItemsItem.prototype.createSurveyQuestionEditor = function () {
        return new __WEBPACK_IMPORTED_MODULE_4__questionEditors_questionEditor__["b" /* SurveyQuestionEditor */](this.item, null, "multipletextitem", this.options);
    };
    return SurveyPropertyTextItemsItem;
}(__WEBPACK_IMPORTED_MODULE_5__propertyNestedPropertyEditor__["b" /* SurveyNestedPropertyEditorItem */]));

__WEBPACK_IMPORTED_MODULE_6__propertyEditorFactory__["a" /* SurveyPropertyEditorFactory */].registerEditor("textitems", function (property) {
    return new SurveyPropertyTextItemsEditor(property);
});


/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_knockout__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_survey_knockout__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_survey_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_survey_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__propertyItemsEditor__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__editorLocalization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__propertyEditorFactory__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__propertyConditionEditor__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__propertyDefaultValueEditor__ = __webpack_require__(27);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SurveyPropertyTriggersEditor; });
/* unused harmony export SurveyPropertyTrigger */
/* unused harmony export SurveyPropertyVisibleTrigger */
/* unused harmony export SurveyPropertySetValueTrigger */
/* unused harmony export SurveyPropertyCopyValueTrigger */
/* unused harmony export SurveyPropertyRunExpressionTrigger */
/* unused harmony export SurveyPropertyTriggerObjects */








var SurveyPropertyTriggersEditor = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SurveyPropertyTriggersEditor, _super);
    function SurveyPropertyTriggersEditor(property) {
        var _this = _super.call(this, property) || this;
        _this.availableTriggers = [];
        _this.triggerClasses = [];
        var self = _this;
        _this.onDeleteClick = function () {
            self.koItems.remove(self.koSelected());
        };
        _this.onAddClick = function (item) {
            self.addItem(item.value);
        };
        _this.koSelected = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"](null);
        _this.koSelected.subscribe(function (newValue) {
            if (!!newValue) {
                newValue.beforeShow();
            }
        });
        _this.koPages = __WEBPACK_IMPORTED_MODULE_1_knockout__["observableArray"]();
        _this.koQuestions = __WEBPACK_IMPORTED_MODULE_1_knockout__["observableArray"]();
        _this.koQuestionNames = __WEBPACK_IMPORTED_MODULE_1_knockout__["observableArray"]();
        _this.koElements = __WEBPACK_IMPORTED_MODULE_1_knockout__["observableArray"]();
        _this.triggerClasses = __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["JsonObject"].metaData.getChildrenClasses("surveytrigger", true);
        _this.availableTriggers = _this.getAvailableTriggers();
        _this.koTriggers = __WEBPACK_IMPORTED_MODULE_1_knockout__["observableArray"](_this.getLocalizedTriggers());
        return _this;
    }
    Object.defineProperty(SurveyPropertyTriggersEditor.prototype, "editorType", {
        get: function () {
            return "triggers";
        },
        enumerable: true,
        configurable: true
    });
    SurveyPropertyTriggersEditor.prototype.onValueChanged = function () {
        if (this.editingObject) {
            var allQuestions = this.editingObject.getAllQuestions();
            this.koPages(this.getElements(this.editingObject.pages));
            this.koQuestions(this.getElements(allQuestions));
            this.koQuestionNames(this.getQuestionNames(allQuestions));
            this.koElements(this.getElements(this.getAllElements()));
        }
        _super.prototype.onValueChanged.call(this);
        if (this.koSelected) {
            this.koSelected(this.koItems().length > 0 ? this.koItems()[0] : null);
        }
    };
    //TODO this code should be in the library
    SurveyPropertyTriggersEditor.prototype.getAllElements = function () {
        var res = [];
        var pages = this.editingObject.pages;
        for (var i = 0; i < pages.length; i++) {
            this.addElemenetsIntoList(pages[i], res);
        }
        return res;
    };
    SurveyPropertyTriggersEditor.prototype.addElemenetsIntoList = function (element, list) {
        var elements = element.getElementsInDesign(false);
        if (!elements)
            return;
        for (var i = 0; i < elements.length; i++) {
            list.push(elements[i]);
            this.addElemenetsIntoList(elements[i], list);
        }
    };
    SurveyPropertyTriggersEditor.prototype.addItem = function (triggerType) {
        var trigger = __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["JsonObject"].metaData.createClass(triggerType);
        var triggerItem = this.createPropertyTrigger(trigger);
        this.koItems.push(triggerItem);
        this.koSelected(triggerItem);
    };
    SurveyPropertyTriggersEditor.prototype.createEditorItem = function (item) {
        var jsonObj = new __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["JsonObject"]();
        var trigger = __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["JsonObject"].metaData.createClass(item.getType());
        jsonObj.toObject(item, trigger);
        return this.createPropertyTrigger(trigger);
    };
    SurveyPropertyTriggersEditor.prototype.createItemFromEditorItem = function (editorItem) {
        var editorTrigger = editorItem;
        return editorTrigger.createTrigger();
    };
    SurveyPropertyTriggersEditor.prototype.getLocalizedTriggers = function () {
        var res = [];
        for (var i = 0; i < this.availableTriggers.length; i++) {
            var name = this.availableTriggers[i];
            res.push({ value: name, text: __WEBPACK_IMPORTED_MODULE_4__editorLocalization__["a" /* editorLocalization */].getTriggerName(name) });
        }
        return res;
    };
    SurveyPropertyTriggersEditor.prototype.getAvailableTriggers = function () {
        var result = [];
        for (var i = 0; i < this.triggerClasses.length; i++) {
            result.push(this.triggerClasses[i].name);
        }
        return result;
    };
    SurveyPropertyTriggersEditor.prototype.getElements = function (items) {
        var _this = this;
        var elements = [];
        var options = this.options;
        items.forEach(function (item) {
            var element = {};
            element.name = item.name;
            element.text = item.name;
            if (_this.options &&
                _this.options.showTitlesInExpressions &&
                item["title"]) {
                element.text = item.title;
            }
            if (item.isPage) {
                element.page = item;
            }
            else {
                element.question = item;
            }
            elements.push(element);
        });
        options &&
            options.onConditionQuestionsGetListCallback(this.editablePropertyName, this, options, elements);
        return elements;
    };
    SurveyPropertyTriggersEditor.prototype.getQuestionNames = function (questions) {
        var items = [];
        for (var i = 0; i < questions.length; i++) {
            questions[i].addConditionNames(items);
        }
        var names = [];
        for (var i = 0; i < items.length; i++) {
            if (items[i].indexOf("[") < 0) {
                names.push(items[i]);
            }
        }
        return names;
    };
    SurveyPropertyTriggersEditor.prototype.createPropertyTrigger = function (trigger) {
        var triggerItem = null;
        trigger["survey"] = this.object;
        if (trigger.getType() == "visibletrigger") {
            triggerItem = new SurveyPropertyVisibleTrigger(trigger, this.koPages, this.koElements, this.options);
        }
        if (trigger.getType() == "setvaluetrigger") {
            triggerItem = new SurveyPropertySetValueTrigger(trigger, this.koQuestions, this.editingObject, this.options);
        }
        if (trigger.getType() == "copyvaluetrigger") {
            triggerItem = new SurveyPropertyCopyValueTrigger(trigger, this.koQuestions, this.options);
        }
        if (trigger.getType() == "runexpressiontrigger") {
            triggerItem = new SurveyPropertyRunExpressionTrigger(trigger, this.koQuestions, this.options);
        }
        if (!triggerItem) {
            triggerItem = new SurveyPropertyTrigger(trigger, this.options);
        }
        return triggerItem;
    };
    return SurveyPropertyTriggersEditor;
}(__WEBPACK_IMPORTED_MODULE_3__propertyItemsEditor__["a" /* SurveyPropertyItemsEditor */]));

var SurveyPropertyTrigger = /** @class */ (function () {
    function SurveyPropertyTrigger(trigger, options) {
        var _this = this;
        this.trigger = trigger;
        this.availableOperators = [];
        this.conditionEditor = null;
        this.availableOperators = __WEBPACK_IMPORTED_MODULE_5__propertyEditorFactory__["a" /* SurveyPropertyEditorFactory */].getOperators();
        this.triggerType = trigger.getType();
        this.koType = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"](this.triggerType);
        this.koName = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"](trigger.name);
        this.koOperator = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"](trigger.operator);
        this.koValue = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"](trigger.value);
        var expressionProperty = __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["JsonObject"].metaData.findProperty("trigger", "expression");
        if (expressionProperty) {
            this.conditionEditor = new __WEBPACK_IMPORTED_MODULE_6__propertyConditionEditor__["a" /* SurveyPropertyConditionEditor */](expressionProperty);
            this.conditionEditor.options = options;
            this.conditionEditor.showHelpText = false;
            if (!this.trigger.expression) {
                this.trigger.expression = this.trigger.buildExpression();
            }
            this.conditionEditor.object = this.trigger;
        }
        var self = this;
        this.koRequireValue = __WEBPACK_IMPORTED_MODULE_1_knockout__["computed"](function () {
            return self.koOperator() != "empty" && self.koOperator() != "notempty";
        });
        this.koIsValid = __WEBPACK_IMPORTED_MODULE_1_knockout__["computed"](function () {
            if (!!_this.conditionEditor) {
                var text = self.conditionEditor.koTextValue();
                return !!text;
            }
            if (self.koName() && (!self.koRequireValue() || self.koValue()))
                return true;
            return false;
        });
        this.koText = __WEBPACK_IMPORTED_MODULE_1_knockout__["computed"](function () {
            self.koName();
            self.koOperator();
            self.koValue();
            return self.getText();
        });
    }
    SurveyPropertyTrigger.prototype.beforeShow = function () {
        if (!!this.conditionEditor) {
            this.conditionEditor.beforeShow();
        }
    };
    SurveyPropertyTrigger.prototype.createTrigger = function () {
        var trigger = (__WEBPACK_IMPORTED_MODULE_2_survey_knockout__["JsonObject"].metaData.createClass(this.triggerType));
        if (!!this.conditionEditor) {
            trigger["expression"] = this.conditionEditor.koTextValue();
        }
        else {
            //TODO remove else code
            trigger.name = this.koName();
            trigger.operator = this.koOperator();
            trigger.value = this.koValue();
        }
        return trigger;
    };
    SurveyPropertyTrigger.prototype.getText = function () {
        if (!this.koIsValid())
            return __WEBPACK_IMPORTED_MODULE_4__editorLocalization__["a" /* editorLocalization */].getString("pe.triggerNotSet");
        if (!!this.conditionEditor) {
            var res = this.conditionEditor.koTextValue();
            if (!res)
                return "";
            return __WEBPACK_IMPORTED_MODULE_4__editorLocalization__["a" /* editorLocalization */].getString("pe.triggerRunIf") + ": " + res;
        }
        return (__WEBPACK_IMPORTED_MODULE_4__editorLocalization__["a" /* editorLocalization */].getString("pe.triggerRunIf") +
            " '" +
            this.koName() +
            "' " +
            this.getOperatorText() +
            this.getValueText());
    };
    SurveyPropertyTrigger.prototype.getOperatorText = function () {
        var op = this.koOperator();
        for (var i = 0; i < this.availableOperators.length; i++) {
            if (this.availableOperators[i].name == op)
                return this.availableOperators[i].text;
        }
        return op;
    };
    SurveyPropertyTrigger.prototype.getValueText = function () {
        if (!this.koRequireValue())
            return "";
        return " " + this.koValue();
    };
    return SurveyPropertyTrigger;
}());

var SurveyPropertyVisibleTrigger = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SurveyPropertyVisibleTrigger, _super);
    function SurveyPropertyVisibleTrigger(trigger, koPages, koQuestions, options) {
        var _this = _super.call(this, trigger, options) || this;
        _this.trigger = trigger;
        _this.pages = new SurveyPropertyTriggerObjects(__WEBPACK_IMPORTED_MODULE_4__editorLocalization__["a" /* editorLocalization */].getString("pe.triggerMakePagesVisible"), koPages(), trigger.pages);
        _this.questions = new SurveyPropertyTriggerObjects(__WEBPACK_IMPORTED_MODULE_4__editorLocalization__["a" /* editorLocalization */].getString("pe.triggerMakeQuestionsVisible"), koQuestions(), trigger.questions);
        return _this;
    }
    SurveyPropertyVisibleTrigger.prototype.createTrigger = function () {
        var trigger = _super.prototype.createTrigger.call(this);
        trigger.pages = this.pages.koChoosen().map(function (o) { return o.name; });
        trigger.questions = this.questions.koChoosen().map(function (o) { return o.name; });
        return trigger;
    };
    return SurveyPropertyVisibleTrigger;
}(SurveyPropertyTrigger));

var SurveyPropertySetValueTrigger = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SurveyPropertySetValueTrigger, _super);
    function SurveyPropertySetValueTrigger(trigger, koQuestions, triggerSurvey, options) {
        var _this = _super.call(this, trigger, options) || this;
        _this.trigger = trigger;
        _this.triggerSurvey = triggerSurvey;
        _this.koQuestions = koQuestions;
        _this.koSurvey = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"](SurveyPropertySetValueTrigger.emptySurvey);
        _this.koHasSurvey = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"](false);
        _this.kosetToName = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"](trigger.setToName);
        _this.kosetValue = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"](trigger.setValue);
        _this.koisVariable = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"](trigger.isVariable);
        var self = _this;
        _this.kosetToName.subscribe(function (newValue) {
            if (!self.koisVariable()) {
                self.kosetValue(null);
            }
            self.buildSurvey();
        });
        _this.koisVariable.subscribe(function (newValue) {
            self.kosetToName("");
            self.kosetValue(null);
            self.buildSurvey();
        });
        _this.buildSurvey();
        return _this;
    }
    SurveyPropertySetValueTrigger.prototype.createTrigger = function () {
        var trigger = _super.prototype.createTrigger.call(this);
        trigger.setToName = this.kosetToName();
        trigger.setValue = this.kosetValue();
        trigger.isVariable = this.koisVariable();
        return trigger;
    };
    Object.defineProperty(SurveyPropertySetValueTrigger.prototype, "setToNameOptions", {
        get: function () {
            return __WEBPACK_IMPORTED_MODULE_4__editorLocalization__["a" /* editorLocalization */].getString("pe.conditionSelectQuestion");
        },
        enumerable: true,
        configurable: true
    });
    SurveyPropertySetValueTrigger.prototype.buildSurvey = function () {
        var question = !this.koisVariable() && !!this.kosetToName()
            ? this.triggerSurvey.getQuestionByName(this.kosetToName())
            : null;
        if (!question) {
            this.survey = null;
            this.koHasSurvey(false);
            this.koSurvey(SurveyPropertySetValueTrigger.emptySurvey);
            return;
        }
        var qJson = __WEBPACK_IMPORTED_MODULE_7__propertyDefaultValueEditor__["a" /* SurveyPropertyDefaultValueEditor */].createJsonFromQuestion(question);
        qJson.titleLocation = "top";
        qJson.title = __WEBPACK_IMPORTED_MODULE_4__editorLocalization__["a" /* editorLocalization */].getString("pe.triggerSetValue");
        this.survey = __WEBPACK_IMPORTED_MODULE_7__propertyDefaultValueEditor__["a" /* SurveyPropertyDefaultValueEditor */].createSurveyFromJsonQuestion(qJson);
        this.survey.setValue("question", this.kosetValue());
        var self = this;
        this.survey.onValueChanged.add(function (sender, options) {
            self.kosetValue(options.value);
        });
        this.koSurvey(this.survey);
        this.koHasSurvey(true);
    };
    SurveyPropertySetValueTrigger.emptySurvey = new __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["Survey"]();
    return SurveyPropertySetValueTrigger;
}(SurveyPropertyTrigger));

var SurveyPropertyCopyValueTrigger = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SurveyPropertyCopyValueTrigger, _super);
    function SurveyPropertyCopyValueTrigger(trigger, koQuestions, options) {
        var _this = _super.call(this, trigger, options) || this;
        _this.trigger = trigger;
        _this.koQuestions = koQuestions;
        _this.kosetToName = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"](trigger["setToName"]);
        _this.kofromName = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"](trigger["fromName"]);
        return _this;
    }
    SurveyPropertyCopyValueTrigger.prototype.createTrigger = function () {
        var trigger = _super.prototype.createTrigger.call(this);
        trigger["setToName"] = this.kosetToName();
        trigger["fromName"] = this.kofromName();
        return trigger;
    };
    return SurveyPropertyCopyValueTrigger;
}(SurveyPropertyTrigger));

var SurveyPropertyRunExpressionTrigger = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SurveyPropertyRunExpressionTrigger, _super);
    function SurveyPropertyRunExpressionTrigger(trigger, koQuestions, options) {
        var _this = _super.call(this, trigger, options) || this;
        _this.trigger = trigger;
        _this.koQuestions = koQuestions;
        _this.kosetToName = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"](trigger["setToName"]);
        _this.korunExpression = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"](trigger["runExpression"]);
        return _this;
    }
    SurveyPropertyRunExpressionTrigger.prototype.createTrigger = function () {
        var trigger = _super.prototype.createTrigger.call(this);
        trigger["setToName"] = this.kosetToName();
        trigger["runExpression"] = this.korunExpression();
        return trigger;
    };
    return SurveyPropertyRunExpressionTrigger;
}(SurveyPropertyTrigger));

var SurveyPropertyTriggerObjects = /** @class */ (function () {
    function SurveyPropertyTriggerObjects(title, allObjects, choosenObjects) {
        var _this = this;
        this.title = title;
        this.koObjects = __WEBPACK_IMPORTED_MODULE_1_knockout__["observableArray"]();
        this.koChoosen = __WEBPACK_IMPORTED_MODULE_1_knockout__["observableArray"]();
        this.koSelected = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"]();
        this.koChoosenSelected = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"]();
        this.deleteItem = function () {
            _this.changeItems(_this.koChoosenSelected(), _this.koChoosen, _this.koObjects);
        };
        this.addItem = function () {
            _this.changeItems(_this.koSelected(), _this.koObjects, _this.koChoosen);
        };
        allObjects.forEach(function (obj) {
            if (choosenObjects.indexOf(obj.name) !== -1) {
                _this.koChoosen.push(obj);
            }
            else {
                _this.koObjects.push(obj);
            }
        });
    }
    SurveyPropertyTriggerObjects.prototype.changeItems = function (item, removedFrom, addTo) {
        if (!item)
            return;
        removedFrom.remove(item);
        addTo.push(item);
        removedFrom.sort();
        addTo.sort();
    };
    return SurveyPropertyTriggerObjects;
}());

__WEBPACK_IMPORTED_MODULE_5__propertyEditorFactory__["a" /* SurveyPropertyEditorFactory */].registerEditor("triggers", function (property) {
    return new SurveyPropertyTriggersEditor(property);
});


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_knockout__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_survey_knockout__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_survey_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_survey_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__propertyItemsEditor__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__objectEditor__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__editorLocalization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__propertyEditorFactory__ = __webpack_require__(4);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SurveyPropertyValidatorsEditor; });
/* unused harmony export SurveyPropertyValidatorItem */







var SurveyPropertyValidatorsEditor = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SurveyPropertyValidatorsEditor, _super);
    function SurveyPropertyValidatorsEditor(property) {
        var _this = _super.call(this, property) || this;
        _this.availableValidators = [];
        _this.validatorClasses = [];
        var self = _this;
        _this.selectedObjectEditor = new __WEBPACK_IMPORTED_MODULE_4__objectEditor__["a" /* SurveyObjectEditor */]();
        _this.selectedObjectEditor.onPropertyValueChanged.add(function (sender, options) {
            self.onPropertyValueChanged(options.property, options.object, options.newValue);
        });
        _this.koSelected = __WEBPACK_IMPORTED_MODULE_1_knockout__["observable"](null);
        _this.koSelected.subscribe(function (newValue) {
            self.selectedObjectEditor.selectedObject =
                newValue != null ? newValue.validator : null;
        });
        _this.validatorClasses = __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["JsonObject"].metaData.getChildrenClasses("surveyvalidator", true);
        _this.availableValidators = _this.getAvailableValidators();
        _this.koValidators = __WEBPACK_IMPORTED_MODULE_1_knockout__["observableArray"](_this.getLocalizedValidators());
        _this.onDeleteClick = function () {
            self.koItems.remove(self.koSelected());
        };
        _this.onAddClick = function (item) {
            self.addItem(item.value);
        };
        return _this;
    }
    Object.defineProperty(SurveyPropertyValidatorsEditor.prototype, "editorType", {
        get: function () {
            return "validators";
        },
        enumerable: true,
        configurable: true
    });
    SurveyPropertyValidatorsEditor.prototype.onValueChanged = function () {
        _super.prototype.onValueChanged.call(this);
        if (this.koSelected) {
            this.koSelected(this.koItems().length > 0 ? this.koItems()[0] : null);
        }
    };
    SurveyPropertyValidatorsEditor.prototype.createEditorItem = function (item) {
        var jsonObj = new __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["JsonObject"]();
        var validator = __WEBPACK_IMPORTED_MODULE_2_survey_knockout__["JsonObject"].metaData.createClass(item.getType());
        jsonObj.toObject(item, validator);
        this.setItemProperties(validator);
        return new SurveyPropertyValidatorItem(validator);
    };
    SurveyPropertyValidatorsEditor.prototype.createItemFromEditorItem = function (editorItem) {
        var item = editorItem;
        delete item.validator["survey"];
        return item.validator;
    };
    SurveyPropertyValidatorsEditor.prototype.addItem = function (validatorType) {
        var newValidator = new SurveyPropertyValidatorItem(__WEBPACK_IMPORTED_MODULE_2_survey_knockout__["JsonObject"].metaData.createClass(validatorType));
        this.setItemProperties(newValidator.validator);
        this.koItems.push(newValidator);
        this.koSelected(newValidator);
    };
    SurveyPropertyValidatorsEditor.prototype.setItemProperties = function (validator) {
        if (this.object) {
            validator["survey"] = this.object.survey;
        }
        validator.locOwner = this;
    };
    SurveyPropertyValidatorsEditor.prototype.getLocalizedValidators = function () {
        var res = [];
        for (var i = 0; i < this.availableValidators.length; i++) {
            var name = this.availableValidators[i];
            res.push({
                value: name,
                text: __WEBPACK_IMPORTED_MODULE_5__editorLocalization__["a" /* editorLocalization */].getValidatorName(name)
            });
        }
        return res;
    };
    SurveyPropertyValidatorsEditor.prototype.getAvailableValidators = function () {
        var res = [];
        for (var i = 0; i < this.validatorClasses.length; i++) {
            res.push(this.validatorClasses[i].name);
        }
        return res;
    };
    SurveyPropertyValidatorsEditor.prototype.onPropertyValueChanged = function (property, obj, newValue) {
        if (this.koSelected() == null)
            return;
        this.koSelected().validator[property.name] = newValue;
    };
    return SurveyPropertyValidatorsEditor;
}(__WEBPACK_IMPORTED_MODULE_3__propertyItemsEditor__["a" /* SurveyPropertyItemsEditor */]));

var SurveyPropertyValidatorItem = /** @class */ (function () {
    function SurveyPropertyValidatorItem(validator) {
        this.validator = validator;
        this.text = __WEBPACK_IMPORTED_MODULE_5__editorLocalization__["a" /* editorLocalization */].getValidatorName(validator.getType());
    }
    return SurveyPropertyValidatorItem;
}());

__WEBPACK_IMPORTED_MODULE_6__propertyEditorFactory__["a" /* SurveyPropertyEditorFactory */].registerEditor("validators", function (property) {
    return new SurveyPropertyValidatorsEditor(property);
});


/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_knockout__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accordion_scss__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accordion_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__accordion_scss__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccordionItemModel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AccordionModel; });


var template = __webpack_require__(132);
var AccordionItemModel = /** @class */ (function () {
    function AccordionItemModel(data, template) {
        var _this = this;
        this.data = data;
        this.template = template;
        this.collapsed = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"](true);
        this.toggle = function () { return _this.collapsed(!_this.collapsed()); };
        var self = this;
        data.onExpand = function () {
            self.collapsed(false);
        };
    }
    Object.defineProperty(AccordionItemModel.prototype, "title", {
        get: function () {
            return this.data.title;
        },
        enumerable: true,
        configurable: true
    });
    return AccordionItemModel;
}());

var AccordionModel = /** @class */ (function () {
    function AccordionModel(params) {
        this.tabs = __WEBPACK_IMPORTED_MODULE_0_knockout__["computed"](function () {
            return __WEBPACK_IMPORTED_MODULE_0_knockout__["unwrap"](params.tabs)
                .map(function (tabData) { return new AccordionItemModel(tabData, __WEBPACK_IMPORTED_MODULE_0_knockout__["unwrap"](params.template)); });
        });
        !!this.tabs()[0] && this.tabs()[0].collapsed(false);
    }
    return AccordionModel;
}());

__WEBPACK_IMPORTED_MODULE_0_knockout__["components"].register("svd-accordion", {
    viewModel: AccordionModel,
    template: template
});


/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_knockout__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__splitter_scss__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__splitter_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__splitter_scss__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SplitterComponentViewModel; });


var SplitterComponentViewModel = /** @class */ (function () {
    function SplitterComponentViewModel(params, componentInfo) {
        var splitterElement = componentInfo.element;
        var container = componentInfo.element.parentElement;
        var siblings = [];
        var minLeft = params.minLeft || 10;
        var minRight = params.minRight || 10;
        for (var i = 0; i < container.children.length; i++) {
            siblings.push(container.children[i]);
        }
        var splitterElementIndex = siblings.indexOf(splitterElement);
        var leftElement = siblings[splitterElementIndex - 1];
        var rightElement = siblings[splitterElementIndex + 1];
        var onresize = function () {
            splitterElement.style.left =
                siblings
                    .slice(0, splitterElementIndex)
                    .reduce(function (w, s) { return w + s.offsetWidth; }, 0) -
                    splitterElement.offsetWidth +
                    "px";
        };
        window.addEventListener("resize", onresize);
        onresize();
        var onmousemove = function (event) {
            var newLeft = leftElement.offsetWidth + event.movementX;
            var newRight = rightElement.offsetWidth - event.movementX;
            if (newLeft > minLeft && newRight > minRight) {
                splitterElement.style.left =
                    splitterElement.offsetLeft + event.movementX + "px";
                leftElement.style.width = (newLeft / container.offsetWidth) * 100 + "%";
                rightElement.style.width =
                    (newRight / container.offsetWidth) * 100 + "%";
            }
        };
        var onmouseup = function () {
            splitterElement.className = splitterElement.className.replace(/\ssvd-active-splitter/g, "");
            document.removeEventListener("mousemove", onmousemove);
            document.removeEventListener("mouseleave", onmouseup);
            document.removeEventListener("mouseup", onmouseup);
        };
        splitterElement.onmousedown = function () {
            splitterElement.className += " svd-active-splitter";
            document.addEventListener("mousemove", onmousemove);
            document.addEventListener("mouseleave", onmouseup);
            document.addEventListener("mouseup", onmouseup);
        };
    }
    return SplitterComponentViewModel;
}());

__WEBPACK_IMPORTED_MODULE_0_knockout__["components"].register("svd-splitter", {
    viewModel: {
        createViewModel: function (params, componentInfo) {
            return new SplitterComponentViewModel(params, componentInfo);
        }
    },
    template: '<div class="svd-splitter"></div>'
});


/***/ }),
/* 74 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 75 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 76 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 77 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 78 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 79 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 80 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 81 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 82 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 83 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports = "<svg style=\"display:none;\"><symbol viewBox=\"0 0 16 16\" id=\"icon-actionaddtotoolbox\"><path d=\"M7.3 8H1v2h5.2c.2-.7.6-1.4 1.1-2zM10 6.2V5H1v2h7.3c.5-.3 1.1-.6 1.7-.8zM1 2h9v2H1zM11.5 7C9 7 7 9 7 11.5S9 16 11.5 16s4.5-2 4.5-4.5S14 7 11.5 7zm2.5 5h-2v2h-1v-2H9v-1h2V9h1v2h2v1z\"></path></symbol><symbol viewBox=\"0 0 16 16\" id=\"icon-actionbold\"><path d=\"M1 1v5h2V4h3v8H4v2h7v-2H9V4h3v2h2V1z\"></path></symbol><symbol viewBox=\"0 0 16 16\" id=\"icon-actionconvertto\"><path d=\"M3 10L0 7h6zM13 7l3 3h-6z\"></path><path d=\"M8 4c1.5 0 2.8.8 3.4 2h2.2c-.8-2.3-3-4-5.7-4C4.7 2 2 4.7 2 8h2c0-2.2 1.8-4 4-4zM11.9 9c-.4 1.7-2 3-3.9 3-1 0-1.9-.4-2.6-1H2.8c1 1.8 3 3 5.2 3 3 0 5.4-2.2 5.9-5h-2z\"></path></symbol><symbol viewBox=\"0 0 16 16\" id=\"icon-actioncopy\"><path d=\"M2 6h9v9H2z\"></path><path d=\"M5 3v2h7v7h2V3z\"></path></symbol><symbol viewBox=\"0 0 16 16\" id=\"icon-actiondelete\"><path d=\"M8 2C4.7 2 2 4.7 2 8s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6zm3 8l-1 1-2-2-2 2-1-1 2-2-2-2 1-1 2 2 2-2 1 1-2 2 2 2z\"></path></symbol><symbol viewBox=\"0 0 32 32\" id=\"icon-actiondragelement\"><path d=\"M4 10h24a2 2 0 0 0 0-4H4a2 2 0 0 0 0 4zm24 4H4a2 2 0 0 0 0 4h24a2 2 0 0 0 0-4zm0 8H4a2 2 0 0 0 0 4h24a2 2 0 0 0 0-4z\"></path></symbol><symbol viewBox=\"0 0 16 16\" id=\"icon-actioneditelement\"><path d=\"M1 15h4l-4-4zM7 5l-5 5 4 4 5-5zM14 6l-4-4-2 2 4 4zM9 14h5v1H9z\"></path></symbol><symbol viewBox=\"0 0 16 16\" id=\"icon-actionhidetitle\"><path d=\"M15.7 7.7c-.1-.1-1.5-1.7-3.4-3L15 2l-1-1-2.9 2.9C10.1 3.4 9 3 8 3 4.3 3 .4 7.5.3 7.7L0 8l.3.3c.1.1 1.5 1.7 3.4 3L1 14l1 1 2.9-2.9c1 .5 2.1.9 3.1.9 3.7 0 7.6-4.5 7.7-4.7L16 8l-.3-.3zM2 8c.8-.8 3.4-3 6-3 .6 0 .6 0 0 0-1.7 0-3 1.3-3 3 0 .6.2 1.1.4 1.6l-.6.6C3.5 9.4 2.5 8.5 2 8zm6 3c-.6 0-.6 0 0 0 1.7 0 3-1.3 3-3 0-.6-.2-1.1-.4-1.6l.6-.6c1.3.8 2.3 1.7 2.8 2.2-.8.8-3.4 3-6 3z\"></path></symbol><symbol viewBox=\"0 0 16 16\" id=\"icon-actionisrequired\"><circle cx=\"7.5\" cy=\"13.5\" r=\"1.5\"></circle><path d=\"M8 10l1-9H6l1 9z\"></path></symbol><symbol viewBox=\"0 0 16 16\" id=\"icon-actionitalic\"><path d=\"M14 1H2L1 4h1l.33-1H7L5 13H3v1h6v-1H7L9 3h4.33L13 4h1l1-3z\"></path></symbol><symbol viewBox=\"0 0 16 16\" id=\"icon-actionnotrequired\"><path d=\"M14 1L8.4 6.6 9 1H6l.8 7.2L1 14l1 1L15 2z\"></path><circle cx=\"7.5\" cy=\"13.5\" r=\"1.5\"></circle></symbol><symbol viewBox=\"0 0 16 16\" id=\"icon-actionshowtitle\"><path d=\"M15.7 7.7C15.6 7.5 11.7 3 8 3S.4 7.5.3 7.7L0 8l.3.3c.1.2 4 4.7 7.7 4.7s7.6-4.5 7.7-4.7L16 8l-.3-.3zM8 11c-2.6 0-5.2-2.2-6-3 .8-.8 3.4-3 6-3s5.2 2.2 6 3c-.8.8-3.4 3-6 3z\"></path><circle cx=\"8\" cy=\"8\" r=\"3\"></circle></symbol><symbol viewBox=\"0 0 16 16\" id=\"icon-actionunderline\"><path class=\"st0\" d=\"M2 13h12v1H2z\"></path><path d=\"M13 1H2v3h1V3h4v8H5v1h6v-1H9V3h4v1h1V1z\"></path></symbol><symbol viewBox=\"0 0 16 16\" id=\"icon-add\"><path d=\"M14 7h-4V3H7v4H3v3h4v4h3v-4h4z\"></path></symbol><symbol viewBox=\"0 0 10 10\" id=\"icon-arrow_down_10x10\"><path d=\"M2 2L0 4l5 5 5-5-2-2-3 3z\"></path></symbol><symbol viewBox=\"0 0 10 10\" id=\"icon-arrow_up_10x10\"><path d=\"M8 9l2-2-5-5-5 5 2 2 3-3z\"></path></symbol><symbol viewBox=\"0 0 34 34\" id=\"icon-arrowdown_34x34\"><style><![CDATA[.st0{fill:#fff}]]></style><path class=\"st0\" d=\"M12 16l2-2 3 3 3-3 2 2-5 5z\"></path></symbol><symbol viewBox=\"0 0 24 24\" id=\"icon-cloud_24x24\"><style><![CDATA[.st0{fill:#1ab394}]]></style><path class=\"st0\" d=\"M75 6.5C75 4.6 73.4 3 71.5 3S68 4.6 68 6.5c0 1.4.8 2.6 2 3.2-.2 1-.7 1.8-1.7 2.3-.4.2-.9.4-1.3.6-.8.3-1.7.6-2.5.9-.2.1-.3.1-.5.2v-6c1.2-.6 2-1.8 2-3.2C66 2.6 64.4 1 62.5 1S59 2.6 59 4.5c0 1.4.8 2.6 2 3.2v9.7c-1.2.6-2 1.8-2 3.2 0 1.8 1.6 3.4 3.5 3.4s3.5-1.6 3.5-3.5c0-1.4-.8-2.6-2-3.2.1-.5.4-1 .9-1.2.3-.1.6-.3 1-.4 1.1-.4 2.1-.7 3.2-1.2 1.4-.6 2.5-1.5 3.1-2.9.2-.4.3-1.1.4-1.8C74 9.3 75 8.1 75 6.5zM62.5 3c.8 0 1.5.7 1.5 1.5S63.3 6 62.5 6 61 5.3 61 4.5 61.7 3 62.5 3zm0 19c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5-.7 1.5-1.5 1.5zM70 6.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5S72.3 8 71.5 8 70 7.3 70 6.5zM9 18l1 1 2-2v6h2v-6l2 2 1-1-4-4z\"></path><path class=\"st0\" d=\"M20.9 7.9c.1-.3.1-.6.1-.9 0-2.8-2.2-5-5-5-2.6 0-4.7 1.9-4.9 4.4C10.3 5.6 9.2 5 8 5 5.8 5 4 6.8 4 9v.2c-1.7.4-3 1.3-3 3.8 0 2.3 2.4 3 4 3h3l5-5 5 5c2.8 0 5-1.2 5-4 0-1.7-.8-3.1-2.1-4.1z\"></path></symbol><symbol viewBox=\"0 0 16 16\" id=\"icon-autocomplete\"><style><![CDATA[.st0{fill:#3d4d5d}]]></style><path class=\"st0\" d=\"M15 6H7v10h9v-1H8v-2h7v2h1V6h-1zm0 6H8v-2h7v2zm0-3H8V7h7v2zM3 10H1V4h2V3H0v8h3zM14 5h1V3H6v1h8zM5 1h1V0H3v1h1v11H3v1h3v-1H5z\"></path></symbol><symbol viewBox=\"0 0 16 16\" id=\"icon-barrating\"><style><![CDATA[.st0{fill:#3d4d5d}]]></style><path class=\"st0\" d=\"M12.1 15l-4.6-2.4L2.9 15l.9-5.1L0 6.3l5.2-.7L7.5 1l2.3 4.6 5.2.7-3.8 3.6.9 5.1z\"></path></symbol><symbol viewBox=\"0 0 16 16\" id=\"icon-datepicker\"><style><![CDATA[.st0{fill:#3d4d5d}]]></style><path class=\"st0\" d=\"M3 7h2v2H3zM7 11h2v2H7zM3 11h2v2H3zM11 11h2v2h-2zM11 7h2v2h-2zM10 6H6v4h4V6zM9 9H7V7h2v2zM4 0h1v3H4zM11 0h1v3h-1z\"></path><path class=\"st0\" d=\"M13 2v2h-3V2H6v2H3V2H0v14h16V2h-3zm2 13H1V5h14v10z\"></path></symbol><symbol viewBox=\"0 0 16 16\" id=\"icon-editor\"><style><![CDATA[.st0{fill:#3d4d5d}]]></style><path class=\"st0\" d=\"M1 3h2v5H2v1h4V8H5V3h2v1h1V1H0v3h1zM10 5h6v1h-6zM10 8h6v1h-6zM0 11h16v1H0zM0 14h16v1H0z\"></path></symbol><symbol viewBox=\"0 0 16 16\" id=\"icon-microphone\"><style><![CDATA[.st0{fill:#3d4d5d}]]></style><path class=\"st0\" d=\"M11 3.4C11 2.1 9.9 1 8.6 1h-.2C7.1 1 6 2.1 6 3.4V5h5V3.4zM8.4 10h.3C9.9 10 11 8.9 11 7.6V6H6v1.6C6 8.9 7.1 10 8.4 10z\"></path><path class=\"st0\" d=\"M12 6v.9c0 2.2-1.6 4.1-3.5 4.1S5 9.1 5 6.9V6H4v1c0 2.5 1.8 4.6 4 4.9V14H6v1h5v-1H9v-2.1c2.2-.3 4-2.4 4-4.9V6h-1z\"></path></symbol><symbol viewBox=\"0 0 16 16\" id=\"icon-nouislider\"><style><![CDATA[.st0{fill:#3d4d5d}]]></style><path class=\"st0\" d=\"M0 10h16v2H0zM2 4v3l2 2 2-2V4zM10 4v3l2 2 2-2V4z\"></path></symbol><symbol viewBox=\"0 0 16 16\" id=\"icon-signaturepad\"><style><![CDATA[.st0{fill:#3d4d5d}]]></style><path class=\"st0\" d=\"M0 0v15h16V0H0zm15 14H1V1h14v13z\"></path><path class=\"st0\" d=\"M2.6 10.2c.1.1.1.2.2.3-.2.3-.4.6-.7.8l.7.7c.2-.3.5-.6.7-.9h.1c.2.1.9.1 1.1.1 1.5-.1 2.3-.5 2.8-.8h.1l.6.3h.6c.7-.1 1.9-.8 2.5-1.2.2-.1.5-.3.5-.3v.2c0 .2 0 .3.1.5.1.3.3.4.6.5.2 0 .4 0 .5-.1.1-.3.8-1 1-1.3V8c-.1.1-.3.2-.4.4-.2.2-.5.4-.8.6l-.1.1v-.3c0-.2 0-.4-.1-.5-.1-.4-.5-.6-.9-.4-.1.1-.4.2-.6.4-.9.6-2 1.2-2.2 1.3-.1 0-.2.1-.4.1l.1-.1c.3-.3.7-.6.9-1 .2-.3.3-.6.3-.9 0-.4 0-.7-.2-1.1-.1-.3-.4-.6-.8-.7-.2-.1-.4-.1-.7 0-.2.1-.5.2-.7.4-.3.3-.5.6-.6 1-.1.2-.1.5-.1.7 0 .4 0 .7.1 1.1 0 .2.1.3.2.5-.6.3-1.5.7-2.8.6v-.1c0-.1.1-.3.2-.4.4-.7.7-1.4.9-2.1.2-.6.3-1.3.3-1.9V4.3c0-.3-.1-.6-.3-.8-.2-.4-.6-.6-1-.5-.3.1-.5.2-.7.4-.3.2-.6.5-.8.9-.2.5-.4 1-.6 1.6-.1.5-.2 1-.2 1.5s0 1 .1 1.4c.1.6.3 1 .5 1.4zm5-2.5c.1-.2.2-.5.4-.6.2-.2.4-.2.7-.2.1 0 .2.1.2.2.1.3.1.6-.1.8-.2.3-.4.6-.6.8-.2.2-.3.3-.5.4-.1-.1-.1-.2-.1-.4v-1zM3 6.7c.1-.6.3-1.3.6-1.8.1-.3.3-.5.5-.8.1 0 .2-.1.2-.1.1-.1.2 0 .3.1.1.1.1.3.1.4 0 .4.1.9 0 1.3 0 .8-.2 1.6-.5 2.3-.3.5-.5 1-.8 1.5-.1 0-.2-.1-.2-.2-.2-.6-.3-1.2-.3-1.8 0-.3.1-.6.1-.9z\"></path></symbol><symbol viewBox=\"0 0 16 16\" id=\"icon-sortablejs\"><style><![CDATA[.st0{fill:#3d4d5d}]]></style><path class=\"st0\" d=\"M7 1h9v2H7zM9 6h7v2H9zM11 11h5v2h-5zM5 10l1 1c-2.2 0-4-1.8-4-4 0-1.9 1.3-3.4 3-3.9v-2C2.2 1.5 0 4 0 7c0 3.3 2.7 6 5.9 6H6l-1 1 1 1 3-3-3-3-1 1z\"></path></symbol><symbol viewBox=\"0 0 16 16\" id=\"icon-tagbox\"><style><![CDATA[.st0{fill:#3d4d5d}]]></style><path class=\"st0\" d=\"M15 11H0V5h15v6zM1 10h13V6H1v4z\"></path><path class=\"st0\" d=\"M2 7h4v2H2zM7 7h4v2H7z\"></path></symbol><symbol viewBox=\"0 0 24 24\" id=\"icon-delete_24x24\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#1AB394\" d=\"M6 8l2-2 4 4 4-4 2 2-4 4 4 4-2 2-4-4-4 4-2-2 4-4-4-4z\"></path></symbol><symbol viewBox=\"0 0 24 24\" id=\"icon-edit\"><g fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path d=\"M19 4l-9 9 4 4 9-9-4-4zM8 15v4h4l-4-4zM1 17v2h4v-2H1z\"></path></g></symbol><symbol viewBox=\"0 0 16 16\" id=\"icon-boolean\"><path d=\"M0 16h10V6H0v10zm2-6l2 2 4-4 1 1-5 5-3-3 1-1z\"></path><path d=\"M5 1v4h1V2h8v8h-3v1h4V1z\"></path></symbol><symbol viewBox=\"0 0 16 16\" id=\"icon-checkbox\"><path d=\"M1 1v14h14V1H1zm6 10L4 8l1-1 2 2 4-4 1 1-5 5z\"></path></symbol><symbol viewBox=\"0 0 16 16\" id=\"icon-comment\"><path d=\"M8 2C4.1 2 1 4.2 1 7c0 1.9 1.5 3.6 3.8 4.4C4.6 13.1 3 14 3 14s1.5-.2 2.7-.9c.4-.2.9-.8 1.3-1.2.3.1.6.1 1 .1 3.9 0 7-2.2 7-5s-3.1-5-7-5zM4 8c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm4 0c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm4 0c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z\"></path></symbol><symbol viewBox=\"0 0 16 16\" id=\"icon-default\"><path d=\"M0 4h4V0H0v4zm6 0h4V0H6v4zm6-4v4h4V0h-4zM0 10h4V6H0v4zm6 0h4V6H6v4zm6 0h4V6h-4v4zM0 16h4v-4H0v4zm6 0h4v-4H6v4zm6 0h4v-4h-4v4z\"></path></symbol><symbol viewBox=\"0 0 16 16\" id=\"icon-dropdown\"><path d=\"M1 1v6h14V1H1zm10 5L8 3l1-1 2 2 2-2 1 1-3 3zm-8 5h12V9H3v2zm0 4h12v-2H3v2z\"></path></symbol><symbol viewBox=\"0 0 16 16\" id=\"icon-expression\"><path d=\"M15 9l-4 4-2-2-1 1 3 3 5-5zM4 4v1h2v1H3v3h4V4H4zm2 4H4V7h2v1zM8 8h1v1H8z\"></path><path d=\"M1 1h13v7l1-1V0H0v12h6l1-1H1z\"></path><path d=\"M10 4h1v1h-1zM9 5h1v1H9zM11 5h1v1h-1zM11 3h1v1h-1zM9 3h1v1H9z\"></path></symbol><symbol viewBox=\"0 0 16 16\" id=\"icon-file\"><path d=\"M9 0v5h5z\"></path><path d=\"M8 0H2v16h12V6H8z\"></path></symbol><symbol viewBox=\"0 0 16 16\" id=\"icon-flowpanel\"><path d=\"M14 4h2v1h-2zM0 4h2v1H0zM14 6h2v1h-2zM0 6h2v1H0zM14 8h2v1h-2zM0 8h2v1H0zM14 10h2v1h-2zM0 10h2v1H0zM0 2h16v1H0zM0 0h16v1H0zM0 12h16v1H0zM0 14h16v1H0zM11 4L7 8 5 6 4 7l3 3 5-5z\"></path></symbol><symbol viewBox=\"0 0 16 16\" id=\"icon-html\"><path d=\"M4 4L0 8l4 4 1-1-3-3 3-3zM11 4l-1 1 3 3-3 3 1 1 4-4z\"></path></symbol><symbol viewBox=\"0 0 16 16\" id=\"icon-imagepicker\"><style><![CDATA[.st0{fill:#3d4d5d}]]></style><path class=\"st0\" d=\"M15 14H0V1h15v13zM1 13h13V2H1v11z\"></path><path class=\"st0\" d=\"M2 3v9h11V3H2zm4 1c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1zm-3 7l2-3 1 1 2-3 4 5H3z\"></path></symbol><symbol viewBox=\"0 0 16 16\" id=\"icon-matrix\"><path d=\"M4 1C2.3 1 1 2.3 1 4s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3zm0 5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z\"></path><circle cx=\"4\" cy=\"4\" r=\"1\"></circle><path d=\"M12 7c1.7 0 3-1.3 3-3s-1.3-3-3-3-3 1.3-3 3 1.3 3 3 3zm0-5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zM4 9c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3zm0 5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM12 9c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3zm0 5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z\"></path></symbol><symbol viewBox=\"0 0 16 16\" id=\"icon-matrixdropdown\"><path d=\"M4 1C2.3 1 1 2.3 1 4s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3zm0 5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z\"></path><circle cx=\"4\" cy=\"4\" r=\"1\"></circle><path d=\"M12 7c1.7 0 3-1.3 3-3s-1.3-3-3-3-3 1.3-3 3 1.3 3 3 3zm0-5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zM4 9c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3zm0 5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z\"></path><circle cx=\"4\" cy=\"12\" r=\"1\"></circle><path d=\"M12 9c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3zm0 5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z\"></path></symbol><symbol viewBox=\"0 0 16 16\" id=\"icon-matrixdynamic\"><path d=\"M3 1C1.3 1 0 2.3 0 4s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3zm0 5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z\"></path><circle cx=\"3\" cy=\"4\" r=\"1\"></circle><path d=\"M11 7c1.7 0 3-1.3 3-3s-1.3-3-3-3-3 1.3-3 3 1.3 3 3 3zm0-5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zM3 9c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3zm0 5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM8 15h2l-2-2zM9.03 11.99l4.03-4.03 1.98 1.98-4.03 4.03z\"></path></symbol><symbol viewBox=\"0 0 16 16\" id=\"icon-multipletext\"><path d=\"M0 2v12h16V2H0zm5 9H2V9h3v2zm0-4H2V5h3v2zm9 4H7V9h7v2zm0-4H7V5h7v2z\"></path></symbol><symbol viewBox=\"0 0 16 16\" id=\"icon-panel_dynamic\"><path d=\"M2 8h10v1H2zM2 11h8l1-1H2zM9 16h2l-2-2zM14 9l-4 4 2 2 4-4zM3 3v2H2l2 2 2-2H5V3zM11 5V3H9v2H8l2 2 2-2z\"></path><path d=\"M1 1h12v7l1-1V0H0v14h7l1-1H1z\"></path></symbol><symbol viewBox=\"0 0 16 16\" id=\"icon-panel\"><path d=\"M0 0v16h16V0H0zm15 15H1V1h14v14z\"></path><path d=\"M2 12h12v2H2zM2 9h12v2H2zM11 8L8 5h2V2h2v3h2zM5 8L2 5h2V2h2v3h2z\"></path></symbol><symbol viewBox=\"0 0 16 16\" id=\"icon-paneldynamic\"><path d=\"M2 8h10v1H2zM2 11h8l1-1H2zM9 16h2l-2-2zM14 9l-4 4 2 2 4-4zM3 3v2H2l2 2 2-2H5V3zM11 5V3H9v2H8l2 2 2-2z\"></path><path d=\"M1 1h12v7l1-1V0H0v14h7l1-1H1z\"></path></symbol><symbol viewBox=\"0 0 16 16\" id=\"icon-radiogroup\"><path d=\"M3 1C1.3 1 0 2.3 0 4s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3zm0 4c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm0 4c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3zm0 4c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zM8 3v2h8V3H8zm0 10h8v-2H8v2z\"></path></symbol><symbol viewBox=\"0 0 16 16\" id=\"icon-rating\"><path d=\"M0 7h1l1-1v5h1V5H2L0 7zm5 5h5V4H5v8zm1-5h2V6H6V5h3v3H7v2h2v1H6V7zm6-2v1h2v1h-2v1h2v2h-2v1h3V5h-3z\"></path></symbol><symbol viewBox=\"0 0 16 16\" id=\"icon-text\"><path d=\"M2 1v3h1V3h4v10H5v1h6v-1H9V3h4v1h1V1H2z\"></path></symbol><symbol viewBox=\"0 0 24 24\" id=\"icon-fork_24x24\"><path opacity=\".9\" d=\"M-40-20c-1.2 0-2-.9-2-2v-2c0-1.1.9-2 2-2h.1c1.1 0 2 .9 2 2v2.1c-.1 1-1 1.9-2.1 1.9z\"></path><path opacity=\".5\" d=\"M-40-2c-1.2 0-2-.9-2-2v-2c0-1.1.9-2 2-2h.1c1.1 0 2 .9 2 2v2c-.1 1.1-1 2-2.1 2z\"></path><path opacity=\".2\" d=\"M-52-14c0-1.2.9-2 2-2h2.1c1.1 0 2 .9 2 2v.1c0 1.1-.9 2-2 2H-50c-1.1-.1-2-1-2-2.1z\"></path><path opacity=\".7\" d=\"M-34-14c0-1.2.9-2 2-2h2.1c1.1 0 2 .9 2 2v.1c0 1.1-.9 2-2 2H-32c-1.1-.1-2-1-2-2.1z\"></path><path opacity=\".1\" d=\"M-44.5-18.6c-.8.8-2.1.8-2.8.1l-1.2-1.2c-.8-.8-.8-2 0-2.8l.1-.1c.8-.8 2-.8 2.8 0l1.2 1.2c.7.8.7 2.1-.1 2.8z\"></path><path opacity=\".6\" d=\"M-31.5-5.5c-.8.8-2.1.8-2.8.1l-1.2-1.2c-.8-.8-.8-2 0-2.8l.1-.1c.8-.8 2-.8 2.8 0l1.2 1.2c.7.8.7 2-.1 2.8z\"></path><path opacity=\".3\" d=\"M-48.5-5.5c-.8-.8-.8-2.1-.1-2.8l1.2-1.2c.8-.8 2-.8 2.8 0l.1.1c.8.8.8 2 0 2.8l-1.2 1.2c-.7.7-2 .7-2.8-.1z\"></path><path opacity=\".8\" d=\"M-35.4-18.5c-.8-.8-.8-2.1-.1-2.8l1.2-1.2c.8-.8 2-.8 2.8 0l.1.1c.8.8.8 2 0 2.8l-1.2 1.2c-.8.7-2.1.7-2.8-.1z\"></path><path opacity=\".9\" fill=\"#9D9FA1\" d=\"M-22-13l2-2 4 4 9-9 2 2-11 11z\"></path><path d=\"M41-19h-1.2c-.2-.7-.4-1.3-.8-1.9l.8-.8c.4-.4.4-1 0-1.4l-.7-.7c-.4-.4-1-.4-1.4 0l-.8.8c-.6-.4-1.2-.6-1.9-.8V-25c0-.5-.5-1-1-1h-1c-.5 0-1 .5-1 1v1.2c-.7.2-1.3.4-1.9.8l-.8-.8c-.4-.4-1-.4-1.4 0l-.7.7c-.4.4-.4 1 0 1.4l.8.8c-.4.6-.6 1.2-.8 1.9H26c-.5 0-1 .5-1 1v1c0 .5.5 1 1 1h1.2c.2.7.4 1.3.8 1.9l-.8.8c-.4.4-.4 1 0 1.4l.7.7c.4.4 1 .4 1.4 0l.8-.8c.6.4 1.2.6 1.9.8v1.2c0 .5.5 1 1 1h1c.5 0 1-.5 1-1v-1.2c.7-.2 1.3-.4 1.9-.8l.8.8c.4.4 1 .4 1.4 0l.7-.7c.4-.4.4-1 0-1.4l-.8-.8c.4-.6.6-1.2.8-1.9H41c.5 0 1-.5 1-1v-1c0-.5-.5-1-1-1zm-7.5 5.5c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4z\"></path><path opacity=\".9\" fill=\"#9D9FA1\" d=\"M13-15v-3h-1.2c-.1-.4-.3-.8-.5-1.2l.9-.9-2.2-2-.9.9c-.4-.2-.8-.4-1.2-.5V-23H5v1.2c-.4.1-.8.3-1.2.5l-.8-.8L.8-20l.9.9c-.2.4-.4.8-.5 1.2H0v3h1.2c.1.4.3.8.5 1.2l-.9.7L3-10.8l.9-.9c.4.2.8.4 1.2.5v1.2h3v-1.2c.4-.1.8-.3 1.2-.5l.9.9 2.1-2.1-.9-.9c.2-.4.4-.8.5-1.2H13zm-6.5 1.5c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3z\"></path><path opacity=\".6\" fill=\"#9D9FA1\" d=\"M23-9v-2h-1.1c-.1-.4-.2-.7-.4-1l.8-.8-1.4-1.4-.9.8c-.3-.2-.7-.3-1-.4V-15h-2v1.1c-.4.1-.7.2-1 .4l-.8-.8-1.4 1.4.8.8c-.2.3-.3.7-.4 1H13v2h1.1c.1.4.2.7.4 1l-.8.8 1.4 1.4.9-.7c.3.2.7.3 1 .4V-5h2v-1.1c.4-.1.7-.2 1-.4l.8.8 1.4-1.4-.8-.9c.2-.3.3-.7.4-1H23zm-5 1c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z\"></path><path opacity=\".5\" fill=\"#9D9FA1\" d=\"M-69-7h3v5h-3z\"></path><path opacity=\".9\" fill=\"#9D9FA1\" d=\"M-69-23h3v5h-3z\"></path><path opacity=\".2\" fill=\"#9D9FA1\" d=\"M-72.993-13.993v3h-5v-3z\"></path><path opacity=\".7\" fill=\"#9D9FA1\" d=\"M-56.993-13.993v3h-5v-3z\"></path><path opacity=\".6\" fill=\"#9D9FA1\" d=\"M-64.615-7.549l2.121-2.12 3.536 3.535-2.122 2.121z\"></path><path opacity=\".1\" fill=\"#9D9FA1\" d=\"M-75.98-18.791l2.121-2.122 3.536 3.536-2.122 2.121z\"></path><path opacity=\".3\" fill=\"#9D9FA1\" d=\"M-72.505-9.669l2.121 2.121-3.535 3.536-2.122-2.121z\"></path><path opacity=\".8\" fill=\"#9D9FA1\" d=\"M-61.14-20.912l2.121 2.121-3.535 3.536-2.122-2.121z\"></path><path fill=\"#1AB394\" d=\"M21 6.5C21 4.6 19.4 3 17.5 3S14 4.6 14 6.5c0 1.4.8 2.6 2 3.2-.2 1-.7 1.8-1.7 2.3-.4.2-.9.4-1.3.6-.8.3-1.7.6-2.5.9-.2.1-.3.1-.5.2v-6c1.2-.6 2-1.8 2-3.2C12 2.6 10.4 1 8.5 1S5 2.6 5 4.5c0 1.4.8 2.6 2 3.2v9.7c-1.2.6-2 1.8-2 3.2C5 22.4 6.6 24 8.5 24s3.5-1.6 3.5-3.5c0-1.4-.8-2.6-2-3.2.1-.5.4-1 .9-1.2.3-.1.6-.3 1-.4 1.1-.4 2.1-.7 3.2-1.2 1.4-.6 2.5-1.5 3.1-2.9.2-.4.3-1.1.4-1.8C20 9.3 21 8.1 21 6.5zM8.5 3c.8 0 1.5.7 1.5 1.5S9.3 6 8.5 6 7 5.3 7 4.5 7.7 3 8.5 3zm0 19c-.8 0-1.5-.7-1.5-1.5S7.7 19 8.5 19s1.5.7 1.5 1.5S9.3 22 8.5 22zM16 6.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5S18.3 8 17.5 8 16 7.3 16 6.5z\"></path></symbol><symbol viewBox=\"0 0 12 12\" id=\"icon-gear\"><path d=\"M12 7V5H9.9c-.1-.4-.3-.7-.5-1l1.5-1.5-1.4-1.4L8 2.6c-.3-.2-.6-.4-1-.5V0H5v2.1c-.4.1-.7.3-1 .5L2.5 1.1 1.1 2.5 2.6 4c-.2.3-.4.6-.5 1H0v2h2.1c.1.4.2.7.4 1L1.1 9.5l1.4 1.4L4 9.4c.3.2.7.3 1 .4V12h2V9.9c.4-.1.7-.2 1-.4L9.5 11l1.4-1.4L9.4 8c.2-.3.3-.7.4-1H12zM6 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z\"></path></symbol><symbol viewBox=\"0 0 12 12\" id=\"icon-gearactive\"><path d=\"M12 7V5H9.9c-.1-.4-.3-.7-.5-1l1.5-1.5-1.4-1.4L8 2.6c-.3-.2-.6-.4-1-.5V0H5v2.1c-.4.1-.7.3-1 .5L2.5 1.1 1.1 2.5 2.6 4c-.2.3-.4.6-.5 1H0v2h2.1c.1.4.2.7.4 1L1.1 9.5l1.4 1.4L4 9.4c.3.2.7.3 1 .4V12h2V9.9c.4-.1.7-.2 1-.4L9.5 11l1.4-1.4L9.4 8c.2-.3.3-.7.4-1H12zM6 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z\"></path></symbol><symbol viewBox=\"0 0 12 12\" id=\"icon-inplacecheck\"><path d=\"M2 7l1-1 2 2 5-5 1 1-6 6z\"></path></symbol><symbol viewBox=\"0 0 12 12\" id=\"icon-inplacedelete\"><path d=\"M3 2L2 3l3 3-3 3 1 1 3-3 3 3 1-1-3-3 3-3-1-1-3 3z\"></path></symbol><symbol viewBox=\"0 0 12 12\" id=\"icon-inplacedraggable\"><path d=\"M0 4h7v7H0z\"></path><path d=\"M2 3h6v6h1V2H2z\"></path><path d=\"M4 1h6v6h1V0H4z\"></path></symbol><symbol viewBox=\"0 0 12 12\" id=\"icon-inplaceedit\"><path d=\"M1 11h3L1 8zM6 3L2 7l3 3 4-4zM11 4L8 1 7 2l3 3zM7 10h5v1H7z\"></path></symbol><symbol viewBox=\"0 0 12 12\" id=\"icon-inplaceplus\"><path d=\"M11 5H7V1H5v4H1v2h4v4h2V7h4z\"></path></symbol><symbol viewBox=\"0 0 16 16\" id=\"icon-left\"><path d=\"M11 12l-2 2-6-6 6-6 2 2-4 4z\"></path></symbol><symbol viewBox=\"0 0 24 24\" id=\"icon-new_24x24\"><path fill=\"#1AB394\" d=\"M18 11h-5V6h-3v5H5v3h5v5h3v-5h5z\"></path></symbol><symbol viewBox=\"0 0 20 20\" id=\"icon-noncommercial\"><path d=\"M10 0C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10S15.5 0 10 0zM2 10c0-1.4.4-2.8 1.1-3.9l7.6 7.6c-.3.1-.6.2-.9.2-1.1 0-2.1-.4-3-1.1l-1 1.8c.2.2.5.5.9.7s.9.4 1.4.5c.3.1.6.1.9.2v1h2v-1.3c.5-.1.9-.3 1.2-.5l1.7 1.7c-1.1.7-2.5 1.1-3.9 1.1-4.4 0-8-3.6-8-8zm14.1 5.1l-2.4-2.4v-.3c0-.6-.1-1.2-.3-1.6s-.5-.7-.8-.9c-.3-.2-.7-.4-1.1-.5l-1.2-.3c-.1-.1-.2-.1-.4-.2L8.4 7.4c0-.3.2-.6.4-.8.3-.2.7-.3 1.3-.3.8 0 1.6.3 2.4 1l.9-1.8c-.5-.4-1-.7-1.6-.9-.3-.1-.6-.2-.9-.2V3H9v1.4c-.7.1-1.3.3-1.7.7-.2.2-.4.4-.5.7L4.9 3.9C6.3 2.7 8 2 10 2c4.4 0 8 3.6 8 8 0 2-.7 3.7-1.9 5.1z\"></path></symbol><symbol viewBox=\"0 0 16 16\" id=\"icon-right\"><path d=\"M5 4l2-2 6 6-6 6-2-2 4-4z\"></path></symbol><symbol viewBox=\"0 0 24 24\" id=\"icon-modified\"><path opacity=\".9\" d=\"M14 11V8h-1.2c-.1-.4-.3-.8-.5-1.2l.9-.8L11 3.8l-.9.9c-.3-.2-.7-.4-1.1-.5V3H6v1.2c-.4.1-.8.3-1.2.5L4 3.8 1.8 6l.9.9c-.2.3-.4.7-.5 1.1H1v3h1.2c.1.4.3.8.5 1.2l-.9.8L4 15.2l.9-.9c.4.2.8.4 1.2.5V16h3v-1.2c.4-.1.8-.3 1.2-.5l.9.9 2.1-2.1-.9-.9c.2-.4.4-.8.5-1.2H14zm-6.5 1.5c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3z\"></path><path opacity=\".6\" d=\"M24 17v-2h-1.1c-.1-.4-.2-.7-.4-1l.8-.8-1.4-1.4-.9.8c-.3-.2-.7-.3-1-.4V11h-2v1.1c-.4.1-.7.2-1 .4l-.8-.8-1.4 1.4.8.8c-.2.3-.3.7-.4 1H14v2h1.1c.1.4.2.7.4 1l-.8.8 1.4 1.4.8-.8c.3.2.7.3 1 .4V21h2v-1.1c.4-.1.7-.2 1-.4l.8.8 1.4-1.4-.7-.9c.2-.3.3-.7.4-1H24zm-5 1c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z\"></path></symbol><symbol viewBox=\"0 0 24 24\" id=\"icon-saved\"><path opacity=\".9\" d=\"M4 13l2-2 4 4 9-9 2 2-11 11z\"></path></symbol><symbol viewBox=\"0 0 24 24\" id=\"icon-saving\"><path opacity=\".5\" d=\"M10 17h3v5h-3z\"></path><path opacity=\".9\" d=\"M10 1h3v5h-3z\"></path><path opacity=\".2\" d=\"M6 10v3H1v-3z\"></path><path opacity=\".7\" d=\"M22 10v3h-5v-3z\"></path><path opacity=\".6\" d=\"M14.39 16.45l2.12-2.121 3.536 3.535-2.121 2.121z\"></path><path opacity=\".1\" d=\"M2.954 5.136l2.121-2.121L8.61 6.55 6.49 8.672z\"></path><path opacity=\".3\" d=\"M6.49 14.328l2.12 2.122-3.535 3.535-2.121-2.121z\"></path><path opacity=\".8\" d=\"M17.925 3.015l2.121 2.12-3.535 3.536-2.122-2.12z\"></path></symbol></svg>";

/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports = "<script type=\"text/html\" id=\"convert-action\">\r\n  <span class=\"svda_question_action\">\r\n      <!-- ko if: allowChangeType -->\r\n      <select onmousewheel=\"return false;\" class=\"svda_current_type svd-main-color svd-light-bg-color\" data-bind=\"foreach: availableTypes, event: { change: onConvertType }, attr: {title: title}\">\r\n          <option class=\"svd-light-bg-color\" data-bind=\"text: $data.name, value: $data.value, attr:{selected: $data.value === $parent.type ? 'selected': null}\"></option>\r\n      </select>\r\n      <!-- /ko -->\r\n      <!-- ko ifnot: allowChangeType -->\r\n      <span data-bind=\"text: text\" class=\"svda_current_type svd-main-color\"> </span>\r\n      <!-- /ko -->\r\n  </span>\r\n</script>\r\n\r\n<script type=\"text/html\" id=\"action-separator\">\r\n  <span class=\"svda_action_separator svd-dark-border-color\">\r\n  </span>\r\n</script>\r\n\r\n<script type=\"text/html\" id=\"fp-add-question\">\r\n  <span class=\"svda_question_action\">\r\n      <select onmousewheel=\"return false;\" class=\"svda_current_type svd-main-color svd-light-bg-color\" data-bind=\"event: { change: onAddQuestion }, attr: {title: title}\">\r\n        <option class=\"svd-light-bg-color\" data-bind=\"text: title, value: undefined\"></option>\r\n        <!-- ko foreach: availableTypes -->\r\n          <option class=\"svd-light-bg-color\" data-bind=\"text: $data.name || $data, value: $data.value || $data\"></option>\r\n        <!-- /ko -->\r\n    </select>\r\n  </span>\r\n</script>\r\n";

/***/ }),
/* 86 */
/***/ (function(module, exports) {

module.exports = "<div class=\"svd_container svd-light-bg-color\" data-bind=\"css: themeCss\">\r\n  <!-- ko ifnot: haveCommercialLicense -->\r\n  <div class=\"svd_commercial_container\">\r\n    <a\r\n      class=\"svd_commercial_text\"\r\n      href=\"https://surveyjs.io/Licenses#BuildSurvey\"\r\n      target=\"_blank\"\r\n    >\r\n      <span>\r\n        <svg-icon\r\n          class=\"svd-primary-icon\"\r\n          params=\"iconName: 'icon-noncommercial', size: 20\"\r\n        ></svg-icon>\r\n      </span>\r\n      <span class=\"svd_commercial_product svd-main-color\"\r\n        >SurveyJS Builder</span\r\n      >\r\n      <span class=\"svd_noncommercial_use svd-light-text-color\"\r\n        >for non-commercial use only</span\r\n      >\r\n    </a>\r\n  </div>\r\n  <!-- /ko  -->\r\n  <ul\r\n    class=\"navbar-default container-fluid nav nav-tabs editor-tabs svd-light-bg-color\"\r\n  >\r\n    <!-- ko foreach: tabs -->\r\n    <li\r\n      class=\"nav-item\"\r\n      data-bind=\"css: {active: $parent.koViewType() == name}\"\r\n    >\r\n      <a class=\"nav-link\" href=\"#\" data-bind=\"click: action, text: title\"></a>\r\n    </li>\r\n    <!-- /ko -->\r\n  </ul>\r\n  <div class=\"panel card svd_content svd-dark-bg-color\">\r\n    <!-- ko foreach: tabs -->\r\n    <div data-bind=\"visible: $parent.koViewType() == name\">\r\n      <!-- ko template: { name: template, data: data, afterRender: function(element, model) { $parent.onEditorTabRenderedCallback(name, element, model, $data); } } -->\r\n      <!-- /ko -->\r\n    </div>\r\n    <!-- /ko -->\r\n  </div>\r\n  <div\r\n    data-bind=\"template: { name: 'questioneditor', data: questionEditorWindow }\"\r\n  ></div>\r\n</div>\r\n";

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports = "<script type=\"text/html\" id=\"jsoneditor\">\r\n    <div data-bind=\"visible: !hasAceEditor\">\r\n        <textarea class=\"svd_json_editor_area\" data-bind=\"textInput:koText\"></textarea>\r\n        <!-- ko foreach: koErrors -->\r\n        <div>\r\n            <span>Error: </span><span data-bind=\"text: text\"></span>\r\n        </div>\r\n        <!-- /ko  -->\r\n    </div>\r\n    <div id=\"surveyjsJSONEditor\" class=\"svd_json_editor\"></div>\r\n</script>";

/***/ }),
/* 88 */
/***/ (function(module, exports) {

module.exports = "<script type=\"text/html\" id=\"surveys-manage\">\r\n    <div class=\"svd-manage\">\r\n        <div class=\"svd-manage-mask\" data-bind=\"visible: isLoading\"></div>\r\n        <div class=\"svd-manage-control svd-light-border-color\">\r\n            <select onmousewheel=\"return false;\" class=\"svd-manage-select\" data-bind=\"visible: !isEditMode(), options: surveys,\r\n                        optionsText: 'name',\r\n                        value: currentSurvey,\r\n                        optionsCaption: 'Choose survey to edit or start editing and survey will be saved automatically...'\"></select>\r\n            <input type=\"text\" class=\"svd-manage-name\" data-bind=\"visible: isEditMode, value: currentSurveyName, event: { keyup: nameEditorKeypress }\"\r\n            />\r\n        </div>\r\n        <div class=\"svd-manage-buttons\">\r\n            <span class=\"icon\" data-bind=\"visible: currentSurvey, click: edit, css: cssEdit, attr: { title: titleEdit }\"></span>\r\n            <span class=\"icon\" data-bind=\"visible: !isEditMode(), click: add, css: cssAdd, attr: { title: titleAdd }\"></span>\r\n            <span class=\"icon icon-delete\" title=\"Delete current survey\" data-bind=\"visible: !isEditMode() && !surveyId() && currentSurvey(), click:remove\"></span>\r\n        </div>\r\n    </div>\r\n</script>\r\n<script type=\"text/html\" id=\"attach-survey\">\r\n    <a target=\"_blank\" href=\"#\" data-bind=\"attr: { href: action, title: title }\">\r\n        <span class=\"icon\" data-bind=\"css: innerCss\"></span>\r\n        <span data-bind=\"text: title\"></span>\r\n    </a>\r\n</script>";

/***/ }),
/* 89 */
/***/ (function(module, exports) {

module.exports = "<script type=\"text/html\" id=\"objecteditor\">\r\n    <table class=\"table svd_table-nowrap svd_properties_grid\">\r\n        <tbody data-bind=\"foreach: koProperties\">\r\n            <!-- ko template: { name: 'objecteditorproperty', afterRender: $parent.koAfterRender } -->\r\n            <!-- /ko -->\r\n        </tbody>\r\n    </table>\r\n</script>\r\n<script type=\"text/html\" id=\"objecteditorproperty\">\r\n    <tr data-bind=\"click: $parent.changeActiveProperty($data), css: {'active': $parent.koActiveProperty() == $data}\">\r\n        <td width=\"50%\">\r\n            <span data-bind=\"text: displayName, attr: {title: title || displayName}\"></span>\r\n        </td>\r\n        <td class=\"svd-light-text-color form-group\" width=\"50%\">\r\n            <div data-bind=\"event: { keydown: $data.editor.keyDownHandler }\">\r\n                <!-- ko template: { name: 'propertyeditor-' + editorTypeTemplate, data: $data.editor } -->\r\n                <!-- /ko -->\r\n            </div>\r\n        </td>\r\n    </tr>\r\n</script>";

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports = "<script type=\"text/html\" id=\"svd-page-selector-template\">\r\n  <div class=\"svd-page-selector svd_custom_select svd-light-bg-color svd-light-border-color\">\r\n      <select onmousewheel=\"return false;\" data-bind=\"options: pagesSelection, value: pageSelection, optionsText: getDisplayText\"></select>\r\n  </div>\r\n  <div tabindex=\"0\" class=\"svd-page-scroller-arrow\" data-bind=\"key2click, clickNoFocus: moveLeft, attr: {title: getLocString('ed.moveLeft')}\">\r\n      <span>\r\n          <svg-icon class=\"svd-secondary-icon\" params=\"iconName: 'icon-left'\"></svg-icon>\r\n      </span>\r\n  </div>\r\n\r\n  <div class=\"svd-pages\" data-bind=\"sortable: {foreach: editor.pages, options: sortableOptions}, event: {wheel: onWheel}\">\r\n      <div tabindex=\"0\" class=\"svd-page svd-light-border-color\" data-bind=\"key2click, css: $parent.getPageClass($data), clickNoFocus: $parent.onPageClick\">\r\n          <span class=\"svd-page-name\" data-bind=\"text: $parent.getDisplayText($data)\"></span>\r\n          <span class=\"svd-page-actions-container\">\r\n              <svg-icon data-bind=\"css: $parent.getPageMenuIconClass($data)\" params=\"iconName: $parent.getPageMenuIconClass($data), size: 12\"></svg-icon>\r\n              <div style=\"position: static\">\r\n                  <div class=\"svd-page-actions svd-dark-border-color svd-light-bg-color\" data-bind=\"visible: $parent.showActions($data)\">\r\n                      <span class=\"svd-page-action\" data-bind=\"click: function(model, event) {$parent.showPageSettings($data); event.stopPropagation();}, attr: {title: $parent.getLocString('ed.editPage')}\">\r\n                          <span>\r\n                              <svg-icon class=\"svd-primary-icon\" params=\"iconName: 'icon-actioneditelement'\"></svg-icon>\r\n                          </span>\r\n                          <span class=\"svd-main-color\" data-bind=\"text: $parent.getLocString('ed.edit')\"></span>\r\n                      </span>\r\n                      <span class=\"svd-page-action\" data-bind=\"click: function(model, event) {$parent.deletePage($data); event.stopPropagation();}, attr: {title: $parent.getLocString('ed.deletePage')}, visible: !$parent.isLastPage()\">\r\n                          <svg-icon class=\"svd-primary-icon\" params=\"iconName: 'icon-actiondelete'\"></svg-icon>\r\n                      </span>\r\n                      <span class=\"svda_action_separator svd-dark-border-color\" data-bind=\"visible: !$parent.isLastPage()\"></span>\r\n                      <span class=\"svd-page-action\" data-bind=\"click: function(model, event) {$parent.copyPage($data); event.stopPropagation();}, attr: {title: $parent.getLocString('survey.Copy')}\">\r\n                          <svg-icon class=\"svd-primary-icon\" params=\"iconName: 'icon-actioncopy'\"></svg-icon>\r\n                      </span>\r\n                  </div>\r\n              </div>\r\n          </span>\r\n      </div>\r\n  </div>\r\n  <div tabindex=\"0\" class=\"svd-page-scroller-arrow\" data-bind=\"key2click, clickNoFocus: moveRight, attr: {title: getLocString('ed.moveRight')}\">\r\n      <span>\r\n          <svg-icon class=\"svd-secondary-icon\" params=\"iconName: 'icon-right'\"></svg-icon>\r\n      </span>\r\n  </div>\r\n  <div tabindex=\"0\" class=\"svd-page-add\" data-bind=\"key2click, clickNoFocus: addPage, attr: {title: getLocString('ed.addNewPage')}\">\r\n      <span>\r\n          <svg-icon class=\"svd-secondary-icon\" params=\"iconName: 'icon-add'\"></svg-icon>\r\n      </span>\r\n  </div>\r\n</script>\r\n";

/***/ }),
/* 91 */
/***/ (function(module, exports) {

module.exports = "<script type=\"text/html\" id=\"propertyeditor-boolean\">\r\n    <div class=\"sjs-cb-wrapper\">\r\n        <label>\r\n            <div class=\"sjs-cb-container\">\r\n                <input class=\"svd_editor_control\" type=\"checkbox\" data-bind=\"checked: koValue, disable: $data.readOnly\">\r\n                <span class=\"checkmark\" data-bind=\"css: { 'svd-main-background-color': koValue, 'svd-light-background-color': !koValue() }\"></span>\r\n                <!-- ko if: $data.isDiplayNameVisible -->\r\n                <span class=\"sjs-cb-label\" data-bind=\"text: $data.displayName\"></span>\r\n                <!-- /ko -->\r\n            </div>\r\n        </label>\r\n    </div>\r\n</script>";

/***/ }),
/* 92 */
/***/ (function(module, exports) {

module.exports = "<script type=\"text/html\" id=\"propertyeditor-cells\">\r\n    <!-- ko template: { name: 'propertyeditor-modal', data: $data } -->\r\n    <!-- /ko -->\r\n</script>\r\n<script type=\"text/html\" id=\"propertyeditorcontent-cells\">\r\n    <div class=\"panel card\">\r\n        <div data-bind=\"visible:!koCanEdit(), text: $root.getLocString('pe.cellsEmptyRowsColumns')\"></div>\r\n        <div  data-bind=\"visible: koCanEdit\" style=\"overflow:auto\">\r\n            <table class=\"table\">\r\n                <thead>\r\n                    <tr>\r\n                        <th></th>\r\n                        <!-- ko foreach: koColumns -->\r\n                        <th>\r\n                            <span data-bind=\"text:$data\"></span>\r\n                        </th>\r\n                        <!-- /ko -->\r\n                    </tr>\r\n                </thead>\r\n                <tbody>\r\n                    <!-- ko foreach: koRows  -->\r\n                    <tr>\r\n                        <td>\r\n                        <span data-bind=\"text:rowText\"></span>\r\n                        </td>\r\n                        <!-- ko foreach: koCells -->\r\n                        <td style=\"min-width:120px\" class=\"form-group\">\r\n                            <textarea rows=\"2\" cols=\"25\" class=\"form-control\" data-bind=\"textInput:text\"></textarea>\r\n                        </td>\r\n                        <!-- /ko -->\r\n                    </tr>\r\n                    <!-- /ko -->\r\n                </tbody>\r\n            </table>\r\n        </div>\r\n    </div>\r\n</script>";

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports = "<script type=\"text/html\" id=\"propertyeditor-condition\">\r\n  <!-- ko template: { name: 'propertyeditor-modal', data: $data } -->\r\n  <!-- /ko -->\r\n</script>\r\n\r\n<script type=\"text/html\" id=\"propertyeditorcontent-condition\">\r\n  <div class=\"propertyeditor-condition\">\r\n      <div class=\"form-inline form-group\">\r\n          <div class=\"form-control svd_custom_select\">\r\n              <select onmousewheel=\"return false;\" style=\"max-width:200px\" data-bind=\"value: koAddConditionQuestion\">\r\n                <option data-bind=\"text: addConditionQuestionOptions, attr: {title: addConditionQuestionOptions}\" ></option>\r\n                <!-- ko foreach: koAddConditionQuestions -->\r\n                <option data-bind=\"value: name, text: (text || '').substring(0, 80), attr: {title: text}\" ></option>\r\n                <!-- /ko -->\r\n              </select>\r\n          </div>\r\n          <div class=\"form-control svd_custom_select\">\r\n              <select onmousewheel=\"return false;\" data-bind=\"options:availableOperators, optionsValue: 'name', optionsText: 'text', value:koAddConditionOperator\"></select>\r\n          </div>\r\n          <input class=\"form-control\" type=\"text\" data-bind=\"textInput:koAddConditionValue, enable: koAddContionValueEnabled\" style=\"width:120px\"\r\n          />\r\n          <input type=\"button\" class=\"form-control btn btn-primary\" data-bind=\"enable: koCanAddCondition, click: onConditionAddClick, value: koAddConditionButtonText\"\r\n          />\r\n          <div class=\"svd_wrap_elements\" data-bind=\"visible:koHasValueSurvey\">\r\n              <survey-widget params=\"survey: koValueSurvey\"></survey-widget>\r\n          </div>\r\n      </div>\r\n      <!-- ko if: $parent.hasAceEditor -->\r\n      <span data-bind=\"text:$data.getLocString('pe.aceEditorHelp')\"></span>\r\n      <div id=\"expression-ace-editor\" style=\"height: 200px; width: 100%;\" data-bind=\"value:koValue, aceEditor:{questions: $parent.availableQuestions, question: $data.editingObject, editor: $parent}\"></div>\r\n      <!-- /ko -->\r\n\r\n      <!-- ko if: !$parent.hasAceEditor -->\r\n      <textarea class=\"svd-dark-border-color\" data-bind=\"value:koTextValue\" rows=\"4\" autofocus=\"autofocus\"></textarea>\r\n      <!-- /ko -->\r\n\r\n      <!-- <div class=\"assistant\">\r\n          <div class=\"assistant-title\" data-bind=\"text:$data.getLocString('pe.assistantTitle')\"></div>\r\n          <div class=\"assistant-content\" data-bind=\"foreach:availableQuestions\">\r\n              <div class=\"assistant-item\" data-bind=\" text:name, click:function () { $parent.insertQuestion($data, $element); } \"></div>\r\n          </div>\r\n      </div> -->\r\n      <!-- ko if: showHelpText -->\r\n      <span data-bind=\"text:$data.getLocString('pe.conditionHelp')\" style=\"white-space:normal \"></span>\r\n      <div data-bind=\"visible: $data.hasLocString('pe.conditionShowMoreUrl')\">\r\n          <a data-bind=\"attr: { href: $data.getLocString('pe.conditionShowMoreUrl')}, text:$data.getLocString('pe.showMore')\" target=\"_blank\"></a>\r\n      </div>\r\n      <!-- /ko -->\r\n  </div>\r\n</script>\r\n";

/***/ }),
/* 94 */
/***/ (function(module, exports) {

module.exports = "<script type=\"text/html\" id=\"propertyeditor-custom\">\r\n    <!-- ko template: { name: \"propertyeditor-customcontent\", data: $data, afterRender: $data.koAfterRender } --><!-- /ko -->\r\n</script>\r\n<script type=\"text/html\" id=\"propertyeditor-customcontent\"><div></div></script>";

/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports = "<script type=\"text/html\" id=\"propertyeditor-value\">\r\n    <!-- ko template: { name: 'propertyeditor-modal', data: $data } -->\r\n    <!-- /ko -->\r\n</script>\r\n\r\n<script type=\"text/html\" id=\"propertyeditorcontent-value\">\r\n    <form>\r\n        <div class=\"svd_wrap_elements\">\r\n            <survey-widget params=\"survey: koSurvey\"></survey-widget>\r\n        </div>\r\n    </form>\r\n</script>";

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports = "<script type=\"text/html\" id=\"propertyeditor-dropdown\">\r\n    <div class=\"svd_custom_select svd_property_editor_dropdown\">\r\n        <select onmousewheel=\"return false;\" class=\"form-control svd_editor_control\" data-bind=\"value: koValue, disable: readOnly, options: koChoices,  optionsValue: 'value',  optionsText: 'text', hasFocus: koHasFocus\"  style=\"width:100%\"></select>\r\n    </div>\r\n</script>";

/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports = "<script type=\"text/html\" id=\"propertyeditor-error\">\r\n    <div class=\"alert alert-danger\" role=\"alert\" data-bind=\"visible:koDisplayError\">\r\n        <span class=\"glyphicon glyphicon-exclamation-sign\" aria-hidden=\"true\"></span>\r\n        <span class=\"sr-only\">Error:</span>\r\n        <span data-bind=\"text:koErrorText\"></span>\r\n    </div>\r\n</script>";

/***/ }),
/* 98 */
/***/ (function(module, exports) {

module.exports = "<script type=\"text/html\" id=\"propertyeditor-expression\">\r\n    <!-- ko template: { name: 'propertyeditor-modal', data: $data } -->\r\n    <!-- /ko -->\r\n</script>\r\n\r\n<script type=\"text/html\" id=\"propertyeditorcontent-expression\">\r\n    <div class=\"propertyeditor-expression\">\r\n        <!-- ko if: $parent.hasAceEditor -->\r\n        <span data-bind=\"text:$root.getLocString('pe.aceEditorHelp')\"></span>\r\n        <div id=\"expression-ace-editor\" style=\"height: 400px; width: 100%;\" data-bind=\"value:koValue, aceEditor: {questions: $parent.availableQuestions, question: $data.editingObject, editor: $parent}\"></div>\r\n        <!-- /ko -->\r\n\r\n        <!-- ko if: !$parent.hasAceEditor -->\r\n        <textarea class=\"svd-dark-border-color\" data-bind=\"value:koTextValue\" rows=\"4\" autofocus=\"autofocus\"></textarea>\r\n        <!-- /ko -->\r\n        <!-- <div class=\"assistant\">\r\n            <div class=\"assistant-title\" data-bind=\"text:$root.getLocString('pe.assistantTitle')\"></div>\r\n            <div class=\"assistant-content\" data-bind=\"foreach:availableQuestions\">\r\n                <div class=\"assistant-item\" data-bind=\"text:name, click:function () { $parent.insertQuestion($data, $element); } \"></div>\r\n            </div>\r\n        </div> -->\r\n        <!-- ko if: showHelpText -->        \r\n            <span data-bind=\"text:$root.getLocString('pe.expressionHelp')\" style=\"white-space:normal\"></span>\r\n            <!-- <div>\r\n                <a data-bind=\"text:$root.getLocString('pe.showMore')\" target=\"_blank\" href=\"https://surveyjs.io/Documentation/LibraryParameter?id=Question&parameter=visibleIf\"></a>\r\n            </div> -->\r\n        <!-- /ko -->\r\n    </div>\r\n</script>";

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports = "<script type=\"text/html\" id=\"propertyeditor-html\">\r\n  <!-- ko template: { name: 'propertyeditor-modal', data: $data } --><!-- /ko -->\r\n</script>\r\n\r\n<script type=\"text/html\" id=\"propertyeditorcontent-html\">\r\n  <textarea class=\"form-control\" data-bind=\"value:koValue, disable: readOnly\" style=\"width:100%;height:auto\" rows=\"10\" autofocus=\"autofocus\"></textarea>\r\n</script>\r\n";

/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports = "<script type=\"text/html\" id=\"propertyeditor-itemvalues\">\r\n    <!-- ko template: { name: 'propertyeditor-modal' } -->\r\n    <!-- /ko -->\r\n</script>\r\n<script type=\"text/html\" id=\"propertyeditorcontent-itemvalues\">\r\n    <div style=\"margin-bottom:3px\" data-bind=\"visible: koIsList() && koShowTextView()\">\r\n        <button class=\"btn btn-sm btn-xs\" data-bind=\"css: {'btn-primary': koActiveView() === 'form', 'btn-link': koActiveView() !== 'form'}, click:changeToFormViewClick, text: $root.getLocString('pe.formEntry')\"></button>\r\n        <button class=\"btn btn-sm btn-xs\" data-bind=\"css: {'btn-primary': koActiveView() !== 'form', 'btn-link': koActiveView() === 'form'}, click:changeToTextViewClick, text: $root.getLocString('pe.fastEntry')\"></button>\r\n    </div>\r\n    <div data-bind=\"visible: koActiveView() == 'form'\">\r\n        <!-- ko template: { name: 'propertyeditorcontent-nesteditems', data: $data } -->\r\n        <!-- /ko -->\r\n    </div>\r\n    <div data-bind=\"visible:koIsList() && koActiveView() != 'form'\">\r\n        <textarea class=\"form-control\" data-bind=\"textInput: koItemsText\" style=\"overflow-y: auto; overflow-x:hidden; max-height:400px; min-height:250px; width:100%\"></textarea>\r\n    </div>\r\n</script>";

/***/ }),
/* 101 */
/***/ (function(module, exports) {

module.exports = "<script type=\"text/html\" id=\"propertyeditor-matrixdropdowncolumns\">\r\n    <!-- ko template: { name: 'propertyeditor-modal', data: $data } -->\r\n    <!-- /ko -->\r\n</script>\r\n<script type=\"text/html\" id=\"propertyeditorcontent-matrixdropdowncolumns\">\r\n    <!-- ko template: { name: 'propertyeditorcontent-nesteditems', data: $data } -->\r\n    <!-- /ko -->\r\n</script>";

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports = "<script type=\"text/html\" id=\"propertyeditor-modal\">\r\n    <div class=\"input-group form-group\" data-bind=\"visible:!$data.isEditable\">\r\n        <a tabindex=\"0\" class=\"form-control\" data-bind=\"key2click, click: $data.onShowModal, attr: {'data-target' : modalNameTarget}\">\r\n            <span data-bind=\"text: koText\"></span>\r\n        </a>\r\n        <div class=\"input-group-addon\">\r\n            <span class=\"glyphicon glyphicon-edit\" aria-hidden=\"true\" data-bind=\"click: $data.onShowModal, attr: {'data-target' : modalNameTarget}, text: $root.getLocString('pe.edit')\"></span>\r\n        </div>\r\n    </div>\r\n    <div class=\"input-group form-group\" data-bind=\"visible:$data.isEditable\">\r\n        <input class=\"form-control svd_editor_control\" type=\"text\" data-bind=\"value: koValue\" />\r\n        <div class=\"input-group-addon\">\r\n            <span class=\"glyphicon glyphicon-edit\" aria-hidden=\"true\" data-bind=\"click: $data.onShowModal, attr: {'data-target' : modalNameTarget}, text: $root.getLocString('pe.edit')\"></span>\r\n        </div>\r\n    </div>\r\n\r\n    <div data-bind=\"attr: {id : modalName}\" class=\"modal\" role=\"dialog\">\r\n        <div class=\"modal-dialog\">\r\n            <div class=\"modal-content\">\r\n                <div class=\"modal-header\">\r\n                    <button type=\"button\" class=\"close\" data-bind=\"click: onResetClick\">&times;</button>\r\n                    <h4 class=\"modal-title\" data-bind=\"text:$data.koTitleCaption\"></h4>\r\n                </div>\r\n                <div class=\"modal-body svd_notopbottompaddings\">\r\n                    <!-- ko template: {name: 'propertyeditor-error', data: $data} -->\r\n                    <!-- /ko -->\r\n                    <!-- ko template: { name: 'propertyeditor-modalcontent', data: $data } -->\r\n                    <!-- /ko -->\r\n                </div>\r\n                <div class=\"modal-footer\">\r\n                    <input type=\"button\" class=\"btn btn-primary\" data-bind=\"visible: $data.koShowApplyButton, click: $data.onApplyClick, value: $root.getLocString('pe.apply')\"\r\n                        style=\"width:100px\" />\r\n                    <input type=\"button\" class=\"btn btn-default btn-secondary\" data-bind=\"click: $data.onOkClick, value: $root.getLocString('pe.ok')\"\r\n                        style=\"width:100px\" />\r\n                    <input type=\"button\" class=\"btn btn-primary\" data-bind=\"click: $data.onResetClick, value: $root.getLocString('pe.cancel')\"\r\n                        style=\"width:100px\" />\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</script>";

/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports = "<script type=\"text/html\" id=\"propertyeditor-modalcontent\">\r\n    <div data-bind=\"html: $data.koHtmlTop\"></div>\r\n    <!-- ko template: { name: 'propertyeditorcontent-' + editorTypeTemplate, data: $data, afterRender: $data.koAfterRender } -->\r\n    <!-- /ko -->\r\n    <div data-bind=\"html: $data.koHtmlBottom\"></div>\r\n</script>";

/***/ }),
/* 104 */
/***/ (function(module, exports) {

module.exports = "<script type=\"text/html\" id=\"propertyeditor-multiplevalues\">\r\n    <!-- ko template: { name: 'propertyeditor-modal', data: $data } -->\r\n    <!-- /ko -->\r\n</script>\r\n<script type=\"text/html\" class=\"btn-xs\" id=\"propertyeditorcontent-multiplevalues\">\r\n    <div style=\"max-height:300px; overflow-y:scroll;\">\r\n        <!-- ko foreach: { data: koItems, as: 'item'}  -->\r\n        <div class=\"sjs-cb-wrapper\" data-bind=\"style:{display: 'inline-block'\">\r\n            <label>\r\n                <div class=\"sjs-cb-container\">\r\n                    <input type=\"checkbox\" data-bind=\"attr: {value: item.value}, checked: $parent.koEditingValue\" />\r\n                    <span class=\"checkmark\" data-bind=\"css: $parent.getBackgroundCls(item.value)\">\r\n                        <span class=\"check\"></span>\r\n                    </span>\r\n                    <span class=\"sjs-cb-label\" style=\"position: static;\" data-bind=\"text: item.text\"></span>\r\n                </div>\r\n            </label>\r\n        </div>\r\n        <!-- /ko -->\r\n    </div>\r\n</script>";

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports = "<script type=\"text/html\" id=\"propertyeditorcontent-nested\">\r\n    <div style=\"padding-left: 10px;\">\r\n        <button type=\"button\" class=\"btn btn-sm btn-secondary\" data-bind=\"click: onCancelEditItemClick\">\r\n            <span class=\"glyphicon glyphicon-list-alt\"></span>\r\n        </button>\r\n        <span data-bind=\"text: koEditorName\"></span>\r\n      <!-- ko template: { name: \"questioneditor-content\", data: koEditItem().itemEditor } -->\r\n      <!-- /ko -->\r\n  </div>\r\n</script>\r\n";

/***/ }),
/* 106 */
/***/ (function(module, exports) {

module.exports = "<script type=\"text/html\" id=\"propertyeditorcontent-nesteditems\">\r\n    <div data-bind=\"visible: koIsList\"  style=\"overflow-y: auto; overflow-x:hidden; max-height:400px;min-height:200px\">\r\n        <table class=\"svd_items_table\">\r\n            <thead>\r\n                <tr>\r\n                    <th></th>\r\n                    <!-- ko foreach: columns -->\r\n                    <th data-bind=\"text: text\"></th>\r\n                    <!-- /ko -->\r\n                    <th></th>\r\n                </tr>\r\n            </thead>\r\n            <tbody data-bind=\"sortable: { foreach: koItems, options: { handle: '.svd-drag-handle', animation: 150 } }\">\r\n                <tr>\r\n                    <td class=\"svd-itemvalue-actions-container\">\r\n                        <div class=\"svd-drag-handle svd-itemvalue-action\">\r\n                            ☰\r\n                        </div>\r\n                        <button type=\"button\" class=\"btn btn-default btn-secondary svd-textitems-edit svd-itemvalue-action\" data-bind=\"click: $parent.onEditItemClick\">\r\n                            <span class=\"glyphicon glyphicon-edit\" data-bind=\"text: $root.getLocString('pe.edit')\"></span>\r\n                        </button>\r\n                    </td>\r\n                    <!-- ko foreach: cells -->\r\n                    <td class=\"form-group\">\r\n                        <!-- ko template: { name: 'propertyeditor', data: objectProperty.editor } -->\r\n                        <!-- /ko -->\r\n                    </td>\r\n                    <!-- /ko -->\r\n                    <td class=\"svd-textitems-column\">\r\n                        <button type=\"button\" class=\"btn btn-sm btn-danger\" data-bind=\"visible: $parent.koAllowAddRemoveItems, click: $parent.onDeleteClick\">\r\n                            <span class=\"glyphicon glyphicon-remove\" aria-hidden=\"true\"></span>\r\n                        </button>\r\n                    </td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n        <div class=\"svd-items-control-footer\" data-bind=\"visible: koAllowAddRemoveItems\">\r\n            <input type=\"button\" class=\"btn btn-primary\" data-bind=\"click: onAddClick, value: $root.getLocString('pe.addNew')\" />\r\n            <input type=\"button\" class=\"btn btn-danger\" data-bind=\"click: onClearClick, value: $root.getLocString('pe.removeAll')\" />\r\n        </div>\r\n    </div>\r\n    <!-- ko if: !koIsList() -->\r\n    <!-- ko template: { name: \"propertyeditorcontent-nested\", data: $data } -->\r\n    <!-- /ko -->\r\n    <!-- /ko -->\r\n</script>";

/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports = "<script type=\"text/html\" id=\"propertyeditor-number\">\r\n    <input class=\"form-control svd_editor_control\" type=\"number\" data-bind=\"value: koValue, disable: readOnly\" style=\"width:100%\" />\r\n</script>";

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports = "<script type=\"text/html\" id=\"propertyeditor-restfull\">\r\n  <!-- ko template: { name: 'propertyeditor-modal', data: $data } -->\r\n  <!-- /ko -->\r\n</script>\r\n\r\n<script type=\"text/html\" id=\"propertyeditorcontent-restfull\">\r\n  <form>\r\n      <div class=\"form-group\" data-bind=\"foreach: koItems\">\r\n          <div class=\"form-group\">\r\n              <label data-bind=\"attr: {for: name}, text: $root.getLocString('pe.'+name)\"></label>\r\n              <input type=\"text\" data-bind=\"attr: {id: name}, value:koValue\" class=\"form-control\"></input>\r\n          </div>\r\n      </div>\r\n      <div class=\"form-group\">\r\n          <label for=\"titleName\">\r\n              <span data-bind=\"text:$root.getLocString('pe.testService')\"></span>\r\n          </label>\r\n          <div class=\"form-control svd_custom_select\" style=\"display: block;\">\r\n              <select onmousewheel=\"return false;\" data-bind=\"options: question.visibleChoices, optionsText: 'text', optionsValue: 'value', optionsCaption: question.optionsCaption\"></select>\r\n          </div>\r\n      </div>\r\n  </form>\r\n</script>\r\n";

/***/ }),
/* 109 */
/***/ (function(module, exports) {

module.exports = "<script type=\"text/html\" id=\"propertyeditor-string\">\r\n    <input class=\"form-control svd_editor_control\" type=\"text\" data-bind=\"value: koValue, disable: readOnly, attr: {placeholder: defaultValue}\" style=\"width:100%\" />\r\n</script>";

/***/ }),
/* 110 */
/***/ (function(module, exports) {

module.exports = "<script type=\"text/html\" id=\"propertyeditor-text\">\r\n  <!-- ko template: { name: 'propertyeditor-modal', data: $data } --><!-- /ko -->\r\n</script>\r\n\r\n<script type=\"text/html\" id=\"propertyeditorcontent-text\">\r\n  <textarea class=\"form-control\" data-bind=\"value:koValue, disable: readOnly, attr: {rows: isDiplayNameVisible ? '2' : '5'}\" style=\"width:100%;height:auto\" autofocus=\"autofocus\"></textarea>\r\n</script>\r\n";

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports = "<script type=\"text/html\" id=\"propertyeditor-textitems\">\r\n    <!-- ko template: { name: 'propertyeditor-modal', data: $data } -->\r\n    <!-- /ko -->\r\n</script>\r\n<script type=\"text/html\" id=\"propertyeditorcontent-textitems\">\r\n    <!-- ko template: { name: 'propertyeditorcontent-nesteditems', data: $data } -->\r\n    <!-- /ko -->\r\n</script>";

/***/ }),
/* 112 */
/***/ (function(module, exports) {

module.exports = "<script type=\"text/html\" id=\"propertyeditor-triggers\">\r\n    <!-- ko template: { name: 'propertyeditor-modal', data: $data } -->\r\n    <!-- /ko -->\r\n</script>\r\n<script type=\"text/html\" id=\"propertyeditorcontent-triggers\">\r\n    <div class=\"propertyeditor-triggers\">\r\n        <div class=\"input-group form-group\">\r\n            <div class=\"input-group-addon first-addon\" data-bind=\"visible: koAllowAddRemoveItems\">\r\n                <div class=\"ddmenu-container\">\r\n                    <div style=\"-webkit-tap-highlight-color:rgba(0,0,0,0)\" data-bind=\"trueclick\"></div>\r\n\r\n                    <div class=\"ddmenu\">\r\n                        <span tabindex=\"0\" data-bind=\"attr: { title: $root.getLocString('pe.addNew') }\">\r\n                            <span class=\"glyphicon glyphicon-plus svd-main-color\"></span>\r\n                        </span>\r\n                        <div tabindex=\"0\" data-bind=\"trueclick\"></div>\r\n                        <ul class=\"svd-light-bg-color\">\r\n                            <!-- ko foreach: koTriggers -->\r\n                            <li>\r\n                                <a data-bind=\"click: $parent.onAddClick, text:$data.text\"></a>\r\n                            </li>\r\n                            <!-- /ko  -->\r\n                        </ul>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div class=\"form-control svd_custom_select\">\r\n                <select onmousewheel=\"return false;\" data-bind=\"options: koItems, optionsText: 'koText', value: koSelected\"></select>\r\n            </div>\r\n            <span data-bind=\"visible: koAllowAddRemoveItems, attr: { title: $root.getLocString('pe.delete') }, enable: koSelected() != null, click: onDeleteClick\"\r\n                class=\"input-group-addon btn-danger\">\r\n                <span class=\"glyphicon glyphicon-remove\"></span>\r\n            </span>\r\n        </div>\r\n        <div data-bind=\"visible: koSelected() == null\">\r\n            <div data-bind=\"visible: koQuestionNames().length == 0, text: $root.getLocString('pe.noquestions')\"></div>\r\n            <div data-bind=\"visible: koQuestionNames().length > 0, text: $root.getLocString('pe.createtrigger')\"></div>\r\n        </div>\r\n        <div data-bind=\"visible: koSelected() != null\">\r\n            <div data-bind=\"with: koSelected\">\r\n                <!-- ko if: conditionEditor != null -->\r\n                    <!-- ko template: { name: 'propertyeditorcontent-condition', data: conditionEditor } -->\r\n                    <!-- /ko -->\r\n                <!-- /ko -->\r\n                <!-- ko if: conditionEditor == null -->\r\n                <div class=\"form-inline form-group\">\r\n                    <span class=\"input-group\" data-bind=\"text: $root.getLocString('pe.triggerOn')\"></span>\r\n                    <div class=\"form-control svd_custom_select\">\r\n                        <select onmousewheel=\"return false;\" data-bind=\"options:$parent.koQuestionNames, value: koName\"></select>\r\n                    </div>\r\n                    <div class=\"form-control svd_custom_select\">\r\n                        <select onmousewheel=\"return false;\" data-bind=\"options:availableOperators, optionsValue: 'name', optionsText: 'text', value:koOperator\"></select>\r\n                    </div>\r\n                    <input class=\"form-control\" type=\"text\" data-bind=\"visible: koRequireValue, value:koValue\" />\r\n                </div>\r\n                <!-- /ko -->\r\n                <!-- ko if: koType() == 'visibletrigger' -->\r\n                <div class=\"row\">\r\n                    <div class=\"col-lg-6 col-sm-6\">\r\n                        <!-- ko template: { name: 'propertyeditor-triggersitems', data: pages } -->\r\n                        <!-- /ko -->\r\n                    </div>\r\n                    <div class=\"col-lg-6 col-sm-6\">\r\n                        <!-- ko template: { name: 'propertyeditor-triggersitems', data: questions } -->\r\n                        <!-- /ko -->\r\n                    </div>\r\n                </div>\r\n                <!-- /ko -->\r\n                <!-- ko if: koType() == 'completetrigger' -->\r\n                <div class=\"row\">\r\n                    <div style=\"margin: 10px\" data-bind=\"text: $root.getLocString('pe.triggerCompleteText')\"></div>\r\n                </div>\r\n                <!-- /ko -->\r\n                <!-- ko if: koType() == 'setvaluetrigger' -->\r\n                <div class=\"row col-lg-12 col-sm-12\">\r\n                    <div data-bind=\"text: $root.getLocString('pe.triggerSetToName')\"></div>\r\n                </div>\r\n                <div class=\"row\">\r\n                    <div class=\"col-lg-6 col-sm-6\">\r\n                        <div class=\"form-group\">\r\n                            <input class=\"form-control\" type=\"text\" data-bind=\"value:kosetToName, visible: koisVariable\" />\r\n                            <div class=\"form-control svd_custom_select\" data-bind=\"visible: !koisVariable()\">\r\n                                <select onmousewheel=\"return false;\" data-bind=\"options:koQuestions, value: kosetToName, optionsText: 'text', optionsValue: 'name', optionsCaption: setToNameOptions\"></select>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"col-lg-6 col-sm-6\">\r\n                        <!-- ko template: { name: \"propertyeditor-boolean\", data: { koValue: koisVariable, displayName: $root.getLocString('pe.triggerIsVariable'), isDiplayNameVisible: true } } -->\r\n                        <!-- /ko -->\r\n                    </div>\r\n                    <div class=\"col-lg-12 col-sm-12\">\r\n                        <div class=\"form-group\" data-bind=\"visible:koisVariable\">\r\n                            <div data-bind=\"text: $root.getLocString('pe.triggerSetValue')\"></div>\r\n                            <input class=\"form-control\" type=\"text\" data-bind=\"value:kosetValue\" />\r\n                        </div>\r\n                        <div class=\"form-group\" data-bind=\"visible:koHasSurvey\">\r\n                            <survey-widget params=\"survey: koSurvey\"></survey-widget>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <!-- /ko -->\r\n                <!-- ko if: koType() == 'copyvaluetrigger' -->\r\n                <div class=\"row\">\r\n                    <div class=\"col-lg-6 col-sm-6\">\r\n                        <div class=\"form-group\">\r\n                            <div data-bind=\"text: $root.getLocString('pe.triggerSetToName')\"></div>\r\n                            <input class=\"form-control\" type=\"text\" data-bind=\"value:kosetToName\" />\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"col-lg-6 col-sm-6\">\r\n                        <div class=\"form-group\">\r\n                            <div data-bind=\"text: $root.getLocString('pe.triggerFromName')\"></div>\r\n                            <input class=\"form-control\" type=\"text\" data-bind=\"value:kofromName\" />\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <!-- /ko -->\r\n                <!-- ko if: koType() == 'runexpressiontrigger' -->\r\n                <div class=\"row\">\r\n                    <div class=\"form-group col-lg-12 col-sm-12\">\r\n                        <div data-bind=\"text: $root.getLocString('pe.triggerSetToName')\"></div>\r\n                        <input class=\"form-control\" type=\"text\" data-bind=\"value:kosetToName\" />\r\n                        <div data-bind=\"text: $root.getLocString('pe.triggerRunExpression')\"></div>\r\n                        <textarea class=\"form-control\" type=\"text\" data-bind=\"value:korunExpression\" rows=\"3\"></textarea>\r\n                    </div>\r\n                </div>\r\n                <!-- /ko -->\r\n            </div>\r\n        </div>\r\n    </div>\r\n</script>";

/***/ }),
/* 113 */
/***/ (function(module, exports) {

module.exports = "<script type=\"text/html\" id=\"propertyeditor-triggersitems\">\r\n  <div>\r\n      <div class=\"form-group\" data-bind=\"text: title\"></div>\r\n      <div class=\"form-group input-group\">\r\n          <select onmousewheel=\"return false;\" class=\"form-control\" multiple=\"multiple\" data-bind=\"options:koChoosen, value: koChoosenSelected, optionsText: 'text'\"></select>\r\n          <span class=\"input-group-addon btn-danger\" data-bind=\"click: deleteItem\">\r\n              <span class=\"glyphicon glyphicon-remove\"></span>\r\n          </span>\r\n      </div>\r\n      <div class=\"form-group input-group\">\r\n          <div class=\"form-control svd_custom_select\">\r\n              <select onmousewheel=\"return false;\" data-bind=\"options:koObjects, value: koSelected, optionsText: 'text'\"></select>\r\n          </div>\r\n          <span class=\"input-group-addon btn-default\" data-bind=\"click: addItem\">\r\n              <span class=\"glyphicon glyphicon-plus svd-main-color\"></span>\r\n          </span>\r\n      </div>\r\n  </div>\r\n</script>\r\n";

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports = "<script type=\"text/html\" id=\"propertyeditor-validators\">\r\n    <!-- ko template: { name: 'propertyeditor-modal', data: $data } -->\r\n    <!-- /ko -->\r\n</script>\r\n<script type=\"text/html\" id=\"propertyeditorcontent-validators\">\r\n    <div class=\"propertyeditor-validators\">\r\n        <div class=\"input-group form-group\">\r\n            <div class=\"input-group-addon first-addon\" data-bind=\"visible: koAllowAddRemoveItems\">\r\n                <div class=\"ddmenu-container\">\r\n                    <div style=\"-webkit-tap-highlight-color:rgba(0,0,0,0)\" data-bind=\"trueclick\"></div>\r\n\r\n                    <div class=\"ddmenu\">\r\n                        <span tabindex=\"0\">\r\n                            <span class=\"glyphicon glyphicon-plus svd-main-color\"></span>\r\n                        </span>\r\n\r\n                        <div tabindex=\"0\" data-bind=\"trueclick\"></div>\r\n                        <ul class=\"svd-light-bg-color\">\r\n                            <!-- ko foreach: koValidators -->\r\n                            <li>\r\n                                <a href=\"#\" data-bind=\"click: $parent.onAddClick\">\r\n                                    <span data-bind=\"text:$data.text\"></span>\r\n                                </a>\r\n                            </li>\r\n                            <!-- /ko  -->\r\n                        </ul>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div class=\"form-control svd_custom_select\">\r\n                <select onmousewheel=\"return false;\" data-bind=\"options: koItems, optionsText: 'text', value: koSelected\"></select>\r\n            </div>\r\n            <span class=\"input-group-addon btn-danger\" data-bind=\"visible: koAllowAddRemoveItems, enable: koSelected() != null, click: onDeleteClick\">\r\n                <span class=\"glyphicon glyphicon-remove\"></span>\r\n            </span>\r\n        </div>\r\n        <div data-bind=\"template: { name: 'objecteditor', data: selectedObjectEditor }\"></div>\r\n    </div>\r\n</script>";

/***/ }),
/* 115 */
/***/ (function(module, exports) {

module.exports = "<script type=\"text/html\" id=\"propertyeditor\">\r\n    <label data-bind=\"text:displayName, visible: showDisplayNameOnTop\"></label>\r\n    <!-- ko template: {name: 'propertyeditor-error', data: $data} -->\r\n    <!-- /ko -->\r\n    <!-- ko template: {name: $data.contentTemplateName, data: $data} -->\r\n    <!-- /ko -->\r\n</script>";

/***/ }),
/* 116 */
/***/ (function(module, exports) {

module.exports = "<script type=\"text/html\" id=\"questioneditor-content\">\r\n    <!-- ko if: $data.useTabsInElementEditor -->\r\n    <ul class=\"nav nav-tabs modal-tabs\" data-bind=\"foreach: koTabs\">\r\n        <li class=\"nav-item\" role=\"presentation\" data-bind=\"css: {active: $parent.koActiveTab() == $data.name}, click: $parent.onTabClick\">\r\n            <a class=\"nav-link\" data-bind=\"css: {active: $parent.koActiveTab() == $data.name}\">\r\n                <span data-bind=\"text:$data.title\"></span>\r\n            </a>\r\n        </li>\r\n    </ul>\r\n    <!-- ko foreach: koTabs -->\r\n    <div data-bind=\"if: $parent.koActiveTab() === $data.name\" style=\"margin-top:5px\">\r\n        <!-- ko template: { name: $data.htmlTemplate, data: $data.templateObject, afterRender: $data.koAfterRender } -->\r\n        <!-- /ko -->\r\n    </div>\r\n    <!-- /ko  -->\r\n    <!-- /ko  -->\r\n    <!-- ko ifnot: $data.useTabsInElementEditor -->\r\n    <svd-accordion params=\"tabs: koTabs, template: 'svd-editor-tab-template'\"></svd-accordion>\r\n    <!-- /ko  -->\r\n</script>\r\n\r\n<script type=\"text/html\" id=\"svd-editor-tab-template\">\r\n    <!-- ko template: { name: $data.htmlTemplate, data: $data.templateObject, afterRender: $data.koAfterRender } -->\r\n    <!-- /ko -->\r\n</script>";

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports = "<script type=\"text/html\" id=\"questioneditor\">\r\n    <div id=\"surveyquestioneditorwindow\" class=\"modal\" data-bind=\"with:koEditor\">\r\n        <div class=\"modal-dialog\">\r\n            <div class=\"modal-content\">\r\n                <div class=\"modal-header\">\r\n                    <button type=\"button\" class=\"close\" data-bind=\"click: onResetClick\">&times;</button>\r\n                    <h4 class=\"modal-title\" data-bind=\"text:koTitle\"></h4>\r\n                </div>\r\n                <div class=\"modal-body svd_notopbottompaddings\">\r\n                    <!-- ko template: { name: \"questioneditor-content\", data: $data } -->\r\n                    <!-- /ko -->\r\n                </div>\r\n                <div class=\"modal-footer\">\r\n                    <input type=\"button\" class=\"btn btn-primary\" data-bind=\"visible: koShowApplyButton, click: onApplyClick, value: $root.getLocString('pe.apply')\"\r\n                        style=\"width:100px\" />\r\n                    <input type=\"button\" class=\"btn btn-default btn-secondary\" data-bind=\"click: onOkClick, value: $root.getLocString('pe.ok')\"\r\n                        style=\"width:100px\" />\r\n                    <input type=\"button\" class=\"btn btn-primary\" data-bind=\"click: onResetClick, value: $root.getLocString('pe.cancel')\" style=\"width:100px\"\r\n                    />\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</script>";

/***/ }),
/* 118 */
/***/ (function(module, exports) {

module.exports = "<script type=\"text/html\" id=\"questioneditortab\">\r\n  <div class=\"row\" data-bind=\"css: 'svd-popup-editor-tab-' + name\">\r\n      <div class=\"col-sm-12\">\r\n          <!-- ko foreach: properties.rows -->\r\n          <div class=\"form-group\">\r\n              <!-- ko foreach: properties -->\r\n                  <div data-bind=\"event: { keydown: objectProperty.editor.keyDownHandler }\">\r\n                  <!-- ko template: { name: 'propertyeditor', data: objectProperty.editor } --><!-- /ko -->\r\n                  </div>\r\n              <!-- /ko  -->\r\n          </div>\r\n          <!-- /ko  -->\r\n      </div>\r\n  </div>\r\n</script>\r\n";

/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports = "<script type=\"text/html\" id=\"surveyembeding\">\r\n    <div class=\"row\">\r\n        <div class=\"form-control svd_custom_select svd_embed_tab\">\r\n            <select onmousewheel=\"return false;\" data-bind=\"value:koLibraryVersion\">\r\n                <option value=\"angular\" data-bind=\"text: $root.getLocString('ew.angular')\"></option>\r\n                <option value=\"jquery\" data-bind=\"text: $root.getLocString('ew.jquery')\"></option>\r\n                <option value=\"knockout\" data-bind=\"text: $root.getLocString('ew.knockout')\"></option>\r\n                <option value=\"react\" data-bind=\"text: $root.getLocString('ew.react')\"></option>\r\n                <option value=\"vue\" data-bind=\"text: $root.getLocString('ew.vue')\"></option>\r\n            </select>\r\n        </div>\r\n        <div class=\"form-control svd_custom_select svd_embed_tab\">\r\n            <select onmousewheel=\"return false;\" data-bind=\"value:koScriptUsing\">\r\n                <option value=\"bootstrap\" data-bind=\"text: $root.getLocString('ew.bootstrap')\"></option>\r\n                <option value=\"standard\" data-bind=\"text: $root.getLocString('ew.standard')\"></option>\r\n            </select>\r\n        </div>\r\n        <div class=\"form-control svd_custom_select svd_embed_tab\">\r\n            <select onmousewheel=\"return false;\" data-bind=\"value:koShowAsWindow\">\r\n                <option value=\"page\" data-bind=\"text: $root.getLocString('ew.showOnPage')\"></option>\r\n                <option value=\"window\" data-bind=\"text: $root.getLocString('ew.showInWindow')\"></option>\r\n            </select>\r\n        </div>\r\n        <label class=\"checkbox-inline form-check-label\" data-bind=\"visible:koHasIds\">\r\n            <input type=\"checkbox\" data-bind=\"checked:koLoadSurvey\" />\r\n            <span data-bind=\"text: $root.getLocString('ew.loadFromServer')\"></span>\r\n        </label>\r\n    </div>\r\n    <div class=\"panel card\">\r\n        <div class=\"panel-heading card-header\" data-bind=\"text: $root.getLocString('ew.titleScript')\"></div>\r\n        <div data-bind=\"visible:hasAceEditor\">\r\n            <div id=\"surveyEmbedingHead\" style=\"height:70px;width:100%\"></div>\r\n        </div>\r\n        <textarea data-bind=\"visible:!hasAceEditor, text: koHeadText\" style=\"height:70px;width:100%\"></textarea>\r\n    </div>\r\n    <div class=\"panel card\" data-bind=\"visible: koVisibleHtml\">\r\n        <div class=\"panel-heading card-header\" data-bind=\"text: $root.getLocString('ew.titleHtml')\"></div>\r\n        <div data-bind=\"visible:hasAceEditor\">\r\n            <div id=\"surveyEmbedingBody\" style=\"height:30px;width:100%\"></div>\r\n        </div>\r\n        <textarea data-bind=\"visible:!hasAceEditor, text: koBodyText\" style=\"height:30px;width:100%\"></textarea>\r\n    </div>\r\n    <div class=\"panel card\">\r\n        <div class=\"panel-heading card-header\" data-bind=\"text: $root.getLocString('ew.titleJavaScript')\"></div>\r\n        <div data-bind=\"visible:hasAceEditor\">\r\n            <div id=\"surveyEmbedingJava\" style=\"height:300px;width:100%\"></div>\r\n        </div>\r\n        <textarea data-bind=\"visible:!hasAceEditor, text: koJavaText\" style=\"height:300px;width:100%\"></textarea>\r\n    </div>\r\n</script>";

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports = "<script type=\"text/html\" id=\"surveylive\">\r\n  <div data-bind=\"visible: koIsRunning()\">\r\n      <span data-bind=\"visible: koPages().length > 1\">\r\n          <label  for=\"testSurveyPageChanged\" data-bind=\"text: selectPageText\"></label>\r\n          <span id=\"testSurveyPageChanged\">\r\n              <select onmousewheel=\"return false;\" class=\"form-control\" data-bind=\"options: koPages, optionsText: 'title', optionsValue: 'page', value: koActivePage, optionsAfterRender: setPageDisable\"></select>\r\n          </span>\r\n      </span>\r\n       <span>\r\n          <label  for=\"testSurveyLocale\" data-bind=\"text: localeText\"></label>\r\n          <span id=\"testSurveyLocale\">\r\n              <select onmousewheel=\"return false;\" class=\"form-control\" data-bind=\"options: koLanguages, value: koActiveLanguage, optionsText:'text', optionsValue: 'value'\"></select>\r\n          </span>\r\n      </span>\r\n      <label>\r\n          <div class=\"sjs-cb-container\">\r\n              <input class=\"svd_editor_control\" type=\"checkbox\" data-bind=\"checked: survey.showInvisibleElements\">\r\n              <span class=\"checkmark\" data-bind=\"css: { 'svd-main-background-color': survey.showInvisibleElements, 'svd-light-background-color': !survey.showInvisibleElements }\"></span>\r\n              <span class=\"sjs-cb-label\" data-bind=\"text: showInvisibleElementsText\"></span>\r\n          </div>\r\n       </label>\r\n  </div>\r\n  <survey-widget params=\"survey: koSurvey\"></survey-widget>\r\n  <!-- ko ifnot: koIsRunning -->\r\n  <div class=\"svd_test_results\">\r\n      <div class=\"svd_results_header\">\r\n          <button class=\"btn btn-primary\" data-bind=\"click: selectTestClick, text: testSurveyAgainText\"></button>\r\n          <h2 data-bind=\"text: surveyResultsText\"></h2>\r\n      </div>\r\n      <ul class=\"navbar-default container-fluid nav nav-tabs editor-tabs\">\r\n          <li class=\"nav-item active\" data-bind=\"css: {active: koResultViewType() === 'table'}\">\r\n              <a class=\"nav-link\" href=\"#\" data-bind=\"click: selectTableClick, text: $root.getLocString('ed.surveyResultsTable')\"></a>\r\n          </li>\r\n          <li class=\"nav-item\" data-bind=\"css: {active: koResultViewType() === 'text'}\">\r\n              <a class=\"nav-link\" href=\"#\" data-bind=\"click: selectJsonClick, text: $root.getLocString('ed.surveyResultsJson')\"></a>\r\n          </li>\r\n      </ul>\r\n      <div class=\"svd_results_text svd-light-bg-color\" data-bind=\"visible: koResultViewType() === 'text'\">\r\n          <div data-bind=\"html: koResultText\"></div>\r\n      </div>\r\n      <div class=\"svd_results_table svd-light-bg-color\" data-bind=\"visible: koResultViewType() === 'table'\">\r\n          <table>\r\n              <thead>\r\n                  <tr class=\"svd-light-background-color\">\r\n                      <th class=\"svd-dark-border-color\" data-bind=\"text: resultsTitle\"></th>\r\n                      <th class=\"svd-dark-border-color\" data-bind=\"text: resultsName\"></th>\r\n                      <th class=\"svd-dark-border-color\" data-bind=\"text: resultsValue\"></th>\r\n                      <th class=\"svd-dark-border-color\" data-bind=\"text: resultsDisplayValue\"></th>\r\n                  </tr>\r\n              </thead>\r\n              <tbody>\r\n                  <!-- ko foreach: koResultData -->\r\n                  <!-- ko template: \"survey-result-table-row\" -->\r\n                  <!-- /ko -->\r\n                  <!-- /ko -->\r\n              </tbody>\r\n          </table>\r\n      </div>\r\n  </div>\r\n  <!-- /ko -->\r\n</script>\r\n<script type=\"text/html\" id=\"survey-result-table-row\">\r\n  <tr data-bind=\"click: function() { isNode && collapsed(!collapsed()); }\">\r\n      <td class=\"svd-dark-border-color\">\r\n          <!-- ko if: isNode -->\r\n          <span class=\"survey-result-marker\" data-bind=\"css: { 'survey-result-marker--expanded': !collapsed() }\">▶</span>\r\n          <!-- /ko -->\r\n          <span data-bind=\"text: title\"></span></td>\r\n      <td class=\"svd-dark-border-color\" data-bind=\"text: name\"></td>\r\n      <td class=\"svd-dark-border-color\"><div class=\"survey-result-value\" data-bind=\"text: getString(value)\"></div></td>\r\n      <td class=\"svd-dark-border-color\" data-bind=\"text: getString(displayValue)\"></td>\r\n  </tr>\r\n  <!-- ko if: isNode && !collapsed() -->\r\n  <!-- ko foreach: data -->\r\n  <!-- ko template: \"survey-result-table-row\" -->\r\n  <!-- /ko -->\r\n  <!-- /ko -->\r\n  <!-- /ko -->\r\n</script>\r\n";

/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports = "<script type=\"text/html\" id=\"se-tab-designer\">\r\n    <div\r\n    class=\"row svd_survey_designer\"\r\n  >\r\n    <div\r\n      class=\"col-lg-2 col-md-2 col-sm-1 col-xs-1 svd_toolbox svd-dark-bg-color\"\r\n    >\r\n      <!-- ko if: toolbox.koHasCategories -->\r\n      <div\r\n        class=\"panel-group\"\r\n        role=\"tablist\"\r\n        data-bind=\"foreach: toolbox.koCategories\"\r\n      >\r\n        <div class=\"panel panel-info\">\r\n          <div\r\n            class=\"svd-toolbox-category-header\"\r\n            role=\"tab\"\r\n            data-bind=\"click: expand\"\r\n          >\r\n            <span\r\n              data-bind=\"css: { 'svd-main-color': !koCollapsed() }, text: name\"\r\n            ></span>\r\n            <!-- ko if: koCollapsed -->\r\n            <svg-icon\r\n              class=\"icon-toolbox-arrow\"\r\n              params=\"iconName: 'icon-arrow_down_10x10', size: 10\"\r\n            ></svg-icon>\r\n            <!-- /ko -->\r\n            <!-- ko ifnot: koCollapsed -->\r\n            <svg-icon\r\n              class=\"icon-toolbox-arrow svd-primary-icon\"\r\n              params=\"iconName: 'icon-arrow_up_10x10', size: 10\"\r\n            ></svg-icon>\r\n            <!-- /ko -->\r\n          </div>\r\n          <div\r\n            role=\"tabpanel\"\r\n            data-bind=\"css: { 'panel-collapse collapse': koCollapsed}\"\r\n          >\r\n            <!-- ko foreach: items -->\r\n            <div\r\n              tabindex=\"0\"\r\n              draggable=\"true\"\r\n              class=\"svd_toolbox_item svd-light-border-color\"\r\n              data-bind=\"css: 'svd_toolbox_item_' + iconName, key2click, clickNoFocus: $root.clickToolboxItem, event:{dragstart: function(el, e) { $root.draggingToolboxItem($data, e); return true;}, dragend: function(el, e) { $root.dragEnd(); }}\"\r\n            >\r\n              <span data-bind=\"attr: {title: title}\">\r\n                <svg-icon params=\"iconName: iconName\"></svg-icon>\r\n              </span>\r\n              <span\r\n                class=\"svd_toolbox_item_text hidden-sm hidden-xs\"\r\n                data-bind=\"text:title\"\r\n              ></span>\r\n            </div>\r\n            <!-- /ko  -->\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <!-- /ko  -->\r\n      <!-- ko if: !toolbox.koHasCategories() -->\r\n      <div\r\n        class=\"svd_toolbox_title hidden-sm hidden-xs\"\r\n        data-bind=\"text: $root.getLocString('ed.toolbox')\"\r\n      ></div>\r\n      <!-- ko foreach: toolbox.koItems -->\r\n      <div\r\n        tabindex=\"0\"\r\n        draggable=\"true\"\r\n        class=\"svd_toolbox_item svd-light-border-color\"\r\n        data-bind=\"css: 'svd_toolbox_item_' + iconName, key2click, clickNoFocus: $root.clickToolboxItem, event:{dragstart: function(el, e) { $root.draggingToolboxItem($data, e); return true;}, dragend: function(el, e) { $root.dragEnd(); }}\"\r\n      >\r\n        <span data-bind=\"attr: {title: title}\">\r\n          <svg-icon params=\"iconName: iconName\"></svg-icon>\r\n        </span>\r\n        <span\r\n          class=\"svd_toolbox_item_text hidden-sm hidden-xs\"\r\n          data-bind=\"text:title\"\r\n        ></span>\r\n      </div>\r\n      <!-- /ko  -->\r\n      <!-- /ko  -->\r\n    </div>\r\n    <svd-splitter params=\"minLeft: 100, minRight: 600\"></svd-splitter>\r\n    <div\r\n      class=\"col-xs-11 svd_editors\"\r\n      data-bind=\"css: {'col-lg-7 col-md-7 col-sm-8': koShowPropertyGrid, 'col-lg-10 col-md-10 col-sm-11': !koShowPropertyGrid(), 'svd_wide': !koShowPropertyGrid()}\"\r\n    >\r\n      <div class=\"svd_toolbar\">\r\n        <!-- ko foreach: toolbarItems -->\r\n        <span\r\n          tabindex=\"0\"\r\n          class=\"svd_action\"\r\n          data-bind=\"css: $data.css, visible: visible, attr: { id: id }\"\r\n        >\r\n          <!-- ko template: { name: $data.template || 'svd-toolbar-button', data: $data.data || $data } -->\r\n          <!-- /ko -->\r\n        </span>\r\n        <!-- /ko -->\r\n      </div>\r\n      <pages-editor params=\"editor:$data\" data-bind=\"visible: koShowPagesToolbox\">\r\n      </pages-editor>\r\n      <div\r\n        class=\"svd_questions_editor svd-light-bg-color\"\r\n        id=\"scrollableDiv\"\r\n        data-bind=\"style: { height: koDesignerHeight }, event: { dragover: dragOverQuestionsEditor, drop: dropOnQuestionsEditor }\"\r\n      >\r\n        <div id=\"surveyjs\"></div>\r\n        <!-- ko if: isCurrentPageEmpty -->\r\n        <div\r\n          class=\"empty-message\"\r\n          data-bind=\"text: $root.getLocString('survey.dropQuestion')\"\r\n        ></div>\r\n        <!-- /ko -->\r\n      </div>\r\n    </div>\r\n    <svd-splitter params=\"minLeft: 600, minRight: 150\"></svd-splitter>\r\n    <div\r\n      class=\"col-lg-3 col-md-3 col-sm-3 hidden-xs svd_properties svd-light-border-color svd-light-bg-color\"\r\n      data-bind=\"visible: koShowPropertyGrid\"\r\n    >\r\n      <div class=\"svd_object_selector svd-light-border-color\">\r\n        <div class=\"svd_custom_select\">\r\n          <select\r\n            onmousewheel=\"return false;\"\r\n            id=\"objectSelector\"\r\n            class=\"form-control\"\r\n            data-bind=\"options: koObjects, optionsText: 'text', value: koSelectedObject\"\r\n          ></select>\r\n        </div>\r\n        <span\r\n          data-bind=\"click: editCurrentObject, attr: { title: $root.getLocString('ed.editSelObject')}\"\r\n        >\r\n          <svg-icon\r\n            class=\"svd-primary-icon icon-edit\"\r\n            params=\"iconName: 'icon-edit', size:24\"\r\n          ></svg-icon>\r\n        </span>\r\n      </div>\r\n      <div\r\n        class=\"svd_object_editor\"\r\n        data-bind=\"style: {height: koDesignerHeight}\"\r\n      >\r\n        <div\r\n          data-bind=\"template: { name: 'objecteditor', data: selectedObjectEditor }\"\r\n        ></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</script>\r\n<script type=\"text/html\" id=\"se-tab-test\">\r\n  <div data-bind=\"style: {width: koTestSurveyWidth}\">\r\n    <div id=\"surveyjsExample\" data-bind=\"template: { name: 'surveylive', data: surveyLive }\"></div>\r\n  </div>\r\n</script>\r\n";

/***/ }),
/* 122 */
/***/ (function(module, exports) {

module.exports = "<script type=\"text/html\" id=\"svd-toolbar-button\">\r\n    <button type=\"button\" class=\"btn btn-primary\" data-bind=\"enable: $data.enabled || true, click: action, css: $data.innerCss\">\r\n        <span data-bind=\"text: title\"></span>\r\n    </button>\r\n</script>\r\n<script type=\"text/html\" id=\"svd-toolbar-options\">\r\n    <div class=\"ddmenu-container toolbar-options btn-group inline\">\r\n        <div style=\"-webkit-tap-highlight-color:rgba(0,0,0,0)\" data-bind=\"trueclick\"></div>\r\n\r\n        <div class=\"ddmenu\">\r\n            <span class=\"btn btn-primary\" tabindex=\"0\">\r\n                <span data-bind=\"text: title\"></span>\r\n                <span class=\"caret\"></span>\r\n            </span>\r\n            <div tabindex=\"0\" data-bind=\"trueclick\"></div>\r\n            <ul class=\"svd-light-bg-color\">\r\n                <!-- ko foreach: items -->\r\n                <li data-bind=\"css: $data.css\">\r\n                    <a href=\"#\" data-bind=\"click: action, text: title\"></a>\r\n                </li>\r\n                <!-- /ko -->\r\n            </ul>\r\n        </div>\r\n    </div>\r\n</script>\r\n<script type=\"text/html\" id=\"svd-toolbar-state\">\r\n    <span class=\"icon\">\r\n        <svg-icon class=\"icon-status\" params=\"iconName: innerCss, size: 24\"></svg-icon>\r\n    </span>\r\n    <span class=\"svd-light-text-color\" data-bind=\"text: title\"></span>\r\n</script>";

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports = "<script type=\"text/html\" id=\"translation\">\r\n    <div class=\"form-group svd-translation-tab\">\r\n        <div class=\"form-group svd-language-select\">\r\n        <div class=\"svd_custom_select svd-light-bg-color svd-light-border-color\"> \r\n            <select onmousewheel=\"return false;\" data-bind=\"options: koAvailableLanguages, value: koSelectedLanguageToAdd, optionsText:'text', optionsCaption: $data.selectLanguageOptionsCaption\"></select>\r\n        </div>\r\n        <div class=\"svd-translation-tab-show-all-strings-container\">\r\n        <!-- ko template: { name: 'propertyeditor-boolean', data: {  koValue: koShowAllStrings, displayName: $data.showAllStringsText, isDiplayNameVisible: true } } -->\r\n        <!-- /ko -->\r\n        </div>\r\n        <div class=\"svd_custom_select svd-light-bg-color svd-light-border-color\"> \r\n            <select onmousewheel=\"return false;\" data-bind=\"options: koFilteredPages, value: koFilteredPage, optionsValue: 'value', optionsText:'text'\"></select>\r\n        </div>\r\n        </div>\r\n        <div>\r\n        <!-- ko foreach: {data: $data.koLocales, as: 'item' } -->\r\n        <label data-bind=\"visible: !!item.locale\">\r\n        <!-- ko template: { name: 'propertyeditor-boolean', data: {  koValue: item.koVisible, displayName: $parent.getLocaleName($data.locale), isDiplayNameVisible: true } } -->\r\n        <!-- /ko -->\r\n        </label>\r\n        <!-- /ko -->\r\n        </div>\r\n        <div class=\"form-group\">\r\n            <button class=\"btn btn-primary\"  type=\"button\" data-bind=\"visible:$data.koCanMergeLocaleWithDefault, text:$data.koMergeLocaleWithDefaultText, click:$data.koMergeLocaleWithDefault\"></button>\r\n            <button class=\"btn btn-primary\"  type=\"button\" data-bind=\"text:$data.exportToCSVText, click:$data.koExportToSCVFile\"></button>\r\n            <button class=\"btn btn-primary\"  type=\"button\" onclick=\"this.getElementsByTagName('input')[0].click();\">\r\n            <input type=\"file\" style=\"display:none;\" accept=\".csv\" data-bind=\"event: { change: function() { $data.koImportFromSCVFile($element) } }\" />\r\n            <span data-bind=\"text:$data.importFromCSVText\"></span>\r\n            </button>\r\n        </div>\r\n        <div class=\"svd-translation-no-strings svd-light-text-color\" data-bind=\"visible:$data.koIsEmpty\">\r\n            <span data-bind=\"text:$data.noStringsText\"></span>\r\n        </div>\r\n        <!-- ko ifnot: $data.koIsEmpty -->\r\n        <!-- ko template: { name: \"translation-group\", data: $data.koRoot } -->\r\n        <!-- /ko -->    \r\n        <!-- /ko -->    \r\n    </div>    \r\n</script>\r\n<script type=\"text/html\" id=\"translation-group\">\r\n    <div class=\"svd-translation-strings svd-light-border-color svd-light-bg-color\">\r\n        <table class=\"svd_items_table\" data-bind=\"visible: $data.locItems.length > 0\">\r\n            <thead>\r\n                <tr>\r\n                    <th></th>\r\n                    <!-- ko foreach: $data.koLocales -->\r\n                    <th data-bind=\"visible: $data.koVisible, text: $parent.getLocaleName($data.locale), style: {width: $parent.locWidth}\"></th>\r\n                    <!-- /ko -->\r\n                </tr>\r\n            </thead>\r\n            <tbody data-bind=\"foreach: {data: $data.locItems, as: 'item' }\">\r\n                <tr>\r\n                    <td style=\"max-width: 200px; min-width:100px\"><span data-bind=\"text:item.text\"></span></td>\r\n                    <!-- ko foreach: $parent.koLocales -->\r\n                    <td data-bind=\"visible: $data.koVisible, style: {width: $data.koVisible ? $parent.locWidth : '0px'}\">\r\n                        <textarea class=\"form-control\" style=\"width:100%\" data-bind=\"visible: $data.koVisible, value:item.koValue($data.locale), attr: {placeholder: !$data.locale? item.defaultValue : ''}\"></textarea>\r\n                    </td>\r\n                    <!-- /ko -->\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n\r\n        <div class=\"svd-translation-panel-strings\" data-bind=\"foreach: {data: $data.groups, as: 'group' }\">\r\n            <div class=\"svd-toolbox-category-header\" role=\"tab\" data-bind=\"click: function(){ group.koExpanded(!group.koExpanded())}\">\r\n                <span class=\"svd-translation-panel-strings-title\"data-bind=\"css: { 'svd-main-color': group.koExpanded() }, text: group.name\"></span>\r\n                <!-- ko ifnot: koExpanded -->\r\n                <svg-icon class=\"icon-toolbox-arrow\" params=\"iconName: 'icon-arrow_down_10x10', size: 10\"></svg-icon>\r\n                <!-- /ko -->\r\n                <!-- ko if: koExpanded -->\r\n                <svg-icon class=\"icon-toolbox-arrow svd-primary-icon\" params=\"iconName: 'icon-arrow_up_10x10', size: 10\"></svg-icon>\r\n                <!-- /ko -->\r\n            </div>\r\n            <div data-bind=\"visible: koExpanded\">\r\n            <!-- ko template: { name: \"translation-group\", data: group } -->\r\n            <!-- /ko -->\r\n            <div>\r\n        </div>\r\n    </div>\r\n</script>";

/***/ }),
/* 124 */
/***/ (function(module, exports) {

module.exports = "<div>\n    <!-- ko foreach: actions -->\n    <!-- ko if: !$data.template -->\n    <span class=\"svda_question_action svd-main-color\" data-bind=\"key2click, clickNoFocus: function() { onClick($parent.question); }, attr: {title: text, tabindex: $data.needFocus === undefined || !!$data.needFocus ? 0 : undefined }\">\n        <span>\n            <svg-icon class=\"svd-primary-icon\" data-bind=\"css: $parent.getStyle($data)\" params=\"iconName: $parent.getStyle($data)\"></svg-icon>\n        </span>\n        <span data-bind=\"text: $data.hasTitle ? text: ''\"></span>\n    </span>\n    <!-- /ko -->\n    <!-- ko if: !!$data.template -->\n    <!-- ko template: template -->\n    <!-- /ko -->\n    <!-- /ko -->\n    <!-- /ko -->\n</div>";

/***/ }),
/* 125 */
/***/ (function(module, exports) {

module.exports = "<div class=\"svda-content\">\n  <span class=\"svda-image-editor\">\n    <span\n      class=\"edit-image-item\"\n      data-bind=\"click: chooseImage, clickBubble: false, attr: { title: getLocString('pe.edit') }\"\n    >\n      <svg-icon\n        class=\"svd-primary-icon\"\n        params=\"iconName: 'icon-inplaceedit', size: 12\"\n      ></svg-icon>\n    </span>\n  </span>\n  <span\n    class=\"svda-drag-handle\"\n    data-bind=\"attr: { title: getLocString('pe.move') }\"\n  >\n    <svg-icon\n      class=\"svd-primary-icon\"\n      params=\"iconName: 'icon-inplacedraggable', size: 12\"\n    ></svg-icon>\n  </span>\n  <!--ko ifnot: isLastItem -->\n  <span\n    class=\"svda-delete-item\"\n    data-bind=\"click: deleteItem, attr: { title: getLocString('pe.delete') }\"\n  >\n    <svg-icon\n      class=\"svd-primary-icon\"\n      params=\"iconName: 'icon-inplacedelete', size: 12\"\n    ></svg-icon>\n  </span>\n  <!-- /ko -->\n</div>\n";

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports = "<div class=\"svda-content\">\n  <span\n    class=\"svda-title-editor-content\"\n    data-bind=\"visible: isEditing\"\n    style=\"display: none;\"\n  >\n    <input\n      data-bind=\"textInput: editingName, event: { keyup: nameEditorKeypress, blur: postEdit }\"\n      style=\"border-top: none; border-left: none; border-right: none; outline: none; background-color: transparent; display: inline-block;\"\n    />\n    <span\n      class=\"svda-edit-button\"\n      data-bind=\"click: postEdit, enable: editingName() != ''\"\n    >\n      <svg-icon\n        class=\"svd-primary-icon\"\n        params=\"iconName: 'icon-inplacecheck', size: 12\"\n      ></svg-icon>\n    </span>\n    <!-- <span class=\"svda-edit-button\" data-bind=\"click: cancelEdit\">✕</span> -->\n  </span>\n  <span\n    class=\"svda-title-editor-content svda-title-editor-start\"\n    data-bind=\"visible: !isEditing()\"\n  >\n    <span style=\"display: none;\" data-bind=\"text: editingName\"></span>\n    <span\n      class=\"edit-survey-name\"\n      data-bind=\"click: startEdit, attr: { title: getLocString('pe.edit') }\"\n    >\n      <svg-icon\n        class=\"svd-primary-icon\"\n        params=\"iconName: 'icon-inplaceedit', size: 12\"\n      ></svg-icon>\n    </span>\n  </span>\n  <!-- ko if: isDraggable -->\n  <span\n    class=\"svda-drag-handle\"\n    data-bind=\"attr: { title: getLocString('pe.move') }, visible: !isEditing()\"\n  >\n    <svg-icon\n      class=\"svd-primary-icon\"\n      params=\"iconName: 'icon-inplacedraggable', size: 12\"\n    ></svg-icon>\n  </span>\n  <!-- /ko -->\n  <!--ko ifnot: isLastItem -->\n  <span\n    class=\"svda-delete-item\"\n    data-bind=\"click: deleteItem, attr: { title: getLocString('pe.delete') }, visible: !isEditing()\"\n  >\n    <svg-icon\n      class=\"svd-primary-icon\"\n      params=\"iconName: 'icon-inplacedelete', size: 12\"\n    ></svg-icon>\n  </span>\n  <!-- /ko -->\n</div>\n";

/***/ }),
/* 127 */
/***/ (function(module, exports) {

module.exports = "<div>\n    <!-- ko foreach: actions -->\n    <!-- ko if: !$data.template -->\n    <span class=\"svda_question_action svd-main-color\" data-bind=\"key2click, clickNoFocus: function() { onClick($parent.question); }, attr: {title: text, tabindex: $data.needFocus === undefined || !!$data.needFocus ? 0 : undefined }\">\n        <span>\n            <svg-icon class=\"svd-primary-icon\" data-bind=\"css: $parent.getStyle($data)\" params=\"iconName: $parent.getStyle($data)\"></svg-icon>\n        </span>\n        <span data-bind=\"text: $data.hasTitle ? text: ''\"></span>\n    </span>\n    <!-- /ko -->\n    <!-- ko if: !!$data.template -->\n    <!-- ko template: template -->\n    <!-- /ko -->\n    <!-- /ko -->\n    <!-- /ko -->\n</div>";

/***/ }),
/* 128 */
/***/ (function(module, exports) {

module.exports = "<div class=\"svda-content\">\n  <span\n    class=\"svda-title-editor-content\"\n    data-bind=\"visible: isEditing\"\n    style=\"display: none;\"\n  >\n    <input\n      data-bind=\"textInput: editingName, event: { keyup: nameEditorKeypress, blur: postEdit }\"\n      style=\"border-top: none; border-left: none; border-right: none; outline: none; background-color: transparent; display: inline-block; margin: -6px;\"\n    />\n    <span\n      class=\"svda-edit-button\"\n      data-bind=\"click: postEdit, enable: editingName() != ''\"\n    >\n      <svg-icon\n        class=\"svd-primary-icon\"\n        params=\"iconName: 'icon-inplacecheck', size: 12\"\n      ></svg-icon>\n    </span>\n    <!-- <span class=\"svda-edit-button\" data-bind=\"click: cancelEdit\">✕</span> -->\n  </span>\n  <span\n    class=\"svda-title-editor-content svda-title-editor-start\"\n    data-bind=\"visible: !isEditing()\"\n  >\n    <span style=\"display: none;\" data-bind=\"text: editingName\"></span>\n    <span\n      class=\"edit-survey-name\"\n      data-bind=\"click: startEdit, attr: { title: getLocString('pe.edit') }\"\n    >\n      <svg-icon\n        class=\"svd-primary-icon\"\n        params=\"iconName: 'icon-inplaceedit', size: 12\"\n      ></svg-icon>\n    </span>\n  </span>\n  <!--ko ifnot: isLastItem -->\n  <span\n    class=\"svda-delete-item\"\n    data-bind=\"click: deleteItem, attr: { title: getLocString('pe.delete') }, visible: !isEditing()\"\n  >\n    <svg-icon\n      class=\"svd-primary-icon\"\n      params=\"iconName: 'icon-inplacedelete', size: 12\"\n    ></svg-icon>\n  </span>\n  <!-- /ko -->\n</div>\n";

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports = "<div class=\"svda-select-items-editor\">\n  <div class=\"svda-select-items-title\" data-bind=\"click: toggle\">\n    <span\n      class=\"svd-main-color\"\n      data-bind=\"text: getLocString('pe.editChoices')\"\n    ></span>\n  </div>\n  <div\n    class=\"svda-select-items-content svd-dark-border-color svd-light-bg-color\"\n    data-bind=\"visible: isExpanded\"\n  >\n    <div class=\"svda-select-items-collection\">\n      <!-- ko foreach: { data: choices, afterRender: choicesRendered } -->\n      <div class=\"item_editable item_draggable\">\n        <span data-bind=\"text: text\"></span>\n        <span>\n          <item-editor\n            params=\"name: $parent.valueName, valueChanged: $parent.valueChanged, target: $data, model: $data, item: $data, question: $parent.question, editor: $parent.editor\"\n          ></item-editor>\n        </span>\n      </div>\n      <!-- /ko -->\n    </div>\n    <!-- ko if: question.hasOther -->\n    <div class=\"item_editable\">\n      <span data-bind=\"text: otherText\"></span>\n      <span>\n        <item-editor\n          params=\"name: &quot;otherText&quot;, target: question, model: question, valueChanged: otherValueChanged, item: question.otherItem, question: question, editor: editor\"\n        ></item-editor>\n      </span>\n    </div>\n    <!-- /ko -->\n    <div\n      class=\"svda-add-new-item\"\n      data-bind=\"click: addItem, attr: { title: getLocString('pe.addItem') }\"\n    >\n      <svg-icon\n        class=\"svd-primary-icon\"\n        params=\"iconName: 'icon-inplaceplus', size: 12\"\n      ></svg-icon>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 130 */
/***/ (function(module, exports) {

module.exports = "<div class=\"svda-content\">\n    <span class=\"svda-title-editor-content\" data-bind=\"visible: isEditing\" style=\"display: none;\">\n        <input data-bind=\"textInput: editingName, event: { keyup: nameEditorKeypress, blur: postEdit }\" style=\"border-top: none; border-left: none; border-right: none; outline: none; background-color: transparent; display: inline-block;\"\n        />\n        <span class=\"svda-edit-button\" data-bind=\"click: postEdit, enable: editingName() != ''\">\n            <svg-icon class=\"svd-primary-icon\" params=\"iconName: 'icon-inplacecheck', size: 12\"></svg-icon>\n        </span>\n        <!-- <span class=\"svda-edit-button\" data-bind=\"click: cancelEdit\">✕</span> -->\n    </span>\n    <span class=\"svda-title-editor-content svda-title-editor-start\" data-bind=\"visible: !isEditing()\">\n        <span style=\"display: none;\" data-bind=\"text: editingName\"></span>\n        <span class=\"edit-survey-name\" data-bind=\"click: startEdit, attr: { title: getLocString('pe.edit') }\">\n            <svg-icon class=\"svd-primary-icon\" params=\"iconName: 'icon-inplaceedit', size: 12\"></svg-icon>\n        </span>\n    </span>\n</div>";

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "" + __webpack_require__(86) + " " + __webpack_require__(87) + "\n" + __webpack_require__(89) + " " + __webpack_require__(90) + "\n" + __webpack_require__(120) + " " + __webpack_require__(119) + "\n" + __webpack_require__(123) + "\n" + __webpack_require__(117) + "\n" + __webpack_require__(116) + "\n" + __webpack_require__(118) + "\n" + __webpack_require__(115) + "\n" + __webpack_require__(91) + "\n" + __webpack_require__(96) + "\n" + __webpack_require__(99) + "\n" + __webpack_require__(93) + "\n" + __webpack_require__(98) + "\n" + __webpack_require__(100) + "\n" + __webpack_require__(104) + "\n" + __webpack_require__(105) + "\n" + __webpack_require__(101) + "\n" + __webpack_require__(102) + "" + __webpack_require__(103) + "\n" + __webpack_require__(107) + "\n" + __webpack_require__(108) + "\n" + __webpack_require__(95) + "\n" + __webpack_require__(109) + "\n" + __webpack_require__(110) + "\n" + __webpack_require__(92) + "\n" + __webpack_require__(111) + "\n" + __webpack_require__(112) + "\n" + __webpack_require__(113) + "\n" + __webpack_require__(114) + "\n" + __webpack_require__(94) + "\n" + __webpack_require__(88) + " " + __webpack_require__(122) + "\n" + __webpack_require__(85) + "\n" + __webpack_require__(106) + "" + __webpack_require__(97) + "\n" + __webpack_require__(84) + " " + __webpack_require__(121) + "\n";

/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports = "<div>\n    <!-- ko foreach: tabs -->\n    <div class=\"svd-accordion-tab-header\" role=\"tab\" data-bind=\"click: toggle\">\n        <span data-bind=\"css: { 'svd-main-color': !collapsed() }, text: title\"></span>\n        <!-- ko if: collapsed -->\n        <svg-icon class=\"icon-toolbox-arrow\" params=\"iconName: 'icon-arrow_down_10x10', size: 10\"></svg-icon>\n        <!-- /ko -->\n        <!-- ko ifnot: collapsed -->\n        <svg-icon class=\"icon-toolbox-arrow svd-primary-icon\" params=\"iconName: 'icon-arrow_up_10x10', size: 10\"></svg-icon>\n        <!-- /ko -->\n    </div>\n    <div class=\"svd-accordion-tab-content\" role=\"tab\" data-bind=\"ifnot: collapsed\">\n        <!-- ko template: { name: template, data: data } -->\n        <!-- /ko -->\n    </div>\n    <!-- /ko -->\n</div>";

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_knockout__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__textWorker__ = __webpack_require__(20);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SurveyJSONEditor; });


var SurveyJSONEditor = /** @class */ (function () {
    function SurveyJSONEditor() {
        this.isProcessingImmediately = false;
        this.timeoutId = -1;
        this.koText = __WEBPACK_IMPORTED_MODULE_0_knockout__["observable"]("");
        this.koErrors = __WEBPACK_IMPORTED_MODULE_0_knockout__["observableArray"]();
        var self = this;
        this.koText.subscribe(function (newValue) {
            self.onJsonEditorChanged();
        });
    }
    SurveyJSONEditor.prototype.init = function (editorElement) {
        if (!this.hasAceEditor)
            return;
        this.aceEditor = ace.edit(editorElement);
        var self = this;
        //TODO add event to change ace theme and mode
        //this.aceEditor.setTheme("ace/theme/monokai");
        //this.aceEditor.session.setMode("ace/mode/json");
        this.aceEditor.setShowPrintMargin(false);
        this.aceEditor.getSession().on("change", function () {
            self.onJsonEditorChanged();
        });
        this.aceEditor.getSession().setUseWorker(true);
        __WEBPACK_IMPORTED_MODULE_1__textWorker__["a" /* SurveyTextWorker */].newLineChar = this.aceEditor.session.doc.getNewLineCharacter();
    };
    Object.defineProperty(SurveyJSONEditor.prototype, "hasAceEditor", {
        get: function () {
            return typeof ace !== "undefined";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyJSONEditor.prototype, "text", {
        get: function () {
            if (!this.hasAceEditor)
                return this.koText();
            return this.aceEditor.getValue();
        },
        set: function (value) {
            this.isProcessingImmediately = true;
            this.koText(value);
            if (this.aceEditor) {
                this.aceEditor.setValue(value);
                this.aceEditor.renderer.updateFull(true);
            }
            this.processJson(value);
            this.isProcessingImmediately = false;
        },
        enumerable: true,
        configurable: true
    });
    SurveyJSONEditor.prototype.show = function (value) {
        this.text = value;
        if (this.aceEditor) {
            this.aceEditor.focus();
        }
    };
    Object.defineProperty(SurveyJSONEditor.prototype, "isJsonCorrect", {
        get: function () {
            this.textWorker = new __WEBPACK_IMPORTED_MODULE_1__textWorker__["a" /* SurveyTextWorker */](this.text);
            return this.textWorker.isJsonCorrect;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyJSONEditor.prototype, "survey", {
        get: function () {
            return this.textWorker.survey;
        },
        enumerable: true,
        configurable: true
    });
    SurveyJSONEditor.prototype.onJsonEditorChanged = function () {
        if (this.timeoutId > -1) {
            clearTimeout(this.timeoutId);
        }
        if (this.isProcessingImmediately) {
            this.timeoutId = -1;
        }
        else {
            var self = this;
            this.timeoutId = window.setTimeout(function () {
                self.timeoutId = -1;
                self.processJson(self.text);
            }, SurveyJSONEditor.updateTextTimeout);
        }
    };
    SurveyJSONEditor.prototype.processJson = function (text) {
        this.textWorker = new __WEBPACK_IMPORTED_MODULE_1__textWorker__["a" /* SurveyTextWorker */](text);
        if (this.aceEditor) {
            this.aceEditor
                .getSession()
                .setAnnotations(this.createAnnotations(text, this.textWorker.errors));
        }
        else {
            this.koErrors(this.textWorker.errors);
        }
    };
    SurveyJSONEditor.prototype.createAnnotations = function (text, errors) {
        var annotations = new Array();
        for (var i = 0; i < errors.length; i++) {
            var error = errors[i];
            var annotation = {
                row: error.position.start.row,
                column: error.position.start.column,
                text: error.text,
                type: "error"
            };
            annotations.push(annotation);
        }
        return annotations;
    };
    SurveyJSONEditor.updateTextTimeout = 1000;
    return SurveyJSONEditor;
}());



/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* fork of the https://github.com/SortableJS/knockout-sortablejs because of es modules build error 
    waiting for approve pullrequests:
     * https://github.com/SortableJS/knockout-sortablejs/pull/9)
     * https://github.com/SortableJS/knockout-sortablejs/pull/1/files
*/

/*global ko*/

(function(factory) {
  "use strict";
  //get ko ref via global or require
  var koRef;
  if (typeof ko !== "undefined") {
    //global ref already defined
    koRef = ko;
  } else if (
    true
  ) {
    //commonjs / node.js
    koRef = __webpack_require__(1);
  }
  //get sortable ref via global or require
  var sortableRef;
  if (typeof Sortable !== "undefined") {
    //global ref already defined
    sortableRef = Sortable;
  } else if (
    true
  ) {
    //commonjs / node.js
    sortableRef = __webpack_require__(9);
  }
  //use references if we found them
  if (koRef !== undefined && sortableRef !== undefined) {
    factory(koRef, sortableRef);
  } else if (true) {
    //if both references aren't found yet, get via AMD if available
    //we may have a reference to only 1, or none
    if (koRef !== undefined && sortableRef === undefined) {
      !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(9)], __WEBPACK_AMD_DEFINE_RESULT__ = function(amdSortableRef) {
        factory(koRef, amdSortableRef);
      }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (koRef === undefined && sortableRef !== undefined) {
      !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function(amdKnockout) {
        factory(amdKnockout, sortableRef);
      }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (koRef === undefined && sortableRef === undefined) {
      !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(9)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
  } else {
    //no more routes to get references
    //report specific error
    if (koRef !== undefined && sortableRef === undefined) {
      throw new Error("knockout-sortable could not get reference to Sortable");
    } else if (koRef === undefined && sortableRef !== undefined) {
      throw new Error("knockout-sortable could not get reference to Knockout");
    } else if (koRef === undefined && sortableRef === undefined) {
      throw new Error(
        "knockout-sortable could not get reference to Knockout or Sortable"
      );
    }
  }
})(function(ko, Sortable) {
  "use strict";

  var init = function(
      element,
      valueAccessor,
      allBindings,
      viewModel,
      bindingContext,
      sortableOptions
    ) {
      var options = buildOptions(valueAccessor, sortableOptions);

      // It's seems that we cannot update the eventhandlers after we've created
      // the sortable, so define them in init instead of update
      [
        "onStart",
        "onEnd",
        "onRemove",
        "onAdd",
        "onUpdate",
        "onSort",
        "onFilter",
        "onMove",
        "onClone"
      ].forEach(function(e) {
        if (options[e] || eventHandlers[e])
          options[e] = function(
            eventType,
            parentVM,
            parentBindings,
            handler,
            e
          ) {
            var itemVM = ko.dataFor(e.item),
              // All of the bindings on the parent element
              bindings = ko.utils.peekObservable(parentBindings()),
              // The binding options for the draggable/sortable binding of the parent element
              bindingHandlerBinding = bindings.sortable || bindings.draggable,
              // The collection that we should modify
              collection =
                bindingHandlerBinding.collection ||
                bindingHandlerBinding.foreach;
            if (handler) handler(e, itemVM, parentVM, collection, bindings);
            if (eventHandlers[eventType])
              eventHandlers[eventType](
                e,
                itemVM,
                parentVM,
                collection,
                bindings
              );
          }.bind(undefined, e, viewModel, allBindings, options[e]);
      });

      var sortableElement = Sortable.create(element, options);

      // Destroy the sortable if knockout disposes the element it's connected to
      ko.utils.domNodeDisposal.addDisposeCallback(element, function() {
        sortableElement.destroy();
      });
      return ko.bindingHandlers.template.init(element, valueAccessor);
    },
    update = function(
      element,
      valueAccessor,
      allBindings,
      viewModel,
      bindingContext,
      sortableOptions
    ) {
      // There seems to be some problems with updating the options of a sortable
      // Tested to change eventhandlers and the group options without any luck

      return ko.bindingHandlers.template.update(
        element,
        valueAccessor,
        allBindings,
        viewModel,
        bindingContext
      );
    },
    eventHandlers = (function(handlers) {
      var moveOperations = [],
        tryMoveOperation = function(
          e,
          itemVM,
          parentVM,
          collection,
          parentBindings
        ) {
          // A move operation is the combination of a add and remove event,
          // this is to make sure that we have both the target and origin collections
          var currentOperation = {
              event: e,
              itemVM: itemVM,
              parentVM: parentVM,
              collection: collection,
              parentBindings: parentBindings
            },
            existingOperation = moveOperations.filter(function(op) {
              return op.itemVM === currentOperation.itemVM;
            })[0];

          if (!existingOperation) {
            moveOperations.push(currentOperation);
          } else {
            // We're finishing the operation and already have a handle on
            // the operation item meaning that it's safe to remove it
            moveOperations.splice(moveOperations.indexOf(existingOperation), 1);

            var removeOperation =
                currentOperation.event.type === "remove"
                  ? currentOperation
                  : existingOperation,
              addOperation =
                currentOperation.event.type === "add"
                  ? currentOperation
                  : existingOperation;

            moveItem(
              itemVM,
              removeOperation.collection,
              addOperation.collection,
              addOperation.event.clone,
              addOperation.event
            );
          }
        },
        // Moves an item from the "from" collection to the "to" collection, these
        // can be references to the same collection which means it's a sort.
        // clone indicates if we should move or copy the item into the new collection
        moveItem = function(itemVM, from, to, clone, e) {
          // Unwrapping this allows us to manipulate the actual array
          var fromArray = from(),
            // It's not certain that the items actual index is the same
            // as the index reported by sortable due to filtering etc.
            originalIndex = fromArray.indexOf(itemVM),
            newIndex = e.newIndex;

          // We have to find out the actual desired index of the to array,
          // as this might be a computed array. We could otherwise potentially
          // drop an item above the 3rd visible item, but the 2nd visible item
          // has an actual index of 5.
          if (e.item.previousElementSibling) {
            newIndex = to().indexOf(ko.dataFor(e.item.previousElementSibling));
            newIndex += newIndex > originalIndex ? 0 : 1;
          }

          // Remove sortables "unbound" element
          e.item.parentNode.removeChild(e.item);

          // This splice is necessary for both clone and move/sort
          // In sort/move since it shouldn't be at this index/in this array anymore
          // In clone since we have to work around knockouts valuHasMutated
          // when manipulating arrays and avoid a "unbound" item added by sortable
          fromArray.splice(originalIndex, 1);
          // Update the array, this will also remove sortables "unbound" clone
          from.valueHasMutated();
          if (clone && from !== to) {
            // Read the item
            fromArray.splice(originalIndex, 0, itemVM);
            // Force knockout to update
            from.valueHasMutated();
          }
          // Force deferred tasks to run now, registering the removal
          !!ko.tasks && ko.tasks.runEarly();
          // Insert the item on its new position
          to().splice(newIndex, 0, itemVM);
          // Make sure to tell knockout that we've modified the actual array.
          to.valueHasMutated();
        };

      handlers.onRemove = tryMoveOperation;
      handlers.onAdd = tryMoveOperation;
      handlers.onUpdate = function(
        e,
        itemVM,
        parentVM,
        collection,
        parentBindings
      ) {
        // This will be performed as a sort since the to/from collections
        // reference the same collection and clone is set to false
        moveItem(itemVM, collection, collection, false, e);
      };

      return handlers;
    })({}),
    // bindingOptions are the options set in the "data-bind" attribute in the ui.
    // options are custom options, for instance draggable/sortable specific options
    buildOptions = function(bindingOptions, options) {
      // deep clone/copy of properties from the "from" argument onto
      // the "into" argument and returns the modified "into"
      var merge = function(into, from) {
          for (var prop in from) {
            if (
              Object.prototype.toString.call(from[prop]) === "[object Object]"
            ) {
              if (
                Object.prototype.toString.call(into[prop]) !== "[object Object]"
              ) {
                into[prop] = {};
              }
              into[prop] = merge(into[prop], from[prop]);
            } else into[prop] = from[prop];
          }

          return into;
        },
        // unwrap the supplied options
        unwrappedOptions =
          ko.utils.peekObservable(bindingOptions()).options || {};

      // Make sure that we don't modify the provided settings object
      options = merge({}, options);

      // group is handled differently since we should both allow to change
      // a draggable to a sortable (and vice versa), but still be able to set
      // a name on a draggable without it becoming a drop target.
      if (
        unwrappedOptions.group &&
        Object.prototype.toString.call(unwrappedOptions.group) !==
          "[object Object]"
      ) {
        // group property is a name string declaration, convert to object.
        unwrappedOptions.group = { name: unwrappedOptions.group };
      }

      return merge(options, unwrappedOptions);
    };

  ko.bindingHandlers.draggable = {
    sortableOptions: {
      group: { pull: "clone", put: false },
      sort: false
    },
    init: function(
      element,
      valueAccessor,
      allBindings,
      viewModel,
      bindingContext
    ) {
      return init(
        element,
        valueAccessor,
        allBindings,
        viewModel,
        bindingContext,
        ko.bindingHandlers.draggable.sortableOptions
      );
    },
    update: function(
      element,
      valueAccessor,
      allBindings,
      viewModel,
      bindingContext
    ) {
      return update(
        element,
        valueAccessor,
        allBindings,
        viewModel,
        bindingContext,
        ko.bindingHandlers.draggable.sortableOptions
      );
    }
  };

  ko.bindingHandlers.sortable = {
    sortableOptions: {
      group: { pull: true, put: true }
    },
    init: function(
      element,
      valueAccessor,
      allBindings,
      viewModel,
      bindingContext
    ) {
      return init(
        element,
        valueAccessor,
        allBindings,
        viewModel,
        bindingContext,
        ko.bindingHandlers.sortable.sortableOptions
      );
    },
    update: function(
      element,
      valueAccessor,
      allBindings,
      viewModel,
      bindingContext
    ) {
      return update(
        element,
        valueAccessor,
        allBindings,
        viewModel,
        bindingContext,
        ko.bindingHandlers.sortable.sortableOptions
      );
    }
  };
});


/***/ })
/******/ ]);
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(2)))

/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(454);
module.exports = __webpack_require__(213);


/***/ })
],[1753]);


// WEBPACK FOOTER //
// static/js/app.91c81b3151edb8f6a4dc.js